import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A 64-bit signed integer */
  Long: any;
};

export type BoolW = {
  __typename?: 'BoolW';
  value?: Maybe<Scalars['Boolean']>;
};

export enum DayOfWeek {
  DayOfWeekFriday = 'DAY_OF_WEEK_FRIDAY',
  DayOfWeekMonday = 'DAY_OF_WEEK_MONDAY',
  DayOfWeekNone = 'DAY_OF_WEEK_NONE',
  DayOfWeekSaturday = 'DAY_OF_WEEK_SATURDAY',
  DayOfWeekSunday = 'DAY_OF_WEEK_SUNDAY',
  DayOfWeekThursday = 'DAY_OF_WEEK_THURSDAY',
  DayOfWeekTuesday = 'DAY_OF_WEEK_TUESDAY',
  DayOfWeekWednesday = 'DAY_OF_WEEK_WEDNESDAY'
}

export type DecimalMsg = {
  __typename?: 'DecimalMsg';
  value?: Maybe<Scalars['String']>;
};

export type DecimalRangeMsg = {
  __typename?: 'DecimalRangeMsg';
  value?: Maybe<Scalars['String']>;
};

export type DoubleW = {
  __typename?: 'DoubleW';
  value?: Maybe<Scalars['Float']>;
};

export type FieldMask = {
  __typename?: 'FieldMask';
  paths?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Input_BoolW = {
  value?: InputMaybe<Scalars['Boolean']>;
};

export type Input_DecimalMsg = {
  value?: InputMaybe<Scalars['String']>;
};

export type Input_DecimalRangeMsg = {
  value?: InputMaybe<Scalars['String']>;
};

export type Input_DoubleW = {
  value?: InputMaybe<Scalars['Float']>;
};

export type Input_FieldMask = {
  paths?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Int32W = {
  value?: InputMaybe<Scalars['Int']>;
};

export type Input_Int64W = {
  value?: InputMaybe<Scalars['Long']>;
};

export type Input_PrecisionDurationMsg = {
  resolution?: InputMaybe<TimePrecisionLevel>;
  seconds?: InputMaybe<Scalars['Long']>;
};

export type Input_PrecisionTimeFrameMsg = {
  timeFrom?: InputMaybe<Input_PrecisionTimestampMsg>;
  timeUntil?: InputMaybe<Input_PrecisionTimestampMsg>;
};

export type Input_PrecisionTimestampMsg = {
  resolution?: InputMaybe<TimePrecisionLevel>;
  timestamp?: InputMaybe<Input_Timestamp>;
};

export type Input_RatioMsg = {
  denominator?: InputMaybe<Scalars['Int']>;
  numerator?: InputMaybe<Scalars['Int']>;
};

export type Input_TimeFrameMsg = {
  timeFrom?: InputMaybe<Input_Timestamp>;
  timeUntil?: InputMaybe<Input_Timestamp>;
};

export type Input_TimeMsg = {
  createdAt?: InputMaybe<Input_Timestamp>;
  updatedAt?: InputMaybe<Input_Timestamp>;
};

export type Input_TimeOfDayMsg = {
  hours?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['Int']>;
};

export type Input_Timestamp = {
  nanos?: InputMaybe<Scalars['Int']>;
  seconds?: InputMaybe<Scalars['Long']>;
};

export type Input_VeiosDateTimeMsg = {
  approximation?: InputMaybe<Scalars['Boolean']>;
  datetime?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  precisionLevel?: InputMaybe<TimePrecisionLevel>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_VeiosTimeFrameMsg = {
  end?: InputMaybe<Input_VeiosDateTimeMsg>;
  id?: InputMaybe<Scalars['String']>;
  span?: InputMaybe<Input_VeiosTimeSpanMsg>;
  start?: InputMaybe<Input_VeiosDateTimeMsg>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TimeFrameType>;
};

export type Input_VeiosTimeSpanMsg = {
  approximation?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  precisionLevel?: InputMaybe<TimePrecisionLevel>;
  seconds?: InputMaybe<Scalars['Long']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_AddInvoicePositionsRequest = {
  invoiceId?: InputMaybe<Scalars['String']>;
  /** It is enough to provide billing position id */
  invoicePositions?: InputMaybe<Array<InputMaybe<Input_Billing_InvoicePositionMsg>>>;
};

export type Input_Billing_AddMaterialCostsToBillingPositionRequest = {
  billingPositionId?: InputMaybe<Scalars['String']>;
  materialBillingCosts?: InputMaybe<Array<InputMaybe<Input_Billing_CreateMaterialBillingCostRequest>>>;
};

export type Input_Billing_AdditionalBillingFieldsMsg = {
  admissionDate?: InputMaybe<Input_Timestamp>;
  asvTeamId?: InputMaybe<Scalars['String']>;
  batchNumber?: InputMaybe<Scalars['String']>;
  dischargeDate?: InputMaybe<Input_Timestamp>;
  doctorNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  doctorUserId?: InputMaybe<Scalars['String']>;
  finishTime?: InputMaybe<Input_Timestamp>;
  goNumberAddition?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  indicatorForPostHospitalServices?: InputMaybe<Scalars['Boolean']>;
  multiplier?: InputMaybe<Scalars['Float']>;
  omimRecords?: InputMaybe<Array<InputMaybe<Input_Billing_BillingOmimRecordMsg>>>;
  operationDate?: InputMaybe<Input_Timestamp>;
  opsCodes?: InputMaybe<Array<InputMaybe<Input_Billing_BillingOpsCodeMsg>>>;
  organSpecifications?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientNumberOfFekForm?: InputMaybe<Scalars['String']>;
  percentageOfPerformance?: InputMaybe<Scalars['Int']>;
  /** Field Nr.: 20 */
  quantityKmAm?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  reasoningGnrs?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCodeReferenceMsg>>>;
  referralPracticeBsnr?: InputMaybe<Scalars['String']>;
  repeatExaminationForCancerScreening?: InputMaybe<Scalars['Boolean']>;
  serviceLocationAdministrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  serviceLocationOrDeviceLocation?: InputMaybe<Scalars['String']>;
  /** in minutes */
  totalCutSutureTime?: InputMaybe<Scalars['Int']>;
  travelExpense?: InputMaybe<Input_Billing_TravelExpenseMsg>;
  typeOfExamination?: InputMaybe<Scalars['String']>;
  /** Field Nr.: 22 */
  unitOfMeasureKmAm?: InputMaybe<Billing_AmKmUnit>;
  yearOfLastCancerScreening?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_AggregateBillingCasesRequest = {
  /** mandatory: billing case ids that will be aggregated into a cumulative billing case */
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional, set if the billing cases should be added to an existing cumulative billing case */
  cumulativeBillingCaseId?: InputMaybe<Scalars['String']>;
  germanAggregationData?: InputMaybe<Input_Billing_German_GermanBillingCaseAggregationDataMsg>;
};

export type Input_Billing_AggregateBillingCasesResponse = {
  cumulativeBillingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
};

export type Input_Billing_ApplyCodeChainToBillingCaseRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingCertificateId?: InputMaybe<Scalars['String']>;
  /** optional */
  billingDayId?: InputMaybe<Scalars['String']>;
  codeChainId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ApplyCodeChainToBillingCaseResponse = {
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
  updatedFeeCategoryConfiguration?: InputMaybe<Input_Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Input_Billing_ApplyCoverageAssignmentsTemplateRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ApplyCoverageAssignmentsTemplateResponse = {
  /**
   * True if a template existed and was applied; does not necessarily mean that coverages were added:
   *  if no coverages matching the template were found, any linked coverages will be cleared, no coverages will be assigned.
   */
  applied?: InputMaybe<Scalars['Boolean']>;
  billingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
};

export type Input_Billing_BillingAreaMsg = {
  billingAreaCode?: InputMaybe<Scalars['String']>;
  printingName?: InputMaybe<Scalars['String']>;
  validityPeriod?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_BillingCaseDischargeTimeFiltersMsg = {
  includePlanned?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_BillingCaseDrgFiltersMsg = {
  approvalLevel?: InputMaybe<Scalars['Int']>;
  exclusionFilters?: InputMaybe<Array<InputMaybe<Billing_CaseExclusionFilterType>>>;
};

export type Input_Billing_BillingCaseIdList = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_BillingCaseIdentifiersMsg = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  caseNumber?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingCaseList = {
  billingCases?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCaseMsg>>>;
};

export type Input_Billing_BillingCaseMsg = {
  activePeriod?: InputMaybe<Input_TimeFrameMsg>;
  admissionType?: InputMaybe<Billing_AdmissionType>;
  /** Set if category is cumulative */
  aggregatedBillingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingEvents?: InputMaybe<Array<InputMaybe<Input_Billing_BillingEventMsg>>>;
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
  billingStatus?: InputMaybe<Input_Billing_BillingStatusMsg>;
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  billingUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** Either fetched from external system or generated by internal database sequence */
  caseNumber?: InputMaybe<Scalars['String']>;
  caseType?: InputMaybe<Billing_BillingCaseType>;
  category?: InputMaybe<Billing_BillingCaseCategory>;
  /** Ranked list of coverages; ranking allows splitting billing to the different coverages */
  coverages?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageAssignmentMsg>>>;
  /** Set if linked to a cumulative billing case */
  cumulativeBillingCaseId?: InputMaybe<Scalars['String']>;
  currentStatus?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  germanBgDetails?: InputMaybe<Input_Billing_German_BillingCaseBgDetailsMsg>;
  germanDetails?: InputMaybe<Input_Billing_German_BillingCaseDetailsMsg>;
  /** country-specific data */
  germanGroupingData?: InputMaybe<Input_Billing_German_GroupingDataMsg>;
  id?: InputMaybe<Scalars['String']>;
  initialCaseReleaseDate?: InputMaybe<Input_Timestamp>;
  initialLockDate?: InputMaybe<Input_Timestamp>;
  latestCaseReleaseDate?: InputMaybe<Input_Timestamp>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  registrationStatuses?: InputMaybe<Array<InputMaybe<Billing_RegistrationStatus>>>;
  /** not manually updatable; synchronized from visits */
  relatedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  tags?: InputMaybe<Array<InputMaybe<Billing_BillingCaseTag>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Billing_BillingCasePeriodTemplateMsg = {
  duration?: InputMaybe<Input_PrecisionDurationMsg>;
  type?: InputMaybe<Billing_BillingCasePeriodType>;
};

export type Input_Billing_BillingCaseStatusMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** The case types for which this billing case status can be selected */
  possibleCaseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  /** Used for sorting */
  sort?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Billing_BillingStatusActivationStatus>;
  statusCategory?: InputMaybe<Billing_BillingCaseStatusCategory>;
  tags?: InputMaybe<Array<InputMaybe<Billing_BillingCaseStatusTag>>>;
};

export type Input_Billing_BillingCodeReferenceMsg = {
  billingCatalogType?: InputMaybe<Billing_BillingCatalogType>;
  catalogVersionId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingDayBillingPositionList = {
  billingDay?: InputMaybe<Input_Billing_German_BillingDayMsg>;
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
};

export type Input_Billing_BillingEventMsg = {
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
  timestamp?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingFeeCategoryConfigurationMsg = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** i.e. treatment id. pair with context_type */
  contextId?: InputMaybe<Scalars['String']>;
  /** i.e. treatment. pair with context_id */
  contextType?: InputMaybe<Billing_BillingFeeCategoryConfigurationContextType>;
  enabledFeeCategories?: InputMaybe<Array<InputMaybe<Billing_BillingFeeCategory>>>;
};

export type Input_Billing_BillingMaterialCostMsg = {
  articleIdentifier?: InputMaybe<Scalars['String']>;
  costInCents?: InputMaybe<Scalars['Int']>;
  ean?: InputMaybe<Scalars['String']>;
  grossPrice?: InputMaybe<Input_Billing_Money>;
  grossPriceString?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inputGrossPriceInCents?: InputMaybe<Scalars['Int']>;
  inputNetPriceInCents?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Array<InputMaybe<Input_Billing_MaterialCostTemplateLabelMsg>>>;
  manufacturer?: InputMaybe<Input_Billing_MaterialCompanyMsg>;
  name?: InputMaybe<Scalars['String']>;
  netPrice?: InputMaybe<Input_Billing_Money>;
  netPriceString?: InputMaybe<Scalars['String']>;
  productGroup?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<Input_Billing_MaterialCompanyMsg>;
  vat?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingOfficeMsg = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingOmimGCodeMsg = {
  geneName?: InputMaybe<Scalars['String']>;
  omimGCodeOfExaminedGene?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingOmimPCodeMsg = {
  omimPCode?: InputMaybe<Scalars['String']>;
  typeOfIllness?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingOmimRecordMsg = {
  omimGCode?: InputMaybe<Input_Billing_Omim_GCodeMsg>;
  omimGCodeFreeText?: InputMaybe<Scalars['String']>;
  omimPCode?: InputMaybe<Input_Billing_Omim_PCodeMsg>;
  omimPCodeFreeText?: InputMaybe<Scalars['String']>;
};

/** TODO: Check whether still in use */
export type Input_Billing_BillingOpsCodeMsg = {
  complication?: InputMaybe<Scalars['String']>;
  /** in minutes */
  cutSutureTime?: InputMaybe<Scalars['Int']>;
  opsCode?: InputMaybe<Scalars['String']>;
  sideLocalization?: InputMaybe<Billing_OpsNumberLocalization>;
};

/**
 * Currently not implemented
 *  TODO: Naming
 *  Request for approval of billing positions, required e.g. for German psychotherapists
 */
export type Input_Billing_BillingPositionAllowanceMsg = {
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
  /** If set, further specifies who can use the approved claim */
  careTeam?: InputMaybe<Input_Billing_CareTeamMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** Mainly clinic; might allow setting that controls level of owner in the future */
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Billing_BillingPositionAllowanceStatus>;
  validityPeriod?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_BillingPositionContentMsg = {
  additionalFields?: InputMaybe<Input_Billing_AdditionalBillingFieldsMsg>;
  codeReference?: InputMaybe<Input_Billing_BillingCodeReferenceMsg>;
  drgFields?: InputMaybe<Input_Billing_DrgBillingFieldsMsg>;
  materialCosts?: InputMaybe<Array<InputMaybe<Input_Billing_BillingMaterialCostMsg>>>;
  multiplier?: InputMaybe<Input_Billing_MultiplierMsg>;
  occupationalAccidentInsuranceFields?: InputMaybe<Input_Billing_OccupationalAccidentInsuranceFieldsMsg>;
  priceInformation?: InputMaybe<Input_Billing_PriceInformationMsg>;
  type?: InputMaybe<Billing_BillingPositionType>;
};

export type Input_Billing_BillingPositionList = {
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
};

export type Input_Billing_BillingPositionMsg = {
  appliedFlatRateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingDayId?: InputMaybe<Scalars['String']>;
  codeChainId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Input_Billing_BillingPositionContentMsg>;
  creatorId?: InputMaybe<Scalars['String']>;
  feeCategory?: InputMaybe<Billing_BillingFeeCategory>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  /** By default the same as the creatorId, but can be set to different user manually */
  serviceProviderUserId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Billing_BillingPositionStatus>;
  surgeryId?: InputMaybe<Scalars['String']>;
  targetReference?: InputMaybe<Input_Billing_ServiceReferenceMsg>;
  timeOfPerformedService?: InputMaybe<Input_PrecisionTimestampMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  treatmentCaseId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  validatorUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingProcedureAdditionalFieldsMsg = {
  assignedRevenue?: InputMaybe<Input_Billing_Money>;
  complications?: InputMaybe<Scalars['String']>;
  internalComment?: InputMaybe<Scalars['String']>;
  /** could be some enum or id. TODO: Probably not needed here, but characteristic of ops code? */
  opsType?: InputMaybe<Billing_OpsSpecialType>;
  responsibleUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zeCode?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingProcedureMsg = {
  additionalFields?: InputMaybe<Input_Billing_BillingProcedureAdditionalFieldsMsg>;
  assignedUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** Required */
  billingCaseId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Input_Billing_ProceduralCodeReferenceMsg>;
  /** this field record whether the procedure was actually used for grouping - it is set by the grouper (e.g. KODIP) */
  drgRelevant?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalBillingProcedureIdMsg>>>;
  firstDocumentingUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  initialCreationContextType?: InputMaybe<Billing_BillingProcedureContextType>;
  /** this field decides whether the procedure should be used for grouping */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** If true, means this procedure is the main procedure for the assigned unit */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastUpdatingUserId?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Laterality_Laterality>;
  order?: InputMaybe<Scalars['Int']>;
  /** Required */
  patientId?: InputMaybe<Scalars['String']>;
  procedureDate?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** Can only be positive */
  quantity?: InputMaybe<Scalars['Int']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_BillingProceduresList = {
  billingProcedures?: InputMaybe<Array<InputMaybe<Input_Billing_BillingProcedureMsg>>>;
};

export type Input_Billing_BillingStatusMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalBillingStatusIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** Indicates whether this billing status is the default not billed status */
  isNotBilled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  status?: InputMaybe<Billing_BillingStatusActivationStatus>;
  tags?: InputMaybe<Array<InputMaybe<Billing_BillingStatusTag>>>;
};

export type Input_Billing_BillingTypeFeeCategoryMappingMsg = {
  allowedFeeCategories?: InputMaybe<Array<InputMaybe<Billing_BillingFeeCategory>>>;
  billingCaseType?: InputMaybe<Billing_BillingCaseType>;
  billingTypeId?: InputMaybe<Scalars['String']>;
  defaultFeeCategories?: InputMaybe<Array<InputMaybe<Billing_BillingFeeCategory>>>;
};

export type Input_Billing_BillingTypeMsg = {
  /** Determines what active period is set on creation of billing case of this type */
  activePeriodTemplate?: InputMaybe<Input_Billing_BillingCasePeriodTemplateMsg>;
  billingTypeTagAssignments?: InputMaybe<Array<InputMaybe<Input_Billing_BillingTypeTagAssignmentMsg>>>;
  enableBillingCertificate?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalBillingTypeIdMsg>>>;
  grouperTypeAssignments?: InputMaybe<Array<InputMaybe<Input_Billing_GrouperTypeAssignmentMsg>>>;
  hasPatientReceipt?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Billing_BillingTypeOwnerMsg>;
  /** The case types for which this billing type can be selected */
  possibleCaseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  /** Coverage types that may be applied to billing cases of this type */
  possibleCoverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
};

export type Input_Billing_BillingTypeOwnerMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_BillingTypeOwnerType>;
};

export type Input_Billing_BillingTypeTagAssignmentMsg = {
  caseType?: InputMaybe<Billing_BillingCaseType>;
  tag?: InputMaybe<Billing_BillingTypeTag>;
};

export type Input_Billing_CancelOrReactivateBillingCaseRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  cancelBillingCase?: InputMaybe<Scalars['Boolean']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  reactivateBillingCase?: InputMaybe<Scalars['Boolean']>;
};

/** Currently not implemented */
export type Input_Billing_CareTeamMemberMsg = {
  id?: InputMaybe<Scalars['String']>;
  practitionerId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Billing_CareTeamMemberRole>>>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Currently not implemented */
export type Input_Billing_CareTeamMsg = {
  activityPeriod?: InputMaybe<Input_TimeFrameMsg>;
  id?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<Array<InputMaybe<Input_Billing_CareTeamMemberMsg>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_CheckBillingCaseStatusUpdateRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  statusFilters?: InputMaybe<Input_Billing_ListBillingCaseStatusesRequest>;
};

export type Input_Billing_CheckBillingCaseStatusUpdateResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Billing_CheckBillingCaseStatusUpdateResponseEntryMsg>>>;
};

export type Input_Billing_CheckBillingCaseStatusUpdateResponseEntryMsg = {
  /** Whether it is possible to select this status for the requested billing case or not. */
  canBeSelected?: InputMaybe<Scalars['Boolean']>;
  caseStatus?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
  /** The failing checks that prevent the selection of this status. */
  reasons?: InputMaybe<Array<InputMaybe<Billing_BillingCaseStatusCheckFailureReason>>>;
};

/** Currently not implemented */
export type Input_Billing_ClaimItemMsg = {
  billingPosition?: InputMaybe<Input_Billing_BillingPositionMsg>;
  id?: InputMaybe<Scalars['String']>;
  pricingUnit?: InputMaybe<Billing_ValueUnitType>;
  value?: InputMaybe<Input_DecimalMsg>;
};

/** Currently not implemented */
export type Input_Billing_ClaimMsg = {
  /** Whether new billing positions in the case are added to this claim; only one active claim per case allowed */
  active?: InputMaybe<Scalars['Boolean']>;
  /** TODO: Decide on side of relationship */
  billingCaseId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<Input_Billing_ClaimItemMsg>>>;
  status?: InputMaybe<Billing_ClaimStatus>;
};

export type Input_Billing_CostUnitTypeMappingMsg = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  caseType?: InputMaybe<Billing_BillingCaseType>;
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_CostUnitVisitTypeMappingMsg = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  caseType?: InputMaybe<Billing_BillingCaseType>;
  defaultVisitType?: InputMaybe<Patient_VisitType>;
  id?: InputMaybe<Scalars['String']>;
  possibleVisitTypes?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Billing_CoverageAssignmentMsg = {
  coverage?: InputMaybe<Input_Billing_CoverageMsg>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_CoverageAssignmentTemplateMsg = {
  /** If true, only applies to coverages with billing case scope */
  billingCaseScope?: InputMaybe<Scalars['Boolean']>;
  coverageType?: InputMaybe<Billing_CoverageType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Used to auto-fill coverages on billing case based on its billing type */
export type Input_Billing_CoverageAssignmentsTemplateMsg = {
  assignmentTemplates?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageAssignmentTemplateMsg>>>;
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_CoverageHolderReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_CoverageHolderType>;
};

export type Input_Billing_CoverageIdentifierMsg = {
  identifier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_CoverageIdentifierType>;
};

export type Input_Billing_CoverageList = {
  coverages?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageMsg>>>;
};

export type Input_Billing_CoverageMsg = {
  /** Person who holds the coverage, German "Hauptversicherter" */
  coverageHolder?: InputMaybe<Input_Billing_CoverageHolderReferenceMsg>;
  coverageIdentifiers?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageIdentifierMsg>>>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  insurer?: InputMaybe<Input_Billing_InsurerMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  payors?: InputMaybe<Array<InputMaybe<Input_Billing_PayorReferenceMsg>>>;
  proofsOfInsurance?: InputMaybe<Array<InputMaybe<Input_Billing_ProofOfInsuranceMsg>>>;
  /** If set, means that the coverage can only be used for the given billing case // TODO: Should patientId still be set? Probably yes. TODO: In service, it's BillingCase instead of id, but for proto, it gets annoying due to circular import. Probably id in the message is fine */
  scopeBillingCaseId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** TODO: How to differentiate KV vs. non-KV? */
  type?: InputMaybe<Billing_CoverageType>;
  validityPeriod?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_CreateBillingCaseFileRequest = {
  /** optional; otherwise, all certificates for unit and quarter are used */
  billingCertificateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quarterStartDate?: InputMaybe<Input_Timestamp>;
  telematikConnectorId?: InputMaybe<Scalars['String']>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_CreateBillingCaseFileResponse = {
  validationErrors?: InputMaybe<Scalars['String']>;
  validationFileUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_CreateBillingPositionRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  billingDayId?: InputMaybe<Scalars['String']>;
  billingPosition?: InputMaybe<Input_Billing_BillingPositionMsg>;
};

export type Input_Billing_CreateBillingProcedureRequest = {
  billingProcedure?: InputMaybe<Input_Billing_BillingProcedureMsg>;
};

export type Input_Billing_CreateBillingProcedureResponse = {
  billingProcedure?: InputMaybe<Input_Billing_BillingProcedureMsg>;
};

export type Input_Billing_CreateCostUnitVisitTypeMappingRequest = {
  mapping?: InputMaybe<Input_Billing_CostUnitVisitTypeMappingMsg>;
};

export type Input_Billing_CreateCostUnitVisitTypeMappingResponse = {
  mapping?: InputMaybe<Input_Billing_CostUnitVisitTypeMappingMsg>;
};

export type Input_Billing_CreateCoverageRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  coverage?: InputMaybe<Input_Billing_CoverageMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
};

/**
 * +++[ REQUESTS ]+++
 * ****************
 */
export type Input_Billing_CreateInsurersRequest = {
  insurers?: InputMaybe<Array<InputMaybe<Input_Billing_InsurerMsg>>>;
};

export type Input_Billing_CreateInvoiceRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingPositionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * to find an invoice type and default designated user in billing config
   *  should be set if billing case has no billingUnitReference
   */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_CreateMaterialBillingCostRequest = {
  /**
   * optional, if set will create the material cost using the configuration
   *  and the fields in the material cost message will be ignored (except quantity)
   */
  configurationId?: InputMaybe<Scalars['String']>;
  materialCost?: InputMaybe<Input_Billing_BillingMaterialCostMsg>;
};

export type Input_Billing_CreateOrUpdateInsurerRequest = {
  /** if set the entity is searched by external Id with the given type */
  byExternalIdType?: InputMaybe<Billing_ExternalInsurerIdType>;
  insurer?: InputMaybe<Input_Billing_InsurerMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_CreateProofOfInsuranceRequest = {
  coverageId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DavMsg = {
  ik?: InputMaybe<Input_Billing_InstitutionIdentifierMsg>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DavsMsg = {
  davCoverage?: InputMaybe<Input_Billing_DavMsg>;
  davFederal?: InputMaybe<Input_Billing_DavMsg>;
  davState?: InputMaybe<Input_Billing_DavMsg>;
};

export type Input_Billing_DeleteBillingCaseRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  hardDelete?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_DeleteBillingCaseStatusRequest = {
  billingCaseStatusId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteBillingFeeCategoryConfigurationRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  contextId?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Input_Billing_DeleteBillingFeeCategoryConfigurationResponse = {
  billingFeeCategoryConfiguration?: InputMaybe<Input_Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Input_Billing_DeleteBillingPositionRequest = {
  billingDayId?: InputMaybe<Scalars['String']>;
  billingPositionId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteBillingPositionsRequest = {
  billingPositionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_DeleteBillingPositionsResponse = {
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
};

export type Input_Billing_DeleteBillingProcedureRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteBillingProcedureResponse = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteBillingStatusRequest = {
  billingStatusId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteBillingTypeRequest = {
  billingTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCostUnitTypeMappingRequest = {
  costUnitTypeMappingId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCostUnitTypeMappingResponse = {
  deletedCostUnitTypeMappingId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCostUnitVisitTypeMappingRequest = {
  costUnitVisitTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCostUnitVisitTypeMappingResponse = {
  deletedCostUnitVisitTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCoverageAssignmentsTemplateRequest = {
  coverageAssignmentsTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCoverageAssignmentsTemplateResponse = {
  deletedCoverageAssignmentsTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCoverageRequest = {
  coverageId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteCoverageResponse = {
  deletedCoverageId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteInvoiceRequest = {
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeleteInvoiceResponse = {
  deletedInvoiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_DeriveFlatRatesFromTreatmentRequest = {
  icdCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_DeriveGoaeCodesFromTreatmentRequest = {
  treatment?: InputMaybe<Input_Treatment_TreatmentMsg>;
};

export type Input_Billing_DiscountMsg = {
  discountAmount?: InputMaybe<Input_Billing_Money>;
  discountDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** DRG grouping result; usually from KODIP */
export type Input_Billing_DrgBillingFieldsMsg = {
  /** Zusatzentgelte */
  additionalFees?: InputMaybe<Array<InputMaybe<Input_Billing_DrgCalculatedAdditionalFeesMsg>>>;
  /** Grouper status flag für das Aufnahme-/Geburtsgewicht (in g) */
  admissionBodyWeightGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für den Aufnahmeanlass (§ 21) */
  admissionEventGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für den Aufnahmegrund (§ 301) */
  admissionReasonGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für das Alter in Tagen (ab 2011_2013) */
  ageDaysGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für das Alter in Jahren (ab 2011_2013) */
  ageYearsGrouperStatus?: InputMaybe<Scalars['String']>;
  /**
   * B-BEP Abschlag in Euro
   *  B-BEP = Beatmungsstatus/Beatmungsentwöhnungspotentials
   */
  bBepDiscount?: InputMaybe<Input_DecimalMsg>;
  bBepDiscountType?: InputMaybe<Billing_BbepDiscountType>;
  /** Basisfallwert */
  baseRate?: InputMaybe<Input_DecimalMsg>;
  /**
   * Abschlag in Euro pro Tag bei Unterschreitung der oGVD
   *  Discount in euros per day if the upper limit of stay is not met
   */
  dailyLengthOfStayDiscount?: InputMaybe<Input_DecimalMsg>;
  /**
   * Zuschlag in Euro pro Tag bei Überschreitung der oGVD
   *  Surcharge in euros per day if the upper limit length of stay is exceeded
   */
  dailyLengthOfStaySurcharge?: InputMaybe<Input_DecimalMsg>;
  /**
   * Abschlag in Euro pro Tag bei Unterschreitung der mVD bei Verlegungsfällen
   *  Discount in euros per day if the average length of stay is not met in the case of transfer
   */
  dailyMeanLengthOfStayDiscount?: InputMaybe<Input_DecimalMsg>;
  /** Days below the low trim point; Tage mit Abschlägen wg. Unterschreitung der unteren Grenzverweildauer */
  daysBelowLowerLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
  /**
   * Days below the average length of stay; Tage mit Abschläg wg. Unterschreitung der mittleren Verweildauer bei
   *  Verlegungsfällen
   */
  daysBelowMeanLengthOfStay?: InputMaybe<Scalars['Int']>;
  /** Days exceeding the high trim point; Tage mit Zuschlag wg. Überschreitung der oberen Grenzverweildauer */
  daysExceedingUpperLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
  /** DRG; 0 to 25 */
  diagRelatedGroup?: InputMaybe<Scalars['String']>;
  diagRelatedGroupText?: InputMaybe<Scalars['String']>;
  /** Grouper diagnoses statuses string */
  diagnosesGrouperStatuses?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für den Entlassungsgrund */
  dischargeReasonGrouperStatus?: InputMaybe<Scalars['String']>;
  /**
   * Ab-/Zuschläge zum Standard-DRG-Erlös
   *  Discounts/Surcharges to the standard drg price
   */
  drgPriceAdjustment?: InputMaybe<Input_DecimalMsg>;
  /**
   * Effektiver DRG-Erlös (ohne Zusatzentgelte)
   *  effective DRG price (without additional fees)
   */
  effectiveDrgPrice?: InputMaybe<Input_DecimalMsg>;
  /**
   * Effektiv-Relativgewicht; diesen Wert bitte nur für statische Zwecke nutzen; kaufmännisch korrekt sind der
   *  Eff.Erlös und die Ab/Zuschläge zum Erlös
   *
   *  Effective relative weight; please use this value only for static purposes; commercially correct are the effective
   *  revenue and the discounts/surcharges to the revenue
   */
  effectiveRelativeWeight?: InputMaybe<Input_DecimalMsg>;
  grouperStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Ist Ausnahme von Wiederaufnahme */
  isExceptionOfReadmission?: InputMaybe<Scalars['Boolean']>;
  /**
   * Grouperinformation, ob ein abgesenktes oder nicht-abgesenktes Relativgewicht für die DRG bei der Ermittlung des
   *  Erlöses verwendet wurde
   *  Nein, wenn nicht abgesenkte Bewertungsrelation genutzt worden ist oder eine abgesenkte überhaupt nicht vorhanden
   *  ist
   *  Ja, wenn die abgesenkte abgerechnet wurde (für FPV 2017 nur I68D oder I68E)
   *
   *
   *  Grouper information on whether a reduced or non-reduced relative weight for the DRG was used to determine the
   *  revenue
   *  No, if a non-reduced valuation ratio was used or a reduced one does not exist at all
   *  Yes, if the reduced one was billed (for FPV 2017 only I68D or I68E)
   */
  isReducedRelWeightUsed?: InputMaybe<Scalars['Boolean']>;
  /** Ist eine Verlegungsfallpauschale */
  isRelocationFee?: InputMaybe<Scalars['Boolean']>;
  /** Grouper status flag für Verwendung der Urlaubstage (0=OK, 2= Fehler) */
  leaveDaysGrouperError?: InputMaybe<Scalars['Boolean']>;
  /** Grouper status flag für die Verweildauer */
  lengthOfStayGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Low trim point = 1. mit Abschlag bei Unterschreitung der uGVD */
  lowerLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
  /** Grouper status flag für die Hauptdiagnose */
  mainDiagnosisGrouperStatus?: InputMaybe<Scalars['String']>;
  /** MDC; 0 to 999 */
  majorDiagCategory?: InputMaybe<Scalars['String']>;
  majorDiagCategoryText?: InputMaybe<Scalars['String']>;
  /** mittlere Verweildauer (mVD) */
  meanLengthOfStay?: InputMaybe<Input_DecimalMsg>;
  /**
   * Grouper status flag für MHLS (Mental Health Legal Status - siehe MentalStatus, Status der psychiatrischen
   *  Zwangseinweisung)
   */
  mentalHealthLegalStatusGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Pflexit: Ergebnis für die Pflege-Erlösermittlung durch den DRG-Grouper */
  nursingRevenueResult?: InputMaybe<Input_Billing_DrgNursingRevenueResultMsg>;
  partition?: InputMaybe<Billing_DrgPartition>;
  pccl?: InputMaybe<Scalars['Int']>;
  /** Grouper procedures statuses string */
  proceduresGrouperStatuses?: InputMaybe<Scalars['String']>;
  /** Abschlag-Relativgewicht */
  relativeWeightDiscount?: InputMaybe<Input_DecimalMsg>;
  /** Zuschläge Relativgewicht */
  relativeWeightSurcharge?: InputMaybe<Input_DecimalMsg>;
  /** Verlegung Relativgewicht */
  relocationRelativeWeight?: InputMaybe<Input_DecimalMsg>;
  /** Grouper status flag für SameDay */
  sameDayGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Grouper status flag für das Geschlecht */
  sexGrouperStatus?: InputMaybe<Scalars['String']>;
  /** Standard DRG-Erlös */
  standardDrgPrice?: InputMaybe<Input_DecimalMsg>;
  /** Standard Relativgewicht */
  standardRelativeWeight?: InputMaybe<Input_DecimalMsg>;
  /**
   * Ab-/Zuschläge zum Standard-Relativgewicht;diesen Wert bitte nur für statische Zwecke nutzen; kaufmännisch korrekt
   *  sind der Eff.Erlös und die Ab/Zuschläge zum Erlös
   *
   *  Discounts/surcharges to the standard relative weight; please use this value only for static purposes; commercially
   *  correct are the effective revenue and the discounts/surcharges to the revenue
   */
  standardRelativeWeightAdjustment?: InputMaybe<Input_DecimalMsg>;
  /** Gesamtbetrag der Zusatzentgelte */
  totalAdditionalFee?: InputMaybe<Input_DecimalMsg>;
  /** Rueckgabe: DRG Art Vereinbarung (11=Bundeseinheitlich, 12=Individuell verhandelbar) */
  typeAgreement?: InputMaybe<Billing_DrgTypeAgreement>;
  /** High trim point = 1. mit Zuschlag bei Überschreitung der oberen Grenzverweildauer (oGVD) */
  upperLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
  /**
   * vom Grouper berechnete/benutzte Verweildauer des Falles
   *  Duration of stay of the case calculated/used by the grouper
   *  los = length of stay
   */
  usedLengthOfStay?: InputMaybe<Scalars['Int']>;
  /** Grouper status flag für die Beatmungsstunden */
  ventilationHoursGrouperStatus?: InputMaybe<Scalars['String']>;
};

/** Zusatzentgelte */
export type Input_Billing_DrgCalculatedAdditionalFeesMsg = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  opCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  price?: InputMaybe<Input_DecimalMsg>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_DrgCalculatedAdditionalFeeType>;
};

/** Pflexit result for nursing revenue determination */
export type Input_Billing_DrgNursingRevenueResultMsg = {
  /** Verwendetes Pflegeentgelt */
  baseRate?: InputMaybe<Input_DecimalMsg>;
  /**
   * Pflegebewertungsrelation pro Tag
   *
   *  aka nursing care rating ratio or nursing care assessment ratio
   *
   *  The Nursing Care Rating Ratio per day describes the financial valuation of nursing care services provided to a
   *  patient within a single day in the context of the DRG system
   */
  dailyCareEvalRatio?: InputMaybe<Input_DecimalMsg>;
  /** Erlös in Euro pro Tag */
  pricePerDay?: InputMaybe<Input_DecimalMsg>;
  /** Gesamtzahl der Pflegetage */
  totalCareDays?: InputMaybe<Scalars['Int']>;
  /** Gesamterlös in Euro */
  totalPrice?: InputMaybe<Input_DecimalMsg>;
};

export type Input_Billing_EbsMsg = {
  ebsDescription?: InputMaybe<Scalars['String']>;
  ebsIdentifier?: InputMaybe<Scalars['String']>;
  ik?: InputMaybe<Input_Billing_InstitutionIdentifierMsg>;
};

export type Input_Billing_ExportCodingOverviewRequest = {
  filter?: InputMaybe<Input_Billing_ListBillingCasesRequest>;
};

export type Input_Billing_ExportCodingOverviewResponse = {
  fileName?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ExternalBillingProcedureIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalBillingProcedureIdType>;
};

export type Input_Billing_ExternalBillingStatusIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalBillingStatusIdType>;
};

export type Input_Billing_ExternalBillingTypeIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalBillingTypeIdType>;
};

export type Input_Billing_ExternalInsuranceLegalBasisIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalInsuranceLegalBasisIdType>;
};

export type Input_Billing_ExternalInsurerIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalInsurerIdType>;
};

export type Input_Billing_ExternalInsurerNetworkIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_ExternalInsurerNetworkIdType>;
};

export type Input_Billing_FeeCategoryGroupReferenceMsg = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** i.e. treatment id. pair with context_type */
  contextId?: InputMaybe<Scalars['String']>;
  /** i.e. treatment. pair with context_id */
  contextType?: InputMaybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Input_Billing_FeeCategoryReferenceMsg = {
  billingFeeCategory?: InputMaybe<Billing_BillingFeeCategory>;
  feeCategoryGroupReference?: InputMaybe<Input_Billing_FeeCategoryGroupReferenceMsg>;
};

export type Input_Billing_FindBillingCaseStatusesRequest = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_FindBillingCaseStatusesResponse = {
  billingCaseStatusByName?: InputMaybe<Array<InputMaybe<Input_Billing_FindBillingCaseStatusesResponse_BillingCaseStatusByNameEntry>>>;
};

export type Input_Billing_FindBillingCaseStatusesResponse_BillingCaseStatusByNameEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
};

export type Input_Billing_FindBillingTypeRequest = {
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Billing_BillingTypeOwnerMsg>;
};

export type Input_Billing_FindBillingTypeResponse = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_FindBillingTypesByNameRequest = {
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_FindBillingTypesRequest = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owner?: InputMaybe<Input_Billing_BillingTypeOwnerMsg>;
};

export type Input_Billing_FindBillingTypesResponse = {
  billingTypeByName?: InputMaybe<Array<InputMaybe<Input_Billing_FindBillingTypesResponse_BillingTypeByNameEntry>>>;
};

export type Input_Billing_FindBillingTypesResponse_BillingTypeByNameEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_BillingTypeMsg>;
};

export type Input_Billing_FindCostUnitTypeMappingRequest = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  caseType?: InputMaybe<Billing_BillingCaseType>;
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
};

export type Input_Billing_FindCostUnitTypeMappingResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  mapping?: InputMaybe<Input_Billing_CostUnitTypeMappingMsg>;
};

export type Input_Billing_FindCostUnitVisitTypeMappingRequest = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  caseType?: InputMaybe<Billing_BillingCaseType>;
  /** if not set, allow finding the mapping defined for caseType without billingType if no mapping found for the combination of both */
  requireExactMatch?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_FindCostUnitVisitTypeMappingResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  mapping?: InputMaybe<Input_Billing_CostUnitVisitTypeMappingMsg>;
};

export type Input_Billing_FindCoverageAssignmentsTemplateRequest = {
  billingTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_FindCoverageAssignmentsTemplateResponse = {
  coverageAssignmentsTemplate?: InputMaybe<Input_Billing_CoverageAssignmentsTemplateMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_FindInsurerNetworkRequest = {
  /** mandatory */
  externalId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalIdType?: InputMaybe<Billing_ExternalInsurerNetworkIdType>;
};

export type Input_Billing_FindInsurerNetworkResponse = {
  exists?: InputMaybe<Scalars['Boolean']>;
  insurerNetwork?: InputMaybe<Input_Billing_InsurerNetworkMsg>;
};

export type Input_Billing_FindInsurerRequest = {
  /** optional filter */
  dataSourceType?: InputMaybe<Billing_InsurerDataSourceType>;
  externalId?: InputMaybe<Input_Billing_ExternalInsurerIdMsg>;
  number?: InputMaybe<Scalars['String']>;
  /** filters german Insurers for activity */
  validityPeriod?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_FindInsurerResponse = {
  exists?: InputMaybe<Scalars['Boolean']>;
  insurer?: InputMaybe<Input_Billing_InsurerMsg>;
};

export type Input_Billing_FindValidCoverageTypesRequest = {
  /** billing type id is a required filter */
  billingTypeId?: InputMaybe<Scalars['String']>;
  /** optional filter */
  caseType?: InputMaybe<Billing_BillingCaseType>;
};

export type Input_Billing_FindValidCoverageTypesResponse = {
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
};

export type Input_Billing_FinishBillingCaseAdministrationRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  confirmBillingCaseTypeChange?: InputMaybe<Scalars['Boolean']>;
  discharged?: InputMaybe<Scalars['Boolean']>;
  preliminary?: InputMaybe<Scalars['Boolean']>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Billing_GermanBgInvoiceDetailsMsg = {
  /** Rechnungstyp [sri_2] */
  bgInvoiceType?: InputMaybe<Billing_German_BgInvoiceType>;
  designatedUserId?: InputMaybe<Scalars['String']>;
  diagnosisDetails?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  freeTextDiagnosis?: InputMaybe<Scalars['String']>;
  /** [sri_6] */
  generalCostsFeeTotal?: InputMaybe<Input_Billing_Money>;
  id?: InputMaybe<Scalars['String']>;
  linkedFormId?: InputMaybe<Scalars['String']>;
  /** [sri_7] */
  materialCostsFeeTotal?: InputMaybe<Input_Billing_Money>;
  priceTotalHospital?: InputMaybe<Input_Billing_Money>;
  /** [kto_1] */
  priceTotalPhysician?: InputMaybe<Input_Billing_Money>;
  /** [sri_4] */
  selectedTreatmentTypeFeeTotal?: InputMaybe<Input_Billing_Money>;
  /** [sri_5] */
  specialCostHospitalTotal?: InputMaybe<Input_Billing_Money>;
  /** [sri_5] */
  specialCostPhysicianTotal?: InputMaybe<Input_Billing_Money>;
  /** Art der Heilbehandlung [sri_1] */
  therapeuticTreatmentBillingType?: InputMaybe<Billing_TherapeuticTreatmentBillingType>;
  xmlInfoId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GermanInsurerBillingInformationMsg = {
  insurerBillingNumber?: InputMaybe<Scalars['String']>;
  isBillingIk?: InputMaybe<Scalars['Boolean']>;
  validityPeriod?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_GermanInsurerInformationMsg = {
  /** gueltigkeit */
  activePeriod?: InputMaybe<Input_TimeFrameMsg>;
  /** adresse_liste -> anschrift */
  address?: InputMaybe<Input_Core_AddressMsg>;
  /** kt_abrechnungsbereich_liste */
  billingAreas?: InputMaybe<Array<InputMaybe<Input_Billing_BillingAreaMsg>>>;
  /** abrechnungsstelle */
  billingOffice?: InputMaybe<Input_Billing_BillingOfficeMsg>;
  /** gebuehrenordnung */
  billingSystem?: InputMaybe<Billing_BillingCatalogType>;
  /** vertrags_kv */
  contractKvId?: InputMaybe<Scalars['String']>;
  datasetQuarter?: InputMaybe<Scalars['Int']>;
  datasetYear?: InputMaybe<Scalars['Int']>;
  /** dav_liste */
  davs?: InputMaybe<Input_Billing_DavsMsg>;
  /** ebs */
  ebs?: InputMaybe<Input_Billing_EbsMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** unz_kv_geltungsbereich_liste */
  inadmissibleKvAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** abrechnungs_ik */
  insurerBillingInfo?: InputMaybe<Array<InputMaybe<Input_Billing_GermanInsurerBillingInformationMsg>>>;
  /** bezeichnung */
  insurerDescription?: InputMaybe<Input_Billing_InsurerDescriptionMsg>;
  /** existenzbeendigung */
  insurerExistenceFinish?: InputMaybe<Input_Billing_InsurerExistenceFinishMsg>;
  /** kostentraegergruppe */
  insurerGroupId?: InputMaybe<Scalars['String']>;
  /** letzte_aenderung */
  lastChange?: InputMaybe<Input_Billing_LastChangeMsg>;
  /** ortssuchname_liste -> ortssuchname */
  placeSearchNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** adresse_liste -> postfach */
  postOfficeBox?: InputMaybe<Input_Core_AddressMsg>;
  /** "Temporärer Kostenträger-Stammsatz" */
  temporary?: InputMaybe<Scalars['Boolean']>;
  vknr?: InputMaybe<Scalars['String']>;
  /** wop */
  wop?: InputMaybe<Input_Billing_PlaceOfResidencePrincipleMsg>;
};

export type Input_Billing_GermanInsurerSearchAidMsg = {
  /** German "Ortssuchname" */
  locationSearchTexts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Additional name by which search is possible, German "Suchname" */
  searchName?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingCaseByCaseNumberRequest = {
  billingCaseNumber?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingCaseRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingCasesRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_GetBillingFeeCategoryConfigurationRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  contextId?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Input_Billing_GetBillingFeeCategoryConfigurationResponse = {
  allowedFeeCategories?: InputMaybe<Array<InputMaybe<Billing_BillingFeeCategory>>>;
  billingFeeCategoryConfiguration?: InputMaybe<Input_Billing_BillingFeeCategoryConfigurationMsg>;
  defaultFeeCategories?: InputMaybe<Array<InputMaybe<Billing_BillingFeeCategory>>>;
};

export type Input_Billing_GetBillingProcedureBulkRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_GetBillingProcedureRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingProcedureResponse = {
  billingProcedure?: InputMaybe<Input_Billing_BillingProcedureMsg>;
};

export type Input_Billing_GetBillingProceduresLetterTextRequest = {
  generationParameters?: InputMaybe<Input_Common_Letter_LetterTextGenerationParametersMsg>;
  surgeryId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingTypeFeeCategoryMappingRequest = {
  billingCaseType?: InputMaybe<Billing_BillingCaseType>;
  billingTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetBillingTypeFeeCategoryMappingResponse = {
  billingTypeFeeCategoryMapping?: InputMaybe<Input_Billing_BillingTypeFeeCategoryMappingMsg>;
};

export type Input_Billing_GetCoverageRequest = {
  coverageId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetCoveragesRequest = {
  coverageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_GetCurrentCaseRequest = {
  /** must be provided if requireExactUnit is false and the unitReference point to an organizational unit */
  parentDepartmentId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  /** If true, only cases that belong to the exact unitReference are considered; if false, the unit's parents as well */
  requireExactUnit?: InputMaybe<Scalars['Boolean']>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_GetCurrentCaseResponse = {
  case?: InputMaybe<Input_Billing_BillingCaseMsg>;
};

export type Input_Billing_GetInvoiceRequest = {
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetLightBillingCaseInfoRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_GetLightBillingCaseInfoResponse = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  currentStatus?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
};

export type Input_Billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionResponse = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionsRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_GrouperTypeAssignmentMsg = {
  caseType?: InputMaybe<Billing_BillingCaseType>;
  grouperType?: InputMaybe<Billing_GrouperType>;
};

export type Input_Billing_InstitutionIdentifierMsg = {
  ikNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_InsuranceLegalBasisMsg = {
  description?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalInsuranceLegalBasisIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_InsurerDescriptionMsg = {
  name?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sortName?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_InsurerExistenceFinishMsg = {
  acquiringCoverageId?: InputMaybe<Scalars['String']>;
  finishType?: InputMaybe<Billing_InsurerFinishType>;
  lastQuarter?: InputMaybe<Scalars['Int']>;
  lastYear?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_InsurerFeeScheduleKeyValueMsg = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_InsurerGroupKeyValueMsg = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_InsurerList = {
  insurers?: InputMaybe<Array<InputMaybe<Input_Billing_InsurerMsg>>>;
};

export type Input_Billing_InsurerMsg = {
  /** German "Gebührenordnung" */
  billingTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCatalogType>>>;
  /** Id of the catalog responsible for loading this insurer instance */
  catalogId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  dataSourceType?: InputMaybe<Billing_InsurerDataSourceType>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalInsurerIdMsg>>>;
  germanInsurerInformation?: InputMaybe<Input_Billing_GermanInsurerInformationMsg>;
  id?: InputMaybe<Scalars['String']>;
  legalBasis?: InputMaybe<Array<InputMaybe<Input_Billing_InsuranceLegalBasisMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Array<InputMaybe<Input_Billing_InsurerNetworkMsg>>>;
  /** For Germans: IKNR */
  number?: InputMaybe<Scalars['String']>;
  /** For custom insurers, the unit responsible for configuration of the insurer */
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  validity?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_InsurerNetworkMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalInsurerNetworkIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_InvoiceMsg = {
  billingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Billing_InvoiceCategory>;
  /** Precise date */
  dueDate?: InputMaybe<Input_Timestamp>;
  /** Either relative e.g. in 5 days */
  dueDateDuration?: InputMaybe<Input_PrecisionDurationMsg>;
  externalOrganizationId?: InputMaybe<Scalars['String']>;
  finalPaymentDate?: InputMaybe<Input_Timestamp>;
  germanBgInvoiceDetails?: InputMaybe<Input_Billing_GermanBgInvoiceDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** if type is FINAL or CONSOLIDATED the invoice can contain other invoices */
  includedInvoices?: InputMaybe<Array<InputMaybe<Input_Billing_InvoiceMsg>>>;
  invoiceTextHtml?: InputMaybe<Scalars['String']>;
  issuer?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** Consecutive bill number */
  number?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  paid?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  performancePeriod?: InputMaybe<Input_TimeFrameMsg>;
  positions?: InputMaybe<Array<InputMaybe<Input_Billing_InvoicePositionMsg>>>;
  /** Date to be displayed on the bill */
  postedDate?: InputMaybe<Input_Timestamp>;
  procedureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** refered invoice used for reminders */
  referencedInvoice?: InputMaybe<Input_Billing_InvoiceMsg>;
  status?: InputMaybe<Billing_InvoiceStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_InvoicePositionMsg = {
  billingPosition?: InputMaybe<Input_Billing_BillingPositionMsg>;
  /** percentage that of total billing position contained in this invoice */
  splitPercentage?: InputMaybe<Input_DecimalMsg>;
  /** absolute value of total billing position contained in this invoice */
  splitPrice?: InputMaybe<Input_Billing_Money>;
};

export type Input_Billing_LastChangeMsg = {
  /** wirksamkeitsdatum */
  effectiveDate?: InputMaybe<Input_Timestamp>;
  /** erfassungsdatum */
  entryDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Billing_LengthOfStayStatus = {
  lowerLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
  meanLengthOfStay?: InputMaybe<Input_DecimalMsg>;
  upperLengthOfStayLimit?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_ListBillingCaseDiagnosesRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListBillingCaseDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Billing_ListBillingCaseLockedStatusesRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListBillingCaseLockedStatusesResponse = {
  billingCaseIdToLocked?: InputMaybe<Array<InputMaybe<Input_Billing_ListBillingCaseLockedStatusesResponse_BillingCaseIdToLockedEntry>>>;
};

export type Input_Billing_ListBillingCaseLockedStatusesResponse_BillingCaseIdToLockedEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_ListBillingCasePatientsRequest = {
  billingStatusIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caseNumber?: InputMaybe<Scalars['String']>;
  caseStatusIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  coverageIdentifier?: InputMaybe<Scalars['String']>;
  coverageType?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  dischargeTimeFilters?: InputMaybe<Input_Billing_BillingCaseDischargeTimeFiltersMsg>;
  sktDetails?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListBillingCasePatientsResponse = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListBillingCaseStatusesRequest = {
  /** optional filter */
  caseType?: InputMaybe<Billing_BillingCaseType>;
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional */
  statusCategory?: InputMaybe<Billing_BillingCaseStatusCategory>;
};

export type Input_Billing_ListBillingCaseStatusesResponse = {
  billingCaseStatuses?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCaseStatusMsg>>>;
};

export type Input_Billing_ListBillingCasesRequest = {
  /** optional */
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingStatusIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caseNumber?: InputMaybe<Scalars['String']>;
  caseReleaseTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  caseStatusIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  coverageIdentifier?: InputMaybe<Scalars['String']>;
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  /** Whether the cases should be ordered ascending or descending (default) by date */
  dateOrderAscending?: InputMaybe<Scalars['Boolean']>;
  dischargeTimeFilters?: InputMaybe<Input_Billing_BillingCaseDischargeTimeFiltersMsg>;
  drgFilters?: InputMaybe<Input_Billing_BillingCaseDrgFiltersMsg>;
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relevantUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  sktDetails?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListBillingCasesResponse = {
  billingCases?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCaseMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_ListBillingDayBillingPositionsRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  billingFeeCategory?: InputMaybe<Billing_BillingFeeCategory>;
  billingPositionType?: InputMaybe<Billing_BillingPositionType>;
};

export type Input_Billing_ListBillingDayBillingPositionsResponse = {
  billingDayBillingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingDayBillingPositionList>>>;
};

export type Input_Billing_ListBillingPositionsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingCertificateId?: InputMaybe<Scalars['String']>;
  billingDayId?: InputMaybe<Scalars['String']>;
  billingFeeCategory?: InputMaybe<Billing_BillingFeeCategory>;
  billingPositionType?: InputMaybe<Billing_BillingPositionType>;
  from?: InputMaybe<Input_Timestamp>;
  patientId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Input_Timestamp>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListBillingPositionsResponse = {
  billingPositions?: InputMaybe<Array<InputMaybe<Input_Billing_BillingPositionMsg>>>;
};

export type Input_Billing_ListBillingProceduresBulkRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListBillingProceduresBulkResponse = {
  billingProceduresByBillingCaseId?: InputMaybe<Array<InputMaybe<Input_Billing_ListBillingProceduresBulkResponse_BillingProceduresByBillingCaseIdEntry>>>;
};

export type Input_Billing_ListBillingProceduresBulkResponse_BillingProceduresByBillingCaseIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_BillingProceduresList>;
};

export type Input_Billing_ListBillingProceduresRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListBillingProceduresResponse = {
  billingProcedures?: InputMaybe<Array<InputMaybe<Input_Billing_BillingProcedureMsg>>>;
};

export type Input_Billing_ListBillingStatusesRequest = {
  /** optional filter */
  isNotBilled?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_ListBillingStatusesResponse = {
  billingStatuses?: InputMaybe<Array<InputMaybe<Input_Billing_BillingStatusMsg>>>;
};

export type Input_Billing_ListBillingTypesRequest = {
  /** optional filter */
  caseType?: InputMaybe<Billing_BillingCaseType>;
  owner?: InputMaybe<Input_Billing_BillingTypeOwnerMsg>;
};

export type Input_Billing_ListBillingTypesResponse = {
  billingTypes?: InputMaybe<Array<InputMaybe<Input_Billing_BillingTypeMsg>>>;
};

export type Input_Billing_ListCoverageHoldersRequest = {
  deactivated?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ListCoverageHoldersResponse = {
  coverageHolders?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageHolderReferenceMsg>>>;
};

export type Input_Billing_ListCoveragesRequest = {
  /** filters for the scopeBillingCaseId of the coverage, not for whether a coverage is assigned to that billing case */
  billingCaseId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  /** if empty, don't filter by type */
  types?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
};

export type Input_Billing_ListCoveragesResponse = {
  coverages?: InputMaybe<Array<InputMaybe<Input_Billing_CoverageMsg>>>;
};

export type Input_Billing_ListExternalBillingCaseIdsRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListExternalBillingCaseIdsResponse = {
  identifiers?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCaseIdentifiersMsg>>>;
};

export type Input_Billing_ListInsurersRequest = {
  /** If set, only returns insurers that match all provided billingCatalogTypes */
  billingCatalogTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCatalogType>>>;
  /** If set, only returns insurers that match all provided coverageTypes */
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  /** optional filter */
  dataSourceType?: InputMaybe<Billing_InsurerDataSourceType>;
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_ListInsurersResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  insurers?: InputMaybe<Array<InputMaybe<Input_Billing_InsurerMsg>>>;
};

export type Input_Billing_ListInvoicesRequest = {
  billingCaseStatusIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingCaseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  billingTypeTag?: InputMaybe<Billing_BillingTypeTag>;
  daleStatuses?: InputMaybe<Array<InputMaybe<Billing_DaleXmlStatus>>>;
  genders?: InputMaybe<Array<InputMaybe<Core_Sex>>>;
  invoiceStatuses?: InputMaybe<Array<InputMaybe<Billing_InvoiceStatus>>>;
  leadingUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  treatmentType?: InputMaybe<Billing_TherapeuticTreatmentBillingType>;
  /** optional for BG invoices */
  xmlInfoIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListInvoicesResponse = {
  invoices?: InputMaybe<Array<InputMaybe<Input_Billing_InvoiceMsg>>>;
};

export type Input_Billing_ListLengthOfStayStatusesRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListLengthOfStayStatusesResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Billing_ListLengthOfStayStatusesResponseEntry>>>;
};

export type Input_Billing_ListLengthOfStayStatusesResponseEntry = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  lengthOfStayStatus?: InputMaybe<Input_Billing_LengthOfStayStatus>;
};

export type Input_Billing_ListPatientCaseIdsRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_ListPatientCaseIdsResponse = {
  patientIdToBillingCaseIds?: InputMaybe<Array<InputMaybe<Input_Billing_ListPatientCaseIdsResponse_PatientIdToBillingCaseIdsEntry>>>;
};

export type Input_Billing_ListPatientCaseIdsResponse_PatientIdToBillingCaseIdsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_BillingCaseIdList>;
};

export type Input_Billing_MaterialCompanyMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** for type manufacturer */
  manufacturerNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  status?: InputMaybe<Billing_MaterialCostTemplateStatus>;
  /** for type supplier */
  supplierNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_MaterialCompanyType>;
};

export type Input_Billing_MaterialCostTemplateLabelMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  status?: InputMaybe<Billing_MaterialCostTemplateStatus>;
};

/**
 * we can not use google.type.Money because of course the python library is older than yours truly.
 *  Represents an amount of money with its currency type.
 */
export type Input_Billing_Money = {
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   *  The value must be between -999,999,999 and +999,999,999 inclusive.
   *  If `units` is positive, `nanos` must be positive or zero.
   *  If `units` is zero, `nanos` can be positive, zero, or negative.
   *  If `units` is negative, `nanos` must be negative or zero.
   *  For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos?: InputMaybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   *  For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units?: InputMaybe<Scalars['Long']>;
};

export type Input_Billing_MultiplierJustificationMsg = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_MultiplierMsg = {
  factor?: InputMaybe<Input_DecimalMsg>;
  justification?: InputMaybe<Input_Billing_MultiplierJustificationMsg>;
};

export type Input_Billing_OccupationalAccidentInsuranceFieldsMsg = {
  generalCostsFee?: InputMaybe<Input_Billing_Money>;
  id?: InputMaybe<Scalars['String']>;
  justification?: InputMaybe<Scalars['String']>;
  materialCostsFee?: InputMaybe<Input_Billing_Money>;
  medicalProviderId?: InputMaybe<Scalars['String']>;
  medicalTreatmentType?: InputMaybe<Billing_MedicalTreatmentType>;
  organ?: InputMaybe<Scalars['String']>;
  selectedTreatmentTypeFee?: InputMaybe<Input_Billing_Money>;
  specialCostFeeHospitals?: InputMaybe<Input_Billing_Money>;
  specialCostFeePhysicians?: InputMaybe<Input_Billing_Money>;
  therapeuticTreatmentBillingType?: InputMaybe<Billing_TherapeuticTreatmentBillingType>;
  time?: InputMaybe<Input_Timestamp>;
  typeOfExamination?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_PayorReferenceMsg = {
  payorId?: InputMaybe<Scalars['String']>;
  /** For some insurances multiple references are valid */
  primary?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Billing_PayorReferenceType>;
};

export type Input_Billing_PlaceOfResidenceMsg = {
  districtOfficeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_PlaceOfResidencePrincipleMsg = {
  placesOfResidence?: InputMaybe<Array<InputMaybe<Input_Billing_PlaceOfResidenceMsg>>>;
  wopValue?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_PriceInformationMsg = {
  calculationDetails?: InputMaybe<Input_Billing_PriceInformationMsg_PriceCalculationDetailsMsg>;
  grossPrice?: InputMaybe<Input_Billing_Money>;
  grossPriceString?: InputMaybe<Scalars['String']>;
  netPrice?: InputMaybe<Input_Billing_Money>;
  netPriceInCents?: InputMaybe<Scalars['Int']>;
  netPriceString?: InputMaybe<Scalars['String']>;
  totalGrossCost?: InputMaybe<Input_Billing_Money>;
  totalGrossCostString?: InputMaybe<Scalars['String']>;
  totalGrossMaterialCost?: InputMaybe<Input_Billing_Money>;
  totalGrossMaterialCostString?: InputMaybe<Scalars['String']>;
  vat?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_PriceInformationMsg_PriceCalculationDetailsMsg = {
  basePrice?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  weightedPrice?: InputMaybe<Scalars['String']>;
  weightedPriceWithQuantity?: InputMaybe<Scalars['String']>;
  weighting?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ProceduralCodeReferenceMsg = {
  opsCode?: InputMaybe<Scalars['String']>;
  opsVersion?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ProofOfInsuranceMsg = {
  /** not stored, but calculated by backend as convenience for the frontend */
  active?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time period for which this proof of insurance is accepted - once activity period is over,
   *  a new proof of insurance is required (typically means providing the same document, e.g., a coverage card, again)
   */
  activityPeriod?: InputMaybe<Input_TimeFrameMsg>;
  germanPrivateCoverageInformation?: InputMaybe<Input_Billing_German_GermanPrivateCoverageInformationMsg>;
  /** can be set together with telematikPatientCoreDataEntryId/telematikLegacyPatientCoreDataEntryId */
  germanStatutoryCoverageInformation?: InputMaybe<Input_Billing_German_GermanStatutoryCoverageInformationMsg>;
  id?: InputMaybe<Scalars['String']>;
  telematikLegacyPatientCoreDataEntryId?: InputMaybe<Scalars['String']>;
  telematikPatientCoreDataEntryId?: InputMaybe<Scalars['String']>;
  /** If multiple active proofs of insurance exist, the one that was created later is taken as the one active proof */
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Billing_ProofOfInsuranceType>;
};

export type Input_Billing_RemoveInvoicePositionsRequest = {
  billingPositionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_RemoveMaterialCostsFromBillingPositionRequest = {
  billingPositionId?: InputMaybe<Scalars['String']>;
  materialCostIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_SearchBillingCaseStatusRequest = {
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_SearchBillingCaseStatusResponse = {
  hits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_SearchBillingRequest = {
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_SearchBillingResponse = {
  hits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_SearchBillingTypeRequest = {
  caseType?: InputMaybe<Billing_BillingCaseType>;
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_SearchBillingTypeResponse = {
  hits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_SearchInsurerRequest = {
  coverageType?: InputMaybe<Billing_CoverageType>;
  /** optional filter */
  dataSourceType?: InputMaybe<Billing_InsurerDataSourceType>;
  /** if set, will be used to resolve search config in the backend that may set filters that are not set in request */
  searchScope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ServiceReferenceMsg = {
  targetId?: InputMaybe<Scalars['String']>;
  targetType?: InputMaybe<Billing_ServiceType>;
};

export type Input_Billing_SetBillingFeeCategoryConfigurationRequest = {
  billingFeeCategoryConfiguration?: InputMaybe<Input_Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Input_Billing_SetBillingFeeCategoryConfigurationResponse = {
  billingFeeCategoryConfiguration?: InputMaybe<Input_Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Input_Billing_SetBillingTypeFeeCategoryMappingRequest = {
  billingTypeFeeCategoryMapping?: InputMaybe<Input_Billing_BillingTypeFeeCategoryMappingMsg>;
};

export type Input_Billing_SetBillingTypeFeeCategoryMappingResponse = {
  billingTypeFeeCategoryMapping?: InputMaybe<Input_Billing_BillingTypeFeeCategoryMappingMsg>;
};

export type Input_Billing_TravelExpenseMsg = {
  distanceInKm?: InputMaybe<Input_DecimalMsg>;
  travelZone?: InputMaybe<Billing_TravelZone>;
  visitLocation?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_UpdateBillingCaseDischargeScheduleRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingCaseStatusUpdateType?: InputMaybe<Billing_DischargeBillingCaseStatusUpdateType>;
  dischargeDate?: InputMaybe<Input_Timestamp>;
  onlyDischargeDate?: InputMaybe<Scalars['Boolean']>;
  onlyPlannedDischargeDate?: InputMaybe<Scalars['Boolean']>;
  plannedDischargeDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Billing_UpdateBillingCaseRequest = {
  billingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  ignoreLock?: InputMaybe<Scalars['Boolean']>;
  /**
   * The id of the new outpatient visit, which is created as a result of billing case type change
   *  from inpatient to outpatient. Optional field. If provided, triggers handling the case type change.
   */
  newVisitId?: InputMaybe<Scalars['String']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateBillingCaseResponse = {
  billingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
  failureReasons?: InputMaybe<Array<InputMaybe<Billing_BillingCaseStatusCheckFailureReason>>>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_UpdateBillingCaseStatusRequest = {
  billingCaseStatus?: InputMaybe<Input_Billing_BillingCaseStatusMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateBillingCaseTypeRequest = {
  /** mandatory */
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  targetType?: InputMaybe<Billing_BillingCaseType>;
  /** TODO: Required? */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_UpdateBillingCaseTypeResponse = {
  billingCase?: InputMaybe<Input_Billing_BillingCaseMsg>;
  /** Set if a new visit was created due to the billing case type update */
  createdVisitId?: InputMaybe<Scalars['String']>;
  oldBillingCaseType?: InputMaybe<Billing_BillingCaseType>;
  oldBillingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
};

export type Input_Billing_UpdateBillingPositionBillingDayRequest = {
  billingDayId?: InputMaybe<Scalars['String']>;
  billingPositionId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_UpdateBillingPositionRequest = {
  billingPosition?: InputMaybe<Input_Billing_BillingPositionMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateBillingProcedureRequest = {
  billingProcedure?: InputMaybe<Input_Billing_BillingProcedureMsg>;
  /** Required for Kodip interface robustness */
  ignoreInvalidDate?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateBillingProcedureResponse = {
  billingProcedure?: InputMaybe<Input_Billing_BillingProcedureMsg>;
  updatedBillingProcedures?: InputMaybe<Array<InputMaybe<Input_Billing_BillingProcedureMsg>>>;
};

export type Input_Billing_UpdateBillingProceduresDateRequest = {
  procedureDate?: InputMaybe<Input_PrecisionTimestampMsg>;
  surgeryId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_UpdateBillingStatusRequest = {
  billingStatus?: InputMaybe<Input_Billing_BillingStatusMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateBillingTypeRequest = {
  billingType?: InputMaybe<Input_Billing_BillingTypeMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateCostUnitVisitTypeMappingRequest = {
  mapping?: InputMaybe<Input_Billing_CostUnitVisitTypeMappingMsg>;
};

export type Input_Billing_UpdateCostUnitVisitTypeMappingResponse = {
  mapping?: InputMaybe<Input_Billing_CostUnitVisitTypeMappingMsg>;
};

export type Input_Billing_UpdateCoverageRequest = {
  coverage?: InputMaybe<Input_Billing_CoverageMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateDesignatedUserRequest = {
  designatedUserId?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_UpdateInvoiceRequest = {
  invoice?: InputMaybe<Input_Billing_InvoiceMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_UpdateMaterialCostRequest = {
  billingPositionId?: InputMaybe<Scalars['String']>;
  materialCost?: InputMaybe<Input_Billing_BillingMaterialCostMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

/** Sent from Visit to Billing */
export type Input_Billing_UpdateRelatedUnitsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  relatedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_Billing_ValidateInsurerRequest = {
  insurerId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_ValidateInsurerResponse = {
  invalidExternalIds?: InputMaybe<Array<InputMaybe<Input_Billing_ExternalInsurerIdMsg>>>;
};

export type Input_Billing_German_AcknowledgeDiagnosisRuleVersionRequest = {
  diagnosisRuleVersionId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_AdditionalCodeInputFieldGroupMsg = {
  additionalInputFieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chargenNumberRequired?: InputMaybe<Scalars['Boolean']>;
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
  fieldListType?: InputMaybe<Billing_German_AdditionalInputFieldListType>;
  gnrKeyAsJustification?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  opsKeyAsJustification?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_AgeIntervalMsg = {
  ageLower?: InputMaybe<Input_Reference_AgeMsg>;
  ageUpper?: InputMaybe<Input_Reference_AgeMsg>;
};

export type Input_Billing_German_AmountConditionMsg = {
  ageInterval?: InputMaybe<Input_Billing_German_AgeIntervalMsg>;
  id?: InputMaybe<Scalars['String']>;
  maxAmount?: InputMaybe<Scalars['Int']>;
  timeContext?: InputMaybe<Input_Billing_German_TimeContextMsg>;
  timeContextLength?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_ApplyDiagnosisRulesRequest = {
  /**
   * mandatory for DIAGNOSIS_RULE_SCOPE_INTER_QUARTER, optional otherwise:
   *  if no diagnosisCodingIds set, all codings in the given certificates are used;
   *  also used to get the quarter for which the check is executed
   */
  billingCertificateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checkTiming?: InputMaybe<Billing_German_DiagnosisRuleCheckTiming>;
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scope?: InputMaybe<Billing_German_DiagnosisRuleScope>;
  /** filter for valid rules */
  validAt?: InputMaybe<Input_Timestamp>;
};

export type Input_Billing_German_ApplyDiagnosisRulesResponse = {
  suggestions?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisSuggestionsMsg>>>;
};

export type Input_Billing_German_ApplyGroupPsychotherapyCodeRequest = {
  /** If true, adds codes to approvalsCompanion, else to approvals */
  companion?: InputMaybe<Scalars['Boolean']>;
  groupPsychotherapyCodeId?: InputMaybe<Scalars['String']>;
  psychotherapyApprovalId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ApprovalLevelEventMsg = {
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_ApprovalLevelMsg = {
  approvalLevelValue?: InputMaybe<Scalars['Int']>;
  eventHistory?: InputMaybe<Array<InputMaybe<Input_Billing_German_ApprovalLevelEventMsg>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_AssignBillingDiagnosisCodingIdRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  diagnosisCodingId?: InputMaybe<Input_Billing_German_BillingDiagnosisCodingIdMsg>;
};

export type Input_Billing_German_AssignBillingDiagnosisCodingIdResponse = {
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDiagnosisCodingIdMsg>>>;
};

export type Input_Billing_German_AssignGroupingDiagnosisRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['String']>;
  groupingDiagnosis?: InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>;
  ignoreValidation?: InputMaybe<Scalars['Boolean']>;
  step?: InputMaybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

export type Input_Billing_German_AssignGroupingDiagnosisResponse = {
  assignedGroupingDiagnosis?: InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>;
  modifiedGroupingDiagnoses?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>>>;
  validationErrors?: InputMaybe<Array<InputMaybe<Billing_German_GroupingDataValidationError>>>;
};

export type Input_Billing_German_AsvTeamMemberMsg = {
  id?: InputMaybe<Scalars['String']>;
  membershipExpiration?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_AsvTeamMsg = {
  id?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<Array<InputMaybe<Input_Billing_German_AsvTeamMemberMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Billing_German_AutocompleteEbmCodeFolderRequest = {
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_AutocompleteEbmCodeFolderResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Billing_German_AutocompleteEbmCodeFolderResponse_Result>>>;
};

export type Input_Billing_German_AutocompleteEbmCodeFolderResponse_Result = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BgBillingSettingsMsg = {
  /** DALE-Prüfmodul aktiviert (if empty/false) / deaktiviert (if true) */
  deactivateDaleRuleCheckModule?: InputMaybe<Scalars['Boolean']>;
  /** Standard D-Arzt */
  defaultDesignatedUserId?: InputMaybe<Scalars['String']>;
  /** Standardmäßige Rechnungsfrist (Tage) */
  defaultInvoicePeriodDays?: InputMaybe<Scalars['Int']>;
  /** Rechnungstyp */
  defaultInvoiceType?: InputMaybe<Billing_German_BgInvoiceType>;
  /** Mahnverfahren (Stufe 1) */
  dunningLevelOne?: InputMaybe<Input_Billing_German_DunningSettingsMsg>;
  /** Mahnverfahren (Stufe 3) */
  dunningLevelThree?: InputMaybe<Input_Billing_German_DunningSettingsMsg>;
  /** Mahnverfahren (Stufe 2) */
  dunningLevelTwo?: InputMaybe<Input_Billing_German_DunningSettingsMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingAdmissionReasonMsg = {
  digitFour?: InputMaybe<Scalars['String']>;
  digitThree?: InputMaybe<Scalars['String']>;
  digitsOneTwo?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingCaseBgDetailsMsg = {
  /** Unfallzeitpunkt [uvt_4] */
  accidentDate?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** Aktenzeichen des UV-Trägers [uvt_5] */
  accidentInsurerFileReference?: InputMaybe<Scalars['String']>;
  /** Unfallort [ufd_4] */
  accidentLocation?: InputMaybe<Scalars['String']>;
  /** Unfallbetrieb [ufb_1] */
  accidentOccupationId?: InputMaybe<Scalars['String']>;
  /** Unfallzeitpunkt [ufd_ 1] */
  accidentTime?: InputMaybe<Input_Timestamp>;
  /** Zeitpunkt des Eintreffens [eti_1, eti_2] */
  arrivalTime?: InputMaybe<Input_Timestamp>;
  /** optional, could be set only if statutoryInsured = true */
  careInsuranceBgCase?: InputMaybe<Input_Billing_InsurerMsg>;
  familyInsured?: InputMaybe<Scalars['Boolean']>;
  healthInsuranceBgCase?: InputMaybe<Input_Billing_German_HealthInsuranceBgCaseMsg>;
  /** optional, will be set if mapped health insurance has one */
  healthInsuranceIdentifier?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Personalunfall [vin_12] */
  personnelAccident?: InputMaybe<Scalars['Boolean']>;
  /** Name des Hauptversicherten (Gesetzliche Krankenkasse) [ksd_1] */
  primaryInsuredPartyId?: InputMaybe<Scalars['String']>;
  statutoryInsured?: InputMaybe<Scalars['Boolean']>;
  /** Arbeitszeitraum [ufd_2, ufd_3] */
  workingPeriod?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
};

export type Input_Billing_German_BillingCaseDetailCodesMsg = {
  /** corresponds to admissionEventCode */
  admissionEvent?: InputMaybe<Scalars['String']>;
  /** corresponds to admissionReason.digitFour */
  admissionReasonFour?: InputMaybe<Scalars['String']>;
  /** corresponds to admissionReason.digitsOneTwo */
  admissionReasonOneTwo?: InputMaybe<Scalars['String']>;
  /** corresponds to admissionReason.digitThree */
  admissionReasonThree?: InputMaybe<Scalars['String']>;
  /** corresponds to dischargeReason.digitsOneTwo */
  dischargeReasonOneTwo?: InputMaybe<Scalars['String']>;
  /** corresponds to dischargeReason.digitThree */
  dischargeReasonThree?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingCaseDetailsMsg = {
  /** Aufnahmeanlass (§ 21) */
  admissionEventCode?: InputMaybe<Scalars['String']>;
  /** Aufnahmegrund § 301 */
  admissionReason?: InputMaybe<Input_Billing_German_BillingAdmissionReasonMsg>;
  /** Entlassungs-/Verlegungsgrund (§ 301) */
  dischargeReason?: InputMaybe<Input_Billing_German_BillingDischargeReasonMsg>;
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether this case, together with a second one, needs to be merged into a cumulative case.
   *  This field should be derived from rules in the Fallpauschalenverordnung about Wiederkehrerketten.
   *  For now we store this is a boolean in the database, when we get the info from the external HIS.
   */
  mightRequireCumulativeCase?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_BillingCertificateCodesMsg = {
  /** corresponds to BillingCertificateMsg.billingDetailsFormCode // BillingCertificateType */
  billingCertificateType?: InputMaybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.billingSubjectCode // KBV_DATASET_BILLING_SUBJECT_CODE */
  billingSubject?: InputMaybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.contactTypeCode // KVDT_DATASET_CONTACT_TYPE_CODE */
  contactType?: InputMaybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.costUnitBillingFieldCode // https://applications.kbv.de/S_KTS_KTABRECHNUNGSBEREICH_V1.00.xhtml */
  costUnitBillingField?: InputMaybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.curativePreventiveEssAttendingCode // KVDT_DATASET_CURATIVE_PREVENTIVE_ESS_ATTENDING_CODE */
  curativePreventiveEssAttending?: InputMaybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.examinationCategoryCode // KBV_DATASET_EXAMINATION_CATEGORY */
  examinationCategory?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingCertificateMsg = {
  /** Unfall, Unfallfolgen [4202] */
  accidentConsequences?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  /** Zusätzliche Angaben zu Untersuchungen [4209] */
  additionalExaminationInformation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Überweisung von anderen Ärzten [4219] */
  additionalReferrals?: InputMaybe<Scalars['String']>;
  /** SKT-Zusatzangaben [4124] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  additionalSktInformation?: InputMaybe<Scalars['String']>;
  /** Ausnahmeindikation [4229] */
  admissionIndication?: InputMaybe<Scalars['String']>;
  /** Mutmaßlicher Tag der Entbindung [4206] */
  anticipatedDeliveryDate?: InputMaybe<Input_Timestamp>;
  /** Appointment scheduling day (dt. Tag der Terminvermittlung) [4115] */
  appointmentSchedulingDate?: InputMaybe<Input_Timestamp>;
  /**
   * Psychotherapy
   *  Anerkannte Psychotherapie
   */
  approvedPsychotherapy?: InputMaybe<Scalars['Boolean']>;
  /** never empty */
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingDays?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDayMsg>>>;
  /** German "Scheinuntergruppe" [4239] // TODO: Search call that groups */
  billingDetailsFormCode?: InputMaybe<Scalars['String']>;
  /** Abrechnungsgebiet [4122] */
  billingSubjectCode?: InputMaybe<Scalars['String']>;
  /** Ergänzende Informationen zur Vermittlungs-/Kontaktart [4105] */
  contactTypeAdditionalInfo?: InputMaybe<Scalars['String']>;
  /** Vermittlungs-/Kontaktart [4103] */
  contactTypeCode?: InputMaybe<Scalars['String']>;
  /** Kostenträger-Abrechnungsbereich [4106] // https://applications.kbv.de/S_KTS_KTABRECHNUNGSBEREICH_V1.00.xhtml */
  costUnitBillingFieldCode?: InputMaybe<Scalars['String']>;
  coverage?: InputMaybe<Input_Billing_CoverageMsg>;
  /** Kurativ / Präventiv / ESS / belegärztliche Behandlung [4221] */
  curativePreventiveEssAttendingCode?: InputMaybe<Scalars['String']>;
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDiagnosisCodingIdMsg>>>;
  /** Personenkreis/Untersuchungskategorie [4123] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  examinationCategoryCode?: InputMaybe<Scalars['String']>;
  feeSchedule?: InputMaybe<Billing_German_BillingFeeSchedule>;
  /** Befund/Medikation [4208] */
  findingAndMedication?: InputMaybe<Scalars['String']>;
  /** Weiterbehandelnder Arzt [4243] */
  furtherTreatmentPhysician?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Hash-String der Meldebestätigung des Implantateregisters [4135] */
  implantRegistryHashes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Zeitraum stationäre Behandlung [4233] */
  inpatientVisitTimeframe?: InputMaybe<Input_TimeFrameMsg>;
  /** German "Ausstellungsdatum" [4102]. Expand */
  issueDate?: InputMaybe<Input_Timestamp>;
  /** Behandlungstag bei IVD-Leistungen [4214] */
  ivdTreatmentDate?: InputMaybe<Input_Timestamp>;
  /** eingeschränkter Leistungsanspruch gemäß § 16 Abs. 3a SGB V) [4204] */
  limitedServiceEntitlement?: InputMaybe<Scalars['Boolean']>;
  /** Auftrag [4205] // TODO: for subgroup 21, provide search selection options */
  orderInformation?: InputMaybe<Scalars['String']>;
  /** ASV-Teamnummer des Erstveranlassers [4225] */
  originatorAsvTeamNumber?: InputMaybe<Scalars['String']>;
  /** (N)BSNR des Erstveranlassers [4217] */
  originatorBsnr?: InputMaybe<Scalars['String']>;
  /** LANR des Erstveranlassers [4241] */
  originatorLanr?: InputMaybe<Scalars['String']>;
  /** Anerkennungen */
  psychotherapyApprovals?: InputMaybe<Array<InputMaybe<Input_Billing_German_PsychotherapyApprovalMsg>>>;
  /** Überweisung an [4220] */
  referralTarget?: InputMaybe<Scalars['String']>;
  /** ASV-Teamnummer des Überweisers [4226] // TODO: Auto-fill from visit if possible */
  referrerAsvTeamNumber?: InputMaybe<Scalars['String']>;
  /** (N)BSNR des Überweisers [4218] // TODO: Auto-fill from visit if possible */
  referrerBsnr?: InputMaybe<Scalars['String']>;
  /** LANR des Überweisers [4242] // TODO: Auto-fill from visit if possible */
  referrerLanr?: InputMaybe<Scalars['String']>;
  /** Vermittlungscode [4114] */
  schedulingIdentifier?: InputMaybe<Scalars['String']>;
  /** SKT-Bemerkungen [4126] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  sktComments?: InputMaybe<Scalars['String']>;
  /** Gültigkeit SKT [4125] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  sktValidityPeriod?: InputMaybe<Input_TimeFrameMsg>;
  /** Somatische Abklärung [4236] */
  somaticAssessment?: InputMaybe<Scalars['Boolean']>;
  /** Diagnose/Verdachtsdiagnose [4207] */
  suspectedDiagnosis?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** German "Quartal" [4101], must be converted to format q/yyyy (q is 1,2,3 or 4) when transferring data to KVDT */
  validityQuarter?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** can be empty */
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_BillingCodeApprovalMsg = {
  /** Allows explicitly marking request as denied */
  approvalDenied?: InputMaybe<Scalars['Boolean']>;
  /** [4254]/[4257] */
  approvedQuantity?: InputMaybe<Scalars['Int']>;
  /** [4253]/[4256] */
  codeReference?: InputMaybe<Input_Billing_BillingCodeReferenceMsg>;
  /**
   * In standard case, each code uses one quantity; but there are codes for short sessions that only "count half", i.e., when two of them are documented, one unit is used.
   *  So we have to keep track of the halves, but display it as rounded-down integer (i.e., Math.floor(usedQuantityHalves / 2)).
   */
  usedQuantityHalves?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_BillingDayMsg = {
  contactIndex?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Input_Core_LocalDateMsg>;
  id?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Input_Core_LocalTimeMsg>;
};

export type Input_Billing_German_BillingDiagnosisCodingIdMsg = {
  diagnosisCodingGroupId?: InputMaybe<Scalars['String']>;
  diagnosisCodingId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingDischargeReasonMsg = {
  digitThree?: InputMaybe<Scalars['String']>;
  digitsOneTwo?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_BillingSettingsMsg = {
  /** AMV-Prüfnummer */
  amvApprovalNumber?: InputMaybe<Scalars['String']>;
  bgBillingSettings?: InputMaybe<Input_Billing_German_BgBillingSettingsMsg>;
  /** Determines which grouping diagnosis assignments can be set through medical documentation, e.g., in treatments or visit cockpit */
  diagnosisAssignmentSettings?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisAssignmentSettingMsg>>>;
  drgWorkplaceApprovalLevel?: InputMaybe<Billing_German_DrgWorkplaceApprovalLevel>;
  gnrScorePrices?: InputMaybe<Array<InputMaybe<Input_Billing_German_GnrScorePriceMsg>>>;
  /** catalog specialist group requires specialist group input */
  icdCodeSearchCatalog?: InputMaybe<Billing_German_IcdCodeSearchCatalog>;
  id?: InputMaybe<Scalars['String']>;
  /** KV-Bereich */
  kvArea?: InputMaybe<Scalars['String']>;
  patientReceiptSettings?: InputMaybe<Input_Billing_German_PatientReceiptSettingsMsg>;
  specialistGroupCode?: InputMaybe<Scalars['String']>;
  tiActivationSettings?: InputMaybe<Input_Billing_German_TiActivationSettingsMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** unique */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  vatOptions?: InputMaybe<Array<InputMaybe<Input_Billing_German_VatPercentageMsg>>>;
  /** Hinweis bei Besonderer Personengruppe "6" */
  warningSpecialPersonGroupNine?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_CheckBillingCertificateValidityRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CheckBillingCertificateValidityResponse = {
  valid?: InputMaybe<Scalars['Boolean']>;
  violationTypes?: InputMaybe<Array<InputMaybe<Billing_German_BillingCertificateValidityViolationType>>>;
};

export type Input_Billing_German_ClearClinicalComplexityLevelsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** These grouping diagnoses will remain unchanged; all other ones will have their clinical complexity levels cleared */
  excludedGroupingDiagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_CodeConditionMsg = {
  ageInterval?: InputMaybe<Input_Billing_German_AgeIntervalMsg>;
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  letterRequired?: InputMaybe<Scalars['Boolean']>;
  requiredGender?: InputMaybe<Core_Sex>;
};

export type Input_Billing_German_CodeExclusionMsg = {
  codeReference?: InputMaybe<Input_Billing_BillingCodeReferenceMsg>;
  id?: InputMaybe<Scalars['String']>;
  timeContext?: InputMaybe<Input_Billing_German_TimeContextMsg>;
};

export type Input_Billing_German_CodeJustificationMsg = {
  code?: InputMaybe<Scalars['String']>;
  codeJustificationType?: InputMaybe<Billing_German_CodeJustificationType>;
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Billing_OpsNumberLocalization>;
};

export type Input_Billing_German_CodePricingMsg = {
  id?: InputMaybe<Scalars['String']>;
  pricingUnit?: InputMaybe<Billing_ValueUnitType>;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Billing_German_CodePricingServiceType>;
  value?: InputMaybe<Input_DecimalMsg>;
};

export type Input_Billing_German_CodeRecordRequest = {
  ebmCode?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CodeRecordSearchResultMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_BillingCatalogType>;
};

export type Input_Billing_German_CodingRuleSuggestionOptionMsg = {
  action?: InputMaybe<Billing_German_DiagnosisRuleErrorAction>;
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Billing_German_LightGermanDiagnosisCodingMsg>>>;
  /** List of Diagnosensicherheit */
  diagnosisDetailTypes?: InputMaybe<Array<InputMaybe<Treatment_DiagnosisDetailType>>>;
  hintText?: InputMaybe<Scalars['String']>;
  /** List of Seitenlokalisation */
  lateralities?: InputMaybe<Array<InputMaybe<Laterality_Laterality>>>;
  ruleCode?: InputMaybe<Scalars['String']>;
  suggestionText?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CodingWarningLinkMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** uuid of the relevant element, may be empty */
  referenceId?: InputMaybe<Scalars['String']>;
  /** textual description of the relevant element */
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Billing_German_GroupingElementType>;
  /** textual description of the relevant element's type, use if type is NONE */
  typeDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CodingWarningMsg = {
  id?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodingWarningLinkMsg>>>;
  severity?: InputMaybe<Billing_German_CodingWarningSeverity>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateBillingCertificateRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  coverageId?: InputMaybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_CreateBillingDayRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Input_Core_LocalDateMsg>;
  time?: InputMaybe<Input_Core_LocalTimeMsg>;
};

export type Input_Billing_German_CreateBillingDayResponse = {
  billingDay?: InputMaybe<Input_Billing_German_BillingDayMsg>;
};

export type Input_Billing_German_CreateBillingSettingsRequest = {
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_CreateEbmRecordRequest = {
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_CreateEbmRecordResponse = {
  affectedFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_CreateEbmRecordsRequest = {
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_CreateEbmRecordsResponse = {
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
  transactionCommitted?: InputMaybe<Input_Billing_German_CreateEbmRecordsResponse_TransactionCommittedEvent>;
  transactionStarted?: InputMaybe<Input_Billing_German_CreateEbmRecordsResponse_TransactionStartedEvent>;
  willFlush?: InputMaybe<Input_Billing_German_CreateEbmRecordsResponse_WillFlushEvent>;
};

export type Input_Billing_German_CreateEbmRecordsResponse_TransactionCommittedEvent = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateEbmRecordsResponse_TransactionStartedEvent = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateEbmRecordsResponse_WillFlushEvent = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateGermanIcdCodeExceptionConfigRequest = {
  icdCodeException?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateGermanLabBillingConfigRequest = {
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_CreateGroupingDataRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateUvGoaeCodeRecordsRequest = {
  uvGoaeCodeRecords?: InputMaybe<Array<InputMaybe<Input_Billing_German_UvGoaeCodeRecordMsg>>>;
};

export type Input_Billing_German_CreateVentilationPauseRequest = {
  ventilationPeriodId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateVentilationPeriodRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_CreateVentilationPeriodResponse = {
  ventilationOverview?: InputMaybe<Input_Billing_German_VentilationOverviewMsg>;
};

export type Input_Billing_German_DeleteAsvTeamRequest = {
  asvTeamId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteAsvTeamResponse = {
  deletedAsvTeamId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteBillingCertificateRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteBillingCertificateResponse = {
  deletedBillingCertificateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteBillingSettingsRequest = {
  billingSettingsId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteBillingSettingsResponse = {
  deletedBillingSettingsId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteDiagnosisRuleRequest = {
  diagnosisRuleId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteDiagnosisRuleResponse = {
  deletedDiagnosisRuleId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteDiagnosisRuleVersionRequest = {
  diagnosisRuleVersionId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteDiagnosisRuleVersionResponse = {
  deletedDiagnosisRuleVersionId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteEbmCodeFolderRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteEbmCodeFolderResponse = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteEbmRecordRequest = {
  code?: InputMaybe<Scalars['String']>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_DeleteEbmRecordResponse = {
  affectedFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
  originalEbmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_DeleteGermanLabBillingConfigRequest = {
  germanLabBillingConfigId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteGermanLabBillingConfigResponse = {
  deletedGermanLabBillingConfigId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteGoaeCodeRecordRequest = {
  code?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteGoaeCodeRecordResponse = {
  code?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteVentilationPauseRequest = {
  ventilationPauseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteVentilationPauseResponse = {
  deletedVentilationPauseId?: InputMaybe<Scalars['String']>;
  totalActualDuration?: InputMaybe<Scalars['Int']>;
  totalBillableDuration?: InputMaybe<Scalars['Int']>;
  ventilationPeriod?: InputMaybe<Input_Billing_German_VentilationPeriodMsg>;
};

export type Input_Billing_German_DeleteVentilationPeriodRequest = {
  ventilationPeriodId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DeleteVentilationPeriodResponse = {
  deletedVentilationPeriodId?: InputMaybe<Scalars['String']>;
  totalActualDuration?: InputMaybe<Scalars['Int']>;
  totalBillableDuration?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_DiagnosisAssignmentSettingMsg = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  step?: InputMaybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

export type Input_Billing_German_DiagnosisCodingBillingInfoMsg = {
  diagnosisCodingGroupId?: InputMaybe<Scalars['String']>;
  diagnosisCodingId?: InputMaybe<Scalars['String']>;
  diagnosisType?: InputMaybe<Treatment_DiagnosisType>;
};

export type Input_Billing_German_DiagnosisCodingsUpdateMsg = {
  codingBillingInfos?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisCodingBillingInfoMsg>>>;
  date?: InputMaybe<Input_Timestamp>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DiagnosisRuleCheckMsg = {
  /** <existenz> */
  existence?: InputMaybe<Billing_German_DiagnosisRuleCheckExistence>;
  id?: InputMaybe<Scalars['String']>;
  /** <operator> */
  operator?: InputMaybe<Logic_LogicalOperator>;
  /** <subpruefung> - only one level of subCheck possible */
  subCheck?: InputMaybe<Input_Billing_German_DiagnosisRuleCheckMsg>;
  /** <parameter> */
  valueType?: InputMaybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_list> */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_DiagnosisRuleConditionMsg = {
  /** <existenz> */
  existence?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  /** <operator> */
  operator?: InputMaybe<Logic_LogicalOperator>;
  /** <subbedingung> - only one level of subCondition possible */
  subCondition?: InputMaybe<Input_Billing_German_DiagnosisRuleConditionMsg>;
  /** <parameter> */
  valueType?: InputMaybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_list> */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_DiagnosisRuleErrorFixMsg = {
  /** <regel> */
  action?: InputMaybe<Billing_German_DiagnosisRuleErrorAction>;
  id?: InputMaybe<Scalars['String']>;
  /** <subkorrektur> */
  subFixes?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisRuleErrorSubfixMsg>>>;
  /** <parameter> */
  valueType?: InputMaybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_liste> */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_DiagnosisRuleErrorHandlingMsg = {
  /** <korrektur> */
  fix?: InputMaybe<Input_Billing_German_DiagnosisRuleErrorFixMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** <hinweis> */
  informationText?: InputMaybe<Scalars['String']>;
  /** <vorschlag> */
  recommendationText?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DiagnosisRuleErrorSubfixMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** <parameter> */
  valueType?: InputMaybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_liste> */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_DiagnosisRuleMsg = {
  /** German "aktiv" */
  active?: InputMaybe<Scalars['Boolean']>;
  catalogId?: InputMaybe<Scalars['String']>;
  /** <krw:pruefung> */
  check?: InputMaybe<Input_Billing_German_DiagnosisRuleCheckMsg>;
  /** <krw:echtzeitpruefung_liste> */
  checkTimings?: InputMaybe<Array<InputMaybe<Billing_German_DiagnosisRuleCheckTiming>>>;
  /** <krw:bedingung> */
  condition?: InputMaybe<Input_Billing_German_DiagnosisRuleConditionMsg>;
  /** <krw:beschreibung> */
  description?: InputMaybe<Scalars['String']>;
  /** <krw:fehlerbehandlung> */
  errorHandling?: InputMaybe<Input_Billing_German_DiagnosisRuleErrorHandlingMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** <krw:regelanwendung> */
  mandatory?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Input_Billing_German_DiagnosisRuleOwnerReferenceMsg>;
  /** <krw:pruefgrundlage_liste> */
  patientGroup?: InputMaybe<Array<InputMaybe<Billing_German_DiagnosisRulePatientGroup>>>;
  /** <krw:bezugsraum> */
  referencePeriod?: InputMaybe<Input_Billing_German_DiagnosisRuleReferencePeriodMsg>;
  /** Identifier by KBV <krw:id> or self-defined */
  ruleCode?: InputMaybe<Scalars['String']>;
  /** <krw:regelkategorie> */
  ruleScope?: InputMaybe<Billing_German_DiagnosisRuleScope>;
  /** <krw:regelquelle_liste> */
  sources?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisRuleSourceMsg>>>;
  /** <krw:kurz_beschreibung> */
  summary?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_DiagnosisRuleOwnerReferenceMsg = {
  ownerId?: InputMaybe<Scalars['String']>;
  ownerType?: InputMaybe<Billing_German_DiagnosisRuleOwnerType>;
};

export type Input_Billing_German_DiagnosisRuleReferencePeriodMsg = {
  /** <anzahl_quartale>; if set, must be >= 1; only relevant for rule scope INTER_QUARTER */
  numberOfQuarters?: InputMaybe<Scalars['Int']>;
  ruleScope?: InputMaybe<Billing_German_DiagnosisRuleScope>;
};

export type Input_Billing_German_DiagnosisRuleSourceMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** <regelthema> */
  sourceTopic?: InputMaybe<Scalars['String']>;
  /** <regelquelle> */
  sourceType?: InputMaybe<Billing_German_DiagnosisRuleSourceType>;
};

export type Input_Billing_German_DiagnosisSuggestionsMsg = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  originalIcdCode?: InputMaybe<Scalars['String']>;
  suggestionOptions?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodingRuleSuggestionOptionMsg>>>;
};

export type Input_Billing_German_DunningSettingsMsg = {
  /** Mahngebühr (cent) */
  dunningFeeCents?: InputMaybe<Scalars['Int']>;
  /** Mahnfrist (Tage) */
  dunningPeriodDays?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_EbmCodeDetailsMsg = {
  chapterIdentifier?: InputMaybe<Scalars['String']>;
  chapterName?: InputMaybe<Scalars['String']>;
  codePricings?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodePricingMsg>>>;
  facultativeServiceContent?: InputMaybe<Scalars['String']>;
  longTextHtml?: InputMaybe<Scalars['String']>;
  notesHtml?: InputMaybe<Scalars['String']>;
  obligateServiceContent?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  serviceGroupId?: InputMaybe<Scalars['String']>;
  shortText?: InputMaybe<Scalars['String']>;
  subSection?: InputMaybe<Scalars['String']>;
  subSubSection?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_EbmCodeFolderList = {
  ebmCodeFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
};

export type Input_Billing_German_EbmCodeFolderMsg = {
  code?: InputMaybe<Scalars['String']>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  ebmCodeRecords?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeRecordMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
  subFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
};

export type Input_Billing_German_EbmCodeRecordMsg = {
  additionalInputFieldGroups?: InputMaybe<Array<InputMaybe<Input_Billing_German_AdditionalCodeInputFieldGroupMsg>>>;
  amountConditions?: InputMaybe<Array<InputMaybe<Input_Billing_German_AmountConditionMsg>>>;
  authorizedMedicalSpecializations?: InputMaybe<Array<InputMaybe<Input_Billing_German_MedicalSpecializationMsg>>>;
  codeCondition?: InputMaybe<Input_Billing_German_CodeConditionMsg>;
  codeExclusions?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodeExclusionMsg>>>;
  codeJustifications?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodeJustificationMsg>>>;
  codePricings?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodePricingMsg>>>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  ebmCode?: InputMaybe<Scalars['String']>;
  ebmCodeDetails?: InputMaybe<Input_Billing_German_EbmCodeDetailsMsg>;
  ebmCodeFolderId?: InputMaybe<Scalars['String']>;
  ebmJustificationsPresent?: InputMaybe<Scalars['Boolean']>;
  icdJustificationsPresent?: InputMaybe<Scalars['Boolean']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  opsJustificationsPresent?: InputMaybe<Scalars['Boolean']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  path?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
  validity?: InputMaybe<Input_Billing_German_ValidityTimespanMsg>;
};

export type Input_Billing_German_EbmKeytabMsg = {
  description?: InputMaybe<Scalars['String']>;
  /** id of the keytab file */
  id?: InputMaybe<Input_Billing_German_KeytabIdMsg>;
  /** keytabs sometimes reference another keytab */
  referencedKeyTab?: InputMaybe<Input_Billing_German_EbmKeytabMsg>;
  softwareVersion?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_FindActiveBillingCertificateRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_FindActiveBillingCertificateResponse = {
  billingCertificate?: InputMaybe<Input_Billing_German_BillingCertificateMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_FindActiveDiagnosisRuleVersionRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_FindBillingSettingsRequest = {
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_FindBillingSettingsResponse = {
  billingSettings?: InputMaybe<Input_Billing_German_BillingSettingsMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_FindDiagnosisAssignmentSettingsRequest = {
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_FindDiagnosisAssignmentSettingsResponse = {
  diagnosisAssignmentSettings?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisAssignmentSettingMsg>>>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_FindGermanLabBillingConfigRequest = {
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_FindGermanLabBillingConfigResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  germanLabBillingConfig?: InputMaybe<Input_Billing_German_GermanLabBillingConfigMsg>;
};

export type Input_Billing_German_GermanBillingCaseAggregationDataMsg = {
  diagnosisOverrides?: InputMaybe<Array<InputMaybe<Input_Billing_German_GermanBillingCaseAggregationDiagnosisOverrideMsg>>>;
  procedureOverrides?: InputMaybe<Array<InputMaybe<Input_Billing_German_GermanBillingCaseAggregationProcedureOverrideMsg>>>;
};

export type Input_Billing_German_GermanBillingCaseAggregationDiagnosisOverrideMsg = {
  /**
   * since multiple GroupingDiagnosis with the same diagnosisCodingGroupId can exist in an aggregated billing case,
   *  we need to provide this field so that we can differentiate these duplicated GroupingDiagnoses.
   */
  billingCaseId?: InputMaybe<Scalars['String']>;
  diagnosisCodingGroupId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_GermanBillingCaseAggregationProcedureOverrideMsg = {
  billingProcedureId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
};

/** Used to provide string descriptions for the codes in GermanCoverageInformationMsg; added to the schema by rejoiner */
export type Input_Billing_German_GermanCoverageInformationCodeDetailsMsg = {
  /** corresponds to dmpDesignationCode */
  dmpDesignation?: InputMaybe<Scalars['String']>;
  /** corresponds to examinationCategoryCode */
  examinationCategory?: InputMaybe<Scalars['String']>;
  /** corresponds to insuredPersonTypeCode */
  insuredPersonType?: InputMaybe<Scalars['String']>;
  /** corresponds to privateContactTypeCode */
  privateContactType?: InputMaybe<Scalars['String']>;
  /** corresponds to specialPersonGroupCode */
  specialPersonGroup?: InputMaybe<Scalars['String']>;
  /** corresponds to suspendedEntitlementTypeCode */
  suspendedEntitlementType?: InputMaybe<Scalars['String']>;
  /** corresponds to wopDesignationCode */
  wopDesignation?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GermanIcdCodeExceptionConfigMsg = {
  icdCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** todo skipping warning only for quarter period */
  userThatSkipWarningIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_GermanLabBillingConfigMsg = {
  certificates?: InputMaybe<Array<InputMaybe<Input_Billing_German_RingTestCertificateMsg>>>;
  devices?: InputMaybe<Array<InputMaybe<Input_Billing_German_GermanLabBillingDeviceMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** German "Werden zertifikatspflichtige Laborleistungen abgerechnet?" */
  ringTestCertificatesRequired?: InputMaybe<Scalars['Boolean']>;
  /** German "Verwendung von Unit Use-Reagenzien" */
  singleUseReagentUsage?: InputMaybe<Billing_German_GermanSingleUseReagentUsage>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** unique */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_GermanLabBillingDeviceMsg = {
  deviceDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GermanPrivateCoverageInformationMsg = {
  /** Karte gültig bis */
  cardValidityEnd?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** Beihilfe. TODO: probably should be separate coverage altogether */
  healthInsuranceSubsidyActive?: InputMaybe<Scalars['Boolean']>;
  /** Beihilfe (Details). TODO: probably should be separate coverage altogether */
  healthInsuranceSubsidyDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Personennummer */
  personalNumber?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GermanStatutoryCoverageInformationMsg = {
  /** SKT-Zusatzangaben [4124] */
  additionalSktInformation?: InputMaybe<Scalars['String']>;
  /** Aufnehmender Kostenträger: can differ from cost unit code due to insurer fusion */
  billingCostUnitCode?: InputMaybe<Scalars['String']>;
  /** Zuzahlungsbefreiung -- filled from eGK/KvK - always editable */
  copaymentExemption?: InputMaybe<Scalars['Boolean']>;
  /** Zuzahlungsbefreiung bis -- filled from eGK/KvK - always editable */
  copaymentExemptionEndDate?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** Kostenträger [4134] -- readonly - only filled if KvK or eGK is read */
  costUnit?: InputMaybe<Scalars['String']>;
  /** Kostenträgerkennung [4111] (IK) */
  costUnitCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  /** VersicherungsschutzEnde */
  coverageEndDate?: InputMaybe<Input_Core_LocalDateMsg>;
  /** Geburtsdatum */
  dateOfBirth?: InputMaybe<Input_PrecisionTimestampMsg>;
  /** DMP-Kennzeichnung [4132]; 2-character code */
  dmpDesignationCode?: InputMaybe<Scalars['String']>;
  /** Personenkreis/Untersuchungskategorie [4123]; 2-character code */
  examinationCategoryCode?: InputMaybe<Scalars['String']>;
  /** Vorname */
  firstName?: InputMaybe<Scalars['String']>;
  /** Patientenquittung */
  generatePatientReceipts?: InputMaybe<Scalars['Boolean']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Versichertenart [3108] */
  insuredPersonTypeCode?: InputMaybe<Scalars['String']>;
  /** Versicherten_ID */
  insureeId?: InputMaybe<Scalars['String']>;
  /** Versichertennummer (only with SKT) */
  insureeNumber?: InputMaybe<Scalars['String']>;
  /** Name */
  lastName?: InputMaybe<Scalars['String']>;
  locality?: InputMaybe<Scalars['String']>;
  /** Namenszusatz */
  nameAffixes?: InputMaybe<Scalars['String']>;
  /** Vorsatzwort */
  namePrefix?: InputMaybe<Scalars['String']>;
  /** Vortage */
  pastCopaymentDays?: InputMaybe<Scalars['Int']>;
  /** Mindernder Nachweis für Vortage */
  pastCopaymentDaysValidated?: InputMaybe<Scalars['Boolean']>;
  poBox?: InputMaybe<Scalars['String']>;
  poBoxCountryCode?: InputMaybe<Scalars['String']>;
  poBoxLocality?: InputMaybe<Scalars['String']>;
  /** Postfachadresse */
  poBoxPostcode?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  /** Grund der Zuzahlungsbefreiung -- always editable */
  reasonForCopaymentExemption?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Core_Sex>;
  /** SKT-Bemerkungen [4126] */
  sktComments?: InputMaybe<Scalars['String']>;
  /** Besondere Personengruppe [4131]; 2-character code */
  specialPersonGroupCode?: InputMaybe<Scalars['String']>;
  /** Adresse */
  streetName?: InputMaybe<Scalars['String']>;
  /** Titel */
  title?: InputMaybe<Scalars['String']>;
  /** WOP-Kennzeichen [3116]; 2-character code */
  wopDesignationCode?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GetAsvTeamsRequest = {
  asvTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_GetAsvTeamsResponse = {
  asvTeams?: InputMaybe<Array<InputMaybe<Input_Billing_German_AsvTeamMsg>>>;
};

export type Input_Billing_German_GetBillingCertificateRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GetCodeRecordsRequest = {
  codeReferences?: InputMaybe<Array<InputMaybe<Input_Billing_BillingCodeReferenceMsg>>>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_GetCodeRecordsResponse = {
  ebmCodeRecords?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeRecordMsg>>>;
  goaeCodeRecords?: InputMaybe<Array<InputMaybe<Input_Billing_German_GoaeCodeRecordMsg>>>;
  uvgoaeCodeRecords?: InputMaybe<Array<InputMaybe<Input_Billing_German_UvGoaeCodeRecordMsg>>>;
};

export type Input_Billing_German_GetEbmCodeFolderRequest = {
  depth?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_GetEbmCodeFolderResponse = {
  ebmCodeFolder?: InputMaybe<Input_Billing_German_EbmCodeFolderMsg>;
};

export type Input_Billing_German_GetEbmKeytabRequest = {
  code?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GetEbmKeytabResponse = {
  ebmKeytab?: InputMaybe<Input_Billing_German_EbmKeytabMsg>;
};

export type Input_Billing_German_GetEbmRecordRequest = {
  code?: InputMaybe<Scalars['String']>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Billing_German_GetEbmRecordResponse = {
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_GetGroupingDataRequest = {
  groupingDataId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GetOrCreateVentilationOverviewRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GetSimpleCodeRecordRequest = {
  code?: InputMaybe<Scalars['String']>;
  ebmCatalogId?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  type?: InputMaybe<Billing_BillingCatalogType>;
};

export type Input_Billing_German_GetSimpleCodeRecordResponse = {
  result?: InputMaybe<Input_Billing_German_CodeRecordSearchResultMsg>;
};

export type Input_Billing_German_GetVentilationPeriodRequest = {
  ventilationPeriodId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GnrScorePriceMsg = {
  billingCatalogType?: InputMaybe<Billing_BillingCatalogType>;
  pricePerPoint?: InputMaybe<Input_Billing_Money>;
};

export type Input_Billing_German_GoaeCodeMultiplierDescriptionMsg = {
  maxMultiplier?: InputMaybe<Input_DecimalMsg>;
  points?: InputMaybe<Input_DecimalMsg>;
  ruleMaxMultiplier?: InputMaybe<Input_DecimalMsg>;
  singleMultiplier?: InputMaybe<Input_DecimalMsg>;
};

export type Input_Billing_German_GoaeCodeRecordMsg = {
  catalogId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludedCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  multiplierDescription?: InputMaybe<Input_Billing_German_GoaeCodeMultiplierDescriptionMsg>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GroupPsychotherapyCodeList = {
  codes?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupPsychotherapyCodeMsg>>>;
};

/** For group therapies, one "fake" code, e.g., "3550X" triggers a list of connected actual codes */
export type Input_Billing_German_GroupPsychotherapyCodeMsg = {
  billingCatalogType?: InputMaybe<Billing_BillingCatalogType>;
  code?: InputMaybe<Scalars['String']>;
  connectedCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_GroupingDataMsg = {
  /** Beurlaubungstage */
  absenceDays?: InputMaybe<Scalars['Int']>;
  /** Aufnahmegewicht in g */
  admissionBodyWeightGrams?: InputMaybe<Scalars['Int']>;
  approvalLevel?: InputMaybe<Input_Billing_German_ApprovalLevelMsg>;
  /** Pflegeberechnungstage */
  careCalculationDays?: InputMaybe<Scalars['Int']>;
  caseNote?: InputMaybe<Scalars['String']>;
  /** Tage ohne Berechnung/Behandlung */
  daysExcludedFromCalculation?: InputMaybe<Scalars['Int']>;
  /** Tage ohne Berechnung/Behandlung (after review by insurer (German: Medizinischer Dienst der Krankenkasse)) */
  daysExcludedFromCalculationReviewed?: InputMaybe<Scalars['Boolean']>;
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>>>;
  /** Abteilungstyp */
  drgDepartmentType?: InputMaybe<Billing_German_DrgDepartmentType>;
  id?: InputMaybe<Scalars['String']>;
  /** Verweildauer */
  lengthOfStayDays?: InputMaybe<Scalars['Int']>;
  /**
   * Link to medical diagnoses that are marked for processing in grouping. Does not necessarily mean that
   *  codings in these diagnoses are also marked as drg relevant.
   *  However, no codings outside of these diagnoses can be linked in any grouping diagnosis of this GroupingData.
   */
  selectedDiagnosisRevisionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Beatmungsstunden */
  ventilationHours?: InputMaybe<Scalars['Int']>;
  ventilationOverview?: InputMaybe<Input_Billing_German_VentilationOverviewMsg>;
  warnings?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodingWarningMsg>>>;
};

export type Input_Billing_German_GroupingDiagnosisAssignmentMsg = {
  id?: InputMaybe<Scalars['String']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  /** only relevant if step is UNIT_ASSIGNMENT */
  leadingUnitAssignmentId?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

/** Diagnosis information relevant for grouping */
export type Input_Billing_German_GroupingDiagnosisMsg = {
  aggregationSourceBillingCaseId?: InputMaybe<Scalars['String']>;
  assignments?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupingDiagnosisAssignmentMsg>>>;
  /** CCL */
  clinicalComplexityLevel?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  diagnosisCodingGroupId?: InputMaybe<Scalars['String']>;
  /** this field records whether the diagnosis was actually used for grouping - it is set by the grouper (e.g. KODIP) */
  drgRelevant?: InputMaybe<Scalars['Boolean']>;
  /** eff. CCL */
  effectiveClinicalComplexityLevel?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Billing_German_GroupingDiagnosisTag>>>;
  /** visit which the diagnosis belongs to */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_HealthInsuranceBgCaseMsg = {
  /** statutory insurer from DGUV stammdaten */
  dguvStatutoryInsurer?: InputMaybe<Input_Billing_InsurerMsg>;
  insurerType?: InputMaybe<Billing_German_HealthInsuranceBgCaseType>;
};

export type Input_Billing_German_KeytabIdMsg = {
  code?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_LightGermanDiagnosisCodingMsg = {
  /** germanDiagnosisCoding.description */
  description?: InputMaybe<Scalars['String']>;
  diagnosisThesauruses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icdCode?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_LinkBillingCertificateRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListAsvTeamsRequest = {
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListAsvTeamsResponse = {
  teams?: InputMaybe<Array<InputMaybe<Input_Billing_German_AsvTeamMsg>>>;
};

export type Input_Billing_German_ListBillingCertificatesRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListBillingCertificatesResponse = {
  billingCertificates?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingCertificateMsg>>>;
};

export type Input_Billing_German_ListBillingDaysRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  /** if not supplied, today is used */
  date?: InputMaybe<Input_Core_LocalDateMsg>;
};

export type Input_Billing_German_ListBillingDaysResponse = {
  billingDays?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDayMsg>>>;
};

export type Input_Billing_German_ListDiagnosisRuleChangesRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListDiagnosisRuleChangesResponse = {
  addedRules?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisRuleMsg>>>;
  /** Set to true if the current version is the first one in the system */
  noPreviousVersion?: InputMaybe<Scalars['Boolean']>;
  removedRules?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisRuleMsg>>>;
};

export type Input_Billing_German_ListDiagnosisRulesRequest = {
  /** optional filter */
  active?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  checkTiming?: InputMaybe<Billing_German_DiagnosisRuleCheckTiming>;
  /** optional filter */
  mandatory?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Input_Billing_German_DiagnosisRuleOwnerReferenceMsg>;
  /** Optional: Set if pagination is desired */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  /** optional filter: if set, filters exact matches */
  ruleCode?: InputMaybe<Scalars['String']>;
  /** optional sort */
  summarySort?: InputMaybe<Helper_SortOrder>;
};

export type Input_Billing_German_ListDiagnosisRulesResponse = {
  /** number of search results (only relevant for paginated searches) */
  hitCount?: InputMaybe<Scalars['Int']>;
  rules?: InputMaybe<Array<InputMaybe<Input_Billing_German_DiagnosisRuleMsg>>>;
};

export type Input_Billing_German_ListEbmCodeFoldersRequest = {
  ebmCatalogId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListEbmCodeFoldersResponse = {
  ebmCodeFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
};

export type Input_Billing_German_ListEbmKeytabsRequest = {
  groupId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListEbmKeytabsResponse = {
  keytabs?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmKeytabMsg>>>;
};

export type Input_Billing_German_ListGroupingDiagnosesRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ListGroupingDiagnosesResponse = {
  groupingDiagnoses?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>>>;
};

export type Input_Billing_German_ListVentilationPeriodsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_MedicalSpecializationMsg = {
  id?: InputMaybe<Scalars['String']>;
  serviceAreaId?: InputMaybe<Scalars['String']>;
  specializationFieldId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_PatientReceiptSettingsMsg = {
  /** Punktwert (Cent) */
  pointValueCents?: InputMaybe<Input_DecimalMsg>;
  /** Quotierung (%) */
  quota?: InputMaybe<Input_DecimalMsg>;
};

export type Input_Billing_German_PsychotherapyApprovalMsg = {
  /** Datum Anerkennung [4235] */
  approvalDate?: InputMaybe<Input_Timestamp>;
  /** Bewilligte Ziffern für den Versicherten [4253] */
  approvals?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingCodeApprovalMsg>>>;
  /** Bewilligte Ziffern für die Bezugsperson [4256] */
  approvalsCompanion?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingCodeApprovalMsg>>>;
  /** Gesamtanzahl bewilligter Einheiten Versicherter [4252] -> gets further specified in approvals */
  approvedTreatmentUnits?: InputMaybe<Scalars['Int']>;
  /** Gesamtanzahl bewilligter Einheiten Bezugsperson [4255] -> gets further specified in approvalsCompanion */
  approvedTreatmentUnitsCompanion?: InputMaybe<Scalars['Int']>;
  /** Kombinationsbehandlung [4250] */
  combinationTreatment?: InputMaybe<Scalars['Boolean']>;
  /** Art der Kombinationsbehandlung [4251] */
  combinationTreatmentPart?: InputMaybe<Billing_German_PsychotherapyTreatmentPart>;
  id?: InputMaybe<Scalars['String']>;
  /** Begründung gegenüber der Krankenkasse */
  pauseReportedToInsurer?: InputMaybe<Scalars['Boolean']>;
  /** Therapie pausieren */
  pauseTherapy?: InputMaybe<Scalars['Boolean']>;
  /** Zeitraum - time frame for which the therapy is paused */
  pauseTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** LANR des Vertragspsychotherapeuten [4299] */
  psychotherapistLanr?: InputMaybe<Scalars['String']>;
  /** Antragsdatum [4247] */
  requestDate?: InputMaybe<Input_Timestamp>;
  /** If true, means that the connected psychotherapy is finished and is not considered in approval remainder calculations */
  terminated?: InputMaybe<Scalars['Boolean']>;
  /** Krankenkasse gesondert über Beendigung informiert */
  terminationReportedToInsurer?: InputMaybe<Scalars['Boolean']>;
  /** Abgerechnete Einheiten Versicherter -> calculated by backend */
  usedTreatmentUnits?: InputMaybe<Scalars['Int']>;
  /** Abgerechnete Einheiten Bezugsperson -> calculated by backend */
  usedTreatmentUnitsCompanion?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_PsychotherapyApprovalWarningMsg = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  hints?: InputMaybe<Array<InputMaybe<Billing_German_PsychotherapyCodingHint>>>;
};

export type Input_Billing_German_PsychotherapyRecurrencePreventionEbmCodeMsg = {
  ebmCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_PutEbmCodeFolderRequest = {
  ebmCodeFolder?: InputMaybe<Input_Billing_German_EbmCodeFolderMsg>;
};

export type Input_Billing_German_PutEbmCodeFolderResponse = {
  ebmCodeFolder?: InputMaybe<Input_Billing_German_EbmCodeFolderMsg>;
};

export type Input_Billing_German_PutEbmCodeFoldersRequest = {
  ebmCodeFolder?: InputMaybe<Input_Billing_German_EbmCodeFolderMsg>;
};

export type Input_Billing_German_PutEbmCodeFoldersResponse = {
  ebmCodeFolder?: InputMaybe<Input_Billing_German_EbmCodeFolderMsg>;
  transactionCommitted?: InputMaybe<Input_Billing_German_PutEbmCodeFoldersResponse_TransactionCommittedEvent>;
  transactionStarted?: InputMaybe<Input_Billing_German_PutEbmCodeFoldersResponse_TransactionStartedEvent>;
};

export type Input_Billing_German_PutEbmCodeFoldersResponse_TransactionCommittedEvent = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_PutEbmCodeFoldersResponse_TransactionStartedEvent = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

/** Joined through rejoiner, comes from S_NVV_RV_ZERTIFIKAT (OID: 1.2.276.0.76.3.1.1.5.2.22 ) */
export type Input_Billing_German_RingTestCertificateDetailsMsg = {
  analyteCode?: InputMaybe<Scalars['String']>;
  analyteName?: InputMaybe<Scalars['String']>;
  ebmCode?: InputMaybe<Scalars['String']>;
  materialCode?: InputMaybe<Scalars['String']>;
  materialName?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Billing_German_RingTestCertificateMsg = {
  /** S_NVV_RV_ZERTIFIKAT (OID: 1.2.276.0.76.3.1.1.5.2.22 ) */
  analyteCode?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Billing_German_RingTestCertificateAvailability>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_SearchAsvTeamsRequest = {
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  text?: InputMaybe<Scalars['String']>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Billing_German_SearchAsvTeamsResponse = {
  asvTeams?: InputMaybe<Array<InputMaybe<Input_Billing_German_AsvTeamMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_SearchCodeRecordsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingCertificateId?: InputMaybe<Scalars['String']>;
  catalogContext?: InputMaybe<Input_Catalog_CatalogQueryContextMsg>;
  catalogId?: InputMaybe<Scalars['String']>;
  overrideUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_SearchCodeRecordsResponse = {
  catalogId?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Array<InputMaybe<Input_Billing_German_CodeRecordSearchResultMsg>>>;
};

export type Input_Billing_German_SearchGroupPsychotherapyCodesRequest = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_TiActivationSettingsMsg = {
  cardTerminalActive?: InputMaybe<Scalars['Boolean']>;
  eArztbriefActive?: InputMaybe<Scalars['Boolean']>;
  eAuActive?: InputMaybe<Scalars['Boolean']>;
  eHbaActive?: InputMaybe<Scalars['Boolean']>;
  eMpActive?: InputMaybe<Scalars['Boolean']>;
  ePaSupport?: InputMaybe<Billing_German_EPaSupport>;
  ePrescriptionActive?: InputMaybe<Scalars['Boolean']>;
  kimActive?: InputMaybe<Scalars['Boolean']>;
  nfdmActive?: InputMaybe<Scalars['Boolean']>;
  smcBActive?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Billing_German_TimeContextMsg = {
  timeContextId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_UnassignBillingDiagnosisCodingIdRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  diagnosisCodingId?: InputMaybe<Input_Billing_German_BillingDiagnosisCodingIdMsg>;
};

export type Input_Billing_German_UnassignBillingDiagnosisCodingIdResponse = {
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDiagnosisCodingIdMsg>>>;
};

export type Input_Billing_German_UnassignGroupingDiagnosisRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** optional; if set, clears all tags of the grouping diagnosis; by default only clears main tag and main department assignments */
  clearTags?: InputMaybe<Scalars['Boolean']>;
  groupingDiagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_UnassignGroupingDiagnosisResponse = {
  deletedGroupingDiagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_UpdateAsvTeamRequest = {
  asvTeam?: InputMaybe<Input_Billing_German_AsvTeamMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateBillingCertificateRequest = {
  billingCertificate?: InputMaybe<Input_Billing_German_BillingCertificateMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateBillingPositionDaySeparationRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Input_Core_LocalDateMsg>;
};

export type Input_Billing_German_UpdateBillingPositionDaySeparationResponse = {
  billingDays?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingDayMsg>>>;
  date?: InputMaybe<Input_Core_LocalDateMsg>;
};

export type Input_Billing_German_UpdateBillingSettingsRequest = {
  billingSettings?: InputMaybe<Input_Billing_German_BillingSettingsMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateDiagnosisRuleRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  rule?: InputMaybe<Input_Billing_German_DiagnosisRuleMsg>;
};

export type Input_Billing_German_UpdateEbmRecordRequest = {
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateEbmRecordResponse = {
  affectedFolders?: InputMaybe<Array<InputMaybe<Input_Billing_German_EbmCodeFolderMsg>>>;
  ebmCodeRecord?: InputMaybe<Input_Billing_German_EbmCodeRecordMsg>;
};

export type Input_Billing_German_UpdateGermanIcdCodeExceptionConfigRequest = {
  /**
   * one of U07.1, U07.2 or U99.0
   *  adds current user to list of users that skip the warning
   */
  icdCode?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_UpdateGermanLabBillingConfigRequest = {
  germanLabBillingConfig?: InputMaybe<Input_Billing_German_GermanLabBillingConfigMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateGoaeCodeRecordRequest = {
  goaeCodeRecord?: InputMaybe<Input_Billing_German_GoaeCodeRecordMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateGroupingDataRequest = {
  /** only grouping diagnoses with one of these coding group ids will be used for validation */
  diagnosisCodingGroupIdsForValidationCheck?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  groupingData?: InputMaybe<Input_Billing_German_GroupingDataMsg>;
  /** Only allowed from gateway service */
  ignoreLock?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateGroupingDiagnosisRequest = {
  groupingDiagnosis?: InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>;
  ignoreValidation?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Billing_German_UpdateGroupingDiagnosisResponse = {
  groupingDiagnosis?: InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>;
  modifiedGroupingDiagnoses?: InputMaybe<Array<InputMaybe<Input_Billing_German_GroupingDiagnosisMsg>>>;
  validationErrors?: InputMaybe<Array<InputMaybe<Billing_German_GroupingDataValidationError>>>;
};

export type Input_Billing_German_UpdateVentilationPauseRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  ventilationPause?: InputMaybe<Input_Billing_German_VentilationPauseMsg>;
};

export type Input_Billing_German_UpdateVentilationPauseResponse = {
  totalActualDuration?: InputMaybe<Scalars['Int']>;
  totalBillableDuration?: InputMaybe<Scalars['Int']>;
  ventilationPeriod?: InputMaybe<Input_Billing_German_VentilationPeriodMsg>;
};

export type Input_Billing_German_UpdateVentilationPeriodRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  ventilationPeriod?: InputMaybe<Input_Billing_German_VentilationPeriodMsg>;
};

export type Input_Billing_German_UpdateVentilationPeriodResponse = {
  totalActualDuration?: InputMaybe<Scalars['Int']>;
  totalBillableDuration?: InputMaybe<Scalars['Int']>;
  ventilationPeriod?: InputMaybe<Input_Billing_German_VentilationPeriodMsg>;
};

export type Input_Billing_German_UvGoaeCodePricingMsg = {
  pricingUnit?: InputMaybe<Billing_ValueUnitType>;
  pricingValue?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_German_UvGoaeCodeRecordMsg = {
  additionalDescription?: InputMaybe<Scalars['String']>;
  catalogId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  edqNumber?: InputMaybe<Scalars['Int']>;
  generalCost?: InputMaybe<Input_Billing_Money>;
  materialCost?: InputMaybe<Input_Billing_Money>;
  medicalTreatmentGeneralCost?: InputMaybe<Input_Billing_Money>;
  medicalTreatmentSpecialCost?: InputMaybe<Input_Billing_Money>;
  shortDescription?: InputMaybe<Scalars['String']>;
  specialCostForPhysicians?: InputMaybe<Input_Billing_Money>;
  specialCostHospitals?: InputMaybe<Input_Billing_Money>;
};

export type Input_Billing_German_ValidatePsychotherapyApprovalRequest = {
  billingQuarter?: InputMaybe<Input_PrecisionTimestampMsg>;
  codeReference?: InputMaybe<Input_Billing_BillingCodeReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_German_ValidatePsychotherapyApprovalResponse = {
  codingHint?: InputMaybe<Billing_German_PsychotherapyCodingHint>;
};

export type Input_Billing_German_ValidatePsychotherapyApprovalsRequest = {
  billingQuarter?: InputMaybe<Input_PrecisionTimestampMsg>;
};

export type Input_Billing_German_ValidatePsychotherapyApprovalsResponse = {
  warnings?: InputMaybe<Array<InputMaybe<Input_Billing_German_PsychotherapyApprovalWarningMsg>>>;
};

export type Input_Billing_German_ValidityTimespanMsg = {
  effectiveEnd?: InputMaybe<Input_Timestamp>;
  effectiveStart?: InputMaybe<Input_Timestamp>;
  serviceEnd?: InputMaybe<Input_Timestamp>;
  serviceStart?: InputMaybe<Input_Timestamp>;
};

/** Wrapper for vatOptions list, as repeated DecimalMsg cannot be handled by rejoiner */
export type Input_Billing_German_VatPercentageMsg = {
  percentage?: InputMaybe<Input_DecimalMsg>;
};

export type Input_Billing_German_VentilationOverviewMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** Duration in minutes */
  totalActualVentilationDuration?: InputMaybe<Scalars['Int']>;
  /** Duration in minutes */
  totalBillableVentilationDuration?: InputMaybe<Scalars['Int']>;
  ventilationPeriods?: InputMaybe<Array<InputMaybe<Input_Billing_German_VentilationPeriodMsg>>>;
};

export type Input_Billing_German_VentilationPauseMsg = {
  end?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Input_Timestamp>;
};

export type Input_Billing_German_VentilationPeriodMsg = {
  actualDuration?: InputMaybe<Scalars['Int']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billableDuration?: InputMaybe<Scalars['Int']>;
  billableDurationManuallySet?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Input_Timestamp>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intraoperative?: InputMaybe<Scalars['Boolean']>;
  modeOfVentilation?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  start?: InputMaybe<Input_Timestamp>;
  ventilationPauses?: InputMaybe<Array<InputMaybe<Input_Billing_German_VentilationPauseMsg>>>;
};

export type Input_Billing_Omim_CreateOrUpdateCatalogStreamRequest = {
  catalogId?: InputMaybe<Scalars['String']>;
  gCode?: InputMaybe<Input_Billing_Omim_GCodeMsg>;
  /** Bulk upsert */
  gCodeList?: InputMaybe<Input_Billing_Omim_GCodeList>;
  mapping?: InputMaybe<Input_Billing_Omim_CreateOrUpdateCatalogStreamRequest_Mapping>;
  pCode?: InputMaybe<Input_Billing_Omim_PCodeMsg>;
  /** Bulk upsert */
  pCodeList?: InputMaybe<Input_Billing_Omim_PCodeList>;
};

export type Input_Billing_Omim_CreateOrUpdateCatalogStreamRequest_Mapping = {
  gCodeId?: InputMaybe<Scalars['String']>;
  pCodeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_Omim_CreateOrUpdateCatalogStreamResponse = {
  catalogId?: InputMaybe<Scalars['String']>;
  gCode?: InputMaybe<Input_Billing_Omim_GCodeMsg>;
  gCodeList?: InputMaybe<Input_Billing_Omim_GCodeList>;
  mapping?: InputMaybe<Input_Billing_Omim_CreateOrUpdateCatalogStreamResponse_Mapping>;
  pCode?: InputMaybe<Input_Billing_Omim_PCodeMsg>;
  pCodeList?: InputMaybe<Input_Billing_Omim_PCodeList>;
};

export type Input_Billing_Omim_CreateOrUpdateCatalogStreamResponse_Mapping = {
  gCode?: InputMaybe<Input_Billing_Omim_GCodeMsg>;
  pCode?: InputMaybe<Input_Billing_Omim_PCodeMsg>;
};

export type Input_Billing_Omim_GCodeList = {
  gCodes?: InputMaybe<Array<InputMaybe<Input_Billing_Omim_GCodeMsg>>>;
};

export type Input_Billing_Omim_GCodeMsg = {
  catalogId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  geneName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isFreeText?: InputMaybe<Scalars['Boolean']>;
  prefix?: InputMaybe<Billing_Omim_PrefixG>;
};

export type Input_Billing_Omim_GetLatestCatalogRequest = {
  billingCertificateId?: InputMaybe<Scalars['String']>;
  catalogNumber?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_Omim_GetLatestCatalogResponse = {
  catalog?: InputMaybe<Input_Catalog_CatalogMsg>;
};

export type Input_Billing_Omim_PCodeList = {
  pCodes?: InputMaybe<Array<InputMaybe<Input_Billing_Omim_PCodeMsg>>>;
};

export type Input_Billing_Omim_PCodeMsg = {
  catalogId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isFreeText?: InputMaybe<Scalars['Boolean']>;
  phenotype?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Billing_Omim_PrefixP>;
};

export type Input_Billing_Omim_SearchGCodesRequest = {
  catalogContext?: InputMaybe<Input_Catalog_CatalogQueryContextMsg>;
  query?: InputMaybe<Scalars['String']>;
  /** Set if p code is already selected */
  selectedPCodeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_Omim_SearchGCodesResponse = {
  gCodes?: InputMaybe<Array<InputMaybe<Input_Billing_Omim_GCodeMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Billing_Omim_SearchPCodesRequest = {
  catalogContext?: InputMaybe<Input_Catalog_CatalogQueryContextMsg>;
  query?: InputMaybe<Scalars['String']>;
  /** Set if g code is already selected */
  selectedGCodeId?: InputMaybe<Scalars['String']>;
};

export type Input_Billing_Omim_SearchPCodesResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  pCodes?: InputMaybe<Array<InputMaybe<Input_Billing_Omim_PCodeMsg>>>;
};

export type Input_Catalog_AcknowledgeCatalogUpdateRequest = {
  catalogId?: InputMaybe<Scalars['String']>;
};

export type Input_Catalog_CatalogMsg = {
  /** Some catalogs need updates need to be manually acknowledged */
  acknowledgementRequired?: InputMaybe<Scalars['Boolean']>;
  /** All catalogs must offer a combined identifier of their version */
  combinedVersionId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<Scalars['String']>;
  /** Identifies the region for which this catalog applies */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Catalog_CatalogStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Catalog_CatalogType>;
  /** If users can override/overlay contents of the catalog */
  userOverrideAllowed?: InputMaybe<Scalars['Boolean']>;
  /** no validity set defaults to always */
  validity?: InputMaybe<Input_TimeFrameMsg>;
  /** Will be set to true once catalog update has been acknowledged */
  versionAcknowledged?: InputMaybe<Scalars['Boolean']>;
  /** Optional, typically a more human-friendly way of showing the version */
  versionDisplayName?: InputMaybe<Scalars['String']>;
};

export type Input_Catalog_CatalogQueryContextMsg = {
  combinedVersionId?: InputMaybe<Scalars['String']>;
  /** The point in time that is matched to find the correct catalog with validity between */
  referenceTimePoint?: InputMaybe<Input_Timestamp>;
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /** show inactive catalogs */
  showInactive?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Catalog_CatalogType>;
};

export type Input_Catalog_CreateCatalogRequest = {
  catalog?: InputMaybe<Input_Catalog_CatalogMsg>;
};

export type Input_Catalog_CreateCatalogResponse = {
  catalog?: InputMaybe<Input_Catalog_CatalogMsg>;
};

export type Input_Catalog_FindCatalogsRequest = {
  catalogContext?: InputMaybe<Input_Catalog_CatalogQueryContextMsg>;
};

export type Input_Catalog_FindCatalogsResponse = {
  catalogs?: InputMaybe<Array<InputMaybe<Input_Catalog_CatalogMsg>>>;
};

export type Input_Catalog_SetCatalogStatusRequest = {
  catalogId?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<Catalog_CatalogStatus>;
  /** these catalogs end when the new catalog begins. */
  precedingCatalogIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** no longer active these catalogs are replaced by new catalog and are not available any longer */
  supersededCatalogIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * A group of categories of a categorical system
 *  Example: "positive" is a CategoryGroup, with categories "positive", "positive (some)", "positive (many)"
 */
export type Input_Category_CategoryGroupMsg = {
  categories?: InputMaybe<Array<InputMaybe<Input_Category_CategoryMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** One specific category of a categorical system */
export type Input_Category_CategoryMsg = {
  /** for result categories: whether this category is conspicuous */
  conspicuous?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** if set, can be used as displayed text in frontend */
  shortKey?: InputMaybe<Scalars['String']>;
  /** whether this category is the default value of its CategorySystem */
  systemDefault?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Category_CategorySystemList = {
  categorySystems?: InputMaybe<Array<InputMaybe<Input_Category_CategorySystemMsg>>>;
};

/** A categorical system in which some parameter can be categorized */
export type Input_Category_CategorySystemMsg = {
  /** only one out of (categories, categoryGroups) is set */
  categories?: InputMaybe<Array<InputMaybe<Input_Category_CategoryMsg>>>;
  /** only one out of (categories, categoryGroups) is set */
  categoryGroups?: InputMaybe<Array<InputMaybe<Input_Category_CategoryGroupMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** name as displayed when saving space is required, e.g., on small labels */
  shortName?: InputMaybe<Scalars['String']>;
};

/**
 * A group of categories of a categorical system
 *  Example: "positive" is a CategoryGroup, with categories "positive", "positive (some)", "positive (many)"
 */
export type Input_Category_ResultCategoryGroupMsg = {
  categories?: InputMaybe<Array<InputMaybe<Input_Category_ResultCategoryMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** One specific category of a categorical system */
export type Input_Category_ResultCategoryMsg = {
  conspicuous?: InputMaybe<Scalars['Boolean']>;
  /** Set true if the referenceRange is created ad-hoc instead of pre-defined */
  customCategory?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** if set, can be used as displayed text in frontend */
  shortKey?: InputMaybe<Scalars['String']>;
  /** whether this category is the default value of its CategorySystem */
  systemDefault?: InputMaybe<Scalars['Boolean']>;
};

/** A categorical system in which some parameter can be categorized */
export type Input_Category_ResultCategorySystemMsg = {
  /** only one out of (categories, categoryGroups) is set */
  categories?: InputMaybe<Array<InputMaybe<Input_Category_ResultCategoryMsg>>>;
  /** only one out of (categories, categoryGroups) is set */
  categoryGroups?: InputMaybe<Array<InputMaybe<Input_Category_ResultCategoryGroupMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** name as displayed when saving space is required, e.g., on small labels */
  shortName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_AddClinicalRequestInputRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_AddClinicalRequestTemplateToFavoritesRequest = {
  clinicalRequestTemplateId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_AddCustomClinicalRequestInputRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  inputType?: InputMaybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Input_Clinicalrequest_BlockPathMsg = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Clinicalrequest_CalculateAppointmentDurationsElementMsg = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  /** In minutes */
  duration?: InputMaybe<Scalars['Int']>;
  /** If not true, use the appointment type's standard duration */
  hasDuration?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_CalculateAppointmentDurationsRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_CalculateAppointmentDurationsResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_CalculateAppointmentDurationsElementMsg>>>;
};

export type Input_Clinicalrequest_CancelClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ChangeClinicalRequestInputVisibilityRequest = {
  changeReason?: InputMaybe<Scalars['String']>;
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
  customClinicalRequestInputId?: InputMaybe<Scalars['String']>;
  /**
   * set true when hiding an input
   *  not set when reactivating a hidden input
   */
  hide?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_ChangeClinicalRequestInputVisibilityResponse = {
  clinicalRequestInput?: InputMaybe<Input_Clinicalrequest_ClinicalRequestInputMsg>;
  customClinicalRequestInput?: InputMaybe<Input_Clinicalrequest_CustomClinicalRequestInputMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg = {
  actionTime?: InputMaybe<Input_Timestamp>;
  actionType?: InputMaybe<Clinicalrequest_ClinicalRequestActionType>;
  addInputAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_AddInputAction>;
  cancelRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_CancelRequestAction>;
  createRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_CreateRequestAction>;
  finishRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_FinishRequestAction>;
  id?: InputMaybe<Scalars['String']>;
  rejectRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_RejectRequestAction>;
  removeInputAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_RemoveInputAction>;
  reprioritizeRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_ReprioritizeRequestAction>;
  submitRequestAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_SubmitRequestAction>;
  updateInputContentAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_UpdateInputContentAction>;
  updateInputDocumentTypeAction?: InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg_UpdateInputDocumentTypeAction>;
  userReference?: InputMaybe<Input_Core_UserReferenceMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_AddInputAction = {
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_CancelRequestAction = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_CreateRequestAction = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_FinishRequestAction = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_RejectRequestAction = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_RemoveInputAction = {
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_ReprioritizeRequestAction = {
  fromCustomPriorityLevel?: InputMaybe<Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  fromStandardPriorityLevel?: InputMaybe<Clinicalrequest_PriorityLevel>;
  priorityLevelType?: InputMaybe<Clinicalrequest_ClinicalRequestPriorityLevelType>;
  reasonForReprioritization?: InputMaybe<Scalars['String']>;
  toCustomPriorityLevel?: InputMaybe<Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  toStandardPriorityLevel?: InputMaybe<Clinicalrequest_PriorityLevel>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_SubmitRequestAction = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_UpdateInputContentAction = {
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestActionMsg_UpdateInputDocumentTypeAction = {
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fromDocumentType?: InputMaybe<Input_Document_DocumentTypeMsg>;
  toDocumentType?: InputMaybe<Input_Document_DocumentTypeMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestAgreementMsg = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Input_Clinicalrequest_ClinicalRequestAgreementTemplateMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestAgreementTemplateMsg = {
  containsDocument?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  documentGroupId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  /** Set true if the document should be displayed, but no corresponding checkbox */
  skipAgreement?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_ClinicalRequestAppointmentConfigMsg = {
  /** In minutes; defines how long an appointment for this clinicalRequest takes, can also be added up in case several parts/specifiers of a request all have defined durations. */
  appointmentDuration?: InputMaybe<Scalars['Int']>;
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  disableBookingInRequest?: InputMaybe<Scalars['Boolean']>;
  /** If set, appointments can be booked directly (without needing appointment request) from the clinical request execution view */
  enableDirectBookingInExecution?: InputMaybe<Scalars['Boolean']>;
  /** If set, appointments can be booked directly (without needing appointment request) from the clinical request view */
  enableDirectBookingInRequest?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestBasicInfoMsg = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  completionDate?: InputMaybe<Input_Timestamp>;
  requester?: InputMaybe<Input_Core_UserReferenceMsg>;
  requesterUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_InternalOrPortalUnitReferenceMsg>>>;
  submissionDate?: InputMaybe<Input_Timestamp>;
  templateName?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestCategoryList = {
  clinicalRequestCategory?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>>>;
};

/** ----- Request template categories ----- */
export type Input_Clinicalrequest_ClinicalRequestCategoryMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** When the parent is set, its subCategories are not set to avoid infinite messages */
  parentCategory?: InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>;
  /** One-to-n mapping: a sub-category belongs to exactly one category */
  subCategories?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

/** One part of the documentation entry for a clinical request */
export type Input_Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg = {
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  /** Title of the input field, used for some types */
  title?: InputMaybe<Scalars['String']>;
  /** Only relevant for type "Treatment" */
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  type?: InputMaybe<Clinicalrequest_ClinicalRequestExecutionComponentType>;
};

/** Allows defining standard execution templates */
export type Input_Clinicalrequest_ClinicalRequestExecutionTemplatePresetMsg = {
  avelios?: InputMaybe<Scalars['Boolean']>;
  components?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** Slightly redundant additional information */
  mode?: InputMaybe<Clinicalrequest_ClinicalRequestExecutionMode>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

/** Represents an uploaded resource (see InputTemplateReferenceType) */
export type Input_Clinicalrequest_ClinicalRequestInputMsg = {
  contentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Clinicalrequest_ClinicalRequestInputOrigin>;
  status?: InputMaybe<Clinicalrequest_ClinicalRequestInputStatus>;
  template?: InputMaybe<Input_Clinicalrequest_ClinicalRequestInputTemplateMsg>;
  uploadDate?: InputMaybe<Input_Timestamp>;
  visibilityChanges?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestInputTemplateList = {
  inputTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputTemplateMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestInputTemplateMsg = {
  namedClinicalRequestInputTemplate?: InputMaybe<Input_Clinicalrequest_NamedClinicalRequestInputTemplateMsg>;
  structuredClinicalRequestInputTemplate?: InputMaybe<Input_Clinicalrequest_StructuredClinicalRequestInputTemplateMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg = {
  changeDate?: InputMaybe<Input_Timestamp>;
  changeReason?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestList = {
  clinicalRequests?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestMsg = {
  actions?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestActionMsg>>>;
  additionalRequesterEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  additionalRequesterPhoneNumbers?: InputMaybe<Array<InputMaybe<Input_Core_PhoneNumberMsg>>>;
  agreements?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestAgreementMsg>>>;
  attachedDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  attachedLabTestInstanceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clinicalRequestPriorityLevel?: InputMaybe<Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  completionDate?: InputMaybe<Input_Timestamp>;
  /** Users with whom the submission of the request has already been discussed */
  correspondentUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdOnBehalfOf?: InputMaybe<Array<InputMaybe<Input_Core_UserReferenceMsg>>>;
  customInputs?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_CustomClinicalRequestInputMsg>>>;
  customProblem?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  diagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Forms that are part of the request */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  inputs?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputMsg>>>;
  inquiry?: InputMaybe<Scalars['String']>;
  linkedAnamnesisId?: InputMaybe<Scalars['String']>;
  /** Text in html format */
  linkedAnamnesisTextHtml?: InputMaybe<Scalars['String']>;
  /** Set if appointments are booked directly (without appointment request) from the clinical request or its execution */
  linkedAppointmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set if appointment requests are sent from the clinical request or its execution */
  linkedAppointmentRequestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkedPhysicalExaminationId?: InputMaybe<Scalars['String']>;
  /** Text in html format */
  linkedPhysicalExaminationTextHtml?: InputMaybe<Scalars['String']>;
  medicationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  patientInformation?: InputMaybe<Input_Clinicalrequest_ClinicalRequestPatientInformationMsg>;
  patientPortalUserId?: InputMaybe<Scalars['String']>;
  /** each list is a chain of hierarchical problems, first element of each list would be the parent etc. */
  relevantProblems?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestProblemTemplateList>>>;
  /** each list is a chain of hierarchical problems, first element of each list would be the parent etc. */
  relevantSpecifiers?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestSpecifierList>>>;
  requestedConsultantUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requester?: InputMaybe<Input_Core_UserReferenceMsg>;
  requesterUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_InternalOrPortalUnitReferenceMsg>>>;
  /** Users who will be notified about result */
  resultRecipients?: InputMaybe<Array<InputMaybe<Input_Core_UserReferenceMsg>>>;
  standardPriorityLevel?: InputMaybe<Clinicalrequest_PriorityLevel>;
  status?: InputMaybe<Clinicalrequest_ClinicalRequestStatus>;
  submissionDate?: InputMaybe<Input_Timestamp>;
  surgeryId?: InputMaybe<Scalars['String']>;
  targetFacilityId?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  transportType?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  treatingOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
  warnings?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestWarningMsg>>>;
};

/** This is set by the requester from the portal side, since they do not have access to internal patient data. Later, a patient id can be linked by the clinic. */
export type Input_Clinicalrequest_ClinicalRequestPatientInformationMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  currentOrganizationalUnit?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Clinicalrequest_ClinicalRequestPriorityLevelList = {
  priorityLevels?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  duration?: InputMaybe<Input_PrecisionDurationMsg>;
  id?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Input_Core_LocalizedStringMsg>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  standardPriorityLevel?: InputMaybe<Clinicalrequest_PriorityLevel>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestProblemTemplateList = {
  problemTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestProblemTemplateMsg = {
  children?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  selectable?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  /** Warning to be displayed if this problem template is selected */
  warningText?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestRequestSettingsMsg = {
  hideDiagnoses?: InputMaybe<Scalars['Boolean']>;
  hidePriority?: InputMaybe<Scalars['Boolean']>;
  hideProblemTemplates?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_ClinicalRequestSpecifierList = {
  specifiers?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestTemplateAccessMsg = {
  clinicalRequestTemplateBasicInfo?: InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>;
  lastAccessTime?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestTemplateAllergyRequirementMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  specifiers?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  status?: InputMaybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
};

/** ----- Favorites ----- */
export type Input_Clinicalrequest_ClinicalRequestTemplateFavoritesMsg = {
  clinicalRequestTemplateBasicInfos?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>>>;
  userId?: InputMaybe<Scalars['String']>;
};

/** ----- Request History ----- */
export type Input_Clinicalrequest_ClinicalRequestTemplateHistoryMsg = {
  clinicalRequestTemplateAccesses?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateAccessMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestTemplateList = {
  clinicalRequestTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

/** Defines both requesting and executing side */
export type Input_Clinicalrequest_ClinicalRequestTemplateMsg = {
  additionalConsults?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  agreementTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestAgreementTemplateMsg>>>;
  appointmentConfigs?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestAppointmentConfigMsg>>>;
  /** Most specific category that the template is assigned to; can be empty */
  category?: InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>;
  /** Whether requester can select specific doctors */
  consultantSelectionEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Defines how additional specific results of the clinical request execution are documented */
  executionComponents?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  executionMode?: InputMaybe<Clinicalrequest_ClinicalRequestExecutionMode>;
  /** If true, the request execution is done by an external provider that is not part of the internal clinic hierarchy */
  externalRecipient?: InputMaybe<Scalars['Boolean']>;
  /** Only relevant if externalRecipient is true */
  externalRequestDefinition?: InputMaybe<Input_Clinicalrequest_ExternalClinicalRequestDefinitionMsg>;
  /** The id of the form template versioning group to be conducted when requesting this consultation */
  formVersioningGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Used to group different versions of the request template */
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inputTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputTemplateMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  /** Users who should get notified if something happens in requests of this template */
  notificationRecipientUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The owner of the request template; for non-external recipients, this is also the recipient */
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  problemTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
  referenceId?: InputMaybe<Scalars['String']>;
  requestSettings?: InputMaybe<Input_Clinicalrequest_ClinicalRequestRequestSettingsMsg>;
  specifiers?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  status?: InputMaybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** Warnings that are displayed to the requester, used e.g., to remind requester to add all required information */
  warningTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestWarningTemplateMsg>>>;
};

export type Input_Clinicalrequest_ClinicalRequestTemplatePresetList = {
  presets?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplatePresetMsg>>>;
};

/** ----- Request template presets ----- */
export type Input_Clinicalrequest_ClinicalRequestTemplatePresetMsg = {
  clinicalRequestTemplateBasicInfos?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

/** ----- Clinical Request Template Specifiers ----- */
export type Input_Clinicalrequest_ClinicalRequestTemplateSpecifierMsg = {
  appointmentConfigs?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestAppointmentConfigMsg>>>;
  /** later on add requirements */
  childSpecifiers?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  /** Defines additional entry fields for this specifier */
  executionComponents?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  externalId?: InputMaybe<Scalars['String']>;
  formVersioningGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Laterality_Laterality>;
  name?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ClinicalRequestWarningMsg = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Input_Clinicalrequest_ClinicalRequestWarningTemplateMsg>;
};

export type Input_Clinicalrequest_ClinicalRequestWarningTemplateMsg = {
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_CreateClinicalRequestRequest = {
  clinicalRequestSpecifiersIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clinicalRequestTemplateId?: InputMaybe<Scalars['String']>;
  /** should be set in the portal side */
  externalRequesterUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  /** optional */
  patientId?: InputMaybe<Scalars['String']>;
  /** optional */
  surgeryId?: InputMaybe<Scalars['String']>;
  /** should be set in the portal side */
  targetFacilityId?: InputMaybe<Scalars['String']>;
  /** optional */
  treatmentId?: InputMaybe<Scalars['String']>;
  /** optional */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_CustomClinicalRequestInputMsg = {
  contentId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Input_Document_DocumentTypeMsg>;
  fileName?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Clinicalrequest_ClinicalRequestInputOrigin>;
  referenceType?: InputMaybe<Clinicalrequest_InputTemplateReferenceType>;
  status?: InputMaybe<Clinicalrequest_ClinicalRequestInputStatus>;
  uploadDate?: InputMaybe<Input_Timestamp>;
  visibilityChanges?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg>>>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestCategoryRequest = {
  clinicalRequestCategoryId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestCategoryResponse = {
  deletedClinicalRequestCategoryId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestResponse = {
  deletedClinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestTemplatePresetRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_DeleteClinicalRequestTemplatePresetResponse = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ExternalClinicalRequestDefinitionMsg = {
  /** Used to determine where to sent the request */
  externalExternalRecipientIds?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ExternalClinicalRequestRecipientIdMsg>>>;
  /** Specifies the external units of the receiving party */
  externalRecipientUnits?: InputMaybe<Array<InputMaybe<Input_Core_ExternalAdministrativeUnitReferenceMsg>>>;
  /** Allow identifying the request template for exchanging requests with an external system */
  externalTemplateIds?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ExternalClinicalRequestTemplateIdMsg>>>;
  /** Flag determining if request will be pushed to the Gateway service */
  useAppointmentDate?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_ExternalClinicalRequestRecipientIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Clinicalrequest_ExternalClinicalRequestRecipientIdType>;
};

export type Input_Clinicalrequest_ExternalClinicalRequestTemplateIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Clinicalrequest_ExternalClinicalRequestTemplateIdType>;
};

export type Input_Clinicalrequest_GetClinicalRequestForEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_GetClinicalRequestInputRequest = {
  clinicalRequestInputId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_GetClinicalRequestInputTemplateRequest = {
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_GetClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_GetClinicalRequestsRequest = {
  clinicalRequestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Clinicalrequest_GetCustomClinicalRequestInputRequest = {
  customClinicalRequestInputId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_LinkPatientToClinicalRequestKafkaEvent = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  inputs?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestInputMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_LinkPatientToClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListAllClinicalRequestTemplatesRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListClinicalRequestPriorityLevelsRequest = {
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplateCatalogByCategoryResponse = {
  categories?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>>>;
  templates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplateCatalogByOwnerResponse = {
  clinicTrees?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitTreeMsg>>>;
  templates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplateCatalogRequest = {
  groupByCategories?: InputMaybe<Scalars['Boolean']>;
  groupByOwner?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplateHistoryRequest = {
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplatePresetsRequest = {
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListClinicalRequestTemplatesRequest = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** should be set true if don't want to fetch lower hierarchies' templates. */
  exactMatchWithScope?: InputMaybe<Scalars['Boolean']>;
  inFavourites?: InputMaybe<Scalars['Boolean']>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional filter */
  templateStatuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestTemplateStatus>>>;
};

export type Input_Clinicalrequest_ListClinicalRequestsRequest = {
  /** optional, if true, only returns Clinical Requests that have linked appointments */
  hasLinkedAppointment?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, returns any Clinical Requests that have linked appointments or linked appointment requests */
  hasLinkedAppointmentOrRequest?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  /** optional */
  statuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestStatus>>>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListClinicalRequestsResponse = {
  clinicalRequests?: InputMaybe<Input_Clinicalrequest_ClinicalRequestList>;
};

export type Input_Clinicalrequest_ListFavoriteClinicalRequestTemplatesRequest = {
  /** optional */
  favoriteCount?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListIncomingClinicalRequestsRequest = {
  administrativeUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  exactMatchWithScope?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: InputMaybe<Scalars['Boolean']>;
  requestedConsultantUserId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Helper_SortOrder>;
  sortType?: InputMaybe<Clinicalrequest_ClinicalRequestSortType>;
  /** required */
  statuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestStatus>>>;
  targetFacilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListIncomingClinicalRequestsResponse = {
  clinicalRequests?: InputMaybe<Input_Clinicalrequest_ClinicalRequestList>;
};

export type Input_Clinicalrequest_ListOutgoingClinicalRequestsRequest = {
  administrativeUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  exactMatchWithScope?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: InputMaybe<Scalars['Boolean']>;
  requester?: InputMaybe<Input_Core_UserReferenceMsg>;
  sortOrder?: InputMaybe<Helper_SortOrder>;
  sortType?: InputMaybe<Clinicalrequest_ClinicalRequestSortType>;
  /** required */
  statuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestStatus>>>;
  treatingOrganizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_ListOutgoingClinicalRequestsResponse = {
  clinicalRequests?: InputMaybe<Input_Clinicalrequest_ClinicalRequestList>;
};

export type Input_Clinicalrequest_ListUnsubmittedClinicalRequestsRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_NamedClinicalRequestInputTemplateMsg = {
  documentType?: InputMaybe<Input_Document_DocumentTypeMsg>;
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  referenceType?: InputMaybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Input_Clinicalrequest_NotifyClinicalRequestCommentRecipientsRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_NotifyClinicalRequestCommentRecipientsResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_PriorityLevelIdList = {
  priorityLevelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Clinicalrequest_PriorityLevelList = {
  levels?: InputMaybe<Array<InputMaybe<Clinicalrequest_PriorityLevel>>>;
};

export type Input_Clinicalrequest_ReferenceMsg = {
  blockPath?: InputMaybe<Input_Clinicalrequest_BlockPathMsg>;
  referenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_RejectClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_RemoveClinicalRequestInputRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  inputId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_RemoveClinicalRequestInputResponse = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  input?: InputMaybe<Input_Clinicalrequest_ClinicalRequestInputMsg>;
};

export type Input_Clinicalrequest_RemoveClinicalRequestTemplateFromFavoritesRequest = {
  clinicalRequestTemplateId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_RemoveCustomClinicalRequestInputRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  inputId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_RemoveCustomClinicalRequestInputResponse = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  input?: InputMaybe<Input_Clinicalrequest_CustomClinicalRequestInputMsg>;
};

export type Input_Clinicalrequest_ReprioritizeClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  newPriorityLevelId?: InputMaybe<Scalars['String']>;
  newStandardPriorityLevel?: InputMaybe<Clinicalrequest_PriorityLevel>;
  reasonForReprioritization?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_SearchClinicalRequestTemplatesRequest = {
  /** should be set true if don't want to fetch lower hierarchies' templates. */
  exactMatchWithScope?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional filter */
  templateStatuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestTemplateStatus>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_SearchClinicalRequestTemplatesResponse = {
  clinicalRequestTemplates?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Clinicalrequest_SearchClinicalRequestsRequest = {
  clinicalRequestPatientInformationId?: InputMaybe<Scalars['String']>;
  /** optional filter */
  clinicalRequestStatuses?: InputMaybe<Array<InputMaybe<Clinicalrequest_ClinicalRequestStatus>>>;
  /** optional filter */
  clinicalRequestTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** should be set true if don't want to fetch lower hierarchies' requests. */
  exactMatchWithOwner?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointments */
  hasLinkedAppointment?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, returns any Clinical Requests that have linked appointments or linked appointment requests */
  hasLinkedAppointmentOrRequest?: InputMaybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: InputMaybe<Scalars['Boolean']>;
  /**
   * must to set in the requestee side to display the requests
   *  optional to set as "requested unit" in the requester side
   */
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** mandatory */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  priorityLevelIdList?: InputMaybe<Input_Clinicalrequest_PriorityLevelIdList>;
  priorityLevelList?: InputMaybe<Input_Clinicalrequest_PriorityLevelList>;
  /**
   * must to set in the requester side to list requester' clinical requests
   *  optional filter for requestee side
   */
  sentBy?: InputMaybe<Input_Core_InternalOrPortalUnitReferenceMsg>;
  /** optional filter */
  submissionEndDate?: InputMaybe<Input_Timestamp>;
  /** optional filter */
  submissionStartDate?: InputMaybe<Input_Timestamp>;
  /** optional filter */
  targetFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional filter, set true to see unlinked clinical requests with patients */
  unlinkedRequestsWithPatients?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Clinicalrequest_SearchClinicalRequestsResponse = {
  clinicalRequests?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Clinicalrequest_StructuredClinicalRequestInputTemplateMsg = {
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Input_Clinicalrequest_ReferenceMsg>;
  referenceType?: InputMaybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Input_Clinicalrequest_SubmitClinicalRequestRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Clinicalrequest_UpdateClinicalRequestCategoryRequest = {
  clinicalRequestCategory?: InputMaybe<Input_Clinicalrequest_ClinicalRequestCategoryMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Clinicalrequest_UpdateClinicalRequestRequest = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Clinicalrequest_UpdateClinicalRequestTemplatePresetRequest = {
  templatePreset?: InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplatePresetMsg>;
};

export type Input_Clinicalrequest_UpdateClinicalRequestTemplateRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  template?: InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>;
};

export type Input_Clinicalrequest_UpdateClinicalRequestTemplateStatusRequest = {
  clinicalRequestTemplateId?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
};

export type Input_Clinicalrequest_UpdateCustomClinicalRequestInputRequest = {
  customClinicalRequestInput?: InputMaybe<Input_Clinicalrequest_CustomClinicalRequestInputMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Clinicalrequest_UpdateRelevantProblemsRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  clinicalRequestProblemTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Clinicalrequest_UpdateRelevantSpecifiersRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  clinicalRequestSpecifiersIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Comment_CommentContextReferenceMsg = {
  contextId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Comment_CommentContextType>;
};

export type Input_Comment_CommentList = {
  comments?: InputMaybe<Array<InputMaybe<Input_Comment_CommentMsg>>>;
};

export type Input_Comment_CommentMsg = {
  /** backend manages the active property of the comment */
  active?: InputMaybe<Scalars['Boolean']>;
  commenter?: InputMaybe<Input_Core_UserReferenceMsg>;
  commenterUnits?: InputMaybe<Array<InputMaybe<Input_Core_InternalOrPortalUnitReferenceMsg>>>;
  /** Main context */
  context?: InputMaybe<Input_Comment_CommentContextReferenceMsg>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  referencedUsers?: InputMaybe<Array<InputMaybe<Input_Core_UserReferenceMsg>>>;
  /**
   * Comment that this comment replies to.
   *  Maximum depth: 1, i.e., in the nested comment, no further CommentMsg will be nested
   */
  replyToComment?: InputMaybe<Input_Comment_CommentMsg>;
  /** The context of a comment is the main context and all the sub contexts. */
  subContexts?: InputMaybe<Array<InputMaybe<Input_Comment_CommentContextReferenceMsg>>>;
  text?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Comment_CreateCommentRequest = {
  context?: InputMaybe<Input_Comment_CommentContextReferenceMsg>;
  /** optional */
  replyToCommentId?: InputMaybe<Scalars['String']>;
  subContexts?: InputMaybe<Array<InputMaybe<Input_Comment_CommentContextReferenceMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Comment_DeleteCommentRequest = {
  commentId?: InputMaybe<Scalars['String']>;
};

export type Input_Comment_DeleteCommentResponse = {
  deletedCommentId?: InputMaybe<Scalars['String']>;
};

export type Input_Comment_GetCommentHistoryRequest = {
  groupId?: InputMaybe<Scalars['String']>;
};

/** it only returns the latest versions of the comments */
export type Input_Comment_ListCommentsRequest = {
  contextFilters?: InputMaybe<Array<InputMaybe<Input_Comment_ListCommentsRequestContextFilterMsg>>>;
  /** optional sort */
  creationDateSort?: InputMaybe<Helper_SortOrder>;
  /**
   * optional filter
   *  if it's set to true, fetches only the active ones. O/w fetches both active and inactive ones
   */
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Set if pagination is desired */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Comment_ListCommentsRequestContextFilterMsg = {
  /** Context has to match */
  context?: InputMaybe<Input_Comment_CommentContextReferenceMsg>;
  /** It is enough to have one sub context that match */
  subContexts?: InputMaybe<Array<InputMaybe<Input_Comment_CommentContextReferenceMsg>>>;
};

export type Input_Comment_ListCommentsResponse = {
  comments?: InputMaybe<Array<InputMaybe<Input_Comment_CommentMsg>>>;
  contextFilters?: InputMaybe<Array<InputMaybe<Input_Comment_ListCommentsRequestContextFilterMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

/** It doesn't update the comment.replyToComment */
export type Input_Comment_UpdateCommentRequest = {
  comment?: InputMaybe<Input_Comment_CommentMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Common_Access_ContextPathKeyMsg = {
  context?: InputMaybe<Common_Access_PathKeyContext>;
  pathKey?: InputMaybe<Input_Common_Access_PathKeyMsg>;
};

export type Input_Common_Access_ListAccessConstraintsResponse = {
  pathKeyAccessConstraints?: InputMaybe<Array<InputMaybe<Input_Common_Access_PathKeyAccessConstraintMsg>>>;
  scopedAccessConstraints?: InputMaybe<Array<InputMaybe<Input_Common_Access_ScopedAccessConstraintMsg>>>;
};

export type Input_Common_Access_ListRouteConstraintsRequest = {
  targetContext?: InputMaybe<Common_Access_TargetConstraint>;
};

export type Input_Common_Access_PathKeyAccessConstraintMsg = {
  accessConstraint?: InputMaybe<Common_Access_AccessConstraint>;
  contextPathKey?: InputMaybe<Input_Common_Access_ContextPathKeyMsg>;
};

export type Input_Common_Access_PathKeyMsg = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Common_Access_RouteConstraintList = {
  routeConstraints?: InputMaybe<Array<InputMaybe<Common_Access_RouteConstraint>>>;
};

export type Input_Common_Access_ScopedAccessConstraintMsg = {
  accessConstraint?: InputMaybe<Common_Access_AccessConstraint>;
  anesthesiaPlanAction?: InputMaybe<Common_Access_AnesthesiaPlanAction>;
  applicationElement?: InputMaybe<Common_Access_ApplicationElement>;
  applicationModule?: InputMaybe<Common_Access_ApplicationModule>;
  caseAction?: InputMaybe<Common_Access_CaseAction>;
  cockpitAction?: InputMaybe<Common_Access_CockpitAction>;
  configurationAction?: InputMaybe<Common_Access_ConfigurationAction>;
  coreDataAction?: InputMaybe<Common_Access_CoreDataAction>;
  dischargeAction?: InputMaybe<Common_Access_DischargeAction>;
  findingAction?: InputMaybe<Common_Access_FindingAction>;
  formsAction?: InputMaybe<Common_Access_FormsAction>;
  medicationAction?: InputMaybe<Common_Access_MedicationAction>;
  metaAnamnesisAction?: InputMaybe<Common_Access_MetaAnamnesisAction>;
  /**
   * theoretically all following oneof, but not used since otherwise issues in the database backend
   *  used when there is neither an element nor an action specified
   */
  moduleAccessConstraint?: InputMaybe<Common_Access_AccessConstraint>;
  noAction?: InputMaybe<Scalars['Boolean']>;
  occupancyManagementAction?: InputMaybe<Common_Access_OccupancyManagementAction>;
  patientAction?: InputMaybe<Common_Access_PatientAction>;
  patientChartAction?: InputMaybe<Common_Access_PatientChartAction>;
  patientLetterAction?: InputMaybe<Common_Access_PatientLetterAction>;
  reportsAndProtocolsAction?: InputMaybe<Common_Access_ReportsAndProtocolsAction>;
  requestsAction?: InputMaybe<Common_Access_RequestsAction>;
  surgeryCalendarAction?: InputMaybe<Common_Access_SurgeryCalendarAction>;
  surgeryWorklistAction?: InputMaybe<Common_Access_SurgeryWorklistAction>;
  surgicalCockpitAction?: InputMaybe<Common_Access_SurgicalCockpitAction>;
  treatmentAction?: InputMaybe<Common_Access_TreatmentAction>;
  visitAction?: InputMaybe<Common_Access_VisitAction>;
  wardOverviewAction?: InputMaybe<Common_Access_WardOverviewAction>;
};

export type Input_Common_Access_TargetConstraintList = {
  targetConstraints?: InputMaybe<Array<InputMaybe<Common_Access_TargetConstraint>>>;
};

export type Input_Common_Access_TargetedRouteConstraintMsg = {
  routeConstraints?: InputMaybe<Array<InputMaybe<Common_Access_RouteConstraint>>>;
  targetContext?: InputMaybe<Common_Access_TargetConstraint>;
};

export type Input_Common_Letter_GetComponentLetterTextRequest = {
  /** For what the letter text should be returned */
  component?: InputMaybe<Input_Common_Letter_LetterComponentReferenceMsg>;
  parameters?: InputMaybe<Input_Common_Letter_LetterTextGenerationParametersMsg>;
  /**
   * Optional. Use this field for components that require a numbered heading (e.g., ReasonForPresentation, TherapyCard).
   *  selected component reference ids with the same component type (LetterComponentType) should be sent to derive numbered heading for the component
   */
  selectedComponentReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Common_Letter_GetSectionLetterTextResponse = {
  /** The generated letterText for the given section */
  letterText?: InputMaybe<Input_Core_LetterTextMsg>;
  /** The section from which the letterText was generated */
  sectionType?: InputMaybe<Common_Letter_LetterSectionType>;
};

export type Input_Common_Letter_LetterComponentReferenceList = {
  references?: InputMaybe<Array<InputMaybe<Input_Common_Letter_LetterComponentReferenceMsg>>>;
};

export type Input_Common_Letter_LetterComponentReferenceMsg = {
  /**
   * Interpretation of the id depends on the component type:
   *  Typically, it's the id of the given component, but for components that don't have an own id, can be id of context.
   */
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Common_Letter_LetterComponentType>;
};

export type Input_Common_Letter_LetterTextGenerationParametersMsg = {
  /** Whether html links that can be interpreted by the caller should be inserted in the html content */
  insertLinks?: InputMaybe<Scalars['Boolean']>;
  /** Desired language of the text */
  language?: InputMaybe<Core_Language>;
  /** Sex of the patient */
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Core_AcknowledgementMsg = {
  acknowledgementDate?: InputMaybe<Input_Timestamp>;
  clinicalFindingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  obsolete?: InputMaybe<Scalars['Boolean']>;
  reasonForDissent?: InputMaybe<Core_ReasonForAcknowledgementDissent>;
  reasonForDissentText?: InputMaybe<Scalars['String']>;
  requestingUserId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Core_AcknowledgementStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_AddressMsg = {
  additional?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  co?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Input_Core_CoordinatesMsg>;
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  countryCode?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  municipalKey?: InputMaybe<Scalars['String']>;
  postOfficeBox?: InputMaybe<Scalars['Boolean']>;
  postOfficeBoxAddress?: InputMaybe<Scalars['String']>;
  precinct?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Input_Core_AdministrativeUnitMappingList = {
  mappings?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitMappingMsg>>>;
};

export type Input_Core_AdministrativeUnitMappingMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_AdministrativeUnitReferenceList = {
  unitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_Core_AdministrativeUnitReferenceMsg = {
  type?: InputMaybe<Core_AdministrativeUnitType>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ClinicalFindingActionList = {
  clinicalFindingActions?: InputMaybe<Array<InputMaybe<Input_Core_ClinicalFindingActionMsg>>>;
};

export type Input_Core_ClinicalFindingActionMsg = {
  actionTime?: InputMaybe<Input_Timestamp>;
  actionType?: InputMaybe<Core_ClinicalFindingActionType>;
  affectedUserId?: InputMaybe<Scalars['String']>;
  affectingUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  obsolete?: InputMaybe<Scalars['Boolean']>;
  reasonForDissent?: InputMaybe<Core_ReasonForAcknowledgementDissent>;
  reasonForDissentText?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ClinicalInfoReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_ClinicalInfoType>;
};

export type Input_Core_ContactMsg = {
  addresses?: InputMaybe<Array<InputMaybe<Input_Core_AddressMsg>>>;
  emails?: InputMaybe<Array<InputMaybe<Input_Core_EmailMsg>>>;
  faxNumbers?: InputMaybe<Array<InputMaybe<Input_Core_PhoneNumberMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  landlineNumbers?: InputMaybe<Array<InputMaybe<Input_Core_PhoneNumberMsg>>>;
  mobileNumbers?: InputMaybe<Array<InputMaybe<Input_Core_PhoneNumberMsg>>>;
  useType?: InputMaybe<Core_PersonalInformationUseType>;
};

export type Input_Core_ContactReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_ContactReferenceType>;
};

export type Input_Core_CoordinatesMsg = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type Input_Core_CreateAcknowledgementRequest = {
  clinicalFindingId?: InputMaybe<Scalars['String']>;
  targetUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_DateScheduleMsg = {
  /** If true, the owner of this schedule is unavailable in the defined time frame */
  blocked?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Input_Timestamp>;
};

export type Input_Core_DayOfWeekScheduleMsg = {
  dayOfWeek?: InputMaybe<DayOfWeek>;
  id?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
};

export type Input_Core_DeleteAcknowledgementRequest = {
  acknowledgementId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_DeleteRequirementTemplateRequest = {
  requirementTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_EmailMsg = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Core_ExternalAdministrativeUnitReferenceMsg = {
  type?: InputMaybe<Core_ExternalAdministrativeUnitType>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ExternalClinicIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_ExternalClinicIdType>;
};

export type Input_Core_ExternalClinicList = {
  clinics?: InputMaybe<Array<InputMaybe<Input_Core_ExternalClinicMsg>>>;
};

export type Input_Core_ExternalClinicMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  divisions?: InputMaybe<Array<InputMaybe<Input_Core_ExternalDivisionMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Core_ExternalClinicIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  validity?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Core_ExternalDivisionList = {
  divisions?: InputMaybe<Array<InputMaybe<Input_Core_ExternalDivisionMsg>>>;
};

export type Input_Core_ExternalDivisionMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_Core_ExternalOrganizationalUnitMsg>>>;
};

export type Input_Core_ExternalEmployerMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ExternalOrganizationalUnitList = {
  units?: InputMaybe<Array<InputMaybe<Input_Core_ExternalOrganizationalUnitMsg>>>;
};

export type Input_Core_ExternalOrganizationalUnitMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  divisionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ExternalProcedureCodeIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_ExternalProcedureCodeIdType>;
};

/**
 * This marks a special status of a patient relevant for medical care.
 *  Examples: Pregnant, Infectious, MRSA
 */
export type Input_Core_FlagMsg = {
  details?: InputMaybe<Scalars['String']>;
  flagId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  id?: InputMaybe<Scalars['String']>;
  importance?: InputMaybe<Core_Importance>;
  status?: InputMaybe<Core_ObjectStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Core_FlexibleAdministrativeUnitMappingMsg = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_FractionMsg = {
  denominator?: InputMaybe<Scalars['Long']>;
  numerator?: InputMaybe<Scalars['Long']>;
};

export type Input_Core_HumanNameMsg = {
  /** dt. Namenszusatz */
  affix?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  maidenName?: InputMaybe<Scalars['String']>;
  middleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** dt. Vorsatzwort */
  prefix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  useType?: InputMaybe<Core_PersonalInformationUseType>;
};

export type Input_Core_InternalOrPortalUnitReferenceList = {
  unitReferences?: InputMaybe<Array<InputMaybe<Input_Core_InternalOrPortalUnitReferenceMsg>>>;
};

export type Input_Core_InternalOrPortalUnitReferenceMsg = {
  type?: InputMaybe<Core_InternalOrPortalUnitType>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_KnowledgeInputMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Core_LetterReferenceMsg = {
  id?: InputMaybe<Scalars['String']>;
  letterId?: InputMaybe<Scalars['String']>;
  /** We use timestamps to sort the references, as we often want the latest one */
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Core_LetterTextMsg = {
  html?: InputMaybe<Scalars['String']>;
};

export type Input_Core_ListRequirementTemplatesRequest = {
  /** required filter */
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** required filter */
  target?: InputMaybe<Core_RequirementTemplateTarget>;
};

export type Input_Core_LocalDateMsg = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Input_Core_LocalDateTimeMsg = {
  date?: InputMaybe<Input_Core_LocalDateMsg>;
  time?: InputMaybe<Input_Core_LocalTimeMsg>;
};

export type Input_Core_LocalOrOffsetDateMsg = {
  localDate?: InputMaybe<Input_Core_LocalDateMsg>;
  offsetDate?: InputMaybe<Input_Core_OffsetDateMsg>;
};

export type Input_Core_LocalOrOffsetDateTimeMsg = {
  localDateTime?: InputMaybe<Input_Core_LocalDateTimeMsg>;
  offsetDateTime?: InputMaybe<Input_Core_OffsetDateTimeMsg>;
};

export type Input_Core_LocalTimeMsg = {
  hour?: InputMaybe<Scalars['Int']>;
  minute?: InputMaybe<Scalars['Int']>;
  nano?: InputMaybe<Scalars['Int']>;
  second?: InputMaybe<Scalars['Int']>;
};

export type Input_Core_LocalizedStringMsg = {
  id?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<InputMaybe<Input_Core_TranslationMsg>>>;
};

export type Input_Core_MergePatientsFailure = {
  errorMessage?: InputMaybe<Scalars['String']>;
  failedService?: InputMaybe<Core_MergePatientsService>;
};

export type Input_Core_MergePatientsRequest = {
  patientIdToBeMergedInto?: InputMaybe<Scalars['String']>;
  patientIdsToBeMerged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Core_MergePatientsResponse = {
  failures?: InputMaybe<Array<InputMaybe<Input_Core_MergePatientsFailure>>>;
  result?: InputMaybe<Core_MergePatientsResult>;
};

export type Input_Core_OffsetDateMsg = {
  date?: InputMaybe<Input_Core_LocalDateMsg>;
  offsetSeconds?: InputMaybe<Scalars['Int']>;
};

export type Input_Core_OffsetDateTimeMsg = {
  dateTime?: InputMaybe<Input_Core_LocalDateTimeMsg>;
  offsetSeconds?: InputMaybe<Scalars['Int']>;
};

export type Input_Core_PatchUpdateTreeNodeMsg = {
  children?: InputMaybe<Array<InputMaybe<Input_Core_PatchUpdateTreeNodeMsg>>>;
  index?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Core_PatchUpdateTreeRootMsg = {
  nodes?: InputMaybe<Array<InputMaybe<Input_Core_PatchUpdateTreeNodeMsg>>>;
};

export type Input_Core_PersonReferenceMsg = {
  /** TODO: remove */
  id?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_PersonReferenceType>;
};

export type Input_Core_PhoneNumberMsg = {
  countryCode?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Long']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Core_PhoneNumberType>;
};

export type Input_Core_ProcedureCodeMsg = {
  externalId?: InputMaybe<Input_Core_ExternalProcedureCodeIdMsg>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Core_RequirementTemplateAssigneeMsg = {
  id?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  userGroup?: InputMaybe<Input_Core_RoleBasedUserGroupMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Core_RequirementTemplateList = {
  templates?: InputMaybe<Array<InputMaybe<Input_Core_RequirementTemplateMsg>>>;
};

export type Input_Core_RequirementTemplateMsg = {
  assignees?: InputMaybe<Array<InputMaybe<Input_Core_RequirementTemplateAssigneeMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** What kind of object the requirement template is for */
  target?: InputMaybe<Core_RequirementTemplateTarget>;
};

export type Input_Core_RoleBasedUserGroupMsg = {
  numberOfUsers?: InputMaybe<Scalars['Int']>;
  roleType?: InputMaybe<Core_RoleType>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Core_ScopedRoleTypeMsg = {
  roleType?: InputMaybe<Core_RoleType>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Core_ScopedRoleTypeTemplateMsg = {
  roleType?: InputMaybe<Core_RoleType>;
  scopeType?: InputMaybe<Core_AdministrativeUnitType>;
};

export type Input_Core_ServiceProviderReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_ServiceProviderType>;
};

export type Input_Core_SimpleInternalOrPortalUnitList = {
  internalOrPortalUnits?: InputMaybe<Array<InputMaybe<Input_Core_SimpleInternalOrPortalUnitMsg>>>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of external clinics and departments in the patient portal
 * and administrative units in the clinic side.
 */
export type Input_Core_SimpleInternalOrPortalUnitMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_InternalOrPortalUnitType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of portal and professional portal users in the patient portal
 * and normal users in the clinic side.
 */
export type Input_Core_SimpleUserMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Core_StorageLocationMsg = {
  address?: InputMaybe<Input_Core_AddressMsg>;
  storageLocationDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Core_TimeFrameOfDayMsg = {
  end?: InputMaybe<Input_TimeOfDayMsg>;
  start?: InputMaybe<Input_TimeOfDayMsg>;
};

export type Input_Core_TranslationMsg = {
  /** ISO 639-3 coded */
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Core_UpdateAcknowledgementRequest = {
  acknowledgement?: InputMaybe<Input_Core_AcknowledgementMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Core_UserIdListMsg = {
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Core_UserReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_UserType>;
};

export type Input_Core_YearMonthMsg = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Input_Device_AppDetailsMsg = {
  /** Users the app is assigned to */
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the app */
  id?: InputMaybe<Scalars['String']>;
  /** VeiosUsers that manage the app */
  keyUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of the app */
  name?: InputMaybe<Scalars['String']>;
  /** Rooms in which the app is being used */
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** AdministrativeUnitIds that have access to the app */
  scope?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** Current status of the app */
  status?: InputMaybe<Device_AppStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Device_ListAppConfigsRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Device_ListAppsRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_ClaimPortalUserFormDocumentsRequest = {
  formId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_ClaimPortalUserFormDocumentsResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Document_ConfirmDocumentsRequest = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Document_ConfirmDocumentsResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentMsg>>>;
};

export type Input_Document_CreateDocumentRequest = {
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: InputMaybe<Scalars['Boolean']>;
  document?: InputMaybe<Input_Document_DocumentMsg>;
};

export type Input_Document_CreateOrUpdateDocumentRequest = {
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: InputMaybe<Scalars['Boolean']>;
  document?: InputMaybe<Input_Document_DocumentMsg>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_CreateOrUpdateDocumentsRequest = {
  requests?: InputMaybe<Array<InputMaybe<Input_Document_CreateOrUpdateDocumentRequest>>>;
};

export type Input_Document_CreateOrUpdateDocumentsResponse = {
  documentToLetterIds?: InputMaybe<Array<InputMaybe<Input_Document_DocumentToLetterIdMsg>>>;
};

export type Input_Document_DeleteDocumentRequest = {
  documentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DeleteDocumentResponse = {
  deletedDocumentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DeleteDocumentsRequest = {
  externalDocumentId?: InputMaybe<Input_Document_ExternalDocumentIdMsg>;
};

export type Input_Document_DeleteDocumentsResponse = {
  deletedDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Document_DocumentBasicInfoList = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentBasicInfoMsg>>>;
};

export type Input_Document_DocumentBasicInfoMsg = {
  activationStatus?: InputMaybe<Document_DocumentActivationStatus>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  /** Official date of document */
  documentDate?: InputMaybe<Input_Timestamp>;
  format?: InputMaybe<Document_DocumentFormat>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Document_DocumentType>;
  url?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentIdentifiersMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Document_ExternalDocumentIdMsg>>>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentInfo = {
  document?: InputMaybe<Input_Document_DocumentMsg>;
  ref?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentLinkMsg = {
  /** Id of external entity linking to the document */
  linkId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Document_DocumentLinkType>;
};

export type Input_Document_DocumentList = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentMsg = {
  acknowledgements?: InputMaybe<Array<InputMaybe<Input_Core_AcknowledgementMsg>>>;
  activationStatus?: InputMaybe<Document_DocumentActivationStatus>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  creatorUserId?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['String']>;
  documentClass?: InputMaybe<Input_Document_DocumentTypeMsg>;
  /** Official date of document */
  documentDate?: InputMaybe<Input_Timestamp>;
  /** Entities associated with document */
  documentLinks?: InputMaybe<Array<InputMaybe<Input_Document_DocumentLinkMsg>>>;
  /** True if the document was not originally created from within our system */
  external?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Document_ExternalDocumentIdMsg>>>;
  externalUrl?: InputMaybe<Scalars['String']>;
  externalViewerId?: InputMaybe<Scalars['String']>;
  findingActions?: InputMaybe<Array<InputMaybe<Input_Core_ClinicalFindingActionMsg>>>;
  format?: InputMaybe<Document_DocumentFormat>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  latestUpdaterUserId?: InputMaybe<Scalars['String']>;
  /** used by frontend to choose appropriate preview */
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** If the document originated from within the system, links to the origin */
  origin?: InputMaybe<Input_Document_DocumentOriginMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  /** a patient linked to this document by their portal-user id */
  portalUserId?: InputMaybe<Scalars['String']>;
  releasedToPortal?: InputMaybe<Scalars['Boolean']>;
  /** References to recipient administrative units */
  targetUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Document_DocumentType>;
  /** OrganizationalUnitId of creating department */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  url?: InputMaybe<Scalars['String']>;
  /** Date of related visit */
  visitDate?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentOriginMsg = {
  originId?: InputMaybe<Scalars['String']>;
  originType?: InputMaybe<Document_DocumentOriginType>;
};

export type Input_Document_DocumentToLetterIdMsg = {
  documentId?: InputMaybe<Scalars['String']>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentTypeExternalIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Document_DocumentTypeExternalIdType>;
};

export type Input_Document_DocumentTypeList = {
  documentTypes?: InputMaybe<Array<InputMaybe<Input_Document_DocumentTypeMsg>>>;
};

export type Input_Document_DocumentTypeMsg = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Document_DocumentTypeExternalIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DocumentVersionList = {
  documentGroupId?: InputMaybe<Scalars['String']>;
  documentVersions?: InputMaybe<Array<InputMaybe<Input_Document_DocumentBasicInfoMsg>>>;
};

export type Input_Document_DownloadDocumentRequest = {
  /** download latest version */
  documentGroupId?: InputMaybe<Scalars['String']>;
  /** download specific version */
  documentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_DownloadDocumentResponse = {
  chunk?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Document_DocumentMsg>;
};

export type Input_Document_ExternalDocumentIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Document_ExternalDocumentIdType>;
};

export type Input_Document_ExternalizeDocumentsRequest = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set to true, push the documents that are already set to external */
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Document_ExternalizeDocumentsResponse = {
  alreadyExternalDocumentsCount?: InputMaybe<Scalars['Int']>;
  externalizedDocumentsCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Document_FindDocumentIdentifiersRequest = {
  externalDocumentId?: InputMaybe<Input_Document_ExternalDocumentIdMsg>;
};

export type Input_Document_FindDocumentIdentifiersResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  identifiers?: InputMaybe<Input_Document_DocumentIdentifiersMsg>;
};

export type Input_Document_GetDocumentFindingActionHistoryRequest = {
  documentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_GetDocumentRequest = {
  documentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_GetDocumentsRequest = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Document_HandlePortalReleaseRequest = {
  documentId?: InputMaybe<Scalars['String']>;
  released?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Document_HandlePortalReleaseResponse = {
  document?: InputMaybe<Input_Document_DocumentBasicInfoMsg>;
  releaseId?: InputMaybe<Scalars['String']>;
  released?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Document_LinkOrCreateExternalDocumentRequest = {
  document?: InputMaybe<Input_Document_DocumentMsg>;
  possibleDocumentGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_LinkOrCreateExternalDocumentResponse = {
  document?: InputMaybe<Input_Document_DocumentMsg>;
};

export type Input_Document_ListDocumentVersionsRequest = {
  documentGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Document_ListDocumentVersionsResponse = {
  documentVersions?: InputMaybe<Array<InputMaybe<Input_Document_DocumentVersionList>>>;
};

export type Input_Document_ListDocumentsRequest = {
  origins?: InputMaybe<Array<InputMaybe<Input_Document_DocumentOriginMsg>>>;
};

export type Input_Document_ListDocumentsResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentBasicInfoMsg>>>;
};

export type Input_Document_ListPatientDocumentsRequest = {
  activationStatuses?: InputMaybe<Array<InputMaybe<Document_DocumentActivationStatus>>>;
  documentDateSortOrder?: InputMaybe<Helper_SortOrder>;
  patientId?: InputMaybe<Scalars['String']>;
  /** Optional filter */
  types?: InputMaybe<Array<InputMaybe<Document_DocumentType>>>;
};

export type Input_Document_LoadPatientDocumentsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_LoadPatientDocumentsResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentInfo>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_PortalReleaseMsg = {
  documentGroupId?: InputMaybe<Scalars['String']>;
  released?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_SearchDocumentFullTextsRequest = {
  /** optional: set if only documents of a specific patient should be searched */
  patientId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Optional filter */
  types?: InputMaybe<Array<InputMaybe<Document_DocumentType>>>;
};

export type Input_Document_SearchDocumentsRequest = {
  /** mandatory */
  patientId?: InputMaybe<Scalars['String']>;
  /**
   * at least one of the search term and types must be provided
   *  optional
   */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** optional filter */
  types?: InputMaybe<Array<InputMaybe<Document_DocumentType>>>;
};

export type Input_Document_UpdateDocumentRequest = {
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: InputMaybe<Scalars['Boolean']>;
  document?: InputMaybe<Input_Document_DocumentMsg>;
};

export type Input_Document_UpdateExternalDocumentIdsRequest = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Document_ExternalDocumentIdMsg>>>;
  /** groupId of the Document */
  groupId?: InputMaybe<Scalars['String']>;
  /**
   * If set to true, the provided externalIds are set for all documents in the given group;
   *  if not set to true, the externalIds are only set for the latest document version in the group
   */
  updateAllGroupDocuments?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Document_UpdateMetadataRequest = {
  document?: InputMaybe<Input_Document_DocumentMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Document_Transfer_ClinicalRequestIdentifier = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_DeleteAllResourcesRequest = {
  clinicalRequestIdentifier?: InputMaybe<Input_Document_Transfer_ClinicalRequestIdentifier>;
};

export type Input_Document_Transfer_DeleteAllResourcesResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_DeleteResourceRequest = {
  clinicalRequestIdentifier?: InputMaybe<Input_Document_Transfer_ClinicalRequestIdentifier>;
  resourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_DeleteResourceResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_DocumentMetadataMsg = {
  appointmentTaskId?: InputMaybe<Scalars['String']>;
  clinicalRequestIdentifier?: InputMaybe<Input_Document_Transfer_ClinicalRequestIdentifier>;
  documentClass?: InputMaybe<Input_Document_DocumentTypeMsg>;
  documentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  originalFileName?: InputMaybe<Scalars['String']>;
  releasedToPortal?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Input_Timestamp>;
};

export type Input_Document_Transfer_DownloadDocumentRequest = {
  clinicalRequestIdentifier?: InputMaybe<Input_Document_Transfer_ClinicalRequestIdentifier>;
  documentId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  static?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Document_Transfer_DownloadDocumentResponse = {
  chunk?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Document_Transfer_DocumentMetadataMsg>;
};

export type Input_Document_Transfer_GetDocumentMetadataRequest = {
  documentGroupId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  staticDocumentGroupId?: InputMaybe<Scalars['String']>;
  staticDocumentId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_GetDocumentMetadataResponse = {
  document?: InputMaybe<Input_Document_Transfer_DocumentMetadataMsg>;
};

export type Input_Document_Transfer_ListPortalUserDocumentsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Document_Transfer_ListPortalUserDocumentsResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_Transfer_DocumentMetadataMsg>>>;
};

export type Input_Document_Transfer_UploadDocumentRequest = {
  chunk?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Document_Transfer_DocumentMetadataMsg>;
};

export type Input_Document_Transfer_UploadDocumentResponse = {
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_ActiveIngredientMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Drug_ExternalActiveIngredientIdMsg>>>;
  lowerStrengthValue?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  strengthUnit?: InputMaybe<Input_Drug_ActiveIngredientStrengthUnitMsg>;
  type?: InputMaybe<Drug_ActiveIngredientType>;
  upperStrengthValue?: InputMaybe<Scalars['Float']>;
};

export type Input_Drug_ActiveIngredientStrengthUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Drug_ExternalActiveIngredientStrengthUnitIdMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_AtcCodeMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_DrugDataVersionMsg = {
  /** Date when the data was imported */
  importDate?: InputMaybe<Input_Timestamp>;
  /** Date when the source data was provided */
  sourceDataDate?: InputMaybe<Input_Timestamp>;
  sourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  versionTitle?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_DrugDosageUnitsEntryMsg = {
  dosageUnits?: InputMaybe<Array<InputMaybe<Input_Knowledge_MedicationDosageUnitResult>>>;
  drugIdentifier?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_DrugFormMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Drug_ExternalDrugFormIdMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_DrugIdentifierMsg = {
  integerId?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_DrugInformationMsg = {
  /** The content of the information */
  contentHtml?: InputMaybe<Scalars['String']>;
  /** The content might be provided in e.g., pdf format, in which case this references that document */
  contentStaticDocumentId?: InputMaybe<Scalars['String']>;
  /** Only relevant if set; date until this information is valid */
  expirationDate?: InputMaybe<Input_Timestamp>;
  /** optional; set if the content has a separate title. Set for type GERMAN_OFFICIAL_PRODUCT_CHARACTERISTICS */
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_DrugInformationType>;
  /** Only relevant if set; date from which this information is valid */
  validityStartDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Drug_DrugInstanceMsg = {
  /**
   * If type is REFERENCE, this is the resolved drug and immutable.
   *  If type is EMBEDDED, the drug in this field is the embedded drug and potentially mutable.
   */
  drug?: InputMaybe<Input_Drug_DrugMsg>;
  /** only set if type is REFERENCE */
  reference?: InputMaybe<Input_Drug_DrugReferenceMsg>;
  type?: InputMaybe<Drug_DrugInstanceType>;
};

export type Input_Drug_DrugLinkMsg = {
  drug?: InputMaybe<Input_Drug_DrugMsg>;
  reference?: InputMaybe<Input_Drug_DrugReferenceMsg>;
};

export type Input_Drug_DrugMsg = {
  activeIngredients?: InputMaybe<Array<InputMaybe<Input_Drug_ActiveIngredientMsg>>>;
  allowedIntakeMechanisms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  allowedIntakeTypes?: InputMaybe<Array<InputMaybe<Input_Knowledge_IntakeTypeMsg>>>;
  atcCodes?: InputMaybe<Array<InputMaybe<Input_Drug_AtcCodeMsg>>>;
  /** Should appear as an option by default as a reconstitution and dilution solution. */
  defaultSolution?: InputMaybe<Scalars['Boolean']>;
  dilutionOptions?: InputMaybe<Array<InputMaybe<Input_Drug_MedicationComponentMsg>>>;
  /** Anzeigename. Note: this is explicitly separate from the synonyms */
  displayName?: InputMaybe<Scalars['String']>;
  divisibility?: InputMaybe<Drug_DrugDivisibility>;
  dosageUnit?: InputMaybe<Input_Medication_MedicationDosageUnitMsg>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Drug_ExternalDrugIdMsg>>>;
  /** flags, informationTexts, purposes aren't set for the custom drugs. */
  flags?: InputMaybe<Array<InputMaybe<Drug_DrugFlag>>>;
  form?: InputMaybe<Input_Drug_DrugFormMsg>;
  germanBillingProperties?: InputMaybe<Input_Drug_GermanBillingPropertiesMsg>;
  /** Eigenanfertigung */
  inHouseProduction?: InputMaybe<Scalars['Boolean']>;
  informationTexts?: InputMaybe<Array<InputMaybe<Input_Drug_DrugInformationMsg>>>;
  isInFormulary?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Hinweise der Apotheke */
  pharmacyNotes?: InputMaybe<Scalars['String']>;
  purposes?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPurposeMsg>>>;
  reconstitutionOptions?: InputMaybe<Array<InputMaybe<Input_Drug_MedicationComponentMsg>>>;
  requireDilution?: InputMaybe<Scalars['Boolean']>;
  /** Rekonstitution */
  requireReconstitution?: InputMaybe<Scalars['Boolean']>;
  /** Lieferant */
  supplier?: InputMaybe<Scalars['String']>;
  synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Drug_DrugPackageBenefitAssessmentMsg = {
  contentHtml?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** German "Beschluss zur Nutzenbewertung nach § 35a SGB V (AM-RL Anlage XII)" */
export type Input_Drug_DrugPackageBenefitResolutionMsg = {
  /** Benefit assessments, in Germany for specific patient groups */
  benefitAssessments?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageBenefitAssessmentMsg>>>;
  contentHtml?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_DrugPackageDiscountMsg = {
  /** Discount in price unit */
  absoluteDiscount?: InputMaybe<Scalars['Float']>;
  /** Which of the prices is discounted */
  discountedPriceType?: InputMaybe<Drug_DrugPackagePriceType>;
  /** Discount in % */
  relativeDiscount?: InputMaybe<Scalars['Float']>;
};

export type Input_Drug_DrugPackageIdentifierMsg = {
  integerId?: InputMaybe<Scalars['Int']>;
};

/** In which context the drug package information applies, e.g. for which diseases certain hints must be considered */
export type Input_Drug_DrugPackageInformationContextMsg = {
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_DrugPackageInformationContextType>;
};

export type Input_Drug_DrugPackageInformationMsg = {
  /** Content of the information, often in html format */
  content?: InputMaybe<Scalars['String']>;
  /** Only relevant if set; date when this information was created, can differ from validity */
  creationDate?: InputMaybe<Input_Timestamp>;
  /** Only relevant if set; date until this information is valid */
  expirationDate?: InputMaybe<Input_Timestamp>;
  /** optional title */
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_DrugPackageInformationType>;
  /** Only relevant if set; date from which this information is valid */
  validityStartDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Drug_DrugPackageList = {
  drugPackages?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageMsg>>>;
};

/**
 * A specific package that contains the given drug.
 *  An example would be "Drug X, 50 pills", where "50 pills" is the additional information provided by the package.
 */
export type Input_Drug_DrugPackageMsg = {
  benefitResolutions?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageBenefitResolutionMsg>>>;
  discounts?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageDiscountMsg>>>;
  drug?: InputMaybe<Input_Drug_DrugMsg>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Drug_ExternalDrugPackageIdMsg>>>;
  /** Additional characteristics of the package */
  flags?: InputMaybe<Array<InputMaybe<Drug_DrugPackageFlag>>>;
  /** only set if internal drug package (e.g., in-house medication list) */
  id?: InputMaybe<Scalars['String']>;
  informationTexts?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageInformationMsg>>>;
  packageName?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<Scalars['String']>;
  packageSizeUnit?: InputMaybe<Scalars['String']>;
  /** priceHistory contains last three selling price changes and it's ordered by validFrom descending */
  priceHistory?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackagePriceHistoryMsg>>>;
  prices?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackagePriceMsg>>>;
  sizeType?: InputMaybe<Drug_DrugPackageSizeType>;
  source?: InputMaybe<Drug_DrugPackageSource>;
};

export type Input_Drug_DrugPackagePriceHistoryMsg = {
  price?: InputMaybe<Scalars['Float']>;
  validFrom?: InputMaybe<Input_Timestamp>;
};

export type Input_Drug_DrugPackagePriceMsg = {
  price?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Drug_DrugPackagePriceType>;
};

/** What this drug is used for, e.g. against which disease */
export type Input_Drug_DrugPurposeMsg = {
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_DrugPurposeType>;
};

export type Input_Drug_DrugReferenceMsg = {
  identifier?: InputMaybe<Scalars['String']>;
  overrideEntryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Drug_DrugReferenceType>;
};

export type Input_Drug_DrugSearchResultMsg = {
  drug?: InputMaybe<Input_Drug_DrugMsg>;
  reference?: InputMaybe<Input_Drug_DrugReferenceMsg>;
};

export type Input_Drug_ExternalActiveIngredientIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalActiveIngredientIdType>;
};

export type Input_Drug_ExternalActiveIngredientStrengthUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalActiveIngredientStrengthUnitIdType>;
};

export type Input_Drug_ExternalDrugFormIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalDrugFormIdType>;
};

export type Input_Drug_ExternalDrugIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalDrugIdType>;
};

export type Input_Drug_ExternalDrugPackageIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDrugPackageIdType>;
};

/** by default, output list is sorted ascending by selling price */
export type Input_Drug_FindDrugPackageReplacementSuggestionsRequest = {
  /** mandatory */
  drugPackageIdentifier?: InputMaybe<Input_Drug_DrugPackageIdentifierMsg>;
  /**
   * optional filter
   *  For Germans: IKNR
   */
  externalInsurerId?: InputMaybe<Scalars['String']>;
  /** German KVID, shouldn't be set if BSNR known */
  externalInsurerNetworkId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: InputMaybe<Scalars['String']>;
  /** German LANR, used to filter/fetch results that depend on this */
  externalUserId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: InputMaybe<Input_Timestamp>;
  /** mandatory */
  suggestionType?: InputMaybe<Drug_DrugReplacementSuggestionType>;
};

export type Input_Drug_FindDrugPackagesByPznRequest = {
  pzn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Drug_FindDrugPackagesByPznResponse = {
  pznToDrugPackage?: InputMaybe<Array<InputMaybe<Input_Drug_FindDrugPackagesByPznResponse_PznToDrugPackageEntry>>>;
};

export type Input_Drug_FindDrugPackagesByPznResponse_PznToDrugPackageEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Drug_PznToDrugPackageMapEntry>;
};

export type Input_Drug_FindDrugRequest = {
  includeInformationTexts?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Input_Drug_DrugReferenceMsg>;
};

export type Input_Drug_FindDrugResponse = {
  drugLink?: InputMaybe<Input_Drug_DrugLinkMsg>;
};

export type Input_Drug_FindDrugsByExternalDrugPackageIdsRequest = {
  externalIdType?: InputMaybe<Knowledge_ExternalDrugPackageIdType>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Drug_FindDrugsByExternalDrugPackageIdsResponse = {
  externalIdToDrugReference?: InputMaybe<Array<InputMaybe<Input_Drug_FindDrugsByExternalDrugPackageIdsResponse_ExternalIdToDrugReferenceEntry>>>;
};

export type Input_Drug_FindDrugsByExternalDrugPackageIdsResponse_ExternalIdToDrugReferenceEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Drug_DrugReferenceMsg>;
};

export type Input_Drug_FindDrugsRequest = {
  references?: InputMaybe<Array<InputMaybe<Input_Drug_DrugReferenceMsg>>>;
};

export type Input_Drug_FindDrugsResponse = {
  drugLinks?: InputMaybe<Array<InputMaybe<Input_Drug_DrugLinkMsg>>>;
};

/** by default, output list is sorted ascending by selling price */
export type Input_Drug_FindSimilarDrugPackagesRequest = {
  /** mandatory */
  drugPackageIdentifier?: InputMaybe<Input_Drug_DrugPackageIdentifierMsg>;
  /** For Germans: IKNR; required if onlyDiscounted == true */
  externalInsurerId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  /** optional filter */
  onlyDiscounted?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Drug_GermanBillingPropertiesMsg = {
  /** ZE Nummer */
  additionalReimbursementCode?: InputMaybe<Scalars['String']>;
  /** ZE Hinweis */
  additionalReimbursementNotes?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Drug_GermanMedicationBillingTag>>>;
};

export type Input_Drug_GetDrugDataVersionRequest = {
  sourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
};

export type Input_Drug_GetDrugDataVersionResponse = {
  version?: InputMaybe<Input_Drug_DrugDataVersionMsg>;
};

export type Input_Drug_GetDrugPackageRequest = {
  drugPackageIdentifier?: InputMaybe<Input_Drug_DrugPackageIdentifierMsg>;
  /** For Germans: IKNR */
  externalInsurerId?: InputMaybe<Scalars['String']>;
  /** German KVID, shouldn't be set if BSNR known */
  externalInsurerNetworkId?: InputMaybe<Scalars['String']>;
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: InputMaybe<Scalars['String']>;
  /** German LANR */
  externalUserId?: InputMaybe<Scalars['String']>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Drug_GetDrugsDosageUnitsRequest = {
  dataset?: InputMaybe<Drug_DrugDosageUnitDataset>;
  drugIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Drug_GetDrugsDosageUnitsResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Drug_DrugDosageUnitsEntryMsg>>>;
};

export type Input_Drug_Icd10CodeMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_ImportCustomDrugPackageRequest = {
  drugPackage?: InputMaybe<Input_Drug_DrugPackageMsg>;
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
};

export type Input_Drug_MedicationComponentMsg = {
  /** if a medication consists of multiple components, their composition is specified via this field */
  compositionInfo?: InputMaybe<Input_Drug_MedicationCompositionInfoMsg>;
  drugInstance?: InputMaybe<Input_Drug_DrugInstanceMsg>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_MedicationComponentType>;
};

export type Input_Drug_MedicationComponentUnitTargetMsg = {
  targetActiveIngredientId?: InputMaybe<Scalars['String']>;
  targetComponent?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Drug_MedicationComponentUnitTargetType>;
};

export type Input_Drug_MedicationCompositionDosageUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Medication_ExternalMedicationDosageUnitIdMsg>>>;
  target?: InputMaybe<Input_Drug_MedicationComponentUnitTargetMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Drug_MedicationCompositionInfoMsg = {
  dosageUnit?: InputMaybe<Input_Drug_MedicationCompositionDosageUnitMsg>;
  dosageValue?: InputMaybe<Input_Medication_MedicationDosageValueMsg>;
};

export type Input_Drug_PznToDrugPackageMapEntry = {
  drugPackage?: InputMaybe<Input_Drug_DrugPackageMsg>;
  roaCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Drug_SearchActiveIngredientStrengthUnitsRequest = {
  dataset?: InputMaybe<Drug_ActiveIngredientStrengthUnitDataset>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Drug_SearchActiveIngredientStrengthUnitsResponse = {
  activeIngredientStrengthUnits?: InputMaybe<Array<InputMaybe<Input_Drug_ActiveIngredientStrengthUnitMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchActiveIngredientsRequest = {
  dataset?: InputMaybe<Drug_ActiveIngredientDataset>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Drug_SearchActiveIngredientsResponse = {
  activeIngredients?: InputMaybe<Array<InputMaybe<Input_Drug_ActiveIngredientMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchAtcCodesRequest = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
};

export type Input_Drug_SearchAtcCodesResponse = {
  atcCodes?: InputMaybe<Array<InputMaybe<Input_Drug_AtcCodeMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchDrugFormsRequest = {
  dataset?: InputMaybe<Drug_DrugFormDataset>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Drug_SearchDrugFormsResponse = {
  drugForms?: InputMaybe<Array<InputMaybe<Input_Drug_DrugFormMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchDrugInformationTextsRequest = {
  /** mandatory; currently only supports EXTERNAL_DRUG_SOURCE_TYPE_MMI */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  /** mandatory; currently only supports DRUG_INFORMATION_TYPE_GERMAN_RED_HAND, DRUG_INFORMATION_TYPE_GERMAN_BLUE_HAND */
  informationType?: InputMaybe<Drug_DrugInformationType>;
  /** mandatory */
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
  /** Optional full-text search filter */
  titleSearchText?: InputMaybe<Scalars['String']>;
  /** Optional filter; also possible to only set one of start/end */
  validityEndTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** Optional filter; also possible to only set one of start/end */
  validityStartTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Drug_SearchDrugInformationTextsResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  informationTexts?: InputMaybe<Array<InputMaybe<Input_Drug_DrugInformationMsg>>>;
};

export type Input_Drug_SearchDrugPackagesRequest = {
  /** optional sort */
  activeIngredientStrengthSort?: InputMaybe<Helper_SortOrder>;
  /**
   * If true, results are returned if they contain any of the includedAtcCodes; if false, only if they contain all.
   *  Ignored if exactIncludedAtcCodes is set
   */
  anyIncludedAtcCode?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  containsGermanAmnogFlag?: InputMaybe<Scalars['Boolean']>;
  containsGermanClinicPackageFlag?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  containsRegistrationNumber?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  drugIdentifier?: InputMaybe<Input_Drug_DrugIdentifierMsg>;
  /** If set to true, only return results that have exactly these includedActiveIngredientNames, no other active ingredients */
  exactIncludedActiveIngredientNames?: InputMaybe<Scalars['Boolean']>;
  /** If set to true, only returns results that have exactly these atc codes, no other codes */
  exactIncludedAtcCodes?: InputMaybe<Scalars['Boolean']>;
  /** optional filter: If set, only results that don't match any of the intake forms are returned */
  excludedIntakeFormIfaCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * optional filter
   *  For Germans: IKNR
   */
  externalInsurerId?: InputMaybe<Scalars['String']>;
  /** German KVID, shouldn't be set if BSNR known */
  externalInsurerNetworkId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: InputMaybe<Scalars['String']>;
  /** German LANR */
  externalUserId?: InputMaybe<Scalars['String']>;
  /** Results are returned if their components include all of the icd10 codes */
  icd10Codes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional filter */
  includeGermanDoctorSamples?: InputMaybe<Scalars['Boolean']>;
  /** Results are returned if their components include all of the active ingredient names */
  includedActiveIngredientNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Results are returned if their components include the atc codes */
  includedAtcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional filter: If set, only results that match any of the intake forms are returned */
  includedIntakeFormIfaCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional filter */
  onlyDiscounted?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: InputMaybe<Input_Timestamp>;
  /** optional sort */
  patientPaymentSort?: InputMaybe<Helper_SortOrder>;
  /** optional filter: If true, only returns prescription exclusive drugs, if false, only those that are not prescription exclusive */
  prescriptionExclusive?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  searchField?: InputMaybe<Drug_DrugPackageSearchField>;
  /** optional sort */
  sellingPriceSort?: InputMaybe<Helper_SortOrder>;
  /** optional filter */
  sizeType?: InputMaybe<Drug_DrugPackageSizeType>;
  /** optional filter */
  vaccineFlag?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Drug_SearchDrugPackagesResponse = {
  drugPackages?: InputMaybe<Array<InputMaybe<Input_Drug_DrugPackageMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchDrugSubstitutionsRequest = {
  /** The administrative units of which the drug catalogs are used. If not set, the current administrative units of the user are used. */
  catalogAdministrativeUnits?: InputMaybe<Input_Core_AdministrativeUnitMappingMsg>;
  /** the drug in the specified drug instance should only be filled if type is EMBEDDED */
  drugInstance?: InputMaybe<Input_Drug_DrugInstanceMsg>;
  /** by default call searches the substitutions in the formulary so set notOnlyFormulary to true to get the all results */
  notOnlyFormulary?: InputMaybe<Scalars['Boolean']>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Drug_SearchDrugSubstitutionsResponse = {
  drugs?: InputMaybe<Array<InputMaybe<Input_Drug_DrugSearchResultMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchDrugsRequest = {
  /** The administrative units of which the drug catalogs are used. If not set, the current administrative units of the user are used. */
  catalogAdministrativeUnits?: InputMaybe<Input_Core_AdministrativeUnitMappingMsg>;
  isInFormulary?: InputMaybe<Scalars['Boolean']>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Drug_SearchDrugsResponse = {
  drugs?: InputMaybe<Array<InputMaybe<Input_Drug_DrugSearchResultMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Drug_SearchIcd10CodesRequest = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: InputMaybe<Drug_ExternalDrugSourceType>;
  paginationSettings?: InputMaybe<Input_Helper_PaginationSettingsMsg>;
};

export type Input_Drug_SearchIcd10CodesResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  icd10Codes?: InputMaybe<Array<InputMaybe<Input_Drug_Icd10CodeMsg>>>;
};

export type Input_Email_SendAppointmentCancellationEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentConfirmationEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentRebookingEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentRejectionEmailRequest = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentReminderEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentRequestCancellationEmailRequest = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentRequestSubmissionEmailRequest = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentSelectionEmailRequest = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendAppointmentUpdateEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendClinicalRequestCompletionEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendClinicalRequestNewAttachmentEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendClinicalRequestNewCommentEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendClinicalRequestNewReportEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendClinicalRequestRejectionEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendClinicalRequestSubmissionEmailRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendDocumentAddedToThePortalEmailRequest = {
  documentId?: InputMaybe<Scalars['String']>;
  documentName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
  portalFacilityPath?: InputMaybe<Input_Patientportal_PortalFacilityPathMsg>;
  portalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  professionalPortalUserName?: InputMaybe<Input_Core_HumanNameMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
};

export type Input_Email_SendUnverifiedUserAppointmentCancellationEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendUnverifiedUserAppointmentConfirmationEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendUnverifiedUserAppointmentReminderEmailRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  confirmationProviderSelfInfo?: InputMaybe<Input_Patientportal_ConfirmationProviderSelfInfoMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendUnverifiedUserAppointmentRequestSubmissionEmailRequest = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  language?: InputMaybe<Core_Language>;
  patientId?: InputMaybe<Scalars['String']>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Email_SendValidationEmailRequest = {
  confirmationProviderSelfInfo?: InputMaybe<Input_Patientportal_ConfirmationProviderSelfInfoMsg>;
  emailType?: InputMaybe<Email_EmailType>;
  language?: InputMaybe<Core_Language>;
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  targetEmailAddress?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_External_Data_ExternalDataOriginReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<External_Data_ExternalDataOriginType>;
};

export type Input_Form_AddressFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_AddressFormValueMsg = {
  addressValue?: InputMaybe<Input_Core_AddressMsg>;
};

export type Input_Form_AllergyFormQuestionMsg = {
  importScope?: InputMaybe<Form_AllergyFormQuestionImportScope>;
};

export type Input_Form_AllergyFormValueMsg = {
  value?: InputMaybe<Input_Treatment_AllergenMsg>;
};

export type Input_Form_AnswerFormQuestionRequest = {
  answer?: InputMaybe<Input_Form_FormAnswerMsg>;
  answerGroupId?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_AnswerFormQuestionResponse = {
  answer?: InputMaybe<Input_Form_FormAnswerMsg>;
  answerGroup?: InputMaybe<Input_Form_FormAnswerGroupMsg>;
  changedAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  /**
   * When a question has been answered on a signed form, all the signatures are reset.
   * This field is added to avoid fetching for each answer request.
   * Only id and signatory request fields of the form message are filled.
   */
  form?: InputMaybe<Input_Form_FormMsg>;
};

export type Input_Form_AnswerFormSequenceQuestionRequest = {
  doAutoMoveToNext?: InputMaybe<Scalars['Boolean']>;
  sequenceAnswerId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Form_FormValueMsg>;
};

export type Input_Form_AnswerFormSequenceQuestionResponse = {
  /**
   * When a question has been answered on a signed form, all the signatures are reset.
   * This field is added to avoid fetching for each answer request.
   * Only id and signatory request fields of the form message are filled.
   */
  form?: InputMaybe<Input_Form_FormMsg>;
  nextQuestion?: InputMaybe<Input_Form_FormQuestionMsg>;
  nextSequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
  nextSequenceQuestion?: InputMaybe<Input_Form_FormSequenceQuestionMsg>;
  sequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
};

export type Input_Form_BooleanFormQuestionMsg = {
  longNoText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  longYesText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  nullable?: InputMaybe<Scalars['Boolean']>;
  shortNoText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  shortYesText?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_BooleanFormValueMsg = {
  value?: InputMaybe<Scalars['Boolean']>;
};

/**
 * This question allows the user to choose one of the AnswerGroups of a child QuestionGroup of the current QuestionGroup.
 *  (the target child QuestionGroup has to be specified via childQuestionGroupTargetId)
 */
export type Input_Form_ChildAnswerGroupSelectFormQuestionMsg = {
  childQuestionGroupTargetId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_ChildAnswerGroupSelectFormValueMsg = {
  childAnswerGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_ClaimPortalFormRequest = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_ClaimPortalFormResponse = {
  form?: InputMaybe<Input_Form_FormMsg>;
};

export type Input_Form_CreateFormAnswerGroupRequest = {
  directParentForm?: InputMaybe<Input_Form_FormElementLocationMsg>;
  parentAnswerGroup?: InputMaybe<Input_Form_FormElementLocationMsg>;
  questionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_CreateFormAnswerGroupResponse = {
  answerGroup?: InputMaybe<Input_Form_FormAnswerGroupMsg>;
  changedAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  parentInfo?: InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>;
};

export type Input_Form_CreateFormDatasetRequest = {
  initialName?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  withInitialOptionGroup?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_CreateFormDatasetResponse = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
  /** question-groups are not included */
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_CreateFormOptionGroupRequest = {
  datasetLocation?: InputMaybe<Input_Form_FormElementLocationMsg>;
};

export type Input_Form_CreateFormOptionGroupResponse = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
};

export type Input_Form_CreateFormOptionRequest = {
  optionGroupLocation?: InputMaybe<Input_Form_FormElementLocationMsg>;
};

export type Input_Form_CreateFormOptionResponse = {
  option?: InputMaybe<Input_Form_FormOptionMsg>;
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
};

export type Input_Form_CreateFormQuestionGroupRequest = {
  directParentTemplate?: InputMaybe<Input_Form_FormElementLocationMsg>;
  parentQuestionGroup?: InputMaybe<Input_Form_FormElementLocationMsg>;
};

export type Input_Form_CreateFormQuestionGroupResponse = {
  parentQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_CreateFormQuestionRequest = {
  controlFlowQuestionTemplateId?: InputMaybe<Scalars['String']>;
  questionGroup?: InputMaybe<Input_Form_FormElementLocationMsg>;
  type?: InputMaybe<Form_FormValueType>;
};

export type Input_Form_CreateFormQuestionResponse = {
  controlFlowTemplate?: InputMaybe<Input_Form_FormTemplateMsg>;
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
};

export type Input_Form_CreateFormRequest = {
  context?: InputMaybe<Input_Form_FormContextMsg>;
  inSequenceMode?: InputMaybe<Scalars['Boolean']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_CreateFormResponse = {
  createdByUserId?: InputMaybe<Scalars['String']>;
  form?: InputMaybe<Input_Form_FormMsg>;
  tags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Input_Form_CreateFormSignatureRequest = {
  assignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  formId?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_CreateFormSignaturesRequest = {
  formId?: InputMaybe<Scalars['String']>;
  requests?: InputMaybe<Array<InputMaybe<Input_Form_CreateFormSignatureRequest>>>;
};

export type Input_Form_CreateFormTemplateRequest = {
  initialLanguage?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
  withInitialQuestionGroup?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_CreateFormTemplateResponse = {
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
  /** includes only templates */
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_CreateFormTemplateVersioningGroupRequest = {
  initialName?: InputMaybe<Scalars['String']>;
  portalReadable?: InputMaybe<Scalars['Boolean']>;
  referenceId?: InputMaybe<Scalars['String']>;
  templateVersioningGroupTags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Input_Form_CreateFormTemplateVersioningGroupResponse = {
  /** includes only permissionScope */
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_CreateFormsRequest = {
  context?: InputMaybe<Input_Form_FormContextMsg>;
  entries?: InputMaybe<Array<InputMaybe<Input_Form_CreateFormsRequestEntryMsg>>>;
  inSequenceMode?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_CreateFormsRequestEntryMsg = {
  templateId?: InputMaybe<Scalars['String']>;
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_CreateFormsResponse = {
  createdByUserId?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Array<InputMaybe<Input_Form_CreateFormsResponseEntry>>>;
};

export type Input_Form_CreateFormsResponseEntry = {
  form?: InputMaybe<Input_Form_FormMsg>;
  tags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormAnswerGroupRequest = {
  answerGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormAnswerGroupResponse = {
  answerGroupId?: InputMaybe<Scalars['String']>;
  changedAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  parentInfo?: InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>;
};

export type Input_Form_DeleteFormDatasetRequest = {
  datasetId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormDatasetResponse = {
  datasetId?: InputMaybe<Scalars['String']>;
  /** question-groups are not included */
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_DeleteFormOptionGroupRequest = {
  optionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormOptionGroupResponse = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
  optionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormOptionRequest = {
  optionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormOptionResponse = {
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
  optionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormQuestionGroupRequest = {
  questionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormQuestionGroupResponse = {
  parentQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  questionGroupId?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_DeleteFormQuestionRequest = {
  questionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormQuestionResponse = {
  controlFlowTemplate?: InputMaybe<Input_Form_FormTemplateMsg>;
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  questionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormSignatureRequest = {
  formId?: InputMaybe<Scalars['String']>;
  signatureId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormSignaturesRequest = {
  formId?: InputMaybe<Scalars['String']>;
  signatureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_DeleteFormTemplateRequest = {
  templateId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormTemplateResponse = {
  templateId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormTemplateVersioningGroupRequest = {
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DeleteFormTemplateVersioningGroupResponse = {
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DiagnosisFormQuestionMsg = {
  importScope?: InputMaybe<Form_DiagnosisFormQuestionImportScope>;
  searchType?: InputMaybe<Form_DiagnosisSearchType>;
};

export type Input_Form_DiagnosisFormValueMsg = {
  value?: InputMaybe<Input_Treatment_DiagnosisDetailMsg>;
};

export type Input_Form_DischargeFormStatusUpdateResponse = {
  formId?: InputMaybe<Scalars['String']>;
  formStatus?: InputMaybe<Form_FormStatus>;
  kbvFormId?: InputMaybe<Scalars['String']>;
  kbvFormStatus?: InputMaybe<Form_KbvFormStatus>;
  tags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  updatedByUserId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DocumentFormQuestionMsg = {
  /** The maximum allowed file size in bytes */
  maxFileSize?: InputMaybe<Scalars['Long']>;
  /** Static document to be downloaded, filled in and uploaded again as part of the question */
  staticDocumentGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DocumentFormValueMsg = {
  documentId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_DoubleFormQuestionMsg = {
  showSlider?: InputMaybe<Scalars['Boolean']>;
  stepSize?: InputMaybe<Scalars['Float']>;
  unitDatasetId?: InputMaybe<Scalars['String']>;
  valueMax?: InputMaybe<Scalars['Float']>;
  valueMin?: InputMaybe<Scalars['Float']>;
};

export type Input_Form_DoubleFormValueMsg = {
  unitOptionId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type Input_Form_EmailFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_EmailFormValueMsg = {
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FindFormSequenceAnswerRequest = {
  absolute?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Form_FormSequenceAnswerRelativePosition>;
};

export type Input_Form_FindFormSequenceAnswerResponse = {
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
  sequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: InputMaybe<Input_Form_FormSequenceQuestionMsg>;
};

export type Input_Form_FindFormTemplateRequest = {
  referenceId?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Input_Form_FormTemplateSelectorMsg>;
};

export type Input_Form_FindFormTemplateResponse = {
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_FindFormTemplateVersioningGroupRequest = {
  referenceId?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Input_Form_FormTemplateVersioningGroupSelectorMsg>;
};

export type Input_Form_FindFormTemplateVersioningGroupResponse = {
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_FindSiblingFormSequenceAnswerRequest = {
  /** if true search forwards, if false search backwards */
  forwards?: InputMaybe<Scalars['Boolean']>;
  sequenceAnswerId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FindSiblingFormSequenceAnswerResponse = {
  siblingQuestion?: InputMaybe<Input_Form_FormQuestionMsg>;
  siblingSequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
  siblingSequenceQuestion?: InputMaybe<Input_Form_FormSequenceQuestionMsg>;
};

export type Input_Form_FormActionMsg = {
  date?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  signatureActionData?: InputMaybe<Input_Signature_SignatureActionDataMsg>;
  type?: InputMaybe<Form_FormActionType>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormAnswerConditionMsg = {
  /** boolean */
  booleanTrue?: InputMaybe<Input_Helper_Empty>;
  doubleGreater?: InputMaybe<Scalars['Float']>;
  /** double */
  doubleLess?: InputMaybe<Scalars['Float']>;
  /** integer */
  integerEqual?: InputMaybe<Scalars['Int']>;
  integerGreater?: InputMaybe<Scalars['Int']>;
  integerLess?: InputMaybe<Scalars['Int']>;
  /** knowledge */
  knowledgeEqual?: InputMaybe<Scalars['String']>;
  /** multi select */
  multiSelectContains?: InputMaybe<Scalars['String']>;
  /** general */
  null?: InputMaybe<Input_Helper_Empty>;
  /** all multi-values */
  numAnswersEqual?: InputMaybe<Scalars['Int']>;
  numAnswersGreater?: InputMaybe<Scalars['Int']>;
  numAnswersLess?: InputMaybe<Scalars['Int']>;
  /** select */
  selectEqual?: InputMaybe<Scalars['String']>;
  stringContains?: InputMaybe<Scalars['String']>;
  stringEndsWith?: InputMaybe<Scalars['String']>;
  /** string */
  stringEqual?: InputMaybe<Scalars['String']>;
  stringLengthEqual?: InputMaybe<Scalars['Int']>;
  stringLengthGreater?: InputMaybe<Scalars['Int']>;
  stringLengthLess?: InputMaybe<Scalars['Int']>;
  stringMatches?: InputMaybe<Scalars['String']>;
  stringStartsWith?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormAnswerGroupConditionMsg = {
  /**
   * Searches for the answer to the given question-id (which has to be a child-answer-group-question) in a parent answer-group of the target answer-group.
   *  Evaluates to true if that answer equals the id of the target answer-group.
   */
  childSelectTarget?: InputMaybe<Scalars['String']>;
  /** whether the target answer-group is the first one in it's parent answer-group for its question-group-id */
  first?: InputMaybe<Input_Helper_Empty>;
  /** whether the target answer-group is the last one in it's parent answer-group for its question-group-id */
  last?: InputMaybe<Input_Helper_Empty>;
};

export type Input_Form_FormAnswerGroupHierarchyMsg = {
  answerGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerGroupMsg>>>;
};

export type Input_Form_FormAnswerGroupMsg = {
  answers?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerMsg>>>;
  childAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  directParentFormId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  parentAnswerGroupId?: InputMaybe<Scalars['String']>;
  questionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormAnswerGroupOperatorMsg = {
  condition?: InputMaybe<Input_Form_FormAnswerGroupConditionMsg>;
  selector?: InputMaybe<Input_Form_FormAnswerGroupSelectorMsg>;
};

export type Input_Form_FormAnswerGroupSelectorMsg = {
  /** the answer-group with the given question-group-id that is either the current answer-group or a parent answer-group of it */
  parentAnswerGroup?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormAnswerMsg = {
  answerGroupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** This field is true if the enablement predicate of the question matches */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** This field is true if the enablement predicate of the question matches */
  isValid?: InputMaybe<Scalars['Boolean']>;
  /**
   * This field is just there to make it easier to group answers by the question group.
   *  NOTE: maybe remove this if it turns out to be unnecessary, this is a little unclean
   */
  questionGroupId?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Input_Timestamp>;
  value?: InputMaybe<Input_Form_FormValueMsg>;
};

export type Input_Form_FormAnswerOperatorMsg = {
  condition?: InputMaybe<Input_Form_FormAnswerConditionMsg>;
  selector?: InputMaybe<Input_Form_FormAnswerSelectorMsg>;
};

export type Input_Form_FormAnswerSelectorMsg = {
  /** all answers for the given question-id */
  allAnswers?: InputMaybe<Scalars['String']>;
  /** any answers for the given question-id */
  anyAnswer?: InputMaybe<Scalars['String']>;
  /**
   * Finds the shortest path to the given question(-id) from the question-group of the current answer-group.
   *  Then that path is walked, starting from the current answer-group. Then the following happens:
   *  - Answer exists at the end of the path: the value of that answer is used
   *  - Answer does NOT exists at the end: the default value for the given question-id is used
   *
   *  This selector will not attempt to find the second-closest possible answer,
   *  even if we didn't find one while walking the path initially. (You probably wouldn't want that anyway)
   *
   *  The intention for this selector is for it to be used as the default.
   */
  nearestAnswer?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormChildAnswerGroupInfoMsg = {
  answerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  questionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormContextIdentifierMsg = {
  contextId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Form_FormContextType>;
};

export type Input_Form_FormContextMsg = {
  identifiers?: InputMaybe<Array<InputMaybe<Input_Form_FormContextIdentifierMsg>>>;
};

export type Input_Form_FormDatasetMsg = {
  id?: InputMaybe<Scalars['String']>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  optionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionGroupMsg>>>;
};

export type Input_Form_FormElementLocationMsg = {
  targetId?: InputMaybe<Scalars['String']>;
  targetIndex?: InputMaybe<Scalars['Int']>;
};

export type Input_Form_FormExternalIdMappingMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMsg>>>;
  targetId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormExternalIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  externalIdType?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormList = {
  forms?: InputMaybe<Array<InputMaybe<Input_Form_FormMsg>>>;
};

export type Input_Form_FormMsg = {
  actions?: InputMaybe<Array<InputMaybe<Input_Form_FormActionMsg>>>;
  answerGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerGroupMsg>>>;
  context?: InputMaybe<Input_Form_FormContextMsg>;
  createdAt?: InputMaybe<Input_Timestamp>;
  createdByPortalUserId?: InputMaybe<Scalars['String']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  directChildAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  /** whether there is data loss when converting from sequential form */
  hasSequentialConversionDataLoss?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  linkedContextIdentifiers?: InputMaybe<Array<InputMaybe<Input_Form_LinkedFormContextIdentifierMsg>>>;
  lockedAt?: InputMaybe<Input_Timestamp>;
  lockedByUserId?: InputMaybe<Scalars['String']>;
  owningOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Input_Form_FormResultMsg>;
  sequenceAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceAnswerMsg>>>;
  signatoryRequests?: InputMaybe<Array<InputMaybe<Input_Signature_SignatureMsg>>>;
  signed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Form_FormStatus>;
  templateId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Input_Timestamp>;
};

export type Input_Form_FormOperatorList = {
  operators?: InputMaybe<Array<InputMaybe<Input_Form_FormOperatorMsg>>>;
};

export type Input_Form_FormOperatorMsg = {
  and?: InputMaybe<Input_Form_FormOperatorList>;
  answer?: InputMaybe<Input_Form_FormAnswerOperatorMsg>;
  answerGroup?: InputMaybe<Input_Form_FormAnswerGroupOperatorMsg>;
  not?: InputMaybe<Input_Form_FormOperatorMsg>;
  or?: InputMaybe<Input_Form_FormOperatorList>;
};

export type Input_Form_FormOptionGroupMsg = {
  id?: InputMaybe<Scalars['String']>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  options?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionMsg>>>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_FormOptionMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_FormPermissionReferenceMsg = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Core_AdministrativeUnitType>;
};

export type Input_Form_FormQuestionAdditionalInfoMsg = {
  additionalInfoUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormQuestionContextMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  /** For contexts that have no uuid, such as treatment blocks */
  referenceNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Form_FormQuestionContextType>;
};

export type Input_Form_FormQuestionGroupHierarchyMsg = {
  questionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionGroupMsg>>>;
};

export type Input_Form_FormQuestionGroupMsg = {
  /**
   * Initially, it was planned question-groups can be linked to treatment-block(-templates).
   *  We might replace this with a different mechanism later on and remove this.
   */
  blockNumber?: InputMaybe<Scalars['Int']>;
  childQuestionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Only set if this question-group is a direct parent of its form-template. */
  directParentTemplateId?: InputMaybe<Scalars['String']>;
  displayGroup?: InputMaybe<Form_FormQuestionGroupDisplayGroup>;
  enablementContexts?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionContextMsg>>>;
  /**
   * This predicate will be evaluated for every group of child answer-groups
   *  that have the same parent and same question-group.
   *  The result is available via FormChildAnswerGroupInfoMsg#isEnabled.
   */
  enablementPredicate?: InputMaybe<Input_Form_FormOperatorMsg>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated, use displayGroup field instead
   *  Whether this question-group should be displayed when viewing
   *  the form.
   *
   *  If false, this question-group is considered a logical
   *  group and is not rendered. It's child question-groups are then rendered on the same
   *  visual level this question-group would have been rendered at.
   */
  isDisplayGroup?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether there can be multiple answer-groups to this one question-group
   *  inside of the same form. If true, minAnswerGroups and maxAnswerGroups
   *  should be used for further configuration.
   */
  isMultiGroup?: InputMaybe<Scalars['Boolean']>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  maxAnswerGroups?: InputMaybe<Scalars['Int']>;
  minAnswerGroups?: InputMaybe<Scalars['Int']>;
  /** Only set if this question-group has another question-group as its parent. */
  parentQuestionGroupId?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionMsg>>>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_FormQuestionMsg = {
  /** optional, used to provide a link to useful information */
  additionalInfo?: InputMaybe<Input_Form_FormQuestionAdditionalInfoMsg>;
  address?: InputMaybe<Input_Form_AddressFormQuestionMsg>;
  allergy?: InputMaybe<Input_Form_AllergyFormQuestionMsg>;
  /** used to disable editing of preset answers */
  answerIsDisabled?: InputMaybe<Scalars['Boolean']>;
  boolean?: InputMaybe<Input_Form_BooleanFormQuestionMsg>;
  childAnswerGroupSelect?: InputMaybe<Input_Form_ChildAnswerGroupSelectFormQuestionMsg>;
  /**
   * The default value for answers to this question.
   *  In the future, it is our goal to replace this with an 'expression' of some sort
   *  that can be evaluated when the answer is first created. This would allow us
   *  to take the context of the form into consideration.
   */
  defaultValue?: InputMaybe<Input_Form_FormValueMsg>;
  diagnosis?: InputMaybe<Input_Form_DiagnosisFormQuestionMsg>;
  document?: InputMaybe<Input_Form_DocumentFormQuestionMsg>;
  double?: InputMaybe<Input_Form_DoubleFormQuestionMsg>;
  email?: InputMaybe<Input_Form_EmailFormQuestionMsg>;
  enablementContexts?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionContextMsg>>>;
  enablementPredicate?: InputMaybe<Input_Form_FormOperatorMsg>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMsg>>>;
  formReference?: InputMaybe<Input_Form_FormReferenceFormQuestionMsg>;
  id?: InputMaybe<Scalars['String']>;
  infoText?: InputMaybe<Input_Form_InfoTextFormQuestionMsg>;
  integer?: InputMaybe<Input_Form_IntegerFormQuestionMsg>;
  isDisplayAsRequired?: InputMaybe<Scalars['Boolean']>;
  knowledge?: InputMaybe<Input_Form_KnowledgeFormQuestionMsg>;
  labResult?: InputMaybe<Input_Form_LabResultFormQuestionMsg>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  localDate?: InputMaybe<Input_Form_LocalDateFormQuestionMsg>;
  localDateTime?: InputMaybe<Input_Form_LocalDateTimeFormQuestionMsg>;
  localTime?: InputMaybe<Input_Form_LocalTimeFormQuestionMsg>;
  multiAllergy?: InputMaybe<Input_Form_MultiAllergyFormQuestionMsg>;
  multiDiagnosis?: InputMaybe<Input_Form_MultiDiagnosisFormQuestionMsg>;
  multiKnowledge?: InputMaybe<Input_Form_MultiKnowledgeFormQuestionMsg>;
  multiSelect?: InputMaybe<Input_Form_MultiSelectFormQuestionMsg>;
  precisionTimestamp?: InputMaybe<Input_Form_PrecisionTimestampFormQuestionMsg>;
  questionGroupId?: InputMaybe<Scalars['String']>;
  select?: InputMaybe<Input_Form_SelectFormQuestionMsg>;
  signature?: InputMaybe<Input_Form_SignatureFormQuestionMsg>;
  string?: InputMaybe<Input_Form_StringFormQuestionMsg>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  timestamp?: InputMaybe<Input_Form_TimestampFormQuestionMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
  /** A virtual property that specifies the type of the content */
  type?: InputMaybe<Form_FormValueType>;
  userSelect?: InputMaybe<Input_Form_UserSelectFormQuestionMsg>;
  validityPredicate?: InputMaybe<Input_Form_FormOperatorMsg>;
};

export type Input_Form_FormReferenceFormQuestionMsg = {
  /** versioningGroupReferenceIds */
  parentFormVersioningGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scope?: InputMaybe<Form_FormReferenceQuestionScope>;
  tag?: InputMaybe<Form_FormTemplateVersioningGroupTag>;
};

export type Input_Form_FormReferenceFormValueMsg = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormResultMsg = {
  text?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_FormSelectorMsg = {
  includeActions?: InputMaybe<Scalars['Boolean']>;
  includeAnswerGroups?: InputMaybe<Scalars['Boolean']>;
  includeAnswers?: InputMaybe<Scalars['Boolean']>;
  includeDirectChildAnswerGroupInfo?: InputMaybe<Scalars['Boolean']>;
  includeSequenceAnswers?: InputMaybe<Scalars['Boolean']>;
  includeSignatoryRequests?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_FormSequenceAnswerMsg = {
  forwardsState?: InputMaybe<Form_FormSequenceAnswerForwardsState>;
  hasBackwardsSibling?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  sequenceQuestionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Input_Timestamp>;
  value?: InputMaybe<Input_Form_FormValueMsg>;
};

export type Input_Form_FormSequenceAnswerOperatorMsg = {
  condition?: InputMaybe<Input_Form_FormAnswerConditionMsg>;
  selector?: InputMaybe<Input_Form_FormSequenceAnswerSelectorMsg>;
};

export type Input_Form_FormSequenceAnswerSelectorMsg = {
  /** all sequence-answers for the given sequence-question-id */
  allSequenceAnswers?: InputMaybe<Scalars['String']>;
  /** all sequence-answer for the given sequence-question-id */
  anySequenceAnswer?: InputMaybe<Scalars['String']>;
  /** the last (=latest) sequence-answer for the given sequence-question-id */
  lastSequenceAnswer?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormSequenceOperatorList = {
  operators?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceOperatorMsg>>>;
};

export type Input_Form_FormSequenceOperatorMsg = {
  and?: InputMaybe<Input_Form_FormSequenceOperatorList>;
  not?: InputMaybe<Input_Form_FormSequenceOperatorMsg>;
  or?: InputMaybe<Input_Form_FormSequenceOperatorList>;
  sequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerOperatorMsg>;
};

export type Input_Form_FormSequenceQuestionAndAnswerMsg = {
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
  sequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: InputMaybe<Input_Form_FormSequenceQuestionMsg>;
};

export type Input_Form_FormSequenceQuestionMsg = {
  creationQuestionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  linkedReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  questionId?: InputMaybe<Scalars['String']>;
  transitions?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceTransitionMsg>>>;
};

export type Input_Form_FormSequenceTransitionMsg = {
  id?: InputMaybe<Scalars['String']>;
  predicate?: InputMaybe<Input_Form_FormSequenceOperatorMsg>;
  targetSequenceQuestionId?: InputMaybe<Scalars['String']>;
};

/**
 * Depending on the request, none of the linked targets might be set.
 *  Additionally, if any linked target is set, it will only have simple properties set, like a title or subtitle (and specifically no relations).
 */
export type Input_Form_FormTemplateItemReferenceMsg = {
  createdAt?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  linkedDatasets?: InputMaybe<Array<InputMaybe<Input_Form_FormDatasetMsg>>>;
  linkedOptionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionGroupMsg>>>;
  linkedOptions?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionMsg>>>;
  linkedQuestionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionGroupMsg>>>;
  linkedQuestions?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionMsg>>>;
  linkedSequenceQuestions?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceQuestionMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormTemplateLocationConfigMsg = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  location?: InputMaybe<Form_FormTemplateLocation>;
};

export type Input_Form_FormTemplateMsg = {
  /**
   * Control-flow-questions are used exclusively used as the basis for sequence-questions.
   *  Their answers are not displayed in non-sequential views of forms.
   *  The intended usage is for questions like 'Do you want to add another xyz...'
   *  when answering a form in sequential-mode.
   *  The resulting sequence-answer should then be used to influence the
   *  control flow of that form in sequence-mode (using transitions).
   */
  controlFlowQuestions?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionMsg>>>;
  createdAt?: InputMaybe<Input_Timestamp>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  datasets?: InputMaybe<Array<InputMaybe<Input_Form_FormDatasetMsg>>>;
  directChildQuestionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasSequentialSupport?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lockedAt?: InputMaybe<Input_Timestamp>;
  lockedByUserId?: InputMaybe<Scalars['String']>;
  questionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionGroupMsg>>>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateResultMsg>>>;
  sequenceQuestions?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceQuestionMsg>>>;
  startSequenceQuestionId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Form_FormTemplateStatus>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
  versioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormTemplateResultMsg = {
  predicate?: InputMaybe<Input_Form_FormOperatorMsg>;
  text?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_FormTemplateSelectorMsg = {
  includeControlFlowQuestions?: InputMaybe<Scalars['Boolean']>;
  includeDatasets?: InputMaybe<Scalars['Boolean']>;
  includeDirectChildQuestionGroupIds?: InputMaybe<Scalars['Boolean']>;
  includeOptionGroups?: InputMaybe<Scalars['Boolean']>;
  includeOptions?: InputMaybe<Scalars['Boolean']>;
  includeQuestionGroups?: InputMaybe<Scalars['Boolean']>;
  includeQuestions?: InputMaybe<Scalars['Boolean']>;
  includeSequenceQuestions?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_FormTemplateVersioningGroupAccessInfoMsg = {
  accessLimited?: InputMaybe<Scalars['Boolean']>;
  accessType?: InputMaybe<Form_FormAccessType>;
  formTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_FormTemplateVersioningGroupMsg = {
  accessLimited?: InputMaybe<Scalars['Boolean']>;
  accessType?: InputMaybe<Form_FormAccessType>;
  id?: InputMaybe<Scalars['String']>;
  /** this list allows configuring where the active template will appear in non-portal contexts. */
  locationConfigs?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateLocationConfigMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  /** defines which administrative unit can read/edit this form-template */
  permissionScope?: InputMaybe<Array<InputMaybe<Input_Form_FormPermissionReferenceMsg>>>;
  /**
   * Whether this template versioning group can be linked to portal appointment tasks.
   *  Has to bet set at creation and can't be updated.
   */
  portalReadable?: InputMaybe<Scalars['Boolean']>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  templateItemReferences?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateItemReferenceMsg>>>;
  /**
   * Contains all the templates in the versioning group, ordered by creation date ascending.
   *  All templates in this list contain only top level information and no additional inclusions.
   */
  templates?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateMsg>>>;
};

export type Input_Form_FormTemplateVersioningGroupSelectorMsg = {
  includeLocationConfigs?: InputMaybe<Scalars['Boolean']>;
  includePermissionScope?: InputMaybe<Scalars['Boolean']>;
  includeTemplateItemReferences?: InputMaybe<Scalars['Boolean']>;
  includeTemplateItemReferencesLinkedItems?: InputMaybe<Scalars['Boolean']>;
  includeTemplates?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_FormValidationErrorMsg = {
  answerGroupId?: InputMaybe<Scalars['String']>;
  numErrors?: InputMaybe<Scalars['Int']>;
};

export type Input_Form_FormValueMsg = {
  address?: InputMaybe<Input_Form_AddressFormValueMsg>;
  allergy?: InputMaybe<Input_Form_AllergyFormValueMsg>;
  boolean?: InputMaybe<Input_Form_BooleanFormValueMsg>;
  childAnswerGroupSelect?: InputMaybe<Input_Form_ChildAnswerGroupSelectFormValueMsg>;
  diagnosis?: InputMaybe<Input_Form_DiagnosisFormValueMsg>;
  document?: InputMaybe<Input_Form_DocumentFormValueMsg>;
  double?: InputMaybe<Input_Form_DoubleFormValueMsg>;
  email?: InputMaybe<Input_Form_EmailFormValueMsg>;
  formReference?: InputMaybe<Input_Form_FormReferenceFormValueMsg>;
  infoText?: InputMaybe<Input_Form_InfoTextFormValueMsg>;
  integer?: InputMaybe<Input_Form_IntegerFormValueMsg>;
  knowledge?: InputMaybe<Input_Form_KnowledgeFormValueMsg>;
  labResult?: InputMaybe<Input_Form_LabResultFormValueMsg>;
  localDate?: InputMaybe<Input_Form_LocalDateFormValueMsg>;
  localDateTime?: InputMaybe<Input_Form_LocalDateTimeFormValueMsg>;
  localTime?: InputMaybe<Input_Form_LocalTimeFormValueMsg>;
  multiAllergy?: InputMaybe<Input_Form_MultiAllergyFormValueMsg>;
  multiDiagnosis?: InputMaybe<Input_Form_MultiDiagnosisFormValueMsg>;
  multiKnowledge?: InputMaybe<Input_Form_MultiKnowledgeFormValueMsg>;
  multiSelect?: InputMaybe<Input_Form_MultiSelectFormValueMsg>;
  precisionTimestamp?: InputMaybe<Input_Form_PrecisionTimestampFormValueMsg>;
  select?: InputMaybe<Input_Form_SelectFormValueMsg>;
  signature?: InputMaybe<Input_Form_SignatureFormValueMsg>;
  string?: InputMaybe<Input_Form_StringFormValueMsg>;
  timestamp?: InputMaybe<Input_Form_TimestampFormValueMsg>;
  userSelect?: InputMaybe<Input_Form_UserSelectFormValueMsg>;
};

export type Input_Form_GetFormAccessInfoByFormIdResponse = {
  formIdToAccessInfo?: InputMaybe<Array<InputMaybe<Input_Form_GetFormAccessInfoByFormIdResponse_FormIdToAccessInfoEntry>>>;
};

export type Input_Form_GetFormAccessInfoByFormIdResponse_FormIdToAccessInfoEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Form_FormTemplateVersioningGroupAccessInfoMsg>;
};

export type Input_Form_GetFormAccessInfoByFormIdsRequest = {
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_GetFormAnswerGroupHierarchyRequest = {
  /** must be >= 1 */
  depth?: InputMaybe<Scalars['Int']>;
  rootAnswerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * The response contains the flattened sub-hierarchy for each answer-group specified
 *  via the rootAnswerGroupIds parameter in the request.
 *  With depth = 1, each sub-hierarchy contains only one answer-group, namely the
 *  one with its id equal to the matching element in the rootAnswerGroupIds parameter.
 */
export type Input_Form_GetFormAnswerGroupHierarchyResponse = {
  /** each of these elements represents the sub-hierarchy of it's corresponding 'rootAnswerGroupId' in the request */
  answerGroupHierarchies?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerGroupHierarchyMsg>>>;
};

export type Input_Form_GetFormDatasetRequest = {
  formDatasetId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetFormDatasetResponse = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
};

export type Input_Form_GetFormQuestionGroupHierarchyRequest = {
  depth?: InputMaybe<Scalars['Int']>;
  rootQuestionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * The response contains the flattened sub-hierarchy for each question-group specified
 *  via the rootQuestionGroupIds parameter in the request.
 *  With depth = 1, each sub-hierarchy contains only one question-group, namely the
 *  one with its id equal to the matching element in the rootQuestionGroupIds parameter.
 */
export type Input_Form_GetFormQuestionGroupHierarchyResponse = {
  /** each of these elements represents the sub-hierarchy of it's corresponding 'rootQuestionGroupId' in the request */
  questionGroupHierarchies?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionGroupHierarchyMsg>>>;
};

export type Input_Form_GetFormRequest = {
  formId?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Input_Form_FormSelectorMsg>;
};

export type Input_Form_GetFormResponse = {
  form?: InputMaybe<Input_Form_FormMsg>;
};

export type Input_Form_GetFormSequenceAnswerRequest = {
  sequenceAnswerId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetFormSequenceAnswerResponse = {
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
  sequenceAnswer?: InputMaybe<Input_Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: InputMaybe<Input_Form_FormSequenceQuestionMsg>;
};

export type Input_Form_GetFormTemplateAccessInfoByFormIdResponse = {
  formTemplateIdToAccessInfo?: InputMaybe<Array<InputMaybe<Input_Form_GetFormTemplateAccessInfoByFormIdResponse_FormTemplateIdToAccessInfoEntry>>>;
};

export type Input_Form_GetFormTemplateAccessInfoByFormIdResponse_FormTemplateIdToAccessInfoEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Form_FormTemplateVersioningGroupAccessInfoMsg>;
};

export type Input_Form_GetFormTemplateAccessInfoByFormIdsRequest = {
  formTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_GetFormTemplateExternalIdsRequest = {
  templateId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetFormTemplateExternalIdsResponse = {
  optionExternalIdMappings?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMappingMsg>>>;
  questionExternalIdMappings?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMappingMsg>>>;
  questionGroupExternalIdMappings?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMappingMsg>>>;
};

export type Input_Form_GetFormTemplateRequest = {
  selector?: InputMaybe<Input_Form_FormTemplateSelectorMsg>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetFormTemplateResponse = {
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_GetFormTemplateTagsByFormIdElementMsg = {
  formId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Input_Form_GetFormTemplateTagsByFormIdsRequest = {
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_GetFormTemplateTagsByFormIdsResponse = {
  elements?: InputMaybe<Array<InputMaybe<Input_Form_GetFormTemplateTagsByFormIdElementMsg>>>;
};

export type Input_Form_GetFormTemplateVersioningGroupRequest = {
  selector?: InputMaybe<Input_Form_FormTemplateVersioningGroupSelectorMsg>;
  templateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetFormTemplateVersioningGroupResponse = {
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_GetFormTitlesByFormIdElementMsg = {
  formId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_GetFormTitlesByFormIdsRequest = {
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_GetFormTitlesByFormIdsResponse = {
  elements?: InputMaybe<Array<InputMaybe<Input_Form_GetFormTitlesByFormIdElementMsg>>>;
};

export type Input_Form_GetFormsElementMsg = {
  form?: InputMaybe<Input_Form_FormMsg>;
  templateTitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_GetFormsRequest = {
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selector?: InputMaybe<Input_Form_FormSelectorMsg>;
};

export type Input_Form_GetFormsResponse = {
  elements?: InputMaybe<Array<InputMaybe<Input_Form_GetFormsElementMsg>>>;
};

export type Input_Form_GetSequentialFormSummaryRequest = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_GetSequentialFormSummaryResponse = {
  questionsAndAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormSequenceQuestionAndAnswerMsg>>>;
};

/**
 * This question will show the user an information text and has no actual answer.
 *  Use the question-title for the title of the text and the question-subtitle for the body of the text.
 */
export type Input_Form_InfoTextFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_InfoTextFormValueMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_IntegerFormQuestionMsg = {
  showSlider?: InputMaybe<Scalars['Boolean']>;
  specialMode?: InputMaybe<Form_IntegerFormQuestionSpecialMode>;
  stepSize?: InputMaybe<Scalars['Int']>;
  unitDatasetId?: InputMaybe<Scalars['String']>;
  valueMax?: InputMaybe<Scalars['Int']>;
  valueMin?: InputMaybe<Scalars['Int']>;
};

export type Input_Form_IntegerFormValueMsg = {
  unitOptionId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type Input_Form_KnowledgeFormQuestionMsg = {
  knowledgeDataset?: InputMaybe<Knowledge_KnowledgeDataset>;
  /** Whether the dataset should be searchable or all options should be shown by default */
  searchable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_KnowledgeFormValueMsg = {
  value?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Form_LabResultFormQuestionMsg = {
  defaultValueType?: InputMaybe<Form_LabResultFormValueType>;
  loincComponentCode?: InputMaybe<Scalars['String']>;
};

export type Input_Form_LabResultFormValueMsg = {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  categoryValue?: InputMaybe<Scalars['String']>;
  decimalRangeValue?: InputMaybe<Input_DecimalRangeMsg>;
  decimalValue?: InputMaybe<Input_DecimalMsg>;
  intValue?: InputMaybe<Scalars['Int']>;
  ratioValue?: InputMaybe<Input_RatioMsg>;
  textValue?: InputMaybe<Scalars['String']>;
  /** TODO: should be structured */
  unit?: InputMaybe<Scalars['String']>;
  valueType?: InputMaybe<Form_LabResultFormValueType>;
};

export type Input_Form_LinkedFormContextIdentifierMsg = {
  contextId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Form_LinkedFormContextType>;
};

export type Input_Form_ListAppointmentFormsRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Input_Form_FormSelectorMsg>;
};

export type Input_Form_ListAppointmentFormsResponse = {
  forms?: InputMaybe<Input_Form_FormList>;
};

export type Input_Form_ListFormOptionsRequest = {
  datasetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Form_FormExternalIdMsg>>>;
};

export type Input_Form_ListFormOptionsResponse = {
  options?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionMsg>>>;
};

export type Input_Form_ListFormTemplateVersioningGroupsRequest = {
  /**
   * filters by permissionScope administrative-units if not empty;
   *  all template-versioning-groups that have at least one match are returned
   */
  administrativeUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /**
   * filters by locations configs if not empty;
   *  all template-versioning-groups, that have at least one match are returned
   */
  locationConfigs?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateLocationConfigMsg>>>;
  selector?: InputMaybe<Input_Form_FormTemplateVersioningGroupSelectorMsg>;
};

export type Input_Form_ListFormTemplateVersioningGroupsResponse = {
  templateVersioningGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>>>;
};

export type Input_Form_ListFormTemplatesRequest = {
  /** if empty, all administrativeUnits are used */
  administrativeUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** if empty, all locations are used */
  locationConfigs?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateLocationConfigMsg>>>;
  selector?: InputMaybe<Input_Form_FormTemplateSelectorMsg>;
  /** if empty all statuses are used */
  statuses?: InputMaybe<Array<InputMaybe<Form_FormTemplateStatus>>>;
  tag?: InputMaybe<Form_FormTemplateVersioningGroupTag>;
  tagsToExclude?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  /** if empty, all template-versioning-groups are used */
  templateVersioningGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Form_ListFormTemplatesResponse = {
  templates?: InputMaybe<Array<InputMaybe<Input_Form_FormTemplateMsg>>>;
};

export type Input_Form_ListFormsElementMsg = {
  /**
   * optional, only relevant for BG reports
   *  returned if D-Arzt is set in form
   */
  dUserId?: InputMaybe<Scalars['String']>;
  form?: InputMaybe<Input_Form_FormMsg>;
  /**
   * optional, only relevant for BG reports
   *  true if form was send to uni-dav
   */
  sentToUniDav?: InputMaybe<Scalars['Boolean']>;
  templateTitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_ListFormsRequest = {
  /** if empty all, forms of all appointments (and the ones without an appointment) are searched */
  appointmentId?: InputMaybe<Scalars['String']>;
  billingCaseId?: InputMaybe<Scalars['String']>;
  clinicalImpressionId?: InputMaybe<Scalars['String']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  /** dale report relevant filters */
  dUserSelectedInForm?: InputMaybe<Scalars['String']>;
  daleXmlStatuses?: InputMaybe<Array<InputMaybe<Billing_DaleXmlStatus>>>;
  includeTemplateTitles?: InputMaybe<Scalars['Boolean']>;
  lockedAtBefore?: InputMaybe<Input_Timestamp>;
  lockedAtEqualOrAfter?: InputMaybe<Input_Timestamp>;
  minOneOfTagsShouldMatch?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  mustFormTemplateVersioningGroupTags?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  owningOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** if empty all, forms of all patients (and the ones without a patient) are searched */
  patientId?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Input_Form_FormSelectorMsg>;
  sentToUniDav?: InputMaybe<Scalars['Boolean']>;
  /** if empty, all statuses are searched */
  statuses?: InputMaybe<Array<InputMaybe<Form_FormStatus>>>;
  tagsToExclude?: InputMaybe<Array<InputMaybe<Form_FormTemplateVersioningGroupTag>>>;
  /** if empty, all templates are searched */
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** if empty, all locations are searched */
  templateLocations?: InputMaybe<Array<InputMaybe<Form_FormTemplateLocation>>>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** if empty all, forms of all treatments (and the ones without a treatment) are searched */
  treatmentId?: InputMaybe<Scalars['String']>;
  /** if empty, all versioning groups are searched */
  versioningGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_ListFormsResponse = {
  elements?: InputMaybe<Array<InputMaybe<Input_Form_ListFormsElementMsg>>>;
};

export type Input_Form_LocalDateFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_LocalDateFormValueMsg = {
  value?: InputMaybe<Input_Core_LocalDateMsg>;
};

export type Input_Form_LocalDateTimeFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_LocalDateTimeFormValueMsg = {
  value?: InputMaybe<Input_Core_LocalDateTimeMsg>;
};

export type Input_Form_LocalTimeFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_LocalTimeFormValueMsg = {
  value?: InputMaybe<Input_Core_LocalTimeMsg>;
};

export type Input_Form_MoveFormAnswerGroupRequest = {
  answerGroupId?: InputMaybe<Scalars['String']>;
  directParentForm?: InputMaybe<Input_Form_FormElementLocationMsg>;
  parentAnswerGroup?: InputMaybe<Input_Form_FormElementLocationMsg>;
};

export type Input_Form_MoveFormAnswerGroupResponse = {
  answerGroup?: InputMaybe<Input_Form_FormAnswerGroupMsg>;
  changedAnswers?: InputMaybe<Array<InputMaybe<Input_Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: InputMaybe<Array<InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>>>;
  newParentInfo?: InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>;
  oldParentInfo?: InputMaybe<Input_Form_FormChildAnswerGroupInfoMsg>;
};

export type Input_Form_MoveFormOptionGroupRequest = {
  datasetLocation?: InputMaybe<Input_Form_FormElementLocationMsg>;
  optionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_MoveFormOptionGroupResponse = {
  newDataset?: InputMaybe<Input_Form_FormDatasetMsg>;
  oldDataset?: InputMaybe<Input_Form_FormDatasetMsg>;
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
};

export type Input_Form_MoveFormOptionRequest = {
  optionGroupLocation?: InputMaybe<Input_Form_FormElementLocationMsg>;
  optionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_MoveFormOptionResponse = {
  newOptionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
  oldOptionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
  option?: InputMaybe<Input_Form_FormOptionMsg>;
};

export type Input_Form_MoveFormQuestionGroupRequest = {
  directParentTemplate?: InputMaybe<Input_Form_FormElementLocationMsg>;
  parentQuestionGroup?: InputMaybe<Input_Form_FormElementLocationMsg>;
  questionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_MoveFormQuestionGroupResponse = {
  newParentQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  oldParentQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

/** can only be used for non-control-flow questions */
export type Input_Form_MoveFormQuestionRequest = {
  questionGroupLocation?: InputMaybe<Input_Form_FormElementLocationMsg>;
  questionId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_MoveFormQuestionResponse = {
  newQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  oldQuestionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
};

export type Input_Form_MultiAllergyFormQuestionMsg = {
  importScope?: InputMaybe<Form_AllergyFormQuestionImportScope>;
};

export type Input_Form_MultiAllergyFormValueMsg = {
  values?: InputMaybe<Array<InputMaybe<Input_Treatment_AllergenMsg>>>;
};

export type Input_Form_MultiDiagnosisFormQuestionMsg = {
  importScope?: InputMaybe<Form_DiagnosisFormQuestionImportScope>;
  searchType?: InputMaybe<Form_DiagnosisSearchType>;
};

export type Input_Form_MultiDiagnosisFormValueMsg = {
  values?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
};

export type Input_Form_MultiKnowledgeFormQuestionMsg = {
  knowledgeDataset?: InputMaybe<Knowledge_KnowledgeDataset>;
  maxAnswers?: InputMaybe<Scalars['Int']>;
  /** Whether the dataset should be searchable or all options should be shown by default */
  searchable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_MultiKnowledgeFormValueMsg = {
  values?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Form_MultiSelectFormQuestionMsg = {
  datasetId?: InputMaybe<Scalars['String']>;
  maxAnswers?: InputMaybe<Scalars['Int']>;
  searchable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_MultiSelectFormValueMsg = {
  options?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionMsg>>>;
};

export type Input_Form_PrecisionTimestampFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_PrecisionTimestampFormValueMsg = {
  value?: InputMaybe<Input_PrecisionTimestampMsg>;
};

export type Input_Form_RestartFormRequest = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_RestartFormResponse = {
  form?: InputMaybe<Input_Form_FormMsg>;
};

export type Input_Form_SearchFormOptionsRequest = {
  formDatasetId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type Input_Form_SearchFormOptionsResponse = {
  optionGroups?: InputMaybe<Array<InputMaybe<Input_Form_FormOptionGroupMsg>>>;
};

export type Input_Form_SelectFormQuestionMsg = {
  datasetId?: InputMaybe<Scalars['String']>;
  /** if this field is true, the question should be displayed as a radio button */
  isRadio?: InputMaybe<Scalars['Boolean']>;
  searchable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Form_SelectFormValueMsg = {
  option?: InputMaybe<Input_Form_FormOptionMsg>;
};

export type Input_Form_SignFormRequest = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_SignatureFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_SignatureFormValueMsg = {
  /** The signature image should be fetched by imageId in image service */
  signatureImageId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_StringFormQuestionMsg = {
  maxCharacters?: InputMaybe<Scalars['Int']>;
  placeholder?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Form_StringFormValueMsg = {
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Form_TimestampFormQuestionMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Form_TimestampFormValueMsg = {
  value?: InputMaybe<Input_Timestamp>;
};

export type Input_Form_UnsignFormRequest = {
  formId?: InputMaybe<Scalars['String']>;
};

export type Input_Form_UpdateFormDatasetRequest = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
};

export type Input_Form_UpdateFormDatasetResponse = {
  dataset?: InputMaybe<Input_Form_FormDatasetMsg>;
};

export type Input_Form_UpdateFormOptionGroupRequest = {
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
};

export type Input_Form_UpdateFormOptionGroupResponse = {
  optionGroup?: InputMaybe<Input_Form_FormOptionGroupMsg>;
};

export type Input_Form_UpdateFormOptionRequest = {
  option?: InputMaybe<Input_Form_FormOptionMsg>;
};

export type Input_Form_UpdateFormOptionResponse = {
  option?: InputMaybe<Input_Form_FormOptionMsg>;
};

export type Input_Form_UpdateFormQuestionGroupRequest = {
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
};

export type Input_Form_UpdateFormQuestionGroupResponse = {
  questionGroup?: InputMaybe<Input_Form_FormQuestionGroupMsg>;
};

export type Input_Form_UpdateFormQuestionRequest = {
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
};

export type Input_Form_UpdateFormQuestionResponse = {
  question?: InputMaybe<Input_Form_FormQuestionMsg>;
};

export type Input_Form_UpdateFormSignatureRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  signatoryRequest?: InputMaybe<Input_Signature_SignatureMsg>;
};

export type Input_Form_UpdateFormSignaturesRequest = {
  formId?: InputMaybe<Scalars['String']>;
  requests?: InputMaybe<Array<InputMaybe<Input_Signature_SignatureMsg>>>;
};

export type Input_Form_UpdateFormStatusRequest = {
  /**
   * contexts are set to ignore form questions that are ignored due to enablement contexts
   *  if a form question has any enablement contexts, if none of them are in the list of given contexts
   *  its validity is ignored
   */
  contexts?: InputMaybe<Array<InputMaybe<Input_Form_FormQuestionContextMsg>>>;
  formId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Form_FormStatus>;
};

export type Input_Form_UpdateFormStatusResponse = {
  form?: InputMaybe<Input_Form_FormMsg>;
  validationErrors?: InputMaybe<Array<InputMaybe<Input_Form_FormValidationErrorMsg>>>;
};

export type Input_Form_UpdateFormTemplateRequest = {
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_UpdateFormTemplateResponse = {
  template?: InputMaybe<Input_Form_FormTemplateMsg>;
};

export type Input_Form_UpdateFormTemplateVersioningGroupRequest = {
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_UpdateFormTemplateVersioningGroupResponse = {
  /** includes only permissionScope and locationConfigs */
  templateVersioningGroup?: InputMaybe<Input_Form_FormTemplateVersioningGroupMsg>;
};

export type Input_Form_UpdateLinkedFormContextRequest = {
  formId?: InputMaybe<Scalars['String']>;
  /** to remove linked identifier of certain type specify type and leave context id empty */
  linkedContextIdentifiers?: InputMaybe<Array<InputMaybe<Input_Form_LinkedFormContextIdentifierMsg>>>;
};

export type Input_Form_UserSelectFormQuestionMsg = {
  filterType?: InputMaybe<Form_UserSelectFilterType>;
};

export type Input_Form_UserSelectFormValueMsg = {
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Helper_Empty = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Helper_GeneralSearchMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Helper_IdList = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Helper_PaginatedListRequest = {
  /** 0-indexed page index; restriction: (pageSize * pageIndex) + pageSize < 10.000 */
  pageIndex?: InputMaybe<Scalars['Int']>;
  /** How many elements are shown on the page */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Sort instructions which will be processed in the given order */
  sortInstructions?: InputMaybe<Array<InputMaybe<Input_Helper_SortInstruction>>>;
  /** If we want to search within a paginated list */
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Helper_PaginationSettingsMsg = {
  /** 0-indexed page index; restriction: (pageSize * pageIndex) + pageSize < 10.000 */
  pageIndex?: InputMaybe<Scalars['Int']>;
  /** How many elements are shown on the page */
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type Input_Helper_SortInstruction = {
  /** Can be left null if ascending */
  descending?: InputMaybe<Scalars['Boolean']>;
  /**
   * Fully qualified name of the variable based on the entity to be searched;
   *  for instance, if an entity has a field "name" of type HumanNameMsg, sorting for first name would be name.firstName
   */
  variable?: InputMaybe<Scalars['String']>;
};

export type Input_Image_ExifInformationMsg = {
  apertureValue?: InputMaybe<Scalars['Float']>;
  dateTime?: InputMaybe<Input_Timestamp>;
  exposure?: InputMaybe<Scalars['Float']>;
  fNumber?: InputMaybe<Scalars['Float']>;
  /** Mapping can be found here: https://www.awaresystems.be/imaging/tiff/tifftags/privateifd/exif/flash.html */
  flash?: InputMaybe<Scalars['Int']>;
  focalLength?: InputMaybe<Scalars['Float']>;
  isoSpeedRating?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Int']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  orientation?: InputMaybe<Image_ExifOrientation>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Input_Image_ImageDescriptionMsg = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Image_ImageDescriptionType>;
};

export type Input_Image_ImageMetadataMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Image_ImageDescriptionMsg>>>;
  exifInformation?: InputMaybe<Input_Image_ExifInformationMsg>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Knowledge_AllergenResult = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalAllergenIdResult>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_AllergenResultList = {
  allergens?: InputMaybe<Array<InputMaybe<Input_Knowledge_AllergenResult>>>;
};

export type Input_Knowledge_BFarmOpsCodeResultMsg = {
  categoryCode?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  chapterCode?: InputMaybe<Scalars['String']>;
  chapterName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codeRange?: InputMaybe<Input_Knowledge_BFarmOpsCodeResultMsg_CodeRange>;
  /** Display value */
  fullCategoryName?: InputMaybe<Scalars['String']>;
  generatedId?: InputMaybe<Scalars['Long']>;
  groupCode?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  hasSideReference?: InputMaybe<Scalars['Boolean']>;
  isAuxiliary?: InputMaybe<Scalars['Boolean']>;
  isLeaf?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['String']>;
  levelNumber?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentCode?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_BFarmOpsCodeResultMsg_CodeRange = {
  codeEnd?: InputMaybe<Scalars['String']>;
  codeStart?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_BillingCertificateTypeMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  groupCode?: InputMaybe<Scalars['String']>;
  groupDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_BodyPartList = {
  bodyParts?: InputMaybe<Array<InputMaybe<Input_Knowledge_BodyPartMsg>>>;
};

export type Input_Knowledge_BodyPartMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Knowledge_BodyPartLaterality>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_ClassificationSystemResult = {
  /** Fixed UUID */
  generalId?: InputMaybe<Scalars['String']>;
  /** Facet names for the different steps in that classification; required for faceted search for the clinical stages */
  steps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of the classification system */
  text?: InputMaybe<Scalars['String']>;
  /** Versions, e.g. if the system has different editions per year */
  versions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_ClassificationSystemResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_ClassificationSystemResult>>>;
};

export type Input_Knowledge_ClinicalStageResult = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_ClinicalStageResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_ClinicalStageResult>>>;
};

export type Input_Knowledge_CountryList = {
  countries?: InputMaybe<Array<InputMaybe<Input_Knowledge_CountryMsg>>>;
};

export type Input_Knowledge_CountryMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalCountryIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  isInDguv?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DenominationMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalDenominationIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DiagnosisCodingResult = {
  codingId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  system?: InputMaybe<Knowledge_DiagnosisCodingSystemResult>;
  systemVersion?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_DiagnosisCodeTypeResult>;
};

export type Input_Knowledge_DiagnosisDescriptionMsg = {
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DiagnosisInfoResult = {
  codes?: InputMaybe<Array<InputMaybe<Input_Knowledge_DiagnosisCodingResult>>>;
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DiagnosisInfoResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_DiagnosisInfoResult>>>;
};

export type Input_Knowledge_DkgDataElementMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

/** Filters that are relevant for limiting results for discharge reason digit three */
export type Input_Knowledge_DkgDischargeReasonDigitThreeFiltersMsg = {
  dischargeReasonDigitsOneTwo?: InputMaybe<Scalars['String']>;
  insuredPersonTypeCode?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DrugPackageUnitResult = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalDrugPackageUnitIdResult>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_DrugPackageUnitResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_DrugPackageUnitResult>>>;
};

export type Input_Knowledge_ExternalAllergenIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalAllergenIdType>;
};

export type Input_Knowledge_ExternalCountryIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalCountryIdType>;
};

export type Input_Knowledge_ExternalDenominationIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDenominationIdType>;
};

export type Input_Knowledge_ExternalDrugPackageIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDrugPackageIdType>;
};

export type Input_Knowledge_ExternalDrugPackageUnitIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDrugPackageUnitIdType>;
};

export type Input_Knowledge_ExternalLanguageIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalLanguageIdType>;
};

export type Input_Knowledge_ExternalMedicationDosageFormulaUnitIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationDosageFormulaUnitIdType>;
};

export type Input_Knowledge_ExternalMedicationDosageUnitIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export type Input_Knowledge_ExternalMedicationFlowRateFormulaUnitIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationFlowRateFormulaUnitIdType>;
};

export type Input_Knowledge_ExternalMedicationFlowRateUnitIdResult = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationFlowRateUnitIdType>;
};

export type Input_Knowledge_ExternalMedicationIntakeIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationIntakeIdType>;
};

export type Input_Knowledge_ExternalNationalityIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalNationalityIdType>;
};

export type Input_Knowledge_Facet = {
  column?: InputMaybe<Scalars['String']>;
  /** MeiliSearch only allows for faceted search on string data */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_FindCountriesRequest = {
  /** all countries that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalCountryIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_FindCountriesResponse = {
  countries?: InputMaybe<Array<InputMaybe<Input_Knowledge_CountryMsg>>>;
};

export type Input_Knowledge_FindDenominationsRequest = {
  /** all denominations that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalDenominationIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_FindDenominationsResponse = {
  denominations?: InputMaybe<Array<InputMaybe<Input_Knowledge_DenominationMsg>>>;
};

export type Input_Knowledge_FindDocumentTypesRequest = {
  /** all document types that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Document_DocumentTypeExternalIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_FindDocumentTypesResponse = {
  documentTypes?: InputMaybe<Array<InputMaybe<Input_Document_DocumentTypeMsg>>>;
};

export type Input_Knowledge_FindNationalitiesRequest = {
  /** all nationalities that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalNationalityIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_FindNationalitiesResponse = {
  nationalities?: InputMaybe<Array<InputMaybe<Input_Knowledge_NationalityMsg>>>;
};

export type Input_Knowledge_FindOrphaIdCodesRequest = {
  codings?: InputMaybe<Array<InputMaybe<Input_Knowledge_DiagnosisCodingResult>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_FindOrphaIdCodesResponse = {
  foundCodes?: InputMaybe<Input_Knowledge_DiagnosisInfoResultList>;
};

export type Input_Knowledge_FindWopsRequest = {
  wopCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_FindWopsResponse = {
  wops?: InputMaybe<Array<InputMaybe<Input_Knowledge_WopMsg>>>;
};

export type Input_Knowledge_GetCountriesRequest = {
  /** all countries that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalCountryIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_GetDischargeHospitalRequirementRequest = {
  /** only two digits */
  dischargeReasonDigitsOneTwo?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_GetDischargeHospitalRequirementResponse = {
  dischargeHospitalRequirementStatus?: InputMaybe<Knowledge_DischargeHospitalRequirementStatus>;
};

export type Input_Knowledge_GetIcd10DescriptionsRequest = {
  icd10Codes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_GetIcd10DescriptionsResponse = {
  icd10CodeToDescription?: InputMaybe<Array<InputMaybe<Input_Knowledge_GetIcd10DescriptionsResponse_Icd10CodeToDescriptionEntry>>>;
};

export type Input_Knowledge_GetIcd10DescriptionsResponse_Icd10CodeToDescriptionEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Knowledge_DiagnosisDescriptionMsg>;
};

export type Input_Knowledge_GetIcd10DiagnosisInfosRequest = {
  icd10Codes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_GetLanguagesRequest = {
  /** all languages that match at least one of the specified externalIds are returned */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalLanguageIdMsg>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
};

export type Input_Knowledge_GetOpsKbvCodesRequest = {
  opsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_GetOpsKbvCodesResponse = {
  opsCodeToOpsResult?: InputMaybe<Array<InputMaybe<Input_Knowledge_GetOpsKbvCodesResponse_OpsCodeToOpsResultEntry>>>;
};

export type Input_Knowledge_GetOpsKbvCodesResponse_OpsCodeToOpsResultEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Knowledge_OpsResultMsg>;
};

export type Input_Knowledge_IntakeMechanismMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  isInstantaneous?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_IntakeTypeMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalMedicationIntakeIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Knowledge_IntakeTypeTag>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_IntakeTypeResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_IntakeTypeMsg>>>;
};

export type Input_Knowledge_KbvDataElementMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  generalId?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_KbvFormFieldGroup36Msg = {
  code?: InputMaybe<Scalars['String']>;
  generalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_KnowledgeSearchRequest = {
  dataset?: InputMaybe<Knowledge_KnowledgeDataset>;
  facets?: InputMaybe<Array<InputMaybe<Input_Knowledge_Facet>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_KvdtDataElementMsg = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_LanguageList = {
  languages?: InputMaybe<Array<InputMaybe<Input_Knowledge_LanguageMsg>>>;
};

export type Input_Knowledge_LanguageMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalLanguageIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_ListBodyPartsRequest = {
  generalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_ListSpecialistGroupDataRequest = {
  dataset?: InputMaybe<Knowledge_KbvDataset>;
  specialistGroupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_ListSpecialistGroupDataResponse = {
  specialistGroupData?: InputMaybe<Array<InputMaybe<Input_Knowledge_KbvDataElementMsg>>>;
};

export type Input_Knowledge_MapGermanBillingCaseDetailCodesRequest = {
  billingCaseDetails?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingCaseDetailsMsg>>>;
};

export type Input_Knowledge_MapGermanBillingCaseDetailCodesResponse = {
  billingCaseDetailIdToCodes?: InputMaybe<Array<InputMaybe<Input_Knowledge_MapGermanBillingCaseDetailCodesResponse_BillingCaseDetailIdToCodesEntry>>>;
};

export type Input_Knowledge_MapGermanBillingCaseDetailCodesResponse_BillingCaseDetailIdToCodesEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_German_BillingCaseDetailCodesMsg>;
};

export type Input_Knowledge_MapGermanBillingCertificateCodesRequest = {
  billingCertificates?: InputMaybe<Array<InputMaybe<Input_Billing_German_BillingCertificateMsg>>>;
};

export type Input_Knowledge_MapGermanBillingCertificateCodesResponse = {
  billingCertificateIdToCodes?: InputMaybe<Array<InputMaybe<Input_Knowledge_MapGermanBillingCertificateCodesResponse_BillingCertificateIdToCodesEntry>>>;
};

export type Input_Knowledge_MapGermanBillingCertificateCodesResponse_BillingCertificateIdToCodesEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_German_BillingCertificateCodesMsg>;
};

export type Input_Knowledge_MapGermanCoverageInformationCodesRequest = {
  germanCoverageInfos?: InputMaybe<Array<InputMaybe<Input_Billing_German_GermanStatutoryCoverageInformationMsg>>>;
};

export type Input_Knowledge_MapGermanCoverageInformationCodesResponse = {
  coverageInfoIdToCodeDetails?: InputMaybe<Array<InputMaybe<Input_Knowledge_MapGermanCoverageInformationCodesResponse_CoverageInfoIdToCodeDetailsEntry>>>;
};

export type Input_Knowledge_MapGermanCoverageInformationCodesResponse_CoverageInfoIdToCodeDetailsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Billing_German_GermanCoverageInformationCodeDetailsMsg>;
};

export type Input_Knowledge_MapGermanLabBillingCodesRequest = {
  analyteCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Knowledge_MapGermanLabBillingCodesResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Billing_German_RingTestCertificateDetailsMsg>>>;
};

export type Input_Knowledge_MedicationDosageFormulaUnitResult = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalMedicationDosageFormulaUnitIdResult>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_MedicationDosageFormulaUnitResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_MedicationDosageFormulaUnitResult>>>;
};

export type Input_Knowledge_MedicationDosageUnitResult = {
  excludeForSingleIntake?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalMedicationDosageUnitIdResult>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_MedicationDosageUnitResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_MedicationDosageUnitResult>>>;
};

export type Input_Knowledge_MedicationFlowRateFormulaUnitResult = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalMedicationFlowRateFormulaUnitIdResult>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_MedicationFlowRateFormulaUnitResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_MedicationFlowRateFormulaUnitResult>>>;
};

export type Input_Knowledge_MedicationFlowRateUnitResult = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalMedicationFlowRateUnitIdResult>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_MedicationFlowRateUnitResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_MedicationFlowRateUnitResult>>>;
};

export type Input_Knowledge_NationalityMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Knowledge_ExternalNationalityIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  isInDguv?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_OpsResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_OpsResultMsg>>>;
};

export type Input_Knowledge_OpsResultMsg = {
  /** German "Kategorie zum OPS-Code gem. Anlage 1 zum Vertrag nach § 115 b Abs. 1 SGB V" */
  kz115b?: InputMaybe<Knowledge_Kz115bType>;
  /** kz115b = "s" => KZ115bType.S */
  kz155bInfo?: InputMaybe<Scalars['String']>;
  opsCode?: InputMaybe<Scalars['String']>;
  opsVersion?: InputMaybe<Scalars['String']>;
  /** ob die Übermittelung eines Kennzeichens für die Seitenlokalisation notwendig ist. */
  requireLaterality?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  /** Kennzeichnung gem. Punkt 17 der Präambel des Anhangs 2 zum EBM */
  validMedicalJustification?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Knowledge_PractitionerQualificationList = {
  qualifications?: InputMaybe<Array<InputMaybe<Input_Knowledge_QualificationResult>>>;
};

export type Input_Knowledge_QualificationResult = {
  code?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchBFarmOpsCodesRequest = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facets?: InputMaybe<Array<InputMaybe<Input_Knowledge_Facet>>>;
  isLeaf?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
  level?: InputMaybe<Scalars['String']>;
  levelNumber?: InputMaybe<Scalars['Int']>;
  parentCode?: InputMaybe<Scalars['String']>;
  searchLimit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Input_Knowledge_SearchBFarmOpsCodesResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_BFarmOpsCodeResultMsg>>>;
};

export type Input_Knowledge_SearchBillingCertificateTypesRequest = {
  /** allows searching on subset of codes */
  facets?: InputMaybe<Array<InputMaybe<Input_Knowledge_Facet>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  typeGroup?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchBillingCertificateTypesResponse = {
  types?: InputMaybe<Array<InputMaybe<Input_Knowledge_BillingCertificateTypeMsg>>>;
};

export type Input_Knowledge_SearchClinicalStagesRequest = {
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Value of the facet for classification step, obtained from ClassificationSystemResult */
  step?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchCountriesResponse = {
  countries?: InputMaybe<Array<InputMaybe<Input_Knowledge_CountryMsg>>>;
};

export type Input_Knowledge_SearchDenominationsResponse = {
  denominations?: InputMaybe<Array<InputMaybe<Input_Knowledge_DenominationMsg>>>;
};

export type Input_Knowledge_SearchDiagnosisInfoRequest = {
  diagnosisDataset?: InputMaybe<Knowledge_DiagnosisDataset>;
  facets?: InputMaybe<Array<InputMaybe<Input_Knowledge_Facet>>>;
  language?: InputMaybe<Knowledge_SearchLanguage>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchDkgDataRequest = {
  dataset?: InputMaybe<Knowledge_DkgDataset>;
  dischargeReasonDigitThreeFilters?: InputMaybe<Input_Knowledge_DkgDischargeReasonDigitThreeFiltersMsg>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchDkgDataResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_DkgDataElementMsg>>>;
};

export type Input_Knowledge_SearchKbvDataRequest = {
  dataset?: InputMaybe<Knowledge_KbvDataset>;
  /** allows searching on subset of codes */
  facets?: InputMaybe<Array<InputMaybe<Input_Knowledge_Facet>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchKbvDataResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_KbvDataElementMsg>>>;
};

export type Input_Knowledge_SearchKvdtDataRequest = {
  dataset?: InputMaybe<Knowledge_KvdtDataset>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchKvdtDataResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_KvdtDataElementMsg>>>;
};

export type Input_Knowledge_SearchNationalitiesResponse = {
  nationalities?: InputMaybe<Array<InputMaybe<Input_Knowledge_NationalityMsg>>>;
};

export type Input_Knowledge_SearchResult = {
  /** only filled for data sets that contain configurations, e.g., body parts, localisation */
  configurations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_SearchResult>>>;
};

export type Input_Knowledge_SearchResultOptional = {
  searchResult?: InputMaybe<Input_Knowledge_SearchResult>;
  searchResultFound?: InputMaybe<Scalars['Boolean']>;
};

/** generated_id|level|id|name|description|value_set_parent|code_system_parent|value_parent|abstract|deprecated|nullFlavor */
export type Input_Knowledge_SearchTelematikCodesRequest = {
  searchTerm?: InputMaybe<Scalars['String']>;
  valueSet?: InputMaybe<Knowledge_TelematikValueSet>;
};

export type Input_Knowledge_SearchTelematikCodesResponse = {
  telematikCodes?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikCodeMsg>>>;
};

export type Input_Knowledge_SearchWopsRequest = {
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_SearchWopsResponse = {
  wops?: InputMaybe<Array<InputMaybe<Input_Knowledge_WopMsg>>>;
};

export type Input_Knowledge_TubeTypeResult = {
  generalId?: InputMaybe<Scalars['String']>;
  hasBronchialCuffPressure?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Knowledge_TubeTypeResultList = {
  results?: InputMaybe<Array<InputMaybe<Input_Knowledge_TubeTypeResult>>>;
};

export type Input_Knowledge_WopMsg = {
  name?: InputMaybe<Scalars['String']>;
  wopCode?: InputMaybe<Scalars['String']>;
};

/** Substance that is subject of a laboratory's analysis */
export type Input_Lab_AnalyteMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** LOINC is the accepted standard for laboratory information */
  loincComponentCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Analytes can be classified in a tree-like structure; this references the parent. */
  parentId?: InputMaybe<Scalars['String']>;
  shortKey?: InputMaybe<Scalars['String']>;
  synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Lab_AnalyteType>;
};

export type Input_Lab_AnalyteUnitMsg = {
  code?: InputMaybe<Scalars['String']>;
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_AnalyteValueBasicInfoMsg = {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  categoryValue?: InputMaybe<Input_Category_ResultCategoryMsg>;
  comment?: InputMaybe<Scalars['String']>;
  conspicuous?: InputMaybe<Scalars['Boolean']>;
  decimalRangeValue?: InputMaybe<Input_DecimalRangeMsg>;
  decimalValue?: InputMaybe<Input_DecimalMsg>;
  id?: InputMaybe<Scalars['String']>;
  intValue?: InputMaybe<Scalars['Int']>;
  interpretationCodes?: InputMaybe<Array<InputMaybe<Lab_AnalyteValueInterpretation>>>;
  ratioValue?: InputMaybe<Input_RatioMsg>;
  status?: InputMaybe<Lab_AnalyteValueStatus>;
  textValue?: InputMaybe<Scalars['String']>;
  valueUpdatedAt?: InputMaybe<Input_Timestamp>;
};

export type Input_Lab_AnalyteValueCommentMsg = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Lab_AnalyteValueCommentType>;
};

export type Input_Lab_AnalyteValueList = {
  values?: InputMaybe<Array<InputMaybe<Input_Lab_AnalyteValueMsg>>>;
};

/** Value of an analyte measured through a test */
export type Input_Lab_AnalyteValueMsg = {
  analyte?: InputMaybe<Input_Lab_TestAnalyteMsg>;
  boolValue?: InputMaybe<Scalars['Boolean']>;
  categoryValue?: InputMaybe<Input_Category_ResultCategoryMsg>;
  comment?: InputMaybe<Scalars['String']>;
  conspicuous?: InputMaybe<Scalars['Boolean']>;
  decimalRangeValue?: InputMaybe<Input_DecimalRangeMsg>;
  decimalValue?: InputMaybe<Input_DecimalMsg>;
  emergency?: InputMaybe<Scalars['Boolean']>;
  /** False if there are multiple revisions of this value */
  firstRevision?: InputMaybe<Scalars['Boolean']>;
  /** Identifier to group different versions of the same result */
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intValue?: InputMaybe<Scalars['Int']>;
  interpretationCodes?: InputMaybe<Array<InputMaybe<Lab_AnalyteValueInterpretation>>>;
  ratioValue?: InputMaybe<Input_RatioMsg>;
  /** Reference ranges that apply to this value based on patient characteristics */
  referenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  /** Reference ranges that apply to the relative value based on patient characteristics */
  relativeReferenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  /** In some tests, the value is provided both as absolute and as relative */
  relativeValue?: InputMaybe<Input_DecimalRangeMsg>;
  /** Whether the relative value is conspicuous, can differ from the conspicuousness of the standard value */
  relativeValueConspicuous?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether this value was created as a result of a LabRequest;
   *  false if added from within LabTask
   */
  requested?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Lab_AnalyteValueStatus>;
  textValue?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  typedComments?: InputMaybe<Array<InputMaybe<Input_Lab_AnalyteValueCommentMsg>>>;
  /** If the result was automatically fetched from a device, the ID of that device */
  updaterDeviceId?: InputMaybe<Scalars['String']>;
  /** user id of user who last modified the result */
  updaterId?: InputMaybe<Scalars['String']>;
  /** organizational unit Id of user who last modified the result */
  updaterOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /**
   * manually updated timestamp of last value update
   *  required, as the updatedAt timestamp gets updated on replacement of this value with its postscript
   */
  valueUpdatedAt?: InputMaybe<Input_Timestamp>;
};

export type Input_Lab_CalculateFeeCodesRequest = {
  labTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_CalculateFeeCodesResponse = {
  feeCodes?: InputMaybe<Array<InputMaybe<Input_Lab_MedicalFeeCodeMsg>>>;
  labTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_CreateFeeCodeRequest = {
  labTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_DeleteFeeCodeRequest = {
  feeCodeId?: InputMaybe<Scalars['String']>;
  labTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_DeleteFeeCodeResponse = {
  deletedFeeCodeId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_MaterialAmountMsg = {
  doubleAmount?: InputMaybe<Scalars['Float']>;
  intAmount?: InputMaybe<Scalars['Int']>;
  /** If the specific amount is of no interest as long as the material is present */
  presence?: InputMaybe<Scalars['Boolean']>;
  unitGeneralId?: InputMaybe<Scalars['String']>;
};

export type Input_Lab_MaterialInstanceMsg = {
  amount?: InputMaybe<Input_Lab_MaterialAmountMsg>;
  collectionDate?: InputMaybe<Input_Timestamp>;
  comment?: InputMaybe<Scalars['String']>;
  currentLocation?: InputMaybe<Input_Lab_SampleLocationReferenceMsg>;
  expiryDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  /** As some machines can only process very basic ids, this simplified sample key may be used to identify samples */
  machineSampleKey?: InputMaybe<Scalars['String']>;
  receiptDate?: InputMaybe<Input_Timestamp>;
  sampleKey?: InputMaybe<Scalars['String']>;
  /** If the material is a sample, this is the body part from which the sample was extracted */
  sampleLocalization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** The number within the request */
  sampleNumber?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Lab_MaterialStatus>;
  taskStatus?: InputMaybe<Lab_MaterialTaskStatus>;
  type?: InputMaybe<Input_Lab_MaterialTypeMsg>;
};

export type Input_Lab_MaterialRequirementMsg = {
  amount?: InputMaybe<Input_Lab_MaterialAmountMsg>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Input_Lab_MaterialTypeMsg>;
};

export type Input_Lab_MaterialRequirementSetListMsg = {
  MaterialRequirementSets?: InputMaybe<Array<InputMaybe<Input_Lab_MaterialRequirementSetMsg>>>;
};

/** A set of requirements that must be fulfilled at once */
export type Input_Lab_MaterialRequirementSetMsg = {
  id?: InputMaybe<Scalars['String']>;
  informationText?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Array<InputMaybe<Input_Lab_MaterialRequirementMsg>>>;
};

export type Input_Lab_MaterialTypeList = {
  materialTypes?: InputMaybe<Array<InputMaybe<Input_Lab_MaterialTypeMsg>>>;
};

export type Input_Lab_MaterialTypeMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

export type Input_Lab_MedicalFeeCodeList = {
  codes?: InputMaybe<Array<InputMaybe<Input_Lab_MedicalFeeCodeMsg>>>;
};

export type Input_Lab_MedicalFeeCodeMsg = {
  description?: InputMaybe<Scalars['String']>;
  /** The identifier in the given system */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** How many times this code should be billed */
  quantity?: InputMaybe<Scalars['Int']>;
  system?: InputMaybe<Lab_MedicalFeeCodeSystem>;
  /** Value that determines the fee */
  value?: InputMaybe<Scalars['Float']>;
};

export type Input_Lab_SampleLocationReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Lab_SampleLocationType>;
};

export type Input_Lab_TestAnalyteBasicInfoMsg = {
  analyte?: InputMaybe<Input_Lab_AnalyteMsg>;
  id?: InputMaybe<Scalars['String']>;
  referenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  relativeReferenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  resultType?: InputMaybe<Lab_AnalyteResultType>;
  unit?: InputMaybe<Input_Lab_AnalyteUnitMsg>;
};

/** This allows grouping TestAnalytes under the specified group name when displaying the TestAnalytes */
export type Input_Lab_TestAnalyteGroupMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Order in which the groups should be displayed within the test */
  order?: InputMaybe<Scalars['Int']>;
};

/** For each test, an analyte gets combined with additional information, e.g., type of results, required material */
export type Input_Lab_TestAnalyteMsg = {
  analyte?: InputMaybe<Input_Lab_AnalyteMsg>;
  /** If the analyte results are categorical, this specifies the possible categories */
  categorySystem?: InputMaybe<Input_Category_ResultCategorySystemMsg>;
  /** Used for updating LabTask's feeCodes automatically */
  connectedFeeCodes?: InputMaybe<Array<InputMaybe<Input_Lab_MedicalFeeCodeMsg>>>;
  /** Whether free text can be entered in addition to the result */
  enableComment?: InputMaybe<Scalars['Boolean']>;
  /** Whether further categories apart from those defined in the categorySystem can be entered */
  enableCustomCategory?: InputMaybe<Scalars['Boolean']>;
  /** Whether a relative value can be entered in addition to the standard value */
  enableRelativeValue?: InputMaybe<Scalars['Boolean']>;
  /** For double values, number of digits behind the decimal point */
  fractionDigits?: InputMaybe<Scalars['Int']>;
  /** Number of digits behind the decimal point for the relative value */
  fractionDigitsRelative?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Input_Lab_TestAnalyteGroupMsg>;
  id?: InputMaybe<Scalars['String']>;
  loincCode?: InputMaybe<Scalars['String']>;
  /**
   * list of requirement sets - if one of the sets in the list is fully provided,
   *  this TestAnalyte's material requirements are fulfilled
   */
  materialRequirementOptions?: InputMaybe<Array<InputMaybe<Input_Lab_MaterialRequirementSetMsg>>>;
  referenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  relativeReferenceRanges?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeMsg>>>;
  resultType?: InputMaybe<Lab_AnalyteResultType>;
  unit?: InputMaybe<Input_Lab_AnalyteUnitMsg>;
};

export type Input_Lab_UpdateFeeCodeRequest = {
  feeCode?: InputMaybe<Input_Lab_MedicalFeeCodeMsg>;
  labTaskId?: InputMaybe<Scalars['String']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Letter_ClinicalRequestLetterList = {
  letters?: InputMaybe<Array<InputMaybe<Input_Letter_ClinicalRequestLetterMsg>>>;
};

export type Input_Letter_ClinicalRequestLetterMsg = {
  actions?: InputMaybe<Array<InputMaybe<Input_Letter_LetterActionMsg>>>;
  attachments?: InputMaybe<Array<InputMaybe<Input_Letter_LetterAttachmentReferenceMsg>>>;
  category?: InputMaybe<Input_Letter_LetterCategoryMsg>;
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  /** userId of letter creator */
  creatorId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  /** Id of document in document server */
  documentId?: InputMaybe<Scalars['String']>;
  /** Used to group the "same" letter in different stages, e.g., a preliminary version and a final version based on the preliminary one */
  groupId?: InputMaybe<Scalars['String']>;
  /** Content of the letter in html format */
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  letterClass?: InputMaybe<Letter_LetterClass>;
  letterDate?: InputMaybe<Input_Timestamp>;
  /** If true, the current text cannot be changed unless the letter is explicitly unlocked */
  locked?: InputMaybe<Scalars['Boolean']>;
  optionalInformation?: InputMaybe<Input_Letter_OptionalInformationMsg>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<Array<InputMaybe<Input_Letter_LetterRecipientMsg>>>;
  sendingMethods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
  signatoryRequests?: InputMaybe<Array<InputMaybe<Input_Signature_SignatureMsg>>>;
  signed?: InputMaybe<Scalars['Boolean']>;
  stage?: InputMaybe<Letter_LetterStage>;
  status?: InputMaybe<Letter_LetterStatus>;
  subject?: InputMaybe<Scalars['String']>;
  /** If true, the current text is kept in sync with the information entered through the treatment */
  synced?: InputMaybe<Scalars['Boolean']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** Location from which the letter file can be accessed */
  url?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_ClinicalRequestLetterResultList = {
  hitCount?: InputMaybe<Scalars['Int']>;
  letters?: InputMaybe<Array<InputMaybe<Input_Letter_ClinicalRequestLetterMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_CreateOrUpdateClinicalRequestLetterRequest = {
  letter?: InputMaybe<Input_Letter_ClinicalRequestLetterMsg>;
  /**
   * If not set, either the old template for this letter (if the letter already exists)
   *  or the default template for the organizationalUnitId (if the letter does not yet exist) will be used.
   */
  newLetterTemplateId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_CreateOrUpdateLetterCategoryRequest = {
  letterCategory?: InputMaybe<Input_Letter_LetterCategoryMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Letter_CreateOrUpdateLetterTemplateRequest = {
  letterTemplate?: InputMaybe<Input_Letter_LetterTemplateMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Letter_CreateSignatureRequest = {
  assignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  letterId?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Letter_CreateSignaturesRequest = {
  /** This letter id will be used, not the letter id field inside CreateSignatureRequest */
  letterId?: InputMaybe<Scalars['String']>;
  requests?: InputMaybe<Array<InputMaybe<Input_Letter_CreateSignatureRequest>>>;
};

export type Input_Letter_CustomLetterRecipientMsg = {
  additional?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Input_Core_AddressMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_DeleteLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_DeleteLetterResponse = {
  deletedLetterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_DeleteSignatureRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  signatureId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_DeleteSignaturesRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  signatureIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Letter_GetClinicalRequestLetterDocumentRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetClinicalRequestLetterRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  letterGroupId?: InputMaybe<Scalars['String']>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetClinicalRequestLetterTextRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetClinicalRequestLetterTextResponse = {
  html?: InputMaybe<Scalars['String']>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetClinicalRequestReportExistencesRequest = {
  clinicalRequestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Letter_GetClinicalRequestReportExistencesResponse = {
  reportExistenceEntries?: InputMaybe<Array<InputMaybe<Input_Letter_ReportExistenceEntry>>>;
};

export type Input_Letter_GetDefaultLetterCategoryRequest = {
  /** optional; if not set, the default department of the organizationalUnit is used */
  departmentId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<Letter_LetterClass>;
};

export type Input_Letter_GetDefaultLetterTemplateRequest = {
  /** can be set instead of organizationalUnitId; is ignored if organizationalUnitId is set */
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional; if not set, the default department of the organizationalUnit is used */
  departmentId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<Letter_LetterClass>;
};

export type Input_Letter_GetLetterActionHistoryRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetLetterCategoryRequest = {
  categoryId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_GetLetterTemplateRequest = {
  templateId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_LetterActionList = {
  actions?: InputMaybe<Array<InputMaybe<Input_Letter_LetterActionMsg>>>;
};

export type Input_Letter_LetterActionMsg = {
  date?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  /** An action performed on an older version (not latest) */
  obsolete?: InputMaybe<Scalars['Boolean']>;
  /** Only set for 'send' and 'revert send' action */
  sendingMethods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
  signatureActionData?: InputMaybe<Input_Signature_SignatureActionDataMsg>;
  type?: InputMaybe<Letter_LetterActionType>;
  userId?: InputMaybe<Scalars['String']>;
  /** If the action is 'send' or 'publish', id of the sent/published version */
  versionId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_LetterAttachmentReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Letter_LetterAttachmentType>;
};

export type Input_Letter_LetterCategoryAssignmentMsg = {
  type?: InputMaybe<Letter_LetterClass>;
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Letter_LetterCategoryList = {
  categories?: InputMaybe<Array<InputMaybe<Input_Letter_LetterCategoryMsg>>>;
};

export type Input_Letter_LetterCategoryMsg = {
  defaultAssignments?: InputMaybe<Array<InputMaybe<Input_Letter_LetterCategoryAssignmentMsg>>>;
  /** Can be empty; set if a non-standard document type should be set when releasing letters of this category as documents */
  documentType?: InputMaybe<Document_DocumentType>;
  documentTypeExternalIds?: InputMaybe<Array<InputMaybe<Input_Document_DocumentTypeExternalIdMsg>>>;
  gender?: InputMaybe<Letter_GrammaticalGender>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerAssignments?: InputMaybe<Array<InputMaybe<Input_Letter_LetterCategoryAssignmentMsg>>>;
  printSettings?: InputMaybe<Input_Letter_LetterCategoryPrintSettingsMsg>;
};

export type Input_Letter_LetterCategoryPrintSettingsMsg = {
  hidePatientInformation?: InputMaybe<Scalars['Boolean']>;
  hideRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  hideRecipients?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Letter_LetterRecipientList = {
  recipients?: InputMaybe<Array<InputMaybe<Input_Letter_LetterRecipientMsg>>>;
};

export type Input_Letter_LetterRecipientMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  organizationName?: InputMaybe<Scalars['String']>;
  recipientId?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Core_Sex>;
  type?: InputMaybe<Letter_LetterRecipientType>;
};

export type Input_Letter_LetterTemplateList = {
  templates?: InputMaybe<Array<InputMaybe<Input_Letter_LetterTemplateMsg>>>;
};

export type Input_Letter_LetterTemplateMsg = {
  /**
   * The units for which the letter template is the default.
   *  One unit must have exactly one active default template for any type for which it has at least one active template.
   *  All default units must be part of the ownerAdministrativeUnits or its children.
   */
  defaultAdministrativeUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  groupId?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** The units in which the template is registered. */
  ownerAdministrativeUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  status?: InputMaybe<Letter_LetterTemplateStatus>;
  templateType?: InputMaybe<Letter_LetterClass>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Letter_ListLetterCategoriesRequest = {
  categoryAssignment?: InputMaybe<Input_Letter_LetterCategoryAssignmentMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: InputMaybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Letter_ListLetterTemplatesRequest = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: InputMaybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  templateType?: InputMaybe<Letter_LetterClass>;
};

export type Input_Letter_ListLetterVersionsRequest = {
  groupId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_ListLettersRequest = {
  /** Assignee. At least one of creatorUserId and Assignee must be specified. */
  assignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  /** Optional: search only letters that the user still has to sign. For closed/open tabs */
  awaitingSignatureFilter?: InputMaybe<Scalars['Boolean']>;
  /** creatorUserId. At least one of creatorUserId and Assignee must be specified. */
  creatorUserId?: InputMaybe<Scalars['String']>;
  /** Optional: time range filter */
  endDate?: InputMaybe<Input_Timestamp>;
  /** Optional: letter categories */
  letterCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Otpinal filter */
  letterClasses?: InputMaybe<Array<InputMaybe<Letter_LetterClass>>>;
  /** Optional: search for letters that have none of these sending methods */
  missingSendingMethods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
  /** Optional: search for letters that have missing required signatures */
  missingSignature?: InputMaybe<Scalars['Boolean']>;
  /** Optional: True: get letters that the user has only optional signature requirements; False: the user has at least one required signature requirement; Null: all */
  optionalSignature?: InputMaybe<Scalars['Boolean']>;
  /** letterDate or timestamps.updatedAt can be used as an optional sorting variable */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  /** Optional: patient id filter */
  patientId?: InputMaybe<Scalars['String']>;
  /** Optional: scope filter */
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** Optional: sending methods */
  sendingMethods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
  /** Optional: letter types */
  stages?: InputMaybe<Array<InputMaybe<Letter_LetterStage>>>;
  /** Optional: time range filter */
  startDate?: InputMaybe<Input_Timestamp>;
  /** Optional: statuses */
  statuses?: InputMaybe<Array<InputMaybe<Letter_LetterStatus>>>;
  /** Optional filter */
  surgeryId?: InputMaybe<Scalars['String']>;
  /** Optional filter */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_LockLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

/** Optional formal information that will be displayed on the patient letter */
export type Input_Letter_OptionalInformationMsg = {
  department?: InputMaybe<Scalars['String']>;
  ourSign?: InputMaybe<Scalars['String']>;
  yourSign?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_RejectLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_ReportExistenceEntry = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  hasReport?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Letter_RevertLetterSendingRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  /**
   * At least one method must be selected - these methods will be removed;
   *  if no method remains, the letter's status returns to PUBLISHED.
   */
  methods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
};

export type Input_Letter_SearchLetterCategoriesRequest = {
  categoryAssignment?: InputMaybe<Input_Letter_LetterCategoryAssignmentMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: InputMaybe<Scalars['String']>;
  /** optional: defaults to False, if true, disables searching categories on the letter type */
  disableLetterTypeFilter?: InputMaybe<Scalars['Boolean']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: InputMaybe<Scalars['Boolean']>;
  /** optional; Set if pagination is desired; no sort options supported */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Letter_SearchLetterCategoriesResponse = {
  categories?: InputMaybe<Array<InputMaybe<Input_Letter_LetterCategoryMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Letter_SearchLetterTemplatesRequest = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: InputMaybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: InputMaybe<Scalars['Boolean']>;
  /** optional; Set if pagination is desired; no sort options supported */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  /** optional filter */
  templateType?: InputMaybe<Letter_LetterClass>;
};

export type Input_Letter_SearchLetterTemplatesResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  templates?: InputMaybe<Array<InputMaybe<Input_Letter_LetterTemplateMsg>>>;
};

export type Input_Letter_SendLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  /** At least one method must be selected */
  methods?: InputMaybe<Array<InputMaybe<Letter_LetterSendingMethod>>>;
};

export type Input_Letter_SignClinicalRequestLetterResponse = {
  /** Only set if no additional confirmation required */
  letter?: InputMaybe<Input_Letter_ClinicalRequestLetterMsg>;
  /** True if additional confirmation is required to sign the letter */
  publishingConfirmationRequired?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Letter_SignLetterRequest = {
  /**
   * The default value for this is false. Should be set to true only if the user additionally confirms publishing.
   *  If this signature is the last one needed in order to publish the letter and the flag is not set, an exception will be thrown.
   *  If this flag is set but the signature is not the last one needed, the flag will be ignored, signature will be created, the letter will not be published.
   *  If this flag is set but the letter is already published, the flag will be ignored.
   */
  confirmPublishing?: InputMaybe<Scalars['Boolean']>;
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_UnlockLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_UnsignLetterRequest = {
  letterId?: InputMaybe<Scalars['String']>;
};

export type Input_Letter_UpdateClinicalRequestLetterStatusRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Letter_LetterStatus>;
};

export type Input_Letter_UpdateLetterStatusRequest = {
  letterId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Letter_LetterStatus>;
};

export type Input_Letter_UpdateSignatureRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  signatoryRequest?: InputMaybe<Input_Signature_SignatureMsg>;
};

export type Input_Letter_UpdateSignaturesRequest = {
  /** This letter id will be used, if the signature does not belong to this letter, it will not be updated */
  letterId?: InputMaybe<Scalars['String']>;
  signatoryRequests?: InputMaybe<Array<InputMaybe<Input_Signature_SignatureMsg>>>;
};

export type Input_Medication_ExternalMedicationDosageFormulaUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationDosageFormulaUnitIdType>;
};

export type Input_Medication_ExternalMedicationDosageUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export type Input_Medication_MedicationDosageFormulaUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Medication_ExternalMedicationDosageFormulaUnitIdMsg>>>;
  target?: InputMaybe<Input_Medication_MedicationUnitTargetMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Medication_MedicationDosageUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Medication_ExternalMedicationDosageUnitIdMsg>>>;
  target?: InputMaybe<Input_Medication_MedicationUnitTargetMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Medication_MedicationDosageUnitPairMsg = {
  formulaUnit?: InputMaybe<Input_Medication_MedicationDosageFormulaUnitMsg>;
  unit?: InputMaybe<Input_Medication_MedicationDosageUnitMsg>;
};

export type Input_Medication_MedicationDosageValueMsg = {
  displayFraction?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type Input_Medication_MedicationDosageValuePairMsg = {
  formulaValue?: InputMaybe<Input_Medication_MedicationDosageValueMsg>;
  value?: InputMaybe<Input_Medication_MedicationDosageValueMsg>;
};

export type Input_Medication_MedicationUnitTargetMsg = {
  /** if set, the dosage unit refers to the specified activeIngredient */
  targetActiveIngredientId?: InputMaybe<Scalars['String']>;
  /** if set, the dosage unit refers to the specified MedicationComponent */
  targetComponentId?: InputMaybe<Scalars['String']>;
  /** if true, the unit refers to the whole medication */
  targetMedication?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Medication_MedicationUnitTargetType>;
};

export type Input_Patient_ActivateLegalInfoRequest = {
  careAidDisabilityId?: InputMaybe<Scalars['String']>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: InputMaybe<Validation_ExternalValidator>;
  invasiveProceduresLivingWillId?: InputMaybe<Scalars['String']>;
  legalGuardianshipId?: InputMaybe<Scalars['String']>;
  longTermCareId?: InputMaybe<Scalars['String']>;
  organDonationCardId?: InputMaybe<Scalars['String']>;
  /** Mandatory */
  patientId?: InputMaybe<Scalars['String']>;
  powerOfAttorneyId?: InputMaybe<Scalars['String']>;
  /** At least one of treatment id, visit id, externalValidator is needed if immediatelyActivate is set */
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ActivateLegalInfoResponse = {
  careAidDisability?: InputMaybe<Input_Patient_CareAidDisabilityMsg>;
  invasiveProceduresLivingWill?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: InputMaybe<Input_Patient_LegalGuardianshipMsg>;
  longTermCare?: InputMaybe<Input_Patient_LongTermCareMsg>;
  organDonationCard?: InputMaybe<Input_Patient_OrganDonationCardMsg>;
  powerOfAttorney?: InputMaybe<Input_Patient_PowerOfAttorneyMsg>;
};

export type Input_Patient_AddVisitIsolationsRequest = {
  isolations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_AdministrativeUnitIds = {
  /** currently unsupported */
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** currently unsupported */
  divisionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_AnonymousPatientMsg = {
  birthCountry?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  denomination?: InputMaybe<Input_Knowledge_DenominationMsg>;
  maritalStatus?: InputMaybe<Core_MaritalStatus>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  nationality?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Patient_AssignPatientsRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** whether to assign all open patients (true) or only unassigned ones (false) */
  reassign?: InputMaybe<Scalars['Boolean']>;
  /** physicians among whom the patients are distributed */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_CallPatientRequest = {
  roomId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CareAidDisabilityMsg = {
  careDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  careLevel?: InputMaybe<Patient_CareLevel>;
  careLevelAssessmentRequested?: InputMaybe<Scalars['Boolean']>;
  careLevelText?: InputMaybe<Scalars['String']>;
  /** In percent */
  degreeOfDisability?: InputMaybe<Scalars['Int']>;
  degreeOfDisabilityStatus?: InputMaybe<Patient_DegreeOfDisabilityStatusType>;
  degreeOfDisabilityText?: InputMaybe<Scalars['String']>;
  disabilityDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  medicalAidDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  medicalAidPresent?: InputMaybe<Scalars['Boolean']>;
  medicalAidText?: InputMaybe<Scalars['String']>;
  medicalAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_CollectAdditionalServicesRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  visitIdList?: InputMaybe<Input_Patient_VisitIdList>;
};

export type Input_Patient_CollectAdditionalServicesResponse = {
  visitIdToAdditionalServiceMaps?: InputMaybe<Array<InputMaybe<Input_Patient_VisitIdToAdditionalServiceMap>>>;
};

export type Input_Patient_CollectCurrentVisitorsRequest = {
  relevantVisitTypes?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_CollectCurrentVisitorsResponse = {
  currentVisitors?: InputMaybe<Array<InputMaybe<Input_Patient_CurrentVisitorResponseMsg>>>;
};

/**
 * We have to display the contact parties like a validatable block in the treatment,
 *  hence this message
 */
export type Input_Patient_ContactPartiesValidationMsg = {
  id?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_ContactPartyList = {
  contactParties?: InputMaybe<Array<InputMaybe<Input_Patient_ContactPartyMsg>>>;
};

/**
 * A patient's contact party.
 *  Can be a human or an organization.
 */
export type Input_Patient_ContactPartyMsg = {
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  birthCountryCode?: InputMaybe<Scalars['String']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  contactInformation?: InputMaybe<Input_Core_ContactMsg>;
  contactPartyDataSource?: InputMaybe<Patient_ContactPartyDataSource>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  denomination?: InputMaybe<Input_Knowledge_DenominationMsg>;
  designations?: InputMaybe<Array<InputMaybe<Patient_ContactPartyDesignation>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalContactPartyIdMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maritalStatus?: InputMaybe<Core_MaritalStatus>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  nationality?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  organizationName?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Input_Patient_ContactPartyScopeReferenceMsg>;
  sex?: InputMaybe<Core_Sex>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Patient_ContactPartyScopeReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ContactPartyScopeType>;
};

export type Input_Patient_CreateAdditionalServicesAssignmentRequest = {
  /** mandatory for status other than draft */
  additionalServiceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  /** mandatory for status other than draft */
  startTime?: InputMaybe<Input_Timestamp>;
  /** optional; if not set, defaults to DRAFT */
  status?: InputMaybe<Patient_Registry_AdditionalServicesAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreateAdditionalServicesAssignmentResponse = {
  createdAdditionalServicesAssignment?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>;
  /** set if the time of additional service assignment is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_CreateContactPartyRequest = {
  contactParty?: InputMaybe<Input_Patient_ContactPartyMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreateLeadingUnitAssignmentRequest = {
  /** If set, marks connection to place where this assignment was created from */
  origin?: InputMaybe<Input_Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  /** mandatory for status other than draft */
  startTime?: InputMaybe<Input_Timestamp>;
  /** optional; if not set, defaults to DRAFT */
  status?: InputMaybe<Patient_LeadingUnitAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: InputMaybe<Scalars['Boolean']>;
  /** mandatory for status other than draft */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** mandatory */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreateLeadingUnitAssignmentResponse = {
  /** provide created assignment explicitly, as assignments on case are sorted by date */
  createdUnitAssignment?: InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>;
  /** set if the time of leading unit assignment is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_CreateLegalInfoRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

/** Creates an editable revision if necessary */
export type Input_Patient_CreateOrUpdateLegalInfoRequest = {
  /** If there is an existing revision by another user, cancels it. */
  cancelExisting?: InputMaybe<Scalars['Boolean']>;
  careAidDisability?: InputMaybe<Input_Patient_CareAidDisabilityMsg>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: InputMaybe<Validation_ExternalValidator>;
  /** Immediately activates the editable revision and sets the validation. */
  immediatelyActivate?: InputMaybe<Scalars['Boolean']>;
  invasiveProceduresLivingWill?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: InputMaybe<Input_Patient_LegalGuardianshipMsg>;
  longTermCare?: InputMaybe<Input_Patient_LongTermCareMsg>;
  organDonationCard?: InputMaybe<Input_Patient_OrganDonationCardMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  /** Mandatory */
  patientId?: InputMaybe<Scalars['String']>;
  powerOfAttorney?: InputMaybe<Input_Patient_PowerOfAttorneyMsg>;
  /** If there is an existing revision by another user, takes it over. */
  takeOverExisting?: InputMaybe<Scalars['Boolean']>;
  /** At least one of treatment id, visit id, externalValidator is needed if immediatelyActivate is set */
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreateOrUpdateReasonsForIntroductionRequest = {
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_CreatePatientAbsenceRequest = {
  externalId?: InputMaybe<Input_Patient_ExternalPatientAbsenceIdMsg>;
  type?: InputMaybe<Patient_PatientAbsenceType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreatePatientOccupationRequest = {
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientOccupation?: InputMaybe<Input_Patient_PatientOccupationMsg>;
};

export type Input_Patient_CreatePatientRequest = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  createdFromExternal?: InputMaybe<Scalars['Boolean']>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  /** Optional only if external patient db is used */
  externalBillingCaseId?: InputMaybe<Scalars['String']>;
  /** deprecated fields; use externalPatientInfo instead */
  externalPatientId?: InputMaybe<Scalars['String']>;
  /** overrides external patient and system id */
  externalPatientInfo?: InputMaybe<Input_Patient_ExternalPatientIdMsg>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** If specified, the external ids are ignored, and the newly created patient has 'external' false */
  internalContext?: InputMaybe<Input_Patient_PatientContextMsg>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Patient_CreatePatientResponse = {
  /** If patient has been newly created */
  isNewPatient?: InputMaybe<Scalars['Boolean']>;
  patient?: InputMaybe<Input_Patient_PatientMsg>;
};

export type Input_Patient_CreateVisitNumberRequest = {
  /** TODO: Appointment */
  officeHourId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['String']>;
  targetTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Patient_CreateVisitNumberResponse = {
  number?: InputMaybe<Scalars['Int']>;
};

export type Input_Patient_CreateVisitTransferFromCurrentVisitDataRequest = {
  originOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  transferTime?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_CreateVisitTransferFromCurrentVisitDataResponse = {
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visitTransfer?: InputMaybe<Input_Patient_VisitTransferMsg>;
};

export type Input_Patient_CurrentVisitorResponseMsg = {
  patientId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeclarationMsg = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  declarationId?: InputMaybe<Scalars['String']>;
  extraInformation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageLink?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Patient_DeleteAdditionalServicesAssignmentRequest = {
  additionalServicesAssignmentId?: InputMaybe<Scalars['String']>;
  /**
   * If set, and if exists, the gap is filled by the next assignment.
   *  By default the gap is filled by the previous assignment, if both exists, or the only existing assignment.
   */
  fillWithTheNextAssignment?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_DeleteAdditionalServicesAssignmentResponse = {
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_DeleteContactPartyRequest = {
  contactPartyId?: InputMaybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Set if request comes from a treatment -> affects contact party validation */
  treatmentId?: InputMaybe<Scalars['String']>;
  /** Optional: Set if request comes from a visit -> affects contact party validation */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeleteContactPartyResponse = {
  contactPartiesValidation?: InputMaybe<Input_Patient_ContactPartiesValidationMsg>;
  deletedContactPartyId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeleteLeadingUnitAssignmentRequest = {
  /**
   * If set, and if exists, the gap is filled by the next assignment.
   *  By default the gap is filled by the previous assignment, if both exists, or the only existing assignment.
   */
  fillWithTheNextAssignment?: InputMaybe<Scalars['Boolean']>;
  leadingUnitAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeleteLeadingUnitAssignmentResponse = {
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_DeletePatientAbsenceRequest = {
  patientAbsenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeletePatientAbsenceResponse = {
  deletedPatientAbsenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeletePatientOccupationRequest = {
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patientOccupationId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeletePatientOccupationResponse = {
  deletedPatientOccupationId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeletePatientRequest = {
  /**
   * Means the source of the delete operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalDelete?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeletePatientResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeleteVisitTransferRequest = {
  visitTransferId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_DeleteVisitTransferResponse = {
  deletedVisitTransferId?: InputMaybe<Scalars['String']>;
  /**
   * when deleting last visit transfer visit will be updated
   *  static resource will be deleted
   */
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_ExternalContactPartyIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalContactPartyIdType>;
};

export type Input_Patient_ExternalMedicalQualificationIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalMedicalQualificationIdType>;
};

export type Input_Patient_ExternalPatientAbsenceIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalPatientAbsenceIdType>;
};

/** Reference to a patient ID of an external system */
export type Input_Patient_ExternalPatientIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  scope?: InputMaybe<Patient_ExternalIdScope>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalIdType>;
};

export type Input_Patient_ExternalPractitionerIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalPractitionerIdType>;
};

export type Input_Patient_ExternalVisitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalVisitIdType>;
};

export type Input_Patient_ExternalVisitTransferIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_ExternalVisitTransferIdType>;
};

export type Input_Patient_FindAdditionalServicesAssignmentRequest = {
  /** mandatory if origin is not set; will return the assignment that was active at that point in time */
  date?: InputMaybe<Input_Timestamp>;
  /** mandatory if visitId/date are not set */
  origin?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  /** mandatory if origin is not set */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FindAdditionalServicesAssignmentResponse = {
  additionalServicesAssignment?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_FindEarliestLeadingUnitAssignmentIdRequest = {
  leadingUnitAssignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_FindEarliestLeadingUnitAssignmentIdResponse = {
  leadingUnitAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FindLeadingUnitAssignmentRequest = {
  /** optional and used if neither origin nor visitId are set */
  billingCaseId?: InputMaybe<Scalars['String']>;
  /**
   * mandatory if origin is not set; will return the assignment that was active at that point in time
   *  or the assignment with the earliest start date if there are multiple ones with the given date
   */
  date?: InputMaybe<Input_Timestamp>;
  /** mandatory if visitId/date are not set */
  origin?: InputMaybe<Input_Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  /** mandatory if origin is not set */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FindLeadingUnitAssignmentResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  unitAssignment?: InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>;
};

export type Input_Patient_FindOrCreatePatientRequest = {
  externalId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FindOrCreatePatientResponse = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FindPatientRequest = {
  externalBillingCaseId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Input_Patient_ExternalPatientIdMsg>;
};

export type Input_Patient_FindVisitRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  excludedStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  /** at least one of the two is mandatory */
  externalId?: InputMaybe<Input_Patient_ExternalVisitIdMsg>;
  /** optional filters */
  includedStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_FindVisitResponse = {
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_FinishRegistrationRequest = {
  /** Set if billing case was updated */
  billingCaseId?: InputMaybe<Scalars['String']>;
  confirmBillingCaseTypeChange?: InputMaybe<Scalars['Boolean']>;
  /** Only considered if externalWrite and useCurrentOrganizationalUnitId are true */
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** Only provisional and completed are allowed */
  registrationStatus?: InputMaybe<Billing_RegistrationStatus>;
  /** Only considered if externalWrite and useTargetTime are true, and visit is of an outpatient type */
  targetTime?: InputMaybe<Input_Timestamp>;
  /** Only considered if externalWrite is true */
  useCurrentOrganizationalUnitId?: InputMaybe<Scalars['Boolean']>;
  /** Only considered if externalWrite is true */
  useTargetTime?: InputMaybe<Scalars['Boolean']>;
  /** Set if visit registration was updated */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_FinishRegistrationResponse = {
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_GermanVisitBgDetailsMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** Art der Heilbehandlung [sri_1] */
  therapeuticTreatmentBillingType?: InputMaybe<Billing_TherapeuticTreatmentBillingType>;
};

export type Input_Patient_GetAdditionalServicesAssignmentRequest = {
  additionalServicesAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetAdditionalServicesAssignmentResponse = {
  additionalServicesAssignment?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>;
};

export type Input_Patient_GetContactPartiesRequest = {
  contactPartyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetContactPartyRequest = {
  contactPartyId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetInvasiveProceduresLivingWillInfoRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetInvasiveProceduresLivingWillInfoResponse = {
  patientIdToInvasiveProceduresLivingWillInfo?: InputMaybe<Array<InputMaybe<Input_Patient_GetInvasiveProceduresLivingWillInfoResponse_PatientIdToInvasiveProceduresLivingWillInfoEntry>>>;
};

export type Input_Patient_GetInvasiveProceduresLivingWillInfoResponse_PatientIdToInvasiveProceduresLivingWillInfoEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillInfoMsg>;
};

export type Input_Patient_GetLeadingUnitAssignmentRequest = {
  leadingUnitAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetLeadingUnitAssignmentResponse = {
  leadingUnitAssignment?: InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>;
};

export type Input_Patient_GetLeadingUnitAssignmentsRequest = {
  leadingUnitAssignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetLeadingUnitAssignmentsResponse = {
  leadingUnitAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>>>;
};

export type Input_Patient_GetLeadingUnitReferencesRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetLeadingUnitReferencesResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Patient_GetLeadingUnitReferencesResponseEntry>>>;
};

export type Input_Patient_GetLeadingUnitReferencesResponseEntry = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  leadingUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Patient_GetLegalInfoRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetOrCreateVisitTransferRequest = {
  /** optional */
  externalId?: InputMaybe<Input_Patient_ExternalVisitTransferIdMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetOverallAdmissionAndDischargeDateRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  visitTypes?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_GetOverallAdmissionAndDischargeDateResponse = {
  admissionDate?: InputMaybe<Input_Timestamp>;
  dischargeDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Patient_GetPatientAbsenceRequest = {
  patientAbsenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetPatientOccupationRequest = {
  patientOccupationId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetPatientOccupationsRequest = {
  patientOccupationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetPatientRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetPatientsRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetRoomRequest = {
  roomId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetRoomsRequest = {
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetTriageSystemLevelRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetTriageSystemLevelResponse = {
  triageSystemLevel?: InputMaybe<Input_Patient_TriageSystemLevelMsg>;
};

export type Input_Patient_GetTriageSystemRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetVisitDatesFromBillingCasesRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetVisitDatesFromBillingCasesResponse = {
  visitDates?: InputMaybe<Array<InputMaybe<Input_Patient_GetVisitDatesFromBillingCasesResponseEntry>>>;
};

export type Input_Patient_GetVisitDatesFromBillingCasesResponseEntry = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  visitScheduleInfo?: InputMaybe<Input_Patient_VisitScheduleInfoMsg>;
};

export type Input_Patient_GetVisitDetailsRequest = {
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetVisitDetailsResponse = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  currentVisitType?: InputMaybe<Patient_VisitType>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetVisitRequest = {
  /** If set to true, only id will be set in PatientMsg in response message */
  omitFullPatient?: InputMaybe<Scalars['Boolean']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetVisitTransferRequest = {
  visitTransferId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_GetVisitsFinishDatesRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetVisitsFinishDatesResponse = {
  visitFinishDates?: InputMaybe<Array<InputMaybe<Input_Patient_VisitFinishDateMsg>>>;
};

export type Input_Patient_GetVisitsRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetVisitsStartDatesRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_GetVisitsStartDatesResponse = {
  visitStartDates?: InputMaybe<Array<InputMaybe<Input_Patient_VisitStartDateMsg>>>;
};

export type Input_Patient_HandleVisitOnTreatmentFinishRequest = {
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_InpatientVisitInfoMsg = {
  patientId?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_InsertHistoricVisitTransferRequest = {
  /** mandatory for status other than draft */
  endTime?: InputMaybe<Input_Timestamp>;
  /** id of visit transfer below is required */
  nextVisitTransferId?: InputMaybe<Scalars['String']>;
  originOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** mandatory for status other than draft */
  startTime?: InputMaybe<Input_Timestamp>;
  /** mandatory */
  targetOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_InsertHistoricVisitTransferResponse = {
  createdVisitTransfer?: InputMaybe<Input_Patient_VisitTransferMsg>;
  /** set if the time of transfer is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_InvasiveProceduresLivingWillInfoMsg = {
  id?: InputMaybe<Scalars['String']>;
  invasiveVentilationDesired?: InputMaybe<Scalars['Boolean']>;
  reanimationDesired?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_InvasiveProceduresLivingWillMsg = {
  artificialNutritionDesired?: InputMaybe<Scalars['Boolean']>;
  artificialNutritionFurtherDetails?: InputMaybe<Scalars['String']>;
  dialysisDesired?: InputMaybe<Scalars['Boolean']>;
  dialysisFurtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invasiveVentilationDesired?: InputMaybe<Scalars['Boolean']>;
  invasiveVentilationFurtherDetails?: InputMaybe<Scalars['String']>;
  livingWillCreationDate?: InputMaybe<Input_Timestamp>;
  livingWillDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  livingWillFurtherDetails?: InputMaybe<Scalars['String']>;
  livingWillPresent?: InputMaybe<Scalars['Boolean']>;
  livingWillStorageLocation?: InputMaybe<Input_Core_StorageLocationMsg>;
  reanimationDesired?: InputMaybe<Scalars['Boolean']>;
  reanimationFurtherDetails?: InputMaybe<Scalars['String']>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  transferToIcuDesired?: InputMaybe<Scalars['Boolean']>;
  transferToIcuFurtherDetails?: InputMaybe<Scalars['String']>;
  transfusionOfBloodProductsDesired?: InputMaybe<Scalars['Boolean']>;
  transfusionOfBloodProductsDetails?: InputMaybe<Scalars['String']>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_LastVisitInformation = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  visitTime?: InputMaybe<Input_TimeMsg>;
};

export type Input_Patient_LeadingUnitAssignmentMsg = {
  id?: InputMaybe<Scalars['String']>;
  leadingUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: InputMaybe<Input_Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  startTime?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Patient_LeadingUnitAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_LeadingUnitAssignmentOriginReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_LeadingUnitAssignmentOriginType>;
};

export type Input_Patient_LegalGuardianshipMsg = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legalGuardian?: InputMaybe<Input_Patient_ContactPartyMsg>;
  present?: InputMaybe<Scalars['Boolean']>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_LegalInformationMsg = {
  careAidDisability?: InputMaybe<Input_Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: InputMaybe<Input_Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: InputMaybe<Input_Patient_LegalGuardianshipMsg>;
  longTermCare?: InputMaybe<Input_Patient_LongTermCareMsg>;
  organDonationCard?: InputMaybe<Input_Patient_OrganDonationCardMsg>;
  powerOfAttorney?: InputMaybe<Input_Patient_PowerOfAttorneyMsg>;
};

export type Input_Patient_LinkAppointmentToVisitRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_LinkPatientRequest = {
  externalBillingCaseId?: InputMaybe<Scalars['String']>;
  externalPatientId?: InputMaybe<Scalars['String']>;
  /** The existing non-external patient id */
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListAdditionalServicesAssignmentsRequest = {
  /** either this or visitIds is mandatory */
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** either this or billingCaseId is mandatory */
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListAdditionalServicesAssignmentsResponse = {
  additionalServicesAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>>>;
};

export type Input_Patient_ListAssignedToUserPatientsRequest = {
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListLeadingUnitAssignmentsRequest = {
  /** either this or visitIds is mandatory */
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** either this or billingCaseId is mandatory */
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListLeadingUnitAssignmentsResponse = {
  leadingUnitAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>>>;
};

export type Input_Patient_ListLeadingUnitsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListLeadingUnitsResponse = {
  units?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_Patient_ListLegalInfoRevisionsRequest = {
  legalInfoType?: InputMaybe<Patient_LegalInfoType>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListLegalInfoRevisionsResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Patient_ListLegalInfoRevisionsResponseEntryMsg>>>;
};

export type Input_Patient_ListLegalInfoRevisionsResponseEntryMsg = {
  careAidDisability?: InputMaybe<Input_Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: InputMaybe<Input_Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: InputMaybe<Input_Patient_LegalGuardianshipMsg>;
  longTermCare?: InputMaybe<Input_Patient_LongTermCareMsg>;
  organDonationCard?: InputMaybe<Input_Patient_OrganDonationCardMsg>;
  powerOfAttorney?: InputMaybe<Input_Patient_PowerOfAttorneyMsg>;
};

export type Input_Patient_ListPatientAbsencesRequest = {
  statuses?: InputMaybe<Array<InputMaybe<Patient_PatientAbsenceStatus>>>;
  statusesToExclude?: InputMaybe<Array<InputMaybe<Patient_PatientAbsenceStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Patient_PatientAbsenceType>>>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListPatientAbsencesResponse = {
  patientAbsences?: InputMaybe<Array<InputMaybe<Input_Patient_PatientAbsenceMsg>>>;
};

export type Input_Patient_ListPatientOccupationsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListPatientsRequest = {
  addLastVisitInformation?: InputMaybe<Scalars['Boolean']>;
  /** When provided, patient service gets all patients with matching billing case information from billing service and filters the results based on them. */
  billingFilters?: InputMaybe<Input_Billing_ListBillingCasePatientsRequest>;
  /** optional filter */
  createdInOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  dateOfBirthSortOrder?: InputMaybe<Helper_SortOrder>;
  /** optional filter */
  external?: InputMaybe<Scalars['Boolean']>;
  /** The default order is first name ascending. */
  firstNameSortOrder?: InputMaybe<Helper_SortOrder>;
  hideDeceased?: InputMaybe<Scalars['Boolean']>;
  /** Sort instructions will not be used. Instead use explicit sort fields for first name and date of birth. */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  /** This would be doing the same as simply calling getPatient, however through this call, the last visit information may also be provided. */
  patientId?: InputMaybe<Scalars['String']>;
  sexFilters?: InputMaybe<Array<InputMaybe<Core_Sex>>>;
  /** When provided, patient service gets all patients with matching visits and filters the results based on them. */
  visitFilters?: InputMaybe<Input_Patient_ListPatientsRequestVisitFiltersMsg>;
};

export type Input_Patient_ListPatientsRequestVisitFiltersMsg = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  includePlannedAdmission?: InputMaybe<Scalars['Boolean']>;
  includePlannedDischarge?: InputMaybe<Scalars['Boolean']>;
  leadingUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  registrationStatuses?: InputMaybe<Array<InputMaybe<Billing_RegistrationStatus>>>;
  status?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  timeFrameAdmission?: InputMaybe<Input_TimeFrameMsg>;
  timeFrameDischarge?: InputMaybe<Input_TimeFrameMsg>;
  timeFrameRegistration?: InputMaybe<Input_TimeFrameMsg>;
  type?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_ListRoomsRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<Patient_RoomType>>>;
};

export type Input_Patient_ListUnitVisitInfosRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListUnitVisitInfosResponse = {
  visitInfos?: InputMaybe<Array<InputMaybe<Input_Patient_UnitVisitInfoMsg>>>;
};

export type Input_Patient_ListVisitCaseIdsRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitCaseIdsResponse = {
  visitIdToBillingCaseId?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitCaseIdsResponse_VisitIdToBillingCaseIdEntry>>>;
};

export type Input_Patient_ListVisitCaseIdsResponse_VisitIdToBillingCaseIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListVisitIds = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitIdsByBillingCaseIdRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** optional filters */
  excludedStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  types?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_ListVisitIdsByBillingCaseIdsResponse = {
  billingCaseIdToVisitIds?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitIdsByBillingCaseIdsResponse_BillingCaseIdToVisitIdsEntry>>>;
};

export type Input_Patient_ListVisitIdsByBillingCaseIdsResponse_BillingCaseIdToVisitIdsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Patient_VisitIdList>;
};

export type Input_Patient_ListVisitPatientSexesRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitPatientSexesResponse = {
  visitIdToPatientSexMaps?: InputMaybe<Array<InputMaybe<Input_Patient_VisitIdToPatientSexMap>>>;
};

export type Input_Patient_ListVisitStatusInfo = {
  visitStatusInfo?: InputMaybe<Array<InputMaybe<Input_Patient_VisitStatusInfoMsg>>>;
};

export type Input_Patient_ListVisitStatusesByBillingCaseIdRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitStatusesByBillingCaseIdResponse = {
  billingCaseIdToVisitStatusInfo?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitStatusesByBillingCaseIdResponse_BillingCaseIdToVisitStatusInfoEntry>>>;
};

export type Input_Patient_ListVisitStatusesByBillingCaseIdResponse_BillingCaseIdToVisitStatusInfoEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Patient_ListVisitStatusInfo>;
};

export type Input_Patient_ListVisitTransfersRequest = {
  /** either this or visitIds is mandatory */
  billingCaseId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Patient_VisitTransferStatus>>>;
  statusesToExclude?: InputMaybe<Array<InputMaybe<Patient_VisitTransferStatus>>>;
  /** either this or billingCaseId is mandatory */
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitTransfersResponse = {
  visitTransfers?: InputMaybe<Array<InputMaybe<Input_Patient_VisitTransferMsg>>>;
};

export type Input_Patient_ListVisitUnitHistoryRequest = {
  relevantEventStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ListVisitUnitHistoryResponse = {
  unitAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_VisitUnitAssignmentMsg>>>;
};

export type Input_Patient_ListVisitsByBillingCaseIdsRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitsByBillingCaseIdsResponse = {
  visitByBillingCaseId?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitsByBillingCaseIdsResponse_VisitByBillingCaseIdEntry>>>;
};

export type Input_Patient_ListVisitsByBillingCaseIdsResponse_VisitByBillingCaseIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Patient_VisitList>;
};

export type Input_Patient_ListVisitsForInvoiceByBillingCaseIdsRequest = {
  billingCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitsForInvoiceByBillingCaseIdsResponse = {
  visitsByBillingCaseId?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitsForInvoiceByBillingCaseIdsResponse_VisitsByBillingCaseIdEntry>>>;
};

export type Input_Patient_ListVisitsForInvoiceByBillingCaseIdsResponse_VisitsByBillingCaseIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Patient_VisitForInvoiceList>;
};

/** search by location, patient, status, a subset or all of them */
export type Input_Patient_ListVisitsPaginatedRequest = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  admissionDateSort?: InputMaybe<Helper_SortOrder>;
  allEpisodesOfCare?: InputMaybe<Scalars['Boolean']>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingCaseId?: InputMaybe<Scalars['String']>;
  billingCaseIdNot?: InputMaybe<Scalars['String']>;
  creationDateSort?: InputMaybe<Helper_SortOrder>;
  dischargeDateSort?: InputMaybe<Helper_SortOrder>;
  episodeOfCardIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If a user wants to see their assigned visits outside of their current view, this can be set */
  excludedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  firstNameSort?: InputMaybe<Helper_SortOrder>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  hasPatient?: InputMaybe<Scalars['Boolean']>;
  includeLastTreatmentDetails?: InputMaybe<Scalars['Boolean']>;
  /**
   * Must be provided to apply filters only on inpatient visit types, if they are included in the visit types filter.
   *  Currently includes types: INPATIENT, SEMI_INPATIENT
   */
  inpatientFilters?: InputMaybe<Input_Patient_ListVisitsPaginatedRequestInpatientFiltersMsg>;
  lastNameSort?: InputMaybe<Helper_SortOrder>;
  /** (returns only visits in last x minutes) ignores onlyRecent */
  minutesToShow?: InputMaybe<Scalars['Int']>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether only the recent visits (currently: updated in past 8 hours) should be displayed */
  onlyRecent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Must be provided to apply filters only on outpatient visit types, if they are included in the visit types filter.
   *  Currently includes types: OUTPATIENT, SURGERY, PRE_INPATIENT, POST_INPATIENT
   */
  outpatientFilters?: InputMaybe<Input_Patient_ListVisitsPaginatedRequestOutpatientFiltersMsg>;
  /** Mandatory */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  patientId?: InputMaybe<Scalars['String']>;
  plannedAdmissionDateSort?: InputMaybe<Helper_SortOrder>;
  plannedDischargeDateSort?: InputMaybe<Helper_SortOrder>;
  registrationStatuses?: InputMaybe<Array<InputMaybe<Billing_RegistrationStatus>>>;
  requestedTimeFrameStartDateSort?: InputMaybe<Helper_SortOrder>;
  selector?: InputMaybe<Input_Patient_VisitSelectorMsg>;
  statuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Patient_VisitTag>>>;
  targetTimeSort?: InputMaybe<Helper_SortOrder>;
  /**
   * if it's set along with includeLastTreatmentDetails it fetches the last treatment details of the given treatment type
   *  if it's not set it fetches the last treatment details without considering the treatmentType
   */
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  types?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitNumberSort?: InputMaybe<Helper_SortOrder>;
  waitingTimeSort?: InputMaybe<Helper_SortOrder>;
};

export type Input_Patient_ListVisitsPaginatedRequestInpatientFiltersMsg = {
  /** If set narrows the absence time frame filters's target */
  absenceEndIsNull?: InputMaybe<Scalars['Boolean']>;
  /** If set narrows the absence time frame filters's target */
  absenceEndsInTimeFrame?: InputMaybe<Scalars['Boolean']>;
  /** If set narrows the absence time frame filters's target */
  absenceStatuses?: InputMaybe<Array<InputMaybe<Patient_PatientAbsenceStatus>>>;
  absenceTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** If set narrows the absence time frame filters's target */
  absenceTypes?: InputMaybe<Array<InputMaybe<Patient_PatientAbsenceType>>>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  arrivalTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** Used for specifying which fields are considered for entry time frame filter. They are combined with OR-logic. */
  considerAdmissionTime?: InputMaybe<Scalars['Boolean']>;
  considerDesiredIncomingTransferTime?: InputMaybe<Scalars['Boolean']>;
  /** Used for specifying which fields are considered for exit time frame filter. They are combined with OR-logic. */
  considerDischargeTime?: InputMaybe<Scalars['Boolean']>;
  considerIncomingTransferTime?: InputMaybe<Scalars['Boolean']>;
  considerOutgoingTransferTime?: InputMaybe<Scalars['Boolean']>;
  considerPlannedAdmissionTime?: InputMaybe<Scalars['Boolean']>;
  considerPlannedDischargeTime?: InputMaybe<Scalars['Boolean']>;
  considerRequestedAdmissionTime?: InputMaybe<Scalars['Boolean']>;
  considerRequestedDischargeTime?: InputMaybe<Scalars['Boolean']>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  departureTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  dischargeStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitDischargeStatus>>>;
  /** filters out visits with current bed id null when true, filters out the ones with a bed when false */
  hasCurrentBed?: InputMaybe<Scalars['Boolean']>;
  includePlannedAdmissionUnitInUnitFilter?: InputMaybe<Scalars['Boolean']>;
  /** returns only visits that are on ward floor when true, does not do anything when false or null */
  onWardFloor?: InputMaybe<Scalars['Boolean']>;
  schedulePriorities?: InputMaybe<Array<InputMaybe<Patient_VisitSchedulePriority>>>;
  scheduleStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitScheduleStatus>>>;
};

export type Input_Patient_ListVisitsPaginatedRequestOutpatientFiltersMsg = {
  activityStatuses?: InputMaybe<Array<InputMaybe<Patient_VisitActivityStatus>>>;
  /** Used for specifying which fields are considered for time frame filter. They are combined with OR-logic. */
  considerTargetTime?: InputMaybe<Scalars['Boolean']>;
  currentDesiredUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasTargetTime?: InputMaybe<Scalars['Boolean']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  triageLevelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_ListVisitsPaginatedResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  /** it's set if includeLastTreatmentDetails is set to true. */
  visitIdToLastTreatmentDetails?: InputMaybe<Array<InputMaybe<Input_Patient_ListVisitsPaginatedResponse_VisitIdToLastTreatmentDetailsEntry>>>;
  visits?: InputMaybe<Array<InputMaybe<Input_Patient_VisitMsg>>>;
};

export type Input_Patient_ListVisitsPaginatedResponse_VisitIdToLastTreatmentDetailsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Treatment_TreatmentBasicInfoMsg>;
};

/**
 * search by location, patient, status, a subset or all of them
 *  Note: either patientId, some administrative unit id, or some room id has to be provided
 */
export type Input_Patient_ListVisitsRequest = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  admissionTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  billingCaseId?: InputMaybe<Scalars['String']>;
  /** optional filter */
  currentDesiredUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dischargeTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  ignoreAbsences?: InputMaybe<Scalars['Boolean']>;
  /** optional */
  includeLastTreatmentDetails?: InputMaybe<Scalars['Boolean']>;
  includeLeadingUnitAssignments?: InputMaybe<Scalars['Boolean']>;
  includePlannedAdmission?: InputMaybe<Scalars['Boolean']>;
  includePlannedDischarge?: InputMaybe<Scalars['Boolean']>;
  leadingUnitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** optional (returns only visits in last x minutes) ignores onlyRecent */
  minutesToShow?: InputMaybe<Scalars['Int']>;
  /** Whether only the recent visits (currently: updated in past 8 hours) should be displayed */
  onlyRecent?: InputMaybe<Scalars['Boolean']>;
  /** optional */
  patientId?: InputMaybe<Scalars['String']>;
  registrationStatuses?: InputMaybe<Array<InputMaybe<Billing_RegistrationStatus>>>;
  registrationTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** optional */
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** optional */
  statuses?: InputMaybe<Array<InputMaybe<Patient_VisitStatus>>>;
  /**
   * optional, if it's set along with includeLastTreatmentDetails it fetches the last treatment details of the given treatment type
   *  if it's not set it fetches the last treatment details without considering the treatmentType
   */
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  /** optional */
  types?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
};

export type Input_Patient_LongTermCareMsg = {
  id?: InputMaybe<Scalars['String']>;
  longTermRemedyDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  longTermRemedyDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  longTermRemedyFurtherDetails?: InputMaybe<Scalars['String']>;
  longTermRemedyNeed?: InputMaybe<Scalars['Boolean']>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  specialCareDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  specialCareDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  specialCareFurtherDetails?: InputMaybe<Scalars['String']>;
  specialCareNeed?: InputMaybe<Scalars['Boolean']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_MedicalQualificationMsg = {
  /**
   * Whether the qualification is marked as not a "standard", but an additional qualification;
   *  "Zusatzqualifikation" in German
   */
  additional?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalMedicalQualificationIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_OrganDonationCardMsg = {
  chosenForDonationOrgans?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  consent?: InputMaybe<Scalars['Boolean']>;
  creationDate?: InputMaybe<Input_Timestamp>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  donationExceptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  storageLocation?: InputMaybe<Input_Core_StorageLocationMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_PatientAbsenceEventMsg = {
  eventDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_PatientAbsenceStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Contains information about a patient absence, i.e., when a patient is still in the hospital's care, but outside their normal location/ward. */
export type Input_Patient_PatientAbsenceMsg = {
  blockResource?: InputMaybe<Scalars['Boolean']>;
  blockUntil?: InputMaybe<Input_Timestamp>;
  comment?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  events?: InputMaybe<Array<InputMaybe<Input_Patient_PatientAbsenceEventMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalPatientAbsenceIdMsg>>>;
  germanDetails?: InputMaybe<Input_Patient_Registry_German_GermanPatientAbsenceDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** both start and end are mandatory */
  plannedTimeFrame?: InputMaybe<Input_PrecisionTimeFrameMsg>;
  /** at least one reason is mandatory */
  reasons?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  status?: InputMaybe<Patient_PatientAbsenceStatus>;
  /** Actual start, end of the absence */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** Must be set on creation, cannot be changed afterwards */
  type?: InputMaybe<Patient_PatientAbsenceType>;
};

export type Input_Patient_PatientContextMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_PatientContextType>;
};

export type Input_Patient_PatientEventMsg = {
  /** The context where the patient was created, if it is a non-synchronized patient */
  context?: InputMaybe<Input_Patient_PatientContextMsg>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_PatientEventType>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_PatientList = {
  patients?: InputMaybe<Array<InputMaybe<Input_Patient_PatientMsg>>>;
};

export type Input_Patient_PatientMsg = {
  alive?: InputMaybe<Scalars['Boolean']>;
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  birthCountryCode?: InputMaybe<Scalars['String']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  /** Contact parties of the patient (e.g. emergency contacts) */
  contactParties?: InputMaybe<Array<InputMaybe<Input_Patient_ContactPartyMsg>>>;
  /** only required when it is non-external, in which context the patient is created */
  context?: InputMaybe<Input_Patient_PatientContextMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  dateOfBirthPrecision?: InputMaybe<TimePrecisionLevel>;
  dateOfBirthUnknown?: InputMaybe<Scalars['Boolean']>;
  declarationsOfConsent?: InputMaybe<Array<InputMaybe<Input_Patient_DeclarationMsg>>>;
  denomination?: InputMaybe<Input_Knowledge_DenominationMsg>;
  eventHistory?: InputMaybe<Array<InputMaybe<Input_Patient_PatientEventMsg>>>;
  /** true if the patient need to be synced with external systems; false if the patient is only internal */
  external?: InputMaybe<Scalars['Boolean']>;
  externalClinics?: InputMaybe<Array<InputMaybe<Input_Core_ExternalClinicMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalPatientIdMsg>>>;
  flags?: InputMaybe<Array<InputMaybe<Input_Core_FlagMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  legalInformation?: InputMaybe<Input_Patient_LegalInformationMsg>;
  maritalStatus?: InputMaybe<Core_MaritalStatus>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  nationality?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  occupations?: InputMaybe<Array<InputMaybe<Input_Patient_PatientOccupationMsg>>>;
  practitioners?: InputMaybe<Array<InputMaybe<Input_Patient_PractitionerPatientRelationshipMsg>>>;
  privacyStatuses?: InputMaybe<Array<InputMaybe<Patient_PrivacyStatus>>>;
  sex?: InputMaybe<Core_Sex>;
  specialStatuses?: InputMaybe<Array<InputMaybe<Patient_PatientSpecialStatus>>>;
  timeOfDeath?: InputMaybe<Input_PrecisionTimestampMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Patient_PatientOccupationList = {
  patientOccupations?: InputMaybe<Array<InputMaybe<Input_Patient_PatientOccupationMsg>>>;
};

export type Input_Patient_PatientOccupationMsg = {
  coverageId?: InputMaybe<Scalars['String']>;
  current?: InputMaybe<Scalars['Boolean']>;
  employer?: InputMaybe<Input_Patient_ContactPartyMsg>;
  employment?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  employmentPeriod?: InputMaybe<Input_PrecisionTimeFrameMsg>;
  id?: InputMaybe<Scalars['String']>;
  occupations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patient_EmploymentType>;
};

/** PatientMsg enhanced with information about the latest visit */
export type Input_Patient_PatientResult = {
  lastVisitInformation?: InputMaybe<Input_Patient_LastVisitInformation>;
  patient?: InputMaybe<Input_Patient_PatientMsg>;
};

export type Input_Patient_PatientResultList = {
  /** number of search results (only relevant for paginated searches) */
  hitCount?: InputMaybe<Scalars['Int']>;
  results?: InputMaybe<Array<InputMaybe<Input_Patient_PatientResult>>>;
};

export type Input_Patient_PatientUnit = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_PowerOfAttorneyEntryMsg = {
  creationDate?: InputMaybe<Input_Timestamp>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inFavorOfList?: InputMaybe<Array<InputMaybe<Input_Patient_ContactPartyMsg>>>;
  storageLocation?: InputMaybe<Input_Core_StorageLocationMsg>;
};

export type Input_Patient_PowerOfAttorneyMsg = {
  id?: InputMaybe<Scalars['String']>;
  powerOfAttorneyEntries?: InputMaybe<Array<InputMaybe<Input_Patient_PowerOfAttorneyEntryMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Patient_PractitionerAssignmentMsg = {
  externalClinic?: InputMaybe<Input_Core_ExternalClinicMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** When the practitioner is available */
  regularAvailability?: InputMaybe<Array<InputMaybe<Input_Core_DayOfWeekScheduleMsg>>>;
  /** Exceptions to the regular availability */
  specialAvailability?: InputMaybe<Array<InputMaybe<Input_Core_DateScheduleMsg>>>;
};

export type Input_Patient_PractitionerMsg = {
  assignments?: InputMaybe<Array<InputMaybe<Input_Patient_PractitionerAssignmentMsg>>>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  /**
   * Options to take over an entry using a combined search:
   *   * KBV Kollegensuche database
   *   * Referrer database
   *   * Patient portal
   *   * Manual
   */
  dataSource?: InputMaybe<Patient_PractitionerDataSource>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalPractitionerIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the practitioner is a medical professional or not */
  medical?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  qualifications?: InputMaybe<Array<InputMaybe<Input_Patient_MedicalQualificationMsg>>>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  sex?: InputMaybe<Core_Sex>;
  validity?: InputMaybe<Input_TimeFrameMsg>;
};

/** In which roles the practitioner interacts with a specific patient */
export type Input_Patient_PractitionerPatientRelationshipMsg = {
  /**
   * The options for <roles> are:
   *    * General practitioner (dt. Hausarzt)
   *    * The subset of "Specialization(s) (dt. Fachgebiet(e))" which are selected in the Physicians (dt. Ärzte) > Expand of this
   *      respective entry
   */
  generalPractitioner?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  practitioner?: InputMaybe<Input_Patient_PractitionerMsg>;
  /**
   * The specializations in the PractitionerMsg are all the specializations they have;
   *  these are the ones in which the practitioner treats the specific patient
   */
  specializations?: InputMaybe<Array<InputMaybe<Input_Patient_MedicalQualificationMsg>>>;
};

export type Input_Patient_ProfessionalGroupMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalMedicalQualificationIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ReasonForIntroductionList = {
  reasonsForIntroduction?: InputMaybe<Array<InputMaybe<Input_Patient_ReasonForIntroductionMsg>>>;
};

export type Input_Patient_ReasonForIntroductionMsg = {
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ReferralMsg = {
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalClinic?: InputMaybe<Input_Core_ExternalClinicMsg>;
  id?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Input_Patient_PractitionerMsg>;
};

export type Input_Patient_RegisterVisitRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Input_Patient_ExternalVisitIdMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** If set, always creates new visit regardless of existence of open visits, unless visitId is set */
  ignoreExistingVisits?: InputMaybe<Scalars['Boolean']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** If set and organizationalUnitId is not set, the organizationalUnitId of newly created visit is set from this visit's currentOrganizationalUnitId */
  organizationalUnitIdSourceVisitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  setAdmissionDateToNow?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Patient_VisitType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_RoomMsg = {
  capacity?: InputMaybe<Scalars['Int']>;
  flags?: InputMaybe<Array<InputMaybe<Input_Core_FlagMsg>>>;
  /** Id of the room */
  id?: InputMaybe<Scalars['String']>;
  /** Name of the room */
  name?: InputMaybe<Scalars['String']>;
  /** OrganizationalUnit room is in */
  organizationalUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_RoomType>;
};

export type Input_Patient_RoomsList = {
  rooms?: InputMaybe<Array<InputMaybe<Input_Patient_RoomMsg>>>;
};

export type Input_Patient_SearchContactPartiesRequest = {
  /** optional filter */
  designation?: InputMaybe<Patient_ContactPartyDesignation>;
  /** the patient whose contact parties we search through */
  patientId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Input_Patient_ContactPartyScopeReferenceMsg>;
  /** search text */
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_SearchPatientsRequest = {
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Patient_SearchReasonsForIntroductionRequest = {
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_SetContactNumbersRequest = {
  landlineNumber?: InputMaybe<Input_Core_PhoneNumberMsg>;
  mobileNumber?: InputMaybe<Input_Core_PhoneNumberMsg>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_TransferVisitRequest = {
  targetOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  targetRoomId?: InputMaybe<Scalars['String']>;
  targetStatus?: InputMaybe<Patient_VisitStatus>;
  targetUserId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_TriageSystemLevelMsg = {
  colorCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Maximum waiting time until treatment in seconds */
  maximumWaitingTime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  /** Target waiting time until treatment in seconds */
  targetWaitingTime?: InputMaybe<Scalars['Int']>;
};

export type Input_Patient_TriageSystemMsg = {
  id?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Input_Patient_TriageSystemLevelMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UnitVisitInfoMsg = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UpdateAdditionalServicesAssignmentRequest = {
  additionalServicesAssignment?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>;
  /** If not set to true, any synchronized flag on the assignment will be set to false */
  keepSynchronization?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Patient_UpdateAdditionalServicesAssignmentResponse = {
  /** set if the time of additional service assignment is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_UpdateContactPartyRequest = {
  contactParty?: InputMaybe<Input_Patient_ContactPartyMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Patient_UpdateLeadingUnitAssignmentRequest = {
  /** If not set to true, any synchronized flag on the assignment will be set to false */
  keepSynchronization?: InputMaybe<Scalars['Boolean']>;
  leadingUnitAssignment?: InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Patient_UpdateLeadingUnitAssignmentResponse = {
  /** set if the time of leading unit assignment is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_UpdateLegalInfoValidationRequest = {
  /** If there is an existing revision by another user, cancels it. */
  cancelExisting?: InputMaybe<Scalars['Boolean']>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: InputMaybe<Validation_ExternalValidator>;
  legalInfoType?: InputMaybe<Patient_LegalInfoType>;
  patientId?: InputMaybe<Scalars['String']>;
  /**
   * If this flag is set, the current validation gets undone and the data is changed to the previous revision.
   *  It can only be done within 5 minutes of the revision's activation.
   *  If this flag is not set, the validation is updated.
   *  If the last action is "reset", it can not be reset again.
   */
  reset?: InputMaybe<Scalars['Boolean']>;
  /** If there is an existing revision by another user, takes it over. */
  takeOverExisting?: InputMaybe<Scalars['Boolean']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UpdateLegalInfoValidationResponse = {
  careAidDisability?: InputMaybe<Input_Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: InputMaybe<Input_Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: InputMaybe<Input_Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: InputMaybe<Input_Patient_LegalGuardianshipMsg>;
  longTermCare?: InputMaybe<Input_Patient_LongTermCareMsg>;
  organDonationCard?: InputMaybe<Input_Patient_OrganDonationCardMsg>;
  powerOfAttorney?: InputMaybe<Input_Patient_PowerOfAttorneyMsg>;
};

export type Input_Patient_UpdatePatientAbsenceRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  patientAbsence?: InputMaybe<Input_Patient_PatientAbsenceMsg>;
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Patient_UpdatePatientAbsenceResponse = {
  patientAbsence?: InputMaybe<Input_Patient_PatientAbsenceMsg>;
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
};

export type Input_Patient_UpdatePatientOccupationRequest = {
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  patientOccupation?: InputMaybe<Input_Patient_PatientOccupationMsg>;
};

export type Input_Patient_UpdatePatientRequest = {
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  patient?: InputMaybe<Input_Patient_PatientMsg>;
};

export type Input_Patient_UpdateVisitActivityStatusRequest = {
  patientUnit?: InputMaybe<Input_Patient_PatientUnit>;
  /** required if user is called to a room that has not yet been specified in the visit */
  roomId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Patient_VisitActivityStatus>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UpdateVisitCaseRequest = {
  newBillingCaseId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UpdateVisitRequest = {
  /** Only allowed from gateway service */
  additionalServicesAssignmentIdsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Only allowed from gateway service; if set, triggers full create/update logic for new assignments (without id) and updated assignments defined by additionalServicesAssignmentIdsToUpdate */
  createOrUpdateAdditionalServicesAssignments?: InputMaybe<Scalars['Boolean']>;
  /** Only allowed from gateway service; if set, triggers full create/update logic for new assignments (without id) and updated assignments defined by leadingUnitAssignmentIdsToUpdate */
  createOrUpdateLeadingUnitAssignments?: InputMaybe<Scalars['Boolean']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: InputMaybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  ignoreLock?: InputMaybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  leadingUnitAssignmentIdsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If set to true, only id will be set in PatientMsg in response message */
  omitFullPatient?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  resourceAllocationParameters?: InputMaybe<Input_Patient_VisitResourceAllocationParametersMsg>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_UpdateVisitResponse = {
  /** set if the times of admission, discharge, transfers and absences are not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
  visitResourceAllocationResponse?: InputMaybe<Input_Patient_VisitResourceAllocationResponse>;
};

export type Input_Patient_UpdateVisitStatusRequest = {
  externalStatusUpdate?: InputMaybe<Scalars['Boolean']>;
  patientUnit?: InputMaybe<Input_Patient_PatientUnit>;
  reactivateVisit?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Patient_VisitStatus>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_UpdateVisitStatusesOfCaseRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  cancelVisits?: InputMaybe<Scalars['Boolean']>;
  reactivateVisits?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_UpdateVisitStatusesOfCaseResponse = {
  updatedVisitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_UpdateVisitTransferRequest = {
  blockEnd?: InputMaybe<Input_Timestamp>;
  /** the flag is used only during transfer completion */
  blockResource?: InputMaybe<Scalars['Boolean']>;
  /**
   * will set keepSynchronization=false for linked leading unit & additional services assignments
   *  only relevant for already confirmed transfers
   */
  cancelSynchronization?: InputMaybe<Scalars['Boolean']>;
  /**
   * should be set in case overbooking is desired, however currently contingentAssignment is reserved separately
   *  so this flag should not be used during initial resource allocation
   */
  overrideContingents?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  visitTransfer?: InputMaybe<Input_Patient_VisitTransferMsg>;
};

export type Input_Patient_UpdateVisitTransferResponse = {
  /** set if the time of transfer is not valid */
  timeValidationErrors?: InputMaybe<Array<InputMaybe<Patient_VisitTimeValidationError>>>;
  /** only set after transfer completion, as that changes visit */
  visit?: InputMaybe<Input_Patient_VisitMsg>;
  visitTransfer?: InputMaybe<Input_Patient_VisitTransferMsg>;
};

export type Input_Patient_ValidateTreatmentLegalInfosRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_ValidateTreatmentLegalInfosResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

/**
 * This represents a change of a visit activity status to the VisitActivityStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Input_Patient_VisitActivityEventMsg = {
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patient_VisitActivityStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

/**
 * This represents a change of a visit discharge status to the VisitDischargeStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Input_Patient_VisitDischargeEventMsg = {
  id?: InputMaybe<Scalars['String']>;
  plannedDischargeDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patient_VisitDischargeStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

/**
 * This represents a change of a visit status to the VisitStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Input_Patient_VisitEventMsg = {
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  eventOrigin?: InputMaybe<Patient_VisitEventOriginType>;
  id?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patient_VisitStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitFinishDateMsg = {
  finishDate?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitForInvoiceInfoMsg = {
  allowedToBeLinked?: InputMaybe<Scalars['Boolean']>;
  visit?: InputMaybe<Input_Patient_VisitMsg>;
};

export type Input_Patient_VisitForInvoiceList = {
  visitsForInvoice?: InputMaybe<Array<InputMaybe<Input_Patient_VisitForInvoiceInfoMsg>>>;
};

export type Input_Patient_VisitIdList = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_VisitIdToAdditionalServiceMap = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitIdToPatientSexMap = {
  sex?: InputMaybe<Core_Sex>;
  visitId?: InputMaybe<Scalars['String']>;
};

/** TODO rename maybe */
export type Input_Patient_VisitLinkedProcessReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_VisitLinkedProcessType>;
};

/** todo: create message ListVisitsResponse and put the visitIdToLastTreatmentDetails in it */
export type Input_Patient_VisitList = {
  visitIdToLastTreatmentDetails?: InputMaybe<Array<InputMaybe<Input_Patient_VisitList_VisitIdToLastTreatmentDetailsEntry>>>;
  visits?: InputMaybe<Array<InputMaybe<Input_Patient_VisitMsg>>>;
};

export type Input_Patient_VisitList_VisitIdToLastTreatmentDetailsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Treatment_TreatmentBasicInfoMsg>;
};

/** A visit is an event in which a patient comes to a clinic to receive a treatment */
export type Input_Patient_VisitMsg = {
  activityEvents?: InputMaybe<Array<InputMaybe<Input_Patient_VisitActivityEventMsg>>>;
  activityStatus?: InputMaybe<Patient_VisitActivityStatus>;
  /** Additional information about the visit */
  additionalInformation?: InputMaybe<Scalars['String']>;
  /** it represents the current/latest additional services from the additional service assignment history, it's not saved */
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
  additionalServicesAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentMsg>>>;
  /** Id of appointment (if exists) */
  appointmentId?: InputMaybe<Scalars['String']>;
  /** Users for whom the visit is relevant, can be used to track visits currently outside the user's ward */
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingCaseId?: InputMaybe<Scalars['String']>;
  creatorUserId?: InputMaybe<Scalars['String']>;
  /** The userId of the employee the client wants to see */
  currentDesiredUserId?: InputMaybe<Scalars['String']>;
  /** Number the patient is being called with */
  currentNumber?: InputMaybe<Scalars['Int']>;
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Room the visitor is currently in */
  currentRoom?: InputMaybe<Input_Patient_RoomMsg>;
  currentRoomId?: InputMaybe<Scalars['String']>;
  currentVisitType?: InputMaybe<Patient_VisitType>;
  dischargeEvents?: InputMaybe<Array<InputMaybe<Input_Patient_VisitDischargeEventMsg>>>;
  dischargeStatus?: InputMaybe<Patient_VisitDischargeStatus>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalVisitIdMsg>>>;
  /** optional, only if billing case type is BG */
  germanBgDetails?: InputMaybe<Input_Patient_GermanVisitBgDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** TODO reason for admission -> can be a link to other objects I guess */
  infectionExists?: InputMaybe<Core_BoolUnknown>;
  infections?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  initialFinishDate?: InputMaybe<Input_Timestamp>;
  isolationExists?: InputMaybe<Core_BoolUnknown>;
  isolations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  leadingUnitAssignments?: InputMaybe<Array<InputMaybe<Input_Patient_LeadingUnitAssignmentMsg>>>;
  /** it represents the current/latest leading unit from the unit assignment history, it's not saved */
  leadingUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  level?: InputMaybe<Input_Patient_TriageSystemLevelMsg>;
  /**
   * TODO BedType needs to be modeled
   *  TODO special requirements needs to be modeled
   */
  linkedProcesses?: InputMaybe<Array<InputMaybe<Input_Patient_VisitLinkedProcessReferenceMsg>>>;
  /** Id of the office hour (if exists) */
  officeHourId?: InputMaybe<Scalars['String']>;
  organizationalUnitIdOnRegistration?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Input_Patient_PatientMsg>;
  /**
   * IDs of documents with which the patient gets registered
   *  Note: Referral document IDs are saved in the respective ReferralMsg
   */
  patientDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Reasons for visit */
  reasonsForIntroduction?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referrals?: InputMaybe<Array<InputMaybe<Input_Patient_ReferralMsg>>>;
  referred?: InputMaybe<Scalars['Boolean']>;
  registrationStatus?: InputMaybe<Billing_RegistrationStatus>;
  /** TODO: Streamline redundancy with targetTime */
  schedule?: InputMaybe<Input_Patient_VisitScheduleMsg>;
  status?: InputMaybe<Patient_VisitStatus>;
  tags?: InputMaybe<Array<InputMaybe<Patient_VisitTag>>>;
  /** Appointment time entered by patient */
  targetTime?: InputMaybe<Input_Timestamp>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  transfers?: InputMaybe<Array<InputMaybe<Input_Patient_VisitTransferMsg>>>;
  visitEvents?: InputMaybe<Array<InputMaybe<Input_Patient_VisitEventMsg>>>;
};

export type Input_Patient_VisitResourceAllocationParametersMsg = {
  blockEnd?: InputMaybe<Input_Timestamp>;
  blockResource?: InputMaybe<Scalars['Boolean']>;
  /**
   * if true, a temporary resource will be created with the data in temporaryResourceDefinition,
   *  the resource in the assignment will be ignored
   */
  createTemporaryResource?: InputMaybe<Scalars['Boolean']>;
  /** this flag can be set to assign a resource forcibly for this visit (when resource is occupied) */
  forceAssignment?: InputMaybe<Scalars['Boolean']>;
  /** this flag can be set to unassign a resource forcibly for this visit without discharging the patient */
  forceResourceRemoval?: InputMaybe<Scalars['Boolean']>;
  /** if a new resource is expected to be allocated to the visit */
  newResourceId?: InputMaybe<Scalars['String']>;
  overrideConstraints?: InputMaybe<Scalars['Boolean']>;
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** if set to true, aborts contingent allocation */
  removeContingentAllocation?: InputMaybe<Scalars['Boolean']>;
  /**
   * if there is a resource assignment and we want to remove it, works for reserved beds all the time
   *  however a patient occupied bed can not be freed without discharging
   */
  removeResource?: InputMaybe<Scalars['Boolean']>;
  /**
   * if a contingent assignment was already reserved for a visit
   *  this id can be given to update that assignment
   */
  reservedContingentAssignmentId?: InputMaybe<Scalars['String']>;
  /**
   * if a static resource assignment was already reserved for a visit
   *  this id can be given to cancel that assignment
   */
  reservedStaticResourceAssignmentId?: InputMaybe<Scalars['String']>;
  /** If set, ignores all conditions and does not do any resource/contingent allocation; used e.g., if schedule draft is sent to scheduling staff */
  skipResourceAllocation?: InputMaybe<Scalars['Boolean']>;
  /**
   * if a resource is being allocated for a resource, this type can be set to choose
   *  type of the assignment (RESERVED or OCCUPIED)
   *  default is occupied
   */
  staticResourceAssignmentType?: InputMaybe<Resource_StaticResourceAssignmentType>;
  /**
   * if the new resource is full during reallocation,
   *  this flag can be set to swap the assignments in respective resources
   */
  swapIfFull?: InputMaybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: InputMaybe<Input_Resource_TemporaryResourceDefinitionMsg>;
};

/** a message that holds all possible response fields due to resource allocation changes */
export type Input_Patient_VisitResourceAllocationResponse = {
  /** when this allocation results in multiple assignments being modified */
  assignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
  /** Redundant information - if there is no warning, the resource allocation was successful */
  granted?: InputMaybe<Scalars['Boolean']>;
  warning?: InputMaybe<Resource_RequestStaticResourceWarning>;
};

/**
 * This represents a change of a visit schedule status to the VisitScheduleStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Input_Patient_VisitScheduleEventMsg = {
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patient_VisitScheduleStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitScheduleInfoMsg = {
  finalAdmissionDate?: InputMaybe<Input_Timestamp>;
  finalDischargeDate?: InputMaybe<Input_Timestamp>;
  firstPlannedAdmissionDate?: InputMaybe<Input_Timestamp>;
  firstStartDate?: InputMaybe<Input_Timestamp>;
  lastPlannedAdmissionDate?: InputMaybe<Input_Timestamp>;
  lastStartDate?: InputMaybe<Input_Timestamp>;
  notYetDischarged?: InputMaybe<Scalars['Boolean']>;
  plannedDischargeDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Patient_VisitScheduleMsg = {
  absences?: InputMaybe<Array<InputMaybe<Input_Patient_PatientAbsenceMsg>>>;
  admissionDate?: InputMaybe<Input_Timestamp>;
  admissionTimeOfDay?: InputMaybe<Input_TimeOfDayMsg>;
  /** use if the assignment sex differs from patient sex */
  assignmentSex?: InputMaybe<Resource_AssignmentSex>;
  comment?: InputMaybe<Scalars['String']>;
  contingentHolderId?: InputMaybe<Scalars['String']>;
  currentContingentAssignmentId?: InputMaybe<Scalars['String']>;
  /**
   * set if this visit currently has a bed assigned
   *  is set automatically by the backend, unmodifiable by frontend
   */
  currentStaticResourceAssignmentId?: InputMaybe<Scalars['String']>;
  dischargeDate?: InputMaybe<Input_Timestamp>;
  /** Duration from admission to planned discharge date */
  durationAtPlannedDischargeInDays?: InputMaybe<Scalars['Int']>;
  /** Duration from admission to discharge date or now (if discharge is not set) */
  durationInDays?: InputMaybe<Scalars['Int']>;
  events?: InputMaybe<Array<InputMaybe<Input_Patient_VisitScheduleEventMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** relevant only in the case of visit transfers */
  oldContingentAssignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** relevant only in the case of visit transfers */
  oldStaticResourceAssignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** set by the backend if the allocated resource is on ward floor instead of room */
  onWardFloor?: InputMaybe<Scalars['Boolean']>;
  /** Can be in the future as well */
  plannedAdmissionDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  plannedAdmissionOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Can be in the future as well */
  plannedDischargeDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  priority?: InputMaybe<Patient_VisitSchedulePriority>;
  reasonForAdmission?: InputMaybe<Scalars['String']>;
  /** Can be in the future as well */
  registrationDate?: InputMaybe<Input_Timestamp>;
  requestedTimeFrameEnd?: InputMaybe<Input_Timestamp>;
  requestedTimeFrameStart?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Patient_VisitScheduleStatus>;
};

export type Input_Patient_VisitSelectorMsg = {
  includeLeadingUnitAssignments?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_VisitStartDateMsg = {
  startDate?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitStatusInfoMsg = {
  visitId?: InputMaybe<Scalars['String']>;
  visitStatus?: InputMaybe<Patient_VisitStatus>;
  visitType?: InputMaybe<Patient_VisitType>;
};

export type Input_Patient_VisitTransferEventMsg = {
  eventDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_VisitTransferStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_VisitTransferMsg = {
  assignmentSex?: InputMaybe<Resource_AssignmentSex>;
  contingentAssignmentId?: InputMaybe<Scalars['String']>;
  desiredTransferTime?: InputMaybe<Input_Timestamp>;
  desiredTransferTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  events?: InputMaybe<Array<InputMaybe<Input_Patient_VisitTransferEventMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Patient_ExternalVisitTransferIdMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** On transfer completion, will override its visit's contingentHolderId */
  newContingentHolderId?: InputMaybe<Scalars['String']>;
  /** Comment for occupancy management in case draft is sent to occupancy manager */
  occupancyManagementDetails?: InputMaybe<Scalars['String']>;
  originDepartmentId?: InputMaybe<Scalars['String']>;
  originOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** On transfer confirmation, will override its visit's schedule's plannedDischargeDate */
  plannedDischargeDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  /** Used by FE to find possible slots; no further use in BE, as BE uses plannedTransferTime, plannedDischargeDate */
  plannedRemainingDaysAfterTransfer?: InputMaybe<Scalars['Int']>;
  plannedTransferTime?: InputMaybe<Input_Timestamp>;
  priority?: InputMaybe<Patient_VisitTransferPriority>;
  reasonForTransfer?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** set when transfer created within the history in the past */
  simpleTransfer?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Patient_VisitTransferStatus>;
  targetOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** actual transfer time, set by backend when the transfer is completed */
  transferTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Patient_VisitUnitAssignmentMsg = {
  /** end date can be empty */
  endDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Patient_Registry_AdditionalServiceMsg = {
  /** Additional service can be assigned only to visits in these units */
  assignedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** External identifiers that are mapped */
  mappedExternalIds?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_ExternalAdditionalServiceIdMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  possibleCaseTypes?: InputMaybe<Array<InputMaybe<Billing_BillingCaseType>>>;
  /** Additional service can be assigned only to visits of these types */
  possibleVisitTypes?: InputMaybe<Array<InputMaybe<Patient_VisitType>>>;
  referenceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Patient_Registry_AdditionalServiceStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** Allows categorizing the service */
  types?: InputMaybe<Array<InputMaybe<Patient_Registry_AdditionalServiceType>>>;
};

export type Input_Patient_Registry_AdditionalServicesAssignmentMsg = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: InputMaybe<Input_Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  startTime?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Patient_Registry_AdditionalServicesAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patient_Registry_AdditionalServicesAssignmentOriginType>;
};

export type Input_Patient_Registry_DeleteAdditionalServiceRequest = {
  additionalServiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_Registry_DeleteAdditionalServiceResponse = {
  deletedAdditionalServiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_Registry_ExternalAdditionalServiceIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_Registry_FindAdditionalServiceRequest = {
  referenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Patient_Registry_FindAdditionalServiceResponse = {
  additionalService?: InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patient_Registry_GetAdditionalServicesRequest = {
  additionalServiceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patient_Registry_GetAdditionalServicesResponse = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
};

export type Input_Patient_Registry_ListAdditionalServicesRequest = {
  caseType?: InputMaybe<Billing_BillingCaseType>;
  externalId?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Patient_Registry_ListAdditionalServicesResponse = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
};

export type Input_Patient_Registry_SearchAdditionalServicesRequest = {
  caseType?: InputMaybe<Billing_BillingCaseType>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  statuses?: InputMaybe<Array<InputMaybe<Patient_Registry_AdditionalServiceStatus>>>;
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Patient_Registry_SearchAdditionalServicesResponse = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Patient_Registry_UpdateAdditionalServiceRequest = {
  additionalService?: InputMaybe<Input_Patient_Registry_AdditionalServiceMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Patient_Registry_German_GermanPatientAbsenceDetailsMsg = {
  /**
   * If set on start of the absence:
   *  Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 31 (Beginn eines externen Aufenthalts (tagesstationäre Behandlung))
   *  Note: Property of the absence instead of the visit, as this can change daily
   */
  dayInpatientTreatment?: InputMaybe<Scalars['Boolean']>;
  endReason?: InputMaybe<Patient_Registry_German_GermanPatientAbsenceEndReason>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AcceptAppointmentProposalProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_AcceptAppointmentProposalRequest>;
};

export type Input_Patientportal_AcceptLegalGuardianRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AcceptProfessionalPortalUserInviteRequest = {
  inviteIdentifier?: InputMaybe<Input_Patientportal_ProfessionalPortalUserInviteIdentifier>;
};

export type Input_Patientportal_AcceptWardRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

/**
 * Used when confirming an action. The confirmableActionId is always required, all other parameters are optional.
 *  However, one of the following configurations of optional parameters is expected (with this order of priority):
 *  - [actionToken, confirmationProviderIndex, confirmationCode]:
 *      full confirmation using confirmation-code
 *  - [actionToken, confirmationProviderIndex, confirmationToken]:
 *      - CONFIRMATION_TOKEN_MODE_PARTIAL_CONFIRM:
 *          partial + full confirmation in single step using confirmation-token
 *      - CONFIRMATION_TOKEN_MODE_FULL_CONFIRM:
 *          full confirmation using confirmation-token
 *  - [confirmationProviderIndex, confirmationToken]:
 *      - CONFIRMATION_TOKEN_MODE_PARTIAL_CONFIRM:
 *          partial confirmation using confirmation-token
 *      - CONFIRMATION_TOKEN_MODE_FULL_CONFIRM:
 *          full confirmation using confirmation-token
 *  - [actionToken]:
 *      full confirmation of action already partially confirmed
 */
export type Input_Patientportal_ActionConfirmationMsg = {
  actionToken?: InputMaybe<Scalars['String']>;
  confirmableActionId?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  confirmationProviderIndex?: InputMaybe<Scalars['Int']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AddLegalGuardianRequest = {
  legalGuardianId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patientportal_PortalUserRelationshipType>;
};

export type Input_Patientportal_AddLegalGuardianResponse = {
  legalGuardian?: InputMaybe<Input_Patientportal_PortalUserMsg>;
};

export type Input_Patientportal_AdditionalServiceProxyList = {
  proxyAdditionalServices?: InputMaybe<Array<InputMaybe<Input_Patientportal_AdditionalServiceProxyMsg>>>;
};

export type Input_Patientportal_AdditionalServiceProxyMsg = {
  additionalService?: InputMaybe<Input_Resource_AdditionalServiceMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AnswerFormQuestionProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_AnswerFormQuestionRequest>;
};

export type Input_Patientportal_AnswerFormQuestionProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_AnswerFormQuestionResponse>;
};

export type Input_Patientportal_AnswerFormSequenceQuestionProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_AnswerFormSequenceQuestionRequest>;
};

export type Input_Patientportal_AnswerFormSequenceQuestionProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_AnswerFormSequenceQuestionResponse>;
};

export type Input_Patientportal_AppointmentHandlerProxyList = {
  proxyAppointmentHandlers?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentHandlerProxyMsg>>>;
};

export type Input_Patientportal_AppointmentHandlerProxyMsg = {
  appointmentHandler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AppointmentProxyList = {
  proxyAppointments?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentProxyMsg>>>;
};

export type Input_Patientportal_AppointmentProxyMsg = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AppointmentRequestProxyList = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  proxyAppointmentRequests?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentRequestProxyMsg>>>;
};

export type Input_Patientportal_AppointmentRequestProxyMsg = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AppointmentSeriesProxyMsg = {
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
  proxyAppointments?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentProxyMsg>>>;
};

export type Input_Patientportal_AppointmentTaskProxyMsg = {
  appointmentTask?: InputMaybe<Input_Resource_AppointmentTaskMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_AppointmentTypeProxyList = {
  proxyAppointmentTypes?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentTypeProxyMsg>>>;
};

export type Input_Patientportal_AppointmentTypeProxyMsg = {
  appointmentType?: InputMaybe<Input_Resource_AppointmentTypeMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_BookReservedAppointmentOrSeriesProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_BookReservedAppointmentOrSeriesRequest>;
};

export type Input_Patientportal_BookReservedAppointmentOrSeriesProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Resource_BookReservedAppointmentOrSeriesResponse>;
};

export type Input_Patientportal_CancelAppointmentProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_CancelAppointmentOrSeriesRequest>;
};

export type Input_Patientportal_CancelAppointmentRequestProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_CancelAppointmentRequestRequest>;
};

export type Input_Patientportal_CancelClinicalRequestProxyRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CancelClinicalRequestProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ClinicalRequestProxyMsg = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ClinicalRequestTemplateProxyMsg = {
  clinicalRequestTemplate?: InputMaybe<Input_Clinicalrequest_ClinicalRequestTemplateMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/**
 * A confirmable-action, is an action that has to be confirmed with a confirmation-provider.
 *  This message is always only sent to the initiator of an action.
 *  The initiator of an action owns a secret action-token.
 *  Each confirmation-provider owns at least one of two things (but can own both):
 *  - confirmation-code:
 *      This secret code is either sent to the confirmation-provider (e.g. via email) or can be computed by it (e.g. time-based OTP).
 *      The user can only confirm an action with it, if used together with the action-token of the initiator.
 *      As a result, this code has to either be manually entered on initiator device or a link/button containing the confirmation-code has to
 *      be activated on the device the action was initiated on, so that both pieces of information are present.
 *      Where we control the display of confirmation-codes to the user, the following guidelines should be used:
 *        - The confirmation-code text itself should be shown in a way that's easy to read and copy-and-paste compatible
 *        - If no confirmation-token is present for this provider, a link/button can be shown in addition to the confirmation-code text.
 *          When clicked, this link/button should auto-fill (and can auto-submit) the confirmation-code, but this can only be done on the
 *          same device the action was initiated, as explained above. This restriction should be hinted to the user
 *          in the UI. Implementing this link/button is especially important for long confirmation-codes that can occur in some situations.
 *  - confirmation-token:
 *      This secret token is only present for confirmation-providers it can be sent to (e.g email). The actual usage of this confirmation-token
 *      depends on the confirmation-token-mode of the confirmation-provider:
 *      - NO_CONFIRM:
 *          No confirmation-token is sent to any confirmation-provider.
 *      - PARTIAL_CONFIRM:
 *          In partial confirmation mode, the confirmation-token can be used to partially confirm the action without requiring any additional
 *          secrets. After being partially confirmed, an action still has to be fully confirmed. This is done using the action-token of the
 *          initiator, but this time also without requiring any additional secrets. This behavior is desirable for actions where the
 *          initiator is more or equally trustworthy in comparison to the confirmation-provider (e.g. 2FA sign-in).
 *          Note: The two steps described above can also be combined into one if both the confirmation-token and the action-token are present on
 *          the same device at the same time (e.g. when a confirmation-token link is clicked in the same browser).
 *      - FULL_CONFIRM:
 *          In full confirmation mode, the confirmation-token can be used to fully confirm the action without requiring any additional secrets.
 *          This behavior is desirable for actions where the initiator is less trustworthy than the confirmation-provider
 *          (e.g. password reset).
 *      For confirmation-tokens, we always display how they are displayed and these are the guidelines:
 *      - The confirmation-token should not be displayed as text
 *      - A link/button should be shown that automatically confirms the action fully or partially when activated.
 */
export type Input_Patientportal_ConfirmableActionMsg = {
  /** secret token, owned by the initiator */
  actionToken?: InputMaybe<Scalars['String']>;
  /** all confirmation-providers that own a confirmationCode/confirmationToken for this action */
  confirmationProviders?: InputMaybe<Array<InputMaybe<Input_Patientportal_ConfirmationProviderMsg>>>;
  /** until when this confirmable action is valid */
  expiresAt?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ConfirmationCodeInfoMsg = {
  length?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Patientportal_ConfirmationCodeType>;
};

export type Input_Patientportal_ConfirmationProviderEmailMsg = {
  /** if not set, only a confirmation-token was sent to this provider but no confirmation-code */
  confirmationCodeInfo?: InputMaybe<Input_Patientportal_ConfirmationCodeInfoMsg>;
  /** how confirmation-tokens sent to this confirmation-provider can be used, NO_CONFIRM means no confirmation-token was sent */
  confirmationTokenMode?: InputMaybe<Patientportal_ConfirmationTokenMode>;
  emailAddress?: InputMaybe<Scalars['String']>;
};

/**
 * Information on a specific confirmation-provider.
 *  Has flexible design to allow for more technologies in the future.
 */
export type Input_Patientportal_ConfirmationProviderMsg = {
  email?: InputMaybe<Input_Patientportal_ConfirmationProviderEmailMsg>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * ActionConfirmationProviderTimeBasedOtpMsg timeBasedOtp = 6;
   *  ActionConfirmationProviderWebauthnMsg webauthn = 7;
   */
  sms?: InputMaybe<Input_Patientportal_ConfirmationProviderSmsMsg>;
  type?: InputMaybe<Patientportal_ConfirmationProviderType>;
};

/** Information on a specific confirmation-provider that is sent to that provider itself. */
export type Input_Patientportal_ConfirmationProviderSelfInfoMsg = {
  confirmableActionId?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  confirmationProviderIndex?: InputMaybe<Scalars['Int']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmationTokenMode?: InputMaybe<Patientportal_ConfirmationTokenMode>;
};

export type Input_Patientportal_ConfirmationProviderSmsMsg = {
  /** if not set, only a confirmation-token was sent to this provider but no confirmation-code */
  confirmationCodeInfo?: InputMaybe<Input_Patientportal_ConfirmationCodeInfoMsg>;
  /** how confirmation-tokens sent to this confirmation-provider can be used, NO_CONFIRM means no confirmation-token was sent */
  confirmationTokenMode?: InputMaybe<Patientportal_ConfirmationTokenMode>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateAppointmentRequestProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_CreateAppointmentRequestRequest>;
};

export type Input_Patientportal_CreateClinicalRequestProxyRequest = {
  clinicalRequestTemplateId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  requesterUnitReference?: InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>;
};

export type Input_Patientportal_CreateClinicalRequestProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateCommentProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Comment_CreateCommentRequest>;
};

export type Input_Patientportal_CreateCommentProxyResponse = {
  comment?: InputMaybe<Input_Comment_CommentMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateExternalClinicRequest = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalClinicBranchMsg>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateExternalDepartmentRequest = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  externalClinicId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateExternalOrganizationalUnitRequest = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  externalDepartmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateFormAnswerGroupProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_CreateFormAnswerGroupRequest>;
};

export type Input_Patientportal_CreateFormAnswerGroupProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_CreateFormAnswerGroupResponse>;
};

export type Input_Patientportal_CreateFormProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_CreateFormRequest>;
};

export type Input_Patientportal_CreateFormProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_CreateFormResponse>;
};

export type Input_Patientportal_CreateOrUpdatePortalClinicRequest = {
  portalClinic?: InputMaybe<Input_Patientportal_PortalClinicMsg>;
};

export type Input_Patientportal_CreatePortalFacilityRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreatePortalFacilityResponse = {
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
};

export type Input_Patientportal_CreatePortalPatientDataSnapshotProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_CreatePortalPatientDataSnapshotRequest>;
};

export type Input_Patientportal_CreatePortalUserRequest = {
  captchaSolution?: InputMaybe<Scalars['String']>;
  deviceSecretId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Patientportal_PortalDeviceType>;
  password?: InputMaybe<Scalars['String']>;
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
};

export type Input_Patientportal_CreatePortalUserResponse = {
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  thirdPartyCommunicationVerificationConfirmableActions?: InputMaybe<Array<InputMaybe<Input_Patientportal_ConfirmableActionMsg>>>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateProfessionalPortalUserInviteRequest = {
  externalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  ownerPortalClinicId?: InputMaybe<Scalars['String']>;
  targetFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validityTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  whitelistedEmailDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whitelistedEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_CreateProfessionalPortalUserRequest = {
  captchaSolution?: InputMaybe<Scalars['String']>;
  /** only considered by backend if request comes from super user */
  enableTwoFactorAuthentication?: InputMaybe<Scalars['Boolean']>;
  inviteIdentifier?: InputMaybe<Input_Patientportal_ProfessionalPortalUserInviteIdentifier>;
  password?: InputMaybe<Scalars['String']>;
  portalUser?: InputMaybe<Input_Patientportal_ProfessionalPortalUserMsg>;
};

export type Input_Patientportal_CreateProfessionalPortalUserResponse = {
  portalUser?: InputMaybe<Input_Patientportal_ProfessionalPortalUserMsg>;
  thirdPartyCommunicationVerificationConfirmableActions?: InputMaybe<Array<InputMaybe<Input_Patientportal_ConfirmableActionMsg>>>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_CreateReasonForRepresentationPortalProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Treatment_ReasonForPresentationMsg>;
};

export type Input_Patientportal_DeleteClinicalRequestProxyRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteClinicalRequestProxyResponse = {
  deletedClinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteCommentProxyRequest = {
  commentId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteCommentProxyResponse = {
  deletedCommentId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteExternalClinicRequest = {
  externalClinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteExternalDepartmentRequest = {
  externalDepartmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteExternalOrganizationalUnitRequest = {
  externalOrganizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeleteFormAnswerGroupProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_DeleteFormAnswerGroupRequest>;
};

export type Input_Patientportal_DeleteFormAnswerGroupProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_DeleteFormAnswerGroupResponse>;
};

export type Input_Patientportal_DeletePortalFacilityRequest = {
  portalFacilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeletePortalFacilityResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_DeletePortalSnapshotsRequest = {
  /** All Ids of snapshots that should be deleted */
  snapshotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_DocumentMetadataProxyMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Input_Document_Transfer_DocumentMetadataMsg>;
};

export type Input_Patientportal_ExternalAdministrativeUnitReferenceList = {
  externalAdministrativeUnitReferences?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
};

export type Input_Patientportal_ExternalAdministrativeUnitReferenceMsg = {
  type?: InputMaybe<Patientportal_ExternalAdministrativeUnitReferenceType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** Additional information about locations of a clinic, not tied to organizational hierarchy */
export type Input_Patientportal_ExternalClinicBranchMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ExternalClinicList = {
  externalClinics?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalClinicMsg>>>;
};

export type Input_Patientportal_ExternalClinicMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  departments?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalDepartmentMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalClinicBranchMsg>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ExternalDepartmentList = {
  externalDepartments?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalDepartmentMsg>>>;
};

export type Input_Patientportal_ExternalDepartmentMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Input_Patientportal_ExternalOrganizationalUnitList = {
  externalOrganizationalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Input_Patientportal_ExternalOrganizationalUnitMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  departmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** This type is linked to a professional portal user */
export type Input_Patientportal_ExternalPractitionerMsg = {
  id?: InputMaybe<Scalars['String']>;
  medicalFieldIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Patientportal_FindClinicUserPortalStaffRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  clinicUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_FindClinicUserPortalStaffResponse = {
  portalStaff?: InputMaybe<Input_Patientportal_PortalStaffMsg>;
};

export type Input_Patientportal_FindCurrentLegalGuardianRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_FindCurrentLegalGuardianResponse = {
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  portalUserFound?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_FindCurrentPortalUserRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_FindCurrentPortalUserResponse = {
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  portalUserFound?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_FindCurrentProfessionalPortalUserResponse = {
  professionalPortalUser?: InputMaybe<Input_Patientportal_ProfessionalPortalUserMsg>;
  professionalPortalUserFound?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_FindFormSequenceAnswerProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_FindFormSequenceAnswerRequest>;
};

export type Input_Patientportal_FindFormSequenceAnswerProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_FindFormSequenceAnswerResponse>;
};

export type Input_Patientportal_FindPortalUserIdsByPatientIdsRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_FindPortalUserIdsByPatientIdsResponse = {
  patientIdToPortalUserId?: InputMaybe<Array<InputMaybe<Input_Patientportal_FindPortalUserIdsByPatientIdsResponse_PatientIdToPortalUserIdEntry>>>;
};

export type Input_Patientportal_FindPortalUserIdsByPatientIdsResponse_PatientIdToPortalUserIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_FindPortalUserRequest = {
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Input_Core_PhoneNumberMsg>;
};

export type Input_Patientportal_FindPortalUserResponse = {
  portalUsers?: InputMaybe<Array<InputMaybe<Input_Patientportal_SimplePortalUserMsg>>>;
};

export type Input_Patientportal_FindSiblingFormSequenceAnswerProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_FindSiblingFormSequenceAnswerRequest>;
};

export type Input_Patientportal_FindSiblingFormSequenceAnswerProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_FindSiblingFormSequenceAnswerResponse>;
};

export type Input_Patientportal_GetAnamnesisCardReasonPortalProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Treatment_GetAnamnesisCardReasonRequest>;
};

export type Input_Patientportal_GetAppointmentFormReferenceBlacklistProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetAppointmentFormReferenceBlacklistProxyResponse = {
  formReferenceBlacklist?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyResponse = {
  formTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetAppointmentHistoryProxyRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetAppointmentHistoryProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Resource_GetAppointmentHistoryResponse>;
};

export type Input_Patientportal_GetAppointmentProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAppointmentRequest>;
};

export type Input_Patientportal_GetAppointmentRequestProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAppointmentRequestRequest>;
};

export type Input_Patientportal_GetAppointmentSeriesProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAppointmentSeriesRequest>;
};

export type Input_Patientportal_GetAppointmentTaskProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAppointmentTaskRequest>;
};

export type Input_Patientportal_GetAppointmentTypeProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAppointmentTypeRequest>;
};

export type Input_Patientportal_GetAvailableAppointmentSlotsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_GetAvailableAppointmentTimesRequest>;
};

export type Input_Patientportal_GetClinicPortalFacilitiesRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetClinicPortalFacilitiesResponse = {
  paths?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityHierarchyPathMsg>>>;
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_GetClinicalRequestLetterDocumentProxyRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetClinicalRequestLetterDocumentProxyResponse = {
  document?: InputMaybe<Input_Document_DocumentMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetClinicalRequestProxyRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetClinicalRequestProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetCommentHistoryProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetCommentHistoryProxyResponse = {
  comments?: InputMaybe<Array<InputMaybe<Input_Comment_CommentMsg>>>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetCurrentLegalGuardiansRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetCurrentPortalUserClinicsResponse = {
  clinics?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserClinicMsg>>>;
};

export type Input_Patientportal_GetCurrentWardsRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetDocumentPortalProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  documentGroupId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  staticDocumentGroupId?: InputMaybe<Scalars['String']>;
  staticDocumentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetDocumentPortalProxyResponse = {
  document?: InputMaybe<Input_Patientportal_DocumentMetadataProxyMsg>;
};

export type Input_Patientportal_GetExternalClinicRequest = {
  externalClinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetExternalClinicsRequest = {
  externalClinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetExternalDepartmentRequest = {
  externalDepartmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetExternalDepartmentsRequest = {
  externalDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetExternalOrganizationalUnitRequest = {
  externalOrganizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetExternalOrganizationalUnitsRequest = {
  externalOrganizationalUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetFormAnswerGroupHierarchyProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetFormAnswerGroupHierarchyRequest>;
};

export type Input_Patientportal_GetFormAnswerGroupHierarchyProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetFormAnswerGroupHierarchyResponse>;
};

export type Input_Patientportal_GetFormProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetFormRequest>;
};

export type Input_Patientportal_GetFormProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetFormResponse>;
};

export type Input_Patientportal_GetFormQuestionGroupHierarchyProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetFormQuestionGroupHierarchyRequest>;
};

export type Input_Patientportal_GetFormQuestionGroupHierarchyProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetFormQuestionGroupHierarchyResponse>;
};

export type Input_Patientportal_GetFormSequenceAnswerProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetFormSequenceAnswerRequest>;
};

export type Input_Patientportal_GetFormSequenceAnswerProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetFormSequenceAnswerResponse>;
};

export type Input_Patientportal_GetFormTemplateProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetFormTemplateRequest>;
};

export type Input_Patientportal_GetFormTemplateProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetFormTemplateResponse>;
};

export type Input_Patientportal_GetOfficeHourPortalFacilityPathRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetOfficeHourPortalFacilityPathResponse = {
  path?: InputMaybe<Input_Patientportal_OfficeHourPortalFacilityPathMsg>;
};

export type Input_Patientportal_GetOfficeHoursPortalFacilityPathsRequest = {
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetOfficeHoursPortalFacilityPathsResponse = {
  paths?: InputMaybe<Array<InputMaybe<Input_Patientportal_OfficeHourPortalFacilityPathMsg>>>;
};

export type Input_Patientportal_GetPortalClinicRequest = {
  portalClinicId?: InputMaybe<Scalars['String']>;
  portalClinicName?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalFacilityHierarchyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  depth?: InputMaybe<Scalars['Int']>;
  /** optional filter: if set, only facilities that have at least one of the capabilities are returned */
  requiredCapabilities?: InputMaybe<Array<InputMaybe<Patientportal_PortalFacilityCapability>>>;
  rootPortalFacilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalFacilityHierarchyResponse = {
  parentId?: InputMaybe<Scalars['String']>;
  paths?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityHierarchyPathMsg>>>;
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_GetPortalFacilityPathsRequest = {
  /** If set, only ids and names will be returned */
  onlyName?: InputMaybe<Scalars['Boolean']>;
  portalFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetPortalFacilityPathsResponse = {
  paths?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityPathMsg>>>;
};

export type Input_Patientportal_GetPortalSnapshotsRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalStaffRequest = {
  portalStaffId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalStaffResponse = {
  portalStaff?: InputMaybe<Input_Patientportal_PortalStaffMsg>;
};

export type Input_Patientportal_GetPortalUserAppointmentSeriesProxyRequest = {
  /** Optional filter to limit the dates of appointment */
  filterEnd?: InputMaybe<Input_Timestamp>;
  /** Optional filter to limit the dates of appointments */
  filterStart?: InputMaybe<Input_Timestamp>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentSeriesStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentSeriesStatus>>>;
};

export type Input_Patientportal_GetPortalUserAppointmentSeriesProxyResponse = {
  proxyAppointmentSeries?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentSeriesProxyMsg>>>;
};

export type Input_Patientportal_GetPortalUserAppointmentsProxyRequest = {
  /** Optional filter to limit the dates of appointments */
  filterEnd?: InputMaybe<Input_Timestamp>;
  /** Optional filter to limit the dates of appointments */
  filterStart?: InputMaybe<Input_Timestamp>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>>>;
};

export type Input_Patientportal_GetPortalUserAppointmentsProxyResponse = {
  proxyAppointments?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentProxyMsg>>>;
};

export type Input_Patientportal_GetPortalUserDocumentsProxyRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalUserDocumentsProxyResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Patientportal_DocumentMetadataProxyMsg>>>;
};

export type Input_Patientportal_GetPortalUserPermissionsRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalUserRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetPortalUsersRequest = {
  portalUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetProfessionalPortalUserRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_GetProfessionalPortalUsersRequest = {
  portalUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_GetSequentialFormSummaryProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_GetSequentialFormSummaryRequest>;
};

export type Input_Patientportal_GetSequentialFormSummaryProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_GetSequentialFormSummaryResponse>;
};

export type Input_Patientportal_GrantPortalUserPermissionsRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
  portalUserPermissions?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserPermissionMsg>>>;
};

export type Input_Patientportal_ListAdditionalServicesProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ListAdditionalServicesRequest>;
};

export type Input_Patientportal_ListAppointmentFormsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_ListAppointmentFormsRequest>;
};

export type Input_Patientportal_ListAppointmentFormsProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_ListAppointmentFormsResponse>;
};

export type Input_Patientportal_ListAppointmentHandlersProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ListAppointmentHandlersRequest>;
};

export type Input_Patientportal_ListAppointmentTasksProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ListAppointmentTasksRequest>;
};

export type Input_Patientportal_ListAppointmentTasksProxyResponse = {
  proxyAppointmentTasks?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentTaskProxyMsg>>>;
};

export type Input_Patientportal_ListAppointmentsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ListAppointmentsRequest>;
};

export type Input_Patientportal_ListClinicalRequestPriorityLevelsProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ListClinicalRequestPriorityLevelsProxyResponse = {
  facilityId?: InputMaybe<Scalars['String']>;
  priorityLevels?: InputMaybe<Array<InputMaybe<Input_Clinicalrequest_ClinicalRequestPriorityLevelMsg>>>;
};

export type Input_Patientportal_ListClinicalRequestTemplatesProxyRequest = {
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Clinicalrequest_ListClinicalRequestTemplatesRequest>;
};

export type Input_Patientportal_ListClinicalRequestTemplatesProxyResponse = {
  proxyClinicalRequestTemplates?: InputMaybe<Array<InputMaybe<Input_Patientportal_ClinicalRequestTemplateProxyMsg>>>;
};

export type Input_Patientportal_ListCommentsProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Comment_ListCommentsRequest>;
};

export type Input_Patientportal_ListCommentsProxyResponse = {
  comments?: InputMaybe<Array<InputMaybe<Input_Comment_CommentMsg>>>;
  contextFilters?: InputMaybe<Array<InputMaybe<Input_Comment_ListCommentsRequestContextFilterMsg>>>;
  facilityId?: InputMaybe<Scalars['String']>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Patientportal_ListFormOptionsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_ListFormOptionsRequest>;
};

export type Input_Patientportal_ListFormOptionsProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_ListFormOptionsResponse>;
};

export type Input_Patientportal_ListPortalPatientDataSnapshotMetadataProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Portaldata_ListPortalPatientDataSnapshotMetadataRequest>;
};

export type Input_Patientportal_ListPortalPatientDataSnapshotMetadataProxyResponse = {
  response?: InputMaybe<Input_Portaldata_ListPortalPatientDataSnapshotMetadataResponse>;
};

export type Input_Patientportal_ListPortalUserAppointmentRequestsProxyRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ListPortalUserAppointmentTasksProxyResponse = {
  proxyAppointmentTasks?: InputMaybe<Array<InputMaybe<Input_Patientportal_AppointmentTaskProxyMsg>>>;
};

export type Input_Patientportal_ListPortalUserAppointmentTypesEntryProxyMsg = {
  appointmentType?: InputMaybe<Input_Resource_ListPortalUserAppointmentTypesEntryMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ListPortalUserAppointmentTypesProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ListPortalUserAppointmentTypesRequest>;
};

export type Input_Patientportal_ListPortalUserAppointmentTypesProxyResponse = {
  proxyAppointmentTypes?: InputMaybe<Array<InputMaybe<Input_Patientportal_ListPortalUserAppointmentTypesEntryProxyMsg>>>;
};

export type Input_Patientportal_ListUnsubmittedClinicalRequestsProxyRequest = {
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_ListUnsubmittedClinicalRequestsProxyResponse = {
  clinicalRequests?: InputMaybe<Array<InputMaybe<Input_Patientportal_ClinicalRequestProxyMsg>>>;
};

export type Input_Patientportal_MapPortalUserToInternalPatientRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  forceRelink?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_MapPortalUserToInternalPatientResponse = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_MergePatientsPortalRequest = {
  patientIdToBeMergedInto?: InputMaybe<Scalars['String']>;
  patientIdsToBeMerged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  portalClinicId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_OfficeHourPortalFacilityPathMsg = {
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_PartiallyConfirmActionRequest = {
  confirmableActionId?: InputMaybe<Scalars['String']>;
  confirmationProviderIndex?: InputMaybe<Scalars['Int']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
};

/** Configurations for portal accounts */
export type Input_Patientportal_PortalAccountSettingsMsg = {
  accessibilityModeActive?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_PortalClinicInformationMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_PortalClinicMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serverNetworkConfiguration?: InputMaybe<Input_Patientportal_ServerNetworkConfigurationMsg>;
};

export type Input_Patientportal_PortalDataSnapshotList = {
  snapshots?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalDataSnapshotMsg>>>;
};

/** Contains an encrypted snapshot of portal entity */
export type Input_Patientportal_PortalDataSnapshotMsg = {
  data?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  portalClinicInformation?: InputMaybe<Input_Patientportal_PortalClinicInformationMsg>;
  portalUserId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Patientportal_PortalSnapshotType>;
};

export type Input_Patientportal_PortalFacilityAnswerMsg = {
  answerText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_PortalFacilityFaqEntryMsg = {
  answer?: InputMaybe<Input_Patientportal_PortalFacilityAnswerMsg>;
  id?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Input_Patientportal_PortalFacilityQuestionMsg>;
};

export type Input_Patientportal_PortalFacilityHierarchyPathMsg = {
  childIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_PortalFacilityList = {
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_PortalFacilityMsg = {
  administrativeUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  capabilities?: InputMaybe<Array<InputMaybe<Patientportal_PortalFacilityCapability>>>;
  clinicId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  contactNote?: InputMaybe<Input_Core_LocalizedStringMsg>;
  dataProtectionInformationUrl?: InputMaybe<Scalars['String']>;
  frequentlyAskedQuestions?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityFaqEntryMsg>>>;
  headerImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  logoImageId?: InputMaybe<Scalars['String']>;
  longDescription?: InputMaybe<Input_Core_LocalizedStringMsg>;
  name?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Array<InputMaybe<Input_Patientportal_WeeklyScheduleMsg>>>;
  openingHoursFreeText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  shortDescription?: InputMaybe<Input_Core_LocalizedStringMsg>;
  showOpeningHours?: InputMaybe<Scalars['Boolean']>;
  showVisitingHours?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  visitingHours?: InputMaybe<Array<InputMaybe<Input_Patientportal_WeeklyScheduleMsg>>>;
  visitingHoursFreeText?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Patientportal_PortalFacilityPathMsg = {
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_PortalFacilityQuestionMsg = {
  id?: InputMaybe<Scalars['String']>;
  questionText?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Patientportal_PortalStaffMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  matrixUsername?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_PortalUserClinicMsg = {
  id?: InputMaybe<Scalars['String']>;
  isSyncEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_PortalUserList = {
  portalUsers?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserMsg>>>;
};

export type Input_Patientportal_PortalUserMsg = {
  accountVerificationRequiredForClinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  medicalDataSetupCompleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  phoneNumber?: InputMaybe<Scalars['Long']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Input_Patientportal_PortalAccountSettingsMsg>;
  sex?: InputMaybe<Core_Sex>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_PortalUserPermissionList = {
  portalUserPermissions?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserPermissionMsg>>>;
};

export type Input_Patientportal_PortalUserPermissionMsg = {
  accessPermission?: InputMaybe<User_AccessPermission>;
  expirationDate?: InputMaybe<Input_Timestamp>;
  permissionTarget?: InputMaybe<User_PermissionTarget>;
  targetPortalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_PortalUserRelationshipList = {
  relationships?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserRelationshipMsg>>>;
};

export type Input_Patientportal_PortalUserRelationshipMsg = {
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  state?: InputMaybe<Patientportal_PortalUserRelationshipState>;
  type?: InputMaybe<Patientportal_PortalUserRelationshipType>;
};

export type Input_Patientportal_PreparePasswordResetParamsMsg = {
  deviceSecretId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Patientportal_PreparePasswordResetRequest = {
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
  params?: InputMaybe<Input_Patientportal_PreparePasswordResetParamsMsg>;
};

export type Input_Patientportal_PreparePasswordResetResponse = {
  confirmableAction?: InputMaybe<Input_Patientportal_ConfirmableActionMsg>;
  success?: InputMaybe<Input_Patientportal_PreparePasswordResetSuccessMsg>;
};

export type Input_Patientportal_PreparePasswordResetSuccessMsg = {
  passwordResetToken?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ProfessionalPortalUserInviteIdentifier = {
  id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ProfessionalPortalUserInviteMsg = {
  externalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Patientportal_PortalClinicMsg>;
  targetFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  token?: InputMaybe<Scalars['String']>;
  validityTimeFrame?: InputMaybe<Input_TimeFrameMsg>;
  whitelistedEmailDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whitelistedEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Patientportal_ProfessionalPortalUserList = {
  portalUsers?: InputMaybe<Array<InputMaybe<Input_Patientportal_ProfessionalPortalUserMsg>>>;
};

export type Input_Patientportal_ProfessionalPortalUserMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  email?: InputMaybe<Scalars['String']>;
  externalPractitioner?: InputMaybe<Input_Patientportal_ExternalPractitionerMsg>;
  externalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordReset?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  permissions?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserPermissionMsg>>>;
  phoneNumber?: InputMaybe<Scalars['Long']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Input_Patientportal_PortalAccountSettingsMsg>;
  sex?: InputMaybe<Core_Sex>;
  verified?: InputMaybe<Scalars['Boolean']>;
  whitelistedConsultRecipients?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_RejectAppointmentProposalsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_RejectAppointmentProposalsRequest>;
};

export type Input_Patientportal_RejectLegalGuardianRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RejectWardRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RemoveClinicalRequestAccessRequest = {
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RemoveClinicalRequestInputProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Clinicalrequest_RemoveClinicalRequestInputRequest>;
};

export type Input_Patientportal_RemoveClinicalRequestInputProxyResponse = {
  facilityId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Clinicalrequest_RemoveClinicalRequestInputResponse>;
};

export type Input_Patientportal_RemoveCustomClinicalRequestInputProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Clinicalrequest_RemoveCustomClinicalRequestInputRequest>;
};

export type Input_Patientportal_RemoveCustomClinicalRequestInputProxyResponse = {
  facilityId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Clinicalrequest_RemoveCustomClinicalRequestInputResponse>;
};

export type Input_Patientportal_RemoveLegalGuardianRequest = {
  legalGuardianId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RemoveLegalGuardianResponse = {
  legalGuardian?: InputMaybe<Input_Patientportal_PortalUserMsg>;
};

export type Input_Patientportal_RemoveScheduleAssignmentProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_RemoveScheduleAssignmentRequest>;
};

export type Input_Patientportal_RemoveScheduleExceptionProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_RemoveScheduleExceptionRequest>;
};

export type Input_Patientportal_RenotifyConfirmationProviderRequest = {
  actionToken?: InputMaybe<Scalars['String']>;
  confirmableActionId?: InputMaybe<Scalars['String']>;
  confirmationProviderIndex?: InputMaybe<Scalars['Int']>;
};

export type Input_Patientportal_RenotifyConfirmationProviderResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RequestLegalGuardianRequest = {
  email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patientportal_PortalUserRelationshipType>;
};

export type Input_Patientportal_RequestWardRequest = {
  email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Patientportal_PortalUserRelationshipType>;
};

export type Input_Patientportal_ResetPasswordRequest = {
  newPassword?: InputMaybe<Scalars['String']>;
  passwordResetToken?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_ResetPasswordResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_RestartFormProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_RestartFormRequest>;
};

export type Input_Patientportal_RestartFormProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_RestartFormResponse>;
};

export type Input_Patientportal_RevokePortalUserPermissionsRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
  portalUserPermissions?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalUserPermissionMsg>>>;
};

export type Input_Patientportal_ScheduleAssignmentProxyMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ScheduleAssignmentMsg>;
};

export type Input_Patientportal_ScheduleExceptionProxyMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_ScheduleExceptionMsg>;
};

export type Input_Patientportal_SearchClinicalRequestsProxyRequest = {
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Clinicalrequest_SearchClinicalRequestsRequest>;
};

export type Input_Patientportal_SearchClinicalRequestsProxyResponse = {
  clinicalRequests?: InputMaybe<Array<InputMaybe<Input_Patientportal_ClinicalRequestProxyMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Patientportal_SearchExternalClinicsRequest = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SearchExternalDepartmentsRequest = {
  externalClinicId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SearchExternalDepartmentsResponse = {
  externalClinicId?: InputMaybe<Scalars['String']>;
  externalDepartments?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalDepartmentMsg>>>;
};

export type Input_Patientportal_SearchExternalOrganizationalUnitsRequest = {
  externalDepartmentId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SearchExternalOrganizationalUnitsResponse = {
  externalDepartmentId?: InputMaybe<Scalars['String']>;
  externalOrganizationalUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Input_Patientportal_SearchFormOptionsProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_SearchFormOptionsRequest>;
};

export type Input_Patientportal_SearchFormOptionsProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_SearchFormOptionsResponse>;
};

export type Input_Patientportal_SearchPortalFacilitiesRequest = {
  /** Optional input used to sort results and filter */
  coordinates?: InputMaybe<Input_Core_CoordinatesMsg>;
  /** Optional filter */
  languagesFilter?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** Must be provided in kilometers */
  maxDistanceFilter?: InputMaybe<Scalars['Float']>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
};

export type Input_Patientportal_SearchPortalFacilitiesResponse = {
  hitCount?: InputMaybe<Scalars['Int']>;
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_ServerNetworkConfigurationMsg = {
  host?: InputMaybe<Scalars['String']>;
  port?: InputMaybe<Scalars['Int']>;
};

export type Input_Patientportal_SetDeviceFirebaseTokenRequest = {
  deviceSecretId?: InputMaybe<Scalars['String']>;
  firebaseToken?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SetDeviceFirebaseTokenResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SignInPortalUserParamsMsg = {
  deviceSecretId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Patientportal_PortalDeviceType>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Core_UserType>;
};

export type Input_Patientportal_SignInPortalUserRequest = {
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
  params?: InputMaybe<Input_Patientportal_SignInPortalUserParamsMsg>;
};

export type Input_Patientportal_SignInPortalUserResponse = {
  confirmableAction?: InputMaybe<Input_Patientportal_ConfirmableActionMsg>;
  success?: InputMaybe<Input_Patientportal_SignInPortalUserSuccessMsg>;
};

export type Input_Patientportal_SignInPortalUserSuccessMsg = {
  encryptedMatrixRecoveryKey?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SimpleExternalAdministrativeUnitList = {
  externalAdministrativeUnits?: InputMaybe<Array<InputMaybe<Input_Patientportal_SimpleExternalAdministrativeUnitMsg>>>;
};

export type Input_Patientportal_SimpleExternalAdministrativeUnitMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Input_Patientportal_SimpleExternalAdministrativeUnitMsg>;
  type?: InputMaybe<Patientportal_ExternalAdministrativeUnitReferenceType>;
};

export type Input_Patientportal_SimplePortalUserMsg = {
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SubmitAppointmentRequestProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_SubmitAppointmentRequestRequest>;
};

export type Input_Patientportal_SubmitClinicalRequestProxyRequest = {
  clinicalRequestId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SubmitClinicalRequestProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_SwitchPortalUserRequest = {
  /** If left empty, switches to the legal guardian account if they are currently logged in as a ward */
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdateAnamnesisCardReasonPortalProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Treatment_UpdateAnamnesisCardReasonRequest>;
};

export type Input_Patientportal_UpdateAppointmentRequestProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_UpdateAppointmentRequestRequest>;
};

export type Input_Patientportal_UpdateAppointmentTaskResultProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_UpdateAppointmentTaskResultRequest>;
};

export type Input_Patientportal_UpdateAppointmentTaskStatusProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Resource_UpdateAppointmentTaskStatusRequest>;
};

export type Input_Patientportal_UpdateClinicalRequestProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Clinicalrequest_UpdateClinicalRequestRequest>;
};

export type Input_Patientportal_UpdateClinicalRequestProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdateCommentProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Comment_UpdateCommentRequest>;
};

export type Input_Patientportal_UpdateCommentProxyResponse = {
  comment?: InputMaybe<Input_Comment_CommentMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdateCustomClinicalRequestInputProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Clinicalrequest_UpdateCustomClinicalRequestInputRequest>;
};

export type Input_Patientportal_UpdateCustomClinicalRequestInputProxyResponse = {
  customClinicalRequestInput?: InputMaybe<Input_Clinicalrequest_CustomClinicalRequestInputMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdateFormStatusProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Form_UpdateFormStatusRequest>;
};

export type Input_Patientportal_UpdateFormStatusProxyResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Input_Form_UpdateFormStatusResponse>;
};

export type Input_Patientportal_UpdatePortalFacilityParentRequest = {
  parentId?: InputMaybe<Scalars['String']>;
  portalFacilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdatePortalFacilityParentResponse = {
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
};

export type Input_Patientportal_UpdatePortalFacilityParentsRequest = {
  requests?: InputMaybe<Array<InputMaybe<Input_Patientportal_UpdatePortalFacilityParentRequest>>>;
};

export type Input_Patientportal_UpdatePortalFacilityParentsResponse = {
  portalFacilities?: InputMaybe<Array<InputMaybe<Input_Patientportal_PortalFacilityMsg>>>;
};

export type Input_Patientportal_UpdatePortalFacilityRequest = {
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
};

export type Input_Patientportal_UpdatePortalFacilityResponse = {
  portalFacility?: InputMaybe<Input_Patientportal_PortalFacilityMsg>;
};

export type Input_Patientportal_UpdatePortalPatientAllergiesProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientAllergiesRequest>;
};

export type Input_Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesRequest>;
};

export type Input_Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyResponse = {
  response?: InputMaybe<Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesResponse>;
};

export type Input_Patientportal_UpdatePortalPatientDiagnosesProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientDiagnosesRequest>;
};

export type Input_Patientportal_UpdatePortalPatientDiaryEntriesProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientDiaryEntriesRequest>;
};

export type Input_Patientportal_UpdatePortalPatientMedicationsProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientMedicationsRequest>;
};

export type Input_Patientportal_UpdatePortalPatientQuantityEntriesProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientQuantityEntriesRequest>;
};

export type Input_Patientportal_UpdatePortalPatientSurgeriesProxyRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request?: InputMaybe<Input_Portaldata_UpdatePortalPatientSurgeriesRequest>;
};

export type Input_Patientportal_UpdatePortalUserClinicRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  isSyncEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Patientportal_UpdatePortalUserClinicResponse = {
  clinic?: InputMaybe<Input_Patientportal_PortalUserClinicMsg>;
};

export type Input_Patientportal_UpdatePortalUserPasswordParamsMsg = {
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_UpdatePortalUserPasswordRequest = {
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
  params?: InputMaybe<Input_Patientportal_UpdatePortalUserPasswordParamsMsg>;
};

export type Input_Patientportal_UpdatePortalUserPasswordResponse = {
  confirmableAction?: InputMaybe<Input_Patientportal_ConfirmableActionMsg>;
  success?: InputMaybe<Input_Helper_Empty>;
};

export type Input_Patientportal_UpdatePortalUserRequest = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  /** True sets the corresponding field true, otherwise does not change it */
  medicalDataSetupCompleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Patientportal_UpdatePortalUserResponse = {
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
};

export type Input_Patientportal_UpdatePortalUserSettingsRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  settings?: InputMaybe<Input_Patientportal_PortalAccountSettingsMsg>;
};

export type Input_Patientportal_UpdateRelevantProblemsProxyRequest = {
  facilityId?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Input_Clinicalrequest_UpdateRelevantProblemsRequest>;
};

export type Input_Patientportal_UpdateRelevantProblemsProxyResponse = {
  clinicalRequest?: InputMaybe<Input_Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_VerifyThirdPartyCommunicationParamsMsg = {
  email?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_VerifyThirdPartyCommunicationRequest = {
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
  params?: InputMaybe<Input_Patientportal_VerifyThirdPartyCommunicationParamsMsg>;
};

export type Input_Patientportal_VerifyThirdPartyCommunicationResponse = {
  confirmableAction?: InputMaybe<Input_Patientportal_ConfirmableActionMsg>;
  success?: InputMaybe<Input_Patientportal_VerifyThirdPartyCommunicationSuccessMsg>;
};

export type Input_Patientportal_VerifyThirdPartyCommunicationSuccessMsg = {
  token?: InputMaybe<Scalars['String']>;
};

export type Input_Patientportal_WeeklyScheduleMsg = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  id?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
};

export type Input_Portaldata_CreatePortalPatientDataSnapshotRequest = {
  snapshot?: InputMaybe<Input_Portaldata_PortalPatientDataSnapshotMsg>;
};

export type Input_Portaldata_ExternalPortalActiveIngredientIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalActiveIngredientIdType>;
};

export type Input_Portaldata_ExternalPortalActiveIngredientUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalActiveIngredientUnitIdType>;
};

export type Input_Portaldata_ExternalPortalDrugFormIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalDrugFormIdType>;
};

export type Input_Portaldata_ExternalPortalDrugIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Drug_ExternalDrugIdType>;
};

export type Input_Portaldata_ExternalPortalDrugPackageIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDrugPackageIdType>;
};

export type Input_Portaldata_ExternalPortalMedicationDosageUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export type Input_Portaldata_ListPortalPatientDataSnapshotMetadataRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_ListPortalPatientDataSnapshotMetadataResponse = {
  patientDataSnapshotMetadata?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalPatientDataSnapshotMetadataMsg>>>;
};

export type Input_Portaldata_ListPortalPatientDataSnapshotsRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_ListPortalPatientDataSnapshotsResponse = {
  portalPatientDataSnapshots?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalPatientDataSnapshotMsg>>>;
};

export type Input_Portaldata_PortalActiveIngredientMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalActiveIngredientIdMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  strength?: InputMaybe<Input_Portaldata_PortalActiveIngredientStrengthMsg>;
};

export type Input_Portaldata_PortalActiveIngredientStrengthMsg = {
  lowerValue?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Input_Portaldata_PortalActiveIngredientUnitMsg>;
  /** In some cases, the strength is provided as a range; in that case, this is required */
  upperValue?: InputMaybe<Scalars['Float']>;
};

export type Input_Portaldata_PortalActiveIngredientUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalActiveIngredientUnitIdMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalAllergyMsg = {
  allergen?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  clientId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reactionSeverity?: InputMaybe<Treatment_ReactionSeverity>;
  reactionType?: InputMaybe<Treatment_ReactionType>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Portaldata_PortalDiagnosisCodingMsg = {
  codingId?: InputMaybe<Scalars['String']>;
  system?: InputMaybe<Treatment_DiagnosisCodingSystem>;
  systemVersion?: InputMaybe<Scalars['String']>;
  /** Relevant if the system uses multiple types of codes */
  type?: InputMaybe<Treatment_DiagnosisCodeType>;
};

export type Input_Portaldata_PortalDiagnosisMsg = {
  clientId?: InputMaybe<Scalars['String']>;
  codings?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiagnosisCodingMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_DiagnosisDetailType>;
};

export type Input_Portaldata_PortalDiaryEntryContentFeverMsg = {
  temperatureC?: InputMaybe<Scalars['Float']>;
};

export type Input_Portaldata_PortalDiaryEntryContentHealthStatusMsg = {
  healthStatus?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDiaryEntryContentMsg = {
  contentFever?: InputMaybe<Input_Portaldata_PortalDiaryEntryContentFeverMsg>;
  contentHealthStatus?: InputMaybe<Input_Portaldata_PortalDiaryEntryContentHealthStatusMsg>;
  contentNotes?: InputMaybe<Input_Portaldata_PortalDiaryEntryContentNotesMsg>;
  contentPain?: InputMaybe<Input_Portaldata_PortalDiaryEntryContentPainMsg>;
  contentSymptom?: InputMaybe<Input_Portaldata_PortalDiaryEntryContentSymptomMsg>;
  contentType?: InputMaybe<Portaldata_PortalDiaryEntryContentType>;
  endTime?: InputMaybe<Input_Core_LocalTimeMsg>;
  startTime?: InputMaybe<Input_Core_LocalTimeMsg>;
};

export type Input_Portaldata_PortalDiaryEntryContentNotesMsg = {
  notes?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDiaryEntryContentPainMsg = {
  intensity?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDiaryEntryContentSymptomMsg = {
  intensity?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  symptom?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Portaldata_PortalDiaryEntryMsg = {
  clientId?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiaryEntryContentMsg>>>;
  date?: InputMaybe<Input_Core_LocalDateMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDrugFormMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalDrugFormIdMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDrugMsg = {
  activeIngredients?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalActiveIngredientMsg>>>;
  customText?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalDrugIdMsg>>>;
  form?: InputMaybe<Input_Portaldata_PortalDrugFormMsg>;
  /**
   * If this is set, only the customText is relevant, not the other fields.
   *  Relevant e.g. in cases in which several active ingredients are mixed in custom ratio to create this drug.
   */
  isCustom?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalDrugPackageMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalDrugPackageIdMsg>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalMedicationDosageUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Portaldata_ExternalPortalMedicationDosageUnitIdMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_PortalMedicationMsg = {
  clientId?: InputMaybe<Scalars['String']>;
  drug?: InputMaybe<Input_Portaldata_PortalDrugMsg>;
  drugPackage?: InputMaybe<Input_Portaldata_PortalDrugPackageMsg>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Input_Portaldata_PortalMedicationScheduleMsg>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  type?: InputMaybe<Portaldata_PortalMedicationType>;
};

export type Input_Portaldata_PortalMedicationScheduleMsg = {
  /** used with type WEEKLY */
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  dosageUnit?: InputMaybe<Input_Portaldata_PortalMedicationDosageUnitMsg>;
  /** used with type DAILY/WEEKLY */
  eveningDosageValue?: InputMaybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  morningDosageValue?: InputMaybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  nightDosageValue?: InputMaybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  noonDosageValue?: InputMaybe<Scalars['Float']>;
  /** used with type TEXT */
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Portaldata_PortalMedicationScheduleType>;
};

export type Input_Portaldata_PortalPatientDataSnapshotMetadataMsg = {
  patientDataSnapshotId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Portaldata_PortalPatientDataSnapshotStatus>;
  timestamp?: InputMaybe<Input_Timestamp>;
};

export type Input_Portaldata_PortalPatientDataSnapshotMsg = {
  allergies?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalAllergyMsg>>>;
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiagnosisMsg>>>;
  diaryEntries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiaryEntryMsg>>>;
  hasAllergies?: InputMaybe<Scalars['Boolean']>;
  hasDiagnoses?: InputMaybe<Scalars['Boolean']>;
  hasMedications?: InputMaybe<Scalars['Boolean']>;
  hasSurgeries?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalMedicationMsg>>>;
  quantityEntries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalQuantityEntryMsg>>>;
  status?: InputMaybe<Portaldata_PortalPatientDataSnapshotStatus>;
  surgeries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalSurgeryMsg>>>;
  timestamp?: InputMaybe<Input_Timestamp>;
};

export type Input_Portaldata_PortalQuantityBloodPressureMsg = {
  diastolicValueMmHg?: InputMaybe<Scalars['Int']>;
  systolicValueMmHg?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityBloodSugarMsg = {
  valueMgDl?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityDistanceWalkingRunningMsg = {
  valueM?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityEntryMsg = {
  clientId?: InputMaybe<Scalars['String']>;
  endTimestamp?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Input_Portaldata_PortalQuantityMsg>;
  startTimestamp?: InputMaybe<Input_Timestamp>;
};

export type Input_Portaldata_PortalQuantityFlightsClimbedMsg = {
  value?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityHeightMsg = {
  valueCm?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityMsg = {
  bloodPressure?: InputMaybe<Input_Portaldata_PortalQuantityBloodPressureMsg>;
  bloodSugar?: InputMaybe<Input_Portaldata_PortalQuantityBloodSugarMsg>;
  distanceWalkingRunning?: InputMaybe<Input_Portaldata_PortalQuantityDistanceWalkingRunningMsg>;
  flightsClimbed?: InputMaybe<Input_Portaldata_PortalQuantityFlightsClimbedMsg>;
  height?: InputMaybe<Input_Portaldata_PortalQuantityHeightMsg>;
  oxygenSaturation?: InputMaybe<Input_Portaldata_PortalQuantityOxygenSaturationMsg>;
  pulse?: InputMaybe<Input_Portaldata_PortalQuantityPulseMsg>;
  respiratoryRate?: InputMaybe<Input_Portaldata_PortalQuantityRespiratoryRateMsg>;
  stepCount?: InputMaybe<Input_Portaldata_PortalQuantityStepCountMsg>;
  temperature?: InputMaybe<Input_Portaldata_PortalQuantityTemperatureMsg>;
  type?: InputMaybe<Portaldata_PortalQuantityType>;
  weight?: InputMaybe<Input_Portaldata_PortalQuantityWeightMsg>;
};

export type Input_Portaldata_PortalQuantityOxygenSaturationMsg = {
  valuePercent?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityPulseMsg = {
  valueBpm?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityRespiratoryRateMsg = {
  valueBpm?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityStepCountMsg = {
  value?: InputMaybe<Scalars['Int']>;
};

export type Input_Portaldata_PortalQuantityTemperatureMsg = {
  valueC?: InputMaybe<Scalars['Float']>;
};

export type Input_Portaldata_PortalQuantityWeightMsg = {
  valueKg?: InputMaybe<Scalars['Float']>;
};

export type Input_Portaldata_PortalSurgeryMsg = {
  clientId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Input_Core_LocalDateTimeMsg>;
  id?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  notes?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  surgeon?: InputMaybe<Scalars['String']>;
};

export type Input_Portaldata_UpdatePortalPatientAllergiesRequest = {
  createdOrUpdatedPortalAllergies?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalAllergyMsg>>>;
  deletedPortalAllergyClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAllergies?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesRequest = {
  elements?: InputMaybe<Array<InputMaybe<Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesRequestElementMsg>>>;
};

export type Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesRequestElementMsg = {
  patientDataSnapshotId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Portaldata_PortalPatientDataSnapshotStatus>;
};

export type Input_Portaldata_UpdatePortalPatientDataSnapshotStatusesResponse = {
  changedPatientDataSnapshots?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalPatientDataSnapshotMetadataMsg>>>;
};

export type Input_Portaldata_UpdatePortalPatientDiagnosesRequest = {
  createdOrUpdatedPortalDiagnoses?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiagnosisMsg>>>;
  deletedPortalDiagnosisClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasDiagnoses?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Portaldata_UpdatePortalPatientDiaryEntriesRequest = {
  createdOrUpdatedPortalDiaryEntries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalDiaryEntryMsg>>>;
  deletedPortalDiaryEntryClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Portaldata_UpdatePortalPatientMedicationsRequest = {
  createdOrUpdatedPortalMedications?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalMedicationMsg>>>;
  deletedPortalMedicationClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasMedications?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Portaldata_UpdatePortalPatientQuantityEntriesRequest = {
  createdOrUpdatedPortalQuantityEntries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalQuantityEntryMsg>>>;
  deletedPortalQuantityEntryClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Portaldata_UpdatePortalPatientSurgeriesRequest = {
  createdOrUpdatedPortalSurgeries?: InputMaybe<Array<InputMaybe<Input_Portaldata_PortalSurgeryMsg>>>;
  deletedPortalSurgeryClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasSurgeries?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Reference_AgeMsg = {
  age?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<TimePrecisionLevel>;
};

/** If the category of the result is part of the list in this reference, the result is inconspicuous */
export type Input_Reference_CategoryReferenceMsg = {
  contain?: InputMaybe<Array<InputMaybe<Input_Category_ResultCategoryMsg>>>;
};

export type Input_Reference_DecimalReferenceMsg = {
  lower?: InputMaybe<Input_DecimalMsg>;
  lowerInclusive?: InputMaybe<Scalars['Boolean']>;
  upper?: InputMaybe<Input_DecimalMsg>;
  upperInclusive?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Reference_IntegerReferenceMsg = {
  lower?: InputMaybe<Scalars['Int']>;
  lowerInclusive?: InputMaybe<Scalars['Boolean']>;
  upper?: InputMaybe<Scalars['Int']>;
  upperInclusive?: InputMaybe<Scalars['Boolean']>;
};

/** A group of people identified by various criteria such as sex, age, or further medical characteristics */
export type Input_Reference_PopulationMsg = {
  /** inclusive */
  ageLower?: InputMaybe<Input_Reference_AgeMsg>;
  /** inclusive */
  ageUpper?: InputMaybe<Input_Reference_AgeMsg>;
  /** Can be set if the reference applies to a specific subset, e.g., pregnant women */
  flags?: InputMaybe<Array<InputMaybe<Input_Core_FlagMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sexes?: InputMaybe<Array<InputMaybe<Core_Sex>>>;
};

export type Input_Reference_RatioReferenceMsg = {
  lower?: InputMaybe<Input_RatioMsg>;
  lowerInclusive?: InputMaybe<Scalars['Boolean']>;
  upper?: InputMaybe<Input_RatioMsg>;
  upperInclusive?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Reference_ReferenceRangeMsg = {
  boolReference?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Input_Reference_CategoryReferenceMsg>;
  /**
   * Set true if the referenceRange is not defined for the TestAnalyte, but created ad-hoc;
   *  this is especially the case for external lab results.
   */
  customRange?: InputMaybe<Scalars['Boolean']>;
  /**
   * If the reference range should be displayed in a non-standardized way,
   *  e.g. using an overall description for a number of categories
   */
  customText?: InputMaybe<Scalars['String']>;
  decimalReference?: InputMaybe<Input_Reference_DecimalReferenceMsg>;
  /** For double values, number of digits behind the decimal point */
  fractionDigits?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  integerReference?: InputMaybe<Input_Reference_IntegerReferenceMsg>;
  /** The scope this reference range is valid for, like a measurement parameter. */
  parentId?: InputMaybe<Scalars['String']>;
  /** For whom this reference range is applicable */
  population?: InputMaybe<Input_Reference_PopulationMsg>;
  ratioReference?: InputMaybe<Input_Reference_RatioReferenceMsg>;
  text?: InputMaybe<Input_Reference_TextReferenceMsg>;
  type?: InputMaybe<Input_Reference_ReferenceRangeTypeMsg>;
};

export type Input_Reference_ReferenceRangeSystemMsg = {
  id?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  referenceRangeTypes?: InputMaybe<Array<InputMaybe<Input_Reference_ReferenceRangeTypeMsg>>>;
};

export type Input_Reference_ReferenceRangeTypeMsg = {
  colorCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** if true, the respective reference range is the inconspicuous, i.e., default, one */
  inconspicuousReference?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Reference_ReferenceRangeKind>;
  name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Reference_ReferenceRangeSeverity>;
};

export type Input_Reference_TextReferenceMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AcceptAppointmentProposalRequest = {
  /** The given proposed appointment will be booked and the others for the same request will be rejected */
  appointmentSlotProposalId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AddAppointmentSeriesAttendeesRequest = {
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  status?: InputMaybe<Resource_AppointmentStatus>;
};

export type Input_Resource_AddDepletableResourceChangeRequest = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  change?: InputMaybe<Input_Resource_DepletableResourceChangeMsg>;
};

export type Input_Resource_AdditionalServiceList = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Resource_AdditionalServiceMsg>>>;
};

export type Input_Resource_AdditionalServiceMsg = {
  /** We might need price unit in the future, for now it is in Euros */
  additionalPrice?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  /** In minutes */
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_LocalizedStringMsg>;
  officeHourId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Resource_AdditionalServiceStatus>;
};

export type Input_Resource_AppointmentAttendeeBasicInfoMsg = {
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
};

export type Input_Resource_AppointmentAttendeeInfoMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Resource_ExternalAppointmentAttendeeIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  sex?: InputMaybe<Core_Sex>;
};

export type Input_Resource_AppointmentAttendeeMsg = {
  /**
   * Used only when an appointment is created in the clinic side frontend for a patient (the actual human being)
   * that does not have a portal account or an internal patient (the backend entity)
   */
  attendeeInfo?: InputMaybe<Input_Resource_AppointmentAttendeeInfoMsg>;
  attendeeStatus?: InputMaybe<Resource_AppointmentStatus>;
  displayType?: InputMaybe<Resource_AppointmentAttendeeIdentifierDisplayType>;
  id?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AppointmentBasicInfoMsg = {
  appointmentTypeName?: InputMaybe<Input_Core_LocalizedStringMsg>;
  attendeeCount?: InputMaybe<Scalars['Int']>;
  attendeeInfos?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeBasicInfoMsg>>>;
  editingDisabled?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Input_Timestamp>;
  external?: InputMaybe<Scalars['Boolean']>;
  groupAppointment?: InputMaybe<Scalars['Boolean']>;
  groupAppointmentQuota?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  officeHourId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Input_Timestamp>;
  unverified?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentBlockList = {
  appointmentBlocks?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentBlockMsg>>>;
};

export type Input_Resource_AppointmentBlockMsg = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Input_Timestamp>;
  handlers?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerMsg>>>;
  officeHourId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_AppointmentBookerReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_AppointmentBookerReferenceType>;
};

export type Input_Resource_AppointmentConfigMsg = {
  /** Datetime appointment configuration starts being active */
  activeEnd?: InputMaybe<Input_Timestamp>;
  /** Datetime appointment configuration starts being active */
  activeStart?: InputMaybe<Input_Timestamp>;
  /** Whether portal users can see the available appointment slots or not */
  calendarVisible?: InputMaybe<Scalars['Boolean']>;
  coverageTypes?: InputMaybe<Array<InputMaybe<Billing_CoverageType>>>;
  filteringMode?: InputMaybe<Resource_AppointmentTypeFilteringMode>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to abort the booking process if one of the references of the last FormSequenceQuestion in a sequential Form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of this appointment config matches.
   */
  formReferenceBlacklist?: InputMaybe<Scalars['String']>;
  /** The id of the form template versioning group to be conducted when a portal user wants to book an appointment from the corresponding portal facility */
  formTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  planningHorizon?: InputMaybe<Resource_PlanningHorizon>;
  planningHorizonCustomQuarters?: InputMaybe<Array<InputMaybe<Input_VeiosTimeFrameMsg>>>;
  /** Defines how much time before the appointment the reminders are sent and via which methods. */
  reminderTimes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentReminderTimeMsg>>>;
  useDefaultQuarters?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentEventMsg = {
  appointmentEndTime?: InputMaybe<Input_Timestamp>;
  appointmentHandler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  appointmentStartTime?: InputMaybe<Input_Timestamp>;
  appointmentStatus?: InputMaybe<Resource_AppointmentStatus>;
  appointmentType?: InputMaybe<Input_Resource_AppointmentTypeMsg>;
  attendee?: InputMaybe<Input_Resource_AppointmentAttendeeMsg>;
  happenedAt?: InputMaybe<Input_Timestamp>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForForceScheduling?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForRebooking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  userReference?: InputMaybe<Input_Resource_AppointmentBookerReferenceMsg>;
};

export type Input_Resource_AppointmentFlagMsg = {
  activationStatus?: InputMaybe<Resource_AppointmentFlagActivationStatus>;
  /** Hexadecimal RGB */
  colorCode?: InputMaybe<Scalars['String']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Resource_AppointmentHandlerList = {
  appointmentHandlers?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerMsg>>>;
};

export type Input_Resource_AppointmentHandlerMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Resource_ExternalAppointmentHandlerIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Resource_AppointmentHandlerStatus>;
  title?: InputMaybe<Scalars['String']>;
  unitReferences?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  userAssignments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerUserAssignmentMsg>>>;
};

export type Input_Resource_AppointmentHandlerUserAssignmentMsg = {
  endTime?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** This object is not persisted. It is derived from the event history of the appointment and its connected requests. */
export type Input_Resource_AppointmentHistoryEventMsg = {
  actionType?: InputMaybe<Resource_AppointmentRequestActionType>;
  endTime?: InputMaybe<Input_Timestamp>;
  /** Event type should be combined with action type */
  eventType?: InputMaybe<Resource_AppointmentHistoryEventType>;
  /** If the event type is "BOOKED" */
  startTime?: InputMaybe<Input_Timestamp>;
  timestamp?: InputMaybe<Input_Timestamp>;
  userReference?: InputMaybe<Input_Resource_AppointmentBookerReferenceMsg>;
};

/** Allows linking various procedures etc. to appointments to allow navigating between them */
export type Input_Resource_AppointmentLinkMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_AppointmentLinkType>;
};

export type Input_Resource_AppointmentList = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
};

export type Input_Resource_AppointmentMsg = {
  /** Additional services can be selected from the list of additional services the appointment type offers. It is enough to set the ids. */
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Resource_AdditionalServiceMsg>>>;
  appointmentFlags?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentFlagMsg>>>;
  /** Series won't have appointments to prevent an infinite loop */
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
  /** TODO remove */
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  /** For group appointments, status from attendee is the binding one for the attendee */
  appointmentStatus?: InputMaybe<Resource_AppointmentStatus>;
  appointmentType?: InputMaybe<Input_Resource_AppointmentTypeMsg>;
  attendeeCount?: InputMaybe<Scalars['Int']>;
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  comment?: InputMaybe<Scalars['String']>;
  /** For some cases, editing of imported appointments in our system should be blocked */
  editingDisabled?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Input_Timestamp>;
  /**
   * The event history is still relevant for group appointments' history.
   *  For the full history of the appointment for a specific attendee including the request history, use getAppointmentHistory call.
   */
  eventHistory?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentEventMsg>>>;
  /** Booked or requested by a patient portal user */
  external?: InputMaybe<Scalars['Boolean']>;
  /** This external id and external flag above are not related */
  externalIds?: InputMaybe<Array<InputMaybe<Input_Resource_ExternalAppointmentIdMsg>>>;
  forceScheduled?: InputMaybe<Scalars['Boolean']>;
  /** The two fields for group appointment are initially taken over from appointment type but can be updated by professionals */
  groupAppointment?: InputMaybe<Scalars['Boolean']>;
  groupAppointmentQuota?: InputMaybe<Scalars['Int']>;
  handler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  id?: InputMaybe<Scalars['String']>;
  /** Marks whether appointment was created in an external system and only imported into our system */
  imported?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentLinkMsg>>>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  officeHourId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Boolean']>;
  /** Not stored on the appointment; only added to this message when explicitly requested */
  requestBasicInfos?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestBasicInfoMsg>>>;
  requestContextReference?: InputMaybe<Input_Resource_AppointmentRequestContextReferenceMsg>;
  startTime?: InputMaybe<Input_Timestamp>;
  unverified?: InputMaybe<Scalars['Boolean']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AppointmentRegularScheduleDetailsList = {
  scheduleDetails?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRegularScheduleDetailsMsg>>>;
};

export type Input_Resource_AppointmentRegularScheduleDetailsMsg = {
  appointmentConfigurationId?: InputMaybe<Scalars['String']>;
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeMsg>>>;
  officeHourId?: InputMaybe<Scalars['String']>;
  planningHorizon?: InputMaybe<Resource_PlanningHorizon>;
  weekDaysConfigs?: InputMaybe<Array<InputMaybe<Input_Resource_WeekDaysConfigMsg>>>;
};

export type Input_Resource_AppointmentReminderTimeMsg = {
  mode?: InputMaybe<Resource_AppointmentReminderMode>;
  /** How much time, in the given units, before the appointment, the reminder should be sent. */
  timeInterval?: InputMaybe<Scalars['Long']>;
  /** Time unit */
  unit?: InputMaybe<TimePrecisionLevel>;
};

export type Input_Resource_AppointmentRequestAgreementMsg = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Input_Resource_AppointmentRequestAgreementTemplateMsg>;
};

export type Input_Resource_AppointmentRequestAgreementTemplateMsg = {
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  id?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
};

/** Contains information from the request that may be needed in combination with an appointment */
export type Input_Resource_AppointmentRequestBasicInfoMsg = {
  agreements?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestAgreementMsg>>>;
  comment?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  requestPreferencesFreeText?: InputMaybe<Scalars['String']>;
  submissionDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_AppointmentRequestConfigMsg = {
  /** When turned on, patients can update a request and send it back, after the proposal step (converting it to an inbound request if it is already not) */
  allowCounterRequests?: InputMaybe<Scalars['Boolean']>;
  appointmentRequestSetting?: InputMaybe<Resource_AppointmentRequestSetting>;
  /** priority of waiting requests are, True: manually entered, False: automatically calculated */
  autoPrioritySetting?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether approval of the request is manual or automatic
   * It can be automatic only when the slot selection is also automatic.
   */
  autoRequestApproval?: InputMaybe<Scalars['Boolean']>;
  /** Whether selection of slots is manual or automatic */
  autoSlotSelection?: InputMaybe<Scalars['Boolean']>;
  /**
   * If turned on, the appointment requests made by the patients will block the time slot and the resources.
   * It requires having appointment request setting set to SLOT_REQUEST
   * For auto approval case, this becomes irrelevant as every request is either approved or rejected automatically as soon as they are submitted
   */
  blockingInboundRequests?: InputMaybe<Scalars['Boolean']>;
  /** If turned on, the appointment proposals made to the patients as well as the appointment requests made by the clinic will block the time slot and the resources. */
  blockingOutboundRequestsAndProposedSlots?: InputMaybe<Scalars['Boolean']>;
  /** How much time, in the given units, after the submission, the request must be expired. */
  deadlineInterval?: InputMaybe<Scalars['Int']>;
  /** Time unit */
  deadlineUnit?: InputMaybe<TimeUnit>;
  id?: InputMaybe<Scalars['String']>;
  /** Must be 1 if proposeSlots is false */
  numberOfAutoProposedSlots?: InputMaybe<Scalars['Int']>;
  /**
   * This field is a helper field. The actual information is stored in the other fields.
   *  When this is set, BE overrides the other fields to form the selected preset's config.
   */
  preset?: InputMaybe<Resource_AppointmentRequestConfigPreset>;
  /**
   * Whether the selected slots are proposed or the selected slot is directly booked
   * If set to false, only one slot must be selected in the slot selection step.
   */
  proposeSlots?: InputMaybe<Scalars['Boolean']>;
  timeoutForProposedSlots?: InputMaybe<Scalars['Int']>;
  timeoutPrecisionLevelForProposedSlots?: InputMaybe<TimePrecisionLevel>;
  waitingListEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentRequestContextReferenceMsg = {
  /** Optional: reference id */
  referenceId?: InputMaybe<Scalars['String']>;
  requestContextType?: InputMaybe<Resource_AppointmentRequestContextType>;
};

export type Input_Resource_AppointmentRequestEventMsg = {
  id?: InputMaybe<Scalars['String']>;
  requestActionType?: InputMaybe<Resource_AppointmentRequestActionType>;
  requestDirection?: InputMaybe<Resource_AppointmentRequestDirection>;
  requestPreferences?: InputMaybe<Input_Resource_AppointmentRequestPreferencesMsg>;
  requestStatus?: InputMaybe<Resource_AppointmentRequestStatus>;
  requesterReference?: InputMaybe<Input_Resource_AppointmentRequesterReferenceMsg>;
  slotProposals?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentSlotProposalMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Resource_AppointmentRequestList = {
  appointmentRequests?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestMsg>>>;
};

export type Input_Resource_AppointmentRequestMsg = {
  actionType?: InputMaybe<Resource_AppointmentRequestActionType>;
  /** Additional services can be selected from the list of additional services the appointment type offers. It is enough to set the ids. */
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Resource_AdditionalServiceMsg>>>;
  agreements?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestAgreementMsg>>>;
  appointmentFlags?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentFlagMsg>>>;
  appointmentSlotProposals?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentSlotProposalMsg>>>;
  appointmentType?: InputMaybe<Input_Resource_AppointmentTypeMsg>;
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
  comment?: InputMaybe<Scalars['String']>;
  createdInOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  eventHistory?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestEventMsg>>>;
  /** TODO: workaround solution that should be replaced by appointment request tasks */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  reasonForArchiving?: InputMaybe<Scalars['String']>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForRejection?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForRejectionExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForVisit?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  requestContextReference?: InputMaybe<Input_Resource_AppointmentRequestContextReferenceMsg>;
  requestDirection?: InputMaybe<Resource_AppointmentRequestDirection>;
  requestPreferences?: InputMaybe<Input_Resource_AppointmentRequestPreferencesMsg>;
  requester?: InputMaybe<Input_Resource_AppointmentRequesterReferenceMsg>;
  status?: InputMaybe<Resource_AppointmentRequestStatus>;
  submissionDate?: InputMaybe<Input_Timestamp>;
  unverified?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentRequestPreferencesMsg = {
  /** Preferred handler, optional */
  appointmentHandler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  exactTimeSlot?: InputMaybe<Input_Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg>;
  /**
   * True means only the slots that patients can book
   * False means only the slots that patients can not book
   * Null means all slots
   * Patient portal requests must always set this to true, no restriction for clinic
   */
  freeText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  insideTimeFrame?: InputMaybe<Input_Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  patientBookable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg = {
  end?: InputMaybe<Input_Timestamp>;
  start?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_AppointmentRequesterReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  requesterType?: InputMaybe<Resource_AppointmentRequesterType>;
};

export type Input_Resource_AppointmentSeriesList = {
  appointmentSeries?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentSeriesMsg>>>;
};

export type Input_Resource_AppointmentSeriesMsg = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Resource_AppointmentSeriesStatus>;
  title?: InputMaybe<Scalars['String']>;
  /**
   * If the appointments of the series is from various administrative units,
   * this should reference an administrative unit that contains the administrative units of the appointments
   * so that the permission check is easier and no permission denied issue is faced later when appointments are processed one by one
   */
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_AppointmentSlotProposalMsg = {
  endTime?: InputMaybe<Input_Timestamp>;
  groupAppointment?: InputMaybe<Scalars['Boolean']>;
  handler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  /**
   * If exists, it (or the attendee if it is a group appointment) will have the status "PENDING", it will block the time slot and the resources.
   * Its existence depends on the appointment type.
   */
  proposedAppointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  startTime?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Resource_AppointmentSlotProposalStatus>;
};

export type Input_Resource_AppointmentTaskContentReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_AppointmentTaskContentType>;
};

export type Input_Resource_AppointmentTaskContentTemplateReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_AppointmentTaskContentTemplateType>;
};

export type Input_Resource_AppointmentTaskList = {
  appointmentTasks?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskMsg>>>;
};

export type Input_Resource_AppointmentTaskMsg = {
  appointmentId?: InputMaybe<Scalars['String']>;
  contentReferences?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskContentReferenceMsg>>>;
  dueStage?: InputMaybe<Resource_AppointmentTaskDueStage>;
  id?: InputMaybe<Scalars['String']>;
  information?: InputMaybe<Input_Core_LocalizedStringMsg>;
  portalUserId?: InputMaybe<Scalars['String']>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  resultReferences?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskResultReferenceMsg>>>;
  status?: InputMaybe<Resource_AppointmentTaskStatus>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  taskTemplate?: InputMaybe<Input_Resource_AppointmentTaskTemplateMsg>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
  type?: InputMaybe<Resource_AppointmentTaskType>;
};

export type Input_Resource_AppointmentTaskResultReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_AppointmentTaskResultType>;
};

export type Input_Resource_AppointmentTaskTemplateMsg = {
  contentTemplateReferences?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskContentTemplateReferenceMsg>>>;
  dueStage?: InputMaybe<Resource_AppointmentTaskDueStage>;
  id?: InputMaybe<Scalars['String']>;
  information?: InputMaybe<Input_Core_LocalizedStringMsg>;
  officeHourId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Resource_AppointmentTaskTemplateStatus>;
  subtitle?: InputMaybe<Input_Core_LocalizedStringMsg>;
  taskType?: InputMaybe<Resource_AppointmentTaskType>;
  title?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Resource_AppointmentTimeFrameList = {
  appointmentTimeFrames?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTimeFrameMsg>>>;
};

export type Input_Resource_AppointmentTimeFrameMsg = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Input_Timestamp>;
  handler?: InputMaybe<Input_Resource_AppointmentHandlerMsg>;
  officeHourId?: InputMaybe<Scalars['String']>;
  patientBookableAppointment?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_AppointmentTypeAnswerMsg = {
  answerText?: InputMaybe<Input_Core_LocalizedStringMsg>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AppointmentTypeAppointmentLimitMsg = {
  activeEnd?: InputMaybe<Input_Timestamp>;
  /** Time frame can be null, means it has no start or end */
  activeStart?: InputMaybe<Input_Timestamp>;
  /** Limit has to be greater than or equal to 0 */
  appointmentLimit?: InputMaybe<Scalars['Int']>;
  /** Unit can be MONTH, WEEK, DAY */
  limitUnit?: InputMaybe<TimeUnit>;
};

export type Input_Resource_AppointmentTypeFaqEntryMsg = {
  answer?: InputMaybe<Input_Resource_AppointmentTypeAnswerMsg>;
  id?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Input_Resource_AppointmentTypeQuestionMsg>;
};

export type Input_Resource_AppointmentTypeList = {
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeMsg>>>;
};

export type Input_Resource_AppointmentTypeMsg = {
  additionalServices?: InputMaybe<Array<InputMaybe<Input_Resource_AdditionalServiceMsg>>>;
  agreementTemplates?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestAgreementTemplateMsg>>>;
  allowPortalUserCancellation?: InputMaybe<Scalars['Boolean']>;
  allowPortalUserRescheduling?: InputMaybe<Scalars['Boolean']>;
  appointmentFlags?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentFlagMsg>>>;
  appointmentLocations?: InputMaybe<Array<InputMaybe<Resource_AppointmentLocation>>>;
  /** For initial booking */
  appointmentRequestConfig?: InputMaybe<Input_Resource_AppointmentRequestConfigMsg>;
  appointmentTaskTemplates?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskTemplateMsg>>>;
  /**
   * If true: users cannot book an appointment of this appointmentType if they have an ongoing appointment request
   * or if they have an already booked appointment
   *
   * Ongoing appointment request: An appointment request with status equal to one of the following: {submitted, approved, in_proposal, fulfilled}
   */
  blockMultipleBookings?: InputMaybe<Scalars['Boolean']>;
  /** RGB color code */
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  /** In minutes */
  duration?: InputMaybe<Scalars['Int']>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Resource_ExternalAppointmentTypeIdMsg>>>;
  externalVideoAppointment?: InputMaybe<Scalars['Boolean']>;
  externalVideoAppointmentNote?: InputMaybe<Input_Core_LocalizedStringMsg>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to abort the booking process if one of the references of the last FormSequenceQuestion in a sequential Form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of this appointment type matches.
   */
  formReferenceBlacklist?: InputMaybe<Scalars['String']>;
  /**
   * The id of the form template versioning group to be conducted when a portal user wants to book an appointment of this appointment type,
   *  to be filled directly after selecting this appointment type
   */
  formTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
  frequentlyAskedQuestions?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeFaqEntryMsg>>>;
  /** In minutes */
  granularity?: InputMaybe<Scalars['Int']>;
  groupAppointment?: InputMaybe<Scalars['Boolean']>;
  groupAppointmentQuota?: InputMaybe<Scalars['Int']>;
  handlerSelectable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  includedServices?: InputMaybe<Array<InputMaybe<Input_Resource_IncludedServiceMsg>>>;
  /** Denotes that an appointment-booking portal-user has to provide their insurance type. Does not affect anything in the backend, currently. */
  insuranceTypeRequired?: InputMaybe<Scalars['Boolean']>;
  limits?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeAppointmentLimitMsg>>>;
  /** allows jumping into various cockpits from appointments */
  linkedCockpitTypes?: InputMaybe<Array<InputMaybe<Resource_CockpitType>>>;
  name?: InputMaybe<Input_Core_LocalizedStringMsg>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to filter appointment-types by the references of the last FormSequenceQuestion in a sequential form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of appointment config
   */
  parentConfigFormReferenceWhitelist?: InputMaybe<Scalars['String']>;
  phoneAppointmentNote?: InputMaybe<Input_Core_LocalizedStringMsg>;
  portalDisplayName?: InputMaybe<Input_Core_LocalizedStringMsg>;
  /**
   * How much time, in the given units, before the appointment, the appointment can be cancelled by the portal user,
   *  if enabled by allowPortalUserCancellation.
   */
  portalUserCancellationTimeInterval?: InputMaybe<Scalars['Int']>;
  portalUserCancellationTimeUnit?: InputMaybe<TimeUnit>;
  /** defines which procedures etc. can be linked to appointments of this type */
  possibleAppointmentLinks?: InputMaybe<Array<InputMaybe<Resource_AppointmentLinkType>>>;
  /**
   * The id of the form template versioning group to be conducted when a portal user wants to submit an appointment
   *  request from the corresponding portal facility. Form needs to be completed before request submission is possible.
   */
  preSubmissionFormTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
  /** used for deployment */
  referenceId?: InputMaybe<Scalars['String']>;
  /**
   * Overrides the same field from the office hour appointment config.
   * Defines how much time before the appointment the reminders are sent and via which methods.
   */
  reminderTimes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentReminderTimeMsg>>>;
  /**
   * If rescheduling config does not exist, appointmentRequestConfig will be used.
   *  Currently a completely independent rescheduling request config feature is not specified.
   *  For that reason, BE will sync data from appointmentRequestConfig to reschedulingRequestConfig.
   *  If directBooking preset is active, the fields regarding direct booking will be the exception to the sync.
   */
  reschedulingRequestConfig?: InputMaybe<Input_Resource_AppointmentRequestConfigMsg>;
  status?: InputMaybe<Resource_AppointmentTypeStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /**
   * Can be used to turn off reminders for an appointment type whose office hour has reminders.
   *  If the appointment type has reminderConfigs, this field becomes obsolete, as the office hour reminders are overridden anyway.
   */
  turnOffOfficeHourReminderConfigs?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_AppointmentTypeQuestionMsg = {
  id?: InputMaybe<Scalars['String']>;
  questionText?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Resource_ApproveAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  /** if appointment request config states manual appointment approval and manual slot selection, slots must be provided */
  proposedSlots?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTimeFrameMsg>>>;
};

export type Input_Resource_ApproveAppointmentRequestResponse = {
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  result?: InputMaybe<Input_Resource_ApproveAppointmentRequestResponseMessageMsg>;
};

export type Input_Resource_ApproveAppointmentRequestResponseMessageMsg = {
  message?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_ApproveAppointmentRequestsRequest = {
  requests?: InputMaybe<Array<InputMaybe<Input_Resource_ApproveAppointmentRequestRequest>>>;
};

export type Input_Resource_ApproveAppointmentRequestsResponse = {
  responses?: InputMaybe<Array<InputMaybe<Input_Resource_ApproveAppointmentRequestResponse>>>;
};

export type Input_Resource_ArchiveAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  reasonForArchiving?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_AssignmentSexCountMapMsg = {
  count?: InputMaybe<Scalars['Int']>;
  sex?: InputMaybe<Resource_AssignmentSex>;
};

export type Input_Resource_BedLocationBottleneckMsg = {
  overbookingCount?: InputMaybe<Scalars['Int']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_BedLocationResourceMsg = {
  outlets?: InputMaybe<Array<InputMaybe<Input_Resource_OutletMsg>>>;
  roomId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_BedLocationsOverviewEntryMsg = {
  /** blocked by isolation, would otherwise be available */
  bedLocationsBlockedOnlyByIsolationCount?: InputMaybe<Scalars['Int']>;
  /** have a blocking assignment */
  blockedBedLocationsCount?: InputMaybe<Scalars['Int']>;
  /** not assigned, but have been booked via contingent, so they need a bed location */
  bookedContingentAssignmentCount?: InputMaybe<Scalars['Int']>;
  entries?: InputMaybe<Array<InputMaybe<Input_Resource_FreeBedLocationsOverviewEntryMsg>>>;
  /** available for assignment */
  freeBedLocationsCount?: InputMaybe<Scalars['Int']>;
  occupiedBedLocationsCount?: InputMaybe<Scalars['Int']>;
  occupiedTemporaryBedLocationsCount?: InputMaybe<Scalars['Int']>;
  totalBedLocations?: InputMaybe<Scalars['Int']>;
  totalTemporaryBedLocations?: InputMaybe<Scalars['Int']>;
};

/** ------------- Model Types ------------- */
export type Input_Resource_BedResourceMsg = {
  bedLocationId?: InputMaybe<Scalars['String']>;
  bedType?: InputMaybe<Input_Resource_BedTypeMsg>;
};

export type Input_Resource_BedTypeMsg = {
  bedHandling?: InputMaybe<Resource_BedHandlingType>;
  maxCapacityKilograms?: InputMaybe<Scalars['Float']>;
};

export type Input_Resource_BookReservedAppointmentOrSeriesRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  /** If provided, the appointment will be booked for only these attendees, otherwise all */
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  /** Relevant only when the appointment is force scheduled */
  reasonsForForceScheduling?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForRebooking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_BookReservedAppointmentOrSeriesResponse = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
};

export type Input_Resource_CancelAppointmentOrSeriesRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  /** If provided, appointment will be cancelled for only these attendees */
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  /** If set to true and the appointment is a part of series, cancel the later ones in the same series. */
  deleteLaterAppointments?: InputMaybe<Scalars['Boolean']>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_CancelAppointmentOrSeriesResponse = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
};

export type Input_Resource_CancelAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_CancelExternalAppointmentsRequest = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Resource_ExternalAppointmentIdMsg>>>;
};

export type Input_Resource_CancelStaticResourceAssignmentRequest = {
  staticResourceAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_CancelStaticResourceAssignmentResponse = {
  staticResourceAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_CreateAppointmentFlagRequest = {
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  immediatelyActivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** mandatory */
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_CreateAppointmentFlagResponse = {
  flag?: InputMaybe<Input_Resource_AppointmentFlagMsg>;
};

export type Input_Resource_CreateAppointmentRequest = {
  /** Optional: provide to include additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  forceCreation?: InputMaybe<Scalars['Boolean']>;
  /** considered only if forceCreation is true and the appointment status is BOOKED */
  reasonsForForceScheduling?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_CreateAppointmentRequestRequest = {
  /** Optional: provide to include additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
};

export type Input_Resource_CreateAppointmentSeriesAppointmentsRequest = {
  /** Optional: provide to include additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  /**
   * Provide the ids of the existing appointment series attendees.
   *  If no attendees are provided, all attendees of the series will be used.
   */
  attendeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional override for appointment type's default duration */
  duration?: InputMaybe<Scalars['Int']>;
  /** Date of first appointment */
  firstDate?: InputMaybe<Input_Timestamp>;
  /** Optional filters for preferred handlers */
  handlerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The last date an appointment can take place */
  lastDate?: InputMaybe<Input_Timestamp>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  minusDays?: InputMaybe<Scalars['Int']>;
  /** The preferred number of appointments */
  numberOfAppointments?: InputMaybe<Scalars['Int']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /** mandatory information for defining recurrence of appointments */
  period?: InputMaybe<Scalars['Int']>;
  periodUnit?: InputMaybe<TimeUnit>;
  /**
   * Optional input fields to make the search flexible in case an appointment can not be found
   *  on the preferred dates
   */
  plusDays?: InputMaybe<Scalars['Int']>;
};

export type Input_Resource_CreateAppointmentTaskRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentTask?: InputMaybe<Input_Resource_AppointmentTaskMsg>;
  /** Optional list of portal user Ids */
  portalUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_CreateAppointmentTaskResponse = {
  appointmentTasks?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskMsg>>>;
};

export type Input_Resource_CreateDepletableResourceRequest = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  resource?: InputMaybe<Input_Resource_DepletableResourceMsg>;
};

export type Input_Resource_CreateOrJoinAppointmentRequest = {
  /** Optional: provide to include additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentId?: InputMaybe<Scalars['String']>;
  /** Can be used to connect appointments to appointments series */
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  /** If no attendees are provided, an empty attendee with status `RESERVED` will be automatically added */
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  forceCreation?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Resource_AppointmentLocation>;
  /** considered only if forceCreation is true and the appointment status is BOOKED */
  reasonsForForceScheduling?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  slot?: InputMaybe<Input_Resource_AppointmentTimeFrameMsg>;
  /** For simplicity, all attendees has to have the same status. If left empty, the status will be reserved. */
  status?: InputMaybe<Resource_AppointmentStatus>;
};

/** Create */
export type Input_Resource_CreateStaticResourceRequest = {
  administrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  parentResourceId?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Input_Resource_StaticResourceMsg>;
  updateParent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_CurrentAssignmentStatusesMsg = {
  assignmentStatuses?: InputMaybe<Array<InputMaybe<Resource_StaticResourceAssignmentType>>>;
};

export type Input_Resource_DateList = {
  dates?: InputMaybe<Array<InputMaybe<Input_Timestamp>>>;
};

export type Input_Resource_DateToBedLocationsOverviewMapMsg = {
  date?: InputMaybe<Input_Timestamp>;
  entry?: InputMaybe<Input_Resource_BedLocationsOverviewEntryMsg>;
};

export type Input_Resource_DeleteAppointmentFlagRequest = {
  flagId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DeleteAppointmentFlagResponse = {
  deletedFlagId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DeleteAppointmentTaskRequest = {
  appointmentTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DeleteAppointmentTaskTemplateRequest = {
  templateId?: InputMaybe<Scalars['String']>;
};

/** Delete */
export type Input_Resource_DeleteDepletableResourceRequest = {
  resourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DeleteStaticResourceCategoryRequest = {
  categoryId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DeleteStaticResourceRequest = {
  resourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_DepletableResourceChangeMsg = {
  amountD?: InputMaybe<Scalars['Float']>;
  amountI?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Input_Timestamp>;
  externalId?: InputMaybe<Scalars['String']>;
  externalType?: InputMaybe<Resource_ExternalType>;
  id?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Input_Resource_DepletableResourceMsg>;
  resourceInformation?: InputMaybe<Input_Resource_ResourceInformationMsg>;
};

export type Input_Resource_DepletableResourceList = {
  depletableResources?: InputMaybe<Array<InputMaybe<Input_Resource_DepletableResourceMsg>>>;
};

/** ----- Depletable Resources ----- // */
export type Input_Resource_DepletableResourceMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  externalType?: InputMaybe<Resource_ExternalType>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  resourceInformation?: InputMaybe<Input_Resource_ResourceInformationMsg>;
  unitType?: InputMaybe<Resource_UnitType>;
};

export type Input_Resource_ExternalAppointmentAttendeeIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ExternalAppointmentHandlerIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ExternalAppointmentIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ExternalAppointmentTypeIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ExternalResourceIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_ExternalResourceIdType>;
};

export type Input_Resource_FindAppointmentAttendeeRequest = {
  externalAppointmentAttendeeId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_FindAppointmentAttendeeResponse = {
  attendee?: InputMaybe<Input_Resource_AppointmentAttendeeMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_FindResourceTypeRequest = {
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_FindResourceTypeResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Input_Resource_ResourceTypeMsg>;
};

export type Input_Resource_FindStaticResourceNamesByIdsRequest = {
  staticResourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_FindStaticResourceNamesByIdsResponse = {
  staticResourceNameById?: InputMaybe<Array<InputMaybe<Input_Resource_FindStaticResourceNamesByIdsResponse_StaticResourceNameByIdEntry>>>;
};

export type Input_Resource_FindStaticResourceNamesByIdsResponse_StaticResourceNameByIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_FindStaticResourceParametersMsg = {
  externalId?: InputMaybe<Input_Resource_ExternalResourceIdMsg>;
  name?: InputMaybe<Scalars['String']>;
  parentResourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_StaticResourceType>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_FindStaticResourceRequest = {
  parameters?: InputMaybe<Input_Resource_FindStaticResourceParametersMsg>;
  referenceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_FindStaticResourceResponse = {
  found?: InputMaybe<Scalars['Boolean']>;
  staticResource?: InputMaybe<Input_Resource_StaticResourceMsg>;
};

export type Input_Resource_FlagsAdministrativeUnitContextMsg = {
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: InputMaybe<Scalars['Boolean']>;
  ownerUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_Resource_FlagsOfficeHourContextMsg = {
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_FreeBedLocationsOverviewEntryMsg = {
  sexToCountMaps?: InputMaybe<Array<InputMaybe<Input_Resource_AssignmentSexCountMapMsg>>>;
  /** Administrative unit is joined to the message */
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_GetAccountVerificationRequiredRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentConfigRequest = {
  appointmentConfigId?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentFormReferenceBlacklistRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentFormReferenceBlacklistResponse = {
  formReferenceBlacklist?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentFormTemplateVersioningGroupIdRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentFormTemplateVersioningGroupIdResponse = {
  formTemplateVersioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentHistoryRequest = {
  /**
   * Optional field for portal user requests, the attendee will be deducted from the current portal user id.
   *  Mandatory for clinic user requests.
   */
  appointmentAttendeeId?: InputMaybe<Scalars['String']>;
  appointmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentHistoryResponse = {
  events?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHistoryEventMsg>>>;
};

export type Input_Resource_GetAppointmentRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  /** If set, includes request information in the response */
  getRequestInfo?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_GetAppointmentRequestDocumentsRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentRequestDocumentsResponse = {
  documents?: InputMaybe<Array<InputMaybe<Input_Document_DocumentBasicInfoMsg>>>;
};

export type Input_Resource_GetAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentRequestsRequest = {
  appointmentRequestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_GetAppointmentSeriesRequest = {
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentTaskRequest = {
  appointmentTaskId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentTypeRequest = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentTypesRequest = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentTypeReferenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_GetAppointmentWaitingListRequest = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetAppointmentsRequest = {
  appointmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_GetAppointmentsResponse = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
};

export type Input_Resource_GetAvailableAppointmentBlocksRequest = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** End datetime of filter */
  end?: InputMaybe<Input_Timestamp>;
  handlerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inPersonAppointment?: InputMaybe<Scalars['Boolean']>;
  /** Merge overlapping blocks of different handlers with same appointment type */
  mergeBlocks?: InputMaybe<Scalars['Boolean']>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True: patients can book, false: patients can not book, null: all */
  patientBookable?: InputMaybe<Scalars['Boolean']>;
  /** Start datetime of filter */
  start?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_GetAvailableAppointmentTimesRequest = {
  additionalServiceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the appointment that should not block the availability of the results */
  appointmentId?: InputMaybe<Scalars['String']>;
  /** Appointment type is necessary to determine the correct appointment config */
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  /** The length of the appointment that is being looked for, only for clinic side */
  duration?: InputMaybe<Scalars['Int']>;
  /** End datetime of filter */
  end?: InputMaybe<Input_Timestamp>;
  handlerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Maximum number of results that will be returned */
  maxNumberOfResults?: InputMaybe<Scalars['Int']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /**
   * True means only the slots that patients can book
   * False means only the slots that patients can not book
   * Null means all slots
   * Patient portal requests must always set this to true, no restriction for clinic
   */
  patientBookable?: InputMaybe<Scalars['Boolean']>;
  /** Start datetime of filter */
  start?: InputMaybe<Input_Timestamp>;
  timeFrames?: InputMaybe<Array<InputMaybe<Input_Core_TimeFrameOfDayMsg>>>;
};

export type Input_Resource_GetBedLocationsBottlenecksRequest = {
  filterEnd?: InputMaybe<Input_Timestamp>;
  filterStart?: InputMaybe<Input_Timestamp>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_GetBedLocationsBottlenecksResponse = {
  /** List of dates where at least one overbooking was done */
  bottlenecks?: InputMaybe<Array<InputMaybe<Input_Resource_BedLocationBottleneckMsg>>>;
};

export type Input_Resource_GetBedLocationsOccupancyTrendRequest = {
  filterEnd?: InputMaybe<Input_Timestamp>;
  filterStart?: InputMaybe<Input_Timestamp>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_GetBedLocationsOccupancyTrendResponse = {
  /** Provide entries sorted by instant, ascending */
  entries?: InputMaybe<Array<InputMaybe<Input_Resource_GetBedLocationsOccupancyTrendResponseEntry>>>;
};

export type Input_Resource_GetBedLocationsOccupancyTrendResponseEntry = {
  /** TODO granularity needs to be discussed */
  instant?: InputMaybe<Input_Timestamp>;
  /** number of occupied bed locations / total bed locations at the instant given */
  occupancyRatio?: InputMaybe<Scalars['Float']>;
};

export type Input_Resource_GetBedLocationsOverviewRequest = {
  filterEnd?: InputMaybe<Input_Timestamp>;
  filterStart?: InputMaybe<Input_Timestamp>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_GetBedLocationsOverviewResponse = {
  overviews?: InputMaybe<Array<InputMaybe<Input_Resource_DateToBedLocationsOverviewMapMsg>>>;
};

export type Input_Resource_GetPatientAppointmentsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetPatientAppointmentsResponse = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetResourceTypesRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_GetResourceTypesResponse = {
  types?: InputMaybe<Array<InputMaybe<Input_Resource_ResourceTypeMsg>>>;
};

export type Input_Resource_GetStaticResourceAssignmentRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetStaticResourceAssignmentsRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_GetStaticResourceRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_GetStaticResourcesRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_IncludedServiceMsg = {
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_LocalizedStringMsg>;
};

export type Input_Resource_LinkVisitToAppointmentRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListAdditionalServicesRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListAppointmentFlagsRequest = {
  administrativeUnit?: InputMaybe<Input_Resource_FlagsAdministrativeUnitContextMsg>;
  officeHour?: InputMaybe<Input_Resource_FlagsOfficeHourContextMsg>;
};

export type Input_Resource_ListAppointmentFlagsResponse = {
  flags?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentFlagMsg>>>;
};

export type Input_Resource_ListAppointmentHandlersRequest = {
  administrativeUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /** Optional filter; if no statuses are provided, defaults to only returning active ones */
  statuses?: InputMaybe<Array<InputMaybe<Resource_AppointmentHandlerStatus>>>;
};

export type Input_Resource_ListAppointmentRegularScheduleDetailsRequest = {
  officeHoursIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  planningHorizon?: InputMaybe<Resource_PlanningHorizon>;
};

export type Input_Resource_ListAppointmentRequestsRequest = {
  appointmentFlagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdInOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Optional list of appointment locations */
  locations?: InputMaybe<Array<InputMaybe<Resource_AppointmentLocation>>>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional pagination */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Resource_AppointmentRequestStatus>>>;
  /** Optional order, default decreasing */
  submissionTimeSortOrder?: InputMaybe<Helper_SortOrder>;
};

export type Input_Resource_ListAppointmentRequestsResponse = {
  appointmentRequests?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentRequestMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Resource_ListAppointmentSchedulesRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListAppointmentSchedulesResponse = {
  appointmentConfigurationId?: InputMaybe<Scalars['String']>;
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeMsg>>>;
  officeHourId?: InputMaybe<Scalars['String']>;
  scheduleAssignments?: InputMaybe<Array<InputMaybe<Input_Resource_ScheduleAssignmentMsg>>>;
  scheduleExceptions?: InputMaybe<Array<InputMaybe<Input_Resource_ScheduleExceptionMsg>>>;
};

export type Input_Resource_ListAppointmentSeriesRequest = {
  /** Optional */
  appointmentAttendeeInfoId?: InputMaybe<Scalars['String']>;
  /** End datetime of filter request */
  filterEnd?: InputMaybe<Input_Timestamp>;
  /** Start datetime of filter request */
  filterStart?: InputMaybe<Input_Timestamp>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  /** filter appointment series where status is in this list. if empty, it is ignored. */
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentSeriesStatus>>>;
  /** filter appointment series where status is not in this list. if empty, it is ignored. */
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentSeriesStatus>>>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_ListAppointmentTaskTemplatesRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Resource_AppointmentTaskTemplateStatus>>>;
};

export type Input_Resource_ListAppointmentTaskTemplatesResponse = {
  templates?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskTemplateMsg>>>;
};

export type Input_Resource_ListAppointmentTasksRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListAppointmentTypesRequest = {
  /** Optional, the language the types should be listed in alphabetically */
  locale?: InputMaybe<Scalars['String']>;
  /** At least one is mandatory */
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional filter; if no statuses are provided, defaults to only returning active ones */
  statuses?: InputMaybe<Array<InputMaybe<Resource_AppointmentTypeStatus>>>;
};

export type Input_Resource_ListAppointmentsRequest = {
  appointmentAttendeeInfoId?: InputMaybe<Scalars['String']>;
  appointmentFlagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional order, default decreasing */
  bookingTimeSortOrder?: InputMaybe<Helper_SortOrder>;
  clinicId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  /** True: booked or requested by portal user, False: Booked or requested by clinic user, Null: Both */
  external?: InputMaybe<Scalars['Boolean']>;
  /** End datetime of filter request */
  filterEnd?: InputMaybe<Input_Timestamp>;
  /** Start datetime of filter request */
  filterStart?: InputMaybe<Input_Timestamp>;
  handlerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * If set to true, only return appointments that have the imported flag set to true; if false, only those with false; if null, don't filter by this.
   *  This cannot be used in combination with the external flag; so if imported is not null, external is ignored
   */
  imported?: InputMaybe<Scalars['Boolean']>;
  /** Optional appointment locations */
  locations?: InputMaybe<Array<InputMaybe<Resource_AppointmentLocation>>>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Optional pagination */
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  patientId?: InputMaybe<Scalars['String']>;
  portalUserId?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Boolean']>;
  /** Optional order, default decreasing */
  startTimeSortOrder?: InputMaybe<Helper_SortOrder>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_ListAppointmentsResponse = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Resource_ListOperatingRoomComplexRoomIdsRequest = {
  operatingRoomComplexIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_ListOperatingRoomComplexRoomIdsResponse = {
  operatingRoomComplexIdToResourceIds?: InputMaybe<Array<InputMaybe<Input_Resource_ListOperatingRoomComplexRoomIdsResponse_OperatingRoomComplexIdToResourceIdsEntry>>>;
};

export type Input_Resource_ListOperatingRoomComplexRoomIdsResponse_OperatingRoomComplexIdToResourceIdsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Resource_StaticResourceIdList>;
};

export type Input_Resource_ListPortalUserAppointmentTasksRequest = {
  portalUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListPortalUserAppointmentTypesEntryMsg = {
  appointmentType?: InputMaybe<Input_Resource_AppointmentTypeMsg>;
  bookingState?: InputMaybe<Resource_AppointmentTypeBookingState>;
};

export type Input_Resource_ListPortalUserAppointmentTypesRequest = {
  /**
   * This list should be created from FormSequenceQuestionMsg->linkedReferences->id of the last FormSequenceQuestionMsg that
   *  is encountered.
   *  It's an optional filter, if no ids are provided, this filter is not applied.
   */
  formReferencesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional, the language the types should be listed in alphabetically */
  locale?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /** Optional filter, if none is provided, all types are returned */
  statuses?: InputMaybe<Array<InputMaybe<Resource_AppointmentTypeStatus>>>;
};

export type Input_Resource_ListPortalUserAppointmentTypesResponse = {
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_ListPortalUserAppointmentTypesEntryMsg>>>;
};

export type Input_Resource_ListResourcesRequest = {
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used
   *  to check for any possible assignments these resources have.
   *  If these fields are set, only assignments in this timeframe will be considered, if not
   *  only currently active assignments will be considered.
   *  If only checkAssignmentsFrom is given, the checked timeframe will start and end at the moment of checkAssignmentsFrom.
   *  If only checkAssignmentsUntil is given, the checked timeframe will start from now until this stamp.
   */
  checkAssignmentsFrom?: InputMaybe<Input_Timestamp>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used
   *  to check for any possible assignments these resources have.
   *  If these fields are set, only assignments in this timeframe will be considered, if not
   *  only currently active assignments will be considered.
   *  If only checkAssignmentsFrom is given, the checked timeframe will start and end at the moment of checkAssignmentsFrom.
   *  If only checkAssignmentsUntil is given, the checked timeframe will start from now until this stamp.
   */
  checkAssignmentsUntil?: InputMaybe<Input_Timestamp>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used to filter
   *  resources that have no available child resources of the given type
   *  the type is required since many resources that are connected to a parent also have child resources
   */
  checkChildrenAvailability?: InputMaybe<Scalars['Boolean']>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used to filter
   *  resources that have no available child resources of the given type
   *  the type is required since many resources that are connected to a parent also have child resources
   */
  childrenType?: InputMaybe<Resource_StaticResourceType>;
  currentAssignmentStatuses?: InputMaybe<Input_Resource_CurrentAssignmentStatusesMsg>;
  /** WARNING: this is not for regular usage, only set to true when explicitly required */
  includeTemporaryResources?: InputMaybe<Scalars['Boolean']>;
  /** Ignored if includeTemporaryResources is not true. If set, returns only those that have are explicitly marked as parent-less */
  onlyTemporaryWithoutParents?: InputMaybe<Scalars['Boolean']>;
  /** only works if type is set as operating room */
  operatingRoomComplexId?: InputMaybe<Scalars['String']>;
  parentResourceId?: InputMaybe<Scalars['String']>;
  removeAssigned?: InputMaybe<Scalars['Boolean']>;
  returnChildren?: InputMaybe<Scalars['Boolean']>;
  returnCurrentAssignments?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Resource_StaticResourceType>;
  units?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_Resource_ListStaticResourceAssignmentRequest = {
  /** At least one of resourceId, visitId must be set */
  resourceId?: InputMaybe<Scalars['String']>;
  returnOldAssignments?: InputMaybe<Scalars['Boolean']>;
  /** At least one of resourceId, visitId must be set */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListStaticResourceAssignmentTimeFramesEntryMsg = {
  assignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  endTime?: InputMaybe<Input_Timestamp>;
  /** Static resource assignment exception id, if the time frame is based on one */
  exceptionId?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_ListStaticResourceAssignmentTimeFramesRequest = {
  filterEnd?: InputMaybe<Input_Timestamp>;
  filterStart?: InputMaybe<Input_Timestamp>;
  /** Special case for operating rooms, gets time frames for all assignments of the operating rooms of the complex */
  operatingRoomComplexId?: InputMaybe<Scalars['String']>;
  /** Adds in session time frames too */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Either set staticResourceAssignmentIds, staticResourceIds or operatingRoomComplexId */
  staticResourceAssignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  staticResourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusIn?: InputMaybe<Array<InputMaybe<Resource_ResourceAssignmentStatus>>>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_ResourceAssignmentStatus>>>;
  typesIn?: InputMaybe<Array<InputMaybe<Resource_StaticResourceAssignmentType>>>;
  typesNotIn?: InputMaybe<Array<InputMaybe<Resource_StaticResourceAssignmentType>>>;
};

export type Input_Resource_ListStaticResourceAssignmentTimeFramesResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Resource_ListStaticResourceAssignmentTimeFramesEntryMsg>>>;
};

/** TODO: find fields to filter with */
export type Input_Resource_ListStaticResourceCategoriesRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ListStaticResourcesResponse = {
  assignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentsMapMsg>>>;
  staticResources?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceMsg>>>;
};

export type Input_Resource_OperatingRoomMsg = {
  /** TODO : fill it according to needs */
  operatingRoomComplexId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_OutletMsg = {
  bedLocationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  outletType?: InputMaybe<Resource_OutletType>;
  roomId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ReassignStaticResourceRequest = {
  /** if true, a temporary resource will be created with the data in temporaryResourceDefinition */
  createTemporaryResource?: InputMaybe<Scalars['Boolean']>;
  forceAssignment?: InputMaybe<Scalars['Boolean']>;
  isolation?: InputMaybe<Scalars['Boolean']>;
  newAssignmentSex?: InputMaybe<Resource_AssignmentSex>;
  newEndDate?: InputMaybe<Input_Timestamp>;
  /** ignored if create temporary resource is set */
  newResourceId?: InputMaybe<Scalars['String']>;
  oldAssignmentId?: InputMaybe<Scalars['String']>;
  oldResourceAssignee?: InputMaybe<Input_Resource_UnassignStaticResourceByAssigneeRequest>;
  removeEndDate?: InputMaybe<Scalars['Boolean']>;
  swapIfFull?: InputMaybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: InputMaybe<Input_Resource_TemporaryResourceDefinitionMsg>;
};

export type Input_Resource_ReassignStaticResourceResponse = {
  /** if there were conflicting assignments that could be swapped */
  assignmentsCreatedForOldResource?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
  /** if there were conflicting assignments that could be swapped */
  assignmentsRemovedFromNewResource?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
  /** assignment created as a result of reassigning action */
  newAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  /** assignment that ended as a result of reassigning action */
  oldAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  warning?: InputMaybe<Resource_RequestStaticResourceWarning>;
};

export type Input_Resource_RefreshReservedAppointmentOrSeriesRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  /** If provided, the appointment will be refreshed for only these attendees, otherwise all */
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
};

export type Input_Resource_RefreshReservedAppointmentOrSeriesResponse = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
};

export type Input_Resource_RegularScheduleEntryMsg = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  handlers?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerMsg>>>;
  timeFrame?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
};

export type Input_Resource_RejectAppointmentProposalsRequest = {
  /** Rejects all proposed appointments for this request */
  appointmentRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RejectAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  reasonsForRejection?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForRejectionExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_RejectAppointmentRequestsRequest = {
  requests?: InputMaybe<Array<InputMaybe<Input_Resource_RejectAppointmentRequestRequest>>>;
};

export type Input_Resource_RemoveAdditionalServiceRequest = {
  additionalServiceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RemoveAppointmentConfigRequest = {
  appointmentConfigId?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RemoveAppointmentHandlerRequest = {
  appointmentHandlerId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RemoveAppointmentTypeRequest = {
  appointmentTypeId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RemoveScheduleAssignmentRequest = {
  scheduleAssignmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RemoveScheduleExceptionRequest = {
  scheduleExceptionId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RequestDepletableResourceRequest = {
  acquirerId?: InputMaybe<Scalars['String']>;
  acquirerType?: InputMaybe<Resource_ResourceAcquirerType>;
  amountD?: InputMaybe<Scalars['Float']>;
  amountI?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Input_Timestamp>;
  resourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_RequestStaticResourceRequest = {
  assignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  /** if true, a temporary resource will be created with the data in temporaryResourceDefinition, the resource in the assignment will be ignored */
  createTemporaryResource?: InputMaybe<Scalars['Boolean']>;
  forceAssignment?: InputMaybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: InputMaybe<Input_Resource_TemporaryResourceDefinitionMsg>;
};

export type Input_Resource_RequestStaticResourceResponse = {
  assignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  granted?: InputMaybe<Scalars['Boolean']>;
  warning?: InputMaybe<Resource_RequestStaticResourceWarning>;
};

export type Input_Resource_RequestStaticResourcesRequest = {
  assignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
};

export type Input_Resource_RequestStaticResourcesResponse = {
  assignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
};

export type Input_Resource_ReserveAssignedResourceRequest = {
  assignmentId?: InputMaybe<Scalars['String']>;
  reserveUntil?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_ReserveAssignedResourceResponse = {
  futureAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  oldAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  reserveAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
};

export type Input_Resource_ResetAppointmentStatusRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ResourceAssignmentCreatorMsg = {
  creatorId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_ResourceAssignmentCreatorType>;
};

export type Input_Resource_ResourceIdList = {
  resourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_ResourceInformationMsg = {
  expirationDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  manufactureDate?: InputMaybe<Input_Timestamp>;
  partNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ResourceListResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ResourceManufacturerMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_ResourceTypeMsg = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Input_Resource_ResourceManufacturerMsg>;
  modelNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  staticResourceType?: InputMaybe<Resource_StaticResourceType>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

/** Request */
export type Input_Resource_ResourcesRequest = {
  depletableRequests?: InputMaybe<Array<InputMaybe<Input_Resource_RequestDepletableResourceRequest>>>;
  staticRequests?: InputMaybe<Array<InputMaybe<Input_Resource_RequestStaticResourceRequest>>>;
};

export type Input_Resource_RoomResourceMsg = {
  bedLocations?: InputMaybe<Array<InputMaybe<Input_Resource_BedLocationResourceMsg>>>;
  isolated?: InputMaybe<Scalars['Boolean']>;
  isolationTypeId?: InputMaybe<Scalars['String']>;
  outlets?: InputMaybe<Array<InputMaybe<Input_Resource_OutletMsg>>>;
  restroomType?: InputMaybe<Resource_RestroomType>;
  /** Dynamically and automatically assigned to the room */
  sex?: InputMaybe<Resource_AssignmentSex>;
  /**
   * the latest time the sex assignment of the room is valid
   *  when a gendered assignment is set to a room, the expiration date is the end date of the assignment
   *  if there are multiple gendered assignments in the room, this date is the end date of the earliest ending assignment
   *  if this date is in the past, there are no guarantees that the sex of the room is correct,
   *  recalculateAssignmentSexes can be used to manually align room sexes
   */
  sexExpirationDate?: InputMaybe<Input_Timestamp>;
  showerType?: InputMaybe<Resource_ShowerType>;
};

export type Input_Resource_ScheduleAssignmentList = {
  scheduleAssignments?: InputMaybe<Array<InputMaybe<Input_Resource_ScheduleAssignmentMsg>>>;
};

export type Input_Resource_ScheduleAssignmentMsg = {
  /** Datetime schedule assigment stops being active */
  activeEnd?: InputMaybe<Input_Timestamp>;
  /** Datetime schedule assigment starts being active */
  activeStart?: InputMaybe<Input_Timestamp>;
  /**
   * If this is true, regardless of patientBookableTimeRange, the schedule is patient bookable.
   *  Otherwise the state of being patient bookable depends on patientBookableTimeRange.
   */
  alwaysPatientBookable?: InputMaybe<Scalars['Boolean']>;
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeMsg>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  handlers?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  /**
   * Only appointments on a date between (current date + patientBookableLatestTimeRange) and (current date + patientBookableEarliestTimeRange)
   *  are bookable for patients. Example: Earliest 10 days, latest 2 days means one can book appointments between 2 days later and 10 days later.
   *  If earliest is null or smaller than latest, patients can never book an appointment.
   *  If latest is null, there is no limit on that end of the range.
   */
  patientBookableEarliestTimeRange?: InputMaybe<Scalars['Int']>;
  patientBookableLatestTimeRange?: InputMaybe<Scalars['Int']>;
  timeFrame?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
};

export type Input_Resource_ScheduleExceptionList = {
  scheduleExceptions?: InputMaybe<Array<InputMaybe<Input_Resource_ScheduleExceptionMsg>>>;
};

export type Input_Resource_ScheduleExceptionMsg = {
  appointmentTypes?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTypeMsg>>>;
  /** True: blocking an available time frame, False: adding a new available time frame */
  blocking?: InputMaybe<Scalars['Boolean']>;
  /** optional */
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Input_Timestamp>;
  handlers?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentHandlerMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  officeHourId?: InputMaybe<Scalars['String']>;
  patientBookable?: InputMaybe<Scalars['Boolean']>;
  scheduleExceptionTag?: InputMaybe<Resource_ScheduleExceptionTag>;
  startTime?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_SearchAppointmentsSmartRequest = {
  filterEnd?: InputMaybe<Input_Timestamp>;
  filterStart?: InputMaybe<Input_Timestamp>;
  /** optional filter */
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paginatedListRequest?: InputMaybe<Input_Helper_PaginatedListRequest>;
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>>>;
};

export type Input_Resource_SearchAppointmentsSmartResponse = {
  appointments?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentBasicInfoMsg>>>;
  hitCount?: InputMaybe<Scalars['Int']>;
};

export type Input_Resource_SearchResourceTypesRequest = {
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: InputMaybe<Scalars['Boolean']>;
  /** mandatory */
  ownerUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** optional */
  staticResourceType?: InputMaybe<Resource_StaticResourceType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_SearchResourceTypesResponse = {
  types?: InputMaybe<Array<InputMaybe<Input_Resource_ResourceTypeMsg>>>;
};

export type Input_Resource_SearchStaticResourceCategoriesRequest = {
  text?: InputMaybe<Scalars['String']>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_SearchStaticResourceCategoriesResponse = {
  categories?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceCategoryMsg>>>;
};

export type Input_Resource_SelectAppointmentSlotsRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  proposedSlots?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentMsg>>>;
};

export type Input_Resource_StaticResourceAssignmentList = {
  staticResourceAssignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
};

/** ----- Static Resource Assignment ----- // */
export type Input_Resource_StaticResourceAssignmentMsg = {
  assignedPatientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignmentSex?: InputMaybe<Resource_AssignmentSex>;
  /** required field if assignment type is STATIC_RESOURCE_ASSIGNMENT_TYPE_MAINTENANCE, ignored/not set otherwise */
  assignmentText?: InputMaybe<Scalars['String']>;
  connectedAppointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  creator?: InputMaybe<Input_Resource_ResourceAssignmentCreatorMsg>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  endDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  /** isolation status of the assignment, relevant only for bed location assignments */
  isolated?: InputMaybe<Scalars['Boolean']>;
  /**
   * If this is true, the assignment can be postponed or moved earlier in case of a conflict when the user chooses to override the conflict.
   *  Currently only relevant for assignments that are part of a bundle, which is used by surgery.
   */
  movableOnConflict?: InputMaybe<Scalars['Boolean']>;
  /** For in session assignments, the id of the corresponding "non in session" assignment */
  originalAssignmentId?: InputMaybe<Scalars['String']>;
  /** the owner of the assignment, may not be set */
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** If type is "block" */
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** If recurring start date and end date are the active time frame of the rule */
  recurring?: InputMaybe<Scalars['Boolean']>;
  resource?: InputMaybe<Input_Resource_StaticResourceMsg>;
  sessionId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Resource_ResourceAssignmentStatus>;
  timeFrame?: InputMaybe<Input_Core_TimeFrameOfDayMsg>;
  type?: InputMaybe<Resource_StaticResourceAssignmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_StaticResourceAssignmentsMapMsg = {
  assignments?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceAssignmentMsg>>>;
  staticResourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_StaticResourceCategoryList = {
  categories?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceCategoryMsg>>>;
};

/** ---- Static Resource Category / Specifier ---- // */
export type Input_Resource_StaticResourceCategoryMsg = {
  categorySpecifiers?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceCategorySpecifierMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Resource_StaticResourceCategorySpecifierMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  staticResources?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceMsg>>>;
};

export type Input_Resource_StaticResourceIdList = {
  staticResourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_StaticResourceList = {
  staticResources?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceMsg>>>;
};

/** ----- Static Resource ----- // */
export type Input_Resource_StaticResourceMsg = {
  active?: InputMaybe<Scalars['Boolean']>;
  associatedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  bedLocation?: InputMaybe<Input_Resource_BedLocationResourceMsg>;
  /**
   * todo: model this better after assignments
   *  repeated string accessibleOperationRoomIds = 15;
   */
  categorySpecifier?: InputMaybe<Input_Resource_StaticResourceCategorySpecifierMsg>;
  containedStaticResources?: InputMaybe<Array<InputMaybe<Input_Resource_StaticResourceMsg>>>;
  externalId?: InputMaybe<Input_Resource_ExternalResourceIdMsg>;
  groupId?: InputMaybe<Scalars['String']>;
  /** if the resource supposed to have a parent but currently it does not exist and assumed to be to be a "temporary" parent */
  hasNoParent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  information?: InputMaybe<Input_Resource_ResourceInformationMsg>;
  instanceType?: InputMaybe<Resource_StaticResourceType>;
  name?: InputMaybe<Scalars['String']>;
  operatingRoom?: InputMaybe<Input_Resource_OperatingRoomMsg>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  parentResourceInstanceType?: InputMaybe<Resource_StaticResourceType>;
  /** optional, will be set if parent resource exist */
  parentResourceName?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  room?: InputMaybe<Input_Resource_RoomResourceMsg>;
  /** means this resource is going to be removed after releasing its assignment */
  temporary?: InputMaybe<Scalars['Boolean']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Input_Resource_ResourceTypeMsg>;
};

export type Input_Resource_SubmitAppointmentRebookingRequestRequest = {
  /** Id of the appointment to be rescheduled, mandatory */
  appointmentId?: InputMaybe<Scalars['String']>;
  /** Can be optionally used to update the appointment type */
  appointmentTypeId?: InputMaybe<Scalars['String']>;
  /** Attendee must be set because, there is no other way of knowing which attendee will be rebooked */
  attendee?: InputMaybe<Input_Resource_AppointmentAttendeeMsg>;
  /**
   * TODO : we might need to add or remove additional services here
   *  TODO related to a TODO in appointment request msg
   */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The preferences are mandatory */
  preferences?: InputMaybe<Input_Resource_AppointmentRequestPreferencesMsg>;
  /** Must be set by clinic side requests, portal requests do not need it */
  requestDirection?: InputMaybe<Resource_AppointmentRequestDirection>;
};

export type Input_Resource_SubmitAppointmentRequestRequest = {
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  createAppointmentRequestRequest?: InputMaybe<Input_Resource_CreateAppointmentRequestRequest>;
  /** In order to place the submission in the waiting list */
  inWaitingList?: InputMaybe<Scalars['Boolean']>;
  /** Can be used only for requesting to rebook a booked appointment */
  rebookingRequestSubmission?: InputMaybe<Input_Resource_SubmitAppointmentRebookingRequestRequest>;
};

export type Input_Resource_SubmitCounterAppointmentRequestRequest = {
  /** Optional: provide to update the additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  /** In order to place the submission in the waiting list */
  inWaitingList?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Resource_TemporaryResourceDefinitionMsg = {
  associatedUnits?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** if the resource supposed to have a parent but currently it does not exist and assumed to be to be a "temporary" parent */
  hasNoParent?: InputMaybe<Scalars['Boolean']>;
  instanceType?: InputMaybe<Resource_StaticResourceType>;
  name?: InputMaybe<Scalars['String']>;
  /** optional; if set, temporary resource gets assigned as child to this resource */
  parentResourceId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_UnassignStaticResourceByAssigneeRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  /** Static resource and one of the assignee ids are mandatory unless the static resource is temporarily */
  resourceId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_UnassignStaticResourceRequest = {
  assignmentId?: InputMaybe<Scalars['String']>;
  blockEnd?: InputMaybe<Input_Timestamp>;
  blockResource?: InputMaybe<Scalars['Boolean']>;
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  resourceAssignee?: InputMaybe<Input_Resource_UnassignStaticResourceByAssigneeRequest>;
  sessionId?: InputMaybe<Scalars['String']>;
  /** if set, the unassigned assignment will end at this timestamp, cannot be in the future */
  unassignInstant?: InputMaybe<Input_Timestamp>;
};

export type Input_Resource_UnassignStaticResourceResponse = {
  createdBlockingAssignment?: InputMaybe<Input_Resource_StaticResourceAssignmentMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_UnassignStaticResourcesRequest = {
  assignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_UnassignStaticResourcesResponse = {
  assignmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Resource_UnitMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Resource_UnitType>;
};

export type Input_Resource_UpdateAppointmentAttendeeRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentSeriesId?: InputMaybe<Scalars['String']>;
  attendee?: InputMaybe<Input_Resource_AppointmentAttendeeMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Resource_UpdateAppointmentAttendeeResponse = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  appointmentSeries?: InputMaybe<Input_Resource_AppointmentSeriesMsg>;
};

export type Input_Resource_UpdateAppointmentFlagRequest = {
  flag?: InputMaybe<Input_Resource_AppointmentFlagMsg>;
  immediatelyActivate?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Resource_UpdateAppointmentFlagResponse = {
  flag?: InputMaybe<Input_Resource_AppointmentFlagMsg>;
};

export type Input_Resource_UpdateAppointmentRequest = {
  appointment?: InputMaybe<Input_Resource_AppointmentMsg>;
  /** Mark changes as confirmed; used to push changes if push is activated */
  confirm?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Resource_UpdateAppointmentRequestFlagsRequest = {
  appointmentFlagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentRequestId?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_UpdateAppointmentRequestRequest = {
  /** Optional: provide to update the additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Resource_UpdateAppointmentSlotRequest = {
  /** Optional: provide to include additional services */
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  appointmentId?: InputMaybe<Scalars['String']>;
  /** If provided the slot will be updated only for these attendees, for others it will stay the same. Otherwise all */
  attendees?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentAttendeeMsg>>>;
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  newSlot?: InputMaybe<Input_Resource_AppointmentTimeFrameMsg>;
  /** considered only if forceUpdate is true and the status is BOOKED. DATASET_REASON_FOR_EXCEPTIONAL_SCHEDULING */
  reasonsForForceScheduling?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** considered only if the status is booked */
  reasonsForRebooking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** required: only reserved or booked are allowed */
  status?: InputMaybe<Resource_AppointmentStatus>;
};

export type Input_Resource_UpdateAppointmentTaskRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  task?: InputMaybe<Input_Resource_AppointmentTaskMsg>;
};

export type Input_Resource_UpdateAppointmentTaskResultRequest = {
  appointmentTaskId?: InputMaybe<Scalars['String']>;
  newResultReferences?: InputMaybe<Array<InputMaybe<Input_Resource_AppointmentTaskResultReferenceMsg>>>;
};

export type Input_Resource_UpdateAppointmentTaskStatusRequest = {
  appointmentTaskId?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<Resource_AppointmentTaskStatus>;
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Resource_UpdateAppointmentVisitInformationRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  /** For now, can be either ONGOING or FINISHED */
  status?: InputMaybe<Resource_AppointmentStatus>;
  visitId?: InputMaybe<Scalars['String']>;
};

/** Update */
export type Input_Resource_UpdateDepletableResourceRequest = {
  depletableResource?: InputMaybe<Input_Resource_DepletableResourceMsg>;
};

export type Input_Resource_UpdateResourceTypeRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  type?: InputMaybe<Input_Resource_ResourceTypeMsg>;
};

export type Input_Resource_UpdateScheduleAssignmentsRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
  scheduleAssignmentList?: InputMaybe<Input_Resource_ScheduleAssignmentList>;
};

export type Input_Resource_UpdateScheduleExceptionsRequest = {
  endTime?: InputMaybe<Input_Timestamp>;
  officeHourId?: InputMaybe<Scalars['String']>;
  scheduleExceptionList?: InputMaybe<Input_Resource_ScheduleExceptionList>;
  scheduleExceptionTag?: InputMaybe<Resource_ScheduleExceptionTag>;
  startTime?: InputMaybe<Input_Timestamp>;
};

/** TODO: make this patch to update non-time related fields? */
export type Input_Resource_UpdateStaticResourceAssignmentRequest = {
  assignmentId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Input_Timestamp>;
  /**
   * if this flag is set, the update will be performed even if there are other conflicting assignments
   *  the cancelled assignments will be returned
   */
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  isolation?: InputMaybe<Scalars['Boolean']>;
  moveableOnConflict?: InputMaybe<Scalars['Boolean']>;
  /**
   * If true, non of the fields that affect scheduling and status are changed.
   *  Such fields include reasonsForBlocking and moveableOnConflict.
   */
  noScheduleUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Replaces existing reasonsForBlocking if replaceReasonsForBlocking is set */
  reasonsForBlocking?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  replaceReasonsForBlocking?: InputMaybe<Scalars['Boolean']>;
  /** If the assignment is an in session assignment, the session id must be provided */
  sessionId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Input_Timestamp>;
  status?: InputMaybe<Resource_ResourceAssignmentStatus>;
  type?: InputMaybe<Resource_StaticResourceAssignmentType>;
};

export type Input_Resource_UpdateStaticResourceCategoryRequest = {
  category?: InputMaybe<Input_Resource_StaticResourceCategoryMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Resource_UpdateStaticResourceRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  staticResource?: InputMaybe<Input_Resource_StaticResourceMsg>;
};

export type Input_Resource_VerifyAppointmentRequestsRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Resource_WeekDaysConfigMsg = {
  regularScheduleEntries?: InputMaybe<Array<InputMaybe<Input_Resource_RegularScheduleEntryMsg>>>;
  weekday?: InputMaybe<DayOfWeek>;
};

export type Input_Signature_ElectronicSignatureDetailsMsg = {
  encryptionAlgorithm?: InputMaybe<Signature_EncryptionAlgorithm>;
  lastValidated?: InputMaybe<Input_Timestamp>;
  signatureScheme?: InputMaybe<Signature_SignatureScheme>;
  /** Hash for qualified electronic signature */
  signedHash?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<Signature_ElectronicSignatureVerificationStatus>;
};

export type Input_Signature_SignatureActionDataMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** When a user is added to / updated / removed from signature requests list */
  previousAssignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  /** Whether previous assignee was marked as optional */
  previousOptional?: InputMaybe<Scalars['Boolean']>;
  updatedAssignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  /** Whether updated assignee is marked as optional */
  updatedOptional?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Signature_SignatureAssigneeMsg = {
  assignedRole?: InputMaybe<Input_Core_ScopedRoleTypeMsg>;
  assignedUserId?: InputMaybe<Scalars['String']>;
};

export type Input_Signature_SignatureMsg = {
  /** The assignee is either a user or a combination of scope and role */
  assignee?: InputMaybe<Input_Signature_SignatureAssigneeMsg>;
  done?: InputMaybe<Scalars['Boolean']>;
  electronicSignatureDetails?: InputMaybe<Input_Signature_ElectronicSignatureDetailsMsg>;
  /** Id of a user who signed the letter with another signature but indirectly fulfilled this signature */
  fulfillingUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  signatureDate?: InputMaybe<Input_Timestamp>;
  /** The id of the user who signed the letter directly with this signature */
  signingUserId?: InputMaybe<Scalars['String']>;
  /** Image of the signature; will be printed if set */
  staticImageId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Signature_SignatureType>;
};

export type Input_Signature_SignatureRequirementTemplateMsg = {
  assignedRole?: InputMaybe<Input_Core_ScopedRoleTypeTemplateMsg>;
  id?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Surgery_LightSurgeryClassMsg = {
  /** Defines what consents are required for preanaesthetic assessment */
  anesthesiaConsentClassIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Use system icd-10 */
  icdCodes?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCodingMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  opsCodes?: InputMaybe<Array<InputMaybe<Input_Core_ProcedureCodeMsg>>>;
  plannedCaseType?: InputMaybe<Surgery_PlannedCaseType>;
  /** Defines what consents are required for pre-operative assessment */
  preOperativeConsentClassIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  schedulingInfo?: InputMaybe<Input_Surgery_SurgeryClassSchedulingInfoMsg>;
};

export type Input_Surgery_SurgeryClassSchedulingInfoMsg = {
  anesthesiaFollowUpDurationInSeconds?: InputMaybe<Scalars['Int']>;
  anesthesiaPreparationDurationInSeconds?: InputMaybe<Scalars['Int']>;
  contingentHolderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cutToCloseDurationInSeconds?: InputMaybe<Scalars['Int']>;
  deviceCategorySpecifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  followupStart?: InputMaybe<Surgery_SurgerySubPhaseType>;
  operatingTableCategorySpecifierId?: InputMaybe<Scalars['String']>;
  preparationStart?: InputMaybe<Surgery_SurgerySubPhaseType>;
  simultaneousFollowUpPhases?: InputMaybe<Scalars['Boolean']>;
  simultaneousPreparationPhases?: InputMaybe<Scalars['Boolean']>;
  surgeryStaffFollowUpDurationInSeconds?: InputMaybe<Scalars['Int']>;
  surgeryStaffPreparationDurationInSeconds?: InputMaybe<Scalars['Int']>;
  turnOverDurationInSeconds?: InputMaybe<Scalars['Int']>;
};

export type Input_Surgery_SurgeryRequirementLinkedRequestReferenceMsg = {
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Surgery_SurgeryRequirementRequestType>;
};

export type Input_Surgery_SurgeryRequirementMsg = {
  creatorUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  linkedRequests?: InputMaybe<Array<InputMaybe<Input_Surgery_SurgeryRequirementLinkedRequestReferenceMsg>>>;
  modifierUserId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Surgery_SurgerySpecifierMsg = {
  /** Can be provided instead of surgery diagnosis for high priority emergency surgeries. TODO: Is this really everything we need in here as specifiers of a specific surgery? */
  emergencySurgeryDiagnoses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Surgery_SurgeryLaterality>;
  surgeryClass?: InputMaybe<Input_Surgery_LightSurgeryClassMsg>;
  /**
   * TODO Specification Surgery Request 6.5.1.3 might need to update diagnosis too for the following feature
   * If the surgery diagnosis has not been documented beforehand the user has the option to select
   * a new ICD-10 diagnosis as it is done for all other clinical requests. When confirming the selection the user
   * needs to receive a warning note that the newly selected diagnosis is added to the patient’s treatment diagnoses.
   * By confirming the warning note the diagnosis is added to the patient’s diagnoses and is also selected in the
   * surgery diagnosis input field.
   */
  surgeryDiagnosesIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Telematik_TelematikAuthorMsg = {
  emailTelecommunications?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  institutions?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikOrganizationMsg>>>;
  person?: InputMaybe<Input_Telematik_TelematikPersonMsg>;
  phoneTelecommunications?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikPhoneTelecommunicationMsg>>>;
  roles?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikCodeMsg>>>;
  specialities?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikCodeMsg>>>;
};

export type Input_Telematik_TelematikCodeMsg = {
  code?: InputMaybe<Scalars['String']>;
  codeSystemId?: InputMaybe<Scalars['String']>;
  codeSystemName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Input_Core_LocalizedStringMsg>;
  displayName?: InputMaybe<Scalars['String']>;
};

export type Input_Telematik_TelematikDocumentMetadataMsg = {
  authors?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikAuthorMsg>>>;
  classCode?: InputMaybe<Input_Telematik_TelematikCodeMsg>;
  comments?: InputMaybe<Input_Core_LocalizedStringMsg>;
  confidentialityCodes?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikCodeMsg>>>;
  creationTime?: InputMaybe<Input_Timestamp>;
  eventCodeLists?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikCodeMsg>>>;
  formatCode?: InputMaybe<Input_Telematik_TelematikCodeMsg>;
  healthCareFacilityTypeCode?: InputMaybe<Input_Telematik_TelematikCodeMsg>;
  languageCode?: InputMaybe<Scalars['String']>;
  legalAuthenticator?: InputMaybe<Input_Telematik_TelematikPersonMsg>;
  mimeType?: InputMaybe<Scalars['String']>;
  practiceSettingCode?: InputMaybe<Input_Telematik_TelematikCodeMsg>;
  referenceIds?: InputMaybe<Array<InputMaybe<Input_Telematik_TelematikReferenceIdentifierMsg>>>;
  serviceStartTime?: InputMaybe<Input_Timestamp>;
  serviceStopTime?: InputMaybe<Input_Timestamp>;
  titles?: InputMaybe<Input_Core_LocalizedStringMsg>;
  typeCode?: InputMaybe<Input_Telematik_TelematikCodeMsg>;
  uri?: InputMaybe<Scalars['String']>;
};

export type Input_Telematik_TelematikIntendedRecipientMsg = {
  email?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Input_Telematik_TelematikOrganizationMsg>;
  person?: InputMaybe<Input_Telematik_TelematikPersonMsg>;
  phone?: InputMaybe<Input_Telematik_TelematikPhoneTelecommunicationMsg>;
};

/** id+assigningAuthority <=> Optional<telematikId> */
export type Input_Telematik_TelematikOrganizationMsg = {
  assigningAuthority?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** id+assigningAuthority <=> Optional<Either<lanr, lifelongKvnr>> */
export type Input_Telematik_TelematikPersonMsg = {
  assigningAuthority?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prefix?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type Input_Telematik_TelematikPhoneTelecommunicationMsg = {
  areaOrCityCode?: InputMaybe<Scalars['Long']>;
  countryCode?: InputMaybe<Scalars['Long']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  localPhoneNumberExtension?: InputMaybe<Scalars['Long']>;
  phoneNumber?: InputMaybe<Scalars['Long']>;
  useCode?: InputMaybe<Scalars['String']>;
};

export type Input_Telematik_TelematikReferenceIdentifierMsg = {
  assigningAuthority?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Telematik_TelematikReferenceIdentifierType>;
};

export type Input_Treatment_AbdomenLocationsBlock = {
  leftLowerQuadrant?: InputMaybe<Scalars['String']>;
  leftUpperQuadrant?: InputMaybe<Scalars['String']>;
  midAbdomen?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  rightLowerQuadrant?: InputMaybe<Scalars['String']>;
  rightUpperQuadrant?: InputMaybe<Scalars['String']>;
  wholeAbdomen?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AbdominalCirculationNoiseBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AbdominalInspectionGeneralBlock = {
  abdominalMovementsPresent?: InputMaybe<Scalars['Boolean']>;
  abdominalMovementsText?: InputMaybe<Scalars['String']>;
  abdominalShapeText?: InputMaybe<Scalars['String']>;
  abdominalShapes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  posture?: InputMaybe<Treatment_PostureType>;
  postureText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AbdominalPainMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  quality?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  radiationDescription?: InputMaybe<Scalars['String']>;
  radiationPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_AbdominalPercussionBlock = {
  entireAbdomen?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  leftUpperQuadrant?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  lowerLeftQuadrant?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  lowerRightQuadrant?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  midAbdomen?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  percussionSounds?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  rightUpperQuadrant?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_AbdominalWallBlock = {
  abdominalWall?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_AbnormalityAngleAndTextMsg = {
  angle1?: InputMaybe<Scalars['Int']>;
  angle2?: InputMaybe<Scalars['Int']>;
  angle3?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateDiagnosesInScopeRequest = {
  scopeId?: InputMaybe<Scalars['String']>;
  scopeType?: InputMaybe<Treatment_DiagnosisScopeType>;
};

export type Input_Treatment_ActivateDiagnosesInScopeResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateDiagnosesRequest = {
  /**
   * optional: if set, will put the given categoryAssignment into all of the diagnoses in the context (including already active ones) if not yet there
   *  and no "stronger" assignment for the same scope exists.
   */
  categoryAssignment?: InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>;
  /**
   * optional: only relevant if categoryAssignment is set. If set, only sets the categoryAssignment for diagnoses that
   *  have any assignment matching any of the categoryAssignmentRequirementsAny. Required for surgery completion logic.
   */
  categoryAssignmentRequirementsAny?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>>>;
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ActivateDiagnosisVersionRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateDiagnosisVersionResponse = {
  /** the revision that was deactivated as a result if that exists */
  deactivatedDiagnosisRevision?: InputMaybe<Input_Treatment_DiagnosisMsg>;
  /** the activated Diagnosis */
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_ActivateFluidFlowSystemVersionRequest = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateFluidFlowSystemVersionResponse = {
  /** the revision that was deactivated as a result if that exists */
  deactivatedFluidFlowSystemRevision?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
  /** the activated FluidFlowSystem */
  fluidFlowSystem?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
};

export type Input_Treatment_ActivateFluidFlowVersionRequest = {
  fluidFlowId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateFluidFlowVersionResponse = {
  /** the revision that was deactivated as a result if that exists */
  deactivatedFluidFlowRevision?: InputMaybe<Input_Treatment_FluidFlowMsg>;
  /** the activated FluidFlow */
  fluidFlow?: InputMaybe<Input_Treatment_FluidFlowMsg>;
};

export type Input_Treatment_ActivateSymptomConfigurationVersionRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateSymptomConfigurationVersionResponse = {
  /** the revision that was deactivated as a result if that exists */
  deactivatedSymptomConfigurationRevision?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
  /** the activated SymptomConfiguration */
  symptomConfiguration?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
};

export type Input_Treatment_ActivateTherapyCardRevisionRequest = {
  therapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateTherapyCardRevisionResponse = {
  deactivatedTherapyCardRevision?: InputMaybe<Input_Treatment_TherapyCardMsg>;
  therapyCard?: InputMaybe<Input_Treatment_TherapyCardMsg>;
};

export type Input_Treatment_ActivateWoundVersionRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ActivateWoundVersionResponse = {
  /** the revision that was deactivated as a result if that exists */
  deactivatedWoundRevision?: InputMaybe<Input_Treatment_WoundMsg>;
  /** the activated Wound */
  wound?: InputMaybe<Input_Treatment_WoundMsg>;
};

export type Input_Treatment_ActivityEverydayLifeBlock = {
  jobActivityLevel?: InputMaybe<Treatment_JobActivityLevel>;
  physicalActivity?: InputMaybe<Treatment_PhysicalActivityType>;
  physicalActivityText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AlcoholBlock = {
  alcohols?: InputMaybe<Array<InputMaybe<Input_Treatment_AlcoholMsg>>>;
  consumptionPresent?: InputMaybe<Scalars['Boolean']>;
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_AlcoholMsg = {
  amount?: InputMaybe<Scalars['Int']>;
  amountReference?: InputMaybe<Treatment_AlcoholAmountReference>;
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyReference?: InputMaybe<Treatment_ConsumptionFrequencyReference>;
  id?: InputMaybe<Scalars['String']>;
  substance?: InputMaybe<Treatment_AlcoholType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AllenTestBlock = {
  resultLeft?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  resultRight?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  textLeft?: InputMaybe<Scalars['String']>;
  textRight?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AllergenMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_Treatment_ExternalAllergenIdMsg>>>;
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AllergiesAndIntolerancesBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_AllergyAndIntoleranceMsg = {
  activationStatus?: InputMaybe<Treatment_AllergyActivation>;
  allergen?: InputMaybe<Input_Treatment_AllergenMsg>;
  createdInTreatmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intakeRouteIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  lastAppearance?: InputMaybe<Input_VeiosDateTimeMsg>;
  notes?: InputMaybe<Scalars['String']>;
  onset?: InputMaybe<Input_VeiosTimeFrameMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  reactionSeverity?: InputMaybe<Treatment_ReactionSeverity>;
  reactionStatus?: InputMaybe<Treatment_ReactionStatus>;
  /** TODO: Part of allergy dataset? */
  reactionType?: InputMaybe<Treatment_ReactionType>;
  recurrenceRisk?: InputMaybe<Treatment_RecurrenceRisk>;
  registeringUserId?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  verification?: InputMaybe<Treatment_AllergyVerification>;
};

export type Input_Treatment_AllergyList = {
  allergies?: InputMaybe<Array<InputMaybe<Input_Treatment_AllergyAndIntoleranceMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

/** Amyotrophic Lateral Sclerosis Functional Rating Scale (ALSFRS-R-SE) */
export type Input_Treatment_AlsfrsBlock = {
  climbingStairs?: InputMaybe<Treatment_ClimbingStairs>;
  cuttingFood?: InputMaybe<Treatment_CuttingFood>;
  dressing?: InputMaybe<Treatment_Dressing>;
  handlingFeedingTube?: InputMaybe<Treatment_HandlingFeedingTube>;
  handwriting?: InputMaybe<Treatment_Handwriting>;
  mechanicalVentilation?: InputMaybe<Treatment_MechanicalVentilation>;
  respiratorySleepDisturbance?: InputMaybe<Treatment_RespiratorySleepDisturbance>;
  salivation?: InputMaybe<Treatment_Salivation>;
  score?: InputMaybe<Scalars['Int']>;
  shortnessOfBreath?: InputMaybe<Treatment_ShortnessOfBreath>;
  speech?: InputMaybe<Treatment_Speech>;
  swallowing?: InputMaybe<Treatment_Swallowing>;
  turningOverInBed?: InputMaybe<Treatment_TurningOverInBed>;
  walking?: InputMaybe<Treatment_Walking>;
};

export type Input_Treatment_AnalRegionInspectionBlock = {
  discoveredAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  hemorrhoidsDegree?: InputMaybe<Treatment_HemorrhoidsDegree>;
  hemorrhoidsPresent?: InputMaybe<Scalars['Boolean']>;
  inspection?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_AnamnesisBlockContentMsg = {
  activityEverydayLife?: InputMaybe<Input_Treatment_ActivityEverydayLifeBlock>;
  alcohol?: InputMaybe<Input_Treatment_AlcoholBlock>;
  allergiesAndIntolerances?: InputMaybe<Input_Treatment_AllergiesAndIntolerancesBlock>;
  ankleBrachialIndex?: InputMaybe<Input_Treatment_AnkleBrachialIndexBlock>;
  apfelRisk?: InputMaybe<Input_Treatment_ApfelRiskBlock>;
  /** Pediatric scores */
  apgarScore?: InputMaybe<Input_Treatment_ApgarScoreBlock>;
  ariscat?: InputMaybe<Input_Treatment_AriscatBlock>;
  /** Anaesthesiology */
  asaClassification?: InputMaybe<Input_Treatment_AsaClassificationBlock>;
  aspirationRisk?: InputMaybe<Input_Treatment_AspirationRiskBlock>;
  /** Performance in activities of daily living */
  barthelIndex?: InputMaybe<Input_Treatment_BarthelIndexBlock>;
  bdiIi?: InputMaybe<Input_Treatment_BdiIiBlock>;
  biensteinBreathScale?: InputMaybe<Input_Treatment_BiensteinBreathScaleBlock>;
  bloodPressureAndPulse?: InputMaybe<Input_Treatment_BloodPressureAndPulseAnamnesticBlock>;
  /** Neurology */
  bodsScore?: InputMaybe<Input_Treatment_BodsScoreBlock>;
  bodyMeasurements?: InputMaybe<Input_Treatment_BodyMeasurementsBlock>;
  bradenQScale?: InputMaybe<Input_Treatment_BradenQScaleBlock>;
  /** Wounds */
  bradenScale?: InputMaybe<Input_Treatment_BradenScaleBlock>;
  bradenScaleBass?: InputMaybe<Input_Treatment_BradenScaleBassBlock>;
  cam?: InputMaybe<Input_Treatment_CamBlock>;
  camIcu?: InputMaybe<Input_Treatment_CamIcuBlock>;
  cardiacArrhythmia?: InputMaybe<Input_Treatment_CardiacArrhythmiaBlock>;
  cardiacInsufficiency?: InputMaybe<Input_Treatment_CardiacInsufficiencyBlock>;
  /** Cardiology */
  cha2Ds2Vasc?: InputMaybe<Input_Treatment_Cha2Ds2VascBlock>;
  /** Gastroenterology */
  childPugh?: InputMaybe<Input_Treatment_ChildPughBlock>;
  /** Sugery */
  clavienDindo?: InputMaybe<Input_Treatment_ClavienDindoBlock>;
  clockTest?: InputMaybe<Input_Treatment_ClockTestBlock>;
  constantShoulder?: InputMaybe<Input_Treatment_ConstantShoulderBlock>;
  contraceptives?: InputMaybe<Input_Treatment_ContraceptivesBlock>;
  cough?: InputMaybe<Input_Treatment_CoughBlock>;
  /** Pneumology scores */
  crb65Score?: InputMaybe<Input_Treatment_Crb65ScoreBlock>;
  currentPregnancy?: InputMaybe<Input_Treatment_CurrentPregnancyBlock>;
  cycle?: InputMaybe<Input_Treatment_CycleBlock>;
  cycleDisorders?: InputMaybe<Input_Treatment_CycleDisordersBlock>;
  deliriumDetection?: InputMaybe<Input_Treatment_DeliriumDetectionBlock>;
  demTect?: InputMaybe<Input_Treatment_DemTectBlock>;
  dermatologyLifeQualityIndex?: InputMaybe<Input_Treatment_DermatologyLifeQualityIndexBlock>;
  dic?: InputMaybe<Input_Treatment_DicBlock>;
  diseasesOfFamilyMembers?: InputMaybe<Input_Treatment_DiseasesOfFamilyMembersBlock>;
  dos?: InputMaybe<Input_Treatment_DosBlock>;
  dyspnea?: InputMaybe<Input_Treatment_DyspneaAnamnesticBlock>;
  earlyRehabilitationBarthelIndex?: InputMaybe<Input_Treatment_EarlyRehabilitationBarthelIndexBlock>;
  eclam?: InputMaybe<Input_Treatment_EclamBlock>;
  /** Oncology */
  ecogStatus?: InputMaybe<Input_Treatment_EcogStatusBlock>;
  edemata?: InputMaybe<Input_Treatment_EdemataBlock>;
  educationalLevel?: InputMaybe<Input_Treatment_EducationalLevelBlock>;
  /** Orthopedics */
  efas?: InputMaybe<Input_Treatment_EfasBlock>;
  epworthSleepinessScale?: InputMaybe<Input_Treatment_EpworthSleepinessScaleBlock>;
  erection?: InputMaybe<Input_Treatment_ErectionBlock>;
  extendedBarthelIndex?: InputMaybe<Input_Treatment_ExtendedBarthelIndexBlock>;
  familyStatus?: InputMaybe<Input_Treatment_FamilyStatusBlock>;
  fatigueAssessmentScale?: InputMaybe<Input_Treatment_FatigueAssessmentScaleBlock>;
  fever?: InputMaybe<Input_Treatment_FeverBlock>;
  fim?: InputMaybe<Input_Treatment_FimBlock>;
  friedrichWeickmannScale?: InputMaybe<Input_Treatment_FriedrichWeickmannScaleBlock>;
  ftnd?: InputMaybe<Input_Treatment_FtndBlock>;
  gastrointestinalDysfunction?: InputMaybe<Input_Treatment_GastrointestinalDysfunctionBlock>;
  /** Geriatrics */
  geriatricDepressionScale?: InputMaybe<Input_Treatment_GeriatricDepressionScaleBlock>;
  glasgowComaScale?: InputMaybe<Input_Treatment_GlasgowComaScaleScoreBlock>;
  /** Psychiatrics */
  globalAssessmentOfFunctioning?: InputMaybe<Input_Treatment_GlobalAssessmentOfFunctioningBlock>;
  goalAttainmentScaleBlock?: InputMaybe<Input_Treatment_GoalAttainmentScaleBlock>;
  hasBled?: InputMaybe<Input_Treatment_HasBledBlock>;
  hendrich?: InputMaybe<Input_Treatment_HendrichBlock>;
  hendrichBass?: InputMaybe<Input_Treatment_HendrichBassBlock>;
  hereditaryKidneyTumor?: InputMaybe<Input_Treatment_HereditaryKidneyTumorBlock>;
  iadl?: InputMaybe<Input_Treatment_IadlBlock>;
  icdsc?: InputMaybe<Input_Treatment_IcdscBlock>;
  /** Urology */
  incontinence?: InputMaybe<Input_Treatment_IncontinenceBlock>;
  ipss?: InputMaybe<Input_Treatment_IpssBlock>;
  isarScreening?: InputMaybe<Input_Treatment_IsarScreeningBlock>;
  itch?: InputMaybe<Input_Treatment_ItchBlock>;
  karnofskyIndex?: InputMaybe<Input_Treatment_KarnofskyIndexBlock>;
  kellgrenLawrence?: InputMaybe<Input_Treatment_KellgrenLawrenceBlock>;
  lachsGeriatricScreening?: InputMaybe<Input_Treatment_LachsGeriatricScreeningBlock>;
  lightSensitivity?: InputMaybe<Input_Treatment_LightSensitivityBlock>;
  livingSituation?: InputMaybe<Input_Treatment_LivingSituationBlock>;
  medication?: InputMaybe<Input_Treatment_MedicationBlock>;
  meldAndMeldNa?: InputMaybe<Input_Treatment_MeldAndMeldNaBlock>;
  menarcheMenopause?: InputMaybe<Input_Treatment_MenarcheMenopauseBlock>;
  metabolicEquivalentOfTaskBlock?: InputMaybe<Input_Treatment_MetabolicEquivalentOfTaskBlock>;
  micturitionDisorder?: InputMaybe<Input_Treatment_MicturitionDisorderBlock>;
  miniMentalStateExamination?: InputMaybe<Input_Treatment_MiniMentalStateExaminationBlock>;
  miniNutritionalAssessmentLongVersion?: InputMaybe<Input_Treatment_MiniNutritionalAssessmentLongVersionBlock>;
  miniNutritionalAssessmentShortVersion?: InputMaybe<Input_Treatment_MiniNutritionalAssessmentShortVersionBlock>;
  mocaTest?: InputMaybe<Input_Treatment_MocaTestBlock>;
  modifiedKatzAdl?: InputMaybe<Input_Treatment_ModifiedKatzAdlBlock>;
  modifiedNortonScale?: InputMaybe<Input_Treatment_ModifiedNortonScaleBlock>;
  mrs?: InputMaybe<Input_Treatment_MrsBlock>;
  nicotine?: InputMaybe<Input_Treatment_NicotineBlock>;
  nightSweats?: InputMaybe<Input_Treatment_NightSweatsBlock>;
  nikolausSocialQuestionnaire?: InputMaybe<Input_Treatment_NikolausSocialQuestionnaireBlock>;
  nonInvasiveVentilation?: InputMaybe<Input_Treatment_NonInvasiveVentilationBlock>;
  nuDesc?: InputMaybe<Input_Treatment_NuDescBlock>;
  /** Symptoms */
  numericPainRatingScale?: InputMaybe<Input_Treatment_NumericPainRatingScaleBlock>;
  nutritionalDisturbance?: InputMaybe<Input_Treatment_NutritionalDisturbanceBlock>;
  nutritionalRiskScreening?: InputMaybe<Input_Treatment_NutritionalRiskScreeningBlock>;
  nyha?: InputMaybe<Input_Treatment_NyhaBlock>;
  occupation?: InputMaybe<Input_Treatment_OccupationsBlock>;
  otherDrugsAndAddictiveSubstances?: InputMaybe<Input_Treatment_OtherDrugsAndAddictiveSubstancesBlock>;
  otherRiskFactors?: InputMaybe<Input_Treatment_OtherRiskFactorsBlock>;
  oxygenTherapy?: InputMaybe<Input_Treatment_OxygenTherapyBlock>;
  /** Preanesthetic Assessment */
  pacemaker?: InputMaybe<Input_Treatment_PacemakerBlock>;
  padss?: InputMaybe<Input_Treatment_PadssBlock>;
  pain?: InputMaybe<Input_Treatment_PainBlock>;
  /** Dermatology */
  pasi?: InputMaybe<Input_Treatment_PasiBlock>;
  pastAirwayManagement?: InputMaybe<Input_Treatment_PastAirwayManagementBlock>;
  patientHealthQuestionnaire?: InputMaybe<Input_Treatment_PatientHealthQuestionnaireBlock>;
  pediatricGlasgowComaScale?: InputMaybe<Input_Treatment_PediatricGlasgowComaScaleScoreBlock>;
  preExistingConditions?: InputMaybe<Input_Treatment_PreExistingConditionsBlock>;
  previousPregnancies?: InputMaybe<Input_Treatment_PreviousPregnanciesBlock>;
  previousSurgeries?: InputMaybe<Input_Treatment_PreviousSurgeriesBlock>;
  qsofa?: InputMaybe<Input_Treatment_QsofaBlock>;
  recentTravels?: InputMaybe<Input_Treatment_RecentTravelsBlock>;
  revisedCardiacRiskIndex?: InputMaybe<Input_Treatment_RevisedCardiacRiskIndexBlock>;
  /** Intensive Care Medicine */
  saps?: InputMaybe<Input_Treatment_SapsBlock>;
  sexLife?: InputMaybe<Input_Treatment_SexLifeBlock>;
  sigstad?: InputMaybe<Input_Treatment_SigstadBlock>;
  skinChange?: InputMaybe<Input_Treatment_SkinChangeBlock>;
  /** Rheumatology */
  sledai2K?: InputMaybe<Input_Treatment_Sledai2KBlock>;
  sleepDisorder?: InputMaybe<Input_Treatment_SleepDisorderBlock>;
  /** Emergency Medicine */
  sofa?: InputMaybe<Input_Treatment_SofaBlock>;
  sport?: InputMaybe<Input_Treatment_SportsBlock>;
  staffelsteinHip?: InputMaybe<Input_Treatment_StaffelsteinHipBlock>;
  staffelsteinKnee?: InputMaybe<Input_Treatment_StaffelsteinKneeBlock>;
  stdRisk?: InputMaybe<Input_Treatment_StdRiskBlock>;
  stopBangRisk?: InputMaybe<Input_Treatment_StopBangRiskBlock>;
  temperature?: InputMaybe<Input_Treatment_TemperatureAnamnesticBlock>;
  timedUpAndGoTest?: InputMaybe<Input_Treatment_TimedUpAndGoTestBlock>;
  tinettiMobilityTest?: InputMaybe<Input_Treatment_TinettiMobilityTestBlock>;
  tiss?: InputMaybe<Input_Treatment_TissBlock>;
  tissChildren?: InputMaybe<Input_Treatment_TissChildrenBlock>;
  tracheostomy?: InputMaybe<Input_Treatment_TracheostomyBlock>;
  updrs?: InputMaybe<Input_Treatment_UpdrsBlock>;
  vaccinations?: InputMaybe<Input_Treatment_VaccinationsBlock>;
  verbalRatingScale?: InputMaybe<Input_Treatment_VerbalRatingScaleBlock>;
  vertigo?: InputMaybe<Input_Treatment_VertigoBlock>;
  visualAnalogueScale?: InputMaybe<Input_Treatment_VisualAnalogueScaleBlock>;
  wagnerArmstrongClassification?: InputMaybe<Input_Treatment_WagnerArmstrongClassificationBlock>;
  warScore?: InputMaybe<Input_Treatment_WarScoreBlock>;
  wellsI?: InputMaybe<Input_Treatment_WellsIBlock>;
  wellsII?: InputMaybe<Input_Treatment_WellsIiBlock>;
};

export type Input_Treatment_AnamnesisBlockContentScoreMsg = {
  blockMetadata?: InputMaybe<Input_Treatment_AnamnesisBlockMetadataMsg>;
  scores?: InputMaybe<Array<InputMaybe<Input_Treatment_ScoreBlockMsg>>>;
};

export type Input_Treatment_AnamnesisBlockMetadataMsg = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  problemSpecific?: InputMaybe<Scalars['Boolean']>;
  singleton?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Treatment_AnamnesisBlockMetadataTag>>>;
  type?: InputMaybe<Treatment_AnamnesisBlockType>;
};

export type Input_Treatment_AnamnesisBlockMsg = {
  blockMetadata?: InputMaybe<Input_Treatment_AnamnesisBlockMetadataMsg>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Input_Treatment_AnamnesisBlockContentMsg>;
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_AnamnesisBlockLocation>;
  /** Origin of block */
  origin?: InputMaybe<Treatment_AnamnesisBlockOrigin>;
  /** Id of anamnesis that owns the block */
  owningAnamnesisId?: InputMaybe<Scalars['String']>;
  /** If Block is part of SpecialCard then owningCardId gives parent */
  owningCardId?: InputMaybe<Scalars['String']>;
  owningFormId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** Only relevant for static blocks. Shows that doctor has checked this block's content in the current treatment. */
  validation?: InputMaybe<Input_Validation_ValidationMsg>;
};

export type Input_Treatment_AnamnesisCardMetadataList = {
  cardsMetadata?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisCardMetadataMsg>>>;
};

export type Input_Treatment_AnamnesisCardMetadataMsg = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  problemSpecificType?: InputMaybe<Treatment_ProblemSpecificAnamnesisType>;
  singleton?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_AnamnesisCardMsg = {
  anamnesticProgress?: InputMaybe<Input_Treatment_AnamnesticProgressMsg>;
  anesthesiaBackground?: InputMaybe<Input_Treatment_AnesthesiaBackgroundMsg>;
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Treatment_AnamnesisCardMetadataMsg>;
  owningAnamnesisId?: InputMaybe<Scalars['String']>;
  reasonForAdmission?: InputMaybe<Input_Treatment_ReasonForAdmissionMsg>;
  reasonForCareAdmission?: InputMaybe<Input_Treatment_ReasonForCareAdmissionMsg>;
  reasonForPresentation?: InputMaybe<Input_Treatment_ReasonForPresentationMsg>;
  surgeryPreparation?: InputMaybe<Input_Treatment_SurgeryPreparationMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Treatment_AnamnesisList = {
  anamnesisList?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisMsg>>>;
};

export type Input_Treatment_AnamnesisMsg = {
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_AnamnesisLocation>;
  sections?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisSectionMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Treatment_AnamnesisSectionMsg = {
  cards?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisCardMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Treatment_SectionMetadataMsg>;
  owningAnamnesisId?: InputMaybe<Scalars['String']>;
  shortcuts?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Treatment_AnamnesisTemplateMsg = {
  id?: InputMaybe<Scalars['String']>;
  ownerOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Input_Treatment_SectionTemplateMsg>>>;
  shortcuts?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: InputMaybe<Treatment_TreatmentType>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Inpatient equivalent to ReasonForPresentationMsg */
export type Input_Treatment_AnamnesticProgressMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** only used to document non-present symptoms */
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
};

export type Input_Treatment_AnesthesiaBackgroundMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  pastAnesthesiaComplications?: InputMaybe<Input_Treatment_PastAnesthesiaComplicationsMsg>;
  previousHistoryHtml?: InputMaybe<Scalars['String']>;
  symptomOccurrences?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
};

export type Input_Treatment_AnesthesiologicalRiskFactorMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  riskFactor?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_AnkleBrachialIndexBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Float']>;
  /** unit: mmHg */
  systolicBloodPressureOfAnkle?: InputMaybe<Scalars['Int']>;
  /** unit: mmHg */
  systolicBloodPressureOfArm?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_ApfelRiskBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  female?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  motionSicknessHistory?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  nonSmoker?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** <yes (1) / no (0)> */
  useOfPostoperativeOpioids?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ApgarScoreBlock = {
  activity?: InputMaybe<Treatment_ActivityEnum>;
  appearance?: InputMaybe<Treatment_AppearanceEnum>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  grimace?: InputMaybe<Treatment_GrimaceEnum>;
  pulse?: InputMaybe<Treatment_PulseEnum>;
  respiration?: InputMaybe<Treatment_RespirationEnum>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_ApicalImpulseBlock = {
  apicalImpulse?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_AppearanceBlock = {
  appearance?: InputMaybe<Treatment_AppearanceType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AppendicitisSignsBlock = {
  blumbergSignPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  lanzSignPresent?: InputMaybe<Scalars['Boolean']>;
  mcBurneySignPresent?: InputMaybe<Scalars['Boolean']>;
  obturatorPainPresent?: InputMaybe<Scalars['Boolean']>;
  present?: InputMaybe<Scalars['Boolean']>;
  psoasPainPresent?: InputMaybe<Scalars['Boolean']>;
  rovsingSignPresent?: InputMaybe<Scalars['Boolean']>;
  sitkowskiSignPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ApplyHistoricAnamnesisBlockRequest = {
  currentAnamnesisBlockId?: InputMaybe<Scalars['String']>;
  historicAnamnesisBlockId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricAnamnesisBlockResponse = {
  anamnesisBlock?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
};

export type Input_Treatment_ApplyHistoricAnamnesisRequest = {
  currentAnamnesisId?: InputMaybe<Scalars['String']>;
  historicAnamnesisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricAnamnesisResponse = {
  anamnesis?: InputMaybe<Input_Treatment_AnamnesisMsg>;
};

export type Input_Treatment_ApplyHistoricPhysicalBlockRequest = {
  currentPhysicalBlockId?: InputMaybe<Scalars['String']>;
  historicPhysicalBlockId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricPhysicalBlockResponse = {
  physicalBlock?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
};

export type Input_Treatment_ApplyHistoricPhysicalExaminationRequest = {
  currentPhysicalExaminationId?: InputMaybe<Scalars['String']>;
  historicPhysicalExaminationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricPhysicalExaminationResponse = {
  physicalExamination?: InputMaybe<Input_Treatment_PhysicalExaminationMsg>;
};

export type Input_Treatment_ApplyHistoricTherapyCardRequest = {
  currentTherapyCardId?: InputMaybe<Scalars['String']>;
  historicTherapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricTherapyCardResponse = {
  therapyCard?: InputMaybe<Input_Treatment_TherapyCardMsg>;
};

export type Input_Treatment_ApplyHistoricTherapyRequest = {
  currentTherapyId?: InputMaybe<Scalars['String']>;
  historicTherapyId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyHistoricTherapyResponse = {
  therapy?: InputMaybe<Input_Treatment_TherapyMsg>;
};

export type Input_Treatment_ApplyPhysicalPresetRequest = {
  presetId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ApplyPhysicalPresetResponse = {
  appliedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockMsg>>>;
};

export type Input_Treatment_AriscatBlock = {
  ariscatAgeSelection?: InputMaybe<Treatment_AriscatAgeSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Emergency procedure: <yes (8) / no (0)> */
  emergencyProcedure?: InputMaybe<Scalars['Boolean']>;
  /** Preoperative SpO2 (%) */
  preoperartiveSpO2?: InputMaybe<Treatment_PreoperartiveSpO2>;
  /** Preoperative anemia (≤10 g/dl): <yes (11) / no (0)> */
  preoperativeAnemia?: InputMaybe<Scalars['Boolean']>;
  /** Respiratory Infections in the last month: <yes (16) / no (0)> */
  respiratoryInfections?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** Duration of surgery (hours) */
  surgeryDuration?: InputMaybe<Treatment_SurgeryDuration>;
  surgicalIncision?: InputMaybe<Treatment_SurgicalIncision>;
};

export type Input_Treatment_ArteriaMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_AsaClassificationBlock = {
  asaClassificationSelection?: InputMaybe<Treatment_AsaClassificationSelection>;
  completed?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_AscitesBlock = {
  ascitesPresent?: InputMaybe<Scalars['Boolean']>;
  fluidWavePresent?: InputMaybe<Scalars['Boolean']>;
  shiftingDullnessPresent?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AspirationRiskBlock = {
  aspirationRiskPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_AssessmentMsg = {
  /** automatic addition of points based on previous entries */
  assessmentScore?: InputMaybe<Scalars['Float']>;
  calfCircumference?: InputMaybe<Treatment_CalfCircumference>;
  /** How much does the patient drink per day?: */
  dailyFluidIntake?: InputMaybe<Treatment_DailyFluidIntake>;
  /** Eating with or without help: */
  eatingAssistance?: InputMaybe<Treatment_EatingAssistance>;
  /** Compared with persons of the same age, the patient estimates his health status as follows: */
  estimateHealthStatus?: InputMaybe<Treatment_EstimateHealthStatus>;
  /** Does the patient eat fruits or vegetables at least twice a day? */
  fruitsOrVegetablesIntake?: InputMaybe<Scalars['Boolean']>;
  /** Does the patient have pressure ulcers or skin ulcers: < yes (0) / no (1)> */
  hasPressureOrSkinUlcers?: InputMaybe<Scalars['Boolean']>;
  /** Does the patient live independently at home?: < yes (0) / no (1)> */
  livingIndependentlyAtHome?: InputMaybe<Scalars['Boolean']>;
  /** How many main meals does the patient eat per day?: */
  mealsPerDay?: InputMaybe<Treatment_MealsPerDay>;
  /** Protein intake: Does the patient eat: */
  proteinIntakeList?: InputMaybe<Array<InputMaybe<Treatment_ProteinIntake>>>;
  /** How does the patient rate his or her nutritional status */
  rateNutritionalStatus?: InputMaybe<Treatment_RateNutritionalStatus>;
  /** Does the patient take more than 3 prescription medications per day?: < yes (0) / no (1)> */
  takingMoreThanThreeMedicationsPerDay?: InputMaybe<Scalars['Boolean']>;
  upperArmCircumference?: InputMaybe<Treatment_UpperArmCircumference>;
};

export type Input_Treatment_AttentionBlock = {
  abstraction?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  abstractionText?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  concentration?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  concentrationText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  neglect?: InputMaybe<Scalars['Boolean']>;
  neglectDescriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_NeglectDescriptionMsg>>>;
  perception?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  perceptionText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AutoUpdatedAnamnesisBlockInfo = {
  blockId?: InputMaybe<Scalars['String']>;
  blockNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_AutoUpdatedProblemSpecificAnamnesisCardReasonInfo = {
  reasonInfo?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_AxillaryLymphNodesBlock = {
  abnormalitiesPresent?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export type Input_Treatment_BalanceTestMsg = {
  arises?: InputMaybe<Treatment_Arises>;
  attemptToRise?: InputMaybe<Treatment_AttemptToRise>;
  balanceWithEyesAndFeetClosed?: InputMaybe<Treatment_BalanceWithEyesAndFeetClosed>;
  immediateStandingBalance?: InputMaybe<Treatment_ImmediateStandingBalance>;
  nudged?: InputMaybe<Treatment_Nudged>;
  seatingBalance?: InputMaybe<Treatment_SeatingBalance>;
  sittingDown?: InputMaybe<Treatment_SittingDown>;
  standingBalance?: InputMaybe<Treatment_StandingBalance>;
  turning360Degrees?: InputMaybe<Treatment_Turning360Degrees>;
};

export type Input_Treatment_BarthelIndexBlock = {
  barthelIndexFields?: InputMaybe<Input_Treatment_BarthelIndexFieldsMsg>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_BarthelIndexFieldsMsg = {
  barthelIndexDressing?: InputMaybe<Treatment_BarthelIndexDressing>;
  bathing?: InputMaybe<Treatment_Bathing>;
  bladderControl?: InputMaybe<Treatment_BladderControl>;
  bowelControl?: InputMaybe<Treatment_BowelControl>;
  feeding?: InputMaybe<Treatment_Feeding>;
  grooming?: InputMaybe<Treatment_Grooming>;
  mobilityOnLevelsSurface?: InputMaybe<Treatment_MobilityOnLevelsSurface>;
  score?: InputMaybe<Scalars['Int']>;
  stairs?: InputMaybe<Treatment_Stairs>;
  toiletUse?: InputMaybe<Treatment_ToiletUse>;
  transfers?: InputMaybe<Treatment_Transfers>;
};

export type Input_Treatment_BdiIiBlock = {
  /** <My appetite has not changed (0) / My appetite is a little worse than usual (1) /My appetite is a little bigger than usual (1) /My appetite is much worse than usual (2) /My appetite is much bigger than usual (2) / I have no appetite at all (3) /I have cravings all the time (3)> */
  changesInAppetite?: InputMaybe<Treatment_ChangesInAppetite>;
  /** <My sleep habits have not changed (0) /I sleep a little more than usual (1) /I sleep a little less than usual (1) /I sleep a lot more than usual (2) /I sleep a lot less than usual (2) /I sleep most of the day (3) /I wake up 1-2 hours earlier than usual and can't get back to sleep (3)> */
  changesInSleepHabits?: InputMaybe<Treatment_ChangesInSleepHabits>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** <I don't cry more often than I used to (0) /I cry more now than I used to (1) /I cry at the slightest occasion (2) /I would like to cry, but I can't (3)> */
  crying?: InputMaybe<Treatment_Crying>;
  /** <I can concentrate as well as ever (0) /I can't concentrate as well as usual (1) /I find it difficult to concentrate on anything for any length of time (2) /I can't concentrate at all (3)> */
  difficultyConcentrating?: InputMaybe<Treatment_DifficultyConcentrating>;
  /** <I don't feel like a failure (0) /I have feelings of failure more often (1) /When I look back, I see a lot of failures (2) /I feel like I am a complete failure as a person (3)> */
  feelingsOfFailure?: InputMaybe<Treatment_FeelingsOfFailure>;
  /** <I don't feel like I'm being punished for anything (0) /I feel like I might be punished (1) /I expect to be punished (2) /I feel like I'm being punished (3)> */
  feelingsOfPunishment?: InputMaybe<Treatment_FeelingsOfPunishment>;
  /** <I don't have any particular guilt feelings (0) /I often have guilt feelings about things I have done or should have done (1) /I have guilt feelings most of the time (2) /I have guilt feelings all the time (3)> */
  guiltFeelings?: InputMaybe<Treatment_GuiltFeelings>;
  /** <I am as decisive as ever (0) /I find it harder than usual to make decisions (1) /I find it much harder than usual to make decisions (2) /I have trouble making decisions at all (3)> */
  inabilityToMakeDecisions?: InputMaybe<Treatment_InabilityToMakeDecisions>;
  /** <I am not more irritable than usual (0) /I am more irritable than usual (1) I am much more irritable than usual (2) /I feel irritable all the time (3)> */
  irritability?: InputMaybe<Treatment_Irritability>;
  /** <I have as much energy as ever (0) /I have less energy than usual (1) /I have so little energy that I can hardly manage anything (2) /I have no energy left to do anything at all (3)> */
  lossOfEnergy?: InputMaybe<Treatment_LossOfEnergy>;
  /** <I can enjoy things as much as I used to (0) /I can't enjoy things as much as I used to (1) /Things that only used to give me pleasure I can hardly enjoy anymore (2) /Things that used to give me pleasure I can't enjoy at all (3)> */
  lossOfEnjoyment?: InputMaybe<Treatment_LossOfEnjoyment>;
  /** <I have not lost interest in other people or in activities (0) /I have less interest in other people or in things than usual (1) /I have lost interest in other people or things for the most part (2) /I have a hard time being interested in anything at all (3)> */
  lossOfInterest?: InputMaybe<Treatment_LossOfInterest>;
  /** <My interest in sexuality has not changed lately (0) / I am less interested in sexuality than I used to be (1) /I am much less interested in sexuality now (2) /I have completely lost interest in sexuality (3)> */
  lossOfSexualInterest?: InputMaybe<Treatment_LossOfSexualInterest>;
  /** <I am not despondent about the future (0) / I am more despondent about the future than usual (1) /I am despondent and do not expect my situation to get better (2) /I think my future is hopeless and will only get worse (3)> */
  pessimism?: InputMaybe<Treatment_Pessimism>;
  /** <I am no more restless than usual (0) /I am more restless than usual (1) /I am so restless that it is difficult for me to sit still (2) /I am such a restless person that I am constantly moving or doing something (3)> */
  restlessness?: InputMaybe<Treatment_Restlessness>;
  /** <I am not sad (0) / I am often sad (1) / I am sad all the time (2) / I am so sad or unhappy that I can't stand it (3)> */
  sadness?: InputMaybe<Treatment_Sadness>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** <I think as highly of myself as ever (0) /I have lost confidence in myself (1) /I am disappointed in myself (2) /I completely reject myself (3)> */
  selfRejection?: InputMaybe<Treatment_SelfRejection>;
  /** <I do not criticize or blame myself more than usual (0) /I am more critical of myself than usual (1) /I criticize myself for all my shortcomings (2) /I blame myself for everything bad that happens (3)> */
  selfReproach?: InputMaybe<Treatment_SelfReproach>;
  /** <I don't think about harming myself (0) / I sometimes think about suicide, but I wouldn't do it (1) /I would like to kill myself most (2) /I would kill myself if I had the chance (3)> */
  suicidalThoughts?: InputMaybe<Treatment_SuicidalThoughts>;
  /** <I don't feel more tired or exhausted than usual (0) /I get tired or exhausted more quickly than usual (1) /I am too tired or exhausted to do many things I usually do (2) /I am so tired or exhausted that I can do almost nothing (3)> */
  tirednessOrExhaustion?: InputMaybe<Treatment_TirednessOrExhaustion>;
  /** <I don't feel worthless (0) /I consider myself less valuable and useful than usual (1) Compared to other people, I feel much less valuable (2) /I feel completely worthless (3)> */
  worthlessness?: InputMaybe<Treatment_Worthlessness>;
};

export type Input_Treatment_BiensteinBreathScaleBlock = {
  bbsPain?: InputMaybe<Treatment_BbsPain>;
  bbsWillingnessToCooperate?: InputMaybe<Treatment_BbsWillingnessToCooperate>;
  breathingEffort?: InputMaybe<Treatment_BreathingEffort>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  dysphagia?: InputMaybe<Treatment_Dysphagia>;
  immunodeficiency?: InputMaybe<Treatment_Immunodeficiency>;
  intubationAnesthesiaVentilation?: InputMaybe<Treatment_IntubationAnesthesiaVentilation>;
  levelOfConsciousness?: InputMaybe<Treatment_LevelOfConsciousness>;
  manipulativeOrotrachealMeasures?: InputMaybe<Treatment_ManipulativeOrotrachealMeasures>;
  mobilityLimitations?: InputMaybe<Treatment_MobilityLimitations>;
  occupation?: InputMaybe<Treatment_Occupation>;
  presentAcuteRespiratoryDisease?: InputMaybe<Treatment_PresentAcuteRespiratoryDisease>;
  previousLungDisease?: InputMaybe<Treatment_PreviousLungDisease>;
  respiratoryDepressantMedications?: InputMaybe<Treatment_RespiratoryDepressantMedications>;
  respiratoryRate?: InputMaybe<Treatment_RespiratoryRate>;
  score?: InputMaybe<Scalars['Int']>;
  smoker?: InputMaybe<Treatment_Smoker>;
};

export type Input_Treatment_BingeEatingMsg = {
  accompanyingFeelings?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  endingReasons?: InputMaybe<Scalars['String']>;
  foodAndQuantity?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_BingeEatingResolution>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intensity?: InputMaybe<Treatment_BingeEatingIntensity>;
  trigger?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_BloodPressureAndPulseAnamnesticBlock = {
  measurements?: InputMaybe<Array<InputMaybe<Input_Treatment_BloodPressureAndPulseAnamnesticMsg>>>;
};

export type Input_Treatment_BloodPressureAndPulseAnamnesticMsg = {
  diastolicValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  numberOfBPM?: InputMaybe<Scalars['Int']>;
  systolicValue?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  timeOfMeasurement?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_BloodPressureAndPulseBlock = {
  measurements?: InputMaybe<Array<InputMaybe<Input_Treatment_BloodPressureAndPulseMsg>>>;
};

export type Input_Treatment_BloodPressureAndPulseMsg = {
  diastolicValue?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  numberOfBPM?: InputMaybe<Scalars['Int']>;
  pulseQuality?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  pulseRhythmType?: InputMaybe<Treatment_PulseRhythmType>;
  systolicValue?: InputMaybe<Scalars['Int']>;
  timeOfMeasurement?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_BodsScoreBlock = {
  bodsScoreOneValueSelection?: InputMaybe<Treatment_BodsScoreOneValueSelection>;
  bodsScoreTwoValueSelection?: InputMaybe<Treatment_BodsScoreTwoValueSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_BodyMeasurementsBlock = {
  abdominalGirth?: InputMaybe<Scalars['Float']>;
  bmi?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_BodyMisconceptionMsg = {
  avoidanceOfExposingActivities?: InputMaybe<Scalars['Boolean']>;
  dissatisfactionDescription?: InputMaybe<Scalars['String']>;
  dissatisfactionWithAreas?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  perceptionMismatch?: InputMaybe<Scalars['Boolean']>;
  perceptionMismatchDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_BowelSoundsBlock = {
  bowelSound?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  entireAbdomenText?: InputMaybe<Scalars['String']>;
  leftUpperQuadrantText?: InputMaybe<Scalars['String']>;
  lowerLeftQuadrantText?: InputMaybe<Scalars['String']>;
  lowerRightQuadrantText?: InputMaybe<Scalars['String']>;
  midAbdomenText?: InputMaybe<Scalars['String']>;
  rightUpperQuadrantText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_BradenQScaleBlock = {
  bradenScaleActivity?: InputMaybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: InputMaybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  frictionAndShear?: InputMaybe<Treatment_FrictionAndShear>;
  moisture?: InputMaybe<Treatment_Moisture>;
  nutrition?: InputMaybe<Treatment_Nutrition>;
  score?: InputMaybe<Scalars['Int']>;
  sensorySensitivity?: InputMaybe<Treatment_SensorySensitivity>;
  tissuePerfusionAndOxygenation?: InputMaybe<Treatment_TissuePerfusionAndOxygenation>;
};

/** BradenScaleBlock for BAss */
export type Input_Treatment_BradenScaleBassBlock = {
  bradenScaleActivity?: InputMaybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: InputMaybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  frictionAndShear?: InputMaybe<Treatment_FrictionAndShear>;
  moisture?: InputMaybe<Treatment_Moisture>;
  nutrition?: InputMaybe<Treatment_Nutrition>;
  other?: InputMaybe<Treatment_OtherSignificantRiskFactors>;
  score?: InputMaybe<Scalars['Int']>;
  sensorySensitivity?: InputMaybe<Treatment_SensorySensitivity>;
};

export type Input_Treatment_BradenScaleBlock = {
  bradenScaleActivity?: InputMaybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: InputMaybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  frictionAndShear?: InputMaybe<Treatment_FrictionAndShear>;
  moisture?: InputMaybe<Treatment_Moisture>;
  nutrition?: InputMaybe<Treatment_Nutrition>;
  score?: InputMaybe<Scalars['Int']>;
  sensorySensitivity?: InputMaybe<Treatment_SensorySensitivity>;
};

export type Input_Treatment_BreathingMovabilityBlock = {
  breathingMovabilities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  breathingMovabilityResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_BreathingMovementBlock = {
  breathingMovement?: InputMaybe<Treatment_BreathingMovementType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_BronchophonyBlock = {
  bronchophony?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  bronchophonyAbnormalitiesPresent?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

/** for reference: https://www.criticalcarepractitioner.co.uk/wp-content/uploads/2017/07/CONFUSION-ASSESSMENT-METHOD-CAM-.png */
export type Input_Treatment_CamBlock = {
  /** A: Acute onset or fluctuating course: <yes/ no> */
  acuteOnsetOrFluctuatingCourse?: InputMaybe<Scalars['Boolean']>;
  /** D: Altered level of consciousness: <yes/no> */
  alteredLevelOfConsciousness?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Result of the assessment */
  delirium?: InputMaybe<Scalars['Boolean']>;
  /** C: Disorganized Thinking: <yes/no> */
  disorganizedThinking?: InputMaybe<Scalars['Boolean']>;
  /** B: Inattention: <yes/no> */
  inattention?: InputMaybe<Scalars['Boolean']>;
};

/** for reference: https://www.researchgate.net/figure/Confusion-assessment-method-for-the-ICU-CAM-ICU-Flow-sheet_fig1_303790119 */
export type Input_Treatment_CamIcuBlock = {
  /** A: Acute onset or fluctuating course: <yes/ no> */
  acuteOnsetOrFluctuatingCourse?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Result of the assessment */
  delirium?: InputMaybe<Scalars['Boolean']>;
  /** D: Disorganized thinking – combined number of errors to questions and commands >1: <yes / no> */
  disorganizedThinking?: InputMaybe<Scalars['Boolean']>;
  /** B: Letter attention test with >2 errors: < yes/ no> */
  letterAttentionTest?: InputMaybe<Scalars['Boolean']>;
  /** C: RASS = 0: < yes/ no> */
  rass?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_CancelDiagnosisVersionRequest = {
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelDiagnosisVersionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelFluidFlowSystemVersionRequest = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelFluidFlowSystemVersionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelFluidFlowVersionRequest = {
  fluidFlowId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelFluidFlowVersionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelSymptomConfigurationVersionRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelSymptomConfigurationVersionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelTherapyCardRevisionRequest = {
  revisionGroupId?: InputMaybe<Scalars['String']>;
  revisionId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelTherapyCardRevisionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelWoundVersionRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CancelWoundVersionResponse = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CardMetadataMsg = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  singleton?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_CardTemplateMsg = {
  blocks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Whether the card should already be created when the skeleton is constructed */
  create?: InputMaybe<Scalars['Boolean']>;
  number?: InputMaybe<Scalars['Int']>;
  /**
   * Used in problem-specific cards:
   *  determines which diagnoses are displayed in selectable list of "non-existing complications"
   */
  relevantAnesthesiaComplications?: InputMaybe<Array<InputMaybe<Input_Treatment_RelevantAnesthesiaComplicationInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which diagnoses are displayed in selectable list of "non-existent diagnoses"
   */
  relevantDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_RelevantDiagnosisInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which reasons are displayed in selectable list of "reasons for presentation"
   */
  relevantReasons?: InputMaybe<Array<InputMaybe<Input_Treatment_RelevantReasonForPresentationInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which symptoms are displayed in selectable list of "non-existent symptoms"
   */
  relevantSymptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_RelevantSymptomInfoMsg>>>;
};

export type Input_Treatment_CardiacArrhythmiaBlock = {
  arrhythmia?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  chestPain?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  chestPainPresent?: InputMaybe<Scalars['Boolean']>;
  chestTightnessDescription?: InputMaybe<Scalars['String']>;
  chestTightnessPresent?: InputMaybe<Scalars['Boolean']>;
  estimatedBeatsPerMinute?: InputMaybe<Scalars['Int']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  occurrence?: InputMaybe<Treatment_SymptomOnsetType>;
  paroxysmalArrhythmia?: InputMaybe<Input_Treatment_ParoxysmalCardiacArrhythmiaMsg>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  unconsciousnessDescription?: InputMaybe<Scalars['String']>;
  unconsciousnessPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_CardiacInsufficiencyBlock = {
  furtherClassification?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  furtherInformation?: InputMaybe<Input_Treatment_CardiacInsufficiencyDetailsMsg>;
  nyhaClassification?: InputMaybe<Treatment_NyhaClassification>;
  occurrence?: InputMaybe<Treatment_CardiacInsufficiencyOccurrence>;
  occurrenceText?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  reducedPerformance?: InputMaybe<Scalars['Boolean']>;
  sweats?: InputMaybe<Scalars['Boolean']>;
  tachycardia?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_CardiacInsufficiencyDetailsMsg = {
  chestPain?: InputMaybe<Scalars['Boolean']>;
  coldAndBlueLipsOrFingers?: InputMaybe<Scalars['Boolean']>;
  coughingOrFoaming?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  lossOfConsciousness?: InputMaybe<Scalars['Boolean']>;
  nightlyUrinationFrequency?: InputMaybe<Scalars['Int']>;
  nocturnalUrinationUrge?: InputMaybe<Scalars['Boolean']>;
  skinPaleness?: InputMaybe<Scalars['Boolean']>;
  stomachPainAndNausea?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_CervicalSpineJointsMsg = {
  /** c3/4 */
  c3C4?: InputMaybe<Laterality_Laterality>;
  /** c4/5 */
  c4C5?: InputMaybe<Laterality_Laterality>;
  /** c5/6 */
  c5C6?: InputMaybe<Laterality_Laterality>;
  /** c6/7 */
  c6C7?: InputMaybe<Laterality_Laterality>;
  /** c7/8 */
  c7C8?: InputMaybe<Laterality_Laterality>;
  /** c8/Th1 */
  c8Th1?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_CervicalSpineMsg = {
  c4?: InputMaybe<Laterality_Laterality>;
  c5?: InputMaybe<Laterality_Laterality>;
  c6?: InputMaybe<Laterality_Laterality>;
  c7?: InputMaybe<Laterality_Laterality>;
  c8?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_Cha2Ds2VascBlock = {
  /** ≥75 years-old (2) / 65-74 years-old (1) / <65 years-old (0) */
  age?: InputMaybe<Treatment_Cha2Ds2VascAge>;
  /** yes (1) / no (0) */
  chronicalHeartFailure?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  diabetes?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  female?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  hypertension?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** yes (1) / no (0) */
  strokeTiaThromboembolismHistory?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  vascularDiseaseHistory?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ChangeDiagnosisCreationVisitRequest = {
  newVisitId?: InputMaybe<Scalars['String']>;
  oldVisitId?: InputMaybe<Scalars['String']>;
  /** currently, only supported for surgery diagnoses, might be extended in future */
  surgeryId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ChecklistElementActionMsg = {
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_ChecklistElementStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ChecklistElementMsg = {
  actions?: InputMaybe<Array<InputMaybe<Input_Treatment_ChecklistElementActionMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Input_Treatment_ChecklistItemMsg>;
  status?: InputMaybe<Treatment_ChecklistElementStatus>;
};

export type Input_Treatment_ChecklistItemMsg = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ChecklistMsg = {
  elements?: InputMaybe<Array<InputMaybe<Input_Treatment_ChecklistElementMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_ChecklistType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ChecklistTemplateMsg = {
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<Input_Treatment_ChecklistItemMsg>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Treatment_ChecklistType>;
};

export type Input_Treatment_ChewingMusclesAndFacialMotorSkillsBlock = {
  examinationOfEyelidClosing?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfEyelidClosingText?: InputMaybe<Scalars['String']>;
  examinationOfMasticatoryMuscles?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfMasticatoryMusclesText?: InputMaybe<Scalars['String']>;
  examinationOfTheMimicMuscles?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfTheMimicMusclesText?: InputMaybe<Scalars['String']>;
  facialMotorSkills?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ChildPughBlock = {
  /** Ascites (sonographic): absent (1) / slight (2) / moderate (3) */
  ascites?: InputMaybe<Treatment_AscitesCheck>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** no Encephalopathy (1) / Grade I-II (2) / >Grade II (3) */
  hepatischeEnzephalopathie?: InputMaybe<Treatment_HepatischeEnzephalopathie>;
  /** % : >70 (1) / 40-70 (2) / <40 (3) */
  quickValue?: InputMaybe<Treatment_QuickValue>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** g/dl: < >3.5 (1) / 2,8-3,5 (2) / <2,8 (3) */
  serumAlbumin?: InputMaybe<Treatment_SerumAlbumin>;
  /** mg/dl: <2,0 (1) / 2.0-3,0 (2) / >3.0 (3) */
  serumBilirubin?: InputMaybe<Treatment_SerumBilirubin>;
};

export type Input_Treatment_ClavienDindoBlock = {
  clavienDindoSelection?: InputMaybe<Treatment_ClavienDindoSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ClinicalRecommendationMsg = {
  compliance?: InputMaybe<Treatment_RecommendationCompliance>;
  complianceDetails?: InputMaybe<Scalars['String']>;
  connectedDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  /** Text of the recommendation in html format */
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Treatment_ClinicalRecommendationOrigin>;
};

export type Input_Treatment_ClinicalRecommendationsList = {
  /** If we want the list for a given diagnosis, this is set */
  diagnosisId?: InputMaybe<Scalars['String']>;
  recommendations?: InputMaybe<Array<InputMaybe<Input_Treatment_ClinicalRecommendationMsg>>>;
  /** If we want the list for a given treatment, this is set */
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ClinicalStagingCodingMsg = {
  /** Fixed UUID of coding system */
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Version of coding system (often year) */
  version?: InputMaybe<Scalars['String']>;
};

/** Used to define the extent of a disease */
export type Input_Treatment_ClinicalStagingInputMsg = {
  code?: InputMaybe<Input_Treatment_ClinicalStagingCodingMsg>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  tumorInformation?: InputMaybe<Input_Treatment_TumorInformationMsg>;
};

export type Input_Treatment_ClockTestBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  shulmanScale?: InputMaybe<Treatment_ClockScaleSelection>;
  sunderlandScale?: InputMaybe<Treatment_ClockScaleSelection>;
  watsonScale?: InputMaybe<Treatment_ClockScaleSelection>;
};

export type Input_Treatment_CompositeChecklistIdMsg = {
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_ChecklistType>;
};

export type Input_Treatment_CompressionStabilityBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ConstantShoulderBlock = {
  /** 0°-30° (0) / 31°-60° (2) / 61°-90° (4) / 91°-120° (6) / 121°-150° (8) / 151°-180° (10) */
  abduction?: InputMaybe<Treatment_DegreeSelect>;
  /** Ability to work: 0-4 */
  abilityToWork?: InputMaybe<Treatment_ConstantShoulderSliderToFour>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /**
   * hand on top of head, elbow forward (2)
   * /hand on top of head, elbow to side (2)
   * /hand on back of head, elbow forward (2)
   * /hand on back of head, elbow to side (2)
   * /unrestricted overhead mobility (2)
   */
  externalRotationList?: InputMaybe<Array<InputMaybe<Treatment_ExternalRotation>>>;
  /** 0°-30° (0) / 31°-60° (2) / 61°-90° (4) / 91°-120° (6) / 121°-150° (8) / 151°-180° (10) */
  flexion?: InputMaybe<Treatment_DegreeSelect>;
  /**
   * Force (90° abduction in scapular plane, hand pronated):
   * <numeric input>
   * (non-negative integers; two decimals; interval: 0,45; range: 0,45 to 11,25 >
   */
  force?: InputMaybe<Scalars['Float']>;
  /** girth (2) / xiphoid (4) /neck (6) / vertex (8) / beyond head (10) */
  handReach?: InputMaybe<Treatment_HandReach>;
  /**
   * back of hand on outer thigh (0)
   * /back of hand on buttock (2)
   * /back of hand on lumbosacral junction (4)
   * /back of hand on girdle line (3rd LWK) (6)
   * /back of hand on 12th dorsal vertebra (8)
   * /back of hand between shoulder blades (10)
   */
  internalRotation?: InputMaybe<Treatment_InternalRotation>;
  /** Pain: 0-15 */
  pain?: InputMaybe<Treatment_ConstantShoulderSliderToFifteen>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** Sleep ability: 0-2 */
  sleepAbility?: InputMaybe<Treatment_ConstantShoulderSliderToTwo>;
  /** Recreational/sports ability: 0-15 */
  sportsAbility?: InputMaybe<Treatment_ConstantShoulderSliderToFifteen>;
};

export type Input_Treatment_ContraceptivesBlock = {
  contraceptiveIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ContusionHematomaBlock = {
  contusionMarks?: InputMaybe<Array<InputMaybe<Input_Treatment_ContusionMarkMsg>>>;
  contusionMarksPresent?: InputMaybe<Scalars['Boolean']>;
  contusionMarksText?: InputMaybe<Scalars['String']>;
  hematomas?: InputMaybe<Array<InputMaybe<Input_Treatment_HematomaMsg>>>;
  hematomasPresent?: InputMaybe<Scalars['Boolean']>;
  hematomasText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ContusionMarkMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_CoordinationAbnormalitiesSingleTestMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_CoordinationAbnormalitiesTestMsg = {
  id?: InputMaybe<Scalars['String']>;
  leftTest?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesSingleTestMsg>;
  rightTest?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesSingleTestMsg>;
};

export type Input_Treatment_CoordinationBlock = {
  baranyTest?: InputMaybe<Input_Treatment_CoordinationTestMsg>;
  coordination?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  diadochokinesis?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesTestMsg>;
  fingerNoseTest?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesTestMsg>;
  fingerToFingerTest?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesTestMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  heelKneeTest?: InputMaybe<Input_Treatment_CoordinationAbnormalitiesTestMsg>;
};

export type Input_Treatment_CoordinationSingleTestMsg = {
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CoordinationTestMsg = {
  id?: InputMaybe<Scalars['String']>;
  leftTest?: InputMaybe<Input_Treatment_CoordinationSingleTestMsg>;
  rightTest?: InputMaybe<Input_Treatment_CoordinationSingleTestMsg>;
};

export type Input_Treatment_CortisoneMsg = {
  cortisoneDrugLink?: InputMaybe<Input_Drug_DrugLinkMsg>;
  /** non-negative; unit: ml */
  cortisoneVolume?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_CoughBlock = {
  furtherClassification?: InputMaybe<Input_Treatment_CoughDetailsMsg>;
  furtherClassificationPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  symptomAppearance?: InputMaybe<Treatment_SymptomAppearance>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_CoughDetailsMsg = {
  coughQualities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  coughSounds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  coughTriggerPresent?: InputMaybe<Scalars['Boolean']>;
  coughTriggers?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  painDescription?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  painPresent?: InputMaybe<Scalars['Boolean']>;
  sputumAmountDescription?: InputMaybe<Scalars['String']>;
  sputumDaytimeDependencePresent?: InputMaybe<Scalars['Boolean']>;
  sputumDaytimeDependences?: InputMaybe<Array<InputMaybe<Treatment_DaytimeDependence>>>;
  sputumDescription?: InputMaybe<Scalars['String']>;
  sputumIncreasedAfterEating?: InputMaybe<Scalars['Boolean']>;
  sputumPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_Crb65ScoreBlock = {
  /** < yes (1) / no (0) > */
  ageGreaterOrEqual65?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** <present (1) / not present (0) > */
  confusionPresent?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0) > */
  diastolicBloodPressureLessOrEqual60OrSystolicBloodPressureLessThan90?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0) > */
  respiratoryRateGreaterOrEqualThan30?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_CreateAllergyRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  /** Optional: if within a treatment, this has to be set */
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateAnamnesisBlockRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_AnamnesisBlockLocation>;
  pathKey?: InputMaybe<Input_Treatment_PathKeyMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateAnamnesisBlockResponse = {
  anamnesisBlock?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
};

export type Input_Treatment_CreateAnamnesisCardRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_CreateAnamnesisRequest = {
  location?: InputMaybe<Treatment_AnamnesisLocation>;
  patientId?: InputMaybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateAnamnesisResponse = {
  anamnesis?: InputMaybe<Input_Treatment_AnamnesisMsg>;
};

export type Input_Treatment_CreateChecklistTemplateRequest = {
  items?: InputMaybe<Array<InputMaybe<Input_Treatment_ChecklistItemMsg>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  type?: InputMaybe<Treatment_ChecklistType>;
};

export type Input_Treatment_CreateClinicalRecommendationRequest = {
  dischargeId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Treatment_ClinicalRecommendationOrigin>;
  patientId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateClinicalRecommendationResponse = {
  clinicalRecommendationId?: InputMaybe<Scalars['String']>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<Input_Treatment_ClinicalRecommendationMsg>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_CreateDiagnosisCodingRequest = {
  /**
   * By default, an icd coding change will clear any alpha/orphaIds.
   *  For synchronization with external systems, it may be convenient to set those first and then create the ICD code -
   *  in that case, this is set.
   */
  avoidClearingCodings?: InputMaybe<Scalars['Boolean']>;
  /** If set to true, any existing icd codes will be cleared from the diagnosis */
  clearIcdCodings?: InputMaybe<Scalars['Boolean']>;
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisCoding?: InputMaybe<Input_Treatment_DiagnosisCodingMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateDiagnosisCodingResponse = {
  diagnosisCoding?: InputMaybe<Input_Treatment_DiagnosisCodingMsg>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: InputMaybe<Scalars['String']>;
  updatedDiagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_CreateDiagnosisRequest = {
  categoryAssignment?: InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>;
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  /** always needs to be set */
  patientId?: InputMaybe<Scalars['String']>;
  /** If the diagnosis is not determined through treatment, but just an entry of old data */
  previousDiagnosis?: InputMaybe<Scalars['Boolean']>;
  /** if the diagnosis is created in a preanesthetic assessment for the recommendation */
  recommended?: InputMaybe<Scalars['Boolean']>;
  /** optional */
  tagAssignments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisTagAssignmentMsg>>>;
};

export type Input_Treatment_CreateDiagnosisResponse = {
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_CreateFluidFlowRequest = {
  fluidFlow?: InputMaybe<Input_Treatment_FluidFlowMsg>;
  /**
   * when creating a fluid flow, its version source is assumed to be new
   *  due to them being only revisioned
   */
  versionSource?: InputMaybe<Input_Versioning_VersionSourceMsg>;
};

export type Input_Treatment_CreateFluidFlowSystemRequest = {
  detailsNumber?: InputMaybe<Scalars['Int']>;
  fluidFlowSystem?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
  /** only relevant for NamedFluidFlowSystemMsg */
  name?: InputMaybe<Scalars['String']>;
  /**
   * when creating a fluid flow system, its version source is assumed to be new
   *  due to them being only revisioned
   */
  versionSource?: InputMaybe<Input_Versioning_VersionSourceMsg>;
};

export type Input_Treatment_CreateImmunityTestRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreatePhysicalBlockRequest = {
  location?: InputMaybe<Treatment_PhysicalBlockLocation>;
  pathKey?: InputMaybe<Input_Treatment_PathKeyMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  physicalExaminationId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreatePhysicalBlockResponse = {
  physicalBlock?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
};

export type Input_Treatment_CreatePhysicalExaminationRequest = {
  location?: InputMaybe<Treatment_PhysicalExaminationLocation>;
  patientId?: InputMaybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreatePhysicalExaminationResponse = {
  physicalExamination?: InputMaybe<Input_Treatment_PhysicalExaminationMsg>;
};

export type Input_Treatment_CreatePhysicalPresetRequest = {
  overrideDefault?: InputMaybe<Scalars['Boolean']>;
  preset?: InputMaybe<Input_Treatment_PhysicalPresetMsg>;
};

export type Input_Treatment_CreateSymptomConfigurationRequest = {
  parameters?: InputMaybe<Input_Versioning_VersionedEntityCreationParametersMsg>;
  symptomConfiguration?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
  versionSource?: InputMaybe<Input_Versioning_VersionSourceMsg>;
};

export type Input_Treatment_CreateTherapyCardRequest = {
  cardNumber?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Treatment_TherapyCardLocation>;
  /** only relevant for NamedProcedureMsg */
  name?: InputMaybe<Scalars['String']>;
  participatingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  revisionSource?: InputMaybe<Input_Versioning_RevisionSourceMsg>;
  surgeryId?: InputMaybe<Scalars['String']>;
  therapyId?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateTherapyRequest = {
  location?: InputMaybe<Treatment_TherapyLocation>;
  patientId?: InputMaybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateTherapyResponse = {
  therapy?: InputMaybe<Input_Treatment_TherapyMsg>;
};

export type Input_Treatment_CreateTreatmentRequest = {
  /** To create a treatment without visitId, this flag must be explicitly set */
  allowMissingVisitId?: InputMaybe<Scalars['Boolean']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateTreatmentResponse = {
  /** set if denied due to existing open treatment in some other unit */
  blockingOpenTreatment?: InputMaybe<Input_Treatment_OpenTreatmentInfoMsg>;
  /** set if there is an open treatment the user can continue with in the same unit */
  oldTreatmentInUnit?: InputMaybe<Input_Treatment_OpenTreatmentInfoMsg>;
  /** set if successful */
  treatment?: InputMaybe<Input_Treatment_TreatmentMsg>;
};

export type Input_Treatment_CreateVaccinationCertificateRequest = {
  fileId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateVaccinationDiseaseRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateVaccinationRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  /** optional: set only if vaccination is part of the treatment */
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CreateWoundRequest = {
  /** mandatory */
  context?: InputMaybe<Input_Treatment_WoundContextReferenceMsg>;
  documentationDate?: InputMaybe<Input_Timestamp>;
  parameters?: InputMaybe<Input_Versioning_VersionedEntityCreationParametersMsg>;
  versionSource?: InputMaybe<Input_Versioning_VersionSourceMsg>;
};

export type Input_Treatment_CrepitationMsg = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locationInput?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_CrepitationsBlock = {
  crepitations?: InputMaybe<Array<InputMaybe<Input_Treatment_CrepitationMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_CruciateLigamentsExaminationBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_CruciateLigamentsExaminationMsg>;
  right?: InputMaybe<Input_Treatment_CruciateLigamentsExaminationMsg>;
};

export type Input_Treatment_CruciateLigamentsExaminationMsg = {
  activeQuadricepsTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  activeQuadricepsTestText?: InputMaybe<Scalars['String']>;
  anteriorDrawerTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorDrawerTestText?: InputMaybe<Scalars['String']>;
  gravitySignTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  gravitySignTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lachmansTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lachmansTestText?: InputMaybe<Scalars['String']>;
  pivotShiftTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pivotShiftTestText?: InputMaybe<Scalars['String']>;
  posteriorDrawerTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  posteriorDrawerTestText?: InputMaybe<Scalars['String']>;
  reversedLachmansTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  reversedLachmansTestText?: InputMaybe<Scalars['String']>;
  tibiaStepOffSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaStepOffSignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CryotherapyMsg = {
  connectedDiagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cycles?: InputMaybe<Scalars['Int']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  notes?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  timePerCycle?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_CurrentPregnancyBlock = {
  calculatedGestationalAge?: InputMaybe<Scalars['Int']>;
  currentPregnancyPresent?: InputMaybe<Core_BoolUnknown>;
  currentPregnancyText?: InputMaybe<Scalars['String']>;
  lastMenstruation?: InputMaybe<Input_VeiosDateTimeMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CustomFunctionTestMsg = {
  customFunctionTestName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  leftText?: InputMaybe<Scalars['String']>;
  right?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  rightText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CvcMsg = {
  insertion?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  numberOfLumen?: InputMaybe<Scalars['Int']>;
  skinLevel?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_CycleBlock = {
  averageBleedingDuration?: InputMaybe<Scalars['Int']>;
  averageBleedingIntensity?: InputMaybe<Treatment_BleedingIntensity>;
  averageCycleDurationDays?: InputMaybe<Scalars['Int']>;
  averageCycleDurationText?: InputMaybe<Scalars['String']>;
  bleedingPresent?: InputMaybe<Scalars['Boolean']>;
  maximumCycleDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  maximumCycleDurationText?: InputMaybe<Scalars['String']>;
  minimumCycleDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  minimumCycleDurationText?: InputMaybe<Scalars['String']>;
  periodRhythmRegular?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_CycleDisordersBlock = {
  cycleDisorders?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** In days */
  cycleDuration?: InputMaybe<Scalars['Int']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  /** In ml */
  mensesAmount?: InputMaybe<Scalars['Int']>;
  /** In days */
  mensesDuration?: InputMaybe<Scalars['Int']>;
  menstruationCycle?: InputMaybe<Treatment_MenstruationCycle>;
  menstruationCycleText?: InputMaybe<Scalars['String']>;
  menstruationPresent?: InputMaybe<Scalars['Boolean']>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

/** todo: maybe merge patient and default configurations? */
export type Input_Treatment_DefaultFluidBalanceConfigurationMsg = {
  active?: InputMaybe<Scalars['Boolean']>;
  configuration?: InputMaybe<Input_Treatment_FluidBalanceConfigurationMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** TODO: probably only one default configuration per scope */
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Treatment_DeformitiesMalpositionsLowerLimbBlock = {
  deformitiesAndMalpositions?: InputMaybe<Array<InputMaybe<Input_Treatment_DeformitiesMalpositionsMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DeformitiesMalpositionsMsg = {
  deformitiesAndMalpositions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_DeformitiesMalpositionsSpineBlock = {
  deformitiesAndMalpositions?: InputMaybe<Array<InputMaybe<Input_Treatment_DeformitiesMalpositionsMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DeformitiesMalpositionsUpperLimbBlock = {
  deformitiesAndMalpositions?: InputMaybe<Array<InputMaybe<Input_Treatment_DeformitiesMalpositionsMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DeleteAllergyRequest = {
  allergyId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteAllergyResponse = {
  /** ID of deleted allergy */
  deletedAllergyId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteAnamnesisCardRequest = {
  cardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteClinicalRecommendationRequest = {
  clinicalRecommendationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteClinicalRecommendationResponse = {
  deletedClinicalRecommendationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDefaultFluidBalanceConfigurationRequest = {
  defaultConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDefaultFluidBalanceConfigurationResponse = {
  defaultConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDiagnosisCodingRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisCodingGroupId?: InputMaybe<Scalars['String']>;
  diagnosisCodingId?: InputMaybe<Scalars['String']>;
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDiagnosisCodingResponse = {
  deletedDiagnosisCodingId?: InputMaybe<Scalars['String']>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: InputMaybe<Scalars['String']>;
  updatedDiagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_DeleteDiagnosisCodingsRequest = {
  contexts?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>>>;
  /** deletes all codings of the given diagnoses */
  diagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDiagnosisCodingsResponse = {
  deletedDiagnosisCodingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_DeleteDiagnosisVersionRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteDiagnosisVersionResponse = {
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedDiagnosisRevision?: InputMaybe<Input_Treatment_DiagnosisMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedDiagnosisRevision?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_DeleteFluidFlowSystemVersionRequest = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteFluidFlowSystemVersionResponse = {
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedFluidFlowSystemRevision?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedFluidFlowSystemRevision?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
};

export type Input_Treatment_DeleteFluidFlowVersionRequest = {
  fluidFlowId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteFluidFlowVersionResponse = {
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedFluidFlowRevision?: InputMaybe<Input_Treatment_FluidFlowMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedFluidFlowRevision?: InputMaybe<Input_Treatment_FluidFlowMsg>;
};

export type Input_Treatment_DeletePatientFluidBalanceConfigurationRequest = {
  patientConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeletePatientFluidBalanceConfigurationResponse = {
  patientConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeletePhysicalBlocksRequest = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  /** Value doesn't matter, field just has to be set if scope should be physicalExamination */
  physicalExamination?: InputMaybe<Scalars['Boolean']>;
  physicalId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_DeletePhysicalBlocksResponse = {
  deletedBlockInfos?: InputMaybe<Array<InputMaybe<Input_Treatment_DeletedPhysicalBlockInfoMsg>>>;
};

export type Input_Treatment_DeleteSymptomConfigurationVersionRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteSymptomConfigurationVersionResponse = {
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedSymptomConfigurationRevision?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedSymptomConfigurationRevision?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
};

export type Input_Treatment_DeleteTherapyCardRequest = {
  cardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteTherapyCardResponse = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteVaccinationRequest = {
  vaccinationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteVaccinationResponse = {
  deletedVaccinationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteWoundRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteWoundResponse = {
  /** ID of deleted wound */
  deletedWoundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteWoundVersionRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeleteWoundVersionResponse = {
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedWoundRevision?: InputMaybe<Input_Treatment_WoundMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedWoundRevision?: InputMaybe<Input_Treatment_WoundMsg>;
};

export type Input_Treatment_DeletedPhysicalBlockInfoMsg = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  deletedBlockId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DeliriumDetectionBlock = {
  agitation?: InputMaybe<Treatment_DeliriumDetectionAgitation>;
  anxiety?: InputMaybe<Treatment_DeliriumDetectionAnxiety>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  hallucination?: InputMaybe<Treatment_DeliriumDetectionHallucination>;
  myocloniasEpilepticSeizuresSelection?: InputMaybe<Treatment_MyocloniasEpilepticSeizuresSelection>;
  orientation?: InputMaybe<Treatment_DeliriumDetectionOrientation>;
  paroxysmalSweating?: InputMaybe<Treatment_DeliriumDetectionParoxysmalSweating>;
  score?: InputMaybe<Scalars['Int']>;
  sleepWakeRhythm?: InputMaybe<Treatment_SleepWakeRhythm>;
  tremor?: InputMaybe<Treatment_DeliriumDetectionTremor>;
};

export type Input_Treatment_DemTectBlock = {
  /** Age <60 years: <yes/no> (singleselect) */
  ageLessThan60?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /**
   * Task 2: Convert numbers and number words (max. 4 points): <numeric input> (non-negative integers from 0-4)
   * if age < 60 years :
   * Evaluation Task 2: <0 points (0) / 1-2 points (1) / 3 points (2) / 4 points (3)> (singleselect)
   * else :
   * Evaluation Task 2: <0 points (0) / 1-2 points (1) / 3 points (2) / 4 points (3)> (singleselect)
   */
  convertNumbersAndNumberWords?: InputMaybe<Scalars['Int']>;
  /**
   * Task 4: Repeat number sequence backwards (max 6 points): <numeric input> (non-negative integers from 0-6)
   * if age < 60 years :
   * Evaluation Task 4: <0 points (0) / 2-3points (1) / 4 points (2) / 5-6 points (3)> (singleselect)
   * else :
   * Evaluation Task 4: <0 points (0) / 2 points (1) / 3 points (2) / 4-6 points (3)> (singleselect)
   */
  repeatNumberSequenceBackwards?: InputMaybe<Scalars['Int']>;
  /**
   * Task 1: Repeat word list (max. 20 points): <numeric input> (non-negative integers from 0-20)
   * if age < 60 years :
   * Evaluation Task 1: <0-7 points (0) / 8-10 points (1) / 11-12 points (2) / 13-20 points (3)>
   * else :
   * Evaluation Task 1: <0-6 points (0) / 7-8 points (1) / 9-10 points (2) / 11-20 points (3)>
   */
  repeatWordList?: InputMaybe<Scalars['Int']>;
  /**
   * Task 5: repeat word list from task 1 (max. 10 points): <numeric input> (non-negative integers from 0-10)
   * if age < 60 years :
   * Evaluation Task 5: <0 points (0) / 1-3 points (1) / 4-5 points (2) / 6-10 points (5)> (singleselect)
   * else :
   * Evaluation Task 5: <0 points (0) / 1-2 points (1) / 3-4 points (2) / 5-10 points (5)> (singleselect)
   */
  repeatWordListAgain?: InputMaybe<Scalars['Int']>;
  /** Automatic addition of points based on points from Evaluation of tasks */
  score?: InputMaybe<Scalars['Int']>;
  /**
   * Task 3: Supermarket task (max. 30 points): <numeric input> (non-negative integers from 0-30)
   * if age < 60 years :
   * Evaluation Task 3: <0-12 points (0) / 13-15 points (1) / 16-19 points (2) / 20-30 points (4)> (singleselect)
   * else :
   * Evaluation Task 3: <0-5 points (0) / 6-9 points (1) / 10-15 points (2) / 16-30 points (4)> (singleselect)
   */
  supermarketTask?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_DentureMsg = {
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_DenturesBlock = {
  dentures?: InputMaybe<Array<InputMaybe<Input_Treatment_DentureMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DermatologyLifeQualityIndexBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** 1: Over the last week, how itchy, sore, painful or stinging has your skin been? */
  painfulSkinStatus?: InputMaybe<Treatment_DlqiSelection>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** 9: Over the last week, how much has your skin caused any sexual difficulties? */
  skinConditionCausesSexualDifficulties?: InputMaybe<Treatment_DlqiSelection>;
  /** 7b: f "No", over the last week how much has your skin been a problem at work or studying?: */
  skinConditionImpactAtWork?: InputMaybe<Treatment_DlqiSelection>;
  /** 3: Over the last week, how much has your skin interfered with you going shopping or looking after your home or garden? */
  skinConditionImpactOnDailyActivities?: InputMaybe<Treatment_DlqiSelection>;
  /** 5: Over the last week, how much has your skin affected any social or leisure activities? */
  skinConditionImpactOnSocialActivities?: InputMaybe<Treatment_DlqiSelection>;
  /** 8: Over the last week, how much has your skin created problems with your partner or any of your close friends or relatives? */
  skinConditionImpactSocialRelationship?: InputMaybe<Treatment_DlqiSelection>;
  /** 4: Over the last week, how much has your skin influenced the clothes you wear? */
  skinConditionInfluencedByClothes?: InputMaybe<Treatment_DlqiSelection>;
  /** 6: Over the last week, how much has your skin made it difficult for you to do any sport? */
  skinDifficultyToDoSport?: InputMaybe<Treatment_DlqiSelection>;
  /** 2: Over the last week, how embarrassed self-conscious have you been because of your skin? */
  skinEmbarrassment?: InputMaybe<Treatment_DlqiSelection>;
  /** 7a: Over the last week, has your skin prevented you from working or studying? */
  skinPreventionFromWorking?: InputMaybe<Treatment_DlqiSelection>;
  /** 10: Over the last week, how much of a problem has the treatment for your skin been, for example by making your home messy, or by taking up time? */
  skinTreatmentDisruptionLevel?: InputMaybe<Treatment_DlqiSelection>;
};

export type Input_Treatment_DiagnosesDevelopmentMsg = {
  conditionDevelopment?: InputMaybe<Treatment_ConditionDevelopment>;
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiagnosisAccessContextMsg = {
  /** the most specific context */
  specificContext?: InputMaybe<Input_Treatment_DiagnosisContextReferenceMsg>;
  /** optional additional information */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiagnosisCategoryAssignmentMsg = {
  category?: InputMaybe<Treatment_DiagnosisCategory>;
  scopeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_DiagnosisScopeType>;
};

export type Input_Treatment_DiagnosisCodingActivityInfoMsg = {
  latest?: InputMaybe<Scalars['Boolean']>;
  latestDiagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiagnosisCodingList = {
  diagnosisCodings?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCodingMsg>>>;
};

/** Standardized medical code for a diagnosis */
export type Input_Treatment_DiagnosisCodingMsg = {
  codingId?: InputMaybe<Scalars['String']>;
  germanCodingDetails?: InputMaybe<Input_Treatment_Diagnosis_German_GermanDiagnosisCodingDetailsMsg>;
  /** Allows grouping the same coding of different revisions of the same diagnosis together */
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** The name of the code */
  name?: InputMaybe<Scalars['String']>;
  /** id of person who inserted the data */
  recorderId?: InputMaybe<Input_Core_PersonReferenceMsg>;
  system?: InputMaybe<Treatment_DiagnosisCodingSystem>;
  systemVersion?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  /** Relevant if the system uses multiple types of codes */
  type?: InputMaybe<Treatment_DiagnosisCodeType>;
  units?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
  /** id of person who last updated the data */
  updaterId?: InputMaybe<Input_Core_PersonReferenceMsg>;
};

/** contextId refers to billing case id when type is set to DIAGNOSIS_CONTEXT_TYPE_CODING */
export type Input_Treatment_DiagnosisContextReferenceMsg = {
  contextId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_DiagnosisContextType>;
};

export type Input_Treatment_DiagnosisDetailMsg = {
  codes?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCodingMsg>>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Laterality_Laterality>;
  status?: InputMaybe<Treatment_DiagnosisStatus>;
  type?: InputMaybe<Treatment_DiagnosisDetailType>;
};

export type Input_Treatment_DiagnosisDevelopmentMsg = {
  conditionDevelopment?: InputMaybe<Treatment_ConditionDevelopment>;
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiagnosisList = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiagnosisMsg = {
  /** Period of time in which the diagnosed illness eased up */
  abatement?: InputMaybe<Input_VeiosTimeFrameMsg>;
  /** id of person who gave the diagnosis */
  asserterId?: InputMaybe<Input_Core_PersonReferenceMsg>;
  categoryAssignments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>>>;
  causedByDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  clinicalStagings?: InputMaybe<Array<InputMaybe<Input_Treatment_ClinicalStagingInputMsg>>>;
  /** only set if created in coding context for the given billing case */
  createdInBillingCaseId?: InputMaybe<Scalars['String']>;
  createdInClinicalRequestExecutionId?: InputMaybe<Scalars['String']>;
  /** only set if created within a surgery */
  createdInSurgeryId?: InputMaybe<Scalars['String']>;
  /** id of treatment diagnosis was created in */
  createdInTreatmentId?: InputMaybe<Scalars['String']>;
  /** only used for versioning purposes; will not be set if created in a more specific context (e.g., treatment) */
  createdInVisitId?: InputMaybe<Scalars['String']>;
  /** In combination with the createdIn... ids, defines where this version of the diagnosis was created */
  creationContextType?: InputMaybe<Treatment_DiagnosisContextType>;
  creationOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** obsolete, but has to be kept for documentation of old data */
  dateOfFinalDiagnosis?: InputMaybe<Input_Timestamp>;
  /** is set by backend, should not be edited by FE */
  deleted?: InputMaybe<Scalars['Boolean']>;
  diagnosisDetail?: InputMaybe<Input_Treatment_DiagnosisDetailMsg>;
  differentialDiagnosesDetail?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  /** Whether the diagnosis was not determined through treatment, but just an entry of old information */
  external?: InputMaybe<Scalars['Boolean']>;
  /** If false, this diagnosis is newly created and was not initialized by editing/importing an existing diagnosis */
  hasPredecessor?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  /** While the version info is newly created for each version, the initial context tells where the diagnosis versioning group was originally created */
  initialCreationContext?: InputMaybe<Input_Treatment_DiagnosisContextReferenceMsg>;
  /**
   * When this diagnosis was initially made.
   *  Can be before the date of entry if e.g., a different hospital or doctor's office made the diagnosis.
   *  When an updated diagnosis is entered, the initialDiagnosisDate of the previous version is transferred.
   */
  initialDiagnosisDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** Period of time in which the diagnosed illness first appeared */
  onset?: InputMaybe<Input_VeiosTimeFrameMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  recommended?: InputMaybe<Scalars['Boolean']>;
  /** id of person who inserted the data */
  recorderId?: InputMaybe<Input_Core_PersonReferenceMsg>;
  severity?: InputMaybe<Treatment_DiagnosisSeverity>;
  tagAssignments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisTagAssignmentMsg>>>;
  text?: InputMaybe<Scalars['String']>;
  textHtml?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_DiagnosisType>;
  validated?: InputMaybe<Scalars['Boolean']>;
  versionInfo?: InputMaybe<Input_Versioning_VersionInfoMsg>;
};

export type Input_Treatment_DiagnosisPresenceMsg = {
  codes?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCodingMsg>>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DiagnosisTagAssignmentMsg = {
  tag?: InputMaybe<Treatment_DiagnosisTag>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DialysisCatheterMsg = {
  insertion?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  numberOfLumen?: InputMaybe<Scalars['Int']>;
  skinLevel?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_DicBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  fibrinFormationMarker?: InputMaybe<Treatment_DicFibrinFormationMarker>;
  fibrinogen?: InputMaybe<Treatment_DicFibrinogen>;
  platelets?: InputMaybe<Treatment_DicPlatelets>;
  prothrombinTimeProlongation?: InputMaybe<Treatment_DicProthrombinTimeProlongation>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_DigitalRectalExamBlock = {
  analReflexPresent?: InputMaybe<Scalars['Boolean']>;
  bloodOnGlovePresent?: InputMaybe<Scalars['Boolean']>;
  faecesOnGlovePresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  mucousMembraneText?: InputMaybe<Scalars['String']>;
  mucousMembranes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  pressurePainPresent?: InputMaybe<Scalars['Boolean']>;
  resistances?: InputMaybe<Array<InputMaybe<Input_Treatment_DigitalRectalResistanceMsg>>>;
  resistancesPresent?: InputMaybe<Scalars['Boolean']>;
  sphincterTonus?: InputMaybe<Treatment_SphincterTonusType>;
};

export type Input_Treatment_DigitalRectalResistanceMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** Clock-like system from 1 to 12 */
  localizations?: InputMaybe<Array<InputMaybe<Treatment_ResistanceLocation>>>;
  text?: InputMaybe<Scalars['String']>;
};

/**
 * A collection of all vaccination-relevant information for one patient, specified by the patientId.
 *  Aimed at containing all information required by the German "Digitaler Impfpass".
 */
export type Input_Treatment_DigitalVaccinationCertificateMsg = {
  /** Id of the photo/scan of the paper vaccination certificate */
  fileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  immunityTests?: InputMaybe<Array<InputMaybe<Input_Treatment_ImmunityTestMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
  relevantDiseases?: InputMaybe<Array<InputMaybe<Input_Treatment_VaccinationRelevantDiseaseMsg>>>;
  vaccinations?: InputMaybe<Array<InputMaybe<Input_Treatment_VaccinationMsg>>>;
};

export type Input_Treatment_DiseasesOfFamilyMemberMsg = {
  dateOfDeath?: InputMaybe<Input_VeiosDateTimeMsg>;
  degreeOfRelationship?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  diagnosisDetails?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  passedAway?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DiseasesOfFamilyMembersBlock = {
  familyMembersDiseases?: InputMaybe<Array<InputMaybe<Input_Treatment_DiseasesOfFamilyMemberMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_DosBlock = {
  /** Gives answers that do not fit the question */
  answersDoesNotFitTheQuestion?: InputMaybe<Treatment_DosSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Knows which part of the day it is */
  dayPartAwareness?: InputMaybe<Treatment_DosSelectionNegation>;
  /** Does not finish question or answer */
  doesNotFinishQuestionOrAnswer?: InputMaybe<Treatment_DosSelection>;
  /** Dozes during conversation or activities */
  dozesDuringActivities?: InputMaybe<Treatment_DosSelection>;
  /** Is easily distracted by stimuli from the environment */
  easilyDistracted?: InputMaybe<Treatment_DosSelection>;
  /** Is easily or suddenly emotional */
  easilyEmotional?: InputMaybe<Treatment_DosSelection>;
  /** Sees / hears things which are not there */
  imaginarySensation?: InputMaybe<Treatment_DosSelection>;
  /** Is picking, disorderly, restless */
  isPickingDisorderlyRestless?: InputMaybe<Treatment_DosSelection>;
  /** Maintains attention to conversation or action */
  maintainAttentionToAction?: InputMaybe<Treatment_DosSelectionNegation>;
  /** Pulls IV tubes, feeding tubes, catheters */
  pullsIvTubesFeedingTubes?: InputMaybe<Treatment_DosSelection>;
  /** Reacts slowly to instructions */
  reactsSlowlyToInstructions?: InputMaybe<Treatment_DosSelection>;
  /** Remembers recent event */
  rememberRecentEvent?: InputMaybe<Treatment_DosSelectionNegation>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** Thinks to be somewhere else */
  thinksToBeSomewhereElse?: InputMaybe<Treatment_DosSelection>;
};

export type Input_Treatment_DrugAndAddictiveSubstanceMsg = {
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyReference?: InputMaybe<Treatment_ConsumptionFrequencyReference>;
  id?: InputMaybe<Scalars['String']>;
  substance?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_DyspneaAnamnesticBlock = {
  atsGrade?: InputMaybe<Treatment_DyspneaAtsGrade>;
  atsGradeText?: InputMaybe<Scalars['String']>;
  auxiliaryRespiratoryMuscleUse?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  muscleUseDescription?: InputMaybe<Scalars['String']>;
  occurrence?: InputMaybe<Treatment_SymptomOnsetType>;
  occurrenceSituation?: InputMaybe<Treatment_DyspneaSituation>;
  occurrenceSituationDescription?: InputMaybe<Scalars['String']>;
  paroxysmalDyspnea?: InputMaybe<Input_Treatment_ParoxysmalDyspneaMsg>;
  persistentDyspnea?: InputMaybe<Input_Treatment_PersistentDyspneaMsg>;
  positionDependence?: InputMaybe<Scalars['Boolean']>;
  positionDependenceDescription?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  qualities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_EarPartInspectionAbnormalityMsg = {
  combined?: InputMaybe<Input_Treatment_EarPartSideInspectionMsg>;
  documentationMode?: InputMaybe<Treatment_LateralityDocumentationMode>;
  id?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_EarPartSideInspectionMsg>;
  right?: InputMaybe<Input_Treatment_EarPartSideInspectionMsg>;
};

export type Input_Treatment_EarPartInspectionMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_EarPartInspectionAbnormalityMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_EarPartSideInspectionMsg = {
  abnormality?: InputMaybe<Input_Treatment_PhysicalAbnormalityMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_EarlyRehabilitationBarthelIndexBlock = {
  barthelIndexFields?: InputMaybe<Input_Treatment_BarthelIndexFieldsMsg>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  frIndex?: InputMaybe<Input_Treatment_FrIndexMsg>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_EarsInspectionBlock = {
  earCanals?: InputMaybe<Input_Treatment_EarPartInspectionMsg>;
  externalEars?: InputMaybe<Input_Treatment_EarPartInspectionMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  mastoid?: InputMaybe<Input_Treatment_MastoidInspectionMsg>;
  tympanicMembranes?: InputMaybe<Input_Treatment_EarPartInspectionMsg>;
};

export type Input_Treatment_EchocardiographyMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_EclamBlock = {
  /** Joint complaints */
  arthritis?: InputMaybe<Scalars['Boolean']>;
  /** Skin mucosal involvement */
  butterflyErythema?: InputMaybe<Scalars['Boolean']>;
  /** Complement depletion */
  c3?: InputMaybe<Scalars['Boolean']>;
  c50?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  discoidErythema?: InputMaybe<Scalars['Boolean']>;
  /** ESR (Elevation) */
  esrElevation?: InputMaybe<Scalars['Boolean']>;
  fatigue?: InputMaybe<Scalars['Boolean']>;
  /** General symptoms */
  fever?: InputMaybe<Scalars['Boolean']>;
  functionalImpairment?: InputMaybe<Scalars['Boolean']>;
  generalizedErythema?: InputMaybe<Scalars['Boolean']>;
  /** Cns involvement */
  headacheOrMigraine?: InputMaybe<Scalars['Boolean']>;
  hematuria?: InputMaybe<Scalars['Boolean']>;
  hemolyticAnemia?: InputMaybe<Scalars['Boolean']>;
  increasingDyspnea?: InputMaybe<Scalars['Boolean']>;
  leukopeniaOrLymphopenia?: InputMaybe<Scalars['Boolean']>;
  /** Myositis */
  myositis?: InputMaybe<Scalars['Boolean']>;
  newAthralgias?: InputMaybe<Scalars['Boolean']>;
  /** Hematologic involvement */
  nonHemolyticAnemia?: InputMaybe<Scalars['Boolean']>;
  oralUlcers?: InputMaybe<Scalars['Boolean']>;
  organicBrainPsychosyndrome?: InputMaybe<Scalars['Boolean']>;
  pathologicSediment?: InputMaybe<Scalars['Boolean']>;
  /** Pericarditis */
  pericarditis?: InputMaybe<Scalars['Boolean']>;
  /** Pulmonary involvement */
  pleuritis?: InputMaybe<Scalars['Boolean']>;
  pneumonitis?: InputMaybe<Scalars['Boolean']>;
  /** Renal involvement */
  proteinuria?: InputMaybe<Scalars['Boolean']>;
  psychosis?: InputMaybe<Scalars['Boolean']>;
  renalManifestationNewOrWorsened?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Float']>;
  seizures?: InputMaybe<Scalars['Boolean']>;
  skinMucosalManifestationNewOrWorsening?: InputMaybe<Scalars['Boolean']>;
  sterilePeritonitis?: InputMaybe<Scalars['Boolean']>;
  stroke?: InputMaybe<Scalars['Boolean']>;
  thrombocytopenia?: InputMaybe<Scalars['Boolean']>;
  /** Intestinal involvement */
  vasculitis?: InputMaybe<Scalars['Boolean']>;
  vasculitisOfTheSkin?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_EcogStatusBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  ecogGrade?: InputMaybe<Treatment_EcogGrade>;
};

export type Input_Treatment_EconomicCircumstancesMsg = {
  economicCircumstancesScore?: InputMaybe<Scalars['Int']>;
  financialDisposalLimitPerMonth?: InputMaybe<Scalars['Int']>;
  moneySufficient?: InputMaybe<Scalars['Boolean']>;
  savingsAssetsAvailable?: InputMaybe<Scalars['Boolean']>;
  selfManaged?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_EdemaMsg = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_EdemasBlock = {
  edemaPresent?: InputMaybe<Scalars['Boolean']>;
  edemas?: InputMaybe<Array<InputMaybe<Input_Treatment_EdemaMsg>>>;
};

export type Input_Treatment_EdemataBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  improvedAfterRest?: InputMaybe<Scalars['Boolean']>;
  improvedAfterRestDescription?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  occurrenceTimes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  onsetType?: InputMaybe<Treatment_SymptomAppearance>;
  painTriggers?: InputMaybe<Array<InputMaybe<Treatment_EdemataPainTrigger>>>;
  painfulSwelling?: InputMaybe<Scalars['Boolean']>;
  present?: InputMaybe<Scalars['Boolean']>;
  temperatureSensation?: InputMaybe<Treatment_EdemataTemperatureSensation>;
};

export type Input_Treatment_EducationalLevelBlock = {
  highestEducationalLevel?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_EfasBlock = {
  /**
   * Can you jog? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  canJog?: InputMaybe<Treatment_EfasSlider>;
  /**
   * Can you run? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  canRun?: InputMaybe<Treatment_EfasSlider>;
  /**
   * 3: How much has your gait (i.e., the way you walk) changed because of your foot and or ankle problem? <0-4> (slider)
   *  show as a note: 0=Extreme gait change, 4=No
   */
  changeInGait?: InputMaybe<Treatment_EfasSlider>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /**
   * 1: Do you have pain in your foot and or ankle when you are at rest? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  footOrAnklePainAtRest?: InputMaybe<Treatment_EfasSlider>;
  /**
   * 5: Do you have pain in your foot and or ankle when you are walking? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  footOrAnklePainInWalking?: InputMaybe<Treatment_EfasSlider>;
  /**
   * Do you have problems landing after jumping? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  landingProblemsAfterJumping?: InputMaybe<Treatment_EfasSlider>;
  /**
   * 6: How often do you have pain in your foot and/or ankle during physical activity? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  painDuringPhysicalActivity?: InputMaybe<Treatment_EfasSlider>;
  /**
   * Are you able to perform your sports with your usual technique? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  performSportsWithUsualTechnique?: InputMaybe<Treatment_EfasSlider>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /**
   * 2: How far can you walk before you get pain in your foot and/or ankle<0-4> (slider)
   *  show as a note: /0=Impossible, 4=No limitation
   */
  walkedBeforePain?: InputMaybe<Treatment_EfasSlider>;
  /**
   * 4: Do you have difficulty walking on uneven surfaces? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  walkingDifficultyOnEvenSurfaces?: InputMaybe<Treatment_EfasSlider>;
};

export type Input_Treatment_ElbowJointMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  flexionInPronation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  flexionInSupination?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_EpworthSleepinessScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  lyingDownInTheAfternoon?: InputMaybe<Treatment_EpsSelection>;
  oneHourRidingWithNoBreak?: InputMaybe<Treatment_EpsSelection>;
  score?: InputMaybe<Scalars['Int']>;
  sittingAndReading?: InputMaybe<Treatment_EpsSelection>;
  sittingAndTalking?: InputMaybe<Treatment_EpsSelection>;
  sittingInAPublicInactivePlace?: InputMaybe<Treatment_EpsSelection>;
  sittingQuietlyAfterLunch?: InputMaybe<Treatment_EpsSelection>;
  stoppedInTraffic?: InputMaybe<Treatment_EpsSelection>;
  watchingTelevision?: InputMaybe<Treatment_EpsSelection>;
};

export type Input_Treatment_ErectionBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  confidence?: InputMaybe<Treatment_ErectionConfidence>;
  difficulty?: InputMaybe<Treatment_ErectionDifficulty>;
  maintenance?: InputMaybe<Treatment_ErectionMaintenance>;
  satisfaction?: InputMaybe<Treatment_ErectionSatisfaction>;
  score?: InputMaybe<Scalars['Int']>;
  sufficiency?: InputMaybe<Treatment_ErectionSufficiency>;
};

export type Input_Treatment_ExcretoryGlandsMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ExecutiveFunctionsBlock = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_ExecutiveFunctionsDescriptionMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  luriaSequence?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  luriaSequenceText?: InputMaybe<Scalars['String']>;
  planningAndExecutionOfActivities?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_ExecutiveFunctionsDescriptionMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ExtendedBarthelIndexBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  comprehension?: InputMaybe<Treatment_Comprehension>;
  extendedBarthelIndexMemory?: InputMaybe<Treatment_ExtendedBarthelIndexMemory>;
  makingOneselfUnderstood?: InputMaybe<Treatment_MakingOneselfUnderstood>;
  problemSolving?: InputMaybe<Treatment_ProblemSolving>;
  score?: InputMaybe<Scalars['Int']>;
  socialInteraction?: InputMaybe<Treatment_SocialInteraction>;
  visionAndNeglect?: InputMaybe<Treatment_VisionAndNeglect>;
};

export type Input_Treatment_ExternalAllergenIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalAllergenIdType>;
};

export type Input_Treatment_ExternalMaterialBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ExternalSourceMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** can be patient id, contact id, external contact (e.g., clinic/practitioner) id */
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Treatment_ExternalSourceType>;
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ExternalVaccinationIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Knowledge_ExternalDrugPackageIdType>;
};

export type Input_Treatment_ExtrapyramidalMovementDisordersBlock = {
  extrapyramidalMovementDisorders?: InputMaybe<Scalars['Boolean']>;
  extrapyramidalMovementDisordersDescriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_ExtrapyramidalMovementDisordersMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ExtrapyramidalMovementDisordersMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ExtremitiesTemperatureBlock = {
  abnormalitiesExaminationResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FacetInfiltrationMsg = {
  cervicalSpineJoints?: InputMaybe<Input_Treatment_CervicalSpineJointsMsg>;
  cervicalSpineJointsPresent?: InputMaybe<Scalars['Boolean']>;
  headJoints?: InputMaybe<Input_Treatment_HeadJointsMsg>;
  headJointsPresent?: InputMaybe<Scalars['Boolean']>;
  imaging?: InputMaybe<Scalars['Boolean']>;
  lumbarSpineJoints?: InputMaybe<Input_Treatment_LumbarSpineJointsMsg>;
  lumbarSpineJointsPresent?: InputMaybe<Scalars['Boolean']>;
  others?: InputMaybe<Scalars['String']>;
  othersPresent?: InputMaybe<Scalars['Boolean']>;
  thoracicSpineJoints?: InputMaybe<Input_Treatment_ThoracicSpineJointsMsg>;
  thoracicSpineJointsPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_FacialSensitivityAndTrigeminalReflexesBlock = {
  aesthesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  aesthesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  aesthesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
  algesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  algesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  algesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
  facialSensitivity?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  kornealReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  kornealReflexText?: InputMaybe<Scalars['String']>;
  masseterReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  masseterReflexText?: InputMaybe<Scalars['String']>;
  palpationOfNerveExitPoints?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  palpationOfNerveExitPointsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FamilyStatusBlock = {
  familyStatus?: InputMaybe<Treatment_FamilyStatus>;
  numberBoys?: InputMaybe<Scalars['Int']>;
  numberGirls?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FastingPeriodsMsg = {
  duration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_FastingPeriodResolution>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FatigueAssessmentScaleBlock = {
  botheredByFatigue?: InputMaybe<Treatment_FasSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  energeticEveryday?: InputMaybe<Treatment_FasSelection>;
  lazyDuringDay?: InputMaybe<Treatment_FasSelection>;
  mentallyExhausted?: InputMaybe<Treatment_FasSelection>;
  noDesireToDoAnything?: InputMaybe<Treatment_FasSelection>;
  physicallyExhausted?: InputMaybe<Treatment_FasSelection>;
  problemsToThinkClearly?: InputMaybe<Treatment_FasSelection>;
  procrastination?: InputMaybe<Treatment_FasSelection>;
  quiteConcentration?: InputMaybe<Treatment_FasSelection>;
  score?: InputMaybe<Scalars['Int']>;
  tiredVeryQuickly?: InputMaybe<Treatment_FasSelection>;
};

export type Input_Treatment_FecalCollectorMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FeverBlock = {
  chillsPresent?: InputMaybe<Scalars['Boolean']>;
  chillsText?: InputMaybe<Scalars['String']>;
  daytimeDependencePresent?: InputMaybe<Scalars['Boolean']>;
  daytimeDependences?: InputMaybe<Array<InputMaybe<Treatment_DaytimeDependence>>>;
  feverCourseText?: InputMaybe<Scalars['String']>;
  feverCourses?: InputMaybe<Array<InputMaybe<Treatment_FeverCourse>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  sweatingPresent?: InputMaybe<Scalars['Boolean']>;
  sweatingText?: InputMaybe<Scalars['String']>;
  /** Temperature in celsius */
  temperature?: InputMaybe<Scalars['Float']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

/** Functional Independence Measure (FIM) */
export type Input_Treatment_FimBlock = {
  bathingShoweringWashing?: InputMaybe<Treatment_FimSelection>;
  bladderControl?: InputMaybe<Treatment_FimSelection>;
  bowelControl?: InputMaybe<Treatment_FimSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  dressingDownstairs?: InputMaybe<Treatment_FimSelection>;
  dressingUpstairs?: InputMaybe<Treatment_FimSelection>;
  eatingAndDrinking?: InputMaybe<Treatment_FimSelection>;
  /** Expression (making oneself understood) */
  expression?: InputMaybe<Treatment_FimSelection>;
  intimateHygiene?: InputMaybe<Treatment_FimSelection>;
  movementClimbingStairs?: InputMaybe<Treatment_FimSelection>;
  movementWalkingWheelchair?: InputMaybe<Treatment_FimSelection>;
  personalHygiene?: InputMaybe<Treatment_FimSelection>;
  problemSolvingSkills?: InputMaybe<Treatment_FimSelection>;
  score?: InputMaybe<Scalars['Int']>;
  /** Social Behavior */
  socialBehavior?: InputMaybe<Treatment_FimSelection>;
  transferBedChairWheelChair?: InputMaybe<Treatment_FimSelection>;
  transferShowerBath?: InputMaybe<Treatment_FimSelection>;
  transferToiletSeat?: InputMaybe<Treatment_FimSelection>;
  understanding?: InputMaybe<Treatment_FimSelection>;
};

export type Input_Treatment_FindDiagnosisActiveVersionRevisionsRequest = {
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_FindDiagnosisActiveVersionRevisionsResponse = {
  diagnosisCodingIdToLatestInfo?: InputMaybe<Array<InputMaybe<Input_Treatment_FindDiagnosisActiveVersionRevisionsResponse_DiagnosisCodingIdToLatestInfoEntry>>>;
};

export type Input_Treatment_FindDiagnosisActiveVersionRevisionsResponse_DiagnosisCodingIdToLatestInfoEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Treatment_DiagnosisCodingActivityInfoMsg>;
};

export type Input_Treatment_FindLatestAnamnesisBlockRequest = {
  pathKeys?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FindLatestAnamnesisBlockResponse = {
  anamnesisBlock?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_FindLatestPhysicalBlockRequest = {
  pathKeys?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FindLatestPhysicalBlockResponse = {
  exists?: InputMaybe<Scalars['Boolean']>;
  physicalBlock?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
};

export type Input_Treatment_FindLatestTreatmentsDetailsRequest = {
  /** optional filter */
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_FindLatestTreatmentsDetailsResponse = {
  visitIdToLastTreatmentDetails?: InputMaybe<Array<InputMaybe<Input_Treatment_FindLatestTreatmentsDetailsResponse_VisitIdToLastTreatmentDetailsEntry>>>;
};

export type Input_Treatment_FindLatestTreatmentsDetailsResponse_VisitIdToLastTreatmentDetailsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Treatment_TreatmentBasicInfoMsg>;
};

export type Input_Treatment_FingerJointsMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fingerAbduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  fingerAdduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  fingerExtension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  fingerFlexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
  littleFingerAbduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  thumbAbduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  thumbAdduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  thumbExtension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  thumbFlexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  thumbOpposition?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
};

export type Input_Treatment_FlowNoiseLowerExtremityBlock = {
  left?: InputMaybe<Input_Treatment_FlowNoiseLowerExtremityMsg>;
  right?: InputMaybe<Input_Treatment_FlowNoiseLowerExtremityMsg>;
};

export type Input_Treatment_FlowNoiseLowerExtremityMsg = {
  arteriaDorsalisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaDorsalisText?: InputMaybe<Scalars['String']>;
  arteriaFemoralisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaFemoralisText?: InputMaybe<Scalars['String']>;
  arteriaPopliteaFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaPopliteaText?: InputMaybe<Scalars['String']>;
  arteriaTibialisPosteriorFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaTibialisText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FlowNoiseUpperExtremityMsg = {
  arteriaBrachialisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaBrachialisText?: InputMaybe<Scalars['String']>;
  arteriaCarotisCommunisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaCarotisCommunisText?: InputMaybe<Scalars['String']>;
  arteriaRadialisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaRadialisText?: InputMaybe<Scalars['String']>;
  arteriaSubclaviaFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaSubclaviaText?: InputMaybe<Scalars['String']>;
  arteriaUlnarisFlowNoisePresent?: InputMaybe<Scalars['Boolean']>;
  arteriaUlnarisText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FlowNoisesUpperExtremityBlock = {
  left?: InputMaybe<Input_Treatment_FlowNoiseUpperExtremityMsg>;
  right?: InputMaybe<Input_Treatment_FlowNoiseUpperExtremityMsg>;
};

export type Input_Treatment_FluidBalanceConfigurationMsg = {
  /** The time of day for the start time of the first entry */
  offsetTimeOfDay?: InputMaybe<Input_TimeOfDayMsg>;
  /** Allows defining the period of every fluid balance entry, e.g. 8 HOURS */
  period?: InputMaybe<Scalars['Int']>;
  /** Only "HOURS" and "DAYS" are valid. TODO: For the demo "DAYS" with period > 1 are also not valid. */
  periodUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_FluidFlowBalanceMsg = {
  endTime?: InputMaybe<Input_Timestamp>;
  overall?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Input_Timestamp>;
  totalIn?: InputMaybe<Scalars['Int']>;
  totalOut?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_FluidFlowMsg = {
  flowDate?: InputMaybe<Input_Timestamp>;
  fluidFlowSystem?: InputMaybe<Input_Treatment_FluidFlowSystemBasicInfoMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inflowForms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  outflowForms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  /** Quantity in milliliters */
  quantity?: InputMaybe<Scalars['Int']>;
  stationaryVisitId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_FluidFlowType>;
  versionInfo?: InputMaybe<Input_Versioning_VersionInfoMsg>;
};

export type Input_Treatment_FluidFlowResultMsg = {
  /** The configuration on which the result is based */
  configuration?: InputMaybe<Input_Treatment_FluidBalanceConfigurationMsg>;
  configurationId?: InputMaybe<Scalars['String']>;
  configurationName?: InputMaybe<Scalars['String']>;
  defaultConfiguration?: InputMaybe<Scalars['Boolean']>;
  fluidFlowBalances?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowBalanceMsg>>>;
};

export type Input_Treatment_FluidFlowSystemBasicInfoMsg = {
  endDate?: InputMaybe<Input_Timestamp>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Treatment_FluidFlowSystemMetadataMsg>;
  startDate?: InputMaybe<Input_Timestamp>;
};

export type Input_Treatment_FluidFlowSystemDetailsMsg = {
  arteria?: InputMaybe<Input_Treatment_ArteriaMsg>;
  cvc?: InputMaybe<Input_Treatment_CvcMsg>;
  dialysisCatheter?: InputMaybe<Input_Treatment_DialysisCatheterMsg>;
  fecalCollector?: InputMaybe<Input_Treatment_FecalCollectorMsg>;
  gastricTube?: InputMaybe<Input_Treatment_GastricTubeMsg>;
  intraosseousAccess?: InputMaybe<Input_Treatment_IntraosseousAccessMsg>;
  mediastinalDrainage?: InputMaybe<Input_Treatment_MediastinalDrainageMsg>;
  namedFluidFlowSystem?: InputMaybe<Input_Treatment_NamedFluidFlowSystemMsg>;
  painCatheter?: InputMaybe<Input_Treatment_PainCatheterMsg>;
  peg?: InputMaybe<Input_Treatment_PegMsg>;
  pericardialDrainage?: InputMaybe<Input_Treatment_PericardialDrainageMsg>;
  peritonealCatheter?: InputMaybe<Input_Treatment_PeritonealCatheterMsg>;
  picc?: InputMaybe<Input_Treatment_PiCcMsg>;
  piv?: InputMaybe<Input_Treatment_PivMsg>;
  portCatheter?: InputMaybe<Input_Treatment_PortCatheterMsg>;
  renalFistulaCatheter?: InputMaybe<Input_Treatment_RenalFistulaCatheterMsg>;
  shunt?: InputMaybe<Input_Treatment_ShuntMsg>;
  thoraxDrainage?: InputMaybe<Input_Treatment_ThoraxDrainageMsg>;
  urinaryCatheter?: InputMaybe<Input_Treatment_UrinaryCatheterMsg>;
  vacuumTherapySystem?: InputMaybe<Input_Treatment_VacuumTherapySystemMsg>;
  ventricularDrainage?: InputMaybe<Input_Treatment_VentricularDrainageMsg>;
  woundDrainage?: InputMaybe<Input_Treatment_WoundDrainageMsg>;
};

export type Input_Treatment_FluidFlowSystemList = {
  fluidFlowSystems?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMsg>>>;
};

export type Input_Treatment_FluidFlowSystemMetadataMsg = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_FluidFlowSystemMsg = {
  details?: InputMaybe<Input_Treatment_FluidFlowSystemDetailsMsg>;
  endDate?: InputMaybe<Input_Timestamp>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Input_Treatment_FluidFlowSystemMetadataMsg>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Input_Timestamp>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  versionInfo?: InputMaybe<Input_Versioning_VersionInfoMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

/** repetition cycle */
export type Input_Treatment_FluidFlowSystemTimePeriodMsg = {
  duration?: InputMaybe<Scalars['Float']>;
  durationTimeUnit?: InputMaybe<TimeUnit>;
  offset?: InputMaybe<Scalars['Float']>;
  offsetTimeUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_ForceLevelsAndDetailsMsg = {
  forceAsymmetry?: InputMaybe<Treatment_ForceAsymmetry>;
  forceLeft?: InputMaybe<Scalars['Int']>;
  forceRight?: InputMaybe<Scalars['Int']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FrIndexMsg = {
  /** Behavioral disorder requiring supervision: <yes (-50) / no (0)> */
  behavioralDisorderRequiringSupervision?: InputMaybe<Scalars['Boolean']>;
  frIndexScore?: InputMaybe<Scalars['Int']>;
  /** Intensive care monitoring obligation: <yes (-50) / no (0)> */
  intensiveCareMonitoringObligation?: InputMaybe<Scalars['Boolean']>;
  /** Intermittent Ventilation: <yes (-50) / no (0)> */
  intermittentVentilation?: InputMaybe<Scalars['Boolean']>;
  /** Orientation disorder requiring supervision: <yes (-50) / no (0)> */
  orientationDisorderRequiringSupervision?: InputMaybe<Scalars['Boolean']>;
  /** Severe communication disorder: <yes (-50) / no (0)> */
  severeCommunicationDisorder?: InputMaybe<Scalars['Boolean']>;
  /** Swallowing disorder requiring supervision: <yes (-50) / no (0)> */
  swallowingDisorderRequiringSupervision?: InputMaybe<Scalars['Boolean']>;
  /** Tracheostoma requiring suction: <yes (-50) / no (0)> */
  tracheostomaRequiringSuction?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_FriedrichWeickmannScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  details?: InputMaybe<Scalars['String']>;
  scale?: InputMaybe<Treatment_FriedrichWeickmannScaleSelection>;
};

export type Input_Treatment_FtndBlock = {
  /** Which cigarette would you not want to do without: <the first one after waking up (1)/another one (0)> (singleselect) */
  cigaretteToDoWithout?: InputMaybe<Treatment_FtndCigaretteToDoWithout>;
  /** How many cigarettes do you smoke per day: <More than 30 (3) /21-30 (2) /11-20 (1) /10 or less (0)> (singleselect) */
  cigarettesPerDay?: InputMaybe<Treatment_FtndCigarettesPerDay>;
  completed?: InputMaybe<Scalars['Boolean']>;
  /** When do you smoke your first cigarette after waking up: <within 5 minutes (3)/within 6 to 30 minutes (2)/within 31 to 60 minutes (1)/it takes longer than 60 minutes (0)> (singleselect) */
  firstCigaretteTime?: InputMaybe<Treatment_FtndFirstCigaretteTime>;
  score?: InputMaybe<Scalars['Int']>;
  /** Do you find it difficult to refrain from smoking in places where smoking is prohibited (e.g. church, library, cinema, etc.): <yes (1) /no (0)> (singleselect) */
  smokeInProhibitedPlacesDifficulty?: InputMaybe<Scalars['Boolean']>;
  /** Do you generally smoke more in the first few hours after waking up than during the rest of the day: <yes (1) / no (0)> (singleselect) */
  smokeMoreInFirstHours?: InputMaybe<Scalars['Boolean']>;
  /** Do you smoke when you are ill and have to stay in bed during the day?: <yes (1) / no (0)> (singleselect) */
  smokeWhenIll?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_FunctionTestsHandMsg = {
  allenTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  allenTestText?: InputMaybe<Scalars['String']>;
  bottleSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  bottleSignText?: InputMaybe<Scalars['String']>;
  carpalCompressionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  carpalCompressionTestText?: InputMaybe<Scalars['String']>;
  finkelsteinSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  finkelsteinSignText?: InputMaybe<Scalars['String']>;
  fistClosure?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fistClosureText?: InputMaybe<Scalars['String']>;
  hoffmannTinelSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  hoffmannTinelSignText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  phalenSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  phalenSignText?: InputMaybe<Scalars['String']>;
  triggerFinger?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  triggerFingerText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FunctionTestsHipAndPelvicMsg = {
  drehmannsSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  drehmannsSignText?: InputMaybe<Scalars['String']>;
  faberTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  faberTestText?: InputMaybe<Scalars['String']>;
  faddirTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  faddirTestText?: InputMaybe<Scalars['String']>;
  hipImpingementTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  hipImpingementTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mennellsSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  mennellsSignText?: InputMaybe<Scalars['String']>;
  patricksTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  patricksTestText?: InputMaybe<Scalars['String']>;
  psoasSnappingTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  psoasSnappingTestText?: InputMaybe<Scalars['String']>;
  spineTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  spineTestText?: InputMaybe<Scalars['String']>;
  standingFlexionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  standingFlexionTestText?: InputMaybe<Scalars['String']>;
  thomasTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thomasTestText?: InputMaybe<Scalars['String']>;
  threeStageHyperextensionsTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  threeStageHyperextensionsTestText?: InputMaybe<Scalars['String']>;
  tractSnappingTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tractSnappingTestText?: InputMaybe<Scalars['String']>;
  trendelenburgsSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  trendelenburgsSignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FunctionalExaminationOfVestibularNerveBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  nystagmusAssessments?: InputMaybe<Array<InputMaybe<Input_Treatment_NystagmusAssessmentMsg>>>;
  vestibuloOcularReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_FurtherFunctionalTestsSpineBlock = {
  behindTheHeadWallDistance?: InputMaybe<Scalars['Float']>;
  behindTheHeadWallDistanceTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  chinSternumDistanceInclination?: InputMaybe<Scalars['Float']>;
  chinSternumDistanceReclination?: InputMaybe<Scalars['Float']>;
  chinSternumDistanceTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  thoracicCircumferenceDifference?: InputMaybe<Scalars['Float']>;
  thoracicCircumferenceDifferenceTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thoracicCircumferenceExpiration?: InputMaybe<Scalars['Float']>;
  thoracicCircumferenceInspiration?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_FurtherProceduresMsg = {
  id?: InputMaybe<Scalars['String']>;
  recommendations?: InputMaybe<Array<InputMaybe<Input_Treatment_ClinicalRecommendationMsg>>>;
};

export type Input_Treatment_FurtherShoulderFunctionTestsBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_FurtherShoulderFunctionTestsMsg>;
  right?: InputMaybe<Input_Treatment_FurtherShoulderFunctionTestsMsg>;
};

export type Input_Treatment_FurtherShoulderFunctionTestsMsg = {
  anteriorApprehensionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorApprehensionTestText?: InputMaybe<Scalars['String']>;
  crossBodyTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  crossBodyTestText?: InputMaybe<Scalars['String']>;
  frontDrawer?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  frontDrawerText?: InputMaybe<Scalars['String']>;
  hawkinsKennedyTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  hawkinsKennedyTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  infraspinatusTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  infraspinatusTestText?: InputMaybe<Scalars['String']>;
  neerTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  neerTestText?: InputMaybe<Scalars['String']>;
  oBrienTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  oBrienTestText?: InputMaybe<Scalars['String']>;
  palmUpTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  palmUpTestText?: InputMaybe<Scalars['String']>;
  posteriorApprehensionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  posteriorApprehensionTestText?: InputMaybe<Scalars['String']>;
  rearDrawer?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  rearDrawerText?: InputMaybe<Scalars['String']>;
  speedTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  speedTestText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GaitBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  gait?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  heelWalking?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  heelWalkingText?: InputMaybe<Scalars['String']>;
  normalWalkingAndTurning?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  normalWalkingAndTurningDescriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_GaitDescriptionMsg>>>;
  tightropeWalking?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tightropeWalkingText?: InputMaybe<Scalars['String']>;
  toeWalking?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  toeWalkingText?: InputMaybe<Scalars['String']>;
  /** The unity of the walking distance is the meter (m). */
  walkingDistance?: InputMaybe<Scalars['Int']>;
  walkingDistanceText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GaitDescriptionMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GaitTestMsg = {
  initiationOfGait?: InputMaybe<Treatment_InitiationOfGait>;
  /** <yes (1) / no (0)> */
  leftFootCompletelyLeavesTheGroundWhileWalking?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  leftFootPassesRightStanceFoot?: InputMaybe<Scalars['Boolean']>;
  path?: InputMaybe<Treatment_Path>;
  /** <yes (1) / no (0)> */
  rightAndLeftStepsAppearToBeOfEqualLength?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  rightFootCompletelyLeavesTheGroundWhileWalking?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  rightFootPassesLeftStanceFoot?: InputMaybe<Scalars['Boolean']>;
  stepContinually?: InputMaybe<Treatment_StepContinually>;
  trunk?: InputMaybe<Treatment_Trunk>;
  walkingStance?: InputMaybe<Treatment_WalkingStance>;
};

export type Input_Treatment_GallBladderSignsBlock = {
  courvoisiersSignPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  murphysSignPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_GastricTubeMsg = {
  length?: InputMaybe<Scalars['Float']>;
  lengthUnit?: InputMaybe<Treatment_FlowSystemLengthUnit>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  materials?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  numberOfLumen?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_GastrointestinalDysfunctionBlock = {
  abdominalCramps?: InputMaybe<Scalars['Boolean']>;
  abdominalGirthIncrease?: InputMaybe<Scalars['Boolean']>;
  abdominalPain?: InputMaybe<Input_Treatment_AbdominalPainMsg>;
  abdominalPainPresent?: InputMaybe<Scalars['Boolean']>;
  digestiveComplaints?: InputMaybe<Scalars['Boolean']>;
  flatulence?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  heartburnPresent?: InputMaybe<Scalars['Boolean']>;
  heartburnText?: InputMaybe<Scalars['String']>;
  ingestionAspirationPresent?: InputMaybe<Scalars['Boolean']>;
  nauseaPresent?: InputMaybe<Scalars['Boolean']>;
  nauseaText?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  regurgitationOnset?: InputMaybe<Treatment_RegurgitationOnset>;
  regurgitationPresent?: InputMaybe<Scalars['Boolean']>;
  stoolDescription?: InputMaybe<Input_Treatment_StoolDescriptionMsg>;
  stoolDescriptionPresent?: InputMaybe<Scalars['Boolean']>;
  swallowingDifficultyPresent?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  vomitingPresent?: InputMaybe<Scalars['Boolean']>;
  vomitingText?: InputMaybe<Scalars['String']>;
  /** in kg */
  weightGain?: InputMaybe<Scalars['Float']>;
  weightIncrease?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_GeneralAnesthesiaMsg = {
  airwayAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  airwayManagements?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  anesthesiaSystems?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  blockage?: InputMaybe<Scalars['Boolean']>;
  /** unit: cmH2O */
  bronchialCuffPressure?: InputMaybe<Scalars['Int']>;
  canPerformWithoutAnesthesia?: InputMaybe<Scalars['Boolean']>;
  cormackLehaneClassification?: InputMaybe<Treatment_CormackLehaneClassification>;
  /** one decimal; unit: cm */
  depth?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intubationAccess?: InputMaybe<Treatment_IntubationAccess>;
  intubationText?: InputMaybe<Scalars['String']>;
  maskVentilations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  narcoticApplication?: InputMaybe<Treatment_NarcoticApplication>;
  patientIntubated?: InputMaybe<Scalars['Boolean']>;
  preoxygenation?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  rapidSequenceInduction?: InputMaybe<Scalars['Boolean']>;
  /** one-decimal; unit: <mm / Charr> */
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_GeneralAnesthesiaSizeUnit>;
  /** unit: cmH2O */
  trachealCuffPressure?: InputMaybe<Scalars['Int']>;
  tubeTypes?: InputMaybe<Array<InputMaybe<Input_Treatment_GeneralAnesthesiaTubeTypeMsg>>>;
  types?: InputMaybe<Array<InputMaybe<Treatment_GeneralAnesthesiaType>>>;
  ventilationTypes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_GeneralAnesthesiaTubeTypeMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  hasBronchialCuffPressure?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GeneralConditionBlock = {
  generalCondition?: InputMaybe<Treatment_GeneralConditionType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GeneralFindingsBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GeriatricDepressionScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Do you think you have more difficulty with memory than other people?: < yes (1) / no (0)> */
  difficultyWithMemory?: InputMaybe<Scalars['Boolean']>;
  /** Are you afraid that something bad will happen to you?: < yes (1) / no (0)> */
  fearFromFuture?: InputMaybe<Scalars['Boolean']>;
  /** Do you often feel bored?: < yes (1) / no (0)> */
  feelsBored?: InputMaybe<Scalars['Boolean']>;
  /** Do you feel full of energy?: < yes (0) / no (1)> */
  feelsFullOfEnergy?: InputMaybe<Scalars['Boolean']>;
  /** Do you feel happy most of the time?: < yes (0) / no (1)> */
  feelsHappy?: InputMaybe<Scalars['Boolean']>;
  /** Do you often feel helpless?: < yes (1) / no (0)> */
  feelsHelpless?: InputMaybe<Scalars['Boolean']>;
  /** Do you think most other people have it better than you?: < yes (1) / no (0)> */
  feelsOtherPeopleAreBetter?: InputMaybe<Scalars['Boolean']>;
  /** Do you feel that your situation is hopeless?: < yes (1) / no (0)> */
  feelsSituationIsHopeless?: InputMaybe<Scalars['Boolean']>;
  /** Do you feel pretty worthless in your current state?: < yes (1) / no (0)> */
  feelsWorthless?: InputMaybe<Scalars['Boolean']>;
  /** Have you given up many of your activities and interests?: < yes (1) / no (0)> */
  giveUpInterests?: InputMaybe<Scalars['Boolean']>;
  /** Are you in a good mood most of the time?: < yes (0) / no (1)> */
  inGoodMood?: InputMaybe<Scalars['Boolean']>;
  /** Do you feel like your life is empty?: < yes (1) / no (0)> */
  lifeEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Are you basically satisfied with your life?: < yes (0) / no (1)> */
  lifeSatisfaction?: InputMaybe<Scalars['Boolean']>;
  /** Do you prefer to be at home instead of going out and doing something?: < yes (1) / no (0)> */
  preferIndoorsActivities?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** Do you think it is nice to be alive now?: < yes (0) / no (1)> */
  wantsToBeAlive?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_GetAnamnesisBlockRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  blockId?: InputMaybe<Scalars['String']>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  fieldMask?: InputMaybe<Input_FieldMask>;
  owningCardId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_GetAnamnesisCardAnamnesticProgressRequest = {
  anamnesticProgressId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardAnesthesiaBackgroundRequest = {
  anesthesiaBackgroundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardReasonForAdmissionRequest = {
  reasonForAdmissionId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardReasonForCareAdmissionRequest = {
  reasonForCareAdmissionId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardReasonRequest = {
  appointmentId?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardSurgeryPreparationRequest = {
  surgeryPreparationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetAnamnesisCardTemplateRequest = {
  cardNumber?: InputMaybe<Scalars['Int']>;
  /** For the latest card template of the organizational unit */
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** For the card template of a specific treatment */
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
};

export type Input_Treatment_GetAnamnesisRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetChecklistRequest = {
  checklistId?: InputMaybe<Scalars['String']>;
  compositeId?: InputMaybe<Input_Treatment_CompositeChecklistIdMsg>;
};

export type Input_Treatment_GetCommitRequest = {
  commitId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetDefaultFluidBalanceConfigurationRequest = {
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_Treatment_GetDiagnosesRequest = {
  diagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_GetDiagnosisCodingsRequest = {
  diagnosisCodingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetDiagnosisLatestRevisionsRequest = {
  revisionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetDiagnosisLatestRevisionsResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_GetFluidFlowSystemMetadataRequest = {
  detailsNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** optional for setting the description as a name with a specific language */
  language?: InputMaybe<Core_Language>;
};

export type Input_Treatment_GetFluidFlowSystemMetadataResponse = {
  metadataList?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMetadataMsg>>>;
};

export type Input_Treatment_GetFluidFlowSystemsRequest = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetFurtherProceduresRequest = {
  procedureId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetLatestPractitionerRequest = {
  administrativeUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** Finds the latest before this timestamp */
  latestTime?: InputMaybe<Input_Timestamp>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetLatestPractitionerResponse = {
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetLatestTreatmentStatusInfoRequest = {
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetLatestTreatmentStatusInfoResponse = {
  statusInfo?: InputMaybe<Array<InputMaybe<Input_Treatment_TreatmentStatusInfoMsg>>>;
};

export type Input_Treatment_GetLatestWoundVersionRequest = {
  woundVersionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetLatestWoundVersionsRequest = {
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetPhysicalBlockRequest = {
  blockId?: InputMaybe<Scalars['String']>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  fieldMask?: InputMaybe<Input_FieldMask>;
  physicalId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_GetPhysicalDefaultPathRequest = {
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetPhysicalExaminationRequest = {
  fieldMask?: InputMaybe<Input_FieldMask>;
  physicalExaminationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetProblemSpecificAnamnesisCardRequest = {
  cardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetProblemSpecificCardsMetadataRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetSymptomConfigurationRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetTherapyCardMetadataListRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['Boolean']>;
  /**
   * if empty, don't filter by tag
   *  if card metadata has one of these filters we have it in the response.
   */
  tags?: InputMaybe<Array<InputMaybe<Treatment_TherapyCardMetadataTag>>>;
  therapyId?: InputMaybe<Scalars['String']>;
  therapyTemplateId?: InputMaybe<Scalars['String']>;
  /** should be set if organizationalUnitId is set. */
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
};

export type Input_Treatment_GetTherapyCardMetadataListResponse = {
  elements?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardMetadataListElementMsg>>>;
};

export type Input_Treatment_GetTherapyCardRequest = {
  therapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetTherapyRequest = {
  therapyId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetTreatmentDetailsRequest = {
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetTreatmentRequest = {
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GetTreatmentTypesRequest = {
  physicalExaminationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_GetTreatmentTypesResponse = {
  treatmentTypes?: InputMaybe<Array<InputMaybe<Input_Treatment_GetTreatmentTypesResponseEntry>>>;
};

export type Input_Treatment_GetTreatmentTypesResponseEntry = {
  physicalExaminationId?: InputMaybe<Scalars['String']>;
  treatmentTypeMsg?: InputMaybe<Input_Treatment_TreatmentTypeMsg>;
};

export type Input_Treatment_GetWoundHistoryRequest = {
  versionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_GlasgowComaScaleBlock = {
  eyeResponse?: InputMaybe<Treatment_EyeResponseType>;
  gcsScore?: InputMaybe<Scalars['Int']>;
  motorResponse?: InputMaybe<Treatment_MotorResponseType>;
  verbalResponse?: InputMaybe<Treatment_VerbalResponseType>;
};

export type Input_Treatment_GlasgowComaScaleScoreBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  eyeResponse?: InputMaybe<Treatment_EyeResponseType>;
  motorResponse?: InputMaybe<Treatment_MotorResponseType>;
  score?: InputMaybe<Scalars['Int']>;
  verbalResponse?: InputMaybe<Treatment_VerbalResponseType>;
};

export type Input_Treatment_GlobalAssessmentOfFunctioningBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  /** non-negative integers from 1-100; unit: % */
  globalAssessmentOfFunctioning?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_GoalAttainmentScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  goalA?: InputMaybe<Scalars['String']>;
  goalB?: InputMaybe<Scalars['String']>;
  goalC?: InputMaybe<Scalars['String']>;
  goalD?: InputMaybe<Scalars['String']>;
  goalDegreeOfAchievementA?: InputMaybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementB?: InputMaybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementC?: InputMaybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementD?: InputMaybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementE?: InputMaybe<Treatment_GoalDegreeOfAchievement>;
  goalE?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HairScalpInspectionBlock = {
  erythema?: InputMaybe<Scalars['Boolean']>;
  erythemaText?: InputMaybe<Scalars['String']>;
  hairDensityReduction?: InputMaybe<Scalars['Boolean']>;
  hairDensityReductionText?: InputMaybe<Scalars['String']>;
  partingHairBorderLeft?: InputMaybe<Scalars['Float']>;
  partingHairBorderMiddle?: InputMaybe<Scalars['Float']>;
  partingHairBorderRight?: InputMaybe<Scalars['Float']>;
  pustules?: InputMaybe<Scalars['Boolean']>;
  pustulesText?: InputMaybe<Scalars['String']>;
  scaling?: InputMaybe<Scalars['Boolean']>;
  scalingText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HairScalpPalpationBlock = {
  epilationBorderArea?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  epilationBorderAreaText?: InputMaybe<Scalars['String']>;
  epilationDiffuseScalp?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  epilationDiffuseScalpText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HandFunctionTestsBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_FunctionTestsHandMsg>;
  right?: InputMaybe<Input_Treatment_FunctionTestsHandMsg>;
};

export type Input_Treatment_HasBledBlock = {
  /** yes (1) / no (0) */
  abnormalLiverFunction?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  abnormalRenalFunction?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  ageGreaterThan65?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  alcoholAbuse?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  bleedingTendency?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  concomitantAntiplateletAgents?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  hypertension?: InputMaybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  labileINsInPatientTakingWarfarin?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** yes (1) / no (0) */
  stroke?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_HeadAndNeckLymphNodesBlock = {
  abnormalitiesPresent?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export type Input_Treatment_HeadAndNeckMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  id?: InputMaybe<Scalars['String']>;
  inclination?: InputMaybe<Input_Treatment_SingleForceLevelAndDetailsMsg>;
  reclination?: InputMaybe<Input_Treatment_SingleForceLevelAndDetailsMsg>;
  rotation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
};

export type Input_Treatment_HeadAndNeckPasiMsg = {
  headAndNeckBodyRegionPercentage?: InputMaybe<Treatment_BodyRegionPercentage>;
  headAndNeckDiscoloration?: InputMaybe<Treatment_PasiSelection>;
  headAndNeckScaling?: InputMaybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.1> */
  headAndNeckScore?: InputMaybe<Scalars['Float']>;
  headAndNeckThickness?: InputMaybe<Treatment_PasiSelection>;
};

export type Input_Treatment_HeadJointsMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HeadSalivaryGlandsBlock = {
  abnormalitiesResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  abnormalitiesResultText?: InputMaybe<Scalars['String']>;
  excretoryGlands?: InputMaybe<Array<InputMaybe<Input_Treatment_ExcretoryGlandsMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HearingBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  gelleTestLeft?: InputMaybe<Scalars['Boolean']>;
  gelleTestLeftText?: InputMaybe<Scalars['String']>;
  gelleTestRight?: InputMaybe<Scalars['Boolean']>;
  gelleTestRightText?: InputMaybe<Scalars['String']>;
  leftAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  leftAbnormalitiesText?: InputMaybe<Scalars['String']>;
  rightAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  rightAbnormalitiesText?: InputMaybe<Scalars['String']>;
  rinneTestLeft?: InputMaybe<Scalars['Boolean']>;
  rinneTestLeftText?: InputMaybe<Scalars['String']>;
  rinneTestRight?: InputMaybe<Scalars['Boolean']>;
  rinneTestRightText?: InputMaybe<Scalars['String']>;
  simpleHearingTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  weberTest?: InputMaybe<Treatment_WeberTestResultType>;
  weberTestText?: InputMaybe<Scalars['String']>;
  whisperedSpeechTestLeft?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  whisperedSpeechTestLeftText?: InputMaybe<Scalars['String']>;
  whisperedSpeechTestRight?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  whisperedSpeechTestRightText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HeartMurmursBlock = {
  heartMurmurs?: InputMaybe<Array<InputMaybe<Input_Treatment_HeartMurmursMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_HeartMurmursMsg = {
  conductionPresent?: InputMaybe<Scalars['Boolean']>;
  conductions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  punctumMaximum?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  timeCourses?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** Sound volume in volume/6 (1/6 ... 6/6) without unit */
  timePoints?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  tonalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  volume?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_HeartRateBlock = {
  heartFrequency?: InputMaybe<Scalars['Int']>;
  heartRate?: InputMaybe<Treatment_HeartRateType>;
};

export type Input_Treatment_HeartSoundBlock = {
  heartRhythm?: InputMaybe<Treatment_HeartRhythmType>;
  heartSound?: InputMaybe<Treatment_HeartSoundType>;
  heartSoundFeatures?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  specialTones?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HematomaMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

/** Hendrich Fall Risk for BAss */
export type Input_Treatment_HendrichBassBlock = {
  alteredElimination?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confusionOrDisorientation?: InputMaybe<Scalars['Boolean']>;
  depression?: InputMaybe<Scalars['Boolean']>;
  dizzinessOrVertigo?: InputMaybe<Scalars['Boolean']>;
  nonAdaptiveMobilityOrGeneralizedWeakness?: InputMaybe<Scalars['Boolean']>;
  recentHistoryOfFalls?: InputMaybe<Scalars['Boolean']>;
  /** automatic computation of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
};

/** Hendrich Fall Risk */
export type Input_Treatment_HendrichBlock = {
  alteredElimination?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confusionOrDisorientation?: InputMaybe<Scalars['Boolean']>;
  depression?: InputMaybe<Scalars['Boolean']>;
  dizzinessOrVertigo?: InputMaybe<Scalars['Boolean']>;
  nonAdaptiveMobilityOrGeneralizedWeakness?: InputMaybe<Scalars['Boolean']>;
  primaryCancerDiagnosis?: InputMaybe<Scalars['Boolean']>;
  recentHistoryOfFalls?: InputMaybe<Scalars['Boolean']>;
  /** automatic computation of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_HereditaryKidneyTumorBlock = {
  /** Bilateral tumor: <yes (0.5) / no (0)> (singleselect) */
  bilateralTumor?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Dermatology Leiomyoma or fibrofollicucoma/enoral fibroma/nail fold fibroma/angiofibroma: <yes (1) / no (0)> (singleselect) */
  dermatologyLeiomyoma?: InputMaybe<Scalars['Boolean']>;
  /** Age at initial diagnosis < 45 years: <yes (1.5) / no (0)> (singleselect) */
  diagnosisBeforeFortyFive?: InputMaybe<Scalars['Boolean']>;
  /** GIST: <yes (1) / no (0)> (singleselect) */
  gist?: InputMaybe<Scalars['Boolean']>;
  /** Hemangioblastoma retina/CNS, childhood seizures: <yes (1) / no (0)> (singleselect) */
  hemangioblastoma?: InputMaybe<Scalars['Boolean']>;
  /** Multifocal tumor (non-papillary in terminal NI): <yes (1) / no (0)> (singleselect) */
  multifocalTumor?: InputMaybe<Scalars['Boolean']>;
  /** Non-clear cell RCC: <yes (1) / no (0)> (singleselect) */
  nonclearCellRcc?: InputMaybe<Scalars['Boolean']>;
  /** Phaeochromocytoma/paraganglion: <yes (1) / no (0)> (singleselect) */
  phaeochromocytoma?: InputMaybe<Scalars['Boolean']>;
  /** Pulmonary cysts, recurrent pneumathoraces, lympangioleiomyomatosis: <yes (1) / no (0)> (singleselect) */
  pulmonaryCysts?: InputMaybe<Scalars['Boolean']>;
  /** Positive family history for RCC-associated tumor syndromes?: <yes (1.5) / no (0)> (singleselect) */
  rccSyndromesInFamily?: InputMaybe<Scalars['Boolean']>;
  /** Renal tumor in the family 1st/2nd degree of kinship: <yes (1.5) / no (0)> (singleselect) */
  renalTumorInFamily?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Float']>;
  /** Uterus with multiple leiomyomas or fibroid tumors (aged <30 years): <yes (1.5) / no (0)> (singleselect) */
  uterusLeiomyomas?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_HerniaBlock = {
  hernias?: InputMaybe<Array<InputMaybe<Input_Treatment_HerniaMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_HerniaMsg = {
  bowelSoundsPresent?: InputMaybe<Scalars['Boolean']>;
  herniaType?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  palpable?: InputMaybe<Scalars['Boolean']>;
  reponible?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_HipAndPelvicFunctionTestsBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_FunctionTestsHipAndPelvicMsg>;
  right?: InputMaybe<Input_Treatment_FunctionTestsHipAndPelvicMsg>;
};

export type Input_Treatment_HipJointMsg = {
  abduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  adduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_HousingSituationMsg = {
  bathroom?: InputMaybe<Treatment_Bathroom>;
  comfort?: InputMaybe<Treatment_Comfort>;
  heating?: InputMaybe<Treatment_Heating>;
  housingSituationScore?: InputMaybe<Scalars['Int']>;
  housingSituationStairs?: InputMaybe<Treatment_HousingSituationStairs>;
  lengthOfResidence?: InputMaybe<Treatment_LengthOfResidence>;
  lighting?: InputMaybe<Treatment_Lighting>;
  localTransport?: InputMaybe<Treatment_LocalTransport>;
  satisfactionWithHousingCondition?: InputMaybe<Treatment_SatisfactionWithHousingSituation>;
  shopping?: InputMaybe<Treatment_Shopping>;
  telephone?: InputMaybe<Treatment_Telephone>;
  water?: InputMaybe<Treatment_Water>;
};

export type Input_Treatment_HypopharynxMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

/** Instrumental activities of daily living (IADL) */
export type Input_Treatment_IadlBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  iadlCooking?: InputMaybe<Treatment_IadlCooking>;
  iadlFunction?: InputMaybe<Treatment_IadlFunction>;
  iadlHousehold?: InputMaybe<Treatment_IadlHousehold>;
  iadlLaundry?: InputMaybe<Treatment_IadlLaundry>;
  iadlMedication?: InputMaybe<Treatment_IadlMedication>;
  iadlMoneyTransactions?: InputMaybe<Treatment_IadlMoneyTransactions>;
  iadlShopping?: InputMaybe<Treatment_IadlShopping>;
  iadlTransportation?: InputMaybe<Treatment_IadlTransportation>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_IcdscBlock = {
  /** < yes (1) / no (0)> */
  agitationOrSlowness?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  changedConsciousness?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  disorientation?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  fluctuatingSymptoms?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  hallucination?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  inadequateSpeechOrDisposition?: InputMaybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  inattention?: InputMaybe<Scalars['Boolean']>;
  /** Automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** < yes (1) / no (0)> */
  sleepDisturbance?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_IllusionsBlock = {
  auditoryHallucinations?: InputMaybe<Scalars['Boolean']>;
  auditoryHallucinationsDescriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  auditoryHallucinationsText?: InputMaybe<Scalars['String']>;
  bodyHallucinations?: InputMaybe<Scalars['Boolean']>;
  bodyHallucinationsText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  hallucinations?: InputMaybe<Scalars['Boolean']>;
  hypnagogicHallucinations?: InputMaybe<Scalars['Boolean']>;
  hypnagogicHallucinationsText?: InputMaybe<Scalars['String']>;
  illusions?: InputMaybe<Scalars['Boolean']>;
  illusoryMisperceptions?: InputMaybe<Scalars['Boolean']>;
  illusoryMisperceptionsText?: InputMaybe<Scalars['String']>;
  metamorphosia?: InputMaybe<Scalars['Boolean']>;
  metamorphosiaText?: InputMaybe<Scalars['String']>;
  olfactoryAndGustatoryHallucinations?: InputMaybe<Scalars['Boolean']>;
  olfactoryAndGustatoryHallucinationsText?: InputMaybe<Scalars['String']>;
  pseudoHallucinations?: InputMaybe<Scalars['Boolean']>;
  pseudoHallucinationsText?: InputMaybe<Scalars['String']>;
  visualHallucinations?: InputMaybe<Scalars['Boolean']>;
  visualHallucinationsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ImmunityTestList = {
  immunityTests?: InputMaybe<Array<InputMaybe<Input_Treatment_ImmunityTestMsg>>>;
};

/** A test administered to determine whether an immunity against a given disease already exists. */
export type Input_Treatment_ImmunityTestMsg = {
  examinationDate?: InputMaybe<Input_Timestamp>;
  externalInformationDetails?: InputMaybe<Input_Treatment_ExternalSourceMsg>;
  id?: InputMaybe<Scalars['String']>;
  immune?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  /** False if test was administered externally */
  primarySource?: InputMaybe<Scalars['Boolean']>;
  registeringUserId?: InputMaybe<Scalars['String']>;
  /** Disease at which the test is aimed */
  testTypeId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_ImportDiagnosisRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
  /** True if import as primary diagnosis, false if import as secondary diagnosis */
  primaryDiagnosis?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ImportDiagnosisResponse = {
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_ImportSymptomConfigurationRequest = {
  /** The following three fields are optional, if they don't exist, they will be taken from symptom configuration */
  patientId?: InputMaybe<Scalars['String']>;
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ImportSymptomConfigurationsRequest = {
  /** must match the patientId of the provided symptomOccurrences */
  patientId?: InputMaybe<Scalars['String']>;
  symptomOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ImportSymptomConfigurationsResponse = {
  configurations?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationMsg>>>;
};

export type Input_Treatment_IncontinenceBlock = {
  amount?: InputMaybe<Treatment_IncontinenceAmount>;
  completed?: InputMaybe<Scalars['Boolean']>;
  /** if “Incontinence pads” is selected: */
  dayIncontinencePadCount?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<Treatment_IncontinenceFrequency>;
  incontinenceOccasions?: InputMaybe<Array<InputMaybe<Treatment_IncontinenceOccasion>>>;
  /** if “Incontinence pads” is selected: */
  nightIncontinencePadCount?: InputMaybe<Scalars['Int']>;
  padStatus?: InputMaybe<Treatment_IncontinencePadStatus>;
  score?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Treatment_IncontinenceSeverity>;
};

export type Input_Treatment_InguinalLymphNodesBlock = {
  abnormalitiesPresent?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export type Input_Treatment_InnerNoseMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  nasalCavity?: InputMaybe<Input_Treatment_NasalCavityMsg>;
  nasalVestibule?: InputMaybe<Input_Treatment_NasalVestibuleMsg>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_InspectionOfTheMusculatureAndMuscleTrophicsBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  inspectionOfTheMusculatureAndMuscleTrophics?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_IntraosseousAccessMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_IpssBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  delayUrinationDifficulty?: InputMaybe<Treatment_IpssDelayUrinationDifficulty>;
  incompleteEmptying?: InputMaybe<Treatment_IpssIncompleteEmptying>;
  nightUrination?: InputMaybe<Treatment_IpssNightUrination>;
  repeatUrination?: InputMaybe<Treatment_IpssRepeatUrination>;
  restartUrination?: InputMaybe<Treatment_IpssRestartUrination>;
  score?: InputMaybe<Scalars['Int']>;
  strain?: InputMaybe<Treatment_IpssStrain>;
  weakStream?: InputMaybe<Treatment_IpssWeakStream>;
};

export type Input_Treatment_IsarScreeningBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  hospitalizedInPastSixMonths?: InputMaybe<Scalars['Boolean']>;
  memoryProblems?: InputMaybe<Scalars['Boolean']>;
  needHelpAfterIllness?: InputMaybe<Scalars['Boolean']>;
  needHelpBeforeIllness?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  sightProblems?: InputMaybe<Scalars['Boolean']>;
  takeMoreMedicationsDaily?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ItchBlock = {
  daytimeDependence?: InputMaybe<Treatment_DaytimeDependence>;
  daytimeDependencePresent?: InputMaybe<Scalars['Boolean']>;
  itchClassification?: InputMaybe<Treatment_ItchClassification>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
  severity?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_JugularVeinsInspectionBlock = {
  jugularVeinPressure?: InputMaybe<Scalars['Float']>;
  jugularVeinPressureText?: InputMaybe<Scalars['String']>;
  jugularVeinsType?: InputMaybe<Treatment_JugularVeinsType>;
  jugularVeinsTypeText?: InputMaybe<Scalars['String']>;
  pulseWavesType?: InputMaybe<Treatment_PathologicalExaminationResult>;
  pulseWavesTypeText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_KarnofskyIndexBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  indexSelection?: InputMaybe<Treatment_IndexSelection>;
};

export type Input_Treatment_KellgrenLawrenceBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  grade?: InputMaybe<Treatment_KellgrenLawrenceGrade>;
};

export type Input_Treatment_KidneyPainOnPercussionBlock = {
  painOnPercussionPresent?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_KneeJointMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LachsGeriatricScreeningBlock = {
  /** true -> conspicuous , false -> inconspicuous */
  activity?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  arms?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  bladderContinence?: InputMaybe<Scalars['Boolean']>;
  /** 8a: Cognitive status. true -> conspicuous , false -> inconspicuous */
  cognitiveStatusFirstScreening?: InputMaybe<Scalars['Boolean']>;
  /** 8b: Cognitive status. // true -> conspicuous , false -> inconspicuous */
  cognitiveStatusSecondScreening?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  depression?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  fallInLastMonth?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  fecalContinence?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  generalRisk?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  hearing?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  legs?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  nutrition?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** true -> conspicuous , false -> inconspicuous */
  seeing?: InputMaybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  socialSupport?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  sufferingFromFrequentPain?: InputMaybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  takingMoreThanFiveMedications?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_LaryngoscopyIndicationMsg = {
  text?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Treatment_LaryngoscopyIndicationTiming>;
};

export type Input_Treatment_LaryngoscopyMsg = {
  assessment?: InputMaybe<Scalars['String']>;
  evaluationOfSwallowing?: InputMaybe<Scalars['String']>;
  evaluationOfSwallowingPresent?: InputMaybe<Scalars['Boolean']>;
  floatingOrSupportedLaryngoscopy?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageSeriesId?: InputMaybe<Scalars['String']>;
  indication?: InputMaybe<Input_Treatment_LaryngoscopyIndicationMsg>;
  /** TODO add billing */
  localizedDiagnosisDetails?: InputMaybe<Array<InputMaybe<Input_Treatment_LocalizedDiagnosisDetailMsg>>>;
  microlaryngoscopy?: InputMaybe<Scalars['Boolean']>;
  technique?: InputMaybe<Treatment_LaryngoscopyTechnique>;
  vocalCordCompletelyMobile?: InputMaybe<Scalars['Boolean']>;
  vocalCordImmobilityDetails?: InputMaybe<Input_Treatment_VocalCordImmobilityDetailsMsg>;
};

export type Input_Treatment_LarynxHypopharynxInspectionBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  hypopharynx?: InputMaybe<Array<InputMaybe<Input_Treatment_HypopharynxMsg>>>;
  hypopharynxResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  hypopharynxResultText?: InputMaybe<Scalars['String']>;
  larynx?: InputMaybe<Array<InputMaybe<Input_Treatment_LarynxMsg>>>;
  larynxResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  larynxResultText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LarynxMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_LightSensitivityBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LimbCircumferenceDifferenceBlock = {
  armCircumferenceDifferencePresent?: InputMaybe<Scalars['Boolean']>;
  armCircumferenceDifferenceText?: InputMaybe<Scalars['String']>;
  legCircumferenceDifferencePresent?: InputMaybe<Scalars['Boolean']>;
  legCircumferenceDifferenceText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListActivePatientsDiagnosesRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whitelistedIcd10Prefixes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListAllergiesRequest = {
  includeNotYetActive?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListAnamensisBlockMetadataResponse = {
  anamnesisBlockMetadataList?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMetadataMsg>>>;
};

export type Input_Treatment_ListAnamnesesRequest = {
  anamnesisIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  /** TODO why treatment id? */
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListAnamnesisBlockHistoryRequest = {
  pathKey?: InputMaybe<Input_Treatment_PathKeyMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListAnamnesisBlockHistoryResponse = {
  anamnesisBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
};

export type Input_Treatment_ListAnamnesisBlockMetadataRequest = {
  /** optional for setting the description as a name with a specific language */
  language?: InputMaybe<Core_Language>;
  tag?: InputMaybe<Treatment_AnamnesisBlockMetadataTag>;
};

export type Input_Treatment_ListAnamnesisBlocksResponse = {
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
};

export type Input_Treatment_ListAnamnesisHistoryRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListAnamnesisHistoryResponse = {
  anamneses?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisMsg>>>;
};

export type Input_Treatment_ListAnamnesisScoresRequest = {
  /** If set to true, blockNumbers will be ignored and all score blocks will be returned */
  allScores?: InputMaybe<Scalars['Boolean']>;
  blockNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Optional, used for alphabetical ordering (default is German) */
  locale?: InputMaybe<Core_Language>;
  /** Optional filter */
  medicalItemStatuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  surgeryId?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListAnamnesisScoresResponse = {
  blockContentScores?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockContentScoreMsg>>>;
};

export type Input_Treatment_ListClinicalRecommendationsRequest = {
  dischargeId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListCurrentSymptomConfigurationsRequest = {
  /** mandatory, required for versioning */
  patientId?: InputMaybe<Scalars['String']>;
  /** Mandatory */
  treatmentId?: InputMaybe<Scalars['String']>;
  /** Mandatory */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListCurrentSymptomConfigurationsResponse = {
  symptomConfigurations?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationMsg>>>;
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDefaultPhysicalPresetsRequest = {
  /** optional: If this is set, return only the preset parts that are relevant to that physical examination's template */
  physicalExaminationId?: InputMaybe<Scalars['String']>;
  /** optional */
  scope?: InputMaybe<Input_Treatment_PhysicalPresetScopeMsg>;
};

export type Input_Treatment_ListDeletedDiagnosesRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  /** required */
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDeletedDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ListDiagnosesByVisitIdsRequest = {
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListDiagnosesByVisitIdsResponse = {
  diagnosesByVisitIds?: InputMaybe<Array<InputMaybe<Input_Treatment_ListDiagnosesByVisitIdsResponse_DiagnosesByVisitIdsEntry>>>;
};

export type Input_Treatment_ListDiagnosesByVisitIdsResponse_DiagnosesByVisitIdsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Treatment_DiagnosisList>;
};

export type Input_Treatment_ListDiagnosesRequest = {
  categoryAssignments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>>>;
  createdInTreatmentId?: InputMaybe<Scalars['String']>;
  /** optional filters */
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDiagnosesResponse = {
  diagnosis?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ListDiagnosisRecommendationsRequest = {
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDiagnosisRevisionsRequest = {
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDiagnosisRevisionsResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ListDiagnosisVersionsRequest = {
  diagnosisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListDiagnosisVersionsResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ListFilledAnamnesisBlocksRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFilledPhysicalBlocksRequest = {
  examinationId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowRevisionsRequest = {
  fluidFlowId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowRevisionsResponse = {
  fluidFlows?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowMsg>>>;
};

export type Input_Treatment_ListFluidFlowSystemMetadataRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowSystemMetadataResponse = {
  metadataList?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMetadataMsg>>>;
};

export type Input_Treatment_ListFluidFlowSystemRevisionsRequest = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowSystemRevisionsResponse = {
  fluidFlowSystems?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMsg>>>;
};

export type Input_Treatment_ListFluidFlowSystemVersionsRequest = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowSystemVersionsResponse = {
  fluidFlowSystems?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMsg>>>;
};

export type Input_Treatment_ListFluidFlowSystemsRequest = {
  endDate?: InputMaybe<Input_Timestamp>;
  numbers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowSystemsResponse = {
  fluidFlowSystems?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMsg>>>;
};

export type Input_Treatment_ListFluidFlowVersionsRequest = {
  fluidFlowId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowVersionsResponse = {
  fluidFlows?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowMsg>>>;
};

export type Input_Treatment_ListFluidFlowsRequest = {
  /** The last entry ends before or at the offset time of the end date */
  endDate?: InputMaybe<Input_Timestamp>;
  /** Optional filter to filter by fluid flow system */
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  returnDeleted?: InputMaybe<Scalars['Boolean']>;
  /** The first entry starts at the offset time of the start date */
  startDate?: InputMaybe<Input_Timestamp>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListFluidFlowsResponse = {
  fluidFlowSystemId?: InputMaybe<Scalars['String']>;
  inFlows?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowMsg>>>;
  outFlows?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
  /** Every result is for a different configuration */
  results?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowResultMsg>>>;
};

export type Input_Treatment_ListImmunityTestsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPatientDiagnosesRequest = {
  /** if set, visitId is ignored and returns diagnoses with overrides from this context */
  billingCaseId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
  /**
   * optional. if set, filter the diagnoses by checking for the existence of an external id of type ICD10
   *  that starts with any of the given prefixes
   */
  whitelistedIcd10Prefixes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListPatientFluidBalanceConfigurationsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPatientFluidBalanceConfigurationsResponse = {
  patientConfigurations?: InputMaybe<Array<InputMaybe<Input_Treatment_PatientFluidBalanceConfigurationMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPatientsAllergiesRequest = {
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListPatientsAllergiesResponse = {
  allergyLists?: InputMaybe<Array<InputMaybe<Input_Treatment_AllergyList>>>;
};

export type Input_Treatment_ListPhysicalBlockHistoryRequest = {
  pathKey?: InputMaybe<Input_Treatment_PathKeyMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPhysicalBlockHistoryResponse = {
  physicalBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockMsg>>>;
};

export type Input_Treatment_ListPhysicalBlockMetadataRequest = {
  /** optional for setting the description as a name with a specific language */
  language?: InputMaybe<Core_Language>;
};

export type Input_Treatment_ListPhysicalBlockMetadataResponse = {
  physicalBlockMetadataList?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockMetadataMsg>>>;
};

export type Input_Treatment_ListPhysicalBlocksResponse = {
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockMsg>>>;
};

export type Input_Treatment_ListPhysicalExaminationHistoryRequest = {
  /** Set to show empty physical examinations. By default they are filtered out. */
  displayEmpty?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPhysicalExaminationHistoryResponse = {
  physicalExaminations?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalExaminationMsg>>>;
};

export type Input_Treatment_ListPhysicalExaminationsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  physicalExaminationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPhysicalPresetsRequest = {
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: InputMaybe<Scalars['Boolean']>;
  /** Set to true if presets marked as "defaultPreset" should also be returned */
  includeDefaultPresets?: InputMaybe<Scalars['Boolean']>;
  owners?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalPresetOwnerReferenceMsg>>>;
  /** Optional: scope filter */
  scope?: InputMaybe<Input_Treatment_PhysicalPresetScopeMsg>;
};

export type Input_Treatment_ListPreviousDiagnosesRequest = {
  /** We have to exclude primary and secondary diagnoses of the current treatment */
  currentTreatmentId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPreviousTreatmentInfoRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  /** optional filter */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPreviousVaccinationsRequest = {
  /** We have to exclude vaccinations that were made in the current treatment */
  currentTreatmentId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListPrimaryVisitDiagnosesRequest = {
  visitPatientIdPairs?: InputMaybe<Array<InputMaybe<Input_Treatment_VisitPatientIdPairMsg>>>;
};

export type Input_Treatment_ListPrimaryVisitDiagnosesResponse = {
  primaryVisitDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_VisitDiagnosesList>>>;
};

export type Input_Treatment_ListSurgeryDiagnosesRequest = {
  /** mandatory */
  patientId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  surgeryId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListSurgeryDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  surgeryId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListSurgeryDiagnosisVersioningGroupIdsRequest = {
  billingCaseId?: InputMaybe<Scalars['String']>;
  surgeryIds?: InputMaybe<Input_Helper_IdList>;
};

export type Input_Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse = {
  diagnosisVersioningGroupIdToSurgeryIds?: InputMaybe<Array<InputMaybe<Input_Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse_DiagnosisVersioningGroupIdToSurgeryIdsEntry>>>;
};

export type Input_Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse_DiagnosisVersioningGroupIdToSurgeryIdsEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Helper_IdList>;
};

export type Input_Treatment_ListSymptomConfigurationRevisionsRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListSymptomConfigurationRevisionsResponse = {
  symptomConfigurations?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationMsg>>>;
};

export type Input_Treatment_ListSymptomConfigurationVersionsRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListSymptomConfigurationVersionsResponse = {
  symptomConfigurations?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationMsg>>>;
};

export type Input_Treatment_ListSymptomConfigurationsRequest = {
  endCutoff?: InputMaybe<Input_Timestamp>;
  /** mandatory, required for versioning */
  patientId?: InputMaybe<Scalars['String']>;
  returnDeleted?: InputMaybe<Scalars['Boolean']>;
  startCutoff?: InputMaybe<Input_Timestamp>;
  /** if set, not yet active configurations created in this treatment are displayed as well */
  treatmentId?: InputMaybe<Scalars['String']>;
  /** Provide at least one of visit id or treatment id */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListSymptomConfigurationsResponse = {
  versionGroups?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationVersionGroupMsg>>>;
};

export type Input_Treatment_ListTherapyCardHistoryRequest = {
  /** if filtering by timeframe, this flag decides whether TherapyCards which don't have a timeframe specified will be returned */
  includeUnspecifiedTimeFrames?: InputMaybe<Scalars['Boolean']>;
  /** if empty, don't filter by tag */
  metadataTags?: InputMaybe<Array<InputMaybe<Treatment_TherapyCardMetadataTag>>>;
  numbers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  surgeryId?: InputMaybe<Scalars['String']>;
  /** if not set, don't filter by timeframe */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTherapyCardHistoryResponse = {
  therapyCards?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardMsg>>>;
};

export type Input_Treatment_ListTherapyCardRevisionsRequest = {
  therapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTherapyCardRevisionsResponse = {
  therapyCards?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardMsg>>>;
};

export type Input_Treatment_ListTherapyHistoryRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTherapyHistoryResponse = {
  therapies?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyMsg>>>;
};

export type Input_Treatment_ListTreatmentAnamnesisBlocksRequest = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  treatmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListTreatmentAnamnesisBlocksResponse = {
  entries?: InputMaybe<Array<InputMaybe<Input_Treatment_ListTreatmentAnamnesisBlocksResponseEntryMsg>>>;
};

export type Input_Treatment_ListTreatmentAnamnesisBlocksResponseEntryMsg = {
  /** Set if the treatment had a block of the given number; not set if not. */
  anamnesisBlock?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTreatmentDiagnosesRequest = {
  treatmentId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTreatmentsRequest = {
  /** optional sortOrder, default DESC */
  createdAtSortOrder?: InputMaybe<Helper_SortOrder>;
  patientId?: InputMaybe<Scalars['String']>;
  /** if empty, don't filter by status */
  statuses?: InputMaybe<Array<InputMaybe<Treatment_TreatmentStatus>>>;
  /** optional filter */
  surgeryId?: InputMaybe<Scalars['String']>;
  /** if empty, don't filter by type */
  types?: InputMaybe<Array<InputMaybe<Treatment_TreatmentType>>>;
  /** optional filter */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListTreatmentsResponse = {
  patientId?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Input_Treatment_TreatmentMsg>>>;
  /** it's set if `visitId` is set in the `ListTreatmentsRequest` */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListVaccinationDiseasesRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListVaccinationsRequest = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListWoundProcedureHistoryRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Treatment_MedicalItemStatus>>>;
  /** if not set, don't filter by timeframe */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  timeFrameTimeFromSort?: InputMaybe<Helper_SortOrder>;
  visitId?: InputMaybe<Scalars['String']>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListWoundProcedureHistoryResponse = {
  woundProcedureGroups?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundProcedureGroupMsg>>>;
};

export type Input_Treatment_ListWoundRevisionsRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListWoundRevisionsResponse = {
  wounds?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundMsg>>>;
};

export type Input_Treatment_ListWoundVersionsRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ListWoundVersionsResponse = {
  wounds?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundMsg>>>;
};

export type Input_Treatment_ListWoundsRequest = {
  /** mandatory */
  context?: InputMaybe<Input_Treatment_WoundContextReferenceMsg>;
  /** optional filter */
  healingProgresses?: InputMaybe<Array<InputMaybe<Treatment_WoundHealingProgress>>>;
  /** optional filter */
  onlyHealed?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  onlyLatestVersion?: InputMaybe<Scalars['Boolean']>;
  /** optional filter */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  /** optional sort */
  woundDateSort?: InputMaybe<Helper_SortOrder>;
  /** optional filter */
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_ListWoundsResponse = {
  patientId?: InputMaybe<Scalars['String']>;
  woundVersionGroups?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundVersionGroupMsg>>>;
};

export type Input_Treatment_LiverPalpationBlock = {
  hepatojugularRefluxPresent?: InputMaybe<Scalars['Boolean']>;
  isLiverPalpable?: InputMaybe<Scalars['Boolean']>;
  liverRim?: InputMaybe<Scalars['Int']>;
  liverSurface?: InputMaybe<Treatment_LiverSurface>;
  liverTexture?: InputMaybe<Treatment_LiverTexture>;
  pulsationsPresent?: InputMaybe<Scalars['Boolean']>;
  tendernessPresent?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LiverSizeBlock = {
  liverSize?: InputMaybe<Scalars['Float']>;
  measurement?: InputMaybe<Array<InputMaybe<Treatment_LiverSizeMeasurement>>>;
};

export type Input_Treatment_LiverSkinSignExaminationBlock = {
  liverSkinSigns?: InputMaybe<Array<InputMaybe<Input_Treatment_LiverSkinSignMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_LiverSkinSignMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  imageSeriesId?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_LivingSituationBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LocalAnaesthesiaMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_LocalAnestheticMsg = {
  /** non-negative; unit: ml */
  localAnaesthesiaVolume?: InputMaybe<Scalars['Float']>;
  localAnesthesticDrugLink?: InputMaybe<Input_Drug_DrugLinkMsg>;
};

export type Input_Treatment_LocalizedDiagnosisDetailMsg = {
  diagnosisDetail?: InputMaybe<Input_Treatment_DiagnosisDetailMsg>;
  diagnosisLocalization?: InputMaybe<Treatment_DiagnosisLocalization>;
};

export type Input_Treatment_LowerAnkleJointMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  id?: InputMaybe<Scalars['String']>;
  pronation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  supination?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
};

export type Input_Treatment_LowerLegAndAnkleFunctionTestMsg = {
  anteriorDrawerTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorDrawerTestText?: InputMaybe<Scalars['String']>;
  crossedLegTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  crossedLegTestText?: InputMaybe<Scalars['String']>;
  frickTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  frickTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lateralGapping?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lateralGappingText?: InputMaybe<Scalars['String']>;
  silfverskjoeldTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  silfverskjoeldTestText?: InputMaybe<Scalars['String']>;
  squeezeTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  squeezeTestText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LowerLegAndAnkleFunctionTestsBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_LowerLegAndAnkleFunctionTestMsg>;
  right?: InputMaybe<Input_Treatment_LowerLegAndAnkleFunctionTestMsg>;
};

export type Input_Treatment_LowerLimbsPasiMsg = {
  lowerLimbsBodyRegionPercentage?: InputMaybe<Treatment_BodyRegionPercentage>;
  lowerLimbsDiscoloration?: InputMaybe<Treatment_PasiSelection>;
  lowerLimbsScaling?: InputMaybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.4> */
  lowerLimbsScore?: InputMaybe<Scalars['Float']>;
  lowerLimbsThickness?: InputMaybe<Treatment_PasiSelection>;
};

export type Input_Treatment_LumbarSpineJointsMsg = {
  /** L1/L2 */
  l1L2?: InputMaybe<Laterality_Laterality>;
  /** L2/L3 */
  l2L3?: InputMaybe<Laterality_Laterality>;
  /** L3/L4 */
  l3L4?: InputMaybe<Laterality_Laterality>;
  /** L4/L5 */
  l4L5?: InputMaybe<Laterality_Laterality>;
  /** L5/S1 */
  l5S1?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_LumbarSpineMsg = {
  l1?: InputMaybe<Laterality_Laterality>;
  l2?: InputMaybe<Laterality_Laterality>;
  l3?: InputMaybe<Laterality_Laterality>;
  l4?: InputMaybe<Laterality_Laterality>;
  l5?: InputMaybe<Laterality_Laterality>;
  s1?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_LungAusculatationsBlock = {
  auscultations?: InputMaybe<Array<InputMaybe<Input_Treatment_LungAuscultationDescriptionMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  nonExistentRales?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_LungAuscultationDescriptionMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_LungBorderBlock = {
  lungBorder?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LungsThoraxPressurePainBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_LymphNodesAbnormalitiesMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_MallampatiClassificationBlock = {
  mallampatiClassificationSelection?: InputMaybe<Treatment_MallampatiClassificationSelection>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_MastoidAbnormalityMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MastoidInspectionAbnormalityMsg = {
  combined?: InputMaybe<Input_Treatment_MastoidSideInspectionMsg>;
  documentationMode?: InputMaybe<Treatment_LateralityDocumentationMode>;
  id?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_MastoidSideInspectionMsg>;
  right?: InputMaybe<Input_Treatment_MastoidSideInspectionMsg>;
};

export type Input_Treatment_MastoidInspectionMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_MastoidInspectionAbnormalityMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_MastoidSideInspectionMsg = {
  abnormality?: InputMaybe<Input_Treatment_MastoidAbnormalityMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MediastinalDrainageMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  suction?: InputMaybe<Scalars['Float']>;
  suctionUnit?: InputMaybe<Treatment_SuctionUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_MedicalItemContextMsg = {
  currentStatusEntry?: InputMaybe<Input_Treatment_MedicalItemStatusEntryMsg>;
  dischargeId?: InputMaybe<Scalars['String']>;
  historicStatusEntries?: InputMaybe<Array<InputMaybe<Input_Treatment_MedicalItemStatusEntryMsg>>>;
  owningAdministrativeUnit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MedicalItemStatusEntryMsg = {
  setAt?: InputMaybe<Input_Timestamp>;
  setBy?: InputMaybe<Input_Core_PersonReferenceMsg>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
};

export type Input_Treatment_MedicationBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_MeldAndMeldNaBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** unit: mg/dl */
  creatinine?: InputMaybe<Scalars['Float']>;
  inr?: InputMaybe<Scalars['Float']>;
  /** MELD-Score – Serum sodium - (0.025 * MELD-Score * (140 – Serum sodium)) + 140 */
  meldNaScore?: InputMaybe<Scalars['Int']>;
  /** 10 * ((0.957 * ln(Creatinine)) + (0.378 * ln(Total Bilirubin)) + (1.12 * ln(INR))) + 6.43 */
  meldScore?: InputMaybe<Scalars['Int']>;
  /** unit: mmol/l */
  serumSodium?: InputMaybe<Scalars['Float']>;
  /** unit: mg/dl */
  totalBilirubin?: InputMaybe<Scalars['Float']>;
  twoFoldHemodialysis?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_MemoryBlock = {
  amnesia?: InputMaybe<Scalars['Boolean']>;
  amnesiaDescriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  amnesiaText?: InputMaybe<Scalars['String']>;
  autobiographicalMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  autobiographicalMemoryText?: InputMaybe<Scalars['String']>;
  confabulations?: InputMaybe<Scalars['Boolean']>;
  confabulationsText?: InputMaybe<Scalars['String']>;
  episodicMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  episodicMemoryText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  longTermMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  longTermMemoryText?: InputMaybe<Scalars['String']>;
  memory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  paramnesia?: InputMaybe<Scalars['Boolean']>;
  paramnesiaText?: InputMaybe<Scalars['String']>;
  retention?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  retentionText?: InputMaybe<Scalars['String']>;
  semanticMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  semanticMemoryText?: InputMaybe<Scalars['String']>;
  shortTermMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  shortTermMemoryText?: InputMaybe<Scalars['String']>;
  timeGridDisturbances?: InputMaybe<Scalars['Boolean']>;
  timeGridDisturbancesText?: InputMaybe<Scalars['String']>;
  workingMemory?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  workingMemoryText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MenarcheMenopauseBlock = {
  /** The time of the menarche; typically just entered as year or month and year */
  menarche?: InputMaybe<Input_VeiosDateTimeMsg>;
  /** The time of the menopause; typically just entered as year or month and year */
  menopause?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_MenisciExaminationBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_MenisciExaminationMsg>;
  right?: InputMaybe<Input_Treatment_MenisciExaminationMsg>;
};

export type Input_Treatment_MenisciExaminationMsg = {
  apleyGrindingSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  apleyGrindingSignText?: InputMaybe<Scalars['String']>;
  boehlersSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  boehlersSignText?: InputMaybe<Scalars['String']>;
  bragardTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  bragardTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mcMurrayTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  mcMurrayTestText?: InputMaybe<Scalars['String']>;
  payrsSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  payrsSignText?: InputMaybe<Scalars['String']>;
  steinmannIISign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  steinmannIISignText?: InputMaybe<Scalars['String']>;
  steinmannISign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  steinmannISignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MentalEatingDisorderMsg = {
  bingeEating?: InputMaybe<Input_Treatment_BingeEatingMsg>;
  bingeEatingPresent?: InputMaybe<Scalars['Boolean']>;
  bodyMisconception?: InputMaybe<Input_Treatment_BodyMisconceptionMsg>;
  bodyMisconceptionPresent?: InputMaybe<Scalars['Boolean']>;
  dietaryBehavior?: InputMaybe<Treatment_DietaryBehavior>;
  dietaryBehaviorDescription?: InputMaybe<Scalars['String']>;
  fastingPeriods?: InputMaybe<Input_Treatment_FastingPeriodsMsg>;
  fastingPeriodsPresent?: InputMaybe<Scalars['Boolean']>;
  feelingOfHunger?: InputMaybe<Scalars['Boolean']>;
  feelingOfSatiety?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  /** in kg */
  maximumWeight?: InputMaybe<Scalars['Float']>;
  /** in kg */
  minimumWeight?: InputMaybe<Scalars['Float']>;
  purging?: InputMaybe<Input_Treatment_PurgingMsg>;
  purgingPresent?: InputMaybe<Scalars['Boolean']>;
  regularMainMeals?: InputMaybe<Scalars['Boolean']>;
  regularMainMealsDescription?: InputMaybe<Scalars['String']>;
  satisfiedWithCurrentWeight?: InputMaybe<Scalars['Boolean']>;
  snacks?: InputMaybe<Scalars['Boolean']>;
  snacksDescription?: InputMaybe<Scalars['String']>;
  timeOfFeelingOfHunger?: InputMaybe<Scalars['String']>;
  weightDissatisfactionReasons?: InputMaybe<Scalars['String']>;
  weightVariability?: InputMaybe<Treatment_WeightVariability>;
};

export type Input_Treatment_MetabolicEquivalentOfTaskBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  metabolicEquivalentOfTaskSelection?: InputMaybe<Treatment_MetabolicEquivalentOfTaskSelection>;
  score?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MicturitionDisorderBlock = {
  dailyNocturiaFrequency?: InputMaybe<Scalars['Int']>;
  flow?: InputMaybe<Treatment_MicturitionFlowType>;
  furtherComplaints?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherComplaintsText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  nocturiaPresent?: InputMaybe<Scalars['Boolean']>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  totalVolume?: InputMaybe<Treatment_MicuritionVolume>;
  urinaryContinencePresent?: InputMaybe<Scalars['Boolean']>;
  urinaryContinenceText?: InputMaybe<Scalars['String']>;
  urinaryIncontinenceType?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  urineColors?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  urineTextures?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_MiniMentalStateExaminationBlock = {
  attentionAndCalculationAbilityList?: InputMaybe<Array<InputMaybe<Treatment_AttentionAndCalculationAbility>>>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  followCommandList?: InputMaybe<Array<InputMaybe<Treatment_FollowCommand>>>;
  identifyObjectList?: InputMaybe<Array<InputMaybe<Treatment_IdentifyObject>>>;
  memoryAbilityList?: InputMaybe<Array<InputMaybe<Treatment_MemoryAbility>>>;
  memoryList?: InputMaybe<Array<InputMaybe<Treatment_Memory>>>;
  orientationLocalisationList?: InputMaybe<Array<InputMaybe<Treatment_OrientationLocalisation>>>;
  orientationTimeList?: InputMaybe<Array<InputMaybe<Treatment_OrientationTime>>>;
  repeatSentenceList?: InputMaybe<Array<InputMaybe<Treatment_RepeatSentence>>>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_MiniNutritionalAssessmentLongVersionBlock = {
  assessment?: InputMaybe<Input_Treatment_AssessmentMsg>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Score Screening + Score Assessment */
  score?: InputMaybe<Scalars['Float']>;
  screening?: InputMaybe<Input_Treatment_ScreeningMsg>;
};

export type Input_Treatment_MiniNutritionalAssessmentShortVersionBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Int']>;
  screening?: InputMaybe<Input_Treatment_ScreeningMsg>;
};

/** Arbitrary text in which examinations can be specified */
export type Input_Treatment_MiscellaneousExaminationMsg = {
  text?: InputMaybe<Scalars['String']>;
};

/** Arbitrary text in which therapies can be specified */
export type Input_Treatment_MiscellaneousTherapyMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MobilitySpineBlock = {
  movementPain?: InputMaybe<Scalars['Boolean']>;
  movementPainText?: InputMaybe<Scalars['String']>;
  restrictionOfMovement?: InputMaybe<Scalars['Boolean']>;
  restrictionOfMovementText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_MobilityTestAnkleBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestAnkleMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestAnkleMsg>;
};

export type Input_Treatment_MobilityTestAnkleMeasurementMsg = {
  id?: InputMaybe<Scalars['String']>;
  lowerAnklePronationSupination?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  upperAnklePlantarFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestAnkleMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestAnkleMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestAnkleMeasurementMsg>;
};

export type Input_Treatment_MobilityTestCervicalSpineBlock = {
  mobilityTestSpine?: InputMaybe<Input_Treatment_MobilityTestSpineMsg>;
};

export type Input_Treatment_MobilityTestElbowJointBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestElbowJointMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestElbowJointMsg>;
};

export type Input_Treatment_MobilityTestElbowJointMeasurementMsg = {
  flexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  pronationSupinationForearm?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestElbowJointMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestElbowJointMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestElbowJointMeasurementMsg>;
};

export type Input_Treatment_MobilityTestFingerJointsBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_MobilityTestFingerJointsMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestFingerJointsMsg>;
};

export type Input_Treatment_MobilityTestFingerJointsMeasurementMsg = {
  fingerBasicJointsAdductionAbduction?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  fingerBasicJointsFlexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  fingerEndJointsFlexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  fingerMiddleJointsFlexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  thumbBasicJointFlexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointAdductionAbduction?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointFlexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointInternalExternalRotation?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestFingerJointsMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestFingerJointsMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestFingerJointsMeasurementMsg>;
};

export type Input_Treatment_MobilityTestHipJointBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestHipJointMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestHipJointMsg>;
};

export type Input_Treatment_MobilityTestHipJointMeasurementMsg = {
  adAbduction?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  flexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  internalExternalRotation?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestHipJointMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestHipJointMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestHipJointMeasurementMsg>;
};

export type Input_Treatment_MobilityTestKneeBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestKneeMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestKneeMsg>;
};

export type Input_Treatment_MobilityTestKneeMeasurementMsg = {
  adAbductionKneeFlexed?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  adAbductionKneeStraight?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  flexionExtension?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  internalExternalRotationKneeFlexed?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  internalExternalRotationKneeStraight?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestKneeMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestKneeMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestKneeMeasurementMsg>;
};

export type Input_Treatment_MobilityTestLumbarSpineBlock = {
  mobilityTestSpine?: InputMaybe<Input_Treatment_MobilityTestSpineMsg>;
};

export type Input_Treatment_MobilityTestShoulderBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestShoulderMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestShoulderMsg>;
};

export type Input_Treatment_MobilityTestShoulderJointIsolatedBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestShoulderJointIsolatedMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestShoulderJointIsolatedMsg>;
};

export type Input_Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg = {
  adAbduction?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  anteRetroversion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  innerOuterRotation90Abducted?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  internalExternalRotationNeutralPosition?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestShoulderJointIsolatedMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg>;
};

export type Input_Treatment_MobilityTestShoulderMeasurementMsg = {
  adAbduction?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  anteRetroversion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  internalExternalRotation?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestShoulderMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestShoulderMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestShoulderMeasurementMsg>;
};

export type Input_Treatment_MobilityTestSpineMeasurementMsg = {
  id?: InputMaybe<Scalars['String']>;
  inclinationReclination?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  lateralFlexionLeftRight?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  rotationLeftRight?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestSpineMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestSpineMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestSpineMeasurementMsg>;
};

export type Input_Treatment_MobilityTestThoracicSpineBlock = {
  mobilityTestSpine?: InputMaybe<Input_Treatment_MobilityTestSpineMsg>;
};

export type Input_Treatment_MobilityTestToeJointsBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_MobilityTestToeJointsMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestToeJointsMsg>;
};

export type Input_Treatment_MobilityTestToeJointsMeasurementMsg = {
  basicToeJointsFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  endToeJointsPlantarFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  id?: InputMaybe<Scalars['String']>;
  middleToeJointsPlantarFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

export type Input_Treatment_MobilityTestToeJointsMsg = {
  activeMeasurement?: InputMaybe<Input_Treatment_MobilityTestToeJointsMeasurementMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passiveMeasurement?: InputMaybe<Input_Treatment_MobilityTestToeJointsMeasurementMsg>;
};

export type Input_Treatment_MobilityTestWristBlock = {
  left?: InputMaybe<Input_Treatment_MobilityTestWristMsg>;
  right?: InputMaybe<Input_Treatment_MobilityTestWristMsg>;
};

export type Input_Treatment_MobilityTestWristMsg = {
  activePalmarFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
  enterPassiveMeasurements?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  passivePalmarFlexionDorsiflexion?: InputMaybe<Input_Treatment_AbnormalityAngleAndTextMsg>;
};

/** Montreal Coginitive Assessment */
export type Input_Treatment_MocaTestBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  connectionOfLettersAndNumbers?: InputMaybe<Treatment_ConnectionOfLettersAndNumbers>;
  copyingThreeDimensionalCube?: InputMaybe<Treatment_CopyingThreeDimensionalCube>;
  listingWords?: InputMaybe<Treatment_ListingWords>;
  namingAnimalList?: InputMaybe<Array<InputMaybe<Treatment_NamingAnimal>>>;
  orientationList?: InputMaybe<Array<InputMaybe<Treatment_Orientation>>>;
  recallingWordList?: InputMaybe<Array<InputMaybe<Treatment_RecallingWord>>>;
  recognizingFeatures?: InputMaybe<Treatment_RecognizingFeatures>;
  repetitionOfNumbersInDictatedOrder?: InputMaybe<Treatment_RepetitionOfNumbersInDictatedOrder>;
  repetitionOfNumbersInReversedOrder?: InputMaybe<Treatment_RepetitionOfNumbersInReversedOrder>;
  repetitionOfSentences?: InputMaybe<Treatment_RepetitionOfSentences>;
  /** automatic computation of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  seriesOfLetters?: InputMaybe<Treatment_SeriesOfLetters>;
  subtraction?: InputMaybe<Treatment_Subtraction>;
};

/** Modified Katz Activities of Daily Living (ADL) Scale */
export type Input_Treatment_ModifiedKatzAdlBlock = {
  bathing?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  continence?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
  dressing?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
  eating?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
  score?: InputMaybe<Scalars['Int']>;
  toileting?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
  transferring?: InputMaybe<Treatment_ModifiedKatzAdlSelection>;
};

export type Input_Treatment_ModifiedNortonScaleBlock = {
  additionalDiseases?: InputMaybe<Treatment_AdditionalDiseases>;
  age?: InputMaybe<Treatment_Age>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  incontinence?: InputMaybe<Treatment_Incontinence>;
  mentalState?: InputMaybe<Treatment_MentalState>;
  modifiedNortonActivity?: InputMaybe<Treatment_ModifiedNortonActivity>;
  modifiedNortonMobility?: InputMaybe<Treatment_ModifiedNortonMobility>;
  physicalCondition?: InputMaybe<Treatment_PhysicalCondition>;
  score?: InputMaybe<Scalars['Int']>;
  skinCondition?: InputMaybe<Treatment_SkinCondition>;
  willingnessToCooperate?: InputMaybe<Treatment_MnsWillingnessToCooperate>;
};

export type Input_Treatment_MonosynapticReflexMsg = {
  forceAsymmetry?: InputMaybe<Treatment_ForceAsymmetry>;
  id?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Treatment_ReflexStatus>;
  right?: InputMaybe<Treatment_ReflexStatus>;
};

export type Input_Treatment_MonosynapticReflexesBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  reflexes?: InputMaybe<Input_Treatment_MonosynapticReflexesGroupMsg>;
};

export type Input_Treatment_MonosynapticReflexesGroupMsg = {
  achillesTendonReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  adductorReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  bicepsTendonReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  brachioradialisReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  id?: InputMaybe<Scalars['String']>;
  masseterReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  patellarTendonReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  pronatorReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  tibialisPosteriorReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  tricepsTendonReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
  troemnerReflex?: InputMaybe<Input_Treatment_MonosynapticReflexMsg>;
};

export type Input_Treatment_MoodAndPsycheBlock = {
  moodAndPsyche?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_MotorAspectsOfDailyLivingMsg = {
  chewingAndSwallowing?: InputMaybe<Treatment_UpdrsSelection>;
  dressing?: InputMaybe<Treatment_UpdrsSelection>;
  eatingTasks?: InputMaybe<Treatment_UpdrsSelection>;
  freezing?: InputMaybe<Treatment_UpdrsSelection>;
  gettingOutOfBed?: InputMaybe<Treatment_UpdrsSelection>;
  handwriting?: InputMaybe<Treatment_UpdrsSelection>;
  hobbiesAndActivities?: InputMaybe<Treatment_UpdrsSelection>;
  hygiene?: InputMaybe<Treatment_UpdrsSelection>;
  salivaAndDrooling?: InputMaybe<Treatment_UpdrsSelection>;
  speech?: InputMaybe<Treatment_UpdrsSelection>;
  tremor?: InputMaybe<Treatment_UpdrsSelection>;
  turningInBed?: InputMaybe<Treatment_UpdrsSelection>;
  walkingAndBalance?: InputMaybe<Treatment_UpdrsSelection>;
};

export type Input_Treatment_MotorComplicationsMsg = {
  complexityOfMotorFluctuation?: InputMaybe<Treatment_UpdrsSelection>;
  functionalImpactOfDyskinesias?: InputMaybe<Treatment_UpdrsSelection>;
  functionalImpactOfFluctuations?: InputMaybe<Treatment_UpdrsSelection>;
  painfulOffStateDystonia?: InputMaybe<Treatment_UpdrsSelection>;
  timeSpentInTheOffState?: InputMaybe<Treatment_UpdrsSelection>;
  timeSpentWithDyskinesias?: InputMaybe<Treatment_UpdrsSelection>;
};

export type Input_Treatment_MotorExaminationMsg = {
  arisingFromChair?: InputMaybe<Treatment_UpdrsSelection>;
  constancyOfRestTremor?: InputMaybe<Treatment_UpdrsSelection>;
  facialExpression?: InputMaybe<Treatment_UpdrsSelection>;
  fingerTappingLeftHand?: InputMaybe<Treatment_UpdrsSelection>;
  fingerTappingRightHand?: InputMaybe<Treatment_UpdrsSelection>;
  freezingOfGait?: InputMaybe<Treatment_UpdrsSelection>;
  gait?: InputMaybe<Treatment_UpdrsSelection>;
  globalSpontaneityOfMovement?: InputMaybe<Treatment_UpdrsSelection>;
  handMovementsLeftHand?: InputMaybe<Treatment_UpdrsSelection>;
  handMovementsRightHand?: InputMaybe<Treatment_UpdrsSelection>;
  /** <Asymptomatic (0) / Unilateral involvement only (1) /Bilateral involvement without impairment of balance (2) / Mild to moderate involvement (3) /Severe disability; still able to walk or stand unassisted (4) /Wheelchair bound or bedridden unless aided (5)> */
  hoehnAndYahrStage?: InputMaybe<Treatment_HoehnAndYahrStage>;
  /** Is the patient on levodopa?: <yes/no> */
  isPatientOnLevodopa?: InputMaybe<Scalars['Boolean']>;
  /** Is the patient on medication?: <yes/no> */
  isPatientOnMedication?: InputMaybe<Scalars['Boolean']>;
  kineticTremorLeftHand?: InputMaybe<Treatment_UpdrsSelection>;
  kineticTremorRightHand?: InputMaybe<Treatment_UpdrsSelection>;
  legAbilityLeftLeg?: InputMaybe<Treatment_UpdrsSelection>;
  legAbilityRightLeg?: InputMaybe<Treatment_UpdrsSelection>;
  /** minutes since last dose: <numeric input> (non-negative integers, no decimals, unit: minutes) */
  minutesSinceLastDose?: InputMaybe<Scalars['Int']>;
  /** Did these movements interfere with ratings?: <yes/no> */
  movementsInterfereWithRatings?: InputMaybe<Scalars['Boolean']>;
  /** Patient's clinical state: <on/off> */
  patientClinicalState?: InputMaybe<Treatment_PatientClinicalState>;
  posturalStability?: InputMaybe<Treatment_UpdrsSelection>;
  posturalTremorLeftHand?: InputMaybe<Treatment_UpdrsSelection>;
  posturalTremorRightHand?: InputMaybe<Treatment_UpdrsSelection>;
  postureCheck?: InputMaybe<Treatment_UpdrsSelection>;
  pronationSupinationMovementsLeftHand?: InputMaybe<Treatment_UpdrsSelection>;
  pronationSupinationMovementsRightHand?: InputMaybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLipJaw?: InputMaybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLle?: InputMaybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLue?: InputMaybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeRle?: InputMaybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeRue?: InputMaybe<Treatment_UpdrsSelection>;
  rigidityLle?: InputMaybe<Treatment_UpdrsSelection>;
  rigidityLue?: InputMaybe<Treatment_UpdrsSelection>;
  rigidityNeck?: InputMaybe<Treatment_UpdrsSelection>;
  rigidityRle?: InputMaybe<Treatment_UpdrsSelection>;
  rigidityRue?: InputMaybe<Treatment_UpdrsSelection>;
  speech?: InputMaybe<Treatment_UpdrsSelection>;
  toeTappingLeftFoot?: InputMaybe<Treatment_UpdrsSelection>;
  toeTappingRightFoot?: InputMaybe<Treatment_UpdrsSelection>;
  /** Were dyskinesias present?: <yes/no> */
  wereDyskinesiasPreset?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_MouthAndThroatAndLarynxInspectionBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  mouthOpening?: InputMaybe<Input_Treatment_MouthOpeningMsg>;
  oralMucosa?: InputMaybe<Input_Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  oropharynx?: InputMaybe<Input_Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  ostiaOfTheExcretoryDuctsOfSalivaryGlands?: InputMaybe<Input_Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  thyreomentalDistance?: InputMaybe<Input_Treatment_ThyreomentalDistanceMsg>;
  tonsillaePalatinae?: InputMaybe<Input_Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  toothStatus?: InputMaybe<Input_Treatment_ToothStatusMsg>;
};

export type Input_Treatment_MouthAndThroatAndLarynxPartExaminationMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalAbnormalityMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_MouthOpeningMsg = {
  abnormality?: InputMaybe<Treatment_MouthOpeningAbnormality>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mouthOpeningExaminationResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_MrsBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  scale?: InputMaybe<Treatment_MrsScaleSelection>;
};

export type Input_Treatment_MuscleToneBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  muscleTone?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_NailChangeExaminationBlock = {
  nailChanges?: InputMaybe<Array<InputMaybe<Input_Treatment_NailChangeMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_NailChangeMsg = {
  dermatoscopicDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageSeriesId?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  macroscopicDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NamedFluidFlowSystemMsg = {
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NamedProcedureMsg = {
  content?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NasalCavityConspicuousnessEntryMsg = {
  combined?: InputMaybe<Input_Treatment_NasalCavityConspicuousnessMsg>;
  documentationMode?: InputMaybe<Treatment_LateralityDocumentationMode>;
  id?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_NasalCavityConspicuousnessMsg>;
  right?: InputMaybe<Input_Treatment_NasalCavityConspicuousnessMsg>;
};

export type Input_Treatment_NasalCavityConspicuousnessMsg = {
  conspicuousness?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NasalCavityMsg = {
  conspicuousnesses?: InputMaybe<Array<InputMaybe<Input_Treatment_NasalCavityConspicuousnessEntryMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_NasalVestibuleMsg = {
  furtherDetailsCombined?: InputMaybe<Scalars['String']>;
  furtherDetailsLeft?: InputMaybe<Scalars['String']>;
  furtherDetailsRight?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_NeckAndShoulderMotorSkillsBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  headRotation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  headRotationText?: InputMaybe<Scalars['String']>;
  neckAndShoulderMotorSkills?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  shoulderRotation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  shoulderRotationText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NeglectDescriptionMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NerveRootBlockMsg = {
  cervicalSpine?: InputMaybe<Input_Treatment_CervicalSpineMsg>;
  cervicalSpinePresent?: InputMaybe<Scalars['Boolean']>;
  imaging?: InputMaybe<Scalars['Boolean']>;
  lumbarSpine?: InputMaybe<Input_Treatment_LumbarSpineMsg>;
  lumbarSpinePresent?: InputMaybe<Scalars['Boolean']>;
  others?: InputMaybe<Scalars['String']>;
  othersPresent?: InputMaybe<Scalars['Boolean']>;
  thoracicSpine?: InputMaybe<Input_Treatment_ThoracicSpineMsg>;
  thoracicSpinePresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_NerveStretchSignsBlock = {
  brudzinskiSign?: InputMaybe<Scalars['Boolean']>;
  brudzinskiSignText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_NerveStretchSignsMsg>;
  lhermittSign?: InputMaybe<Scalars['Boolean']>;
  lhermittSignText?: InputMaybe<Scalars['String']>;
  meningismusSign?: InputMaybe<Scalars['Boolean']>;
  meningismusSignText?: InputMaybe<Scalars['String']>;
  right?: InputMaybe<Input_Treatment_NerveStretchSignsMsg>;
};

export type Input_Treatment_NerveStretchSignsMsg = {
  bragardSign?: InputMaybe<Scalars['Boolean']>;
  bragardSignText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kernigSign?: InputMaybe<Scalars['Boolean']>;
  kernigSignText?: InputMaybe<Scalars['String']>;
  lasegueSign?: InputMaybe<Scalars['Boolean']>;
  lasegueSignText?: InputMaybe<Scalars['String']>;
  pseudolasequeSign?: InputMaybe<Scalars['Boolean']>;
  pseudolasequeSignText?: InputMaybe<Scalars['String']>;
  reversedLasequeSign?: InputMaybe<Scalars['Boolean']>;
  reversedLasequeSignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NeuraxialAnesthesiaMsg = {
  /** one decimal; unit: cm */
  catheterInEpiduralSpace?: InputMaybe<Scalars['Float']>;
  cerebrospinalFluid?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** one decimal; unit: cm */
  lossOfResistance?: InputMaybe<Scalars['Float']>;
  punctureLocation?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  punctures?: InputMaybe<Scalars['Int']>;
  /** one decimal; unit: cm */
  skinLevel?: InputMaybe<Scalars['Float']>;
  /** one decimal; unit: cm */
  tunnel?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_NeurologicalExaminationMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NicotineBlock = {
  calculatedPackYears?: InputMaybe<Scalars['Int']>;
  consumptionPresent?: InputMaybe<Scalars['Boolean']>;
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
  nicotineConsumptions?: InputMaybe<Array<InputMaybe<Input_Treatment_NicotineMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NicotineMsg = {
  consumptionDuration?: InputMaybe<Scalars['Int']>;
  consumptionDurationReference?: InputMaybe<Treatment_ConsumptionDurationReference>;
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyReference?: InputMaybe<Treatment_ConsumptionFrequencyReference>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  tobaccoUse?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_NightSweatsBlock = {
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_NightSweatsResolution>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  nightlyPajamaChanges?: InputMaybe<Scalars['Int']>;
  pajamaChangePresent?: InputMaybe<Scalars['Boolean']>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_NihssBlock = {
  dysarthria?: InputMaybe<Treatment_DysarthriaTestResult>;
  dysarthriaText?: InputMaybe<Scalars['String']>;
  extremitiesAtaxia?: InputMaybe<Treatment_ExtremitiesAtaxiaTestResult>;
  extremitiesAtaxiaText?: InputMaybe<Scalars['String']>;
  facialNerveParesis?: InputMaybe<Treatment_FacialNerveParesisTestResult>;
  facialNerveParesisText?: InputMaybe<Scalars['String']>;
  followingInstructions?: InputMaybe<Treatment_FollowingInstructionsTestResult>;
  followingInstructionsText?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Treatment_LanguageTestResult>;
  languageText?: InputMaybe<Scalars['String']>;
  motorFunctionLeftArm?: InputMaybe<Treatment_MotorFunctionArmTestResult>;
  motorFunctionLeftArmText?: InputMaybe<Scalars['String']>;
  motorFunctionLeftLeg?: InputMaybe<Treatment_MotorFunctionLegTestResult>;
  motorFunctionLeftLegText?: InputMaybe<Scalars['String']>;
  motorFunctionRightArm?: InputMaybe<Treatment_MotorFunctionArmTestResult>;
  motorFunctionRightArmText?: InputMaybe<Scalars['String']>;
  motorFunctionRightLeg?: InputMaybe<Treatment_MotorFunctionLegTestResult>;
  motorFunctionRightLegText?: InputMaybe<Scalars['String']>;
  neglect?: InputMaybe<Treatment_NeglectTestResult>;
  neglectText?: InputMaybe<Scalars['String']>;
  oculomotorFunction?: InputMaybe<Treatment_OculomotorFunctionTestResult>;
  oculomotorFunctionText?: InputMaybe<Scalars['String']>;
  orientation?: InputMaybe<Treatment_OrientationTestResult>;
  orientationText?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Int']>;
  sensitivity?: InputMaybe<Treatment_SensitivityTestResult>;
  sensitivityText?: InputMaybe<Scalars['String']>;
  vigilance?: InputMaybe<Treatment_NihssVigilanceType>;
  vigilanceText?: InputMaybe<Scalars['String']>;
  visualField?: InputMaybe<Treatment_VisualFieldTestResult>;
  visualFieldText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NikolausSocialQuestionnaireBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  economicCircumstances?: InputMaybe<Input_Treatment_EconomicCircumstancesMsg>;
  housingSituation?: InputMaybe<Input_Treatment_HousingSituationMsg>;
  score?: InputMaybe<Scalars['Int']>;
  socialActivities?: InputMaybe<Input_Treatment_SocialActivitiesMsg>;
  socialContactsAndSupport?: InputMaybe<Input_Treatment_SocialContactsAndSupportMsg>;
};

export type Input_Treatment_NonInvasiveVentilationBlock = {
  causes?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  durationOfTherapyPerDay?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  oxygenFlowRate?: InputMaybe<Scalars['Int']>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_NonMotorAspectsOfDailyLivingMsg = {
  anxiousMood?: InputMaybe<Treatment_UpdrsSelection>;
  apathy?: InputMaybe<Treatment_UpdrsSelection>;
  cognitiveImpairment?: InputMaybe<Treatment_UpdrsSelection>;
  constipationProblems?: InputMaybe<Treatment_UpdrsSelection>;
  daytimeSleepiness?: InputMaybe<Treatment_UpdrsSelection>;
  depressedMood?: InputMaybe<Treatment_UpdrsSelection>;
  fatigue?: InputMaybe<Treatment_UpdrsSelection>;
  featuresOfDss?: InputMaybe<Treatment_UpdrsSelection>;
  hallucinationsAndPsychosis?: InputMaybe<Treatment_UpdrsSelection>;
  lightHeadednessOnStanding?: InputMaybe<Treatment_UpdrsSelection>;
  painAndOtherSensations?: InputMaybe<Treatment_UpdrsSelection>;
  sleepProblems?: InputMaybe<Treatment_UpdrsSelection>;
  /** <patient / caregiver / both> */
  sourceOfInformation?: InputMaybe<Treatment_SourceOfInformation>;
  urinaryProblems?: InputMaybe<Treatment_UpdrsSelection>;
  /** <patient / caregiver / both> */
  whoIsFillingOutQuestionnaire?: InputMaybe<Treatment_SourceOfInformation>;
};

export type Input_Treatment_NoseExaminationMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_NoseInspectionBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  innerNose?: InputMaybe<Input_Treatment_InnerNoseMsg>;
  midFace?: InputMaybe<Input_Treatment_NoseExaminationMsg>;
  nasopharynx?: InputMaybe<Input_Treatment_NoseExaminationMsg>;
  outerNose?: InputMaybe<Input_Treatment_NoseExaminationMsg>;
};

export type Input_Treatment_NosePalpationBlock = {
  frontalSinus?: InputMaybe<Input_Treatment_SinusPalpationMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  maxillarySinus?: InputMaybe<Input_Treatment_SinusPalpationMsg>;
};

export type Input_Treatment_NuDescBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  disorientation?: InputMaybe<Treatment_NuDescSelection>;
  illusions?: InputMaybe<Treatment_NuDescSelection>;
  inappropriateBehavior?: InputMaybe<Treatment_NuDescSelection>;
  inappropriateCommunication?: InputMaybe<Treatment_NuDescSelection>;
  psychomotoricRetardation?: InputMaybe<Treatment_NuDescSelection>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_NumericPainRatingScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  severitySlider?: InputMaybe<Treatment_SeveritySlider>;
};

export type Input_Treatment_NutritionStatusBlock = {
  nutritionStatus?: InputMaybe<Treatment_NutritionStatusType>;
};

export type Input_Treatment_NutritionalDisturbanceBlock = {
  bmi?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  hungerDescription?: InputMaybe<Scalars['String']>;
  hungerLevel?: InputMaybe<Treatment_Hunger>;
  mentalEatingDisorder?: InputMaybe<Input_Treatment_MentalEatingDisorderMsg>;
  mentalEatingDisorderSuspected?: InputMaybe<Scalars['Boolean']>;
  nutritionForms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
  thirstDescription?: InputMaybe<Scalars['String']>;
  thirstLevel?: InputMaybe<Treatment_Thirst>;
};

export type Input_Treatment_NutritionalRiskScreeningBlock = {
  /** Age ≥ 70: */
  ageGreaterThan70?: InputMaybe<Scalars['Boolean']>;
  /** <20.5 kg/m2?: <yes/no> */
  bodyMassIndexBelow20Point5?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Has food intake been decreased in the past week?: <yes/no> */
  decreaseFoodIntakeInPastWeek?: InputMaybe<Scalars['Boolean']>;
  diseaseSeverity?: InputMaybe<Treatment_NrsSelection>;
  /**
   * if yes to any of the questions, then
   * 1) Nutritional status disorder: < None (0) / Mild (1) / Moderate (2) / Severe (3)> (singleselect)
   * 2) Disease severity: < None (0) / Mild (1) / Moderate (2) / Severe (3)> (singleselect)
   * 3) Age ≥ 70: <yes (1) /no (0)> (singleselect)
   */
  nutritionalStatusDisorder?: InputMaybe<Treatment_NrsSelection>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** Is the patient seriously ill? (e.g. intensive care): <yes/no> */
  seriouslyIll?: InputMaybe<Scalars['Boolean']>;
  /** Has the patient lost weight in the past 3 months?: <yes/no> */
  weightLossInPastThreeMonths?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_NyhaBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  nyhaStage?: InputMaybe<Treatment_NyhaStage>;
  score?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_NystagmusAssessmentMsg = {
  assessmentText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OpsInformationMsg = {
  id?: InputMaybe<Scalars['String']>;
  opsCode?: InputMaybe<Scalars['String']>;
  opsVersion?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OccupationMsg = {
  employmentTime?: InputMaybe<Input_VeiosTimeFrameMsg>;
  id?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OccupationsBlock = {
  isCurrentlyEmployed?: InputMaybe<Scalars['Boolean']>;
  occupationSatisfaction?: InputMaybe<Treatment_OccupationSatisfactionType>;
  occupations?: InputMaybe<Array<InputMaybe<Input_Treatment_OccupationMsg>>>;
  satisfactionText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  unemploymentText?: InputMaybe<Scalars['String']>;
  wasUnemployedBefore?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_OculomotorSkillsBlock = {
  convergenceReaction?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  convergenceReactionText?: InputMaybe<Scalars['String']>;
  eyeMovement?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  eyeMovementText?: InputMaybe<Scalars['String']>;
  fixationSuppressionOfTheVestibuloOcularReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fixationSuppressionOfTheVestibuloOcularReflexText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  inspectionBulbPosition?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  inspectionBulbPositionText?: InputMaybe<Scalars['String']>;
  lidElevation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lidElevationText?: InputMaybe<Scalars['String']>;
  oculomotorSkills?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pursuitTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pursuitTestText?: InputMaybe<Scalars['String']>;
  vestibuloOcularReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: InputMaybe<Scalars['String']>;
  voluntarySaccades?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  voluntarySaccadesText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OlfactorySenseBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  olfactorySense?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_OpenTreatmentInfoMsg = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_TreatmentType>;
  userId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OrientationBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<Scalars['Boolean']>;
  personText?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['Boolean']>;
  placeText?: InputMaybe<Scalars['String']>;
  situation?: InputMaybe<Scalars['Boolean']>;
  situationText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Boolean']>;
  timeText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OrientativeFunctionalTestsSpineBlock = {
  adamsForwardBentTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  adamsForwardBentTestText?: InputMaybe<Scalars['String']>;
  distanceDorsiflexionOtt?: InputMaybe<Scalars['Float']>;
  distanceDorsiflexionSchober?: InputMaybe<Scalars['Float']>;
  distanceVentralFlexionOtt?: InputMaybe<Scalars['Float']>;
  distanceVentralFlexionSchober?: InputMaybe<Scalars['Float']>;
  fingerTipsToFloorDistance?: InputMaybe<Scalars['Float']>;
  fingertipsToFloorDistanceTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  ottsSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  schobersTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_OrientativeShoulderFunctionTestsBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_OrientativeShoulderFunctionTestsMsg>;
  right?: InputMaybe<Input_Treatment_OrientativeShoulderFunctionTestsMsg>;
};

export type Input_Treatment_OrientativeShoulderFunctionTestsMsg = {
  apronHandle?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  apronHandleText?: InputMaybe<Scalars['String']>;
  bellyPressTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  bellyPressTestText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jobeTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  jobeTestText?: InputMaybe<Scalars['String']>;
  liftOffTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  liftOffTestText?: InputMaybe<Scalars['String']>;
  neckGrip?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  neckGripText?: InputMaybe<Scalars['String']>;
  painfulArcTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  painfulArcTestText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OrientingEyeExaminationBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_OrientingForceSingleTestMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OrientingForceTestBlock = {
  armExtensionTest?: InputMaybe<Input_Treatment_OrientingForceSingleTestMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  legExtensionTest?: InputMaybe<Input_Treatment_OrientingForceSingleTestMsg>;
  orientingForceTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_OrientingNeurologicalExaminationBlock = {
  orientingNeurologicalExamination?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  orientingNeurologicalExaminationText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OtherDrugsAndAddictiveSubstancesBlock = {
  consumptionPresent?: InputMaybe<Scalars['Boolean']>;
  currentConsumption?: InputMaybe<Scalars['Boolean']>;
  substances?: InputMaybe<Array<InputMaybe<Input_Treatment_DrugAndAddictiveSubstanceMsg>>>;
};

export type Input_Treatment_OtherPhysicalBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_OtherRiskFactorsBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  riskFactors?: InputMaybe<Array<InputMaybe<Input_Treatment_AnesthesiologicalRiskFactorMsg>>>;
};

export type Input_Treatment_OxygenTherapyBlock = {
  durationOfTherapyPerDay?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  oxygenFlowRate?: InputMaybe<Scalars['Int']>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_PDmsLowerExtremitiesBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_PDmsLowerExtremityMsg>;
  right?: InputMaybe<Input_Treatment_PDmsLowerExtremityMsg>;
};

export type Input_Treatment_PDmsLowerExtremityMsg = {
  id?: InputMaybe<Scalars['String']>;
  pDmsIntact?: InputMaybe<Treatment_IntactExaminationResult>;
  peripheralProperties?: InputMaybe<Input_Treatment_PeripheralPropertiesMsg>;
};

export type Input_Treatment_PDmsUpperExtremitiesBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_PDmsUpperExtremityMsg>;
  right?: InputMaybe<Input_Treatment_PDmsUpperExtremityMsg>;
};

export type Input_Treatment_PDmsUpperExtremityMsg = {
  id?: InputMaybe<Scalars['String']>;
  pDmsIntact?: InputMaybe<Treatment_IntactExaminationResult>;
  peripheralProperties?: InputMaybe<Input_Treatment_PeripheralPropertiesMsg>;
};

export type Input_Treatment_PacemakerBlock = {
  currentPacemakerMode?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  indicationsForImplantation?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDetailMsg>>>;
  intrinsicRhythmPresent?: InputMaybe<Scalars['Boolean']>;
  lastCheckUpAppointment?: InputMaybe<Input_Timestamp>;
  lastCheckUpAppointmentId?: InputMaybe<Scalars['String']>;
  /** add knowledge dataset */
  pacemakerType?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_PadssBlock = {
  /** < walking without vertigo possible (2) / walking with assistance possible (1) / no walking possible, vertigo (0)> */
  ambulation?: InputMaybe<Treatment_Ambulation>;
  /** < minor (2) / moderate (1) / severe (0)> */
  bleeding?: InputMaybe<Treatment_Bleeding>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** < minor (2) / moderate (1) / severe (0)> */
  nausea?: InputMaybe<Treatment_Nausea>;
  /** < minor (VAS 1-2) (2) / moderate (VAS 3-4) (1) / severe (VAS >4) (0)> */
  pain?: InputMaybe<Treatment_Pain>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** < <20% of preoperative value (2) / 20-40% of preoperative value (1) / >40% of preoperative value (0)> */
  systolicBloodPressure?: InputMaybe<Treatment_SystolicBloodPressure>;
};

export type Input_Treatment_PainBlock = {
  aggravatingFactors?: InputMaybe<Scalars['Boolean']>;
  aggravatingFactorsText?: InputMaybe<Scalars['String']>;
  onset?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** natural number without 0 */
  period?: InputMaybe<Scalars['Int']>;
  periodUnit?: InputMaybe<TimeUnit>;
  quality?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  radiation?: InputMaybe<Scalars['Boolean']>;
  radiationLocalizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  relievingFactors?: InputMaybe<Scalars['Boolean']>;
  relievingFactorsText?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['Int']>;
  temporalCourse?: InputMaybe<Treatment_TemporalCourse>;
};

export type Input_Treatment_PainCatheterMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_PainQuestionnaireMsg = {
  fiveMinutes?: InputMaybe<Scalars['Int']>;
  oneHour?: InputMaybe<Scalars['Int']>;
  oneMinute?: InputMaybe<Scalars['Int']>;
  sixHours?: InputMaybe<Scalars['Int']>;
  tenMinutes?: InputMaybe<Scalars['Int']>;
  thirtyMinutes?: InputMaybe<Scalars['Int']>;
  twentyFourHours?: InputMaybe<Scalars['Int']>;
  twentyMinutes?: InputMaybe<Scalars['Int']>;
  twoHours?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PalpationAnkleJointBlock = {
  left?: InputMaybe<Input_Treatment_PalpationAnkleJointMsg>;
  right?: InputMaybe<Input_Treatment_PalpationAnkleJointMsg>;
};

export type Input_Treatment_PalpationAnkleJointMsg = {
  ankleJoint?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  ankleJointText?: InputMaybe<Scalars['String']>;
  calcaneus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  calcaneusText?: InputMaybe<Scalars['String']>;
  fibula?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fibulaText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  talus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  talusText?: InputMaybe<Scalars['String']>;
  tibia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationElbowJointBlock = {
  left?: InputMaybe<Input_Treatment_PalpationElbowJointMsg>;
  right?: InputMaybe<Input_Treatment_PalpationElbowJointMsg>;
};

export type Input_Treatment_PalpationElbowJointMsg = {
  elbowJoint?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  elbowJointText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lateralEpicondyle?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lateralEpicondyleText?: InputMaybe<Scalars['String']>;
  medialEpicondyle?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  medialEpicondyleText?: InputMaybe<Scalars['String']>;
  olecranon?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  olecranonText?: InputMaybe<Scalars['String']>;
  radialHead?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  radialHeadText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationFootBlock = {
  left?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  leftText?: InputMaybe<Scalars['String']>;
  right?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  rightText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationForearmBlock = {
  left?: InputMaybe<Input_Treatment_PalpationForearmMsg>;
  right?: InputMaybe<Input_Treatment_PalpationForearmMsg>;
};

export type Input_Treatment_PalpationForearmMsg = {
  id?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  radiusText?: InputMaybe<Scalars['String']>;
  ulna?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  ulnaText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationHandsBlock = {
  left?: InputMaybe<Input_Treatment_PalpationHandsMsg>;
  right?: InputMaybe<Input_Treatment_PalpationHandsMsg>;
};

export type Input_Treatment_PalpationHandsMsg = {
  fingerJoints?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fingerJointsText?: InputMaybe<Scalars['String']>;
  handAndHandJoints?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  handAndHandJointsText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationHipAndPelvicBlock = {
  left?: InputMaybe<Input_Treatment_PalpationHipAndPelvicMsg>;
  right?: InputMaybe<Input_Treatment_PalpationHipAndPelvicMsg>;
};

export type Input_Treatment_PalpationHipAndPelvicMsg = {
  groinPressure?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  groinPressureText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  pelvicCompression?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pelvicCompressionText?: InputMaybe<Scalars['String']>;
  pelvicStability?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pelvicStabilityText?: InputMaybe<Scalars['String']>;
  thigh?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thighText?: InputMaybe<Scalars['String']>;
  trochanterMajor?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  trochanterMajorText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationKneeBlock = {
  left?: InputMaybe<Input_Treatment_PalpationKneeMsg>;
  right?: InputMaybe<Input_Treatment_PalpationKneeMsg>;
};

export type Input_Treatment_PalpationKneeMsg = {
  aboveAndBelowPatella?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  aboveBelowPatellaText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  knee?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  kneeJointGap?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  kneeJointGapText?: InputMaybe<Scalars['String']>;
  kneeText?: InputMaybe<Scalars['String']>;
  patella?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  patellaText?: InputMaybe<Scalars['String']>;
  surroundingSoftTissue?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  surroundingSoftTissueText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationLowerLegBlock = {
  left?: InputMaybe<Input_Treatment_PalpationLowerLegMsg>;
  right?: InputMaybe<Input_Treatment_PalpationLowerLegMsg>;
};

export type Input_Treatment_PalpationLowerLegMsg = {
  fibula?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  fibulaText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  tibia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PalpationShoulderUpperArmBlock = {
  left?: InputMaybe<Input_Treatment_PalpationShoulderUpperArmMsg>;
  right?: InputMaybe<Input_Treatment_PalpationShoulderUpperArmMsg>;
};

export type Input_Treatment_PalpationShoulderUpperArmMsg = {
  acromioclavicularJoint?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  acromioclavicularJointText?: InputMaybe<Scalars['String']>;
  acromion?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  acromionText?: InputMaybe<Scalars['String']>;
  clavicle?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  clavicleText?: InputMaybe<Scalars['String']>;
  coracoidProcess?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  coracoidProcessText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intertubercularSulcus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  intertubercularSulcusText?: InputMaybe<Scalars['String']>;
  majorTubercle?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  majorTubercleText?: InputMaybe<Scalars['String']>;
  scapula?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  scapulaText?: InputMaybe<Scalars['String']>;
  sternoclavicularJoint?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  sternoclavicularJointText?: InputMaybe<Scalars['String']>;
  tubercleMinus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tubercleMinusText?: InputMaybe<Scalars['String']>;
  upperArm?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  upperArmText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PancreatitisSkinSignsBlock = {
  pancreatitisSkinSigns?: InputMaybe<Array<InputMaybe<Treatment_PancreatitisSkinSignsType>>>;
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ParoxysmalCardiacArrhythmiaMsg = {
  averageDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  cessationMechanismsDescription?: InputMaybe<Scalars['String']>;
  cessationMechanismsPresent?: InputMaybe<Scalars['Boolean']>;
  endType?: InputMaybe<Treatment_ArrythmiaOnsetType>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_SymptomFrequency>;
  id?: InputMaybe<Scalars['String']>;
  lastOccurrence?: InputMaybe<Input_VeiosDateTimeMsg>;
  onsetType?: InputMaybe<Treatment_ArrythmiaOnsetType>;
  situationalOnsetPresent?: InputMaybe<Scalars['Boolean']>;
  situationalOnsets?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ParoxysmalDyspneaMsg = {
  averageDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  endType?: InputMaybe<Treatment_SymptomAppearance>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_DyspneaResolution>;
  id?: InputMaybe<Scalars['String']>;
  lastOccurrence?: InputMaybe<Input_VeiosDateTimeMsg>;
  onsetType?: InputMaybe<Treatment_SymptomAppearance>;
  situationDependenceDescription?: InputMaybe<Scalars['String']>;
  situationDependencePresent?: InputMaybe<Scalars['Boolean']>;
  terminationMechanismsDescription?: InputMaybe<Scalars['String']>;
  terminationMechanismsPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ParoxysmalVertigoMsg = {
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_SymptomFrequency>;
  id?: InputMaybe<Scalars['String']>;
  lastSeizureDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  seizureDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  symptomsBetweenSeizures?: InputMaybe<Scalars['Boolean']>;
  symptomsBetweenSeizuresText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PasiBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  headAndNeckPasi?: InputMaybe<Input_Treatment_HeadAndNeckPasiMsg>;
  lowerLimbsPasi?: InputMaybe<Input_Treatment_LowerLimbsPasiMsg>;
  /** <Sum of all Subscores> */
  score?: InputMaybe<Scalars['Float']>;
  trunkPasi?: InputMaybe<Input_Treatment_TrunkPasiMsg>;
  upperLimbsPasi?: InputMaybe<Input_Treatment_UpperLimbsPasiMsg>;
};

export type Input_Treatment_PastAirwayManagementBlock = {
  airwayAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  cormackLehaneClassification?: InputMaybe<Treatment_CormackLehaneClassification>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  maskVentilations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PastAnaesthesiaComplicationOccurrenceMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  pastComplication?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_PastAnesthesiaComplicationsMsg = {
  complications?: InputMaybe<Array<InputMaybe<Input_Treatment_PastAnaesthesiaComplicationOccurrenceMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  nonExistingComplications?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PastTracheostomyDetailsMsg = {
  date?: InputMaybe<Input_Timestamp>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PatellaExaminationBlock = {
  customFunctionTests?: InputMaybe<Array<InputMaybe<Input_Treatment_CustomFunctionTestMsg>>>;
  left?: InputMaybe<Input_Treatment_PatellaExaminationMsg>;
  right?: InputMaybe<Input_Treatment_PatellaExaminationMsg>;
};

export type Input_Treatment_PatellaExaminationMsg = {
  apprehensionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  apprehensionTestText?: InputMaybe<Scalars['String']>;
  facetPressurePain?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  facetPressurePainText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  patellaMobility?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  patellaMobilityText?: InputMaybe<Scalars['String']>;
  patellaTap?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  patellaTapText?: InputMaybe<Scalars['String']>;
  zohlensSign?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  zohlensSignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PathKeyMsg = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PathologicReflexesBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  glabellarReflex?: InputMaybe<Scalars['Boolean']>;
  glabellarReflexText?: InputMaybe<Scalars['String']>;
  left?: InputMaybe<Input_Treatment_PathologicReflexesMsg>;
  right?: InputMaybe<Input_Treatment_PathologicReflexesMsg>;
  snoutReflex?: InputMaybe<Scalars['Boolean']>;
  snoutReflexText?: InputMaybe<Scalars['String']>;
  suckingReflex?: InputMaybe<Scalars['Boolean']>;
  suckingReflexText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PathologicReflexesMsg = {
  babinskiReflex?: InputMaybe<Scalars['Boolean']>;
  babinskiReflexText?: InputMaybe<Scalars['String']>;
  gordonSign?: InputMaybe<Scalars['Boolean']>;
  gordonSignText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  oppenheimSign?: InputMaybe<Scalars['Boolean']>;
  oppenheimSignText?: InputMaybe<Scalars['String']>;
  palmarGraspSign?: InputMaybe<Scalars['Boolean']>;
  palmarGraspSignText?: InputMaybe<Scalars['String']>;
  palmomentalReflex?: InputMaybe<Scalars['Boolean']>;
  palmomentalReflexText?: InputMaybe<Scalars['String']>;
  struempellSign?: InputMaybe<Scalars['Boolean']>;
  struempellSignText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PatientDiagnosisList = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  patientId?: InputMaybe<Scalars['String']>;
};

/**
 * TODO: is it possible to look at fluid balances of a patient from previous visits?
 * If it is possible, we would probably want different configurations based on visits instead of patient as the configuration might differ.
 * Otherwise, we should probably come up with a way to clean up configurations for patients whose stationary visit ended unless there is a reason to keep them for future
 */
export type Input_Treatment_PatientFluidBalanceConfigurationMsg = {
  active?: InputMaybe<Scalars['Boolean']>;
  configuration?: InputMaybe<Input_Treatment_FluidBalanceConfigurationMsg>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PatientHealthQuestionnaireBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  feelingBadAboutYourself?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  feelingHopeless?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  feelingTired?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  littleInterest?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  movingOrSpeakingSlowly?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  poorAppetite?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  score?: InputMaybe<Scalars['Int']>;
  thoughtsAboutHurtingYourself?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  troubleConcentration?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
  troubleFalling?: InputMaybe<Treatment_PatientHealthQuestionnaireSelection>;
};

export type Input_Treatment_PatientsDiagnosisList = {
  patientsDiagnosis?: InputMaybe<Array<InputMaybe<Input_Treatment_PatientDiagnosisList>>>;
};

export type Input_Treatment_PediatricGlasgowComaScaleScoreBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  eyeResponse?: InputMaybe<Treatment_EyeResponseType>;
  motorResponse?: InputMaybe<Treatment_PediatricMotorResponseType>;
  score?: InputMaybe<Scalars['Int']>;
  verbalResponse?: InputMaybe<Treatment_PediatricVerbalResponseType>;
};

export type Input_Treatment_PegMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PercussionSoundDescriptionMsg = {
  id?: InputMaybe<Scalars['String']>;
  lungLocalizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  percussionSoundDescriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PercussionSoundLungBlock = {
  percussionSound?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  percussionSoundDescriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_PercussionSoundDescriptionMsg>>>;
};

export type Input_Treatment_PericardialDrainageMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  suction?: InputMaybe<Scalars['Float']>;
  suctionUnit?: InputMaybe<Treatment_SuctionUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_PeriduralInjectionsMsg = {
  singleShotPeriduralAnaesthesia?: InputMaybe<Scalars['Boolean']>;
  spineLevels?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PeripheralAnesthesiaMsg = {
  /** one decimal; unit: cm */
  depth?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  punctureLocation?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** one decimal; unit: cm */
  skinLevel?: InputMaybe<Scalars['Float']>;
  technique?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** one decimal; unit: cm */
  tunnel?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_PeripheralPropertiesMsg = {
  id?: InputMaybe<Scalars['String']>;
  peripheralBloodFlowState?: InputMaybe<Treatment_IntactExaminationResult>;
  peripheralBloodFlowText?: InputMaybe<Scalars['String']>;
  peripheralMotorFunctionState?: InputMaybe<Treatment_IntactExaminationResult>;
  peripheralMotorFunctionText?: InputMaybe<Scalars['String']>;
  peripheralSensibilityState?: InputMaybe<Treatment_IntactExaminationResult>;
  peripheralSensibilityText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PeripheralPulseDeficitBlock = {
  peripheralPulseDeficit?: InputMaybe<Scalars['Boolean']>;
  peripheralPulseDeficitText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PeritonealCatheterMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PeritonealPunctureMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PeritonitisSignsBlock = {
  contralateralReboundTendernessPresent?: InputMaybe<Scalars['Boolean']>;
  contralateralReboundTendernessText?: InputMaybe<Scalars['String']>;
  cutaneousHyperesthesiaPresent?: InputMaybe<Scalars['Boolean']>;
  cutaneousHyperesthesiaText?: InputMaybe<Scalars['String']>;
  muscularDefensePresent?: InputMaybe<Scalars['Boolean']>;
  muscularDefenseText?: InputMaybe<Scalars['String']>;
  painIncreasedByCoughingPresent?: InputMaybe<Scalars['Boolean']>;
  painIncreasedByCoughingText?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  reboundTendernessPresent?: InputMaybe<Scalars['Boolean']>;
  reboundTendernessText?: InputMaybe<Scalars['String']>;
  shakingPainPresent?: InputMaybe<Scalars['Boolean']>;
  shakingPainText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PersistentDyspneaMsg = {
  course?: InputMaybe<Treatment_DyspneaCourse>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PharyngealMotorSkillsAndSensitivityBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  gagReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  gagReflexText?: InputMaybe<Scalars['String']>;
  pharyngealMotorSkillsAndSensitivity?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  softPalate?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  softPalateText?: InputMaybe<Scalars['String']>;
  swallowingAct?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  swallowingActText?: InputMaybe<Scalars['String']>;
  uvula?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  uvulaText?: InputMaybe<Scalars['String']>;
  voiceCheck?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  voiceCheckText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PhysicalAbnormalityMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PhysicalBlockContentMsg = {
  abdominalCirculationNoise?: InputMaybe<Input_Treatment_AbdominalCirculationNoiseBlock>;
  abdominalInspectionGeneral?: InputMaybe<Input_Treatment_AbdominalInspectionGeneralBlock>;
  abdominalPercussion?: InputMaybe<Input_Treatment_AbdominalPercussionBlock>;
  abdominalWall?: InputMaybe<Input_Treatment_AbdominalWallBlock>;
  /** should be directly before ExtremitiesTemperatureBlock extremitiesTemperature = 20151; */
  allenTest?: InputMaybe<Input_Treatment_AllenTestBlock>;
  alsfrs?: InputMaybe<Input_Treatment_AlsfrsBlock>;
  analRegionInspection?: InputMaybe<Input_Treatment_AnalRegionInspectionBlock>;
  apicalImpulse?: InputMaybe<Input_Treatment_ApicalImpulseBlock>;
  appearance?: InputMaybe<Input_Treatment_AppearanceBlock>;
  appendicitisSigns?: InputMaybe<Input_Treatment_AppendicitisSignsBlock>;
  ascites?: InputMaybe<Input_Treatment_AscitesBlock>;
  attention?: InputMaybe<Input_Treatment_AttentionBlock>;
  axillaryLymphNodes?: InputMaybe<Input_Treatment_AxillaryLymphNodesBlock>;
  bloodPressureAndPulse?: InputMaybe<Input_Treatment_BloodPressureAndPulseBlock>;
  bodyMeasurements?: InputMaybe<Input_Treatment_BodyMeasurementsBlock>;
  bowelSounds?: InputMaybe<Input_Treatment_BowelSoundsBlock>;
  breathingMovability?: InputMaybe<Input_Treatment_BreathingMovabilityBlock>;
  breathingMovement?: InputMaybe<Input_Treatment_BreathingMovementBlock>;
  bronchophony?: InputMaybe<Input_Treatment_BronchophonyBlock>;
  chewingMusclesAndFacialMotorSkills?: InputMaybe<Input_Treatment_ChewingMusclesAndFacialMotorSkillsBlock>;
  compressionStability?: InputMaybe<Input_Treatment_CompressionStabilityBlock>;
  contusionHematoma?: InputMaybe<Input_Treatment_ContusionHematomaBlock>;
  coordination?: InputMaybe<Input_Treatment_CoordinationBlock>;
  crepitations?: InputMaybe<Input_Treatment_CrepitationsBlock>;
  cruciateLigamentsExamination?: InputMaybe<Input_Treatment_CruciateLigamentsExaminationBlock>;
  deformitiesMalpositionsLowerLimbs?: InputMaybe<Input_Treatment_DeformitiesMalpositionsLowerLimbBlock>;
  deformitiesMalpositionsSpine?: InputMaybe<Input_Treatment_DeformitiesMalpositionsSpineBlock>;
  deformitiesMalpositionsUpperLimb?: InputMaybe<Input_Treatment_DeformitiesMalpositionsUpperLimbBlock>;
  /** Preanesthetic Assessment */
  dentures?: InputMaybe<Input_Treatment_DenturesBlock>;
  digitalRectalExamination?: InputMaybe<Input_Treatment_DigitalRectalExamBlock>;
  earsInspection?: InputMaybe<Input_Treatment_EarsInspectionBlock>;
  edemas?: InputMaybe<Input_Treatment_EdemasBlock>;
  executiveFunctions?: InputMaybe<Input_Treatment_ExecutiveFunctionsBlock>;
  externalMaterial?: InputMaybe<Input_Treatment_ExternalMaterialBlock>;
  extrapyramidalMovementDisorders?: InputMaybe<Input_Treatment_ExtrapyramidalMovementDisordersBlock>;
  extremitiesTemperature?: InputMaybe<Input_Treatment_ExtremitiesTemperatureBlock>;
  facialSensitivityAndTrigeminalReflexes?: InputMaybe<Input_Treatment_FacialSensitivityAndTrigeminalReflexesBlock>;
  flowNoiseLowerExtremity?: InputMaybe<Input_Treatment_FlowNoiseLowerExtremityBlock>;
  flowNoiseUpperExtremity?: InputMaybe<Input_Treatment_FlowNoisesUpperExtremityBlock>;
  functionTestsHipAndPelvic?: InputMaybe<Input_Treatment_HipAndPelvicFunctionTestsBlock>;
  /** should be directly after NeckAndShoulderMotorSkillsBlock neckAndShoulderMotorSkills = 20180; */
  functionalExaminationOfVestibularNerve?: InputMaybe<Input_Treatment_FunctionalExaminationOfVestibularNerveBlock>;
  furtherFunctionalTestsSpine?: InputMaybe<Input_Treatment_FurtherFunctionalTestsSpineBlock>;
  furtherShoulderFunctionTests?: InputMaybe<Input_Treatment_FurtherShoulderFunctionTestsBlock>;
  gait?: InputMaybe<Input_Treatment_GaitBlock>;
  gallBladderSigns?: InputMaybe<Input_Treatment_GallBladderSignsBlock>;
  generalCondition?: InputMaybe<Input_Treatment_GeneralConditionBlock>;
  generalFindings?: InputMaybe<Input_Treatment_GeneralFindingsBlock>;
  glasgowComaScale?: InputMaybe<Input_Treatment_GlasgowComaScaleBlock>;
  hairScalpInspection?: InputMaybe<Input_Treatment_HairScalpInspectionBlock>;
  hairScalpPalpation?: InputMaybe<Input_Treatment_HairScalpPalpationBlock>;
  handFunctionTests?: InputMaybe<Input_Treatment_HandFunctionTestsBlock>;
  headAndNeckLymphNode?: InputMaybe<Input_Treatment_HeadAndNeckLymphNodesBlock>;
  headSalivaryGlands?: InputMaybe<Input_Treatment_HeadSalivaryGlandsBlock>;
  hearing?: InputMaybe<Input_Treatment_HearingBlock>;
  heartMurmurs?: InputMaybe<Input_Treatment_HeartMurmursBlock>;
  heartRate?: InputMaybe<Input_Treatment_HeartRateBlock>;
  heartSound?: InputMaybe<Input_Treatment_HeartSoundBlock>;
  hernia?: InputMaybe<Input_Treatment_HerniaBlock>;
  illusions?: InputMaybe<Input_Treatment_IllusionsBlock>;
  inguinalLymphNodes?: InputMaybe<Input_Treatment_InguinalLymphNodesBlock>;
  inspectionOfTheMusculatureAndMuscleTrophics?: InputMaybe<Input_Treatment_InspectionOfTheMusculatureAndMuscleTrophicsBlock>;
  jugularVeinsInspection?: InputMaybe<Input_Treatment_JugularVeinsInspectionBlock>;
  kidneyPainOnPercussion?: InputMaybe<Input_Treatment_KidneyPainOnPercussionBlock>;
  larynxHypopharynxInspection?: InputMaybe<Input_Treatment_LarynxHypopharynxInspectionBlock>;
  limbCircumferenceDifference?: InputMaybe<Input_Treatment_LimbCircumferenceDifferenceBlock>;
  liverPalpation?: InputMaybe<Input_Treatment_LiverPalpationBlock>;
  liverSize?: InputMaybe<Input_Treatment_LiverSizeBlock>;
  liverSkinSigns?: InputMaybe<Input_Treatment_LiverSkinSignExaminationBlock>;
  lowerLegAndAnkleFunctionTests?: InputMaybe<Input_Treatment_LowerLegAndAnkleFunctionTestsBlock>;
  lungAusculatations?: InputMaybe<Input_Treatment_LungAusculatationsBlock>;
  lungBorder?: InputMaybe<Input_Treatment_LungBorderBlock>;
  lungsThoraxPressurePain?: InputMaybe<Input_Treatment_LungsThoraxPressurePainBlock>;
  mallampatiClassification?: InputMaybe<Input_Treatment_MallampatiClassificationBlock>;
  memory?: InputMaybe<Input_Treatment_MemoryBlock>;
  menisciExamination?: InputMaybe<Input_Treatment_MenisciExaminationBlock>;
  mobilitySpine?: InputMaybe<Input_Treatment_MobilitySpineBlock>;
  mobilityTestAnkle?: InputMaybe<Input_Treatment_MobilityTestAnkleBlock>;
  mobilityTestCervicalSpine?: InputMaybe<Input_Treatment_MobilityTestCervicalSpineBlock>;
  mobilityTestElbowJoint?: InputMaybe<Input_Treatment_MobilityTestElbowJointBlock>;
  mobilityTestFingerJoint?: InputMaybe<Input_Treatment_MobilityTestFingerJointsBlock>;
  mobilityTestHipJoint?: InputMaybe<Input_Treatment_MobilityTestHipJointBlock>;
  mobilityTestKnee?: InputMaybe<Input_Treatment_MobilityTestKneeBlock>;
  mobilityTestLumbarSpine?: InputMaybe<Input_Treatment_MobilityTestLumbarSpineBlock>;
  mobilityTestShoulder?: InputMaybe<Input_Treatment_MobilityTestShoulderBlock>;
  mobilityTestShoulderJointIsolated?: InputMaybe<Input_Treatment_MobilityTestShoulderJointIsolatedBlock>;
  mobilityTestThoracicSpine?: InputMaybe<Input_Treatment_MobilityTestThoracicSpineBlock>;
  mobilityTestToeJoints?: InputMaybe<Input_Treatment_MobilityTestToeJointsBlock>;
  mobilityTestWrist?: InputMaybe<Input_Treatment_MobilityTestWristBlock>;
  monosynapticReflexes?: InputMaybe<Input_Treatment_MonosynapticReflexesBlock>;
  moodAndPsyche?: InputMaybe<Input_Treatment_MoodAndPsycheBlock>;
  mouthAndThroatAndLarynxInspection?: InputMaybe<Input_Treatment_MouthAndThroatAndLarynxInspectionBlock>;
  muscleTone?: InputMaybe<Input_Treatment_MuscleToneBlock>;
  nailChange?: InputMaybe<Input_Treatment_NailChangeExaminationBlock>;
  neckAndShoulderMotorSkills?: InputMaybe<Input_Treatment_NeckAndShoulderMotorSkillsBlock>;
  nerveStretchSigns?: InputMaybe<Input_Treatment_NerveStretchSignsBlock>;
  nihss?: InputMaybe<Input_Treatment_NihssBlock>;
  noseInspection?: InputMaybe<Input_Treatment_NoseInspectionBlock>;
  /** should be directly after NoseInspectionBlock noseInspection = 20029; */
  nosePalpation?: InputMaybe<Input_Treatment_NosePalpationBlock>;
  nutritionStatus?: InputMaybe<Input_Treatment_NutritionStatusBlock>;
  oculomotorSkills?: InputMaybe<Input_Treatment_OculomotorSkillsBlock>;
  olfactorySense?: InputMaybe<Input_Treatment_OlfactorySenseBlock>;
  orientation?: InputMaybe<Input_Treatment_OrientationBlock>;
  orientativeFunctionalTestsSpine?: InputMaybe<Input_Treatment_OrientativeFunctionalTestsSpineBlock>;
  orientativeShoulderFunctionTests?: InputMaybe<Input_Treatment_OrientativeShoulderFunctionTestsBlock>;
  orientingEyeExamination?: InputMaybe<Input_Treatment_OrientingEyeExaminationBlock>;
  orientingForceTest?: InputMaybe<Input_Treatment_OrientingForceTestBlock>;
  orientingNeurologicalExamination?: InputMaybe<Input_Treatment_OrientingNeurologicalExaminationBlock>;
  otherPhysical?: InputMaybe<Input_Treatment_OtherPhysicalBlock>;
  pDmsLowerExtremities?: InputMaybe<Input_Treatment_PDmsLowerExtremitiesBlock>;
  pDmsUpperExtremities?: InputMaybe<Input_Treatment_PDmsUpperExtremitiesBlock>;
  palpationAnkleJoint?: InputMaybe<Input_Treatment_PalpationAnkleJointBlock>;
  palpationElbowJoint?: InputMaybe<Input_Treatment_PalpationElbowJointBlock>;
  palpationFoot?: InputMaybe<Input_Treatment_PalpationFootBlock>;
  palpationForearm?: InputMaybe<Input_Treatment_PalpationForearmBlock>;
  palpationHands?: InputMaybe<Input_Treatment_PalpationHandsBlock>;
  palpationHipAndPelvic?: InputMaybe<Input_Treatment_PalpationHipAndPelvicBlock>;
  palpationKnee?: InputMaybe<Input_Treatment_PalpationKneeBlock>;
  palpationLowerLeg?: InputMaybe<Input_Treatment_PalpationLowerLegBlock>;
  palpationShoulderUpperArm?: InputMaybe<Input_Treatment_PalpationShoulderUpperArmBlock>;
  pancreatitisSkinSigns?: InputMaybe<Input_Treatment_PancreatitisSkinSignsBlock>;
  patellaExamination?: InputMaybe<Input_Treatment_PatellaExaminationBlock>;
  pathologicReflexes?: InputMaybe<Input_Treatment_PathologicReflexesBlock>;
  percussionSoundLung?: InputMaybe<Input_Treatment_PercussionSoundLungBlock>;
  peripheralPulseDeficit?: InputMaybe<Input_Treatment_PeripheralPulseDeficitBlock>;
  peritonitisSigns?: InputMaybe<Input_Treatment_PeritonitisSignsBlock>;
  pharyngealMotorSkillsAndSensitivity?: InputMaybe<Input_Treatment_PharyngealMotorSkillsAndSensitivityBlock>;
  polysynapticReflexes?: InputMaybe<Input_Treatment_PolysynapticReflexesBlock>;
  postureAndStand?: InputMaybe<Input_Treatment_PostureAndStandBlock>;
  precordialBruit?: InputMaybe<Input_Treatment_PrecordialBruitBlock>;
  pressurePainAbdomen?: InputMaybe<Input_Treatment_AbdomenLocationsBlock>;
  prostateExamination?: InputMaybe<Input_Treatment_ProstateExaminationBlock>;
  psychopathologicalFindings?: InputMaybe<Input_Treatment_PsychopathologicalFindingsBlock>;
  pulsePalpationAbdomen?: InputMaybe<Input_Treatment_PulsePalpationAbdomenBlock>;
  pulsePalpationLowerExtremity?: InputMaybe<Input_Treatment_PulsePalpationLowerExtremityBlock>;
  pulsePalpationUpperExtremity?: InputMaybe<Input_Treatment_PulsePalpationUpperExtremityBlock>;
  pupilsAndLightReaction?: InputMaybe<Input_Treatment_PupilsAndLightReactionBlock>;
  qualitativeConsciousness?: InputMaybe<Input_Treatment_QualitativeConsciousnessBlock>;
  resistancesAbdomen?: InputMaybe<Input_Treatment_AbdomenLocationsBlock>;
  respiration?: InputMaybe<Input_Treatment_RespirationBlock>;
  senseOfTaste?: InputMaybe<Input_Treatment_SenseOfTasteBlock>;
  sensitivity?: InputMaybe<Input_Treatment_SensitivityBlock>;
  singleForceTest?: InputMaybe<Input_Treatment_SingleForceTestBlock>;
  skinChangeExaminations?: InputMaybe<Input_Treatment_SkinChangeExaminationsBlock>;
  skinColor?: InputMaybe<Input_Treatment_SkinColorBlock>;
  skinThickness?: InputMaybe<Input_Treatment_SkinThicknessBlock>;
  skinTurgor?: InputMaybe<Input_Treatment_SkinTurgorBlock>;
  skullPalpation?: InputMaybe<Input_Treatment_SkullPalpationBlock>;
  softTissueEmphysema?: InputMaybe<Input_Treatment_SoftTissueEmphysemaBlock>;
  speaking?: InputMaybe<Input_Treatment_SpeakingBlock>;
  specialRespiratoryFeatures?: InputMaybe<Input_Treatment_SpecialRespiratoryFeaturesBlock>;
  specificEars?: InputMaybe<Input_Treatment_SpecificEarsBlock>;
  specificEyes?: InputMaybe<Input_Treatment_SpecificEyesBlock>;
  specificNoseAndSinus?: InputMaybe<Input_Treatment_SpecificNoseAndSinusBlock>;
  speech?: InputMaybe<Input_Treatment_SpeechBlock>;
  spineAgility?: InputMaybe<Input_Treatment_SpineAgilityBlock>;
  spinePalpation?: InputMaybe<Input_Treatment_SpinePalpationBlock>;
  spinePercussion?: InputMaybe<Input_Treatment_SpinePercussionBlock>;
  spleenPalpation?: InputMaybe<Input_Treatment_SpleenPalpationBlock>;
  stopBangRisk?: InputMaybe<Input_Treatment_StopBangRiskBlock>;
  surgicalScars?: InputMaybe<Input_Treatment_SurgicalScarsBlock>;
  swellingLimbs?: InputMaybe<Input_Treatment_SwellingLimbsBlock>;
  temperature?: InputMaybe<Input_Treatment_TemperatureBlock>;
  thoraxForm?: InputMaybe<Input_Treatment_ThoraxFormBlock>;
  thyroidInspectionAndPalpationAndAuscultation?: InputMaybe<Input_Treatment_ThyroidInspectionAndPalpationAndAuscultationBlock>;
  tongueMotorSkills?: InputMaybe<Input_Treatment_TongueMotorSkillsBlock>;
  tracheaPosition?: InputMaybe<Input_Treatment_TracheaPositionBlock>;
  trichoscopy?: InputMaybe<Input_Treatment_TrichoscopyBlock>;
  upperLipBiteTest?: InputMaybe<Input_Treatment_UpperLipBiteTestBlock>;
  urinaryBladder?: InputMaybe<Input_Treatment_UrinaryBladderBlock>;
  varicosis?: InputMaybe<Input_Treatment_VaricosisBlock>;
  vigilance?: InputMaybe<Input_Treatment_VigilanceBlock>;
  visualAcuity?: InputMaybe<Input_Treatment_VisualAcuityBlock>;
  visualFieldAndVisualAttention?: InputMaybe<Input_Treatment_VisualFieldAndVisualAttentionBlock>;
  vocalFremitus?: InputMaybe<Input_Treatment_VocalFremitusBlock>;
  wounds?: InputMaybe<Input_Treatment_WoundExaminationBlock>;
};

export type Input_Treatment_PhysicalBlockMetadataMsg = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  singleton?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Treatment_PhysicalBlockType>;
};

export type Input_Treatment_PhysicalBlockMsg = {
  blockMetadata?: InputMaybe<Input_Treatment_PhysicalBlockMetadataMsg>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Input_Treatment_PhysicalBlockContentMsg>;
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_PhysicalBlockLocation>;
  /** Id of physical examination that owns the block */
  owningPhysicalId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Treatment_PhysicalBlockPresetMsg = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Input_Treatment_PhysicalBlockContentMsg>;
  id?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PhysicalCardMsg = {
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockMsg>>>;
  metadata?: InputMaybe<Input_Treatment_CardMetadataMsg>;
  owningPhysicalId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PhysicalExaminationList = {
  physicalExaminationList?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalExaminationMsg>>>;
};

export type Input_Treatment_PhysicalExaminationMsg = {
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_PhysicalExaminationLocation>;
  sections?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalSectionMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PhysicalPresetList = {
  presets?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalPresetMsg>>>;
};

export type Input_Treatment_PhysicalPresetMsg = {
  blockPresets?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalBlockPresetMsg>>>;
  creatorUserId?: InputMaybe<Scalars['String']>;
  /** Only one default preset is allowed per owner (i.e., combination of ownerType and ownerId), this is checked in the backend. */
  defaultPreset?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Input_Treatment_PhysicalPresetOwnerReferenceMsg>;
  scope?: InputMaybe<Input_Treatment_PhysicalPresetScopeMsg>;
};

export type Input_Treatment_PhysicalPresetOwnerReferenceMsg = {
  ownerId?: InputMaybe<Scalars['String']>;
  ownerType?: InputMaybe<Treatment_PhysicalPresetOwnerType>;
};

export type Input_Treatment_PhysicalPresetScopeMsg = {
  number?: InputMaybe<Scalars['Int']>;
  /** Relevant only for PHYSICAL_PRESET_SCOPE_BLOCK */
  parentNumber?: InputMaybe<Scalars['Int']>;
  scopeType?: InputMaybe<Treatment_PhysicalPresetScopeType>;
};

export type Input_Treatment_PhysicalSectionMsg = {
  cards?: InputMaybe<Array<InputMaybe<Input_Treatment_PhysicalCardMsg>>>;
  metadata?: InputMaybe<Input_Treatment_SectionMetadataMsg>;
  owningPhysicalId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PhysicalTemplateMsg = {
  /** The section/card/block that is displayed by default when opening the physical examination */
  defaultPath?: InputMaybe<Input_Treatment_PathKeyMsg>;
  id?: InputMaybe<Scalars['String']>;
  ownerOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Input_Treatment_SectionTemplateMsg>>>;
  shortcuts?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: InputMaybe<Treatment_TreatmentType>;
  version?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PiCcMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  numberOfLumen?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PivMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
};

export type Input_Treatment_PleuralPunctureMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PolysynapticReflexesBlock = {
  abdomialSkinReflex?: InputMaybe<Scalars['Boolean']>;
  abdomialSkinReflexText?: InputMaybe<Scalars['String']>;
  analReflex?: InputMaybe<Scalars['Boolean']>;
  analReflexText?: InputMaybe<Scalars['String']>;
  babinskiReflexLeft?: InputMaybe<Scalars['Boolean']>;
  babinskiReflexLeftText?: InputMaybe<Scalars['String']>;
  babinskiReflexRight?: InputMaybe<Scalars['Boolean']>;
  babinskiReflexRightText?: InputMaybe<Scalars['String']>;
  bulbocavernosusReflex?: InputMaybe<Scalars['Boolean']>;
  bulbocavernosusReflexText?: InputMaybe<Scalars['String']>;
  cornealReflexLeft?: InputMaybe<Scalars['Boolean']>;
  cornealReflexLeftText?: InputMaybe<Scalars['String']>;
  cornealReflexRight?: InputMaybe<Scalars['Boolean']>;
  cornealReflexRightText?: InputMaybe<Scalars['String']>;
  coughReflex?: InputMaybe<Scalars['Boolean']>;
  coughReflexText?: InputMaybe<Scalars['String']>;
  cremastericReflexLeft?: InputMaybe<Scalars['Boolean']>;
  cremastericReflexLeftText?: InputMaybe<Scalars['String']>;
  cremastericReflexRight?: InputMaybe<Scalars['Boolean']>;
  cremastericReflexRightText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  gagReflex?: InputMaybe<Scalars['Boolean']>;
  gagReflexText?: InputMaybe<Scalars['String']>;
  lightReactionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  lightReactionTestText?: InputMaybe<Scalars['String']>;
  vestibuloOcularReflex?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PortCatheterMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** unit: mm (Millimeters) */
  needleLength?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_PostureAndStandBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  jumping?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  jumpingText?: InputMaybe<Scalars['String']>;
  posture?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  postureAndStand?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  postureText?: InputMaybe<Scalars['String']>;
  retropulsionTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  retropulsionTestText?: InputMaybe<Scalars['String']>;
  rombergsTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  rombergsTestText?: InputMaybe<Scalars['String']>;
  singleLegStand?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  singleLegStandText?: InputMaybe<Scalars['String']>;
  twoLeggedStand?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  twoLeggedStandText?: InputMaybe<Scalars['String']>;
  unterbergersTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  unterbergersTestText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PreExistingConditionsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_PrecordialBruitBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PreviousExaminationMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  opsId?: InputMaybe<Input_Treatment_OpsInformationMsg>;
  therapist?: InputMaybe<Input_Treatment_TherapistMsg>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_PreviousPregnanciesBlock = {
  gravida?: InputMaybe<Scalars['Int']>;
  numberCaesareanSections?: InputMaybe<Scalars['Int']>;
  para?: InputMaybe<Scalars['Int']>;
  pastCaesareanSection?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PreviousSurgeriesBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_PreviousTherapyMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  medicationId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  opsId?: InputMaybe<Input_Treatment_OpsInformationMsg>;
  therapist?: InputMaybe<Input_Treatment_TherapistMsg>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_PreviousTreatmentInfo = {
  primaryDiagnosisDescriptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  treatmentDetails?: InputMaybe<Input_Treatment_TreatmentDetailsMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PreviousTreatmentInfoList = {
  treatments?: InputMaybe<Array<InputMaybe<Input_Treatment_PreviousTreatmentInfo>>>;
};

export type Input_Treatment_ProstateExaminationBlock = {
  mucousMembraneMovable?: InputMaybe<Scalars['Boolean']>;
  pressurePainPresent?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  text?: InputMaybe<Scalars['String']>;
  textures?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_PsychopathologicalFindingsBlock = {
  htmlText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PulsePalpationAbdomenBlock = {
  pulsePalpation?: InputMaybe<Treatment_PulsePalpationAbdomenType>;
  pulsePalpationText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PulsePalpationLowerExtremityBlock = {
  left?: InputMaybe<Input_Treatment_PulsePalpationLowerExtremityMsg>;
  right?: InputMaybe<Input_Treatment_PulsePalpationLowerExtremityMsg>;
};

export type Input_Treatment_PulsePalpationLowerExtremityMsg = {
  dorsalisPedisArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  dorsalisPedisArteryText?: InputMaybe<Scalars['String']>;
  femoralArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  femoralArteryText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  poplitealArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  poplitealArteryText?: InputMaybe<Scalars['String']>;
  posteriorTibialArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  posteriorTibialArteryText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PulsePalpationUpperExtremityBlock = {
  left?: InputMaybe<Input_Treatment_PulsePalpationUpperExtremityMsg>;
  right?: InputMaybe<Input_Treatment_PulsePalpationUpperExtremityMsg>;
};

export type Input_Treatment_PulsePalpationUpperExtremityMsg = {
  brachialArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  brachialArteryText?: InputMaybe<Scalars['String']>;
  carotidArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  carotidArteryText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  radialArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  radialArteryText?: InputMaybe<Scalars['String']>;
  subclavianArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  subclavianArteryText?: InputMaybe<Scalars['String']>;
  ulnarArtery?: InputMaybe<Treatment_VascularSystemPalpationResult>;
  ulnarArteryText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PupilsAndLightReactionBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  pupilLeft?: InputMaybe<Input_Treatment_PupilsMsg>;
  pupilRight?: InputMaybe<Input_Treatment_PupilsMsg>;
  pupilSizeRelationship?: InputMaybe<Treatment_PupilSizeRelationship>;
  pupilSizeRelationshipText?: InputMaybe<Scalars['String']>;
  pupilsAndLightReaction?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_PupilsMsg = {
  directLightReaction?: InputMaybe<Treatment_LightReaction>;
  directLightReactionText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  indirectLightReaction?: InputMaybe<Treatment_LightReaction>;
  indirectLightReactionText?: InputMaybe<Scalars['String']>;
  pupilForm?: InputMaybe<Treatment_PupilForm>;
  pupilFormText?: InputMaybe<Scalars['String']>;
  pupilSize?: InputMaybe<Treatment_PupilSize>;
  pupilSizeText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_PurgingMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  methods?: InputMaybe<Array<InputMaybe<Treatment_PurgingMethod>>>;
  otherMethodDescription?: InputMaybe<Scalars['String']>;
  vomitingType?: InputMaybe<Treatment_PurgingVomiting>;
};

export type Input_Treatment_PushTreatmentDiagnosesRequest = {
  treatmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_PushTreatmentDiagnosesResponse = {
  failedTreatmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  successfulTreatmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_QsofaBlock = {
  /** altered mentation or GCS less than 15: <yes (1) / no (0)> */
  alteredMentation?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** respiratory rate greater or equal than 22 per minute: <yes (1) / no (0)> */
  respiratoryRate?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** systolic blood pressure less than or equal 100 mmHg: <yes (1) / no (0)> */
  systolicBloodPressure?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_QualitativeConsciousnessBlock = {
  cloudingOfConsciousness?: InputMaybe<Scalars['Boolean']>;
  cloudingOfConsciousnessText?: InputMaybe<Scalars['String']>;
  consciousnessConstriction?: InputMaybe<Scalars['Boolean']>;
  consciousnessConstrictionText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  shiftInConsciousness?: InputMaybe<Scalars['Boolean']>;
  shiftInConsciousnessText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ReactivateWoundRequest = {
  woundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ReactivateWoundResponse = {
  reactivatedWoundId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ReasonForAdmissionMsg = {
  /** If linked to an appointment otherwise empty */
  appointmentId?: InputMaybe<Scalars['String']>;
  diagnosisPresences?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisPresenceMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  previousExaminations?: InputMaybe<Array<InputMaybe<Input_Treatment_PreviousExaminationMsg>>>;
  previousExaminationsPresent?: InputMaybe<Scalars['Boolean']>;
  previousHistoryHtml?: InputMaybe<Scalars['String']>;
  previousTherapies?: InputMaybe<Array<InputMaybe<Input_Treatment_PreviousTherapyMsg>>>;
  previousTherapiesPresent?: InputMaybe<Scalars['Boolean']>;
  reasonsForAdmission?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  recorderType?: InputMaybe<Core_RecorderType>;
  symptomChangePresent?: InputMaybe<Scalars['Boolean']>;
  symptomChangeText?: InputMaybe<Scalars['String']>;
  symptomOccurrences?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
};

export type Input_Treatment_ReasonForCareAdmissionMsg = {
  id?: InputMaybe<Scalars['String']>;
  reasonForCareAdmission?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ReasonForPresentationMsg = {
  /** If linked to an appointment otherwise empty */
  appointmentId?: InputMaybe<Scalars['String']>;
  diagnosisDevelopments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisDevelopmentMsg>>>;
  diagnosisPresences?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisPresenceMsg>>>;
  /** false if follow-up */
  firstExamination?: InputMaybe<Scalars['Boolean']>;
  followUpExaminationText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  previousExaminations?: InputMaybe<Array<InputMaybe<Input_Treatment_PreviousExaminationMsg>>>;
  previousExaminationsPresent?: InputMaybe<Scalars['Boolean']>;
  previousHistory?: InputMaybe<Scalars['String']>;
  previousHistoryHtml?: InputMaybe<Scalars['String']>;
  previousTherapies?: InputMaybe<Array<InputMaybe<Input_Treatment_PreviousTherapyMsg>>>;
  previousTherapiesPresent?: InputMaybe<Scalars['Boolean']>;
  reasonsForPresentation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  recorderType?: InputMaybe<Core_RecorderType>;
  symptomChangePresent?: InputMaybe<Scalars['Boolean']>;
  symptomChangeText?: InputMaybe<Scalars['String']>;
  symptomOccurrences?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
};

export type Input_Treatment_ReassignDiagnosesRequest = {
  alsoReassignEditable?: InputMaybe<Scalars['Boolean']>;
  sourceAssignments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>>>;
  targets?: InputMaybe<Array<InputMaybe<Input_Treatment_ReassignDiagnosesTargetMsg>>>;
};

export type Input_Treatment_ReassignDiagnosesResponse = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
};

export type Input_Treatment_ReassignDiagnosesTargetMsg = {
  scopeId?: InputMaybe<Scalars['String']>;
  scopeType?: InputMaybe<Treatment_DiagnosisScopeType>;
};

export type Input_Treatment_RecentTravelsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  recentDestinations?: InputMaybe<Array<InputMaybe<Input_Treatment_TravelDestinationMsg>>>;
};

export type Input_Treatment_RelevantAnesthesiaComplicationInfoMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RelevantDiagnosisInfoMsg = {
  codes?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisCodingMsg>>>;
  description?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RelevantReasonForPresentationInfoMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RelevantSymptomInfoMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RemoveSymptomConfigurationRequest = {
  symptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RemoveSymptomConfigurationResponse = {
  removedSymptomConfigurationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RenalFistulaCatheterMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** unit: Charr */
  size?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_ResetAnamnesisBlockValidationRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  blockId?: InputMaybe<Scalars['String']>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_RespirationBlock = {
  respirationMeasurements?: InputMaybe<Array<InputMaybe<Input_Treatment_RespirationMsg>>>;
};

export type Input_Treatment_RespirationMsg = {
  depth?: InputMaybe<Treatment_RespiratoryDepthType>;
  id?: InputMaybe<Scalars['String']>;
  inspiratoryExpiratoryRatios?: InputMaybe<Array<InputMaybe<Treatment_InspiratoryExpiratoryRatio>>>;
  pulseOximetry?: InputMaybe<Scalars['Float']>;
  respirationFrequency?: InputMaybe<Scalars['Int']>;
  respirationFrequencyType?: InputMaybe<Treatment_RespirationFrequencyType>;
  rhythm?: InputMaybe<Treatment_RespiratoryRhythmType>;
  timeOfMeasurement?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_RestingElectrocardiographyMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_RevisedCardiacRiskIndexBlock = {
  /** Cerebrovascular Disease: <yes (1) / no (0)> */
  cerebrovascularDisease?: InputMaybe<Scalars['Boolean']>;
  /** Serum Creatinine >2 mg/dl or compensated renal insufficiency: <yes (1) / no (0)> */
  compensatedRenalInsufficiency?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Congestive Heart Failure: <yes (1) / no (0)> */
  congestiveHeartFailure?: InputMaybe<Scalars['Boolean']>;
  /** Coronary Artery Disease: <yes (1) / no (0)> */
  coronaryArteryDisease?: InputMaybe<Scalars['Boolean']>;
  /** Diabetes Mellitus on Insulin: <yes (1) / no (0)> */
  diabetesMellitusOnInsulin?: InputMaybe<Scalars['Boolean']>;
  /** High Risk Surgery: <yes (1) / no (0)> */
  highRiskSurgery?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_RiskFactorsMsg = {
  animalExposurePresent?: InputMaybe<Scalars['Boolean']>;
  animalExposureText?: InputMaybe<Scalars['String']>;
  consumedRawMilkProductsPresent?: InputMaybe<Scalars['Boolean']>;
  consumedRawMilkProductsText?: InputMaybe<Scalars['String']>;
  contactSickPresent?: InputMaybe<Scalars['Boolean']>;
  contactSickText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  malariaProphylaxisPresent?: InputMaybe<Scalars['Boolean']>;
  malariaProphylaxisText?: InputMaybe<Scalars['String']>;
  receivedBloodTransfusionPresent?: InputMaybe<Scalars['Boolean']>;
  receivedBloodTransfusions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  receivedBloodTransfusionsText?: InputMaybe<Scalars['String']>;
  sexualRiskContactsPresent?: InputMaybe<Scalars['Boolean']>;
  sexualRiskContactsText?: InputMaybe<Scalars['String']>;
  specialActivitiesPresent?: InputMaybe<Scalars['Boolean']>;
  specialActivitiesText?: InputMaybe<Scalars['String']>;
  visitsCavesPresent?: InputMaybe<Scalars['Boolean']>;
  visitsCavesText?: InputMaybe<Scalars['String']>;
};

/** Simplified Acute Physiology Score (SAPS) */
export type Input_Treatment_SapsBlock = {
  admissionType?: InputMaybe<Treatment_SapsAdmissionType>;
  age?: InputMaybe<Treatment_SapsAge>;
  chronicDisease?: InputMaybe<Treatment_SapsChronicDisease>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  heartRate?: InputMaybe<Treatment_SapsHeartRate>;
  pa02FiO2?: InputMaybe<Treatment_SapsPa02FiO2>;
  score?: InputMaybe<Scalars['Int']>;
  serumBicarbonate?: InputMaybe<Treatment_SapsSerumBicarbonate>;
  serumBilirubin?: InputMaybe<Treatment_SapsSerumBilirubin>;
  serumPotassium?: InputMaybe<Treatment_SapsSerumPotassium>;
  serumSodium?: InputMaybe<Treatment_SapsSerumSodium>;
  serumUrea?: InputMaybe<Treatment_SapsSerumUrea>;
  systolicBloodPressure?: InputMaybe<Treatment_SapsSystolicBloodPressure>;
  temperature?: InputMaybe<Treatment_SapsTemperature>;
  urineOutput?: InputMaybe<Treatment_SapsUrineOutput>;
  whiteBloodCellCount?: InputMaybe<Treatment_SapsWhiteBloodCellCount>;
};

export type Input_Treatment_ScoreBlockMsg = {
  blockId?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  scoreValues?: InputMaybe<Array<InputMaybe<Input_Treatment_ScoreValueMsg>>>;
  timestamps?: InputMaybe<Input_TimeMsg>;
};

export type Input_Treatment_ScoreValueMsg = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** fieldName = "score" by default for non-void types. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** if type = VOID then you should ignore the other fields. */
  scoreDataType?: InputMaybe<Treatment_ScoreDataType>;
  scoreFloat?: InputMaybe<Scalars['Float']>;
  scoreInt?: InputMaybe<Scalars['Int']>;
  scoreString?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ScreeningMsg = {
  bmi?: InputMaybe<Treatment_Bmi>;
  /** Has the patient eaten less during the last 3 months because of loss of appetite, digestive problems, difficulty chewing or swallowing? */
  eatingHabitLastThreeMonths?: InputMaybe<Treatment_EatingHabit>;
  /** Acute illness or psychological stress during the last 3 months?: < yes (0) / no (1)> */
  illnessOrStressLastThreeMonths?: InputMaybe<Scalars['Boolean']>;
  mobility?: InputMaybe<Treatment_Mobility>;
  neuropsychologicalProblems?: InputMaybe<Treatment_NeuropsychologicalProblems>;
  /** automatic addition of points based on entries above */
  screeningScore?: InputMaybe<Scalars['Int']>;
  /** weight loss in the last 3 months */
  weightLossLastThreeMonths?: InputMaybe<Treatment_WeightLoss>;
};

export type Input_Treatment_SearchPatientDiagnosesRequest = {
  patientId?: InputMaybe<Scalars['String']>;
  searchContext?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SectionMetadataMsg = {
  /** True if the cards that appear in the section are not fixed */
  dynamic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_SectionTemplateMsg = {
  cards?: InputMaybe<Array<InputMaybe<Input_Treatment_CardTemplateMsg>>>;
  number?: InputMaybe<Scalars['Int']>;
  shortcuts?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
};

export type Input_Treatment_SedationMsg = {
  airwayAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  airwayManagements?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  canPerformWithoutSedation?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ventilationTypes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SenseOfTasteBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  bitter?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  bitterText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  salty?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  saltyText?: InputMaybe<Scalars['String']>;
  senseOfTaste?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  sour?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  sourText?: InputMaybe<Scalars['String']>;
  sweet?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  sweetText?: InputMaybe<Scalars['String']>;
  tastePerception?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  tasteQualities?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_SensitivityBlock = {
  aesthesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  aesthesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  aesthesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
  algesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  algesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  algesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  pallaesthesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  pallaesthesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  pallaesthesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
  proprioception?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  proprioceptionText?: InputMaybe<Scalars['String']>;
  sensitivity?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thermaesthesia?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thermaesthesiaAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  thermaesthesiaAbnormalitiesText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SexLifeBlock = {
  erectileDysfunctionPresent?: InputMaybe<Scalars['Boolean']>;
  erectileDysfunctionText?: InputMaybe<Scalars['String']>;
  happySexLifePresent?: InputMaybe<Scalars['Boolean']>;
  happySexLifeText?: InputMaybe<Scalars['String']>;
  potencyEnhancingDrugsPresent?: InputMaybe<Scalars['Boolean']>;
  potencyEnhancingDrugsText?: InputMaybe<Scalars['String']>;
  problemsSexPresent?: InputMaybe<Scalars['Boolean']>;
  problemsSexText?: InputMaybe<Scalars['String']>;
  sexPartners?: InputMaybe<Array<InputMaybe<Treatment_Partners>>>;
  sexPartnersText?: InputMaybe<Scalars['String']>;
  sexualPractices?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ShoulderJointMsg = {
  abduction?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  elevation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  externalRotation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
  internalRotation?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
};

export type Input_Treatment_ShuntMsg = {
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  vessels?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SignVaccinationRequest = {
  vaccinationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SigstadBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
  /** multiselect */
  symptomList?: InputMaybe<Array<InputMaybe<Treatment_Symptom>>>;
};

export type Input_Treatment_SingleForceLevelAndDetailsMsg = {
  force?: InputMaybe<Scalars['Int']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SingleForceTestBlock = {
  elbowJoint?: InputMaybe<Input_Treatment_ElbowJointMsg>;
  fingerJoints?: InputMaybe<Input_Treatment_FingerJointsMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  headAndNeck?: InputMaybe<Input_Treatment_HeadAndNeckMsg>;
  hipJoints?: InputMaybe<Input_Treatment_HipJointMsg>;
  kneeJoint?: InputMaybe<Input_Treatment_KneeJointMsg>;
  lowerAnkleJoint?: InputMaybe<Input_Treatment_LowerAnkleJointMsg>;
  shoulderJoint?: InputMaybe<Input_Treatment_ShoulderJointMsg>;
  toeJoints?: InputMaybe<Input_Treatment_ToeJointsMsg>;
  upperAnkleJoint?: InputMaybe<Input_Treatment_UpperAnkleJointMsg>;
  wrist?: InputMaybe<Input_Treatment_WristMsg>;
};

export type Input_Treatment_SinusPalpationMsg = {
  id?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Treatment_SinusPercussionLocalization>;
  localizationText?: InputMaybe<Scalars['String']>;
  percussionType?: InputMaybe<Treatment_SinusPercussionType>;
};

export type Input_Treatment_SkinChangeBlock = {
  changeOverTime?: InputMaybe<Scalars['Boolean']>;
  changeOverTimeDescription?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  numberOfEpisodes?: InputMaybe<Scalars['Int']>;
  numberOfEpisodesResolution?: InputMaybe<Treatment_SkinChangeTime>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  timeOccurrence?: InputMaybe<Treatment_TimeOccurrence>;
  types?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SkinChangeExaminationsBlock = {
  abnormalitiesPresent?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  skinChanges?: InputMaybe<Array<InputMaybe<Input_Treatment_SkinChangeMsg>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SkinChangeMsg = {
  dermatoscopicDescription?: InputMaybe<Scalars['String']>;
  descriptionDataset?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  id?: InputMaybe<Scalars['String']>;
  imageSeriesId?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  macroscopicDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SkinColorBlock = {
  skinColors?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SkinStaplingClipMsg = {
  clips?: InputMaybe<Scalars['Int']>;
  recommendedRemovalDuration?: InputMaybe<Scalars['Int']>;
  recommendedRemovalDurationUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_SkinThicknessBlock = {
  skinThickness?: InputMaybe<Treatment_SkinThicknessType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SkinTurgorBlock = {
  skinTurgor?: InputMaybe<Treatment_SkinTurgorType>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SkullPalpationBlock = {
  examinationResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  examinationResultText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  orbitalRimStepFormationPresent?: InputMaybe<Scalars['Boolean']>;
  orbitalRimStepFormationText?: InputMaybe<Scalars['String']>;
  palpableBonyStepsPresent?: InputMaybe<Scalars['Boolean']>;
  palpableBonyStepsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_Sledai2KBlock = {
  alopecia?: InputMaybe<Treatment_Sledai2KAlopecia>;
  arthritis?: InputMaybe<Treatment_Sledai2KArthritis>;
  completed?: InputMaybe<Scalars['Boolean']>;
  cranialNerveDisorder?: InputMaybe<Treatment_Sledai2KCranialNerveDisorder>;
  cva?: InputMaybe<Treatment_Sledai2KCva>;
  fever?: InputMaybe<Treatment_Sledai2KFever>;
  hematuria?: InputMaybe<Treatment_Sledai2KHematuria>;
  increasedDnaBinding?: InputMaybe<Treatment_Sledai2KIncreasedDnaBinding>;
  leukopenia?: InputMaybe<Treatment_Sledai2KLeukopenia>;
  lowComplement?: InputMaybe<Treatment_Sledai2KLowComplement>;
  lupusHeadache?: InputMaybe<Treatment_Sledai2KLupusHeadache>;
  mucosalUlcers?: InputMaybe<Treatment_Sledai2KMucosalUlcers>;
  myositis?: InputMaybe<Treatment_Sledai2KMyositis>;
  organicBrainSyndrome?: InputMaybe<Treatment_Sledai2KOrganicBrainSyndrome>;
  pericarditis?: InputMaybe<Treatment_Sledai2KPericarditis>;
  pleurisy?: InputMaybe<Treatment_Sledai2KPleurisy>;
  proteinuria?: InputMaybe<Treatment_Sledai2KProteinuria>;
  psychosis?: InputMaybe<Treatment_Sledai2KPsychosis>;
  pyuria?: InputMaybe<Treatment_Sledai2KPyuria>;
  rash?: InputMaybe<Treatment_Sledai2KRash>;
  score?: InputMaybe<Scalars['Int']>;
  seizure?: InputMaybe<Treatment_Sledai2KSeizure>;
  thrombocytopenia?: InputMaybe<Treatment_Sledai2KThrombocytopenia>;
  urinaryCasts?: InputMaybe<Treatment_Sledai2KUrinaryCasts>;
  vasculitis?: InputMaybe<Treatment_Sledai2KVasculitis>;
  visualDisturbance?: InputMaybe<Treatment_Sledai2KVisualDisturbance>;
};

export type Input_Treatment_SleepApneaMsg = {
  feelingOfSuffocation?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  observedRespiratoryCessation?: InputMaybe<Scalars['Boolean']>;
  startling?: InputMaybe<Scalars['Boolean']>;
  sufficientAirThroughNose?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_SleepDisorderBlock = {
  details?: InputMaybe<Input_Treatment_SleepDisorderDetailsMsg>;
  furtherClassification?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  sleepApnea?: InputMaybe<Input_Treatment_SleepApneaMsg>;
  sleepApneaPresent?: InputMaybe<Scalars['Boolean']>;
  sleepDisturbancePresent?: InputMaybe<Scalars['Boolean']>;
  sleepDisturbances?: InputMaybe<Array<InputMaybe<Treatment_SleepDisturbance>>>;
  sleepMovement?: InputMaybe<Input_Treatment_SleepMovementMsg>;
  sleepMovementPresent?: InputMaybe<Scalars['Boolean']>;
  /** From 1 (bad) to 10 (good) */
  sleepQuality?: InputMaybe<Scalars['Int']>;
  snoring?: InputMaybe<Input_Treatment_SnoringMsg>;
  snoringPresent?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_SleepDisorderDetailsMsg = {
  awakeAtNightDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  awakingTime?: InputMaybe<Input_TimeOfDayMsg>;
  bedTime?: InputMaybe<Input_TimeOfDayMsg>;
  decreasedPerformance?: InputMaybe<Scalars['Boolean']>;
  decreasedSexualDesire?: InputMaybe<Scalars['Boolean']>;
  erectileDysfunction?: InputMaybe<Scalars['Boolean']>;
  exhaustionDespiteSleep?: InputMaybe<Scalars['Boolean']>;
  fallAsleepDuringDay?: InputMaybe<Scalars['Boolean']>;
  fallingAsleepDuration?: InputMaybe<Input_VeiosTimeSpanMsg>;
  id?: InputMaybe<Scalars['String']>;
  impairedConcentrationOrMemory?: InputMaybe<Scalars['Boolean']>;
  microsleepWhileDriving?: InputMaybe<Scalars['Boolean']>;
  morningHeadache?: InputMaybe<Scalars['Boolean']>;
  nightlyUrinationFrequency?: InputMaybe<Scalars['Int']>;
  nocturnalUrinationUrge?: InputMaybe<Scalars['Boolean']>;
  recentWeightLoss?: InputMaybe<Scalars['Boolean']>;
  talkingInSleep?: InputMaybe<Scalars['Boolean']>;
  talkingInSleepDescription?: InputMaybe<Scalars['String']>;
  /** in kg */
  weightLoss?: InputMaybe<Scalars['Float']>;
  weightLossTimeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  workInShifts?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_SleepMovementMsg = {
  flappingMovement?: InputMaybe<Scalars['Boolean']>;
  flappingMovementDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legMovement?: InputMaybe<Scalars['Boolean']>;
  legMovementDescription?: InputMaybe<Scalars['String']>;
  legTinglingOrPain?: InputMaybe<Scalars['Boolean']>;
  legTinglingOrPainDescription?: InputMaybe<Scalars['String']>;
  tossingAndTurning?: InputMaybe<Scalars['Boolean']>;
  tossingAndTurningDescription?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SnoringMsg = {
  id?: InputMaybe<Scalars['String']>;
  partnerDisturbed?: InputMaybe<Array<InputMaybe<Treatment_PartnerDisturbed>>>;
  partnerDisturbedDescription?: InputMaybe<Scalars['String']>;
  snoringRhythm?: InputMaybe<Treatment_SnoringRhythm>;
  /** From 1 (silent) to 10 (loud) */
  snoringVolume?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_SocialActivitiesMsg = {
  activitySatisfactionWithCondition?: InputMaybe<Treatment_ActivitySatisfactionWithCondition>;
  hobbiesStatus?: InputMaybe<Treatment_HobbiesStatus>;
  interestsDevelopment?: InputMaybe<Treatment_InterestsDevelopment>;
  leavingHome?: InputMaybe<Treatment_LeavingHome>;
  occupation?: InputMaybe<Scalars['String']>;
  petsStatus?: InputMaybe<Treatment_PetsStatus>;
  socialActivitiesScore?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_SocialContactsAndSupportMsg = {
  caregivers?: InputMaybe<Treatment_Caregivers>;
  contactSatisfactionWithCondition?: InputMaybe<Treatment_ContactSatisfactionWithCondition>;
  contactWithCaregiver?: InputMaybe<Treatment_ContactWithCaregiver>;
  developmentOfContacts?: InputMaybe<Treatment_DevelopmentOfContacts>;
  livingCircumstances?: InputMaybe<Treatment_LivingCircumstances>;
  relationshipWithCaregiver?: InputMaybe<Treatment_RelationshipWithCaregiver>;
  socialContactsAndSupportScore?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_SofaBlock = {
  bilirubin?: InputMaybe<Treatment_SofaBilirubin>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  creatinine?: InputMaybe<Treatment_SofaCreatinine>;
  glasgowComaScale?: InputMaybe<Treatment_SofaGlasgowComaScale>;
  meanArterialPressure?: InputMaybe<Treatment_SofaMeanArterialPressure>;
  oxygenationIndex?: InputMaybe<Treatment_SofaOxygenationIndex>;
  platelets?: InputMaybe<Treatment_SofaPlatelets>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_SoftTissueEmphysemMsg = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locationInput?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SoftTissueEmphysemaBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  softTissueEmphysema?: InputMaybe<Array<InputMaybe<Input_Treatment_SoftTissueEmphysemMsg>>>;
};

export type Input_Treatment_SpeakingBlock = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_SpeakingDescriptionMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  speaking?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_SpeakingDescriptionMsg = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpecialRespiratoryFeaturesBlock = {
  breathingSounds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  breathingSoundsPresent?: InputMaybe<Scalars['Boolean']>;
  cyanosis?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  cyanosisPresent?: InputMaybe<Scalars['Boolean']>;
  dyspnea?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  dyspneaPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  specialBreathingPatterns?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  specialBreathingPatternsPresent?: InputMaybe<Scalars['Boolean']>;
  tidalAirSmells?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  tidalAirSmellsResult?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_SpecificEarsBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpecificEyesBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpecificNoseAndSinusBlock = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpeechBlock = {
  aphasia?: InputMaybe<Scalars['Boolean']>;
  aphasiaDescriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  aphasiaText?: InputMaybe<Scalars['String']>;
  flowOfSpeech?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  flowOfSpeechAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  flowOfSpeechText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  naming?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  namingText?: InputMaybe<Scalars['String']>;
  repeating?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  repeatingText?: InputMaybe<Scalars['String']>;
  speech?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  speechComprehension?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  speechComprehensionText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpineAgilityBlock = {
  movementPainPresent?: InputMaybe<Scalars['Boolean']>;
  movementPainText?: InputMaybe<Scalars['String']>;
  restrictionOfMovementPresent?: InputMaybe<Scalars['Boolean']>;
  restrictionOfMovementText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpineInfiltrationIndicationMsg = {
  painBeforeInjection?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpineInfiltrationMsg = {
  cortisone?: InputMaybe<Input_Treatment_CortisoneMsg>;
  cortisonePresent?: InputMaybe<Scalars['Boolean']>;
  facetInfiltration?: InputMaybe<Input_Treatment_FacetInfiltrationMsg>;
  facetInfiltrationPresent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  indication?: InputMaybe<Input_Treatment_SpineInfiltrationIndicationMsg>;
  localAnesthetic?: InputMaybe<Input_Treatment_LocalAnestheticMsg>;
  nerveRootBlock?: InputMaybe<Input_Treatment_NerveRootBlockMsg>;
  nerveRootBlockPresent?: InputMaybe<Scalars['Boolean']>;
  neurologicalExaminationAfterInfiltration?: InputMaybe<Input_Treatment_NeurologicalExaminationMsg>;
  neurologicalExaminationBeforeInfiltration?: InputMaybe<Input_Treatment_NeurologicalExaminationMsg>;
  /** most likely will be replaced by formId in the future */
  painQuestionnaireAfterInjection?: InputMaybe<Input_Treatment_PainQuestionnaireMsg>;
  periduralInjections?: InputMaybe<Input_Treatment_PeriduralInjectionsMsg>;
};

export type Input_Treatment_SpinePalpationBlock = {
  abnormalitiesPresent?: InputMaybe<Scalars['Boolean']>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SpinePercussionBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_SpleenPalpationBlock = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  spleenPalpable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_SportMsg = {
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyReference?: InputMaybe<Treatment_SportFrequencyReference>;
  id?: InputMaybe<Scalars['String']>;
  occurringProblems?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SportsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  sports?: InputMaybe<Array<InputMaybe<Input_Treatment_SportMsg>>>;
};

export type Input_Treatment_StaffelsteinHipBlock = {
  abduction?: InputMaybe<Treatment_Abduction>;
  completed?: InputMaybe<Scalars['Boolean']>;
  extensionDeficit?: InputMaybe<Treatment_HipExtensionDeficit>;
  flexion?: InputMaybe<Treatment_Flexion>;
  gettingUp?: InputMaybe<Treatment_GettingUp>;
  glutealMuscleStrength?: InputMaybe<Treatment_GlutealMuscleStrength>;
  hygiene?: InputMaybe<Treatment_Hygiene>;
  limp?: InputMaybe<Treatment_Limp>;
  pain?: InputMaybe<Treatment_StaffelsteinPain>;
  publicTransportation?: InputMaybe<Treatment_PublicTransportation>;
  score?: InputMaybe<Scalars['Int']>;
  shoesOrSocks?: InputMaybe<Treatment_ShoesOrSocks>;
  stairsDifficulty?: InputMaybe<Treatment_StairsDifficulty>;
  walkingAids?: InputMaybe<Treatment_WalkingAids>;
  walkingDistance?: InputMaybe<Treatment_HipWalkingDistance>;
};

export type Input_Treatment_StaffelsteinKneeBlock = {
  /** without difficulty (5) /with difficulty and use of handrail (3) /with great difficulty or not possible (0) */
  climbingStairs?: InputMaybe<Treatment_DifficultySelect>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** 0° (10) / 5°-15° (5) / ≥20° (0) */
  extensionDeficit?: InputMaybe<Treatment_KneeExtensionDeficit>;
  /** ≥100° (10) / 75°-95° (5) / ≤70° (0) */
  flexion?: InputMaybe<Treatment_Flexion>;
  /** without difficulty (5) /with little assistance (3) /dependent (great difficulty) */
  gettingUpFromBedAndChair?: InputMaybe<Treatment_DifficultySelect>;
  /** fluent gait (5) /mild to moderate (3) /severe (0) */
  limp?: InputMaybe<Treatment_Limp>;
  /**
   * no pain during activities of daily living (40)
   * /mild, occasional or subthreshold pain that does not affect activities of daily living (30)
   * /moderate pain, possibly with analgesic use (20)
   * /pain significantly interferes with work and activities of daily living, constant need for analgesics (10)
   * /severe pain, patient severely restricted or immobile (0)
   */
  pain?: InputMaybe<Treatment_StaffelsteinPain>;
  /** without difficulty (5) /with little assistance (3) /dependent (0) (with great difficulty / not possible) */
  personalAndToiletHygiene?: InputMaybe<Treatment_DifficultySelect>;
  publicTransportation?: InputMaybe<Treatment_PublicTransportation>;
  /** without difficulty (5) /with difficulty (3) /not possible (0) */
  puttingOnSocksOrShoes?: InputMaybe<Treatment_DifficultySelect>;
  /** 4/5 - 5/5 (10) / 3/5 (5) / 1/5 - 2/5 (0) */
  quadricepsMuscleStrength?: InputMaybe<Treatment_QuadricepsMuscleStrength>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** unremarkable (10) / periarticular swelling (5) / significant intraarticular effusion (0) */
  softTissueFindings?: InputMaybe<Treatment_SoftTissueFindings>;
  /** none (5) /forearm crutches, walking stick (4) /rollator, walking frame (3) / wheelchair (2) / bedridden (0) */
  walkingAids?: InputMaybe<Treatment_WalkingAids>;
  /** unlimited (5) /walking at a stretch from 50m to 500m possible (4) /walking at a stretch to 50m possible (4) /mobile in room (2) /immobile (5) */
  walkingDistance?: InputMaybe<Treatment_KneeWalkingDistance>;
};

export type Input_Treatment_StandbyMsg = {
  airwayAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  airwayManagements?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ventilationTypes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_StdRiskBlock = {
  numberPartnersLastMonth?: InputMaybe<Scalars['Int']>;
  numberPartnersLastSixMonth?: InputMaybe<Scalars['Int']>;
  numberPartnersLifetime?: InputMaybe<Scalars['Int']>;
  stdProtections?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  stdRiskFactorsPresent?: InputMaybe<Scalars['Boolean']>;
  stdRiskFactorsText?: InputMaybe<Scalars['String']>;
  stdTestsPresent?: InputMaybe<Scalars['Boolean']>;
  stdTestsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_StoolDescriptionMsg = {
  defecationPain?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  defecationPainPresent?: InputMaybe<Scalars['Boolean']>;
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  evaluationText?: InputMaybe<Scalars['String']>;
  fecalContinenceDescription?: InputMaybe<Scalars['String']>;
  fecalContinencePresent?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['Int']>;
  frequencyResolution?: InputMaybe<Treatment_DefecationResolution>;
  id?: InputMaybe<Scalars['String']>;
  lastDefecation?: InputMaybe<Input_VeiosDateTimeMsg>;
  qualities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_StopBangRiskBlock = {
  /** Age >50 years: <yes (1) / no (0)> */
  ageGreaterThan50?: InputMaybe<Scalars['Boolean']>;
  /** BMI >35 kg/m2: <yes (1) / no (0)> */
  bmiGreaterThan35?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** High blood pressure or current treatment for hypertension: <yes (1) / no (0)> */
  highBloodPressure?: InputMaybe<Scalars['Boolean']>;
  /** Loud snoring: <yes (1) / no (0)> */
  loudSnoring?: InputMaybe<Scalars['Boolean']>;
  /** Male: <yes (1) / no (0)> */
  male?: InputMaybe<Scalars['Boolean']>;
  /** Neck circumference >40 cm: <yes (1) / no (0)> */
  neckCircumferenceGreaterThan40?: InputMaybe<Scalars['Boolean']>;
  /** Often fatigue or sleepiness during the daytime: <yes (1) / no (0)> */
  oftenFatigue?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** Observed to stop breathing during sleep: <yes (1) / no (0)> */
  stopBreathingDuringSleep?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_SuctionTimeIntervalMsg = {
  duration?: InputMaybe<Scalars['Int']>;
  durationTimeUnit?: InputMaybe<TimeUnit>;
  repetitionCycle?: InputMaybe<Scalars['Int']>;
  repetitionCycleTimeUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_SurgeryPreparationMsg = {
  diagnosesDevelopments?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosesDevelopmentMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  previousHistoryHtml?: InputMaybe<Scalars['String']>;
  symptomOccurrences?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
};

export type Input_Treatment_SurgicalScarMsg = {
  dateOfOperation?: InputMaybe<Input_VeiosDateTimeMsg>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Float']>;
  localizationsInput?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  nameOfOperation?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SurgicalScarsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  surgicalScars?: InputMaybe<Array<InputMaybe<Input_Treatment_SurgicalScarMsg>>>;
};

export type Input_Treatment_SutureRemovalMsg = {
  recommendedRemovalDuration?: InputMaybe<Scalars['Int']>;
  recommendedRemovalDurationUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_SutureThreadMsg = {
  resobabilityType?: InputMaybe<Treatment_SutureThreadResobabilityType>;
  /** unit:USP */
  sutureThreadSize?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  sutureThreads?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SwellingLimbsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
  swellings?: InputMaybe<Array<InputMaybe<Input_Treatment_SwellingLimbsMsg>>>;
};

export type Input_Treatment_SwellingLimbsMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_SymptomConfigurationMsg = {
  /** Blocks that are related to this SymptomConfiguration */
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
  conditionDevelopment?: InputMaybe<Treatment_ConditionDevelopment>;
  /** For when this entry applies */
  date?: InputMaybe<Input_Timestamp>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  owner?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  symptom?: InputMaybe<Input_Treatment_SymptomMsg>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
  versionInfo?: InputMaybe<Input_Versioning_VersionInfoMsg>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SymptomConfigurationVersionGroupMsg = {
  symptomConfigurations?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomConfigurationMsg>>>;
  versioningGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SymptomMsg = {
  generalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_SymptomOccurrenceMsg = {
  blocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AnamnesisBlockMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  symptoms?: InputMaybe<Array<InputMaybe<Input_Treatment_SymptomMsg>>>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_TakeOverTherapyCardEditableRevisionRequest = {
  revisionGroupId?: InputMaybe<Scalars['String']>;
  therapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TakeOverTherapyCardEditableRevisionResponse = {
  card?: InputMaybe<Input_Treatment_TherapyCardMsg>;
};

export type Input_Treatment_TemperatureAnamnesticBlock = {
  temperatureMeasurements?: InputMaybe<Array<InputMaybe<Input_Treatment_TemperatureAnamnesticMsg>>>;
};

export type Input_Treatment_TemperatureAnamnesticMsg = {
  id?: InputMaybe<Scalars['String']>;
  locationOfMeasurement?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  temperature?: InputMaybe<Scalars['Float']>;
  timeOfMeasurement?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_TemperatureBlock = {
  temperaturMeasurements?: InputMaybe<Array<InputMaybe<Input_Treatment_TemperatureMsg>>>;
};

export type Input_Treatment_TemperatureMsg = {
  id?: InputMaybe<Scalars['String']>;
  locationOfMeasurement?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  temperature?: InputMaybe<Scalars['Float']>;
  timeOfMeasurement?: InputMaybe<Input_VeiosDateTimeMsg>;
};

export type Input_Treatment_TherapistMsg = {
  id?: InputMaybe<Scalars['String']>;
  medicalSpecialtyIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  /** Allows to gender: "Facharzt/Fachärztin für ..." */
  sex?: InputMaybe<Core_Sex>;
  /**
   * can be name etc.
   *  TODO: more structure needed?
   */
  text?: InputMaybe<Scalars['String']>;
  /** If the therapist has already been entered as practitioner in the system, this id can be used to retrieve the information */
  therapistId?: InputMaybe<Input_Core_PersonReferenceMsg>;
};

export type Input_Treatment_TherapyCardContentMsg = {
  cryotherapy?: InputMaybe<Input_Treatment_CryotherapyMsg>;
  echocardiography?: InputMaybe<Input_Treatment_EchocardiographyMsg>;
  /** anesthetic procedures */
  generalAnesthesia?: InputMaybe<Input_Treatment_GeneralAnesthesiaMsg>;
  laryngoscopy?: InputMaybe<Input_Treatment_LaryngoscopyMsg>;
  localAnaesthesia?: InputMaybe<Input_Treatment_LocalAnaesthesiaMsg>;
  miscExamination?: InputMaybe<Input_Treatment_MiscellaneousExaminationMsg>;
  miscTherapy?: InputMaybe<Input_Treatment_MiscellaneousTherapyMsg>;
  namedProcedure?: InputMaybe<Input_Treatment_NamedProcedureMsg>;
  neuraxialAnesthesia?: InputMaybe<Input_Treatment_NeuraxialAnesthesiaMsg>;
  peripheralAnesthesia?: InputMaybe<Input_Treatment_PeripheralAnesthesiaMsg>;
  peritonealPuncture?: InputMaybe<Input_Treatment_PeritonealPunctureMsg>;
  pleuralPuncture?: InputMaybe<Input_Treatment_PleuralPunctureMsg>;
  restingElectrocardiography?: InputMaybe<Input_Treatment_RestingElectrocardiographyMsg>;
  sedation?: InputMaybe<Input_Treatment_SedationMsg>;
  spineInfiltration?: InputMaybe<Input_Treatment_SpineInfiltrationMsg>;
  standby?: InputMaybe<Input_Treatment_StandbyMsg>;
  ultrasound?: InputMaybe<Input_Treatment_UltrasoundMsg>;
  woundDebridement?: InputMaybe<Input_Treatment_WoundDebridementMsg>;
  woundSkinStapling?: InputMaybe<Input_Treatment_WoundSkinStaplingMsg>;
  woundSuture?: InputMaybe<Input_Treatment_WoundSutureMsg>;
  woundTreatment?: InputMaybe<Input_Treatment_WoundTreatmentMsg>;
  woundVacuumTherapy?: InputMaybe<Input_Treatment_WoundVacuumTherapyMsg>;
};

export type Input_Treatment_TherapyCardMetadataListElementMsg = {
  cardMetadata?: InputMaybe<Input_Treatment_TherapyCardMetadataMsg>;
  /** The name of the named procedure if this element corresponds to a NamedProcedure */
  name?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TherapyCardMetadataMsg = {
  forms?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyFormMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  /** tells us if there are multiple therapies in one card */
  singleton?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Treatment_TherapyCardMetadataTag>>>;
};

export type Input_Treatment_TherapyCardMsg = {
  content?: InputMaybe<Input_Treatment_TherapyCardContentMsg>;
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_TherapyCardLocation>;
  metadata?: InputMaybe<Input_Treatment_TherapyCardMetadataMsg>;
  participatingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  /** can be null/empty */
  therapyId?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
};

export type Input_Treatment_TherapyCardTemplateMsg = {
  /** Only relevant for NamedProcedureMsg: Content of the NamedProcedureMsg gets auto-filled with this when this template is selected. */
  content?: InputMaybe<Scalars['String']>;
  create?: InputMaybe<Scalars['Boolean']>;
  /** only relevant for NamedProcedureMsg */
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_TherapyFormMsg = {
  id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TherapyMsg = {
  context?: InputMaybe<Input_Treatment_MedicalItemContextMsg>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Treatment_TherapyLocation>;
  therapies?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardMsg>>>;
  therapyTemplate?: InputMaybe<Input_Treatment_TherapyTemplateMsg>;
  treatmentEvaluationText?: InputMaybe<Scalars['String']>;
  /** can be empty/null */
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TherapyTemplateMsg = {
  cards?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardTemplateMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  ownerOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** The type of treatment that this template is used for */
  type?: InputMaybe<Treatment_TreatmentType>;
  version?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_ThoracicSpineJointsMsg = {
  /** Th1/Th2 */
  th1Th2?: InputMaybe<Laterality_Laterality>;
  /** Th2/Th3 */
  th2Th3?: InputMaybe<Laterality_Laterality>;
  /** Th3/Th4 */
  th3Th4?: InputMaybe<Laterality_Laterality>;
  /** Th4/Th5 */
  th4Th5?: InputMaybe<Laterality_Laterality>;
  /** Th5/Th6 */
  th5Th6?: InputMaybe<Laterality_Laterality>;
  /** Th6/Th7 */
  th6Th7?: InputMaybe<Laterality_Laterality>;
  /** Th7/Th8 */
  th7Th8?: InputMaybe<Laterality_Laterality>;
  /** Th8/Th9 */
  th8Th9?: InputMaybe<Laterality_Laterality>;
  /** Th9/Th10 */
  th9Th10?: InputMaybe<Laterality_Laterality>;
  /** Th10/Th11 */
  th10Th11?: InputMaybe<Laterality_Laterality>;
  /** Th11/Th12 */
  th11Th12?: InputMaybe<Laterality_Laterality>;
  /** Th12/L1 */
  th12L1?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_ThoracicSpineMsg = {
  th1?: InputMaybe<Laterality_Laterality>;
  th2?: InputMaybe<Laterality_Laterality>;
  th3?: InputMaybe<Laterality_Laterality>;
  th4?: InputMaybe<Laterality_Laterality>;
  th5?: InputMaybe<Laterality_Laterality>;
  th6?: InputMaybe<Laterality_Laterality>;
  th7?: InputMaybe<Laterality_Laterality>;
  th8?: InputMaybe<Laterality_Laterality>;
  th9?: InputMaybe<Laterality_Laterality>;
  th10?: InputMaybe<Laterality_Laterality>;
  th11?: InputMaybe<Laterality_Laterality>;
  th12?: InputMaybe<Laterality_Laterality>;
};

export type Input_Treatment_ThoraxDrainageMsg = {
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  suction?: InputMaybe<Scalars['Float']>;
  suctionUnit?: InputMaybe<Treatment_SuctionUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_ThoraxFormBlock = {
  text?: InputMaybe<Scalars['String']>;
  thoraxForm?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  thoraxForms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ThoraxSkinChangeBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ThyreomentalDistanceMsg = {
  /** one decimal, unit: cm */
  distance?: InputMaybe<Scalars['Float']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ThyroidExaminationDetailMsg = {
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ThyroidExaminationMsg = {
  details?: InputMaybe<Array<InputMaybe<Input_Treatment_ThyroidExaminationDetailMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  textIfInconspicuous?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ThyroidInspectionAndPalpationAndAuscultationBlock = {
  auscultation?: InputMaybe<Input_Treatment_ThyroidExaminationMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<Input_Treatment_ThyroidExaminationMsg>;
  palpation?: InputMaybe<Input_Treatment_ThyroidExaminationMsg>;
  strumaGrading?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_TimedUpAndGoTestBlock = {
  completed?: InputMaybe<Scalars['Boolean']>;
  testTimeSelection?: InputMaybe<Treatment_TestTimeSelection>;
};

export type Input_Treatment_TinettiMobilityTestBlock = {
  balanceTest?: InputMaybe<Input_Treatment_BalanceTestMsg>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  gaitTest?: InputMaybe<Input_Treatment_GaitTestMsg>;
  score?: InputMaybe<Scalars['Int']>;
};

/** Therapeutic Intervention Scoring System (TISS) */
export type Input_Treatment_TissBlock = {
  /** Actions outside the ward (diagnostics / surgery): <yes (5) / no (0)> */
  actionsOutsideTheWard?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** controlled ventilation: <yes (5) / no (0)> */
  controlledVentilation?: InputMaybe<Scalars['Boolean']>;
  /** Fluid replacement in high volumes (>5 l/24 hr): <yes (4) / no (0)> */
  fluidReplacementInHighVolumes?: InputMaybe<Scalars['Boolean']>;
  /** Hemofiltration / dialysis: <yes (3) / no (0)> */
  hemofilterationDialysis?: InputMaybe<Scalars['Boolean']>;
  /** Infusion of multiple catecholamines (>1): <yes (4) / no (0)> */
  infusionOfMultipleCatecholamines?: InputMaybe<Scalars['Boolean']>;
  /** Intracranial pressure measurement: <yes (4) / no (0)> */
  intracranialPressureMeasurement?: InputMaybe<Scalars['Boolean']>;
  /** Left atrial catheter / pulmonary catheter: <yes (8) / no (0)> */
  leftAtrialPulmonaryCatheter?: InputMaybe<Scalars['Boolean']>;
  /** Peripheral arterial catheter: <yes (5) / no (0)> */
  peripheralArterialCatheter?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** Special interventions in the ITS (e.g., tracheostomy, cardioversion): <yes (5) / no (0)> */
  specialInterventionsInTheITS?: InputMaybe<Scalars['Boolean']>;
  /** Treatment of metabolic acidosis/alkalosis: <yes (4) / no (0)> */
  treatmentOfMetabolicAcidosisAlkalosis?: InputMaybe<Scalars['Boolean']>;
};

/** Therapeutic Intervention Scoring System (TISS) Children */
export type Input_Treatment_TissChildrenBlock = {
  /** Actions outside the ICU requiring transport: <yes (5) / no (0)> */
  actionsOutsideIcu?: InputMaybe<Scalars['Boolean']>;
  admissionStatus?: InputMaybe<Treatment_AdmissionStatus>;
  age?: InputMaybe<Treatment_TissChildrenAge>;
  /** Apparative ventilation including any form of CPAP: <yes (5) / no (0)> */
  apparativeVentilation?: InputMaybe<Scalars['Boolean']>;
  /** Catheters (non-transurethral or suprapubic bladder catheter): <yes (4) / no (0)> */
  catheters?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  creatinine?: InputMaybe<Treatment_TissChildrenCreatinine>;
  /** Dialysis: <yes (6) / no (0)> */
  dialysis?: InputMaybe<Scalars['Boolean']>;
  /** Fluid replacement > 3,000 ml/m2KOF /24h: <yes (4) / no (0)> */
  fluidReplacementGreaterThan3K?: InputMaybe<Scalars['Boolean']>;
  glasgowComaScale?: InputMaybe<Treatment_GlasgowComaScale>;
  got?: InputMaybe<Treatment_Got>;
  heartRate?: InputMaybe<Treatment_TissChildrenHeartRate>;
  /** Infusion of >1 catecholamine or PDE III inhibitor or vasopressor: <yes (4) / no (0)> */
  infusionOfGreaterThanOneCatecholamine?: InputMaybe<Scalars['Boolean']>;
  /** Intracranial pressure measurement (invasive procedure): <yes (4) / no (0)> */
  intracranialPressureMeasurement?: InputMaybe<Scalars['Boolean']>;
  /** Invasive circulatory monitoring: <yes (5) / no (0)> */
  invasiveCirculatoryMonitoring?: InputMaybe<Scalars['Boolean']>;
  leukocytes?: InputMaybe<Treatment_TissChildrenLeukocytes>;
  pa02FiO2?: InputMaybe<Treatment_TissChildrenPa02FiO2>;
  paCo2?: InputMaybe<Treatment_TissChildrenPaCo2>;
  platelets?: InputMaybe<Treatment_TissChildrenPlatelets>;
  preExistingConditions?: InputMaybe<Treatment_PreExistingConditions>;
  prothrombinTimeByQuick?: InputMaybe<Treatment_ProthrombinTimeByQuick>;
  pupillaryResponse?: InputMaybe<Treatment_PupillaryResponse>;
  score?: InputMaybe<Scalars['Int']>;
  /** Special interventions in the intensive care unit: <yes (8) / no (0)> */
  specialInterventionsInIntensiveCare?: InputMaybe<Scalars['Boolean']>;
  standardBaseExcess?: InputMaybe<Treatment_TissChildrenStandardBaseExcess>;
  systolicBloodPressure?: InputMaybe<Treatment_TissChildrenSystolicBloodPressure>;
  /** Therapy of alkalosis or acidosis: <yes (4) / no (0)> */
  therapyOfAlkalosisOrAcidosis?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_ToeJointsMsg = {
  bigToeExtension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TongueMotorSkillsBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  tongueMotorSkills?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_ToothStatusDescriptionMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  statuses?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_ToothStatusMsg = {
  descriptions?: InputMaybe<Array<InputMaybe<Input_Treatment_ToothStatusDescriptionMsg>>>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  toothStatus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_TracheaPositionBlock = {
  tracheaPosition?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_TracheostomyBlock = {
  afterTracheostomy?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  pastTracheostomies?: InputMaybe<Array<InputMaybe<Input_Treatment_PastTracheostomyDetailsMsg>>>;
  present?: InputMaybe<Scalars['Boolean']>;
  tracheostomyTubeSizes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  tracheostomyTubeTypes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_TravelDestinationMsg = {
  destinationIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  mainPreTravelInformationSource?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  receivedPreTravelInformationPresent?: InputMaybe<Scalars['Boolean']>;
  riskFactorsQuestionnaire?: InputMaybe<Input_Treatment_RiskFactorsMsg>;
  text?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
  transportMeans?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  travelReason?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_TreatmentBasicInfoMsg = {
  id?: InputMaybe<Scalars['String']>;
  treatmentDetails?: InputMaybe<Input_Treatment_TreatmentDetailsMsg>;
};

export type Input_Treatment_TreatmentComponentDescriptionMsg = {
  description?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Core_Language>;
};

/** Defines the default structure of a treatment in the given administrative unit */
export type Input_Treatment_TreatmentConfigurationMsg = {
  activeSteps?: InputMaybe<Array<InputMaybe<Treatment_TreatmentStep>>>;
  id?: InputMaybe<Scalars['String']>;
  ownerOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  /** The type of treatment that this configuration is used for */
  type?: InputMaybe<Treatment_TreatmentType>;
  version?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_TreatmentDetailsMsg = {
  /** When the treatment was aborted, empty if not aborted */
  abortedAt?: InputMaybe<Input_Timestamp>;
  /** User who aborted the treatment, empty if not aborted or auto-aborted */
  abortingUserId?: InputMaybe<Scalars['String']>;
  clinicalRequestExecutionId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Input_Treatment_TreatmentDurationMsg>;
  /** Whether the treatment was aborted by force, usually by someone outside of the treatment's organizational unit */
  forcedAbortion?: InputMaybe<Scalars['Boolean']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Users participating in the treatment */
  participatingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  patientId?: InputMaybe<Scalars['String']>;
  /** Specifies the reason in case the treatment was aborted */
  reasonForAbortion?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_TreatmentStatus>;
  surgeryId?: InputMaybe<Scalars['String']>;
  /** Start and end of the treatment, manually documented */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  type?: InputMaybe<Treatment_TreatmentType>;
  /** Reference to the user who conducts the treatment, typically a doctor */
  userId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TreatmentDetailsUpdateRequest = {
  /** Set this when "re-finishing" an already finished treatment to allow for activation of modified activated information */
  confirmFinish?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Input_Treatment_TreatmentDurationMsg>;
  /** should be set to true to force treatment abortion */
  forceAbortion?: InputMaybe<Scalars['Boolean']>;
  /** Users participating in the treatment */
  participatingUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Relevant only if the status is set to aborted */
  reasonForAbortion?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_TreatmentStatus>;
  /** Start and end of the treatment, manually documented */
  timeFrame?: InputMaybe<Input_TimeFrameMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TreatmentDurationMsg = {
  duration?: InputMaybe<Scalars['Int']>;
  durationUnit?: InputMaybe<TimeUnit>;
};

export type Input_Treatment_TreatmentMsg = {
  anamnesis?: InputMaybe<Input_Treatment_AnamnesisMsg>;
  configuration?: InputMaybe<Input_Treatment_TreatmentConfigurationMsg>;
  fieldMask?: InputMaybe<Input_FieldMask>;
  furtherProcedures?: InputMaybe<Input_Treatment_FurtherProceduresMsg>;
  id?: InputMaybe<Scalars['String']>;
  physicalExamination?: InputMaybe<Input_Treatment_PhysicalExaminationMsg>;
  therapy?: InputMaybe<Input_Treatment_TherapyMsg>;
  treatmentDetails?: InputMaybe<Input_Treatment_TreatmentDetailsMsg>;
  vaccinations?: InputMaybe<Array<InputMaybe<Input_Treatment_VaccinationMsg>>>;
};

export type Input_Treatment_TreatmentStatusInfoMsg = {
  status?: InputMaybe<Treatment_TreatmentStatus>;
  timestamps?: InputMaybe<Input_TimeMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TreatmentTemplateMsg = {
  id?: InputMaybe<Scalars['String']>;
  ownerOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<Input_Treatment_SectionTemplateMsg>>>;
  shortcuts?: InputMaybe<Array<InputMaybe<Input_Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: InputMaybe<Treatment_TreatmentType>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Direct use of enum in SchemaModification causes error */
export type Input_Treatment_TreatmentTypeMsg = {
  treatmentType?: InputMaybe<Treatment_TreatmentType>;
};

export type Input_Treatment_TrichoscopyBlock = {
  caliberJumps?: InputMaybe<Scalars['Boolean']>;
  caliberJumpsText?: InputMaybe<Scalars['String']>;
  miniaturizedHair?: InputMaybe<Scalars['Boolean']>;
  miniaturizedHairText?: InputMaybe<Scalars['String']>;
  peladHair?: InputMaybe<Scalars['Boolean']>;
  peladHairText?: InputMaybe<Scalars['String']>;
  perifollicularScaling?: InputMaybe<Scalars['Boolean']>;
  perifollicularScalingText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  tuftHair?: InputMaybe<Scalars['Boolean']>;
  tuftHairText?: InputMaybe<Scalars['String']>;
  yellowDots?: InputMaybe<Scalars['Boolean']>;
  yellowDotsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_TrunkPasiMsg = {
  trunkBodyRegionPercentage?: InputMaybe<Treatment_BodyRegionPercentage>;
  trunkDiscoloration?: InputMaybe<Treatment_PasiSelection>;
  trunkScaling?: InputMaybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.3> */
  trunkScore?: InputMaybe<Scalars['Float']>;
  trunkThickness?: InputMaybe<Treatment_PasiSelection>;
};

export type Input_Treatment_TumorInformationMsg = {
  /** G */
  grading?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** N */
  lymphNode?: InputMaybe<Scalars['String']>;
  lymphNodeSuffix1?: InputMaybe<Scalars['Int']>;
  lymphNodeSuffix2?: InputMaybe<Scalars['Int']>;
  lymphNodeSuffixSentinel?: InputMaybe<Scalars['String']>;
  /** L */
  lymphaticVesselInvasion?: InputMaybe<Scalars['String']>;
  /** M */
  metastases?: InputMaybe<Scalars['String']>;
  metastasesPrefix?: InputMaybe<Scalars['String']>;
  metastasesSuffix?: InputMaybe<Scalars['String']>;
  /** Pn */
  perineuralInvasion?: InputMaybe<Scalars['String']>;
  /** prefix */
  prefix?: InputMaybe<Scalars['String']>;
  prefixLymphNode?: InputMaybe<Scalars['String']>;
  prefixTumorSize?: InputMaybe<Scalars['String']>;
  /** R */
  residualStatus?: InputMaybe<Scalars['String']>;
  /** S */
  serumTumorMarkers?: InputMaybe<Scalars['String']>;
  /** T */
  tumorSize?: InputMaybe<Scalars['String']>;
  /** V */
  veinInvasion?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UltrasoundMsg = {
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UpdateAllergyRequest = {
  allergy?: InputMaybe<Input_Treatment_AllergyAndIntoleranceMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateAnamnesisBlockRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  block?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  commitId?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<Scalars['String']>;
  disableBlockAutoValidation?: InputMaybe<Scalars['Boolean']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchUpdateTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_UpdateAnamnesisBlockResponse = {
  /**
   * If we added/removed symptoms in a reason for presentation block,
   *  that may have caused other blocks to be updated accordingly
   */
  autoUpdatedCards?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedProblemSpecificAnamnesisCardReasonInfo>>>;
  block?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
  id?: InputMaybe<Scalars['String']>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_UpdateAnamnesisBlockStatusRequest = {
  anamnesisBlockId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
};

export type Input_Treatment_UpdateAnamnesisBlockStatusResponse = {
  anamnesisBlock?: InputMaybe<Input_Treatment_AnamnesisBlockMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardAnamnesticProgressRequest = {
  anamnesticProgress?: InputMaybe<Input_Treatment_AnamnesticProgressMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardAnamnesticProgressResponse = {
  anamnesticProgress?: InputMaybe<Input_Treatment_AnamnesticProgressMsg>;
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardAnesthesiaBackgroundRequest = {
  anesthesiaBackground?: InputMaybe<Input_Treatment_AnesthesiaBackgroundMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardAnesthesiaBackgroundResponse = {
  anesthesiaBackground?: InputMaybe<Input_Treatment_AnesthesiaBackgroundMsg>;
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonForAdmissionRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  reasonForAdmission?: InputMaybe<Input_Treatment_ReasonForAdmissionMsg>;
  /** default false; setting this to true triggers a subscription publish updating the frontend in realtime */
  systemUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonForAdmissionResponse = {
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
  reasonForAdmission?: InputMaybe<Input_Treatment_ReasonForAdmissionMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonForCareAdmissionRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  reasonForCareAdmission?: InputMaybe<Input_Treatment_ReasonForCareAdmissionMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonForCareAdmissionResponse = {
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
  reasonForCareAdmission?: InputMaybe<Input_Treatment_ReasonForCareAdmissionMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  reason?: InputMaybe<Input_Treatment_ReasonForPresentationMsg>;
  /** default false; setting this to true triggers a subscription publish updating the frontend in realtime */
  systemUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_UpdateAnamnesisCardReasonResponse = {
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
  reasonForPresentation?: InputMaybe<Input_Treatment_ReasonForPresentationMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardSurgeryPreparationRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  surgeryPreparation?: InputMaybe<Input_Treatment_SurgeryPreparationMsg>;
};

export type Input_Treatment_UpdateAnamnesisCardSurgeryPreparationResponse = {
  autoUpdatedBlocks?: InputMaybe<Array<InputMaybe<Input_Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: InputMaybe<Input_Treatment_AnamnesisCardMsg>;
  surgeryPreparation?: InputMaybe<Input_Treatment_SurgeryPreparationMsg>;
};

export type Input_Treatment_UpdateAnamnesisStatusRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
};

export type Input_Treatment_UpdateAnamnesisStatusResponse = {
  anamnesis?: InputMaybe<Input_Treatment_AnamnesisMsg>;
};

export type Input_Treatment_UpdateChecklistElementRequest = {
  checklistElement?: InputMaybe<Input_Treatment_ChecklistElementMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateChecklistElementStatusesRequest = {
  checklistId?: InputMaybe<Scalars['String']>;
  targetStatus?: InputMaybe<Treatment_ChecklistElementStatus>;
};

export type Input_Treatment_UpdateChecklistElementStatusesResponse = {
  checklistElements?: InputMaybe<Array<InputMaybe<Input_Treatment_ChecklistElementMsg>>>;
};

export type Input_Treatment_UpdateClinicalRecommendationRequest = {
  clinicalRecommendation?: InputMaybe<Input_Treatment_ClinicalRecommendationMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateClinicalRecommendationResponse = {
  clinicalRecommendationId?: InputMaybe<Scalars['String']>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<Input_Treatment_ClinicalRecommendationMsg>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_UpdateDefaultFluidBalanceConfigurationRequest = {
  defaultConfiguration?: InputMaybe<Input_Treatment_DefaultFluidBalanceConfigurationMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateDiagnosesAssignmentsRequest = {
  requests?: InputMaybe<Array<InputMaybe<Input_Treatment_UpdateDiagnosisAssignmentRequest>>>;
};

export type Input_Treatment_UpdateDiagnosesAssignmentsResponse = {
  responses?: InputMaybe<Array<InputMaybe<Input_Treatment_UpdateDiagnosisAssignmentResponse>>>;
};

export type Input_Treatment_UpdateDiagnosisAssignmentRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
  /** To un-assign, set the category to NONE */
  targetCategoryAssignment?: InputMaybe<Input_Treatment_DiagnosisCategoryAssignmentMsg>;
};

export type Input_Treatment_UpdateDiagnosisAssignmentResponse = {
  deletedDiagnosisId?: InputMaybe<Scalars['String']>;
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_UpdateDiagnosisCodingRequest = {
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosisCoding?: InputMaybe<Input_Treatment_DiagnosisCodingMsg>;
  diagnosisId?: InputMaybe<Scalars['String']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateDiagnosisCodingResponse = {
  diagnosisCoding?: InputMaybe<Input_Treatment_DiagnosisCodingMsg>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: InputMaybe<Scalars['String']>;
  updatedDiagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_UpdateDiagnosisRequest = {
  /**
   * If true, ensures none of the diagnosis' existing codes are kept; they are all replaced by the ones from the update.
   *  Needed because patch update does not support deletion and creation in the same update
   */
  clearExistingCodes?: InputMaybe<Scalars['Boolean']>;
  context?: InputMaybe<Input_Treatment_DiagnosisAccessContextMsg>;
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateDiagnosisResponse = {
  diagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
  /** Set if the update triggered creation of a new version */
  replacedDiagnosis?: InputMaybe<Input_Treatment_DiagnosisMsg>;
};

export type Input_Treatment_UpdateFluidFlowRequest = {
  /**
   * If there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: InputMaybe<Scalars['Boolean']>;
  fluidFlow?: InputMaybe<Input_Treatment_FluidFlowMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  /**
   * If there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: InputMaybe<Scalars['Boolean']>;
  /**
   * when updating a fluid flow system, its version direction is assumed to be revision
   *  due to them being only revisioned
   */
  versioningDirection?: InputMaybe<Versioning_VersioningDirection>;
};

export type Input_Treatment_UpdateFluidFlowSystemRequest = {
  /**
   * if there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: InputMaybe<Scalars['Boolean']>;
  fluidFlowSystem?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: InputMaybe<Scalars['Boolean']>;
  /**
   * when updating a fluid flow system, its version direction is assumed to be revision
   *  due to them being only revisioned
   */
  versioningDirection?: InputMaybe<Versioning_VersioningDirection>;
};

export type Input_Treatment_UpdateFurtherProceduresResponse = {
  furtherProcedures?: InputMaybe<Input_Treatment_FurtherProceduresMsg>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  procedureId?: InputMaybe<Scalars['String']>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_UpdateImmunityTestRequest = {
  immunityTest?: InputMaybe<Input_Treatment_ImmunityTestMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdatePatientFluidBalanceConfigurationRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  patientConfiguration?: InputMaybe<Input_Treatment_PatientFluidBalanceConfigurationMsg>;
};

export type Input_Treatment_UpdatePhysicalBlockRequest = {
  block?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  commitId?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<Scalars['String']>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchUpdateTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  physicalId?: InputMaybe<Scalars['String']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_UpdatePhysicalBlockResponse = {
  block?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
  id?: InputMaybe<Scalars['String']>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_UpdatePhysicalBlockStatusRequest = {
  physicalBlockId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
};

export type Input_Treatment_UpdatePhysicalBlockStatusResponse = {
  physicalBlock?: InputMaybe<Input_Treatment_PhysicalBlockMsg>;
};

export type Input_Treatment_UpdatePhysicalExaminationStatusRequest = {
  physicalExaminationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
};

export type Input_Treatment_UpdatePhysicalExaminationStatusResponse = {
  physicalExamination?: InputMaybe<Input_Treatment_PhysicalExaminationMsg>;
};

export type Input_Treatment_UpdatePhysicalPresetRequest = {
  overrideDefault?: InputMaybe<Scalars['Boolean']>;
  preset?: InputMaybe<Input_Treatment_PhysicalPresetMsg>;
};

export type Input_Treatment_UpdateSymptomConfigurationRequest = {
  parameters?: InputMaybe<Input_Versioning_VersionedEntityCreationParametersMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  symptomConfiguration?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
  versioningDirection?: InputMaybe<Versioning_VersioningDirection>;
};

export type Input_Treatment_UpdateSymptomConfigurationResponse = {
  /** Set if the update triggered creation of a new version, this is the old version that shouldn't be displayed in that treatment anymore */
  replacedSymptomConfiguration?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
  symptomConfiguration?: InputMaybe<Input_Treatment_SymptomConfigurationMsg>;
};

export type Input_Treatment_UpdateTherapyCardRequest = {
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: InputMaybe<Scalars['Boolean']>;
  card?: InputMaybe<Input_Treatment_TherapyCardMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_UpdateTherapyCardResponse = {
  id?: InputMaybe<Scalars['String']>;
  inMemory?: InputMaybe<Scalars['Boolean']>;
  persisted?: InputMaybe<Scalars['Boolean']>;
  therapyCard?: InputMaybe<Input_Treatment_TherapyCardMsg>;
  /** result of BlockUpdate validation */
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_Treatment_UpdateTherapyCardStatusRequest = {
  immediatelyActivate?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Treatment_MedicalItemStatus>;
  therapyCardId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UpdateTherapyCardStatusResponse = {
  therapyCard?: InputMaybe<Input_Treatment_TherapyCardMsg>;
};

export type Input_Treatment_UpdateTherapyStatusRequest = {
  status?: InputMaybe<Treatment_MedicalItemStatus>;
  therapyId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UpdateTherapyStatusResponse = {
  therapy?: InputMaybe<Input_Treatment_TherapyMsg>;
};

export type Input_Treatment_UpdateTreatmentEvaluationRequest = {
  therapyId?: InputMaybe<Scalars['String']>;
  treatmentEvaluationText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UpdateTreatmentEvaluationResponse = {
  treatmentEvaluationText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UpdateVaccinationDiseaseRequest = {
  disease?: InputMaybe<Input_Treatment_VaccinationRelevantDiseaseMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
};

export type Input_Treatment_UpdateVaccinationRequest = {
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  vaccination?: InputMaybe<Input_Treatment_VaccinationMsg>;
};

export type Input_Treatment_UpdateWoundRequest = {
  parameters?: InputMaybe<Input_Versioning_VersionedEntityCreationParametersMsg>;
  patch?: InputMaybe<Scalars['Boolean']>;
  patchTree?: InputMaybe<Input_Core_PatchUpdateTreeRootMsg>;
  versioningDirection?: InputMaybe<Versioning_VersioningDirection>;
  wound?: InputMaybe<Input_Treatment_WoundMsg>;
};

export type Input_Treatment_UpdrsBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  motorAspectsOfDailyLiving?: InputMaybe<Input_Treatment_MotorAspectsOfDailyLivingMsg>;
  motorComplications?: InputMaybe<Input_Treatment_MotorComplicationsMsg>;
  motorExamination?: InputMaybe<Input_Treatment_MotorExaminationMsg>;
  nonMotorAspectsOfDailyLiving?: InputMaybe<Input_Treatment_NonMotorAspectsOfDailyLivingMsg>;
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_UpperAnkleJointMsg = {
  dorsalExtension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  id?: InputMaybe<Scalars['String']>;
  plantarFlexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
};

export type Input_Treatment_UpperLimbsPasiMsg = {
  upperLimbsBodyRegionPercentage?: InputMaybe<Treatment_BodyRegionPercentage>;
  upperLimbsDiscoloration?: InputMaybe<Treatment_PasiSelection>;
  upperLimbsScaling?: InputMaybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.2> */
  upperLimbsScore?: InputMaybe<Scalars['Float']>;
  upperLimbsThickness?: InputMaybe<Treatment_PasiSelection>;
};

export type Input_Treatment_UpperLipBiteTestBlock = {
  score?: InputMaybe<Scalars['Int']>;
  upperLipBiteTestSelection?: InputMaybe<Treatment_UpperLipBiteTestSelection>;
};

export type Input_Treatment_UrinaryBladderBlock = {
  palpationUrinaryBladder?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_UrinaryCatheterMsg = {
  materials?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_VaccinationDiseaseList = {
  diseases?: InputMaybe<Array<InputMaybe<Input_Treatment_VaccinationRelevantDiseaseMsg>>>;
};

export type Input_Treatment_VaccinationList = {
  patientId?: InputMaybe<Scalars['String']>;
  vaccinations?: InputMaybe<Array<InputMaybe<Input_Treatment_VaccinationMsg>>>;
};

export type Input_Treatment_VaccinationMsg = {
  /** Alternative to entering all data from previous vaccinations: just set this */
  basicImmunizationCompleted?: InputMaybe<Scalars['Boolean']>;
  bodyPartId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  /** Fixed legal disclaimer */
  disclaimer?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<Treatment_VaccinationEntryType>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_Treatment_ExternalVaccinationIdMsg>>>;
  externalVaccinationDetails?: InputMaybe<Input_Treatment_ExternalSourceMsg>;
  /** Dates at which a follow-up vaccination is required */
  followUpDates?: InputMaybe<Array<InputMaybe<Input_VeiosDateTimeMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  /** Path by which the vaccine is taken into the body */
  intakeRouteId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  notes?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<Scalars['String']>;
  /** True if vaccination was administered as part of the treatment */
  primarySource?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Input_Treatment_VaccinationQuantityMsg>;
  /** When the vaccination was recorded in this system */
  recordDate?: InputMaybe<Input_Timestamp>;
  registeringUserId?: InputMaybe<Scalars['String']>;
  responsibleUserId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Treatment_VaccinationStatus>;
  vaccinationDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  /** Diseases which the vaccination is aimed at */
  vaccinationTargetIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  vaccine?: InputMaybe<Input_Treatment_VaccineMsg>;
};

/** TODO: Rather use standardized QuantityMsg? */
export type Input_Treatment_VaccinationQuantityMsg = {
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Core_Unit>;
};

/**
 * A disease that a patient had against which vaccinations are administered.
 *  Can influence when/whether a vaccination is required, depending on the immunity level reached by having the disease.
 */
export type Input_Treatment_VaccinationRelevantDiseaseMsg = {
  diseaseId?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  externalInformationDetails?: InputMaybe<Input_Treatment_ExternalSourceMsg>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** False if information was provided from an external source */
  primarySource?: InputMaybe<Scalars['Boolean']>;
  recordDate?: InputMaybe<Input_Timestamp>;
  registeringUserId?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_VaccinationsBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_VaccineMsg = {
  batch?: InputMaybe<Scalars['String']>;
  drugLink?: InputMaybe<Input_Drug_DrugLinkMsg>;
  expirationDate?: InputMaybe<Input_VeiosDateTimeMsg>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_VacuumTherapySystemMsg = {
  connectedWoundVersionGroupId?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  suctionRate?: InputMaybe<Scalars['Int']>;
  /** TODO we need to check for the correctness of the data type */
  suctionTimeInterval?: InputMaybe<Input_Treatment_FluidFlowSystemTimePeriodMsg>;
  /** if type = continually then suctionTimeInterval.offset should be equal to null */
  suctionTimeIntervalType?: InputMaybe<Treatment_SuctionTimeIntervalType>;
  suctionUnit?: InputMaybe<Treatment_SuctionUnit>;
};

export type Input_Treatment_ValidateAnamnesisBlockRequest = {
  anamnesisId?: InputMaybe<Scalars['String']>;
  blockId?: InputMaybe<Scalars['String']>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  cardNumber?: InputMaybe<Scalars['Int']>;
  sectionNumber?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_ValidateImmunityTestRequest = {
  immunityTestId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ValidateVaccinationDiseaseRequest = {
  diseaseId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ValidateVaccinationRequest = {
  vaccinationId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_ValidationRequestMsg = {
  validateAllSubLevels?: InputMaybe<Scalars['Boolean']>;
  validateThisLevel?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_VaricosisBlock = {
  text?: InputMaybe<Scalars['String']>;
  varicosisPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_VentricularDrainageMsg = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_VerbalRatingScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  severitySelection?: InputMaybe<Treatment_SeveritySelection>;
};

export type Input_Treatment_VertigoBlock = {
  directions?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  furtherClassification?: InputMaybe<Input_Treatment_VertigoDetailsMsg>;
  furtherClassificationPresent?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  onsetType?: InputMaybe<Treatment_SymptomOnsetType>;
  paroxysmalVertigo?: InputMaybe<Input_Treatment_ParoxysmalVertigoMsg>;
  present?: InputMaybe<Scalars['Boolean']>;
  timeFrame?: InputMaybe<Input_VeiosTimeFrameMsg>;
};

export type Input_Treatment_VertigoDetailsMsg = {
  description?: InputMaybe<Scalars['String']>;
  dizzyInMorningAfterGettingUp?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  increasedVertigoTime?: InputMaybe<Treatment_IncreasedVertigoTime>;
  positionalDependences?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  seeingStartsWhenGettingUp?: InputMaybe<Scalars['Boolean']>;
  triggers?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  unsteadyGait?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_VigilanceBlock = {
  text?: InputMaybe<Scalars['String']>;
  vigilance?: InputMaybe<Treatment_VigilanceType>;
};

export type Input_Treatment_VisitDiagnosesList = {
  diagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  idPair?: InputMaybe<Input_Treatment_VisitPatientIdPairMsg>;
  /** kept separately for FE backwards compatibility */
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_VisitPatientIdPairMsg = {
  patientId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_VisualAcuityBlock = {
  abnormalityLeftText?: InputMaybe<Scalars['String']>;
  abnormalityRightText?: InputMaybe<Scalars['String']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  simpleVisualAcuityTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Input_Treatment_VisualAnalogueScaleBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  severitySlider?: InputMaybe<Treatment_SeveritySlider>;
};

export type Input_Treatment_VisualFieldAndVisualAttentionBlock = {
  fingerPerimetricVisualFieldTest?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  leftAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  leftAbnormalitiesText?: InputMaybe<Scalars['String']>;
  overallAssessment?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  overallAssessmentText?: InputMaybe<Scalars['String']>;
  rightAbnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  rightAbnormalitiesText?: InputMaybe<Scalars['String']>;
  testForVisualExtinction?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  testForVisualExtinctionText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_VocalCordImmobilityDetailsMsg = {
  immobility?: InputMaybe<Treatment_VocalCordImmobility>;
  paresis?: InputMaybe<Treatment_VocalCordParesis>;
};

export type Input_Treatment_VocalFremitusBlock = {
  abnormalities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  vocalFremitus?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
};

/** https://veioscom.sharepoint.com/:x:/r/sites/product/_layouts/15/Doc.aspx?sourcedoc=%7B9D898CC3-81F6-4EB1-8F8D-6AA67CBC8E69%7D&file=20230415_DataSet_Wagner-Armstrong_diab.%20foot.xlsx&action=default&mobileredirect=true */
export type Input_Treatment_WagnerArmstrongClassificationBlock = {
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  wagnerArmstrongInput?: InputMaybe<Treatment_WagnerArmstrongInput>;
};

export type Input_Treatment_WarScoreBlock = {
  /** Acquired immunodeficiency due to pharmacotherapy such as ciclosporin, methotrexate, glucocorticoids, antibodies: <yes (1) / no (0)> */
  acquiredImmunodeficiencyDueToPharmacotherapy?: InputMaybe<Scalars['Boolean']>;
  /** Acquired immunosuppressive disease (e.g., diabetes mellitus): <yes (1) / no (0)> */
  acquiredImmunosuppressiveDisease?: InputMaybe<Scalars['Boolean']>;
  /** Patient age >80 years : <yes (1) / no (0)> */
  ageGreaterThan80?: InputMaybe<Scalars['Boolean']>;
  /** Burn wounds with involvement of >15% body surface area (BSA): <yes (3) / no (0)> */
  burnWoundsWithInvolvement15PercentOfBsa?: InputMaybe<Scalars['Boolean']>;
  /** Chronic wounds of any aetiology with a depth >1,5 cm: <yes (1) / no (0)> */
  chronicWoundsDepthGreaterThan1Point5Cm?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Difficult hygienic conditions due to social or professional environment (e.g., farmer, truck driver): <yes (1) / no (0)> */
  difficultHygienicConditions?: InputMaybe<Scalars['Boolean']>;
  /** Extended inpatient status >3 weeks: <yes (1) / no (0)> */
  extendedInpatientStatusMoreThan3Weeks?: InputMaybe<Scalars['Boolean']>;
  /** Heavily contaminated acute wounds: <yes (2) / no (0)> */
  heavilyContaminatedAcuteWounds?: InputMaybe<Scalars['Boolean']>;
  /** Postsurgical wound healing disorder which results in (unplanned) healing by secondary intention: <yes (1) / no (0)> */
  postsurgicalWoundHealingDisorder?: InputMaybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: InputMaybe<Scalars['Int']>;
  /** Severe acquired immunodeficiency (e.g., HIV infection): <yes (2) / no (0)> */
  severeAcquiredImmunodeficiency?: InputMaybe<Scalars['Boolean']>;
  /** Severe congenital immunodeficiency such as agammaglobulinaemia, severe combined immunodeficiency (SCID): <yes (3) / no (0)> */
  severeCongenitalImmunodeficiency?: InputMaybe<Scalars['Boolean']>;
  /** Solid tumour disease: <yes (1) / no (0)> */
  solidTumorDisease?: InputMaybe<Scalars['Boolean']>;
  /** Systemic haematological disease: <yes (1) / no (0)> */
  systemicHaematologicalDisease?: InputMaybe<Scalars['Boolean']>;
  /** Wound dimensions >10 cm2: <yes (1) / no (0)> */
  woundDimensionsGreaterThan10?: InputMaybe<Scalars['Boolean']>;
  /** Wound persisting for >1 year: <yes (1) / no (0)> */
  woundPersistingForGreaterThanOneYear?: InputMaybe<Scalars['Boolean']>;
  /** Wounds exposed to high bacterial loads due to localization (e.g., perineum, genitals): <yes (1) / no (0)> */
  woundsExposedToHighBacterialLoads?: InputMaybe<Scalars['Boolean']>;
  /** Bite, stab or gunshot wounds penetrating 1,5-3,5 cm: <yes (2) / no (0)> */
  woundsPenetratingBetween1Point5And3Point5Cm?: InputMaybe<Scalars['Boolean']>;
  /** Bite, stab or gunshot wounds penetrating >3,5 cm: <yes (3) / no (0)> */
  woundsPenetratingMoreThan3Point5Cm?: InputMaybe<Scalars['Boolean']>;
  /** Wounds that have a direct connection to organs or functional structures (e.g. including joints) or which contain foreign material: <yes (3) / no (0)> */
  woundsWithDirectConnectionToOrgans?: InputMaybe<Scalars['Boolean']>;
  /** Young age of patient (premature infants, babies, young children): <yes (1) / no (0)> */
  youngAgeOfPatient?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_WellsIBlock = {
  /** Clinical signs of deep vein thrombosis:  yes (3) / no (0) */
  clinicalSignsOfDeepVeinThrombosis?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Heart rate >100/min: yes (1.5) / no (0) */
  exceedHeartRate?: InputMaybe<Scalars['Boolean']>;
  /** Hemoptysis: yes (1) / no (0) */
  hemoptysis?: InputMaybe<Scalars['Boolean']>;
  /** Pulmonary embolism more likely than alternative diagnosis: yes (3) / no (0) */
  likelyPulmonaryEmbolism?: InputMaybe<Scalars['Boolean']>;
  /** Malignancy: yes (1) / no (0) */
  malignancy?: InputMaybe<Scalars['Boolean']>;
  /** Previous pulmonary embolism or deep vein thrombosis: yes (1.5) / no (0) */
  previousPulmonaryEmbolism?: InputMaybe<Scalars['Boolean']>;
  /** Recent surgery or immobilization: yes (1.5) / no (0) */
  recentSurgery?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_WellsIiBlock = {
  /** Clinical signs of deep vein thrombosis: yes (1) / no (0) */
  clinicalSignsOfDeepVeinThrombosis?: InputMaybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Heart rate >100/min: yes (1) / no (0) */
  exceedHeartRate?: InputMaybe<Scalars['Boolean']>;
  /** Hemoptysis: yes (1) / no (0) */
  hemoptysis?: InputMaybe<Scalars['Boolean']>;
  /** Pulmonary embolism more likely than alternative diagnosis: yes (1) / no (0) */
  likelyPulmonaryEmbolism?: InputMaybe<Scalars['Boolean']>;
  /** Malignancy: yes (1) / no (0) */
  malignancy?: InputMaybe<Scalars['Boolean']>;
  /** Previous pulmonary embolism or deep vein thrombosis: yes (1) / no (0) */
  previousPulmonaryEmbolism?: InputMaybe<Scalars['Boolean']>;
  /** Recent surgery or immobilization: yes (1) / no (0) */
  recentSurgery?: InputMaybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: InputMaybe<Scalars['Int']>;
};

export type Input_Treatment_WoundAnamnesisMsg = {
  connectedDiagnoses?: InputMaybe<Array<InputMaybe<Input_Treatment_DiagnosisMsg>>>;
  placesOfOrigin?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  recurrenceAmount?: InputMaybe<Scalars['Int']>;
  /** recurrence */
  recurrencePresent?: InputMaybe<Scalars['Boolean']>;
  woundAids?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundDate?: InputMaybe<Input_Timestamp>;
  woundDiagnostics?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundTherapies?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_WoundContextReferenceMsg = {
  patientId?: InputMaybe<Scalars['String']>;
  treatmentId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Treatment_WoundContextType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundDebridementMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  localAnesthesia?: InputMaybe<Input_Treatment_WoundLocalAnesthesiaMsg>;
  woundCleanings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundCompression?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  woundCoverings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundPads?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundRinsings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundTamponades?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_WoundDrainageMsg = {
  connectedWoundVersionGroupId?: InputMaybe<Scalars['String']>;
  localization?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Scalars['Float']>;
  sizeUnit?: InputMaybe<Treatment_FlowSystemSizeUnit>;
  type?: InputMaybe<Input_Core_KnowledgeInputMsg>;
};

export type Input_Treatment_WoundExaminationBlock = {
  present?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_WoundExudateMsg = {
  exudatePresent?: InputMaybe<Scalars['Boolean']>;
  exudateQualities?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  exudateQuantity?: InputMaybe<Treatment_ExudateQuantity>;
};

export type Input_Treatment_WoundGroundMsg = {
  groundConspicuous?: InputMaybe<Scalars['Boolean']>;
  groundText?: InputMaybe<Scalars['String']>;
  grounds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_WoundInfectionSignsMsg = {
  infectionSigns?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  infectionSignsPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_WoundList = {
  wounds?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundMsg>>>;
};

export type Input_Treatment_WoundLocalAnesthesiaMsg = {
  drugLink?: InputMaybe<Input_Drug_DrugLinkMsg>;
  /** non-negative; unit: ml */
  localAnaesthesiaVolume?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_WoundMarginExcisionMsg = {
  excisionPresent?: InputMaybe<Scalars['Boolean']>;
  excisionText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundMarginMsg = {
  marginText?: InputMaybe<Scalars['String']>;
  margins?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  marginsConspicuous?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_WoundMsg = {
  advancedWoundTherapies?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  anamnesis?: InputMaybe<Input_Treatment_WoundAnamnesisMsg>;
  ceapClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  chronicWound?: InputMaybe<Scalars['Boolean']>;
  connectedFlowSystems?: InputMaybe<Array<InputMaybe<Input_Treatment_FluidFlowSystemMsg>>>;
  decubitusClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  description?: InputMaybe<Scalars['String']>;
  /** use it for first documentation date */
  documentationDate?: InputMaybe<Input_Timestamp>;
  exudate?: InputMaybe<Input_Treatment_WoundExudateMsg>;
  fontaineClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  ground?: InputMaybe<Input_Treatment_WoundGroundMsg>;
  healed?: InputMaybe<Scalars['Boolean']>;
  /** use it for first documentation date */
  healingDate?: InputMaybe<Input_Timestamp>;
  healingProgress?: InputMaybe<Treatment_WoundHealingProgress>;
  id?: InputMaybe<Scalars['String']>;
  imageSeriesId?: InputMaybe<Scalars['String']>;
  infectionSigns?: InputMaybe<Input_Treatment_WoundInfectionSignsMsg>;
  localizations?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  margin?: InputMaybe<Input_Treatment_WoundMarginMsg>;
  odor?: InputMaybe<Input_Treatment_WoundOdorMsg>;
  pain?: InputMaybe<Input_Treatment_WoundPainMsg>;
  patientId?: InputMaybe<Scalars['String']>;
  rutherfordClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  size?: InputMaybe<Input_Treatment_WoundSizeMsg>;
  surroundings?: InputMaybe<Input_Treatment_WoundSurroundingsMsg>;
  tascClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  treatmentId?: InputMaybe<Scalars['String']>;
  undermining?: InputMaybe<Input_Treatment_WoundUnderminingMsg>;
  versionInfo?: InputMaybe<Input_Versioning_VersionInfoMsg>;
  visitId?: InputMaybe<Scalars['String']>;
  wagnerDiabeticFootUlcerClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  widmerClassification?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  woundHealingFactors?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundStage?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  woundSymptoms?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundTypes?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

export type Input_Treatment_WoundOdorMsg = {
  odorPresent?: InputMaybe<Scalars['Boolean']>;
  odorText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundPainMsg = {
  /** range: 1-10; unit: NRS */
  painLevel?: InputMaybe<Scalars['Int']>;
  painPresent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_Treatment_WoundProcedureGroupMsg = {
  therapyCards?: InputMaybe<Array<InputMaybe<Input_Treatment_TherapyCardMsg>>>;
  woundVersionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundSizeMsg = {
  /** Calculated area in cm² */
  area?: InputMaybe<Scalars['Float']>;
  /** in cm */
  depth?: InputMaybe<Scalars['Float']>;
  /** in cm */
  diameter?: InputMaybe<Scalars['Float']>;
  /** in cm */
  length?: InputMaybe<Scalars['Float']>;
  /** in cm */
  width?: InputMaybe<Scalars['Float']>;
};

export type Input_Treatment_WoundSkinGlueMsg = {
  skinGlue?: InputMaybe<Scalars['Boolean']>;
  skinGlueText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundSkinStaplingMsg = {
  clip?: InputMaybe<Input_Treatment_SkinStaplingClipMsg>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  localAnesthesia?: InputMaybe<Input_Treatment_WoundLocalAnesthesiaMsg>;
  skinGlue?: InputMaybe<Input_Treatment_WoundSkinGlueMsg>;
  woundCleanings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundMarginExcision?: InputMaybe<Input_Treatment_WoundMarginExcisionMsg>;
  woundRinsings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_WoundSurroundingsMsg = {
  surroundings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  surroundingsConspicuous?: InputMaybe<Scalars['Boolean']>;
  surroundingsText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundSutureMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  localAnesthesia?: InputMaybe<Input_Treatment_WoundLocalAnesthesiaMsg>;
  methodType?: InputMaybe<Treatment_WoundSutureMethodType>;
  skinGlue?: InputMaybe<Input_Treatment_WoundSkinGlueMsg>;
  /** non-negative integers */
  stitches?: InputMaybe<Scalars['Int']>;
  sutureRemoval?: InputMaybe<Input_Treatment_SutureRemovalMsg>;
  sutureTechniques?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  sutureThread?: InputMaybe<Input_Treatment_SutureThreadMsg>;
  woundCleanings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundMarginExcision?: InputMaybe<Input_Treatment_WoundMarginExcisionMsg>;
  woundRinsings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_WoundTreatmentMsg = {
  furtherDetails?: InputMaybe<Scalars['String']>;
  woundCleanings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundCompression?: InputMaybe<Input_Core_KnowledgeInputMsg>;
  woundCoverings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundRinsings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundTamponades?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_WoundUnderminingMsg = {
  /** TODO: Data type? */
  underminingLocales?: InputMaybe<Array<InputMaybe<Treatment_UnderminingLocale>>>;
  underminingPresent?: InputMaybe<Scalars['Boolean']>;
  underminingText?: InputMaybe<Scalars['String']>;
};

export type Input_Treatment_WoundVacuumTherapyMsg = {
  actionType?: InputMaybe<Treatment_WoundVacuumTherapyActionType>;
  connectedFlowSystem?: InputMaybe<Input_Treatment_FluidFlowSystemMsg>;
  debridement?: InputMaybe<Scalars['Boolean']>;
  furtherDetails?: InputMaybe<Scalars['String']>;
  localAnesthesia?: InputMaybe<Input_Treatment_WoundLocalAnesthesiaMsg>;
  suctionRate?: InputMaybe<Scalars['Int']>;
  suctionTimeInterval?: InputMaybe<Input_Treatment_SuctionTimeIntervalMsg>;
  suctionTimeIntervalType?: InputMaybe<Treatment_SuctionTimeIntervalType>;
  woundCleanings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundRinsings?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_Treatment_WoundVersionGroupMsg = {
  latestWoundId?: InputMaybe<Scalars['String']>;
  versionGroupId?: InputMaybe<Scalars['String']>;
  wounds?: InputMaybe<Array<InputMaybe<Input_Treatment_WoundMsg>>>;
};

export type Input_Treatment_WristMsg = {
  evaluation?: InputMaybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: InputMaybe<Input_Treatment_ForceLevelsAndDetailsMsg>;
  id?: InputMaybe<Scalars['String']>;
};

/** Allows overriding Diagnosis' properties for specific coding */
export type Input_Treatment_Diagnosis_German_GermanDiagnosisCodingDetailsMsg = {
  /** German "Kommentar" */
  comment?: InputMaybe<Scalars['String']>;
  diagnosisDetailType?: InputMaybe<Treatment_DiagnosisDetailType>;
  diagnosisType?: InputMaybe<Treatment_DiagnosisType>;
  /** German "Ausnahmetatbestand" */
  exceptionalCircumstance?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** German "Erläuterung" */
  justification?: InputMaybe<Scalars['String']>;
  laterality?: InputMaybe<Laterality_Laterality>;
  persistentCode?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_AdministrativeUnitList = {
  administrativeUnits?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitMsg>>>;
};

export type Input_User_AdministrativeUnitMsg = {
  children?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitMsg>>>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  defaultParentId?: InputMaybe<Scalars['String']>;
  externalCategories?: InputMaybe<Array<InputMaybe<Input_User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  /** Administrative Unit Tree */
  id?: InputMaybe<Scalars['String']>;
  /** Administrative Unit Details */
  name?: InputMaybe<Scalars['String']>;
  organizationalUnitType?: InputMaybe<User_OrganizationalUnitType>;
  parents?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitMsg>>>;
  specializationIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
  type?: InputMaybe<Core_AdministrativeUnitType>;
};

export type Input_User_AdministrativeUnitNameMappingMsg = {
  clinic?: InputMaybe<Input_User_SimpleAdministrativeUnitMsg>;
  department?: InputMaybe<Input_User_SimpleAdministrativeUnitMsg>;
  division?: InputMaybe<Input_User_SimpleAdministrativeUnitMsg>;
  organizationalUnit?: InputMaybe<Input_User_SimpleAdministrativeUnitMsg>;
};

export type Input_User_AdministrativeUnitProxyMappingList = {
  mappings?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitProxyMappingMsg>>>;
};

/** AdministrativeUnitMapping extended by external ids */
export type Input_User_AdministrativeUnitProxyMappingMsg = {
  /** Only id and external ids and external categories are set */
  clinic?: InputMaybe<Input_User_ClinicMsg>;
  clinicId?: InputMaybe<Scalars['String']>;
  /** Only id and external ids and external categories are set */
  department?: InputMaybe<Input_User_DepartmentMsg>;
  /** Only id and external ids and external categories are set */
  division?: InputMaybe<Input_User_DivisionMsg>;
  /** Only id and external ids and external categories are set */
  organizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
};

/** Light-weight representation of a unit hierarchy */
export type Input_User_AdministrativeUnitTreeMsg = {
  children?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitTreeMsg>>>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

/** Used only for broadcasting division/department updates via kafka */
export type Input_User_AdministrativeUnitUpdateMsg = {
  externalCategories?: InputMaybe<Array<InputMaybe<Input_User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  /** Used to communicate the updates of division and departments */
  unitMapping?: InputMaybe<Input_Core_AdministrativeUnitMappingMsg>;
  /** false for first time creations, true for updates */
  updateChildren?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_ClinicList = {
  clinics?: InputMaybe<Array<InputMaybe<Input_User_ClinicMsg>>>;
};

export type Input_User_ClinicMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  divisions?: InputMaybe<Array<InputMaybe<Input_User_DivisionMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  specializationIds?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>>>;
};

/** associated units should be given in parentIds and childrenIds */
export type Input_User_CreateAdministrativeUnitRequest = {
  administrativeUnit?: InputMaybe<Input_User_AdministrativeUnitMsg>;
  childrenIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** When returning the created unit */
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
  parentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_CreateDepartmentRequest = {
  department?: InputMaybe<Input_User_DepartmentMsg>;
  divisionId?: InputMaybe<Scalars['String']>;
};

export type Input_User_CreateDivisionRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Input_User_DivisionMsg>;
};

export type Input_User_CreateOrganizationalUnitRequest = {
  /** Mandatory, must be one of the department ids as well */
  defaultDepartmentId?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
};

export type Input_User_CreateRoleRequest = {
  externalNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_CreateUserRequest = {
  password?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Input_User_UserMsg>;
};

export type Input_User_CreateUserResponse = {
  user?: InputMaybe<Input_User_UserMsg>;
  validationResult?: InputMaybe<Input_Validation_ValidationResultMsg>;
};

export type Input_User_DeleteOfficeHourRequest = {
  officeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_User_DeleteOfficeHourResponse = {
  deletedOfficeHourId?: InputMaybe<Scalars['String']>;
};

export type Input_User_DeleteRoleRequest = {
  roleId?: InputMaybe<Scalars['String']>;
};

export type Input_User_DeleteRoleResponse = {
  deletedRoleId?: InputMaybe<Scalars['String']>;
};

export type Input_User_DepartmentList = {
  departments?: InputMaybe<Array<InputMaybe<Input_User_DepartmentMsg>>>;
};

export type Input_User_DepartmentMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  divisionId?: InputMaybe<Scalars['String']>;
  externalCategories?: InputMaybe<Array<InputMaybe<Input_User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_User_OrganizationalUnitMsg>>>;
};

export type Input_User_DepartmentSearchResultMsg = {
  department?: InputMaybe<Input_User_DepartmentMsg>;
  parentDivision?: InputMaybe<Input_User_DivisionMsg>;
};

export type Input_User_DivisionList = {
  divisions?: InputMaybe<Array<InputMaybe<Input_User_DivisionMsg>>>;
};

export type Input_User_DivisionMsg = {
  clinicId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  departments?: InputMaybe<Array<InputMaybe<Input_User_DepartmentMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** fow now it's only added to department but will be added to other administrative unit types in the future */
export type Input_User_ExternalAdministrativeUnitCategoryMsg = {
  category?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_ExternalAdministrativeUnitCategoryType>;
};

export type Input_User_ExternalUnitIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_ExternalUnitIdType>;
};

export type Input_User_ExternalUserIdMsg = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_ExternalUserIdType>;
};

export type Input_User_FindAdministrativeUnitRequest = {
  baseUnitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  /** optional: if the unit is an organizationalUnit and only one of its parents should be searched, this should be set */
  parentDepartmentId?: InputMaybe<Scalars['String']>;
  /** Unit must have primary address */
  requirePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
  /** Optional: if set, only returns unit if it has an external id with any of these types */
  requiredExternalIdTypesAny?: InputMaybe<Array<InputMaybe<User_ExternalUnitIdType>>>;
};

export type Input_User_FindAdministrativeUnitResponse = {
  clinic?: InputMaybe<Input_User_ClinicMsg>;
  department?: InputMaybe<Input_User_DepartmentMsg>;
  division?: InputMaybe<Input_User_DivisionMsg>;
  found?: InputMaybe<Scalars['Boolean']>;
  organizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
};

export type Input_User_FindExternalUnitIdsRequest = {
  /** optional: if the unit is an organizationalUnit and only one of its parents should be searched, this should be set */
  parentDepartmentId?: InputMaybe<Scalars['String']>;
  /** If true, the external id is searched in the unit's parents if the unit itself does not contain an external id of the given type */
  searchParents?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<User_ExternalUnitIdType>;
  unit?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_User_FindExternalUnitIdsResponse = {
  externalUnitIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
};

export type Input_User_FindHumanNamesByUserIdsRequest = {
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_FindHumanNamesByUserIdsResponse = {
  userIdToHumanName?: InputMaybe<Array<InputMaybe<Input_User_FindHumanNamesByUserIdsResponse_UserIdToHumanNameEntry>>>;
};

export type Input_User_FindHumanNamesByUserIdsResponse_UserIdToHumanNameEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Input_Core_HumanNameMsg>;
};

export type Input_User_FindUserIdsByUserNamesRequest = {
  userNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_FindUserIdsByUserNamesResponse = {
  userNameToUserId?: InputMaybe<Array<InputMaybe<Input_User_FindUserIdsByUserNamesResponse_UserNameToUserIdEntry>>>;
};

export type Input_User_FindUserIdsByUserNamesResponse_UserNameToUserIdEntry = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/**
 * Only used to provide frontend with an easy way of checking authorization of a user,
 *  gets converted by backend when sending info about current user
 */
export type Input_User_FlatPermissionMsg = {
  accessPermission?: InputMaybe<User_AccessPermission>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  target?: InputMaybe<User_PermissionTarget>;
};

export type Input_User_GetAdministrativeUnitIds = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetAdministrativeUnitNameMappingRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetAdministrativeUnitRequest = {
  administrativeUnitId?: InputMaybe<Scalars['String']>;
  includeDetails?: InputMaybe<Scalars['Boolean']>;
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_GetClinicRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  /** Whether clinic details such as address should be included in the return message */
  includeDetails?: InputMaybe<Scalars['Boolean']>;
  /** Whether the child divisions, departments, organizational units should be included in the return message */
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_GetClinicsRequest = {
  clinicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_GetDepartmentRequest = {
  departmentId?: InputMaybe<Scalars['String']>;
  /** Whether the child organizational units should be included in the return message */
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_GetDepartmentsRequest = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_GetDivisionRequest = {
  divisionId?: InputMaybe<Scalars['String']>;
  /** Whether the child departments, organizational units should be included in the return message */
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_GetDivisionsRequest = {
  divisionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_GetOfficeHourIdsFromNameAndUnitIdRequest = {
  name?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetOfficeHourIdsFromNameAndUnitIdResponse = {
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_GetOfficeHourRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetOfficeHourResponse = {
  clinicId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  officeHour?: InputMaybe<Input_User_OfficeHourMsg>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetOfficeHoursRequest = {
  divisionId?: InputMaybe<Scalars['String']>;
  officeHourIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetOrganizationalUnitRequest = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetOrganizationalUnitsRequest = {
  organizationalUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_GetRoleRequest = {
  externalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetUnitsFromExternalIdsRequest = {
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetUnitsFromExternalIdsResponse = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_User_GetUserRequest = {
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_User_GetUsersRequest = {
  includePermissions?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_JwtAppTokenRequest = {
  appId?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Input_User_SpecialPermissionMsg>>>;
};

export type Input_User_JwtTokenMsg = {
  refreshToken?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_User_JwtTokenRefreshRequest = {
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type Input_User_ListAdministrativeUnitMappingsRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_User_ListAdministrativeUnitMappingsResponse = {
  /** mappings where the organizational unit is the lowest level and the department is the unit's default department */
  defaultUnitMappings?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the department is the lowest level */
  departmentMappings?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the division is the lowest level */
  divisionMappings?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the organizational unit is the lowest level, multiple parents per organizational unit possible */
  unitMappings?: InputMaybe<Array<InputMaybe<Input_Core_FlexibleAdministrativeUnitMappingMsg>>>;
};

export type Input_User_ListAdministrativeUnitProxyMappingsRequest = {
  /** NOT USED */
  _?: InputMaybe<Scalars['String']>;
};

export type Input_User_ListAdministrativeUnitsRequest = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeDetails?: InputMaybe<Scalars['Boolean']>;
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_ListExternalUserIdsRequest = {
  externalIdTypes?: InputMaybe<Array<InputMaybe<User_ExternalUserIdType>>>;
  unitReference?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
};

export type Input_User_ListExternalUserIdsResponseElementMsg = {
  externalUserIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUserIdMsg>>>;
  humanName?: InputMaybe<Input_Core_HumanNameMsg>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_User_ListExternalUserIdsResponseElementResponse = {
  externalUserIds?: InputMaybe<Array<InputMaybe<Input_User_ListExternalUserIdsResponseElementMsg>>>;
};

export type Input_User_ListLoginTargetModulesResponse = {
  possibleTargetModules?: InputMaybe<Array<InputMaybe<User_LoginTargetModule>>>;
};

export type Input_User_ListLoginTargetUnitsRequest = {
  targetModule?: InputMaybe<User_LoginTargetModule>;
};

export type Input_User_ListLoginTargetUnitsResponse = {
  clinicTrees?: InputMaybe<Array<InputMaybe<Input_User_AdministrativeUnitTreeMsg>>>;
};

export type Input_User_ListOrganizationalUnitIdsRequest = {
  administrativeUnitIds?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_User_ListOrganizationalUnitIdsResponse = {
  organizationalUnitIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_User_LogOutRequest = {
  /** dummy as Empty is not accepted as input */
  logOut?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_OfficeHourList = {
  divisionId?: InputMaybe<Scalars['String']>;
  officeHours?: InputMaybe<Array<InputMaybe<Input_User_OfficeHourMsg>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_OfficeHourMsg = {
  activationStatus?: InputMaybe<User_OfficeHourActivationStatus>;
  /** True if the Patient needs an appointment to attend the OfficeHour */
  hasAppointments?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  regularSchedule?: InputMaybe<Array<InputMaybe<Input_Core_DayOfWeekScheduleMsg>>>;
  specialSchedule?: InputMaybe<Array<InputMaybe<Input_Core_DateScheduleMsg>>>;
};

export type Input_User_OfficeHourToAdministrativeUnitMappingList = {
  officeHoursToAdministrativeUnitMappings?: InputMaybe<Array<InputMaybe<Input_User_OfficeHourToAdministrativeUnitMappingMsg>>>;
};

export type Input_User_OfficeHourToAdministrativeUnitMappingMsg = {
  officeHourId?: InputMaybe<Scalars['String']>;
  unitMapping?: InputMaybe<Input_Core_FlexibleAdministrativeUnitMappingMsg>;
};

export type Input_User_OrganizationalUnitList = {
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_User_OrganizationalUnitMsg>>>;
};

export type Input_User_OrganizationalUnitMsg = {
  contact?: InputMaybe<Input_Core_ContactMsg>;
  defaultClinicId?: InputMaybe<Scalars['String']>;
  defaultDepartmentId?: InputMaybe<Scalars['String']>;
  defaultDivisionId?: InputMaybe<Scalars['String']>;
  externalCategories?: InputMaybe<Array<InputMaybe<Input_User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_OrganizationalUnitType>;
};

export type Input_User_OrganizationalUnitResultList = {
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_User_OrganizationalUnitMsg>>>;
};

export type Input_User_OrganizationalUnitSearchResultMsg = {
  organizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
  parentDepartment?: InputMaybe<Input_User_DepartmentMsg>;
  parentDivision?: InputMaybe<Input_User_DivisionMsg>;
};

/** Used only for broadcasting organizational unit updates via kafka */
export type Input_User_OrganizationalUnitUpdateMsg = {
  defaultUnitMapping?: InputMaybe<Input_Core_AdministrativeUnitMappingMsg>;
  externalCategories?: InputMaybe<Array<InputMaybe<Input_User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  unitMappings?: InputMaybe<Input_Core_FlexibleAdministrativeUnitMappingMsg>;
  updateChildren?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Consists of a target area (e.g., Treatment, Patient Letter) and a list of access permissions (e.g., Read, Write).
 *  The unit type determines on which scale this permission is granted.
 */
export type Input_User_PermissionTokenMsg = {
  accessPermission?: InputMaybe<User_AccessPermission>;
  administrativeUnitType?: InputMaybe<Core_AdministrativeUnitType>;
  id?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<User_PermissionTarget>;
};

export type Input_User_RequestSpecialAccessRequest = {
  resourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<User_SpecialAccessTargetType>;
};

/** A collection of actions that a user with this role is allowed to perform */
export type Input_User_RoleMsg = {
  /** Names by which the role is defined in the clinic's other systems */
  externalNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pathKeyConstraints?: InputMaybe<Array<InputMaybe<Input_Common_Access_PathKeyAccessConstraintMsg>>>;
  permissionTokens?: InputMaybe<Array<InputMaybe<Input_User_PermissionTokenMsg>>>;
  scopedConstraints?: InputMaybe<Array<InputMaybe<Input_Common_Access_ScopedAccessConstraintMsg>>>;
  targetConstraints?: InputMaybe<Array<InputMaybe<Common_Access_TargetConstraint>>>;
  targetedRouteConstraints?: InputMaybe<Array<InputMaybe<Input_Common_Access_TargetedRouteConstraintMsg>>>;
  types?: InputMaybe<Array<InputMaybe<Core_RoleType>>>;
};

/**
 * Maps a role, which specifies the actions that can be performed, to a scope, which specifies where these
 *  actions can be performed
 */
export type Input_User_RoleScopeMappingMsg = {
  id?: InputMaybe<Scalars['String']>;
  /** role with predefined permissions */
  role?: InputMaybe<Input_User_RoleMsg>;
  /** the administrative units in which the user has that role */
  scope?: InputMaybe<Array<InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>>>;
};

export type Input_User_SearchDepartmentsRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  /** if this is set to true, the parent division of each department will be included in the response */
  includeParentDivision?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_User_SearchDepartmentsResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_User_DepartmentSearchResultMsg>>>;
};

export type Input_User_SearchDivisionsRequest = {
  /** mandatory filter */
  clinicId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_User_SearchOfficeHoursRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  includeParents?: InputMaybe<Scalars['Boolean']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type Input_User_SearchOfficeHoursResultList = {
  officeHoursSearchResults?: InputMaybe<Array<InputMaybe<Input_User_SearchOfficeHoursResultMsg>>>;
};

export type Input_User_SearchOfficeHoursResultMsg = {
  officeHour?: InputMaybe<Input_User_OfficeHourMsg>;
  parentClinic?: InputMaybe<Input_User_ClinicMsg>;
  parentDepartment?: InputMaybe<Input_User_DepartmentMsg>;
  parentDivision?: InputMaybe<Input_User_DivisionMsg>;
  parentOrganizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
};

export type Input_User_SearchOrganizationalUnitsRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  /**
   * If this is set to true, the parent department of each unit will be included in the response.
   *  If the departmentId parent_filter is set, that department will be returned, else the default parent.
   */
  includeParentDepartment?: InputMaybe<Scalars['Boolean']>;
  /**
   * If this is set to true, the parent division of each unit will be included in the response.
   *  If the departmentId parent_filter is set, the parent of that department will be returned,
   *  else the division of the default parent.
   */
  includeParentDivision?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  /** optional filter */
  type?: InputMaybe<User_OrganizationalUnitType>;
};

export type Input_User_SearchOrganizationalUnitsResponse = {
  results?: InputMaybe<Array<InputMaybe<Input_User_OrganizationalUnitSearchResultMsg>>>;
};

export type Input_User_SearchRolesRequest = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type Input_User_SearchRolesResponse = {
  roles?: InputMaybe<Array<InputMaybe<Input_User_RoleMsg>>>;
};

export type Input_User_SearchUsersRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['String']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  /** Only relevant if administrative unit filter set; if true, rank by unit instead of filtering */
  rankByUnit?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  /** D-Arzt filter */
  userShouldHaveIk?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_SignInRequest = {
  password?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_User_SimpleAdministrativeUnitList = {
  administrativeUnits?: InputMaybe<Array<InputMaybe<Input_User_SimpleAdministrativeUnitMsg>>>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of administrative units
 */
export type Input_User_SimpleAdministrativeUnitMsg = {
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUnitIdMsg>>>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_AdministrativeUnitType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** Allows fine-grained customization of a user's permissions beyond the role */
export type Input_User_SpecialPermissionMsg = {
  accessPermission?: InputMaybe<User_AccessPermission>;
  id?: InputMaybe<Scalars['String']>;
  /**
   * true  = permission is added
   *  false = permission is denied even if it would be granted by the user's role
   */
  positive?: InputMaybe<Scalars['Boolean']>;
  scope?: InputMaybe<Input_Core_AdministrativeUnitReferenceMsg>;
  target?: InputMaybe<User_PermissionTarget>;
};

export type Input_User_TokenMsg = {
  token?: InputMaybe<Scalars['String']>;
};

/**
 * new associated units, must be given in parentIds or childrenIds
 *  along with relevant flags being set to true: updateParents, updateChildren, updateDefaultParent
 *  Previous children and parents will be cleaned. Should they be kept, they must also be given in the list of parentIds or childrenIds
 *  new default parent id should be given inside administrative unit if updateDefaultParent flag is set to true
 */
export type Input_User_UpdateAdministrativeUnitRequest = {
  administrativeUnit?: InputMaybe<Input_User_AdministrativeUnitMsg>;
  childrenIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** When returning the updated unit */
  includeHierarchy?: InputMaybe<Scalars['Boolean']>;
  parentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updateChildren?: InputMaybe<Scalars['Boolean']>;
  updateDefaultParent?: InputMaybe<Scalars['Boolean']>;
  updateParents?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_UpdateCurrentOrganizationalUnitRequest = {
  /**
   * if not set, the default department of the provided organizationalUnit is set if the user is assigned to it;
   *  else any department the user is assigned to that is a parent of the provided organizational unit is set.
   */
  departmentId?: InputMaybe<Scalars['String']>;
  /** mandatory */
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_User_UpdateCurrentOrganizationalUnitResponse = {
  token?: InputMaybe<Input_User_TokenMsg>;
  user?: InputMaybe<Input_User_UserMsg>;
};

export type Input_User_UpdateDepartmentRequest = {
  department?: InputMaybe<Input_User_DepartmentMsg>;
  divisionId?: InputMaybe<Scalars['String']>;
  updateParent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_UpdateDivisionRequest = {
  clinicId?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<Input_User_DivisionMsg>;
  updateParent?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_UpdateExternalUserIdRequest = {
  /** Currently, only allowed type is LANR */
  externalId?: InputMaybe<Input_User_ExternalUserIdMsg>;
  /** If set to true, any external ids in the given user of externalId.type will be removed */
  remove?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_User_UpdateOfficeHourRequest = {
  officeHour?: InputMaybe<Input_User_OfficeHourMsg>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  updateOrganizationalUnit?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_UpdateOrganizationalUnitRequest = {
  defaultDepartmentId?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationalUnit?: InputMaybe<Input_User_OrganizationalUnitMsg>;
  updateDefaultParent?: InputMaybe<Scalars['Boolean']>;
  updateParents?: InputMaybe<Scalars['Boolean']>;
};

export type Input_User_UpdateRoleRequest = {
  role?: InputMaybe<Input_User_RoleMsg>;
};

export type Input_User_UpdateUserPasswordRequest = {
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_User_UpdateUserPermissionsRequest = {
  permissions?: InputMaybe<Array<InputMaybe<Input_User_RoleScopeMappingMsg>>>;
  /**
   * If set to true, the role scope mappings are persisted as provided in this request. By default, the roles are scoped
   *  to all scopes where the respective user has any roles.
   */
  useProvidedRoleScopes?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_User_UpdateUserPermissionsResponse = {
  token?: InputMaybe<Input_User_TokenMsg>;
  user?: InputMaybe<Input_User_UserMsg>;
};

export type Input_User_UserMsg = {
  clinics?: InputMaybe<Array<InputMaybe<Input_User_ClinicMsg>>>;
  contact?: InputMaybe<Input_Core_ContactMsg>;
  /**
   * The administrative units connected to the organizational unit for which the user is currently signed in;
   *  required for authorization
   */
  currentAdministrativeUnitIds?: InputMaybe<Input_Core_AdministrativeUnitMappingMsg>;
  /** The department for which the user is currently signed in */
  currentDepartmentId?: InputMaybe<Scalars['String']>;
  /** The organizational unit for which the user is currently signed in */
  currentOrganizationalUnitId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Input_Timestamp>;
  departments?: InputMaybe<Array<InputMaybe<Input_User_DepartmentMsg>>>;
  divisions?: InputMaybe<Array<InputMaybe<Input_User_DivisionMsg>>>;
  externalIds?: InputMaybe<Array<InputMaybe<Input_User_ExternalUserIdMsg>>>;
  /** Used to provide frontend with an easy way of checking authorization of a user */
  flatPermissions?: InputMaybe<Array<InputMaybe<Input_User_FlatPermissionMsg>>>;
  id?: InputMaybe<Scalars['String']>;
  medicalPosition?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Input_Core_HumanNameMsg>;
  organizationalPosition?: InputMaybe<Scalars['String']>;
  organizationalUnits?: InputMaybe<Array<InputMaybe<Input_User_OrganizationalUnitMsg>>>;
  permissions?: InputMaybe<Array<InputMaybe<Input_User_RoleScopeMappingMsg>>>;
  qualifications?: InputMaybe<Array<InputMaybe<Input_Patient_MedicalQualificationMsg>>>;
  sex?: InputMaybe<Core_Sex>;
  specialPermissions?: InputMaybe<Array<InputMaybe<Input_User_SpecialPermissionMsg>>>;
  systemUser?: InputMaybe<Scalars['Boolean']>;
  useExternalAuthentication?: InputMaybe<Scalars['Boolean']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_User_UserResultList = {
  users?: InputMaybe<Array<InputMaybe<Input_User_UserMsg>>>;
};

/** Represents an inconsistent state */
export type Input_Validation_ConsistencyIssueMsg = {
  field?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Validation_ConsistencyStatus>;
};

export type Input_Validation_ValidationIssueMsg = {
  field?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Validation_ValidationStatus>;
};

/** This message is used as part of other messages to contain information about validation by a user */
export type Input_Validation_ValidationMsg = {
  externalValidator?: InputMaybe<Validation_ExternalValidator>;
  id?: InputMaybe<Scalars['String']>;
  /** The action type which made the validation end up in the current state */
  reset?: InputMaybe<Scalars['Boolean']>;
  validatedAt?: InputMaybe<Input_Timestamp>;
  /** ID of the treatment in which the block was last validated */
  validatedInTreatmentId?: InputMaybe<Scalars['String']>;
  /** ID of the visit in which the block was last validated */
  validatedInVisitId?: InputMaybe<Scalars['String']>;
  /** ID of the user who made the validation */
  validatorId?: InputMaybe<Scalars['String']>;
  /** Organizational unit the user is in at the moment of validation */
  validatorOrganizationalUnitId?: InputMaybe<Scalars['String']>;
};

export type Input_Validation_ValidationResultMsg = {
  consistencyIssues?: InputMaybe<Array<InputMaybe<Input_Validation_ConsistencyIssueMsg>>>;
  validationIssues?: InputMaybe<Array<InputMaybe<Input_Validation_ValidationIssueMsg>>>;
};

export type Input_Versioning_RevisionInfoMsg = {
  currentStatusEntry?: InputMaybe<Input_Versioning_RevisionStatusEntryMsg>;
  /**
   * if this revision group already has a revision that is being edited and that revision is not this one,
   *  then this field is set and represents the currentStatusEntry of that exclusive editable revision.
   *  => if this field is set, create calls with this revisionGroupId as a source will fail = this revisionGroup is locked
   */
  exclusivelyEditableRevision?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  groupCreatorId?: InputMaybe<Scalars['String']>;
  historicStatusEntries?: InputMaybe<Array<InputMaybe<Input_Versioning_RevisionStatusEntryMsg>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  revisionCreationTimestamp?: InputMaybe<Input_Timestamp>;
  revisionGroupCreationTimestamp?: InputMaybe<Input_Timestamp>;
  revisionGroupId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Input_Timestamp>;
};

export type Input_Versioning_RevisionSourceMsg = {
  new?: InputMaybe<Scalars['Boolean']>;
  revisionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Versioning_RevisionStatusEntryMsg = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Versioning_RevisionStatus>;
  timestamp?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Versioning_VersionInfoMsg = {
  currentStatusEntry?: InputMaybe<Input_Versioning_VersionStatusEntryMsg>;
  /**
   * if this version group can only have one editable version at a time,
   *  and such a version exists but is not this one,
   *  then this field is set and represents the currentStatusEntry of that exclusive editable version.
   *  => if this field is set, update calls or create calls with this versionGroupId as a source will fail = this versionGroup is locked
   */
  exclusivelyEditableVersion?: InputMaybe<Input_Versioning_VersionInfoMsg>;
  historicStatusEntries?: InputMaybe<Array<InputMaybe<Input_Versioning_VersionStatusEntryMsg>>>;
  revisionInfo?: InputMaybe<Input_Versioning_RevisionInfoMsg>;
  versionCreationTimestamp?: InputMaybe<Input_Timestamp>;
  versionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Versioning_VersionSourceMsg = {
  new?: InputMaybe<Scalars['Boolean']>;
  revisionGroupId?: InputMaybe<Scalars['String']>;
  versionGroup?: InputMaybe<Input_Versioning_VersionSourceVersionGroupMsg>;
};

export type Input_Versioning_VersionSourceVersionGroupMsg = {
  /**
   * optional, if specified the new group version is created based
   *  on this instance version
   */
  revisionGroupId?: InputMaybe<Scalars['String']>;
  versionGroupId?: InputMaybe<Scalars['String']>;
};

export type Input_Versioning_VersionStatusEntryMsg = {
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Versioning_VersionStatus>;
  timestamp?: InputMaybe<Input_Timestamp>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_Versioning_VersionedEntityCreationParametersMsg = {
  /**
   * If there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: InputMaybe<Scalars['Boolean']>;
  /**
   * If there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: InputMaybe<Scalars['Boolean']>;
  /**
   * When creating a new editable revision for a version and
   * the creator of the version is not this user, then the version must be taken over.
   * This action would push a new status entry to the VersionedEntity, changing the user to the current one.
   * This is a prerequisite if the current user wants to edit this version.(Wound Control in this context)
   * Only relevant if version source is revisionGroupId.
   */
  takeOverVersion?: InputMaybe<Scalars['Boolean']>;
};

export type Int32W = {
  __typename?: 'Int32W';
  value?: Maybe<Scalars['Int']>;
};

export type Int64W = {
  __typename?: 'Int64W';
  value?: Maybe<Scalars['Long']>;
};

export enum Month {
  MonthApril = 'MONTH_APRIL',
  MonthAugust = 'MONTH_AUGUST',
  MonthDecember = 'MONTH_DECEMBER',
  MonthFebruary = 'MONTH_FEBRUARY',
  MonthJanuary = 'MONTH_JANUARY',
  MonthJuly = 'MONTH_JULY',
  MonthJune = 'MONTH_JUNE',
  MonthMarch = 'MONTH_MARCH',
  MonthMay = 'MONTH_MAY',
  MonthNone = 'MONTH_NONE',
  MonthNovember = 'MONTH_NOVEMBER',
  MonthOctober = 'MONTH_OCTOBER',
  MonthSeptember = 'MONTH_SEPTEMBER'
}

export type MutationType = {
  __typename?: 'MutationType';
  acceptAppointmentProposal?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  acceptLegalGuardian?: Maybe<Patientportal_PortalUserMsg>;
  acceptProfessionalPortalUserInvite?: Maybe<Helper_Empty>;
  acceptWard?: Maybe<Patientportal_PortalUserMsg>;
  addLegalGuardian?: Maybe<Patientportal_AddLegalGuardianResponse>;
  answerFormQuestion?: Maybe<Patientportal_AnswerFormQuestionProxyResponse>;
  answerFormSequenceQuestion?: Maybe<Patientportal_AnswerFormSequenceQuestionProxyResponse>;
  cancelAppointment?: Maybe<Patientportal_AppointmentProxyMsg>;
  cancelAppointmentRequest?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  cancelClinicalRequest?: Maybe<Patientportal_CancelClinicalRequestProxyResponse>;
  createAppointmentRequest?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  createClinicalRequest?: Maybe<Patientportal_CreateClinicalRequestProxyResponse>;
  createComment?: Maybe<Patientportal_CreateCommentProxyResponse>;
  createExternalClinic?: Maybe<Patientportal_ExternalClinicMsg>;
  createExternalDepartment?: Maybe<Patientportal_ExternalDepartmentMsg>;
  createExternalOrganizationalUnit?: Maybe<Patientportal_ExternalOrganizationalUnitMsg>;
  createForm?: Maybe<Patientportal_CreateFormProxyResponse>;
  createFormAnswerGroup?: Maybe<Patientportal_CreateFormAnswerGroupProxyResponse>;
  createPortalPatientDataSnapshot?: Maybe<Helper_Empty>;
  createPortalSnapshot?: Maybe<Patientportal_PortalDataSnapshotMsg>;
  createPortalUser?: Maybe<Patientportal_CreatePortalUserResponse>;
  createProfessionalPortalUser?: Maybe<Patientportal_CreateProfessionalPortalUserResponse>;
  createProfessionalPortalUserInvite?: Maybe<Patientportal_ProfessionalPortalUserInviteMsg>;
  createReasonForPresentation?: Maybe<Treatment_ReasonForPresentationMsg>;
  deleteClinicalRequest?: Maybe<Patientportal_DeleteClinicalRequestProxyResponse>;
  deleteComment?: Maybe<Patientportal_DeleteCommentProxyResponse>;
  deleteExternalClinic?: Maybe<Helper_Empty>;
  deleteExternalDepartment?: Maybe<Helper_Empty>;
  deleteExternalOrganizationalUnit?: Maybe<Helper_Empty>;
  deleteFormAnswerGroup?: Maybe<Patientportal_DeleteFormAnswerGroupProxyResponse>;
  deleteProfessionalPortalUserInvite?: Maybe<Helper_Empty>;
  findFormSequenceAnswer?: Maybe<Patientportal_FindFormSequenceAnswerProxyResponse>;
  findSiblingFormSequenceAnswer?: Maybe<Patientportal_FindSiblingFormSequenceAnswerProxyResponse>;
  logOut?: Maybe<Helper_Empty>;
  partiallyConfirmAction?: Maybe<Helper_Empty>;
  preparePasswordReset?: Maybe<Patientportal_PreparePasswordResetResponse>;
  rejectAppointmentProposals?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  rejectLegalGuardian?: Maybe<Helper_Empty>;
  rejectWard?: Maybe<Helper_Empty>;
  removeClinicalRequestInput?: Maybe<Patientportal_RemoveClinicalRequestInputProxyResponse>;
  removeCustomClinicalRequestInput?: Maybe<Patientportal_RemoveCustomClinicalRequestInputProxyResponse>;
  removeLegalGuardian?: Maybe<Patientportal_RemoveLegalGuardianResponse>;
  renotifyConfirmationProvider?: Maybe<Patientportal_RenotifyConfirmationProviderResponse>;
  requestLegalGuardian?: Maybe<Helper_Empty>;
  requestWard?: Maybe<Helper_Empty>;
  resetPassword?: Maybe<Patientportal_ResetPasswordResponse>;
  restartForm?: Maybe<Patientportal_RestartFormProxyResponse>;
  setDeviceFirebaseToken?: Maybe<Patientportal_SetDeviceFirebaseTokenResponse>;
  signInPortalUser?: Maybe<Patientportal_SignInPortalUserResponse>;
  submitAppointmentRequest?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  submitClinicalRequest?: Maybe<Patientportal_SubmitClinicalRequestProxyResponse>;
  switchPortalUser?: Maybe<Patientportal_SignInPortalUserResponse>;
  updateAppointmentRequest?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  updateAppointmentTaskResult?: Maybe<Patientportal_AppointmentTaskProxyMsg>;
  updateAppointmentTaskStatus?: Maybe<Patientportal_AppointmentTaskProxyMsg>;
  updateClinicalRequest?: Maybe<Patientportal_UpdateClinicalRequestProxyResponse>;
  updateComment?: Maybe<Patientportal_UpdateCommentProxyResponse>;
  updateCustomClinicalRequestInput?: Maybe<Patientportal_UpdateCustomClinicalRequestInputProxyResponse>;
  updateFormStatus?: Maybe<Patientportal_UpdateFormStatusProxyResponse>;
  updatePortalPatientAllergies?: Maybe<Helper_Empty>;
  updatePortalPatientDataSnapshotStatuses?: Maybe<Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyResponse>;
  updatePortalPatientDiagnoses?: Maybe<Helper_Empty>;
  updatePortalPatientDiaryEntries?: Maybe<Helper_Empty>;
  updatePortalPatientMedications?: Maybe<Helper_Empty>;
  updatePortalPatientQuantityEntries?: Maybe<Helper_Empty>;
  updatePortalPatientSurgeries?: Maybe<Helper_Empty>;
  updatePortalUser?: Maybe<Patientportal_UpdatePortalUserResponse>;
  updatePortalUserClinic?: Maybe<Patientportal_UpdatePortalUserClinicResponse>;
  updatePortalUserPassword?: Maybe<Patientportal_UpdatePortalUserPasswordResponse>;
  updatePortalUserSettings?: Maybe<Patientportal_PortalAccountSettingsMsg>;
  updateReasonForRepresentation?: Maybe<Treatment_UpdateAnamnesisCardReasonResponse>;
  updateRelevantProblems?: Maybe<Patientportal_UpdateRelevantProblemsProxyResponse>;
  verifyThirdPartyCommunication?: Maybe<Patientportal_VerifyThirdPartyCommunicationResponse>;
};


export type MutationTypeAcceptAppointmentProposalArgs = {
  input?: InputMaybe<Input_Patientportal_AcceptAppointmentProposalProxyRequest>;
};


export type MutationTypeAcceptLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_AcceptLegalGuardianRequest>;
};


export type MutationTypeAcceptProfessionalPortalUserInviteArgs = {
  input?: InputMaybe<Input_Patientportal_AcceptProfessionalPortalUserInviteRequest>;
};


export type MutationTypeAcceptWardArgs = {
  input?: InputMaybe<Input_Patientportal_AcceptWardRequest>;
};


export type MutationTypeAddLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_AddLegalGuardianRequest>;
};


export type MutationTypeAnswerFormQuestionArgs = {
  input?: InputMaybe<Input_Patientportal_AnswerFormQuestionProxyRequest>;
};


export type MutationTypeAnswerFormSequenceQuestionArgs = {
  input?: InputMaybe<Input_Patientportal_AnswerFormSequenceQuestionProxyRequest>;
};


export type MutationTypeCancelAppointmentArgs = {
  input?: InputMaybe<Input_Patientportal_CancelAppointmentProxyRequest>;
};


export type MutationTypeCancelAppointmentRequestArgs = {
  input?: InputMaybe<Input_Patientportal_CancelAppointmentRequestProxyRequest>;
};


export type MutationTypeCancelClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_CancelClinicalRequestProxyRequest>;
};


export type MutationTypeCreateAppointmentRequestArgs = {
  input?: InputMaybe<Input_Patientportal_CreateAppointmentRequestProxyRequest>;
};


export type MutationTypeCreateClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_CreateClinicalRequestProxyRequest>;
};


export type MutationTypeCreateCommentArgs = {
  input?: InputMaybe<Input_Patientportal_CreateCommentProxyRequest>;
};


export type MutationTypeCreateExternalClinicArgs = {
  input?: InputMaybe<Input_Patientportal_CreateExternalClinicRequest>;
};


export type MutationTypeCreateExternalDepartmentArgs = {
  input?: InputMaybe<Input_Patientportal_CreateExternalDepartmentRequest>;
};


export type MutationTypeCreateExternalOrganizationalUnitArgs = {
  input?: InputMaybe<Input_Patientportal_CreateExternalOrganizationalUnitRequest>;
};


export type MutationTypeCreateFormArgs = {
  input?: InputMaybe<Input_Patientportal_CreateFormProxyRequest>;
};


export type MutationTypeCreateFormAnswerGroupArgs = {
  input?: InputMaybe<Input_Patientportal_CreateFormAnswerGroupProxyRequest>;
};


export type MutationTypeCreatePortalPatientDataSnapshotArgs = {
  input?: InputMaybe<Input_Patientportal_CreatePortalPatientDataSnapshotProxyRequest>;
};


export type MutationTypeCreatePortalSnapshotArgs = {
  input?: InputMaybe<Input_Patientportal_PortalDataSnapshotMsg>;
};


export type MutationTypeCreatePortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_CreatePortalUserRequest>;
};


export type MutationTypeCreateProfessionalPortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_CreateProfessionalPortalUserRequest>;
};


export type MutationTypeCreateProfessionalPortalUserInviteArgs = {
  input?: InputMaybe<Input_Patientportal_CreateProfessionalPortalUserInviteRequest>;
};


export type MutationTypeCreateReasonForPresentationArgs = {
  input?: InputMaybe<Input_Patientportal_CreateReasonForRepresentationPortalProxyRequest>;
};


export type MutationTypeDeleteClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteClinicalRequestProxyRequest>;
};


export type MutationTypeDeleteCommentArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteCommentProxyRequest>;
};


export type MutationTypeDeleteExternalClinicArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteExternalClinicRequest>;
};


export type MutationTypeDeleteExternalDepartmentArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteExternalDepartmentRequest>;
};


export type MutationTypeDeleteExternalOrganizationalUnitArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteExternalOrganizationalUnitRequest>;
};


export type MutationTypeDeleteFormAnswerGroupArgs = {
  input?: InputMaybe<Input_Patientportal_DeleteFormAnswerGroupProxyRequest>;
};


export type MutationTypeDeleteProfessionalPortalUserInviteArgs = {
  input?: InputMaybe<Input_Patientportal_ProfessionalPortalUserInviteIdentifier>;
};


export type MutationTypeFindFormSequenceAnswerArgs = {
  input?: InputMaybe<Input_Patientportal_FindFormSequenceAnswerProxyRequest>;
};


export type MutationTypeFindSiblingFormSequenceAnswerArgs = {
  input?: InputMaybe<Input_Patientportal_FindSiblingFormSequenceAnswerProxyRequest>;
};


export type MutationTypeLogOutArgs = {
  input?: InputMaybe<Input_Helper_Empty>;
};


export type MutationTypePartiallyConfirmActionArgs = {
  input?: InputMaybe<Input_Patientportal_PartiallyConfirmActionRequest>;
};


export type MutationTypePreparePasswordResetArgs = {
  input?: InputMaybe<Input_Patientportal_PreparePasswordResetRequest>;
};


export type MutationTypeRejectAppointmentProposalsArgs = {
  input?: InputMaybe<Input_Patientportal_RejectAppointmentProposalsProxyRequest>;
};


export type MutationTypeRejectLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_RejectLegalGuardianRequest>;
};


export type MutationTypeRejectWardArgs = {
  input?: InputMaybe<Input_Patientportal_RejectWardRequest>;
};


export type MutationTypeRemoveClinicalRequestInputArgs = {
  input?: InputMaybe<Input_Patientportal_RemoveClinicalRequestInputProxyRequest>;
};


export type MutationTypeRemoveCustomClinicalRequestInputArgs = {
  input?: InputMaybe<Input_Patientportal_RemoveCustomClinicalRequestInputProxyRequest>;
};


export type MutationTypeRemoveLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_RemoveLegalGuardianRequest>;
};


export type MutationTypeRenotifyConfirmationProviderArgs = {
  input?: InputMaybe<Input_Patientportal_RenotifyConfirmationProviderRequest>;
};


export type MutationTypeRequestLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_RequestLegalGuardianRequest>;
};


export type MutationTypeRequestWardArgs = {
  input?: InputMaybe<Input_Patientportal_RequestWardRequest>;
};


export type MutationTypeResetPasswordArgs = {
  input?: InputMaybe<Input_Patientportal_ResetPasswordRequest>;
};


export type MutationTypeRestartFormArgs = {
  input?: InputMaybe<Input_Patientportal_RestartFormProxyRequest>;
};


export type MutationTypeSetDeviceFirebaseTokenArgs = {
  input?: InputMaybe<Input_Patientportal_SetDeviceFirebaseTokenRequest>;
};


export type MutationTypeSignInPortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_SignInPortalUserRequest>;
};


export type MutationTypeSubmitAppointmentRequestArgs = {
  input?: InputMaybe<Input_Patientportal_SubmitAppointmentRequestProxyRequest>;
};


export type MutationTypeSubmitClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_SubmitClinicalRequestProxyRequest>;
};


export type MutationTypeSwitchPortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_SwitchPortalUserRequest>;
};


export type MutationTypeUpdateAppointmentRequestArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateAppointmentRequestProxyRequest>;
};


export type MutationTypeUpdateAppointmentTaskResultArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateAppointmentTaskResultProxyRequest>;
};


export type MutationTypeUpdateAppointmentTaskStatusArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateAppointmentTaskStatusProxyRequest>;
};


export type MutationTypeUpdateClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateClinicalRequestProxyRequest>;
};


export type MutationTypeUpdateCommentArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateCommentProxyRequest>;
};


export type MutationTypeUpdateCustomClinicalRequestInputArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateCustomClinicalRequestInputProxyRequest>;
};


export type MutationTypeUpdateFormStatusArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateFormStatusProxyRequest>;
};


export type MutationTypeUpdatePortalPatientAllergiesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientAllergiesProxyRequest>;
};


export type MutationTypeUpdatePortalPatientDataSnapshotStatusesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyRequest>;
};


export type MutationTypeUpdatePortalPatientDiagnosesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientDiagnosesProxyRequest>;
};


export type MutationTypeUpdatePortalPatientDiaryEntriesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientDiaryEntriesProxyRequest>;
};


export type MutationTypeUpdatePortalPatientMedicationsArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientMedicationsProxyRequest>;
};


export type MutationTypeUpdatePortalPatientQuantityEntriesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientQuantityEntriesProxyRequest>;
};


export type MutationTypeUpdatePortalPatientSurgeriesArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalPatientSurgeriesProxyRequest>;
};


export type MutationTypeUpdatePortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalUserRequest>;
};


export type MutationTypeUpdatePortalUserClinicArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalUserClinicRequest>;
};


export type MutationTypeUpdatePortalUserPasswordArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalUserPasswordRequest>;
};


export type MutationTypeUpdatePortalUserSettingsArgs = {
  input?: InputMaybe<Input_Patientportal_UpdatePortalUserSettingsRequest>;
};


export type MutationTypeUpdateReasonForRepresentationArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateAnamnesisCardReasonPortalProxyRequest>;
};


export type MutationTypeUpdateRelevantProblemsArgs = {
  input?: InputMaybe<Input_Patientportal_UpdateRelevantProblemsProxyRequest>;
};


export type MutationTypeVerifyThirdPartyCommunicationArgs = {
  input?: InputMaybe<Input_Patientportal_VerifyThirdPartyCommunicationRequest>;
};

export type PrecisionDurationMsg = {
  __typename?: 'PrecisionDurationMsg';
  resolution?: Maybe<TimePrecisionLevel>;
  seconds?: Maybe<Scalars['Long']>;
};

export type PrecisionTimeFrameMsg = {
  __typename?: 'PrecisionTimeFrameMsg';
  timeFrom?: Maybe<PrecisionTimestampMsg>;
  timeUntil?: Maybe<PrecisionTimestampMsg>;
};

export type PrecisionTimestampMsg = {
  __typename?: 'PrecisionTimestampMsg';
  resolution?: Maybe<TimePrecisionLevel>;
  timestamp?: Maybe<Timestamp>;
};

export type QueryType = {
  __typename?: 'QueryType';
  findClinicUserPortalStaff?: Maybe<Patientportal_FindClinicUserPortalStaffResponse>;
  findCountries?: Maybe<Knowledge_FindCountriesResponse>;
  findCurrentLegalGuardian?: Maybe<Patientportal_FindCurrentLegalGuardianResponse>;
  findCurrentPortalUser?: Maybe<Patientportal_FindCurrentPortalUserResponse>;
  findCurrentProfessionalPortalUser?: Maybe<Patientportal_FindCurrentProfessionalPortalUserResponse>;
  getAppointment?: Maybe<Patientportal_AppointmentProxyMsg>;
  getAppointmentFormReferenceBlacklist?: Maybe<Patientportal_GetAppointmentFormReferenceBlacklistProxyResponse>;
  getAppointmentFormTemplateVersioningGroupId?: Maybe<Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyResponse>;
  getAppointmentHistory?: Maybe<Patientportal_GetAppointmentHistoryProxyResponse>;
  getAppointmentRequest?: Maybe<Patientportal_AppointmentRequestProxyMsg>;
  getAppointmentSeries?: Maybe<Patientportal_AppointmentSeriesProxyMsg>;
  getAppointmentTask?: Maybe<Patientportal_AppointmentTaskProxyMsg>;
  getAppointmentType?: Maybe<Patientportal_AppointmentTypeProxyMsg>;
  getAvailableAppointmentDates?: Maybe<Resource_DateList>;
  getAvailableAppointmentSlots?: Maybe<Resource_AppointmentTimeFrameList>;
  getClinicalRequest?: Maybe<Patientportal_GetClinicalRequestProxyResponse>;
  getClinicalRequestLetterDocument?: Maybe<Patientportal_GetClinicalRequestLetterDocumentProxyResponse>;
  getCommentHistory?: Maybe<Patientportal_GetCommentHistoryProxyResponse>;
  getCountry?: Maybe<Knowledge_SearchResultOptional>;
  getCurrentLegalGuardians?: Maybe<Patientportal_PortalUserRelationshipList>;
  getCurrentPortalUserClinics?: Maybe<Patientportal_GetCurrentPortalUserClinicsResponse>;
  getCurrentWards?: Maybe<Patientportal_PortalUserRelationshipList>;
  getDocument?: Maybe<Patientportal_GetDocumentPortalProxyResponse>;
  getExternalClinic?: Maybe<Patientportal_ExternalClinicMsg>;
  getExternalClinics?: Maybe<Patientportal_ExternalClinicList>;
  getExternalDepartment?: Maybe<Patientportal_ExternalDepartmentMsg>;
  getExternalDepartments?: Maybe<Patientportal_ExternalDepartmentList>;
  getExternalOrganizationalUnit?: Maybe<Patientportal_ExternalOrganizationalUnitMsg>;
  getExternalOrganizationalUnits?: Maybe<Patientportal_ExternalOrganizationalUnitList>;
  getForm?: Maybe<Patientportal_GetFormProxyResponse>;
  getFormAnswerGroupHierarchy?: Maybe<Patientportal_GetFormAnswerGroupHierarchyProxyResponse>;
  getFormQuestionGroupHierarchy?: Maybe<Patientportal_GetFormQuestionGroupHierarchyProxyResponse>;
  getFormSequenceAnswer?: Maybe<Patientportal_GetFormSequenceAnswerProxyResponse>;
  getFormTemplate?: Maybe<Patientportal_GetFormTemplateProxyResponse>;
  getOfficeHourPortalFacilityPath?: Maybe<Patientportal_GetOfficeHourPortalFacilityPathResponse>;
  getOfficeHoursPortalFacilityPaths?: Maybe<Patientportal_GetOfficeHoursPortalFacilityPathsResponse>;
  getPortalFacilityHierarchy?: Maybe<Patientportal_GetPortalFacilityHierarchyResponse>;
  getPortalFacilityPaths?: Maybe<Patientportal_GetPortalFacilityPathsResponse>;
  getPortalUserAppointmentSeries?: Maybe<Patientportal_GetPortalUserAppointmentSeriesProxyResponse>;
  getPortalUserAppointments?: Maybe<Patientportal_GetPortalUserAppointmentsProxyResponse>;
  getPortalUserDocuments?: Maybe<Patientportal_GetPortalUserDocumentsProxyResponse>;
  getProfessionalPortalUserInvite?: Maybe<Patientportal_ProfessionalPortalUserInviteMsg>;
  getReasonForRepresentation?: Maybe<Treatment_ReasonForPresentationMsg>;
  getSequentialFormSummary?: Maybe<Patientportal_GetSequentialFormSummaryProxyResponse>;
  getSimpleExternalAdministrativeUnits?: Maybe<Patientportal_SimpleExternalAdministrativeUnitList>;
  listAdditionalServices?: Maybe<Patientportal_AdditionalServiceProxyList>;
  listAppointmentForms?: Maybe<Patientportal_ListAppointmentFormsProxyResponse>;
  listAppointmentHandlers?: Maybe<Patientportal_AppointmentHandlerProxyList>;
  listAppointmentTasks?: Maybe<Patientportal_ListAppointmentTasksProxyResponse>;
  listBodyParts?: Maybe<Knowledge_BodyPartList>;
  listClinicalRequestPriorityLevels?: Maybe<Patientportal_ListClinicalRequestPriorityLevelsProxyResponse>;
  listClinicalRequestTemplates?: Maybe<Patientportal_ListClinicalRequestTemplatesProxyResponse>;
  listComments?: Maybe<Patientportal_ListCommentsProxyResponse>;
  listFormOptions?: Maybe<Patientportal_ListFormOptionsProxyResponse>;
  listPortalPatientDataSnapshotMetadata?: Maybe<Patientportal_ListPortalPatientDataSnapshotMetadataProxyResponse>;
  listPortalUserAppointmentRequests?: Maybe<Patientportal_AppointmentRequestProxyList>;
  listPortalUserAppointmentTasks?: Maybe<Patientportal_ListPortalUserAppointmentTasksProxyResponse>;
  listPortalUserAppointmentTypes?: Maybe<Patientportal_ListPortalUserAppointmentTypesProxyResponse>;
  listUnsubmittedClinicalRequests?: Maybe<Patientportal_ListUnsubmittedClinicalRequestsProxyResponse>;
  searchClassificationSystems?: Maybe<Knowledge_ClassificationSystemResultList>;
  searchClinicalRequests?: Maybe<Patientportal_SearchClinicalRequestsProxyResponse>;
  searchClinicalStages?: Maybe<Knowledge_ClinicalStageResultList>;
  searchCountries?: Maybe<Knowledge_SearchCountriesResponse>;
  searchDiagnosisInfo?: Maybe<Knowledge_DiagnosisInfoResultList>;
  searchDocumentTypes?: Maybe<Document_DocumentTypeList>;
  searchDrugPackageUnits?: Maybe<Knowledge_DrugPackageUnitResultList>;
  searchDrugPackages?: Maybe<Drug_SearchDrugPackagesResponse>;
  searchDrugs?: Maybe<Drug_SearchDrugsResponse>;
  searchExternalClinics?: Maybe<Patientportal_ExternalClinicList>;
  searchExternalDepartments?: Maybe<Patientportal_SearchExternalDepartmentsResponse>;
  searchFormOptions?: Maybe<Patientportal_SearchFormOptionsProxyResponse>;
  searchMedicalFeeCode?: Maybe<Lab_MedicalFeeCodeList>;
  searchMedicationDosageUnits?: Maybe<Knowledge_MedicationDosageUnitResultList>;
  searchOPS?: Maybe<Knowledge_OpsResultList>;
  searchOPSKBV?: Maybe<Knowledge_OpsResultList>;
  searchPortalFacilities?: Maybe<Patientportal_SearchPortalFacilitiesResponse>;
  searchStandardizedData?: Maybe<Knowledge_SearchResultList>;
};


export type QueryTypeFindClinicUserPortalStaffArgs = {
  input?: InputMaybe<Input_Patientportal_FindClinicUserPortalStaffRequest>;
};


export type QueryTypeFindCountriesArgs = {
  input?: InputMaybe<Input_Knowledge_FindCountriesRequest>;
};


export type QueryTypeFindCurrentLegalGuardianArgs = {
  input?: InputMaybe<Input_Patientportal_FindCurrentLegalGuardianRequest>;
};


export type QueryTypeFindCurrentPortalUserArgs = {
  input?: InputMaybe<Input_Patientportal_FindCurrentPortalUserRequest>;
};


export type QueryTypeFindCurrentProfessionalPortalUserArgs = {
  input?: InputMaybe<Input_Helper_Empty>;
};


export type QueryTypeGetAppointmentArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentProxyRequest>;
};


export type QueryTypeGetAppointmentFormReferenceBlacklistArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentFormReferenceBlacklistProxyRequest>;
};


export type QueryTypeGetAppointmentFormTemplateVersioningGroupIdArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyRequest>;
};


export type QueryTypeGetAppointmentHistoryArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentHistoryProxyRequest>;
};


export type QueryTypeGetAppointmentRequestArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentRequestProxyRequest>;
};


export type QueryTypeGetAppointmentSeriesArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentSeriesProxyRequest>;
};


export type QueryTypeGetAppointmentTaskArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentTaskProxyRequest>;
};


export type QueryTypeGetAppointmentTypeArgs = {
  input?: InputMaybe<Input_Patientportal_GetAppointmentTypeProxyRequest>;
};


export type QueryTypeGetAvailableAppointmentDatesArgs = {
  input?: InputMaybe<Input_Patientportal_GetAvailableAppointmentSlotsProxyRequest>;
};


export type QueryTypeGetAvailableAppointmentSlotsArgs = {
  input?: InputMaybe<Input_Patientportal_GetAvailableAppointmentSlotsProxyRequest>;
};


export type QueryTypeGetClinicalRequestArgs = {
  input?: InputMaybe<Input_Patientportal_GetClinicalRequestProxyRequest>;
};


export type QueryTypeGetClinicalRequestLetterDocumentArgs = {
  input?: InputMaybe<Input_Patientportal_GetClinicalRequestLetterDocumentProxyRequest>;
};


export type QueryTypeGetCommentHistoryArgs = {
  input?: InputMaybe<Input_Patientportal_GetCommentHistoryProxyRequest>;
};


export type QueryTypeGetCountryArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeGetCurrentLegalGuardiansArgs = {
  input?: InputMaybe<Input_Patientportal_GetCurrentLegalGuardiansRequest>;
};


export type QueryTypeGetCurrentPortalUserClinicsArgs = {
  input?: InputMaybe<Input_Helper_Empty>;
};


export type QueryTypeGetCurrentWardsArgs = {
  input?: InputMaybe<Input_Patientportal_GetCurrentWardsRequest>;
};


export type QueryTypeGetDocumentArgs = {
  input?: InputMaybe<Input_Patientportal_GetDocumentPortalProxyRequest>;
};


export type QueryTypeGetExternalClinicArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalClinicRequest>;
};


export type QueryTypeGetExternalClinicsArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalClinicsRequest>;
};


export type QueryTypeGetExternalDepartmentArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalDepartmentRequest>;
};


export type QueryTypeGetExternalDepartmentsArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalDepartmentsRequest>;
};


export type QueryTypeGetExternalOrganizationalUnitArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalOrganizationalUnitRequest>;
};


export type QueryTypeGetExternalOrganizationalUnitsArgs = {
  input?: InputMaybe<Input_Patientportal_GetExternalOrganizationalUnitsRequest>;
};


export type QueryTypeGetFormArgs = {
  input?: InputMaybe<Input_Patientportal_GetFormProxyRequest>;
};


export type QueryTypeGetFormAnswerGroupHierarchyArgs = {
  input?: InputMaybe<Input_Patientportal_GetFormAnswerGroupHierarchyProxyRequest>;
};


export type QueryTypeGetFormQuestionGroupHierarchyArgs = {
  input?: InputMaybe<Input_Patientportal_GetFormQuestionGroupHierarchyProxyRequest>;
};


export type QueryTypeGetFormSequenceAnswerArgs = {
  input?: InputMaybe<Input_Patientportal_GetFormSequenceAnswerProxyRequest>;
};


export type QueryTypeGetFormTemplateArgs = {
  input?: InputMaybe<Input_Patientportal_GetFormTemplateProxyRequest>;
};


export type QueryTypeGetOfficeHourPortalFacilityPathArgs = {
  input?: InputMaybe<Input_Patientportal_GetOfficeHourPortalFacilityPathRequest>;
};


export type QueryTypeGetOfficeHoursPortalFacilityPathsArgs = {
  input?: InputMaybe<Input_Patientportal_GetOfficeHoursPortalFacilityPathsRequest>;
};


export type QueryTypeGetPortalFacilityHierarchyArgs = {
  input?: InputMaybe<Input_Patientportal_GetPortalFacilityHierarchyRequest>;
};


export type QueryTypeGetPortalFacilityPathsArgs = {
  input?: InputMaybe<Input_Patientportal_GetPortalFacilityPathsRequest>;
};


export type QueryTypeGetPortalUserAppointmentSeriesArgs = {
  input?: InputMaybe<Input_Patientportal_GetPortalUserAppointmentSeriesProxyRequest>;
};


export type QueryTypeGetPortalUserAppointmentsArgs = {
  input?: InputMaybe<Input_Patientportal_GetPortalUserAppointmentsProxyRequest>;
};


export type QueryTypeGetPortalUserDocumentsArgs = {
  input?: InputMaybe<Input_Patientportal_GetPortalUserDocumentsProxyRequest>;
};


export type QueryTypeGetProfessionalPortalUserInviteArgs = {
  input?: InputMaybe<Input_Patientportal_ProfessionalPortalUserInviteIdentifier>;
};


export type QueryTypeGetReasonForRepresentationArgs = {
  input?: InputMaybe<Input_Patientportal_GetAnamnesisCardReasonPortalProxyRequest>;
};


export type QueryTypeGetSequentialFormSummaryArgs = {
  input?: InputMaybe<Input_Patientportal_GetSequentialFormSummaryProxyRequest>;
};


export type QueryTypeGetSimpleExternalAdministrativeUnitsArgs = {
  input?: InputMaybe<Input_Patientportal_ExternalAdministrativeUnitReferenceList>;
};


export type QueryTypeListAdditionalServicesArgs = {
  input?: InputMaybe<Input_Patientportal_ListAdditionalServicesProxyRequest>;
};


export type QueryTypeListAppointmentFormsArgs = {
  input?: InputMaybe<Input_Patientportal_ListAppointmentFormsProxyRequest>;
};


export type QueryTypeListAppointmentHandlersArgs = {
  input?: InputMaybe<Input_Patientportal_ListAppointmentHandlersProxyRequest>;
};


export type QueryTypeListAppointmentTasksArgs = {
  input?: InputMaybe<Input_Patientportal_ListAppointmentTasksProxyRequest>;
};


export type QueryTypeListBodyPartsArgs = {
  input?: InputMaybe<Input_Knowledge_ListBodyPartsRequest>;
};


export type QueryTypeListClinicalRequestPriorityLevelsArgs = {
  input?: InputMaybe<Input_Patientportal_ListClinicalRequestPriorityLevelsProxyRequest>;
};


export type QueryTypeListClinicalRequestTemplatesArgs = {
  input?: InputMaybe<Input_Patientportal_ListClinicalRequestTemplatesProxyRequest>;
};


export type QueryTypeListCommentsArgs = {
  input?: InputMaybe<Input_Patientportal_ListCommentsProxyRequest>;
};


export type QueryTypeListFormOptionsArgs = {
  input?: InputMaybe<Input_Patientportal_ListFormOptionsProxyRequest>;
};


export type QueryTypeListPortalPatientDataSnapshotMetadataArgs = {
  input?: InputMaybe<Input_Patientportal_ListPortalPatientDataSnapshotMetadataProxyRequest>;
};


export type QueryTypeListPortalUserAppointmentRequestsArgs = {
  input?: InputMaybe<Input_Patientportal_ListPortalUserAppointmentRequestsProxyRequest>;
};


export type QueryTypeListPortalUserAppointmentTasksArgs = {
  input?: InputMaybe<Input_Resource_ListPortalUserAppointmentTasksRequest>;
};


export type QueryTypeListPortalUserAppointmentTypesArgs = {
  input?: InputMaybe<Input_Patientportal_ListPortalUserAppointmentTypesProxyRequest>;
};


export type QueryTypeListUnsubmittedClinicalRequestsArgs = {
  input?: InputMaybe<Input_Patientportal_ListUnsubmittedClinicalRequestsProxyRequest>;
};


export type QueryTypeSearchClassificationSystemsArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchClinicalRequestsArgs = {
  input?: InputMaybe<Input_Patientportal_SearchClinicalRequestsProxyRequest>;
};


export type QueryTypeSearchClinicalStagesArgs = {
  input?: InputMaybe<Input_Knowledge_SearchClinicalStagesRequest>;
};


export type QueryTypeSearchCountriesArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchDiagnosisInfoArgs = {
  input?: InputMaybe<Input_Knowledge_SearchDiagnosisInfoRequest>;
};


export type QueryTypeSearchDocumentTypesArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchDrugPackageUnitsArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchDrugPackagesArgs = {
  input?: InputMaybe<Input_Drug_SearchDrugPackagesRequest>;
};


export type QueryTypeSearchDrugsArgs = {
  input?: InputMaybe<Input_Drug_SearchDrugsRequest>;
};


export type QueryTypeSearchExternalClinicsArgs = {
  input?: InputMaybe<Input_Patientportal_SearchExternalClinicsRequest>;
};


export type QueryTypeSearchExternalDepartmentsArgs = {
  input?: InputMaybe<Input_Patientportal_SearchExternalDepartmentsRequest>;
};


export type QueryTypeSearchFormOptionsArgs = {
  input?: InputMaybe<Input_Patientportal_SearchFormOptionsProxyRequest>;
};


export type QueryTypeSearchMedicalFeeCodeArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchMedicationDosageUnitsArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchOpsArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchOpskbvArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};


export type QueryTypeSearchPortalFacilitiesArgs = {
  input?: InputMaybe<Input_Patientportal_SearchPortalFacilitiesRequest>;
};


export type QueryTypeSearchStandardizedDataArgs = {
  input?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
};

export type RatioMsg = {
  __typename?: 'RatioMsg';
  denominator?: Maybe<Scalars['Int']>;
  numerator?: Maybe<Scalars['Int']>;
};

export enum SpecialDecimal {
  SpecialDecimalMax = 'SPECIAL_DECIMAL_MAX',
  SpecialDecimalMin = 'SPECIAL_DECIMAL_MIN',
  SpecialDecimalNone = 'SPECIAL_DECIMAL_NONE'
}

export type TimeFrameMsg = {
  __typename?: 'TimeFrameMsg';
  timeFrom?: Maybe<Timestamp>;
  timeUntil?: Maybe<Timestamp>;
};

export enum TimeFrameType {
  TimeFrameTypeNone = 'TIME_FRAME_TYPE_NONE',
  TimeFrameTypeSpan = 'TIME_FRAME_TYPE_SPAN',
  TimeFrameTypeSpanInTimePoint = 'TIME_FRAME_TYPE_SPAN_IN_TIME_POINT',
  TimeFrameTypeStartAndEnd = 'TIME_FRAME_TYPE_START_AND_END',
  TimeFrameTypeStartAndSpan = 'TIME_FRAME_TYPE_START_AND_SPAN',
  TimeFrameTypeStartOngoing = 'TIME_FRAME_TYPE_START_ONGOING',
  TimeFrameTypeTextOnly = 'TIME_FRAME_TYPE_TEXT_ONLY',
  TimeFrameTypeTimePoint = 'TIME_FRAME_TYPE_TIME_POINT'
}

export type TimeMsg = {
  __typename?: 'TimeMsg';
  createdAt?: Maybe<Timestamp>;
  updatedAt?: Maybe<Timestamp>;
};

export type TimeOfDayMsg = {
  __typename?: 'TimeOfDayMsg';
  hours?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['Int']>;
};

export enum TimePrecisionLevel {
  TimePrecisionLevelDay = 'TIME_PRECISION_LEVEL_DAY',
  TimePrecisionLevelHour = 'TIME_PRECISION_LEVEL_HOUR',
  TimePrecisionLevelMinute = 'TIME_PRECISION_LEVEL_MINUTE',
  TimePrecisionLevelMonth = 'TIME_PRECISION_LEVEL_MONTH',
  TimePrecisionLevelNone = 'TIME_PRECISION_LEVEL_NONE',
  TimePrecisionLevelQuarter = 'TIME_PRECISION_LEVEL_QUARTER',
  TimePrecisionLevelSecond = 'TIME_PRECISION_LEVEL_SECOND',
  TimePrecisionLevelWeek = 'TIME_PRECISION_LEVEL_WEEK',
  TimePrecisionLevelYear = 'TIME_PRECISION_LEVEL_YEAR'
}

export enum TimeUnit {
  TimeUnitDay = 'TIME_UNIT_DAY',
  TimeUnitHour = 'TIME_UNIT_HOUR',
  TimeUnitMinute = 'TIME_UNIT_MINUTE',
  TimeUnitMonth = 'TIME_UNIT_MONTH',
  TimeUnitNone = 'TIME_UNIT_NONE',
  TimeUnitSecond = 'TIME_UNIT_SECOND',
  TimeUnitWeek = 'TIME_UNIT_WEEK',
  TimeUnitYear = 'TIME_UNIT_YEAR'
}

export type Timestamp = {
  __typename?: 'Timestamp';
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Long']>;
};

export type VeiosDateTimeMsg = {
  __typename?: 'VeiosDateTimeMsg';
  approximation?: Maybe<Scalars['Boolean']>;
  datetime?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  precisionLevel?: Maybe<TimePrecisionLevel>;
  text?: Maybe<Scalars['String']>;
};

export type VeiosTimeFrameMsg = {
  __typename?: 'VeiosTimeFrameMsg';
  end?: Maybe<VeiosDateTimeMsg>;
  id?: Maybe<Scalars['String']>;
  span?: Maybe<VeiosTimeSpanMsg>;
  start?: Maybe<VeiosDateTimeMsg>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<TimeFrameType>;
};

export type VeiosTimeSpanMsg = {
  __typename?: 'VeiosTimeSpanMsg';
  approximation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  precisionLevel?: Maybe<TimePrecisionLevel>;
  seconds?: Maybe<Scalars['Long']>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_AddInvoicePositionsRequest = {
  __typename?: 'billing_AddInvoicePositionsRequest';
  invoiceId?: Maybe<Scalars['String']>;
  /** It is enough to provide billing position id */
  invoicePositions?: Maybe<Array<Maybe<Billing_InvoicePositionMsg>>>;
};

export type Billing_AddMaterialCostsToBillingPositionRequest = {
  __typename?: 'billing_AddMaterialCostsToBillingPositionRequest';
  billingPositionId?: Maybe<Scalars['String']>;
  materialBillingCosts?: Maybe<Array<Maybe<Billing_CreateMaterialBillingCostRequest>>>;
};

export type Billing_AdditionalBillingFieldsMsg = {
  __typename?: 'billing_AdditionalBillingFieldsMsg';
  admissionDate?: Maybe<Timestamp>;
  asvTeamId?: Maybe<Scalars['String']>;
  batchNumber?: Maybe<Scalars['String']>;
  dischargeDate?: Maybe<Timestamp>;
  doctorNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  doctorUserId?: Maybe<Scalars['String']>;
  finishTime?: Maybe<Timestamp>;
  goNumberAddition?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  indicatorForPostHospitalServices?: Maybe<Scalars['Boolean']>;
  multiplier?: Maybe<Scalars['Float']>;
  omimRecords?: Maybe<Array<Maybe<Billing_BillingOmimRecordMsg>>>;
  operationDate?: Maybe<Timestamp>;
  opsCodes?: Maybe<Array<Maybe<Billing_BillingOpsCodeMsg>>>;
  organSpecifications?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientNumberOfFekForm?: Maybe<Scalars['String']>;
  percentageOfPerformance?: Maybe<Scalars['Int']>;
  /** Field Nr.: 20 */
  quantityKmAm?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  reasoningGnrs?: Maybe<Array<Maybe<Billing_BillingCodeReferenceMsg>>>;
  referralPracticeBsnr?: Maybe<Scalars['String']>;
  repeatExaminationForCancerScreening?: Maybe<Scalars['Boolean']>;
  serviceLocationAdministrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  serviceLocationOrDeviceLocation?: Maybe<Scalars['String']>;
  /** in minutes */
  totalCutSutureTime?: Maybe<Scalars['Int']>;
  travelExpense?: Maybe<Billing_TravelExpenseMsg>;
  typeOfExamination?: Maybe<Scalars['String']>;
  /** Field Nr.: 22 */
  unitOfMeasureKmAm?: Maybe<Billing_AmKmUnit>;
  yearOfLastCancerScreening?: Maybe<Scalars['Int']>;
};

export enum Billing_AdmissionType {
  AdmissionTypeEmergency = 'ADMISSION_TYPE_EMERGENCY',
  AdmissionTypeExternal = 'ADMISSION_TYPE_EXTERNAL',
  AdmissionTypeInternal = 'ADMISSION_TYPE_INTERNAL',
  AdmissionTypeNone = 'ADMISSION_TYPE_NONE',
  AdmissionTypeReferral = 'ADMISSION_TYPE_REFERRAL',
  AdmissionTypeSelf = 'ADMISSION_TYPE_SELF'
}

export type Billing_AggregateBillingCasesRequest = {
  __typename?: 'billing_AggregateBillingCasesRequest';
  /** mandatory: billing case ids that will be aggregated into a cumulative billing case */
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional, set if the billing cases should be added to an existing cumulative billing case */
  cumulativeBillingCaseId?: Maybe<Scalars['String']>;
  germanAggregationData?: Maybe<Billing_German_GermanBillingCaseAggregationDataMsg>;
};

export type Billing_AggregateBillingCasesResponse = {
  __typename?: 'billing_AggregateBillingCasesResponse';
  cumulativeBillingCase?: Maybe<Billing_BillingCaseMsg>;
};

export enum Billing_AmKmUnit {
  /** Milligrams */
  AmKmUnitMg = 'AM_KM_UNIT_MG',
  /** Milliliter */
  AmKmUnitMl = 'AM_KM_UNIT_ML',
  AmKmUnitNone = 'AM_KM_UNIT_NONE',
  /** Micrograms */
  AmKmUnitUg = 'AM_KM_UNIT_UG'
}

export type Billing_ApplyCodeChainToBillingCaseRequest = {
  __typename?: 'billing_ApplyCodeChainToBillingCaseRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  billingCertificateId?: Maybe<Scalars['String']>;
  /** optional */
  billingDayId?: Maybe<Scalars['String']>;
  codeChainId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Billing_ApplyCodeChainToBillingCaseResponse = {
  __typename?: 'billing_ApplyCodeChainToBillingCaseResponse';
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
  updatedFeeCategoryConfiguration?: Maybe<Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Billing_ApplyCoverageAssignmentsTemplateRequest = {
  __typename?: 'billing_ApplyCoverageAssignmentsTemplateRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_ApplyCoverageAssignmentsTemplateResponse = {
  __typename?: 'billing_ApplyCoverageAssignmentsTemplateResponse';
  /**
   * True if a template existed and was applied; does not necessarily mean that coverages were added:
   *  if no coverages matching the template were found, any linked coverages will be cleared, no coverages will be assigned.
   */
  applied?: Maybe<Scalars['Boolean']>;
  billingCase?: Maybe<Billing_BillingCaseMsg>;
};

export enum Billing_BbepDiscountType {
  BbepDiscountTypeNone = 'BBEP_DISCOUNT_TYPE_NONE',
  /**
   * 16% des abgerechneten Entgeltes n. §7 Abs. 1 Satz 1 Nr. 1 KHEntgG (die reine aDRG ohne ZE und Pflegeentgelte),
   *  aber maximal 2.000€
   *
   *  16% of the invoiced fee according to Section 7 Paragraph 1 Clause 1 No. 1 KHEntgG (the pure aDRG without ZE and nursing fees),
   *  but a maximum of €2,000
   */
  BbepDiscountTypeType1 = 'BBEP_DISCOUNT_TYPE_TYPE1',
  /**
   * Ein einmaliger Abschlag in Höhe von 280€
   *
   *  A one-time discount of 280€
   */
  BbepDiscountTypeType2 = 'BBEP_DISCOUNT_TYPE_TYPE2'
}

export type Billing_BillingAreaMsg = {
  __typename?: 'billing_BillingAreaMsg';
  billingAreaCode?: Maybe<Scalars['String']>;
  printingName?: Maybe<Scalars['String']>;
  validityPeriod?: Maybe<TimeFrameMsg>;
};

export enum Billing_BillingCaseCategory {
  BillingCaseCategoryCumulative = 'BILLING_CASE_CATEGORY_CUMULATIVE',
  BillingCaseCategoryNone = 'BILLING_CASE_CATEGORY_NONE',
  BillingCaseCategoryStandard = 'BILLING_CASE_CATEGORY_STANDARD'
}

export type Billing_BillingCaseDischargeTimeFiltersMsg = {
  __typename?: 'billing_BillingCaseDischargeTimeFiltersMsg';
  includePlanned?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<TimeFrameMsg>;
};

export type Billing_BillingCaseDrgFiltersMsg = {
  __typename?: 'billing_BillingCaseDrgFiltersMsg';
  approvalLevel?: Maybe<Scalars['Int']>;
  exclusionFilters?: Maybe<Array<Maybe<Billing_CaseExclusionFilterType>>>;
};

export type Billing_BillingCaseIdList = {
  __typename?: 'billing_BillingCaseIdList';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_BillingCaseIdentifiersMsg = {
  __typename?: 'billing_BillingCaseIdentifiersMsg';
  billingCaseId?: Maybe<Scalars['String']>;
  caseNumber?: Maybe<Scalars['String']>;
};

export type Billing_BillingCaseList = {
  __typename?: 'billing_BillingCaseList';
  billingCases?: Maybe<Array<Maybe<Billing_BillingCaseMsg>>>;
};

export type Billing_BillingCaseMsg = {
  __typename?: 'billing_BillingCaseMsg';
  activePeriod?: Maybe<TimeFrameMsg>;
  admissionType?: Maybe<Billing_AdmissionType>;
  /** Set if category is cumulative */
  aggregatedBillingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingEvents?: Maybe<Array<Maybe<Billing_BillingEventMsg>>>;
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
  billingStatus?: Maybe<Billing_BillingStatusMsg>;
  billingType?: Maybe<Billing_BillingTypeMsg>;
  billingUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** Either fetched from external system or generated by internal database sequence */
  caseNumber?: Maybe<Scalars['String']>;
  caseType?: Maybe<Billing_BillingCaseType>;
  category?: Maybe<Billing_BillingCaseCategory>;
  /** Ranked list of coverages; ranking allows splitting billing to the different coverages */
  coverages?: Maybe<Array<Maybe<Billing_CoverageAssignmentMsg>>>;
  /** Set if linked to a cumulative billing case */
  cumulativeBillingCaseId?: Maybe<Scalars['String']>;
  currentStatus?: Maybe<Billing_BillingCaseStatusMsg>;
  deleted?: Maybe<Scalars['Boolean']>;
  germanBgDetails?: Maybe<Billing_German_BillingCaseBgDetailsMsg>;
  germanDetails?: Maybe<Billing_German_BillingCaseDetailsMsg>;
  /** country-specific data */
  germanGroupingData?: Maybe<Billing_German_GroupingDataMsg>;
  id?: Maybe<Scalars['String']>;
  initialCaseReleaseDate?: Maybe<Timestamp>;
  initialLockDate?: Maybe<Timestamp>;
  latestCaseReleaseDate?: Maybe<Timestamp>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  registrationStatuses?: Maybe<Array<Maybe<Billing_RegistrationStatus>>>;
  /** not manually updatable; synchronized from visits */
  relatedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  tags?: Maybe<Array<Maybe<Billing_BillingCaseTag>>>;
  timestamps?: Maybe<TimeMsg>;
};

export type Billing_BillingCasePeriodTemplateMsg = {
  __typename?: 'billing_BillingCasePeriodTemplateMsg';
  duration?: Maybe<PrecisionDurationMsg>;
  type?: Maybe<Billing_BillingCasePeriodType>;
};

export enum Billing_BillingCasePeriodType {
  /** Active for current quarter, so both start and end date set, start date typically before current date */
  BillingCasePeriodTypeCurrentQuarter = 'BILLING_CASE_PERIOD_TYPE_CURRENT_QUARTER',
  /** Starts from current date, no end set initially */
  BillingCasePeriodTypeCurrentStart = 'BILLING_CASE_PERIOD_TYPE_CURRENT_START',
  /** Starts from current date, end after fixed duration */
  BillingCasePeriodTypeFixedDuration = 'BILLING_CASE_PERIOD_TYPE_FIXED_DURATION',
  BillingCasePeriodTypeNone = 'BILLING_CASE_PERIOD_TYPE_NONE'
}

export enum Billing_BillingCaseStatusCategory {
  BillingCaseStatusCategoryAborted = 'BILLING_CASE_STATUS_CATEGORY_ABORTED',
  BillingCaseStatusCategoryActive = 'BILLING_CASE_STATUS_CATEGORY_ACTIVE',
  BillingCaseStatusCategoryFinished = 'BILLING_CASE_STATUS_CATEGORY_FINISHED',
  BillingCaseStatusCategoryNone = 'BILLING_CASE_STATUS_CATEGORY_NONE',
  BillingCaseStatusCategoryNotYetActive = 'BILLING_CASE_STATUS_CATEGORY_NOT_YET_ACTIVE'
}

export enum Billing_BillingCaseStatusCheckFailureReason {
  /** Billing type does not support the status */
  BillingCaseStatusCheckFailureReasonBillingTypeMismatch = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_BILLING_TYPE_MISMATCH',
  /** Billing case status requires not being set to “final billed” */
  BillingCaseStatusCheckFailureReasonCannotRevokeFinalStatusTag = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_CANNOT_REVOKE_FINAL_STATUS_TAG',
  /** Billing case status requires a department main diagnosis be present for all departments involved */
  BillingCaseStatusCheckFailureReasonDepartmentMainDiagnosisMissing = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_DEPARTMENT_MAIN_DIAGNOSIS_MISSING',
  /** Billing case status requires discharge to be not completed */
  BillingCaseStatusCheckFailureReasonDischargeCompleted = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_DISCHARGE_COMPLETED',
  /** Billing case status requires discharge to be completed */
  BillingCaseStatusCheckFailureReasonDischargeMissing = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_DISCHARGE_MISSING',
  /** Billing case status requires highest drg approval level */
  BillingCaseStatusCheckFailureReasonHighestDrgApprovalLevelUnmet = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_HIGHEST_DRG_APPROVAL_LEVEL_UNMET',
  /** Billing case status requires a main diagnosis be present */
  BillingCaseStatusCheckFailureReasonMainDiagnosisMissing = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_MAIN_DIAGNOSIS_MISSING',
  /** The new or the old billing case status is missing "allow manual selection" tag. */
  BillingCaseStatusCheckFailureReasonManualSelectionNotAllowed = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_MANUAL_SELECTION_NOT_ALLOWED',
  BillingCaseStatusCheckFailureReasonNone = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_NONE',
  /** Billing case status requires all surgeries completed */
  BillingCaseStatusCheckFailureReasonOpenSurgeryExists = 'BILLING_CASE_STATUS_CHECK_FAILURE_REASON_OPEN_SURGERY_EXISTS'
}

export type Billing_BillingCaseStatusMsg = {
  __typename?: 'billing_BillingCaseStatusMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** The case types for which this billing case status can be selected */
  possibleCaseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  /** Used for sorting */
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Billing_BillingStatusActivationStatus>;
  statusCategory?: Maybe<Billing_BillingCaseStatusCategory>;
  tags?: Maybe<Array<Maybe<Billing_BillingCaseStatusTag>>>;
};

export enum Billing_BillingCaseStatusTag {
  BillingCaseStatusTagAllowCompletedDischarge = 'BILLING_CASE_STATUS_TAG_ALLOW_COMPLETED_DISCHARGE',
  /** Manual case type change is possible only if the old and the new statuses both have one of these tags, depending on the case type. */
  BillingCaseStatusTagAllowManualSelectionInpatient = 'BILLING_CASE_STATUS_TAG_ALLOW_MANUAL_SELECTION_INPATIENT',
  BillingCaseStatusTagAllowManualSelectionOutpatient = 'BILLING_CASE_STATUS_TAG_ALLOW_MANUAL_SELECTION_OUTPATIENT',
  BillingCaseStatusTagAllowScheduledDischarge = 'BILLING_CASE_STATUS_TAG_ALLOW_SCHEDULED_DISCHARGE',
  BillingCaseStatusTagAutomaticGroupingRelevant = 'BILLING_CASE_STATUS_TAG_AUTOMATIC_GROUPING_RELEVANT',
  /** Case related data such as diagnoses and drg will not be editable if status has this tag */
  BillingCaseStatusTagLockCaseData = 'BILLING_CASE_STATUS_TAG_LOCK_CASE_DATA',
  BillingCaseStatusTagNone = 'BILLING_CASE_STATUS_TAG_NONE',
  BillingCaseStatusTagReadyForBilling = 'BILLING_CASE_STATUS_TAG_READY_FOR_BILLING',
  BillingCaseStatusTagRequireAllDepartmentMainDiagnoses = 'BILLING_CASE_STATUS_TAG_REQUIRE_ALL_DEPARTMENT_MAIN_DIAGNOSES',
  BillingCaseStatusTagRequireHighestDrgApprovalLevel = 'BILLING_CASE_STATUS_TAG_REQUIRE_HIGHEST_DRG_APPROVAL_LEVEL',
  BillingCaseStatusTagRequireMainDiagnosis = 'BILLING_CASE_STATUS_TAG_REQUIRE_MAIN_DIAGNOSIS',
  BillingCaseStatusTagRequireSurgeryCompletion = 'BILLING_CASE_STATUS_TAG_REQUIRE_SURGERY_COMPLETION',
  BillingCaseStatusTagTriggerOnDischargeCompletion = 'BILLING_CASE_STATUS_TAG_TRIGGER_ON_DISCHARGE_COMPLETION',
  BillingCaseStatusTagTriggerOnFinalRegistration = 'BILLING_CASE_STATUS_TAG_TRIGGER_ON_FINAL_REGISTRATION',
  BillingCaseStatusTagTriggerOnPreliminaryRegistration = 'BILLING_CASE_STATUS_TAG_TRIGGER_ON_PRELIMINARY_REGISTRATION'
}

export enum Billing_BillingCaseTag {
  BillingCaseTagNone = 'BILLING_CASE_TAG_NONE',
  /** Marks that the billing case's case type was changed and the case type change is not finished; affects which fields are mandatory. */
  BillingCaseTagUnfinishedCaseTypeChange = 'BILLING_CASE_TAG_UNFINISHED_CASE_TYPE_CHANGE'
}

export enum Billing_BillingCaseType {
  BillingCaseTypeInpatient = 'BILLING_CASE_TYPE_INPATIENT',
  BillingCaseTypeNone = 'BILLING_CASE_TYPE_NONE',
  BillingCaseTypeOutpatient = 'BILLING_CASE_TYPE_OUTPATIENT',
  BillingCaseTypeSemiInpatient = 'BILLING_CASE_TYPE_SEMI_INPATIENT'
}

export enum Billing_BillingCatalogType {
  /** Ersatzkassengebührenordnung */
  BillingCatalogTypeBema = 'BILLING_CATALOG_TYPE_BEMA',
  BillingCatalogTypeDrg = 'BILLING_CATALOG_TYPE_DRG',
  /** Einheitlicher Bewertungsmaßstab */
  BillingCatalogTypeEbm = 'BILLING_CATALOG_TYPE_EBM',
  /** Gebührenordnung Ärzte */
  BillingCatalogTypeEkGo = 'BILLING_CATALOG_TYPE_EK_GO',
  /** Bewertungsmaßstab Ärzte */
  BillingCatalogTypeGoae = 'BILLING_CATALOG_TYPE_GOAE',
  BillingCatalogTypeNone = 'BILLING_CATALOG_TYPE_NONE',
  /** Gebührenordnung für Ärzte für die gesetzliche Unfallversicherung */
  BillingCatalogTypeUvGoae = 'BILLING_CATALOG_TYPE_UV_GOAE'
}

export type Billing_BillingCodeReferenceMsg = {
  __typename?: 'billing_BillingCodeReferenceMsg';
  billingCatalogType?: Maybe<Billing_BillingCatalogType>;
  catalogVersionId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type Billing_BillingDayBillingPositionList = {
  __typename?: 'billing_BillingDayBillingPositionList';
  billingDay?: Maybe<Billing_German_BillingDayMsg>;
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
};

export type Billing_BillingEventMsg = {
  __typename?: 'billing_BillingEventMsg';
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Billing_BillingCaseStatusMsg>;
  timestamp?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export enum Billing_BillingFeeCategory {
  BillingFeeCategoryEbm = 'BILLING_FEE_CATEGORY_EBM',
  BillingFeeCategoryGoae = 'BILLING_FEE_CATEGORY_GOAE',
  BillingFeeCategoryMaterialCost = 'BILLING_FEE_CATEGORY_MATERIAL_COST',
  BillingFeeCategoryNone = 'BILLING_FEE_CATEGORY_NONE',
  BillingFeeCategoryOther = 'BILLING_FEE_CATEGORY_OTHER',
  BillingFeeCategoryUvGoae = 'BILLING_FEE_CATEGORY_UV_GOAE'
}

export enum Billing_BillingFeeCategoryConfigurationContextType {
  BillingFeeCategoryConfigurationContextTypeNone = 'BILLING_FEE_CATEGORY_CONFIGURATION_CONTEXT_TYPE_NONE',
  BillingFeeCategoryConfigurationContextTypeSurgery = 'BILLING_FEE_CATEGORY_CONFIGURATION_CONTEXT_TYPE_SURGERY',
  BillingFeeCategoryConfigurationContextTypeTreatment = 'BILLING_FEE_CATEGORY_CONFIGURATION_CONTEXT_TYPE_TREATMENT',
  BillingFeeCategoryConfigurationContextTypeVisit = 'BILLING_FEE_CATEGORY_CONFIGURATION_CONTEXT_TYPE_VISIT'
}

export type Billing_BillingFeeCategoryConfigurationMsg = {
  __typename?: 'billing_BillingFeeCategoryConfigurationMsg';
  billingCaseId?: Maybe<Scalars['String']>;
  /** i.e. treatment id. pair with context_type */
  contextId?: Maybe<Scalars['String']>;
  /** i.e. treatment. pair with context_id */
  contextType?: Maybe<Billing_BillingFeeCategoryConfigurationContextType>;
  enabledFeeCategories?: Maybe<Array<Maybe<Billing_BillingFeeCategory>>>;
};

export type Billing_BillingMaterialCostMsg = {
  __typename?: 'billing_BillingMaterialCostMsg';
  articleIdentifier?: Maybe<Scalars['String']>;
  costInCents?: Maybe<Scalars['Int']>;
  ean?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Billing_Money>;
  grossPriceString?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inputGrossPriceInCents?: Maybe<Scalars['Int']>;
  inputNetPriceInCents?: Maybe<Scalars['Int']>;
  labels?: Maybe<Array<Maybe<Billing_MaterialCostTemplateLabelMsg>>>;
  manufacturer?: Maybe<Billing_MaterialCompanyMsg>;
  name?: Maybe<Scalars['String']>;
  netPrice?: Maybe<Billing_Money>;
  netPriceString?: Maybe<Scalars['String']>;
  productGroup?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  supplier?: Maybe<Billing_MaterialCompanyMsg>;
  vat?: Maybe<Scalars['String']>;
};

export type Billing_BillingOfficeMsg = {
  __typename?: 'billing_BillingOfficeMsg';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Billing_BillingOmimGCodeMsg = {
  __typename?: 'billing_BillingOmimGCodeMsg';
  geneName?: Maybe<Scalars['String']>;
  omimGCodeOfExaminedGene?: Maybe<Scalars['String']>;
};

export type Billing_BillingOmimPCodeMsg = {
  __typename?: 'billing_BillingOmimPCodeMsg';
  omimPCode?: Maybe<Scalars['String']>;
  typeOfIllness?: Maybe<Scalars['String']>;
};

export type Billing_BillingOmimRecordMsg = {
  __typename?: 'billing_BillingOmimRecordMsg';
  omimGCode?: Maybe<Billing_Omim_GCodeMsg>;
  omimGCodeFreeText?: Maybe<Scalars['String']>;
  omimPCode?: Maybe<Billing_Omim_PCodeMsg>;
  omimPCodeFreeText?: Maybe<Scalars['String']>;
};

/** TODO: Check whether still in use */
export type Billing_BillingOpsCodeMsg = {
  __typename?: 'billing_BillingOpsCodeMsg';
  complication?: Maybe<Scalars['String']>;
  /** in minutes */
  cutSutureTime?: Maybe<Scalars['Int']>;
  opsCode?: Maybe<Scalars['String']>;
  sideLocalization?: Maybe<Billing_OpsNumberLocalization>;
};

/**
 * Currently not implemented
 *  TODO: Naming
 *  Request for approval of billing positions, required e.g. for German psychotherapists
 */
export type Billing_BillingPositionAllowanceMsg = {
  __typename?: 'billing_BillingPositionAllowanceMsg';
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
  /** If set, further specifies who can use the approved claim */
  careTeam?: Maybe<Billing_CareTeamMsg>;
  id?: Maybe<Scalars['String']>;
  /** Mainly clinic; might allow setting that controls level of owner in the future */
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  status?: Maybe<Billing_BillingPositionAllowanceStatus>;
  validityPeriod?: Maybe<TimeFrameMsg>;
};

export enum Billing_BillingPositionAllowanceStatus {
  BillingPositionAllowanceStatusApproved = 'BILLING_POSITION_ALLOWANCE_STATUS_APPROVED',
  BillingPositionAllowanceStatusNone = 'BILLING_POSITION_ALLOWANCE_STATUS_NONE',
  BillingPositionAllowanceStatusOpen = 'BILLING_POSITION_ALLOWANCE_STATUS_OPEN',
  BillingPositionAllowanceStatusSubmitted = 'BILLING_POSITION_ALLOWANCE_STATUS_SUBMITTED'
}

export type Billing_BillingPositionContentMsg = {
  __typename?: 'billing_BillingPositionContentMsg';
  additionalFields?: Maybe<Billing_AdditionalBillingFieldsMsg>;
  codeReference?: Maybe<Billing_BillingCodeReferenceMsg>;
  drgFields?: Maybe<Billing_DrgBillingFieldsMsg>;
  materialCosts?: Maybe<Array<Maybe<Billing_BillingMaterialCostMsg>>>;
  multiplier?: Maybe<Billing_MultiplierMsg>;
  occupationalAccidentInsuranceFields?: Maybe<Billing_OccupationalAccidentInsuranceFieldsMsg>;
  priceInformation?: Maybe<Billing_PriceInformationMsg>;
  type?: Maybe<Billing_BillingPositionType>;
};

export type Billing_BillingPositionList = {
  __typename?: 'billing_BillingPositionList';
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
};

export type Billing_BillingPositionMsg = {
  __typename?: 'billing_BillingPositionMsg';
  appliedFlatRateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingCaseId?: Maybe<Scalars['String']>;
  billingDayId?: Maybe<Scalars['String']>;
  codeChainId?: Maybe<Scalars['String']>;
  content?: Maybe<Billing_BillingPositionContentMsg>;
  creatorId?: Maybe<Scalars['String']>;
  feeCategory?: Maybe<Billing_BillingFeeCategory>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  /** By default the same as the creatorId, but can be set to different user manually */
  serviceProviderUserId?: Maybe<Scalars['String']>;
  status?: Maybe<Billing_BillingPositionStatus>;
  surgeryId?: Maybe<Scalars['String']>;
  targetReference?: Maybe<Billing_ServiceReferenceMsg>;
  timeOfPerformedService?: Maybe<PrecisionTimestampMsg>;
  timestamps?: Maybe<TimeMsg>;
  treatmentCaseId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  validatorUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Billing_BillingPositionStatus {
  BillingPositionStatusBilled = 'BILLING_POSITION_STATUS_BILLED',
  BillingPositionStatusCreated = 'BILLING_POSITION_STATUS_CREATED',
  BillingPositionStatusNone = 'BILLING_POSITION_STATUS_NONE',
  BillingPositionStatusPartiallyBilled = 'BILLING_POSITION_STATUS_PARTIALLY_BILLED',
  BillingPositionStatusRejected = 'BILLING_POSITION_STATUS_REJECTED',
  BillingPositionStatusSubmitted = 'BILLING_POSITION_STATUS_SUBMITTED'
}

export enum Billing_BillingPositionType {
  BillingPositionTypeEmployerLiability = 'BILLING_POSITION_TYPE_EMPLOYER_LIABILITY',
  BillingPositionTypeNone = 'BILLING_POSITION_TYPE_NONE',
  BillingPositionTypePrivate = 'BILLING_POSITION_TYPE_PRIVATE',
  BillingPositionTypeStatutory = 'BILLING_POSITION_TYPE_STATUTORY'
}

export type Billing_BillingProcedureAdditionalFieldsMsg = {
  __typename?: 'billing_BillingProcedureAdditionalFieldsMsg';
  assignedRevenue?: Maybe<Billing_Money>;
  complications?: Maybe<Scalars['String']>;
  internalComment?: Maybe<Scalars['String']>;
  /** could be some enum or id. TODO: Probably not needed here, but characteristic of ops code? */
  opsType?: Maybe<Billing_OpsSpecialType>;
  responsibleUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  zeCode?: Maybe<Scalars['String']>;
};

export enum Billing_BillingProcedureContextType {
  BillingProcedureContextTypeCoding = 'BILLING_PROCEDURE_CONTEXT_TYPE_CODING',
  BillingProcedureContextTypeNone = 'BILLING_PROCEDURE_CONTEXT_TYPE_NONE',
  BillingProcedureContextTypeSurgery = 'BILLING_PROCEDURE_CONTEXT_TYPE_SURGERY',
  BillingProcedureContextTypeTreatment = 'BILLING_PROCEDURE_CONTEXT_TYPE_TREATMENT',
  BillingProcedureContextTypeVisit = 'BILLING_PROCEDURE_CONTEXT_TYPE_VISIT'
}

export type Billing_BillingProcedureMsg = {
  __typename?: 'billing_BillingProcedureMsg';
  additionalFields?: Maybe<Billing_BillingProcedureAdditionalFieldsMsg>;
  assignedUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** Required */
  billingCaseId?: Maybe<Scalars['String']>;
  code?: Maybe<Billing_ProceduralCodeReferenceMsg>;
  /** this field record whether the procedure was actually used for grouping - it is set by the grouper (e.g. KODIP) */
  drgRelevant?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Billing_ExternalBillingProcedureIdMsg>>>;
  firstDocumentingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initialCreationContextType?: Maybe<Billing_BillingProcedureContextType>;
  /** this field decides whether the procedure should be used for grouping */
  isActive?: Maybe<Scalars['Boolean']>;
  /** If true, means this procedure is the main procedure for the assigned unit */
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastUpdatingUserId?: Maybe<Scalars['String']>;
  laterality?: Maybe<Laterality_Laterality>;
  order?: Maybe<Scalars['Int']>;
  /** Required */
  patientId?: Maybe<Scalars['String']>;
  procedureDate?: Maybe<PrecisionTimestampMsg>;
  /** Can only be positive */
  quantity?: Maybe<Scalars['Int']>;
  surgeryId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_BillingProceduresList = {
  __typename?: 'billing_BillingProceduresList';
  billingProcedures?: Maybe<Array<Maybe<Billing_BillingProcedureMsg>>>;
};

export enum Billing_BillingStatusActivationStatus {
  BillingStatusActivationStatusActive = 'BILLING_STATUS_ACTIVATION_STATUS_ACTIVE',
  /** treated as deleted */
  BillingStatusActivationStatusInactive = 'BILLING_STATUS_ACTIVATION_STATUS_INACTIVE',
  BillingStatusActivationStatusNone = 'BILLING_STATUS_ACTIVATION_STATUS_NONE',
  BillingStatusActivationStatusNotYetActive = 'BILLING_STATUS_ACTIVATION_STATUS_NOT_YET_ACTIVE'
}

export type Billing_BillingStatusMsg = {
  __typename?: 'billing_BillingStatusMsg';
  externalIds?: Maybe<Array<Maybe<Billing_ExternalBillingStatusIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** Indicates whether this billing status is the default not billed status */
  isNotBilled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  status?: Maybe<Billing_BillingStatusActivationStatus>;
  tags?: Maybe<Array<Maybe<Billing_BillingStatusTag>>>;
};

export enum Billing_BillingStatusTag {
  BillingStatusTagFinalBilled = 'BILLING_STATUS_TAG_FINAL_BILLED',
  BillingStatusTagLockCase = 'BILLING_STATUS_TAG_LOCK_CASE',
  BillingStatusTagLockVisit = 'BILLING_STATUS_TAG_LOCK_VISIT',
  BillingStatusTagNone = 'BILLING_STATUS_TAG_NONE'
}

export type Billing_BillingTypeFeeCategoryMappingMsg = {
  __typename?: 'billing_BillingTypeFeeCategoryMappingMsg';
  allowedFeeCategories?: Maybe<Array<Maybe<Billing_BillingFeeCategory>>>;
  billingCaseType?: Maybe<Billing_BillingCaseType>;
  billingTypeId?: Maybe<Scalars['String']>;
  defaultFeeCategories?: Maybe<Array<Maybe<Billing_BillingFeeCategory>>>;
};

export type Billing_BillingTypeMsg = {
  __typename?: 'billing_BillingTypeMsg';
  /** Determines what active period is set on creation of billing case of this type */
  activePeriodTemplate?: Maybe<Billing_BillingCasePeriodTemplateMsg>;
  billingTypeTagAssignments?: Maybe<Array<Maybe<Billing_BillingTypeTagAssignmentMsg>>>;
  enableBillingCertificate?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Billing_ExternalBillingTypeIdMsg>>>;
  grouperTypeAssignments?: Maybe<Array<Maybe<Billing_GrouperTypeAssignmentMsg>>>;
  hasPatientReceipt?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Billing_BillingTypeOwnerMsg>;
  /** The case types for which this billing type can be selected */
  possibleCaseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  /** Coverage types that may be applied to billing cases of this type */
  possibleCoverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
};

export type Billing_BillingTypeOwnerMsg = {
  __typename?: 'billing_BillingTypeOwnerMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_BillingTypeOwnerType>;
};

export enum Billing_BillingTypeOwnerType {
  /** global throughout the system */
  BillingTypeOwnerTypeAvelios = 'BILLING_TYPE_OWNER_TYPE_AVELIOS',
  BillingTypeOwnerTypeClinic = 'BILLING_TYPE_OWNER_TYPE_CLINIC',
  BillingTypeOwnerTypeDepartment = 'BILLING_TYPE_OWNER_TYPE_DEPARTMENT',
  BillingTypeOwnerTypeDivision = 'BILLING_TYPE_OWNER_TYPE_DIVISION',
  BillingTypeOwnerTypeNone = 'BILLING_TYPE_OWNER_TYPE_NONE',
  BillingTypeOwnerTypeOrganizationalUnit = 'BILLING_TYPE_OWNER_TYPE_ORGANIZATIONAL_UNIT'
}

export enum Billing_BillingTypeTag {
  BillingTypeTagCodingUvGoae = 'BILLING_TYPE_TAG_CODING_UV_GOAE',
  BillingTypeTagCodingWorkplace = 'BILLING_TYPE_TAG_CODING_WORKPLACE',
  BillingTypeTagDrg = 'BILLING_TYPE_TAG_DRG',
  BillingTypeTagNone = 'BILLING_TYPE_TAG_NONE',
  BillingTypeTagOccupationalInsuranceAssociation = 'BILLING_TYPE_TAG_OCCUPATIONAL_INSURANCE_ASSOCIATION'
}

export type Billing_BillingTypeTagAssignmentMsg = {
  __typename?: 'billing_BillingTypeTagAssignmentMsg';
  caseType?: Maybe<Billing_BillingCaseType>;
  tag?: Maybe<Billing_BillingTypeTag>;
};

export type Billing_CancelOrReactivateBillingCaseRequest = {
  __typename?: 'billing_CancelOrReactivateBillingCaseRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  cancelBillingCase?: Maybe<Scalars['Boolean']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  reactivateBillingCase?: Maybe<Scalars['Boolean']>;
};

/** Currently not implemented */
export type Billing_CareTeamMemberMsg = {
  __typename?: 'billing_CareTeamMemberMsg';
  id?: Maybe<Scalars['String']>;
  practitionerId?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Billing_CareTeamMemberRole>>>;
  userId?: Maybe<Scalars['String']>;
};

export enum Billing_CareTeamMemberRole {
  CareTeamMemberRoleInvolvedPractitioner = 'CARE_TEAM_MEMBER_ROLE_INVOLVED_PRACTITIONER',
  CareTeamMemberRoleLeadPractitioner = 'CARE_TEAM_MEMBER_ROLE_LEAD_PRACTITIONER',
  CareTeamMemberRoleNone = 'CARE_TEAM_MEMBER_ROLE_NONE'
}

/** Currently not implemented */
export type Billing_CareTeamMsg = {
  __typename?: 'billing_CareTeamMsg';
  activityPeriod?: Maybe<TimeFrameMsg>;
  id?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<Billing_CareTeamMemberMsg>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export enum Billing_CaseExclusionFilterType {
  CaseExclusionFilterTypeNone = 'CASE_EXCLUSION_FILTER_TYPE_NONE',
  CaseExclusionFilterTypeNoAdmissionDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_ADMISSION_DIAGNOSIS',
  CaseExclusionFilterTypeNoBillingProcedure = 'CASE_EXCLUSION_FILTER_TYPE_NO_BILLING_PROCEDURE',
  CaseExclusionFilterTypeNoDepartmentMainDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_DEPARTMENT_MAIN_DIAGNOSIS',
  CaseExclusionFilterTypeNoDischarge = 'CASE_EXCLUSION_FILTER_TYPE_NO_DISCHARGE',
  CaseExclusionFilterTypeNoDischargeDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_DISCHARGE_DIAGNOSIS',
  CaseExclusionFilterTypeNoDrgBillingPosition = 'CASE_EXCLUSION_FILTER_TYPE_NO_DRG_BILLING_POSITION',
  CaseExclusionFilterTypeNoGroupingDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_GROUPING_DIAGNOSIS',
  CaseExclusionFilterTypeNoMainDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_MAIN_DIAGNOSIS',
  CaseExclusionFilterTypeNoReferralDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_REFERRAL_DIAGNOSIS',
  CaseExclusionFilterTypeNoSurgeryDiagnosis = 'CASE_EXCLUSION_FILTER_TYPE_NO_SURGERY_DIAGNOSIS'
}

export type Billing_CheckBillingCaseStatusUpdateRequest = {
  __typename?: 'billing_CheckBillingCaseStatusUpdateRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  statusFilters?: Maybe<Billing_ListBillingCaseStatusesRequest>;
};

export type Billing_CheckBillingCaseStatusUpdateResponse = {
  __typename?: 'billing_CheckBillingCaseStatusUpdateResponse';
  entries?: Maybe<Array<Maybe<Billing_CheckBillingCaseStatusUpdateResponseEntryMsg>>>;
};

export type Billing_CheckBillingCaseStatusUpdateResponseEntryMsg = {
  __typename?: 'billing_CheckBillingCaseStatusUpdateResponseEntryMsg';
  /** Whether it is possible to select this status for the requested billing case or not. */
  canBeSelected?: Maybe<Scalars['Boolean']>;
  caseStatus?: Maybe<Billing_BillingCaseStatusMsg>;
  /** The failing checks that prevent the selection of this status. */
  reasons?: Maybe<Array<Maybe<Billing_BillingCaseStatusCheckFailureReason>>>;
};

/** Currently not implemented */
export type Billing_ClaimItemMsg = {
  __typename?: 'billing_ClaimItemMsg';
  billingPosition?: Maybe<Billing_BillingPositionMsg>;
  id?: Maybe<Scalars['String']>;
  pricingUnit?: Maybe<Billing_ValueUnitType>;
  value?: Maybe<DecimalMsg>;
};

/** Currently not implemented */
export type Billing_ClaimMsg = {
  __typename?: 'billing_ClaimMsg';
  /** Whether new billing positions in the case are added to this claim; only one active claim per case allowed */
  active?: Maybe<Scalars['Boolean']>;
  /** TODO: Decide on side of relationship */
  billingCaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<Billing_ClaimItemMsg>>>;
  status?: Maybe<Billing_ClaimStatus>;
};

export enum Billing_ClaimStatus {
  ClaimStatusFulfilled = 'CLAIM_STATUS_FULFILLED',
  ClaimStatusNone = 'CLAIM_STATUS_NONE',
  ClaimStatusNotYetSubmitted = 'CLAIM_STATUS_NOT_YET_SUBMITTED',
  ClaimStatusSubmitted = 'CLAIM_STATUS_SUBMITTED'
}

export type Billing_CostUnitTypeMappingMsg = {
  __typename?: 'billing_CostUnitTypeMappingMsg';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  caseType?: Maybe<Billing_BillingCaseType>;
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_CostUnitVisitTypeMappingMsg = {
  __typename?: 'billing_CostUnitVisitTypeMappingMsg';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  caseType?: Maybe<Billing_BillingCaseType>;
  defaultVisitType?: Maybe<Patient_VisitType>;
  id?: Maybe<Scalars['String']>;
  possibleVisitTypes?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Billing_CoverageAssignmentMsg = {
  __typename?: 'billing_CoverageAssignmentMsg';
  coverage?: Maybe<Billing_CoverageMsg>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type Billing_CoverageAssignmentTemplateMsg = {
  __typename?: 'billing_CoverageAssignmentTemplateMsg';
  /** If true, only applies to coverages with billing case scope */
  billingCaseScope?: Maybe<Scalars['Boolean']>;
  coverageType?: Maybe<Billing_CoverageType>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

/** Used to auto-fill coverages on billing case based on its billing type */
export type Billing_CoverageAssignmentsTemplateMsg = {
  __typename?: 'billing_CoverageAssignmentsTemplateMsg';
  assignmentTemplates?: Maybe<Array<Maybe<Billing_CoverageAssignmentTemplateMsg>>>;
  billingType?: Maybe<Billing_BillingTypeMsg>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_CoverageHolderReferenceMsg = {
  __typename?: 'billing_CoverageHolderReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_CoverageHolderType>;
};

export enum Billing_CoverageHolderType {
  CoverageHolderTypeContactParty = 'COVERAGE_HOLDER_TYPE_CONTACT_PARTY',
  CoverageHolderTypeNone = 'COVERAGE_HOLDER_TYPE_NONE',
  CoverageHolderTypePatient = 'COVERAGE_HOLDER_TYPE_PATIENT'
}

export type Billing_CoverageIdentifierMsg = {
  __typename?: 'billing_CoverageIdentifierMsg';
  identifier?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_CoverageIdentifierType>;
};

export enum Billing_CoverageIdentifierType {
  /** TODO: Should this be here or somewhere separate? */
  CoverageIdentifierTypeBillingCaseScopedNumber = 'COVERAGE_IDENTIFIER_TYPE_BILLING_CASE_SCOPED_NUMBER',
  CoverageIdentifierTypeId = 'COVERAGE_IDENTIFIER_TYPE_ID',
  CoverageIdentifierTypeNone = 'COVERAGE_IDENTIFIER_TYPE_NONE',
  CoverageIdentifierTypeNumber = 'COVERAGE_IDENTIFIER_TYPE_NUMBER'
}

export type Billing_CoverageList = {
  __typename?: 'billing_CoverageList';
  coverages?: Maybe<Array<Maybe<Billing_CoverageMsg>>>;
};

export type Billing_CoverageMsg = {
  __typename?: 'billing_CoverageMsg';
  /** Person who holds the coverage, German "Hauptversicherter" */
  coverageHolder?: Maybe<Billing_CoverageHolderReferenceMsg>;
  coverageIdentifiers?: Maybe<Array<Maybe<Billing_CoverageIdentifierMsg>>>;
  deactivated?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  insurer?: Maybe<Billing_InsurerMsg>;
  patientId?: Maybe<Scalars['String']>;
  payors?: Maybe<Array<Maybe<Billing_PayorReferenceMsg>>>;
  proofsOfInsurance?: Maybe<Array<Maybe<Billing_ProofOfInsuranceMsg>>>;
  /** If set, means that the coverage can only be used for the given billing case // TODO: Should patientId still be set? Probably yes. TODO: In service, it's BillingCase instead of id, but for proto, it gets annoying due to circular import. Probably id in the message is fine */
  scopeBillingCaseId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  /** TODO: How to differentiate KV vs. non-KV? */
  type?: Maybe<Billing_CoverageType>;
  validityPeriod?: Maybe<TimeFrameMsg>;
};

export enum Billing_CoverageType {
  /** German Beihilfe */
  CoverageTypeAssistance = 'COVERAGE_TYPE_ASSISTANCE',
  /** German BG */
  CoverageTypeLiabilityAssociation = 'COVERAGE_TYPE_LIABILITY_ASSOCIATION',
  CoverageTypeNone = 'COVERAGE_TYPE_NONE',
  /** Sonstige (covers foreign insurances, additional private insurances, and some private institutions) */
  CoverageTypeOther = 'COVERAGE_TYPE_OTHER',
  /** Patient pays */
  CoverageTypePatient = 'COVERAGE_TYPE_PATIENT',
  CoverageTypePensionInsurance = 'COVERAGE_TYPE_PENSION_INSURANCE',
  CoverageTypePrivate = 'COVERAGE_TYPE_PRIVATE',
  CoverageTypePrivateCare = 'COVERAGE_TYPE_PRIVATE_CARE',
  CoverageTypeSocialOffice = 'COVERAGE_TYPE_SOCIAL_OFFICE',
  CoverageTypeStatutory = 'COVERAGE_TYPE_STATUTORY',
  CoverageTypeStatutoryCare = 'COVERAGE_TYPE_STATUTORY_CARE',
  /** German KV */
  CoverageTypeStatutoryKv = 'COVERAGE_TYPE_STATUTORY_KV'
}

export type Billing_CreateBillingCaseFileRequest = {
  __typename?: 'billing_CreateBillingCaseFileRequest';
  /** optional; otherwise, all certificates for unit and quarter are used */
  billingCertificateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  quarterStartDate?: Maybe<Timestamp>;
  telematikConnectorId?: Maybe<Scalars['String']>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_CreateBillingCaseFileResponse = {
  __typename?: 'billing_CreateBillingCaseFileResponse';
  validationErrors?: Maybe<Scalars['String']>;
  validationFileUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_CreateBillingPositionRequest = {
  __typename?: 'billing_CreateBillingPositionRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  billingDayId?: Maybe<Scalars['String']>;
  billingPosition?: Maybe<Billing_BillingPositionMsg>;
};

export type Billing_CreateBillingProcedureRequest = {
  __typename?: 'billing_CreateBillingProcedureRequest';
  billingProcedure?: Maybe<Billing_BillingProcedureMsg>;
};

export type Billing_CreateBillingProcedureResponse = {
  __typename?: 'billing_CreateBillingProcedureResponse';
  billingProcedure?: Maybe<Billing_BillingProcedureMsg>;
};

export type Billing_CreateCostUnitVisitTypeMappingRequest = {
  __typename?: 'billing_CreateCostUnitVisitTypeMappingRequest';
  mapping?: Maybe<Billing_CostUnitVisitTypeMappingMsg>;
};

export type Billing_CreateCostUnitVisitTypeMappingResponse = {
  __typename?: 'billing_CreateCostUnitVisitTypeMappingResponse';
  mapping?: Maybe<Billing_CostUnitVisitTypeMappingMsg>;
};

export type Billing_CreateCoverageRequest = {
  __typename?: 'billing_CreateCoverageRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  coverage?: Maybe<Billing_CoverageMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
};

/**
 * +++[ REQUESTS ]+++
 * ****************
 */
export type Billing_CreateInsurersRequest = {
  __typename?: 'billing_CreateInsurersRequest';
  insurers?: Maybe<Array<Maybe<Billing_InsurerMsg>>>;
};

export type Billing_CreateInvoiceRequest = {
  __typename?: 'billing_CreateInvoiceRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  billingPositionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * to find an invoice type and default designated user in billing config
   *  should be set if billing case has no billingUnitReference
   */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_CreateMaterialBillingCostRequest = {
  __typename?: 'billing_CreateMaterialBillingCostRequest';
  /**
   * optional, if set will create the material cost using the configuration
   *  and the fields in the material cost message will be ignored (except quantity)
   */
  configurationId?: Maybe<Scalars['String']>;
  materialCost?: Maybe<Billing_BillingMaterialCostMsg>;
};

export type Billing_CreateOrUpdateInsurerRequest = {
  __typename?: 'billing_CreateOrUpdateInsurerRequest';
  /** if set the entity is searched by external Id with the given type */
  byExternalIdType?: Maybe<Billing_ExternalInsurerIdType>;
  insurer?: Maybe<Billing_InsurerMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_CreateProofOfInsuranceRequest = {
  __typename?: 'billing_CreateProofOfInsuranceRequest';
  coverageId?: Maybe<Scalars['String']>;
};

export enum Billing_DaleXmlStatus {
  DaleXmlStatusAborted = 'DALE_XML_STATUS_ABORTED',
  DaleXmlStatusDeliveredAsDuplicate = 'DALE_XML_STATUS_DELIVERED_AS_DUPLICATE',
  DaleXmlStatusDeliveredSuccessfully = 'DALE_XML_STATUS_DELIVERED_SUCCESSFULLY',
  DaleXmlStatusDeliveredWithErrors = 'DALE_XML_STATUS_DELIVERED_WITH_ERRORS',
  DaleXmlStatusDeliveredWithWarnings = 'DALE_XML_STATUS_DELIVERED_WITH_WARNINGS',
  DaleXmlStatusNone = 'DALE_XML_STATUS_NONE',
  DaleXmlStatusNoErrors = 'DALE_XML_STATUS_NO_ERRORS',
  DaleXmlStatusNoFeedbackReceived = 'DALE_XML_STATUS_NO_FEEDBACK_RECEIVED',
  DaleXmlStatusRuleCheckRequired = 'DALE_XML_STATUS_RULE_CHECK_REQUIRED',
  DaleXmlStatusSent = 'DALE_XML_STATUS_SENT',
  DaleXmlStatusWithErrors = 'DALE_XML_STATUS_WITH_ERRORS'
}

export type Billing_DavMsg = {
  __typename?: 'billing_DavMsg';
  ik?: Maybe<Billing_InstitutionIdentifierMsg>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type Billing_DavsMsg = {
  __typename?: 'billing_DavsMsg';
  davCoverage?: Maybe<Billing_DavMsg>;
  davFederal?: Maybe<Billing_DavMsg>;
  davState?: Maybe<Billing_DavMsg>;
};

export type Billing_DeleteBillingCaseRequest = {
  __typename?: 'billing_DeleteBillingCaseRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  hardDelete?: Maybe<Scalars['Boolean']>;
};

export type Billing_DeleteBillingCaseStatusRequest = {
  __typename?: 'billing_DeleteBillingCaseStatusRequest';
  billingCaseStatusId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteBillingFeeCategoryConfigurationRequest = {
  __typename?: 'billing_DeleteBillingFeeCategoryConfigurationRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  contextId?: Maybe<Scalars['String']>;
  contextType?: Maybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Billing_DeleteBillingFeeCategoryConfigurationResponse = {
  __typename?: 'billing_DeleteBillingFeeCategoryConfigurationResponse';
  billingFeeCategoryConfiguration?: Maybe<Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Billing_DeleteBillingPositionRequest = {
  __typename?: 'billing_DeleteBillingPositionRequest';
  billingDayId?: Maybe<Scalars['String']>;
  billingPositionId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteBillingPositionsRequest = {
  __typename?: 'billing_DeleteBillingPositionsRequest';
  billingPositionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_DeleteBillingPositionsResponse = {
  __typename?: 'billing_DeleteBillingPositionsResponse';
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
};

export type Billing_DeleteBillingProcedureRequest = {
  __typename?: 'billing_DeleteBillingProcedureRequest';
  id?: Maybe<Scalars['String']>;
};

export type Billing_DeleteBillingProcedureResponse = {
  __typename?: 'billing_DeleteBillingProcedureResponse';
  id?: Maybe<Scalars['String']>;
};

export type Billing_DeleteBillingStatusRequest = {
  __typename?: 'billing_DeleteBillingStatusRequest';
  billingStatusId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteBillingTypeRequest = {
  __typename?: 'billing_DeleteBillingTypeRequest';
  billingTypeId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCostUnitTypeMappingRequest = {
  __typename?: 'billing_DeleteCostUnitTypeMappingRequest';
  costUnitTypeMappingId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCostUnitTypeMappingResponse = {
  __typename?: 'billing_DeleteCostUnitTypeMappingResponse';
  deletedCostUnitTypeMappingId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCostUnitVisitTypeMappingRequest = {
  __typename?: 'billing_DeleteCostUnitVisitTypeMappingRequest';
  costUnitVisitTypeId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCostUnitVisitTypeMappingResponse = {
  __typename?: 'billing_DeleteCostUnitVisitTypeMappingResponse';
  deletedCostUnitVisitTypeId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCoverageAssignmentsTemplateRequest = {
  __typename?: 'billing_DeleteCoverageAssignmentsTemplateRequest';
  coverageAssignmentsTemplateId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCoverageAssignmentsTemplateResponse = {
  __typename?: 'billing_DeleteCoverageAssignmentsTemplateResponse';
  deletedCoverageAssignmentsTemplateId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCoverageRequest = {
  __typename?: 'billing_DeleteCoverageRequest';
  coverageId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteCoverageResponse = {
  __typename?: 'billing_DeleteCoverageResponse';
  deletedCoverageId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteInvoiceRequest = {
  __typename?: 'billing_DeleteInvoiceRequest';
  invoiceId?: Maybe<Scalars['String']>;
};

export type Billing_DeleteInvoiceResponse = {
  __typename?: 'billing_DeleteInvoiceResponse';
  deletedInvoiceId?: Maybe<Scalars['String']>;
};

export type Billing_DeriveFlatRatesFromTreatmentRequest = {
  __typename?: 'billing_DeriveFlatRatesFromTreatmentRequest';
  icdCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  opsCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_DeriveGoaeCodesFromTreatmentRequest = {
  __typename?: 'billing_DeriveGoaeCodesFromTreatmentRequest';
  treatment?: Maybe<Treatment_TreatmentMsg>;
};

export enum Billing_DischargeBillingCaseStatusUpdateType {
  DischargeBillingCaseStatusUpdateTypeCancelDischarge = 'DISCHARGE_BILLING_CASE_STATUS_UPDATE_TYPE_CANCEL_DISCHARGE',
  DischargeBillingCaseStatusUpdateTypeCompleteDischarge = 'DISCHARGE_BILLING_CASE_STATUS_UPDATE_TYPE_COMPLETE_DISCHARGE',
  DischargeBillingCaseStatusUpdateTypeNone = 'DISCHARGE_BILLING_CASE_STATUS_UPDATE_TYPE_NONE'
}

export type Billing_DiscountMsg = {
  __typename?: 'billing_DiscountMsg';
  discountAmount?: Maybe<Billing_Money>;
  discountDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** DRG grouping result; usually from KODIP */
export type Billing_DrgBillingFieldsMsg = {
  __typename?: 'billing_DrgBillingFieldsMsg';
  /** Zusatzentgelte */
  additionalFees?: Maybe<Array<Maybe<Billing_DrgCalculatedAdditionalFeesMsg>>>;
  /** Grouper status flag für das Aufnahme-/Geburtsgewicht (in g) */
  admissionBodyWeightGrouperStatus?: Maybe<Scalars['String']>;
  /** Grouper status flag für den Aufnahmeanlass (§ 21) */
  admissionEventGrouperStatus?: Maybe<Scalars['String']>;
  /** Grouper status flag für den Aufnahmegrund (§ 301) */
  admissionReasonGrouperStatus?: Maybe<Scalars['String']>;
  /** Grouper status flag für das Alter in Tagen (ab 2011_2013) */
  ageDaysGrouperStatus?: Maybe<Scalars['String']>;
  /** Grouper status flag für das Alter in Jahren (ab 2011_2013) */
  ageYearsGrouperStatus?: Maybe<Scalars['String']>;
  /**
   * B-BEP Abschlag in Euro
   *  B-BEP = Beatmungsstatus/Beatmungsentwöhnungspotentials
   */
  bBepDiscount?: Maybe<DecimalMsg>;
  bBepDiscountType?: Maybe<Billing_BbepDiscountType>;
  /** Basisfallwert */
  baseRate?: Maybe<DecimalMsg>;
  /**
   * Abschlag in Euro pro Tag bei Unterschreitung der oGVD
   *  Discount in euros per day if the upper limit of stay is not met
   */
  dailyLengthOfStayDiscount?: Maybe<DecimalMsg>;
  /**
   * Zuschlag in Euro pro Tag bei Überschreitung der oGVD
   *  Surcharge in euros per day if the upper limit length of stay is exceeded
   */
  dailyLengthOfStaySurcharge?: Maybe<DecimalMsg>;
  /**
   * Abschlag in Euro pro Tag bei Unterschreitung der mVD bei Verlegungsfällen
   *  Discount in euros per day if the average length of stay is not met in the case of transfer
   */
  dailyMeanLengthOfStayDiscount?: Maybe<DecimalMsg>;
  /** Days below the low trim point; Tage mit Abschlägen wg. Unterschreitung der unteren Grenzverweildauer */
  daysBelowLowerLengthOfStayLimit?: Maybe<Scalars['Int']>;
  /**
   * Days below the average length of stay; Tage mit Abschläg wg. Unterschreitung der mittleren Verweildauer bei
   *  Verlegungsfällen
   */
  daysBelowMeanLengthOfStay?: Maybe<Scalars['Int']>;
  /** Days exceeding the high trim point; Tage mit Zuschlag wg. Überschreitung der oberen Grenzverweildauer */
  daysExceedingUpperLengthOfStayLimit?: Maybe<Scalars['Int']>;
  /** DRG; 0 to 25 */
  diagRelatedGroup?: Maybe<Scalars['String']>;
  diagRelatedGroupText?: Maybe<Scalars['String']>;
  /** Grouper diagnoses statuses string */
  diagnosesGrouperStatuses?: Maybe<Scalars['String']>;
  /** Grouper status flag für den Entlassungsgrund */
  dischargeReasonGrouperStatus?: Maybe<Scalars['String']>;
  /**
   * Ab-/Zuschläge zum Standard-DRG-Erlös
   *  Discounts/Surcharges to the standard drg price
   */
  drgPriceAdjustment?: Maybe<DecimalMsg>;
  /**
   * Effektiver DRG-Erlös (ohne Zusatzentgelte)
   *  effective DRG price (without additional fees)
   */
  effectiveDrgPrice?: Maybe<DecimalMsg>;
  /**
   * Effektiv-Relativgewicht; diesen Wert bitte nur für statische Zwecke nutzen; kaufmännisch korrekt sind der
   *  Eff.Erlös und die Ab/Zuschläge zum Erlös
   *
   *  Effective relative weight; please use this value only for static purposes; commercially correct are the effective
   *  revenue and the discounts/surcharges to the revenue
   */
  effectiveRelativeWeight?: Maybe<DecimalMsg>;
  grouperStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Ist Ausnahme von Wiederaufnahme */
  isExceptionOfReadmission?: Maybe<Scalars['Boolean']>;
  /**
   * Grouperinformation, ob ein abgesenktes oder nicht-abgesenktes Relativgewicht für die DRG bei der Ermittlung des
   *  Erlöses verwendet wurde
   *  Nein, wenn nicht abgesenkte Bewertungsrelation genutzt worden ist oder eine abgesenkte überhaupt nicht vorhanden
   *  ist
   *  Ja, wenn die abgesenkte abgerechnet wurde (für FPV 2017 nur I68D oder I68E)
   *
   *
   *  Grouper information on whether a reduced or non-reduced relative weight for the DRG was used to determine the
   *  revenue
   *  No, if a non-reduced valuation ratio was used or a reduced one does not exist at all
   *  Yes, if the reduced one was billed (for FPV 2017 only I68D or I68E)
   */
  isReducedRelWeightUsed?: Maybe<Scalars['Boolean']>;
  /** Ist eine Verlegungsfallpauschale */
  isRelocationFee?: Maybe<Scalars['Boolean']>;
  /** Grouper status flag für Verwendung der Urlaubstage (0=OK, 2= Fehler) */
  leaveDaysGrouperError?: Maybe<Scalars['Boolean']>;
  /** Grouper status flag für die Verweildauer */
  lengthOfStayGrouperStatus?: Maybe<Scalars['String']>;
  /** Low trim point = 1. mit Abschlag bei Unterschreitung der uGVD */
  lowerLengthOfStayLimit?: Maybe<Scalars['Int']>;
  /** Grouper status flag für die Hauptdiagnose */
  mainDiagnosisGrouperStatus?: Maybe<Scalars['String']>;
  /** MDC; 0 to 999 */
  majorDiagCategory?: Maybe<Scalars['String']>;
  majorDiagCategoryText?: Maybe<Scalars['String']>;
  /** mittlere Verweildauer (mVD) */
  meanLengthOfStay?: Maybe<DecimalMsg>;
  /**
   * Grouper status flag für MHLS (Mental Health Legal Status - siehe MentalStatus, Status der psychiatrischen
   *  Zwangseinweisung)
   */
  mentalHealthLegalStatusGrouperStatus?: Maybe<Scalars['String']>;
  /** Pflexit: Ergebnis für die Pflege-Erlösermittlung durch den DRG-Grouper */
  nursingRevenueResult?: Maybe<Billing_DrgNursingRevenueResultMsg>;
  partition?: Maybe<Billing_DrgPartition>;
  pccl?: Maybe<Scalars['Int']>;
  /** Grouper procedures statuses string */
  proceduresGrouperStatuses?: Maybe<Scalars['String']>;
  /** Abschlag-Relativgewicht */
  relativeWeightDiscount?: Maybe<DecimalMsg>;
  /** Zuschläge Relativgewicht */
  relativeWeightSurcharge?: Maybe<DecimalMsg>;
  /** Verlegung Relativgewicht */
  relocationRelativeWeight?: Maybe<DecimalMsg>;
  /** Grouper status flag für SameDay */
  sameDayGrouperStatus?: Maybe<Scalars['String']>;
  /** Grouper status flag für das Geschlecht */
  sexGrouperStatus?: Maybe<Scalars['String']>;
  /** Standard DRG-Erlös */
  standardDrgPrice?: Maybe<DecimalMsg>;
  /** Standard Relativgewicht */
  standardRelativeWeight?: Maybe<DecimalMsg>;
  /**
   * Ab-/Zuschläge zum Standard-Relativgewicht;diesen Wert bitte nur für statische Zwecke nutzen; kaufmännisch korrekt
   *  sind der Eff.Erlös und die Ab/Zuschläge zum Erlös
   *
   *  Discounts/surcharges to the standard relative weight; please use this value only for static purposes; commercially
   *  correct are the effective revenue and the discounts/surcharges to the revenue
   */
  standardRelativeWeightAdjustment?: Maybe<DecimalMsg>;
  /** Gesamtbetrag der Zusatzentgelte */
  totalAdditionalFee?: Maybe<DecimalMsg>;
  /** Rueckgabe: DRG Art Vereinbarung (11=Bundeseinheitlich, 12=Individuell verhandelbar) */
  typeAgreement?: Maybe<Billing_DrgTypeAgreement>;
  /** High trim point = 1. mit Zuschlag bei Überschreitung der oberen Grenzverweildauer (oGVD) */
  upperLengthOfStayLimit?: Maybe<Scalars['Int']>;
  /**
   * vom Grouper berechnete/benutzte Verweildauer des Falles
   *  Duration of stay of the case calculated/used by the grouper
   *  los = length of stay
   */
  usedLengthOfStay?: Maybe<Scalars['Int']>;
  /** Grouper status flag für die Beatmungsstunden */
  ventilationHoursGrouperStatus?: Maybe<Scalars['String']>;
};

export enum Billing_DrgCalculatedAdditionalFeeType {
  /** 2=individuell zu vereinbaren */
  DrgCalculatedAdditionalFeeTypeIndividual = 'DRG_CALCULATED_ADDITIONAL_FEE_TYPE_INDIVIDUAL',
  /** 1=bundeseinheitlich */
  DrgCalculatedAdditionalFeeTypeNational = 'DRG_CALCULATED_ADDITIONAL_FEE_TYPE_NATIONAL',
  DrgCalculatedAdditionalFeeTypeNone = 'DRG_CALCULATED_ADDITIONAL_FEE_TYPE_NONE',
  /** 3=NUB neue Untersuchungs- und Behandlungsmethoden */
  DrgCalculatedAdditionalFeeTypeNub = 'DRG_CALCULATED_ADDITIONAL_FEE_TYPE_NUB'
}

/** Zusatzentgelte */
export type Billing_DrgCalculatedAdditionalFeesMsg = {
  __typename?: 'billing_DrgCalculatedAdditionalFeesMsg';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  opCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  price?: Maybe<DecimalMsg>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_DrgCalculatedAdditionalFeeType>;
};

/** Pflexit result for nursing revenue determination */
export type Billing_DrgNursingRevenueResultMsg = {
  __typename?: 'billing_DrgNursingRevenueResultMsg';
  /** Verwendetes Pflegeentgelt */
  baseRate?: Maybe<DecimalMsg>;
  /**
   * Pflegebewertungsrelation pro Tag
   *
   *  aka nursing care rating ratio or nursing care assessment ratio
   *
   *  The Nursing Care Rating Ratio per day describes the financial valuation of nursing care services provided to a
   *  patient within a single day in the context of the DRG system
   */
  dailyCareEvalRatio?: Maybe<DecimalMsg>;
  /** Erlös in Euro pro Tag */
  pricePerDay?: Maybe<DecimalMsg>;
  /** Gesamtzahl der Pflegetage */
  totalCareDays?: Maybe<Scalars['Int']>;
  /** Gesamterlös in Euro */
  totalPrice?: Maybe<DecimalMsg>;
};

export enum Billing_DrgPartition {
  /** allgemeine (A) */
  DrgPartitionGeneral = 'DRG_PARTITION_GENERAL',
  /** medizinische (M) */
  DrgPartitionMedical = 'DRG_PARTITION_MEDICAL',
  DrgPartitionNone = 'DRG_PARTITION_NONE',
  /** operative (O) */
  DrgPartitionSurgical = 'DRG_PARTITION_SURGICAL'
}

export enum Billing_DrgTypeAgreement {
  /** 12=Individuell verhandelbar */
  DrgTypeAgreementIndividual = 'DRG_TYPE_AGREEMENT_INDIVIDUAL',
  /** 11=Bundeseinheitlich */
  DrgTypeAgreementNational = 'DRG_TYPE_AGREEMENT_NATIONAL',
  DrgTypeAgreementNone = 'DRG_TYPE_AGREEMENT_NONE'
}

export type Billing_EbsMsg = {
  __typename?: 'billing_EbsMsg';
  ebsDescription?: Maybe<Scalars['String']>;
  ebsIdentifier?: Maybe<Scalars['String']>;
  ik?: Maybe<Billing_InstitutionIdentifierMsg>;
};

export type Billing_ExportCodingOverviewRequest = {
  __typename?: 'billing_ExportCodingOverviewRequest';
  filter?: Maybe<Billing_ListBillingCasesRequest>;
};

export type Billing_ExportCodingOverviewResponse = {
  __typename?: 'billing_ExportCodingOverviewResponse';
  fileName?: Maybe<Scalars['String']>;
};

export type Billing_ExternalBillingProcedureIdMsg = {
  __typename?: 'billing_ExternalBillingProcedureIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalBillingProcedureIdType>;
};

export enum Billing_ExternalBillingProcedureIdType {
  ExternalBillingProcedureIdTypeNone = 'EXTERNAL_BILLING_PROCEDURE_ID_TYPE_NONE',
  ExternalBillingProcedureIdTypeSap = 'EXTERNAL_BILLING_PROCEDURE_ID_TYPE_SAP'
}

export type Billing_ExternalBillingStatusIdMsg = {
  __typename?: 'billing_ExternalBillingStatusIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalBillingStatusIdType>;
};

export enum Billing_ExternalBillingStatusIdType {
  ExternalBillingCaseBillingStatusIdTypeNone = 'EXTERNAL_BILLING_CASE_BILLING_STATUS_ID_TYPE_NONE',
  ExternalBillingCaseBillingStatusIdTypeSap = 'EXTERNAL_BILLING_CASE_BILLING_STATUS_ID_TYPE_SAP'
}

export type Billing_ExternalBillingTypeIdMsg = {
  __typename?: 'billing_ExternalBillingTypeIdMsg';
  externalId?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalBillingTypeIdType>;
};

export enum Billing_ExternalBillingTypeIdType {
  ExternalBillingTypeIdTypeIsh = 'EXTERNAL_BILLING_TYPE_ID_TYPE_ISH',
  ExternalBillingTypeIdTypeNone = 'EXTERNAL_BILLING_TYPE_ID_TYPE_NONE'
}

export type Billing_ExternalInsuranceLegalBasisIdMsg = {
  __typename?: 'billing_ExternalInsuranceLegalBasisIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalInsuranceLegalBasisIdType>;
};

export enum Billing_ExternalInsuranceLegalBasisIdType {
  /** German "Kostenträgerabrechnungsbereich" */
  ExternalInsuranceLegalBasisIdTypeGermanKtab = 'EXTERNAL_INSURANCE_LEGAL_BASIS_ID_TYPE_GERMAN_KTAB',
  ExternalInsuranceLegalBasisIdTypeNone = 'EXTERNAL_INSURANCE_LEGAL_BASIS_ID_TYPE_NONE'
}

export type Billing_ExternalInsurerIdMsg = {
  __typename?: 'billing_ExternalInsurerIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalInsurerIdType>;
};

export enum Billing_ExternalInsurerIdType {
  ExternalInsurerIdTypeGermanVknr = 'EXTERNAL_INSURER_ID_TYPE_GERMAN_VKNR',
  ExternalInsurerIdTypeNone = 'EXTERNAL_INSURER_ID_TYPE_NONE',
  ExternalInsurerIdTypeSap = 'EXTERNAL_INSURER_ID_TYPE_SAP'
}

export type Billing_ExternalInsurerNetworkIdMsg = {
  __typename?: 'billing_ExternalInsurerNetworkIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_ExternalInsurerNetworkIdType>;
};

export enum Billing_ExternalInsurerNetworkIdType {
  ExternalInsurerNetworkIdTypeDistrictCode = 'EXTERNAL_INSURER_NETWORK_ID_TYPE_DISTRICT_CODE',
  ExternalInsurerNetworkIdTypeNone = 'EXTERNAL_INSURER_NETWORK_ID_TYPE_NONE'
}

export type Billing_FeeCategoryGroupReferenceMsg = {
  __typename?: 'billing_FeeCategoryGroupReferenceMsg';
  billingCaseId?: Maybe<Scalars['String']>;
  /** i.e. treatment id. pair with context_type */
  contextId?: Maybe<Scalars['String']>;
  /** i.e. treatment. pair with context_id */
  contextType?: Maybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Billing_FeeCategoryReferenceMsg = {
  __typename?: 'billing_FeeCategoryReferenceMsg';
  billingFeeCategory?: Maybe<Billing_BillingFeeCategory>;
  feeCategoryGroupReference?: Maybe<Billing_FeeCategoryGroupReferenceMsg>;
};

export type Billing_FindBillingCaseStatusesRequest = {
  __typename?: 'billing_FindBillingCaseStatusesRequest';
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_FindBillingCaseStatusesResponse = {
  __typename?: 'billing_FindBillingCaseStatusesResponse';
  billingCaseStatusByName?: Maybe<Array<Maybe<Billing_FindBillingCaseStatusesResponse_BillingCaseStatusByNameEntry>>>;
};

export type Billing_FindBillingCaseStatusesResponse_BillingCaseStatusByNameEntry = {
  __typename?: 'billing_FindBillingCaseStatusesResponse_BillingCaseStatusByNameEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_BillingCaseStatusMsg>;
};

export type Billing_FindBillingTypeRequest = {
  __typename?: 'billing_FindBillingTypeRequest';
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Billing_BillingTypeOwnerMsg>;
};

export type Billing_FindBillingTypeResponse = {
  __typename?: 'billing_FindBillingTypeResponse';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Billing_FindBillingTypesByNameRequest = {
  __typename?: 'billing_FindBillingTypesByNameRequest';
  name?: Maybe<Scalars['String']>;
};

export type Billing_FindBillingTypesRequest = {
  __typename?: 'billing_FindBillingTypesRequest';
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  owner?: Maybe<Billing_BillingTypeOwnerMsg>;
};

export type Billing_FindBillingTypesResponse = {
  __typename?: 'billing_FindBillingTypesResponse';
  billingTypeByName?: Maybe<Array<Maybe<Billing_FindBillingTypesResponse_BillingTypeByNameEntry>>>;
};

export type Billing_FindBillingTypesResponse_BillingTypeByNameEntry = {
  __typename?: 'billing_FindBillingTypesResponse_BillingTypeByNameEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_BillingTypeMsg>;
};

export type Billing_FindCostUnitTypeMappingRequest = {
  __typename?: 'billing_FindCostUnitTypeMappingRequest';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  caseType?: Maybe<Billing_BillingCaseType>;
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
};

export type Billing_FindCostUnitTypeMappingResponse = {
  __typename?: 'billing_FindCostUnitTypeMappingResponse';
  found?: Maybe<Scalars['Boolean']>;
  mapping?: Maybe<Billing_CostUnitTypeMappingMsg>;
};

export type Billing_FindCostUnitVisitTypeMappingRequest = {
  __typename?: 'billing_FindCostUnitVisitTypeMappingRequest';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  caseType?: Maybe<Billing_BillingCaseType>;
  /** if not set, allow finding the mapping defined for caseType without billingType if no mapping found for the combination of both */
  requireExactMatch?: Maybe<Scalars['Boolean']>;
};

export type Billing_FindCostUnitVisitTypeMappingResponse = {
  __typename?: 'billing_FindCostUnitVisitTypeMappingResponse';
  found?: Maybe<Scalars['Boolean']>;
  mapping?: Maybe<Billing_CostUnitVisitTypeMappingMsg>;
};

export type Billing_FindCoverageAssignmentsTemplateRequest = {
  __typename?: 'billing_FindCoverageAssignmentsTemplateRequest';
  billingTypeId?: Maybe<Scalars['String']>;
};

export type Billing_FindCoverageAssignmentsTemplateResponse = {
  __typename?: 'billing_FindCoverageAssignmentsTemplateResponse';
  coverageAssignmentsTemplate?: Maybe<Billing_CoverageAssignmentsTemplateMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Billing_FindInsurerNetworkRequest = {
  __typename?: 'billing_FindInsurerNetworkRequest';
  /** mandatory */
  externalId?: Maybe<Scalars['String']>;
  /** mandatory */
  externalIdType?: Maybe<Billing_ExternalInsurerNetworkIdType>;
};

export type Billing_FindInsurerNetworkResponse = {
  __typename?: 'billing_FindInsurerNetworkResponse';
  exists?: Maybe<Scalars['Boolean']>;
  insurerNetwork?: Maybe<Billing_InsurerNetworkMsg>;
};

export type Billing_FindInsurerRequest = {
  __typename?: 'billing_FindInsurerRequest';
  /** optional filter */
  dataSourceType?: Maybe<Billing_InsurerDataSourceType>;
  externalId?: Maybe<Billing_ExternalInsurerIdMsg>;
  number?: Maybe<Scalars['String']>;
  /** filters german Insurers for activity */
  validityPeriod?: Maybe<TimeFrameMsg>;
};

export type Billing_FindInsurerResponse = {
  __typename?: 'billing_FindInsurerResponse';
  exists?: Maybe<Scalars['Boolean']>;
  insurer?: Maybe<Billing_InsurerMsg>;
};

export type Billing_FindValidCoverageTypesRequest = {
  __typename?: 'billing_FindValidCoverageTypesRequest';
  /** billing type id is a required filter */
  billingTypeId?: Maybe<Scalars['String']>;
  /** optional filter */
  caseType?: Maybe<Billing_BillingCaseType>;
};

export type Billing_FindValidCoverageTypesResponse = {
  __typename?: 'billing_FindValidCoverageTypesResponse';
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
};

export type Billing_FinishBillingCaseAdministrationRequest = {
  __typename?: 'billing_FinishBillingCaseAdministrationRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  confirmBillingCaseTypeChange?: Maybe<Scalars['Boolean']>;
  discharged?: Maybe<Scalars['Boolean']>;
  preliminary?: Maybe<Scalars['Boolean']>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Billing_GermanBgInvoiceDetailsMsg = {
  __typename?: 'billing_GermanBgInvoiceDetailsMsg';
  /** Rechnungstyp [sri_2] */
  bgInvoiceType?: Maybe<Billing_German_BgInvoiceType>;
  designatedUserId?: Maybe<Scalars['String']>;
  diagnosisDetails?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  freeTextDiagnosis?: Maybe<Scalars['String']>;
  /** [sri_6] */
  generalCostsFeeTotal?: Maybe<Billing_Money>;
  id?: Maybe<Scalars['String']>;
  linkedFormId?: Maybe<Scalars['String']>;
  /** [sri_7] */
  materialCostsFeeTotal?: Maybe<Billing_Money>;
  priceTotalHospital?: Maybe<Billing_Money>;
  /** [kto_1] */
  priceTotalPhysician?: Maybe<Billing_Money>;
  /** [sri_4] */
  selectedTreatmentTypeFeeTotal?: Maybe<Billing_Money>;
  /** [sri_5] */
  specialCostHospitalTotal?: Maybe<Billing_Money>;
  /** [sri_5] */
  specialCostPhysicianTotal?: Maybe<Billing_Money>;
  /** Art der Heilbehandlung [sri_1] */
  therapeuticTreatmentBillingType?: Maybe<Billing_TherapeuticTreatmentBillingType>;
  xmlInfoId?: Maybe<Scalars['String']>;
};

export type Billing_GermanInsurerBillingInformationMsg = {
  __typename?: 'billing_GermanInsurerBillingInformationMsg';
  insurerBillingNumber?: Maybe<Scalars['String']>;
  isBillingIk?: Maybe<Scalars['Boolean']>;
  validityPeriod?: Maybe<TimeFrameMsg>;
};

export type Billing_GermanInsurerInformationMsg = {
  __typename?: 'billing_GermanInsurerInformationMsg';
  /** gueltigkeit */
  activePeriod?: Maybe<TimeFrameMsg>;
  /** adresse_liste -> anschrift */
  address?: Maybe<Core_AddressMsg>;
  /** kt_abrechnungsbereich_liste */
  billingAreas?: Maybe<Array<Maybe<Billing_BillingAreaMsg>>>;
  /** abrechnungsstelle */
  billingOffice?: Maybe<Billing_BillingOfficeMsg>;
  /** gebuehrenordnung */
  billingSystem?: Maybe<Billing_BillingCatalogType>;
  /** vertrags_kv */
  contractKvId?: Maybe<Scalars['String']>;
  datasetQuarter?: Maybe<Scalars['Int']>;
  datasetYear?: Maybe<Scalars['Int']>;
  /** dav_liste */
  davs?: Maybe<Billing_DavsMsg>;
  /** ebs */
  ebs?: Maybe<Billing_EbsMsg>;
  id?: Maybe<Scalars['String']>;
  /** unz_kv_geltungsbereich_liste */
  inadmissibleKvAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** abrechnungs_ik */
  insurerBillingInfo?: Maybe<Array<Maybe<Billing_GermanInsurerBillingInformationMsg>>>;
  /** bezeichnung */
  insurerDescription?: Maybe<Billing_InsurerDescriptionMsg>;
  /** existenzbeendigung */
  insurerExistenceFinish?: Maybe<Billing_InsurerExistenceFinishMsg>;
  /** kostentraegergruppe */
  insurerGroupId?: Maybe<Scalars['String']>;
  /** letzte_aenderung */
  lastChange?: Maybe<Billing_LastChangeMsg>;
  /** ortssuchname_liste -> ortssuchname */
  placeSearchNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** adresse_liste -> postfach */
  postOfficeBox?: Maybe<Core_AddressMsg>;
  /** "Temporärer Kostenträger-Stammsatz" */
  temporary?: Maybe<Scalars['Boolean']>;
  vknr?: Maybe<Scalars['String']>;
  /** wop */
  wop?: Maybe<Billing_PlaceOfResidencePrincipleMsg>;
};

export type Billing_GermanInsurerSearchAidMsg = {
  __typename?: 'billing_GermanInsurerSearchAidMsg';
  /** German "Ortssuchname" */
  locationSearchTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Additional name by which search is possible, German "Suchname" */
  searchName?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingCaseByCaseNumberRequest = {
  __typename?: 'billing_GetBillingCaseByCaseNumberRequest';
  billingCaseNumber?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingCaseRequest = {
  __typename?: 'billing_GetBillingCaseRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingCasesRequest = {
  __typename?: 'billing_GetBillingCasesRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_GetBillingFeeCategoryConfigurationRequest = {
  __typename?: 'billing_GetBillingFeeCategoryConfigurationRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  contextId?: Maybe<Scalars['String']>;
  contextType?: Maybe<Billing_BillingFeeCategoryConfigurationContextType>;
};

export type Billing_GetBillingFeeCategoryConfigurationResponse = {
  __typename?: 'billing_GetBillingFeeCategoryConfigurationResponse';
  allowedFeeCategories?: Maybe<Array<Maybe<Billing_BillingFeeCategory>>>;
  billingFeeCategoryConfiguration?: Maybe<Billing_BillingFeeCategoryConfigurationMsg>;
  defaultFeeCategories?: Maybe<Array<Maybe<Billing_BillingFeeCategory>>>;
};

export type Billing_GetBillingProcedureBulkRequest = {
  __typename?: 'billing_GetBillingProcedureBulkRequest';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_GetBillingProcedureRequest = {
  __typename?: 'billing_GetBillingProcedureRequest';
  id?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingProcedureResponse = {
  __typename?: 'billing_GetBillingProcedureResponse';
  billingProcedure?: Maybe<Billing_BillingProcedureMsg>;
};

export type Billing_GetBillingProceduresLetterTextRequest = {
  __typename?: 'billing_GetBillingProceduresLetterTextRequest';
  generationParameters?: Maybe<Common_Letter_LetterTextGenerationParametersMsg>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingTypeFeeCategoryMappingRequest = {
  __typename?: 'billing_GetBillingTypeFeeCategoryMappingRequest';
  billingCaseType?: Maybe<Billing_BillingCaseType>;
  billingTypeId?: Maybe<Scalars['String']>;
};

export type Billing_GetBillingTypeFeeCategoryMappingResponse = {
  __typename?: 'billing_GetBillingTypeFeeCategoryMappingResponse';
  billingTypeFeeCategoryMapping?: Maybe<Billing_BillingTypeFeeCategoryMappingMsg>;
};

export type Billing_GetCoverageRequest = {
  __typename?: 'billing_GetCoverageRequest';
  coverageId?: Maybe<Scalars['String']>;
};

export type Billing_GetCoveragesRequest = {
  __typename?: 'billing_GetCoveragesRequest';
  coverageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_GetCurrentCaseRequest = {
  __typename?: 'billing_GetCurrentCaseRequest';
  /** must be provided if requireExactUnit is false and the unitReference point to an organizational unit */
  parentDepartmentId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  /** If true, only cases that belong to the exact unitReference are considered; if false, the unit's parents as well */
  requireExactUnit?: Maybe<Scalars['Boolean']>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_GetCurrentCaseResponse = {
  __typename?: 'billing_GetCurrentCaseResponse';
  case?: Maybe<Billing_BillingCaseMsg>;
};

export type Billing_GetInvoiceRequest = {
  __typename?: 'billing_GetInvoiceRequest';
  invoiceId?: Maybe<Scalars['String']>;
};

export type Billing_GetLightBillingCaseInfoRequest = {
  __typename?: 'billing_GetLightBillingCaseInfoRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_GetLightBillingCaseInfoResponse = {
  __typename?: 'billing_GetLightBillingCaseInfoResponse';
  billingCaseId?: Maybe<Scalars['String']>;
  currentStatus?: Maybe<Billing_BillingCaseStatusMsg>;
};

export type Billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionResponse = {
  __typename?: 'billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionResponse';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionsRequest = {
  __typename?: 'billing_GetVisitIdsOfNotLinkedToInvoicesBillingPositionsRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Billing_GrouperType {
  GrouperTypeDrg = 'GROUPER_TYPE_DRG',
  GrouperTypeNone = 'GROUPER_TYPE_NONE',
  GrouperTypePepp = 'GROUPER_TYPE_PEPP'
}

export type Billing_GrouperTypeAssignmentMsg = {
  __typename?: 'billing_GrouperTypeAssignmentMsg';
  caseType?: Maybe<Billing_BillingCaseType>;
  grouperType?: Maybe<Billing_GrouperType>;
};

export type Billing_InstitutionIdentifierMsg = {
  __typename?: 'billing_InstitutionIdentifierMsg';
  ikNumber?: Maybe<Scalars['Int']>;
};

export type Billing_InsuranceLegalBasisMsg = {
  __typename?: 'billing_InsuranceLegalBasisMsg';
  description?: Maybe<Scalars['String']>;
  externalIds?: Maybe<Array<Maybe<Billing_ExternalInsuranceLegalBasisIdMsg>>>;
  id?: Maybe<Scalars['String']>;
};

export enum Billing_InsurerDataSourceType {
  InsurerDataSourceTypeCustom = 'INSURER_DATA_SOURCE_TYPE_CUSTOM',
  InsurerDataSourceTypeGermanArgeIk = 'INSURER_DATA_SOURCE_TYPE_GERMAN_ARGE_IK',
  /** Official list of German occupational accident insurers: https://www.dguv.de/dale-uv/info_fuer_softwarehersteller/downloads/index.jsp */
  InsurerDataSourceTypeGermanDguv = 'INSURER_DATA_SOURCE_TYPE_GERMAN_DGUV',
  InsurerDataSourceTypeGermanDguvHistory = 'INSURER_DATA_SOURCE_TYPE_GERMAN_DGUV_HISTORY',
  InsurerDataSourceTypeGermanKbv = 'INSURER_DATA_SOURCE_TYPE_GERMAN_KBV',
  /** Official list of German private insurers */
  InsurerDataSourceTypeGermanPkv = 'INSURER_DATA_SOURCE_TYPE_GERMAN_PKV',
  /** Imported from hospital information system */
  InsurerDataSourceTypeHis = 'INSURER_DATA_SOURCE_TYPE_HIS',
  InsurerDataSourceTypeNone = 'INSURER_DATA_SOURCE_TYPE_NONE'
}

export type Billing_InsurerDescriptionMsg = {
  __typename?: 'billing_InsurerDescriptionMsg';
  name?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sortName?: Maybe<Scalars['String']>;
};

export type Billing_InsurerExistenceFinishMsg = {
  __typename?: 'billing_InsurerExistenceFinishMsg';
  acquiringCoverageId?: Maybe<Scalars['String']>;
  finishType?: Maybe<Billing_InsurerFinishType>;
  lastQuarter?: Maybe<Scalars['Int']>;
  lastYear?: Maybe<Scalars['Int']>;
};

export type Billing_InsurerFeeScheduleKeyValueMsg = {
  __typename?: 'billing_InsurerFeeScheduleKeyValueMsg';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum Billing_InsurerFinishType {
  InsurerFinishTypeFused = 'INSURER_FINISH_TYPE_FUSED',
  InsurerFinishTypeLiquidated = 'INSURER_FINISH_TYPE_LIQUIDATED',
  InsurerFinishTypeNone = 'INSURER_FINISH_TYPE_NONE'
}

export type Billing_InsurerGroupKeyValueMsg = {
  __typename?: 'billing_InsurerGroupKeyValueMsg';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Billing_InsurerList = {
  __typename?: 'billing_InsurerList';
  insurers?: Maybe<Array<Maybe<Billing_InsurerMsg>>>;
};

export type Billing_InsurerMsg = {
  __typename?: 'billing_InsurerMsg';
  /** German "Gebührenordnung" */
  billingTypes?: Maybe<Array<Maybe<Billing_BillingCatalogType>>>;
  /** Id of the catalog responsible for loading this insurer instance */
  catalogId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  dataSourceType?: Maybe<Billing_InsurerDataSourceType>;
  deleted?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Billing_ExternalInsurerIdMsg>>>;
  germanInsurerInformation?: Maybe<Billing_GermanInsurerInformationMsg>;
  id?: Maybe<Scalars['String']>;
  legalBasis?: Maybe<Array<Maybe<Billing_InsuranceLegalBasisMsg>>>;
  name?: Maybe<Scalars['String']>;
  networks?: Maybe<Array<Maybe<Billing_InsurerNetworkMsg>>>;
  /** For Germans: IKNR */
  number?: Maybe<Scalars['String']>;
  /** For custom insurers, the unit responsible for configuration of the insurer */
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  validity?: Maybe<TimeFrameMsg>;
};

export type Billing_InsurerNetworkMsg = {
  __typename?: 'billing_InsurerNetworkMsg';
  externalIds?: Maybe<Array<Maybe<Billing_ExternalInsurerNetworkIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Billing_InvoiceCategory {
  /** de: Sammelrechnung, consolidates multiple regular or final bills into one bill (can not have additional billing items) */
  InvoiceCategoryConsolidated = 'INVOICE_CATEGORY_CONSOLIDATED',
  /** consolidates several interim bills into one final bill (can not have additional items) */
  InvoiceCategoryFinal = 'INVOICE_CATEGORY_FINAL',
  InvoiceCategoryInterim = 'INVOICE_CATEGORY_INTERIM',
  InvoiceCategoryInterimNone = 'INVOICE_CATEGORY_INTERIM_NONE',
  InvoiceCategoryProForma = 'INVOICE_CATEGORY_PRO_FORMA',
  InvoiceCategoryRegular = 'INVOICE_CATEGORY_REGULAR',
  InvoiceCategoryReminder = 'INVOICE_CATEGORY_REMINDER'
}

export type Billing_InvoiceMsg = {
  __typename?: 'billing_InvoiceMsg';
  billingCase?: Maybe<Billing_BillingCaseMsg>;
  cancellationReason?: Maybe<Scalars['String']>;
  category?: Maybe<Billing_InvoiceCategory>;
  /** Precise date */
  dueDate?: Maybe<Timestamp>;
  /** Either relative e.g. in 5 days */
  dueDateDuration?: Maybe<PrecisionDurationMsg>;
  externalOrganizationId?: Maybe<Scalars['String']>;
  finalPaymentDate?: Maybe<Timestamp>;
  germanBgInvoiceDetails?: Maybe<Billing_GermanBgInvoiceDetailsMsg>;
  id?: Maybe<Scalars['String']>;
  /** if type is FINAL or CONSOLIDATED the invoice can contain other invoices */
  includedInvoices?: Maybe<Array<Maybe<Billing_InvoiceMsg>>>;
  invoiceTextHtml?: Maybe<Scalars['String']>;
  issuer?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** Consecutive bill number */
  number?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  paid?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
  performancePeriod?: Maybe<TimeFrameMsg>;
  positions?: Maybe<Array<Maybe<Billing_InvoicePositionMsg>>>;
  /** Date to be displayed on the bill */
  postedDate?: Maybe<Timestamp>;
  procedureIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** refered invoice used for reminders */
  referencedInvoice?: Maybe<Billing_InvoiceMsg>;
  status?: Maybe<Billing_InvoiceStatus>;
  timestamps?: Maybe<TimeMsg>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_InvoicePositionMsg = {
  __typename?: 'billing_InvoicePositionMsg';
  billingPosition?: Maybe<Billing_BillingPositionMsg>;
  /** percentage that of total billing position contained in this invoice */
  splitPercentage?: Maybe<DecimalMsg>;
  /** absolute value of total billing position contained in this invoice */
  splitPrice?: Maybe<Billing_Money>;
};

export enum Billing_InvoiceStatus {
  InvoiceStatusCancelled = 'INVOICE_STATUS_CANCELLED',
  InvoiceStatusCompleted = 'INVOICE_STATUS_COMPLETED',
  InvoiceStatusNone = 'INVOICE_STATUS_NONE',
  InvoiceStatusPaymentNotComplete = 'INVOICE_STATUS_PAYMENT_NOT_COMPLETE'
}

export type Billing_LastChangeMsg = {
  __typename?: 'billing_LastChangeMsg';
  /** wirksamkeitsdatum */
  effectiveDate?: Maybe<Timestamp>;
  /** erfassungsdatum */
  entryDate?: Maybe<Timestamp>;
};

export type Billing_LengthOfStayStatus = {
  __typename?: 'billing_LengthOfStayStatus';
  lowerLengthOfStayLimit?: Maybe<Scalars['Int']>;
  meanLengthOfStay?: Maybe<DecimalMsg>;
  upperLengthOfStayLimit?: Maybe<Scalars['Int']>;
};

export type Billing_ListBillingCaseDiagnosesRequest = {
  __typename?: 'billing_ListBillingCaseDiagnosesRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_ListBillingCaseDiagnosesResponse = {
  __typename?: 'billing_ListBillingCaseDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Billing_ListBillingCaseLockedStatusesRequest = {
  __typename?: 'billing_ListBillingCaseLockedStatusesRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListBillingCaseLockedStatusesResponse = {
  __typename?: 'billing_ListBillingCaseLockedStatusesResponse';
  billingCaseIdToLocked?: Maybe<Array<Maybe<Billing_ListBillingCaseLockedStatusesResponse_BillingCaseIdToLockedEntry>>>;
};

export type Billing_ListBillingCaseLockedStatusesResponse_BillingCaseIdToLockedEntry = {
  __typename?: 'billing_ListBillingCaseLockedStatusesResponse_BillingCaseIdToLockedEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type Billing_ListBillingCasePatientsRequest = {
  __typename?: 'billing_ListBillingCasePatientsRequest';
  billingStatusIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseNumber?: Maybe<Scalars['String']>;
  caseStatusIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  coverageIdentifier?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  dischargeTimeFilters?: Maybe<Billing_BillingCaseDischargeTimeFiltersMsg>;
  sktDetails?: Maybe<Scalars['String']>;
};

export type Billing_ListBillingCasePatientsResponse = {
  __typename?: 'billing_ListBillingCasePatientsResponse';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListBillingCaseStatusesRequest = {
  __typename?: 'billing_ListBillingCaseStatusesRequest';
  /** optional filter */
  caseType?: Maybe<Billing_BillingCaseType>;
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional */
  statusCategory?: Maybe<Billing_BillingCaseStatusCategory>;
};

export type Billing_ListBillingCaseStatusesResponse = {
  __typename?: 'billing_ListBillingCaseStatusesResponse';
  billingCaseStatuses?: Maybe<Array<Maybe<Billing_BillingCaseStatusMsg>>>;
};

export type Billing_ListBillingCasesRequest = {
  __typename?: 'billing_ListBillingCasesRequest';
  /** optional */
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingStatusIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseNumber?: Maybe<Scalars['String']>;
  caseReleaseTimeFrame?: Maybe<TimeFrameMsg>;
  caseStatusIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  coverageIdentifier?: Maybe<Scalars['String']>;
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  /** Whether the cases should be ordered ascending or descending (default) by date */
  dateOrderAscending?: Maybe<Scalars['Boolean']>;
  dischargeTimeFilters?: Maybe<Billing_BillingCaseDischargeTimeFiltersMsg>;
  drgFilters?: Maybe<Billing_BillingCaseDrgFiltersMsg>;
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  relevantUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  sktDetails?: Maybe<Scalars['String']>;
};

export type Billing_ListBillingCasesResponse = {
  __typename?: 'billing_ListBillingCasesResponse';
  billingCases?: Maybe<Array<Maybe<Billing_BillingCaseMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Billing_ListBillingDayBillingPositionsRequest = {
  __typename?: 'billing_ListBillingDayBillingPositionsRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  billingFeeCategory?: Maybe<Billing_BillingFeeCategory>;
  billingPositionType?: Maybe<Billing_BillingPositionType>;
};

export type Billing_ListBillingDayBillingPositionsResponse = {
  __typename?: 'billing_ListBillingDayBillingPositionsResponse';
  billingDayBillingPositions?: Maybe<Array<Maybe<Billing_BillingDayBillingPositionList>>>;
};

export type Billing_ListBillingPositionsRequest = {
  __typename?: 'billing_ListBillingPositionsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  billingCertificateId?: Maybe<Scalars['String']>;
  billingDayId?: Maybe<Scalars['String']>;
  billingFeeCategory?: Maybe<Billing_BillingFeeCategory>;
  billingPositionType?: Maybe<Billing_BillingPositionType>;
  from?: Maybe<Timestamp>;
  patientId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  to?: Maybe<Timestamp>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_ListBillingPositionsResponse = {
  __typename?: 'billing_ListBillingPositionsResponse';
  billingPositions?: Maybe<Array<Maybe<Billing_BillingPositionMsg>>>;
};

export type Billing_ListBillingProceduresBulkRequest = {
  __typename?: 'billing_ListBillingProceduresBulkRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListBillingProceduresBulkResponse = {
  __typename?: 'billing_ListBillingProceduresBulkResponse';
  billingProceduresByBillingCaseId?: Maybe<Array<Maybe<Billing_ListBillingProceduresBulkResponse_BillingProceduresByBillingCaseIdEntry>>>;
};

export type Billing_ListBillingProceduresBulkResponse_BillingProceduresByBillingCaseIdEntry = {
  __typename?: 'billing_ListBillingProceduresBulkResponse_BillingProceduresByBillingCaseIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_BillingProceduresList>;
};

export type Billing_ListBillingProceduresRequest = {
  __typename?: 'billing_ListBillingProceduresRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_ListBillingProceduresResponse = {
  __typename?: 'billing_ListBillingProceduresResponse';
  billingProcedures?: Maybe<Array<Maybe<Billing_BillingProcedureMsg>>>;
};

export type Billing_ListBillingStatusesRequest = {
  __typename?: 'billing_ListBillingStatusesRequest';
  /** optional filter */
  isNotBilled?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_ListBillingStatusesResponse = {
  __typename?: 'billing_ListBillingStatusesResponse';
  billingStatuses?: Maybe<Array<Maybe<Billing_BillingStatusMsg>>>;
};

export type Billing_ListBillingTypesRequest = {
  __typename?: 'billing_ListBillingTypesRequest';
  /** optional filter */
  caseType?: Maybe<Billing_BillingCaseType>;
  owner?: Maybe<Billing_BillingTypeOwnerMsg>;
};

export type Billing_ListBillingTypesResponse = {
  __typename?: 'billing_ListBillingTypesResponse';
  billingTypes?: Maybe<Array<Maybe<Billing_BillingTypeMsg>>>;
};

export type Billing_ListCoverageHoldersRequest = {
  __typename?: 'billing_ListCoverageHoldersRequest';
  deactivated?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Billing_ListCoverageHoldersResponse = {
  __typename?: 'billing_ListCoverageHoldersResponse';
  coverageHolders?: Maybe<Array<Maybe<Billing_CoverageHolderReferenceMsg>>>;
};

export type Billing_ListCoveragesRequest = {
  __typename?: 'billing_ListCoveragesRequest';
  /** filters for the scopeBillingCaseId of the coverage, not for whether a coverage is assigned to that billing case */
  billingCaseId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  /** if empty, don't filter by type */
  types?: Maybe<Array<Maybe<Billing_CoverageType>>>;
};

export type Billing_ListCoveragesResponse = {
  __typename?: 'billing_ListCoveragesResponse';
  coverages?: Maybe<Array<Maybe<Billing_CoverageMsg>>>;
};

export type Billing_ListExternalBillingCaseIdsRequest = {
  __typename?: 'billing_ListExternalBillingCaseIdsRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListExternalBillingCaseIdsResponse = {
  __typename?: 'billing_ListExternalBillingCaseIdsResponse';
  identifiers?: Maybe<Array<Maybe<Billing_BillingCaseIdentifiersMsg>>>;
};

export type Billing_ListInsurersRequest = {
  __typename?: 'billing_ListInsurersRequest';
  /** If set, only returns insurers that match all provided billingCatalogTypes */
  billingCatalogTypes?: Maybe<Array<Maybe<Billing_BillingCatalogType>>>;
  /** If set, only returns insurers that match all provided coverageTypes */
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  /** optional filter */
  dataSourceType?: Maybe<Billing_InsurerDataSourceType>;
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_ListInsurersResponse = {
  __typename?: 'billing_ListInsurersResponse';
  hitCount?: Maybe<Scalars['Int']>;
  insurers?: Maybe<Array<Maybe<Billing_InsurerMsg>>>;
};

export type Billing_ListInvoicesRequest = {
  __typename?: 'billing_ListInvoicesRequest';
  billingCaseStatusIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingCaseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  billingTypeTag?: Maybe<Billing_BillingTypeTag>;
  daleStatuses?: Maybe<Array<Maybe<Billing_DaleXmlStatus>>>;
  genders?: Maybe<Array<Maybe<Core_Sex>>>;
  invoiceStatuses?: Maybe<Array<Maybe<Billing_InvoiceStatus>>>;
  leadingUnitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  patientId?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameMsg>;
  treatmentType?: Maybe<Billing_TherapeuticTreatmentBillingType>;
  /** optional for BG invoices */
  xmlInfoIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListInvoicesResponse = {
  __typename?: 'billing_ListInvoicesResponse';
  invoices?: Maybe<Array<Maybe<Billing_InvoiceMsg>>>;
};

export type Billing_ListLengthOfStayStatusesRequest = {
  __typename?: 'billing_ListLengthOfStayStatusesRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListLengthOfStayStatusesResponse = {
  __typename?: 'billing_ListLengthOfStayStatusesResponse';
  entries?: Maybe<Array<Maybe<Billing_ListLengthOfStayStatusesResponseEntry>>>;
};

export type Billing_ListLengthOfStayStatusesResponseEntry = {
  __typename?: 'billing_ListLengthOfStayStatusesResponseEntry';
  billingCaseId?: Maybe<Scalars['String']>;
  lengthOfStayStatus?: Maybe<Billing_LengthOfStayStatus>;
};

export type Billing_ListPatientCaseIdsRequest = {
  __typename?: 'billing_ListPatientCaseIdsRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_ListPatientCaseIdsResponse = {
  __typename?: 'billing_ListPatientCaseIdsResponse';
  patientIdToBillingCaseIds?: Maybe<Array<Maybe<Billing_ListPatientCaseIdsResponse_PatientIdToBillingCaseIdsEntry>>>;
};

export type Billing_ListPatientCaseIdsResponse_PatientIdToBillingCaseIdsEntry = {
  __typename?: 'billing_ListPatientCaseIdsResponse_PatientIdToBillingCaseIdsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_BillingCaseIdList>;
};

export type Billing_MaterialCompanyMsg = {
  __typename?: 'billing_MaterialCompanyMsg';
  id?: Maybe<Scalars['String']>;
  /** for type manufacturer */
  manufacturerNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  status?: Maybe<Billing_MaterialCostTemplateStatus>;
  /** for type supplier */
  supplierNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_MaterialCompanyType>;
};

export enum Billing_MaterialCompanyType {
  MaterialCompanyTypeManufacturer = 'MATERIAL_COMPANY_TYPE_MANUFACTURER',
  MaterialCompanyTypeNone = 'MATERIAL_COMPANY_TYPE_NONE',
  MaterialCompanyTypeSupplier = 'MATERIAL_COMPANY_TYPE_SUPPLIER'
}

export type Billing_MaterialCostTemplateLabelMsg = {
  __typename?: 'billing_MaterialCostTemplateLabelMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  status?: Maybe<Billing_MaterialCostTemplateStatus>;
};

export enum Billing_MaterialCostTemplateStatus {
  MaterialCostTemplateStatusActive = 'MATERIAL_COST_TEMPLATE_STATUS_ACTIVE',
  MaterialCostTemplateStatusInactive = 'MATERIAL_COST_TEMPLATE_STATUS_INACTIVE',
  MaterialCostTemplateStatusNone = 'MATERIAL_COST_TEMPLATE_STATUS_NONE',
  MaterialCostTemplateStatusNotYetActive = 'MATERIAL_COST_TEMPLATE_STATUS_NOT_YET_ACTIVE'
}

export enum Billing_MedicalTreatmentType {
  MedicalTreatmentTypeGeneral = 'MEDICAL_TREATMENT_TYPE_GENERAL',
  MedicalTreatmentTypeNone = 'MEDICAL_TREATMENT_TYPE_NONE',
  MedicalTreatmentTypeSpecial = 'MEDICAL_TREATMENT_TYPE_SPECIAL'
}

/**
 * we can not use google.type.Money because of course the python library is older than yours truly.
 *  Represents an amount of money with its currency type.
 */
export type Billing_Money = {
  __typename?: 'billing_Money';
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   *  The value must be between -999,999,999 and +999,999,999 inclusive.
   *  If `units` is positive, `nanos` must be positive or zero.
   *  If `units` is zero, `nanos` can be positive, zero, or negative.
   *  If `units` is negative, `nanos` must be negative or zero.
   *  For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos?: Maybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   *  For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units?: Maybe<Scalars['Long']>;
};

export type Billing_MultiplierJustificationMsg = {
  __typename?: 'billing_MultiplierJustificationMsg';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_MultiplierMsg = {
  __typename?: 'billing_MultiplierMsg';
  factor?: Maybe<DecimalMsg>;
  justification?: Maybe<Billing_MultiplierJustificationMsg>;
};

export type Billing_OccupationalAccidentInsuranceFieldsMsg = {
  __typename?: 'billing_OccupationalAccidentInsuranceFieldsMsg';
  generalCostsFee?: Maybe<Billing_Money>;
  id?: Maybe<Scalars['String']>;
  justification?: Maybe<Scalars['String']>;
  materialCostsFee?: Maybe<Billing_Money>;
  medicalProviderId?: Maybe<Scalars['String']>;
  medicalTreatmentType?: Maybe<Billing_MedicalTreatmentType>;
  organ?: Maybe<Scalars['String']>;
  selectedTreatmentTypeFee?: Maybe<Billing_Money>;
  specialCostFeeHospitals?: Maybe<Billing_Money>;
  specialCostFeePhysicians?: Maybe<Billing_Money>;
  therapeuticTreatmentBillingType?: Maybe<Billing_TherapeuticTreatmentBillingType>;
  time?: Maybe<Timestamp>;
  typeOfExamination?: Maybe<Scalars['String']>;
};

export enum Billing_OpsNumberLocalization {
  OpsNumberLocalizationBothSides = 'OPS_NUMBER_LOCALIZATION_BOTH_SIDES',
  OpsNumberLocalizationLeft = 'OPS_NUMBER_LOCALIZATION_LEFT',
  OpsNumberLocalizationNone = 'OPS_NUMBER_LOCALIZATION_NONE',
  OpsNumberLocalizationRight = 'OPS_NUMBER_LOCALIZATION_RIGHT'
}

export enum Billing_OpsSpecialType {
  OpsSpecialTypeNone = 'OPS_SPECIAL_TYPE_NONE',
  /** Neue Untersuchungs- und Behandlungsmethoden */
  OpsSpecialTypeNub = 'OPS_SPECIAL_TYPE_NUB',
  /** supplemetary changes */
  OpsSpecialTypeZe = 'OPS_SPECIAL_TYPE_ZE'
}

export type Billing_PayorReferenceMsg = {
  __typename?: 'billing_PayorReferenceMsg';
  payorId?: Maybe<Scalars['String']>;
  /** For some insurances multiple references are valid */
  primary?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Billing_PayorReferenceType>;
};

export enum Billing_PayorReferenceType {
  PayorReferenceTypeContactParty = 'PAYOR_REFERENCE_TYPE_CONTACT_PARTY',
  PayorReferenceTypeInsurer = 'PAYOR_REFERENCE_TYPE_INSURER',
  PayorReferenceTypeNone = 'PAYOR_REFERENCE_TYPE_NONE',
  PayorReferenceTypePatient = 'PAYOR_REFERENCE_TYPE_PATIENT'
}

export type Billing_PlaceOfResidenceMsg = {
  __typename?: 'billing_PlaceOfResidenceMsg';
  districtOfficeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
};

export type Billing_PlaceOfResidencePrincipleMsg = {
  __typename?: 'billing_PlaceOfResidencePrincipleMsg';
  placesOfResidence?: Maybe<Array<Maybe<Billing_PlaceOfResidenceMsg>>>;
  wopValue?: Maybe<Scalars['String']>;
};

export type Billing_PriceInformationMsg = {
  __typename?: 'billing_PriceInformationMsg';
  calculationDetails?: Maybe<Billing_PriceInformationMsg_PriceCalculationDetailsMsg>;
  grossPrice?: Maybe<Billing_Money>;
  grossPriceString?: Maybe<Scalars['String']>;
  netPrice?: Maybe<Billing_Money>;
  netPriceInCents?: Maybe<Scalars['Int']>;
  netPriceString?: Maybe<Scalars['String']>;
  totalGrossCost?: Maybe<Billing_Money>;
  totalGrossCostString?: Maybe<Scalars['String']>;
  totalGrossMaterialCost?: Maybe<Billing_Money>;
  totalGrossMaterialCostString?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type Billing_PriceInformationMsg_PriceCalculationDetailsMsg = {
  __typename?: 'billing_PriceInformationMsg_PriceCalculationDetailsMsg';
  basePrice?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  weightedPrice?: Maybe<Scalars['String']>;
  weightedPriceWithQuantity?: Maybe<Scalars['String']>;
  weighting?: Maybe<Scalars['String']>;
};

export type Billing_ProceduralCodeReferenceMsg = {
  __typename?: 'billing_ProceduralCodeReferenceMsg';
  opsCode?: Maybe<Scalars['String']>;
  opsVersion?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_ProofOfInsuranceMsg = {
  __typename?: 'billing_ProofOfInsuranceMsg';
  /** not stored, but calculated by backend as convenience for the frontend */
  active?: Maybe<Scalars['Boolean']>;
  /**
   * Time period for which this proof of insurance is accepted - once activity period is over,
   *  a new proof of insurance is required (typically means providing the same document, e.g., a coverage card, again)
   */
  activityPeriod?: Maybe<TimeFrameMsg>;
  germanPrivateCoverageInformation?: Maybe<Billing_German_GermanPrivateCoverageInformationMsg>;
  /** can be set together with telematikPatientCoreDataEntryId/telematikLegacyPatientCoreDataEntryId */
  germanStatutoryCoverageInformation?: Maybe<Billing_German_GermanStatutoryCoverageInformationMsg>;
  id?: Maybe<Scalars['String']>;
  telematikLegacyPatientCoreDataEntryId?: Maybe<Scalars['String']>;
  telematikPatientCoreDataEntryId?: Maybe<Scalars['String']>;
  /** If multiple active proofs of insurance exist, the one that was created later is taken as the one active proof */
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Billing_ProofOfInsuranceType>;
};

export enum Billing_ProofOfInsuranceReferenceType {
  ProofOfInsuranceReferenceTypeNone = 'PROOF_OF_INSURANCE_REFERENCE_TYPE_NONE',
  /** aka KvK */
  ProofOfInsuranceReferenceTypeTelematikLegacyPatientCoreDataEntry = 'PROOF_OF_INSURANCE_REFERENCE_TYPE_TELEMATIK_LEGACY_PATIENT_CORE_DATA_ENTRY',
  /** aka eGK/VSD/VSDM */
  ProofOfInsuranceReferenceTypeTelematikPatientCoreDataEntry = 'PROOF_OF_INSURANCE_REFERENCE_TYPE_TELEMATIK_PATIENT_CORE_DATA_ENTRY'
}

export enum Billing_ProofOfInsuranceType {
  /** in the future, this type might also be used for virtual cards, such as with digital wallets on a phone */
  ProofOfInsuranceTypeCard = 'PROOF_OF_INSURANCE_TYPE_CARD',
  ProofOfInsuranceTypeManual = 'PROOF_OF_INSURANCE_TYPE_MANUAL',
  ProofOfInsuranceTypeNone = 'PROOF_OF_INSURANCE_TYPE_NONE'
}

export enum Billing_RegistrationStatus {
  RegistrationStatusCompleted = 'REGISTRATION_STATUS_COMPLETED',
  RegistrationStatusDraft = 'REGISTRATION_STATUS_DRAFT',
  RegistrationStatusNone = 'REGISTRATION_STATUS_NONE',
  RegistrationStatusProvisional = 'REGISTRATION_STATUS_PROVISIONAL'
}

export type Billing_RemoveInvoicePositionsRequest = {
  __typename?: 'billing_RemoveInvoicePositionsRequest';
  billingPositionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type Billing_RemoveMaterialCostsFromBillingPositionRequest = {
  __typename?: 'billing_RemoveMaterialCostsFromBillingPositionRequest';
  billingPositionId?: Maybe<Scalars['String']>;
  materialCostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_SearchBillingCaseStatusRequest = {
  __typename?: 'billing_SearchBillingCaseStatusRequest';
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_SearchBillingCaseStatusResponse = {
  __typename?: 'billing_SearchBillingCaseStatusResponse';
  hits?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_SearchBillingRequest = {
  __typename?: 'billing_SearchBillingRequest';
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_SearchBillingResponse = {
  __typename?: 'billing_SearchBillingResponse';
  hits?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_SearchBillingTypeRequest = {
  __typename?: 'billing_SearchBillingTypeRequest';
  caseType?: Maybe<Billing_BillingCaseType>;
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_SearchBillingTypeResponse = {
  __typename?: 'billing_SearchBillingTypeResponse';
  hits?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_SearchInsurerRequest = {
  __typename?: 'billing_SearchInsurerRequest';
  coverageType?: Maybe<Billing_CoverageType>;
  /** optional filter */
  dataSourceType?: Maybe<Billing_InsurerDataSourceType>;
  /** if set, will be used to resolve search config in the backend that may set filters that are not set in request */
  searchScope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_ServiceReferenceMsg = {
  __typename?: 'billing_ServiceReferenceMsg';
  targetId?: Maybe<Scalars['String']>;
  targetType?: Maybe<Billing_ServiceType>;
};

export enum Billing_ServiceType {
  ServiceTypeLabTask = 'SERVICE_TYPE_LAB_TASK',
  ServiceTypeNone = 'SERVICE_TYPE_NONE',
  ServiceTypeProcedure = 'SERVICE_TYPE_PROCEDURE',
  ServiceTypeSurgery = 'SERVICE_TYPE_SURGERY',
  ServiceTypeTreatment = 'SERVICE_TYPE_TREATMENT'
}

export type Billing_SetBillingFeeCategoryConfigurationRequest = {
  __typename?: 'billing_SetBillingFeeCategoryConfigurationRequest';
  billingFeeCategoryConfiguration?: Maybe<Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Billing_SetBillingFeeCategoryConfigurationResponse = {
  __typename?: 'billing_SetBillingFeeCategoryConfigurationResponse';
  billingFeeCategoryConfiguration?: Maybe<Billing_BillingFeeCategoryConfigurationMsg>;
};

export type Billing_SetBillingTypeFeeCategoryMappingRequest = {
  __typename?: 'billing_SetBillingTypeFeeCategoryMappingRequest';
  billingTypeFeeCategoryMapping?: Maybe<Billing_BillingTypeFeeCategoryMappingMsg>;
};

export type Billing_SetBillingTypeFeeCategoryMappingResponse = {
  __typename?: 'billing_SetBillingTypeFeeCategoryMappingResponse';
  billingTypeFeeCategoryMapping?: Maybe<Billing_BillingTypeFeeCategoryMappingMsg>;
};

export enum Billing_TherapeuticTreatmentBillingType {
  TherapeuticTreatmentBillingTypeGeneral = 'THERAPEUTIC_TREATMENT_BILLING_TYPE_GENERAL',
  TherapeuticTreatmentBillingTypeInvalid = 'THERAPEUTIC_TREATMENT_BILLING_TYPE_INVALID',
  TherapeuticTreatmentBillingTypeNone = 'THERAPEUTIC_TREATMENT_BILLING_TYPE_NONE',
  TherapeuticTreatmentBillingTypeSpecial = 'THERAPEUTIC_TREATMENT_BILLING_TYPE_SPECIAL'
}

export type Billing_TravelExpenseMsg = {
  __typename?: 'billing_TravelExpenseMsg';
  distanceInKm?: Maybe<DecimalMsg>;
  travelZone?: Maybe<Billing_TravelZone>;
  visitLocation?: Maybe<Scalars['String']>;
};

export enum Billing_TravelZone {
  TravelZoneNone = 'TRAVEL_ZONE_NONE',
  TravelZoneZ1 = 'TRAVEL_ZONE_Z1',
  TravelZoneZ2 = 'TRAVEL_ZONE_Z2',
  TravelZoneZ3 = 'TRAVEL_ZONE_Z3',
  TravelZoneZ4 = 'TRAVEL_ZONE_Z4'
}

export type Billing_UpdateBillingCaseDischargeScheduleRequest = {
  __typename?: 'billing_UpdateBillingCaseDischargeScheduleRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  billingCaseStatusUpdateType?: Maybe<Billing_DischargeBillingCaseStatusUpdateType>;
  dischargeDate?: Maybe<Timestamp>;
  onlyDischargeDate?: Maybe<Scalars['Boolean']>;
  onlyPlannedDischargeDate?: Maybe<Scalars['Boolean']>;
  plannedDischargeDate?: Maybe<Timestamp>;
};

export type Billing_UpdateBillingCaseRequest = {
  __typename?: 'billing_UpdateBillingCaseRequest';
  billingCase?: Maybe<Billing_BillingCaseMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  ignoreLock?: Maybe<Scalars['Boolean']>;
  /**
   * The id of the new outpatient visit, which is created as a result of billing case type change
   *  from inpatient to outpatient. Optional field. If provided, triggers handling the case type change.
   */
  newVisitId?: Maybe<Scalars['String']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateBillingCaseResponse = {
  __typename?: 'billing_UpdateBillingCaseResponse';
  billingCase?: Maybe<Billing_BillingCaseMsg>;
  failureReasons?: Maybe<Array<Maybe<Billing_BillingCaseStatusCheckFailureReason>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Billing_UpdateBillingCaseStatusRequest = {
  __typename?: 'billing_UpdateBillingCaseStatusRequest';
  billingCaseStatus?: Maybe<Billing_BillingCaseStatusMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateBillingCaseTypeRequest = {
  __typename?: 'billing_UpdateBillingCaseTypeRequest';
  /** mandatory */
  billingCaseId?: Maybe<Scalars['String']>;
  /** mandatory */
  targetType?: Maybe<Billing_BillingCaseType>;
  /** TODO: Required? */
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_UpdateBillingCaseTypeResponse = {
  __typename?: 'billing_UpdateBillingCaseTypeResponse';
  billingCase?: Maybe<Billing_BillingCaseMsg>;
  /** Set if a new visit was created due to the billing case type update */
  createdVisitId?: Maybe<Scalars['String']>;
  oldBillingCaseType?: Maybe<Billing_BillingCaseType>;
  oldBillingType?: Maybe<Billing_BillingTypeMsg>;
};

export type Billing_UpdateBillingPositionBillingDayRequest = {
  __typename?: 'billing_UpdateBillingPositionBillingDayRequest';
  billingDayId?: Maybe<Scalars['String']>;
  billingPositionId?: Maybe<Scalars['String']>;
};

export type Billing_UpdateBillingPositionRequest = {
  __typename?: 'billing_UpdateBillingPositionRequest';
  billingPosition?: Maybe<Billing_BillingPositionMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateBillingProcedureRequest = {
  __typename?: 'billing_UpdateBillingProcedureRequest';
  billingProcedure?: Maybe<Billing_BillingProcedureMsg>;
  /** Required for Kodip interface robustness */
  ignoreInvalidDate?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateBillingProcedureResponse = {
  __typename?: 'billing_UpdateBillingProcedureResponse';
  billingProcedure?: Maybe<Billing_BillingProcedureMsg>;
  updatedBillingProcedures?: Maybe<Array<Maybe<Billing_BillingProcedureMsg>>>;
};

export type Billing_UpdateBillingProceduresDateRequest = {
  __typename?: 'billing_UpdateBillingProceduresDateRequest';
  procedureDate?: Maybe<PrecisionTimestampMsg>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type Billing_UpdateBillingStatusRequest = {
  __typename?: 'billing_UpdateBillingStatusRequest';
  billingStatus?: Maybe<Billing_BillingStatusMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateBillingTypeRequest = {
  __typename?: 'billing_UpdateBillingTypeRequest';
  billingType?: Maybe<Billing_BillingTypeMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateCostUnitVisitTypeMappingRequest = {
  __typename?: 'billing_UpdateCostUnitVisitTypeMappingRequest';
  mapping?: Maybe<Billing_CostUnitVisitTypeMappingMsg>;
};

export type Billing_UpdateCostUnitVisitTypeMappingResponse = {
  __typename?: 'billing_UpdateCostUnitVisitTypeMappingResponse';
  mapping?: Maybe<Billing_CostUnitVisitTypeMappingMsg>;
};

export type Billing_UpdateCoverageRequest = {
  __typename?: 'billing_UpdateCoverageRequest';
  coverage?: Maybe<Billing_CoverageMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateDesignatedUserRequest = {
  __typename?: 'billing_UpdateDesignatedUserRequest';
  designatedUserId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type Billing_UpdateInvoiceRequest = {
  __typename?: 'billing_UpdateInvoiceRequest';
  invoice?: Maybe<Billing_InvoiceMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_UpdateMaterialCostRequest = {
  __typename?: 'billing_UpdateMaterialCostRequest';
  billingPositionId?: Maybe<Scalars['String']>;
  materialCost?: Maybe<Billing_BillingMaterialCostMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

/** Sent from Visit to Billing */
export type Billing_UpdateRelatedUnitsRequest = {
  __typename?: 'billing_UpdateRelatedUnitsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  relatedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type Billing_ValidateInsurerRequest = {
  __typename?: 'billing_ValidateInsurerRequest';
  insurerId?: Maybe<Scalars['String']>;
};

export type Billing_ValidateInsurerResponse = {
  __typename?: 'billing_ValidateInsurerResponse';
  invalidExternalIds?: Maybe<Array<Maybe<Billing_ExternalInsurerIdMsg>>>;
};

export enum Billing_ValueUnitType {
  ValueUnitTypeCent = 'VALUE_UNIT_TYPE_CENT',
  ValueUnitTypeEuro = 'VALUE_UNIT_TYPE_EURO',
  ValueUnitTypeNone = 'VALUE_UNIT_TYPE_NONE',
  ValueUnitTypeNotRated = 'VALUE_UNIT_TYPE_NOT_RATED',
  ValueUnitTypePoint = 'VALUE_UNIT_TYPE_POINT'
}

export type Billing_German_AcknowledgeDiagnosisRuleVersionRequest = {
  __typename?: 'billing_german_AcknowledgeDiagnosisRuleVersionRequest';
  diagnosisRuleVersionId?: Maybe<Scalars['String']>;
};

export type Billing_German_AdditionalCodeInputFieldGroupMsg = {
  __typename?: 'billing_german_AdditionalCodeInputFieldGroupMsg';
  additionalInputFieldIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  chargenNumberRequired?: Maybe<Scalars['Boolean']>;
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
  fieldListType?: Maybe<Billing_German_AdditionalInputFieldListType>;
  gnrKeyAsJustification?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  opsKeyAsJustification?: Maybe<Scalars['Boolean']>;
};

export enum Billing_German_AdditionalInputFieldListType {
  AdditionalInputFieldListTypeNone = 'ADDITIONAL_INPUT_FIELD_LIST_TYPE_NONE',
  AdditionalInputFieldListTypeSelection = 'ADDITIONAL_INPUT_FIELD_LIST_TYPE_SELECTION',
  AdditionalInputFieldListTypeSequence = 'ADDITIONAL_INPUT_FIELD_LIST_TYPE_SEQUENCE'
}

export type Billing_German_AgeIntervalMsg = {
  __typename?: 'billing_german_AgeIntervalMsg';
  ageLower?: Maybe<Reference_AgeMsg>;
  ageUpper?: Maybe<Reference_AgeMsg>;
};

export type Billing_German_AmountConditionMsg = {
  __typename?: 'billing_german_AmountConditionMsg';
  ageInterval?: Maybe<Billing_German_AgeIntervalMsg>;
  id?: Maybe<Scalars['String']>;
  maxAmount?: Maybe<Scalars['Int']>;
  timeContext?: Maybe<Billing_German_TimeContextMsg>;
  timeContextLength?: Maybe<Scalars['Int']>;
};

export type Billing_German_ApplyDiagnosisRulesRequest = {
  __typename?: 'billing_german_ApplyDiagnosisRulesRequest';
  /**
   * mandatory for DIAGNOSIS_RULE_SCOPE_INTER_QUARTER, optional otherwise:
   *  if no diagnosisCodingIds set, all codings in the given certificates are used;
   *  also used to get the quarter for which the check is executed
   */
  billingCertificateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  checkTiming?: Maybe<Billing_German_DiagnosisRuleCheckTiming>;
  diagnosisCodingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  scope?: Maybe<Billing_German_DiagnosisRuleScope>;
  /** filter for valid rules */
  validAt?: Maybe<Timestamp>;
};

export type Billing_German_ApplyDiagnosisRulesResponse = {
  __typename?: 'billing_german_ApplyDiagnosisRulesResponse';
  suggestions?: Maybe<Array<Maybe<Billing_German_DiagnosisSuggestionsMsg>>>;
};

export type Billing_German_ApplyGroupPsychotherapyCodeRequest = {
  __typename?: 'billing_german_ApplyGroupPsychotherapyCodeRequest';
  /** If true, adds codes to approvalsCompanion, else to approvals */
  companion?: Maybe<Scalars['Boolean']>;
  groupPsychotherapyCodeId?: Maybe<Scalars['String']>;
  psychotherapyApprovalId?: Maybe<Scalars['String']>;
};

export type Billing_German_ApprovalLevelEventMsg = {
  __typename?: 'billing_german_ApprovalLevelEventMsg';
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type Billing_German_ApprovalLevelMsg = {
  __typename?: 'billing_german_ApprovalLevelMsg';
  approvalLevelValue?: Maybe<Scalars['Int']>;
  eventHistory?: Maybe<Array<Maybe<Billing_German_ApprovalLevelEventMsg>>>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_German_AssignBillingDiagnosisCodingIdRequest = {
  __typename?: 'billing_german_AssignBillingDiagnosisCodingIdRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  diagnosisCodingId?: Maybe<Billing_German_BillingDiagnosisCodingIdMsg>;
};

export type Billing_German_AssignBillingDiagnosisCodingIdResponse = {
  __typename?: 'billing_german_AssignBillingDiagnosisCodingIdResponse';
  diagnosisCodingIds?: Maybe<Array<Maybe<Billing_German_BillingDiagnosisCodingIdMsg>>>;
};

export type Billing_German_AssignGroupingDiagnosisRequest = {
  __typename?: 'billing_german_AssignGroupingDiagnosisRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['String']>;
  groupingDiagnosis?: Maybe<Billing_German_GroupingDiagnosisMsg>;
  ignoreValidation?: Maybe<Scalars['Boolean']>;
  step?: Maybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

export type Billing_German_AssignGroupingDiagnosisResponse = {
  __typename?: 'billing_german_AssignGroupingDiagnosisResponse';
  assignedGroupingDiagnosis?: Maybe<Billing_German_GroupingDiagnosisMsg>;
  modifiedGroupingDiagnoses?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisMsg>>>;
  validationErrors?: Maybe<Array<Maybe<Billing_German_GroupingDataValidationError>>>;
};

export type Billing_German_AsvTeamMemberMsg = {
  __typename?: 'billing_german_AsvTeamMemberMsg';
  id?: Maybe<Scalars['String']>;
  membershipExpiration?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export type Billing_German_AsvTeamMsg = {
  __typename?: 'billing_german_AsvTeamMsg';
  id?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<Billing_German_AsvTeamMemberMsg>>>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  timestamps?: Maybe<TimeMsg>;
};

export type Billing_German_AutocompleteEbmCodeFolderRequest = {
  __typename?: 'billing_german_AutocompleteEbmCodeFolderRequest';
  ebmCatalogId?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

export type Billing_German_AutocompleteEbmCodeFolderResponse = {
  __typename?: 'billing_german_AutocompleteEbmCodeFolderResponse';
  results?: Maybe<Array<Maybe<Billing_German_AutocompleteEbmCodeFolderResponse_Result>>>;
};

export type Billing_German_AutocompleteEbmCodeFolderResponse_Result = {
  __typename?: 'billing_german_AutocompleteEbmCodeFolderResponse_Result';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Billing_German_BgBillingSettingsMsg = {
  __typename?: 'billing_german_BgBillingSettingsMsg';
  /** DALE-Prüfmodul aktiviert (if empty/false) / deaktiviert (if true) */
  deactivateDaleRuleCheckModule?: Maybe<Scalars['Boolean']>;
  /** Standard D-Arzt */
  defaultDesignatedUserId?: Maybe<Scalars['String']>;
  /** Standardmäßige Rechnungsfrist (Tage) */
  defaultInvoicePeriodDays?: Maybe<Scalars['Int']>;
  /** Rechnungstyp */
  defaultInvoiceType?: Maybe<Billing_German_BgInvoiceType>;
  /** Mahnverfahren (Stufe 1) */
  dunningLevelOne?: Maybe<Billing_German_DunningSettingsMsg>;
  /** Mahnverfahren (Stufe 3) */
  dunningLevelThree?: Maybe<Billing_German_DunningSettingsMsg>;
  /** Mahnverfahren (Stufe 2) */
  dunningLevelTwo?: Maybe<Billing_German_DunningSettingsMsg>;
  id?: Maybe<Scalars['String']>;
};

export enum Billing_German_BgInvoiceType {
  BgInvoiceTypeNone = 'BG_INVOICE_TYPE_NONE',
  /** Praxis (R1) */
  BgInvoiceTypeR_1 = 'BG_INVOICE_TYPE_R_1',
  /** Krankenhaus (R2) */
  BgInvoiceTypeR_2 = 'BG_INVOICE_TYPE_R_2',
  /** Krankenhaus (R3) */
  BgInvoiceTypeR_3 = 'BG_INVOICE_TYPE_R_3'
}

export enum Billing_German_BgTreatmentStandard {
  BgTreatmentStandardGeneral = 'BG_TREATMENT_STANDARD_GENERAL',
  BgTreatmentStandardNone = 'BG_TREATMENT_STANDARD_NONE',
  BgTreatmentStandardSpecial = 'BG_TREATMENT_STANDARD_SPECIAL'
}

export type Billing_German_BillingAdmissionReasonMsg = {
  __typename?: 'billing_german_BillingAdmissionReasonMsg';
  digitFour?: Maybe<Scalars['String']>;
  digitThree?: Maybe<Scalars['String']>;
  digitsOneTwo?: Maybe<Scalars['String']>;
};

export type Billing_German_BillingCaseBgDetailsMsg = {
  __typename?: 'billing_german_BillingCaseBgDetailsMsg';
  /** Unfallzeitpunkt [uvt_4] */
  accidentDate?: Maybe<PrecisionTimestampMsg>;
  /** Aktenzeichen des UV-Trägers [uvt_5] */
  accidentInsurerFileReference?: Maybe<Scalars['String']>;
  /** Unfallort [ufd_4] */
  accidentLocation?: Maybe<Scalars['String']>;
  /** Unfallbetrieb [ufb_1] */
  accidentOccupationId?: Maybe<Scalars['String']>;
  /** Unfallzeitpunkt [ufd_ 1] */
  accidentTime?: Maybe<Timestamp>;
  /** Zeitpunkt des Eintreffens [eti_1, eti_2] */
  arrivalTime?: Maybe<Timestamp>;
  /** optional, could be set only if statutoryInsured = true */
  careInsuranceBgCase?: Maybe<Billing_InsurerMsg>;
  familyInsured?: Maybe<Scalars['Boolean']>;
  healthInsuranceBgCase?: Maybe<Billing_German_HealthInsuranceBgCaseMsg>;
  /** optional, will be set if mapped health insurance has one */
  healthInsuranceIdentifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Personalunfall [vin_12] */
  personnelAccident?: Maybe<Scalars['Boolean']>;
  /** Name des Hauptversicherten (Gesetzliche Krankenkasse) [ksd_1] */
  primaryInsuredPartyId?: Maybe<Scalars['String']>;
  statutoryInsured?: Maybe<Scalars['Boolean']>;
  /** Arbeitszeitraum [ufd_2, ufd_3] */
  workingPeriod?: Maybe<Core_TimeFrameOfDayMsg>;
};

export type Billing_German_BillingCaseDetailCodesMsg = {
  __typename?: 'billing_german_BillingCaseDetailCodesMsg';
  /** corresponds to admissionEventCode */
  admissionEvent?: Maybe<Scalars['String']>;
  /** corresponds to admissionReason.digitFour */
  admissionReasonFour?: Maybe<Scalars['String']>;
  /** corresponds to admissionReason.digitsOneTwo */
  admissionReasonOneTwo?: Maybe<Scalars['String']>;
  /** corresponds to admissionReason.digitThree */
  admissionReasonThree?: Maybe<Scalars['String']>;
  /** corresponds to dischargeReason.digitsOneTwo */
  dischargeReasonOneTwo?: Maybe<Scalars['String']>;
  /** corresponds to dischargeReason.digitThree */
  dischargeReasonThree?: Maybe<Scalars['String']>;
};

export type Billing_German_BillingCaseDetailsMsg = {
  __typename?: 'billing_german_BillingCaseDetailsMsg';
  /** Aufnahmeanlass (§ 21) */
  admissionEventCode?: Maybe<Scalars['String']>;
  /** Aufnahmegrund § 301 */
  admissionReason?: Maybe<Billing_German_BillingAdmissionReasonMsg>;
  /** Entlassungs-/Verlegungsgrund (§ 301) */
  dischargeReason?: Maybe<Billing_German_BillingDischargeReasonMsg>;
  id?: Maybe<Scalars['String']>;
  /**
   * Whether this case, together with a second one, needs to be merged into a cumulative case.
   *  This field should be derived from rules in the Fallpauschalenverordnung about Wiederkehrerketten.
   *  For now we store this is a boolean in the database, when we get the info from the external HIS.
   */
  mightRequireCumulativeCase?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_BillingCertificateCodesMsg = {
  __typename?: 'billing_german_BillingCertificateCodesMsg';
  /** corresponds to BillingCertificateMsg.billingDetailsFormCode // BillingCertificateType */
  billingCertificateType?: Maybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.billingSubjectCode // KBV_DATASET_BILLING_SUBJECT_CODE */
  billingSubject?: Maybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.contactTypeCode // KVDT_DATASET_CONTACT_TYPE_CODE */
  contactType?: Maybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.costUnitBillingFieldCode // https://applications.kbv.de/S_KTS_KTABRECHNUNGSBEREICH_V1.00.xhtml */
  costUnitBillingField?: Maybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.curativePreventiveEssAttendingCode // KVDT_DATASET_CURATIVE_PREVENTIVE_ESS_ATTENDING_CODE */
  curativePreventiveEssAttending?: Maybe<Scalars['String']>;
  /** corresponds to BillingCertificateMsg.examinationCategoryCode // KBV_DATASET_EXAMINATION_CATEGORY */
  examinationCategory?: Maybe<Scalars['String']>;
};

export type Billing_German_BillingCertificateMsg = {
  __typename?: 'billing_german_BillingCertificateMsg';
  /** Unfall, Unfallfolgen [4202] */
  accidentConsequences?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  /** Zusätzliche Angaben zu Untersuchungen [4209] */
  additionalExaminationInformation?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Überweisung von anderen Ärzten [4219] */
  additionalReferrals?: Maybe<Scalars['String']>;
  /** SKT-Zusatzangaben [4124] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  additionalSktInformation?: Maybe<Scalars['String']>;
  /** Ausnahmeindikation [4229] */
  admissionIndication?: Maybe<Scalars['String']>;
  /** Mutmaßlicher Tag der Entbindung [4206] */
  anticipatedDeliveryDate?: Maybe<Timestamp>;
  /** Appointment scheduling day (dt. Tag der Terminvermittlung) [4115] */
  appointmentSchedulingDate?: Maybe<Timestamp>;
  /**
   * Psychotherapy
   *  Anerkannte Psychotherapie
   */
  approvedPsychotherapy?: Maybe<Scalars['Boolean']>;
  /** never empty */
  billingCaseId?: Maybe<Scalars['String']>;
  billingDays?: Maybe<Array<Maybe<Billing_German_BillingDayMsg>>>;
  /** German "Scheinuntergruppe" [4239] // TODO: Search call that groups */
  billingDetailsFormCode?: Maybe<Scalars['String']>;
  /** Abrechnungsgebiet [4122] */
  billingSubjectCode?: Maybe<Scalars['String']>;
  /** Ergänzende Informationen zur Vermittlungs-/Kontaktart [4105] */
  contactTypeAdditionalInfo?: Maybe<Scalars['String']>;
  /** Vermittlungs-/Kontaktart [4103] */
  contactTypeCode?: Maybe<Scalars['String']>;
  /** Kostenträger-Abrechnungsbereich [4106] // https://applications.kbv.de/S_KTS_KTABRECHNUNGSBEREICH_V1.00.xhtml */
  costUnitBillingFieldCode?: Maybe<Scalars['String']>;
  coverage?: Maybe<Billing_CoverageMsg>;
  /** Kurativ / Präventiv / ESS / belegärztliche Behandlung [4221] */
  curativePreventiveEssAttendingCode?: Maybe<Scalars['String']>;
  diagnosisCodingIds?: Maybe<Array<Maybe<Billing_German_BillingDiagnosisCodingIdMsg>>>;
  /** Personenkreis/Untersuchungskategorie [4123] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  examinationCategoryCode?: Maybe<Scalars['String']>;
  feeSchedule?: Maybe<Billing_German_BillingFeeSchedule>;
  /** Befund/Medikation [4208] */
  findingAndMedication?: Maybe<Scalars['String']>;
  /** Weiterbehandelnder Arzt [4243] */
  furtherTreatmentPhysician?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Hash-String der Meldebestätigung des Implantateregisters [4135] */
  implantRegistryHashes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Zeitraum stationäre Behandlung [4233] */
  inpatientVisitTimeframe?: Maybe<TimeFrameMsg>;
  /** German "Ausstellungsdatum" [4102]. Expand */
  issueDate?: Maybe<Timestamp>;
  /** Behandlungstag bei IVD-Leistungen [4214] */
  ivdTreatmentDate?: Maybe<Timestamp>;
  /** eingeschränkter Leistungsanspruch gemäß § 16 Abs. 3a SGB V) [4204] */
  limitedServiceEntitlement?: Maybe<Scalars['Boolean']>;
  /** Auftrag [4205] // TODO: for subgroup 21, provide search selection options */
  orderInformation?: Maybe<Scalars['String']>;
  /** ASV-Teamnummer des Erstveranlassers [4225] */
  originatorAsvTeamNumber?: Maybe<Scalars['String']>;
  /** (N)BSNR des Erstveranlassers [4217] */
  originatorBsnr?: Maybe<Scalars['String']>;
  /** LANR des Erstveranlassers [4241] */
  originatorLanr?: Maybe<Scalars['String']>;
  /** Anerkennungen */
  psychotherapyApprovals?: Maybe<Array<Maybe<Billing_German_PsychotherapyApprovalMsg>>>;
  /** Überweisung an [4220] */
  referralTarget?: Maybe<Scalars['String']>;
  /** ASV-Teamnummer des Überweisers [4226] // TODO: Auto-fill from visit if possible */
  referrerAsvTeamNumber?: Maybe<Scalars['String']>;
  /** (N)BSNR des Überweisers [4218] // TODO: Auto-fill from visit if possible */
  referrerBsnr?: Maybe<Scalars['String']>;
  /** LANR des Überweisers [4242] // TODO: Auto-fill from visit if possible */
  referrerLanr?: Maybe<Scalars['String']>;
  /** Vermittlungscode [4114] */
  schedulingIdentifier?: Maybe<Scalars['String']>;
  /** SKT-Bemerkungen [4126] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  sktComments?: Maybe<Scalars['String']>;
  /** Gültigkeit SKT [4125] // TODO: Also in GermanCoverageInformationMsg -> auto-fill if possible */
  sktValidityPeriod?: Maybe<TimeFrameMsg>;
  /** Somatische Abklärung [4236] */
  somaticAssessment?: Maybe<Scalars['Boolean']>;
  /** Diagnose/Verdachtsdiagnose [4207] */
  suspectedDiagnosis?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  /** German "Quartal" [4101], must be converted to format q/yyyy (q is 1,2,3 or 4) when transferring data to KVDT */
  validityQuarter?: Maybe<PrecisionTimestampMsg>;
  /** can be empty */
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Billing_German_BillingCertificateValidityViolationType {
  BillingCertificateValidityViolationTypeNone = 'BILLING_CERTIFICATE_VALIDITY_VIOLATION_TYPE_NONE',
  /**
   * If the “Kostenträger” is “Bundeswehr” (s. the two Kostenträger in the requirement), the “Personenkennnummer” needs to be entered
   *  in the SKT-Zusatzangaben field (based on the output of kvx3 [9403]). This number has to be checked for its format: <TTMMJJannnnn>.
   *  The costUnitBillingFieldCode is checked if it is one of "79868" and "79869", if so the format of field "additionalSktInformation" is checked.
   */
  BillingCertificateValidityViolationTypePersonenkennnummerFormat = 'BILLING_CERTIFICATE_VALIDITY_VIOLATION_TYPE_PERSONENKENNNUMMER_FORMAT'
}

export type Billing_German_BillingCodeApprovalMsg = {
  __typename?: 'billing_german_BillingCodeApprovalMsg';
  /** Allows explicitly marking request as denied */
  approvalDenied?: Maybe<Scalars['Boolean']>;
  /** [4254]/[4257] */
  approvedQuantity?: Maybe<Scalars['Int']>;
  /** [4253]/[4256] */
  codeReference?: Maybe<Billing_BillingCodeReferenceMsg>;
  /**
   * In standard case, each code uses one quantity; but there are codes for short sessions that only "count half", i.e., when two of them are documented, one unit is used.
   *  So we have to keep track of the halves, but display it as rounded-down integer (i.e., Math.floor(usedQuantityHalves / 2)).
   */
  usedQuantityHalves?: Maybe<Scalars['Int']>;
};

export type Billing_German_BillingDayMsg = {
  __typename?: 'billing_german_BillingDayMsg';
  contactIndex?: Maybe<Scalars['Int']>;
  date?: Maybe<Core_LocalDateMsg>;
  id?: Maybe<Scalars['String']>;
  time?: Maybe<Core_LocalTimeMsg>;
};

export type Billing_German_BillingDiagnosisCodingIdMsg = {
  __typename?: 'billing_german_BillingDiagnosisCodingIdMsg';
  diagnosisCodingGroupId?: Maybe<Scalars['String']>;
  diagnosisCodingId?: Maybe<Scalars['String']>;
};

export type Billing_German_BillingDischargeReasonMsg = {
  __typename?: 'billing_german_BillingDischargeReasonMsg';
  digitThree?: Maybe<Scalars['String']>;
  digitsOneTwo?: Maybe<Scalars['String']>;
};

export enum Billing_German_BillingFeeSchedule {
  BillingFeeScheduleBmae = 'BILLING_FEE_SCHEDULE_BMAE',
  BillingFeeScheduleEbm = 'BILLING_FEE_SCHEDULE_EBM',
  BillingFeeScheduleEgo = 'BILLING_FEE_SCHEDULE_EGO',
  BillingFeeScheduleGoae = 'BILLING_FEE_SCHEDULE_GOAE',
  BillingFeeScheduleNone = 'BILLING_FEE_SCHEDULE_NONE'
}

export type Billing_German_BillingSettingsMsg = {
  __typename?: 'billing_german_BillingSettingsMsg';
  /** AMV-Prüfnummer */
  amvApprovalNumber?: Maybe<Scalars['String']>;
  bgBillingSettings?: Maybe<Billing_German_BgBillingSettingsMsg>;
  /** Determines which grouping diagnosis assignments can be set through medical documentation, e.g., in treatments or visit cockpit */
  diagnosisAssignmentSettings?: Maybe<Array<Maybe<Billing_German_DiagnosisAssignmentSettingMsg>>>;
  drgWorkplaceApprovalLevel?: Maybe<Billing_German_DrgWorkplaceApprovalLevel>;
  gnrScorePrices?: Maybe<Array<Maybe<Billing_German_GnrScorePriceMsg>>>;
  /** catalog specialist group requires specialist group input */
  icdCodeSearchCatalog?: Maybe<Billing_German_IcdCodeSearchCatalog>;
  id?: Maybe<Scalars['String']>;
  /** KV-Bereich */
  kvArea?: Maybe<Scalars['String']>;
  patientReceiptSettings?: Maybe<Billing_German_PatientReceiptSettingsMsg>;
  specialistGroupCode?: Maybe<Scalars['String']>;
  tiActivationSettings?: Maybe<Billing_German_TiActivationSettingsMsg>;
  timestamps?: Maybe<TimeMsg>;
  /** unique */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  vatOptions?: Maybe<Array<Maybe<Billing_German_VatPercentageMsg>>>;
  /** Hinweis bei Besonderer Personengruppe "6" */
  warningSpecialPersonGroupNine?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_CheckBillingCertificateValidityRequest = {
  __typename?: 'billing_german_CheckBillingCertificateValidityRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
};

export type Billing_German_CheckBillingCertificateValidityResponse = {
  __typename?: 'billing_german_CheckBillingCertificateValidityResponse';
  valid?: Maybe<Scalars['Boolean']>;
  violationTypes?: Maybe<Array<Maybe<Billing_German_BillingCertificateValidityViolationType>>>;
};

export type Billing_German_ClearClinicalComplexityLevelsRequest = {
  __typename?: 'billing_german_ClearClinicalComplexityLevelsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  /** These grouping diagnoses will remain unchanged; all other ones will have their clinical complexity levels cleared */
  excludedGroupingDiagnosisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_CodeConditionMsg = {
  __typename?: 'billing_german_CodeConditionMsg';
  ageInterval?: Maybe<Billing_German_AgeIntervalMsg>;
  approvalRequired?: Maybe<Scalars['Boolean']>;
  letterRequired?: Maybe<Scalars['Boolean']>;
  requiredGender?: Maybe<Core_Sex>;
};

export type Billing_German_CodeExclusionMsg = {
  __typename?: 'billing_german_CodeExclusionMsg';
  codeReference?: Maybe<Billing_BillingCodeReferenceMsg>;
  id?: Maybe<Scalars['String']>;
  timeContext?: Maybe<Billing_German_TimeContextMsg>;
};

export type Billing_German_CodeJustificationMsg = {
  __typename?: 'billing_german_CodeJustificationMsg';
  code?: Maybe<Scalars['String']>;
  codeJustificationType?: Maybe<Billing_German_CodeJustificationType>;
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Billing_OpsNumberLocalization>;
};

export enum Billing_German_CodeJustificationType {
  CodeJustificationTypeEbm = 'CODE_JUSTIFICATION_TYPE_EBM',
  CodeJustificationTypeIcd = 'CODE_JUSTIFICATION_TYPE_ICD',
  CodeJustificationTypeNone = 'CODE_JUSTIFICATION_TYPE_NONE',
  CodeJustificationTypeOps = 'CODE_JUSTIFICATION_TYPE_OPS'
}

export type Billing_German_CodePricingMsg = {
  __typename?: 'billing_german_CodePricingMsg';
  id?: Maybe<Scalars['String']>;
  pricingUnit?: Maybe<Billing_ValueUnitType>;
  serviceProviderId?: Maybe<Scalars['String']>;
  serviceType?: Maybe<Billing_German_CodePricingServiceType>;
  value?: Maybe<DecimalMsg>;
};

export enum Billing_German_CodePricingServiceType {
  CodePricingServiceTypeFull = 'CODE_PRICING_SERVICE_TYPE_FULL',
  CodePricingServiceTypeMedical = 'CODE_PRICING_SERVICE_TYPE_MEDICAL',
  CodePricingServiceTypeNone = 'CODE_PRICING_SERVICE_TYPE_NONE',
  CodePricingServiceTypeTechnical = 'CODE_PRICING_SERVICE_TYPE_TECHNICAL'
}

export type Billing_German_CodeRecordRequest = {
  __typename?: 'billing_german_CodeRecordRequest';
  ebmCode?: Maybe<Scalars['String']>;
};

export type Billing_German_CodeRecordSearchResultMsg = {
  __typename?: 'billing_german_CodeRecordSearchResultMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_BillingCatalogType>;
};

export type Billing_German_CodingRuleSuggestionOptionMsg = {
  __typename?: 'billing_german_CodingRuleSuggestionOptionMsg';
  action?: Maybe<Billing_German_DiagnosisRuleErrorAction>;
  diagnoses?: Maybe<Array<Maybe<Billing_German_LightGermanDiagnosisCodingMsg>>>;
  /** List of Diagnosensicherheit */
  diagnosisDetailTypes?: Maybe<Array<Maybe<Treatment_DiagnosisDetailType>>>;
  hintText?: Maybe<Scalars['String']>;
  /** List of Seitenlokalisation */
  lateralities?: Maybe<Array<Maybe<Laterality_Laterality>>>;
  ruleCode?: Maybe<Scalars['String']>;
  suggestionText?: Maybe<Scalars['String']>;
};

export type Billing_German_CodingWarningLinkMsg = {
  __typename?: 'billing_german_CodingWarningLinkMsg';
  id?: Maybe<Scalars['String']>;
  /** uuid of the relevant element, may be empty */
  referenceId?: Maybe<Scalars['String']>;
  /** textual description of the relevant element */
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Billing_German_GroupingElementType>;
  /** textual description of the relevant element's type, use if type is NONE */
  typeDescription?: Maybe<Scalars['String']>;
};

export type Billing_German_CodingWarningMsg = {
  __typename?: 'billing_german_CodingWarningMsg';
  id?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Billing_German_CodingWarningLinkMsg>>>;
  severity?: Maybe<Billing_German_CodingWarningSeverity>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum Billing_German_CodingWarningSeverity {
  CodingWarningSeverityError = 'CODING_WARNING_SEVERITY_ERROR',
  CodingWarningSeverityHint = 'CODING_WARNING_SEVERITY_HINT',
  CodingWarningSeverityNone = 'CODING_WARNING_SEVERITY_NONE',
  CodingWarningSeverityWarning = 'CODING_WARNING_SEVERITY_WARNING'
}

export type Billing_German_CreateBillingCertificateRequest = {
  __typename?: 'billing_german_CreateBillingCertificateRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  coverageId?: Maybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_CreateBillingDayRequest = {
  __typename?: 'billing_german_CreateBillingDayRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  date?: Maybe<Core_LocalDateMsg>;
  time?: Maybe<Core_LocalTimeMsg>;
};

export type Billing_German_CreateBillingDayResponse = {
  __typename?: 'billing_german_CreateBillingDayResponse';
  billingDay?: Maybe<Billing_German_BillingDayMsg>;
};

export type Billing_German_CreateBillingSettingsRequest = {
  __typename?: 'billing_german_CreateBillingSettingsRequest';
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_CreateEbmRecordRequest = {
  __typename?: 'billing_german_CreateEbmRecordRequest';
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_CreateEbmRecordResponse = {
  __typename?: 'billing_german_CreateEbmRecordResponse';
  affectedFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_CreateEbmRecordsRequest = {
  __typename?: 'billing_german_CreateEbmRecordsRequest';
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_CreateEbmRecordsResponse = {
  __typename?: 'billing_german_CreateEbmRecordsResponse';
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
  transactionCommitted?: Maybe<Billing_German_CreateEbmRecordsResponse_TransactionCommittedEvent>;
  transactionStarted?: Maybe<Billing_German_CreateEbmRecordsResponse_TransactionStartedEvent>;
  willFlush?: Maybe<Billing_German_CreateEbmRecordsResponse_WillFlushEvent>;
};

export type Billing_German_CreateEbmRecordsResponse_TransactionCommittedEvent = {
  __typename?: 'billing_german_CreateEbmRecordsResponse_TransactionCommittedEvent';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateEbmRecordsResponse_TransactionStartedEvent = {
  __typename?: 'billing_german_CreateEbmRecordsResponse_TransactionStartedEvent';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateEbmRecordsResponse_WillFlushEvent = {
  __typename?: 'billing_german_CreateEbmRecordsResponse_WillFlushEvent';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateGermanIcdCodeExceptionConfigRequest = {
  __typename?: 'billing_german_CreateGermanIcdCodeExceptionConfigRequest';
  icdCodeException?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateGermanLabBillingConfigRequest = {
  __typename?: 'billing_german_CreateGermanLabBillingConfigRequest';
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_CreateGroupingDataRequest = {
  __typename?: 'billing_german_CreateGroupingDataRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateUvGoaeCodeRecordsRequest = {
  __typename?: 'billing_german_CreateUvGoaeCodeRecordsRequest';
  uvGoaeCodeRecords?: Maybe<Array<Maybe<Billing_German_UvGoaeCodeRecordMsg>>>;
};

export type Billing_German_CreateVentilationPauseRequest = {
  __typename?: 'billing_german_CreateVentilationPauseRequest';
  ventilationPeriodId?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateVentilationPeriodRequest = {
  __typename?: 'billing_german_CreateVentilationPeriodRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_German_CreateVentilationPeriodResponse = {
  __typename?: 'billing_german_CreateVentilationPeriodResponse';
  ventilationOverview?: Maybe<Billing_German_VentilationOverviewMsg>;
};

export type Billing_German_DeleteAsvTeamRequest = {
  __typename?: 'billing_german_DeleteAsvTeamRequest';
  asvTeamId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteAsvTeamResponse = {
  __typename?: 'billing_german_DeleteAsvTeamResponse';
  deletedAsvTeamId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteBillingCertificateRequest = {
  __typename?: 'billing_german_DeleteBillingCertificateRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteBillingCertificateResponse = {
  __typename?: 'billing_german_DeleteBillingCertificateResponse';
  deletedBillingCertificateId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteBillingSettingsRequest = {
  __typename?: 'billing_german_DeleteBillingSettingsRequest';
  billingSettingsId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteBillingSettingsResponse = {
  __typename?: 'billing_german_DeleteBillingSettingsResponse';
  deletedBillingSettingsId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteDiagnosisRuleRequest = {
  __typename?: 'billing_german_DeleteDiagnosisRuleRequest';
  diagnosisRuleId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteDiagnosisRuleResponse = {
  __typename?: 'billing_german_DeleteDiagnosisRuleResponse';
  deletedDiagnosisRuleId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteDiagnosisRuleVersionRequest = {
  __typename?: 'billing_german_DeleteDiagnosisRuleVersionRequest';
  diagnosisRuleVersionId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteDiagnosisRuleVersionResponse = {
  __typename?: 'billing_german_DeleteDiagnosisRuleVersionResponse';
  deletedDiagnosisRuleVersionId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteEbmCodeFolderRequest = {
  __typename?: 'billing_german_DeleteEbmCodeFolderRequest';
  id?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteEbmCodeFolderResponse = {
  __typename?: 'billing_german_DeleteEbmCodeFolderResponse';
  id?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteEbmRecordRequest = {
  __typename?: 'billing_german_DeleteEbmRecordRequest';
  code?: Maybe<Scalars['String']>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_DeleteEbmRecordResponse = {
  __typename?: 'billing_german_DeleteEbmRecordResponse';
  affectedFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
  originalEbmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_DeleteGermanLabBillingConfigRequest = {
  __typename?: 'billing_german_DeleteGermanLabBillingConfigRequest';
  germanLabBillingConfigId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteGermanLabBillingConfigResponse = {
  __typename?: 'billing_german_DeleteGermanLabBillingConfigResponse';
  deletedGermanLabBillingConfigId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteGoaeCodeRecordRequest = {
  __typename?: 'billing_german_DeleteGoaeCodeRecordRequest';
  code?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteGoaeCodeRecordResponse = {
  __typename?: 'billing_german_DeleteGoaeCodeRecordResponse';
  code?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteVentilationPauseRequest = {
  __typename?: 'billing_german_DeleteVentilationPauseRequest';
  ventilationPauseId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteVentilationPauseResponse = {
  __typename?: 'billing_german_DeleteVentilationPauseResponse';
  deletedVentilationPauseId?: Maybe<Scalars['String']>;
  totalActualDuration?: Maybe<Scalars['Int']>;
  totalBillableDuration?: Maybe<Scalars['Int']>;
  ventilationPeriod?: Maybe<Billing_German_VentilationPeriodMsg>;
};

export type Billing_German_DeleteVentilationPeriodRequest = {
  __typename?: 'billing_german_DeleteVentilationPeriodRequest';
  ventilationPeriodId?: Maybe<Scalars['String']>;
};

export type Billing_German_DeleteVentilationPeriodResponse = {
  __typename?: 'billing_german_DeleteVentilationPeriodResponse';
  deletedVentilationPeriodId?: Maybe<Scalars['String']>;
  totalActualDuration?: Maybe<Scalars['Int']>;
  totalBillableDuration?: Maybe<Scalars['Int']>;
};

export type Billing_German_DiagnosisAssignmentSettingMsg = {
  __typename?: 'billing_german_DiagnosisAssignmentSettingMsg';
  enabled?: Maybe<Scalars['Boolean']>;
  step?: Maybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

export type Billing_German_DiagnosisCodingBillingInfoMsg = {
  __typename?: 'billing_german_DiagnosisCodingBillingInfoMsg';
  diagnosisCodingGroupId?: Maybe<Scalars['String']>;
  diagnosisCodingId?: Maybe<Scalars['String']>;
  diagnosisType?: Maybe<Treatment_DiagnosisType>;
};

export type Billing_German_DiagnosisCodingsUpdateMsg = {
  __typename?: 'billing_german_DiagnosisCodingsUpdateMsg';
  codingBillingInfos?: Maybe<Array<Maybe<Billing_German_DiagnosisCodingBillingInfoMsg>>>;
  date?: Maybe<Timestamp>;
  patientId?: Maybe<Scalars['String']>;
};

export enum Billing_German_DiagnosisRuleCheckExistence {
  DiagnosisRuleCheckExistenceFalse = 'DIAGNOSIS_RULE_CHECK_EXISTENCE_FALSE',
  DiagnosisRuleCheckExistenceMax = 'DIAGNOSIS_RULE_CHECK_EXISTENCE_MAX',
  DiagnosisRuleCheckExistenceNone = 'DIAGNOSIS_RULE_CHECK_EXISTENCE_NONE',
  DiagnosisRuleCheckExistenceTrue = 'DIAGNOSIS_RULE_CHECK_EXISTENCE_TRUE'
}

export type Billing_German_DiagnosisRuleCheckMsg = {
  __typename?: 'billing_german_DiagnosisRuleCheckMsg';
  /** <existenz> */
  existence?: Maybe<Billing_German_DiagnosisRuleCheckExistence>;
  id?: Maybe<Scalars['String']>;
  /** <operator> */
  operator?: Maybe<Logic_LogicalOperator>;
  /** <subpruefung> - only one level of subCheck possible */
  subCheck?: Maybe<Billing_German_DiagnosisRuleCheckMsg>;
  /** <parameter> */
  valueType?: Maybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_list> */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Billing_German_DiagnosisRuleCheckTiming {
  /** "zur Abrechnung" */
  DiagnosisRuleCheckTimingBilling = 'DIAGNOSIS_RULE_CHECK_TIMING_BILLING',
  /** "bei Kodierung" */
  DiagnosisRuleCheckTimingCoding = 'DIAGNOSIS_RULE_CHECK_TIMING_CODING',
  DiagnosisRuleCheckTimingNone = 'DIAGNOSIS_RULE_CHECK_TIMING_NONE',
  /** "wählbar" */
  DiagnosisRuleCheckTimingSelectable = 'DIAGNOSIS_RULE_CHECK_TIMING_SELECTABLE'
}

export type Billing_German_DiagnosisRuleConditionMsg = {
  __typename?: 'billing_german_DiagnosisRuleConditionMsg';
  /** <existenz> */
  existence?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  /** <operator> */
  operator?: Maybe<Logic_LogicalOperator>;
  /** <subbedingung> - only one level of subCondition possible */
  subCondition?: Maybe<Billing_German_DiagnosisRuleConditionMsg>;
  /** <parameter> */
  valueType?: Maybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_list> */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Billing_German_DiagnosisRuleErrorAction {
  DiagnosisRuleErrorActionAdd = 'DIAGNOSIS_RULE_ERROR_ACTION_ADD',
  DiagnosisRuleErrorActionDelete = 'DIAGNOSIS_RULE_ERROR_ACTION_DELETE',
  DiagnosisRuleErrorActionNone = 'DIAGNOSIS_RULE_ERROR_ACTION_NONE',
  DiagnosisRuleErrorActionReplace = 'DIAGNOSIS_RULE_ERROR_ACTION_REPLACE'
}

export type Billing_German_DiagnosisRuleErrorFixMsg = {
  __typename?: 'billing_german_DiagnosisRuleErrorFixMsg';
  /** <regel> */
  action?: Maybe<Billing_German_DiagnosisRuleErrorAction>;
  id?: Maybe<Scalars['String']>;
  /** <subkorrektur> */
  subFixes?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleErrorSubfixMsg>>>;
  /** <parameter> */
  valueType?: Maybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_liste> */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_DiagnosisRuleErrorHandlingMsg = {
  __typename?: 'billing_german_DiagnosisRuleErrorHandlingMsg';
  /** <korrektur> */
  fix?: Maybe<Billing_German_DiagnosisRuleErrorFixMsg>;
  id?: Maybe<Scalars['String']>;
  /** <hinweis> */
  informationText?: Maybe<Scalars['String']>;
  /** <vorschlag> */
  recommendationText?: Maybe<Scalars['String']>;
};

export type Billing_German_DiagnosisRuleErrorSubfixMsg = {
  __typename?: 'billing_german_DiagnosisRuleErrorSubfixMsg';
  id?: Maybe<Scalars['String']>;
  /** <parameter> */
  valueType?: Maybe<Billing_German_DiagnosisRuleValueType>;
  /** <value_liste> */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_DiagnosisRuleMsg = {
  __typename?: 'billing_german_DiagnosisRuleMsg';
  /** German "aktiv" */
  active?: Maybe<Scalars['Boolean']>;
  catalogId?: Maybe<Scalars['String']>;
  /** <krw:pruefung> */
  check?: Maybe<Billing_German_DiagnosisRuleCheckMsg>;
  /** <krw:echtzeitpruefung_liste> */
  checkTimings?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleCheckTiming>>>;
  /** <krw:bedingung> */
  condition?: Maybe<Billing_German_DiagnosisRuleConditionMsg>;
  /** <krw:beschreibung> */
  description?: Maybe<Scalars['String']>;
  /** <krw:fehlerbehandlung> */
  errorHandling?: Maybe<Billing_German_DiagnosisRuleErrorHandlingMsg>;
  id?: Maybe<Scalars['String']>;
  /** <krw:regelanwendung> */
  mandatory?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Billing_German_DiagnosisRuleOwnerReferenceMsg>;
  /** <krw:pruefgrundlage_liste> */
  patientGroup?: Maybe<Array<Maybe<Billing_German_DiagnosisRulePatientGroup>>>;
  /** <krw:bezugsraum> */
  referencePeriod?: Maybe<Billing_German_DiagnosisRuleReferencePeriodMsg>;
  /** Identifier by KBV <krw:id> or self-defined */
  ruleCode?: Maybe<Scalars['String']>;
  /** <krw:regelkategorie> */
  ruleScope?: Maybe<Billing_German_DiagnosisRuleScope>;
  /** <krw:regelquelle_liste> */
  sources?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleSourceMsg>>>;
  /** <krw:kurz_beschreibung> */
  summary?: Maybe<Scalars['String']>;
};

export type Billing_German_DiagnosisRuleOwnerReferenceMsg = {
  __typename?: 'billing_german_DiagnosisRuleOwnerReferenceMsg';
  ownerId?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Billing_German_DiagnosisRuleOwnerType>;
};

export enum Billing_German_DiagnosisRuleOwnerType {
  DiagnosisRuleOwnerAvelios = 'DIAGNOSIS_RULE_OWNER_AVELIOS',
  DiagnosisRuleOwnerClinic = 'DIAGNOSIS_RULE_OWNER_CLINIC',
  DiagnosisRuleOwnerDepartment = 'DIAGNOSIS_RULE_OWNER_DEPARTMENT',
  DiagnosisRuleOwnerDivision = 'DIAGNOSIS_RULE_OWNER_DIVISION',
  DiagnosisRuleOwnerNone = 'DIAGNOSIS_RULE_OWNER_NONE',
  DiagnosisRuleOwnerOrganizationalUnit = 'DIAGNOSIS_RULE_OWNER_ORGANIZATIONAL_UNIT',
  DiagnosisRuleOwnerUser = 'DIAGNOSIS_RULE_OWNER_USER'
}

export enum Billing_German_DiagnosisRulePatientGroup {
  DiagnosisRulePatientGroupAll = 'DIAGNOSIS_RULE_PATIENT_GROUP_ALL',
  DiagnosisRulePatientGroupIndividual = 'DIAGNOSIS_RULE_PATIENT_GROUP_INDIVIDUAL',
  DiagnosisRulePatientGroupNone = 'DIAGNOSIS_RULE_PATIENT_GROUP_NONE',
  DiagnosisRulePatientGroupQuarterlyTreated = 'DIAGNOSIS_RULE_PATIENT_GROUP_QUARTERLY_TREATED'
}

export type Billing_German_DiagnosisRuleReferencePeriodMsg = {
  __typename?: 'billing_german_DiagnosisRuleReferencePeriodMsg';
  /** <anzahl_quartale>; if set, must be >= 1; only relevant for rule scope INTER_QUARTER */
  numberOfQuarters?: Maybe<Scalars['Int']>;
  ruleScope?: Maybe<Billing_German_DiagnosisRuleScope>;
};

export enum Billing_German_DiagnosisRuleScope {
  /** Behandlungsfall */
  DiagnosisRuleScopeCase = 'DIAGNOSIS_RULE_SCOPE_CASE',
  /** Quartalsübergreifend */
  DiagnosisRuleScopeInterQuarter = 'DIAGNOSIS_RULE_SCOPE_INTER_QUARTER',
  DiagnosisRuleScopeNone = 'DIAGNOSIS_RULE_SCOPE_NONE'
}

export type Billing_German_DiagnosisRuleSourceMsg = {
  __typename?: 'billing_german_DiagnosisRuleSourceMsg';
  id?: Maybe<Scalars['String']>;
  /** <regelthema> */
  sourceTopic?: Maybe<Scalars['String']>;
  /** <regelquelle> */
  sourceType?: Maybe<Billing_German_DiagnosisRuleSourceType>;
};

export enum Billing_German_DiagnosisRuleSourceType {
  DiagnosisRuleSourceTypeGuideline_295 = 'DIAGNOSIS_RULE_SOURCE_TYPE_GUIDELINE_295',
  DiagnosisRuleSourceTypeIcd_10Gm = 'DIAGNOSIS_RULE_SOURCE_TYPE_ICD_10_GM',
  DiagnosisRuleSourceTypeNone = 'DIAGNOSIS_RULE_SOURCE_TYPE_NONE'
}

export enum Billing_German_DiagnosisRuleValueType {
  DiagnosisRuleValueTypeDiagnosisSecurity = 'DIAGNOSIS_RULE_VALUE_TYPE_DIAGNOSIS_SECURITY',
  DiagnosisRuleValueTypeIcd = 'DIAGNOSIS_RULE_VALUE_TYPE_ICD',
  DiagnosisRuleValueTypeLaterality = 'DIAGNOSIS_RULE_VALUE_TYPE_LATERALITY',
  DiagnosisRuleValueTypeNone = 'DIAGNOSIS_RULE_VALUE_TYPE_NONE'
}

export type Billing_German_DiagnosisSuggestionsMsg = {
  __typename?: 'billing_german_DiagnosisSuggestionsMsg';
  billingCertificateId?: Maybe<Scalars['String']>;
  originalIcdCode?: Maybe<Scalars['String']>;
  suggestionOptions?: Maybe<Array<Maybe<Billing_German_CodingRuleSuggestionOptionMsg>>>;
};

export enum Billing_German_DrgDepartmentType {
  DrgDepartmentTypeDayPatientCare = 'DRG_DEPARTMENT_TYPE_DAY_PATIENT_CARE',
  DrgDepartmentTypeHybridDrg = 'DRG_DEPARTMENT_TYPE_HYBRID_DRG',
  DrgDepartmentTypeMain = 'DRG_DEPARTMENT_TYPE_MAIN',
  DrgDepartmentTypeMainWithMidwife = 'DRG_DEPARTMENT_TYPE_MAIN_WITH_MIDWIFE',
  DrgDepartmentTypeMainWithTargetedReduction = 'DRG_DEPARTMENT_TYPE_MAIN_WITH_TARGETED_REDUCTION',
  DrgDepartmentTypeNone = 'DRG_DEPARTMENT_TYPE_NONE',
  DrgDepartmentTypePhysicianWithFeeAgreement = 'DRG_DEPARTMENT_TYPE_PHYSICIAN_WITH_FEE_AGREEMENT',
  DrgDepartmentTypePhysicianWithFeeAgreementAndTargetedReduction = 'DRG_DEPARTMENT_TYPE_PHYSICIAN_WITH_FEE_AGREEMENT_AND_TARGETED_REDUCTION',
  DrgDepartmentTypeSurgeon = 'DRG_DEPARTMENT_TYPE_SURGEON',
  DrgDepartmentTypeSurgeonWithAnesthesiologist = 'DRG_DEPARTMENT_TYPE_SURGEON_WITH_ANESTHESIOLOGIST',
  DrgDepartmentTypeSurgeonWithAnesthesiologistAndMidwife = 'DRG_DEPARTMENT_TYPE_SURGEON_WITH_ANESTHESIOLOGIST_AND_MIDWIFE',
  DrgDepartmentTypeSurgeonWithAnesthesiologistAndTargetedReduction = 'DRG_DEPARTMENT_TYPE_SURGEON_WITH_ANESTHESIOLOGIST_AND_TARGETED_REDUCTION',
  DrgDepartmentTypeSurgeonWithMidwife = 'DRG_DEPARTMENT_TYPE_SURGEON_WITH_MIDWIFE',
  DrgDepartmentTypeSurgeonWithTargetedReduction = 'DRG_DEPARTMENT_TYPE_SURGEON_WITH_TARGETED_REDUCTION'
}

export enum Billing_German_DrgWorkplaceApprovalLevel {
  DrgWorkplaceApprovalLevel_1 = 'DRG_WORKPLACE_APPROVAL_LEVEL_1',
  DrgWorkplaceApprovalLevel_2 = 'DRG_WORKPLACE_APPROVAL_LEVEL_2',
  DrgWorkplaceApprovalLevel_3 = 'DRG_WORKPLACE_APPROVAL_LEVEL_3',
  DrgWorkplaceApprovalLevel_4 = 'DRG_WORKPLACE_APPROVAL_LEVEL_4',
  DrgWorkplaceApprovalLevel_5 = 'DRG_WORKPLACE_APPROVAL_LEVEL_5',
  DrgWorkplaceApprovalLevelNone = 'DRG_WORKPLACE_APPROVAL_LEVEL_NONE'
}

export type Billing_German_DunningSettingsMsg = {
  __typename?: 'billing_german_DunningSettingsMsg';
  /** Mahngebühr (cent) */
  dunningFeeCents?: Maybe<Scalars['Int']>;
  /** Mahnfrist (Tage) */
  dunningPeriodDays?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export enum Billing_German_EPaSupport {
  EPaSupportLevelOne = 'E_PA_SUPPORT_LEVEL_ONE',
  EPaSupportLevelThree = 'E_PA_SUPPORT_LEVEL_THREE',
  EPaSupportLevelTwo = 'E_PA_SUPPORT_LEVEL_TWO',
  EPaSupportNone = 'E_PA_SUPPORT_NONE'
}

export type Billing_German_EbmCodeDetailsMsg = {
  __typename?: 'billing_german_EbmCodeDetailsMsg';
  chapterIdentifier?: Maybe<Scalars['String']>;
  chapterName?: Maybe<Scalars['String']>;
  codePricings?: Maybe<Array<Maybe<Billing_German_CodePricingMsg>>>;
  facultativeServiceContent?: Maybe<Scalars['String']>;
  longTextHtml?: Maybe<Scalars['String']>;
  notesHtml?: Maybe<Scalars['String']>;
  obligateServiceContent?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  serviceGroupId?: Maybe<Scalars['String']>;
  shortText?: Maybe<Scalars['String']>;
  subSection?: Maybe<Scalars['String']>;
  subSubSection?: Maybe<Scalars['String']>;
};

export type Billing_German_EbmCodeFolderList = {
  __typename?: 'billing_german_EbmCodeFolderList';
  ebmCodeFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
};

export type Billing_German_EbmCodeFolderMsg = {
  __typename?: 'billing_german_EbmCodeFolderMsg';
  code?: Maybe<Scalars['String']>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  ebmCodeRecords?: Maybe<Array<Maybe<Billing_German_EbmCodeRecordMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentFolderId?: Maybe<Scalars['String']>;
  path?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
  subFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
};

export type Billing_German_EbmCodeRecordMsg = {
  __typename?: 'billing_german_EbmCodeRecordMsg';
  additionalInputFieldGroups?: Maybe<Array<Maybe<Billing_German_AdditionalCodeInputFieldGroupMsg>>>;
  amountConditions?: Maybe<Array<Maybe<Billing_German_AmountConditionMsg>>>;
  authorizedMedicalSpecializations?: Maybe<Array<Maybe<Billing_German_MedicalSpecializationMsg>>>;
  codeCondition?: Maybe<Billing_German_CodeConditionMsg>;
  codeExclusions?: Maybe<Array<Maybe<Billing_German_CodeExclusionMsg>>>;
  codeJustifications?: Maybe<Array<Maybe<Billing_German_CodeJustificationMsg>>>;
  codePricings?: Maybe<Array<Maybe<Billing_German_CodePricingMsg>>>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  ebmCode?: Maybe<Scalars['String']>;
  ebmCodeDetails?: Maybe<Billing_German_EbmCodeDetailsMsg>;
  ebmCodeFolderId?: Maybe<Scalars['String']>;
  ebmJustificationsPresent?: Maybe<Scalars['Boolean']>;
  icdJustificationsPresent?: Maybe<Scalars['Boolean']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  opsJustificationsPresent?: Maybe<Scalars['Boolean']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  path?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
  validity?: Maybe<Billing_German_ValidityTimespanMsg>;
};

export type Billing_German_EbmKeytabMsg = {
  __typename?: 'billing_german_EbmKeytabMsg';
  description?: Maybe<Scalars['String']>;
  /** id of the keytab file */
  id?: Maybe<Billing_German_KeytabIdMsg>;
  /** keytabs sometimes reference another keytab */
  referencedKeyTab?: Maybe<Billing_German_EbmKeytabMsg>;
  softwareVersion?: Maybe<Scalars['String']>;
};

export type Billing_German_FindActiveBillingCertificateRequest = {
  __typename?: 'billing_german_FindActiveBillingCertificateRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_German_FindActiveBillingCertificateResponse = {
  __typename?: 'billing_german_FindActiveBillingCertificateResponse';
  billingCertificate?: Maybe<Billing_German_BillingCertificateMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_FindActiveDiagnosisRuleVersionRequest = {
  __typename?: 'billing_german_FindActiveDiagnosisRuleVersionRequest';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_FindBillingSettingsRequest = {
  __typename?: 'billing_german_FindBillingSettingsRequest';
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_FindBillingSettingsResponse = {
  __typename?: 'billing_german_FindBillingSettingsResponse';
  billingSettings?: Maybe<Billing_German_BillingSettingsMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_FindDiagnosisAssignmentSettingsRequest = {
  __typename?: 'billing_german_FindDiagnosisAssignmentSettingsRequest';
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_FindDiagnosisAssignmentSettingsResponse = {
  __typename?: 'billing_german_FindDiagnosisAssignmentSettingsResponse';
  diagnosisAssignmentSettings?: Maybe<Array<Maybe<Billing_German_DiagnosisAssignmentSettingMsg>>>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_FindGermanLabBillingConfigRequest = {
  __typename?: 'billing_german_FindGermanLabBillingConfigRequest';
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_FindGermanLabBillingConfigResponse = {
  __typename?: 'billing_german_FindGermanLabBillingConfigResponse';
  found?: Maybe<Scalars['Boolean']>;
  germanLabBillingConfig?: Maybe<Billing_German_GermanLabBillingConfigMsg>;
};

export type Billing_German_GermanBillingCaseAggregationDataMsg = {
  __typename?: 'billing_german_GermanBillingCaseAggregationDataMsg';
  diagnosisOverrides?: Maybe<Array<Maybe<Billing_German_GermanBillingCaseAggregationDiagnosisOverrideMsg>>>;
  procedureOverrides?: Maybe<Array<Maybe<Billing_German_GermanBillingCaseAggregationProcedureOverrideMsg>>>;
};

export type Billing_German_GermanBillingCaseAggregationDiagnosisOverrideMsg = {
  __typename?: 'billing_german_GermanBillingCaseAggregationDiagnosisOverrideMsg';
  /**
   * since multiple GroupingDiagnosis with the same diagnosisCodingGroupId can exist in an aggregated billing case,
   *  we need to provide this field so that we can differentiate these duplicated GroupingDiagnoses.
   */
  billingCaseId?: Maybe<Scalars['String']>;
  diagnosisCodingGroupId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isMain?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_GermanBillingCaseAggregationProcedureOverrideMsg = {
  __typename?: 'billing_german_GermanBillingCaseAggregationProcedureOverrideMsg';
  billingProcedureId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isMain?: Maybe<Scalars['Boolean']>;
};

/** Used to provide string descriptions for the codes in GermanCoverageInformationMsg; added to the schema by rejoiner */
export type Billing_German_GermanCoverageInformationCodeDetailsMsg = {
  __typename?: 'billing_german_GermanCoverageInformationCodeDetailsMsg';
  /** corresponds to dmpDesignationCode */
  dmpDesignation?: Maybe<Scalars['String']>;
  /** corresponds to examinationCategoryCode */
  examinationCategory?: Maybe<Scalars['String']>;
  /** corresponds to insuredPersonTypeCode */
  insuredPersonType?: Maybe<Scalars['String']>;
  /** corresponds to privateContactTypeCode */
  privateContactType?: Maybe<Scalars['String']>;
  /** corresponds to specialPersonGroupCode */
  specialPersonGroup?: Maybe<Scalars['String']>;
  /** corresponds to suspendedEntitlementTypeCode */
  suspendedEntitlementType?: Maybe<Scalars['String']>;
  /** corresponds to wopDesignationCode */
  wopDesignation?: Maybe<Scalars['String']>;
};

export type Billing_German_GermanIcdCodeExceptionConfigMsg = {
  __typename?: 'billing_german_GermanIcdCodeExceptionConfigMsg';
  icdCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** todo skipping warning only for quarter period */
  userThatSkipWarningIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_GermanLabBillingConfigMsg = {
  __typename?: 'billing_german_GermanLabBillingConfigMsg';
  certificates?: Maybe<Array<Maybe<Billing_German_RingTestCertificateMsg>>>;
  devices?: Maybe<Array<Maybe<Billing_German_GermanLabBillingDeviceMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** German "Werden zertifikatspflichtige Laborleistungen abgerechnet?" */
  ringTestCertificatesRequired?: Maybe<Scalars['Boolean']>;
  /** German "Verwendung von Unit Use-Reagenzien" */
  singleUseReagentUsage?: Maybe<Billing_German_GermanSingleUseReagentUsage>;
  timestamps?: Maybe<TimeMsg>;
  /** unique */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_GermanLabBillingDeviceMsg = {
  __typename?: 'billing_german_GermanLabBillingDeviceMsg';
  deviceDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
};

export type Billing_German_GermanPrivateCoverageInformationMsg = {
  __typename?: 'billing_german_GermanPrivateCoverageInformationMsg';
  /** Karte gültig bis */
  cardValidityEnd?: Maybe<PrecisionTimestampMsg>;
  /** Beihilfe. TODO: probably should be separate coverage altogether */
  healthInsuranceSubsidyActive?: Maybe<Scalars['Boolean']>;
  /** Beihilfe (Details). TODO: probably should be separate coverage altogether */
  healthInsuranceSubsidyDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Personennummer */
  personalNumber?: Maybe<Scalars['String']>;
};

export enum Billing_German_GermanReimbursementType {
  GermanReimbursementTypeAdditionalServices = 'GERMAN_REIMBURSEMENT_TYPE_ADDITIONAL_SERVICES',
  GermanReimbursementTypeDental = 'GERMAN_REIMBURSEMENT_TYPE_DENTAL',
  GermanReimbursementTypeInpatient = 'GERMAN_REIMBURSEMENT_TYPE_INPATIENT',
  GermanReimbursementTypeMedicalCare = 'GERMAN_REIMBURSEMENT_TYPE_MEDICAL_CARE',
  GermanReimbursementTypeNone = 'GERMAN_REIMBURSEMENT_TYPE_NONE'
}

export enum Billing_German_GermanSingleUseReagentUsage {
  GermanSingleUseReagentUsageFull = 'GERMAN_SINGLE_USE_REAGENT_USAGE_FULL',
  GermanSingleUseReagentUsageNone = 'GERMAN_SINGLE_USE_REAGENT_USAGE_NONE',
  GermanSingleUseReagentUsageNoUse = 'GERMAN_SINGLE_USE_REAGENT_USAGE_NO_USE',
  GermanSingleUseReagentUsagePartial = 'GERMAN_SINGLE_USE_REAGENT_USAGE_PARTIAL'
}

export type Billing_German_GermanStatutoryCoverageInformationMsg = {
  __typename?: 'billing_german_GermanStatutoryCoverageInformationMsg';
  /** SKT-Zusatzangaben [4124] */
  additionalSktInformation?: Maybe<Scalars['String']>;
  /** Aufnehmender Kostenträger: can differ from cost unit code due to insurer fusion */
  billingCostUnitCode?: Maybe<Scalars['String']>;
  /** Zuzahlungsbefreiung -- filled from eGK/KvK - always editable */
  copaymentExemption?: Maybe<Scalars['Boolean']>;
  /** Zuzahlungsbefreiung bis -- filled from eGK/KvK - always editable */
  copaymentExemptionEndDate?: Maybe<PrecisionTimestampMsg>;
  /** Kostenträger [4134] -- readonly - only filled if KvK or eGK is read */
  costUnit?: Maybe<Scalars['String']>;
  /** Kostenträgerkennung [4111] (IK) */
  costUnitCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  /** VersicherungsschutzEnde */
  coverageEndDate?: Maybe<Core_LocalDateMsg>;
  /** Geburtsdatum */
  dateOfBirth?: Maybe<PrecisionTimestampMsg>;
  /** DMP-Kennzeichnung [4132]; 2-character code */
  dmpDesignationCode?: Maybe<Scalars['String']>;
  /** Personenkreis/Untersuchungskategorie [4123]; 2-character code */
  examinationCategoryCode?: Maybe<Scalars['String']>;
  /** Vorname */
  firstName?: Maybe<Scalars['String']>;
  /** Patientenquittung */
  generatePatientReceipts?: Maybe<Scalars['Boolean']>;
  houseNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Versichertenart [3108] */
  insuredPersonTypeCode?: Maybe<Scalars['String']>;
  /** Versicherten_ID */
  insureeId?: Maybe<Scalars['String']>;
  /** Versichertennummer (only with SKT) */
  insureeNumber?: Maybe<Scalars['String']>;
  /** Name */
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  /** Namenszusatz */
  nameAffixes?: Maybe<Scalars['String']>;
  /** Vorsatzwort */
  namePrefix?: Maybe<Scalars['String']>;
  /** Vortage */
  pastCopaymentDays?: Maybe<Scalars['Int']>;
  /** Mindernder Nachweis für Vortage */
  pastCopaymentDaysValidated?: Maybe<Scalars['Boolean']>;
  poBox?: Maybe<Scalars['String']>;
  poBoxCountryCode?: Maybe<Scalars['String']>;
  poBoxLocality?: Maybe<Scalars['String']>;
  /** Postfachadresse */
  poBoxPostcode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  /** Grund der Zuzahlungsbefreiung -- always editable */
  reasonForCopaymentExemption?: Maybe<Scalars['String']>;
  sex?: Maybe<Core_Sex>;
  /** SKT-Bemerkungen [4126] */
  sktComments?: Maybe<Scalars['String']>;
  /** Besondere Personengruppe [4131]; 2-character code */
  specialPersonGroupCode?: Maybe<Scalars['String']>;
  /** Adresse */
  streetName?: Maybe<Scalars['String']>;
  /** Titel */
  title?: Maybe<Scalars['String']>;
  /** WOP-Kennzeichen [3116]; 2-character code */
  wopDesignationCode?: Maybe<Scalars['String']>;
};

export type Billing_German_GetAsvTeamsRequest = {
  __typename?: 'billing_german_GetAsvTeamsRequest';
  asvTeamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_GetAsvTeamsResponse = {
  __typename?: 'billing_german_GetAsvTeamsResponse';
  asvTeams?: Maybe<Array<Maybe<Billing_German_AsvTeamMsg>>>;
};

export type Billing_German_GetBillingCertificateRequest = {
  __typename?: 'billing_german_GetBillingCertificateRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
};

export type Billing_German_GetCodeRecordsRequest = {
  __typename?: 'billing_german_GetCodeRecordsRequest';
  codeReferences?: Maybe<Array<Maybe<Billing_BillingCodeReferenceMsg>>>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_GetCodeRecordsResponse = {
  __typename?: 'billing_german_GetCodeRecordsResponse';
  ebmCodeRecords?: Maybe<Array<Maybe<Billing_German_EbmCodeRecordMsg>>>;
  goaeCodeRecords?: Maybe<Array<Maybe<Billing_German_GoaeCodeRecordMsg>>>;
  uvgoaeCodeRecords?: Maybe<Array<Maybe<Billing_German_UvGoaeCodeRecordMsg>>>;
};

export type Billing_German_GetEbmCodeFolderRequest = {
  __typename?: 'billing_german_GetEbmCodeFolderRequest';
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_GetEbmCodeFolderResponse = {
  __typename?: 'billing_german_GetEbmCodeFolderResponse';
  ebmCodeFolder?: Maybe<Billing_German_EbmCodeFolderMsg>;
};

export type Billing_German_GetEbmKeytabRequest = {
  __typename?: 'billing_german_GetEbmKeytabRequest';
  code?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
};

export type Billing_German_GetEbmKeytabResponse = {
  __typename?: 'billing_german_GetEbmKeytabResponse';
  ebmKeytab?: Maybe<Billing_German_EbmKeytabMsg>;
};

export type Billing_German_GetEbmRecordRequest = {
  __typename?: 'billing_german_GetEbmRecordRequest';
  code?: Maybe<Scalars['String']>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Billing_German_GetEbmRecordResponse = {
  __typename?: 'billing_german_GetEbmRecordResponse';
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_GetGroupingDataRequest = {
  __typename?: 'billing_german_GetGroupingDataRequest';
  groupingDataId?: Maybe<Scalars['String']>;
};

export type Billing_German_GetOrCreateVentilationOverviewRequest = {
  __typename?: 'billing_german_GetOrCreateVentilationOverviewRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_German_GetSimpleCodeRecordRequest = {
  __typename?: 'billing_german_GetSimpleCodeRecordRequest';
  code?: Maybe<Scalars['String']>;
  ebmCatalogId?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  type?: Maybe<Billing_BillingCatalogType>;
};

export type Billing_German_GetSimpleCodeRecordResponse = {
  __typename?: 'billing_german_GetSimpleCodeRecordResponse';
  result?: Maybe<Billing_German_CodeRecordSearchResultMsg>;
};

export type Billing_German_GetVentilationPeriodRequest = {
  __typename?: 'billing_german_GetVentilationPeriodRequest';
  ventilationPeriodId?: Maybe<Scalars['String']>;
};

export type Billing_German_GnrScorePriceMsg = {
  __typename?: 'billing_german_GnrScorePriceMsg';
  billingCatalogType?: Maybe<Billing_BillingCatalogType>;
  pricePerPoint?: Maybe<Billing_Money>;
};

export type Billing_German_GoaeCodeMultiplierDescriptionMsg = {
  __typename?: 'billing_german_GoaeCodeMultiplierDescriptionMsg';
  maxMultiplier?: Maybe<DecimalMsg>;
  points?: Maybe<DecimalMsg>;
  ruleMaxMultiplier?: Maybe<DecimalMsg>;
  singleMultiplier?: Maybe<DecimalMsg>;
};

export type Billing_German_GoaeCodeRecordMsg = {
  __typename?: 'billing_german_GoaeCodeRecordMsg';
  catalogId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludedCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  multiplierDescription?: Maybe<Billing_German_GoaeCodeMultiplierDescriptionMsg>;
  title?: Maybe<Scalars['String']>;
};

export type Billing_German_GroupPsychotherapyCodeList = {
  __typename?: 'billing_german_GroupPsychotherapyCodeList';
  codes?: Maybe<Array<Maybe<Billing_German_GroupPsychotherapyCodeMsg>>>;
};

/** For group therapies, one "fake" code, e.g., "3550X" triggers a list of connected actual codes */
export type Billing_German_GroupPsychotherapyCodeMsg = {
  __typename?: 'billing_german_GroupPsychotherapyCodeMsg';
  billingCatalogType?: Maybe<Billing_BillingCatalogType>;
  code?: Maybe<Scalars['String']>;
  connectedCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_German_GroupingDataMsg = {
  __typename?: 'billing_german_GroupingDataMsg';
  /** Beurlaubungstage */
  absenceDays?: Maybe<Scalars['Int']>;
  /** Aufnahmegewicht in g */
  admissionBodyWeightGrams?: Maybe<Scalars['Int']>;
  approvalLevel?: Maybe<Billing_German_ApprovalLevelMsg>;
  /** Pflegeberechnungstage */
  careCalculationDays?: Maybe<Scalars['Int']>;
  caseNote?: Maybe<Scalars['String']>;
  /** Tage ohne Berechnung/Behandlung */
  daysExcludedFromCalculation?: Maybe<Scalars['Int']>;
  /** Tage ohne Berechnung/Behandlung (after review by insurer (German: Medizinischer Dienst der Krankenkasse)) */
  daysExcludedFromCalculationReviewed?: Maybe<Scalars['Boolean']>;
  diagnoses?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisMsg>>>;
  /** Abteilungstyp */
  drgDepartmentType?: Maybe<Billing_German_DrgDepartmentType>;
  id?: Maybe<Scalars['String']>;
  /** Verweildauer */
  lengthOfStayDays?: Maybe<Scalars['Int']>;
  /**
   * Link to medical diagnoses that are marked for processing in grouping. Does not necessarily mean that
   *  codings in these diagnoses are also marked as drg relevant.
   *  However, no codings outside of these diagnoses can be linked in any grouping diagnosis of this GroupingData.
   */
  selectedDiagnosisRevisionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Beatmungsstunden */
  ventilationHours?: Maybe<Scalars['Int']>;
  ventilationOverview?: Maybe<Billing_German_VentilationOverviewMsg>;
  warnings?: Maybe<Array<Maybe<Billing_German_CodingWarningMsg>>>;
};

export enum Billing_German_GroupingDataValidationError {
  GroupingDataValidationErrorDischargeMainWithoutUnitAssignmentMain = 'GROUPING_DATA_VALIDATION_ERROR_DISCHARGE_MAIN_WITHOUT_UNIT_ASSIGNMENT_MAIN',
  GroupingDataValidationErrorNone = 'GROUPING_DATA_VALIDATION_ERROR_NONE'
}

export type Billing_German_GroupingDiagnosisAssignmentMsg = {
  __typename?: 'billing_german_GroupingDiagnosisAssignmentMsg';
  id?: Maybe<Scalars['String']>;
  isMain?: Maybe<Scalars['Boolean']>;
  /** only relevant if step is UNIT_ASSIGNMENT */
  leadingUnitAssignmentId?: Maybe<Scalars['String']>;
  step?: Maybe<Billing_German_GroupingDiagnosisAssignmentStep>;
};

export enum Billing_German_GroupingDiagnosisAssignmentStep {
  GroupingDiagnosisAssignmentStepAdmission = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_ADMISSION',
  GroupingDiagnosisAssignmentStepDischarge = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_DISCHARGE',
  GroupingDiagnosisAssignmentStepNone = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_NONE',
  GroupingDiagnosisAssignmentStepOverall = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_OVERALL',
  GroupingDiagnosisAssignmentStepReferral = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_REFERRAL',
  GroupingDiagnosisAssignmentStepUnitAssignment = 'GROUPING_DIAGNOSIS_ASSIGNMENT_STEP_UNIT_ASSIGNMENT'
}

/** Diagnosis information relevant for grouping */
export type Billing_German_GroupingDiagnosisMsg = {
  __typename?: 'billing_german_GroupingDiagnosisMsg';
  aggregationSourceBillingCaseId?: Maybe<Scalars['String']>;
  assignments?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisAssignmentMsg>>>;
  /** CCL */
  clinicalComplexityLevel?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  diagnosisCodingGroupId?: Maybe<Scalars['String']>;
  /** this field records whether the diagnosis was actually used for grouping - it is set by the grouper (e.g. KODIP) */
  drgRelevant?: Maybe<Scalars['Boolean']>;
  /** eff. CCL */
  effectiveClinicalComplexityLevel?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisTag>>>;
  /** visit which the diagnosis belongs to */
  visitId?: Maybe<Scalars['String']>;
};

export enum Billing_German_GroupingDiagnosisTag {
  GroupingDiagnosisTagNone = 'GROUPING_DIAGNOSIS_TAG_NONE',
  GroupingDiagnosisTagSurgery = 'GROUPING_DIAGNOSIS_TAG_SURGERY'
}

export enum Billing_German_GroupingElementType {
  GroupingElementTypeBillingProcedure = 'GROUPING_ELEMENT_TYPE_BILLING_PROCEDURE',
  GroupingElementTypeDiagnosis = 'GROUPING_ELEMENT_TYPE_DIAGNOSIS',
  GroupingElementTypeNone = 'GROUPING_ELEMENT_TYPE_NONE'
}

export type Billing_German_HealthInsuranceBgCaseMsg = {
  __typename?: 'billing_german_HealthInsuranceBgCaseMsg';
  /** statutory insurer from DGUV stammdaten */
  dguvStatutoryInsurer?: Maybe<Billing_InsurerMsg>;
  insurerType?: Maybe<Billing_German_HealthInsuranceBgCaseType>;
};

export enum Billing_German_HealthInsuranceBgCaseType {
  HealthInsuranceBgCaseTypeNone = 'HEALTH_INSURANCE_BG_CASE_TYPE_NONE',
  HealthInsuranceBgCaseTypeOther = 'HEALTH_INSURANCE_BG_CASE_TYPE_OTHER',
  HealthInsuranceBgCaseTypePrivate = 'HEALTH_INSURANCE_BG_CASE_TYPE_PRIVATE',
  HealthInsuranceBgCaseTypeUnknown = 'HEALTH_INSURANCE_BG_CASE_TYPE_UNKNOWN'
}

export enum Billing_German_IcdCodeSearchCatalog {
  IcdCodeSearchCatalogGeneralPractitioner = 'ICD_CODE_SEARCH_CATALOG_GENERAL_PRACTITIONER',
  IcdCodeSearchCatalogNone = 'ICD_CODE_SEARCH_CATALOG_NONE',
  IcdCodeSearchCatalogSpecialistGroup = 'ICD_CODE_SEARCH_CATALOG_SPECIALIST_GROUP',
  IcdCodeSearchCatalogSystematic = 'ICD_CODE_SEARCH_CATALOG_SYSTEMATIC'
}

export type Billing_German_KeytabIdMsg = {
  __typename?: 'billing_german_KeytabIdMsg';
  code?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
};

export type Billing_German_LightGermanDiagnosisCodingMsg = {
  __typename?: 'billing_german_LightGermanDiagnosisCodingMsg';
  /** germanDiagnosisCoding.description */
  description?: Maybe<Scalars['String']>;
  diagnosisThesauruses?: Maybe<Array<Maybe<Scalars['String']>>>;
  icdCode?: Maybe<Scalars['String']>;
};

export type Billing_German_LinkBillingCertificateRequest = {
  __typename?: 'billing_german_LinkBillingCertificateRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListAsvTeamsRequest = {
  __typename?: 'billing_german_ListAsvTeamsRequest';
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  userId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListAsvTeamsResponse = {
  __typename?: 'billing_german_ListAsvTeamsResponse';
  teams?: Maybe<Array<Maybe<Billing_German_AsvTeamMsg>>>;
};

export type Billing_German_ListBillingCertificatesRequest = {
  __typename?: 'billing_german_ListBillingCertificatesRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListBillingCertificatesResponse = {
  __typename?: 'billing_german_ListBillingCertificatesResponse';
  billingCertificates?: Maybe<Array<Maybe<Billing_German_BillingCertificateMsg>>>;
};

export type Billing_German_ListBillingDaysRequest = {
  __typename?: 'billing_german_ListBillingDaysRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  /** if not supplied, today is used */
  date?: Maybe<Core_LocalDateMsg>;
};

export type Billing_German_ListBillingDaysResponse = {
  __typename?: 'billing_german_ListBillingDaysResponse';
  billingDays?: Maybe<Array<Maybe<Billing_German_BillingDayMsg>>>;
};

export type Billing_German_ListDiagnosisRuleChangesRequest = {
  __typename?: 'billing_german_ListDiagnosisRuleChangesRequest';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_ListDiagnosisRuleChangesResponse = {
  __typename?: 'billing_german_ListDiagnosisRuleChangesResponse';
  addedRules?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleMsg>>>;
  /** Set to true if the current version is the first one in the system */
  noPreviousVersion?: Maybe<Scalars['Boolean']>;
  removedRules?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleMsg>>>;
};

export type Billing_German_ListDiagnosisRulesRequest = {
  __typename?: 'billing_german_ListDiagnosisRulesRequest';
  /** optional filter */
  active?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  checkTiming?: Maybe<Billing_German_DiagnosisRuleCheckTiming>;
  /** optional filter */
  mandatory?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Billing_German_DiagnosisRuleOwnerReferenceMsg>;
  /** Optional: Set if pagination is desired */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  /** optional filter: if set, filters exact matches */
  ruleCode?: Maybe<Scalars['String']>;
  /** optional sort */
  summarySort?: Maybe<Helper_SortOrder>;
};

export type Billing_German_ListDiagnosisRulesResponse = {
  __typename?: 'billing_german_ListDiagnosisRulesResponse';
  /** number of search results (only relevant for paginated searches) */
  hitCount?: Maybe<Scalars['Int']>;
  rules?: Maybe<Array<Maybe<Billing_German_DiagnosisRuleMsg>>>;
};

export type Billing_German_ListEbmCodeFoldersRequest = {
  __typename?: 'billing_german_ListEbmCodeFoldersRequest';
  ebmCatalogId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListEbmCodeFoldersResponse = {
  __typename?: 'billing_german_ListEbmCodeFoldersResponse';
  ebmCodeFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
};

export type Billing_German_ListEbmKeytabsRequest = {
  __typename?: 'billing_german_ListEbmKeytabsRequest';
  groupId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListEbmKeytabsResponse = {
  __typename?: 'billing_german_ListEbmKeytabsResponse';
  keytabs?: Maybe<Array<Maybe<Billing_German_EbmKeytabMsg>>>;
};

export type Billing_German_ListGroupingDiagnosesRequest = {
  __typename?: 'billing_german_ListGroupingDiagnosesRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_German_ListGroupingDiagnosesResponse = {
  __typename?: 'billing_german_ListGroupingDiagnosesResponse';
  groupingDiagnoses?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisMsg>>>;
};

export type Billing_German_ListVentilationPeriodsRequest = {
  __typename?: 'billing_german_ListVentilationPeriodsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Billing_German_MedicalSpecializationMsg = {
  __typename?: 'billing_german_MedicalSpecializationMsg';
  id?: Maybe<Scalars['String']>;
  serviceAreaId?: Maybe<Scalars['String']>;
  specializationFieldId?: Maybe<Scalars['String']>;
};

export type Billing_German_PatientReceiptSettingsMsg = {
  __typename?: 'billing_german_PatientReceiptSettingsMsg';
  /** Punktwert (Cent) */
  pointValueCents?: Maybe<DecimalMsg>;
  /** Quotierung (%) */
  quota?: Maybe<DecimalMsg>;
};

export type Billing_German_PsychotherapyApprovalMsg = {
  __typename?: 'billing_german_PsychotherapyApprovalMsg';
  /** Datum Anerkennung [4235] */
  approvalDate?: Maybe<Timestamp>;
  /** Bewilligte Ziffern für den Versicherten [4253] */
  approvals?: Maybe<Array<Maybe<Billing_German_BillingCodeApprovalMsg>>>;
  /** Bewilligte Ziffern für die Bezugsperson [4256] */
  approvalsCompanion?: Maybe<Array<Maybe<Billing_German_BillingCodeApprovalMsg>>>;
  /** Gesamtanzahl bewilligter Einheiten Versicherter [4252] -> gets further specified in approvals */
  approvedTreatmentUnits?: Maybe<Scalars['Int']>;
  /** Gesamtanzahl bewilligter Einheiten Bezugsperson [4255] -> gets further specified in approvalsCompanion */
  approvedTreatmentUnitsCompanion?: Maybe<Scalars['Int']>;
  /** Kombinationsbehandlung [4250] */
  combinationTreatment?: Maybe<Scalars['Boolean']>;
  /** Art der Kombinationsbehandlung [4251] */
  combinationTreatmentPart?: Maybe<Billing_German_PsychotherapyTreatmentPart>;
  id?: Maybe<Scalars['String']>;
  /** Begründung gegenüber der Krankenkasse */
  pauseReportedToInsurer?: Maybe<Scalars['Boolean']>;
  /** Therapie pausieren */
  pauseTherapy?: Maybe<Scalars['Boolean']>;
  /** Zeitraum - time frame for which the therapy is paused */
  pauseTimeFrame?: Maybe<TimeFrameMsg>;
  /** LANR des Vertragspsychotherapeuten [4299] */
  psychotherapistLanr?: Maybe<Scalars['String']>;
  /** Antragsdatum [4247] */
  requestDate?: Maybe<Timestamp>;
  /** If true, means that the connected psychotherapy is finished and is not considered in approval remainder calculations */
  terminated?: Maybe<Scalars['Boolean']>;
  /** Krankenkasse gesondert über Beendigung informiert */
  terminationReportedToInsurer?: Maybe<Scalars['Boolean']>;
  /** Abgerechnete Einheiten Versicherter -> calculated by backend */
  usedTreatmentUnits?: Maybe<Scalars['Int']>;
  /** Abgerechnete Einheiten Bezugsperson -> calculated by backend */
  usedTreatmentUnitsCompanion?: Maybe<Scalars['Int']>;
};

export type Billing_German_PsychotherapyApprovalWarningMsg = {
  __typename?: 'billing_german_PsychotherapyApprovalWarningMsg';
  billingCertificateId?: Maybe<Scalars['String']>;
  hints?: Maybe<Array<Maybe<Billing_German_PsychotherapyCodingHint>>>;
};

export enum Billing_German_PsychotherapyCodingHint {
  PsychotherapyCodingHintAdd_88130 = 'PSYCHOTHERAPY_CODING_HINT_ADD_88130',
  PsychotherapyCodingHintAdd_88130Or_88131 = 'PSYCHOTHERAPY_CODING_HINT_ADD_88130_OR_88131',
  PsychotherapyCodingHintAdd_88131 = 'PSYCHOTHERAPY_CODING_HINT_ADD_88131',
  PsychotherapyCodingHintNone = 'PSYCHOTHERAPY_CODING_HINT_NONE'
}

export type Billing_German_PsychotherapyRecurrencePreventionEbmCodeMsg = {
  __typename?: 'billing_german_PsychotherapyRecurrencePreventionEbmCodeMsg';
  ebmCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Billing_German_PsychotherapyTreatmentPart {
  /** Alleinige Durchführung mit überwiegend Gruppentherapie (FK 4251 = 2) */
  PsychotherapyTreatmentPartGroupOnePractitoner = 'PSYCHOTHERAPY_TREATMENT_PART_GROUP_ONE_PRACTITONER',
  /** Gruppentherapie-Anteil bei Durchführung durch zwei Therapeuten (FK 4251 = 4) */
  PsychotherapyTreatmentPartGroupTwoPractitioners = 'PSYCHOTHERAPY_TREATMENT_PART_GROUP_TWO_PRACTITIONERS',
  /** Alleinige Durchführung mit überwiegend Einzeltherapie (FK 4251 = 1) */
  PsychotherapyTreatmentPartIndividualOnePractitioner = 'PSYCHOTHERAPY_TREATMENT_PART_INDIVIDUAL_ONE_PRACTITIONER',
  /** Einzeltherapie-Anteil bei Durchführung durch zwei Therapeuten (FK 4251 = 3) */
  PsychotherapyTreatmentPartIndividualTwoPractitoners = 'PSYCHOTHERAPY_TREATMENT_PART_INDIVIDUAL_TWO_PRACTITONERS',
  PsychotherapyTreatmentPartNone = 'PSYCHOTHERAPY_TREATMENT_PART_NONE'
}

export type Billing_German_PutEbmCodeFolderRequest = {
  __typename?: 'billing_german_PutEbmCodeFolderRequest';
  ebmCodeFolder?: Maybe<Billing_German_EbmCodeFolderMsg>;
};

export type Billing_German_PutEbmCodeFolderResponse = {
  __typename?: 'billing_german_PutEbmCodeFolderResponse';
  ebmCodeFolder?: Maybe<Billing_German_EbmCodeFolderMsg>;
};

export type Billing_German_PutEbmCodeFoldersRequest = {
  __typename?: 'billing_german_PutEbmCodeFoldersRequest';
  ebmCodeFolder?: Maybe<Billing_German_EbmCodeFolderMsg>;
};

export type Billing_German_PutEbmCodeFoldersResponse = {
  __typename?: 'billing_german_PutEbmCodeFoldersResponse';
  ebmCodeFolder?: Maybe<Billing_German_EbmCodeFolderMsg>;
  transactionCommitted?: Maybe<Billing_German_PutEbmCodeFoldersResponse_TransactionCommittedEvent>;
  transactionStarted?: Maybe<Billing_German_PutEbmCodeFoldersResponse_TransactionStartedEvent>;
};

export type Billing_German_PutEbmCodeFoldersResponse_TransactionCommittedEvent = {
  __typename?: 'billing_german_PutEbmCodeFoldersResponse_TransactionCommittedEvent';
  _?: Maybe<Scalars['String']>;
};

export type Billing_German_PutEbmCodeFoldersResponse_TransactionStartedEvent = {
  __typename?: 'billing_german_PutEbmCodeFoldersResponse_TransactionStartedEvent';
  _?: Maybe<Scalars['String']>;
};

export enum Billing_German_RingTestCertificateAvailability {
  /** German "Zertifikat vorhanden" */
  RingTestCertificateAvailabilityCertificate = 'RING_TEST_CERTIFICATE_AVAILABILITY_CERTIFICATE',
  RingTestCertificateAvailabilityNone = 'RING_TEST_CERTIFICATE_AVAILABILITY_NONE',
  /** German "Zertifikat nicht vorhanden" */
  RingTestCertificateAvailabilityNoCertificate = 'RING_TEST_CERTIFICATE_AVAILABILITY_NO_CERTIFICATE',
  /** German "pnSD/uu" */
  RingTestCertificateAvailabilitySingleUseReagent = 'RING_TEST_CERTIFICATE_AVAILABILITY_SINGLE_USE_REAGENT'
}

/** Joined through rejoiner, comes from S_NVV_RV_ZERTIFIKAT (OID: 1.2.276.0.76.3.1.1.5.2.22 ) */
export type Billing_German_RingTestCertificateDetailsMsg = {
  __typename?: 'billing_german_RingTestCertificateDetailsMsg';
  analyteCode?: Maybe<Scalars['String']>;
  analyteName?: Maybe<Scalars['String']>;
  ebmCode?: Maybe<Scalars['String']>;
  materialCode?: Maybe<Scalars['String']>;
  materialName?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameMsg>;
};

export type Billing_German_RingTestCertificateMsg = {
  __typename?: 'billing_german_RingTestCertificateMsg';
  /** S_NVV_RV_ZERTIFIKAT (OID: 1.2.276.0.76.3.1.1.5.2.22 ) */
  analyteCode?: Maybe<Scalars['String']>;
  availability?: Maybe<Billing_German_RingTestCertificateAvailability>;
  id?: Maybe<Scalars['String']>;
};

export type Billing_German_SearchAsvTeamsRequest = {
  __typename?: 'billing_german_SearchAsvTeamsRequest';
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  text?: Maybe<Scalars['String']>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Billing_German_SearchAsvTeamsResponse = {
  __typename?: 'billing_german_SearchAsvTeamsResponse';
  asvTeams?: Maybe<Array<Maybe<Billing_German_AsvTeamMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Billing_German_SearchCodeRecordsRequest = {
  __typename?: 'billing_german_SearchCodeRecordsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  billingCertificateId?: Maybe<Scalars['String']>;
  catalogContext?: Maybe<Catalog_CatalogQueryContextMsg>;
  catalogId?: Maybe<Scalars['String']>;
  overrideUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Billing_German_SearchCodeRecordsResponse = {
  __typename?: 'billing_german_SearchCodeRecordsResponse';
  catalogId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<Billing_German_CodeRecordSearchResultMsg>>>;
};

export type Billing_German_SearchGroupPsychotherapyCodesRequest = {
  __typename?: 'billing_german_SearchGroupPsychotherapyCodesRequest';
  searchText?: Maybe<Scalars['String']>;
};

export type Billing_German_TiActivationSettingsMsg = {
  __typename?: 'billing_german_TiActivationSettingsMsg';
  cardTerminalActive?: Maybe<Scalars['Boolean']>;
  eArztbriefActive?: Maybe<Scalars['Boolean']>;
  eAuActive?: Maybe<Scalars['Boolean']>;
  eHbaActive?: Maybe<Scalars['Boolean']>;
  eMpActive?: Maybe<Scalars['Boolean']>;
  ePaSupport?: Maybe<Billing_German_EPaSupport>;
  ePrescriptionActive?: Maybe<Scalars['Boolean']>;
  kimActive?: Maybe<Scalars['Boolean']>;
  nfdmActive?: Maybe<Scalars['Boolean']>;
  smcBActive?: Maybe<Scalars['Boolean']>;
};

export type Billing_German_TimeContextMsg = {
  __typename?: 'billing_german_TimeContextMsg';
  timeContextId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Billing_German_UnassignBillingDiagnosisCodingIdRequest = {
  __typename?: 'billing_german_UnassignBillingDiagnosisCodingIdRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  diagnosisCodingId?: Maybe<Billing_German_BillingDiagnosisCodingIdMsg>;
};

export type Billing_German_UnassignBillingDiagnosisCodingIdResponse = {
  __typename?: 'billing_german_UnassignBillingDiagnosisCodingIdResponse';
  diagnosisCodingIds?: Maybe<Array<Maybe<Billing_German_BillingDiagnosisCodingIdMsg>>>;
};

export type Billing_German_UnassignGroupingDiagnosisRequest = {
  __typename?: 'billing_german_UnassignGroupingDiagnosisRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  /** optional; if set, clears all tags of the grouping diagnosis; by default only clears main tag and main department assignments */
  clearTags?: Maybe<Scalars['Boolean']>;
  groupingDiagnosisId?: Maybe<Scalars['String']>;
};

export type Billing_German_UnassignGroupingDiagnosisResponse = {
  __typename?: 'billing_german_UnassignGroupingDiagnosisResponse';
  deletedGroupingDiagnosisId?: Maybe<Scalars['String']>;
};

export type Billing_German_UpdateAsvTeamRequest = {
  __typename?: 'billing_german_UpdateAsvTeamRequest';
  asvTeam?: Maybe<Billing_German_AsvTeamMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateBillingCertificateRequest = {
  __typename?: 'billing_german_UpdateBillingCertificateRequest';
  billingCertificate?: Maybe<Billing_German_BillingCertificateMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateBillingPositionDaySeparationRequest = {
  __typename?: 'billing_german_UpdateBillingPositionDaySeparationRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  date?: Maybe<Core_LocalDateMsg>;
};

export type Billing_German_UpdateBillingPositionDaySeparationResponse = {
  __typename?: 'billing_german_UpdateBillingPositionDaySeparationResponse';
  billingDays?: Maybe<Array<Maybe<Billing_German_BillingDayMsg>>>;
  date?: Maybe<Core_LocalDateMsg>;
};

export type Billing_German_UpdateBillingSettingsRequest = {
  __typename?: 'billing_german_UpdateBillingSettingsRequest';
  billingSettings?: Maybe<Billing_German_BillingSettingsMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateDiagnosisRuleRequest = {
  __typename?: 'billing_german_UpdateDiagnosisRuleRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  rule?: Maybe<Billing_German_DiagnosisRuleMsg>;
};

export type Billing_German_UpdateEbmRecordRequest = {
  __typename?: 'billing_german_UpdateEbmRecordRequest';
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateEbmRecordResponse = {
  __typename?: 'billing_german_UpdateEbmRecordResponse';
  affectedFolders?: Maybe<Array<Maybe<Billing_German_EbmCodeFolderMsg>>>;
  ebmCodeRecord?: Maybe<Billing_German_EbmCodeRecordMsg>;
};

export type Billing_German_UpdateGermanIcdCodeExceptionConfigRequest = {
  __typename?: 'billing_german_UpdateGermanIcdCodeExceptionConfigRequest';
  /**
   * one of U07.1, U07.2 or U99.0
   *  adds current user to list of users that skip the warning
   */
  icdCode?: Maybe<Scalars['String']>;
};

export type Billing_German_UpdateGermanLabBillingConfigRequest = {
  __typename?: 'billing_german_UpdateGermanLabBillingConfigRequest';
  germanLabBillingConfig?: Maybe<Billing_German_GermanLabBillingConfigMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateGoaeCodeRecordRequest = {
  __typename?: 'billing_german_UpdateGoaeCodeRecordRequest';
  goaeCodeRecord?: Maybe<Billing_German_GoaeCodeRecordMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateGroupingDataRequest = {
  __typename?: 'billing_german_UpdateGroupingDataRequest';
  /** only grouping diagnoses with one of these coding group ids will be used for validation */
  diagnosisCodingGroupIdsForValidationCheck?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  groupingData?: Maybe<Billing_German_GroupingDataMsg>;
  /** Only allowed from gateway service */
  ignoreLock?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateGroupingDiagnosisRequest = {
  __typename?: 'billing_german_UpdateGroupingDiagnosisRequest';
  groupingDiagnosis?: Maybe<Billing_German_GroupingDiagnosisMsg>;
  ignoreValidation?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Billing_German_UpdateGroupingDiagnosisResponse = {
  __typename?: 'billing_german_UpdateGroupingDiagnosisResponse';
  groupingDiagnosis?: Maybe<Billing_German_GroupingDiagnosisMsg>;
  modifiedGroupingDiagnoses?: Maybe<Array<Maybe<Billing_German_GroupingDiagnosisMsg>>>;
  validationErrors?: Maybe<Array<Maybe<Billing_German_GroupingDataValidationError>>>;
};

export type Billing_German_UpdateVentilationPauseRequest = {
  __typename?: 'billing_german_UpdateVentilationPauseRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  ventilationPause?: Maybe<Billing_German_VentilationPauseMsg>;
};

export type Billing_German_UpdateVentilationPauseResponse = {
  __typename?: 'billing_german_UpdateVentilationPauseResponse';
  totalActualDuration?: Maybe<Scalars['Int']>;
  totalBillableDuration?: Maybe<Scalars['Int']>;
  ventilationPeriod?: Maybe<Billing_German_VentilationPeriodMsg>;
};

export type Billing_German_UpdateVentilationPeriodRequest = {
  __typename?: 'billing_german_UpdateVentilationPeriodRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  ventilationPeriod?: Maybe<Billing_German_VentilationPeriodMsg>;
};

export type Billing_German_UpdateVentilationPeriodResponse = {
  __typename?: 'billing_german_UpdateVentilationPeriodResponse';
  totalActualDuration?: Maybe<Scalars['Int']>;
  totalBillableDuration?: Maybe<Scalars['Int']>;
  ventilationPeriod?: Maybe<Billing_German_VentilationPeriodMsg>;
};

export type Billing_German_UvGoaeCodePricingMsg = {
  __typename?: 'billing_german_UvGoaeCodePricingMsg';
  pricingUnit?: Maybe<Billing_ValueUnitType>;
  pricingValue?: Maybe<Scalars['Int']>;
};

export type Billing_German_UvGoaeCodeRecordMsg = {
  __typename?: 'billing_german_UvGoaeCodeRecordMsg';
  additionalDescription?: Maybe<Scalars['String']>;
  catalogId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  edqNumber?: Maybe<Scalars['Int']>;
  generalCost?: Maybe<Billing_Money>;
  materialCost?: Maybe<Billing_Money>;
  medicalTreatmentGeneralCost?: Maybe<Billing_Money>;
  medicalTreatmentSpecialCost?: Maybe<Billing_Money>;
  shortDescription?: Maybe<Scalars['String']>;
  specialCostForPhysicians?: Maybe<Billing_Money>;
  specialCostHospitals?: Maybe<Billing_Money>;
};

export type Billing_German_ValidatePsychotherapyApprovalRequest = {
  __typename?: 'billing_german_ValidatePsychotherapyApprovalRequest';
  billingQuarter?: Maybe<PrecisionTimestampMsg>;
  codeReference?: Maybe<Billing_BillingCodeReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
};

export type Billing_German_ValidatePsychotherapyApprovalResponse = {
  __typename?: 'billing_german_ValidatePsychotherapyApprovalResponse';
  codingHint?: Maybe<Billing_German_PsychotherapyCodingHint>;
};

export type Billing_German_ValidatePsychotherapyApprovalsRequest = {
  __typename?: 'billing_german_ValidatePsychotherapyApprovalsRequest';
  billingQuarter?: Maybe<PrecisionTimestampMsg>;
};

export type Billing_German_ValidatePsychotherapyApprovalsResponse = {
  __typename?: 'billing_german_ValidatePsychotherapyApprovalsResponse';
  warnings?: Maybe<Array<Maybe<Billing_German_PsychotherapyApprovalWarningMsg>>>;
};

export type Billing_German_ValidityTimespanMsg = {
  __typename?: 'billing_german_ValidityTimespanMsg';
  effectiveEnd?: Maybe<Timestamp>;
  effectiveStart?: Maybe<Timestamp>;
  serviceEnd?: Maybe<Timestamp>;
  serviceStart?: Maybe<Timestamp>;
};

/** Wrapper for vatOptions list, as repeated DecimalMsg cannot be handled by rejoiner */
export type Billing_German_VatPercentageMsg = {
  __typename?: 'billing_german_VatPercentageMsg';
  percentage?: Maybe<DecimalMsg>;
};

export type Billing_German_VentilationOverviewMsg = {
  __typename?: 'billing_german_VentilationOverviewMsg';
  id?: Maybe<Scalars['String']>;
  /** Duration in minutes */
  totalActualVentilationDuration?: Maybe<Scalars['Int']>;
  /** Duration in minutes */
  totalBillableVentilationDuration?: Maybe<Scalars['Int']>;
  ventilationPeriods?: Maybe<Array<Maybe<Billing_German_VentilationPeriodMsg>>>;
};

export type Billing_German_VentilationPauseMsg = {
  __typename?: 'billing_german_VentilationPauseMsg';
  end?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  start?: Maybe<Timestamp>;
};

export type Billing_German_VentilationPeriodMsg = {
  __typename?: 'billing_german_VentilationPeriodMsg';
  actualDuration?: Maybe<Scalars['Int']>;
  billable?: Maybe<Scalars['Boolean']>;
  billableDuration?: Maybe<Scalars['Int']>;
  billableDurationManuallySet?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Timestamp>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intraoperative?: Maybe<Scalars['Boolean']>;
  modeOfVentilation?: Maybe<Core_KnowledgeInputMsg>;
  start?: Maybe<Timestamp>;
  ventilationPauses?: Maybe<Array<Maybe<Billing_German_VentilationPauseMsg>>>;
};

export type Billing_Omim_CreateOrUpdateCatalogStreamRequest = {
  __typename?: 'billing_omim_CreateOrUpdateCatalogStreamRequest';
  catalogId?: Maybe<Scalars['String']>;
  gCode?: Maybe<Billing_Omim_GCodeMsg>;
  /** Bulk upsert */
  gCodeList?: Maybe<Billing_Omim_GCodeList>;
  mapping?: Maybe<Billing_Omim_CreateOrUpdateCatalogStreamRequest_Mapping>;
  pCode?: Maybe<Billing_Omim_PCodeMsg>;
  /** Bulk upsert */
  pCodeList?: Maybe<Billing_Omim_PCodeList>;
};

export type Billing_Omim_CreateOrUpdateCatalogStreamRequest_Mapping = {
  __typename?: 'billing_omim_CreateOrUpdateCatalogStreamRequest_Mapping';
  gCodeId?: Maybe<Scalars['String']>;
  pCodeId?: Maybe<Scalars['String']>;
};

export type Billing_Omim_CreateOrUpdateCatalogStreamResponse = {
  __typename?: 'billing_omim_CreateOrUpdateCatalogStreamResponse';
  catalogId?: Maybe<Scalars['String']>;
  gCode?: Maybe<Billing_Omim_GCodeMsg>;
  gCodeList?: Maybe<Billing_Omim_GCodeList>;
  mapping?: Maybe<Billing_Omim_CreateOrUpdateCatalogStreamResponse_Mapping>;
  pCode?: Maybe<Billing_Omim_PCodeMsg>;
  pCodeList?: Maybe<Billing_Omim_PCodeList>;
};

export type Billing_Omim_CreateOrUpdateCatalogStreamResponse_Mapping = {
  __typename?: 'billing_omim_CreateOrUpdateCatalogStreamResponse_Mapping';
  gCode?: Maybe<Billing_Omim_GCodeMsg>;
  pCode?: Maybe<Billing_Omim_PCodeMsg>;
};

export type Billing_Omim_GCodeList = {
  __typename?: 'billing_omim_GCodeList';
  gCodes?: Maybe<Array<Maybe<Billing_Omim_GCodeMsg>>>;
};

export type Billing_Omim_GCodeMsg = {
  __typename?: 'billing_omim_GCodeMsg';
  catalogId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  geneName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFreeText?: Maybe<Scalars['Boolean']>;
  prefix?: Maybe<Billing_Omim_PrefixG>;
};

export type Billing_Omim_GetLatestCatalogRequest = {
  __typename?: 'billing_omim_GetLatestCatalogRequest';
  billingCertificateId?: Maybe<Scalars['String']>;
  catalogNumber?: Maybe<Scalars['Int']>;
  quarter?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Billing_Omim_GetLatestCatalogResponse = {
  __typename?: 'billing_omim_GetLatestCatalogResponse';
  catalog?: Maybe<Catalog_CatalogMsg>;
};

export type Billing_Omim_PCodeList = {
  __typename?: 'billing_omim_PCodeList';
  pCodes?: Maybe<Array<Maybe<Billing_Omim_PCodeMsg>>>;
};

export type Billing_Omim_PCodeMsg = {
  __typename?: 'billing_omim_PCodeMsg';
  catalogId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFreeText?: Maybe<Scalars['Boolean']>;
  phenotype?: Maybe<Scalars['String']>;
  prefix?: Maybe<Billing_Omim_PrefixP>;
};

export enum Billing_Omim_PrefixG {
  PrefixGAsterisk = 'PREFIX_G_ASTERISK',
  PrefixGNone = 'PREFIX_G_NONE',
  PrefixGPlus = 'PREFIX_G_PLUS'
}

export enum Billing_Omim_PrefixP {
  PrefixPHash = 'PREFIX_P_HASH',
  PrefixPNone = 'PREFIX_P_NONE'
}

export type Billing_Omim_SearchGCodesRequest = {
  __typename?: 'billing_omim_SearchGCodesRequest';
  catalogContext?: Maybe<Catalog_CatalogQueryContextMsg>;
  query?: Maybe<Scalars['String']>;
  /** Set if p code is already selected */
  selectedPCodeId?: Maybe<Scalars['String']>;
};

export type Billing_Omim_SearchGCodesResponse = {
  __typename?: 'billing_omim_SearchGCodesResponse';
  gCodes?: Maybe<Array<Maybe<Billing_Omim_GCodeMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Billing_Omim_SearchPCodesRequest = {
  __typename?: 'billing_omim_SearchPCodesRequest';
  catalogContext?: Maybe<Catalog_CatalogQueryContextMsg>;
  query?: Maybe<Scalars['String']>;
  /** Set if g code is already selected */
  selectedGCodeId?: Maybe<Scalars['String']>;
};

export type Billing_Omim_SearchPCodesResponse = {
  __typename?: 'billing_omim_SearchPCodesResponse';
  hitCount?: Maybe<Scalars['Int']>;
  pCodes?: Maybe<Array<Maybe<Billing_Omim_PCodeMsg>>>;
};

export type Catalog_AcknowledgeCatalogUpdateRequest = {
  __typename?: 'catalog_AcknowledgeCatalogUpdateRequest';
  catalogId?: Maybe<Scalars['String']>;
};

export type Catalog_CatalogMsg = {
  __typename?: 'catalog_CatalogMsg';
  /** Some catalogs need updates need to be manually acknowledged */
  acknowledgementRequired?: Maybe<Scalars['Boolean']>;
  /** All catalogs must offer a combined identifier of their version */
  combinedVersionId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
  /** Identifies the region for which this catalog applies */
  regionIdentifier?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Timestamp>;
  status?: Maybe<Catalog_CatalogStatus>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Catalog_CatalogType>;
  /** If users can override/overlay contents of the catalog */
  userOverrideAllowed?: Maybe<Scalars['Boolean']>;
  /** no validity set defaults to always */
  validity?: Maybe<TimeFrameMsg>;
  /** Will be set to true once catalog update has been acknowledged */
  versionAcknowledged?: Maybe<Scalars['Boolean']>;
  /** Optional, typically a more human-friendly way of showing the version */
  versionDisplayName?: Maybe<Scalars['String']>;
};

export type Catalog_CatalogQueryContextMsg = {
  __typename?: 'catalog_CatalogQueryContextMsg';
  combinedVersionId?: Maybe<Scalars['String']>;
  /** The point in time that is matched to find the correct catalog with validity between */
  referenceTimePoint?: Maybe<Timestamp>;
  regionIdentifier?: Maybe<Scalars['String']>;
  /** show inactive catalogs */
  showInactive?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Catalog_CatalogType>;
};

export enum Catalog_CatalogStatus {
  CatalogStatusActive = 'CATALOG_STATUS_ACTIVE',
  CatalogStatusInactive = 'CATALOG_STATUS_INACTIVE',
  CatalogStatusLoading = 'CATALOG_STATUS_LOADING',
  CatalogStatusNone = 'CATALOG_STATUS_NONE',
  CatalogStatusPendingIndexing = 'CATALOG_STATUS_PENDING_INDEXING'
}

export enum Catalog_CatalogType {
  CatalogTypeGermanArgeIkInsurer = 'CATALOG_TYPE_GERMAN_ARGE_IK_INSURER',
  CatalogTypeGermanCareBass = 'CATALOG_TYPE_GERMAN_CARE_BASS',
  CatalogTypeGermanCareEnpGoal = 'CATALOG_TYPE_GERMAN_CARE_ENP_GOAL',
  CatalogTypeGermanCareEnpIntervention = 'CATALOG_TYPE_GERMAN_CARE_ENP_INTERVENTION',
  CatalogTypeGermanCareEpaAc = 'CATALOG_TYPE_GERMAN_CARE_EPA_AC',
  CatalogTypeGermanCareLep = 'CATALOG_TYPE_GERMAN_CARE_LEP',
  CatalogTypeGermanCareNanda = 'CATALOG_TYPE_GERMAN_CARE_NANDA',
  CatalogTypeGermanCarePpr = 'CATALOG_TYPE_GERMAN_CARE_PPR',
  CatalogTypeGermanDguvGkvInsurer = 'CATALOG_TYPE_GERMAN_DGUV_GKV_INSURER',
  CatalogTypeGermanDguvGkvInsurerHistory = 'CATALOG_TYPE_GERMAN_DGUV_GKV_INSURER_HISTORY',
  CatalogTypeGermanDguvInsurer = 'CATALOG_TYPE_GERMAN_DGUV_INSURER',
  CatalogTypeGermanDguvInsurerHistory = 'CATALOG_TYPE_GERMAN_DGUV_INSURER_HISTORY',
  CatalogTypeGermanDrvInsurer = 'CATALOG_TYPE_GERMAN_DRV_INSURER',
  CatalogTypeGermanEbm = 'CATALOG_TYPE_GERMAN_EBM',
  CatalogTypeGermanGoae = 'CATALOG_TYPE_GERMAN_GOAE',
  CatalogTypeGermanIcd10Gm = 'CATALOG_TYPE_GERMAN_ICD10_GM',
  CatalogTypeGermanKvAhexCodingTable = 'CATALOG_TYPE_GERMAN_KV_AHEX_CODING_TABLE',
  CatalogTypeGermanKvBillingRegions = 'CATALOG_TYPE_GERMAN_KV_BILLING_REGIONS',
  CatalogTypeGermanKvBillingRules = 'CATALOG_TYPE_GERMAN_KV_BILLING_RULES',
  CatalogTypeGermanKvIcd_10Warnings = 'CATALOG_TYPE_GERMAN_KV_ICD_10_WARNINGS',
  CatalogTypeGermanKvInsurer = 'CATALOG_TYPE_GERMAN_KV_INSURER',
  CatalogTypeGermanKvPostalCodes = 'CATALOG_TYPE_GERMAN_KV_POSTAL_CODES',
  CatalogTypeGermanKvSpecificMaster = 'CATALOG_TYPE_GERMAN_KV_SPECIFIC_MASTER',
  CatalogTypeGermanMmi = 'CATALOG_TYPE_GERMAN_MMI',
  CatalogTypeGermanOmim = 'CATALOG_TYPE_GERMAN_OMIM',
  CatalogTypeGermanOps = 'CATALOG_TYPE_GERMAN_OPS',
  CatalogTypeGermanPkvInsurer = 'CATALOG_TYPE_GERMAN_PKV_INSURER',
  CatalogTypeGermanUvGoae = 'CATALOG_TYPE_GERMAN_UV_GOAE',
  CatalogTypeNone = 'CATALOG_TYPE_NONE'
}

export type Catalog_CreateCatalogRequest = {
  __typename?: 'catalog_CreateCatalogRequest';
  catalog?: Maybe<Catalog_CatalogMsg>;
};

export type Catalog_CreateCatalogResponse = {
  __typename?: 'catalog_CreateCatalogResponse';
  catalog?: Maybe<Catalog_CatalogMsg>;
};

export type Catalog_FindCatalogsRequest = {
  __typename?: 'catalog_FindCatalogsRequest';
  catalogContext?: Maybe<Catalog_CatalogQueryContextMsg>;
};

export type Catalog_FindCatalogsResponse = {
  __typename?: 'catalog_FindCatalogsResponse';
  catalogs?: Maybe<Array<Maybe<Catalog_CatalogMsg>>>;
};

export type Catalog_SetCatalogStatusRequest = {
  __typename?: 'catalog_SetCatalogStatusRequest';
  catalogId?: Maybe<Scalars['String']>;
  newStatus?: Maybe<Catalog_CatalogStatus>;
  /** these catalogs end when the new catalog begins. */
  precedingCatalogIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** no longer active these catalogs are replaced by new catalog and are not available any longer */
  supersededCatalogIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A group of categories of a categorical system
 *  Example: "positive" is a CategoryGroup, with categories "positive", "positive (some)", "positive (many)"
 */
export type Category_CategoryGroupMsg = {
  __typename?: 'category_CategoryGroupMsg';
  categories?: Maybe<Array<Maybe<Category_CategoryMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** One specific category of a categorical system */
export type Category_CategoryMsg = {
  __typename?: 'category_CategoryMsg';
  /** for result categories: whether this category is conspicuous */
  conspicuous?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** if set, can be used as displayed text in frontend */
  shortKey?: Maybe<Scalars['String']>;
  /** whether this category is the default value of its CategorySystem */
  systemDefault?: Maybe<Scalars['Boolean']>;
};

export type Category_CategorySystemList = {
  __typename?: 'category_CategorySystemList';
  categorySystems?: Maybe<Array<Maybe<Category_CategorySystemMsg>>>;
};

/** A categorical system in which some parameter can be categorized */
export type Category_CategorySystemMsg = {
  __typename?: 'category_CategorySystemMsg';
  /** only one out of (categories, categoryGroups) is set */
  categories?: Maybe<Array<Maybe<Category_CategoryMsg>>>;
  /** only one out of (categories, categoryGroups) is set */
  categoryGroups?: Maybe<Array<Maybe<Category_CategoryGroupMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** name as displayed when saving space is required, e.g., on small labels */
  shortName?: Maybe<Scalars['String']>;
};

/**
 * A group of categories of a categorical system
 *  Example: "positive" is a CategoryGroup, with categories "positive", "positive (some)", "positive (many)"
 */
export type Category_ResultCategoryGroupMsg = {
  __typename?: 'category_ResultCategoryGroupMsg';
  categories?: Maybe<Array<Maybe<Category_ResultCategoryMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** One specific category of a categorical system */
export type Category_ResultCategoryMsg = {
  __typename?: 'category_ResultCategoryMsg';
  conspicuous?: Maybe<Scalars['Boolean']>;
  /** Set true if the referenceRange is created ad-hoc instead of pre-defined */
  customCategory?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** if set, can be used as displayed text in frontend */
  shortKey?: Maybe<Scalars['String']>;
  /** whether this category is the default value of its CategorySystem */
  systemDefault?: Maybe<Scalars['Boolean']>;
};

/** A categorical system in which some parameter can be categorized */
export type Category_ResultCategorySystemMsg = {
  __typename?: 'category_ResultCategorySystemMsg';
  /** only one out of (categories, categoryGroups) is set */
  categories?: Maybe<Array<Maybe<Category_ResultCategoryMsg>>>;
  /** only one out of (categories, categoryGroups) is set */
  categoryGroups?: Maybe<Array<Maybe<Category_ResultCategoryGroupMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** name as displayed when saving space is required, e.g., on small labels */
  shortName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_AddClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_AddClinicalRequestInputRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_AddClinicalRequestTemplateToFavoritesRequest = {
  __typename?: 'clinicalrequest_AddClinicalRequestTemplateToFavoritesRequest';
  clinicalRequestTemplateId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_AddCustomClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_AddCustomClinicalRequestInputRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  inputType?: Maybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Clinicalrequest_BlockPathMsg = {
  __typename?: 'clinicalrequest_BlockPathMsg';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Clinicalrequest_CalculateAppointmentDurationsElementMsg = {
  __typename?: 'clinicalrequest_CalculateAppointmentDurationsElementMsg';
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** In minutes */
  duration?: Maybe<Scalars['Int']>;
  /** If not true, use the appointment type's standard duration */
  hasDuration?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_CalculateAppointmentDurationsRequest = {
  __typename?: 'clinicalrequest_CalculateAppointmentDurationsRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_CalculateAppointmentDurationsResponse = {
  __typename?: 'clinicalrequest_CalculateAppointmentDurationsResponse';
  results?: Maybe<Array<Maybe<Clinicalrequest_CalculateAppointmentDurationsElementMsg>>>;
};

export type Clinicalrequest_CancelClinicalRequestRequest = {
  __typename?: 'clinicalrequest_CancelClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ChangeClinicalRequestInputVisibilityRequest = {
  __typename?: 'clinicalrequest_ChangeClinicalRequestInputVisibilityRequest';
  changeReason?: Maybe<Scalars['String']>;
  clinicalRequestInputId?: Maybe<Scalars['String']>;
  customClinicalRequestInputId?: Maybe<Scalars['String']>;
  /**
   * set true when hiding an input
   *  not set when reactivating a hidden input
   */
  hide?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_ChangeClinicalRequestInputVisibilityResponse = {
  __typename?: 'clinicalrequest_ChangeClinicalRequestInputVisibilityResponse';
  clinicalRequestInput?: Maybe<Clinicalrequest_ClinicalRequestInputMsg>;
  customClinicalRequestInput?: Maybe<Clinicalrequest_CustomClinicalRequestInputMsg>;
};

export type Clinicalrequest_ClinicalRequestActionMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg';
  actionTime?: Maybe<Timestamp>;
  actionType?: Maybe<Clinicalrequest_ClinicalRequestActionType>;
  addInputAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_AddInputAction>;
  cancelRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_CancelRequestAction>;
  createRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_CreateRequestAction>;
  finishRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_FinishRequestAction>;
  id?: Maybe<Scalars['String']>;
  rejectRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_RejectRequestAction>;
  removeInputAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_RemoveInputAction>;
  reprioritizeRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_ReprioritizeRequestAction>;
  submitRequestAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_SubmitRequestAction>;
  updateInputContentAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_UpdateInputContentAction>;
  updateInputDocumentTypeAction?: Maybe<Clinicalrequest_ClinicalRequestActionMsg_UpdateInputDocumentTypeAction>;
  userReference?: Maybe<Core_UserReferenceMsg>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_AddInputAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_AddInputAction';
  clinicalRequestInputId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_CancelRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_CancelRequestAction';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_CreateRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_CreateRequestAction';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_FinishRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_FinishRequestAction';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_RejectRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_RejectRequestAction';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_RemoveInputAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_RemoveInputAction';
  clinicalRequestInputId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_ReprioritizeRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_ReprioritizeRequestAction';
  fromCustomPriorityLevel?: Maybe<Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  fromStandardPriorityLevel?: Maybe<Clinicalrequest_PriorityLevel>;
  priorityLevelType?: Maybe<Clinicalrequest_ClinicalRequestPriorityLevelType>;
  reasonForReprioritization?: Maybe<Scalars['String']>;
  toCustomPriorityLevel?: Maybe<Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  toStandardPriorityLevel?: Maybe<Clinicalrequest_PriorityLevel>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_SubmitRequestAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_SubmitRequestAction';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_UpdateInputContentAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_UpdateInputContentAction';
  clinicalRequestInputId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestActionMsg_UpdateInputDocumentTypeAction = {
  __typename?: 'clinicalrequest_ClinicalRequestActionMsg_UpdateInputDocumentTypeAction';
  clinicalRequestInputId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fromDocumentType?: Maybe<Document_DocumentTypeMsg>;
  toDocumentType?: Maybe<Document_DocumentTypeMsg>;
};

export enum Clinicalrequest_ClinicalRequestActionType {
  ClinicalRequestActionTypeAddInput = 'CLINICAL_REQUEST_ACTION_TYPE_ADD_INPUT',
  ClinicalRequestActionTypeCancelRequest = 'CLINICAL_REQUEST_ACTION_TYPE_CANCEL_REQUEST',
  ClinicalRequestActionTypeCreateRequest = 'CLINICAL_REQUEST_ACTION_TYPE_CREATE_REQUEST',
  ClinicalRequestActionTypeFinishRequest = 'CLINICAL_REQUEST_ACTION_TYPE_FINISH_REQUEST',
  ClinicalRequestActionTypeNone = 'CLINICAL_REQUEST_ACTION_TYPE_NONE',
  ClinicalRequestActionTypeRejectRequest = 'CLINICAL_REQUEST_ACTION_TYPE_REJECT_REQUEST',
  ClinicalRequestActionTypeRemoveInput = 'CLINICAL_REQUEST_ACTION_TYPE_REMOVE_INPUT',
  ClinicalRequestActionTypeReprioritizeRequest = 'CLINICAL_REQUEST_ACTION_TYPE_REPRIORITIZE_REQUEST',
  ClinicalRequestActionTypeSubmitRequest = 'CLINICAL_REQUEST_ACTION_TYPE_SUBMIT_REQUEST',
  ClinicalRequestActionTypeUpdateInputContent = 'CLINICAL_REQUEST_ACTION_TYPE_UPDATE_INPUT_CONTENT',
  ClinicalRequestActionTypeUpdateInputDocumentType = 'CLINICAL_REQUEST_ACTION_TYPE_UPDATE_INPUT_DOCUMENT_TYPE'
}

export type Clinicalrequest_ClinicalRequestAgreementMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestAgreementMsg';
  accepted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  template?: Maybe<Clinicalrequest_ClinicalRequestAgreementTemplateMsg>;
};

export type Clinicalrequest_ClinicalRequestAgreementTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestAgreementTemplateMsg';
  containsDocument?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Core_LocalizedStringMsg>;
  documentGroupId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Set true if the document should be displayed, but no corresponding checkbox */
  skipAgreement?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_ClinicalRequestAppointmentConfigMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestAppointmentConfigMsg';
  /** In minutes; defines how long an appointment for this clinicalRequest takes, can also be added up in case several parts/specifiers of a request all have defined durations. */
  appointmentDuration?: Maybe<Scalars['Int']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  disableBookingInRequest?: Maybe<Scalars['Boolean']>;
  /** If set, appointments can be booked directly (without needing appointment request) from the clinical request execution view */
  enableDirectBookingInExecution?: Maybe<Scalars['Boolean']>;
  /** If set, appointments can be booked directly (without needing appointment request) from the clinical request view */
  enableDirectBookingInRequest?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestBasicInfoMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestBasicInfoMsg';
  clinicalRequestId?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Timestamp>;
  requester?: Maybe<Core_UserReferenceMsg>;
  requesterUnitReferences?: Maybe<Array<Maybe<Core_InternalOrPortalUnitReferenceMsg>>>;
  submissionDate?: Maybe<Timestamp>;
  templateName?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestCategoryList = {
  __typename?: 'clinicalrequest_ClinicalRequestCategoryList';
  clinicalRequestCategory?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>>>;
};

/** ----- Request template categories ----- */
export type Clinicalrequest_ClinicalRequestCategoryMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestCategoryMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** When the parent is set, its subCategories are not set to avoid infinite messages */
  parentCategory?: Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>;
  /** One-to-n mapping: a sub-category belongs to exactly one category */
  subCategories?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>>>;
  timestamps?: Maybe<TimeMsg>;
};

/** One part of the documentation entry for a clinical request */
export type Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg';
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Title of the input field, used for some types */
  title?: Maybe<Scalars['String']>;
  /** Only relevant for type "Treatment" */
  treatmentType?: Maybe<Treatment_TreatmentType>;
  type?: Maybe<Clinicalrequest_ClinicalRequestExecutionComponentType>;
};

export enum Clinicalrequest_ClinicalRequestExecutionComponentType {
  ClinicalRequestExecutionComponentTypeAllergies = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_ALLERGIES',
  /** Structured input for list of clinical recommendations */
  ClinicalRequestExecutionComponentTypeClinicalRecommendations = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_CLINICAL_RECOMMENDATIONS',
  /** Text fields for every involved party */
  ClinicalRequestExecutionComponentTypeClinicalRequestAssessments = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_CLINICAL_REQUEST_ASSESSMENTS',
  /** Structured input for list of diagnoses */
  ClinicalRequestExecutionComponentTypeDiagnoses = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_DIAGNOSES',
  ClinicalRequestExecutionComponentTypeForm = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_FORM',
  ClinicalRequestExecutionComponentTypeInfections = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_INFECTIONS',
  /** TODO: Laboratory parameters */
  ClinicalRequestExecutionComponentTypeIsolation = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_ISOLATION',
  ClinicalRequestExecutionComponentTypeNone = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_NONE',
  /** Text field with title */
  ClinicalRequestExecutionComponentTypeText = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_TEXT',
  /** Selection of yes/no/unknown with a title and an additional text field */
  ClinicalRequestExecutionComponentTypeTextWithBoolUnknown = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_TEXT_WITH_BOOL_UNKNOWN',
  ClinicalRequestExecutionComponentTypeTreatment = 'CLINICAL_REQUEST_EXECUTION_COMPONENT_TYPE_TREATMENT'
}

export enum Clinicalrequest_ClinicalRequestExecutionMode {
  ClinicalRequestExecutionModeConsile = 'CLINICAL_REQUEST_EXECUTION_MODE_CONSILE',
  ClinicalRequestExecutionModeNone = 'CLINICAL_REQUEST_EXECUTION_MODE_NONE',
  ClinicalRequestExecutionModeStructured = 'CLINICAL_REQUEST_EXECUTION_MODE_STRUCTURED',
  ClinicalRequestExecutionModeText = 'CLINICAL_REQUEST_EXECUTION_MODE_TEXT',
  ClinicalRequestExecutionModeTreatment = 'CLINICAL_REQUEST_EXECUTION_MODE_TREATMENT'
}

/** Allows defining standard execution templates */
export type Clinicalrequest_ClinicalRequestExecutionTemplatePresetMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestExecutionTemplatePresetMsg';
  avelios?: Maybe<Scalars['Boolean']>;
  components?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** Slightly redundant additional information */
  mode?: Maybe<Clinicalrequest_ClinicalRequestExecutionMode>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

/** Represents an uploaded resource (see InputTemplateReferenceType) */
export type Clinicalrequest_ClinicalRequestInputMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestInputMsg';
  contentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Clinicalrequest_ClinicalRequestInputOrigin>;
  status?: Maybe<Clinicalrequest_ClinicalRequestInputStatus>;
  template?: Maybe<Clinicalrequest_ClinicalRequestInputTemplateMsg>;
  uploadDate?: Maybe<Timestamp>;
  visibilityChanges?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg>>>;
};

export enum Clinicalrequest_ClinicalRequestInputOrigin {
  ClinicalRequestInputOriginClinic = 'CLINICAL_REQUEST_INPUT_ORIGIN_CLINIC',
  ClinicalRequestInputOriginNone = 'CLINICAL_REQUEST_INPUT_ORIGIN_NONE',
  ClinicalRequestInputOriginPortal = 'CLINICAL_REQUEST_INPUT_ORIGIN_PORTAL'
}

export enum Clinicalrequest_ClinicalRequestInputStatus {
  /** The input has been deleted after the clinical Request has been submitted */
  ClinicalRequestInputStatusDisabled = 'CLINICAL_REQUEST_INPUT_STATUS_DISABLED',
  /** The input has been uploaded or reactivated after the clinicalRequest has been submitted */
  ClinicalRequestInputStatusEnabled = 'CLINICAL_REQUEST_INPUT_STATUS_ENABLED',
  ClinicalRequestInputStatusNone = 'CLINICAL_REQUEST_INPUT_STATUS_NONE'
}

export type Clinicalrequest_ClinicalRequestInputTemplateList = {
  __typename?: 'clinicalrequest_ClinicalRequestInputTemplateList';
  inputTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputTemplateMsg>>>;
};

export type Clinicalrequest_ClinicalRequestInputTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestInputTemplateMsg';
  namedClinicalRequestInputTemplate?: Maybe<Clinicalrequest_NamedClinicalRequestInputTemplateMsg>;
  structuredClinicalRequestInputTemplate?: Maybe<Clinicalrequest_StructuredClinicalRequestInputTemplateMsg>;
};

export type Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestInputVisibilityChangeMsg';
  changeDate?: Maybe<Timestamp>;
  changeReason?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestList = {
  __typename?: 'clinicalrequest_ClinicalRequestList';
  clinicalRequests?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestMsg>>>;
};

export type Clinicalrequest_ClinicalRequestMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestMsg';
  actions?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestActionMsg>>>;
  additionalRequesterEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalRequesterPhoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumberMsg>>>;
  agreements?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestAgreementMsg>>>;
  attachedDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  attachedLabTestInstanceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  clinicalRequestPriorityLevel?: Maybe<Clinicalrequest_ClinicalRequestPriorityLevelMsg>;
  completionDate?: Maybe<Timestamp>;
  /** Users with whom the submission of the request has already been discussed */
  correspondentUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdOnBehalfOf?: Maybe<Array<Maybe<Core_UserReferenceMsg>>>;
  customInputs?: Maybe<Array<Maybe<Clinicalrequest_CustomClinicalRequestInputMsg>>>;
  customProblem?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  diagnosisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Forms that are part of the request */
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  inputs?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputMsg>>>;
  inquiry?: Maybe<Scalars['String']>;
  linkedAnamnesisId?: Maybe<Scalars['String']>;
  /** Text in html format */
  linkedAnamnesisTextHtml?: Maybe<Scalars['String']>;
  /** Set if appointments are booked directly (without appointment request) from the clinical request or its execution */
  linkedAppointmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Set if appointment requests are sent from the clinical request or its execution */
  linkedAppointmentRequestIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedPhysicalExaminationId?: Maybe<Scalars['String']>;
  /** Text in html format */
  linkedPhysicalExaminationTextHtml?: Maybe<Scalars['String']>;
  medicationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
  patientInformation?: Maybe<Clinicalrequest_ClinicalRequestPatientInformationMsg>;
  patientPortalUser?: Maybe<Patientportal_PortalUserMsg>;
  patientPortalUserId?: Maybe<Scalars['String']>;
  /** each list is a chain of hierarchical problems, first element of each list would be the parent etc. */
  relevantProblems?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestProblemTemplateList>>>;
  /** each list is a chain of hierarchical problems, first element of each list would be the parent etc. */
  relevantSpecifiers?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestSpecifierList>>>;
  requestedConsultantUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  requester?: Maybe<Core_UserReferenceMsg>;
  requesterUnitReferences?: Maybe<Array<Maybe<Core_InternalOrPortalUnitReferenceMsg>>>;
  requesterUnits?: Maybe<Array<Core_SimpleInternalOrPortalUnitMsg>>;
  /** Users who will be notified about result */
  resultRecipients?: Maybe<Array<Maybe<Core_UserReferenceMsg>>>;
  standardPriorityLevel?: Maybe<Clinicalrequest_PriorityLevel>;
  status?: Maybe<Clinicalrequest_ClinicalRequestStatus>;
  submissionDate?: Maybe<Timestamp>;
  surgeryId?: Maybe<Scalars['String']>;
  targetFacilityId?: Maybe<Scalars['String']>;
  targetFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  template?: Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>;
  timestamps?: Maybe<TimeMsg>;
  transportType?: Maybe<Core_KnowledgeInputMsg>;
  treatingOrganizationalUnitId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
  warnings?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestWarningMsg>>>;
};

/** This is set by the requester from the portal side, since they do not have access to internal patient data. Later, a patient id can be linked by the clinic. */
export type Clinicalrequest_ClinicalRequestPatientInformationMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestPatientInformationMsg';
  contact?: Maybe<Core_ContactMsg>;
  currentOrganizationalUnit?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_HumanNameMsg>;
  sex?: Maybe<Core_Sex>;
};

export type Clinicalrequest_ClinicalRequestPriorityLevelList = {
  __typename?: 'clinicalrequest_ClinicalRequestPriorityLevelList';
  priorityLevels?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestPriorityLevelMsg>>>;
};

export type Clinicalrequest_ClinicalRequestPriorityLevelMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestPriorityLevelMsg';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Core_LocalizedStringMsg>;
  duration?: Maybe<PrecisionDurationMsg>;
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Core_LocalizedStringMsg>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  standardPriorityLevel?: Maybe<Clinicalrequest_PriorityLevel>;
  timestamps?: Maybe<TimeMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export enum Clinicalrequest_ClinicalRequestPriorityLevelType {
  ClinicalRequestPriorityLevelTypeCustom = 'CLINICAL_REQUEST_PRIORITY_LEVEL_TYPE_CUSTOM',
  ClinicalRequestPriorityLevelTypeNone = 'CLINICAL_REQUEST_PRIORITY_LEVEL_TYPE_NONE',
  ClinicalRequestPriorityLevelTypeStandard = 'CLINICAL_REQUEST_PRIORITY_LEVEL_TYPE_STANDARD'
}

export type Clinicalrequest_ClinicalRequestProblemTemplateList = {
  __typename?: 'clinicalrequest_ClinicalRequestProblemTemplateList';
  problemTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
};

export type Clinicalrequest_ClinicalRequestProblemTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestProblemTemplateMsg';
  children?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
  id?: Maybe<Scalars['String']>;
  selectable?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  /** Warning to be displayed if this problem template is selected */
  warningText?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestRequestSettingsMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestRequestSettingsMsg';
  hideDiagnoses?: Maybe<Scalars['Boolean']>;
  hidePriority?: Maybe<Scalars['Boolean']>;
  hideProblemTemplates?: Maybe<Scalars['Boolean']>;
};

export enum Clinicalrequest_ClinicalRequestSortType {
  ClinicalRequestSortTypeBirthDate = 'CLINICAL_REQUEST_SORT_TYPE_BIRTH_DATE',
  ClinicalRequestSortTypeDateOfCreation = 'CLINICAL_REQUEST_SORT_TYPE_DATE_OF_CREATION',
  ClinicalRequestSortTypeNone = 'CLINICAL_REQUEST_SORT_TYPE_NONE',
  ClinicalRequestSortTypePatientName = 'CLINICAL_REQUEST_SORT_TYPE_PATIENT_NAME',
  ClinicalRequestSortTypePriority = 'CLINICAL_REQUEST_SORT_TYPE_PRIORITY',
  ClinicalRequestSortTypeRecipient = 'CLINICAL_REQUEST_SORT_TYPE_RECIPIENT',
  ClinicalRequestSortTypeRequestee = 'CLINICAL_REQUEST_SORT_TYPE_REQUESTEE',
  ClinicalRequestSortTypeRequestType = 'CLINICAL_REQUEST_SORT_TYPE_REQUEST_TYPE',
  ClinicalRequestSortTypeStatus = 'CLINICAL_REQUEST_SORT_TYPE_STATUS'
}

export type Clinicalrequest_ClinicalRequestSpecifierList = {
  __typename?: 'clinicalrequest_ClinicalRequestSpecifierList';
  specifiers?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
};

export enum Clinicalrequest_ClinicalRequestStatus {
  /**
   * The clinical request has been sent by an unauthorized user
   *  and is awaiting to be approved and submitted by an authorized user
   */
  ClinicalRequestStatusAwaitingAuthorization = 'CLINICAL_REQUEST_STATUS_AWAITING_AUTHORIZATION',
  /** The clinical request has been cancelled by the requester */
  ClinicalRequestStatusCancelled = 'CLINICAL_REQUEST_STATUS_CANCELLED',
  /** The clinical request has been processed and finished by the requestee */
  ClinicalRequestStatusFinished = 'CLINICAL_REQUEST_STATUS_FINISHED',
  /** The clinical request is being processed by the requestee */
  ClinicalRequestStatusInProgress = 'CLINICAL_REQUEST_STATUS_IN_PROGRESS',
  ClinicalRequestStatusNone = 'CLINICAL_REQUEST_STATUS_NONE',
  /** The clinical request has been created and is being edited */
  ClinicalRequestStatusNotSubmitted = 'CLINICAL_REQUEST_STATUS_NOT_SUBMITTED',
  /** The clinical request has been rejected by the requestee */
  ClinicalRequestStatusRejected = 'CLINICAL_REQUEST_STATUS_REJECTED',
  /** The clinical request has been submitted by the requester */
  ClinicalRequestStatusSubmitted = 'CLINICAL_REQUEST_STATUS_SUBMITTED'
}

export type Clinicalrequest_ClinicalRequestTemplateAccessMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateAccessMsg';
  clinicalRequestTemplateBasicInfo?: Maybe<Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>;
  lastAccessTime?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestTemplateAllergyRequirementMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateAllergyRequirementMsg';
  generalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateBasicInfoMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  specifiers?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  status?: Maybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
};

/** ----- Favorites ----- */
export type Clinicalrequest_ClinicalRequestTemplateFavoritesMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateFavoritesMsg';
  clinicalRequestTemplateBasicInfos?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>>>;
  userId?: Maybe<Scalars['String']>;
};

/** ----- Request History ----- */
export type Clinicalrequest_ClinicalRequestTemplateHistoryMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateHistoryMsg';
  clinicalRequestTemplateAccesses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateAccessMsg>>>;
};

export type Clinicalrequest_ClinicalRequestTemplateList = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateList';
  clinicalRequestTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

/** Defines both requesting and executing side */
export type Clinicalrequest_ClinicalRequestTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateMsg';
  additionalConsults?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  agreementTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestAgreementTemplateMsg>>>;
  appointmentConfigs?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestAppointmentConfigMsg>>>;
  /** Most specific category that the template is assigned to; can be empty */
  category?: Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>;
  /** Whether requester can select specific doctors */
  consultantSelectionEnabled?: Maybe<Scalars['Boolean']>;
  /** Defines how additional specific results of the clinical request execution are documented */
  executionComponents?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  executionMode?: Maybe<Clinicalrequest_ClinicalRequestExecutionMode>;
  /** If true, the request execution is done by an external provider that is not part of the internal clinic hierarchy */
  externalRecipient?: Maybe<Scalars['Boolean']>;
  /** Only relevant if externalRecipient is true */
  externalRequestDefinition?: Maybe<Clinicalrequest_ExternalClinicalRequestDefinitionMsg>;
  /** The id of the form template versioning group to be conducted when requesting this consultation */
  formVersioningGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Used to group different versions of the request template */
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inputTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputTemplateMsg>>>;
  name?: Maybe<Scalars['String']>;
  /** Users who should get notified if something happens in requests of this template */
  notificationRecipientUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The owner of the request template; for non-external recipients, this is also the recipient */
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  problemTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestProblemTemplateMsg>>>;
  referenceId?: Maybe<Scalars['String']>;
  requestSettings?: Maybe<Clinicalrequest_ClinicalRequestRequestSettingsMsg>;
  specifiers?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  status?: Maybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
  timestamps?: Maybe<TimeMsg>;
  /** Warnings that are displayed to the requester, used e.g., to remind requester to add all required information */
  warningTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestWarningTemplateMsg>>>;
};

export type Clinicalrequest_ClinicalRequestTemplatePresetList = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplatePresetList';
  presets?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplatePresetMsg>>>;
};

/** ----- Request template presets ----- */
export type Clinicalrequest_ClinicalRequestTemplatePresetMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplatePresetMsg';
  clinicalRequestTemplateBasicInfos?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateBasicInfoMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  userId?: Maybe<Scalars['String']>;
};

/** ----- Clinical Request Template Specifiers ----- */
export type Clinicalrequest_ClinicalRequestTemplateSpecifierMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestTemplateSpecifierMsg';
  appointmentConfigs?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestAppointmentConfigMsg>>>;
  /** later on add requirements */
  childSpecifiers?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateSpecifierMsg>>>;
  /** Defines additional entry fields for this specifier */
  executionComponents?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestExecutionComponentTemplateMsg>>>;
  externalId?: Maybe<Scalars['String']>;
  formVersioningGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  laterality?: Maybe<Laterality_Laterality>;
  name?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
};

export enum Clinicalrequest_ClinicalRequestTemplateStatus {
  ClinicalRequestTemplateStatusActive = 'CLINICAL_REQUEST_TEMPLATE_STATUS_ACTIVE',
  ClinicalRequestTemplateStatusInactive = 'CLINICAL_REQUEST_TEMPLATE_STATUS_INACTIVE',
  ClinicalRequestTemplateStatusNone = 'CLINICAL_REQUEST_TEMPLATE_STATUS_NONE',
  ClinicalRequestTemplateStatusNotYetActive = 'CLINICAL_REQUEST_TEMPLATE_STATUS_NOT_YET_ACTIVE'
}

export type Clinicalrequest_ClinicalRequestWarningMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestWarningMsg';
  accepted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  template?: Maybe<Clinicalrequest_ClinicalRequestWarningTemplateMsg>;
};

export type Clinicalrequest_ClinicalRequestWarningTemplateMsg = {
  __typename?: 'clinicalrequest_ClinicalRequestWarningTemplateMsg';
  description?: Maybe<Core_LocalizedStringMsg>;
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_CreateClinicalRequestRequest = {
  __typename?: 'clinicalrequest_CreateClinicalRequestRequest';
  clinicalRequestSpecifiersIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  clinicalRequestTemplateId?: Maybe<Scalars['String']>;
  /** should be set in the portal side */
  externalRequesterUnits?: Maybe<Array<Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  /** optional */
  patientId?: Maybe<Scalars['String']>;
  /** optional */
  surgeryId?: Maybe<Scalars['String']>;
  /** should be set in the portal side */
  targetFacilityId?: Maybe<Scalars['String']>;
  /** optional */
  treatmentId?: Maybe<Scalars['String']>;
  /** optional */
  visitId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_CustomClinicalRequestInputMsg = {
  __typename?: 'clinicalrequest_CustomClinicalRequestInputMsg';
  contentId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Document_DocumentTypeMsg>;
  fileName?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Clinicalrequest_ClinicalRequestInputOrigin>;
  referenceType?: Maybe<Clinicalrequest_InputTemplateReferenceType>;
  status?: Maybe<Clinicalrequest_ClinicalRequestInputStatus>;
  uploadDate?: Maybe<Timestamp>;
  visibilityChanges?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputVisibilityChangeMsg>>>;
};

export type Clinicalrequest_DeleteClinicalRequestCategoryRequest = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestCategoryRequest';
  clinicalRequestCategoryId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_DeleteClinicalRequestCategoryResponse = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestCategoryResponse';
  deletedClinicalRequestCategoryId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_DeleteClinicalRequestRequest = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_DeleteClinicalRequestResponse = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestResponse';
  deletedClinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_DeleteClinicalRequestTemplatePresetRequest = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestTemplatePresetRequest';
  id?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_DeleteClinicalRequestTemplatePresetResponse = {
  __typename?: 'clinicalrequest_DeleteClinicalRequestTemplatePresetResponse';
  id?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ExternalClinicalRequestDefinitionMsg = {
  __typename?: 'clinicalrequest_ExternalClinicalRequestDefinitionMsg';
  /** Used to determine where to sent the request */
  externalExternalRecipientIds?: Maybe<Array<Maybe<Clinicalrequest_ExternalClinicalRequestRecipientIdMsg>>>;
  /** Specifies the external units of the receiving party */
  externalRecipientUnits?: Maybe<Array<Maybe<Core_ExternalAdministrativeUnitReferenceMsg>>>;
  /** Allow identifying the request template for exchanging requests with an external system */
  externalTemplateIds?: Maybe<Array<Maybe<Clinicalrequest_ExternalClinicalRequestTemplateIdMsg>>>;
  /** Flag determining if request will be pushed to the Gateway service */
  useAppointmentDate?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_ExternalClinicalRequestRecipientIdMsg = {
  __typename?: 'clinicalrequest_ExternalClinicalRequestRecipientIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Clinicalrequest_ExternalClinicalRequestRecipientIdType>;
};

export enum Clinicalrequest_ExternalClinicalRequestRecipientIdType {
  ExternalClinicalRequestRecipientIdTypeHl7Oid = 'EXTERNAL_CLINICAL_REQUEST_RECIPIENT_ID_TYPE_HL7_OID',
  ExternalClinicalRequestRecipientIdTypeNone = 'EXTERNAL_CLINICAL_REQUEST_RECIPIENT_ID_TYPE_NONE'
}

export type Clinicalrequest_ExternalClinicalRequestTemplateIdMsg = {
  __typename?: 'clinicalrequest_ExternalClinicalRequestTemplateIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Clinicalrequest_ExternalClinicalRequestTemplateIdType>;
};

export enum Clinicalrequest_ExternalClinicalRequestTemplateIdType {
  ExternalClinicalRequestTemplateIdTypeHl7UniversalServiceIdentifier = 'EXTERNAL_CLINICAL_REQUEST_TEMPLATE_ID_TYPE_HL7_UNIVERSAL_SERVICE_IDENTIFIER',
  ExternalClinicalRequestTemplateIdTypeHl7UniversalServiceIdentifierAlternate = 'EXTERNAL_CLINICAL_REQUEST_TEMPLATE_ID_TYPE_HL7_UNIVERSAL_SERVICE_IDENTIFIER_ALTERNATE',
  ExternalClinicalRequestTemplateIdTypeNone = 'EXTERNAL_CLINICAL_REQUEST_TEMPLATE_ID_TYPE_NONE'
}

export type Clinicalrequest_GetClinicalRequestForEmailRequest = {
  __typename?: 'clinicalrequest_GetClinicalRequestForEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_GetClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_GetClinicalRequestInputRequest';
  clinicalRequestInputId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_GetClinicalRequestInputTemplateRequest = {
  __typename?: 'clinicalrequest_GetClinicalRequestInputTemplateRequest';
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_GetClinicalRequestRequest = {
  __typename?: 'clinicalrequest_GetClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_GetClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_GetClinicalRequestsRequest';
  clinicalRequestIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Clinicalrequest_GetCustomClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_GetCustomClinicalRequestInputRequest';
  customClinicalRequestInputId?: Maybe<Scalars['String']>;
};

export enum Clinicalrequest_InputTemplateReferenceType {
  InputTemplateReferenceTypeDocument = 'INPUT_TEMPLATE_REFERENCE_TYPE_DOCUMENT',
  InputTemplateReferenceTypeImage = 'INPUT_TEMPLATE_REFERENCE_TYPE_IMAGE',
  InputTemplateReferenceTypeNone = 'INPUT_TEMPLATE_REFERENCE_TYPE_NONE',
  InputTemplateReferenceTypePhysicalBlock = 'INPUT_TEMPLATE_REFERENCE_TYPE_PHYSICAL_BLOCK',
  InputTemplateReferenceTypeQuestionnaireTemplate = 'INPUT_TEMPLATE_REFERENCE_TYPE_QUESTIONNAIRE_TEMPLATE'
}

export type Clinicalrequest_LinkPatientToClinicalRequestKafkaEvent = {
  __typename?: 'clinicalrequest_LinkPatientToClinicalRequestKafkaEvent';
  clinicalRequestId?: Maybe<Scalars['String']>;
  inputs?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestInputMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_LinkPatientToClinicalRequestRequest = {
  __typename?: 'clinicalrequest_LinkPatientToClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListAllClinicalRequestTemplatesRequest = {
  __typename?: 'clinicalrequest_ListAllClinicalRequestTemplatesRequest';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListClinicalRequestPriorityLevelsRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestPriorityLevelsRequest';
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Clinicalrequest_ListClinicalRequestTemplateCatalogByCategoryResponse = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplateCatalogByCategoryResponse';
  categories?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>>>;
  templates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

export type Clinicalrequest_ListClinicalRequestTemplateCatalogByOwnerResponse = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplateCatalogByOwnerResponse';
  clinicTrees?: Maybe<Array<Maybe<User_AdministrativeUnitTreeMsg>>>;
  templates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>>>;
};

export type Clinicalrequest_ListClinicalRequestTemplateCatalogRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplateCatalogRequest';
  groupByCategories?: Maybe<Scalars['Boolean']>;
  groupByOwner?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_ListClinicalRequestTemplateHistoryRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplateHistoryRequest';
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListClinicalRequestTemplatePresetsRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplatePresetsRequest';
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListClinicalRequestTemplatesRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestTemplatesRequest';
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** should be set true if don't want to fetch lower hierarchies' templates. */
  exactMatchWithScope?: Maybe<Scalars['Boolean']>;
  inFavourites?: Maybe<Scalars['Boolean']>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional filter */
  templateStatuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateStatus>>>;
};

export type Clinicalrequest_ListClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_ListClinicalRequestsRequest';
  /** optional, if true, only returns Clinical Requests that have linked appointments */
  hasLinkedAppointment?: Maybe<Scalars['Boolean']>;
  /** optional, if true, returns any Clinical Requests that have linked appointments or linked appointment requests */
  hasLinkedAppointmentOrRequest?: Maybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
  /** optional */
  statuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestStatus>>>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListClinicalRequestsResponse = {
  __typename?: 'clinicalrequest_ListClinicalRequestsResponse';
  clinicalRequests?: Maybe<Clinicalrequest_ClinicalRequestList>;
};

export type Clinicalrequest_ListFavoriteClinicalRequestTemplatesRequest = {
  __typename?: 'clinicalrequest_ListFavoriteClinicalRequestTemplatesRequest';
  /** optional */
  favoriteCount?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListIncomingClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_ListIncomingClinicalRequestsRequest';
  administrativeUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  exactMatchWithScope?: Maybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: Maybe<Scalars['Boolean']>;
  requestedConsultantUserId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Helper_SortOrder>;
  sortType?: Maybe<Clinicalrequest_ClinicalRequestSortType>;
  /** required */
  statuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestStatus>>>;
  targetFacilityId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListIncomingClinicalRequestsResponse = {
  __typename?: 'clinicalrequest_ListIncomingClinicalRequestsResponse';
  clinicalRequests?: Maybe<Clinicalrequest_ClinicalRequestList>;
};

export type Clinicalrequest_ListOutgoingClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_ListOutgoingClinicalRequestsRequest';
  administrativeUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  exactMatchWithScope?: Maybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: Maybe<Scalars['Boolean']>;
  requester?: Maybe<Core_UserReferenceMsg>;
  sortOrder?: Maybe<Helper_SortOrder>;
  sortType?: Maybe<Clinicalrequest_ClinicalRequestSortType>;
  /** required */
  statuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestStatus>>>;
  treatingOrganizationalUnitId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_ListOutgoingClinicalRequestsResponse = {
  __typename?: 'clinicalrequest_ListOutgoingClinicalRequestsResponse';
  clinicalRequests?: Maybe<Clinicalrequest_ClinicalRequestList>;
};

export type Clinicalrequest_ListUnsubmittedClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_ListUnsubmittedClinicalRequestsRequest';
  _?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_NamedClinicalRequestInputTemplateMsg = {
  __typename?: 'clinicalrequest_NamedClinicalRequestInputTemplateMsg';
  documentType?: Maybe<Document_DocumentTypeMsg>;
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  referenceType?: Maybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Clinicalrequest_NotifyClinicalRequestCommentRecipientsRequest = {
  __typename?: 'clinicalrequest_NotifyClinicalRequestCommentRecipientsRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_NotifyClinicalRequestCommentRecipientsResponse = {
  __typename?: 'clinicalrequest_NotifyClinicalRequestCommentRecipientsResponse';
  _?: Maybe<Scalars['String']>;
};

export enum Clinicalrequest_PriorityLevel {
  PriorityLevelEmergency = 'PRIORITY_LEVEL_EMERGENCY',
  PriorityLevelNone = 'PRIORITY_LEVEL_NONE',
  PriorityLevelNormal = 'PRIORITY_LEVEL_NORMAL',
  PriorityLevelUrgent = 'PRIORITY_LEVEL_URGENT'
}

export type Clinicalrequest_PriorityLevelIdList = {
  __typename?: 'clinicalrequest_PriorityLevelIdList';
  priorityLevelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Clinicalrequest_PriorityLevelList = {
  __typename?: 'clinicalrequest_PriorityLevelList';
  levels?: Maybe<Array<Maybe<Clinicalrequest_PriorityLevel>>>;
};

export type Clinicalrequest_ReferenceMsg = {
  __typename?: 'clinicalrequest_ReferenceMsg';
  blockPath?: Maybe<Clinicalrequest_BlockPathMsg>;
  referenceId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_RejectClinicalRequestRequest = {
  __typename?: 'clinicalrequest_RejectClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_RemoveClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_RemoveClinicalRequestInputRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  inputId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_RemoveClinicalRequestInputResponse = {
  __typename?: 'clinicalrequest_RemoveClinicalRequestInputResponse';
  deleted?: Maybe<Scalars['Boolean']>;
  input?: Maybe<Clinicalrequest_ClinicalRequestInputMsg>;
};

export type Clinicalrequest_RemoveClinicalRequestTemplateFromFavoritesRequest = {
  __typename?: 'clinicalrequest_RemoveClinicalRequestTemplateFromFavoritesRequest';
  clinicalRequestTemplateId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_RemoveCustomClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_RemoveCustomClinicalRequestInputRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  inputId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_RemoveCustomClinicalRequestInputResponse = {
  __typename?: 'clinicalrequest_RemoveCustomClinicalRequestInputResponse';
  deleted?: Maybe<Scalars['Boolean']>;
  input?: Maybe<Clinicalrequest_CustomClinicalRequestInputMsg>;
};

export type Clinicalrequest_ReprioritizeClinicalRequestRequest = {
  __typename?: 'clinicalrequest_ReprioritizeClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  newPriorityLevelId?: Maybe<Scalars['String']>;
  newStandardPriorityLevel?: Maybe<Clinicalrequest_PriorityLevel>;
  reasonForReprioritization?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_SearchClinicalRequestTemplatesRequest = {
  __typename?: 'clinicalrequest_SearchClinicalRequestTemplatesRequest';
  /** should be set true if don't want to fetch lower hierarchies' templates. */
  exactMatchWithScope?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional filter */
  templateStatuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateStatus>>>;
  text?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_SearchClinicalRequestTemplatesResponse = {
  __typename?: 'clinicalrequest_SearchClinicalRequestTemplatesResponse';
  clinicalRequestTemplates?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Clinicalrequest_SearchClinicalRequestsRequest = {
  __typename?: 'clinicalrequest_SearchClinicalRequestsRequest';
  clinicalRequestPatientInformationId?: Maybe<Scalars['String']>;
  /** optional filter */
  clinicalRequestStatuses?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestStatus>>>;
  /** optional filter */
  clinicalRequestTemplateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** should be set true if don't want to fetch lower hierarchies' requests. */
  exactMatchWithOwner?: Maybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointments */
  hasLinkedAppointment?: Maybe<Scalars['Boolean']>;
  /** optional, if true, returns any Clinical Requests that have linked appointments or linked appointment requests */
  hasLinkedAppointmentOrRequest?: Maybe<Scalars['Boolean']>;
  /** optional, if true, only returns Clinical Requests that have linked appointment requests */
  hasLinkedAppointmentRequest?: Maybe<Scalars['Boolean']>;
  /**
   * must to set in the requestee side to display the requests
   *  optional to set as "requested unit" in the requester side
   */
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** mandatory */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  priorityLevelIdList?: Maybe<Clinicalrequest_PriorityLevelIdList>;
  priorityLevelList?: Maybe<Clinicalrequest_PriorityLevelList>;
  /**
   * must to set in the requester side to list requester' clinical requests
   *  optional filter for requestee side
   */
  sentBy?: Maybe<Core_InternalOrPortalUnitReferenceMsg>;
  /** optional filter */
  submissionEndDate?: Maybe<Timestamp>;
  /** optional filter */
  submissionStartDate?: Maybe<Timestamp>;
  /** optional filter */
  targetFacilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional filter, set true to see unlinked clinical requests with patients */
  unlinkedRequestsWithPatients?: Maybe<Scalars['Boolean']>;
};

export type Clinicalrequest_SearchClinicalRequestsResponse = {
  __typename?: 'clinicalrequest_SearchClinicalRequestsResponse';
  clinicalRequests?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Clinicalrequest_StructuredClinicalRequestInputTemplateMsg = {
  __typename?: 'clinicalrequest_StructuredClinicalRequestInputTemplateMsg';
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Clinicalrequest_ReferenceMsg>;
  referenceType?: Maybe<Clinicalrequest_InputTemplateReferenceType>;
};

export type Clinicalrequest_SubmitClinicalRequestRequest = {
  __typename?: 'clinicalrequest_SubmitClinicalRequestRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Clinicalrequest_UpdateClinicalRequestCategoryRequest = {
  __typename?: 'clinicalrequest_UpdateClinicalRequestCategoryRequest';
  clinicalRequestCategory?: Maybe<Clinicalrequest_ClinicalRequestCategoryMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Clinicalrequest_UpdateClinicalRequestRequest = {
  __typename?: 'clinicalrequest_UpdateClinicalRequestRequest';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Clinicalrequest_UpdateClinicalRequestTemplatePresetRequest = {
  __typename?: 'clinicalrequest_UpdateClinicalRequestTemplatePresetRequest';
  templatePreset?: Maybe<Clinicalrequest_ClinicalRequestTemplatePresetMsg>;
};

export type Clinicalrequest_UpdateClinicalRequestTemplateRequest = {
  __typename?: 'clinicalrequest_UpdateClinicalRequestTemplateRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  template?: Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>;
};

export type Clinicalrequest_UpdateClinicalRequestTemplateStatusRequest = {
  __typename?: 'clinicalrequest_UpdateClinicalRequestTemplateStatusRequest';
  clinicalRequestTemplateId?: Maybe<Scalars['String']>;
  newStatus?: Maybe<Clinicalrequest_ClinicalRequestTemplateStatus>;
};

export type Clinicalrequest_UpdateCustomClinicalRequestInputRequest = {
  __typename?: 'clinicalrequest_UpdateCustomClinicalRequestInputRequest';
  customClinicalRequestInput?: Maybe<Clinicalrequest_CustomClinicalRequestInputMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Clinicalrequest_UpdateRelevantProblemsRequest = {
  __typename?: 'clinicalrequest_UpdateRelevantProblemsRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  clinicalRequestProblemTemplateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Clinicalrequest_UpdateRelevantSpecifiersRequest = {
  __typename?: 'clinicalrequest_UpdateRelevantSpecifiersRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  clinicalRequestSpecifiersIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Comment_CommentContextReferenceMsg = {
  __typename?: 'comment_CommentContextReferenceMsg';
  contextId?: Maybe<Scalars['String']>;
  type?: Maybe<Comment_CommentContextType>;
};

export enum Comment_CommentContextType {
  CommentContextTypeAppointment = 'COMMENT_CONTEXT_TYPE_APPOINTMENT',
  /** For attendee specific comments on group appointments. */
  CommentContextTypeAppointmentAttendee = 'COMMENT_CONTEXT_TYPE_APPOINTMENT_ATTENDEE',
  CommentContextTypeAppointmentRequest = 'COMMENT_CONTEXT_TYPE_APPOINTMENT_REQUEST',
  CommentContextTypeClinicalRequest = 'COMMENT_CONTEXT_TYPE_CLINICAL_REQUEST',
  CommentContextTypeMedicationIntake = 'COMMENT_CONTEXT_TYPE_MEDICATION_INTAKE',
  CommentContextTypeMedicationIntakeAuthorization = 'COMMENT_CONTEXT_TYPE_MEDICATION_INTAKE_AUTHORIZATION',
  CommentContextTypeNone = 'COMMENT_CONTEXT_TYPE_NONE',
  CommentContextTypePatientDischarge = 'COMMENT_CONTEXT_TYPE_PATIENT_DISCHARGE',
  /** One group is the collection of all versions of a letter; comments should be kept across versions */
  CommentContextTypePatientLetterGroup = 'COMMENT_CONTEXT_TYPE_PATIENT_LETTER_GROUP'
}

export type Comment_CommentList = {
  __typename?: 'comment_CommentList';
  comments?: Maybe<Array<Maybe<Comment_CommentMsg>>>;
};

export type Comment_CommentMsg = {
  __typename?: 'comment_CommentMsg';
  /** backend manages the active property of the comment */
  active?: Maybe<Scalars['Boolean']>;
  commenter?: Maybe<Core_UserReferenceMsg>;
  commenterUnits?: Maybe<Array<Maybe<Core_InternalOrPortalUnitReferenceMsg>>>;
  /** Main context */
  context?: Maybe<Comment_CommentContextReferenceMsg>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  referencedUsers?: Maybe<Array<Maybe<Core_UserReferenceMsg>>>;
  /**
   * Comment that this comment replies to.
   *  Maximum depth: 1, i.e., in the nested comment, no further CommentMsg will be nested
   */
  replyToComment?: Maybe<Comment_CommentMsg>;
  /** The context of a comment is the main context and all the sub contexts. */
  subContexts?: Maybe<Array<Maybe<Comment_CommentContextReferenceMsg>>>;
  text?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
};

export type Comment_CreateCommentRequest = {
  __typename?: 'comment_CreateCommentRequest';
  context?: Maybe<Comment_CommentContextReferenceMsg>;
  /** optional */
  replyToCommentId?: Maybe<Scalars['String']>;
  subContexts?: Maybe<Array<Maybe<Comment_CommentContextReferenceMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Comment_DeleteCommentRequest = {
  __typename?: 'comment_DeleteCommentRequest';
  commentId?: Maybe<Scalars['String']>;
};

export type Comment_DeleteCommentResponse = {
  __typename?: 'comment_DeleteCommentResponse';
  deletedCommentId?: Maybe<Scalars['String']>;
};

export type Comment_GetCommentHistoryRequest = {
  __typename?: 'comment_GetCommentHistoryRequest';
  groupId?: Maybe<Scalars['String']>;
};

/** it only returns the latest versions of the comments */
export type Comment_ListCommentsRequest = {
  __typename?: 'comment_ListCommentsRequest';
  contextFilters?: Maybe<Array<Maybe<Comment_ListCommentsRequestContextFilterMsg>>>;
  /** optional sort */
  creationDateSort?: Maybe<Helper_SortOrder>;
  /**
   * optional filter
   *  if it's set to true, fetches only the active ones. O/w fetches both active and inactive ones
   */
  onlyActive?: Maybe<Scalars['Boolean']>;
  /** Optional: Set if pagination is desired */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Comment_ListCommentsRequestContextFilterMsg = {
  __typename?: 'comment_ListCommentsRequestContextFilterMsg';
  /** Context has to match */
  context?: Maybe<Comment_CommentContextReferenceMsg>;
  /** It is enough to have one sub context that match */
  subContexts?: Maybe<Array<Maybe<Comment_CommentContextReferenceMsg>>>;
};

export type Comment_ListCommentsResponse = {
  __typename?: 'comment_ListCommentsResponse';
  comments?: Maybe<Array<Maybe<Comment_CommentMsg>>>;
  contextFilters?: Maybe<Array<Maybe<Comment_ListCommentsRequestContextFilterMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

/** It doesn't update the comment.replyToComment */
export type Comment_UpdateCommentRequest = {
  __typename?: 'comment_UpdateCommentRequest';
  comment?: Maybe<Comment_CommentMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export enum Common_Access_AccessConstraint {
  AccessConstraintHidden = 'ACCESS_CONSTRAINT_HIDDEN',
  AccessConstraintNone = 'ACCESS_CONSTRAINT_NONE',
  AccessConstraintViewOnly = 'ACCESS_CONSTRAINT_VIEW_ONLY'
}

export enum Common_Access_AnesthesiaPlanAction {
  AnesthesiaPlanActionEditPlan = 'ANESTHESIA_PLAN_ACTION_EDIT_PLAN',
  AnesthesiaPlanActionNone = 'ANESTHESIA_PLAN_ACTION_NONE'
}

export enum Common_Access_ApplicationElement {
  ApplicationElementAllergiesAndIntolerancesBlock = 'APPLICATION_ELEMENT_ALLERGIES_AND_INTOLERANCES_BLOCK',
  ApplicationElementAnaesthesiologicalInformation = 'APPLICATION_ELEMENT_ANAESTHESIOLOGICAL_INFORMATION',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementAnesthesiaChecklist = 'APPLICATION_ELEMENT_ANESTHESIA_CHECKLIST',
  ApplicationElementAnesthesiaPlanAnestheticFlowSystems = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_ANESTHETIC_FLOW_SYSTEMS',
  ApplicationElementAnesthesiaPlanBlock = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_BLOCK',
  ApplicationElementAnesthesiaPlanMonitoringAndEquipment = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_MONITORING_AND_EQUIPMENT',
  ApplicationElementAnesthesiaPlanPlannedAnestheticProcedures = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_PLANNED_ANESTHETIC_PROCEDURES',
  ApplicationElementAnesthesiaPlanRegionalAnesthesia = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_REGIONAL_ANESTHESIA',
  ApplicationElementAnesthesiaPlanStep = 'APPLICATION_ELEMENT_ANESTHESIA_PLAN_STEP',
  ApplicationElementAnesthesiaProtocolBlock = 'APPLICATION_ELEMENT_ANESTHESIA_PROTOCOL_BLOCK',
  ApplicationElementAnesthesiologyClearance = 'APPLICATION_ELEMENT_ANESTHESIOLOGY_CLEARANCE',
  ApplicationElementAnestheticDocumentation = 'APPLICATION_ELEMENT_ANESTHETIC_DOCUMENTATION',
  ApplicationElementAppointmentsBlock = 'APPLICATION_ELEMENT_APPOINTMENTS_BLOCK',
  ApplicationElementBalance = 'APPLICATION_ELEMENT_BALANCE',
  ApplicationElementBillingConfigurationAsvTeams = 'APPLICATION_ELEMENT_BILLING_CONFIGURATION_ASV_TEAMS',
  ApplicationElementBillingConfigurationCodeChains = 'APPLICATION_ELEMENT_BILLING_CONFIGURATION_CODE_CHAINS',
  ApplicationElementBloodProducts = 'APPLICATION_ELEMENT_BLOOD_PRODUCTS',
  ApplicationElementCareAssessment = 'APPLICATION_ELEMENT_CARE_ASSESSMENT',
  ApplicationElementCareInformationAndPlanningBlock = 'APPLICATION_ELEMENT_CARE_INFORMATION_AND_PLANNING_BLOCK',
  ApplicationElementCareTabMedicationTasks = 'APPLICATION_ELEMENT_CARE_TAB_MEDICATION_TASKS',
  ApplicationElementCareTabTasks = 'APPLICATION_ELEMENT_CARE_TAB_TASKS',
  ApplicationElementCareTabTaskExecution = 'APPLICATION_ELEMENT_CARE_TAB_TASK_EXECUTION',
  ApplicationElementCareTasks = 'APPLICATION_ELEMENT_CARE_TASKS',
  ApplicationElementClinicalOrdersAndRequirementsBlock = 'APPLICATION_ELEMENT_CLINICAL_ORDERS_AND_REQUIREMENTS_BLOCK',
  ApplicationElementCockpitNotes = 'APPLICATION_ELEMENT_COCKPIT_NOTES',
  ApplicationElementDataBlock = 'APPLICATION_ELEMENT_DATA_BLOCK',
  ApplicationElementDiagnosesBlock = 'APPLICATION_ELEMENT_DIAGNOSES_BLOCK',
  ApplicationElementDiagnosisList = 'APPLICATION_ELEMENT_DIAGNOSIS_LIST',
  ApplicationElementDischargeAppointments = 'APPLICATION_ELEMENT_DISCHARGE_APPOINTMENTS',
  ApplicationElementDischargeAssessment = 'APPLICATION_ELEMENT_DISCHARGE_ASSESSMENT',
  ApplicationElementDischargeComments = 'APPLICATION_ELEMENT_DISCHARGE_COMMENTS',
  ApplicationElementDischargeInformation = 'APPLICATION_ELEMENT_DISCHARGE_INFORMATION',
  ApplicationElementDischargeLetter = 'APPLICATION_ELEMENT_DISCHARGE_LETTER',
  ApplicationElementDischargeMedication = 'APPLICATION_ELEMENT_DISCHARGE_MEDICATION',
  ApplicationElementDischargeOrdersAndForms = 'APPLICATION_ELEMENT_DISCHARGE_ORDERS_AND_FORMS',
  ApplicationElementDischargeOverview = 'APPLICATION_ELEMENT_DISCHARGE_OVERVIEW',
  ApplicationElementDocumentsBlock = 'APPLICATION_ELEMENT_DOCUMENTS_BLOCK',
  ApplicationElementEpaConfigurationCustomItems = 'APPLICATION_ELEMENT_EPA_CONFIGURATION_CUSTOM_ITEMS',
  ApplicationElementEvents = 'APPLICATION_ELEMENT_EVENTS',
  ApplicationElementFindingsBlock = 'APPLICATION_ELEMENT_FINDINGS_BLOCK',
  ApplicationElementFlagsBlock = 'APPLICATION_ELEMENT_FLAGS_BLOCK',
  ApplicationElementFormsBlock = 'APPLICATION_ELEMENT_FORMS_BLOCK',
  ApplicationElementFurtherProceduresStep = 'APPLICATION_ELEMENT_FURTHER_PROCEDURES_STEP',
  ApplicationElementHospitalization = 'APPLICATION_ELEMENT_HOSPITALIZATION',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementHospitalizationDetails = 'APPLICATION_ELEMENT_HOSPITALIZATION_DETAILS',
  ApplicationElementImagesBlock = 'APPLICATION_ELEMENT_IMAGES_BLOCK',
  ApplicationElementIncomingClinicalRequests = 'APPLICATION_ELEMENT_INCOMING_CLINICAL_REQUESTS',
  ApplicationElementInfectionsBlock = 'APPLICATION_ELEMENT_INFECTIONS_BLOCK',
  ApplicationElementInpatientEventFunction = 'APPLICATION_ELEMENT_INPATIENT_EVENT_FUNCTION',
  ApplicationElementInterventions = 'APPLICATION_ELEMENT_INTERVENTIONS',
  ApplicationElementInvoiceBg = 'APPLICATION_ELEMENT_INVOICE_BG',
  ApplicationElementInvoiceKv = 'APPLICATION_ELEMENT_INVOICE_KV',
  ApplicationElementInvoicePrivate = 'APPLICATION_ELEMENT_INVOICE_PRIVATE',
  ApplicationElementLabResults = 'APPLICATION_ELEMENT_LAB_RESULTS',
  ApplicationElementLabResultsBlock = 'APPLICATION_ELEMENT_LAB_RESULTS_BLOCK',
  /** Administratives Personal Formulare */
  ApplicationElementLimitedAdministrativeStaffForm = 'APPLICATION_ELEMENT_LIMITED_ADMINISTRATIVE_STAFF_FORM',
  /** Pflege-Formulare (z.B. "Präoperative Checkliste Pflege") */
  ApplicationElementLimitedCareForm = 'APPLICATION_ELEMENT_LIMITED_CARE_FORM',
  /** Arzt-Formulare (z.B. "Präoperative Checkliste Arzt") */
  ApplicationElementLimitedDoctorForm = 'APPLICATION_ELEMENT_LIMITED_DOCTOR_FORM',
  /** these are mapped to values of form.FormAccessType. Medizinisches Personal Formulare (Arzt + Pflege) */
  ApplicationElementLimitedMedicalStaffForm = 'APPLICATION_ELEMENT_LIMITED_MEDICAL_STAFF_FORM',
  /** OP Anästhesie Pflege-Formulare */
  ApplicationElementLimitedSurgeryAnesthesiologicalCareForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_ANESTHESIOLOGICAL_CARE_FORM',
  /** OP Anästhesist-Formulare */
  ApplicationElementLimitedSurgeryAnesthesiologistForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_ANESTHESIOLOGIST_FORM',
  /** OP Anästhesie Formulare (z.B. "Anästhesie Checkliste") (op pflege + op anästhesie) */
  ApplicationElementLimitedSurgeryAnesthesiologyTeamForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_ANESTHESIOLOGY_TEAM_FORM',
  /** OP Pflege-Formulare (op + anästhesie pflege) */
  ApplicationElementLimitedSurgeryCareForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_CARE_FORM',
  /** OP Arzt-Formulare (op arzt + anästhesist) */
  ApplicationElementLimitedSurgeryDoctorForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_DOCTOR_FORM',
  /** OP Medizinisches Personal Formulare (z.B. "Sign-In Checkliste", "Team-Time-Out Checkliste", "Sign-Out Checkliste", "Patientenzustand bei Verlegung") (op arzt + anästhesist, op + anästhesie pflege) */
  ApplicationElementLimitedSurgeryMedicalStaffForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_MEDICAL_STAFF_FORM',
  /** OP Personal Formulare (all roles from surgery) */
  ApplicationElementLimitedSurgeryStaffForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_STAFF_FORM',
  /** OP OP-Arzt-Formulare */
  ApplicationElementLimitedSurgerySurgeonForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_SURGEON_FORM',
  /** OP Chirurgie Pflege-Formulare */
  ApplicationElementLimitedSurgerySurgicalCareForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_SURGICAL_CARE_FORM',
  /** OP Chirurgie Formulare (op op arzt + op chirurgie pflege) */
  ApplicationElementLimitedSurgerySurgicalTeamForm = 'APPLICATION_ELEMENT_LIMITED_SURGERY_SURGICAL_TEAM_FORM',
  ApplicationElementMedicalLetter = 'APPLICATION_ELEMENT_MEDICAL_LETTER',
  ApplicationElementMedicalLetterList = 'APPLICATION_ELEMENT_MEDICAL_LETTER_LIST',
  ApplicationElementMedicalProgress = 'APPLICATION_ELEMENT_MEDICAL_PROGRESS',
  ApplicationElementMedicalTabTasks = 'APPLICATION_ELEMENT_MEDICAL_TAB_TASKS',
  ApplicationElementMedicalTabTaskExecution = 'APPLICATION_ELEMENT_MEDICAL_TAB_TASK_EXECUTION',
  ApplicationElementMedication = 'APPLICATION_ELEMENT_MEDICATION',
  ApplicationElementMedicationBlock = 'APPLICATION_ELEMENT_MEDICATION_BLOCK',
  ApplicationElementMedicationList = 'APPLICATION_ELEMENT_MEDICATION_LIST',
  ApplicationElementMedicationPlanTab = 'APPLICATION_ELEMENT_MEDICATION_PLAN_TAB',
  ApplicationElementMedicationPreparation = 'APPLICATION_ELEMENT_MEDICATION_PREPARATION',
  ApplicationElementNone = 'APPLICATION_ELEMENT_NONE',
  ApplicationElementOrders = 'APPLICATION_ELEMENT_ORDERS',
  ApplicationElementOutgoingClinicalRequests = 'APPLICATION_ELEMENT_OUTGOING_CLINICAL_REQUESTS',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementPatientCondition = 'APPLICATION_ELEMENT_PATIENT_CONDITION',
  ApplicationElementPatientLetter = 'APPLICATION_ELEMENT_PATIENT_LETTER',
  ApplicationElementPatientList = 'APPLICATION_ELEMENT_PATIENT_LIST',
  /** pharmacy tab */
  ApplicationElementPharmacyMedicationConfiguration = 'APPLICATION_ELEMENT_PHARMACY_MEDICATION_CONFIGURATION',
  ApplicationElementPharmacyMedicationValidation = 'APPLICATION_ELEMENT_PHARMACY_MEDICATION_VALIDATION',
  ApplicationElementPositionsCoding = 'APPLICATION_ELEMENT_POSITIONS_CODING',
  ApplicationElementPostOperativeCareUnit = 'APPLICATION_ELEMENT_POST_OPERATIVE_CARE_UNIT',
  ApplicationElementPpr = 'APPLICATION_ELEMENT_PPR',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementPreoperativeChecklist = 'APPLICATION_ELEMENT_PREOPERATIVE_CHECKLIST',
  ApplicationElementPreviousSurgeries = 'APPLICATION_ELEMENT_PREVIOUS_SURGERIES',
  ApplicationElementQs = 'APPLICATION_ELEMENT_QS',
  /** Reanimationsinformationen */
  ApplicationElementReanimation = 'APPLICATION_ELEMENT_REANIMATION',
  ApplicationElementRecommendations = 'APPLICATION_ELEMENT_RECOMMENDATIONS',
  /** Zuweiser/in block in anamnesis */
  ApplicationElementReferringBlock = 'APPLICATION_ELEMENT_REFERRING_BLOCK',
  ApplicationElementRolesAndRightsConfigurations = 'APPLICATION_ELEMENT_ROLES_AND_RIGHTS_CONFIGURATIONS',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementSignInChecklist = 'APPLICATION_ELEMENT_SIGN_IN_CHECKLIST',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementSignOutChecklist = 'APPLICATION_ELEMENT_SIGN_OUT_CHECKLIST',
  ApplicationElementSurgeryMaterialPlanning = 'APPLICATION_ELEMENT_SURGERY_MATERIAL_PLANNING',
  ApplicationElementSurgeryOverviewBlock = 'APPLICATION_ELEMENT_SURGERY_OVERVIEW_BLOCK',
  ApplicationElementSurgeryProcessOverview = 'APPLICATION_ELEMENT_SURGERY_PROCESS_OVERVIEW',
  ApplicationElementSurgeryRecommendations = 'APPLICATION_ELEMENT_SURGERY_RECOMMENDATIONS',
  ApplicationElementSurgeryRequestList = 'APPLICATION_ELEMENT_SURGERY_REQUEST_LIST',
  ApplicationElementSurgeryTeams = 'APPLICATION_ELEMENT_SURGERY_TEAMS',
  ApplicationElementSurgicalClearance = 'APPLICATION_ELEMENT_SURGICAL_CLEARANCE',
  ApplicationElementSurgicalDocumentation = 'APPLICATION_ELEMENT_SURGICAL_DOCUMENTATION',
  ApplicationElementSurgicalInformation = 'APPLICATION_ELEMENT_SURGICAL_INFORMATION',
  ApplicationElementSymptoms = 'APPLICATION_ELEMENT_SYMPTOMS',
  ApplicationElementTasksBlock = 'APPLICATION_ELEMENT_TASKS_BLOCK',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  ApplicationElementTeamTimeoutChecklist = 'APPLICATION_ELEMENT_TEAM_TIMEOUT_CHECKLIST',
  ApplicationElementTherapyStep = 'APPLICATION_ELEMENT_THERAPY_STEP',
  ApplicationElementTreatmentsBlock = 'APPLICATION_ELEMENT_TREATMENTS_BLOCK',
  ApplicationElementVitals = 'APPLICATION_ELEMENT_VITALS'
}

export enum Common_Access_ApplicationModule {
  ApplicationModuleAdministration = 'APPLICATION_MODULE_ADMINISTRATION',
  ApplicationModuleAnamnesis = 'APPLICATION_MODULE_ANAMNESIS',
  ApplicationModuleBilling = 'APPLICATION_MODULE_BILLING',
  ApplicationModuleCalendar = 'APPLICATION_MODULE_CALENDAR',
  ApplicationModuleCareAdmissionTreatment = 'APPLICATION_MODULE_CARE_ADMISSION_TREATMENT',
  ApplicationModuleCaseAndVisitInformation = 'APPLICATION_MODULE_CASE_AND_VISIT_INFORMATION',
  ApplicationModuleClinicalRequests = 'APPLICATION_MODULE_CLINICAL_REQUESTS',
  ApplicationModuleConfiguration = 'APPLICATION_MODULE_CONFIGURATION',
  ApplicationModuleCoreData = 'APPLICATION_MODULE_CORE_DATA',
  ApplicationModuleDischarge = 'APPLICATION_MODULE_DISCHARGE',
  ApplicationModuleFindingsInbox = 'APPLICATION_MODULE_FINDINGS_INBOX',
  ApplicationModuleForm = 'APPLICATION_MODULE_FORM',
  /** renamed from APPLICATION_MODULE_COCKPIT */
  ApplicationModuleInpatientCockpit = 'APPLICATION_MODULE_INPATIENT_COCKPIT',
  ApplicationModuleLabRequests = 'APPLICATION_MODULE_LAB_REQUESTS',
  /** Patientenverfügung & Selbstbestimmung */
  ApplicationModuleLivingWillAndInvasiveProcedures = 'APPLICATION_MODULE_LIVING_WILL_AND_INVASIVE_PROCEDURES',
  ApplicationModuleMedicalAdmissionTreatment = 'APPLICATION_MODULE_MEDICAL_ADMISSION_TREATMENT',
  ApplicationModuleMedicalLetter = 'APPLICATION_MODULE_MEDICAL_LETTER',
  ApplicationModuleNone = 'APPLICATION_MODULE_NONE',
  ApplicationModuleOccupancyManagement = 'APPLICATION_MODULE_OCCUPANCY_MANAGEMENT',
  ApplicationModuleOpCalendar = 'APPLICATION_MODULE_OP_CALENDAR',
  ApplicationModuleOutpatientCockpit = 'APPLICATION_MODULE_OUTPATIENT_COCKPIT',
  ApplicationModuleOutpatientTreatment = 'APPLICATION_MODULE_OUTPATIENT_TREATMENT',
  ApplicationModulePatientChart = 'APPLICATION_MODULE_PATIENT_CHART',
  ApplicationModulePharmacy = 'APPLICATION_MODULE_PHARMACY',
  ApplicationModulePositionsCoding = 'APPLICATION_MODULE_POSITIONS_CODING',
  ApplicationModulePreanestheticAssessmentTreatment = 'APPLICATION_MODULE_PREANESTHETIC_ASSESSMENT_TREATMENT',
  ApplicationModulePreoperativeAssessmentTreatment = 'APPLICATION_MODULE_PREOPERATIVE_ASSESSMENT_TREATMENT',
  ApplicationModuleQs = 'APPLICATION_MODULE_QS',
  ApplicationModuleRequests = 'APPLICATION_MODULE_REQUESTS',
  ApplicationModuleRolesAndRightsConfigurations = 'APPLICATION_MODULE_ROLES_AND_RIGHTS_CONFIGURATIONS',
  ApplicationModuleSurgeryCockpit = 'APPLICATION_MODULE_SURGERY_COCKPIT',
  ApplicationModuleSurgeryDocumentation = 'APPLICATION_MODULE_SURGERY_DOCUMENTATION',
  ApplicationModuleSurgeryPatientChart = 'APPLICATION_MODULE_SURGERY_PATIENT_CHART',
  ApplicationModuleSurgeryRequests = 'APPLICATION_MODULE_SURGERY_REQUESTS',
  ApplicationModuleSurgeryWorklist = 'APPLICATION_MODULE_SURGERY_WORKLIST',
  ApplicationModuleTreatment = 'APPLICATION_MODULE_TREATMENT',
  ApplicationModuleWardOverview = 'APPLICATION_MODULE_WARD_OVERVIEW',
  ApplicationModuleWardWorklist = 'APPLICATION_MODULE_WARD_WORKLIST'
}

export enum Common_Access_CaseAction {
  CaseActionArchive = 'CASE_ACTION_ARCHIVE',
  CaseActionBilling = 'CASE_ACTION_BILLING',
  CaseActionCancel = 'CASE_ACTION_CANCEL',
  CaseActionChange = 'CASE_ACTION_CHANGE',
  CaseActionChangeBillingStatus = 'CASE_ACTION_CHANGE_BILLING_STATUS',
  CaseActionCockpit = 'CASE_ACTION_COCKPIT',
  CaseActionCoreData = 'CASE_ACTION_CORE_DATA',
  CaseActionDelete = 'CASE_ACTION_DELETE',
  CaseActionMerge = 'CASE_ACTION_MERGE',
  CaseActionNone = 'CASE_ACTION_NONE',
  CaseActionRegister = 'CASE_ACTION_REGISTER',
  CaseActionTransferHistory = 'CASE_ACTION_TRANSFER_HISTORY'
}

export enum Common_Access_CockpitAction {
  CockpitActionAssignPersonnel = 'COCKPIT_ACTION_ASSIGN_PERSONNEL',
  CockpitActionChangeAdmissionDate = 'COCKPIT_ACTION_CHANGE_ADMISSION_DATE',
  CockpitActionChangeDischargeDate = 'COCKPIT_ACTION_CHANGE_DISCHARGE_DATE',
  CockpitActionNone = 'COCKPIT_ACTION_NONE',
  CockpitActionStartCareAdmission = 'COCKPIT_ACTION_START_CARE_ADMISSION',
  CockpitActionStartMedicalAdmission = 'COCKPIT_ACTION_START_MEDICAL_ADMISSION',
  CockpitActionStartOrContinueTreatment = 'COCKPIT_ACTION_START_OR_CONTINUE_TREATMENT'
}

export enum Common_Access_ConfigurationAction {
  ConfigurationActionExportAssessment = 'CONFIGURATION_ACTION_EXPORT_ASSESSMENT',
  ConfigurationActionNone = 'CONFIGURATION_ACTION_NONE'
}

export type Common_Access_ContextPathKeyMsg = {
  __typename?: 'common_access_ContextPathKeyMsg';
  context?: Maybe<Common_Access_PathKeyContext>;
  pathKey?: Maybe<Common_Access_PathKeyMsg>;
};

export enum Common_Access_CoreDataAction {
  CoreDataActionDelete = 'CORE_DATA_ACTION_DELETE',
  CoreDataActionNone = 'CORE_DATA_ACTION_NONE',
  CoreDataActionSign = 'CORE_DATA_ACTION_SIGN',
  CoreDataActionValidate = 'CORE_DATA_ACTION_VALIDATE'
}

export enum Common_Access_DischargeAction {
  DischargeActionCompleteDischarge = 'DISCHARGE_ACTION_COMPLETE_DISCHARGE',
  DischargeActionNone = 'DISCHARGE_ACTION_NONE'
}

export enum Common_Access_FindingAction {
  FindingActionAcknowledge = 'FINDING_ACTION_ACKNOWLEDGE',
  FindingActionNone = 'FINDING_ACTION_NONE',
  FindingActionRequestAcknowledgement = 'FINDING_ACTION_REQUEST_ACKNOWLEDGEMENT'
}

export enum Common_Access_FormsAction {
  FormsActionNone = 'FORMS_ACTION_NONE',
  FormsActionSign = 'FORMS_ACTION_SIGN'
}

export type Common_Access_ListAccessConstraintsResponse = {
  __typename?: 'common_access_ListAccessConstraintsResponse';
  pathKeyAccessConstraints?: Maybe<Array<Maybe<Common_Access_PathKeyAccessConstraintMsg>>>;
  scopedAccessConstraints?: Maybe<Array<Maybe<Common_Access_ScopedAccessConstraintMsg>>>;
};

export type Common_Access_ListRouteConstraintsRequest = {
  __typename?: 'common_access_ListRouteConstraintsRequest';
  targetContext?: Maybe<Common_Access_TargetConstraint>;
};

export enum Common_Access_MedicationAction {
  MedicationActionAdd = 'MEDICATION_ACTION_ADD',
  MedicationActionAddSingleAdministration = 'MEDICATION_ACTION_ADD_SINGLE_ADMINISTRATION',
  MedicationActionAddSingleAdministrationForDemandMedication = 'MEDICATION_ACTION_ADD_SINGLE_ADMINISTRATION_FOR_DEMAND_MEDICATION',
  MedicationActionAuthorize = 'MEDICATION_ACTION_AUTHORIZE',
  MedicationActionDiscontinue = 'MEDICATION_ACTION_DISCONTINUE',
  MedicationActionMedicationAdministration = 'MEDICATION_ACTION_MEDICATION_ADMINISTRATION',
  MedicationActionNone = 'MEDICATION_ACTION_NONE',
  MedicationActionPause = 'MEDICATION_ACTION_PAUSE',
  MedicationActionReadBmp = 'MEDICATION_ACTION_READ_BMP',
  MedicationActionUpdate = 'MEDICATION_ACTION_UPDATE'
}

export enum Common_Access_MetaAnamnesisAction {
  MetaAnamnesisActionAddUpdateReferrer = 'META_ANAMNESIS_ACTION_ADD_UPDATE_REFERRER',
  MetaAnamnesisActionNone = 'META_ANAMNESIS_ACTION_NONE'
}

export enum Common_Access_OccupancyManagementAction {
  OccupancyManagementActionNone = 'OCCUPANCY_MANAGEMENT_ACTION_NONE',
  OccupancyManagementActionScheduleAdmission = 'OCCUPANCY_MANAGEMENT_ACTION_SCHEDULE_ADMISSION'
}

export type Common_Access_PathKeyAccessConstraintMsg = {
  __typename?: 'common_access_PathKeyAccessConstraintMsg';
  accessConstraint?: Maybe<Common_Access_AccessConstraint>;
  contextPathKey?: Maybe<Common_Access_ContextPathKeyMsg>;
};

export enum Common_Access_PathKeyContext {
  PathKeyContextAnamnesis = 'PATH_KEY_CONTEXT_ANAMNESIS',
  PathKeyContextNone = 'PATH_KEY_CONTEXT_NONE',
  PathKeyContextPhysicalExamination = 'PATH_KEY_CONTEXT_PHYSICAL_EXAMINATION'
}

export type Common_Access_PathKeyMsg = {
  __typename?: 'common_access_PathKeyMsg';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export enum Common_Access_PatientAction {
  PatientActionArchive = 'PATIENT_ACTION_ARCHIVE',
  PatientActionBilling = 'PATIENT_ACTION_BILLING',
  PatientActionCoreData = 'PATIENT_ACTION_CORE_DATA',
  PatientActionDelete = 'PATIENT_ACTION_DELETE',
  PatientActionNone = 'PATIENT_ACTION_NONE',
  PatientActionRegister = 'PATIENT_ACTION_REGISTER'
}

export enum Common_Access_PatientChartAction {
  PatientChartActionNone = 'PATIENT_CHART_ACTION_NONE'
}

export enum Common_Access_PatientLetterAction {
  PatientLetterActionEditCareTransferLetter = 'PATIENT_LETTER_ACTION_EDIT_CARE_TRANSFER_LETTER',
  PatientLetterActionEditDischargeLetter = 'PATIENT_LETTER_ACTION_EDIT_DISCHARGE_LETTER',
  PatientLetterActionNone = 'PATIENT_LETTER_ACTION_NONE',
  PatientLetterActionSign = 'PATIENT_LETTER_ACTION_SIGN'
}

export enum Common_Access_ReportsAndProtocolsAction {
  ReportsAndProtocolsActionNone = 'REPORTS_AND_PROTOCOLS_ACTION_NONE',
  ReportsAndProtocolsActionReleaseAnesthesiologyDocumentation = 'REPORTS_AND_PROTOCOLS_ACTION_RELEASE_ANESTHESIOLOGY_DOCUMENTATION',
  ReportsAndProtocolsActionReleaseIntraoperativeDocumentation = 'REPORTS_AND_PROTOCOLS_ACTION_RELEASE_INTRAOPERATIVE_DOCUMENTATION'
}

export enum Common_Access_RequestsAction {
  RequestsActionCreateClinicalRequest = 'REQUESTS_ACTION_CREATE_CLINICAL_REQUEST',
  RequestsActionCreateSurgeryRequest = 'REQUESTS_ACTION_CREATE_SURGERY_REQUEST',
  RequestsActionNone = 'REQUESTS_ACTION_NONE',
  RequestsActionSign = 'REQUESTS_ACTION_SIGN',
  RequestsActionSubmit = 'REQUESTS_ACTION_SUBMIT'
}

export enum Common_Access_RouteConstraint {
  RouteConstraintAdministrationAndAdmission = 'ROUTE_CONSTRAINT_ADMINISTRATION_AND_ADMISSION',
  RouteConstraintBilling = 'ROUTE_CONSTRAINT_BILLING',
  RouteConstraintBillingConfigurations = 'ROUTE_CONSTRAINT_BILLING_CONFIGURATIONS',
  RouteConstraintCalendar = 'ROUTE_CONSTRAINT_CALENDAR',
  RouteConstraintCareAdmission = 'ROUTE_CONSTRAINT_CARE_ADMISSION',
  RouteConstraintCareAssessmentsConfiguration = 'ROUTE_CONSTRAINT_CARE_ASSESSMENTS_CONFIGURATION',
  RouteConstraintCaseAndVisitInformation = 'ROUTE_CONSTRAINT_CASE_AND_VISIT_INFORMATION',
  RouteConstraintCoreData = 'ROUTE_CONSTRAINT_CORE_DATA',
  RouteConstraintCreateClinicalRequest = 'ROUTE_CONSTRAINT_CREATE_CLINICAL_REQUEST',
  RouteConstraintCreateOrEditMedicalLetter = 'ROUTE_CONSTRAINT_CREATE_OR_EDIT_MEDICAL_LETTER',
  RouteConstraintCreateSurgeryRequest = 'ROUTE_CONSTRAINT_CREATE_SURGERY_REQUEST',
  RouteConstraintDale = 'ROUTE_CONSTRAINT_DALE',
  RouteConstraintDeviceAndAppConfiguration = 'ROUTE_CONSTRAINT_DEVICE_AND_APP_CONFIGURATION',
  RouteConstraintDischargeManagement = 'ROUTE_CONSTRAINT_DISCHARGE_MANAGEMENT',
  RouteConstraintDrgWorkplace = 'ROUTE_CONSTRAINT_DRG_WORKPLACE',
  RouteConstraintEpaAssessment = 'ROUTE_CONSTRAINT_EPA_ASSESSMENT',
  RouteConstraintFindingsInbox = 'ROUTE_CONSTRAINT_FINDINGS_INBOX',
  RouteConstraintKim = 'ROUTE_CONSTRAINT_KIM',
  RouteConstraintKvBillingWorkplace = 'ROUTE_CONSTRAINT_KV_BILLING_WORKPLACE',
  RouteConstraintMedicalAdmission = 'ROUTE_CONSTRAINT_MEDICAL_ADMISSION',
  RouteConstraintMedicalLetters = 'ROUTE_CONSTRAINT_MEDICAL_LETTERS',
  RouteConstraintNone = 'ROUTE_CONSTRAINT_NONE',
  RouteConstraintOccupancyManagement = 'ROUTE_CONSTRAINT_OCCUPANCY_MANAGEMENT',
  RouteConstraintOutpatientCockpit = 'ROUTE_CONSTRAINT_OUTPATIENT_COCKPIT',
  RouteConstraintOutpatientTreatment = 'ROUTE_CONSTRAINT_OUTPATIENT_TREATMENT',
  RouteConstraintPatientOverview = 'ROUTE_CONSTRAINT_PATIENT_OVERVIEW',
  RouteConstraintPharmacyConfiguration = 'ROUTE_CONSTRAINT_PHARMACY_CONFIGURATION',
  RouteConstraintPortalConfigurations = 'ROUTE_CONSTRAINT_PORTAL_CONFIGURATIONS',
  RouteConstraintPpr = 'ROUTE_CONSTRAINT_PPR',
  RouteConstraintPreoperativeVisitAnaesthesiology = 'ROUTE_CONSTRAINT_PREOPERATIVE_VISIT_ANAESTHESIOLOGY',
  RouteConstraintPreoperativeVisitSurgery = 'ROUTE_CONSTRAINT_PREOPERATIVE_VISIT_SURGERY',
  RouteConstraintRegisterVisit = 'ROUTE_CONSTRAINT_REGISTER_VISIT',
  RouteConstraintRequests = 'ROUTE_CONSTRAINT_REQUESTS',
  RouteConstraintRolesAndRightsConfigurations = 'ROUTE_CONSTRAINT_ROLES_AND_RIGHTS_CONFIGURATIONS',
  RouteConstraintStatistics = 'ROUTE_CONSTRAINT_STATISTICS',
  RouteConstraintSurgeryCalendar = 'ROUTE_CONSTRAINT_SURGERY_CALENDAR',
  RouteConstraintSurgeryCockpit = 'ROUTE_CONSTRAINT_SURGERY_COCKPIT',
  RouteConstraintSurgeryWorklist = 'ROUTE_CONSTRAINT_SURGERY_WORKLIST',
  RouteConstraintUnregisteredPatients = 'ROUTE_CONSTRAINT_UNREGISTERED_PATIENTS',
  RouteConstraintVisitOverview = 'ROUTE_CONSTRAINT_VISIT_OVERVIEW',
  RouteConstraintWardOverview = 'ROUTE_CONSTRAINT_WARD_OVERVIEW',
  RouteConstraintWardWorklist = 'ROUTE_CONSTRAINT_WARD_WORKLIST'
}

export type Common_Access_RouteConstraintList = {
  __typename?: 'common_access_RouteConstraintList';
  routeConstraints?: Maybe<Array<Maybe<Common_Access_RouteConstraint>>>;
};

export type Common_Access_ScopedAccessConstraintMsg = {
  __typename?: 'common_access_ScopedAccessConstraintMsg';
  accessConstraint?: Maybe<Common_Access_AccessConstraint>;
  anesthesiaPlanAction?: Maybe<Common_Access_AnesthesiaPlanAction>;
  applicationElement?: Maybe<Common_Access_ApplicationElement>;
  applicationModule?: Maybe<Common_Access_ApplicationModule>;
  caseAction?: Maybe<Common_Access_CaseAction>;
  cockpitAction?: Maybe<Common_Access_CockpitAction>;
  configurationAction?: Maybe<Common_Access_ConfigurationAction>;
  coreDataAction?: Maybe<Common_Access_CoreDataAction>;
  dischargeAction?: Maybe<Common_Access_DischargeAction>;
  findingAction?: Maybe<Common_Access_FindingAction>;
  formsAction?: Maybe<Common_Access_FormsAction>;
  medicationAction?: Maybe<Common_Access_MedicationAction>;
  metaAnamnesisAction?: Maybe<Common_Access_MetaAnamnesisAction>;
  /**
   * theoretically all following oneof, but not used since otherwise issues in the database backend
   *  used when there is neither an element nor an action specified
   */
  moduleAccessConstraint?: Maybe<Common_Access_AccessConstraint>;
  noAction?: Maybe<Scalars['Boolean']>;
  occupancyManagementAction?: Maybe<Common_Access_OccupancyManagementAction>;
  patientAction?: Maybe<Common_Access_PatientAction>;
  patientChartAction?: Maybe<Common_Access_PatientChartAction>;
  patientLetterAction?: Maybe<Common_Access_PatientLetterAction>;
  reportsAndProtocolsAction?: Maybe<Common_Access_ReportsAndProtocolsAction>;
  requestsAction?: Maybe<Common_Access_RequestsAction>;
  surgeryCalendarAction?: Maybe<Common_Access_SurgeryCalendarAction>;
  surgeryWorklistAction?: Maybe<Common_Access_SurgeryWorklistAction>;
  surgicalCockpitAction?: Maybe<Common_Access_SurgicalCockpitAction>;
  treatmentAction?: Maybe<Common_Access_TreatmentAction>;
  visitAction?: Maybe<Common_Access_VisitAction>;
  wardOverviewAction?: Maybe<Common_Access_WardOverviewAction>;
};

export enum Common_Access_SurgeryCalendarAction {
  SurgeryCalendarActionAddPlaceholder = 'SURGERY_CALENDAR_ACTION_ADD_PLACEHOLDER',
  SurgeryCalendarActionBookSurgery = 'SURGERY_CALENDAR_ACTION_BOOK_SURGERY',
  SurgeryCalendarActionCancelSurgeryRequest = 'SURGERY_CALENDAR_ACTION_CANCEL_SURGERY_REQUEST',
  SurgeryCalendarActionChangeOperatingRoomCapacity = 'SURGERY_CALENDAR_ACTION_CHANGE_OPERATING_ROOM_CAPACITY',
  SurgeryCalendarActionCreateSurgeryRequest = 'SURGERY_CALENDAR_ACTION_CREATE_SURGERY_REQUEST',
  SurgeryCalendarActionLockDevice = 'SURGERY_CALENDAR_ACTION_LOCK_DEVICE',
  SurgeryCalendarActionLockOperatingRoom = 'SURGERY_CALENDAR_ACTION_LOCK_OPERATING_ROOM',
  SurgeryCalendarActionNone = 'SURGERY_CALENDAR_ACTION_NONE',
  SurgeryCalendarActionReleaseSurgeryPlan = 'SURGERY_CALENDAR_ACTION_RELEASE_SURGERY_PLAN'
}

export enum Common_Access_SurgeryWorklistAction {
  SurgeryWorklistActionBookSurgery = 'SURGERY_WORKLIST_ACTION_BOOK_SURGERY',
  SurgeryWorklistActionCancelSurgery = 'SURGERY_WORKLIST_ACTION_CANCEL_SURGERY',
  SurgeryWorklistActionCancelSurgerySlot = 'SURGERY_WORKLIST_ACTION_CANCEL_SURGERY_SLOT',
  SurgeryWorklistActionNone = 'SURGERY_WORKLIST_ACTION_NONE',
  SurgeryWorklistActionOpenCockpit = 'SURGERY_WORKLIST_ACTION_OPEN_COCKPIT',
  SurgeryWorklistActionRebookSurgery = 'SURGERY_WORKLIST_ACTION_REBOOK_SURGERY'
}

export enum Common_Access_SurgicalCockpitAction {
  SurgicalCockpitActionContinuePreanestheticAssessment = 'SURGICAL_COCKPIT_ACTION_CONTINUE_PREANESTHETIC_ASSESSMENT',
  SurgicalCockpitActionContinuePreoperativeAssessment = 'SURGICAL_COCKPIT_ACTION_CONTINUE_PREOPERATIVE_ASSESSMENT',
  SurgicalCockpitActionEditAnesthesiologyClearanceStatus = 'SURGICAL_COCKPIT_ACTION_EDIT_ANESTHESIOLOGY_CLEARANCE_STATUS',
  SurgicalCockpitActionEditSurgicalClearanceStatus = 'SURGICAL_COCKPIT_ACTION_EDIT_SURGICAL_CLEARANCE_STATUS',
  SurgicalCockpitActionNone = 'SURGICAL_COCKPIT_ACTION_NONE',
  SurgicalCockpitActionStartPreanestheticAssessment = 'SURGICAL_COCKPIT_ACTION_START_PREANESTHETIC_ASSESSMENT',
  SurgicalCockpitActionStartPreoperativeAssessment = 'SURGICAL_COCKPIT_ACTION_START_PREOPERATIVE_ASSESSMENT'
}

export enum Common_Access_TargetConstraint {
  /** Station */
  TargetConstraintInpatient = 'TARGET_CONSTRAINT_INPATIENT',
  TargetConstraintNone = 'TARGET_CONSTRAINT_NONE',
  /** Ambulanz */
  TargetConstraintOutpatient = 'TARGET_CONSTRAINT_OUTPATIENT',
  /** OP */
  TargetConstraintSurgery = 'TARGET_CONSTRAINT_SURGERY'
}

export type Common_Access_TargetConstraintList = {
  __typename?: 'common_access_TargetConstraintList';
  targetConstraints?: Maybe<Array<Maybe<Common_Access_TargetConstraint>>>;
};

export type Common_Access_TargetedRouteConstraintMsg = {
  __typename?: 'common_access_TargetedRouteConstraintMsg';
  routeConstraints?: Maybe<Array<Maybe<Common_Access_RouteConstraint>>>;
  targetContext?: Maybe<Common_Access_TargetConstraint>;
};

export enum Common_Access_TreatmentAction {
  TreatmentActionAbort = 'TREATMENT_ACTION_ABORT',
  TreatmentActionFinish = 'TREATMENT_ACTION_FINISH',
  TreatmentActionFinishWithProtocol = 'TREATMENT_ACTION_FINISH_WITH_PROTOCOL',
  TreatmentActionNone = 'TREATMENT_ACTION_NONE'
}

export enum Common_Access_VisitAction {
  VisitActionArchive = 'VISIT_ACTION_ARCHIVE',
  VisitActionBilling = 'VISIT_ACTION_BILLING',
  VisitActionCancel = 'VISIT_ACTION_CANCEL',
  VisitActionCaseAndVisitInformation = 'VISIT_ACTION_CASE_AND_VISIT_INFORMATION',
  VisitActionChangeAdmissionDate = 'VISIT_ACTION_CHANGE_ADMISSION_DATE',
  VisitActionChangeCase = 'VISIT_ACTION_CHANGE_CASE',
  VisitActionChangeDischargeDate = 'VISIT_ACTION_CHANGE_DISCHARGE_DATE',
  VisitActionCockpit = 'VISIT_ACTION_COCKPIT',
  VisitActionFinishRegistration = 'VISIT_ACTION_FINISH_REGISTRATION',
  VisitActionInterfaces = 'VISIT_ACTION_INTERFACES',
  VisitActionLinkAccompanyingPerson = 'VISIT_ACTION_LINK_ACCOMPANYING_PERSON',
  VisitActionNone = 'VISIT_ACTION_NONE',
  VisitActionRegister = 'VISIT_ACTION_REGISTER',
  VisitActionRegisterAndLinkAccompanyingPerson = 'VISIT_ACTION_REGISTER_AND_LINK_ACCOMPANYING_PERSON',
  VisitActionTransferHistory = 'VISIT_ACTION_TRANSFER_HISTORY'
}

export enum Common_Access_WardOverviewAction {
  WardOverviewActionAssignBed = 'WARD_OVERVIEW_ACTION_ASSIGN_BED',
  WardOverviewActionAssignPatient = 'WARD_OVERVIEW_ACTION_ASSIGN_PATIENT',
  WardOverviewActionAssignPersonnel = 'WARD_OVERVIEW_ACTION_ASSIGN_PERSONNEL',
  /**
   * not used anywhere
   * @deprecated deprecated in proto
   */
  WardOverviewActionAssignVisit = 'WARD_OVERVIEW_ACTION_ASSIGN_VISIT',
  WardOverviewActionBlockBed = 'WARD_OVERVIEW_ACTION_BLOCK_BED',
  WardOverviewActionChangeAdmissionDate = 'WARD_OVERVIEW_ACTION_CHANGE_ADMISSION_DATE',
  WardOverviewActionChangeDischargeDate = 'WARD_OVERVIEW_ACTION_CHANGE_DISCHARGE_DATE',
  WardOverviewActionChangeLeadingDepartment = 'WARD_OVERVIEW_ACTION_CHANGE_LEADING_DEPARTMENT',
  WardOverviewActionChangeTreatmentCategory = 'WARD_OVERVIEW_ACTION_CHANGE_TREATMENT_CATEGORY',
  WardOverviewActionClinicInternalTransfer = 'WARD_OVERVIEW_ACTION_CLINIC_INTERNAL_TRANSFER',
  WardOverviewActionConfirmCareInstructionsColumn = 'WARD_OVERVIEW_ACTION_CONFIRM_CARE_INSTRUCTIONS_COLUMN',
  WardOverviewActionConfirmDoctorInstructionsColumn = 'WARD_OVERVIEW_ACTION_CONFIRM_DOCTOR_INSTRUCTIONS_COLUMN',
  WardOverviewActionConfirmMedicationColumn = 'WARD_OVERVIEW_ACTION_CONFIRM_MEDICATION_COLUMN',
  WardOverviewActionDischarge = 'WARD_OVERVIEW_ACTION_DISCHARGE',
  WardOverviewActionMarkAsAbsent = 'WARD_OVERVIEW_ACTION_MARK_AS_ABSENT',
  WardOverviewActionMarkAsHoliday = 'WARD_OVERVIEW_ACTION_MARK_AS_HOLIDAY',
  WardOverviewActionNone = 'WARD_OVERVIEW_ACTION_NONE',
  WardOverviewActionOpenCockpit = 'WARD_OVERVIEW_ACTION_OPEN_COCKPIT',
  WardOverviewActionOpenPatientChart = 'WARD_OVERVIEW_ACTION_OPEN_PATIENT_CHART',
  WardOverviewActionReleaseBed = 'WARD_OVERVIEW_ACTION_RELEASE_BED',
  WardOverviewActionReserveBed = 'WARD_OVERVIEW_ACTION_RESERVE_BED',
  WardOverviewActionReserveForPatient = 'WARD_OVERVIEW_ACTION_RESERVE_FOR_PATIENT',
  WardOverviewActionShowCoreData = 'WARD_OVERVIEW_ACTION_SHOW_CORE_DATA',
  WardOverviewActionWardInternalTransfer = 'WARD_OVERVIEW_ACTION_WARD_INTERNAL_TRANSFER'
}

export type Common_Letter_GetComponentLetterTextRequest = {
  __typename?: 'common_letter_GetComponentLetterTextRequest';
  /** For what the letter text should be returned */
  component?: Maybe<Common_Letter_LetterComponentReferenceMsg>;
  parameters?: Maybe<Common_Letter_LetterTextGenerationParametersMsg>;
  /**
   * Optional. Use this field for components that require a numbered heading (e.g., ReasonForPresentation, TherapyCard).
   *  selected component reference ids with the same component type (LetterComponentType) should be sent to derive numbered heading for the component
   */
  selectedComponentReferenceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Common_Letter_GetSectionLetterTextResponse = {
  __typename?: 'common_letter_GetSectionLetterTextResponse';
  /** The generated letterText for the given section */
  letterText?: Maybe<Core_LetterTextMsg>;
  /** The section from which the letterText was generated */
  sectionType?: Maybe<Common_Letter_LetterSectionType>;
};

export type Common_Letter_LetterComponentReferenceList = {
  __typename?: 'common_letter_LetterComponentReferenceList';
  references?: Maybe<Array<Maybe<Common_Letter_LetterComponentReferenceMsg>>>;
};

export type Common_Letter_LetterComponentReferenceMsg = {
  __typename?: 'common_letter_LetterComponentReferenceMsg';
  /**
   * Interpretation of the id depends on the component type:
   *  Typically, it's the id of the given component, but for components that don't have an own id, can be id of context.
   */
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Common_Letter_LetterComponentType>;
};

export enum Common_Letter_LetterComponentType {
  LetterComponentTypeAdmissionMedication = 'LETTER_COMPONENT_TYPE_ADMISSION_MEDICATION',
  /** Treatment service */
  LetterComponentTypeAdmissionTreatment = 'LETTER_COMPONENT_TYPE_ADMISSION_TREATMENT',
  LetterComponentTypeAllergy = 'LETTER_COMPONENT_TYPE_ALLERGY',
  /** for LETTER_COMPONENT_TYPE_ANAMNESIS_HISTORY LetterComponentReferenceMsg.referenceId corresponds to treatment#id */
  LetterComponentTypeAnamnesisHistory = 'LETTER_COMPONENT_TYPE_ANAMNESIS_HISTORY',
  LetterComponentTypeAnesthesiaFurtherDetails = 'LETTER_COMPONENT_TYPE_ANESTHESIA_FURTHER_DETAILS',
  LetterComponentTypeAnesthesiaMachine = 'LETTER_COMPONENT_TYPE_ANESTHESIA_MACHINE',
  /** Billing service */
  LetterComponentTypeBillingProcedure = 'LETTER_COMPONENT_TYPE_BILLING_PROCEDURE',
  LetterComponentTypeBloodBarrier = 'LETTER_COMPONENT_TYPE_BLOOD_BARRIER',
  /** Epa service */
  LetterComponentTypeCareDiagnoses = 'LETTER_COMPONENT_TYPE_CARE_DIAGNOSES',
  LetterComponentTypeCarePlan = 'LETTER_COMPONENT_TYPE_CARE_PLAN',
  LetterComponentTypeCareRisks = 'LETTER_COMPONENT_TYPE_CARE_RISKS',
  LetterComponentTypeClinicalRecommendation = 'LETTER_COMPONENT_TYPE_CLINICAL_RECOMMENDATION',
  /** Clinical request service */
  LetterComponentTypeClinicalRequest = 'LETTER_COMPONENT_TYPE_CLINICAL_REQUEST',
  LetterComponentTypeContaminationGrade = 'LETTER_COMPONENT_TYPE_CONTAMINATION_GRADE',
  LetterComponentTypeDesinfectionType = 'LETTER_COMPONENT_TYPE_DESINFECTION_TYPE',
  /**
   * diagnosis letter components are fetch through getDiagnosisComponentLetterText
   * @deprecated deprecated in proto
   */
  LetterComponentTypeDiagnosis = 'LETTER_COMPONENT_TYPE_DIAGNOSIS',
  LetterComponentTypeDischargeMedication = 'LETTER_COMPONENT_TYPE_DISCHARGE_MEDICATION',
  LetterComponentTypeElectrode = 'LETTER_COMPONENT_TYPE_ELECTRODE',
  LetterComponentTypeEmergence = 'LETTER_COMPONENT_TYPE_EMERGENCE',
  LetterComponentTypeFindings = 'LETTER_COMPONENT_TYPE_FINDINGS',
  /** for LETTER_COMPONENT_TYPE_PRESCRIPTIONS LetterComponentReferenceMsg.referenceId corresponds to either treatment id or the discharge id depending on the context */
  LetterComponentTypeFurtherProceduresMedication = 'LETTER_COMPONENT_TYPE_FURTHER_PROCEDURES_MEDICATION',
  LetterComponentTypeFurtherTreatmentRecommendations = 'LETTER_COMPONENT_TYPE_FURTHER_TREATMENT_RECOMMENDATIONS',
  /** for LETTER_COMPONENT_TYPE_GENERAL_ANAMNESIS LetterComponentReferenceMsg.referenceId corresponds to treatment#id */
  LetterComponentTypeGeneralAnamnesis = 'LETTER_COMPONENT_TYPE_GENERAL_ANAMNESIS',
  LetterComponentTypeLabRequest = 'LETTER_COMPONENT_TYPE_LAB_REQUEST',
  /** Lab service */
  LetterComponentTypeLabTestResult = 'LETTER_COMPONENT_TYPE_LAB_TEST_RESULT',
  LetterComponentTypeMaterialCount = 'LETTER_COMPONENT_TYPE_MATERIAL_COUNT',
  LetterComponentTypeMedicalDevice = 'LETTER_COMPONENT_TYPE_MEDICAL_DEVICE',
  /** Medication service */
  LetterComponentTypeMedicationPlan = 'LETTER_COMPONENT_TYPE_MEDICATION_PLAN',
  LetterComponentTypeNone = 'LETTER_COMPONENT_TYPE_NONE',
  LetterComponentTypeOperatingRoomCleaningType = 'LETTER_COMPONENT_TYPE_OPERATING_ROOM_CLEANING_TYPE',
  LetterComponentTypeOperatingRoomCondition = 'LETTER_COMPONENT_TYPE_OPERATING_ROOM_CONDITION',
  LetterComponentTypePositioning = 'LETTER_COMPONENT_TYPE_POSITIONING',
  LetterComponentTypePostoperativeCareUnit = 'LETTER_COMPONENT_TYPE_POSTOPERATIVE_CARE_UNIT',
  LetterComponentTypePostoperativeCareUnitRecommendations = 'LETTER_COMPONENT_TYPE_POSTOPERATIVE_CARE_UNIT_RECOMMENDATIONS',
  LetterComponentTypePostoperativeDiagnostic = 'LETTER_COMPONENT_TYPE_POSTOPERATIVE_DIAGNOSTIC',
  /** for LETTER_COMPONENT_TYPE_PRESCRIPTIONS LetterComponentReferenceMsg.referenceId corresponds to either treatment id or the discharge id depending on the context */
  LetterComponentTypePrescriptions = 'LETTER_COMPONENT_TYPE_PRESCRIPTIONS',
  /** for LETTER_COMPONENT_TYPE_PROCEDURE LetterComponentReferenceMsg.referenceId corresponds to treatment#therapy#therapies#id */
  LetterComponentTypeProcedure = 'LETTER_COMPONENT_TYPE_PROCEDURE',
  LetterComponentTypeProcedureStep = 'LETTER_COMPONENT_TYPE_PROCEDURE_STEP',
  LetterComponentTypeProgressTreatment = 'LETTER_COMPONENT_TYPE_PROGRESS_TREATMENT',
  LetterComponentTypeRadiologyService = 'LETTER_COMPONENT_TYPE_RADIOLOGY_SERVICE',
  /** for LETTER_COMPONENT_TYPE_REASON_FOR_PRESENTATION LetterComponentReferenceMsg.referenceId corresponds to treatment#anamnesis#sections#cards#reasonForPresentation#id */
  LetterComponentTypeReasonForPresentation = 'LETTER_COMPONENT_TYPE_REASON_FOR_PRESENTATION',
  LetterComponentTypeReferral = 'LETTER_COMPONENT_TYPE_REFERRAL',
  LetterComponentTypeRinsing = 'LETTER_COMPONENT_TYPE_RINSING',
  LetterComponentTypeSpecimen = 'LETTER_COMPONENT_TYPE_SPECIMEN',
  LetterComponentTypeSterileEquipment = 'LETTER_COMPONENT_TYPE_STERILE_EQUIPMENT',
  LetterComponentTypeSterileInstrumentContainer = 'LETTER_COMPONENT_TYPE_STERILE_INSTRUMENT_CONTAINER',
  LetterComponentTypeSurgeryAnestheticProcedure = 'LETTER_COMPONENT_TYPE_SURGERY_ANESTHETIC_PROCEDURE',
  /** Surgery service */
  LetterComponentTypeSurgeryAttendance = 'LETTER_COMPONENT_TYPE_SURGERY_ATTENDANCE',
  LetterComponentTypeSurgeryComment = 'LETTER_COMPONENT_TYPE_SURGERY_COMMENT',
  LetterComponentTypeSurgeryKeyFigure = 'LETTER_COMPONENT_TYPE_SURGERY_KEY_FIGURE',
  LetterComponentTypeSurgeryReportSummary = 'LETTER_COMPONENT_TYPE_SURGERY_REPORT_SUMMARY',
  LetterComponentTypeSurgeryRequest = 'LETTER_COMPONENT_TYPE_SURGERY_REQUEST',
  LetterComponentTypeSurgicalTechnique = 'LETTER_COMPONENT_TYPE_SURGICAL_TECHNIQUE',
  /** for LETTER_COMPONENT_TYPE_PROCEDURE LetterComponentReferenceMsg.referenceId corresponds to treatment#therapy#id */
  LetterComponentTypeTreatmentEvaluation = 'LETTER_COMPONENT_TYPE_TREATMENT_EVALUATION',
  LetterComponentTypeUtilizedDevice = 'LETTER_COMPONENT_TYPE_UTILIZED_DEVICE',
  /** Patient service */
  LetterComponentTypeVisitSummary = 'LETTER_COMPONENT_TYPE_VISIT_SUMMARY',
  LetterComponentTypeWoundDrainage = 'LETTER_COMPONENT_TYPE_WOUND_DRAINAGE'
}

export enum Common_Letter_LetterSectionType {
  /** Epa service */
  LetterSectionCareAssessment = 'LETTER_SECTION_CARE_ASSESSMENT',
  LetterSectionTypeAdmissionInformation = 'LETTER_SECTION_TYPE_ADMISSION_INFORMATION',
  /** Medication service */
  LetterSectionTypeAdmissionMedication = 'LETTER_SECTION_TYPE_ADMISSION_MEDICATION',
  LetterSectionTypeAllergies = 'LETTER_SECTION_TYPE_ALLERGIES',
  LetterSectionTypeAnamnesis = 'LETTER_SECTION_TYPE_ANAMNESIS',
  LetterSectionTypeAnesthesiaFurtherDetails = 'LETTER_SECTION_TYPE_ANESTHESIA_FURTHER_DETAILS',
  LetterSectionTypeAnesthesiaMachines = 'LETTER_SECTION_TYPE_ANESTHESIA_MACHINES',
  /** Billing service */
  LetterSectionTypeBillingProcedures = 'LETTER_SECTION_TYPE_BILLING_PROCEDURES',
  LetterSectionTypeBloodBarriers = 'LETTER_SECTION_TYPE_BLOOD_BARRIERS',
  LetterSectionTypeClinicalRequests = 'LETTER_SECTION_TYPE_CLINICAL_REQUESTS',
  LetterSectionTypeContamination = 'LETTER_SECTION_TYPE_CONTAMINATION',
  LetterSectionTypeDesinfection = 'LETTER_SECTION_TYPE_DESINFECTION',
  /** Treatment service */
  LetterSectionTypeDiagnoses = 'LETTER_SECTION_TYPE_DIAGNOSES',
  LetterSectionTypeDischargeMedication = 'LETTER_SECTION_TYPE_DISCHARGE_MEDICATION',
  LetterSectionTypeElectrodes = 'LETTER_SECTION_TYPE_ELECTRODES',
  LetterSectionTypeEmergence = 'LETTER_SECTION_TYPE_EMERGENCE',
  LetterSectionTypeEndingFormula = 'LETTER_SECTION_TYPE_ENDING_FORMULA',
  LetterSectionTypeEpicrisis = 'LETTER_SECTION_TYPE_EPICRISIS',
  /** Clinical Request service */
  LetterSectionTypeFindings = 'LETTER_SECTION_TYPE_FINDINGS',
  LetterSectionTypeFurtherProcedures = 'LETTER_SECTION_TYPE_FURTHER_PROCEDURES',
  LetterSectionTypeGreetingFormula = 'LETTER_SECTION_TYPE_GREETING_FORMULA',
  LetterSectionTypeLabRequests = 'LETTER_SECTION_TYPE_LAB_REQUESTS',
  /** Lab service */
  LetterSectionTypeLabResults = 'LETTER_SECTION_TYPE_LAB_RESULTS',
  LetterSectionTypeLetterDate = 'LETTER_SECTION_TYPE_LETTER_DATE',
  LetterSectionTypeMaterialCounts = 'LETTER_SECTION_TYPE_MATERIAL_COUNTS',
  LetterSectionTypeMedicalAdmissionTreatment = 'LETTER_SECTION_TYPE_MEDICAL_ADMISSION_TREATMENT',
  LetterSectionTypeMedicalDevices = 'LETTER_SECTION_TYPE_MEDICAL_DEVICES',
  LetterSectionTypeNone = 'LETTER_SECTION_TYPE_NONE',
  LetterSectionTypeOperatingRoomCleaning = 'LETTER_SECTION_TYPE_OPERATING_ROOM_CLEANING',
  LetterSectionTypeOperatingRoomCondition = 'LETTER_SECTION_TYPE_OPERATING_ROOM_CONDITION',
  LetterSectionTypePhysicalExamination = 'LETTER_SECTION_TYPE_PHYSICAL_EXAMINATION',
  LetterSectionTypePositionings = 'LETTER_SECTION_TYPE_POSITIONINGS',
  LetterSectionTypePostoperativeCareUnit = 'LETTER_SECTION_TYPE_POSTOPERATIVE_CARE_UNIT',
  LetterSectionTypePostoperativeDiagnostics = 'LETTER_SECTION_TYPE_POSTOPERATIVE_DIAGNOSTICS',
  LetterSectionTypePrescriptions = 'LETTER_SECTION_TYPE_PRESCRIPTIONS',
  LetterSectionTypeProcedureSteps = 'LETTER_SECTION_TYPE_PROCEDURE_STEPS',
  LetterSectionTypeRadiologyServices = 'LETTER_SECTION_TYPE_RADIOLOGY_SERVICES',
  /** Administrative parts - note that these get wrapped in a different html tag */
  LetterSectionTypeRecipientAddress = 'LETTER_SECTION_TYPE_RECIPIENT_ADDRESS',
  LetterSectionTypeRecommendations = 'LETTER_SECTION_TYPE_RECOMMENDATIONS',
  /** Patient service */
  LetterSectionTypeReferrals = 'LETTER_SECTION_TYPE_REFERRALS',
  LetterSectionTypeRinsings = 'LETTER_SECTION_TYPE_RINSINGS',
  LetterSectionTypeSpecimens = 'LETTER_SECTION_TYPE_SPECIMENS',
  LetterSectionTypeSterileEquipments = 'LETTER_SECTION_TYPE_STERILE_EQUIPMENTS',
  LetterSectionTypeSterileInstrumentContainers = 'LETTER_SECTION_TYPE_STERILE_INSTRUMENT_CONTAINERS',
  LetterSectionTypeSurgeryAnestheticProcedures = 'LETTER_SECTION_TYPE_SURGERY_ANESTHETIC_PROCEDURES',
  LetterSectionTypeSurgeryComment = 'LETTER_SECTION_TYPE_SURGERY_COMMENT',
  LetterSectionTypeSurgeryKeyFigures = 'LETTER_SECTION_TYPE_SURGERY_KEY_FIGURES',
  LetterSectionTypeSurgeryMedication = 'LETTER_SECTION_TYPE_SURGERY_MEDICATION',
  LetterSectionTypeSurgeryReportHeader = 'LETTER_SECTION_TYPE_SURGERY_REPORT_HEADER',
  LetterSectionTypeSurgeryReportSummary = 'LETTER_SECTION_TYPE_SURGERY_REPORT_SUMMARY',
  LetterSectionTypeSurgeryRequests = 'LETTER_SECTION_TYPE_SURGERY_REQUESTS',
  LetterSectionTypeSurgicalTechnique = 'LETTER_SECTION_TYPE_SURGICAL_TECHNIQUE',
  /** Surgery service */
  LetterSectionTypeTeam = 'LETTER_SECTION_TYPE_TEAM',
  LetterSectionTypeTherapy = 'LETTER_SECTION_TYPE_THERAPY',
  LetterSectionTypeTherapyAndProgress = 'LETTER_SECTION_TYPE_THERAPY_AND_PROGRESS',
  LetterSectionTypeUtilizedDevices = 'LETTER_SECTION_TYPE_UTILIZED_DEVICES',
  LetterSectionTypeVentilationParameters = 'LETTER_SECTION_TYPE_VENTILATION_PARAMETERS',
  LetterSectionTypeVitalParameters = 'LETTER_SECTION_TYPE_VITAL_PARAMETERS',
  LetterSectionTypeWoundDrainages = 'LETTER_SECTION_TYPE_WOUND_DRAINAGES'
}

export enum Common_Letter_LetterSubsectionType {
  /** Medication service */
  LetterSubsectionTypeDischargeMedication = 'LETTER_SUBSECTION_TYPE_DISCHARGE_MEDICATION',
  LetterSubsectionTypeNone = 'LETTER_SUBSECTION_TYPE_NONE'
}

export type Common_Letter_LetterTextGenerationParametersMsg = {
  __typename?: 'common_letter_LetterTextGenerationParametersMsg';
  /** Whether html links that can be interpreted by the caller should be inserted in the html content */
  insertLinks?: Maybe<Scalars['Boolean']>;
  /** Desired language of the text */
  language?: Maybe<Core_Language>;
  /** Sex of the patient */
  sex?: Maybe<Core_Sex>;
};

export type Core_AcknowledgementMsg = {
  __typename?: 'core_AcknowledgementMsg';
  acknowledgementDate?: Maybe<Timestamp>;
  clinicalFindingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  obsolete?: Maybe<Scalars['Boolean']>;
  reasonForDissent?: Maybe<Core_ReasonForAcknowledgementDissent>;
  reasonForDissentText?: Maybe<Scalars['String']>;
  requestingUserId?: Maybe<Scalars['String']>;
  status?: Maybe<Core_AcknowledgementStatus>;
  timestamps?: Maybe<TimeMsg>;
  userId?: Maybe<Scalars['String']>;
};

export enum Core_AcknowledgementStatus {
  AcknowledgementStatusDissent = 'ACKNOWLEDGEMENT_STATUS_DISSENT',
  AcknowledgementStatusDone = 'ACKNOWLEDGEMENT_STATUS_DONE',
  AcknowledgementStatusNone = 'ACKNOWLEDGEMENT_STATUS_NONE',
  AcknowledgementStatusOutstanding = 'ACKNOWLEDGEMENT_STATUS_OUTSTANDING'
}

export type Core_AddressMsg = {
  __typename?: 'core_AddressMsg';
  additional?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  co?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Core_CoordinatesMsg>;
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  countryCode?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  municipalKey?: Maybe<Scalars['String']>;
  postOfficeBox?: Maybe<Scalars['Boolean']>;
  postOfficeBoxAddress?: Maybe<Scalars['String']>;
  precinct?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Core_AdministrativeUnitMappingList = {
  __typename?: 'core_AdministrativeUnitMappingList';
  mappings?: Maybe<Array<Maybe<Core_AdministrativeUnitMappingMsg>>>;
};

export type Core_AdministrativeUnitMappingMsg = {
  __typename?: 'core_AdministrativeUnitMappingMsg';
  clinicId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Core_AdministrativeUnitReferenceList = {
  __typename?: 'core_AdministrativeUnitReferenceList';
  unitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type Core_AdministrativeUnitReferenceMsg = {
  __typename?: 'core_AdministrativeUnitReferenceMsg';
  type?: Maybe<Core_AdministrativeUnitType>;
  unitId?: Maybe<Scalars['String']>;
};

export enum Core_AdministrativeUnitType {
  AdministrativeUnitTypeClinic = 'ADMINISTRATIVE_UNIT_TYPE_CLINIC',
  AdministrativeUnitTypeDepartment = 'ADMINISTRATIVE_UNIT_TYPE_DEPARTMENT',
  AdministrativeUnitTypeDivision = 'ADMINISTRATIVE_UNIT_TYPE_DIVISION',
  AdministrativeUnitTypeNone = 'ADMINISTRATIVE_UNIT_TYPE_NONE',
  AdministrativeUnitTypeOrganizationalUnit = 'ADMINISTRATIVE_UNIT_TYPE_ORGANIZATIONAL_UNIT',
  AdministrativeUnitTypeOther = 'ADMINISTRATIVE_UNIT_TYPE_OTHER'
}

export enum Core_BoolUnknown {
  BoolUnknownNo = 'BOOL_UNKNOWN_NO',
  BoolUnknownNone = 'BOOL_UNKNOWN_NONE',
  BoolUnknownUnknown = 'BOOL_UNKNOWN_UNKNOWN',
  BoolUnknownYes = 'BOOL_UNKNOWN_YES'
}

export type Core_ClinicalFindingActionList = {
  __typename?: 'core_ClinicalFindingActionList';
  clinicalFindingActions?: Maybe<Array<Maybe<Core_ClinicalFindingActionMsg>>>;
};

export type Core_ClinicalFindingActionMsg = {
  __typename?: 'core_ClinicalFindingActionMsg';
  actionTime?: Maybe<Timestamp>;
  actionType?: Maybe<Core_ClinicalFindingActionType>;
  affectedUserId?: Maybe<Scalars['String']>;
  affectingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  obsolete?: Maybe<Scalars['Boolean']>;
  reasonForDissent?: Maybe<Core_ReasonForAcknowledgementDissent>;
  reasonForDissentText?: Maybe<Scalars['String']>;
};

export enum Core_ClinicalFindingActionType {
  ClinicalFindingActionTypeAddAcknowledgement = 'CLINICAL_FINDING_ACTION_TYPE_ADD_ACKNOWLEDGEMENT',
  ClinicalFindingActionTypeAddAssignment = 'CLINICAL_FINDING_ACTION_TYPE_ADD_ASSIGNMENT',
  ClinicalFindingActionTypeCreateNewFinding = 'CLINICAL_FINDING_ACTION_TYPE_CREATE_NEW_FINDING',
  ClinicalFindingActionTypeCreateNewVersion = 'CLINICAL_FINDING_ACTION_TYPE_CREATE_NEW_VERSION',
  ClinicalFindingActionTypeDissent = 'CLINICAL_FINDING_ACTION_TYPE_DISSENT',
  ClinicalFindingActionTypeNone = 'CLINICAL_FINDING_ACTION_TYPE_NONE',
  ClinicalFindingActionTypeRemoveAcknowledgement = 'CLINICAL_FINDING_ACTION_TYPE_REMOVE_ACKNOWLEDGEMENT',
  ClinicalFindingActionTypeRemoveAssignment = 'CLINICAL_FINDING_ACTION_TYPE_REMOVE_ASSIGNMENT'
}

export type Core_ClinicalInfoReferenceMsg = {
  __typename?: 'core_ClinicalInfoReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_ClinicalInfoType>;
};

export enum Core_ClinicalInfoType {
  ClinicalInfoTypeAnamnesisBlock = 'CLINICAL_INFO_TYPE_ANAMNESIS_BLOCK',
  ClinicalInfoTypeClinicalRecommendation = 'CLINICAL_INFO_TYPE_CLINICAL_RECOMMENDATION',
  ClinicalInfoTypeDiagnosis = 'CLINICAL_INFO_TYPE_DIAGNOSIS',
  ClinicalInfoTypeLabRequest = 'CLINICAL_INFO_TYPE_LAB_REQUEST',
  ClinicalInfoTypeMedication = 'CLINICAL_INFO_TYPE_MEDICATION',
  ClinicalInfoTypeMiscellaneous = 'CLINICAL_INFO_TYPE_MISCELLANEOUS',
  ClinicalInfoTypeNone = 'CLINICAL_INFO_TYPE_NONE',
  ClinicalInfoTypePatientFlag = 'CLINICAL_INFO_TYPE_PATIENT_FLAG',
  ClinicalInfoTypePhysicalBlock = 'CLINICAL_INFO_TYPE_PHYSICAL_BLOCK',
  ClinicalInfoTypePrescription = 'CLINICAL_INFO_TYPE_PRESCRIPTION',
  ClinicalInfoTypeReasonForPresentation = 'CLINICAL_INFO_TYPE_REASON_FOR_PRESENTATION',
  ClinicalInfoTypeStationaryVisit = 'CLINICAL_INFO_TYPE_STATIONARY_VISIT',
  ClinicalInfoTypeTherapyCard = 'CLINICAL_INFO_TYPE_THERAPY_CARD',
  ClinicalInfoTypeWardTreatment = 'CLINICAL_INFO_TYPE_WARD_TREATMENT'
}

export type Core_ContactMsg = {
  __typename?: 'core_ContactMsg';
  addresses?: Maybe<Array<Maybe<Core_AddressMsg>>>;
  emails?: Maybe<Array<Maybe<Core_EmailMsg>>>;
  faxNumbers?: Maybe<Array<Maybe<Core_PhoneNumberMsg>>>;
  id?: Maybe<Scalars['String']>;
  landlineNumbers?: Maybe<Array<Maybe<Core_PhoneNumberMsg>>>;
  mobileNumbers?: Maybe<Array<Maybe<Core_PhoneNumberMsg>>>;
  useType?: Maybe<Core_PersonalInformationUseType>;
};

export type Core_ContactReferenceMsg = {
  __typename?: 'core_ContactReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_ContactReferenceType>;
};

export enum Core_ContactReferenceType {
  ContactReferenceTypeContactParty = 'CONTACT_REFERENCE_TYPE_CONTACT_PARTY',
  ContactReferenceTypeNone = 'CONTACT_REFERENCE_TYPE_NONE',
  ContactReferenceTypePatient = 'CONTACT_REFERENCE_TYPE_PATIENT',
  ContactReferenceTypePractitioner = 'CONTACT_REFERENCE_TYPE_PRACTITIONER'
}

export type Core_CoordinatesMsg = {
  __typename?: 'core_CoordinatesMsg';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type Core_CreateAcknowledgementRequest = {
  __typename?: 'core_CreateAcknowledgementRequest';
  clinicalFindingId?: Maybe<Scalars['String']>;
  targetUserId?: Maybe<Scalars['String']>;
};

export type Core_DateScheduleMsg = {
  __typename?: 'core_DateScheduleMsg';
  /** If true, the owner of this schedule is unavailable in the defined time frame */
  blocked?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  start?: Maybe<Timestamp>;
};

export type Core_DayOfWeekScheduleMsg = {
  __typename?: 'core_DayOfWeekScheduleMsg';
  dayOfWeek?: Maybe<DayOfWeek>;
  id?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<Core_TimeFrameOfDayMsg>;
};

export type Core_DeleteAcknowledgementRequest = {
  __typename?: 'core_DeleteAcknowledgementRequest';
  acknowledgementId?: Maybe<Scalars['String']>;
};

export type Core_DeleteRequirementTemplateRequest = {
  __typename?: 'core_DeleteRequirementTemplateRequest';
  requirementTemplateId?: Maybe<Scalars['String']>;
};

export type Core_EmailMsg = {
  __typename?: 'core_EmailMsg';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
};

export type Core_ExternalAdministrativeUnitReferenceMsg = {
  __typename?: 'core_ExternalAdministrativeUnitReferenceMsg';
  type?: Maybe<Core_ExternalAdministrativeUnitType>;
  unitId?: Maybe<Scalars['String']>;
};

export enum Core_ExternalAdministrativeUnitType {
  ExternalAdministrativeUnitTypeClinic = 'EXTERNAL_ADMINISTRATIVE_UNIT_TYPE_CLINIC',
  ExternalAdministrativeUnitTypeDivision = 'EXTERNAL_ADMINISTRATIVE_UNIT_TYPE_DIVISION',
  ExternalAdministrativeUnitTypeNone = 'EXTERNAL_ADMINISTRATIVE_UNIT_TYPE_NONE',
  ExternalAdministrativeUnitTypeOrganizationalUnit = 'EXTERNAL_ADMINISTRATIVE_UNIT_TYPE_ORGANIZATIONAL_UNIT'
}

export type Core_ExternalClinicIdMsg = {
  __typename?: 'core_ExternalClinicIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_ExternalClinicIdType>;
};

export enum Core_ExternalClinicIdType {
  /** In Germany: BSNR */
  ExternalClinicIdTypeInstituteCode = 'EXTERNAL_CLINIC_ID_TYPE_INSTITUTE_CODE',
  ExternalClinicIdTypeNone = 'EXTERNAL_CLINIC_ID_TYPE_NONE',
  /** Id used in SANA legacy system */
  ExternalClinicIdTypeSanaLegacy = 'EXTERNAL_CLINIC_ID_TYPE_SANA_LEGACY',
  ExternalClinicIdTypeSap = 'EXTERNAL_CLINIC_ID_TYPE_SAP'
}

export type Core_ExternalClinicList = {
  __typename?: 'core_ExternalClinicList';
  clinics?: Maybe<Array<Maybe<Core_ExternalClinicMsg>>>;
};

export type Core_ExternalClinicMsg = {
  __typename?: 'core_ExternalClinicMsg';
  contact?: Maybe<Core_ContactMsg>;
  deleted?: Maybe<Scalars['Boolean']>;
  divisions?: Maybe<Array<Maybe<Core_ExternalDivisionMsg>>>;
  externalIds?: Maybe<Array<Maybe<Core_ExternalClinicIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  validity?: Maybe<TimeFrameMsg>;
};

export type Core_ExternalDivisionList = {
  __typename?: 'core_ExternalDivisionList';
  divisions?: Maybe<Array<Maybe<Core_ExternalDivisionMsg>>>;
};

export type Core_ExternalDivisionMsg = {
  __typename?: 'core_ExternalDivisionMsg';
  clinicId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationalUnits?: Maybe<Array<Maybe<Core_ExternalOrganizationalUnitMsg>>>;
};

export type Core_ExternalEmployerMsg = {
  __typename?: 'core_ExternalEmployerMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Core_ExternalOrganizationalUnitList = {
  __typename?: 'core_ExternalOrganizationalUnitList';
  units?: Maybe<Array<Maybe<Core_ExternalOrganizationalUnitMsg>>>;
};

export type Core_ExternalOrganizationalUnitMsg = {
  __typename?: 'core_ExternalOrganizationalUnitMsg';
  contact?: Maybe<Core_ContactMsg>;
  divisionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Core_ExternalProcedureCodeIdMsg = {
  __typename?: 'core_ExternalProcedureCodeIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_ExternalProcedureCodeIdType>;
};

export enum Core_ExternalProcedureCodeIdType {
  ExternalProcedureCodeIdTypeNone = 'EXTERNAL_PROCEDURE_CODE_ID_TYPE_NONE',
  ExternalProcedureCodeIdTypeOps = 'EXTERNAL_PROCEDURE_CODE_ID_TYPE_OPS'
}

/**
 * This marks a special status of a patient relevant for medical care.
 *  Examples: Pregnant, Infectious, MRSA
 */
export type Core_FlagMsg = {
  __typename?: 'core_FlagMsg';
  details?: Maybe<Scalars['String']>;
  flagId?: Maybe<Core_KnowledgeInputMsg>;
  id?: Maybe<Scalars['String']>;
  importance?: Maybe<Core_Importance>;
  status?: Maybe<Core_ObjectStatus>;
  timestamps?: Maybe<TimeMsg>;
};

export type Core_FlexibleAdministrativeUnitMappingMsg = {
  __typename?: 'core_FlexibleAdministrativeUnitMappingMsg';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  departmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  divisionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Core_FractionMsg = {
  __typename?: 'core_FractionMsg';
  denominator?: Maybe<Scalars['Long']>;
  numerator?: Maybe<Scalars['Long']>;
};

export type Core_HumanNameMsg = {
  __typename?: 'core_HumanNameMsg';
  /** dt. Namenszusatz */
  affix?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  maidenName?: Maybe<Scalars['String']>;
  middleNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** dt. Vorsatzwort */
  prefix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  useType?: Maybe<Core_PersonalInformationUseType>;
};

export enum Core_Importance {
  ImportanceHigh = 'IMPORTANCE_HIGH',
  ImportanceLow = 'IMPORTANCE_LOW',
  ImportanceMedium = 'IMPORTANCE_MEDIUM',
  ImportanceNone = 'IMPORTANCE_NONE'
}

export type Core_InternalOrPortalUnitReferenceList = {
  __typename?: 'core_InternalOrPortalUnitReferenceList';
  unitReferences?: Maybe<Array<Maybe<Core_InternalOrPortalUnitReferenceMsg>>>;
};

export type Core_InternalOrPortalUnitReferenceMsg = {
  __typename?: 'core_InternalOrPortalUnitReferenceMsg';
  type?: Maybe<Core_InternalOrPortalUnitType>;
  unitId?: Maybe<Scalars['String']>;
};

export enum Core_InternalOrPortalUnitType {
  InternalOrPortalUnitTypeInternalClinic = 'INTERNAL_OR_PORTAL_UNIT_TYPE_INTERNAL_CLINIC',
  InternalOrPortalUnitTypeInternalDepartment = 'INTERNAL_OR_PORTAL_UNIT_TYPE_INTERNAL_DEPARTMENT',
  InternalOrPortalUnitTypeInternalDivision = 'INTERNAL_OR_PORTAL_UNIT_TYPE_INTERNAL_DIVISION',
  InternalOrPortalUnitTypeInternalOrganizationalUnit = 'INTERNAL_OR_PORTAL_UNIT_TYPE_INTERNAL_ORGANIZATIONAL_UNIT',
  InternalOrPortalUnitTypeNone = 'INTERNAL_OR_PORTAL_UNIT_TYPE_NONE',
  InternalOrPortalUnitTypePortalClinic = 'INTERNAL_OR_PORTAL_UNIT_TYPE_PORTAL_CLINIC',
  InternalOrPortalUnitTypePortalDepartment = 'INTERNAL_OR_PORTAL_UNIT_TYPE_PORTAL_DEPARTMENT',
  InternalOrPortalUnitTypePortalOrganizationalUnit = 'INTERNAL_OR_PORTAL_UNIT_TYPE_PORTAL_ORGANIZATIONAL_UNIT'
}

export type Core_KnowledgeInputMsg = {
  __typename?: 'core_KnowledgeInputMsg';
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Core_Language {
  LanguageDeDe = 'LANGUAGE_DE_DE',
  LanguageEnUs = 'LANGUAGE_EN_US',
  LanguageNone = 'LANGUAGE_NONE'
}

export type Core_LetterReferenceMsg = {
  __typename?: 'core_LetterReferenceMsg';
  id?: Maybe<Scalars['String']>;
  letterId?: Maybe<Scalars['String']>;
  /** We use timestamps to sort the references, as we often want the latest one */
  timestamps?: Maybe<TimeMsg>;
};

export type Core_LetterTextMsg = {
  __typename?: 'core_LetterTextMsg';
  html?: Maybe<Scalars['String']>;
};

export type Core_ListRequirementTemplatesRequest = {
  __typename?: 'core_ListRequirementTemplatesRequest';
  /** required filter */
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** required filter */
  target?: Maybe<Core_RequirementTemplateTarget>;
};

export type Core_LocalDateMsg = {
  __typename?: 'core_LocalDateMsg';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Core_LocalDateTimeMsg = {
  __typename?: 'core_LocalDateTimeMsg';
  date?: Maybe<Core_LocalDateMsg>;
  time?: Maybe<Core_LocalTimeMsg>;
};

export type Core_LocalOrOffsetDateMsg = {
  __typename?: 'core_LocalOrOffsetDateMsg';
  localDate?: Maybe<Core_LocalDateMsg>;
  offsetDate?: Maybe<Core_OffsetDateMsg>;
};

export type Core_LocalOrOffsetDateTimeMsg = {
  __typename?: 'core_LocalOrOffsetDateTimeMsg';
  localDateTime?: Maybe<Core_LocalDateTimeMsg>;
  offsetDateTime?: Maybe<Core_OffsetDateTimeMsg>;
};

export type Core_LocalTimeMsg = {
  __typename?: 'core_LocalTimeMsg';
  hour?: Maybe<Scalars['Int']>;
  minute?: Maybe<Scalars['Int']>;
  nano?: Maybe<Scalars['Int']>;
  second?: Maybe<Scalars['Int']>;
};

export type Core_LocalizedStringMsg = {
  __typename?: 'core_LocalizedStringMsg';
  id?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Core_TranslationMsg>>>;
};

export enum Core_MaritalStatus {
  MaritalStatusAnnulled = 'MARITAL_STATUS_ANNULLED',
  MaritalStatusDivorced = 'MARITAL_STATUS_DIVORCED',
  MaritalStatusDomesticPartner = 'MARITAL_STATUS_DOMESTIC_PARTNER',
  MaritalStatusDomesticPartnershipAnnulled = 'MARITAL_STATUS_DOMESTIC_PARTNERSHIP_ANNULLED',
  MaritalStatusDomesticPartnerDeceased = 'MARITAL_STATUS_DOMESTIC_PARTNER_DECEASED',
  MaritalStatusInterlocutory = 'MARITAL_STATUS_INTERLOCUTORY',
  MaritalStatusMarried = 'MARITAL_STATUS_MARRIED',
  MaritalStatusNeverMarried = 'MARITAL_STATUS_NEVER_MARRIED',
  MaritalStatusNone = 'MARITAL_STATUS_NONE',
  MaritalStatusOther = 'MARITAL_STATUS_OTHER',
  MaritalStatusPolygamous = 'MARITAL_STATUS_POLYGAMOUS',
  MaritalStatusUnknown = 'MARITAL_STATUS_UNKNOWN',
  MaritalStatusUnmarried = 'MARITAL_STATUS_UNMARRIED',
  MaritalStatusWidowed = 'MARITAL_STATUS_WIDOWED'
}

export type Core_MergePatientsFailure = {
  __typename?: 'core_MergePatientsFailure';
  errorMessage?: Maybe<Scalars['String']>;
  failedService?: Maybe<Core_MergePatientsService>;
};

export type Core_MergePatientsRequest = {
  __typename?: 'core_MergePatientsRequest';
  patientIdToBeMergedInto?: Maybe<Scalars['String']>;
  patientIdsToBeMerged?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Core_MergePatientsResponse = {
  __typename?: 'core_MergePatientsResponse';
  failures?: Maybe<Array<Maybe<Core_MergePatientsFailure>>>;
  result?: Maybe<Core_MergePatientsResult>;
};

export enum Core_MergePatientsResult {
  MergePatientsResultFail = 'MERGE_PATIENTS_RESULT_FAIL',
  MergePatientsResultNone = 'MERGE_PATIENTS_RESULT_NONE',
  MergePatientsResultSuccess = 'MERGE_PATIENTS_RESULT_SUCCESS'
}

export enum Core_MergePatientsService {
  MergePatientsDocumentService = 'MERGE_PATIENTS_DOCUMENT_SERVICE',
  MergePatientsImageService = 'MERGE_PATIENTS_IMAGE_SERVICE',
  MergePatientsLabService = 'MERGE_PATIENTS_LAB_SERVICE',
  MergePatientsLetterService = 'MERGE_PATIENTS_LETTER_SERVICE',
  MergePatientsNone = 'MERGE_PATIENTS_NONE',
  MergePatientsPatientService = 'MERGE_PATIENTS_PATIENT_SERVICE',
  MergePatientsTreatmentService = 'MERGE_PATIENTS_TREATMENT_SERVICE'
}

export enum Core_ObjectStatus {
  ObjectStatusDisabled = 'OBJECT_STATUS_DISABLED',
  ObjectStatusEnabled = 'OBJECT_STATUS_ENABLED',
  ObjectStatusNone = 'OBJECT_STATUS_NONE'
}

export type Core_OffsetDateMsg = {
  __typename?: 'core_OffsetDateMsg';
  date?: Maybe<Core_LocalDateMsg>;
  offsetSeconds?: Maybe<Scalars['Int']>;
};

export type Core_OffsetDateTimeMsg = {
  __typename?: 'core_OffsetDateTimeMsg';
  dateTime?: Maybe<Core_LocalDateTimeMsg>;
  offsetSeconds?: Maybe<Scalars['Int']>;
};

export type Core_PatchUpdateTreeNodeMsg = {
  __typename?: 'core_PatchUpdateTreeNodeMsg';
  children?: Maybe<Array<Maybe<Core_PatchUpdateTreeNodeMsg>>>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Core_PatchUpdateTreeRootMsg = {
  __typename?: 'core_PatchUpdateTreeRootMsg';
  nodes?: Maybe<Array<Maybe<Core_PatchUpdateTreeNodeMsg>>>;
};

export type Core_PersonReferenceMsg = {
  __typename?: 'core_PersonReferenceMsg';
  /** TODO: remove */
  id?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_PersonReferenceType>;
};

export enum Core_PersonReferenceType {
  PersonReferenceTypeContactParty = 'PERSON_REFERENCE_TYPE_CONTACT_PARTY',
  PersonReferenceTypeNone = 'PERSON_REFERENCE_TYPE_NONE',
  PersonReferenceTypePatient = 'PERSON_REFERENCE_TYPE_PATIENT',
  PersonReferenceTypePractitioner = 'PERSON_REFERENCE_TYPE_PRACTITIONER',
  PersonReferenceTypeUser = 'PERSON_REFERENCE_TYPE_USER'
}

export enum Core_PersonalInformationUseType {
  PersonalInformationUseTypeAnonymous = 'PERSONAL_INFORMATION_USE_TYPE_ANONYMOUS',
  PersonalInformationUseTypeNone = 'PERSONAL_INFORMATION_USE_TYPE_NONE',
  PersonalInformationUseTypeNormal = 'PERSONAL_INFORMATION_USE_TYPE_NORMAL',
  PersonalInformationUseTypeOld = 'PERSONAL_INFORMATION_USE_TYPE_OLD'
}

export type Core_PhoneNumberMsg = {
  __typename?: 'core_PhoneNumberMsg';
  countryCode?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Long']>;
  primary?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Core_PhoneNumberType>;
};

export enum Core_PhoneNumberType {
  PhoneNumberTypeBusiness = 'PHONE_NUMBER_TYPE_BUSINESS',
  PhoneNumberTypeNone = 'PHONE_NUMBER_TYPE_NONE',
  PhoneNumberTypePrivate = 'PHONE_NUMBER_TYPE_PRIVATE'
}

export type Core_ProcedureCodeMsg = {
  __typename?: 'core_ProcedureCodeMsg';
  externalId?: Maybe<Core_ExternalProcedureCodeIdMsg>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Core_ReasonForAcknowledgementDissent {
  ReasonForAcknowledgementDissentNone = 'REASON_FOR_ACKNOWLEDGEMENT_DISSENT_NONE',
  ReasonForAcknowledgementDissentOther = 'REASON_FOR_ACKNOWLEDGEMENT_DISSENT_OTHER',
  ReasonForAcknowledgementDissentQuestionNotAnswered = 'REASON_FOR_ACKNOWLEDGEMENT_DISSENT_QUESTION_NOT_ANSWERED',
  ReasonForAcknowledgementDissentWrongAllocation = 'REASON_FOR_ACKNOWLEDGEMENT_DISSENT_WRONG_ALLOCATION'
}

export enum Core_RecorderType {
  RecorderTypeCare = 'RECORDER_TYPE_CARE',
  RecorderTypeDoctor = 'RECORDER_TYPE_DOCTOR',
  RecorderTypeNone = 'RECORDER_TYPE_NONE',
  RecorderTypePatient = 'RECORDER_TYPE_PATIENT'
}

export type Core_RequirementTemplateAssigneeMsg = {
  __typename?: 'core_RequirementTemplateAssigneeMsg';
  id?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  userGroup?: Maybe<Core_RoleBasedUserGroupMsg>;
  userId?: Maybe<Scalars['String']>;
};

export type Core_RequirementTemplateList = {
  __typename?: 'core_RequirementTemplateList';
  templates?: Maybe<Array<Maybe<Core_RequirementTemplateMsg>>>;
};

export type Core_RequirementTemplateMsg = {
  __typename?: 'core_RequirementTemplateMsg';
  assignees?: Maybe<Array<Maybe<Core_RequirementTemplateAssigneeMsg>>>;
  id?: Maybe<Scalars['String']>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** What kind of object the requirement template is for */
  target?: Maybe<Core_RequirementTemplateTarget>;
};

export enum Core_RequirementTemplateTarget {
  RequirementTemplateTargetClinicalRequestLetter = 'REQUIREMENT_TEMPLATE_TARGET_CLINICAL_REQUEST_LETTER',
  RequirementTemplateTargetLabLetter = 'REQUIREMENT_TEMPLATE_TARGET_LAB_LETTER',
  RequirementTemplateTargetNone = 'REQUIREMENT_TEMPLATE_TARGET_NONE',
  RequirementTemplateTargetPatientLetter = 'REQUIREMENT_TEMPLATE_TARGET_PATIENT_LETTER'
}

export type Core_RoleBasedUserGroupMsg = {
  __typename?: 'core_RoleBasedUserGroupMsg';
  numberOfUsers?: Maybe<Scalars['Int']>;
  roleType?: Maybe<Core_RoleType>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export enum Core_RoleType {
  RoleTypeAdministration = 'ROLE_TYPE_ADMINISTRATION',
  RoleTypeCare = 'ROLE_TYPE_CARE',
  RoleTypeDoctor = 'ROLE_TYPE_DOCTOR',
  RoleTypeHeadDoctor = 'ROLE_TYPE_HEAD_DOCTOR',
  RoleTypeMedicalAssistant = 'ROLE_TYPE_MEDICAL_ASSISTANT',
  RoleTypeNone = 'ROLE_TYPE_NONE',
  RoleTypePharmacy = 'ROLE_TYPE_PHARMACY'
}

export type Core_ScopedRoleTypeMsg = {
  __typename?: 'core_ScopedRoleTypeMsg';
  roleType?: Maybe<Core_RoleType>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Core_ScopedRoleTypeTemplateMsg = {
  __typename?: 'core_ScopedRoleTypeTemplateMsg';
  roleType?: Maybe<Core_RoleType>;
  scopeType?: Maybe<Core_AdministrativeUnitType>;
};

export type Core_ServiceProviderReferenceMsg = {
  __typename?: 'core_ServiceProviderReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_ServiceProviderType>;
};

export enum Core_ServiceProviderType {
  ServiceProviderTypeExternalClinic = 'SERVICE_PROVIDER_TYPE_EXTERNAL_CLINIC',
  ServiceProviderTypeExternalDivision = 'SERVICE_PROVIDER_TYPE_EXTERNAL_DIVISION',
  ServiceProviderTypeExternalOrganizationalUnit = 'SERVICE_PROVIDER_TYPE_EXTERNAL_ORGANIZATIONAL_UNIT',
  ServiceProviderTypeNone = 'SERVICE_PROVIDER_TYPE_NONE',
  ServiceProviderTypeVeiosClinic = 'SERVICE_PROVIDER_TYPE_VEIOS_CLINIC',
  ServiceProviderTypeVeiosDepartment = 'SERVICE_PROVIDER_TYPE_VEIOS_DEPARTMENT',
  ServiceProviderTypeVeiosDivision = 'SERVICE_PROVIDER_TYPE_VEIOS_DIVISION',
  ServiceProviderTypeVeiosOrganizationalUnit = 'SERVICE_PROVIDER_TYPE_VEIOS_ORGANIZATIONAL_UNIT'
}

export enum Core_Sex {
  /** male */
  SexM = 'SEX_M',
  SexNone = 'SEX_NONE',
  SexUndetermined = 'SEX_UNDETERMINED',
  SexUnknown = 'SEX_UNKNOWN',
  /** female */
  SexW = 'SEX_W',
  /** non-binary -> code should be changed to "D" */
  SexX = 'SEX_X'
}

export type Core_SimpleInternalOrPortalUnitList = {
  __typename?: 'core_SimpleInternalOrPortalUnitList';
  internalOrPortalUnits?: Maybe<Array<Maybe<Core_SimpleInternalOrPortalUnitMsg>>>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of external clinics and departments in the patient portal
 * and administrative units in the clinic side.
 */
export type Core_SimpleInternalOrPortalUnitMsg = {
  __typename?: 'core_SimpleInternalOrPortalUnitMsg';
  contact?: Maybe<Core_ContactMsg>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Core_InternalOrPortalUnitType>;
  unitId?: Maybe<Scalars['String']>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of portal and professional portal users in the patient portal
 * and normal users in the clinic side.
 */
export type Core_SimpleUserMsg = {
  __typename?: 'core_SimpleUserMsg';
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_HumanNameMsg>;
  sex?: Maybe<Core_Sex>;
};

export type Core_StorageLocationMsg = {
  __typename?: 'core_StorageLocationMsg';
  address?: Maybe<Core_AddressMsg>;
  storageLocationDescription?: Maybe<Scalars['String']>;
};

export type Core_TimeFrameOfDayMsg = {
  __typename?: 'core_TimeFrameOfDayMsg';
  end?: Maybe<TimeOfDayMsg>;
  start?: Maybe<TimeOfDayMsg>;
};

export type Core_TranslationMsg = {
  __typename?: 'core_TranslationMsg';
  /** ISO 639-3 coded */
  locale?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Core_Unit {
  UnitMg = 'UNIT_MG',
  UnitNone = 'UNIT_NONE'
}

export type Core_UpdateAcknowledgementRequest = {
  __typename?: 'core_UpdateAcknowledgementRequest';
  acknowledgement?: Maybe<Core_AcknowledgementMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Core_UserIdListMsg = {
  __typename?: 'core_UserIdListMsg';
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Core_UserReferenceMsg = {
  __typename?: 'core_UserReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Core_UserType>;
  user?: Maybe<Core_SimpleUserMsg>;
};

export enum Core_UserType {
  UserTypeInternalUser = 'USER_TYPE_INTERNAL_USER',
  UserTypeNone = 'USER_TYPE_NONE',
  UserTypePortalUser = 'USER_TYPE_PORTAL_USER',
  UserTypeProfessionalPortalUser = 'USER_TYPE_PROFESSIONAL_PORTAL_USER'
}

export type Core_YearMonthMsg = {
  __typename?: 'core_YearMonthMsg';
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Device_AppDetailsMsg = {
  __typename?: 'device_AppDetailsMsg';
  /** Users the app is assigned to */
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Id of the app */
  id?: Maybe<Scalars['String']>;
  /** VeiosUsers that manage the app */
  keyUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of the app */
  name?: Maybe<Scalars['String']>;
  /** Rooms in which the app is being used */
  roomIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** AdministrativeUnitIds that have access to the app */
  scope?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** Current status of the app */
  status?: Maybe<Device_AppStatus>;
  timestamps?: Maybe<TimeMsg>;
};

export enum Device_AppStatus {
  AppStatusDisabled = 'APP_STATUS_DISABLED',
  AppStatusErrorConnection = 'APP_STATUS_ERROR_CONNECTION',
  AppStatusErrorOther = 'APP_STATUS_ERROR_OTHER',
  AppStatusNone = 'APP_STATUS_NONE',
  AppStatusReady = 'APP_STATUS_READY'
}

export type Device_ListAppConfigsRequest = {
  __typename?: 'device_ListAppConfigsRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Device_ListAppsRequest = {
  __typename?: 'device_ListAppsRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Document_ClaimPortalUserFormDocumentsRequest = {
  __typename?: 'document_ClaimPortalUserFormDocumentsRequest';
  formId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Document_ClaimPortalUserFormDocumentsResponse = {
  __typename?: 'document_ClaimPortalUserFormDocumentsResponse';
  _?: Maybe<Scalars['String']>;
};

export type Document_ConfirmDocumentsRequest = {
  __typename?: 'document_ConfirmDocumentsRequest';
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Document_ConfirmDocumentsResponse = {
  __typename?: 'document_ConfirmDocumentsResponse';
  documents?: Maybe<Array<Maybe<Document_DocumentMsg>>>;
};

export type Document_CreateDocumentRequest = {
  __typename?: 'document_CreateDocumentRequest';
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: Maybe<Scalars['Boolean']>;
  document?: Maybe<Document_DocumentMsg>;
};

export type Document_CreateOrUpdateDocumentRequest = {
  __typename?: 'document_CreateOrUpdateDocumentRequest';
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: Maybe<Scalars['Boolean']>;
  document?: Maybe<Document_DocumentMsg>;
  letterId?: Maybe<Scalars['String']>;
};

export type Document_CreateOrUpdateDocumentsRequest = {
  __typename?: 'document_CreateOrUpdateDocumentsRequest';
  requests?: Maybe<Array<Maybe<Document_CreateOrUpdateDocumentRequest>>>;
};

export type Document_CreateOrUpdateDocumentsResponse = {
  __typename?: 'document_CreateOrUpdateDocumentsResponse';
  documentToLetterIds?: Maybe<Array<Maybe<Document_DocumentToLetterIdMsg>>>;
};

export type Document_DeleteDocumentRequest = {
  __typename?: 'document_DeleteDocumentRequest';
  documentId?: Maybe<Scalars['String']>;
};

export type Document_DeleteDocumentResponse = {
  __typename?: 'document_DeleteDocumentResponse';
  deletedDocumentId?: Maybe<Scalars['String']>;
};

export type Document_DeleteDocumentsRequest = {
  __typename?: 'document_DeleteDocumentsRequest';
  externalDocumentId?: Maybe<Document_ExternalDocumentIdMsg>;
};

export type Document_DeleteDocumentsResponse = {
  __typename?: 'document_DeleteDocumentsResponse';
  deletedDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Document_DocumentActivationStatus {
  DocumentActivationStatusActive = 'DOCUMENT_ACTIVATION_STATUS_ACTIVE',
  DocumentActivationStatusInactive = 'DOCUMENT_ACTIVATION_STATUS_INACTIVE',
  DocumentActivationStatusNone = 'DOCUMENT_ACTIVATION_STATUS_NONE',
  DocumentActivationStatusNotYetActive = 'DOCUMENT_ACTIVATION_STATUS_NOT_YET_ACTIVE'
}

export type Document_DocumentBasicInfoList = {
  __typename?: 'document_DocumentBasicInfoList';
  documents?: Maybe<Array<Maybe<Document_DocumentBasicInfoMsg>>>;
};

export type Document_DocumentBasicInfoMsg = {
  __typename?: 'document_DocumentBasicInfoMsg';
  activationStatus?: Maybe<Document_DocumentActivationStatus>;
  additionalInformation?: Maybe<Scalars['String']>;
  /** Official date of document */
  documentDate?: Maybe<Timestamp>;
  format?: Maybe<Document_DocumentFormat>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Document_DocumentType>;
  url?: Maybe<Scalars['String']>;
};

export enum Document_DocumentFormat {
  DocumentFormatNone = 'DOCUMENT_FORMAT_NONE',
  DocumentFormatPdf = 'DOCUMENT_FORMAT_PDF'
}

export type Document_DocumentIdentifiersMsg = {
  __typename?: 'document_DocumentIdentifiersMsg';
  externalIds?: Maybe<Array<Maybe<Document_ExternalDocumentIdMsg>>>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Document_DocumentInfo = {
  __typename?: 'document_DocumentInfo';
  document?: Maybe<Document_DocumentMsg>;
  ref?: Maybe<Scalars['String']>;
};

export type Document_DocumentLinkMsg = {
  __typename?: 'document_DocumentLinkMsg';
  /** Id of external entity linking to the document */
  linkId?: Maybe<Scalars['String']>;
  type?: Maybe<Document_DocumentLinkType>;
};

export enum Document_DocumentLinkType {
  DocumentLinkTypeLabLetter = 'DOCUMENT_LINK_TYPE_LAB_LETTER',
  DocumentLinkTypeLabLetterGroup = 'DOCUMENT_LINK_TYPE_LAB_LETTER_GROUP',
  DocumentLinkTypeNone = 'DOCUMENT_LINK_TYPE_NONE',
  DocumentLinkTypePatientLetter = 'DOCUMENT_LINK_TYPE_PATIENT_LETTER',
  DocumentLinkTypePatientLetterGroup = 'DOCUMENT_LINK_TYPE_PATIENT_LETTER_GROUP',
  DocumentLinkTypePatientTreatment = 'DOCUMENT_LINK_TYPE_PATIENT_TREATMENT',
  DocumentLinkTypePatientVisit = 'DOCUMENT_LINK_TYPE_PATIENT_VISIT'
}

export type Document_DocumentList = {
  __typename?: 'document_DocumentList';
  documents?: Maybe<Array<Maybe<Document_DocumentMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Document_DocumentMsg = {
  __typename?: 'document_DocumentMsg';
  acknowledgements?: Maybe<Array<Maybe<Core_AcknowledgementMsg>>>;
  activationStatus?: Maybe<Document_DocumentActivationStatus>;
  additionalInformation?: Maybe<Scalars['String']>;
  creatorUserId?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['String']>;
  documentClass?: Maybe<Document_DocumentTypeMsg>;
  /** Official date of document */
  documentDate?: Maybe<Timestamp>;
  /** Entities associated with document */
  documentLinks?: Maybe<Array<Maybe<Document_DocumentLinkMsg>>>;
  /** True if the document was not originally created from within our system */
  external?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Document_ExternalDocumentIdMsg>>>;
  externalUrl?: Maybe<Scalars['String']>;
  externalViewerId?: Maybe<Scalars['String']>;
  findingActions?: Maybe<Array<Maybe<Core_ClinicalFindingActionMsg>>>;
  /** @deprecated deprecated in proto */
  format?: Maybe<Document_DocumentFormat>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latestUpdaterUserId?: Maybe<Scalars['String']>;
  /** used by frontend to choose appropriate preview */
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** If the document originated from within the system, links to the origin */
  origin?: Maybe<Document_DocumentOriginMsg>;
  patientId?: Maybe<Scalars['String']>;
  /** a patient linked to this document by their portal-user id */
  portalUserId?: Maybe<Scalars['String']>;
  releasedToPortal?: Maybe<Scalars['Boolean']>;
  /** References to recipient administrative units */
  targetUnitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Document_DocumentType>;
  /** OrganizationalUnitId of creating department */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  url?: Maybe<Scalars['String']>;
  /** Date of related visit */
  visitDate?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export type Document_DocumentOriginMsg = {
  __typename?: 'document_DocumentOriginMsg';
  originId?: Maybe<Scalars['String']>;
  originType?: Maybe<Document_DocumentOriginType>;
};

export enum Document_DocumentOriginType {
  DocumentOriginTypeAppointmentTask = 'DOCUMENT_ORIGIN_TYPE_APPOINTMENT_TASK',
  DocumentOriginTypeCareAidDisability = 'DOCUMENT_ORIGIN_TYPE_CARE_AID_DISABILITY',
  DocumentOriginTypeClinicalRequest = 'DOCUMENT_ORIGIN_TYPE_CLINICAL_REQUEST',
  DocumentOriginTypeCockpit = 'DOCUMENT_ORIGIN_TYPE_COCKPIT',
  DocumentOriginTypeConsent = 'DOCUMENT_ORIGIN_TYPE_CONSENT',
  DocumentOriginTypeCustomDrug = 'DOCUMENT_ORIGIN_TYPE_CUSTOM_DRUG',
  DocumentOriginTypeForm = 'DOCUMENT_ORIGIN_TYPE_FORM',
  DocumentOriginTypeLabRequest = 'DOCUMENT_ORIGIN_TYPE_LAB_REQUEST',
  DocumentOriginTypeLegalGuardianship = 'DOCUMENT_ORIGIN_TYPE_LEGAL_GUARDIANSHIP',
  DocumentOriginTypeLivingWill = 'DOCUMENT_ORIGIN_TYPE_LIVING_WILL',
  DocumentOriginTypeLongTermCare = 'DOCUMENT_ORIGIN_TYPE_LONG_TERM_CARE',
  DocumentOriginTypeNone = 'DOCUMENT_ORIGIN_TYPE_NONE',
  DocumentOriginTypeOrganDonationCard = 'DOCUMENT_ORIGIN_TYPE_ORGAN_DONATION_CARD',
  DocumentOriginTypePowerOfAttorneyEntry = 'DOCUMENT_ORIGIN_TYPE_POWER_OF_ATTORNEY_ENTRY',
  DocumentOriginTypeTreatment = 'DOCUMENT_ORIGIN_TYPE_TREATMENT'
}

export type Document_DocumentToLetterIdMsg = {
  __typename?: 'document_DocumentToLetterIdMsg';
  documentId?: Maybe<Scalars['String']>;
  letterId?: Maybe<Scalars['String']>;
};

export enum Document_DocumentType {
  DocumentTypeAdministrative = 'DOCUMENT_TYPE_ADMINISTRATIVE',
  DocumentTypeBmp = 'DOCUMENT_TYPE_BMP',
  DocumentTypeCareAdmissionProtocol = 'DOCUMENT_TYPE_CARE_ADMISSION_PROTOCOL',
  DocumentTypeCareReport = 'DOCUMENT_TYPE_CARE_REPORT',
  DocumentTypeClinicalCouncil = 'DOCUMENT_TYPE_CLINICAL_COUNCIL',
  DocumentTypeClinicalRecord = 'DOCUMENT_TYPE_CLINICAL_RECORD',
  DocumentTypeClinicalRequest = 'DOCUMENT_TYPE_CLINICAL_REQUEST',
  DocumentTypeCustomDrugAttachment = 'DOCUMENT_TYPE_CUSTOM_DRUG_ATTACHMENT',
  DocumentTypeDrvForm = 'DOCUMENT_TYPE_DRV_FORM',
  DocumentTypeIntraoperativeAnesthesiaProtocol = 'DOCUMENT_TYPE_INTRAOPERATIVE_ANESTHESIA_PROTOCOL',
  DocumentTypeKbvForm = 'DOCUMENT_TYPE_KBV_FORM',
  DocumentTypeMedicalAdmissionProtocol = 'DOCUMENT_TYPE_MEDICAL_ADMISSION_PROTOCOL',
  DocumentTypeMedicalRound = 'DOCUMENT_TYPE_MEDICAL_ROUND',
  DocumentTypeNone = 'DOCUMENT_TYPE_NONE',
  DocumentTypeOther = 'DOCUMENT_TYPE_OTHER',
  DocumentTypePatientClinicalCourse = 'DOCUMENT_TYPE_PATIENT_CLINICAL_COURSE',
  DocumentTypePatientConsent = 'DOCUMENT_TYPE_PATIENT_CONSENT',
  DocumentTypePatientEducation = 'DOCUMENT_TYPE_PATIENT_EDUCATION',
  DocumentTypePatientFindingReport = 'DOCUMENT_TYPE_PATIENT_FINDING_REPORT',
  DocumentTypePatientLabResult = 'DOCUMENT_TYPE_PATIENT_LAB_RESULT',
  DocumentTypePatientLetter = 'DOCUMENT_TYPE_PATIENT_LETTER',
  DocumentTypePatientMedication = 'DOCUMENT_TYPE_PATIENT_MEDICATION',
  DocumentTypePatientPrescription = 'DOCUMENT_TYPE_PATIENT_PRESCRIPTION',
  DocumentTypePatientReceipt = 'DOCUMENT_TYPE_PATIENT_RECEIPT',
  DocumentTypePatientSurgeryProtocol = 'DOCUMENT_TYPE_PATIENT_SURGERY_PROTOCOL',
  DocumentTypePatientSurgeryReport = 'DOCUMENT_TYPE_PATIENT_SURGERY_REPORT',
  DocumentTypeProgressEntry = 'DOCUMENT_TYPE_PROGRESS_ENTRY',
  DocumentTypeSurgeryChecklist = 'DOCUMENT_TYPE_SURGERY_CHECKLIST',
  DocumentTypeTreatmentCancellationReport = 'DOCUMENT_TYPE_TREATMENT_CANCELLATION_REPORT'
}

export type Document_DocumentTypeExternalIdMsg = {
  __typename?: 'document_DocumentTypeExternalIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Document_DocumentTypeExternalIdType>;
};

export enum Document_DocumentTypeExternalIdType {
  DocumentTypeExternalIdTypeKdl = 'DOCUMENT_TYPE_EXTERNAL_ID_TYPE_KDL',
  DocumentTypeExternalIdTypeNone = 'DOCUMENT_TYPE_EXTERNAL_ID_TYPE_NONE'
}

export type Document_DocumentTypeList = {
  __typename?: 'document_DocumentTypeList';
  documentTypes?: Maybe<Array<Maybe<Document_DocumentTypeMsg>>>;
};

export type Document_DocumentTypeMsg = {
  __typename?: 'document_DocumentTypeMsg';
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  externalIds?: Maybe<Array<Maybe<Document_DocumentTypeExternalIdMsg>>>;
  id?: Maybe<Scalars['String']>;
};

export type Document_DocumentVersionList = {
  __typename?: 'document_DocumentVersionList';
  documentGroupId?: Maybe<Scalars['String']>;
  documentVersions?: Maybe<Array<Maybe<Document_DocumentBasicInfoMsg>>>;
};

export type Document_DownloadDocumentRequest = {
  __typename?: 'document_DownloadDocumentRequest';
  /** download latest version */
  documentGroupId?: Maybe<Scalars['String']>;
  /** download specific version */
  documentId?: Maybe<Scalars['String']>;
};

export type Document_DownloadDocumentResponse = {
  __typename?: 'document_DownloadDocumentResponse';
  chunk?: Maybe<Scalars['String']>;
  metadata?: Maybe<Document_DocumentMsg>;
};

export type Document_ExternalDocumentIdMsg = {
  __typename?: 'document_ExternalDocumentIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Document_ExternalDocumentIdType>;
};

export enum Document_ExternalDocumentIdType {
  /** The clinic's document system */
  ExternalDocumentIdTypeDocumentServerNumber = 'EXTERNAL_DOCUMENT_ID_TYPE_DOCUMENT_SERVER_NUMBER',
  /** The clinic's document system */
  ExternalDocumentIdTypeDocumentServerUuid = 'EXTERNAL_DOCUMENT_ID_TYPE_DOCUMENT_SERVER_UUID',
  ExternalDocumentIdTypeNone = 'EXTERNAL_DOCUMENT_ID_TYPE_NONE',
  ExternalDocumentIdTypeOtherNumber = 'EXTERNAL_DOCUMENT_ID_TYPE_OTHER_NUMBER'
}

export type Document_ExternalizeDocumentsRequest = {
  __typename?: 'document_ExternalizeDocumentsRequest';
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set to true, push the documents that are already set to external */
  forcePush?: Maybe<Scalars['Boolean']>;
};

export type Document_ExternalizeDocumentsResponse = {
  __typename?: 'document_ExternalizeDocumentsResponse';
  alreadyExternalDocumentsCount?: Maybe<Scalars['Int']>;
  externalizedDocumentsCount?: Maybe<Scalars['Int']>;
};

export type Document_FindDocumentIdentifiersRequest = {
  __typename?: 'document_FindDocumentIdentifiersRequest';
  externalDocumentId?: Maybe<Document_ExternalDocumentIdMsg>;
};

export type Document_FindDocumentIdentifiersResponse = {
  __typename?: 'document_FindDocumentIdentifiersResponse';
  found?: Maybe<Scalars['Boolean']>;
  identifiers?: Maybe<Document_DocumentIdentifiersMsg>;
};

export type Document_GetDocumentFindingActionHistoryRequest = {
  __typename?: 'document_GetDocumentFindingActionHistoryRequest';
  documentId?: Maybe<Scalars['String']>;
};

export type Document_GetDocumentRequest = {
  __typename?: 'document_GetDocumentRequest';
  documentId?: Maybe<Scalars['String']>;
};

export type Document_GetDocumentsRequest = {
  __typename?: 'document_GetDocumentsRequest';
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Document_HandlePortalReleaseRequest = {
  __typename?: 'document_HandlePortalReleaseRequest';
  documentId?: Maybe<Scalars['String']>;
  released?: Maybe<Scalars['Boolean']>;
};

export type Document_HandlePortalReleaseResponse = {
  __typename?: 'document_HandlePortalReleaseResponse';
  document?: Maybe<Document_DocumentBasicInfoMsg>;
  releaseId?: Maybe<Scalars['String']>;
  released?: Maybe<Scalars['Boolean']>;
};

export type Document_LinkOrCreateExternalDocumentRequest = {
  __typename?: 'document_LinkOrCreateExternalDocumentRequest';
  document?: Maybe<Document_DocumentMsg>;
  possibleDocumentGroupId?: Maybe<Scalars['String']>;
};

export type Document_LinkOrCreateExternalDocumentResponse = {
  __typename?: 'document_LinkOrCreateExternalDocumentResponse';
  document?: Maybe<Document_DocumentMsg>;
};

export type Document_ListDocumentVersionsRequest = {
  __typename?: 'document_ListDocumentVersionsRequest';
  documentGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Document_ListDocumentVersionsResponse = {
  __typename?: 'document_ListDocumentVersionsResponse';
  documentVersions?: Maybe<Array<Maybe<Document_DocumentVersionList>>>;
};

export type Document_ListDocumentsRequest = {
  __typename?: 'document_ListDocumentsRequest';
  origins?: Maybe<Array<Maybe<Document_DocumentOriginMsg>>>;
};

export type Document_ListDocumentsResponse = {
  __typename?: 'document_ListDocumentsResponse';
  documents?: Maybe<Array<Maybe<Document_DocumentBasicInfoMsg>>>;
};

export type Document_ListPatientDocumentsRequest = {
  __typename?: 'document_ListPatientDocumentsRequest';
  activationStatuses?: Maybe<Array<Maybe<Document_DocumentActivationStatus>>>;
  documentDateSortOrder?: Maybe<Helper_SortOrder>;
  patientId?: Maybe<Scalars['String']>;
  /** Optional filter */
  types?: Maybe<Array<Maybe<Document_DocumentType>>>;
};

export type Document_LoadPatientDocumentsRequest = {
  __typename?: 'document_LoadPatientDocumentsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Document_LoadPatientDocumentsResponse = {
  __typename?: 'document_LoadPatientDocumentsResponse';
  documents?: Maybe<Array<Maybe<Document_DocumentInfo>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Document_PortalReleaseMsg = {
  __typename?: 'document_PortalReleaseMsg';
  documentGroupId?: Maybe<Scalars['String']>;
  released?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export type Document_SearchDocumentFullTextsRequest = {
  __typename?: 'document_SearchDocumentFullTextsRequest';
  /** optional: set if only documents of a specific patient should be searched */
  patientId?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
  /** Optional filter */
  types?: Maybe<Array<Maybe<Document_DocumentType>>>;
};

export type Document_SearchDocumentsRequest = {
  __typename?: 'document_SearchDocumentsRequest';
  /** mandatory */
  patientId?: Maybe<Scalars['String']>;
  /**
   * at least one of the search term and types must be provided
   *  optional
   */
  searchTerm?: Maybe<Scalars['String']>;
  /** optional filter */
  types?: Maybe<Array<Maybe<Document_DocumentType>>>;
};

export type Document_UpdateDocumentRequest = {
  __typename?: 'document_UpdateDocumentRequest';
  /** If createFindingMessage is set to true, these users will be assigned to the finding message */
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set to true, finding messages will be created in the user service */
  createFindingMessage?: Maybe<Scalars['Boolean']>;
  document?: Maybe<Document_DocumentMsg>;
};

export type Document_UpdateExternalDocumentIdsRequest = {
  __typename?: 'document_UpdateExternalDocumentIdsRequest';
  externalIds?: Maybe<Array<Maybe<Document_ExternalDocumentIdMsg>>>;
  /** groupId of the Document */
  groupId?: Maybe<Scalars['String']>;
  /**
   * If set to true, the provided externalIds are set for all documents in the given group;
   *  if not set to true, the externalIds are only set for the latest document version in the group
   */
  updateAllGroupDocuments?: Maybe<Scalars['Boolean']>;
};

export type Document_UpdateMetadataRequest = {
  __typename?: 'document_UpdateMetadataRequest';
  document?: Maybe<Document_DocumentMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Document_Transfer_ClinicalRequestIdentifier = {
  __typename?: 'document_transfer_ClinicalRequestIdentifier';
  clinicalRequestId?: Maybe<Scalars['String']>;
  clinicalRequestInputTemplateId?: Maybe<Scalars['String']>;
};

export type Document_Transfer_DeleteAllResourcesRequest = {
  __typename?: 'document_transfer_DeleteAllResourcesRequest';
  clinicalRequestIdentifier?: Maybe<Document_Transfer_ClinicalRequestIdentifier>;
};

export type Document_Transfer_DeleteAllResourcesResponse = {
  __typename?: 'document_transfer_DeleteAllResourcesResponse';
  _?: Maybe<Scalars['String']>;
};

export type Document_Transfer_DeleteResourceRequest = {
  __typename?: 'document_transfer_DeleteResourceRequest';
  clinicalRequestIdentifier?: Maybe<Document_Transfer_ClinicalRequestIdentifier>;
  resourceId?: Maybe<Scalars['String']>;
};

export type Document_Transfer_DeleteResourceResponse = {
  __typename?: 'document_transfer_DeleteResourceResponse';
  _?: Maybe<Scalars['String']>;
};

export type Document_Transfer_DocumentMetadataMsg = {
  __typename?: 'document_transfer_DocumentMetadataMsg';
  appointmentTaskId?: Maybe<Scalars['String']>;
  clinicalRequestIdentifier?: Maybe<Document_Transfer_ClinicalRequestIdentifier>;
  documentClass?: Maybe<Document_DocumentTypeMsg>;
  documentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  originalFileName?: Maybe<Scalars['String']>;
  releasedToPortal?: Maybe<Scalars['Boolean']>;
  resourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Timestamp>;
};

export type Document_Transfer_DownloadDocumentRequest = {
  __typename?: 'document_transfer_DownloadDocumentRequest';
  clinicalRequestIdentifier?: Maybe<Document_Transfer_ClinicalRequestIdentifier>;
  documentId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  static?: Maybe<Scalars['Boolean']>;
};

export type Document_Transfer_DownloadDocumentResponse = {
  __typename?: 'document_transfer_DownloadDocumentResponse';
  chunk?: Maybe<Scalars['String']>;
  metadata?: Maybe<Document_Transfer_DocumentMetadataMsg>;
};

export type Document_Transfer_GetDocumentMetadataRequest = {
  __typename?: 'document_transfer_GetDocumentMetadataRequest';
  documentGroupId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  staticDocumentGroupId?: Maybe<Scalars['String']>;
  staticDocumentId?: Maybe<Scalars['String']>;
};

export type Document_Transfer_GetDocumentMetadataResponse = {
  __typename?: 'document_transfer_GetDocumentMetadataResponse';
  document?: Maybe<Document_Transfer_DocumentMetadataMsg>;
};

export type Document_Transfer_ListPortalUserDocumentsRequest = {
  __typename?: 'document_transfer_ListPortalUserDocumentsRequest';
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Document_Transfer_ListPortalUserDocumentsResponse = {
  __typename?: 'document_transfer_ListPortalUserDocumentsResponse';
  documents?: Maybe<Array<Maybe<Document_Transfer_DocumentMetadataMsg>>>;
};

export type Document_Transfer_UploadDocumentRequest = {
  __typename?: 'document_transfer_UploadDocumentRequest';
  chunk?: Maybe<Scalars['String']>;
  metadata?: Maybe<Document_Transfer_DocumentMetadataMsg>;
};

export type Document_Transfer_UploadDocumentResponse = {
  __typename?: 'document_transfer_UploadDocumentResponse';
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum Drug_ActiveIngredientDataset {
  ActiveIngredientDatasetMmi = 'ACTIVE_INGREDIENT_DATASET_MMI',
  ActiveIngredientDatasetNone = 'ACTIVE_INGREDIENT_DATASET_NONE'
}

export type Drug_ActiveIngredientMsg = {
  __typename?: 'drug_ActiveIngredientMsg';
  externalIds?: Maybe<Array<Maybe<Drug_ExternalActiveIngredientIdMsg>>>;
  lowerStrengthValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  strengthUnit?: Maybe<Drug_ActiveIngredientStrengthUnitMsg>;
  type?: Maybe<Drug_ActiveIngredientType>;
  upperStrengthValue?: Maybe<Scalars['Float']>;
};

export enum Drug_ActiveIngredientStrengthUnitDataset {
  ActiveIngredientStrengthUnitDatasetMmi = 'ACTIVE_INGREDIENT_STRENGTH_UNIT_DATASET_MMI',
  ActiveIngredientStrengthUnitDatasetNone = 'ACTIVE_INGREDIENT_STRENGTH_UNIT_DATASET_NONE'
}

export type Drug_ActiveIngredientStrengthUnitMsg = {
  __typename?: 'drug_ActiveIngredientStrengthUnitMsg';
  externalIds?: Maybe<Array<Maybe<Drug_ExternalActiveIngredientStrengthUnitIdMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export enum Drug_ActiveIngredientType {
  /** Dt.: Wirkstoff */
  ActiveIngredientTypeActiveIngredient = 'ACTIVE_INGREDIENT_TYPE_ACTIVE_INGREDIENT',
  /** Dt.: Hilfsstoff */
  ActiveIngredientTypeExcipient = 'ACTIVE_INGREDIENT_TYPE_EXCIPIENT',
  ActiveIngredientTypeNone = 'ACTIVE_INGREDIENT_TYPE_NONE'
}

export type Drug_AtcCodeMsg = {
  __typename?: 'drug_AtcCodeMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Drug_DrugDataVersionMsg = {
  __typename?: 'drug_DrugDataVersionMsg';
  /** Date when the data was imported */
  importDate?: Maybe<Timestamp>;
  /** Date when the source data was provided */
  sourceDataDate?: Maybe<Timestamp>;
  sourceType?: Maybe<Drug_ExternalDrugSourceType>;
  versionTitle?: Maybe<Scalars['String']>;
};

export enum Drug_DrugDivisibility {
  DrugDivisibilityDivisible = 'DRUG_DIVISIBILITY_DIVISIBLE',
  DrugDivisibilityDivisibleForSwallowing = 'DRUG_DIVISIBILITY_DIVISIBLE_FOR_SWALLOWING',
  DrugDivisibilityDivisibleIntoHalves = 'DRUG_DIVISIBILITY_DIVISIBLE_INTO_HALVES',
  DrugDivisibilityDivisibleIntoQuarters = 'DRUG_DIVISIBILITY_DIVISIBLE_INTO_QUARTERS',
  DrugDivisibilityDivisibleIntoThirds = 'DRUG_DIVISIBILITY_DIVISIBLE_INTO_THIRDS',
  DrugDivisibilityIndivisibile = 'DRUG_DIVISIBILITY_INDIVISIBILE',
  DrugDivisibilityNone = 'DRUG_DIVISIBILITY_NONE',
  DrugDivisibilityUnknown = 'DRUG_DIVISIBILITY_UNKNOWN'
}

export enum Drug_DrugDosageUnitDataset {
  DrugDosageUnitDatasetMmi = 'DRUG_DOSAGE_UNIT_DATASET_MMI',
  DrugDosageUnitDatasetNone = 'DRUG_DOSAGE_UNIT_DATASET_NONE'
}

export type Drug_DrugDosageUnitsEntryMsg = {
  __typename?: 'drug_DrugDosageUnitsEntryMsg';
  dosageUnits?: Maybe<Array<Maybe<Knowledge_MedicationDosageUnitResult>>>;
  drugIdentifier?: Maybe<Scalars['String']>;
};

export enum Drug_DrugFlag {
  DrugFlagAdjuvant = 'DRUG_FLAG_ADJUVANT',
  /** "Drug" is anthroposophic */
  DrugFlagAnthroposophic = 'DRUG_FLAG_ANTHROPOSOPHIC',
  /** "Drug" is a bandage */
  DrugFlagBandage = 'DRUG_FLAG_BANDAGE',
  /** "Drug" is a dipstick, i.e., a measurement device */
  DrugFlagDipstick = 'DRUG_FLAG_DIPSTICK',
  /** "Drug" is a food for special medical purposes (FSMI), in German "bilanzierte Diät" */
  DrugFlagFoodForSpecialMedicalPurpose = 'DRUG_FLAG_FOOD_FOR_SPECIAL_MEDICAL_PURPOSE',
  /** German "Praxisbesonderheit nach § 130b SGB V" */
  DrugFlagGermanAmnogSpecialRequirement = 'DRUG_FLAG_GERMAN_AMNOG_SPECIAL_REQUIREMENT',
  /** German "Blaue-Hand-Brief" */
  DrugFlagGermanBlueHand = 'DRUG_FLAG_GERMAN_BLUE_HAND',
  /** German "Verordnungsausschluss der AM-RL Anlage III", meaning there are situations in which this must not be prescribed */
  DrugFlagGermanConditionalPrescriptionExclusion = 'DRUG_FLAG_GERMAN_CONDITIONAL_PRESCRIPTION_EXCLUSION',
  /** German "Verordnungseinschränkung der AM-RL Anlage III", meaning there are limitations on when this can be prescribed */
  DrugFlagGermanConditionalPrescriptionLimitation = 'DRUG_FLAG_GERMAN_CONDITIONAL_PRESCRIPTION_LIMITATION',
  /** German "Lifestyle-Arzneimittel" */
  DrugFlagGermanLifestyleWithoutExceptions = 'DRUG_FLAG_GERMAN_LIFESTYLE_WITHOUT_EXCEPTIONS',
  /** German "bedingtes Lifestyle-Arzneimittel" */
  DrugFlagGermanLifestyleWithExceptions = 'DRUG_FLAG_GERMAN_LIFESTYLE_WITH_EXCEPTIONS',
  /** German "Negativliste" for unprofitable drugs */
  DrugFlagGermanNegativeList = 'DRUG_FLAG_GERMAN_NEGATIVE_LIST',
  /** German "Negativliste" for unprofitable drugs, entry "eingeschränkt" */
  DrugFlagGermanNegativeListLimited = 'DRUG_FLAG_GERMAN_NEGATIVE_LIST_LIMITED',
  /** German "Diätetikum nach § 31 Absatz 5 SGB V" */
  DrugFlagGermanOfficialDietetic = 'DRUG_FLAG_GERMAN_OFFICIAL_DIETETIC',
  /** German "sonstiges Diätetikum" */
  DrugFlagGermanOtherDietetic = 'DRUG_FLAG_GERMAN_OTHER_DIETETIC',
  /** German "OTC-Arzneimittel mit Ausnahmeregelungen für Kinder ab 12 Jahren und Erwachsene (sogenannte OTX-Arzneimittel; AM-RL Anlage I)" */
  DrugFlagGermanOtxDrug = 'DRUG_FLAG_GERMAN_OTX_DRUG',
  /** German "Verordnungsfähiges Medizinprodukt nach § 31 Absatz 1 Nummer 2 SGB V" */
  DrugFlagGermanPrescribableMedicalDevice = 'DRUG_FLAG_GERMAN_PRESCRIBABLE_MEDICAL_DEVICE',
  /** German "Rote-Hand-Brief" */
  DrugFlagGermanRedHand = 'DRUG_FLAG_GERMAN_RED_HAND',
  /** German "Substitutionsausschlussliste, Anlage VII, Teil B der Arzneimittel-Richtlinie" */
  DrugFlagGermanSubstitutionExclusion = 'DRUG_FLAG_GERMAN_SUBSTITUTION_EXCLUSION',
  /** Existence of German "Therapiehinweis des G-BA (AM-RL Anlage IV)" */
  DrugFlagGermanTherapyHint = 'DRUG_FLAG_GERMAN_THERAPY_HINT',
  /** German transfusion law (TFG) applies for this drug */
  DrugFlagGermanTransfusionLawApplicable = 'DRUG_FLAG_GERMAN_TRANSFUSION_LAW_APPLICABLE',
  /** German transfusion law (TFG) applies for this drug with special handling of hemophilia */
  DrugFlagGermanTransfusionLawForHemophiliaApplicable = 'DRUG_FLAG_GERMAN_TRANSFUSION_LAW_FOR_HEMOPHILIA_APPLICABLE',
  /** Drug is prescribed using special "T-Rezept" */
  DrugFlagGermanTPrescriptionExclusive = 'DRUG_FLAG_GERMAN_T_PRESCRIPTION_EXCLUSIVE',
  /** "Drug" is homoeopathic */
  DrugFlagHomoeopathic = 'DRUG_FLAG_HOMOEOPATHIC',
  /** Drug is imported from other country */
  DrugFlagImported = 'DRUG_FLAG_IMPORTED',
  /** "Drug" is a medical device */
  DrugFlagMedicalDevice = 'DRUG_FLAG_MEDICAL_DEVICE',
  /** General flags */
  DrugFlagNarcotic = 'DRUG_FLAG_NARCOTIC',
  DrugFlagNone = 'DRUG_FLAG_NONE',
  /** Drug is only available through pharmacy */
  DrugFlagPharmacyExclusive = 'DRUG_FLAG_PHARMACY_EXCLUSIVE',
  /** Drug can not be sold without matching prescription */
  DrugFlagPrescriptionExclusive = 'DRUG_FLAG_PRESCRIPTION_EXCLUSIVE'
}

export enum Drug_DrugFormDataset {
  DrugFormDatasetMmi = 'DRUG_FORM_DATASET_MMI',
  DrugFormDatasetNone = 'DRUG_FORM_DATASET_NONE'
}

export type Drug_DrugFormMsg = {
  __typename?: 'drug_DrugFormMsg';
  externalIds?: Maybe<Array<Maybe<Drug_ExternalDrugFormIdMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Drug_DrugIdentifierMsg = {
  __typename?: 'drug_DrugIdentifierMsg';
  integerId?: Maybe<Scalars['Int']>;
};

export type Drug_DrugInformationMsg = {
  __typename?: 'drug_DrugInformationMsg';
  /** The content of the information */
  contentHtml?: Maybe<Scalars['String']>;
  /** The content might be provided in e.g., pdf format, in which case this references that document */
  contentStaticDocumentId?: Maybe<Scalars['String']>;
  /** Only relevant if set; date until this information is valid */
  expirationDate?: Maybe<Timestamp>;
  /** optional; set if the content has a separate title. Set for type GERMAN_OFFICIAL_PRODUCT_CHARACTERISTICS */
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_DrugInformationType>;
  /** Only relevant if set; date from which this information is valid */
  validityStartDate?: Maybe<Timestamp>;
};

export enum Drug_DrugInformationType {
  /** Information about general characteristics of the drug */
  DrugInformationTypeCharacteristics = 'DRUG_INFORMATION_TYPE_CHARACTERISTICS',
  /** Details about the composition of the drug */
  DrugInformationTypeComposition = 'DRUG_INFORMATION_TYPE_COMPOSITION',
  /** Information about situations in which the drug should not be used because it may be harmful */
  DrugInformationTypeContraindications = 'DRUG_INFORMATION_TYPE_CONTRAINDICATIONS',
  /** Details about the drug's dosage */
  DrugInformationTypeDosage = 'DRUG_INFORMATION_TYPE_DOSAGE',
  /** Information about how the drug affects fertility */
  DrugInformationTypeFertility = 'DRUG_INFORMATION_TYPE_FERTILITY',
  /** General details about the drug */
  DrugInformationTypeGeneral = 'DRUG_INFORMATION_TYPE_GENERAL',
  /** German "Praxisbesonderheit nach § 130b SGB V", its text is simply a link */
  DrugInformationTypeGermanAmnogSpecialRequirement = 'DRUG_INFORMATION_TYPE_GERMAN_AMNOG_SPECIAL_REQUIREMENT',
  /** German "Blaue-Hand-Brief" */
  DrugInformationTypeGermanBlueHand = 'DRUG_INFORMATION_TYPE_GERMAN_BLUE_HAND',
  /** German "Fachinformationen der Gelben Liste Pharmindex" */
  DrugInformationTypeGermanOfficialProductCharacteristics = 'DRUG_INFORMATION_TYPE_GERMAN_OFFICIAL_PRODUCT_CHARACTERISTICS',
  /** "Texte der AM-RL Anlage I (OTC-Ausnahmeliste)" */
  DrugInformationTypeGermanOtcException = 'DRUG_INFORMATION_TYPE_GERMAN_OTC_EXCEPTION',
  /** "Einträge der Arzneimittel-Richtlinien, Anlage V: Übersicht der verordnungsfähigen Medizinprodukte (zu Lasten der GKV)" */
  DrugInformationTypeGermanPrescriptionInclusion = 'DRUG_INFORMATION_TYPE_GERMAN_PRESCRIPTION_INCLUSION',
  /** "Texte der Verordnungseinschränkungen/-ausschlüssen der AM-RL Anlage III" */
  DrugInformationTypeGermanPrescriptionRegulation = 'DRUG_INFORMATION_TYPE_GERMAN_PRESCRIPTION_REGULATION',
  /** German "Rote-Hand-Brief" */
  DrugInformationTypeGermanRedHand = 'DRUG_INFORMATION_TYPE_GERMAN_RED_HAND',
  /** German "Therapiehinweis des G-BA (AM-RL Anlage IV)" */
  DrugInformationTypeGermanTherapyHint = 'DRUG_INFORMATION_TYPE_GERMAN_THERAPY_HINT',
  /** Information about ingredients of the drug */
  DrugInformationTypeIngredients = 'DRUG_INFORMATION_TYPE_INGREDIENTS',
  /** Interactions the drug has with other drugs */
  DrugInformationTypeInteractions = 'DRUG_INFORMATION_TYPE_INTERACTIONS',
  DrugInformationTypeNone = 'DRUG_INFORMATION_TYPE_NONE',
  /** Information about risks when taking this drug during the nursing period */
  DrugInformationTypeNursingPeriod = 'DRUG_INFORMATION_TYPE_NURSING_PERIOD',
  /** Information about pregnancy-related risks */
  DrugInformationTypePregnancy = 'DRUG_INFORMATION_TYPE_PREGNANCY',
  /** Information about situations in which the drug should only be used after careful consideration. TODO: name */
  DrugInformationTypeProvisionRestriction = 'DRUG_INFORMATION_TYPE_PROVISION_RESTRICTION',
  /** Recommendations for how to take the drug */
  DrugInformationTypeRecommendations = 'DRUG_INFORMATION_TYPE_RECOMMENDATIONS',
  /** Side effects the drug has */
  DrugInformationTypeSideEffects = 'DRUG_INFORMATION_TYPE_SIDE_EFFECTS',
  /** Information about the drug's toxicity */
  DrugInformationTypeToxicity = 'DRUG_INFORMATION_TYPE_TOXICITY',
  /** Details about how the drug should be used */
  DrugInformationTypeUsage = 'DRUG_INFORMATION_TYPE_USAGE',
  /** Warnings about the drug */
  DrugInformationTypeWarnings = 'DRUG_INFORMATION_TYPE_WARNINGS'
}

export type Drug_DrugInstanceMsg = {
  __typename?: 'drug_DrugInstanceMsg';
  /**
   * If type is REFERENCE, this is the resolved drug and immutable.
   *  If type is EMBEDDED, the drug in this field is the embedded drug and potentially mutable.
   */
  drug?: Maybe<Drug_DrugMsg>;
  /** only set if type is REFERENCE */
  reference?: Maybe<Drug_DrugReferenceMsg>;
  type?: Maybe<Drug_DrugInstanceType>;
};

export enum Drug_DrugInstanceType {
  DrugInstanceTypeEmbedded = 'DRUG_INSTANCE_TYPE_EMBEDDED',
  DrugInstanceTypeNone = 'DRUG_INSTANCE_TYPE_NONE',
  DrugInstanceTypeReference = 'DRUG_INSTANCE_TYPE_REFERENCE'
}

export type Drug_DrugLinkMsg = {
  __typename?: 'drug_DrugLinkMsg';
  drug?: Maybe<Drug_DrugMsg>;
  reference?: Maybe<Drug_DrugReferenceMsg>;
};

export type Drug_DrugMsg = {
  __typename?: 'drug_DrugMsg';
  activeIngredients?: Maybe<Array<Maybe<Drug_ActiveIngredientMsg>>>;
  allowedIntakeMechanisms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  allowedIntakeTypes?: Maybe<Array<Maybe<Knowledge_IntakeTypeMsg>>>;
  atcCodes?: Maybe<Array<Maybe<Drug_AtcCodeMsg>>>;
  /** Should appear as an option by default as a reconstitution and dilution solution. */
  defaultSolution?: Maybe<Scalars['Boolean']>;
  dilutionOptions?: Maybe<Array<Maybe<Drug_MedicationComponentMsg>>>;
  /** Anzeigename. Note: this is explicitly separate from the synonyms */
  displayName?: Maybe<Scalars['String']>;
  divisibility?: Maybe<Drug_DrugDivisibility>;
  dosageUnit?: Maybe<Medication_MedicationDosageUnitMsg>;
  externalIds?: Maybe<Array<Maybe<Drug_ExternalDrugIdMsg>>>;
  /** flags, informationTexts, purposes aren't set for the custom drugs. */
  flags?: Maybe<Array<Maybe<Drug_DrugFlag>>>;
  form?: Maybe<Drug_DrugFormMsg>;
  germanBillingProperties?: Maybe<Drug_GermanBillingPropertiesMsg>;
  /** Eigenanfertigung */
  inHouseProduction?: Maybe<Scalars['Boolean']>;
  informationTexts?: Maybe<Array<Maybe<Drug_DrugInformationMsg>>>;
  isInFormulary?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Hinweise der Apotheke */
  pharmacyNotes?: Maybe<Scalars['String']>;
  purposes?: Maybe<Array<Maybe<Drug_DrugPurposeMsg>>>;
  reconstitutionOptions?: Maybe<Array<Maybe<Drug_MedicationComponentMsg>>>;
  requireDilution?: Maybe<Scalars['Boolean']>;
  /** Rekonstitution */
  requireReconstitution?: Maybe<Scalars['Boolean']>;
  /** Lieferant */
  supplier?: Maybe<Scalars['String']>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Drug_DrugPackageBenefitAssessmentMsg = {
  __typename?: 'drug_DrugPackageBenefitAssessmentMsg';
  contentHtml?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** German "Beschluss zur Nutzenbewertung nach § 35a SGB V (AM-RL Anlage XII)" */
export type Drug_DrugPackageBenefitResolutionMsg = {
  __typename?: 'drug_DrugPackageBenefitResolutionMsg';
  /** Benefit assessments, in Germany for specific patient groups */
  benefitAssessments?: Maybe<Array<Maybe<Drug_DrugPackageBenefitAssessmentMsg>>>;
  contentHtml?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Drug_DrugPackageDiscountMsg = {
  __typename?: 'drug_DrugPackageDiscountMsg';
  /** Discount in price unit */
  absoluteDiscount?: Maybe<Scalars['Float']>;
  /** Which of the prices is discounted */
  discountedPriceType?: Maybe<Drug_DrugPackagePriceType>;
  /** Discount in % */
  relativeDiscount?: Maybe<Scalars['Float']>;
};

export enum Drug_DrugPackageFlag {
  /** Whether the drug package information can be edited ad-hoc after selection */
  DrugPackageFlagAdHocEditable = 'DRUG_PACKAGE_FLAG_AD_HOC_EDITABLE',
  /** Whether a cheaper alternative with the same active ingredients and strengths exists */
  DrugPackageFlagCheaperAlternativeExists = 'DRUG_PACKAGE_FLAG_CHEAPER_ALTERNATIVE_EXISTS',
  /**
   * True if a different package suitable for substitution exists that is discounted;
   *  only set if the package itself isn't discounted
   */
  DrugPackageFlagDiscountedAlternativeExists = 'DRUG_PACKAGE_FLAG_DISCOUNTED_ALTERNATIVE_EXISTS',
  /** German "Arzneimittel für neuartige Therapien im Sinne von § 4 Absatz 9" */
  DrugPackageFlagGermanAdvancedTherapyMedicinalProducts = 'DRUG_PACKAGE_FLAG_GERMAN_ADVANCED_THERAPY_MEDICINAL_PRODUCTS',
  /** Special price regulation according to Arzneimittelmarktneuordnungsgesetz (AMNOG) */
  DrugPackageFlagGermanAmnog = 'DRUG_PACKAGE_FLAG_GERMAN_AMNOG',
  /** German "Beschlüsse des G-BA nach §35a SGB V", Nutzenbewertung */
  DrugPackageFlagGermanBenefitAssessment = 'DRUG_PACKAGE_FLAG_GERMAN_BENEFIT_ASSESSMENT',
  /** German "Klinik-/Anstaltspackung" */
  DrugPackageFlagGermanClinicPackage = 'DRUG_PACKAGE_FLAG_GERMAN_CLINIC_PACKAGE',
  /** Rabattvereinbarung nach § 130a Absatz 8 SGB V für die jeweilige Krankenkasse */
  DrugPackageFlagGermanDiscountApplicable = 'DRUG_PACKAGE_FLAG_GERMAN_DISCOUNT_APPLICABLE',
  /** German "Ärztemuster gemäß AMG" */
  DrugPackageFlagGermanDoctorSample = 'DRUG_PACKAGE_FLAG_GERMAN_DOCTOR_SAMPLE',
  /** German "Zuzahlungsfreistellung" (§ 31 Absatz 3 SGB V) */
  DrugPackageFlagGermanPatientCoPaymentExclusion = 'DRUG_PACKAGE_FLAG_GERMAN_PATIENT_CO_PAYMENT_EXCLUSION',
  /** German "Verordnungsfähiges Verbandmittel nach § 31 Absatz 1a SGB V" */
  DrugPackageFlagGermanPrescribableBandage = 'DRUG_PACKAGE_FLAG_GERMAN_PRESCRIBABLE_BANDAGE',
  /** German "Merkmal regionale Arzneimittelvereinbarung nach § 84 Absatz 1 SGB V für dieses Produkt" */
  DrugPackageFlagGermanRegionalAgreement = 'DRUG_PACKAGE_FLAG_GERMAN_REGIONAL_AGREEMENT',
  /** German "Reserveantibiotikum nach § 35a Abs. 1c" */
  DrugPackageFlagGermanReserveAntibiotic = 'DRUG_PACKAGE_FLAG_GERMAN_RESERVE_ANTIBIOTIC',
  /** Begleitende Datenerhebung ohne Verordnungseinschränkung nach § 35a Absatz 3b SGB V */
  DrugPackageFlagGermanSurveyWithoutPrescriptionLimitation = 'DRUG_PACKAGE_FLAG_GERMAN_SURVEY_WITHOUT_PRESCRIPTION_LIMITATION',
  /** Begleitende Datenerhebung mit Verordnungseinschränkung nach § 35a Absatz 3b SGB V */
  DrugPackageFlagGermanSurveyWithPrescriptionLimitation = 'DRUG_PACKAGE_FLAG_GERMAN_SURVEY_WITH_PRESCRIPTION_LIMITATION',
  /** Flags related to market status */
  DrugPackageFlagNone = 'DRUG_PACKAGE_FLAG_NONE',
  /** Package is being recalled from sale, German "Zurückgezogen"? // TODO: check */
  DrugPackageFlagNotAllowedToBeSold = 'DRUG_PACKAGE_FLAG_NOT_ALLOWED_TO_BE_SOLD',
  /** Not sold anymore, German "Außer Vertrieb" */
  DrugPackageFlagOffMarket = 'DRUG_PACKAGE_FLAG_OFF_MARKET'
}

export type Drug_DrugPackageIdentifierMsg = {
  __typename?: 'drug_DrugPackageIdentifierMsg';
  integerId?: Maybe<Scalars['Int']>;
};

/** In which context the drug package information applies, e.g. for which diseases certain hints must be considered */
export type Drug_DrugPackageInformationContextMsg = {
  __typename?: 'drug_DrugPackageInformationContextMsg';
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_DrugPackageInformationContextType>;
};

export enum Drug_DrugPackageInformationContextType {
  DrugPackageInformationContextTypeIcd10 = 'DRUG_PACKAGE_INFORMATION_CONTEXT_TYPE_ICD10',
  DrugPackageInformationContextTypeNone = 'DRUG_PACKAGE_INFORMATION_CONTEXT_TYPE_NONE'
}

export type Drug_DrugPackageInformationMsg = {
  __typename?: 'drug_DrugPackageInformationMsg';
  /** Content of the information, often in html format */
  content?: Maybe<Scalars['String']>;
  /** Only relevant if set; date when this information was created, can differ from validity */
  creationDate?: Maybe<Timestamp>;
  /** Only relevant if set; date until this information is valid */
  expirationDate?: Maybe<Timestamp>;
  /** optional title */
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_DrugPackageInformationType>;
  /** Only relevant if set; date from which this information is valid */
  validityStartDate?: Maybe<Timestamp>;
};

export enum Drug_DrugPackageInformationType {
  /** Information about the composition of the drug package, relevant for e.g., medical devices */
  DrugPackageInformationTypeComposition = 'DRUG_PACKAGE_INFORMATION_TYPE_COMPOSITION',
  DrugPackageInformationTypeGermanRegionalAgreement = 'DRUG_PACKAGE_INFORMATION_TYPE_GERMAN_REGIONAL_AGREEMENT',
  DrugPackageInformationTypeNone = 'DRUG_PACKAGE_INFORMATION_TYPE_NONE',
  /** Which purpose this drug package is for, relevant for e.g., medical devices */
  DrugPackageInformationTypePurpose = 'DRUG_PACKAGE_INFORMATION_TYPE_PURPOSE'
}

export type Drug_DrugPackageList = {
  __typename?: 'drug_DrugPackageList';
  drugPackages?: Maybe<Array<Maybe<Drug_DrugPackageMsg>>>;
};

/**
 * A specific package that contains the given drug.
 *  An example would be "Drug X, 50 pills", where "50 pills" is the additional information provided by the package.
 */
export type Drug_DrugPackageMsg = {
  __typename?: 'drug_DrugPackageMsg';
  benefitResolutions?: Maybe<Array<Maybe<Drug_DrugPackageBenefitResolutionMsg>>>;
  discounts?: Maybe<Array<Maybe<Drug_DrugPackageDiscountMsg>>>;
  drug?: Maybe<Drug_DrugMsg>;
  externalIds?: Maybe<Array<Maybe<Drug_ExternalDrugPackageIdMsg>>>;
  /** Additional characteristics of the package */
  flags?: Maybe<Array<Maybe<Drug_DrugPackageFlag>>>;
  /** only set if internal drug package (e.g., in-house medication list) */
  id?: Maybe<Scalars['String']>;
  informationTexts?: Maybe<Array<Maybe<Drug_DrugPackageInformationMsg>>>;
  packageName?: Maybe<Scalars['String']>;
  packageSize?: Maybe<Scalars['String']>;
  packageSizeUnit?: Maybe<Scalars['String']>;
  /** priceHistory contains last three selling price changes and it's ordered by validFrom descending */
  priceHistory?: Maybe<Array<Maybe<Drug_DrugPackagePriceHistoryMsg>>>;
  prices?: Maybe<Array<Maybe<Drug_DrugPackagePriceMsg>>>;
  sizeType?: Maybe<Drug_DrugPackageSizeType>;
  source?: Maybe<Drug_DrugPackageSource>;
};

export type Drug_DrugPackagePriceHistoryMsg = {
  __typename?: 'drug_DrugPackagePriceHistoryMsg';
  price?: Maybe<Scalars['Float']>;
  validFrom?: Maybe<Timestamp>;
};

export type Drug_DrugPackagePriceMsg = {
  __typename?: 'drug_DrugPackagePriceMsg';
  price?: Maybe<Scalars['Float']>;
  type?: Maybe<Drug_DrugPackagePriceType>;
};

export enum Drug_DrugPackagePriceType {
  /** Price the patient has to pay (before discounts), i.e., sum of patient co-payment and additional cost. */
  DrugPackagePricePatientPayment = 'DRUG_PACKAGE_PRICE_PATIENT_PAYMENT',
  /** Difference between SELLING_PRICE and FIXED_REIMBURSEMENT */
  DrugPackagePriceTypeAdditionalCost = 'DRUG_PACKAGE_PRICE_TYPE_ADDITIONAL_COST',
  /** Amount that is covered by insurance in any case */
  DrugPackagePriceTypeFixedReimbursement = 'DRUG_PACKAGE_PRICE_TYPE_FIXED_REIMBURSEMENT',
  /** Fixed price that the insurance pays to the manufacturer, in Germany: "Erstattungsbetrag nach § 130b Absatz 1 Satz 1 SGB V" */
  DrugPackagePriceTypeInsurancePayment = 'DRUG_PACKAGE_PRICE_TYPE_INSURANCE_PAYMENT',
  DrugPackagePriceTypeNone = 'DRUG_PACKAGE_PRICE_TYPE_NONE',
  /** Fixed price which the patient has to pay, independent of the other prices. Total payment can be higher than this. */
  DrugPackagePriceTypePatientCoPayment = 'DRUG_PACKAGE_PRICE_TYPE_PATIENT_CO_PAYMENT',
  /** Price recommended by the manufacturer */
  DrugPackagePriceTypeRecommended = 'DRUG_PACKAGE_PRICE_TYPE_RECOMMENDED',
  /** Price at which the drug package is sold */
  DrugPackagePriceTypeSellingPrice = 'DRUG_PACKAGE_PRICE_TYPE_SELLING_PRICE'
}

export enum Drug_DrugPackageSearchField {
  DrugPackageSearchFieldAllFields = 'DRUG_PACKAGE_SEARCH_FIELD_ALL_FIELDS',
  DrugPackageSearchFieldAllFieldsExceptNameAndManufacturer = 'DRUG_PACKAGE_SEARCH_FIELD_ALL_FIELDS_EXCEPT_NAME_AND_MANUFACTURER',
  DrugPackageSearchFieldManufacturer = 'DRUG_PACKAGE_SEARCH_FIELD_MANUFACTURER',
  DrugPackageSearchFieldName = 'DRUG_PACKAGE_SEARCH_FIELD_NAME',
  DrugPackageSearchFieldNone = 'DRUG_PACKAGE_SEARCH_FIELD_NONE'
}

export enum Drug_DrugPackageSizeType {
  DrugPackageSizeTypeN1 = 'DRUG_PACKAGE_SIZE_TYPE_N1',
  DrugPackageSizeTypeN2 = 'DRUG_PACKAGE_SIZE_TYPE_N2',
  DrugPackageSizeTypeN3 = 'DRUG_PACKAGE_SIZE_TYPE_N3',
  DrugPackageSizeTypeNone = 'DRUG_PACKAGE_SIZE_TYPE_NONE',
  /** German "Keine therapiegerechte Packungsgroesse" */
  DrugPackageSizeTypeNonTherapeutic = 'DRUG_PACKAGE_SIZE_TYPE_NON_THERAPEUTIC',
  /** German "Nicht betroffen" */
  DrugPackageSizeTypeNotApplicable = 'DRUG_PACKAGE_SIZE_TYPE_NOT_APPLICABLE',
  /** German "Keine Angabe" */
  DrugPackageSizeTypeUnspecified = 'DRUG_PACKAGE_SIZE_TYPE_UNSPECIFIED'
}

export enum Drug_DrugPackageSource {
  DrugPackageSourceCustom = 'DRUG_PACKAGE_SOURCE_CUSTOM',
  DrugPackageSourceMmi = 'DRUG_PACKAGE_SOURCE_MMI',
  DrugPackageSourceNone = 'DRUG_PACKAGE_SOURCE_NONE'
}

/** What this drug is used for, e.g. against which disease */
export type Drug_DrugPurposeMsg = {
  __typename?: 'drug_DrugPurposeMsg';
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_DrugPurposeType>;
};

export enum Drug_DrugPurposeType {
  DrugPurposeTypeIcd10 = 'DRUG_PURPOSE_TYPE_ICD10',
  DrugPurposeTypeNone = 'DRUG_PURPOSE_TYPE_NONE'
}

export type Drug_DrugReferenceMsg = {
  __typename?: 'drug_DrugReferenceMsg';
  identifier?: Maybe<Scalars['String']>;
  overrideEntryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Drug_DrugReferenceType>;
};

export enum Drug_DrugReferenceType {
  DrugSourceReferenceCustomDrugEntry = 'DRUG_SOURCE_REFERENCE_CUSTOM_DRUG_ENTRY',
  DrugSourceReferenceMmiDrug = 'DRUG_SOURCE_REFERENCE_MMI_DRUG',
  DrugSourceReferenceNone = 'DRUG_SOURCE_REFERENCE_NONE'
}

export enum Drug_DrugReplacementSuggestionType {
  DrugReplacementSuggestionTypeDiscountedPackages = 'DRUG_REPLACEMENT_SUGGESTION_TYPE_DISCOUNTED_PACKAGES',
  DrugReplacementSuggestionTypeNone = 'DRUG_REPLACEMENT_SUGGESTION_TYPE_NONE',
  DrugReplacementSuggestionTypePriceComparison = 'DRUG_REPLACEMENT_SUGGESTION_TYPE_PRICE_COMPARISON',
  DrugReplacementSuggestionTypeRegionalAgreements = 'DRUG_REPLACEMENT_SUGGESTION_TYPE_REGIONAL_AGREEMENTS'
}

export type Drug_DrugSearchResultMsg = {
  __typename?: 'drug_DrugSearchResultMsg';
  drug?: Maybe<Drug_DrugMsg>;
  reference?: Maybe<Drug_DrugReferenceMsg>;
};

export type Drug_ExternalActiveIngredientIdMsg = {
  __typename?: 'drug_ExternalActiveIngredientIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalActiveIngredientIdType>;
};

export enum Drug_ExternalActiveIngredientIdType {
  /** German Arzneistoffkatalog-Nummer */
  ExternalActiveIngredientIdTypeAsk = 'EXTERNAL_ACTIVE_INGREDIENT_ID_TYPE_ASK',
  /** WHO's Anatomical Therapeutic Chemical (ATC) Classification System */
  ExternalActiveIngredientIdTypeAtc = 'EXTERNAL_ACTIVE_INGREDIENT_ID_TYPE_ATC',
  /** Chemical Abstracts Service number (international standard for chemicals) for active ingredients */
  ExternalActiveIngredientIdTypeCas = 'EXTERNAL_ACTIVE_INGREDIENT_ID_TYPE_CAS',
  ExternalActiveIngredientIdTypeMmi = 'EXTERNAL_ACTIVE_INGREDIENT_ID_TYPE_MMI',
  ExternalActiveIngredientIdTypeNone = 'EXTERNAL_ACTIVE_INGREDIENT_ID_TYPE_NONE'
}

export type Drug_ExternalActiveIngredientStrengthUnitIdMsg = {
  __typename?: 'drug_ExternalActiveIngredientStrengthUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalActiveIngredientStrengthUnitIdType>;
};

export enum Drug_ExternalActiveIngredientStrengthUnitIdType {
  /** System for German "Bundeseinheitlicher Medikationsplan" */
  ExternalActiveIngredientStrengthUnitIdTypeBmp = 'EXTERNAL_ACTIVE_INGREDIENT_STRENGTH_UNIT_ID_TYPE_BMP',
  ExternalActiveIngredientStrengthUnitIdTypeMmi = 'EXTERNAL_ACTIVE_INGREDIENT_STRENGTH_UNIT_ID_TYPE_MMI',
  ExternalActiveIngredientStrengthUnitIdTypeNone = 'EXTERNAL_ACTIVE_INGREDIENT_STRENGTH_UNIT_ID_TYPE_NONE'
}

export type Drug_ExternalDrugFormIdMsg = {
  __typename?: 'drug_ExternalDrugFormIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalDrugFormIdType>;
};

export enum Drug_ExternalDrugFormIdType {
  ExternalDrugFormIdTypeBmpShortName = 'EXTERNAL_DRUG_FORM_ID_TYPE_BMP_SHORT_NAME',
  ExternalDrugFormIdTypeIfa = 'EXTERNAL_DRUG_FORM_ID_TYPE_IFA',
  ExternalDrugFormIdTypeNone = 'EXTERNAL_DRUG_FORM_ID_TYPE_NONE'
}

export type Drug_ExternalDrugIdMsg = {
  __typename?: 'drug_ExternalDrugIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalDrugIdType>;
};

export enum Drug_ExternalDrugIdType {
  ExternalDrugIdTypeNone = 'EXTERNAL_DRUG_ID_TYPE_NONE',
  ExternalDrugIdTypeRegistrationNumber = 'EXTERNAL_DRUG_ID_TYPE_REGISTRATION_NUMBER',
  ExternalDrugIdTypeVidalVmp = 'EXTERNAL_DRUG_ID_TYPE_VIDAL_VMP'
}

export type Drug_ExternalDrugPackageIdMsg = {
  __typename?: 'drug_ExternalDrugPackageIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDrugPackageIdType>;
};

export enum Drug_ExternalDrugSourceType {
  ExternalDrugSourceTypeMmi = 'EXTERNAL_DRUG_SOURCE_TYPE_MMI',
  ExternalDrugSourceTypeNone = 'EXTERNAL_DRUG_SOURCE_TYPE_NONE'
}

/** by default, output list is sorted ascending by selling price */
export type Drug_FindDrugPackageReplacementSuggestionsRequest = {
  __typename?: 'drug_FindDrugPackageReplacementSuggestionsRequest';
  /** mandatory */
  drugPackageIdentifier?: Maybe<Drug_DrugPackageIdentifierMsg>;
  /**
   * optional filter
   *  For Germans: IKNR
   */
  externalInsurerId?: Maybe<Scalars['String']>;
  /**
   * German KVID, shouldn't be set if BSNR known
   * @deprecated deprecated in proto
   */
  externalInsurerNetworkId?: Maybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: Maybe<Scalars['String']>;
  /** German LANR, used to filter/fetch results that depend on this */
  externalUserId?: Maybe<Scalars['String']>;
  /** mandatory */
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: Maybe<Timestamp>;
  /** mandatory */
  suggestionType?: Maybe<Drug_DrugReplacementSuggestionType>;
};

export type Drug_FindDrugPackagesByPznRequest = {
  __typename?: 'drug_FindDrugPackagesByPznRequest';
  pzn?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Drug_FindDrugPackagesByPznResponse = {
  __typename?: 'drug_FindDrugPackagesByPznResponse';
  pznToDrugPackage?: Maybe<Array<Maybe<Drug_FindDrugPackagesByPznResponse_PznToDrugPackageEntry>>>;
};

export type Drug_FindDrugPackagesByPznResponse_PznToDrugPackageEntry = {
  __typename?: 'drug_FindDrugPackagesByPznResponse_PznToDrugPackageEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Drug_PznToDrugPackageMapEntry>;
};

export type Drug_FindDrugRequest = {
  __typename?: 'drug_FindDrugRequest';
  includeInformationTexts?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Drug_DrugReferenceMsg>;
};

export type Drug_FindDrugResponse = {
  __typename?: 'drug_FindDrugResponse';
  drugLink?: Maybe<Drug_DrugLinkMsg>;
};

export type Drug_FindDrugsByExternalDrugPackageIdsRequest = {
  __typename?: 'drug_FindDrugsByExternalDrugPackageIdsRequest';
  externalIdType?: Maybe<Knowledge_ExternalDrugPackageIdType>;
  externalIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Drug_FindDrugsByExternalDrugPackageIdsResponse = {
  __typename?: 'drug_FindDrugsByExternalDrugPackageIdsResponse';
  externalIdToDrugReference?: Maybe<Array<Maybe<Drug_FindDrugsByExternalDrugPackageIdsResponse_ExternalIdToDrugReferenceEntry>>>;
};

export type Drug_FindDrugsByExternalDrugPackageIdsResponse_ExternalIdToDrugReferenceEntry = {
  __typename?: 'drug_FindDrugsByExternalDrugPackageIdsResponse_ExternalIdToDrugReferenceEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Drug_DrugReferenceMsg>;
};

export type Drug_FindDrugsRequest = {
  __typename?: 'drug_FindDrugsRequest';
  references?: Maybe<Array<Maybe<Drug_DrugReferenceMsg>>>;
};

export type Drug_FindDrugsResponse = {
  __typename?: 'drug_FindDrugsResponse';
  drugLinks?: Maybe<Array<Maybe<Drug_DrugLinkMsg>>>;
};

/** by default, output list is sorted ascending by selling price */
export type Drug_FindSimilarDrugPackagesRequest = {
  __typename?: 'drug_FindSimilarDrugPackagesRequest';
  /** mandatory */
  drugPackageIdentifier?: Maybe<Drug_DrugPackageIdentifierMsg>;
  /** For Germans: IKNR; required if onlyDiscounted == true */
  externalInsurerId?: Maybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  /** optional filter */
  onlyDiscounted?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: Maybe<Timestamp>;
};

export type Drug_GermanBillingPropertiesMsg = {
  __typename?: 'drug_GermanBillingPropertiesMsg';
  /** ZE Nummer */
  additionalReimbursementCode?: Maybe<Scalars['String']>;
  /** ZE Hinweis */
  additionalReimbursementNotes?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Drug_GermanMedicationBillingTag>>>;
};

export enum Drug_GermanMedicationBillingTag {
  GermanMedicationBillingTagNone = 'GERMAN_MEDICATION_BILLING_TAG_NONE',
  GermanMedicationBillingTagNub = 'GERMAN_MEDICATION_BILLING_TAG_NUB',
  GermanMedicationBillingTagZe = 'GERMAN_MEDICATION_BILLING_TAG_ZE'
}

export type Drug_GetDrugDataVersionRequest = {
  __typename?: 'drug_GetDrugDataVersionRequest';
  sourceType?: Maybe<Drug_ExternalDrugSourceType>;
};

export type Drug_GetDrugDataVersionResponse = {
  __typename?: 'drug_GetDrugDataVersionResponse';
  version?: Maybe<Drug_DrugDataVersionMsg>;
};

export type Drug_GetDrugPackageRequest = {
  __typename?: 'drug_GetDrugPackageRequest';
  drugPackageIdentifier?: Maybe<Drug_DrugPackageIdentifierMsg>;
  /** For Germans: IKNR */
  externalInsurerId?: Maybe<Scalars['String']>;
  /**
   * German KVID, shouldn't be set if BSNR known
   * @deprecated deprecated in proto
   */
  externalInsurerNetworkId?: Maybe<Scalars['String']>;
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: Maybe<Scalars['String']>;
  /** German LANR */
  externalUserId?: Maybe<Scalars['String']>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: Maybe<Timestamp>;
};

export type Drug_GetDrugsDosageUnitsRequest = {
  __typename?: 'drug_GetDrugsDosageUnitsRequest';
  dataset?: Maybe<Drug_DrugDosageUnitDataset>;
  drugIdentifiers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Drug_GetDrugsDosageUnitsResponse = {
  __typename?: 'drug_GetDrugsDosageUnitsResponse';
  entries?: Maybe<Array<Maybe<Drug_DrugDosageUnitsEntryMsg>>>;
};

export type Drug_Icd10CodeMsg = {
  __typename?: 'drug_Icd10CodeMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Drug_ImportCustomDrugPackageRequest = {
  __typename?: 'drug_ImportCustomDrugPackageRequest';
  drugPackage?: Maybe<Drug_DrugPackageMsg>;
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
};

export type Drug_MedicationComponentMsg = {
  __typename?: 'drug_MedicationComponentMsg';
  /** if a medication consists of multiple components, their composition is specified via this field */
  compositionInfo?: Maybe<Drug_MedicationCompositionInfoMsg>;
  drugInstance?: Maybe<Drug_DrugInstanceMsg>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_MedicationComponentType>;
};

export enum Drug_MedicationComponentType {
  MedicationComponentTypeDilution = 'MEDICATION_COMPONENT_TYPE_DILUTION',
  MedicationComponentTypeMain = 'MEDICATION_COMPONENT_TYPE_MAIN',
  MedicationComponentTypeNone = 'MEDICATION_COMPONENT_TYPE_NONE',
  MedicationComponentTypeReconstitution = 'MEDICATION_COMPONENT_TYPE_RECONSTITUTION'
}

export type Drug_MedicationComponentUnitTargetMsg = {
  __typename?: 'drug_MedicationComponentUnitTargetMsg';
  targetActiveIngredientId?: Maybe<Scalars['String']>;
  targetComponent?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Drug_MedicationComponentUnitTargetType>;
};

export enum Drug_MedicationComponentUnitTargetType {
  MedicationComponentUnitTargetTypeActiveIngredientId = 'MEDICATION_COMPONENT_UNIT_TARGET_TYPE_ACTIVE_INGREDIENT_ID',
  MedicationComponentUnitTargetTypeComponent = 'MEDICATION_COMPONENT_UNIT_TARGET_TYPE_COMPONENT',
  MedicationComponentUnitTargetTypeNone = 'MEDICATION_COMPONENT_UNIT_TARGET_TYPE_NONE'
}

export type Drug_MedicationCompositionDosageUnitMsg = {
  __typename?: 'drug_MedicationCompositionDosageUnitMsg';
  externalIds?: Maybe<Array<Maybe<Medication_ExternalMedicationDosageUnitIdMsg>>>;
  target?: Maybe<Drug_MedicationComponentUnitTargetMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Drug_MedicationCompositionInfoMsg = {
  __typename?: 'drug_MedicationCompositionInfoMsg';
  dosageUnit?: Maybe<Drug_MedicationCompositionDosageUnitMsg>;
  dosageValue?: Maybe<Medication_MedicationDosageValueMsg>;
};

export type Drug_PznToDrugPackageMapEntry = {
  __typename?: 'drug_PznToDrugPackageMapEntry';
  drugPackage?: Maybe<Drug_DrugPackageMsg>;
  roaCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Drug_SearchActiveIngredientStrengthUnitsRequest = {
  __typename?: 'drug_SearchActiveIngredientStrengthUnitsRequest';
  dataset?: Maybe<Drug_ActiveIngredientStrengthUnitDataset>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Drug_SearchActiveIngredientStrengthUnitsResponse = {
  __typename?: 'drug_SearchActiveIngredientStrengthUnitsResponse';
  activeIngredientStrengthUnits?: Maybe<Array<Maybe<Drug_ActiveIngredientStrengthUnitMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchActiveIngredientsRequest = {
  __typename?: 'drug_SearchActiveIngredientsRequest';
  dataset?: Maybe<Drug_ActiveIngredientDataset>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Drug_SearchActiveIngredientsResponse = {
  __typename?: 'drug_SearchActiveIngredientsResponse';
  activeIngredients?: Maybe<Array<Maybe<Drug_ActiveIngredientMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchAtcCodesRequest = {
  __typename?: 'drug_SearchAtcCodesRequest';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
};

export type Drug_SearchAtcCodesResponse = {
  __typename?: 'drug_SearchAtcCodesResponse';
  atcCodes?: Maybe<Array<Maybe<Drug_AtcCodeMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchDrugFormsRequest = {
  __typename?: 'drug_SearchDrugFormsRequest';
  dataset?: Maybe<Drug_DrugFormDataset>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Drug_SearchDrugFormsResponse = {
  __typename?: 'drug_SearchDrugFormsResponse';
  drugForms?: Maybe<Array<Maybe<Drug_DrugFormMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchDrugInformationTextsRequest = {
  __typename?: 'drug_SearchDrugInformationTextsRequest';
  /** mandatory; currently only supports EXTERNAL_DRUG_SOURCE_TYPE_MMI */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  /** mandatory; currently only supports DRUG_INFORMATION_TYPE_GERMAN_RED_HAND, DRUG_INFORMATION_TYPE_GERMAN_BLUE_HAND */
  informationType?: Maybe<Drug_DrugInformationType>;
  /** mandatory */
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
  /** Optional full-text search filter */
  titleSearchText?: Maybe<Scalars['String']>;
  /** Optional filter; also possible to only set one of start/end */
  validityEndTimeFrame?: Maybe<TimeFrameMsg>;
  /** Optional filter; also possible to only set one of start/end */
  validityStartTimeFrame?: Maybe<TimeFrameMsg>;
};

export type Drug_SearchDrugInformationTextsResponse = {
  __typename?: 'drug_SearchDrugInformationTextsResponse';
  hitCount?: Maybe<Scalars['Int']>;
  informationTexts?: Maybe<Array<Maybe<Drug_DrugInformationMsg>>>;
};

export type Drug_SearchDrugPackagesRequest = {
  __typename?: 'drug_SearchDrugPackagesRequest';
  /** optional sort */
  activeIngredientStrengthSort?: Maybe<Helper_SortOrder>;
  /**
   * If true, results are returned if they contain any of the includedAtcCodes; if false, only if they contain all.
   *  Ignored if exactIncludedAtcCodes is set
   */
  anyIncludedAtcCode?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  containsGermanAmnogFlag?: Maybe<Scalars['Boolean']>;
  containsGermanClinicPackageFlag?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  containsRegistrationNumber?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  drugIdentifier?: Maybe<Drug_DrugIdentifierMsg>;
  /** If set to true, only return results that have exactly these includedActiveIngredientNames, no other active ingredients */
  exactIncludedActiveIngredientNames?: Maybe<Scalars['Boolean']>;
  /** If set to true, only returns results that have exactly these atc codes, no other codes */
  exactIncludedAtcCodes?: Maybe<Scalars['Boolean']>;
  /** optional filter: If set, only results that don't match any of the intake forms are returned */
  excludedIntakeFormIfaCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * optional filter
   *  For Germans: IKNR
   */
  externalInsurerId?: Maybe<Scalars['String']>;
  /**
   * German KVID, shouldn't be set if BSNR known
   * @deprecated deprecated in proto
   */
  externalInsurerNetworkId?: Maybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  /** German BSNR */
  externalUnitId?: Maybe<Scalars['String']>;
  /** German LANR */
  externalUserId?: Maybe<Scalars['String']>;
  /** Results are returned if their components include all of the icd10 codes */
  icd10Codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional filter */
  includeGermanDoctorSamples?: Maybe<Scalars['Boolean']>;
  /** Results are returned if their components include all of the active ingredient names */
  includedActiveIngredientNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Results are returned if their components include the atc codes */
  includedAtcCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional filter: If set, only results that match any of the intake forms are returned */
  includedIntakeFormIfaCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional filter */
  onlyDiscounted?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  /** If provided, flags/information texts are filtered according to patient age */
  patientBirthDate?: Maybe<Timestamp>;
  /** optional sort */
  patientPaymentSort?: Maybe<Helper_SortOrder>;
  /** optional filter: If true, only returns prescription exclusive drugs, if false, only those that are not prescription exclusive */
  prescriptionExclusive?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  searchField?: Maybe<Drug_DrugPackageSearchField>;
  /** optional sort */
  sellingPriceSort?: Maybe<Helper_SortOrder>;
  /** optional filter */
  sizeType?: Maybe<Drug_DrugPackageSizeType>;
  /** optional filter */
  vaccineFlag?: Maybe<Scalars['Boolean']>;
};

export type Drug_SearchDrugPackagesResponse = {
  __typename?: 'drug_SearchDrugPackagesResponse';
  drugPackages?: Maybe<Array<Maybe<Drug_DrugPackageMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchDrugSubstitutionsRequest = {
  __typename?: 'drug_SearchDrugSubstitutionsRequest';
  /** The administrative units of which the drug catalogs are used. If not set, the current administrative units of the user are used. */
  catalogAdministrativeUnits?: Maybe<Core_AdministrativeUnitMappingMsg>;
  /** the drug in the specified drug instance should only be filled if type is EMBEDDED */
  drugInstance?: Maybe<Drug_DrugInstanceMsg>;
  /** by default call searches the substitutions in the formulary so set notOnlyFormulary to true to get the all results */
  notOnlyFormulary?: Maybe<Scalars['Boolean']>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Drug_SearchDrugSubstitutionsResponse = {
  __typename?: 'drug_SearchDrugSubstitutionsResponse';
  drugs?: Maybe<Array<Maybe<Drug_DrugSearchResultMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchDrugsRequest = {
  __typename?: 'drug_SearchDrugsRequest';
  /** The administrative units of which the drug catalogs are used. If not set, the current administrative units of the user are used. */
  catalogAdministrativeUnits?: Maybe<Core_AdministrativeUnitMappingMsg>;
  isInFormulary?: Maybe<Scalars['Boolean']>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Drug_SearchDrugsResponse = {
  __typename?: 'drug_SearchDrugsResponse';
  drugs?: Maybe<Array<Maybe<Drug_DrugSearchResultMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Drug_SearchIcd10CodesRequest = {
  __typename?: 'drug_SearchIcd10CodesRequest';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** mandatory */
  externalSourceType?: Maybe<Drug_ExternalDrugSourceType>;
  paginationSettings?: Maybe<Helper_PaginationSettingsMsg>;
};

export type Drug_SearchIcd10CodesResponse = {
  __typename?: 'drug_SearchIcd10CodesResponse';
  hitCount?: Maybe<Scalars['Int']>;
  icd10Codes?: Maybe<Array<Maybe<Drug_Icd10CodeMsg>>>;
};

export enum Email_EmailType {
  EmailTypeAccountConfirmation = 'EMAIL_TYPE_ACCOUNT_CONFIRMATION',
  EmailTypeForgotPassword = 'EMAIL_TYPE_FORGOT_PASSWORD',
  EmailTypeNone = 'EMAIL_TYPE_NONE',
  EmailTypeTwoFactorAuth = 'EMAIL_TYPE_TWO_FACTOR_AUTH'
}

export type Email_SendAppointmentCancellationEmailRequest = {
  __typename?: 'email_SendAppointmentCancellationEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentConfirmationEmailRequest = {
  __typename?: 'email_SendAppointmentConfirmationEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentRebookingEmailRequest = {
  __typename?: 'email_SendAppointmentRebookingEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentRejectionEmailRequest = {
  __typename?: 'email_SendAppointmentRejectionEmailRequest';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentReminderEmailRequest = {
  __typename?: 'email_SendAppointmentReminderEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentRequestCancellationEmailRequest = {
  __typename?: 'email_SendAppointmentRequestCancellationEmailRequest';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentRequestSubmissionEmailRequest = {
  __typename?: 'email_SendAppointmentRequestSubmissionEmailRequest';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentSelectionEmailRequest = {
  __typename?: 'email_SendAppointmentSelectionEmailRequest';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendAppointmentUpdateEmailRequest = {
  __typename?: 'email_SendAppointmentUpdateEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendClinicalRequestCompletionEmailRequest = {
  __typename?: 'email_SendClinicalRequestCompletionEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendClinicalRequestNewAttachmentEmailRequest = {
  __typename?: 'email_SendClinicalRequestNewAttachmentEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendClinicalRequestNewCommentEmailRequest = {
  __typename?: 'email_SendClinicalRequestNewCommentEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendClinicalRequestNewReportEmailRequest = {
  __typename?: 'email_SendClinicalRequestNewReportEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendClinicalRequestRejectionEmailRequest = {
  __typename?: 'email_SendClinicalRequestRejectionEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendClinicalRequestSubmissionEmailRequest = {
  __typename?: 'email_SendClinicalRequestSubmissionEmailRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendDocumentAddedToThePortalEmailRequest = {
  __typename?: 'email_SendDocumentAddedToThePortalEmailRequest';
  documentId?: Maybe<Scalars['String']>;
  documentName?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
  portalFacilityId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_PortalFacilityPathMsg>;
  portalUserName?: Maybe<Core_HumanNameMsg>;
  professionalPortalUserName?: Maybe<Core_HumanNameMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
};

export type Email_SendUnverifiedUserAppointmentCancellationEmailRequest = {
  __typename?: 'email_SendUnverifiedUserAppointmentCancellationEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendUnverifiedUserAppointmentConfirmationEmailRequest = {
  __typename?: 'email_SendUnverifiedUserAppointmentConfirmationEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendUnverifiedUserAppointmentReminderEmailRequest = {
  __typename?: 'email_SendUnverifiedUserAppointmentReminderEmailRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  confirmationProviderSelfInfo?: Maybe<Patientportal_ConfirmationProviderSelfInfoMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendUnverifiedUserAppointmentRequestSubmissionEmailRequest = {
  __typename?: 'email_SendUnverifiedUserAppointmentRequestSubmissionEmailRequest';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  language?: Maybe<Core_Language>;
  patientId?: Maybe<Scalars['String']>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Email_SendValidationEmailRequest = {
  __typename?: 'email_SendValidationEmailRequest';
  confirmationProviderSelfInfo?: Maybe<Patientportal_ConfirmationProviderSelfInfoMsg>;
  emailType?: Maybe<Email_EmailType>;
  language?: Maybe<Core_Language>;
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  targetEmailAddress?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type External_Data_ExternalDataOriginReferenceMsg = {
  __typename?: 'external_data_ExternalDataOriginReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<External_Data_ExternalDataOriginType>;
};

export enum External_Data_ExternalDataOriginType {
  ExternalDataOriginTypeClinicalRequest = 'EXTERNAL_DATA_ORIGIN_TYPE_CLINICAL_REQUEST',
  ExternalDataOriginTypeNone = 'EXTERNAL_DATA_ORIGIN_TYPE_NONE'
}

export type Form_AddressFormQuestionMsg = {
  __typename?: 'form_AddressFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_AddressFormValueMsg = {
  __typename?: 'form_AddressFormValueMsg';
  addressValue?: Maybe<Core_AddressMsg>;
};

export enum Form_AllergyFormQuestionImportScope {
  AllergyFormQuestionImportScopeBillingCase = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_BILLING_CASE',
  AllergyFormQuestionImportScopeDisabled = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_DISABLED',
  AllergyFormQuestionImportScopeNone = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_NONE',
  AllergyFormQuestionImportScopePatient = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_PATIENT',
  AllergyFormQuestionImportScopeTreatmentOrSurgery = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_TREATMENT_OR_SURGERY',
  AllergyFormQuestionImportScopeVisit = 'ALLERGY_FORM_QUESTION_IMPORT_SCOPE_VISIT'
}

export type Form_AllergyFormQuestionMsg = {
  __typename?: 'form_AllergyFormQuestionMsg';
  importScope?: Maybe<Form_AllergyFormQuestionImportScope>;
};

export type Form_AllergyFormValueMsg = {
  __typename?: 'form_AllergyFormValueMsg';
  value?: Maybe<Treatment_AllergenMsg>;
};

export type Form_AnswerFormQuestionRequest = {
  __typename?: 'form_AnswerFormQuestionRequest';
  answer?: Maybe<Form_FormAnswerMsg>;
  answerGroupId?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['String']>;
};

export type Form_AnswerFormQuestionResponse = {
  __typename?: 'form_AnswerFormQuestionResponse';
  answer?: Maybe<Form_FormAnswerMsg>;
  answerGroup?: Maybe<Form_FormAnswerGroupMsg>;
  changedAnswers?: Maybe<Array<Maybe<Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  /**
   * When a question has been answered on a signed form, all the signatures are reset.
   * This field is added to avoid fetching for each answer request.
   * Only id and signatory request fields of the form message are filled.
   */
  form?: Maybe<Form_FormMsg>;
};

export type Form_AnswerFormSequenceQuestionRequest = {
  __typename?: 'form_AnswerFormSequenceQuestionRequest';
  doAutoMoveToNext?: Maybe<Scalars['Boolean']>;
  sequenceAnswerId?: Maybe<Scalars['String']>;
  value?: Maybe<Form_FormValueMsg>;
};

export type Form_AnswerFormSequenceQuestionResponse = {
  __typename?: 'form_AnswerFormSequenceQuestionResponse';
  /**
   * When a question has been answered on a signed form, all the signatures are reset.
   * This field is added to avoid fetching for each answer request.
   * Only id and signatory request fields of the form message are filled.
   */
  form?: Maybe<Form_FormMsg>;
  nextQuestion?: Maybe<Form_FormQuestionMsg>;
  nextSequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
  nextSequenceQuestion?: Maybe<Form_FormSequenceQuestionMsg>;
  sequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
};

export type Form_BooleanFormQuestionMsg = {
  __typename?: 'form_BooleanFormQuestionMsg';
  longNoText?: Maybe<Core_LocalizedStringMsg>;
  longYesText?: Maybe<Core_LocalizedStringMsg>;
  nullable?: Maybe<Scalars['Boolean']>;
  shortNoText?: Maybe<Core_LocalizedStringMsg>;
  shortYesText?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_BooleanFormValueMsg = {
  __typename?: 'form_BooleanFormValueMsg';
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * This question allows the user to choose one of the AnswerGroups of a child QuestionGroup of the current QuestionGroup.
 *  (the target child QuestionGroup has to be specified via childQuestionGroupTargetId)
 */
export type Form_ChildAnswerGroupSelectFormQuestionMsg = {
  __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg';
  childQuestionGroupTargetId?: Maybe<Scalars['String']>;
};

export type Form_ChildAnswerGroupSelectFormValueMsg = {
  __typename?: 'form_ChildAnswerGroupSelectFormValueMsg';
  childAnswerGroupId?: Maybe<Scalars['String']>;
};

export type Form_ClaimPortalFormRequest = {
  __typename?: 'form_ClaimPortalFormRequest';
  formId?: Maybe<Scalars['String']>;
};

export type Form_ClaimPortalFormResponse = {
  __typename?: 'form_ClaimPortalFormResponse';
  form?: Maybe<Form_FormMsg>;
};

export type Form_CreateFormAnswerGroupRequest = {
  __typename?: 'form_CreateFormAnswerGroupRequest';
  directParentForm?: Maybe<Form_FormElementLocationMsg>;
  parentAnswerGroup?: Maybe<Form_FormElementLocationMsg>;
  questionGroupId?: Maybe<Scalars['String']>;
};

export type Form_CreateFormAnswerGroupResponse = {
  __typename?: 'form_CreateFormAnswerGroupResponse';
  answerGroup?: Maybe<Form_FormAnswerGroupMsg>;
  changedAnswers?: Maybe<Array<Maybe<Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  parentInfo?: Maybe<Form_FormChildAnswerGroupInfoMsg>;
};

export type Form_CreateFormDatasetRequest = {
  __typename?: 'form_CreateFormDatasetRequest';
  initialName?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  withInitialOptionGroup?: Maybe<Scalars['Boolean']>;
};

export type Form_CreateFormDatasetResponse = {
  __typename?: 'form_CreateFormDatasetResponse';
  dataset?: Maybe<Form_FormDatasetMsg>;
  /** question-groups are not included */
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_CreateFormOptionGroupRequest = {
  __typename?: 'form_CreateFormOptionGroupRequest';
  datasetLocation?: Maybe<Form_FormElementLocationMsg>;
};

export type Form_CreateFormOptionGroupResponse = {
  __typename?: 'form_CreateFormOptionGroupResponse';
  dataset?: Maybe<Form_FormDatasetMsg>;
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
};

export type Form_CreateFormOptionRequest = {
  __typename?: 'form_CreateFormOptionRequest';
  optionGroupLocation?: Maybe<Form_FormElementLocationMsg>;
};

export type Form_CreateFormOptionResponse = {
  __typename?: 'form_CreateFormOptionResponse';
  option?: Maybe<Form_FormOptionMsg>;
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
};

export type Form_CreateFormQuestionGroupRequest = {
  __typename?: 'form_CreateFormQuestionGroupRequest';
  directParentTemplate?: Maybe<Form_FormElementLocationMsg>;
  parentQuestionGroup?: Maybe<Form_FormElementLocationMsg>;
};

export type Form_CreateFormQuestionGroupResponse = {
  __typename?: 'form_CreateFormQuestionGroupResponse';
  parentQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_CreateFormQuestionRequest = {
  __typename?: 'form_CreateFormQuestionRequest';
  controlFlowQuestionTemplateId?: Maybe<Scalars['String']>;
  questionGroup?: Maybe<Form_FormElementLocationMsg>;
  type?: Maybe<Form_FormValueType>;
};

export type Form_CreateFormQuestionResponse = {
  __typename?: 'form_CreateFormQuestionResponse';
  controlFlowTemplate?: Maybe<Form_FormTemplateMsg>;
  question?: Maybe<Form_FormQuestionMsg>;
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
};

export type Form_CreateFormRequest = {
  __typename?: 'form_CreateFormRequest';
  context?: Maybe<Form_FormContextMsg>;
  inSequenceMode?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['String']>;
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_CreateFormResponse = {
  __typename?: 'form_CreateFormResponse';
  createdByUserId?: Maybe<Scalars['String']>;
  form?: Maybe<Form_FormMsg>;
  tags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Form_CreateFormSignatureRequest = {
  __typename?: 'form_CreateFormSignatureRequest';
  assignee?: Maybe<Signature_SignatureAssigneeMsg>;
  formId?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
};

export type Form_CreateFormSignaturesRequest = {
  __typename?: 'form_CreateFormSignaturesRequest';
  formId?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<Form_CreateFormSignatureRequest>>>;
};

export type Form_CreateFormTemplateRequest = {
  __typename?: 'form_CreateFormTemplateRequest';
  initialLanguage?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  templateVersioningGroupId?: Maybe<Scalars['String']>;
  withInitialQuestionGroup?: Maybe<Scalars['Boolean']>;
};

export type Form_CreateFormTemplateResponse = {
  __typename?: 'form_CreateFormTemplateResponse';
  template?: Maybe<Form_FormTemplateMsg>;
  /** includes only templates */
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_CreateFormTemplateVersioningGroupRequest = {
  __typename?: 'form_CreateFormTemplateVersioningGroupRequest';
  initialName?: Maybe<Scalars['String']>;
  portalReadable?: Maybe<Scalars['Boolean']>;
  referenceId?: Maybe<Scalars['String']>;
  templateVersioningGroupTags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Form_CreateFormTemplateVersioningGroupResponse = {
  __typename?: 'form_CreateFormTemplateVersioningGroupResponse';
  /** includes only permissionScope */
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_CreateFormsRequest = {
  __typename?: 'form_CreateFormsRequest';
  context?: Maybe<Form_FormContextMsg>;
  entries?: Maybe<Array<Maybe<Form_CreateFormsRequestEntryMsg>>>;
  inSequenceMode?: Maybe<Scalars['Boolean']>;
};

export type Form_CreateFormsRequestEntryMsg = {
  __typename?: 'form_CreateFormsRequestEntryMsg';
  templateId?: Maybe<Scalars['String']>;
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_CreateFormsResponse = {
  __typename?: 'form_CreateFormsResponse';
  createdByUserId?: Maybe<Scalars['String']>;
  entries?: Maybe<Array<Maybe<Form_CreateFormsResponseEntry>>>;
};

export type Form_CreateFormsResponseEntry = {
  __typename?: 'form_CreateFormsResponseEntry';
  form?: Maybe<Form_FormMsg>;
  tags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormAnswerGroupRequest = {
  __typename?: 'form_DeleteFormAnswerGroupRequest';
  answerGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormAnswerGroupResponse = {
  __typename?: 'form_DeleteFormAnswerGroupResponse';
  answerGroupId?: Maybe<Scalars['String']>;
  changedAnswers?: Maybe<Array<Maybe<Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  parentInfo?: Maybe<Form_FormChildAnswerGroupInfoMsg>;
};

export type Form_DeleteFormDatasetRequest = {
  __typename?: 'form_DeleteFormDatasetRequest';
  datasetId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormDatasetResponse = {
  __typename?: 'form_DeleteFormDatasetResponse';
  datasetId?: Maybe<Scalars['String']>;
  /** question-groups are not included */
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_DeleteFormOptionGroupRequest = {
  __typename?: 'form_DeleteFormOptionGroupRequest';
  optionGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormOptionGroupResponse = {
  __typename?: 'form_DeleteFormOptionGroupResponse';
  dataset?: Maybe<Form_FormDatasetMsg>;
  optionGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormOptionRequest = {
  __typename?: 'form_DeleteFormOptionRequest';
  optionId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormOptionResponse = {
  __typename?: 'form_DeleteFormOptionResponse';
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
  optionId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormQuestionGroupRequest = {
  __typename?: 'form_DeleteFormQuestionGroupRequest';
  questionGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormQuestionGroupResponse = {
  __typename?: 'form_DeleteFormQuestionGroupResponse';
  parentQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  questionGroupId?: Maybe<Scalars['String']>;
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_DeleteFormQuestionRequest = {
  __typename?: 'form_DeleteFormQuestionRequest';
  questionId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormQuestionResponse = {
  __typename?: 'form_DeleteFormQuestionResponse';
  controlFlowTemplate?: Maybe<Form_FormTemplateMsg>;
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  questionId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormSignatureRequest = {
  __typename?: 'form_DeleteFormSignatureRequest';
  formId?: Maybe<Scalars['String']>;
  signatureId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormSignaturesRequest = {
  __typename?: 'form_DeleteFormSignaturesRequest';
  formId?: Maybe<Scalars['String']>;
  signatureIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_DeleteFormTemplateRequest = {
  __typename?: 'form_DeleteFormTemplateRequest';
  templateId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormTemplateResponse = {
  __typename?: 'form_DeleteFormTemplateResponse';
  templateId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormTemplateVersioningGroupRequest = {
  __typename?: 'form_DeleteFormTemplateVersioningGroupRequest';
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_DeleteFormTemplateVersioningGroupResponse = {
  __typename?: 'form_DeleteFormTemplateVersioningGroupResponse';
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export enum Form_DiagnosisFormQuestionImportScope {
  DiagnosisFormQuestionImportScopeBillingCase = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_BILLING_CASE',
  DiagnosisFormQuestionImportScopeDisabled = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_DISABLED',
  DiagnosisFormQuestionImportScopeNone = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_NONE',
  DiagnosisFormQuestionImportScopePatient = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_PATIENT',
  DiagnosisFormQuestionImportScopeTreatmentOrSurgery = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_TREATMENT_OR_SURGERY',
  DiagnosisFormQuestionImportScopeVisit = 'DIAGNOSIS_FORM_QUESTION_IMPORT_SCOPE_VISIT'
}

export type Form_DiagnosisFormQuestionMsg = {
  __typename?: 'form_DiagnosisFormQuestionMsg';
  importScope?: Maybe<Form_DiagnosisFormQuestionImportScope>;
  searchType?: Maybe<Form_DiagnosisSearchType>;
};

export type Form_DiagnosisFormValueMsg = {
  __typename?: 'form_DiagnosisFormValueMsg';
  value?: Maybe<Treatment_DiagnosisDetailMsg>;
};

export enum Form_DiagnosisSearchType {
  DiagnosisSearchTypeAlphaId = 'DIAGNOSIS_SEARCH_TYPE_ALPHA_ID',
  DiagnosisSearchTypeIcd = 'DIAGNOSIS_SEARCH_TYPE_ICD',
  DiagnosisSearchTypeNone = 'DIAGNOSIS_SEARCH_TYPE_NONE',
  DiagnosisSearchTypePatient = 'DIAGNOSIS_SEARCH_TYPE_PATIENT'
}

export type Form_DischargeFormStatusUpdateResponse = {
  __typename?: 'form_DischargeFormStatusUpdateResponse';
  formId?: Maybe<Scalars['String']>;
  formStatus?: Maybe<Form_FormStatus>;
  kbvFormId?: Maybe<Scalars['String']>;
  kbvFormStatus?: Maybe<Form_KbvFormStatus>;
  tags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  updatedByUserId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Form_DocumentFormQuestionMsg = {
  __typename?: 'form_DocumentFormQuestionMsg';
  /** The maximum allowed file size in bytes */
  maxFileSize?: Maybe<Scalars['Long']>;
  /** Static document to be downloaded, filled in and uploaded again as part of the question */
  staticDocumentGroupId?: Maybe<Scalars['String']>;
};

export type Form_DocumentFormValueMsg = {
  __typename?: 'form_DocumentFormValueMsg';
  documentId?: Maybe<Scalars['String']>;
};

export type Form_DoubleFormQuestionMsg = {
  __typename?: 'form_DoubleFormQuestionMsg';
  showSlider?: Maybe<Scalars['Boolean']>;
  stepSize?: Maybe<Scalars['Float']>;
  unitDatasetId?: Maybe<Scalars['String']>;
  valueMax?: Maybe<Scalars['Float']>;
  valueMin?: Maybe<Scalars['Float']>;
};

export type Form_DoubleFormValueMsg = {
  __typename?: 'form_DoubleFormValueMsg';
  unitOptionId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Form_EmailFormQuestionMsg = {
  __typename?: 'form_EmailFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_EmailFormValueMsg = {
  __typename?: 'form_EmailFormValueMsg';
  value?: Maybe<Scalars['String']>;
};

export type Form_FindFormSequenceAnswerRequest = {
  __typename?: 'form_FindFormSequenceAnswerRequest';
  absolute?: Maybe<Scalars['Int']>;
  formId?: Maybe<Scalars['String']>;
  relative?: Maybe<Form_FormSequenceAnswerRelativePosition>;
};

export type Form_FindFormSequenceAnswerResponse = {
  __typename?: 'form_FindFormSequenceAnswerResponse';
  question?: Maybe<Form_FormQuestionMsg>;
  sequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: Maybe<Form_FormSequenceQuestionMsg>;
};

export type Form_FindFormTemplateRequest = {
  __typename?: 'form_FindFormTemplateRequest';
  referenceId?: Maybe<Scalars['String']>;
  selector?: Maybe<Form_FormTemplateSelectorMsg>;
};

export type Form_FindFormTemplateResponse = {
  __typename?: 'form_FindFormTemplateResponse';
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_FindFormTemplateVersioningGroupRequest = {
  __typename?: 'form_FindFormTemplateVersioningGroupRequest';
  referenceId?: Maybe<Scalars['String']>;
  selector?: Maybe<Form_FormTemplateVersioningGroupSelectorMsg>;
};

export type Form_FindFormTemplateVersioningGroupResponse = {
  __typename?: 'form_FindFormTemplateVersioningGroupResponse';
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_FindSiblingFormSequenceAnswerRequest = {
  __typename?: 'form_FindSiblingFormSequenceAnswerRequest';
  /** if true search forwards, if false search backwards */
  forwards?: Maybe<Scalars['Boolean']>;
  sequenceAnswerId?: Maybe<Scalars['String']>;
};

export type Form_FindSiblingFormSequenceAnswerResponse = {
  __typename?: 'form_FindSiblingFormSequenceAnswerResponse';
  siblingQuestion?: Maybe<Form_FormQuestionMsg>;
  siblingSequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
  siblingSequenceQuestion?: Maybe<Form_FormSequenceQuestionMsg>;
};

export enum Form_FormAccessType {
  /** OP Anästhesie Formulare (z.B. "Anästhesie Checkliste") (op pflege + op anästhesie) */
  FormAccessSurgeryAnesthesiologyTeam = 'FORM_ACCESS_SURGERY_ANESTHESIOLOGY_TEAM',
  /** OP Chirurgie Formulare (op op arzt + op chirurgie pflege) */
  FormAccessSurgerySurgicalTeam = 'FORM_ACCESS_SURGERY_SURGICAL_TEAM',
  /** Administratives Personal Formulare */
  FormAccessTypeAdministrativeStaff = 'FORM_ACCESS_TYPE_ADMINISTRATIVE_STAFF',
  /** Pflege-Formulare (z.B. "Präoperative Checkliste Pflege") */
  FormAccessTypeCare = 'FORM_ACCESS_TYPE_CARE',
  /** Arzt-Formulare (z.B. "Präoperative Checkliste Arzt") */
  FormAccessTypeDoctor = 'FORM_ACCESS_TYPE_DOCTOR',
  /** Medizinisches Personal Formulare (Arzt + Pflege) */
  FormAccessTypeMedicalStaff = 'FORM_ACCESS_TYPE_MEDICAL_STAFF',
  FormAccessTypeNone = 'FORM_ACCESS_TYPE_NONE',
  /** OP Anästhesie Pflege-Formulare */
  FormAccessTypeSurgeryAnesthesiologicalCare = 'FORM_ACCESS_TYPE_SURGERY_ANESTHESIOLOGICAL_CARE',
  /** OP Anästhesist-Formulare */
  FormAccessTypeSurgeryAnesthesiologist = 'FORM_ACCESS_TYPE_SURGERY_ANESTHESIOLOGIST',
  /** OP Pflege-Formulare (op + anästhesie pflege) */
  FormAccessTypeSurgeryCare = 'FORM_ACCESS_TYPE_SURGERY_CARE',
  /** OP Arzt-Formulare (op arzt + anästhesist) */
  FormAccessTypeSurgeryDoctor = 'FORM_ACCESS_TYPE_SURGERY_DOCTOR',
  /** OP Medizinisches Personal Formulare (z.B. "Sign-In Checkliste", "Team-Time-Out Checkliste", "Sign-Out Checkliste", "Patientenzustand bei Verlegung") (op arzt + anästhesist, op + anästhesie pflege) */
  FormAccessTypeSurgeryMedicalStaff = 'FORM_ACCESS_TYPE_SURGERY_MEDICAL_STAFF',
  /** OP Personal Formulare (all roles from surgery) */
  FormAccessTypeSurgeryStaff = 'FORM_ACCESS_TYPE_SURGERY_STAFF',
  /** OP OP-Arzt-Formulare */
  FormAccessTypeSurgerySurgeon = 'FORM_ACCESS_TYPE_SURGERY_SURGEON',
  /** OP Chirurgie Pflege-Formulare */
  FormAccessTypeSurgerySurgicalCare = 'FORM_ACCESS_TYPE_SURGERY_SURGICAL_CARE'
}

export type Form_FormActionMsg = {
  __typename?: 'form_FormActionMsg';
  date?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  signatureActionData?: Maybe<Signature_SignatureActionDataMsg>;
  type?: Maybe<Form_FormActionType>;
  userId?: Maybe<Scalars['String']>;
};

export enum Form_FormActionType {
  FormActionTypeAddSignature = 'FORM_ACTION_TYPE_ADD_SIGNATURE',
  FormActionTypeNone = 'FORM_ACTION_TYPE_NONE',
  FormActionTypeRemoveSignature = 'FORM_ACTION_TYPE_REMOVE_SIGNATURE',
  FormActionTypeSign = 'FORM_ACTION_TYPE_SIGN',
  FormActionTypeUnsign = 'FORM_ACTION_TYPE_UNSIGN',
  FormActionTypeUpdateSignature = 'FORM_ACTION_TYPE_UPDATE_SIGNATURE'
}

export type Form_FormAnswerConditionMsg = {
  __typename?: 'form_FormAnswerConditionMsg';
  /** boolean */
  booleanTrue?: Maybe<Helper_Empty>;
  doubleGreater?: Maybe<Scalars['Float']>;
  /** double */
  doubleLess?: Maybe<Scalars['Float']>;
  /** integer */
  integerEqual?: Maybe<Scalars['Int']>;
  integerGreater?: Maybe<Scalars['Int']>;
  integerLess?: Maybe<Scalars['Int']>;
  /** knowledge */
  knowledgeEqual?: Maybe<Scalars['String']>;
  /** multi select */
  multiSelectContains?: Maybe<Scalars['String']>;
  /** general */
  null?: Maybe<Helper_Empty>;
  /** all multi-values */
  numAnswersEqual?: Maybe<Scalars['Int']>;
  numAnswersGreater?: Maybe<Scalars['Int']>;
  numAnswersLess?: Maybe<Scalars['Int']>;
  /** select */
  selectEqual?: Maybe<Scalars['String']>;
  stringContains?: Maybe<Scalars['String']>;
  stringEndsWith?: Maybe<Scalars['String']>;
  /** string */
  stringEqual?: Maybe<Scalars['String']>;
  stringLengthEqual?: Maybe<Scalars['Int']>;
  stringLengthGreater?: Maybe<Scalars['Int']>;
  stringLengthLess?: Maybe<Scalars['Int']>;
  stringMatches?: Maybe<Scalars['String']>;
  stringStartsWith?: Maybe<Scalars['String']>;
};

export type Form_FormAnswerGroupConditionMsg = {
  __typename?: 'form_FormAnswerGroupConditionMsg';
  /**
   * Searches for the answer to the given question-id (which has to be a child-answer-group-question) in a parent answer-group of the target answer-group.
   *  Evaluates to true if that answer equals the id of the target answer-group.
   */
  childSelectTarget?: Maybe<Scalars['String']>;
  /** whether the target answer-group is the first one in it's parent answer-group for its question-group-id */
  first?: Maybe<Helper_Empty>;
  /** whether the target answer-group is the last one in it's parent answer-group for its question-group-id */
  last?: Maybe<Helper_Empty>;
};

export type Form_FormAnswerGroupHierarchyMsg = {
  __typename?: 'form_FormAnswerGroupHierarchyMsg';
  answerGroups?: Maybe<Array<Maybe<Form_FormAnswerGroupMsg>>>;
};

export type Form_FormAnswerGroupMsg = {
  __typename?: 'form_FormAnswerGroupMsg';
  answers?: Maybe<Array<Maybe<Form_FormAnswerMsg>>>;
  childAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  directParentFormId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  parentAnswerGroupId?: Maybe<Scalars['String']>;
  questionGroupId?: Maybe<Scalars['String']>;
};

export type Form_FormAnswerGroupOperatorMsg = {
  __typename?: 'form_FormAnswerGroupOperatorMsg';
  condition?: Maybe<Form_FormAnswerGroupConditionMsg>;
  selector?: Maybe<Form_FormAnswerGroupSelectorMsg>;
};

export type Form_FormAnswerGroupSelectorMsg = {
  __typename?: 'form_FormAnswerGroupSelectorMsg';
  /** the answer-group with the given question-group-id that is either the current answer-group or a parent answer-group of it */
  parentAnswerGroup?: Maybe<Scalars['String']>;
};

export type Form_FormAnswerMsg = {
  __typename?: 'form_FormAnswerMsg';
  answerGroupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** This field is true if the enablement predicate of the question matches */
  isEnabled?: Maybe<Scalars['Boolean']>;
  /** This field is true if the enablement predicate of the question matches */
  isValid?: Maybe<Scalars['Boolean']>;
  /**
   * This field is just there to make it easier to group answers by the question group.
   *  NOTE: maybe remove this if it turns out to be unnecessary, this is a little unclean
   */
  questionGroupId?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Timestamp>;
  value?: Maybe<Form_FormValueMsg>;
};

export type Form_FormAnswerOperatorMsg = {
  __typename?: 'form_FormAnswerOperatorMsg';
  condition?: Maybe<Form_FormAnswerConditionMsg>;
  selector?: Maybe<Form_FormAnswerSelectorMsg>;
};

export type Form_FormAnswerSelectorMsg = {
  __typename?: 'form_FormAnswerSelectorMsg';
  /** all answers for the given question-id */
  allAnswers?: Maybe<Scalars['String']>;
  /** any answers for the given question-id */
  anyAnswer?: Maybe<Scalars['String']>;
  /**
   * Finds the shortest path to the given question(-id) from the question-group of the current answer-group.
   *  Then that path is walked, starting from the current answer-group. Then the following happens:
   *  - Answer exists at the end of the path: the value of that answer is used
   *  - Answer does NOT exists at the end: the default value for the given question-id is used
   *
   *  This selector will not attempt to find the second-closest possible answer,
   *  even if we didn't find one while walking the path initially. (You probably wouldn't want that anyway)
   *
   *  The intention for this selector is for it to be used as the default.
   */
  nearestAnswer?: Maybe<Scalars['String']>;
};

export type Form_FormChildAnswerGroupInfoMsg = {
  __typename?: 'form_FormChildAnswerGroupInfoMsg';
  answerGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  questionGroupId?: Maybe<Scalars['String']>;
};

export type Form_FormContextIdentifierMsg = {
  __typename?: 'form_FormContextIdentifierMsg';
  contextId?: Maybe<Scalars['String']>;
  type?: Maybe<Form_FormContextType>;
};

export type Form_FormContextMsg = {
  __typename?: 'form_FormContextMsg';
  identifiers?: Maybe<Array<Maybe<Form_FormContextIdentifierMsg>>>;
};

export enum Form_FormContextType {
  FormContextTypeAppointment = 'FORM_CONTEXT_TYPE_APPOINTMENT',
  FormContextTypeBillingCase = 'FORM_CONTEXT_TYPE_BILLING_CASE',
  FormContextTypeClinicalImpression = 'FORM_CONTEXT_TYPE_CLINICAL_IMPRESSION',
  FormContextTypeClinicalRequest = 'FORM_CONTEXT_TYPE_CLINICAL_REQUEST',
  FormContextTypeNone = 'FORM_CONTEXT_TYPE_NONE',
  FormContextTypePatient = 'FORM_CONTEXT_TYPE_PATIENT',
  FormContextTypeSurgery = 'FORM_CONTEXT_TYPE_SURGERY',
  FormContextTypeTreatment = 'FORM_CONTEXT_TYPE_TREATMENT',
  FormContextTypeVisit = 'FORM_CONTEXT_TYPE_VISIT'
}

export type Form_FormDatasetMsg = {
  __typename?: 'form_FormDatasetMsg';
  id?: Maybe<Scalars['String']>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  name?: Maybe<Scalars['String']>;
  optionGroups?: Maybe<Array<Maybe<Form_FormOptionGroupMsg>>>;
};

export type Form_FormElementLocationMsg = {
  __typename?: 'form_FormElementLocationMsg';
  targetId?: Maybe<Scalars['String']>;
  targetIndex?: Maybe<Scalars['Int']>;
};

export type Form_FormExternalIdMappingMsg = {
  __typename?: 'form_FormExternalIdMappingMsg';
  externalIds?: Maybe<Array<Maybe<Form_FormExternalIdMsg>>>;
  targetId?: Maybe<Scalars['String']>;
};

export type Form_FormExternalIdMsg = {
  __typename?: 'form_FormExternalIdMsg';
  externalId?: Maybe<Scalars['String']>;
  externalIdType?: Maybe<Scalars['String']>;
};

export type Form_FormList = {
  __typename?: 'form_FormList';
  forms?: Maybe<Array<Maybe<Form_FormMsg>>>;
};

export type Form_FormMsg = {
  __typename?: 'form_FormMsg';
  actions?: Maybe<Array<Maybe<Form_FormActionMsg>>>;
  answerGroups?: Maybe<Array<Maybe<Form_FormAnswerGroupMsg>>>;
  context?: Maybe<Form_FormContextMsg>;
  createdAt?: Maybe<Timestamp>;
  createdByPortalUserId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  directChildAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  /** whether there is data loss when converting from sequential form */
  hasSequentialConversionDataLoss?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  linkedContextIdentifiers?: Maybe<Array<Maybe<Form_LinkedFormContextIdentifierMsg>>>;
  lockedAt?: Maybe<Timestamp>;
  lockedByUserId?: Maybe<Scalars['String']>;
  owningOrganizationalUnitId?: Maybe<Scalars['String']>;
  result?: Maybe<Form_FormResultMsg>;
  sequenceAnswers?: Maybe<Array<Maybe<Form_FormSequenceAnswerMsg>>>;
  signatoryRequests?: Maybe<Array<Maybe<Signature_SignatureMsg>>>;
  signed?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Form_FormStatus>;
  templateId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Timestamp>;
};

export type Form_FormOperatorList = {
  __typename?: 'form_FormOperatorList';
  operators?: Maybe<Array<Maybe<Form_FormOperatorMsg>>>;
};

export type Form_FormOperatorMsg = {
  __typename?: 'form_FormOperatorMsg';
  and?: Maybe<Form_FormOperatorList>;
  answer?: Maybe<Form_FormAnswerOperatorMsg>;
  answerGroup?: Maybe<Form_FormAnswerGroupOperatorMsg>;
  not?: Maybe<Form_FormOperatorMsg>;
  or?: Maybe<Form_FormOperatorList>;
};

export type Form_FormOptionGroupMsg = {
  __typename?: 'form_FormOptionGroupMsg';
  id?: Maybe<Scalars['String']>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  options?: Maybe<Array<Maybe<Form_FormOptionMsg>>>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_FormOptionMsg = {
  __typename?: 'form_FormOptionMsg';
  externalIds?: Maybe<Array<Maybe<Form_FormExternalIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_FormPermissionReferenceMsg = {
  __typename?: 'form_FormPermissionReferenceMsg';
  isAdmin?: Maybe<Scalars['Boolean']>;
  unitId?: Maybe<Scalars['String']>;
  unitType?: Maybe<Core_AdministrativeUnitType>;
};

export type Form_FormQuestionAdditionalInfoMsg = {
  __typename?: 'form_FormQuestionAdditionalInfoMsg';
  additionalInfoUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Form_FormQuestionContextMsg = {
  __typename?: 'form_FormQuestionContextMsg';
  referenceId?: Maybe<Scalars['String']>;
  /** For contexts that have no uuid, such as treatment blocks */
  referenceNumber?: Maybe<Scalars['Int']>;
  type?: Maybe<Form_FormQuestionContextType>;
};

export enum Form_FormQuestionContextType {
  FormQuestionContextTypeClinicalRequestTemplateSpecifier = 'FORM_QUESTION_CONTEXT_TYPE_CLINICAL_REQUEST_TEMPLATE_SPECIFIER',
  FormQuestionContextTypeNone = 'FORM_QUESTION_CONTEXT_TYPE_NONE'
}

export enum Form_FormQuestionGroupDisplayGroup {
  FormQuestionGroupDisplayGroupGroup = 'FORM_QUESTION_GROUP_DISPLAY_GROUP_GROUP',
  FormQuestionGroupDisplayGroupInline = 'FORM_QUESTION_GROUP_DISPLAY_GROUP_INLINE',
  FormQuestionGroupDisplayGroupInlineGroup = 'FORM_QUESTION_GROUP_DISPLAY_GROUP_INLINE_GROUP',
  FormQuestionGroupDisplayGroupNone = 'FORM_QUESTION_GROUP_DISPLAY_GROUP_NONE',
  FormQuestionGroupDisplayGroupTable = 'FORM_QUESTION_GROUP_DISPLAY_GROUP_TABLE'
}

export type Form_FormQuestionGroupHierarchyMsg = {
  __typename?: 'form_FormQuestionGroupHierarchyMsg';
  questionGroups?: Maybe<Array<Maybe<Form_FormQuestionGroupMsg>>>;
};

export type Form_FormQuestionGroupMsg = {
  __typename?: 'form_FormQuestionGroupMsg';
  /**
   * Initially, it was planned question-groups can be linked to treatment-block(-templates).
   *  We might replace this with a different mechanism later on and remove this.
   */
  blockNumber?: Maybe<Scalars['Int']>;
  childQuestionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Only set if this question-group is a direct parent of its form-template. */
  directParentTemplateId?: Maybe<Scalars['String']>;
  displayGroup?: Maybe<Form_FormQuestionGroupDisplayGroup>;
  enablementContexts?: Maybe<Array<Maybe<Form_FormQuestionContextMsg>>>;
  /**
   * This predicate will be evaluated for every group of child answer-groups
   *  that have the same parent and same question-group.
   *  The result is available via FormChildAnswerGroupInfoMsg#isEnabled.
   */
  enablementPredicate?: Maybe<Form_FormOperatorMsg>;
  externalIds?: Maybe<Array<Maybe<Form_FormExternalIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  /**
   * Deprecated, use displayGroup field instead
   *  Whether this question-group should be displayed when viewing
   *  the form.
   *
   *  If false, this question-group is considered a logical
   *  group and is not rendered. It's child question-groups are then rendered on the same
   *  visual level this question-group would have been rendered at.
   * @deprecated deprecated in proto
   */
  isDisplayGroup?: Maybe<Scalars['Boolean']>;
  /**
   * Whether there can be multiple answer-groups to this one question-group
   *  inside of the same form. If true, minAnswerGroups and maxAnswerGroups
   *  should be used for further configuration.
   */
  isMultiGroup?: Maybe<Scalars['Boolean']>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  maxAnswerGroups?: Maybe<Scalars['Int']>;
  minAnswerGroups?: Maybe<Scalars['Int']>;
  /** Only set if this question-group has another question-group as its parent. */
  parentQuestionGroupId?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Form_FormQuestionMsg>>>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_FormQuestionMsg = {
  __typename?: 'form_FormQuestionMsg';
  /** optional, used to provide a link to useful information */
  additionalInfo?: Maybe<Form_FormQuestionAdditionalInfoMsg>;
  address?: Maybe<Form_AddressFormQuestionMsg>;
  allergy?: Maybe<Form_AllergyFormQuestionMsg>;
  /** used to disable editing of preset answers */
  answerIsDisabled?: Maybe<Scalars['Boolean']>;
  boolean?: Maybe<Form_BooleanFormQuestionMsg>;
  childAnswerGroupSelect?: Maybe<Form_ChildAnswerGroupSelectFormQuestionMsg>;
  /**
   * The default value for answers to this question.
   *  In the future, it is our goal to replace this with an 'expression' of some sort
   *  that can be evaluated when the answer is first created. This would allow us
   *  to take the context of the form into consideration.
   */
  defaultValue?: Maybe<Form_FormValueMsg>;
  diagnosis?: Maybe<Form_DiagnosisFormQuestionMsg>;
  document?: Maybe<Form_DocumentFormQuestionMsg>;
  double?: Maybe<Form_DoubleFormQuestionMsg>;
  email?: Maybe<Form_EmailFormQuestionMsg>;
  enablementContexts?: Maybe<Array<Maybe<Form_FormQuestionContextMsg>>>;
  enablementPredicate?: Maybe<Form_FormOperatorMsg>;
  externalIds?: Maybe<Array<Maybe<Form_FormExternalIdMsg>>>;
  formReference?: Maybe<Form_FormReferenceFormQuestionMsg>;
  id?: Maybe<Scalars['String']>;
  infoText?: Maybe<Form_InfoTextFormQuestionMsg>;
  integer?: Maybe<Form_IntegerFormQuestionMsg>;
  isDisplayAsRequired?: Maybe<Scalars['Boolean']>;
  knowledge?: Maybe<Form_KnowledgeFormQuestionMsg>;
  labResult?: Maybe<Form_LabResultFormQuestionMsg>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  localDate?: Maybe<Form_LocalDateFormQuestionMsg>;
  localDateTime?: Maybe<Form_LocalDateTimeFormQuestionMsg>;
  localTime?: Maybe<Form_LocalTimeFormQuestionMsg>;
  multiAllergy?: Maybe<Form_MultiAllergyFormQuestionMsg>;
  multiDiagnosis?: Maybe<Form_MultiDiagnosisFormQuestionMsg>;
  multiKnowledge?: Maybe<Form_MultiKnowledgeFormQuestionMsg>;
  multiSelect?: Maybe<Form_MultiSelectFormQuestionMsg>;
  precisionTimestamp?: Maybe<Form_PrecisionTimestampFormQuestionMsg>;
  questionGroupId?: Maybe<Scalars['String']>;
  select?: Maybe<Form_SelectFormQuestionMsg>;
  signature?: Maybe<Form_SignatureFormQuestionMsg>;
  string?: Maybe<Form_StringFormQuestionMsg>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  timestamp?: Maybe<Form_TimestampFormQuestionMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
  /** A virtual property that specifies the type of the content */
  type?: Maybe<Form_FormValueType>;
  userSelect?: Maybe<Form_UserSelectFormQuestionMsg>;
  validityPredicate?: Maybe<Form_FormOperatorMsg>;
};

export type Form_FormReferenceFormQuestionMsg = {
  __typename?: 'form_FormReferenceFormQuestionMsg';
  /** versioningGroupReferenceIds */
  parentFormVersioningGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  scope?: Maybe<Form_FormReferenceQuestionScope>;
  tag?: Maybe<Form_FormTemplateVersioningGroupTag>;
};

export type Form_FormReferenceFormValueMsg = {
  __typename?: 'form_FormReferenceFormValueMsg';
  formId?: Maybe<Scalars['String']>;
};

export enum Form_FormReferenceQuestionScope {
  FormReferenceQuestionScopeBillingCase = 'FORM_REFERENCE_QUESTION_SCOPE_BILLING_CASE',
  FormReferenceQuestionScopeNone = 'FORM_REFERENCE_QUESTION_SCOPE_NONE'
}

export type Form_FormResultMsg = {
  __typename?: 'form_FormResultMsg';
  text?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_FormSelectorMsg = {
  __typename?: 'form_FormSelectorMsg';
  includeActions?: Maybe<Scalars['Boolean']>;
  includeAnswerGroups?: Maybe<Scalars['Boolean']>;
  includeAnswers?: Maybe<Scalars['Boolean']>;
  includeDirectChildAnswerGroupInfo?: Maybe<Scalars['Boolean']>;
  includeSequenceAnswers?: Maybe<Scalars['Boolean']>;
  includeSignatoryRequests?: Maybe<Scalars['Boolean']>;
};

export enum Form_FormSequenceAnswerForwardsState {
  FormSequenceAnswerForwardsStateBlocked = 'FORM_SEQUENCE_ANSWER_FORWARDS_STATE_BLOCKED',
  FormSequenceAnswerForwardsStateComplete = 'FORM_SEQUENCE_ANSWER_FORWARDS_STATE_COMPLETE',
  FormSequenceAnswerForwardsStateNone = 'FORM_SEQUENCE_ANSWER_FORWARDS_STATE_NONE',
  FormSequenceAnswerForwardsStateQuestion = 'FORM_SEQUENCE_ANSWER_FORWARDS_STATE_QUESTION'
}

export type Form_FormSequenceAnswerMsg = {
  __typename?: 'form_FormSequenceAnswerMsg';
  forwardsState?: Maybe<Form_FormSequenceAnswerForwardsState>;
  hasBackwardsSibling?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  sequenceQuestionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Timestamp>;
  value?: Maybe<Form_FormValueMsg>;
};

export type Form_FormSequenceAnswerOperatorMsg = {
  __typename?: 'form_FormSequenceAnswerOperatorMsg';
  condition?: Maybe<Form_FormAnswerConditionMsg>;
  selector?: Maybe<Form_FormSequenceAnswerSelectorMsg>;
};

export enum Form_FormSequenceAnswerRelativePosition {
  FormSequenceAnswerRelativePositionFirst = 'FORM_SEQUENCE_ANSWER_RELATIVE_POSITION_FIRST',
  FormSequenceAnswerRelativePositionLast = 'FORM_SEQUENCE_ANSWER_RELATIVE_POSITION_LAST',
  FormSequenceAnswerRelativePositionNone = 'FORM_SEQUENCE_ANSWER_RELATIVE_POSITION_NONE'
}

export type Form_FormSequenceAnswerSelectorMsg = {
  __typename?: 'form_FormSequenceAnswerSelectorMsg';
  /** all sequence-answers for the given sequence-question-id */
  allSequenceAnswers?: Maybe<Scalars['String']>;
  /** all sequence-answer for the given sequence-question-id */
  anySequenceAnswer?: Maybe<Scalars['String']>;
  /** the last (=latest) sequence-answer for the given sequence-question-id */
  lastSequenceAnswer?: Maybe<Scalars['String']>;
};

export type Form_FormSequenceOperatorList = {
  __typename?: 'form_FormSequenceOperatorList';
  operators?: Maybe<Array<Maybe<Form_FormSequenceOperatorMsg>>>;
};

export type Form_FormSequenceOperatorMsg = {
  __typename?: 'form_FormSequenceOperatorMsg';
  and?: Maybe<Form_FormSequenceOperatorList>;
  not?: Maybe<Form_FormSequenceOperatorMsg>;
  or?: Maybe<Form_FormSequenceOperatorList>;
  sequenceAnswer?: Maybe<Form_FormSequenceAnswerOperatorMsg>;
};

export type Form_FormSequenceQuestionAndAnswerMsg = {
  __typename?: 'form_FormSequenceQuestionAndAnswerMsg';
  question?: Maybe<Form_FormQuestionMsg>;
  sequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: Maybe<Form_FormSequenceQuestionMsg>;
};

export type Form_FormSequenceQuestionMsg = {
  __typename?: 'form_FormSequenceQuestionMsg';
  creationQuestionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  linkedReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  questionId?: Maybe<Scalars['String']>;
  transitions?: Maybe<Array<Maybe<Form_FormSequenceTransitionMsg>>>;
};

export type Form_FormSequenceTransitionMsg = {
  __typename?: 'form_FormSequenceTransitionMsg';
  id?: Maybe<Scalars['String']>;
  predicate?: Maybe<Form_FormSequenceOperatorMsg>;
  targetSequenceQuestionId?: Maybe<Scalars['String']>;
};

export enum Form_FormStatus {
  FormStatusAborted = 'FORM_STATUS_ABORTED',
  FormStatusCompleted = 'FORM_STATUS_COMPLETED',
  FormStatusEditable = 'FORM_STATUS_EDITABLE',
  FormStatusEditableSequentially = 'FORM_STATUS_EDITABLE_SEQUENTIALLY',
  FormStatusNone = 'FORM_STATUS_NONE'
}

/**
 * Depending on the request, none of the linked targets might be set.
 *  Additionally, if any linked target is set, it will only have simple properties set, like a title or subtitle (and specifically no relations).
 */
export type Form_FormTemplateItemReferenceMsg = {
  __typename?: 'form_FormTemplateItemReferenceMsg';
  createdAt?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  linkedDatasets?: Maybe<Array<Maybe<Form_FormDatasetMsg>>>;
  linkedOptionGroups?: Maybe<Array<Maybe<Form_FormOptionGroupMsg>>>;
  linkedOptions?: Maybe<Array<Maybe<Form_FormOptionMsg>>>;
  linkedQuestionGroups?: Maybe<Array<Maybe<Form_FormQuestionGroupMsg>>>;
  linkedQuestions?: Maybe<Array<Maybe<Form_FormQuestionMsg>>>;
  linkedSequenceQuestions?: Maybe<Array<Maybe<Form_FormSequenceQuestionMsg>>>;
  name?: Maybe<Scalars['String']>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: Maybe<Scalars['String']>;
};

export enum Form_FormTemplateLocation {
  FormTemplateLocationAnamnesis = 'FORM_TEMPLATE_LOCATION_ANAMNESIS',
  FormTemplateLocationDischarge = 'FORM_TEMPLATE_LOCATION_DISCHARGE',
  FormTemplateLocationDischargeAssessment = 'FORM_TEMPLATE_LOCATION_DISCHARGE_ASSESSMENT',
  FormTemplateLocationFurtherProcedures = 'FORM_TEMPLATE_LOCATION_FURTHER_PROCEDURES',
  FormTemplateLocationNone = 'FORM_TEMPLATE_LOCATION_NONE',
  FormTemplateLocationSurgery = 'FORM_TEMPLATE_LOCATION_SURGERY',
  FormTemplateLocationTreatment = 'FORM_TEMPLATE_LOCATION_TREATMENT'
}

export type Form_FormTemplateLocationConfigMsg = {
  __typename?: 'form_FormTemplateLocationConfigMsg';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  location?: Maybe<Form_FormTemplateLocation>;
};

export type Form_FormTemplateMsg = {
  __typename?: 'form_FormTemplateMsg';
  /**
   * Control-flow-questions are used exclusively used as the basis for sequence-questions.
   *  Their answers are not displayed in non-sequential views of forms.
   *  The intended usage is for questions like 'Do you want to add another xyz...'
   *  when answering a form in sequential-mode.
   *  The resulting sequence-answer should then be used to influence the
   *  control flow of that form in sequence-mode (using transitions).
   */
  controlFlowQuestions?: Maybe<Array<Maybe<Form_FormQuestionMsg>>>;
  createdAt?: Maybe<Timestamp>;
  createdByUserId?: Maybe<Scalars['String']>;
  datasets?: Maybe<Array<Maybe<Form_FormDatasetMsg>>>;
  directChildQuestionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasSequentialSupport?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  lockedAt?: Maybe<Timestamp>;
  lockedByUserId?: Maybe<Scalars['String']>;
  questionGroups?: Maybe<Array<Maybe<Form_FormQuestionGroupMsg>>>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<Form_FormTemplateResultMsg>>>;
  sequenceQuestions?: Maybe<Array<Maybe<Form_FormSequenceQuestionMsg>>>;
  startSequenceQuestionId?: Maybe<Scalars['String']>;
  status?: Maybe<Form_FormTemplateStatus>;
  title?: Maybe<Core_LocalizedStringMsg>;
  versioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_FormTemplateResultMsg = {
  __typename?: 'form_FormTemplateResultMsg';
  predicate?: Maybe<Form_FormOperatorMsg>;
  text?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_FormTemplateSelectorMsg = {
  __typename?: 'form_FormTemplateSelectorMsg';
  includeControlFlowQuestions?: Maybe<Scalars['Boolean']>;
  includeDatasets?: Maybe<Scalars['Boolean']>;
  includeDirectChildQuestionGroupIds?: Maybe<Scalars['Boolean']>;
  includeOptionGroups?: Maybe<Scalars['Boolean']>;
  includeOptions?: Maybe<Scalars['Boolean']>;
  includeQuestionGroups?: Maybe<Scalars['Boolean']>;
  includeQuestions?: Maybe<Scalars['Boolean']>;
  includeSequenceQuestions?: Maybe<Scalars['Boolean']>;
};

export enum Form_FormTemplateStatus {
  FormTemplateStatusActive = 'FORM_TEMPLATE_STATUS_ACTIVE',
  FormTemplateStatusInactive = 'FORM_TEMPLATE_STATUS_INACTIVE',
  FormTemplateStatusNone = 'FORM_TEMPLATE_STATUS_NONE',
  FormTemplateStatusNotYetActive = 'FORM_TEMPLATE_STATUS_NOT_YET_ACTIVE',
  FormTemplateStatusOldVersion = 'FORM_TEMPLATE_STATUS_OLD_VERSION'
}

export type Form_FormTemplateVersioningGroupAccessInfoMsg = {
  __typename?: 'form_FormTemplateVersioningGroupAccessInfoMsg';
  accessLimited?: Maybe<Scalars['Boolean']>;
  accessType?: Maybe<Form_FormAccessType>;
  formTemplateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_FormTemplateVersioningGroupMsg = {
  __typename?: 'form_FormTemplateVersioningGroupMsg';
  accessLimited?: Maybe<Scalars['Boolean']>;
  accessType?: Maybe<Form_FormAccessType>;
  id?: Maybe<Scalars['String']>;
  /** this list allows configuring where the active template will appear in non-portal contexts. */
  locationConfigs?: Maybe<Array<Maybe<Form_FormTemplateLocationConfigMsg>>>;
  name?: Maybe<Scalars['String']>;
  /** defines which administrative unit can read/edit this form-template */
  permissionScope?: Maybe<Array<Maybe<Form_FormPermissionReferenceMsg>>>;
  /**
   * Whether this template versioning group can be linked to portal appointment tasks.
   *  Has to bet set at creation and can't be updated.
   */
  portalReadable?: Maybe<Scalars['Boolean']>;
  /** a surrogate id that can be specified at creation time and is guaranteed to be unique and never change */
  referenceId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  templateItemReferences?: Maybe<Array<Maybe<Form_FormTemplateItemReferenceMsg>>>;
  /**
   * Contains all the templates in the versioning group, ordered by creation date ascending.
   *  All templates in this list contain only top level information and no additional inclusions.
   */
  templates?: Maybe<Array<Maybe<Form_FormTemplateMsg>>>;
};

export type Form_FormTemplateVersioningGroupSelectorMsg = {
  __typename?: 'form_FormTemplateVersioningGroupSelectorMsg';
  includeLocationConfigs?: Maybe<Scalars['Boolean']>;
  includePermissionScope?: Maybe<Scalars['Boolean']>;
  includeTemplateItemReferences?: Maybe<Scalars['Boolean']>;
  includeTemplateItemReferencesLinkedItems?: Maybe<Scalars['Boolean']>;
  includeTemplates?: Maybe<Scalars['Boolean']>;
};

export enum Form_FormTemplateVersioningGroupTag {
  FormTemplateVersioningGroupTagClinicalRequest = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_CLINICAL_REQUEST',
  FormTemplateVersioningGroupTagDischargeAssessment = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_DISCHARGE_ASSESSMENT',
  FormTemplateVersioningGroupTagGermanBg = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_BG',
  FormTemplateVersioningGroupTagGermanDabe = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_DABE',
  FormTemplateVersioningGroupTagGermanDrv = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_DRV',
  FormTemplateVersioningGroupTagGermanDrvAftercare = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_DRV_AFTERCARE',
  FormTemplateVersioningGroupTagGermanDrvDischarge = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_DRV_DISCHARGE',
  FormTemplateVersioningGroupTagGermanVerb = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_GERMAN_VERB',
  FormTemplateVersioningGroupTagNone = 'FORM_TEMPLATE_VERSIONING_GROUP_TAG_NONE'
}

export type Form_FormValidationErrorMsg = {
  __typename?: 'form_FormValidationErrorMsg';
  answerGroupId?: Maybe<Scalars['String']>;
  numErrors?: Maybe<Scalars['Int']>;
};

export type Form_FormValueMsg = {
  __typename?: 'form_FormValueMsg';
  address?: Maybe<Form_AddressFormValueMsg>;
  allergy?: Maybe<Form_AllergyFormValueMsg>;
  boolean?: Maybe<Form_BooleanFormValueMsg>;
  childAnswerGroupSelect?: Maybe<Form_ChildAnswerGroupSelectFormValueMsg>;
  diagnosis?: Maybe<Form_DiagnosisFormValueMsg>;
  document?: Maybe<Form_DocumentFormValueMsg>;
  double?: Maybe<Form_DoubleFormValueMsg>;
  email?: Maybe<Form_EmailFormValueMsg>;
  formReference?: Maybe<Form_FormReferenceFormValueMsg>;
  infoText?: Maybe<Form_InfoTextFormValueMsg>;
  integer?: Maybe<Form_IntegerFormValueMsg>;
  knowledge?: Maybe<Form_KnowledgeFormValueMsg>;
  labResult?: Maybe<Form_LabResultFormValueMsg>;
  localDate?: Maybe<Form_LocalDateFormValueMsg>;
  localDateTime?: Maybe<Form_LocalDateTimeFormValueMsg>;
  localTime?: Maybe<Form_LocalTimeFormValueMsg>;
  multiAllergy?: Maybe<Form_MultiAllergyFormValueMsg>;
  multiDiagnosis?: Maybe<Form_MultiDiagnosisFormValueMsg>;
  multiKnowledge?: Maybe<Form_MultiKnowledgeFormValueMsg>;
  multiSelect?: Maybe<Form_MultiSelectFormValueMsg>;
  precisionTimestamp?: Maybe<Form_PrecisionTimestampFormValueMsg>;
  select?: Maybe<Form_SelectFormValueMsg>;
  signature?: Maybe<Form_SignatureFormValueMsg>;
  string?: Maybe<Form_StringFormValueMsg>;
  timestamp?: Maybe<Form_TimestampFormValueMsg>;
  userSelect?: Maybe<Form_UserSelectFormValueMsg>;
};

export enum Form_FormValueType {
  FormValueTypeAddress = 'FORM_VALUE_TYPE_ADDRESS',
  FormValueTypeAllergy = 'FORM_VALUE_TYPE_ALLERGY',
  FormValueTypeBoolean = 'FORM_VALUE_TYPE_BOOLEAN',
  FormValueTypeChildAnswerGroupSelect = 'FORM_VALUE_TYPE_CHILD_ANSWER_GROUP_SELECT',
  FormValueTypeDiagnosis = 'FORM_VALUE_TYPE_DIAGNOSIS',
  FormValueTypeDocument = 'FORM_VALUE_TYPE_DOCUMENT',
  FormValueTypeDouble = 'FORM_VALUE_TYPE_DOUBLE',
  FormValueTypeEmail = 'FORM_VALUE_TYPE_EMAIL',
  FormValueTypeFormReference = 'FORM_VALUE_TYPE_FORM_REFERENCE',
  FormValueTypeInfoText = 'FORM_VALUE_TYPE_INFO_TEXT',
  FormValueTypeInteger = 'FORM_VALUE_TYPE_INTEGER',
  FormValueTypeKnowledge = 'FORM_VALUE_TYPE_KNOWLEDGE',
  FormValueTypeLabResult = 'FORM_VALUE_TYPE_LAB_RESULT',
  FormValueTypeLocalDate = 'FORM_VALUE_TYPE_LOCAL_DATE',
  FormValueTypeLocalDateTime = 'FORM_VALUE_TYPE_LOCAL_DATE_TIME',
  FormValueTypeLocalTime = 'FORM_VALUE_TYPE_LOCAL_TIME',
  FormValueTypeMultiAllergy = 'FORM_VALUE_TYPE_MULTI_ALLERGY',
  FormValueTypeMultiDiagnosis = 'FORM_VALUE_TYPE_MULTI_DIAGNOSIS',
  FormValueTypeMultiKnowledge = 'FORM_VALUE_TYPE_MULTI_KNOWLEDGE',
  FormValueTypeMultiSelect = 'FORM_VALUE_TYPE_MULTI_SELECT',
  FormValueTypeNone = 'FORM_VALUE_TYPE_NONE',
  FormValueTypePrecisionTimestamp = 'FORM_VALUE_TYPE_PRECISION_TIMESTAMP',
  FormValueTypeSelect = 'FORM_VALUE_TYPE_SELECT',
  FormValueTypeSignature = 'FORM_VALUE_TYPE_SIGNATURE',
  FormValueTypeString = 'FORM_VALUE_TYPE_STRING',
  FormValueTypeTimestamp = 'FORM_VALUE_TYPE_TIMESTAMP',
  FormValueTypeUserSelect = 'FORM_VALUE_TYPE_USER_SELECT'
}

export type Form_GetFormAccessInfoByFormIdResponse = {
  __typename?: 'form_GetFormAccessInfoByFormIdResponse';
  formIdToAccessInfo?: Maybe<Array<Maybe<Form_GetFormAccessInfoByFormIdResponse_FormIdToAccessInfoEntry>>>;
};

export type Form_GetFormAccessInfoByFormIdResponse_FormIdToAccessInfoEntry = {
  __typename?: 'form_GetFormAccessInfoByFormIdResponse_FormIdToAccessInfoEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Form_FormTemplateVersioningGroupAccessInfoMsg>;
};

export type Form_GetFormAccessInfoByFormIdsRequest = {
  __typename?: 'form_GetFormAccessInfoByFormIdsRequest';
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_GetFormAnswerGroupHierarchyRequest = {
  __typename?: 'form_GetFormAnswerGroupHierarchyRequest';
  /** must be >= 1 */
  depth?: Maybe<Scalars['Int']>;
  rootAnswerGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The response contains the flattened sub-hierarchy for each answer-group specified
 *  via the rootAnswerGroupIds parameter in the request.
 *  With depth = 1, each sub-hierarchy contains only one answer-group, namely the
 *  one with its id equal to the matching element in the rootAnswerGroupIds parameter.
 */
export type Form_GetFormAnswerGroupHierarchyResponse = {
  __typename?: 'form_GetFormAnswerGroupHierarchyResponse';
  /** each of these elements represents the sub-hierarchy of it's corresponding 'rootAnswerGroupId' in the request */
  answerGroupHierarchies?: Maybe<Array<Maybe<Form_FormAnswerGroupHierarchyMsg>>>;
};

export type Form_GetFormDatasetRequest = {
  __typename?: 'form_GetFormDatasetRequest';
  formDatasetId?: Maybe<Scalars['String']>;
};

export type Form_GetFormDatasetResponse = {
  __typename?: 'form_GetFormDatasetResponse';
  dataset?: Maybe<Form_FormDatasetMsg>;
};

export type Form_GetFormQuestionGroupHierarchyRequest = {
  __typename?: 'form_GetFormQuestionGroupHierarchyRequest';
  depth?: Maybe<Scalars['Int']>;
  rootQuestionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The response contains the flattened sub-hierarchy for each question-group specified
 *  via the rootQuestionGroupIds parameter in the request.
 *  With depth = 1, each sub-hierarchy contains only one question-group, namely the
 *  one with its id equal to the matching element in the rootQuestionGroupIds parameter.
 */
export type Form_GetFormQuestionGroupHierarchyResponse = {
  __typename?: 'form_GetFormQuestionGroupHierarchyResponse';
  /** each of these elements represents the sub-hierarchy of it's corresponding 'rootQuestionGroupId' in the request */
  questionGroupHierarchies?: Maybe<Array<Maybe<Form_FormQuestionGroupHierarchyMsg>>>;
};

export type Form_GetFormRequest = {
  __typename?: 'form_GetFormRequest';
  formId?: Maybe<Scalars['String']>;
  selector?: Maybe<Form_FormSelectorMsg>;
};

export type Form_GetFormResponse = {
  __typename?: 'form_GetFormResponse';
  form?: Maybe<Form_FormMsg>;
};

export type Form_GetFormSequenceAnswerRequest = {
  __typename?: 'form_GetFormSequenceAnswerRequest';
  sequenceAnswerId?: Maybe<Scalars['String']>;
};

export type Form_GetFormSequenceAnswerResponse = {
  __typename?: 'form_GetFormSequenceAnswerResponse';
  question?: Maybe<Form_FormQuestionMsg>;
  sequenceAnswer?: Maybe<Form_FormSequenceAnswerMsg>;
  sequenceQuestion?: Maybe<Form_FormSequenceQuestionMsg>;
};

export type Form_GetFormTemplateAccessInfoByFormIdResponse = {
  __typename?: 'form_GetFormTemplateAccessInfoByFormIdResponse';
  formTemplateIdToAccessInfo?: Maybe<Array<Maybe<Form_GetFormTemplateAccessInfoByFormIdResponse_FormTemplateIdToAccessInfoEntry>>>;
};

export type Form_GetFormTemplateAccessInfoByFormIdResponse_FormTemplateIdToAccessInfoEntry = {
  __typename?: 'form_GetFormTemplateAccessInfoByFormIdResponse_FormTemplateIdToAccessInfoEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Form_FormTemplateVersioningGroupAccessInfoMsg>;
};

export type Form_GetFormTemplateAccessInfoByFormIdsRequest = {
  __typename?: 'form_GetFormTemplateAccessInfoByFormIdsRequest';
  formTemplateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_GetFormTemplateExternalIdsRequest = {
  __typename?: 'form_GetFormTemplateExternalIdsRequest';
  templateId?: Maybe<Scalars['String']>;
};

export type Form_GetFormTemplateExternalIdsResponse = {
  __typename?: 'form_GetFormTemplateExternalIdsResponse';
  optionExternalIdMappings?: Maybe<Array<Maybe<Form_FormExternalIdMappingMsg>>>;
  questionExternalIdMappings?: Maybe<Array<Maybe<Form_FormExternalIdMappingMsg>>>;
  questionGroupExternalIdMappings?: Maybe<Array<Maybe<Form_FormExternalIdMappingMsg>>>;
};

export type Form_GetFormTemplateRequest = {
  __typename?: 'form_GetFormTemplateRequest';
  selector?: Maybe<Form_FormTemplateSelectorMsg>;
  templateId?: Maybe<Scalars['String']>;
};

export type Form_GetFormTemplateResponse = {
  __typename?: 'form_GetFormTemplateResponse';
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_GetFormTemplateTagsByFormIdElementMsg = {
  __typename?: 'form_GetFormTemplateTagsByFormIdElementMsg';
  formId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
};

export type Form_GetFormTemplateTagsByFormIdsRequest = {
  __typename?: 'form_GetFormTemplateTagsByFormIdsRequest';
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_GetFormTemplateTagsByFormIdsResponse = {
  __typename?: 'form_GetFormTemplateTagsByFormIdsResponse';
  elements?: Maybe<Array<Maybe<Form_GetFormTemplateTagsByFormIdElementMsg>>>;
};

export type Form_GetFormTemplateVersioningGroupRequest = {
  __typename?: 'form_GetFormTemplateVersioningGroupRequest';
  selector?: Maybe<Form_FormTemplateVersioningGroupSelectorMsg>;
  templateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Form_GetFormTemplateVersioningGroupResponse = {
  __typename?: 'form_GetFormTemplateVersioningGroupResponse';
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_GetFormTitlesByFormIdElementMsg = {
  __typename?: 'form_GetFormTitlesByFormIdElementMsg';
  formId?: Maybe<Scalars['String']>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_GetFormTitlesByFormIdsRequest = {
  __typename?: 'form_GetFormTitlesByFormIdsRequest';
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_GetFormTitlesByFormIdsResponse = {
  __typename?: 'form_GetFormTitlesByFormIdsResponse';
  elements?: Maybe<Array<Maybe<Form_GetFormTitlesByFormIdElementMsg>>>;
};

export type Form_GetFormsElementMsg = {
  __typename?: 'form_GetFormsElementMsg';
  form?: Maybe<Form_FormMsg>;
  templateTitle?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_GetFormsRequest = {
  __typename?: 'form_GetFormsRequest';
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  selector?: Maybe<Form_FormSelectorMsg>;
};

export type Form_GetFormsResponse = {
  __typename?: 'form_GetFormsResponse';
  elements?: Maybe<Array<Maybe<Form_GetFormsElementMsg>>>;
};

export type Form_GetSequentialFormSummaryRequest = {
  __typename?: 'form_GetSequentialFormSummaryRequest';
  formId?: Maybe<Scalars['String']>;
};

export type Form_GetSequentialFormSummaryResponse = {
  __typename?: 'form_GetSequentialFormSummaryResponse';
  questionsAndAnswers?: Maybe<Array<Maybe<Form_FormSequenceQuestionAndAnswerMsg>>>;
};

/**
 * This question will show the user an information text and has no actual answer.
 *  Use the question-title for the title of the text and the question-subtitle for the body of the text.
 */
export type Form_InfoTextFormQuestionMsg = {
  __typename?: 'form_InfoTextFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_InfoTextFormValueMsg = {
  __typename?: 'form_InfoTextFormValueMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_IntegerFormQuestionMsg = {
  __typename?: 'form_IntegerFormQuestionMsg';
  showSlider?: Maybe<Scalars['Boolean']>;
  specialMode?: Maybe<Form_IntegerFormQuestionSpecialMode>;
  stepSize?: Maybe<Scalars['Int']>;
  unitDatasetId?: Maybe<Scalars['String']>;
  valueMax?: Maybe<Scalars['Int']>;
  valueMin?: Maybe<Scalars['Int']>;
};

export enum Form_IntegerFormQuestionSpecialMode {
  IntegerFormQuestionSpecialModeNone = 'INTEGER_FORM_QUESTION_SPECIAL_MODE_NONE',
  IntegerFormQuestionSpecialModeRating = 'INTEGER_FORM_QUESTION_SPECIAL_MODE_RATING',
  IntegerFormQuestionSpecialModeYear = 'INTEGER_FORM_QUESTION_SPECIAL_MODE_YEAR'
}

export type Form_IntegerFormValueMsg = {
  __typename?: 'form_IntegerFormValueMsg';
  unitOptionId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export enum Form_KbvFormStatus {
  KbvFormStatusAborted = 'KBV_FORM_STATUS_ABORTED',
  KbvFormStatusCompleted = 'KBV_FORM_STATUS_COMPLETED',
  KbvFormStatusInProgress = 'KBV_FORM_STATUS_IN_PROGRESS',
  KbvFormStatusNone = 'KBV_FORM_STATUS_NONE',
  KbvFormStatusTodo = 'KBV_FORM_STATUS_TODO'
}

export type Form_KnowledgeFormQuestionMsg = {
  __typename?: 'form_KnowledgeFormQuestionMsg';
  knowledgeDataset?: Maybe<Knowledge_KnowledgeDataset>;
  /** Whether the dataset should be searchable or all options should be shown by default */
  searchable?: Maybe<Scalars['Boolean']>;
};

export type Form_KnowledgeFormValueMsg = {
  __typename?: 'form_KnowledgeFormValueMsg';
  value?: Maybe<Core_KnowledgeInputMsg>;
};

export type Form_LabResultFormQuestionMsg = {
  __typename?: 'form_LabResultFormQuestionMsg';
  defaultValueType?: Maybe<Form_LabResultFormValueType>;
  loincComponentCode?: Maybe<Scalars['String']>;
};

export type Form_LabResultFormValueMsg = {
  __typename?: 'form_LabResultFormValueMsg';
  boolValue?: Maybe<Scalars['Boolean']>;
  categoryValue?: Maybe<Scalars['String']>;
  decimalRangeValue?: Maybe<DecimalRangeMsg>;
  decimalValue?: Maybe<DecimalMsg>;
  intValue?: Maybe<Scalars['Int']>;
  ratioValue?: Maybe<RatioMsg>;
  textValue?: Maybe<Scalars['String']>;
  /** TODO: should be structured */
  unit?: Maybe<Scalars['String']>;
  valueType?: Maybe<Form_LabResultFormValueType>;
};

export enum Form_LabResultFormValueType {
  LabResultFormValueTypeBool = 'LAB_RESULT_FORM_VALUE_TYPE_BOOL',
  LabResultFormValueTypeCategory = 'LAB_RESULT_FORM_VALUE_TYPE_CATEGORY',
  LabResultFormValueTypeDecimal = 'LAB_RESULT_FORM_VALUE_TYPE_DECIMAL',
  LabResultFormValueTypeDecimalRange = 'LAB_RESULT_FORM_VALUE_TYPE_DECIMAL_RANGE',
  LabResultFormValueTypeInt = 'LAB_RESULT_FORM_VALUE_TYPE_INT',
  LabResultFormValueTypeNone = 'LAB_RESULT_FORM_VALUE_TYPE_NONE',
  LabResultFormValueTypeRatio = 'LAB_RESULT_FORM_VALUE_TYPE_RATIO',
  LabResultFormValueTypeText = 'LAB_RESULT_FORM_VALUE_TYPE_TEXT'
}

export type Form_LinkedFormContextIdentifierMsg = {
  __typename?: 'form_LinkedFormContextIdentifierMsg';
  contextId?: Maybe<Scalars['String']>;
  type?: Maybe<Form_LinkedFormContextType>;
};

export enum Form_LinkedFormContextType {
  LinkedFormContextTypeInvoice = 'LINKED_FORM_CONTEXT_TYPE_INVOICE',
  LinkedFormContextTypeNone = 'LINKED_FORM_CONTEXT_TYPE_NONE'
}

export type Form_ListAppointmentFormsRequest = {
  __typename?: 'form_ListAppointmentFormsRequest';
  appointmentId?: Maybe<Scalars['String']>;
  selector?: Maybe<Form_FormSelectorMsg>;
};

export type Form_ListAppointmentFormsResponse = {
  __typename?: 'form_ListAppointmentFormsResponse';
  forms?: Maybe<Form_FormList>;
};

export type Form_ListFormOptionsRequest = {
  __typename?: 'form_ListFormOptionsRequest';
  datasetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalIds?: Maybe<Array<Maybe<Form_FormExternalIdMsg>>>;
};

export type Form_ListFormOptionsResponse = {
  __typename?: 'form_ListFormOptionsResponse';
  options?: Maybe<Array<Maybe<Form_FormOptionMsg>>>;
};

export type Form_ListFormTemplateVersioningGroupsRequest = {
  __typename?: 'form_ListFormTemplateVersioningGroupsRequest';
  /**
   * filters by permissionScope administrative-units if not empty;
   *  all template-versioning-groups that have at least one match are returned
   */
  administrativeUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /**
   * filters by locations configs if not empty;
   *  all template-versioning-groups, that have at least one match are returned
   */
  locationConfigs?: Maybe<Array<Maybe<Form_FormTemplateLocationConfigMsg>>>;
  selector?: Maybe<Form_FormTemplateVersioningGroupSelectorMsg>;
};

export type Form_ListFormTemplateVersioningGroupsResponse = {
  __typename?: 'form_ListFormTemplateVersioningGroupsResponse';
  templateVersioningGroups?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupMsg>>>;
};

export type Form_ListFormTemplatesRequest = {
  __typename?: 'form_ListFormTemplatesRequest';
  /** if empty, all administrativeUnits are used */
  administrativeUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** if empty, all locations are used */
  locationConfigs?: Maybe<Array<Maybe<Form_FormTemplateLocationConfigMsg>>>;
  selector?: Maybe<Form_FormTemplateSelectorMsg>;
  /** if empty all statuses are used */
  statuses?: Maybe<Array<Maybe<Form_FormTemplateStatus>>>;
  tag?: Maybe<Form_FormTemplateVersioningGroupTag>;
  tagsToExclude?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  /** if empty, all template-versioning-groups are used */
  templateVersioningGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Form_ListFormTemplatesResponse = {
  __typename?: 'form_ListFormTemplatesResponse';
  templates?: Maybe<Array<Maybe<Form_FormTemplateMsg>>>;
};

export type Form_ListFormsElementMsg = {
  __typename?: 'form_ListFormsElementMsg';
  /**
   * optional, only relevant for BG reports
   *  returned if D-Arzt is set in form
   */
  dUserId?: Maybe<Scalars['String']>;
  form?: Maybe<Form_FormMsg>;
  /**
   * optional, only relevant for BG reports
   *  true if form was send to uni-dav
   */
  sentToUniDav?: Maybe<Scalars['Boolean']>;
  templateTitle?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_ListFormsRequest = {
  __typename?: 'form_ListFormsRequest';
  /** if empty all, forms of all appointments (and the ones without an appointment) are searched */
  appointmentId?: Maybe<Scalars['String']>;
  billingCaseId?: Maybe<Scalars['String']>;
  clinicalImpressionId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  /** dale report relevant filters */
  dUserSelectedInForm?: Maybe<Scalars['String']>;
  daleXmlStatuses?: Maybe<Array<Maybe<Billing_DaleXmlStatus>>>;
  includeTemplateTitles?: Maybe<Scalars['Boolean']>;
  lockedAtBefore?: Maybe<Timestamp>;
  lockedAtEqualOrAfter?: Maybe<Timestamp>;
  minOneOfTagsShouldMatch?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  mustFormTemplateVersioningGroupTags?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  owningOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** if empty all, forms of all patients (and the ones without a patient) are searched */
  patientId?: Maybe<Scalars['String']>;
  selector?: Maybe<Form_FormSelectorMsg>;
  sentToUniDav?: Maybe<Scalars['Boolean']>;
  /** if empty, all statuses are searched */
  statuses?: Maybe<Array<Maybe<Form_FormStatus>>>;
  tagsToExclude?: Maybe<Array<Maybe<Form_FormTemplateVersioningGroupTag>>>;
  /** if empty, all templates are searched */
  templateIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** if empty, all locations are searched */
  templateLocations?: Maybe<Array<Maybe<Form_FormTemplateLocation>>>;
  timeFrame?: Maybe<TimeFrameMsg>;
  /** if empty all, forms of all treatments (and the ones without a treatment) are searched */
  treatmentId?: Maybe<Scalars['String']>;
  /** if empty, all versioning groups are searched */
  versioningGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Form_ListFormsResponse = {
  __typename?: 'form_ListFormsResponse';
  elements?: Maybe<Array<Maybe<Form_ListFormsElementMsg>>>;
};

export type Form_LocalDateFormQuestionMsg = {
  __typename?: 'form_LocalDateFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_LocalDateFormValueMsg = {
  __typename?: 'form_LocalDateFormValueMsg';
  value?: Maybe<Core_LocalDateMsg>;
};

export type Form_LocalDateTimeFormQuestionMsg = {
  __typename?: 'form_LocalDateTimeFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_LocalDateTimeFormValueMsg = {
  __typename?: 'form_LocalDateTimeFormValueMsg';
  value?: Maybe<Core_LocalDateTimeMsg>;
};

export type Form_LocalTimeFormQuestionMsg = {
  __typename?: 'form_LocalTimeFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_LocalTimeFormValueMsg = {
  __typename?: 'form_LocalTimeFormValueMsg';
  value?: Maybe<Core_LocalTimeMsg>;
};

export type Form_MoveFormAnswerGroupRequest = {
  __typename?: 'form_MoveFormAnswerGroupRequest';
  answerGroupId?: Maybe<Scalars['String']>;
  directParentForm?: Maybe<Form_FormElementLocationMsg>;
  parentAnswerGroup?: Maybe<Form_FormElementLocationMsg>;
};

export type Form_MoveFormAnswerGroupResponse = {
  __typename?: 'form_MoveFormAnswerGroupResponse';
  answerGroup?: Maybe<Form_FormAnswerGroupMsg>;
  changedAnswers?: Maybe<Array<Maybe<Form_FormAnswerMsg>>>;
  changedChildAnswerGroupInfo?: Maybe<Array<Maybe<Form_FormChildAnswerGroupInfoMsg>>>;
  newParentInfo?: Maybe<Form_FormChildAnswerGroupInfoMsg>;
  oldParentInfo?: Maybe<Form_FormChildAnswerGroupInfoMsg>;
};

export type Form_MoveFormOptionGroupRequest = {
  __typename?: 'form_MoveFormOptionGroupRequest';
  datasetLocation?: Maybe<Form_FormElementLocationMsg>;
  optionGroupId?: Maybe<Scalars['String']>;
};

export type Form_MoveFormOptionGroupResponse = {
  __typename?: 'form_MoveFormOptionGroupResponse';
  newDataset?: Maybe<Form_FormDatasetMsg>;
  oldDataset?: Maybe<Form_FormDatasetMsg>;
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
};

export type Form_MoveFormOptionRequest = {
  __typename?: 'form_MoveFormOptionRequest';
  optionGroupLocation?: Maybe<Form_FormElementLocationMsg>;
  optionId?: Maybe<Scalars['String']>;
};

export type Form_MoveFormOptionResponse = {
  __typename?: 'form_MoveFormOptionResponse';
  newOptionGroup?: Maybe<Form_FormOptionGroupMsg>;
  oldOptionGroup?: Maybe<Form_FormOptionGroupMsg>;
  option?: Maybe<Form_FormOptionMsg>;
};

export type Form_MoveFormQuestionGroupRequest = {
  __typename?: 'form_MoveFormQuestionGroupRequest';
  directParentTemplate?: Maybe<Form_FormElementLocationMsg>;
  parentQuestionGroup?: Maybe<Form_FormElementLocationMsg>;
  questionGroupId?: Maybe<Scalars['String']>;
};

export type Form_MoveFormQuestionGroupResponse = {
  __typename?: 'form_MoveFormQuestionGroupResponse';
  newParentQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  oldParentQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  template?: Maybe<Form_FormTemplateMsg>;
};

/** can only be used for non-control-flow questions */
export type Form_MoveFormQuestionRequest = {
  __typename?: 'form_MoveFormQuestionRequest';
  questionGroupLocation?: Maybe<Form_FormElementLocationMsg>;
  questionId?: Maybe<Scalars['String']>;
};

export type Form_MoveFormQuestionResponse = {
  __typename?: 'form_MoveFormQuestionResponse';
  newQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  oldQuestionGroup?: Maybe<Form_FormQuestionGroupMsg>;
  question?: Maybe<Form_FormQuestionMsg>;
};

export type Form_MultiAllergyFormQuestionMsg = {
  __typename?: 'form_MultiAllergyFormQuestionMsg';
  importScope?: Maybe<Form_AllergyFormQuestionImportScope>;
};

export type Form_MultiAllergyFormValueMsg = {
  __typename?: 'form_MultiAllergyFormValueMsg';
  values?: Maybe<Array<Maybe<Treatment_AllergenMsg>>>;
};

export type Form_MultiDiagnosisFormQuestionMsg = {
  __typename?: 'form_MultiDiagnosisFormQuestionMsg';
  importScope?: Maybe<Form_DiagnosisFormQuestionImportScope>;
  searchType?: Maybe<Form_DiagnosisSearchType>;
};

export type Form_MultiDiagnosisFormValueMsg = {
  __typename?: 'form_MultiDiagnosisFormValueMsg';
  values?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
};

export type Form_MultiKnowledgeFormQuestionMsg = {
  __typename?: 'form_MultiKnowledgeFormQuestionMsg';
  knowledgeDataset?: Maybe<Knowledge_KnowledgeDataset>;
  maxAnswers?: Maybe<Scalars['Int']>;
  /** Whether the dataset should be searchable or all options should be shown by default */
  searchable?: Maybe<Scalars['Boolean']>;
};

export type Form_MultiKnowledgeFormValueMsg = {
  __typename?: 'form_MultiKnowledgeFormValueMsg';
  values?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Form_MultiSelectFormQuestionMsg = {
  __typename?: 'form_MultiSelectFormQuestionMsg';
  datasetId?: Maybe<Scalars['String']>;
  maxAnswers?: Maybe<Scalars['Int']>;
  searchable?: Maybe<Scalars['Boolean']>;
};

export type Form_MultiSelectFormValueMsg = {
  __typename?: 'form_MultiSelectFormValueMsg';
  options?: Maybe<Array<Maybe<Form_FormOptionMsg>>>;
};

export type Form_PrecisionTimestampFormQuestionMsg = {
  __typename?: 'form_PrecisionTimestampFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_PrecisionTimestampFormValueMsg = {
  __typename?: 'form_PrecisionTimestampFormValueMsg';
  value?: Maybe<PrecisionTimestampMsg>;
};

export type Form_RestartFormRequest = {
  __typename?: 'form_RestartFormRequest';
  formId?: Maybe<Scalars['String']>;
};

export type Form_RestartFormResponse = {
  __typename?: 'form_RestartFormResponse';
  form?: Maybe<Form_FormMsg>;
};

export type Form_SearchFormOptionsRequest = {
  __typename?: 'form_SearchFormOptionsRequest';
  formDatasetId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type Form_SearchFormOptionsResponse = {
  __typename?: 'form_SearchFormOptionsResponse';
  optionGroups?: Maybe<Array<Maybe<Form_FormOptionGroupMsg>>>;
};

export type Form_SelectFormQuestionMsg = {
  __typename?: 'form_SelectFormQuestionMsg';
  datasetId?: Maybe<Scalars['String']>;
  /** if this field is true, the question should be displayed as a radio button */
  isRadio?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['Boolean']>;
};

export type Form_SelectFormValueMsg = {
  __typename?: 'form_SelectFormValueMsg';
  option?: Maybe<Form_FormOptionMsg>;
};

export type Form_SignFormRequest = {
  __typename?: 'form_SignFormRequest';
  formId?: Maybe<Scalars['String']>;
};

export type Form_SignatureFormQuestionMsg = {
  __typename?: 'form_SignatureFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_SignatureFormValueMsg = {
  __typename?: 'form_SignatureFormValueMsg';
  /** The signature image should be fetched by imageId in image service */
  signatureImageId?: Maybe<Scalars['String']>;
};

export type Form_StringFormQuestionMsg = {
  __typename?: 'form_StringFormQuestionMsg';
  maxCharacters?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Core_LocalizedStringMsg>;
};

export type Form_StringFormValueMsg = {
  __typename?: 'form_StringFormValueMsg';
  value?: Maybe<Scalars['String']>;
};

export type Form_TimestampFormQuestionMsg = {
  __typename?: 'form_TimestampFormQuestionMsg';
  _?: Maybe<Scalars['String']>;
};

export type Form_TimestampFormValueMsg = {
  __typename?: 'form_TimestampFormValueMsg';
  value?: Maybe<Timestamp>;
};

export type Form_UnsignFormRequest = {
  __typename?: 'form_UnsignFormRequest';
  formId?: Maybe<Scalars['String']>;
};

export type Form_UpdateFormDatasetRequest = {
  __typename?: 'form_UpdateFormDatasetRequest';
  dataset?: Maybe<Form_FormDatasetMsg>;
};

export type Form_UpdateFormDatasetResponse = {
  __typename?: 'form_UpdateFormDatasetResponse';
  dataset?: Maybe<Form_FormDatasetMsg>;
};

export type Form_UpdateFormOptionGroupRequest = {
  __typename?: 'form_UpdateFormOptionGroupRequest';
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
};

export type Form_UpdateFormOptionGroupResponse = {
  __typename?: 'form_UpdateFormOptionGroupResponse';
  optionGroup?: Maybe<Form_FormOptionGroupMsg>;
};

export type Form_UpdateFormOptionRequest = {
  __typename?: 'form_UpdateFormOptionRequest';
  option?: Maybe<Form_FormOptionMsg>;
};

export type Form_UpdateFormOptionResponse = {
  __typename?: 'form_UpdateFormOptionResponse';
  option?: Maybe<Form_FormOptionMsg>;
};

export type Form_UpdateFormQuestionGroupRequest = {
  __typename?: 'form_UpdateFormQuestionGroupRequest';
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
};

export type Form_UpdateFormQuestionGroupResponse = {
  __typename?: 'form_UpdateFormQuestionGroupResponse';
  questionGroup?: Maybe<Form_FormQuestionGroupMsg>;
};

export type Form_UpdateFormQuestionRequest = {
  __typename?: 'form_UpdateFormQuestionRequest';
  question?: Maybe<Form_FormQuestionMsg>;
};

export type Form_UpdateFormQuestionResponse = {
  __typename?: 'form_UpdateFormQuestionResponse';
  question?: Maybe<Form_FormQuestionMsg>;
};

export type Form_UpdateFormSignatureRequest = {
  __typename?: 'form_UpdateFormSignatureRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  signatoryRequest?: Maybe<Signature_SignatureMsg>;
};

export type Form_UpdateFormSignaturesRequest = {
  __typename?: 'form_UpdateFormSignaturesRequest';
  formId?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<Signature_SignatureMsg>>>;
};

export type Form_UpdateFormStatusRequest = {
  __typename?: 'form_UpdateFormStatusRequest';
  /**
   * contexts are set to ignore form questions that are ignored due to enablement contexts
   *  if a form question has any enablement contexts, if none of them are in the list of given contexts
   *  its validity is ignored
   */
  contexts?: Maybe<Array<Maybe<Form_FormQuestionContextMsg>>>;
  formId?: Maybe<Scalars['String']>;
  status?: Maybe<Form_FormStatus>;
};

export type Form_UpdateFormStatusResponse = {
  __typename?: 'form_UpdateFormStatusResponse';
  form?: Maybe<Form_FormMsg>;
  validationErrors?: Maybe<Array<Maybe<Form_FormValidationErrorMsg>>>;
};

export type Form_UpdateFormTemplateRequest = {
  __typename?: 'form_UpdateFormTemplateRequest';
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_UpdateFormTemplateResponse = {
  __typename?: 'form_UpdateFormTemplateResponse';
  template?: Maybe<Form_FormTemplateMsg>;
};

export type Form_UpdateFormTemplateVersioningGroupRequest = {
  __typename?: 'form_UpdateFormTemplateVersioningGroupRequest';
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_UpdateFormTemplateVersioningGroupResponse = {
  __typename?: 'form_UpdateFormTemplateVersioningGroupResponse';
  /** includes only permissionScope and locationConfigs */
  templateVersioningGroup?: Maybe<Form_FormTemplateVersioningGroupMsg>;
};

export type Form_UpdateLinkedFormContextRequest = {
  __typename?: 'form_UpdateLinkedFormContextRequest';
  formId?: Maybe<Scalars['String']>;
  /** to remove linked identifier of certain type specify type and leave context id empty */
  linkedContextIdentifiers?: Maybe<Array<Maybe<Form_LinkedFormContextIdentifierMsg>>>;
};

export enum Form_UserSelectFilterType {
  UserSelectFilterTypeExternalIdIk = 'USER_SELECT_FILTER_TYPE_EXTERNAL_ID_IK',
  UserSelectFilterTypeNone = 'USER_SELECT_FILTER_TYPE_NONE'
}

export type Form_UserSelectFormQuestionMsg = {
  __typename?: 'form_UserSelectFormQuestionMsg';
  filterType?: Maybe<Form_UserSelectFilterType>;
};

export type Form_UserSelectFormValueMsg = {
  __typename?: 'form_UserSelectFormValueMsg';
  userId?: Maybe<Scalars['String']>;
};

export type Helper_Empty = {
  __typename?: 'helper_Empty';
  _?: Maybe<Scalars['String']>;
};

export type Helper_GeneralSearchMsg = {
  __typename?: 'helper_GeneralSearchMsg';
  text?: Maybe<Scalars['String']>;
};

export type Helper_IdList = {
  __typename?: 'helper_IdList';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Helper_KeysetPaginatedRequestType {
  KeysetPaginatedRequestTypeFindCurrentPage = 'KEYSET_PAGINATED_REQUEST_TYPE_FIND_CURRENT_PAGE',
  KeysetPaginatedRequestTypeFindFirstPage = 'KEYSET_PAGINATED_REQUEST_TYPE_FIND_FIRST_PAGE',
  KeysetPaginatedRequestTypeFindNextPage = 'KEYSET_PAGINATED_REQUEST_TYPE_FIND_NEXT_PAGE',
  KeysetPaginatedRequestTypeFindPreviousPage = 'KEYSET_PAGINATED_REQUEST_TYPE_FIND_PREVIOUS_PAGE',
  KeysetPaginatedRequestTypeNone = 'KEYSET_PAGINATED_REQUEST_TYPE_NONE'
}

export type Helper_PaginatedListRequest = {
  __typename?: 'helper_PaginatedListRequest';
  /** 0-indexed page index; restriction: (pageSize * pageIndex) + pageSize < 10.000 */
  pageIndex?: Maybe<Scalars['Int']>;
  /** How many elements are shown on the page */
  pageSize?: Maybe<Scalars['Int']>;
  /** Sort instructions which will be processed in the given order */
  sortInstructions?: Maybe<Array<Maybe<Helper_SortInstruction>>>;
  /** If we want to search within a paginated list */
  text?: Maybe<Scalars['String']>;
};

export type Helper_PaginationSettingsMsg = {
  __typename?: 'helper_PaginationSettingsMsg';
  /** 0-indexed page index; restriction: (pageSize * pageIndex) + pageSize < 10.000 */
  pageIndex?: Maybe<Scalars['Int']>;
  /** How many elements are shown on the page */
  pageSize?: Maybe<Scalars['Int']>;
};

export type Helper_SortInstruction = {
  __typename?: 'helper_SortInstruction';
  /** Can be left null if ascending */
  descending?: Maybe<Scalars['Boolean']>;
  /**
   * Fully qualified name of the variable based on the entity to be searched;
   *  for instance, if an entity has a field "name" of type HumanNameMsg, sorting for first name would be name.firstName
   */
  variable?: Maybe<Scalars['String']>;
};

export enum Helper_SortOrder {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  SortOrderNone = 'SORT_ORDER_NONE'
}

export type Image_ExifInformationMsg = {
  __typename?: 'image_ExifInformationMsg';
  apertureValue?: Maybe<Scalars['Float']>;
  dateTime?: Maybe<Timestamp>;
  exposure?: Maybe<Scalars['Float']>;
  fNumber?: Maybe<Scalars['Float']>;
  /** Mapping can be found here: https://www.awaresystems.be/imaging/tiff/tifftags/privateifd/exif/flash.html */
  flash?: Maybe<Scalars['Int']>;
  focalLength?: Maybe<Scalars['Float']>;
  isoSpeedRating?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  orientation?: Maybe<Image_ExifOrientation>;
  width?: Maybe<Scalars['Int']>;
};

export enum Image_ExifOrientation {
  ExifOrientationBottomLeftSide = 'EXIF_ORIENTATION_BOTTOM_LEFT_SIDE',
  ExifOrientationBottomRightSide = 'EXIF_ORIENTATION_BOTTOM_RIGHT_SIDE',
  ExifOrientationLeftSideBottom = 'EXIF_ORIENTATION_LEFT_SIDE_BOTTOM',
  ExifOrientationLeftSideTop = 'EXIF_ORIENTATION_LEFT_SIDE_TOP',
  ExifOrientationNone = 'EXIF_ORIENTATION_NONE',
  ExifOrientationRightSideBottom = 'EXIF_ORIENTATION_RIGHT_SIDE_BOTTOM',
  ExifOrientationRightSideTop = 'EXIF_ORIENTATION_RIGHT_SIDE_TOP',
  ExifOrientationTopLeftSide = 'EXIF_ORIENTATION_TOP_LEFT_SIDE',
  ExifOrientationTopRightSide = 'EXIF_ORIENTATION_TOP_RIGHT_SIDE'
}

export type Image_ImageDescriptionMsg = {
  __typename?: 'image_ImageDescriptionMsg';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Image_ImageDescriptionType>;
};

export enum Image_ImageDescriptionType {
  ImageDescriptionTypeDermoscopic = 'IMAGE_DESCRIPTION_TYPE_DERMOSCOPIC',
  ImageDescriptionTypeMacroscopic = 'IMAGE_DESCRIPTION_TYPE_MACROSCOPIC',
  ImageDescriptionTypeNone = 'IMAGE_DESCRIPTION_TYPE_NONE',
  ImageDescriptionTypeSonographic = 'IMAGE_DESCRIPTION_TYPE_SONOGRAPHIC'
}

export type Image_ImageMetadataMsg = {
  __typename?: 'image_ImageMetadataMsg';
  descriptions?: Maybe<Array<Maybe<Image_ImageDescriptionMsg>>>;
  exifInformation?: Maybe<Image_ExifInformationMsg>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Knowledge_AllergenResult = {
  __typename?: 'knowledge_AllergenResult';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalAllergenIdResult>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Knowledge_AllergenResultList = {
  __typename?: 'knowledge_AllergenResultList';
  allergens?: Maybe<Array<Maybe<Knowledge_AllergenResult>>>;
};

export type Knowledge_BFarmOpsCodeResultMsg = {
  __typename?: 'knowledge_BFarmOpsCodeResultMsg';
  categoryCode?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  chapterCode?: Maybe<Scalars['String']>;
  chapterName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeRange?: Maybe<Knowledge_BFarmOpsCodeResultMsg_CodeRange>;
  /** Display value */
  fullCategoryName?: Maybe<Scalars['String']>;
  generatedId?: Maybe<Scalars['Long']>;
  groupCode?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  hasSideReference?: Maybe<Scalars['Boolean']>;
  isAuxiliary?: Maybe<Scalars['Boolean']>;
  isLeaf?: Maybe<Scalars['Boolean']>;
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['String']>;
  levelNumber?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentCode?: Maybe<Scalars['String']>;
};

export type Knowledge_BFarmOpsCodeResultMsg_CodeRange = {
  __typename?: 'knowledge_BFarmOpsCodeResultMsg_CodeRange';
  codeEnd?: Maybe<Scalars['String']>;
  codeStart?: Maybe<Scalars['String']>;
};

export type Knowledge_BillingCertificateTypeMsg = {
  __typename?: 'knowledge_BillingCertificateTypeMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  groupDescription?: Maybe<Scalars['String']>;
};

export enum Knowledge_BodyPartLaterality {
  BodyPartLateralityLeft = 'BODY_PART_LATERALITY_LEFT',
  BodyPartLateralityNone = 'BODY_PART_LATERALITY_NONE',
  BodyPartLateralityRight = 'BODY_PART_LATERALITY_RIGHT'
}

export type Knowledge_BodyPartList = {
  __typename?: 'knowledge_BodyPartList';
  bodyParts?: Maybe<Array<Maybe<Knowledge_BodyPartMsg>>>;
};

export type Knowledge_BodyPartMsg = {
  __typename?: 'knowledge_BodyPartMsg';
  generalId?: Maybe<Scalars['String']>;
  laterality?: Maybe<Knowledge_BodyPartLaterality>;
  name?: Maybe<Scalars['String']>;
};

export type Knowledge_ClassificationSystemResult = {
  __typename?: 'knowledge_ClassificationSystemResult';
  /** Fixed UUID */
  generalId?: Maybe<Scalars['String']>;
  /** Facet names for the different steps in that classification; required for faceted search for the clinical stages */
  steps?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of the classification system */
  text?: Maybe<Scalars['String']>;
  /** Versions, e.g. if the system has different editions per year */
  versions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_ClassificationSystemResultList = {
  __typename?: 'knowledge_ClassificationSystemResultList';
  results?: Maybe<Array<Maybe<Knowledge_ClassificationSystemResult>>>;
};

export type Knowledge_ClinicalStageResult = {
  __typename?: 'knowledge_ClinicalStageResult';
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_ClinicalStageResultList = {
  __typename?: 'knowledge_ClinicalStageResultList';
  results?: Maybe<Array<Maybe<Knowledge_ClinicalStageResult>>>;
};

export type Knowledge_CountryList = {
  __typename?: 'knowledge_CountryList';
  countries?: Maybe<Array<Maybe<Knowledge_CountryMsg>>>;
};

export type Knowledge_CountryMsg = {
  __typename?: 'knowledge_CountryMsg';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalCountryIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  isInDguv?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_DenominationMsg = {
  __typename?: 'knowledge_DenominationMsg';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalDenominationIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Knowledge_DiagnosisCodeTypeResult {
  DiagnosisCodeTypeResultAdditional = 'DIAGNOSIS_CODE_TYPE_RESULT_ADDITIONAL',
  DiagnosisCodeTypeResultAsterisk = 'DIAGNOSIS_CODE_TYPE_RESULT_ASTERISK',
  DiagnosisCodeTypeResultCross = 'DIAGNOSIS_CODE_TYPE_RESULT_CROSS',
  DiagnosisCodeTypeResultNone = 'DIAGNOSIS_CODE_TYPE_RESULT_NONE',
  DiagnosisCodeTypeResultPrimary = 'DIAGNOSIS_CODE_TYPE_RESULT_PRIMARY'
}

export type Knowledge_DiagnosisCodingResult = {
  __typename?: 'knowledge_DiagnosisCodingResult';
  codingId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  system?: Maybe<Knowledge_DiagnosisCodingSystemResult>;
  systemVersion?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_DiagnosisCodeTypeResult>;
};

export enum Knowledge_DiagnosisCodingSystemResult {
  DiagnosisCodingSystemResultAlphaId = 'DIAGNOSIS_CODING_SYSTEM_RESULT_ALPHA_ID',
  DiagnosisCodingSystemResultIcd_10Gm = 'DIAGNOSIS_CODING_SYSTEM_RESULT_ICD_10_GM',
  DiagnosisCodingSystemResultNone = 'DIAGNOSIS_CODING_SYSTEM_RESULT_NONE',
  DiagnosisCodingSystemResultOrphaId = 'DIAGNOSIS_CODING_SYSTEM_RESULT_ORPHA_ID'
}

export enum Knowledge_DiagnosisDataset {
  DiagnosisDatasetAlphaId = 'DIAGNOSIS_DATASET_ALPHA_ID',
  DiagnosisDatasetIcd_10Gm = 'DIAGNOSIS_DATASET_ICD_10_GM',
  DiagnosisDatasetNone = 'DIAGNOSIS_DATASET_NONE'
}

export type Knowledge_DiagnosisDescriptionMsg = {
  __typename?: 'knowledge_DiagnosisDescriptionMsg';
  description?: Maybe<Scalars['String']>;
};

export type Knowledge_DiagnosisInfoResult = {
  __typename?: 'knowledge_DiagnosisInfoResult';
  codes?: Maybe<Array<Maybe<Knowledge_DiagnosisCodingResult>>>;
  description?: Maybe<Scalars['String']>;
};

export type Knowledge_DiagnosisInfoResultList = {
  __typename?: 'knowledge_DiagnosisInfoResultList';
  results?: Maybe<Array<Maybe<Knowledge_DiagnosisInfoResult>>>;
};

export enum Knowledge_DischargeHospitalRequirementStatus {
  DischargeHospitalRequirementStatusForbidden = 'DISCHARGE_HOSPITAL_REQUIREMENT_STATUS_FORBIDDEN',
  DischargeHospitalRequirementStatusNone = 'DISCHARGE_HOSPITAL_REQUIREMENT_STATUS_NONE',
  DischargeHospitalRequirementStatusOptional = 'DISCHARGE_HOSPITAL_REQUIREMENT_STATUS_OPTIONAL',
  DischargeHospitalRequirementStatusRequired = 'DISCHARGE_HOSPITAL_REQUIREMENT_STATUS_REQUIRED'
}

export type Knowledge_DkgDataElementMsg = {
  __typename?: 'knowledge_DkgDataElementMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export enum Knowledge_DkgDataset {
  /** http://fhir.de/CodeSystem/dgkev/Aufnahmeanlass */
  DkgDatasetAdmissionEvent = 'DKG_DATASET_ADMISSION_EVENT',
  /** http://fhir.de/CodeSystem/dkgev/AufnahmegrundErsteUndZweiteStelle */
  DkgDatasetAdmissionReasonDigitsOneTwo = 'DKG_DATASET_ADMISSION_REASON_DIGITS_ONE_TWO',
  /** http://fhir.de/CodeSystem/dkgev/AufnahmegrundVierteStelle */
  DkgDatasetAdmissionReasonDigitFour = 'DKG_DATASET_ADMISSION_REASON_DIGIT_FOUR',
  /** http://fhir.de/CodeSystem/dkgev/AufnahmegrundDritteStelle */
  DkgDatasetAdmissionReasonDigitThree = 'DKG_DATASET_ADMISSION_REASON_DIGIT_THREE',
  /** http://fhir.de/CodeSystem/dkgev/EntlassungsgrundErsteUndZweiteStelle */
  DkgDatasetDischargeReasonDigitsOneTwo = 'DKG_DATASET_DISCHARGE_REASON_DIGITS_ONE_TWO',
  /** http://fhir.de/CodeSystem/dkgev/EntlassungsgrundDritteStelle */
  DkgDatasetDischargeReasonDigitThree = 'DKG_DATASET_DISCHARGE_REASON_DIGIT_THREE',
  DkgDatasetNone = 'DKG_DATASET_NONE'
}

/** Filters that are relevant for limiting results for discharge reason digit three */
export type Knowledge_DkgDischargeReasonDigitThreeFiltersMsg = {
  __typename?: 'knowledge_DkgDischargeReasonDigitThreeFiltersMsg';
  dischargeReasonDigitsOneTwo?: Maybe<Scalars['String']>;
  insuredPersonTypeCode?: Maybe<Scalars['String']>;
};

export type Knowledge_DrugPackageUnitResult = {
  __typename?: 'knowledge_DrugPackageUnitResult';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalDrugPackageUnitIdResult>>>;
  name?: Maybe<Scalars['String']>;
};

export type Knowledge_DrugPackageUnitResultList = {
  __typename?: 'knowledge_DrugPackageUnitResultList';
  results?: Maybe<Array<Maybe<Knowledge_DrugPackageUnitResult>>>;
};

export enum Knowledge_ExternalActiveIngredientUnitIdType {
  /** System for German "Bundeseinheitlicher Medikationsplan". 6 -> 2 */
  ExternalActiveIngredientUnitIdTypeBmp = 'EXTERNAL_ACTIVE_INGREDIENT_UNIT_ID_TYPE_BMP',
  ExternalActiveIngredientUnitIdTypeMmi = 'EXTERNAL_ACTIVE_INGREDIENT_UNIT_ID_TYPE_MMI',
  ExternalActiveIngredientUnitIdTypeNone = 'EXTERNAL_ACTIVE_INGREDIENT_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalAllergenIdResult = {
  __typename?: 'knowledge_ExternalAllergenIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalAllergenIdType>;
};

export enum Knowledge_ExternalAllergenIdType {
  ExternalAllergenIdTypeMoleculeId = 'EXTERNAL_ALLERGEN_ID_TYPE_MOLECULE_ID',
  ExternalAllergenIdTypeNone = 'EXTERNAL_ALLERGEN_ID_TYPE_NONE',
  ExternalAllergenIdTypeSubstanceClassId = 'EXTERNAL_ALLERGEN_ID_TYPE_SUBSTANCE_CLASS_ID'
}

export type Knowledge_ExternalCountryIdMsg = {
  __typename?: 'knowledge_ExternalCountryIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalCountryIdType>;
};

export enum Knowledge_ExternalCountryIdType {
  ExternalCountryIdTypeDeuv = 'EXTERNAL_COUNTRY_ID_TYPE_DEUV',
  ExternalCountryIdTypeIso2 = 'EXTERNAL_COUNTRY_ID_TYPE_ISO2',
  ExternalCountryIdTypeIso3 = 'EXTERNAL_COUNTRY_ID_TYPE_ISO3',
  ExternalCountryIdTypeNone = 'EXTERNAL_COUNTRY_ID_TYPE_NONE'
}

export type Knowledge_ExternalDenominationIdMsg = {
  __typename?: 'knowledge_ExternalDenominationIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDenominationIdType>;
};

export enum Knowledge_ExternalDenominationIdType {
  ExternalDenominationIdTypeNone = 'EXTERNAL_DENOMINATION_ID_TYPE_NONE',
  ExternalDenominationIdTypeSap = 'EXTERNAL_DENOMINATION_ID_TYPE_SAP'
}

export type Knowledge_ExternalDrugPackageIdResult = {
  __typename?: 'knowledge_ExternalDrugPackageIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDrugPackageIdType>;
};

export enum Knowledge_ExternalDrugPackageIdType {
  ExternalDrugPackageIdTypeMmi = 'EXTERNAL_DRUG_PACKAGE_ID_TYPE_MMI',
  ExternalDrugPackageIdTypeNone = 'EXTERNAL_DRUG_PACKAGE_ID_TYPE_NONE',
  /** German "Pharmazentralnummer" */
  ExternalDrugPackageIdTypePzn = 'EXTERNAL_DRUG_PACKAGE_ID_TYPE_PZN'
}

export type Knowledge_ExternalDrugPackageUnitIdResult = {
  __typename?: 'knowledge_ExternalDrugPackageUnitIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDrugPackageUnitIdType>;
};

export enum Knowledge_ExternalDrugPackageUnitIdType {
  ExternalDrugPackageUnitIdTypeMmi = 'EXTERNAL_DRUG_PACKAGE_UNIT_ID_TYPE_MMI',
  ExternalDrugPackageUnitIdTypeNone = 'EXTERNAL_DRUG_PACKAGE_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalLanguageIdMsg = {
  __typename?: 'knowledge_ExternalLanguageIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalLanguageIdType>;
};

export enum Knowledge_ExternalLanguageIdType {
  ExternalLanguageIdTypeIso_639_1 = 'EXTERNAL_LANGUAGE_ID_TYPE_ISO_639_1',
  ExternalLanguageIdTypeIso_639_2 = 'EXTERNAL_LANGUAGE_ID_TYPE_ISO_639_2',
  ExternalLanguageIdTypeKbv = 'EXTERNAL_LANGUAGE_ID_TYPE_KBV',
  ExternalLanguageIdTypeNone = 'EXTERNAL_LANGUAGE_ID_TYPE_NONE'
}

export type Knowledge_ExternalMedicationDosageFormulaUnitIdResult = {
  __typename?: 'knowledge_ExternalMedicationDosageFormulaUnitIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationDosageFormulaUnitIdType>;
};

export enum Knowledge_ExternalMedicationDosageFormulaUnitIdType {
  ExternalMedicationDosageFormulaUnitIdTypeNone = 'EXTERNAL_MEDICATION_DOSAGE_FORMULA_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalMedicationDosageUnitIdResult = {
  __typename?: 'knowledge_ExternalMedicationDosageUnitIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export enum Knowledge_ExternalMedicationDosageUnitIdType {
  ExternalMedicationDosageUnitIdTypeBmp = 'EXTERNAL_MEDICATION_DOSAGE_UNIT_ID_TYPE_BMP',
  ExternalMedicationDosageUnitIdTypeMmi = 'EXTERNAL_MEDICATION_DOSAGE_UNIT_ID_TYPE_MMI',
  ExternalMedicationDosageUnitIdTypeNone = 'EXTERNAL_MEDICATION_DOSAGE_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalMedicationFlowRateFormulaUnitIdResult = {
  __typename?: 'knowledge_ExternalMedicationFlowRateFormulaUnitIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationFlowRateFormulaUnitIdType>;
};

export enum Knowledge_ExternalMedicationFlowRateFormulaUnitIdType {
  ExternalMedicationFlowRateFormulaUnitIdTypeNone = 'EXTERNAL_MEDICATION_FLOW_RATE_FORMULA_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalMedicationFlowRateUnitIdResult = {
  __typename?: 'knowledge_ExternalMedicationFlowRateUnitIdResult';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationFlowRateUnitIdType>;
};

export enum Knowledge_ExternalMedicationFlowRateUnitIdType {
  ExternalMedicationFlowRateUnitIdTypeNone = 'EXTERNAL_MEDICATION_FLOW_RATE_UNIT_ID_TYPE_NONE'
}

export type Knowledge_ExternalMedicationIntakeIdMsg = {
  __typename?: 'knowledge_ExternalMedicationIntakeIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationIntakeIdType>;
};

export enum Knowledge_ExternalMedicationIntakeIdType {
  ExternalMedicationIntakeIdTypeBmpZwischenueberschriftCode = 'EXTERNAL_MEDICATION_INTAKE_ID_TYPE_BMP_ZWISCHENUEBERSCHRIFT_CODE',
  ExternalMedicationIntakeIdTypeItemroacode = 'EXTERNAL_MEDICATION_INTAKE_ID_TYPE_ITEMROACODE',
  ExternalMedicationIntakeIdTypeNone = 'EXTERNAL_MEDICATION_INTAKE_ID_TYPE_NONE'
}

export type Knowledge_ExternalNationalityIdMsg = {
  __typename?: 'knowledge_ExternalNationalityIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalNationalityIdType>;
};

export enum Knowledge_ExternalNationalityIdType {
  ExternalNationalityIdTypeIso2 = 'EXTERNAL_NATIONALITY_ID_TYPE_ISO2',
  ExternalNationalityIdTypeNone = 'EXTERNAL_NATIONALITY_ID_TYPE_NONE'
}

export type Knowledge_Facet = {
  __typename?: 'knowledge_Facet';
  column?: Maybe<Scalars['String']>;
  /** MeiliSearch only allows for faceted search on string data */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_FindCountriesRequest = {
  __typename?: 'knowledge_FindCountriesRequest';
  /** all countries that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalCountryIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_FindCountriesResponse = {
  __typename?: 'knowledge_FindCountriesResponse';
  countries?: Maybe<Array<Maybe<Knowledge_CountryMsg>>>;
};

export type Knowledge_FindDenominationsRequest = {
  __typename?: 'knowledge_FindDenominationsRequest';
  /** all denominations that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalDenominationIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_FindDenominationsResponse = {
  __typename?: 'knowledge_FindDenominationsResponse';
  denominations?: Maybe<Array<Maybe<Knowledge_DenominationMsg>>>;
};

export type Knowledge_FindDocumentTypesRequest = {
  __typename?: 'knowledge_FindDocumentTypesRequest';
  /** all document types that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Document_DocumentTypeExternalIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_FindDocumentTypesResponse = {
  __typename?: 'knowledge_FindDocumentTypesResponse';
  documentTypes?: Maybe<Array<Maybe<Document_DocumentTypeMsg>>>;
};

export type Knowledge_FindNationalitiesRequest = {
  __typename?: 'knowledge_FindNationalitiesRequest';
  /** all nationalities that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalNationalityIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_FindNationalitiesResponse = {
  __typename?: 'knowledge_FindNationalitiesResponse';
  nationalities?: Maybe<Array<Maybe<Knowledge_NationalityMsg>>>;
};

export type Knowledge_FindOrphaIdCodesRequest = {
  __typename?: 'knowledge_FindOrphaIdCodesRequest';
  codings?: Maybe<Array<Maybe<Knowledge_DiagnosisCodingResult>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_FindOrphaIdCodesResponse = {
  __typename?: 'knowledge_FindOrphaIdCodesResponse';
  foundCodes?: Maybe<Knowledge_DiagnosisInfoResultList>;
};

export type Knowledge_FindWopsRequest = {
  __typename?: 'knowledge_FindWopsRequest';
  wopCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_FindWopsResponse = {
  __typename?: 'knowledge_FindWopsResponse';
  wops?: Maybe<Array<Maybe<Knowledge_WopMsg>>>;
};

export type Knowledge_GetCountriesRequest = {
  __typename?: 'knowledge_GetCountriesRequest';
  /** all countries that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalCountryIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_GetDischargeHospitalRequirementRequest = {
  __typename?: 'knowledge_GetDischargeHospitalRequirementRequest';
  /** only two digits */
  dischargeReasonDigitsOneTwo?: Maybe<Scalars['String']>;
};

export type Knowledge_GetDischargeHospitalRequirementResponse = {
  __typename?: 'knowledge_GetDischargeHospitalRequirementResponse';
  dischargeHospitalRequirementStatus?: Maybe<Knowledge_DischargeHospitalRequirementStatus>;
};

export type Knowledge_GetIcd10DescriptionsRequest = {
  __typename?: 'knowledge_GetIcd10DescriptionsRequest';
  icd10Codes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_GetIcd10DescriptionsResponse = {
  __typename?: 'knowledge_GetIcd10DescriptionsResponse';
  icd10CodeToDescription?: Maybe<Array<Maybe<Knowledge_GetIcd10DescriptionsResponse_Icd10CodeToDescriptionEntry>>>;
};

export type Knowledge_GetIcd10DescriptionsResponse_Icd10CodeToDescriptionEntry = {
  __typename?: 'knowledge_GetIcd10DescriptionsResponse_Icd10CodeToDescriptionEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Knowledge_DiagnosisDescriptionMsg>;
};

export type Knowledge_GetIcd10DiagnosisInfosRequest = {
  __typename?: 'knowledge_GetIcd10DiagnosisInfosRequest';
  icd10Codes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_GetLanguagesRequest = {
  __typename?: 'knowledge_GetLanguagesRequest';
  /** all languages that match at least one of the specified externalIds are returned */
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalLanguageIdMsg>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
};

export type Knowledge_GetOpsKbvCodesRequest = {
  __typename?: 'knowledge_GetOpsKbvCodesRequest';
  opsCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_GetOpsKbvCodesResponse = {
  __typename?: 'knowledge_GetOpsKbvCodesResponse';
  opsCodeToOpsResult?: Maybe<Array<Maybe<Knowledge_GetOpsKbvCodesResponse_OpsCodeToOpsResultEntry>>>;
};

export type Knowledge_GetOpsKbvCodesResponse_OpsCodeToOpsResultEntry = {
  __typename?: 'knowledge_GetOpsKbvCodesResponse_OpsCodeToOpsResultEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Knowledge_OpsResultMsg>;
};

export type Knowledge_IntakeMechanismMsg = {
  __typename?: 'knowledge_IntakeMechanismMsg';
  generalId?: Maybe<Scalars['String']>;
  isInstantaneous?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type Knowledge_IntakeTypeMsg = {
  __typename?: 'knowledge_IntakeTypeMsg';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalMedicationIntakeIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Knowledge_IntakeTypeTag>>>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_IntakeTypeResultList = {
  __typename?: 'knowledge_IntakeTypeResultList';
  results?: Maybe<Array<Maybe<Knowledge_IntakeTypeMsg>>>;
};

export enum Knowledge_IntakeTypeTag {
  IntakeTypeTagHasMechanism = 'INTAKE_TYPE_TAG_HAS_MECHANISM',
  IntakeTypeTagIsInstantaneous = 'INTAKE_TYPE_TAG_IS_INSTANTANEOUS',
  IntakeTypeTagIv = 'INTAKE_TYPE_TAG_IV',
  IntakeTypeTagNone = 'INTAKE_TYPE_TAG_NONE'
}

export enum Knowledge_Kz115bType {
  Kz115BTypeNone = 'KZ115B_TYPE_NONE',
  Kz115BTypeOne = 'KZ115B_TYPE_ONE',
  Kz115BTypeS = 'KZ115B_TYPE_S',
  Kz115BTypeTwo = 'KZ115B_TYPE_TWO'
}

export type Knowledge_KbvDataElementMsg = {
  __typename?: 'knowledge_KbvDataElementMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  generalId?: Maybe<Scalars['String']>;
};

export enum Knowledge_KbvDataset {
  /** https://applications.kbv.de/S_BAR_ZUSATZBEZEICHNUNG_V1.03.xhtml */
  KbvDatasetAdditionalQualifications = 'KBV_DATASET_ADDITIONAL_QUALIFICATIONS',
  /** https://applications.kbv.de/S_NVV_RV_ZERTIFIKAT_V1.08.xhtml */
  KbvDatasetAnalyteCode = 'KBV_DATASET_ANALYTE_CODE',
  /** https://applications.kbv.de/S_KBV_ABRECHNUNGSGEBIET_V1.02.xhtml */
  KbvDatasetBillingSubjectCode = 'KBV_DATASET_BILLING_SUBJECT_CODE',
  /** https://applications.kbv.de/S_KTS_KTABRECHNUNGSBEREICH_V1.00.xhtml */
  KbvDatasetCostUnitBillingFieldCode = 'KBV_DATASET_COST_UNIT_BILLING_FIELD_CODE',
  /** https://applications.kbv.de/S_KBV_DMP_V1.05.xhtml */
  KbvDatasetDmpDesignation = 'KBV_DATASET_DMP_DESIGNATION',
  /** https://applications.kbv.de/S_EBM_ARZTGRUPPE_V1.02.xhtml */
  KbvDatasetEbmDoctorGroup = 'KBV_DATASET_EBM_DOCTOR_GROUP',
  /** https://applications.kbv.de/S_KBV_PERSONENKREIS_V1.00.xhtml */
  KbvDatasetExaminationCategory = 'KBV_DATASET_EXAMINATION_CATEGORY',
  KbvDatasetForm_39GroupField = 'KBV_DATASET_FORM_39_GROUP_FIELD',
  /** https://applications.kbv.de/S_KBV_VERSICHERTENSTATUS_V1.02.xhtml */
  KbvDatasetInsuredPersonType = 'KBV_DATASET_INSURED_PERSON_TYPE',
  KbvDatasetNone = 'KBV_DATASET_NONE',
  KbvDatasetProfessionalGroups = 'KBV_DATASET_PROFESSIONAL_GROUPS',
  /** https://applications.kbv.de/S_KBV_VERSORGUNGSBEREICH_V1.01.xhtml */
  KbvDatasetServiceField = 'KBV_DATASET_SERVICE_FIELD',
  /** https://applications.kbv.de/S_BAR2_WBO_V1.18.xhtml */
  KbvDatasetSpecializations = 'KBV_DATASET_SPECIALIZATIONS',
  /** https://applications.kbv.de/S_KBV_PERSONENGRUPPE_V1.02.xhtml */
  KbvDatasetSpecialPersonGroup = 'KBV_DATASET_SPECIAL_PERSON_GROUP',
  /** only two values: 1 - vollständig, 2 - eingeschränkt */
  KbvDatasetSuspendedEntitlementType = 'KBV_DATASET_SUSPENDED_ENTITLEMENT_TYPE',
  /** https://applications.kbv.de/S_ITA_WOP_V1.00.xhtml */
  KbvDatasetWopDesignation = 'KBV_DATASET_WOP_DESIGNATION'
}

export type Knowledge_KbvFormFieldGroup36Msg = {
  __typename?: 'knowledge_KbvFormFieldGroup36Msg';
  code?: Maybe<Scalars['String']>;
  generalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Knowledge_KnowledgeDataset {
  DatasetAbdominalShape = 'DATASET_ABDOMINAL_SHAPE',
  DatasetAbdominalWallPalpation = 'DATASET_ABDOMINAL_WALL_PALPATION',
  DatasetAbnormalitiesAesthesia = 'DATASET_ABNORMALITIES_AESTHESIA',
  DatasetAbnormalitiesAlgesia = 'DATASET_ABNORMALITIES_ALGESIA',
  DatasetAbnormalitiesDiadochokinesis = 'DATASET_ABNORMALITIES_DIADOCHOKINESIS',
  DatasetAbnormalitiesFingerNose = 'DATASET_ABNORMALITIES_FINGER_NOSE',
  DatasetAbnormalitiesFingerPerimetricVisualFieldTest = 'DATASET_ABNORMALITIES_FINGER_PERIMETRIC_VISUAL_FIELD_TEST',
  DatasetAbnormalitiesFingerToFingerTest = 'DATASET_ABNORMALITIES_FINGER_TO_FINGER_TEST',
  DatasetAbnormalitiesHeadImpulseTest = 'DATASET_ABNORMALITIES_HEAD_IMPULSE_TEST',
  DatasetAbnormalitiesHearing = 'DATASET_ABNORMALITIES_HEARING',
  DatasetAbnormalitiesHeelKneeTest = 'DATASET_ABNORMALITIES_HEEL_KNEE_TEST',
  DatasetAbnormalitiesMuscleTone = 'DATASET_ABNORMALITIES_MUSCLE_TONE',
  DatasetAbnormalitiesMusculatureMuscleTrophics = 'DATASET_ABNORMALITIES_MUSCULATURE_MUSCLE_TROPHICS',
  DatasetAbnormalitiesNasalCavity = 'DATASET_ABNORMALITIES_NASAL_CAVITY',
  DatasetAbnormalitiesOlfactorySense = 'DATASET_ABNORMALITIES_OLFACTORY_SENSE',
  DatasetAbnormalitiesPallaesthesia = 'DATASET_ABNORMALITIES_PALLAESTHESIA',
  DatasetAbnormalitiesPlanningExecution = 'DATASET_ABNORMALITIES_PLANNING_EXECUTION',
  DatasetAbnormalitiesSpeaking = 'DATASET_ABNORMALITIES_SPEAKING',
  DatasetAbnormalitiesSpeechFlow = 'DATASET_ABNORMALITIES_SPEECH_FLOW',
  DatasetAbnormalitiesTastePerception = 'DATASET_ABNORMALITIES_TASTE_PERCEPTION',
  DatasetAbnormalitiesThermaesthesia = 'DATASET_ABNORMALITIES_THERMAESTHESIA',
  DatasetAbnormalitiesTongueMovement = 'DATASET_ABNORMALITIES_TONGUE_MOVEMENT',
  DatasetAbnormalitiesWalkingAndTurning = 'DATASET_ABNORMALITIES_WALKING_AND_TURNING',
  DatasetAdvancedWoundTherapy = 'DATASET_ADVANCED_WOUND_THERAPY',
  DatasetAirwayAid = 'DATASET_AIRWAY_AID',
  DatasetAirwayManagement = 'DATASET_AIRWAY_MANAGEMENT',
  DatasetAirwayManagementInfo = 'DATASET_AIRWAY_MANAGEMENT_INFO',
  /** DATASET_MEDICATION = 72; */
  DatasetAllergicSymptoms = 'DATASET_ALLERGIC_SYMPTOMS',
  DatasetAllergies = 'DATASET_ALLERGIES',
  DatasetAmnesiaTypes = 'DATASET_AMNESIA_TYPES',
  DatasetAnaesthesiaComplications = 'DATASET_ANAESTHESIA_COMPLICATIONS',
  DatasetAnaesthesiaRiskFactors = 'DATASET_ANAESTHESIA_RISK_FACTORS',
  DatasetAnalInspection = 'DATASET_ANAL_INSPECTION',
  DatasetAnesthesiaDevice = 'DATASET_ANESTHESIA_DEVICE',
  DatasetAnesthesiaMonitoringEquipment = 'DATASET_ANESTHESIA_MONITORING_EQUIPMENT',
  DatasetAnesthesiaSystem = 'DATASET_ANESTHESIA_SYSTEM',
  DatasetAnesthesiologyMonitoringSeverity = 'DATASET_ANESTHESIOLOGY_MONITORING_SEVERITY',
  DatasetAnesthesiologyMonitoringType = 'DATASET_ANESTHESIOLOGY_MONITORING_TYPE',
  DatasetAnestheticProcedure = 'DATASET_ANESTHETIC_PROCEDURE',
  DatasetAnteriorRhinoscopy = 'DATASET_ANTERIOR_RHINOSCOPY',
  DatasetApexBeatDescription = 'DATASET_APEX_BEAT_DESCRIPTION',
  DatasetAphasiaTypes = 'DATASET_APHASIA_TYPES',
  DatasetArmExtensionTest = 'DATASET_ARM_EXTENSION_TEST',
  DatasetArterialLineType = 'DATASET_ARTERIAL_LINE_TYPE',
  DatasetAuditoryHallucinations = 'DATASET_AUDITORY_HALLUCINATIONS',
  DatasetAwmfStrumaGrading = 'DATASET_AWMF_STRUMA_GRADING',
  DatasetBedBlockingReason = 'DATASET_BED_BLOCKING_REASON',
  DatasetBloodProduct = 'DATASET_BLOOD_PRODUCT',
  DatasetBloodProductLocation = 'DATASET_BLOOD_PRODUCT_LOCATION',
  DatasetBloodTransfusion = 'DATASET_BLOOD_TRANSFUSION',
  /** DATASET_ALPHA_ID = 1; */
  DatasetBodyParts = 'DATASET_BODY_PARTS',
  DatasetBreathingMovability = 'DATASET_BREATHING_MOVABILITY',
  DatasetBreathingSounds = 'DATASET_BREATHING_SOUNDS',
  DatasetBristolStoolChart = 'DATASET_BRISTOL_STOOL_CHART',
  DatasetBronchophony = 'DATASET_BRONCHOPHONY',
  /** DATASET_CLINICAL_STAGES = 56; */
  DatasetCardiacArrhythmiaBegin = 'DATASET_CARDIAC_ARRHYTHMIA_BEGIN',
  DatasetCardiacArrhythmiaDescription = 'DATASET_CARDIAC_ARRHYTHMIA_DESCRIPTION',
  DatasetCardiovascularSupportSystemsType = 'DATASET_CARDIOVASCULAR_SUPPORT_SYSTEMS_TYPE',
  DatasetCareInstitutionTypes = 'DATASET_CARE_INSTITUTION_TYPES',
  DatasetCareProviderTypes = 'DATASET_CARE_PROVIDER_TYPES',
  DatasetCeapClassification = 'DATASET_CEAP_CLASSIFICATION',
  DatasetCerebrospinalFluid = 'DATASET_CEREBROSPINAL_FLUID',
  DatasetClassificationSystems = 'DATASET_CLASSIFICATION_SYSTEMS',
  DatasetContactPartyType = 'DATASET_CONTACT_PARTY_TYPE',
  DatasetContaminationGrade = 'DATASET_CONTAMINATION_GRADE',
  DatasetContraceptives = 'DATASET_CONTRACEPTIVES',
  DatasetCoughQuality = 'DATASET_COUGH_QUALITY',
  DatasetCoughSound = 'DATASET_COUGH_SOUND',
  DatasetCoughTrigger = 'DATASET_COUGH_TRIGGER',
  DatasetCountries = 'DATASET_COUNTRIES',
  DatasetCyanosis = 'DATASET_CYANOSIS',
  DatasetCycleDisorders = 'DATASET_CYCLE_DISORDERS',
  DatasetDaleSav = 'DATASET_DALE_SAV',
  DatasetDeformitiesLower = 'DATASET_DEFORMITIES_LOWER',
  DatasetDeformitiesSpine = 'DATASET_DEFORMITIES_SPINE',
  DatasetDeformitiesUpper = 'DATASET_DEFORMITIES_UPPER',
  DatasetDentureLocation = 'DATASET_DENTURE_LOCATION',
  DatasetDentureType = 'DATASET_DENTURE_TYPE',
  DatasetDescriptionExcretoryDuctSalivaryGlands = 'DATASET_DESCRIPTION_EXCRETORY_DUCT_SALIVARY_GLANDS',
  DatasetDescriptionSingleEyeFingerPerimetricVisualFieldTest = 'DATASET_DESCRIPTION_SINGLE_EYE_FINGER_PERIMETRIC_VISUAL_FIELD_TEST',
  DatasetDesiredAppointment = 'DATASET_DESIRED_APPOINTMENT',
  DatasetDguvVav = 'DATASET_DGUV_VAV',
  DatasetDigitalRectalExamMucousMembrane = 'DATASET_DIGITAL_RECTAL_EXAM_MUCOUS_MEMBRANE',
  DatasetDischargeContacts = 'DATASET_DISCHARGE_CONTACTS',
  DatasetDischargeCounselingOn = 'DATASET_DISCHARGE_COUNSELING_ON',
  DatasetDrgTypeOfVentilation = 'DATASET_DRG_TYPE_OF_VENTILATION',
  DatasetDrugs = 'DATASET_DRUGS',
  DatasetDyspneaQuality = 'DATASET_DYSPNEA_QUALITY',
  DatasetEarCanalAbnormalities = 'DATASET_EAR_CANAL_ABNORMALITIES',
  DatasetEatingDisorderBehaviors = 'DATASET_EATING_DISORDER_BEHAVIORS',
  DatasetEcgRhythm = 'DATASET_ECG_RHYTHM',
  DatasetEdemaTime = 'DATASET_EDEMA_TIME',
  DatasetEducationalLevel = 'DATASET_EDUCATIONAL_LEVEL',
  DatasetElectrodeType = 'DATASET_ELECTRODE_TYPE',
  DatasetExcretoryGlandsDescription = 'DATASET_EXCRETORY_GLANDS_DESCRIPTION',
  DatasetExsudatQuality = 'DATASET_EXSUDAT_QUALITY',
  DatasetExternalDrain = 'DATASET_EXTERNAL_DRAIN',
  DatasetExternalDrains = 'DATASET_EXTERNAL_DRAINS',
  DatasetExternalEarAbnormalities = 'DATASET_EXTERNAL_EAR_ABNORMALITIES',
  DatasetExtrapyramidalMovementDisorders = 'DATASET_EXTRAPYRAMIDAL_MOVEMENT_DISORDERS',
  DatasetFallLocation = 'DATASET_FALL_LOCATION',
  DatasetFixationType = 'DATASET_FIXATION_TYPE',
  DatasetFlags = 'DATASET_FLAGS',
  DatasetFontaineClassification = 'DATASET_FONTAINE_CLASSIFICATION',
  DatasetForceTest = 'DATASET_FORCE_TEST',
  DatasetGermsRequiringIsolation = 'DATASET_GERMS_REQUIRING_ISOLATION',
  DatasetHeadLymphNodeLocalisation = 'DATASET_HEAD_LYMPH_NODE_LOCALISATION',
  DatasetHeartMurmur = 'DATASET_HEART_MURMUR',
  DatasetHeartMurmurConduction = 'DATASET_HEART_MURMUR_CONDUCTION',
  DatasetHeartMurmurTimepoint = 'DATASET_HEART_MURMUR_TIMEPOINT',
  DatasetHeartMurmurTimeCourse = 'DATASET_HEART_MURMUR_TIME_COURSE',
  DatasetHeartMurmurTonality = 'DATASET_HEART_MURMUR_TONALITY',
  DatasetHeartSoundsFeatures = 'DATASET_HEART_SOUNDS_FEATURES',
  DatasetHerniaType = 'DATASET_HERNIA_TYPE',
  DatasetHypopharynxDescription = 'DATASET_HYPOPHARYNX_DESCRIPTION',
  DatasetHypopharynxLocalization = 'DATASET_HYPOPHARYNX_LOCALIZATION',
  DatasetImmobilizationType = 'DATASET_IMMOBILIZATION_TYPE',
  DatasetInflowFluids = 'DATASET_INFLOW_FLUIDS',
  DatasetInfusionWarmingType = 'DATASET_INFUSION_WARMING_TYPE',
  DatasetInsertionCvcZvk = 'DATASET_INSERTION_CVC_ZVK',
  DatasetIntakeType = 'DATASET_INTAKE_TYPE',
  DatasetInternalBodyMapping = 'DATASET_INTERNAL_BODY_MAPPING',
  DatasetJobs = 'DATASET_JOBS',
  DatasetLanguages = 'DATASET_LANGUAGES',
  DatasetLarynxDescription = 'DATASET_LARYNX_DESCRIPTION',
  DatasetLarynxPalpationDescription = 'DATASET_LARYNX_PALPATION_DESCRIPTION',
  DatasetLegExtensionTest = 'DATASET_LEG_EXTENSION_TEST',
  DatasetLightConditions = 'DATASET_LIGHT_CONDITIONS',
  DatasetLipsDescription = 'DATASET_LIPS_DESCRIPTION',
  DatasetLiverSkinSigns = 'DATASET_LIVER_SKIN_SIGNS',
  DatasetLocalisationLung = 'DATASET_LOCALISATION_LUNG',
  DatasetLocalizationArterial = 'DATASET_LOCALIZATION_ARTERIAL',
  DatasetLocalizationEarCanal = 'DATASET_LOCALIZATION_EAR_CANAL',
  DatasetLocalizationExcretoryDuctSalivaryGlands = 'DATASET_LOCALIZATION_EXCRETORY_DUCT_SALIVARY_GLANDS',
  DatasetLocalizationExcretoryGlands = 'DATASET_LOCALIZATION_EXCRETORY_GLANDS',
  DatasetLocalizationExternalEar = 'DATASET_LOCALIZATION_EXTERNAL_EAR',
  /** DATASET_LOCALIZATION_THORAX_DRAINAGE = 212; */
  DatasetLocalizationGastricTubes = 'DATASET_LOCALIZATION_GASTRIC_TUBES',
  DatasetLocalizationLarynx = 'DATASET_LOCALIZATION_LARYNX',
  DatasetLocalizationLarynxPalpation = 'DATASET_LOCALIZATION_LARYNX_PALPATION',
  DatasetLocalizationLips = 'DATASET_LOCALIZATION_LIPS',
  DatasetLocalizationMeasurementOfTemperature = 'DATASET_LOCALIZATION_MEASUREMENT_OF_TEMPERATURE',
  DatasetLocalizationMouthMucosa = 'DATASET_LOCALIZATION_MOUTH_MUCOSA',
  DatasetLocalizationPharyngealRingAndTonsils = 'DATASET_LOCALIZATION_PHARYNGEAL_RING_AND_TONSILS',
  DatasetLocalizationThyroidGland = 'DATASET_LOCALIZATION_THYROID_GLAND',
  DatasetLocalizationTongue = 'DATASET_LOCALIZATION_TONGUE',
  DatasetLocalizationTympanicMembrane = 'DATASET_LOCALIZATION_TYMPANIC_MEMBRANE',
  DatasetLocalizationVacuumTherapySystem = 'DATASET_LOCALIZATION_VACUUM_THERAPY_SYSTEM',
  DatasetLocalizationWoundDrainage = 'DATASET_LOCALIZATION_WOUND_DRAINAGE',
  DatasetLocalAnesthesiaType = 'DATASET_LOCAL_ANESTHESIA_TYPE',
  DatasetLocationThoraxDrainage = 'DATASET_LOCATION_THORAX_DRAINAGE',
  DatasetLungRales = 'DATASET_LUNG_RALES',
  DatasetLungSounds = 'DATASET_LUNG_SOUNDS',
  DatasetLymphNodeDescription = 'DATASET_LYMPH_NODE_DESCRIPTION',
  DatasetMaskVentilation = 'DATASET_MASK_VENTILATION',
  DatasetMastoidDescription = 'DATASET_MASTOID_DESCRIPTION',
  DatasetMaterialCategory = 'DATASET_MATERIAL_CATEGORY',
  DatasetMaterialGastricTubes = 'DATASET_MATERIAL_GASTRIC_TUBES',
  DatasetMaterialPlanCategory = 'DATASET_MATERIAL_PLAN_CATEGORY',
  DatasetMaterialUrinaryCatheters = 'DATASET_MATERIAL_URINARY_CATHETERS',
  DatasetMedicalAid = 'DATASET_MEDICAL_AID',
  DatasetMedicalSpecialties = 'DATASET_MEDICAL_SPECIALTIES',
  DatasetMedicationParametricDosageReference = 'DATASET_MEDICATION_PARAMETRIC_DOSAGE_REFERENCE',
  DatasetMicturitionProblems = 'DATASET_MICTURITION_PROBLEMS',
  DatasetMiddleRhinoscopy = 'DATASET_MIDDLE_RHINOSCOPY',
  DatasetMoodPsyche = 'DATASET_MOOD_PSYCHE',
  DatasetMouthMucosaDescription = 'DATASET_MOUTH_MUCOSA_DESCRIPTION',
  DatasetMouthOpeningDescription = 'DATASET_MOUTH_OPENING_DESCRIPTION',
  DatasetMovementGeneralExtremity = 'DATASET_MOVEMENT_GENERAL_EXTREMITY',
  DatasetMovementLowerExtremity = 'DATASET_MOVEMENT_LOWER_EXTREMITY',
  DatasetMovementPelvis = 'DATASET_MOVEMENT_PELVIS',
  DatasetMovementSpine = 'DATASET_MOVEMENT_SPINE',
  DatasetMovementTemporomandibular = 'DATASET_MOVEMENT_TEMPOROMANDIBULAR',
  DatasetMovementUpperExtremity = 'DATASET_MOVEMENT_UPPER_EXTREMITY',
  DatasetNailChanges = 'DATASET_NAIL_CHANGES',
  DatasetNarcotrendIndex = 'DATASET_NARCOTREND_INDEX',
  DatasetNarcotrendStage = 'DATASET_NARCOTREND_STAGE',
  DatasetNationalities = 'DATASET_NATIONALITIES',
  DatasetNeglectTypes = 'DATASET_NEGLECT_TYPES',
  DatasetNone = 'DATASET_NONE',
  DatasetNutrition = 'DATASET_NUTRITION',
  DatasetNystagmus = 'DATASET_NYSTAGMUS',
  DatasetNystagmusDescription = 'DATASET_NYSTAGMUS_DESCRIPTION',
  DatasetObstacle = 'DATASET_OBSTACLE',
  DatasetOperatingRoomCleaning = 'DATASET_OPERATING_ROOM_CLEANING',
  DatasetOperatingTable = 'DATASET_OPERATING_TABLE',
  DatasetOrganDonation = 'DATASET_ORGAN_DONATION',
  DatasetOropharynxDescription = 'DATASET_OROPHARYNX_DESCRIPTION',
  DatasetOropharynxLocalization = 'DATASET_OROPHARYNX_LOCALIZATION',
  DatasetOstomySystemsType = 'DATASET_OSTOMY_SYSTEMS_TYPE',
  DatasetOtherPractitioners = 'DATASET_OTHER_PRACTITIONERS',
  DatasetOutflowFluids = 'DATASET_OUTFLOW_FLUIDS',
  DatasetOxygenApplicationForm = 'DATASET_OXYGEN_APPLICATION_FORM',
  DatasetPacemakerModes = 'DATASET_PACEMAKER_MODES',
  DatasetPacemakerTypes = 'DATASET_PACEMAKER_TYPES',
  DatasetPain = 'DATASET_PAIN',
  DatasetPainOnset = 'DATASET_PAIN_ONSET',
  DatasetPercussionLung = 'DATASET_PERCUSSION_LUNG',
  DatasetPercussionSoundAbdomen = 'DATASET_PERCUSSION_SOUND_ABDOMEN',
  DatasetPercussionSpine = 'DATASET_PERCUSSION_SPINE',
  DatasetPeripheralAnesthesiaTechnique = 'DATASET_PERIPHERAL_ANESTHESIA_TECHNIQUE',
  DatasetPeripheralIntravenousLine = 'DATASET_PERIPHERAL_INTRAVENOUS_LINE',
  DatasetPeripheralIvSize = 'DATASET_PERIPHERAL_IV_SIZE',
  DatasetPharyngealRingAndTonsilsDescription = 'DATASET_PHARYNGEAL_RING_AND_TONSILS_DESCRIPTION',
  DatasetPivSize = 'DATASET_PIV_SIZE',
  /** As these are not persisted, no problem in having gaps */
  DatasetPortalFacilityTag = 'DATASET_PORTAL_FACILITY_TAG',
  DatasetPortCatheterLocalization = 'DATASET_PORT_CATHETER_LOCALIZATION',
  DatasetPositioning = 'DATASET_POSITIONING',
  DatasetPositioningAid = 'DATASET_POSITIONING_AID',
  DatasetPositionOfTrachea = 'DATASET_POSITION_OF_TRACHEA',
  DatasetPosteriorRhinoscopy = 'DATASET_POSTERIOR_RHINOSCOPY',
  DatasetPostoperativeCare = 'DATASET_POSTOPERATIVE_CARE',
  DatasetPreoxygenation = 'DATASET_PREOXYGENATION',
  DatasetPrimaryReasonForTravel = 'DATASET_PRIMARY_REASON_FOR_TRAVEL',
  DatasetProstateSize = 'DATASET_PROSTATE_SIZE',
  DatasetProstateTexture = 'DATASET_PROSTATE_TEXTURE',
  DatasetPulseQuality = 'DATASET_PULSE_QUALITY',
  DatasetRadiologyDosageUnit = 'DATASET_RADIOLOGY_DOSAGE_UNIT',
  DatasetRadiologyType = 'DATASET_RADIOLOGY_TYPE',
  DatasetReasonForAdmission = 'DATASET_REASON_FOR_ADMISSION',
  DatasetReasonForAlteringCutToCloseTime = 'DATASET_REASON_FOR_ALTERING_CUT_TO_CLOSE_TIME',
  DatasetReasonForAppointmentRequestRejection = 'DATASET_REASON_FOR_APPOINTMENT_REQUEST_REJECTION',
  DatasetReasonForAppointmentRequestRejectionExternal = 'DATASET_REASON_FOR_APPOINTMENT_REQUEST_REJECTION_EXTERNAL',
  DatasetReasonForAppointmentTaskCancellation = 'DATASET_REASON_FOR_APPOINTMENT_TASK_CANCELLATION',
  DatasetReasonForAppointmentTaskCancellationExternal = 'DATASET_REASON_FOR_APPOINTMENT_TASK_CANCELLATION_EXTERNAL',
  DatasetReasonForAspirationRisk = 'DATASET_REASON_FOR_ASPIRATION_RISK',
  DatasetReasonForCareInterventionTaskCancellation = 'DATASET_REASON_FOR_CARE_INTERVENTION_TASK_CANCELLATION',
  DatasetReasonForConsentCancelling = 'DATASET_REASON_FOR_CONSENT_CANCELLING',
  DatasetReasonForExceptionalScheduling = 'DATASET_REASON_FOR_EXCEPTIONAL_SCHEDULING',
  DatasetReasonForFixation = 'DATASET_REASON_FOR_FIXATION',
  DatasetReasonForHoliday = 'DATASET_REASON_FOR_HOLIDAY',
  DatasetReasonForIsolation = 'DATASET_REASON_FOR_ISOLATION',
  DatasetReasonForMeasurementChange = 'DATASET_REASON_FOR_MEASUREMENT_CHANGE',
  DatasetReasonForMedicationAdministrationCancellation = 'DATASET_REASON_FOR_MEDICATION_ADMINISTRATION_CANCELLATION',
  DatasetReasonForOperatingRoomBlocking = 'DATASET_REASON_FOR_OPERATING_ROOM_BLOCKING',
  DatasetReasonForPatientAppointmentCancellation = 'DATASET_REASON_FOR_PATIENT_APPOINTMENT_CANCELLATION',
  DatasetReasonForPatientAppointmentRebooking = 'DATASET_REASON_FOR_PATIENT_APPOINTMENT_REBOOKING',
  DatasetReasonForPresentation = 'DATASET_REASON_FOR_PRESENTATION',
  DatasetReasonForStaffAppointmentCancellation = 'DATASET_REASON_FOR_STAFF_APPOINTMENT_CANCELLATION',
  DatasetReasonForStaffAppointmentCancellationExternal = 'DATASET_REASON_FOR_STAFF_APPOINTMENT_CANCELLATION_EXTERNAL',
  DatasetReasonForStaffAppointmentRebooking = 'DATASET_REASON_FOR_STAFF_APPOINTMENT_REBOOKING',
  DatasetReasonForSurgeryCancellation = 'DATASET_REASON_FOR_SURGERY_CANCELLATION',
  DatasetReasonForSurgeryKeyFigure = 'DATASET_REASON_FOR_SURGERY_KEY_FIGURE',
  DatasetReasonForSurgeryRescheduling = 'DATASET_REASON_FOR_SURGERY_RESCHEDULING',
  DatasetReasonForSurgerySlotCancellation = 'DATASET_REASON_FOR_SURGERY_SLOT_CANCELLATION',
  DatasetReasonForTravel = 'DATASET_REASON_FOR_TRAVEL',
  DatasetReasonForVisit = 'DATASET_REASON_FOR_VISIT',
  DatasetRegionalAnesthesiaType = 'DATASET_REGIONAL_ANESTHESIA_TYPE',
  DatasetRelatives = 'DATASET_RELATIVES',
  DatasetReligiousAffiliation = 'DATASET_RELIGIOUS_AFFILIATION',
  DatasetRenalFistulaCatheterLocalization = 'DATASET_RENAL_FISTULA_CATHETER_LOCALIZATION',
  DatasetRequestEmployment = 'DATASET_REQUEST_EMPLOYMENT',
  DatasetRequestOccupations = 'DATASET_REQUEST_OCCUPATIONS',
  DatasetRequestPatientTransport = 'DATASET_REQUEST_PATIENT_TRANSPORT',
  DatasetRespiratorySoundBronchi = 'DATASET_RESPIRATORY_SOUND_BRONCHI',
  DatasetRespiratorySoundLungs = 'DATASET_RESPIRATORY_SOUND_LUNGS',
  DatasetRinsingFluid = 'DATASET_RINSING_FLUID',
  DatasetRutherfordClassification = 'DATASET_RUTHERFORD_CLASSIFICATION',
  DatasetSexualPractices = 'DATASET_SEXUAL_PRACTICES',
  DatasetSignsOfInfection = 'DATASET_SIGNS_OF_INFECTION',
  DatasetSkinChange = 'DATASET_SKIN_CHANGE',
  DatasetSkinColor = 'DATASET_SKIN_COLOR',
  DatasetSmellTidalAir = 'DATASET_SMELL_TIDAL_AIR',
  DatasetSpecialBreathingPatterns = 'DATASET_SPECIAL_BREATHING_PATTERNS',
  DatasetSpineLevel = 'DATASET_SPINE_LEVEL',
  DatasetSports = 'DATASET_SPORTS',
  DatasetStdProtection = 'DATASET_STD_PROTECTION',
  DatasetStool = 'DATASET_STOOL',
  DatasetSurgeryDevice = 'DATASET_SURGERY_DEVICE',
  DatasetSurgeryRequirement = 'DATASET_SURGERY_REQUIREMENT',
  DatasetSurgerySpecimen = 'DATASET_SURGERY_SPECIMEN',
  DatasetSurgeryStaffRole = 'DATASET_SURGERY_STAFF_ROLE',
  DatasetSurgicalTechnique = 'DATASET_SURGICAL_TECHNIQUE',
  DatasetSutureThread = 'DATASET_SUTURE_THREAD',
  DatasetSutureThreadSize = 'DATASET_SUTURE_THREAD_SIZE',
  DatasetSymptoms = 'DATASET_SYMPTOMS',
  DatasetTascClassification = 'DATASET_TASC_CLASSIFICATION',
  DatasetThoraxForm = 'DATASET_THORAX_FORM',
  DatasetThyroidGlandAuscultationDescription = 'DATASET_THYROID_GLAND_AUSCULTATION_DESCRIPTION',
  DatasetThyroidGlandInspectionDescription = 'DATASET_THYROID_GLAND_INSPECTION_DESCRIPTION',
  DatasetThyroidGlandPalpationDescription = 'DATASET_THYROID_GLAND_PALPATION_DESCRIPTION',
  DatasetTimingBloodSugar = 'DATASET_TIMING_BLOOD_SUGAR',
  DatasetTobaccoUse = 'DATASET_TOBACCO_USE',
  DatasetTongueDescription = 'DATASET_TONGUE_DESCRIPTION',
  DatasetToothStatus = 'DATASET_TOOTH_STATUS',
  DatasetTracheostomyMethod = 'DATASET_TRACHEOSTOMY_METHOD',
  DatasetTracheostomyTubeSize = 'DATASET_TRACHEOSTOMY_TUBE_SIZE',
  DatasetTracheostomyTubeType = 'DATASET_TRACHEOSTOMY_TUBE_TYPE',
  DatasetTransfusionComplications = 'DATASET_TRANSFUSION_COMPLICATIONS',
  DatasetTransportation = 'DATASET_TRANSPORTATION',
  DatasetTravelInformationSource = 'DATASET_TRAVEL_INFORMATION_SOURCE',
  DatasetTubeType = 'DATASET_TUBE_TYPE',
  DatasetTympanicMembraneAbnormalities = 'DATASET_TYMPANIC_MEMBRANE_ABNORMALITIES',
  DatasetTypeExternalDrains = 'DATASET_TYPE_EXTERNAL_DRAINS',
  DatasetTypeGastricTubes = 'DATASET_TYPE_GASTRIC_TUBES',
  DatasetTypeOfFall = 'DATASET_TYPE_OF_FALL',
  DatasetTypeThoraxDrainage = 'DATASET_TYPE_THORAX_DRAINAGE',
  DatasetTypeUrinaryCatheters = 'DATASET_TYPE_URINARY_CATHETERS',
  DatasetUptakeRoute = 'DATASET_UPTAKE_ROUTE',
  DatasetUrinaryCatheters = 'DATASET_URINARY_CATHETERS',
  DatasetUrinaryIncontinence = 'DATASET_URINARY_INCONTINENCE',
  DatasetUrineColors = 'DATASET_URINE_COLORS',
  DatasetUrineTextures = 'DATASET_URINE_TEXTURES',
  DatasetVaccinations = 'DATASET_VACCINATIONS',
  DatasetVaccinationRelevantDiseases = 'DATASET_VACCINATION_RELEVANT_DISEASES',
  DatasetValuables = 'DATASET_VALUABLES',
  DatasetVentilationMode = 'DATASET_VENTILATION_MODE',
  DatasetVentilationType = 'DATASET_VENTILATION_TYPE',
  DatasetVertigoDirection = 'DATASET_VERTIGO_DIRECTION',
  DatasetVertigoPositionalDependence = 'DATASET_VERTIGO_POSITIONAL_DEPENDENCE',
  DatasetVertigoTrigger = 'DATASET_VERTIGO_TRIGGER',
  DatasetVocalFremitus = 'DATASET_VOCAL_FREMITUS',
  DatasetVolatileAnesthetics = 'DATASET_VOLATILE_ANESTHETICS',
  DatasetWagnerArmstrongClassification = 'DATASET_WAGNER_ARMSTRONG_CLASSIFICATION',
  DatasetWagnerArmstrongDiabInput = 'DATASET_WAGNER_ARMSTRONG_DIAB_INPUT',
  DatasetWarmingUnitType = 'DATASET_WARMING_UNIT_TYPE',
  DatasetWhisperedSpeechTest = 'DATASET_WHISPERED_SPEECH_TEST',
  DatasetWidmerClassification = 'DATASET_WIDMER_CLASSIFICATION',
  DatasetWoundAid = 'DATASET_WOUND_AID',
  DatasetWoundCareAndFixationMaterialsType = 'DATASET_WOUND_CARE_AND_FIXATION_MATERIALS_TYPE',
  DatasetWoundCleaning = 'DATASET_WOUND_CLEANING',
  DatasetWoundCompression = 'DATASET_WOUND_COMPRESSION',
  DatasetWoundCovering = 'DATASET_WOUND_COVERING',
  DatasetWoundDecubitusUlcer = 'DATASET_WOUND_DECUBITUS_ULCER',
  DatasetWoundDiagnostic = 'DATASET_WOUND_DIAGNOSTIC',
  DatasetWoundEdgeProtection = 'DATASET_WOUND_EDGE_PROTECTION',
  DatasetWoundGround = 'DATASET_WOUND_GROUND',
  DatasetWoundHealingFactor = 'DATASET_WOUND_HEALING_FACTOR',
  DatasetWoundMargin = 'DATASET_WOUND_MARGIN',
  DatasetWoundPad = 'DATASET_WOUND_PAD',
  DatasetWoundPlaceOfOrigin = 'DATASET_WOUND_PLACE_OF_ORIGIN',
  DatasetWoundRinsing = 'DATASET_WOUND_RINSING',
  DatasetWoundStage = 'DATASET_WOUND_STAGE',
  DatasetWoundSurroundings = 'DATASET_WOUND_SURROUNDINGS',
  DatasetWoundSutureTechnique = 'DATASET_WOUND_SUTURE_TECHNIQUE',
  DatasetWoundTamponade = 'DATASET_WOUND_TAMPONADE',
  DatasetWoundTherapy = 'DATASET_WOUND_THERAPY',
  DatasetWoundType = 'DATASET_WOUND_TYPE'
}

export type Knowledge_KnowledgeSearchRequest = {
  __typename?: 'knowledge_KnowledgeSearchRequest';
  dataset?: Maybe<Knowledge_KnowledgeDataset>;
  facets?: Maybe<Array<Maybe<Knowledge_Facet>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_KvdtDataElementMsg = {
  __typename?: 'knowledge_KvdtDataElementMsg';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export enum Knowledge_KvdtDataset {
  KvdtDatasetContactTypeCode = 'KVDT_DATASET_CONTACT_TYPE_CODE',
  KvdtDatasetCurativePreventiveEssAttendingCode = 'KVDT_DATASET_CURATIVE_PREVENTIVE_ESS_ATTENDING_CODE',
  KvdtDatasetGynecologyOrderType = 'KVDT_DATASET_GYNECOLOGY_ORDER_TYPE',
  KvdtDatasetNone = 'KVDT_DATASET_NONE'
}

export type Knowledge_LanguageList = {
  __typename?: 'knowledge_LanguageList';
  languages?: Maybe<Array<Maybe<Knowledge_LanguageMsg>>>;
};

export type Knowledge_LanguageMsg = {
  __typename?: 'knowledge_LanguageMsg';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalLanguageIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_ListBodyPartsRequest = {
  __typename?: 'knowledge_ListBodyPartsRequest';
  generalIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_ListSpecialistGroupDataRequest = {
  __typename?: 'knowledge_ListSpecialistGroupDataRequest';
  dataset?: Maybe<Knowledge_KbvDataset>;
  specialistGroupCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_ListSpecialistGroupDataResponse = {
  __typename?: 'knowledge_ListSpecialistGroupDataResponse';
  specialistGroupData?: Maybe<Array<Maybe<Knowledge_KbvDataElementMsg>>>;
};

export type Knowledge_MapGermanBillingCaseDetailCodesRequest = {
  __typename?: 'knowledge_MapGermanBillingCaseDetailCodesRequest';
  billingCaseDetails?: Maybe<Array<Maybe<Billing_German_BillingCaseDetailsMsg>>>;
};

export type Knowledge_MapGermanBillingCaseDetailCodesResponse = {
  __typename?: 'knowledge_MapGermanBillingCaseDetailCodesResponse';
  billingCaseDetailIdToCodes?: Maybe<Array<Maybe<Knowledge_MapGermanBillingCaseDetailCodesResponse_BillingCaseDetailIdToCodesEntry>>>;
};

export type Knowledge_MapGermanBillingCaseDetailCodesResponse_BillingCaseDetailIdToCodesEntry = {
  __typename?: 'knowledge_MapGermanBillingCaseDetailCodesResponse_BillingCaseDetailIdToCodesEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_German_BillingCaseDetailCodesMsg>;
};

export type Knowledge_MapGermanBillingCertificateCodesRequest = {
  __typename?: 'knowledge_MapGermanBillingCertificateCodesRequest';
  billingCertificates?: Maybe<Array<Maybe<Billing_German_BillingCertificateMsg>>>;
};

export type Knowledge_MapGermanBillingCertificateCodesResponse = {
  __typename?: 'knowledge_MapGermanBillingCertificateCodesResponse';
  billingCertificateIdToCodes?: Maybe<Array<Maybe<Knowledge_MapGermanBillingCertificateCodesResponse_BillingCertificateIdToCodesEntry>>>;
};

export type Knowledge_MapGermanBillingCertificateCodesResponse_BillingCertificateIdToCodesEntry = {
  __typename?: 'knowledge_MapGermanBillingCertificateCodesResponse_BillingCertificateIdToCodesEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_German_BillingCertificateCodesMsg>;
};

export type Knowledge_MapGermanCoverageInformationCodesRequest = {
  __typename?: 'knowledge_MapGermanCoverageInformationCodesRequest';
  germanCoverageInfos?: Maybe<Array<Maybe<Billing_German_GermanStatutoryCoverageInformationMsg>>>;
};

export type Knowledge_MapGermanCoverageInformationCodesResponse = {
  __typename?: 'knowledge_MapGermanCoverageInformationCodesResponse';
  coverageInfoIdToCodeDetails?: Maybe<Array<Maybe<Knowledge_MapGermanCoverageInformationCodesResponse_CoverageInfoIdToCodeDetailsEntry>>>;
};

export type Knowledge_MapGermanCoverageInformationCodesResponse_CoverageInfoIdToCodeDetailsEntry = {
  __typename?: 'knowledge_MapGermanCoverageInformationCodesResponse_CoverageInfoIdToCodeDetailsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Billing_German_GermanCoverageInformationCodeDetailsMsg>;
};

export type Knowledge_MapGermanLabBillingCodesRequest = {
  __typename?: 'knowledge_MapGermanLabBillingCodesRequest';
  analyteCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Knowledge_MapGermanLabBillingCodesResponse = {
  __typename?: 'knowledge_MapGermanLabBillingCodesResponse';
  results?: Maybe<Array<Maybe<Billing_German_RingTestCertificateDetailsMsg>>>;
};

export type Knowledge_MedicationDosageFormulaUnitResult = {
  __typename?: 'knowledge_MedicationDosageFormulaUnitResult';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalMedicationDosageFormulaUnitIdResult>>>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_MedicationDosageFormulaUnitResultList = {
  __typename?: 'knowledge_MedicationDosageFormulaUnitResultList';
  results?: Maybe<Array<Maybe<Knowledge_MedicationDosageFormulaUnitResult>>>;
};

export type Knowledge_MedicationDosageUnitResult = {
  __typename?: 'knowledge_MedicationDosageUnitResult';
  excludeForSingleIntake?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalMedicationDosageUnitIdResult>>>;
  name?: Maybe<Scalars['String']>;
};

export type Knowledge_MedicationDosageUnitResultList = {
  __typename?: 'knowledge_MedicationDosageUnitResultList';
  results?: Maybe<Array<Maybe<Knowledge_MedicationDosageUnitResult>>>;
};

export type Knowledge_MedicationFlowRateFormulaUnitResult = {
  __typename?: 'knowledge_MedicationFlowRateFormulaUnitResult';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalMedicationFlowRateFormulaUnitIdResult>>>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_MedicationFlowRateFormulaUnitResultList = {
  __typename?: 'knowledge_MedicationFlowRateFormulaUnitResultList';
  results?: Maybe<Array<Maybe<Knowledge_MedicationFlowRateFormulaUnitResult>>>;
};

export type Knowledge_MedicationFlowRateUnitResult = {
  __typename?: 'knowledge_MedicationFlowRateUnitResult';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalMedicationFlowRateUnitIdResult>>>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_MedicationFlowRateUnitResultList = {
  __typename?: 'knowledge_MedicationFlowRateUnitResultList';
  results?: Maybe<Array<Maybe<Knowledge_MedicationFlowRateUnitResult>>>;
};

export type Knowledge_NationalityMsg = {
  __typename?: 'knowledge_NationalityMsg';
  externalIds?: Maybe<Array<Maybe<Knowledge_ExternalNationalityIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  isInDguv?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_OpsResultList = {
  __typename?: 'knowledge_OpsResultList';
  results?: Maybe<Array<Maybe<Knowledge_OpsResultMsg>>>;
};

export type Knowledge_OpsResultMsg = {
  __typename?: 'knowledge_OpsResultMsg';
  /** German "Kategorie zum OPS-Code gem. Anlage 1 zum Vertrag nach § 115 b Abs. 1 SGB V" */
  kz115b?: Maybe<Knowledge_Kz115bType>;
  /** kz115b = "s" => KZ115bType.S */
  kz155bInfo?: Maybe<Scalars['String']>;
  opsCode?: Maybe<Scalars['String']>;
  opsVersion?: Maybe<Scalars['String']>;
  /** ob die Übermittelung eines Kennzeichens für die Seitenlokalisation notwendig ist. */
  requireLaterality?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  /** Kennzeichnung gem. Punkt 17 der Präambel des Anhangs 2 zum EBM */
  validMedicalJustification?: Maybe<Scalars['Boolean']>;
};

export type Knowledge_PractitionerQualificationList = {
  __typename?: 'knowledge_PractitionerQualificationList';
  qualifications?: Maybe<Array<Maybe<Knowledge_QualificationResult>>>;
};

export type Knowledge_QualificationResult = {
  __typename?: 'knowledge_QualificationResult';
  code?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchBFarmOpsCodesRequest = {
  __typename?: 'knowledge_SearchBFarmOpsCodesRequest';
  codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  facets?: Maybe<Array<Maybe<Knowledge_Facet>>>;
  isLeaf?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Knowledge_SearchLanguage>;
  level?: Maybe<Scalars['String']>;
  levelNumber?: Maybe<Scalars['Int']>;
  parentCode?: Maybe<Scalars['String']>;
  searchLimit?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type Knowledge_SearchBFarmOpsCodesResponse = {
  __typename?: 'knowledge_SearchBFarmOpsCodesResponse';
  results?: Maybe<Array<Maybe<Knowledge_BFarmOpsCodeResultMsg>>>;
};

export type Knowledge_SearchBillingCertificateTypesRequest = {
  __typename?: 'knowledge_SearchBillingCertificateTypesRequest';
  /** allows searching on subset of codes */
  facets?: Maybe<Array<Maybe<Knowledge_Facet>>>;
  searchTerm?: Maybe<Scalars['String']>;
  typeGroup?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchBillingCertificateTypesResponse = {
  __typename?: 'knowledge_SearchBillingCertificateTypesResponse';
  types?: Maybe<Array<Maybe<Knowledge_BillingCertificateTypeMsg>>>;
};

export type Knowledge_SearchClinicalStagesRequest = {
  __typename?: 'knowledge_SearchClinicalStagesRequest';
  searchTerm?: Maybe<Scalars['String']>;
  /** Value of the facet for classification step, obtained from ClassificationSystemResult */
  step?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchCountriesResponse = {
  __typename?: 'knowledge_SearchCountriesResponse';
  countries?: Maybe<Array<Maybe<Knowledge_CountryMsg>>>;
};

export type Knowledge_SearchDenominationsResponse = {
  __typename?: 'knowledge_SearchDenominationsResponse';
  denominations?: Maybe<Array<Maybe<Knowledge_DenominationMsg>>>;
};

export type Knowledge_SearchDiagnosisInfoRequest = {
  __typename?: 'knowledge_SearchDiagnosisInfoRequest';
  diagnosisDataset?: Maybe<Knowledge_DiagnosisDataset>;
  facets?: Maybe<Array<Maybe<Knowledge_Facet>>>;
  language?: Maybe<Knowledge_SearchLanguage>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchDkgDataRequest = {
  __typename?: 'knowledge_SearchDkgDataRequest';
  dataset?: Maybe<Knowledge_DkgDataset>;
  dischargeReasonDigitThreeFilters?: Maybe<Knowledge_DkgDischargeReasonDigitThreeFiltersMsg>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchDkgDataResponse = {
  __typename?: 'knowledge_SearchDkgDataResponse';
  results?: Maybe<Array<Maybe<Knowledge_DkgDataElementMsg>>>;
};

export type Knowledge_SearchKbvDataRequest = {
  __typename?: 'knowledge_SearchKbvDataRequest';
  dataset?: Maybe<Knowledge_KbvDataset>;
  /** allows searching on subset of codes */
  facets?: Maybe<Array<Maybe<Knowledge_Facet>>>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchKbvDataResponse = {
  __typename?: 'knowledge_SearchKbvDataResponse';
  results?: Maybe<Array<Maybe<Knowledge_KbvDataElementMsg>>>;
};

export type Knowledge_SearchKvdtDataRequest = {
  __typename?: 'knowledge_SearchKvdtDataRequest';
  dataset?: Maybe<Knowledge_KvdtDataset>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchKvdtDataResponse = {
  __typename?: 'knowledge_SearchKvdtDataResponse';
  results?: Maybe<Array<Maybe<Knowledge_KvdtDataElementMsg>>>;
};

export enum Knowledge_SearchLanguage {
  SearchLanguageDe = 'SEARCH_LANGUAGE_DE',
  SearchLanguageEn = 'SEARCH_LANGUAGE_EN',
  SearchLanguageNone = 'SEARCH_LANGUAGE_NONE'
}

export type Knowledge_SearchNationalitiesResponse = {
  __typename?: 'knowledge_SearchNationalitiesResponse';
  nationalities?: Maybe<Array<Maybe<Knowledge_NationalityMsg>>>;
};

export type Knowledge_SearchResult = {
  __typename?: 'knowledge_SearchResult';
  /** only filled for data sets that contain configurations, e.g., body parts, localisation */
  configurations?: Maybe<Array<Maybe<Scalars['String']>>>;
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchResultList = {
  __typename?: 'knowledge_SearchResultList';
  results?: Maybe<Array<Maybe<Knowledge_SearchResult>>>;
};

export type Knowledge_SearchResultOptional = {
  __typename?: 'knowledge_SearchResultOptional';
  searchResult?: Maybe<Knowledge_SearchResult>;
  searchResultFound?: Maybe<Scalars['Boolean']>;
};

/** generated_id|level|id|name|description|value_set_parent|code_system_parent|value_parent|abstract|deprecated|nullFlavor */
export type Knowledge_SearchTelematikCodesRequest = {
  __typename?: 'knowledge_SearchTelematikCodesRequest';
  searchTerm?: Maybe<Scalars['String']>;
  valueSet?: Maybe<Knowledge_TelematikValueSet>;
};

export type Knowledge_SearchTelematikCodesResponse = {
  __typename?: 'knowledge_SearchTelematikCodesResponse';
  telematikCodes?: Maybe<Array<Maybe<Telematik_TelematikCodeMsg>>>;
};

export type Knowledge_SearchWopsRequest = {
  __typename?: 'knowledge_SearchWopsRequest';
  searchTerm?: Maybe<Scalars['String']>;
};

export type Knowledge_SearchWopsResponse = {
  __typename?: 'knowledge_SearchWopsResponse';
  wops?: Maybe<Array<Maybe<Knowledge_WopMsg>>>;
};

export enum Knowledge_TelematikValueSet {
  TelematikValueSetAuthorRole = 'TELEMATIK_VALUE_SET_AUTHOR_ROLE',
  TelematikValueSetAuthorSpeciality = 'TELEMATIK_VALUE_SET_AUTHOR_SPECIALITY',
  TelematikValueSetClassCode = 'TELEMATIK_VALUE_SET_CLASS_CODE',
  TelematikValueSetCodeList = 'TELEMATIK_VALUE_SET_CODE_LIST',
  TelematikValueSetConfidentialityCode = 'TELEMATIK_VALUE_SET_CONFIDENTIALITY_CODE',
  TelematikValueSetContentTypeCode = 'TELEMATIK_VALUE_SET_CONTENT_TYPE_CODE',
  TelematikValueSetEventCodeList = 'TELEMATIK_VALUE_SET_EVENT_CODE_LIST',
  TelematikValueSetFormatCode = 'TELEMATIK_VALUE_SET_FORMAT_CODE',
  TelematikValueSetHealthcareFacilityTypeCode = 'TELEMATIK_VALUE_SET_HEALTHCARE_FACILITY_TYPE_CODE',
  TelematikValueSetNone = 'TELEMATIK_VALUE_SET_NONE',
  TelematikValueSetPracticeSettingCode = 'TELEMATIK_VALUE_SET_PRACTICE_SETTING_CODE',
  TelematikValueSetTypeCode = 'TELEMATIK_VALUE_SET_TYPE_CODE'
}

export enum Knowledge_TelematikValueSetLevel {
  TelematikValueSetLevelCodeSystem = 'TELEMATIK_VALUE_SET_LEVEL_CODE_SYSTEM',
  TelematikValueSetLevelEntry = 'TELEMATIK_VALUE_SET_LEVEL_ENTRY',
  TelematikValueSetLevelNone = 'TELEMATIK_VALUE_SET_LEVEL_NONE',
  TelematikValueSetLevelValueSet = 'TELEMATIK_VALUE_SET_LEVEL_VALUE_SET'
}

export type Knowledge_TubeTypeResult = {
  __typename?: 'knowledge_TubeTypeResult';
  generalId?: Maybe<Scalars['String']>;
  hasBronchialCuffPressure?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Knowledge_TubeTypeResultList = {
  __typename?: 'knowledge_TubeTypeResultList';
  results?: Maybe<Array<Maybe<Knowledge_TubeTypeResult>>>;
};

export type Knowledge_WopMsg = {
  __typename?: 'knowledge_WopMsg';
  name?: Maybe<Scalars['String']>;
  wopCode?: Maybe<Scalars['String']>;
};

/** Substance that is subject of a laboratory's analysis */
export type Lab_AnalyteMsg = {
  __typename?: 'lab_AnalyteMsg';
  id?: Maybe<Scalars['String']>;
  /** LOINC is the accepted standard for laboratory information */
  loincComponentCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Analytes can be classified in a tree-like structure; this references the parent. */
  parentId?: Maybe<Scalars['String']>;
  shortKey?: Maybe<Scalars['String']>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Lab_AnalyteType>;
};

export enum Lab_AnalyteResultType {
  AnalyteResultTypeBool = 'ANALYTE_RESULT_TYPE_BOOL',
  AnalyteResultTypeCategory = 'ANALYTE_RESULT_TYPE_CATEGORY',
  AnalyteResultTypeDecimal = 'ANALYTE_RESULT_TYPE_DECIMAL',
  AnalyteResultTypeDecimalRange = 'ANALYTE_RESULT_TYPE_DECIMAL_RANGE',
  AnalyteResultTypeInt = 'ANALYTE_RESULT_TYPE_INT',
  AnalyteResultTypeNone = 'ANALYTE_RESULT_TYPE_NONE',
  AnalyteResultTypeRatio = 'ANALYTE_RESULT_TYPE_RATIO',
  AnalyteResultTypeText = 'ANALYTE_RESULT_TYPE_TEXT'
}

export enum Lab_AnalyteType {
  /** User-generated analyte, will not be displayed in any search */
  AnalyteTypeCustom = 'ANALYTE_TYPE_CUSTOM',
  AnalyteTypeNone = 'ANALYTE_TYPE_NONE',
  /** Standard analyte, typically read in from a database */
  AnalyteTypeStandard = 'ANALYTE_TYPE_STANDARD'
}

export type Lab_AnalyteUnitMsg = {
  __typename?: 'lab_AnalyteUnitMsg';
  code?: Maybe<Scalars['String']>;
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Lab_AnalyteValueBasicInfoMsg = {
  __typename?: 'lab_AnalyteValueBasicInfoMsg';
  boolValue?: Maybe<Scalars['Boolean']>;
  categoryValue?: Maybe<Category_ResultCategoryMsg>;
  comment?: Maybe<Scalars['String']>;
  conspicuous?: Maybe<Scalars['Boolean']>;
  decimalRangeValue?: Maybe<DecimalRangeMsg>;
  decimalValue?: Maybe<DecimalMsg>;
  id?: Maybe<Scalars['String']>;
  intValue?: Maybe<Scalars['Int']>;
  interpretationCodes?: Maybe<Array<Maybe<Lab_AnalyteValueInterpretation>>>;
  ratioValue?: Maybe<RatioMsg>;
  status?: Maybe<Lab_AnalyteValueStatus>;
  textValue?: Maybe<Scalars['String']>;
  valueUpdatedAt?: Maybe<Timestamp>;
};

export type Lab_AnalyteValueCommentMsg = {
  __typename?: 'lab_AnalyteValueCommentMsg';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Lab_AnalyteValueCommentType>;
};

export enum Lab_AnalyteValueCommentType {
  /** AI */
  AnalyteValueCommentTypeAncillaryInstructions = 'ANALYTE_VALUE_COMMENT_TYPE_ANCILLARY_INSTRUCTIONS',
  /** DR (Duplicate/Interaction Reason) */
  AnalyteValueCommentTypeDuplicateReason = 'ANALYTE_VALUE_COMMENT_TYPE_DUPLICATE_REASON',
  /** GI */
  AnalyteValueCommentTypeGeneralInstructions = 'ANALYTE_VALUE_COMMENT_TYPE_GENERAL_INSTRUCTIONS',
  /** GR */
  AnalyteValueCommentTypeGeneralReason = 'ANALYTE_VALUE_COMMENT_TYPE_GENERAL_REASON',
  AnalyteValueCommentTypeNone = 'ANALYTE_VALUE_COMMENT_TYPE_NONE',
  /** PI */
  AnalyteValueCommentTypePatientInstructions = 'ANALYTE_VALUE_COMMENT_TYPE_PATIENT_INSTRUCTIONS',
  /** 1R */
  AnalyteValueCommentTypePrimaryReason = 'ANALYTE_VALUE_COMMENT_TYPE_PRIMARY_REASON',
  /** RE */
  AnalyteValueCommentTypeRemark = 'ANALYTE_VALUE_COMMENT_TYPE_REMARK',
  /** 2R */
  AnalyteValueCommentTypeSecondaryReason = 'ANALYTE_VALUE_COMMENT_TYPE_SECONDARY_REASON'
}

export enum Lab_AnalyteValueInterpretation {
  /** Abnormal (applies to non-numeric results) */
  AnalyteValueInterpretationA = 'ANALYTE_VALUE_INTERPRETATION_A',
  /** Very abnormal (applies to non-numeric units, analogous to panic limits for numeric units) */
  AnalyteValueInterpretationAa = 'ANALYTE_VALUE_INTERPRETATION_AA',
  /** Above absolute high-off instrument scale */
  AnalyteValueInterpretationAboveAbsoluteHighOffInstrumentScale = 'ANALYTE_VALUE_INTERPRETATION_ABOVE_ABSOLUTE_HIGH_OFF_INSTRUMENT_SCALE',
  /** Anti-complementary substances present */
  AnalyteValueInterpretationAc = 'ANALYTE_VALUE_INTERPRETATION_AC',
  /** Better--use when direction not relevant */
  AnalyteValueInterpretationB = 'ANALYTE_VALUE_INTERPRETATION_B',
  /** Below absolute low-off instrument scale */
  AnalyteValueInterpretationBelowAbsoluteLowOffInstrumentScale = 'ANALYTE_VALUE_INTERPRETATION_BELOW_ABSOLUTE_LOW_OFF_INSTRUMENT_SCALE',
  /** Significant change down */
  AnalyteValueInterpretationD = 'ANALYTE_VALUE_INTERPRETATION_D',
  /** Detected */
  AnalyteValueInterpretationDet = 'ANALYTE_VALUE_INTERPRETATION_DET',
  /** Above high normal */
  AnalyteValueInterpretationH = 'ANALYTE_VALUE_INTERPRETATION_H',
  /** Above upper panic limits */
  AnalyteValueInterpretationHh = 'ANALYTE_VALUE_INTERPRETATION_HH',
  /** Intermediate. Indicates for microbiology susceptibilities only. */
  AnalyteValueInterpretationI = 'ANALYTE_VALUE_INTERPRETATION_I',
  /** Indeterminate */
  AnalyteValueInterpretationInd = 'ANALYTE_VALUE_INTERPRETATION_IND',
  /** Below low normal */
  AnalyteValueInterpretationL = 'ANALYTE_VALUE_INTERPRETATION_L',
  /** Below lower panic limits */
  AnalyteValueInterpretationLl = 'ANALYTE_VALUE_INTERPRETATION_LL',
  /** Moderately susceptible. Indicates for microbiology susceptibilities only. */
  AnalyteValueInterpretationMs = 'ANALYTE_VALUE_INTERPRETATION_MS',
  /** Normal (applies to non-numeric results) */
  AnalyteValueInterpretationN = 'ANALYTE_VALUE_INTERPRETATION_N',
  /** Negative */
  AnalyteValueInterpretationNeg = 'ANALYTE_VALUE_INTERPRETATION_NEG',
  AnalyteValueInterpretationNone = 'ANALYTE_VALUE_INTERPRETATION_NONE',
  /** Non-reactive */
  AnalyteValueInterpretationNr = 'ANALYTE_VALUE_INTERPRETATION_NR',
  /** No range defined, or normal ranges don't apply */
  AnalyteValueInterpretationNull = 'ANALYTE_VALUE_INTERPRETATION_NULL',
  /** Positive */
  AnalyteValueInterpretationPos = 'ANALYTE_VALUE_INTERPRETATION_POS',
  /** Quality Control Failure */
  AnalyteValueInterpretationQcf = 'ANALYTE_VALUE_INTERPRETATION_QCF',
  /** Resistant. Indicates for microbiology susceptibilities only. */
  AnalyteValueInterpretationR = 'ANALYTE_VALUE_INTERPRETATION_R',
  /** Reactive */
  AnalyteValueInterpretationRr = 'ANALYTE_VALUE_INTERPRETATION_RR',
  /** Susceptible. Indicates for microbiology susceptibilities only. */
  AnalyteValueInterpretationS = 'ANALYTE_VALUE_INTERPRETATION_S',
  /** Cytotoxic substance present */
  AnalyteValueInterpretationTox = 'ANALYTE_VALUE_INTERPRETATION_TOX',
  /** Significant change up */
  AnalyteValueInterpretationU = 'ANALYTE_VALUE_INTERPRETATION_U',
  /** Very susceptible. Indicates for microbiology susceptibilities only. */
  AnalyteValueInterpretationVs = 'ANALYTE_VALUE_INTERPRETATION_VS',
  /** Worse--use when direction not relevant */
  AnalyteValueInterpretationW = 'ANALYTE_VALUE_INTERPRETATION_W',
  /** Weakly reactive */
  AnalyteValueInterpretationWr = 'ANALYTE_VALUE_INTERPRETATION_WR'
}

export type Lab_AnalyteValueList = {
  __typename?: 'lab_AnalyteValueList';
  values?: Maybe<Array<Maybe<Lab_AnalyteValueMsg>>>;
};

/** Value of an analyte measured through a test */
export type Lab_AnalyteValueMsg = {
  __typename?: 'lab_AnalyteValueMsg';
  analyte?: Maybe<Lab_TestAnalyteMsg>;
  boolValue?: Maybe<Scalars['Boolean']>;
  categoryValue?: Maybe<Category_ResultCategoryMsg>;
  comment?: Maybe<Scalars['String']>;
  conspicuous?: Maybe<Scalars['Boolean']>;
  decimalRangeValue?: Maybe<DecimalRangeMsg>;
  decimalValue?: Maybe<DecimalMsg>;
  emergency?: Maybe<Scalars['Boolean']>;
  /** False if there are multiple revisions of this value */
  firstRevision?: Maybe<Scalars['Boolean']>;
  /** Identifier to group different versions of the same result */
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intValue?: Maybe<Scalars['Int']>;
  interpretationCodes?: Maybe<Array<Maybe<Lab_AnalyteValueInterpretation>>>;
  ratioValue?: Maybe<RatioMsg>;
  /** Reference ranges that apply to this value based on patient characteristics */
  referenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  /** Reference ranges that apply to the relative value based on patient characteristics */
  relativeReferenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  /** In some tests, the value is provided both as absolute and as relative */
  relativeValue?: Maybe<DecimalRangeMsg>;
  /** Whether the relative value is conspicuous, can differ from the conspicuousness of the standard value */
  relativeValueConspicuous?: Maybe<Scalars['Boolean']>;
  /**
   * Whether this value was created as a result of a LabRequest;
   *  false if added from within LabTask
   */
  requested?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Lab_AnalyteValueStatus>;
  textValue?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  typedComments?: Maybe<Array<Maybe<Lab_AnalyteValueCommentMsg>>>;
  /** If the result was automatically fetched from a device, the ID of that device */
  updaterDeviceId?: Maybe<Scalars['String']>;
  /** user id of user who last modified the result */
  updaterId?: Maybe<Scalars['String']>;
  /** organizational unit Id of user who last modified the result */
  updaterOrganizationalUnitId?: Maybe<Scalars['String']>;
  /**
   * manually updated timestamp of last value update
   *  required, as the updatedAt timestamp gets updated on replacement of this value with its postscript
   */
  valueUpdatedAt?: Maybe<Timestamp>;
};

export enum Lab_AnalyteValueStatus {
  AnalyteValueStatusFinal = 'ANALYTE_VALUE_STATUS_FINAL',
  AnalyteValueStatusNone = 'ANALYTE_VALUE_STATUS_NONE',
  AnalyteValueStatusPreliminary = 'ANALYTE_VALUE_STATUS_PRELIMINARY'
}

export type Lab_CalculateFeeCodesRequest = {
  __typename?: 'lab_CalculateFeeCodesRequest';
  labTaskId?: Maybe<Scalars['String']>;
};

export type Lab_CalculateFeeCodesResponse = {
  __typename?: 'lab_CalculateFeeCodesResponse';
  feeCodes?: Maybe<Array<Maybe<Lab_MedicalFeeCodeMsg>>>;
  labTaskId?: Maybe<Scalars['String']>;
};

export type Lab_CreateFeeCodeRequest = {
  __typename?: 'lab_CreateFeeCodeRequest';
  labTaskId?: Maybe<Scalars['String']>;
};

export type Lab_DeleteFeeCodeRequest = {
  __typename?: 'lab_DeleteFeeCodeRequest';
  feeCodeId?: Maybe<Scalars['String']>;
  labTaskId?: Maybe<Scalars['String']>;
};

export type Lab_DeleteFeeCodeResponse = {
  __typename?: 'lab_DeleteFeeCodeResponse';
  deletedFeeCodeId?: Maybe<Scalars['String']>;
};

export type Lab_MaterialAmountMsg = {
  __typename?: 'lab_MaterialAmountMsg';
  doubleAmount?: Maybe<Scalars['Float']>;
  intAmount?: Maybe<Scalars['Int']>;
  /** If the specific amount is of no interest as long as the material is present */
  presence?: Maybe<Scalars['Boolean']>;
  unitGeneralId?: Maybe<Scalars['String']>;
};

export type Lab_MaterialInstanceMsg = {
  __typename?: 'lab_MaterialInstanceMsg';
  amount?: Maybe<Lab_MaterialAmountMsg>;
  collectionDate?: Maybe<Timestamp>;
  comment?: Maybe<Scalars['String']>;
  currentLocation?: Maybe<Lab_SampleLocationReferenceMsg>;
  expiryDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  /** As some machines can only process very basic ids, this simplified sample key may be used to identify samples */
  machineSampleKey?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Timestamp>;
  sampleKey?: Maybe<Scalars['String']>;
  /** If the material is a sample, this is the body part from which the sample was extracted */
  sampleLocalization?: Maybe<Core_KnowledgeInputMsg>;
  /** The number within the request */
  sampleNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<Lab_MaterialStatus>;
  taskStatus?: Maybe<Lab_MaterialTaskStatus>;
  type?: Maybe<Lab_MaterialTypeMsg>;
};

export type Lab_MaterialRequirementMsg = {
  __typename?: 'lab_MaterialRequirementMsg';
  amount?: Maybe<Lab_MaterialAmountMsg>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Lab_MaterialTypeMsg>;
};

export type Lab_MaterialRequirementSetListMsg = {
  __typename?: 'lab_MaterialRequirementSetListMsg';
  MaterialRequirementSets?: Maybe<Array<Maybe<Lab_MaterialRequirementSetMsg>>>;
};

/** A set of requirements that must be fulfilled at once */
export type Lab_MaterialRequirementSetMsg = {
  __typename?: 'lab_MaterialRequirementSetMsg';
  id?: Maybe<Scalars['String']>;
  informationText?: Maybe<Scalars['String']>;
  requirements?: Maybe<Array<Maybe<Lab_MaterialRequirementMsg>>>;
};

export enum Lab_MaterialStatus {
  MaterialStatusFailedToReceive = 'MATERIAL_STATUS_FAILED_TO_RECEIVE',
  MaterialStatusNone = 'MATERIAL_STATUS_NONE',
  MaterialStatusPrepared = 'MATERIAL_STATUS_PREPARED',
  MaterialStatusReceived = 'MATERIAL_STATUS_RECEIVED',
  MaterialStatusRequested = 'MATERIAL_STATUS_REQUESTED',
  MaterialStatusSent = 'MATERIAL_STATUS_SENT'
}

export enum Lab_MaterialTaskStatus {
  MaterialTaskStatusFinished = 'MATERIAL_TASK_STATUS_FINISHED',
  MaterialTaskStatusInProgress = 'MATERIAL_TASK_STATUS_IN_PROGRESS',
  MaterialTaskStatusNone = 'MATERIAL_TASK_STATUS_NONE'
}

export type Lab_MaterialTypeList = {
  __typename?: 'lab_MaterialTypeList';
  materialTypes?: Maybe<Array<Maybe<Lab_MaterialTypeMsg>>>;
};

export type Lab_MaterialTypeMsg = {
  __typename?: 'lab_MaterialTypeMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

export type Lab_MedicalFeeCodeList = {
  __typename?: 'lab_MedicalFeeCodeList';
  codes?: Maybe<Array<Maybe<Lab_MedicalFeeCodeMsg>>>;
};

export type Lab_MedicalFeeCodeMsg = {
  __typename?: 'lab_MedicalFeeCodeMsg';
  description?: Maybe<Scalars['String']>;
  /** The identifier in the given system */
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** How many times this code should be billed */
  quantity?: Maybe<Scalars['Int']>;
  system?: Maybe<Lab_MedicalFeeCodeSystem>;
  /** Value that determines the fee */
  value?: Maybe<Scalars['Float']>;
};

export enum Lab_MedicalFeeCodeSystem {
  /** German "Gebührenordnung für Ärzte" */
  MedicalFeeCodeSystemGvae = 'MEDICAL_FEE_CODE_SYSTEM_GVAE',
  MedicalFeeCodeSystemNone = 'MEDICAL_FEE_CODE_SYSTEM_NONE'
}

export type Lab_SampleLocationReferenceMsg = {
  __typename?: 'lab_SampleLocationReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Lab_SampleLocationType>;
};

export enum Lab_SampleLocationType {
  SampleLocationTypeNone = 'SAMPLE_LOCATION_TYPE_NONE'
}

export type Lab_TestAnalyteBasicInfoMsg = {
  __typename?: 'lab_TestAnalyteBasicInfoMsg';
  analyte?: Maybe<Lab_AnalyteMsg>;
  id?: Maybe<Scalars['String']>;
  referenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  relativeReferenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  resultType?: Maybe<Lab_AnalyteResultType>;
  unit?: Maybe<Lab_AnalyteUnitMsg>;
};

/** This allows grouping TestAnalytes under the specified group name when displaying the TestAnalytes */
export type Lab_TestAnalyteGroupMsg = {
  __typename?: 'lab_TestAnalyteGroupMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Order in which the groups should be displayed within the test */
  order?: Maybe<Scalars['Int']>;
};

/** For each test, an analyte gets combined with additional information, e.g., type of results, required material */
export type Lab_TestAnalyteMsg = {
  __typename?: 'lab_TestAnalyteMsg';
  analyte?: Maybe<Lab_AnalyteMsg>;
  /** If the analyte results are categorical, this specifies the possible categories */
  categorySystem?: Maybe<Category_ResultCategorySystemMsg>;
  /** Used for updating LabTask's feeCodes automatically */
  connectedFeeCodes?: Maybe<Array<Maybe<Lab_MedicalFeeCodeMsg>>>;
  /** Whether free text can be entered in addition to the result */
  enableComment?: Maybe<Scalars['Boolean']>;
  /** Whether further categories apart from those defined in the categorySystem can be entered */
  enableCustomCategory?: Maybe<Scalars['Boolean']>;
  /** Whether a relative value can be entered in addition to the standard value */
  enableRelativeValue?: Maybe<Scalars['Boolean']>;
  /** For double values, number of digits behind the decimal point */
  fractionDigits?: Maybe<Scalars['Int']>;
  /** Number of digits behind the decimal point for the relative value */
  fractionDigitsRelative?: Maybe<Scalars['Int']>;
  group?: Maybe<Lab_TestAnalyteGroupMsg>;
  id?: Maybe<Scalars['String']>;
  loincCode?: Maybe<Scalars['String']>;
  /**
   * list of requirement sets - if one of the sets in the list is fully provided,
   *  this TestAnalyte's material requirements are fulfilled
   */
  materialRequirementOptions?: Maybe<Array<Maybe<Lab_MaterialRequirementSetMsg>>>;
  referenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  relativeReferenceRanges?: Maybe<Array<Maybe<Reference_ReferenceRangeMsg>>>;
  resultType?: Maybe<Lab_AnalyteResultType>;
  unit?: Maybe<Lab_AnalyteUnitMsg>;
};

export type Lab_UpdateFeeCodeRequest = {
  __typename?: 'lab_UpdateFeeCodeRequest';
  feeCode?: Maybe<Lab_MedicalFeeCodeMsg>;
  labTaskId?: Maybe<Scalars['String']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export enum Laterality_Laterality {
  LateralityBoth = 'LATERALITY_BOTH',
  LateralityLeft = 'LATERALITY_LEFT',
  LateralityNone = 'LATERALITY_NONE',
  LateralityRight = 'LATERALITY_RIGHT'
}

export type Letter_ClinicalRequestLetterList = {
  __typename?: 'letter_ClinicalRequestLetterList';
  letters?: Maybe<Array<Maybe<Letter_ClinicalRequestLetterMsg>>>;
};

export type Letter_ClinicalRequestLetterMsg = {
  __typename?: 'letter_ClinicalRequestLetterMsg';
  actions?: Maybe<Array<Maybe<Letter_LetterActionMsg>>>;
  attachments?: Maybe<Array<Maybe<Letter_LetterAttachmentReferenceMsg>>>;
  category?: Maybe<Letter_LetterCategoryMsg>;
  clinicalRequestId?: Maybe<Scalars['String']>;
  /** userId of letter creator */
  creatorId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  /** Id of document in document server */
  documentId?: Maybe<Scalars['String']>;
  /** Used to group the "same" letter in different stages, e.g., a preliminary version and a final version based on the preliminary one */
  groupId?: Maybe<Scalars['String']>;
  /** Content of the letter in html format */
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  letterClass?: Maybe<Letter_LetterClass>;
  letterDate?: Maybe<Timestamp>;
  /** If true, the current text cannot be changed unless the letter is explicitly unlocked */
  locked?: Maybe<Scalars['Boolean']>;
  optionalInformation?: Maybe<Letter_OptionalInformationMsg>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<Maybe<Letter_LetterRecipientMsg>>>;
  sendingMethods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
  signatoryRequests?: Maybe<Array<Maybe<Signature_SignatureMsg>>>;
  signed?: Maybe<Scalars['Boolean']>;
  stage?: Maybe<Letter_LetterStage>;
  status?: Maybe<Letter_LetterStatus>;
  subject?: Maybe<Scalars['String']>;
  /** If true, the current text is kept in sync with the information entered through the treatment */
  synced?: Maybe<Scalars['Boolean']>;
  timestamps?: Maybe<TimeMsg>;
  /** Location from which the letter file can be accessed */
  url?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Letter_ClinicalRequestLetterResultList = {
  __typename?: 'letter_ClinicalRequestLetterResultList';
  hitCount?: Maybe<Scalars['Int']>;
  letters?: Maybe<Array<Maybe<Letter_ClinicalRequestLetterMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Letter_CreateOrUpdateClinicalRequestLetterRequest = {
  __typename?: 'letter_CreateOrUpdateClinicalRequestLetterRequest';
  letter?: Maybe<Letter_ClinicalRequestLetterMsg>;
  /**
   * If not set, either the old template for this letter (if the letter already exists)
   *  or the default template for the organizationalUnitId (if the letter does not yet exist) will be used.
   */
  newLetterTemplateId?: Maybe<Scalars['String']>;
};

export type Letter_CreateOrUpdateLetterCategoryRequest = {
  __typename?: 'letter_CreateOrUpdateLetterCategoryRequest';
  letterCategory?: Maybe<Letter_LetterCategoryMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Letter_CreateOrUpdateLetterTemplateRequest = {
  __typename?: 'letter_CreateOrUpdateLetterTemplateRequest';
  letterTemplate?: Maybe<Letter_LetterTemplateMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Letter_CreateSignatureRequest = {
  __typename?: 'letter_CreateSignatureRequest';
  assignee?: Maybe<Signature_SignatureAssigneeMsg>;
  letterId?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
};

export type Letter_CreateSignaturesRequest = {
  __typename?: 'letter_CreateSignaturesRequest';
  /** This letter id will be used, not the letter id field inside CreateSignatureRequest */
  letterId?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<Letter_CreateSignatureRequest>>>;
};

export type Letter_CustomLetterRecipientMsg = {
  __typename?: 'letter_CustomLetterRecipientMsg';
  additional?: Maybe<Scalars['String']>;
  address?: Maybe<Core_AddressMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Letter_DeleteLetterRequest = {
  __typename?: 'letter_DeleteLetterRequest';
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_DeleteLetterResponse = {
  __typename?: 'letter_DeleteLetterResponse';
  deletedLetterId?: Maybe<Scalars['String']>;
};

export type Letter_DeleteSignatureRequest = {
  __typename?: 'letter_DeleteSignatureRequest';
  letterId?: Maybe<Scalars['String']>;
  signatureId?: Maybe<Scalars['String']>;
};

export type Letter_DeleteSignaturesRequest = {
  __typename?: 'letter_DeleteSignaturesRequest';
  letterId?: Maybe<Scalars['String']>;
  signatureIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Letter_GetClinicalRequestLetterDocumentRequest = {
  __typename?: 'letter_GetClinicalRequestLetterDocumentRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
};

export type Letter_GetClinicalRequestLetterRequest = {
  __typename?: 'letter_GetClinicalRequestLetterRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  letterGroupId?: Maybe<Scalars['String']>;
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_GetClinicalRequestLetterTextRequest = {
  __typename?: 'letter_GetClinicalRequestLetterTextRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_GetClinicalRequestLetterTextResponse = {
  __typename?: 'letter_GetClinicalRequestLetterTextResponse';
  html?: Maybe<Scalars['String']>;
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_GetClinicalRequestReportExistencesRequest = {
  __typename?: 'letter_GetClinicalRequestReportExistencesRequest';
  clinicalRequestIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Letter_GetClinicalRequestReportExistencesResponse = {
  __typename?: 'letter_GetClinicalRequestReportExistencesResponse';
  reportExistenceEntries?: Maybe<Array<Maybe<Letter_ReportExistenceEntry>>>;
};

export type Letter_GetDefaultLetterCategoryRequest = {
  __typename?: 'letter_GetDefaultLetterCategoryRequest';
  /** optional; if not set, the default department of the organizationalUnit is used */
  departmentId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  templateType?: Maybe<Letter_LetterClass>;
};

export type Letter_GetDefaultLetterTemplateRequest = {
  __typename?: 'letter_GetDefaultLetterTemplateRequest';
  /** can be set instead of organizationalUnitId; is ignored if organizationalUnitId is set */
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional; if not set, the default department of the organizationalUnit is used */
  departmentId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  templateType?: Maybe<Letter_LetterClass>;
};

export type Letter_GetLetterActionHistoryRequest = {
  __typename?: 'letter_GetLetterActionHistoryRequest';
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_GetLetterCategoryRequest = {
  __typename?: 'letter_GetLetterCategoryRequest';
  categoryId?: Maybe<Scalars['String']>;
};

export type Letter_GetLetterTemplateRequest = {
  __typename?: 'letter_GetLetterTemplateRequest';
  templateId?: Maybe<Scalars['String']>;
};

export enum Letter_GrammaticalGender {
  GrammaticalGenderFeminine = 'GRAMMATICAL_GENDER_FEMININE',
  GrammaticalGenderMasculine = 'GRAMMATICAL_GENDER_MASCULINE',
  GrammaticalGenderNeuter = 'GRAMMATICAL_GENDER_NEUTER',
  GrammaticalGenderNone = 'GRAMMATICAL_GENDER_NONE'
}

export type Letter_LetterActionList = {
  __typename?: 'letter_LetterActionList';
  actions?: Maybe<Array<Maybe<Letter_LetterActionMsg>>>;
};

export type Letter_LetterActionMsg = {
  __typename?: 'letter_LetterActionMsg';
  date?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  /** An action performed on an older version (not latest) */
  obsolete?: Maybe<Scalars['Boolean']>;
  /** Only set for 'send' and 'revert send' action */
  sendingMethods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
  signatureActionData?: Maybe<Signature_SignatureActionDataMsg>;
  type?: Maybe<Letter_LetterActionType>;
  userId?: Maybe<Scalars['String']>;
  /** If the action is 'send' or 'publish', id of the sent/published version */
  versionId?: Maybe<Scalars['String']>;
};

export enum Letter_LetterActionType {
  LetterActionTypeAddSignature = 'LETTER_ACTION_TYPE_ADD_SIGNATURE',
  LetterActionTypeCreateNewLetter = 'LETTER_ACTION_TYPE_CREATE_NEW_LETTER',
  LetterActionTypeCreateNewVersion = 'LETTER_ACTION_TYPE_CREATE_NEW_VERSION',
  LetterActionTypeNone = 'LETTER_ACTION_TYPE_NONE',
  LetterActionTypePublish = 'LETTER_ACTION_TYPE_PUBLISH',
  LetterActionTypeReject = 'LETTER_ACTION_TYPE_REJECT',
  LetterActionTypeRemoveSignature = 'LETTER_ACTION_TYPE_REMOVE_SIGNATURE',
  /** Used if a letter was mistakenly marked as "SENT" or if at least one of its sendingMethods was selected by mistake */
  LetterActionTypeRevertSend = 'LETTER_ACTION_TYPE_REVERT_SEND',
  LetterActionTypeSend = 'LETTER_ACTION_TYPE_SEND',
  LetterActionTypeSign = 'LETTER_ACTION_TYPE_SIGN',
  LetterActionTypeUnsign = 'LETTER_ACTION_TYPE_UNSIGN',
  LetterActionTypeUpdateSignature = 'LETTER_ACTION_TYPE_UPDATE_SIGNATURE'
}

export type Letter_LetterAttachmentReferenceMsg = {
  __typename?: 'letter_LetterAttachmentReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Letter_LetterAttachmentType>;
};

export enum Letter_LetterAttachmentType {
  /** The document that is associated with the lab result */
  LetterAttachmentTypeLabResult = 'LETTER_ATTACHMENT_TYPE_LAB_RESULT',
  LetterAttachmentTypeNone = 'LETTER_ATTACHMENT_TYPE_NONE'
}

export type Letter_LetterCategoryAssignmentMsg = {
  __typename?: 'letter_LetterCategoryAssignmentMsg';
  type?: Maybe<Letter_LetterClass>;
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Letter_LetterCategoryList = {
  __typename?: 'letter_LetterCategoryList';
  categories?: Maybe<Array<Maybe<Letter_LetterCategoryMsg>>>;
};

export type Letter_LetterCategoryMsg = {
  __typename?: 'letter_LetterCategoryMsg';
  defaultAssignments?: Maybe<Array<Maybe<Letter_LetterCategoryAssignmentMsg>>>;
  /** Can be empty; set if a non-standard document type should be set when releasing letters of this category as documents */
  documentType?: Maybe<Document_DocumentType>;
  documentTypeExternalIds?: Maybe<Array<Maybe<Document_DocumentTypeExternalIdMsg>>>;
  gender?: Maybe<Letter_GrammaticalGender>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerAssignments?: Maybe<Array<Maybe<Letter_LetterCategoryAssignmentMsg>>>;
  printSettings?: Maybe<Letter_LetterCategoryPrintSettingsMsg>;
};

export type Letter_LetterCategoryPrintSettingsMsg = {
  __typename?: 'letter_LetterCategoryPrintSettingsMsg';
  hidePatientInformation?: Maybe<Scalars['Boolean']>;
  hideRecipientAddress?: Maybe<Scalars['Boolean']>;
  hideRecipients?: Maybe<Scalars['Boolean']>;
};

export enum Letter_LetterClass {
  LetterClassCareAdmissionProtocol = 'LETTER_CLASS_CARE_ADMISSION_PROTOCOL',
  LetterClassCareTransferSheet = 'LETTER_CLASS_CARE_TRANSFER_SHEET',
  LetterClassClinicalRequestLetter = 'LETTER_CLASS_CLINICAL_REQUEST_LETTER',
  LetterClassDischargeLetter = 'LETTER_CLASS_DISCHARGE_LETTER',
  LetterClassIntraoperativeAnesthesiaProtocol = 'LETTER_CLASS_INTRAOPERATIVE_ANESTHESIA_PROTOCOL',
  LetterClassLabLetter = 'LETTER_CLASS_LAB_LETTER',
  LetterClassMedicalAdmissionProtocol = 'LETTER_CLASS_MEDICAL_ADMISSION_PROTOCOL',
  LetterClassNone = 'LETTER_CLASS_NONE',
  LetterClassOther = 'LETTER_CLASS_OTHER',
  LetterClassPatientLetter = 'LETTER_CLASS_PATIENT_LETTER',
  LetterClassPostoperativeCareUnitProtocol = 'LETTER_CLASS_POSTOPERATIVE_CARE_UNIT_PROTOCOL',
  LetterClassPreanestheticAssessmentLetter = 'LETTER_CLASS_PREANESTHETIC_ASSESSMENT_LETTER',
  LetterClassPreoperativeAssessmentLetter = 'LETTER_CLASS_PREOPERATIVE_ASSESSMENT_LETTER',
  LetterClassSurgeryProtocol = 'LETTER_CLASS_SURGERY_PROTOCOL',
  LetterClassSurgeryReport = 'LETTER_CLASS_SURGERY_REPORT',
  LetterClassTransferLetter = 'LETTER_CLASS_TRANSFER_LETTER'
}

export type Letter_LetterRecipientList = {
  __typename?: 'letter_LetterRecipientList';
  recipients?: Maybe<Array<Maybe<Letter_LetterRecipientMsg>>>;
};

export type Letter_LetterRecipientMsg = {
  __typename?: 'letter_LetterRecipientMsg';
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_HumanNameMsg>;
  organizationName?: Maybe<Scalars['String']>;
  recipientId?: Maybe<Scalars['String']>;
  sex?: Maybe<Core_Sex>;
  type?: Maybe<Letter_LetterRecipientType>;
};

export enum Letter_LetterRecipientType {
  LetterRecipientTypeAdditional = 'LETTER_RECIPIENT_TYPE_ADDITIONAL',
  LetterRecipientTypeContactParty = 'LETTER_RECIPIENT_TYPE_CONTACT_PARTY',
  LetterRecipientTypeNone = 'LETTER_RECIPIENT_TYPE_NONE',
  LetterRecipientTypePatient = 'LETTER_RECIPIENT_TYPE_PATIENT',
  LetterRecipientTypePortalUser = 'LETTER_RECIPIENT_TYPE_PORTAL_USER',
  LetterRecipientTypePractitioner = 'LETTER_RECIPIENT_TYPE_PRACTITIONER',
  LetterRecipientTypeReferrer = 'LETTER_RECIPIENT_TYPE_REFERRER',
  LetterRecipientTypeUser = 'LETTER_RECIPIENT_TYPE_USER'
}

export enum Letter_LetterSendingMethod {
  /** Letter handed to person directly */
  LetterSendingMethodInPerson = 'LETTER_SENDING_METHOD_IN_PERSON',
  /** Letter sent by mail */
  LetterSendingMethodMail = 'LETTER_SENDING_METHOD_MAIL',
  LetterSendingMethodNone = 'LETTER_SENDING_METHOD_NONE',
  /** Letter pushed to patient portal */
  LetterSendingMethodPatientPortal = 'LETTER_SENDING_METHOD_PATIENT_PORTAL'
}

export enum Letter_LetterStage {
  LetterStageCancellationInformation = 'LETTER_STAGE_CANCELLATION_INFORMATION',
  LetterStageFinal = 'LETTER_STAGE_FINAL',
  LetterStageNone = 'LETTER_STAGE_NONE',
  LetterStagePreliminary = 'LETTER_STAGE_PRELIMINARY'
}

export enum Letter_LetterStatus {
  LetterStatusFinished = 'LETTER_STATUS_FINISHED',
  LetterStatusInProgress = 'LETTER_STATUS_IN_PROGRESS',
  LetterStatusNone = 'LETTER_STATUS_NONE',
  LetterStatusPublished = 'LETTER_STATUS_PUBLISHED',
  LetterStatusRejected = 'LETTER_STATUS_REJECTED',
  LetterStatusSent = 'LETTER_STATUS_SENT',
  LetterStatusWithdrawn = 'LETTER_STATUS_WITHDRAWN'
}

export type Letter_LetterTemplateList = {
  __typename?: 'letter_LetterTemplateList';
  templates?: Maybe<Array<Maybe<Letter_LetterTemplateMsg>>>;
};

export type Letter_LetterTemplateMsg = {
  __typename?: 'letter_LetterTemplateMsg';
  /**
   * The units for which the letter template is the default.
   *  One unit must have exactly one active default template for any type for which it has at least one active template.
   *  All default units must be part of the ownerAdministrativeUnits or its children.
   */
  defaultAdministrativeUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  groupId?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The units in which the template is registered. */
  ownerAdministrativeUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  status?: Maybe<Letter_LetterTemplateStatus>;
  templateType?: Maybe<Letter_LetterClass>;
  timestamps?: Maybe<TimeMsg>;
};

export enum Letter_LetterTemplateStatus {
  LetterTemplateStatusFinished = 'LETTER_TEMPLATE_STATUS_FINISHED',
  LetterTemplateStatusNone = 'LETTER_TEMPLATE_STATUS_NONE',
  LetterTemplateStatusUnfinished = 'LETTER_TEMPLATE_STATUS_UNFINISHED'
}

export type Letter_ListLetterCategoriesRequest = {
  __typename?: 'letter_ListLetterCategoriesRequest';
  categoryAssignment?: Maybe<Letter_LetterCategoryAssignmentMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: Maybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: Maybe<Scalars['Boolean']>;
};

export type Letter_ListLetterTemplatesRequest = {
  __typename?: 'letter_ListLetterTemplatesRequest';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: Maybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  templateType?: Maybe<Letter_LetterClass>;
};

export type Letter_ListLetterVersionsRequest = {
  __typename?: 'letter_ListLetterVersionsRequest';
  groupId?: Maybe<Scalars['String']>;
};

export type Letter_ListLettersRequest = {
  __typename?: 'letter_ListLettersRequest';
  /** Assignee. At least one of creatorUserId and Assignee must be specified. */
  assignee?: Maybe<Signature_SignatureAssigneeMsg>;
  /** Optional: search only letters that the user still has to sign. For closed/open tabs */
  awaitingSignatureFilter?: Maybe<Scalars['Boolean']>;
  /** creatorUserId. At least one of creatorUserId and Assignee must be specified. */
  creatorUserId?: Maybe<Scalars['String']>;
  /** Optional: time range filter */
  endDate?: Maybe<Timestamp>;
  /** Optional: letter categories */
  letterCategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Otpinal filter */
  letterClasses?: Maybe<Array<Maybe<Letter_LetterClass>>>;
  /** Optional: search for letters that have none of these sending methods */
  missingSendingMethods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
  /** Optional: search for letters that have missing required signatures */
  missingSignature?: Maybe<Scalars['Boolean']>;
  /** Optional: True: get letters that the user has only optional signature requirements; False: the user has at least one required signature requirement; Null: all */
  optionalSignature?: Maybe<Scalars['Boolean']>;
  /** letterDate or timestamps.updatedAt can be used as an optional sorting variable */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  /** Optional: patient id filter */
  patientId?: Maybe<Scalars['String']>;
  /** Optional: scope filter */
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** Optional: sending methods */
  sendingMethods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
  /** Optional: letter types */
  stages?: Maybe<Array<Maybe<Letter_LetterStage>>>;
  /** Optional: time range filter */
  startDate?: Maybe<Timestamp>;
  /** Optional: statuses */
  statuses?: Maybe<Array<Maybe<Letter_LetterStatus>>>;
  /** Optional filter */
  surgeryId?: Maybe<Scalars['String']>;
  /** Optional filter */
  visitId?: Maybe<Scalars['String']>;
};

export type Letter_LockLetterRequest = {
  __typename?: 'letter_LockLetterRequest';
  letterId?: Maybe<Scalars['String']>;
};

/** Optional formal information that will be displayed on the patient letter */
export type Letter_OptionalInformationMsg = {
  __typename?: 'letter_OptionalInformationMsg';
  department?: Maybe<Scalars['String']>;
  ourSign?: Maybe<Scalars['String']>;
  yourSign?: Maybe<Scalars['String']>;
};

export type Letter_RejectLetterRequest = {
  __typename?: 'letter_RejectLetterRequest';
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_ReportExistenceEntry = {
  __typename?: 'letter_ReportExistenceEntry';
  clinicalRequestId?: Maybe<Scalars['String']>;
  hasReport?: Maybe<Scalars['Boolean']>;
};

export type Letter_RevertLetterSendingRequest = {
  __typename?: 'letter_RevertLetterSendingRequest';
  letterId?: Maybe<Scalars['String']>;
  /**
   * At least one method must be selected - these methods will be removed;
   *  if no method remains, the letter's status returns to PUBLISHED.
   */
  methods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
};

export type Letter_SearchLetterCategoriesRequest = {
  __typename?: 'letter_SearchLetterCategoriesRequest';
  categoryAssignment?: Maybe<Letter_LetterCategoryAssignmentMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: Maybe<Scalars['String']>;
  /** optional: defaults to False, if true, disables searching categories on the letter type */
  disableLetterTypeFilter?: Maybe<Scalars['Boolean']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: Maybe<Scalars['Boolean']>;
  /** optional; Set if pagination is desired; no sort options supported */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Letter_SearchLetterCategoriesResponse = {
  __typename?: 'letter_SearchLetterCategoriesResponse';
  categories?: Maybe<Array<Maybe<Letter_LetterCategoryMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Letter_SearchLetterTemplatesRequest = {
  __typename?: 'letter_SearchLetterTemplatesRequest';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional; only considered if the unitReference is to an ORGANIZATIONAL_UNIT; if not set, the default department of the organizationalUnit is used. */
  departmentId?: Maybe<Scalars['String']>;
  /** optional; if true, only return templates owned by the exact administrativeUnit provided by the caller, instead of also returning those owned by the parent units */
  onlyExactUnit?: Maybe<Scalars['Boolean']>;
  /** optional; Set if pagination is desired; no sort options supported */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  /** optional filter */
  templateType?: Maybe<Letter_LetterClass>;
};

export type Letter_SearchLetterTemplatesResponse = {
  __typename?: 'letter_SearchLetterTemplatesResponse';
  hitCount?: Maybe<Scalars['Int']>;
  templates?: Maybe<Array<Maybe<Letter_LetterTemplateMsg>>>;
};

export type Letter_SendLetterRequest = {
  __typename?: 'letter_SendLetterRequest';
  letterId?: Maybe<Scalars['String']>;
  /** At least one method must be selected */
  methods?: Maybe<Array<Maybe<Letter_LetterSendingMethod>>>;
};

export type Letter_SignClinicalRequestLetterResponse = {
  __typename?: 'letter_SignClinicalRequestLetterResponse';
  /** Only set if no additional confirmation required */
  letter?: Maybe<Letter_ClinicalRequestLetterMsg>;
  /** True if additional confirmation is required to sign the letter */
  publishingConfirmationRequired?: Maybe<Scalars['Boolean']>;
};

export type Letter_SignLetterRequest = {
  __typename?: 'letter_SignLetterRequest';
  /**
   * The default value for this is false. Should be set to true only if the user additionally confirms publishing.
   *  If this signature is the last one needed in order to publish the letter and the flag is not set, an exception will be thrown.
   *  If this flag is set but the signature is not the last one needed, the flag will be ignored, signature will be created, the letter will not be published.
   *  If this flag is set but the letter is already published, the flag will be ignored.
   */
  confirmPublishing?: Maybe<Scalars['Boolean']>;
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_UnlockLetterRequest = {
  __typename?: 'letter_UnlockLetterRequest';
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_UnsignLetterRequest = {
  __typename?: 'letter_UnsignLetterRequest';
  letterId?: Maybe<Scalars['String']>;
};

export type Letter_UpdateClinicalRequestLetterStatusRequest = {
  __typename?: 'letter_UpdateClinicalRequestLetterStatusRequest';
  letterId?: Maybe<Scalars['String']>;
  status?: Maybe<Letter_LetterStatus>;
};

export type Letter_UpdateLetterStatusRequest = {
  __typename?: 'letter_UpdateLetterStatusRequest';
  letterId?: Maybe<Scalars['String']>;
  status?: Maybe<Letter_LetterStatus>;
};

export type Letter_UpdateSignatureRequest = {
  __typename?: 'letter_UpdateSignatureRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  signatoryRequest?: Maybe<Signature_SignatureMsg>;
};

export type Letter_UpdateSignaturesRequest = {
  __typename?: 'letter_UpdateSignaturesRequest';
  /** This letter id will be used, if the signature does not belong to this letter, it will not be updated */
  letterId?: Maybe<Scalars['String']>;
  signatoryRequests?: Maybe<Array<Maybe<Signature_SignatureMsg>>>;
};

export enum Logic_ComparisonOperator {
  ComparisonOperatorEq = 'COMPARISON_OPERATOR_EQ',
  ComparisonOperatorGeq = 'COMPARISON_OPERATOR_GEQ',
  ComparisonOperatorGt = 'COMPARISON_OPERATOR_GT',
  ComparisonOperatorLeq = 'COMPARISON_OPERATOR_LEQ',
  ComparisonOperatorLt = 'COMPARISON_OPERATOR_LT',
  ComparisonOperatorNeq = 'COMPARISON_OPERATOR_NEQ',
  ComparisonOperatorNone = 'COMPARISON_OPERATOR_NONE'
}

export enum Logic_LogicalOperator {
  LogicalOperatorAnd = 'LOGICAL_OPERATOR_AND',
  LogicalOperatorNone = 'LOGICAL_OPERATOR_NONE',
  LogicalOperatorOr = 'LOGICAL_OPERATOR_OR'
}

export type Medication_ExternalMedicationDosageFormulaUnitIdMsg = {
  __typename?: 'medication_ExternalMedicationDosageFormulaUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationDosageFormulaUnitIdType>;
};

export type Medication_ExternalMedicationDosageUnitIdMsg = {
  __typename?: 'medication_ExternalMedicationDosageUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export type Medication_MedicationDosageFormulaUnitMsg = {
  __typename?: 'medication_MedicationDosageFormulaUnitMsg';
  externalIds?: Maybe<Array<Maybe<Medication_ExternalMedicationDosageFormulaUnitIdMsg>>>;
  target?: Maybe<Medication_MedicationUnitTargetMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Medication_MedicationDosageUnitMsg = {
  __typename?: 'medication_MedicationDosageUnitMsg';
  externalIds?: Maybe<Array<Maybe<Medication_ExternalMedicationDosageUnitIdMsg>>>;
  target?: Maybe<Medication_MedicationUnitTargetMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Medication_MedicationDosageUnitPairMsg = {
  __typename?: 'medication_MedicationDosageUnitPairMsg';
  formulaUnit?: Maybe<Medication_MedicationDosageFormulaUnitMsg>;
  unit?: Maybe<Medication_MedicationDosageUnitMsg>;
};

export type Medication_MedicationDosageValueMsg = {
  __typename?: 'medication_MedicationDosageValueMsg';
  displayFraction?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Medication_MedicationDosageValuePairMsg = {
  __typename?: 'medication_MedicationDosageValuePairMsg';
  formulaValue?: Maybe<Medication_MedicationDosageValueMsg>;
  value?: Maybe<Medication_MedicationDosageValueMsg>;
};

export type Medication_MedicationUnitTargetMsg = {
  __typename?: 'medication_MedicationUnitTargetMsg';
  /** if set, the dosage unit refers to the specified activeIngredient */
  targetActiveIngredientId?: Maybe<Scalars['String']>;
  /** if set, the dosage unit refers to the specified MedicationComponent */
  targetComponentId?: Maybe<Scalars['String']>;
  /** if true, the unit refers to the whole medication */
  targetMedication?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Medication_MedicationUnitTargetType>;
};

export enum Medication_MedicationUnitTargetType {
  MedicationUnitTargetTypeActiveIngredientId = 'MEDICATION_UNIT_TARGET_TYPE_ACTIVE_INGREDIENT_ID',
  MedicationUnitTargetTypeComponentId = 'MEDICATION_UNIT_TARGET_TYPE_COMPONENT_ID',
  MedicationUnitTargetTypeMedication = 'MEDICATION_UNIT_TARGET_TYPE_MEDICATION',
  MedicationUnitTargetTypeNone = 'MEDICATION_UNIT_TARGET_TYPE_NONE'
}

export type Patient_ActivateLegalInfoRequest = {
  __typename?: 'patient_ActivateLegalInfoRequest';
  careAidDisabilityId?: Maybe<Scalars['String']>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: Maybe<Validation_ExternalValidator>;
  invasiveProceduresLivingWillId?: Maybe<Scalars['String']>;
  legalGuardianshipId?: Maybe<Scalars['String']>;
  longTermCareId?: Maybe<Scalars['String']>;
  organDonationCardId?: Maybe<Scalars['String']>;
  /** Mandatory */
  patientId?: Maybe<Scalars['String']>;
  powerOfAttorneyId?: Maybe<Scalars['String']>;
  /** At least one of treatment id, visit id, externalValidator is needed if immediatelyActivate is set */
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_ActivateLegalInfoResponse = {
  __typename?: 'patient_ActivateLegalInfoResponse';
  careAidDisability?: Maybe<Patient_CareAidDisabilityMsg>;
  invasiveProceduresLivingWill?: Maybe<Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: Maybe<Patient_LegalGuardianshipMsg>;
  longTermCare?: Maybe<Patient_LongTermCareMsg>;
  organDonationCard?: Maybe<Patient_OrganDonationCardMsg>;
  powerOfAttorney?: Maybe<Patient_PowerOfAttorneyMsg>;
};

export type Patient_AddVisitIsolationsRequest = {
  __typename?: 'patient_AddVisitIsolationsRequest';
  isolations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_AdministrativeUnitIds = {
  __typename?: 'patient_AdministrativeUnitIds';
  /** currently unsupported */
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** currently unsupported */
  divisionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_AnonymousPatientMsg = {
  __typename?: 'patient_AnonymousPatientMsg';
  birthCountry?: Maybe<Core_KnowledgeInputMsg>;
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  denomination?: Maybe<Knowledge_DenominationMsg>;
  maritalStatus?: Maybe<Core_MaritalStatus>;
  name?: Maybe<Core_HumanNameMsg>;
  nationality?: Maybe<Core_KnowledgeInputMsg>;
};

export type Patient_AssignPatientsRequest = {
  __typename?: 'patient_AssignPatientsRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** whether to assign all open patients (true) or only unassigned ones (false) */
  reassign?: Maybe<Scalars['Boolean']>;
  /** physicians among whom the patients are distributed */
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_CallPatientRequest = {
  __typename?: 'patient_CallPatientRequest';
  roomId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CareAidDisabilityMsg = {
  __typename?: 'patient_CareAidDisabilityMsg';
  careDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  careLevel?: Maybe<Patient_CareLevel>;
  careLevelAssessmentRequested?: Maybe<Scalars['Boolean']>;
  careLevelText?: Maybe<Scalars['String']>;
  /** In percent */
  degreeOfDisability?: Maybe<Scalars['Int']>;
  degreeOfDisabilityStatus?: Maybe<Patient_DegreeOfDisabilityStatusType>;
  degreeOfDisabilityText?: Maybe<Scalars['String']>;
  disabilityDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  medicalAidDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  medicalAidPresent?: Maybe<Scalars['Boolean']>;
  medicalAidText?: Maybe<Scalars['String']>;
  medicalAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export enum Patient_CareLevel {
  CareLevel_1 = 'CARE_LEVEL_1',
  CareLevel_2 = 'CARE_LEVEL_2',
  CareLevel_3 = 'CARE_LEVEL_3',
  CareLevel_4 = 'CARE_LEVEL_4',
  CareLevel_5 = 'CARE_LEVEL_5',
  CareLevelNone = 'CARE_LEVEL_NONE',
  CareLevelNotPresent = 'CARE_LEVEL_NOT_PRESENT'
}

export type Patient_CollectAdditionalServicesRequest = {
  __typename?: 'patient_CollectAdditionalServicesRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  visitIdList?: Maybe<Patient_VisitIdList>;
};

export type Patient_CollectAdditionalServicesResponse = {
  __typename?: 'patient_CollectAdditionalServicesResponse';
  visitIdToAdditionalServiceMaps?: Maybe<Array<Maybe<Patient_VisitIdToAdditionalServiceMap>>>;
};

export type Patient_CollectCurrentVisitorsRequest = {
  __typename?: 'patient_CollectCurrentVisitorsRequest';
  relevantVisitTypes?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_CollectCurrentVisitorsResponse = {
  __typename?: 'patient_CollectCurrentVisitorsResponse';
  currentVisitors?: Maybe<Array<Maybe<Patient_CurrentVisitorResponseMsg>>>;
};

/**
 * We have to display the contact parties like a validatable block in the treatment,
 *  hence this message
 */
export type Patient_ContactPartiesValidationMsg = {
  __typename?: 'patient_ContactPartiesValidationMsg';
  id?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export enum Patient_ContactPartyDataSource {
  ContactPartyDataSourceManual = 'CONTACT_PARTY_DATA_SOURCE_MANUAL',
  ContactPartyDataSourceNone = 'CONTACT_PARTY_DATA_SOURCE_NONE',
  ContactPartyDataSourcePatientPortal = 'CONTACT_PARTY_DATA_SOURCE_PATIENT_PORTAL'
}

export enum Patient_ContactPartyDesignation {
  ContactPartyDesignationAmbulantCareProvider = 'CONTACT_PARTY_DESIGNATION_AMBULANT_CARE_PROVIDER',
  ContactPartyDesignationBillingRecipient = 'CONTACT_PARTY_DESIGNATION_BILLING_RECIPIENT',
  ContactPartyDesignationCareProviderInstitution = 'CONTACT_PARTY_DESIGNATION_CARE_PROVIDER_INSTITUTION',
  ContactPartyDesignationNone = 'CONTACT_PARTY_DESIGNATION_NONE',
  ContactPartyDesignationPayor = 'CONTACT_PARTY_DESIGNATION_PAYOR'
}

export type Patient_ContactPartyList = {
  __typename?: 'patient_ContactPartyList';
  contactParties?: Maybe<Array<Maybe<Patient_ContactPartyMsg>>>;
};

/**
 * A patient's contact party.
 *  Can be a human or an organization.
 */
export type Patient_ContactPartyMsg = {
  __typename?: 'patient_ContactPartyMsg';
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  birthCountryCode?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  contactInformation?: Maybe<Core_ContactMsg>;
  contactPartyDataSource?: Maybe<Patient_ContactPartyDataSource>;
  dateOfBirth?: Maybe<Timestamp>;
  denomination?: Maybe<Knowledge_DenominationMsg>;
  designations?: Maybe<Array<Maybe<Patient_ContactPartyDesignation>>>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalContactPartyIdMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  maritalStatus?: Maybe<Core_MaritalStatus>;
  name?: Maybe<Core_HumanNameMsg>;
  nationality?: Maybe<Core_KnowledgeInputMsg>;
  organizationName?: Maybe<Scalars['String']>;
  scope?: Maybe<Patient_ContactPartyScopeReferenceMsg>;
  sex?: Maybe<Core_Sex>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Patient_ContactPartyScopeReferenceMsg = {
  __typename?: 'patient_ContactPartyScopeReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ContactPartyScopeType>;
};

export enum Patient_ContactPartyScopeType {
  ContactPartyScopeBillingCase = 'CONTACT_PARTY_SCOPE_BILLING_CASE',
  ContactPartyScopeNone = 'CONTACT_PARTY_SCOPE_NONE'
}

export enum Patient_ContactPartyType {
  /** TODO ...Dataset knowledge Input contactparty type */
  ContactPartyTypeEmployer = 'CONTACT_PARTY_TYPE_EMPLOYER',
  ContactPartyTypeNone = 'CONTACT_PARTY_TYPE_NONE'
}

export type Patient_CreateAdditionalServicesAssignmentRequest = {
  __typename?: 'patient_CreateAdditionalServicesAssignmentRequest';
  /** mandatory for status other than draft */
  additionalServiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: Maybe<Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  /** mandatory for status other than draft */
  startTime?: Maybe<Timestamp>;
  /** optional; if not set, defaults to DRAFT */
  status?: Maybe<Patient_Registry_AdditionalServicesAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CreateAdditionalServicesAssignmentResponse = {
  __typename?: 'patient_CreateAdditionalServicesAssignmentResponse';
  createdAdditionalServicesAssignment?: Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>;
  /** set if the time of additional service assignment is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_CreateContactPartyRequest = {
  __typename?: 'patient_CreateContactPartyRequest';
  contactParty?: Maybe<Patient_ContactPartyMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_CreateLeadingUnitAssignmentRequest = {
  __typename?: 'patient_CreateLeadingUnitAssignmentRequest';
  /** If set, marks connection to place where this assignment was created from */
  origin?: Maybe<Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  /** mandatory for status other than draft */
  startTime?: Maybe<Timestamp>;
  /** optional; if not set, defaults to DRAFT */
  status?: Maybe<Patient_LeadingUnitAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: Maybe<Scalars['Boolean']>;
  /** mandatory for status other than draft */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** mandatory */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CreateLeadingUnitAssignmentResponse = {
  __typename?: 'patient_CreateLeadingUnitAssignmentResponse';
  /** provide created assignment explicitly, as assignments on case are sorted by date */
  createdUnitAssignment?: Maybe<Patient_LeadingUnitAssignmentMsg>;
  /** set if the time of leading unit assignment is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_CreateLegalInfoRequest = {
  __typename?: 'patient_CreateLegalInfoRequest';
  patientId?: Maybe<Scalars['String']>;
};

/** Creates an editable revision if necessary */
export type Patient_CreateOrUpdateLegalInfoRequest = {
  __typename?: 'patient_CreateOrUpdateLegalInfoRequest';
  /** If there is an existing revision by another user, cancels it. */
  cancelExisting?: Maybe<Scalars['Boolean']>;
  careAidDisability?: Maybe<Patient_CareAidDisabilityMsg>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: Maybe<Validation_ExternalValidator>;
  /** Immediately activates the editable revision and sets the validation. */
  immediatelyActivate?: Maybe<Scalars['Boolean']>;
  invasiveProceduresLivingWill?: Maybe<Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: Maybe<Patient_LegalGuardianshipMsg>;
  longTermCare?: Maybe<Patient_LongTermCareMsg>;
  organDonationCard?: Maybe<Patient_OrganDonationCardMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  /** Mandatory */
  patientId?: Maybe<Scalars['String']>;
  powerOfAttorney?: Maybe<Patient_PowerOfAttorneyMsg>;
  /** If there is an existing revision by another user, takes it over. */
  takeOverExisting?: Maybe<Scalars['Boolean']>;
  /** At least one of treatment id, visit id, externalValidator is needed if immediatelyActivate is set */
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CreateOrUpdateReasonsForIntroductionRequest = {
  __typename?: 'patient_CreateOrUpdateReasonsForIntroductionRequest';
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  texts?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_CreatePatientAbsenceRequest = {
  __typename?: 'patient_CreatePatientAbsenceRequest';
  externalId?: Maybe<Patient_ExternalPatientAbsenceIdMsg>;
  type?: Maybe<Patient_PatientAbsenceType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CreatePatientOccupationRequest = {
  __typename?: 'patient_CreatePatientOccupationRequest';
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
  patientOccupation?: Maybe<Patient_PatientOccupationMsg>;
};

export type Patient_CreatePatientRequest = {
  __typename?: 'patient_CreatePatientRequest';
  contact?: Maybe<Core_ContactMsg>;
  createdFromExternal?: Maybe<Scalars['Boolean']>;
  dateOfBirth?: Maybe<Timestamp>;
  /** Optional only if external patient db is used */
  externalBillingCaseId?: Maybe<Scalars['String']>;
  /**
   * deprecated fields; use externalPatientInfo instead
   * @deprecated deprecated in proto
   */
  externalPatientId?: Maybe<Scalars['String']>;
  /** overrides external patient and system id */
  externalPatientInfo?: Maybe<Patient_ExternalPatientIdMsg>;
  /** @deprecated deprecated in proto */
  externalSystemId?: Maybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** If specified, the external ids are ignored, and the newly created patient has 'external' false */
  internalContext?: Maybe<Patient_PatientContextMsg>;
  name?: Maybe<Core_HumanNameMsg>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  sex?: Maybe<Core_Sex>;
};

export type Patient_CreatePatientResponse = {
  __typename?: 'patient_CreatePatientResponse';
  /** If patient has been newly created */
  isNewPatient?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<Patient_PatientMsg>;
};

export type Patient_CreateVisitNumberRequest = {
  __typename?: 'patient_CreateVisitNumberRequest';
  /** TODO: Appointment */
  officeHourId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  targetTime?: Maybe<Timestamp>;
};

export type Patient_CreateVisitNumberResponse = {
  __typename?: 'patient_CreateVisitNumberResponse';
  number?: Maybe<Scalars['Int']>;
};

export type Patient_CreateVisitTransferFromCurrentVisitDataRequest = {
  __typename?: 'patient_CreateVisitTransferFromCurrentVisitDataRequest';
  originOrganizationalUnitId?: Maybe<Scalars['String']>;
  transferTime?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_CreateVisitTransferFromCurrentVisitDataResponse = {
  __typename?: 'patient_CreateVisitTransferFromCurrentVisitDataResponse';
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visitTransfer?: Maybe<Patient_VisitTransferMsg>;
};

export type Patient_CurrentVisitorResponseMsg = {
  __typename?: 'patient_CurrentVisitorResponseMsg';
  patientId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_DeclarationMsg = {
  __typename?: 'patient_DeclarationMsg';
  accepted?: Maybe<Scalars['Boolean']>;
  declarationId?: Maybe<Scalars['String']>;
  extraInformation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
};

export enum Patient_DegreeOfDisabilityStatusType {
  DegreeOfDisabilityNone = 'DEGREE_OF_DISABILITY_NONE',
  DegreeOfDisabilityNotPresent = 'DEGREE_OF_DISABILITY_NOT_PRESENT',
  DegreeOfDisabilityPresent = 'DEGREE_OF_DISABILITY_PRESENT',
  DegreeOfDisabilityRequested = 'DEGREE_OF_DISABILITY_REQUESTED'
}

export type Patient_DeleteAdditionalServicesAssignmentRequest = {
  __typename?: 'patient_DeleteAdditionalServicesAssignmentRequest';
  additionalServicesAssignmentId?: Maybe<Scalars['String']>;
  /**
   * If set, and if exists, the gap is filled by the next assignment.
   *  By default the gap is filled by the previous assignment, if both exists, or the only existing assignment.
   */
  fillWithTheNextAssignment?: Maybe<Scalars['Boolean']>;
};

export type Patient_DeleteAdditionalServicesAssignmentResponse = {
  __typename?: 'patient_DeleteAdditionalServicesAssignmentResponse';
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_DeleteContactPartyRequest = {
  __typename?: 'patient_DeleteContactPartyRequest';
  contactPartyId?: Maybe<Scalars['String']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** Optional: Set if request comes from a treatment -> affects contact party validation */
  treatmentId?: Maybe<Scalars['String']>;
  /** Optional: Set if request comes from a visit -> affects contact party validation */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_DeleteContactPartyResponse = {
  __typename?: 'patient_DeleteContactPartyResponse';
  contactPartiesValidation?: Maybe<Patient_ContactPartiesValidationMsg>;
  deletedContactPartyId?: Maybe<Scalars['String']>;
};

export type Patient_DeleteLeadingUnitAssignmentRequest = {
  __typename?: 'patient_DeleteLeadingUnitAssignmentRequest';
  /**
   * If set, and if exists, the gap is filled by the next assignment.
   *  By default the gap is filled by the previous assignment, if both exists, or the only existing assignment.
   */
  fillWithTheNextAssignment?: Maybe<Scalars['Boolean']>;
  leadingUnitAssignmentId?: Maybe<Scalars['String']>;
};

export type Patient_DeleteLeadingUnitAssignmentResponse = {
  __typename?: 'patient_DeleteLeadingUnitAssignmentResponse';
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_DeletePatientAbsenceRequest = {
  __typename?: 'patient_DeletePatientAbsenceRequest';
  patientAbsenceId?: Maybe<Scalars['String']>;
};

export type Patient_DeletePatientAbsenceResponse = {
  __typename?: 'patient_DeletePatientAbsenceResponse';
  deletedPatientAbsenceId?: Maybe<Scalars['String']>;
};

export type Patient_DeletePatientOccupationRequest = {
  __typename?: 'patient_DeletePatientOccupationRequest';
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patientOccupationId?: Maybe<Scalars['String']>;
};

export type Patient_DeletePatientOccupationResponse = {
  __typename?: 'patient_DeletePatientOccupationResponse';
  deletedPatientOccupationId?: Maybe<Scalars['String']>;
};

export type Patient_DeletePatientRequest = {
  __typename?: 'patient_DeletePatientRequest';
  /**
   * Means the source of the delete operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalDelete?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_DeletePatientResponse = {
  __typename?: 'patient_DeletePatientResponse';
  _?: Maybe<Scalars['String']>;
};

export type Patient_DeleteVisitTransferRequest = {
  __typename?: 'patient_DeleteVisitTransferRequest';
  visitTransferId?: Maybe<Scalars['String']>;
};

export type Patient_DeleteVisitTransferResponse = {
  __typename?: 'patient_DeleteVisitTransferResponse';
  deletedVisitTransferId?: Maybe<Scalars['String']>;
  /**
   * when deleting last visit transfer visit will be updated
   *  static resource will be deleted
   */
  visit?: Maybe<Patient_VisitMsg>;
};

export enum Patient_DocumentStatus {
  DocumentStatusNone = 'DOCUMENT_STATUS_NONE',
  DocumentStatusNotPresent = 'DOCUMENT_STATUS_NOT_PRESENT',
  DocumentStatusPresent = 'DOCUMENT_STATUS_PRESENT'
}

export enum Patient_EmploymentType {
  EmploymentTypeEmployee = 'EMPLOYMENT_TYPE_EMPLOYEE',
  EmploymentTypeNone = 'EMPLOYMENT_TYPE_NONE',
  EmploymentTypeSelfEmployed = 'EMPLOYMENT_TYPE_SELF_EMPLOYED'
}

export type Patient_ExternalContactPartyIdMsg = {
  __typename?: 'patient_ExternalContactPartyIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalContactPartyIdType>;
};

export enum Patient_ExternalContactPartyIdType {
  ExternalContactPartyIdHisBillingCaseScoped = 'EXTERNAL_CONTACT_PARTY_ID_HIS_BILLING_CASE_SCOPED',
  ExternalContactPartyIdHisPatientScoped = 'EXTERNAL_CONTACT_PARTY_ID_HIS_PATIENT_SCOPED',
  ExternalContactPartyIdTypeNone = 'EXTERNAL_CONTACT_PARTY_ID_TYPE_NONE'
}

export enum Patient_ExternalIdScope {
  ExternalIdScopeCase = 'EXTERNAL_ID_SCOPE_CASE',
  ExternalIdScopeNone = 'EXTERNAL_ID_SCOPE_NONE',
  ExternalIdScopePatient = 'EXTERNAL_ID_SCOPE_PATIENT'
}

export enum Patient_ExternalIdType {
  ExternalIdTypeHis = 'EXTERNAL_ID_TYPE_HIS',
  ExternalIdTypeInsurance = 'EXTERNAL_ID_TYPE_INSURANCE',
  ExternalIdTypeLab = 'EXTERNAL_ID_TYPE_LAB',
  ExternalIdTypeNone = 'EXTERNAL_ID_TYPE_NONE'
}

export type Patient_ExternalMedicalQualificationIdMsg = {
  __typename?: 'patient_ExternalMedicalQualificationIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalMedicalQualificationIdType>;
};

export enum Patient_ExternalMedicalQualificationIdType {
  /** https://applications.kbv.de/S_EBM_ARZTGRUPPE_V1.02.xhtml */
  ExternalMedicalQualificationIdTypeEbmDoctorGroup = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_EBM_DOCTOR_GROUP',
  /** German "Zusatz-Weiterbildungen gemäß der (Muster-)Weiterbildungsordnung, BAR-Schlüsselverzeichnis Anlage 23": https://applications.kbv.de/S_BAR_ZUSATZBEZEICHNUNG_V1.03.xhtml */
  ExternalMedicalQualificationIdTypeGermanBarAdditionalQualification = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_GERMAN_BAR_ADDITIONAL_QUALIFICATION',
  ExternalMedicalQualificationIdTypeGermanBarProfessionalGroup = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_GERMAN_BAR_PROFESSIONAL_GROUP',
  /** https://applications.kbv.de/S_BAS_ARZTGRUPPE_ALT_V1.00.xhtml */
  ExternalMedicalQualificationIdTypeGermanBasProfessionalGroup = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_GERMAN_BAS_PROFESSIONAL_GROUP',
  /** https://simplifier.net/for/kbvcsforqualificationtype. TODO: add KBV non medical qualification type */
  ExternalMedicalQualificationIdTypeKbvQualificationType = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_KBV_QUALIFICATION_TYPE',
  /** https://applications.kbv.de/S_KBV_VERSORGUNGSBEREICH_V1.01.xhtml */
  ExternalMedicalQualificationIdTypeKbvServiceField = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_KBV_SERVICE_FIELD',
  ExternalMedicalQualificationIdTypeNone = 'EXTERNAL_MEDICAL_QUALIFICATION_ID_TYPE_NONE'
}

export type Patient_ExternalPatientAbsenceIdMsg = {
  __typename?: 'patient_ExternalPatientAbsenceIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalPatientAbsenceIdType>;
};

export enum Patient_ExternalPatientAbsenceIdType {
  /** e.g. SAP i.s.h movement */
  ExternalPatientAbsenceIdTypeHis = 'EXTERNAL_PATIENT_ABSENCE_ID_TYPE_HIS',
  ExternalPatientAbsenceIdTypeNone = 'EXTERNAL_PATIENT_ABSENCE_ID_TYPE_NONE'
}

/** Reference to a patient ID of an external system */
export type Patient_ExternalPatientIdMsg = {
  __typename?: 'patient_ExternalPatientIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  scope?: Maybe<Patient_ExternalIdScope>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalIdType>;
};

export type Patient_ExternalPractitionerIdMsg = {
  __typename?: 'patient_ExternalPractitionerIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalPractitionerIdType>;
};

export enum Patient_ExternalPractitionerIdType {
  /** "lebenslange Arztnummer" */
  ExternalPractitionerIdTypeGermanLanr = 'EXTERNAL_PRACTITIONER_ID_TYPE_GERMAN_LANR',
  /** "Telematik-ID" */
  ExternalPractitionerIdTypeGermanTelematik = 'EXTERNAL_PRACTITIONER_ID_TYPE_GERMAN_TELEMATIK',
  /** "lebenslange Zahnarztnummer" */
  ExternalPractitionerIdTypeGermanZanr = 'EXTERNAL_PRACTITIONER_ID_TYPE_GERMAN_ZANR',
  ExternalPractitionerIdTypeInstituteCode = 'EXTERNAL_PRACTITIONER_ID_TYPE_INSTITUTE_CODE',
  ExternalPractitionerIdTypeNone = 'EXTERNAL_PRACTITIONER_ID_TYPE_NONE',
  ExternalPractitionerIdTypeSap = 'EXTERNAL_PRACTITIONER_ID_TYPE_SAP'
}

export type Patient_ExternalVisitIdMsg = {
  __typename?: 'patient_ExternalVisitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalVisitIdType>;
};

export enum Patient_ExternalVisitIdType {
  ExternalVisitIdTypeNone = 'EXTERNAL_VISIT_ID_TYPE_NONE',
  ExternalVisitIdTypeSap = 'EXTERNAL_VISIT_ID_TYPE_SAP'
}

export type Patient_ExternalVisitTransferIdMsg = {
  __typename?: 'patient_ExternalVisitTransferIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_ExternalVisitTransferIdType>;
};

export enum Patient_ExternalVisitTransferIdType {
  /** e.g. SAP ISH */
  ExternalVisitTransferIdTypeHis = 'EXTERNAL_VISIT_TRANSFER_ID_TYPE_HIS',
  ExternalVisitTransferIdTypeNone = 'EXTERNAL_VISIT_TRANSFER_ID_TYPE_NONE'
}

export type Patient_FindAdditionalServicesAssignmentRequest = {
  __typename?: 'patient_FindAdditionalServicesAssignmentRequest';
  /** mandatory if origin is not set; will return the assignment that was active at that point in time */
  date?: Maybe<Timestamp>;
  /** mandatory if visitId/date are not set */
  origin?: Maybe<Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  /** mandatory if origin is not set */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_FindAdditionalServicesAssignmentResponse = {
  __typename?: 'patient_FindAdditionalServicesAssignmentResponse';
  additionalServicesAssignment?: Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Patient_FindEarliestLeadingUnitAssignmentIdRequest = {
  __typename?: 'patient_FindEarliestLeadingUnitAssignmentIdRequest';
  leadingUnitAssignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_FindEarliestLeadingUnitAssignmentIdResponse = {
  __typename?: 'patient_FindEarliestLeadingUnitAssignmentIdResponse';
  leadingUnitAssignmentId?: Maybe<Scalars['String']>;
};

export type Patient_FindLeadingUnitAssignmentRequest = {
  __typename?: 'patient_FindLeadingUnitAssignmentRequest';
  /** optional and used if neither origin nor visitId are set */
  billingCaseId?: Maybe<Scalars['String']>;
  /**
   * mandatory if origin is not set; will return the assignment that was active at that point in time
   *  or the assignment with the earliest start date if there are multiple ones with the given date
   */
  date?: Maybe<Timestamp>;
  /** mandatory if visitId/date are not set */
  origin?: Maybe<Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  /** mandatory if origin is not set */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_FindLeadingUnitAssignmentResponse = {
  __typename?: 'patient_FindLeadingUnitAssignmentResponse';
  found?: Maybe<Scalars['Boolean']>;
  unitAssignment?: Maybe<Patient_LeadingUnitAssignmentMsg>;
};

export type Patient_FindOrCreatePatientRequest = {
  __typename?: 'patient_FindOrCreatePatientRequest';
  externalId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patient_FindOrCreatePatientResponse = {
  __typename?: 'patient_FindOrCreatePatientResponse';
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_FindPatientRequest = {
  __typename?: 'patient_FindPatientRequest';
  externalBillingCaseId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Patient_ExternalPatientIdMsg>;
};

export type Patient_FindVisitRequest = {
  __typename?: 'patient_FindVisitRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  excludedStatuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  /** at least one of the two is mandatory */
  externalId?: Maybe<Patient_ExternalVisitIdMsg>;
  /** optional filters */
  includedStatuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  types?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_FindVisitResponse = {
  __typename?: 'patient_FindVisitResponse';
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_FinishRegistrationRequest = {
  __typename?: 'patient_FinishRegistrationRequest';
  /** Set if billing case was updated */
  billingCaseId?: Maybe<Scalars['String']>;
  confirmBillingCaseTypeChange?: Maybe<Scalars['Boolean']>;
  /** Only considered if externalWrite and useCurrentOrganizationalUnitId are true */
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** Only provisional and completed are allowed */
  registrationStatus?: Maybe<Billing_RegistrationStatus>;
  /** Only considered if externalWrite and useTargetTime are true, and visit is of an outpatient type */
  targetTime?: Maybe<Timestamp>;
  /** Only considered if externalWrite is true */
  useCurrentOrganizationalUnitId?: Maybe<Scalars['Boolean']>;
  /** Only considered if externalWrite is true */
  useTargetTime?: Maybe<Scalars['Boolean']>;
  /** Set if visit registration was updated */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_FinishRegistrationResponse = {
  __typename?: 'patient_FinishRegistrationResponse';
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_GermanVisitBgDetailsMsg = {
  __typename?: 'patient_GermanVisitBgDetailsMsg';
  id?: Maybe<Scalars['String']>;
  /** Art der Heilbehandlung [sri_1] */
  therapeuticTreatmentBillingType?: Maybe<Billing_TherapeuticTreatmentBillingType>;
};

export type Patient_GetAdditionalServicesAssignmentRequest = {
  __typename?: 'patient_GetAdditionalServicesAssignmentRequest';
  additionalServicesAssignmentId?: Maybe<Scalars['String']>;
};

export type Patient_GetAdditionalServicesAssignmentResponse = {
  __typename?: 'patient_GetAdditionalServicesAssignmentResponse';
  additionalServicesAssignment?: Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>;
};

export type Patient_GetContactPartiesRequest = {
  __typename?: 'patient_GetContactPartiesRequest';
  contactPartyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetContactPartyRequest = {
  __typename?: 'patient_GetContactPartyRequest';
  contactPartyId?: Maybe<Scalars['String']>;
};

export type Patient_GetInvasiveProceduresLivingWillInfoRequest = {
  __typename?: 'patient_GetInvasiveProceduresLivingWillInfoRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetInvasiveProceduresLivingWillInfoResponse = {
  __typename?: 'patient_GetInvasiveProceduresLivingWillInfoResponse';
  patientIdToInvasiveProceduresLivingWillInfo?: Maybe<Array<Maybe<Patient_GetInvasiveProceduresLivingWillInfoResponse_PatientIdToInvasiveProceduresLivingWillInfoEntry>>>;
};

export type Patient_GetInvasiveProceduresLivingWillInfoResponse_PatientIdToInvasiveProceduresLivingWillInfoEntry = {
  __typename?: 'patient_GetInvasiveProceduresLivingWillInfoResponse_PatientIdToInvasiveProceduresLivingWillInfoEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Patient_InvasiveProceduresLivingWillInfoMsg>;
};

export type Patient_GetLeadingUnitAssignmentRequest = {
  __typename?: 'patient_GetLeadingUnitAssignmentRequest';
  leadingUnitAssignmentId?: Maybe<Scalars['String']>;
};

export type Patient_GetLeadingUnitAssignmentResponse = {
  __typename?: 'patient_GetLeadingUnitAssignmentResponse';
  leadingUnitAssignment?: Maybe<Patient_LeadingUnitAssignmentMsg>;
};

export type Patient_GetLeadingUnitAssignmentsRequest = {
  __typename?: 'patient_GetLeadingUnitAssignmentsRequest';
  leadingUnitAssignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetLeadingUnitAssignmentsResponse = {
  __typename?: 'patient_GetLeadingUnitAssignmentsResponse';
  leadingUnitAssignments?: Maybe<Array<Maybe<Patient_LeadingUnitAssignmentMsg>>>;
};

export type Patient_GetLeadingUnitReferencesRequest = {
  __typename?: 'patient_GetLeadingUnitReferencesRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetLeadingUnitReferencesResponse = {
  __typename?: 'patient_GetLeadingUnitReferencesResponse';
  entries?: Maybe<Array<Maybe<Patient_GetLeadingUnitReferencesResponseEntry>>>;
};

export type Patient_GetLeadingUnitReferencesResponseEntry = {
  __typename?: 'patient_GetLeadingUnitReferencesResponseEntry';
  billingCaseId?: Maybe<Scalars['String']>;
  leadingUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Patient_GetLegalInfoRequest = {
  __typename?: 'patient_GetLegalInfoRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_GetOrCreateVisitTransferRequest = {
  __typename?: 'patient_GetOrCreateVisitTransferRequest';
  /** optional */
  externalId?: Maybe<Patient_ExternalVisitTransferIdMsg>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_GetOverallAdmissionAndDischargeDateRequest = {
  __typename?: 'patient_GetOverallAdmissionAndDischargeDateRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  visitTypes?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_GetOverallAdmissionAndDischargeDateResponse = {
  __typename?: 'patient_GetOverallAdmissionAndDischargeDateResponse';
  admissionDate?: Maybe<Timestamp>;
  dischargeDate?: Maybe<Timestamp>;
};

export type Patient_GetPatientAbsenceRequest = {
  __typename?: 'patient_GetPatientAbsenceRequest';
  patientAbsenceId?: Maybe<Scalars['String']>;
};

export type Patient_GetPatientOccupationRequest = {
  __typename?: 'patient_GetPatientOccupationRequest';
  patientOccupationId?: Maybe<Scalars['String']>;
};

export type Patient_GetPatientOccupationsRequest = {
  __typename?: 'patient_GetPatientOccupationsRequest';
  patientOccupationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetPatientRequest = {
  __typename?: 'patient_GetPatientRequest';
  id?: Maybe<Scalars['String']>;
};

export type Patient_GetPatientsRequest = {
  __typename?: 'patient_GetPatientsRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetRoomRequest = {
  __typename?: 'patient_GetRoomRequest';
  roomId?: Maybe<Scalars['String']>;
};

export type Patient_GetRoomsRequest = {
  __typename?: 'patient_GetRoomsRequest';
  roomIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetTriageSystemLevelRequest = {
  __typename?: 'patient_GetTriageSystemLevelRequest';
  id?: Maybe<Scalars['String']>;
};

export type Patient_GetTriageSystemLevelResponse = {
  __typename?: 'patient_GetTriageSystemLevelResponse';
  triageSystemLevel?: Maybe<Patient_TriageSystemLevelMsg>;
};

export type Patient_GetTriageSystemRequest = {
  __typename?: 'patient_GetTriageSystemRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patient_GetVisitDatesFromBillingCasesRequest = {
  __typename?: 'patient_GetVisitDatesFromBillingCasesRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetVisitDatesFromBillingCasesResponse = {
  __typename?: 'patient_GetVisitDatesFromBillingCasesResponse';
  visitDates?: Maybe<Array<Maybe<Patient_GetVisitDatesFromBillingCasesResponseEntry>>>;
};

export type Patient_GetVisitDatesFromBillingCasesResponseEntry = {
  __typename?: 'patient_GetVisitDatesFromBillingCasesResponseEntry';
  billingCaseId?: Maybe<Scalars['String']>;
  visitScheduleInfo?: Maybe<Patient_VisitScheduleInfoMsg>;
};

export type Patient_GetVisitDetailsRequest = {
  __typename?: 'patient_GetVisitDetailsRequest';
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_GetVisitDetailsResponse = {
  __typename?: 'patient_GetVisitDetailsResponse';
  billingCaseId?: Maybe<Scalars['String']>;
  currentVisitType?: Maybe<Patient_VisitType>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_GetVisitRequest = {
  __typename?: 'patient_GetVisitRequest';
  /** If set to true, only id will be set in PatientMsg in response message */
  omitFullPatient?: Maybe<Scalars['Boolean']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_GetVisitTransferRequest = {
  __typename?: 'patient_GetVisitTransferRequest';
  visitTransferId?: Maybe<Scalars['String']>;
};

export type Patient_GetVisitsFinishDatesRequest = {
  __typename?: 'patient_GetVisitsFinishDatesRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetVisitsFinishDatesResponse = {
  __typename?: 'patient_GetVisitsFinishDatesResponse';
  visitFinishDates?: Maybe<Array<Maybe<Patient_VisitFinishDateMsg>>>;
};

export type Patient_GetVisitsRequest = {
  __typename?: 'patient_GetVisitsRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetVisitsStartDatesRequest = {
  __typename?: 'patient_GetVisitsStartDatesRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_GetVisitsStartDatesResponse = {
  __typename?: 'patient_GetVisitsStartDatesResponse';
  visitStartDates?: Maybe<Array<Maybe<Patient_VisitStartDateMsg>>>;
};

export type Patient_HandleVisitOnTreatmentFinishRequest = {
  __typename?: 'patient_HandleVisitOnTreatmentFinishRequest';
  treatmentType?: Maybe<Treatment_TreatmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_InpatientVisitInfoMsg = {
  __typename?: 'patient_InpatientVisitInfoMsg';
  patientId?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
};

export type Patient_InsertHistoricVisitTransferRequest = {
  __typename?: 'patient_InsertHistoricVisitTransferRequest';
  /** mandatory for status other than draft */
  endTime?: Maybe<Timestamp>;
  /** id of visit transfer below is required */
  nextVisitTransferId?: Maybe<Scalars['String']>;
  originOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** mandatory for status other than draft */
  startTime?: Maybe<Timestamp>;
  /** mandatory */
  targetOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** mandatory */
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_InsertHistoricVisitTransferResponse = {
  __typename?: 'patient_InsertHistoricVisitTransferResponse';
  createdVisitTransfer?: Maybe<Patient_VisitTransferMsg>;
  /** set if the time of transfer is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_InvasiveProceduresLivingWillInfoMsg = {
  __typename?: 'patient_InvasiveProceduresLivingWillInfoMsg';
  id?: Maybe<Scalars['String']>;
  invasiveVentilationDesired?: Maybe<Scalars['Boolean']>;
  reanimationDesired?: Maybe<Scalars['Boolean']>;
};

export type Patient_InvasiveProceduresLivingWillMsg = {
  __typename?: 'patient_InvasiveProceduresLivingWillMsg';
  artificialNutritionDesired?: Maybe<Scalars['Boolean']>;
  artificialNutritionFurtherDetails?: Maybe<Scalars['String']>;
  dialysisDesired?: Maybe<Scalars['Boolean']>;
  dialysisFurtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invasiveVentilationDesired?: Maybe<Scalars['Boolean']>;
  invasiveVentilationFurtherDetails?: Maybe<Scalars['String']>;
  livingWillCreationDate?: Maybe<Timestamp>;
  livingWillDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  livingWillFurtherDetails?: Maybe<Scalars['String']>;
  livingWillPresent?: Maybe<Scalars['Boolean']>;
  livingWillStorageLocation?: Maybe<Core_StorageLocationMsg>;
  reanimationDesired?: Maybe<Scalars['Boolean']>;
  reanimationFurtherDetails?: Maybe<Scalars['String']>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  transferToIcuDesired?: Maybe<Scalars['Boolean']>;
  transferToIcuFurtherDetails?: Maybe<Scalars['String']>;
  transfusionOfBloodProductsDesired?: Maybe<Scalars['Boolean']>;
  transfusionOfBloodProductsDetails?: Maybe<Scalars['String']>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export type Patient_LastVisitInformation = {
  __typename?: 'patient_LastVisitInformation';
  organizationalUnitId?: Maybe<Scalars['String']>;
  visitTime?: Maybe<TimeMsg>;
};

export type Patient_LeadingUnitAssignmentMsg = {
  __typename?: 'patient_LeadingUnitAssignmentMsg';
  id?: Maybe<Scalars['String']>;
  leadingUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: Maybe<Patient_LeadingUnitAssignmentOriginReferenceMsg>;
  startTime?: Maybe<Timestamp>;
  status?: Maybe<Patient_LeadingUnitAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: Maybe<Scalars['Boolean']>;
};

export type Patient_LeadingUnitAssignmentOriginReferenceMsg = {
  __typename?: 'patient_LeadingUnitAssignmentOriginReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_LeadingUnitAssignmentOriginType>;
};

export enum Patient_LeadingUnitAssignmentOriginType {
  LeadingUnitAssignmentOriginTypeNone = 'LEADING_UNIT_ASSIGNMENT_ORIGIN_TYPE_NONE',
  LeadingUnitAssignmentOriginTypeVisitTransfer = 'LEADING_UNIT_ASSIGNMENT_ORIGIN_TYPE_VISIT_TRANSFER'
}

export enum Patient_LeadingUnitAssignmentStatus {
  LeadingUnitAssignmentStatusConfirmed = 'LEADING_UNIT_ASSIGNMENT_STATUS_CONFIRMED',
  LeadingUnitAssignmentStatusDraft = 'LEADING_UNIT_ASSIGNMENT_STATUS_DRAFT',
  LeadingUnitAssignmentStatusNone = 'LEADING_UNIT_ASSIGNMENT_STATUS_NONE',
  LeadingUnitAssignmentStatusPlanned = 'LEADING_UNIT_ASSIGNMENT_STATUS_PLANNED'
}

export type Patient_LegalGuardianshipMsg = {
  __typename?: 'patient_LegalGuardianshipMsg';
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legalGuardian?: Maybe<Patient_ContactPartyMsg>;
  present?: Maybe<Scalars['Boolean']>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export enum Patient_LegalGuardianshipStatus {
  LegalGuardianshipNone = 'LEGAL_GUARDIANSHIP_NONE',
  LegalGuardianshipNotPresent = 'LEGAL_GUARDIANSHIP_NOT_PRESENT',
  LegalGuardianshipPresent = 'LEGAL_GUARDIANSHIP_PRESENT'
}

export enum Patient_LegalInfoType {
  LegalInfoTypeCareAidDisability = 'LEGAL_INFO_TYPE_CARE_AID_DISABILITY',
  LegalInfoTypeContactParties = 'LEGAL_INFO_TYPE_CONTACT_PARTIES',
  /** @deprecated deprecated in proto */
  LegalInfoTypeInvasiveProcedures = 'LEGAL_INFO_TYPE_INVASIVE_PROCEDURES',
  LegalInfoTypeInvasiveProceduresLivingWill = 'LEGAL_INFO_TYPE_INVASIVE_PROCEDURES_LIVING_WILL',
  LegalInfoTypeLegalGuardianship = 'LEGAL_INFO_TYPE_LEGAL_GUARDIANSHIP',
  LegalInfoTypeLongTermCare = 'LEGAL_INFO_TYPE_LONG_TERM_CARE',
  LegalInfoTypeNone = 'LEGAL_INFO_TYPE_NONE',
  LegalInfoTypeOrganDonationCard = 'LEGAL_INFO_TYPE_ORGAN_DONATION_CARD',
  LegalInfoTypePowerOfAttorney = 'LEGAL_INFO_TYPE_POWER_OF_ATTORNEY'
}

export type Patient_LegalInformationMsg = {
  __typename?: 'patient_LegalInformationMsg';
  careAidDisability?: Maybe<Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: Maybe<Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: Maybe<Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: Maybe<Patient_LegalGuardianshipMsg>;
  longTermCare?: Maybe<Patient_LongTermCareMsg>;
  organDonationCard?: Maybe<Patient_OrganDonationCardMsg>;
  powerOfAttorney?: Maybe<Patient_PowerOfAttorneyMsg>;
};

export type Patient_LinkAppointmentToVisitRequest = {
  __typename?: 'patient_LinkAppointmentToVisitRequest';
  appointmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_LinkPatientRequest = {
  __typename?: 'patient_LinkPatientRequest';
  externalBillingCaseId?: Maybe<Scalars['String']>;
  externalPatientId?: Maybe<Scalars['String']>;
  /** The existing non-external patient id */
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_ListAdditionalServicesAssignmentsRequest = {
  __typename?: 'patient_ListAdditionalServicesAssignmentsRequest';
  /** either this or visitIds is mandatory */
  billingCaseId?: Maybe<Scalars['String']>;
  /** either this or billingCaseId is mandatory */
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListAdditionalServicesAssignmentsResponse = {
  __typename?: 'patient_ListAdditionalServicesAssignmentsResponse';
  additionalServicesAssignments?: Maybe<Array<Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>>>;
};

export type Patient_ListAssignedToUserPatientsRequest = {
  __typename?: 'patient_ListAssignedToUserPatientsRequest';
  userId?: Maybe<Scalars['String']>;
};

export type Patient_ListLeadingUnitAssignmentsRequest = {
  __typename?: 'patient_ListLeadingUnitAssignmentsRequest';
  /** either this or visitIds is mandatory */
  billingCaseId?: Maybe<Scalars['String']>;
  /** either this or billingCaseId is mandatory */
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListLeadingUnitAssignmentsResponse = {
  __typename?: 'patient_ListLeadingUnitAssignmentsResponse';
  leadingUnitAssignments?: Maybe<Array<Maybe<Patient_LeadingUnitAssignmentMsg>>>;
};

export type Patient_ListLeadingUnitsRequest = {
  __typename?: 'patient_ListLeadingUnitsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
};

export type Patient_ListLeadingUnitsResponse = {
  __typename?: 'patient_ListLeadingUnitsResponse';
  units?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type Patient_ListLegalInfoRevisionsRequest = {
  __typename?: 'patient_ListLegalInfoRevisionsRequest';
  legalInfoType?: Maybe<Patient_LegalInfoType>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_ListLegalInfoRevisionsResponse = {
  __typename?: 'patient_ListLegalInfoRevisionsResponse';
  entries?: Maybe<Array<Maybe<Patient_ListLegalInfoRevisionsResponseEntryMsg>>>;
};

export type Patient_ListLegalInfoRevisionsResponseEntryMsg = {
  __typename?: 'patient_ListLegalInfoRevisionsResponseEntryMsg';
  careAidDisability?: Maybe<Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: Maybe<Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: Maybe<Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: Maybe<Patient_LegalGuardianshipMsg>;
  longTermCare?: Maybe<Patient_LongTermCareMsg>;
  organDonationCard?: Maybe<Patient_OrganDonationCardMsg>;
  powerOfAttorney?: Maybe<Patient_PowerOfAttorneyMsg>;
};

export type Patient_ListPatientAbsencesRequest = {
  __typename?: 'patient_ListPatientAbsencesRequest';
  statuses?: Maybe<Array<Maybe<Patient_PatientAbsenceStatus>>>;
  statusesToExclude?: Maybe<Array<Maybe<Patient_PatientAbsenceStatus>>>;
  types?: Maybe<Array<Maybe<Patient_PatientAbsenceType>>>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListPatientAbsencesResponse = {
  __typename?: 'patient_ListPatientAbsencesResponse';
  patientAbsences?: Maybe<Array<Maybe<Patient_PatientAbsenceMsg>>>;
};

export type Patient_ListPatientOccupationsRequest = {
  __typename?: 'patient_ListPatientOccupationsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_ListPatientsRequest = {
  __typename?: 'patient_ListPatientsRequest';
  addLastVisitInformation?: Maybe<Scalars['Boolean']>;
  /** When provided, patient service gets all patients with matching billing case information from billing service and filters the results based on them. */
  billingFilters?: Maybe<Billing_ListBillingCasePatientsRequest>;
  /** optional filter */
  createdInOrganizationalUnitId?: Maybe<Scalars['String']>;
  dateOfBirthSortOrder?: Maybe<Helper_SortOrder>;
  /** optional filter */
  external?: Maybe<Scalars['Boolean']>;
  /** The default order is first name ascending. */
  firstNameSortOrder?: Maybe<Helper_SortOrder>;
  hideDeceased?: Maybe<Scalars['Boolean']>;
  /** Sort instructions will not be used. Instead use explicit sort fields for first name and date of birth. */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  /** This would be doing the same as simply calling getPatient, however through this call, the last visit information may also be provided. */
  patientId?: Maybe<Scalars['String']>;
  sexFilters?: Maybe<Array<Maybe<Core_Sex>>>;
  /** When provided, patient service gets all patients with matching visits and filters the results based on them. */
  visitFilters?: Maybe<Patient_ListPatientsRequestVisitFiltersMsg>;
};

export type Patient_ListPatientsRequestVisitFiltersMsg = {
  __typename?: 'patient_ListPatientsRequestVisitFiltersMsg';
  administrativeUnitIds?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  includePlannedAdmission?: Maybe<Scalars['Boolean']>;
  includePlannedDischarge?: Maybe<Scalars['Boolean']>;
  leadingUnitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  registrationStatuses?: Maybe<Array<Maybe<Billing_RegistrationStatus>>>;
  status?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  timeFrameAdmission?: Maybe<TimeFrameMsg>;
  timeFrameDischarge?: Maybe<TimeFrameMsg>;
  timeFrameRegistration?: Maybe<TimeFrameMsg>;
  type?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_ListRoomsRequest = {
  __typename?: 'patient_ListRoomsRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Patient_RoomType>>>;
};

export type Patient_ListUnitVisitInfosRequest = {
  __typename?: 'patient_ListUnitVisitInfosRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patient_ListUnitVisitInfosResponse = {
  __typename?: 'patient_ListUnitVisitInfosResponse';
  visitInfos?: Maybe<Array<Maybe<Patient_UnitVisitInfoMsg>>>;
};

export type Patient_ListVisitCaseIdsRequest = {
  __typename?: 'patient_ListVisitCaseIdsRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitCaseIdsResponse = {
  __typename?: 'patient_ListVisitCaseIdsResponse';
  visitIdToBillingCaseId?: Maybe<Array<Maybe<Patient_ListVisitCaseIdsResponse_VisitIdToBillingCaseIdEntry>>>;
};

export type Patient_ListVisitCaseIdsResponse_VisitIdToBillingCaseIdEntry = {
  __typename?: 'patient_ListVisitCaseIdsResponse_VisitIdToBillingCaseIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Patient_ListVisitIds = {
  __typename?: 'patient_ListVisitIds';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitIdsByBillingCaseIdRequest = {
  __typename?: 'patient_ListVisitIdsByBillingCaseIdRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  /** optional filters */
  excludedStatuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  types?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_ListVisitIdsByBillingCaseIdsResponse = {
  __typename?: 'patient_ListVisitIdsByBillingCaseIdsResponse';
  billingCaseIdToVisitIds?: Maybe<Array<Maybe<Patient_ListVisitIdsByBillingCaseIdsResponse_BillingCaseIdToVisitIdsEntry>>>;
};

export type Patient_ListVisitIdsByBillingCaseIdsResponse_BillingCaseIdToVisitIdsEntry = {
  __typename?: 'patient_ListVisitIdsByBillingCaseIdsResponse_BillingCaseIdToVisitIdsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Patient_VisitIdList>;
};

export type Patient_ListVisitPatientSexesRequest = {
  __typename?: 'patient_ListVisitPatientSexesRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitPatientSexesResponse = {
  __typename?: 'patient_ListVisitPatientSexesResponse';
  visitIdToPatientSexMaps?: Maybe<Array<Maybe<Patient_VisitIdToPatientSexMap>>>;
};

export type Patient_ListVisitStatusInfo = {
  __typename?: 'patient_ListVisitStatusInfo';
  visitStatusInfo?: Maybe<Array<Maybe<Patient_VisitStatusInfoMsg>>>;
};

export type Patient_ListVisitStatusesByBillingCaseIdRequest = {
  __typename?: 'patient_ListVisitStatusesByBillingCaseIdRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitStatusesByBillingCaseIdResponse = {
  __typename?: 'patient_ListVisitStatusesByBillingCaseIdResponse';
  billingCaseIdToVisitStatusInfo?: Maybe<Array<Maybe<Patient_ListVisitStatusesByBillingCaseIdResponse_BillingCaseIdToVisitStatusInfoEntry>>>;
};

export type Patient_ListVisitStatusesByBillingCaseIdResponse_BillingCaseIdToVisitStatusInfoEntry = {
  __typename?: 'patient_ListVisitStatusesByBillingCaseIdResponse_BillingCaseIdToVisitStatusInfoEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Patient_ListVisitStatusInfo>;
};

export type Patient_ListVisitTransfersRequest = {
  __typename?: 'patient_ListVisitTransfersRequest';
  /** either this or visitIds is mandatory */
  billingCaseId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Patient_VisitTransferStatus>>>;
  statusesToExclude?: Maybe<Array<Maybe<Patient_VisitTransferStatus>>>;
  /** either this or billingCaseId is mandatory */
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitTransfersResponse = {
  __typename?: 'patient_ListVisitTransfersResponse';
  visitTransfers?: Maybe<Array<Maybe<Patient_VisitTransferMsg>>>;
};

export type Patient_ListVisitUnitHistoryRequest = {
  __typename?: 'patient_ListVisitUnitHistoryRequest';
  relevantEventStatuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_ListVisitUnitHistoryResponse = {
  __typename?: 'patient_ListVisitUnitHistoryResponse';
  unitAssignments?: Maybe<Array<Maybe<Patient_VisitUnitAssignmentMsg>>>;
};

export type Patient_ListVisitsByBillingCaseIdsRequest = {
  __typename?: 'patient_ListVisitsByBillingCaseIdsRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitsByBillingCaseIdsResponse = {
  __typename?: 'patient_ListVisitsByBillingCaseIdsResponse';
  visitByBillingCaseId?: Maybe<Array<Maybe<Patient_ListVisitsByBillingCaseIdsResponse_VisitByBillingCaseIdEntry>>>;
};

export type Patient_ListVisitsByBillingCaseIdsResponse_VisitByBillingCaseIdEntry = {
  __typename?: 'patient_ListVisitsByBillingCaseIdsResponse_VisitByBillingCaseIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Patient_VisitList>;
};

export type Patient_ListVisitsForInvoiceByBillingCaseIdsRequest = {
  __typename?: 'patient_ListVisitsForInvoiceByBillingCaseIdsRequest';
  billingCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitsForInvoiceByBillingCaseIdsResponse = {
  __typename?: 'patient_ListVisitsForInvoiceByBillingCaseIdsResponse';
  visitsByBillingCaseId?: Maybe<Array<Maybe<Patient_ListVisitsForInvoiceByBillingCaseIdsResponse_VisitsByBillingCaseIdEntry>>>;
};

export type Patient_ListVisitsForInvoiceByBillingCaseIdsResponse_VisitsByBillingCaseIdEntry = {
  __typename?: 'patient_ListVisitsForInvoiceByBillingCaseIdsResponse_VisitsByBillingCaseIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Patient_VisitForInvoiceList>;
};

/** search by location, patient, status, a subset or all of them */
export type Patient_ListVisitsPaginatedRequest = {
  __typename?: 'patient_ListVisitsPaginatedRequest';
  administrativeUnitIds?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  admissionDateSort?: Maybe<Helper_SortOrder>;
  allEpisodesOfCare?: Maybe<Scalars['Boolean']>;
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingCaseId?: Maybe<Scalars['String']>;
  billingCaseIdNot?: Maybe<Scalars['String']>;
  creationDateSort?: Maybe<Helper_SortOrder>;
  dischargeDateSort?: Maybe<Helper_SortOrder>;
  episodeOfCardIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If a user wants to see their assigned visits outside of their current view, this can be set */
  excludedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  firstNameSort?: Maybe<Helper_SortOrder>;
  hasAppointment?: Maybe<Scalars['Boolean']>;
  hasPatient?: Maybe<Scalars['Boolean']>;
  includeLastTreatmentDetails?: Maybe<Scalars['Boolean']>;
  /**
   * Must be provided to apply filters only on inpatient visit types, if they are included in the visit types filter.
   *  Currently includes types: INPATIENT, SEMI_INPATIENT
   */
  inpatientFilters?: Maybe<Patient_ListVisitsPaginatedRequestInpatientFiltersMsg>;
  lastNameSort?: Maybe<Helper_SortOrder>;
  /** (returns only visits in last x minutes) ignores onlyRecent */
  minutesToShow?: Maybe<Scalars['Int']>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether only the recent visits (currently: updated in past 8 hours) should be displayed */
  onlyRecent?: Maybe<Scalars['Boolean']>;
  /**
   * Must be provided to apply filters only on outpatient visit types, if they are included in the visit types filter.
   *  Currently includes types: OUTPATIENT, SURGERY, PRE_INPATIENT, POST_INPATIENT
   */
  outpatientFilters?: Maybe<Patient_ListVisitsPaginatedRequestOutpatientFiltersMsg>;
  /** Mandatory */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  patientId?: Maybe<Scalars['String']>;
  plannedAdmissionDateSort?: Maybe<Helper_SortOrder>;
  plannedDischargeDateSort?: Maybe<Helper_SortOrder>;
  registrationStatuses?: Maybe<Array<Maybe<Billing_RegistrationStatus>>>;
  requestedTimeFrameStartDateSort?: Maybe<Helper_SortOrder>;
  selector?: Maybe<Patient_VisitSelectorMsg>;
  statuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  tags?: Maybe<Array<Maybe<Patient_VisitTag>>>;
  targetTimeSort?: Maybe<Helper_SortOrder>;
  /**
   * if it's set along with includeLastTreatmentDetails it fetches the last treatment details of the given treatment type
   *  if it's not set it fetches the last treatment details without considering the treatmentType
   */
  treatmentType?: Maybe<Treatment_TreatmentType>;
  types?: Maybe<Array<Maybe<Patient_VisitType>>>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitNumberSort?: Maybe<Helper_SortOrder>;
  waitingTimeSort?: Maybe<Helper_SortOrder>;
};

export type Patient_ListVisitsPaginatedRequestInpatientFiltersMsg = {
  __typename?: 'patient_ListVisitsPaginatedRequestInpatientFiltersMsg';
  /** If set narrows the absence time frame filters's target */
  absenceEndIsNull?: Maybe<Scalars['Boolean']>;
  /** If set narrows the absence time frame filters's target */
  absenceEndsInTimeFrame?: Maybe<Scalars['Boolean']>;
  /** If set narrows the absence time frame filters's target */
  absenceStatuses?: Maybe<Array<Maybe<Patient_PatientAbsenceStatus>>>;
  absenceTimeFrame?: Maybe<TimeFrameMsg>;
  /** If set narrows the absence time frame filters's target */
  absenceTypes?: Maybe<Array<Maybe<Patient_PatientAbsenceType>>>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  arrivalTimeFrame?: Maybe<TimeFrameMsg>;
  /** Used for specifying which fields are considered for entry time frame filter. They are combined with OR-logic. */
  considerAdmissionTime?: Maybe<Scalars['Boolean']>;
  considerDesiredIncomingTransferTime?: Maybe<Scalars['Boolean']>;
  /** Used for specifying which fields are considered for exit time frame filter. They are combined with OR-logic. */
  considerDischargeTime?: Maybe<Scalars['Boolean']>;
  considerIncomingTransferTime?: Maybe<Scalars['Boolean']>;
  considerOutgoingTransferTime?: Maybe<Scalars['Boolean']>;
  considerPlannedAdmissionTime?: Maybe<Scalars['Boolean']>;
  considerPlannedDischargeTime?: Maybe<Scalars['Boolean']>;
  considerRequestedAdmissionTime?: Maybe<Scalars['Boolean']>;
  considerRequestedDischargeTime?: Maybe<Scalars['Boolean']>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  departureTimeFrame?: Maybe<TimeFrameMsg>;
  dischargeStatuses?: Maybe<Array<Maybe<Patient_VisitDischargeStatus>>>;
  /** filters out visits with current bed id null when true, filters out the ones with a bed when false */
  hasCurrentBed?: Maybe<Scalars['Boolean']>;
  includePlannedAdmissionUnitInUnitFilter?: Maybe<Scalars['Boolean']>;
  /** returns only visits that are on ward floor when true, does not do anything when false or null */
  onWardFloor?: Maybe<Scalars['Boolean']>;
  schedulePriorities?: Maybe<Array<Maybe<Patient_VisitSchedulePriority>>>;
  scheduleStatuses?: Maybe<Array<Maybe<Patient_VisitScheduleStatus>>>;
};

export type Patient_ListVisitsPaginatedRequestOutpatientFiltersMsg = {
  __typename?: 'patient_ListVisitsPaginatedRequestOutpatientFiltersMsg';
  activityStatuses?: Maybe<Array<Maybe<Patient_VisitActivityStatus>>>;
  /** Used for specifying which fields are considered for time frame filter. They are combined with OR-logic. */
  considerTargetTime?: Maybe<Scalars['Boolean']>;
  currentDesiredUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasTargetTime?: Maybe<Scalars['Boolean']>;
  roomIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Used for getting visits who has at least one of the specified time properties inside this time frame. */
  timeFrame?: Maybe<TimeFrameMsg>;
  triageLevelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_ListVisitsPaginatedResponse = {
  __typename?: 'patient_ListVisitsPaginatedResponse';
  hitCount?: Maybe<Scalars['Int']>;
  /** it's set if includeLastTreatmentDetails is set to true. */
  visitIdToLastTreatmentDetails?: Maybe<Array<Maybe<Patient_ListVisitsPaginatedResponse_VisitIdToLastTreatmentDetailsEntry>>>;
  visits?: Maybe<Array<Maybe<Patient_VisitMsg>>>;
};

export type Patient_ListVisitsPaginatedResponse_VisitIdToLastTreatmentDetailsEntry = {
  __typename?: 'patient_ListVisitsPaginatedResponse_VisitIdToLastTreatmentDetailsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Treatment_TreatmentBasicInfoMsg>;
};

/**
 * search by location, patient, status, a subset or all of them
 *  Note: either patientId, some administrative unit id, or some room id has to be provided
 */
export type Patient_ListVisitsRequest = {
  __typename?: 'patient_ListVisitsRequest';
  administrativeUnitIds?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  admissionTimeFrame?: Maybe<TimeFrameMsg>;
  billingCaseId?: Maybe<Scalars['String']>;
  /** optional filter */
  currentDesiredUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dischargeTimeFrame?: Maybe<TimeFrameMsg>;
  ignoreAbsences?: Maybe<Scalars['Boolean']>;
  /** optional */
  includeLastTreatmentDetails?: Maybe<Scalars['Boolean']>;
  includeLeadingUnitAssignments?: Maybe<Scalars['Boolean']>;
  includePlannedAdmission?: Maybe<Scalars['Boolean']>;
  includePlannedDischarge?: Maybe<Scalars['Boolean']>;
  leadingUnitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** optional (returns only visits in last x minutes) ignores onlyRecent */
  minutesToShow?: Maybe<Scalars['Int']>;
  /** Whether only the recent visits (currently: updated in past 8 hours) should be displayed */
  onlyRecent?: Maybe<Scalars['Boolean']>;
  /** optional */
  patientId?: Maybe<Scalars['String']>;
  registrationStatuses?: Maybe<Array<Maybe<Billing_RegistrationStatus>>>;
  registrationTimeFrame?: Maybe<TimeFrameMsg>;
  /** optional */
  roomIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** optional */
  statuses?: Maybe<Array<Maybe<Patient_VisitStatus>>>;
  /**
   * optional, if it's set along with includeLastTreatmentDetails it fetches the last treatment details of the given treatment type
   *  if it's not set it fetches the last treatment details without considering the treatmentType
   */
  treatmentType?: Maybe<Treatment_TreatmentType>;
  /** optional */
  types?: Maybe<Array<Maybe<Patient_VisitType>>>;
};

export type Patient_LongTermCareMsg = {
  __typename?: 'patient_LongTermCareMsg';
  id?: Maybe<Scalars['String']>;
  longTermRemedyDiagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  longTermRemedyDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  longTermRemedyFurtherDetails?: Maybe<Scalars['String']>;
  longTermRemedyNeed?: Maybe<Scalars['Boolean']>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  specialCareDiagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  specialCareDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  specialCareFurtherDetails?: Maybe<Scalars['String']>;
  specialCareNeed?: Maybe<Scalars['Boolean']>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export type Patient_MedicalQualificationMsg = {
  __typename?: 'patient_MedicalQualificationMsg';
  /**
   * Whether the qualification is marked as not a "standard", but an additional qualification;
   *  "Zusatzqualifikation" in German
   */
  additional?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalMedicalQualificationIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patient_OrganDonationCardMsg = {
  __typename?: 'patient_OrganDonationCardMsg';
  chosenForDonationOrgans?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  consent?: Maybe<Scalars['Boolean']>;
  creationDate?: Maybe<Timestamp>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  donationExceptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  storageLocation?: Maybe<Core_StorageLocationMsg>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export type Patient_PatientAbsenceEventMsg = {
  __typename?: 'patient_PatientAbsenceEventMsg';
  eventDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_PatientAbsenceStatus>;
  userId?: Maybe<Scalars['String']>;
};

/** Contains information about a patient absence, i.e., when a patient is still in the hospital's care, but outside their normal location/ward. */
export type Patient_PatientAbsenceMsg = {
  __typename?: 'patient_PatientAbsenceMsg';
  blockResource?: Maybe<Scalars['Boolean']>;
  blockUntil?: Maybe<Timestamp>;
  comment?: Maybe<Scalars['String']>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  events?: Maybe<Array<Maybe<Patient_PatientAbsenceEventMsg>>>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalPatientAbsenceIdMsg>>>;
  germanDetails?: Maybe<Patient_Registry_German_GermanPatientAbsenceDetailsMsg>;
  id?: Maybe<Scalars['String']>;
  /** both start and end are mandatory */
  plannedTimeFrame?: Maybe<PrecisionTimeFrameMsg>;
  /** at least one reason is mandatory */
  reasons?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  status?: Maybe<Patient_PatientAbsenceStatus>;
  /** Actual start, end of the absence */
  timeFrame?: Maybe<TimeFrameMsg>;
  /** Must be set on creation, cannot be changed afterwards */
  type?: Maybe<Patient_PatientAbsenceType>;
};

export enum Patient_PatientAbsenceStatus {
  PatientAbsenceStatusActive = 'PATIENT_ABSENCE_STATUS_ACTIVE',
  PatientAbsenceStatusCancelled = 'PATIENT_ABSENCE_STATUS_CANCELLED',
  PatientAbsenceStatusCompleted = 'PATIENT_ABSENCE_STATUS_COMPLETED',
  PatientAbsenceStatusDraft = 'PATIENT_ABSENCE_STATUS_DRAFT',
  PatientAbsenceStatusNone = 'PATIENT_ABSENCE_STATUS_NONE',
  PatientAbsenceStatusPlanned = 'PATIENT_ABSENCE_STATUS_PLANNED'
}

export enum Patient_PatientAbsenceType {
  /** Patient is still in the hospital's care, but outside their normal location/ward. */
  PatientAbsenceTypeAdHocAbsence = 'PATIENT_ABSENCE_TYPE_AD_HOC_ABSENCE',
  /**
   * Patient is admitted on the ward, but cannot receive surgery, that is why the patient is marked as absent.
   *  When the patient gets back to the hospital for the real admission, the absence ends.
   */
  PatientAbsenceTypeDelayedAdmission = 'PATIENT_ABSENCE_TYPE_DELAYED_ADMISSION',
  /** Patient care is paused due to the patient being outside of the hospital's care, but will resume later. */
  PatientAbsenceTypeHoliday = 'PATIENT_ABSENCE_TYPE_HOLIDAY',
  PatientAbsenceTypeNone = 'PATIENT_ABSENCE_TYPE_NONE'
}

export type Patient_PatientContextMsg = {
  __typename?: 'patient_PatientContextMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_PatientContextType>;
};

export enum Patient_PatientContextType {
  PatientContextTypeLab = 'PATIENT_CONTEXT_TYPE_LAB',
  PatientContextTypeNone = 'PATIENT_CONTEXT_TYPE_NONE',
  PatientContextTypeTelematikPatient = 'PATIENT_CONTEXT_TYPE_TELEMATIK_PATIENT'
}

export enum Patient_PatientDecision {
  PatientDecisionNone = 'PATIENT_DECISION_NONE',
  PatientDecisionUnwanted = 'PATIENT_DECISION_UNWANTED',
  PatientDecisionWanted = 'PATIENT_DECISION_WANTED'
}

export type Patient_PatientEventMsg = {
  __typename?: 'patient_PatientEventMsg';
  /** The context where the patient was created, if it is a non-synchronized patient */
  context?: Maybe<Patient_PatientContextMsg>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_PatientEventType>;
  userId?: Maybe<Scalars['String']>;
};

export enum Patient_PatientEventType {
  PatientEventTypeInitialCreation = 'PATIENT_EVENT_TYPE_INITIAL_CREATION',
  PatientEventTypeNone = 'PATIENT_EVENT_TYPE_NONE',
  PatientEventTypeRegistration = 'PATIENT_EVENT_TYPE_REGISTRATION',
  PatientEventTypeSynchronization = 'PATIENT_EVENT_TYPE_SYNCHRONIZATION'
}

export type Patient_PatientList = {
  __typename?: 'patient_PatientList';
  patients?: Maybe<Array<Maybe<Patient_PatientMsg>>>;
};

export type Patient_PatientMsg = {
  __typename?: 'patient_PatientMsg';
  alive?: Maybe<Scalars['Boolean']>;
  /** ISO Code Table iso3166-1-3 (3 letter country code) */
  birthCountryCode?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  /** Contact parties of the patient (e.g. emergency contacts) */
  contactParties?: Maybe<Array<Maybe<Patient_ContactPartyMsg>>>;
  /** only required when it is non-external, in which context the patient is created */
  context?: Maybe<Patient_PatientContextMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  dateOfBirthPrecision?: Maybe<TimePrecisionLevel>;
  dateOfBirthUnknown?: Maybe<Scalars['Boolean']>;
  declarationsOfConsent?: Maybe<Array<Maybe<Patient_DeclarationMsg>>>;
  denomination?: Maybe<Knowledge_DenominationMsg>;
  eventHistory?: Maybe<Array<Maybe<Patient_PatientEventMsg>>>;
  /** true if the patient need to be synced with external systems; false if the patient is only internal */
  external?: Maybe<Scalars['Boolean']>;
  externalClinics?: Maybe<Array<Maybe<Core_ExternalClinicMsg>>>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalPatientIdMsg>>>;
  flags?: Maybe<Array<Maybe<Core_FlagMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  legalInformation?: Maybe<Patient_LegalInformationMsg>;
  maritalStatus?: Maybe<Core_MaritalStatus>;
  name?: Maybe<Core_HumanNameMsg>;
  nationality?: Maybe<Core_KnowledgeInputMsg>;
  occupations?: Maybe<Array<Maybe<Patient_PatientOccupationMsg>>>;
  practitioners?: Maybe<Array<Maybe<Patient_PractitionerPatientRelationshipMsg>>>;
  privacyStatuses?: Maybe<Array<Maybe<Patient_PrivacyStatus>>>;
  sex?: Maybe<Core_Sex>;
  specialStatuses?: Maybe<Array<Maybe<Patient_PatientSpecialStatus>>>;
  timeOfDeath?: Maybe<PrecisionTimestampMsg>;
  timestamps?: Maybe<TimeMsg>;
};

export type Patient_PatientOccupationList = {
  __typename?: 'patient_PatientOccupationList';
  patientOccupations?: Maybe<Array<Maybe<Patient_PatientOccupationMsg>>>;
};

export type Patient_PatientOccupationMsg = {
  __typename?: 'patient_PatientOccupationMsg';
  coverageId?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  employer?: Maybe<Patient_ContactPartyMsg>;
  employment?: Maybe<Core_KnowledgeInputMsg>;
  employmentPeriod?: Maybe<PrecisionTimeFrameMsg>;
  id?: Maybe<Scalars['String']>;
  occupations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patient_EmploymentType>;
};

/** PatientMsg enhanced with information about the latest visit */
export type Patient_PatientResult = {
  __typename?: 'patient_PatientResult';
  lastVisitInformation?: Maybe<Patient_LastVisitInformation>;
  patient?: Maybe<Patient_PatientMsg>;
};

export type Patient_PatientResultList = {
  __typename?: 'patient_PatientResultList';
  /** number of search results (only relevant for paginated searches) */
  hitCount?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<Patient_PatientResult>>>;
};

export enum Patient_PatientSpecialStatus {
  PatientSpecialStatusEmployee = 'PATIENT_SPECIAL_STATUS_EMPLOYEE',
  PatientSpecialStatusNone = 'PATIENT_SPECIAL_STATUS_NONE',
  PatientSpecialStatusVip = 'PATIENT_SPECIAL_STATUS_VIP'
}

export type Patient_PatientUnit = {
  __typename?: 'patient_PatientUnit';
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_PowerOfAttorneyEntryMsg = {
  __typename?: 'patient_PowerOfAttorneyEntryMsg';
  creationDate?: Maybe<Timestamp>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inFavorOfList?: Maybe<Array<Maybe<Patient_ContactPartyMsg>>>;
  storageLocation?: Maybe<Core_StorageLocationMsg>;
};

export type Patient_PowerOfAttorneyMsg = {
  __typename?: 'patient_PowerOfAttorneyMsg';
  id?: Maybe<Scalars['String']>;
  powerOfAttorneyEntries?: Maybe<Array<Maybe<Patient_PowerOfAttorneyEntryMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  /** @deprecated deprecated in proto */
  timestamps?: Maybe<TimeMsg>;
  validation?: Maybe<Validation_ValidationMsg>;
};

export type Patient_PractitionerAssignmentMsg = {
  __typename?: 'patient_PractitionerAssignmentMsg';
  externalClinic?: Maybe<Core_ExternalClinicMsg>;
  id?: Maybe<Scalars['String']>;
  /** When the practitioner is available */
  regularAvailability?: Maybe<Array<Maybe<Core_DayOfWeekScheduleMsg>>>;
  /** Exceptions to the regular availability */
  specialAvailability?: Maybe<Array<Maybe<Core_DateScheduleMsg>>>;
};

export enum Patient_PractitionerDataSource {
  PractitionerDataSourceKbvColleaguesDb = 'PRACTITIONER_DATA_SOURCE_KBV_COLLEAGUES_DB',
  /** Manually created practitioner */
  PractitionerDataSourceManual = 'PRACTITIONER_DATA_SOURCE_MANUAL',
  PractitionerDataSourceNone = 'PRACTITIONER_DATA_SOURCE_NONE',
  PractitionerDataSourcePatientPortal = 'PRACTITIONER_DATA_SOURCE_PATIENT_PORTAL',
  /** Clinic's own practitioner database, typically includes practitioners from outside the clinic */
  PractitionerDataSourceReferrerDb = 'PRACTITIONER_DATA_SOURCE_REFERRER_DB'
}

export type Patient_PractitionerMsg = {
  __typename?: 'patient_PractitionerMsg';
  assignments?: Maybe<Array<Maybe<Patient_PractitionerAssignmentMsg>>>;
  contact?: Maybe<Core_ContactMsg>;
  /**
   * Options to take over an entry using a combined search:
   *   * KBV Kollegensuche database
   *   * Referrer database
   *   * Patient portal
   *   * Manual
   */
  dataSource?: Maybe<Patient_PractitionerDataSource>;
  dateOfBirth?: Maybe<Timestamp>;
  deleted?: Maybe<Scalars['Boolean']>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalPractitionerIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** ISO 639-2 alpha 3 */
  languageIsoCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the practitioner is a medical professional or not */
  medical?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Core_HumanNameMsg>;
  qualifications?: Maybe<Array<Maybe<Patient_MedicalQualificationMsg>>>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  sex?: Maybe<Core_Sex>;
  validity?: Maybe<TimeFrameMsg>;
};

/** In which roles the practitioner interacts with a specific patient */
export type Patient_PractitionerPatientRelationshipMsg = {
  __typename?: 'patient_PractitionerPatientRelationshipMsg';
  /**
   * The options for <roles> are:
   *    * General practitioner (dt. Hausarzt)
   *    * The subset of "Specialization(s) (dt. Fachgebiet(e))" which are selected in the Physicians (dt. Ärzte) > Expand of this
   *      respective entry
   */
  generalPractitioner?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  practitioner?: Maybe<Patient_PractitionerMsg>;
  /**
   * The specializations in the PractitionerMsg are all the specializations they have;
   *  these are the ones in which the practitioner treats the specific patient
   */
  specializations?: Maybe<Array<Maybe<Patient_MedicalQualificationMsg>>>;
};

export enum Patient_PrivacyStatus {
  PrivacyStatusNone = 'PRIVACY_STATUS_NONE',
  /** When a patient wants their location/room in the hospital kept private. Dt.: "Pförtnersperre" */
  PrivacyStatusPublicListBlock = 'PRIVACY_STATUS_PUBLIC_LIST_BLOCK',
  PrivacyStatusStaff = 'PRIVACY_STATUS_STAFF',
  PrivacyStatusVip = 'PRIVACY_STATUS_VIP'
}

export type Patient_ProfessionalGroupMsg = {
  __typename?: 'patient_ProfessionalGroupMsg';
  externalIds?: Maybe<Array<Maybe<Patient_ExternalMedicalQualificationIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patient_ReasonForIntroductionList = {
  __typename?: 'patient_ReasonForIntroductionList';
  reasonsForIntroduction?: Maybe<Array<Maybe<Patient_ReasonForIntroductionMsg>>>;
};

export type Patient_ReasonForIntroductionMsg = {
  __typename?: 'patient_ReasonForIntroductionMsg';
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Patient_ReferralMsg = {
  __typename?: 'patient_ReferralMsg';
  documentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalClinic?: Maybe<Core_ExternalClinicMsg>;
  id?: Maybe<Scalars['String']>;
  referrer?: Maybe<Patient_PractitionerMsg>;
};

export type Patient_RegisterVisitRequest = {
  __typename?: 'patient_RegisterVisitRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Patient_ExternalVisitIdMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** If set, always creates new visit regardless of existence of open visits, unless visitId is set */
  ignoreExistingVisits?: Maybe<Scalars['Boolean']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** If set and organizationalUnitId is not set, the organizationalUnitId of newly created visit is set from this visit's currentOrganizationalUnitId */
  organizationalUnitIdSourceVisitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  /** @deprecated deprecated in proto */
  setAdmissionDateToNow?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Patient_VisitType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_RoomMsg = {
  __typename?: 'patient_RoomMsg';
  capacity?: Maybe<Scalars['Int']>;
  flags?: Maybe<Array<Maybe<Core_FlagMsg>>>;
  /** Id of the room */
  id?: Maybe<Scalars['String']>;
  /** Name of the room */
  name?: Maybe<Scalars['String']>;
  /** OrganizationalUnit room is in */
  organizationalUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  resourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_RoomType>;
};

export enum Patient_RoomType {
  RoomTypeCare = 'ROOM_TYPE_CARE',
  RoomTypeDoctors = 'ROOM_TYPE_DOCTORS',
  RoomTypeInpatient = 'ROOM_TYPE_INPATIENT',
  RoomTypeNone = 'ROOM_TYPE_NONE',
  RoomTypeOutpatientCabin = 'ROOM_TYPE_OUTPATIENT_CABIN',
  RoomTypePatientAdmission = 'ROOM_TYPE_PATIENT_ADMISSION',
  RoomTypeWaiting = 'ROOM_TYPE_WAITING'
}

export type Patient_RoomsList = {
  __typename?: 'patient_RoomsList';
  rooms?: Maybe<Array<Maybe<Patient_RoomMsg>>>;
};

export type Patient_SearchContactPartiesRequest = {
  __typename?: 'patient_SearchContactPartiesRequest';
  /** optional filter */
  designation?: Maybe<Patient_ContactPartyDesignation>;
  /** the patient whose contact parties we search through */
  patientId?: Maybe<Scalars['String']>;
  scope?: Maybe<Patient_ContactPartyScopeReferenceMsg>;
  /** search text */
  text?: Maybe<Scalars['String']>;
};

export type Patient_SearchPatientsRequest = {
  __typename?: 'patient_SearchPatientsRequest';
  dateOfBirth?: Maybe<Timestamp>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Patient_SearchReasonsForIntroductionRequest = {
  __typename?: 'patient_SearchReasonsForIntroductionRequest';
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Patient_SetContactNumbersRequest = {
  __typename?: 'patient_SetContactNumbersRequest';
  landlineNumber?: Maybe<Core_PhoneNumberMsg>;
  mobileNumber?: Maybe<Core_PhoneNumberMsg>;
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_TransferVisitRequest = {
  __typename?: 'patient_TransferVisitRequest';
  targetOrganizationalUnitId?: Maybe<Scalars['String']>;
  targetRoomId?: Maybe<Scalars['String']>;
  targetStatus?: Maybe<Patient_VisitStatus>;
  targetUserId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_TriageSystemLevelMsg = {
  __typename?: 'patient_TriageSystemLevelMsg';
  colorCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Maximum waiting time until treatment in seconds */
  maximumWaitingTime?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  /** Target waiting time until treatment in seconds */
  targetWaitingTime?: Maybe<Scalars['Int']>;
};

export type Patient_TriageSystemMsg = {
  __typename?: 'patient_TriageSystemMsg';
  id?: Maybe<Scalars['String']>;
  levels?: Maybe<Array<Maybe<Patient_TriageSystemLevelMsg>>>;
  name?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patient_UnitVisitInfoMsg = {
  __typename?: 'patient_UnitVisitInfoMsg';
  patientId?: Maybe<Scalars['String']>;
};

export type Patient_UpdateAdditionalServicesAssignmentRequest = {
  __typename?: 'patient_UpdateAdditionalServicesAssignmentRequest';
  additionalServicesAssignment?: Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>;
  /** If not set to true, any synchronized flag on the assignment will be set to false */
  keepSynchronization?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Patient_UpdateAdditionalServicesAssignmentResponse = {
  __typename?: 'patient_UpdateAdditionalServicesAssignmentResponse';
  /** set if the time of additional service assignment is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_UpdateContactPartyRequest = {
  __typename?: 'patient_UpdateContactPartyRequest';
  contactParty?: Maybe<Patient_ContactPartyMsg>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Patient_UpdateLeadingUnitAssignmentRequest = {
  __typename?: 'patient_UpdateLeadingUnitAssignmentRequest';
  /** If not set to true, any synchronized flag on the assignment will be set to false */
  keepSynchronization?: Maybe<Scalars['Boolean']>;
  leadingUnitAssignment?: Maybe<Patient_LeadingUnitAssignmentMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Patient_UpdateLeadingUnitAssignmentResponse = {
  __typename?: 'patient_UpdateLeadingUnitAssignmentResponse';
  /** set if the time of leading unit assignment is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_UpdateLegalInfoValidationRequest = {
  __typename?: 'patient_UpdateLegalInfoValidationRequest';
  /** If there is an existing revision by another user, cancels it. */
  cancelExisting?: Maybe<Scalars['Boolean']>;
  /** If set, it means the validation is done by an external party. */
  externalValidator?: Maybe<Validation_ExternalValidator>;
  legalInfoType?: Maybe<Patient_LegalInfoType>;
  patientId?: Maybe<Scalars['String']>;
  /**
   * If this flag is set, the current validation gets undone and the data is changed to the previous revision.
   *  It can only be done within 5 minutes of the revision's activation.
   *  If this flag is not set, the validation is updated.
   *  If the last action is "reset", it can not be reset again.
   */
  reset?: Maybe<Scalars['Boolean']>;
  /** If there is an existing revision by another user, takes it over. */
  takeOverExisting?: Maybe<Scalars['Boolean']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_UpdateLegalInfoValidationResponse = {
  __typename?: 'patient_UpdateLegalInfoValidationResponse';
  careAidDisability?: Maybe<Patient_CareAidDisabilityMsg>;
  contactPartiesValidation?: Maybe<Patient_ContactPartiesValidationMsg>;
  invasiveProceduresLivingWill?: Maybe<Patient_InvasiveProceduresLivingWillMsg>;
  legalGuardianship?: Maybe<Patient_LegalGuardianshipMsg>;
  longTermCare?: Maybe<Patient_LongTermCareMsg>;
  organDonationCard?: Maybe<Patient_OrganDonationCardMsg>;
  powerOfAttorney?: Maybe<Patient_PowerOfAttorneyMsg>;
};

export type Patient_UpdatePatientAbsenceRequest = {
  __typename?: 'patient_UpdatePatientAbsenceRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  patientAbsence?: Maybe<Patient_PatientAbsenceMsg>;
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Patient_UpdatePatientAbsenceResponse = {
  __typename?: 'patient_UpdatePatientAbsenceResponse';
  patientAbsence?: Maybe<Patient_PatientAbsenceMsg>;
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
};

export type Patient_UpdatePatientOccupationRequest = {
  __typename?: 'patient_UpdatePatientOccupationRequest';
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  patientOccupation?: Maybe<Patient_PatientOccupationMsg>;
};

export type Patient_UpdatePatientRequest = {
  __typename?: 'patient_UpdatePatientRequest';
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  patient?: Maybe<Patient_PatientMsg>;
};

export type Patient_UpdateVisitActivityStatusRequest = {
  __typename?: 'patient_UpdateVisitActivityStatusRequest';
  patientUnit?: Maybe<Patient_PatientUnit>;
  /** required if user is called to a room that has not yet been specified in the visit */
  roomId?: Maybe<Scalars['String']>;
  status?: Maybe<Patient_VisitActivityStatus>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_UpdateVisitCaseRequest = {
  __typename?: 'patient_UpdateVisitCaseRequest';
  newBillingCaseId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_UpdateVisitRequest = {
  __typename?: 'patient_UpdateVisitRequest';
  /** Only allowed from gateway service */
  additionalServicesAssignmentIdsToUpdate?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Only allowed from gateway service; if set, triggers full create/update logic for new assignments (without id) and updated assignments defined by additionalServicesAssignmentIdsToUpdate */
  createOrUpdateAdditionalServicesAssignments?: Maybe<Scalars['Boolean']>;
  /** Only allowed from gateway service; if set, triggers full create/update logic for new assignments (without id) and updated assignments defined by leadingUnitAssignmentIdsToUpdate */
  createOrUpdateLeadingUnitAssignments?: Maybe<Scalars['Boolean']>;
  /**
   * Means the source of the write operation is an external system.
   *  The published kafka message should have this information on its headers.
   */
  externalWrite?: Maybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  ignoreLock?: Maybe<Scalars['Boolean']>;
  /** Only allowed from gateway service */
  leadingUnitAssignmentIdsToUpdate?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If set to true, only id will be set in PatientMsg in response message */
  omitFullPatient?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  resourceAllocationParameters?: Maybe<Patient_VisitResourceAllocationParametersMsg>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_UpdateVisitResponse = {
  __typename?: 'patient_UpdateVisitResponse';
  /** set if the times of admission, discharge, transfers and absences are not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  visit?: Maybe<Patient_VisitMsg>;
  visitResourceAllocationResponse?: Maybe<Patient_VisitResourceAllocationResponse>;
};

export type Patient_UpdateVisitStatusRequest = {
  __typename?: 'patient_UpdateVisitStatusRequest';
  externalStatusUpdate?: Maybe<Scalars['Boolean']>;
  patientUnit?: Maybe<Patient_PatientUnit>;
  reactivateVisit?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Patient_VisitStatus>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_UpdateVisitStatusesOfCaseRequest = {
  __typename?: 'patient_UpdateVisitStatusesOfCaseRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  cancelVisits?: Maybe<Scalars['Boolean']>;
  reactivateVisits?: Maybe<Scalars['Boolean']>;
};

export type Patient_UpdateVisitStatusesOfCaseResponse = {
  __typename?: 'patient_UpdateVisitStatusesOfCaseResponse';
  updatedVisitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_UpdateVisitTransferRequest = {
  __typename?: 'patient_UpdateVisitTransferRequest';
  blockEnd?: Maybe<Timestamp>;
  /** the flag is used only during transfer completion */
  blockResource?: Maybe<Scalars['Boolean']>;
  /**
   * will set keepSynchronization=false for linked leading unit & additional services assignments
   *  only relevant for already confirmed transfers
   */
  cancelSynchronization?: Maybe<Scalars['Boolean']>;
  /**
   * should be set in case overbooking is desired, however currently contingentAssignment is reserved separately
   *  so this flag should not be used during initial resource allocation
   */
  overrideContingents?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  visitTransfer?: Maybe<Patient_VisitTransferMsg>;
};

export type Patient_UpdateVisitTransferResponse = {
  __typename?: 'patient_UpdateVisitTransferResponse';
  /** set if the time of transfer is not valid */
  timeValidationErrors?: Maybe<Array<Maybe<Patient_VisitTimeValidationError>>>;
  /** only set after transfer completion, as that changes visit */
  visit?: Maybe<Patient_VisitMsg>;
  visitTransfer?: Maybe<Patient_VisitTransferMsg>;
};

export type Patient_ValidateTreatmentLegalInfosRequest = {
  __typename?: 'patient_ValidateTreatmentLegalInfosRequest';
  patientId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_ValidateTreatmentLegalInfosResponse = {
  __typename?: 'patient_ValidateTreatmentLegalInfosResponse';
  _?: Maybe<Scalars['String']>;
};

/**
 * This represents a change of a visit activity status to the VisitActivityStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Patient_VisitActivityEventMsg = {
  __typename?: 'patient_VisitActivityEventMsg';
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patient_VisitActivityStatus>;
  userId?: Maybe<Scalars['String']>;
};

export enum Patient_VisitActivityStatus {
  /** Patient was already treated (either internal or external), now waiting for further treatment */
  VisitActivityStatusAwaitingFurtherTreatment = 'VISIT_ACTIVITY_STATUS_AWAITING_FURTHER_TREATMENT',
  /** Patient was called for treatment or registration */
  VisitActivityStatusCalled = 'VISIT_ACTIVITY_STATUS_CALLED',
  /** Patient is currently treated somewhere else, will return for further treatment */
  VisitActivityStatusInExternalTreatment = 'VISIT_ACTIVITY_STATUS_IN_EXTERNAL_TREATMENT',
  /** Patient currently gets medically treated */
  VisitActivityStatusInTreatment = 'VISIT_ACTIVITY_STATUS_IN_TREATMENT',
  VisitActivityStatusNone = 'VISIT_ACTIVITY_STATUS_NONE',
  /** Patient was set to wait after being called */
  VisitActivityStatusParked = 'VISIT_ACTIVITY_STATUS_PARKED',
  /** Patient is waiting to be called for treatment */
  VisitActivityStatusWaiting = 'VISIT_ACTIVITY_STATUS_WAITING'
}

/**
 * This represents a change of a visit discharge status to the VisitDischargeStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Patient_VisitDischargeEventMsg = {
  __typename?: 'patient_VisitDischargeEventMsg';
  id?: Maybe<Scalars['String']>;
  plannedDischargeDate?: Maybe<VeiosDateTimeMsg>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patient_VisitDischargeStatus>;
  userId?: Maybe<Scalars['String']>;
};

export enum Patient_VisitDischargeStatus {
  VisitDischargeStatusCompleted = 'VISIT_DISCHARGE_STATUS_COMPLETED',
  VisitDischargeStatusNone = 'VISIT_DISCHARGE_STATUS_NONE',
  VisitDischargeStatusPlanned = 'VISIT_DISCHARGE_STATUS_PLANNED'
}

/**
 * This represents a change of a visit status to the VisitStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Patient_VisitEventMsg = {
  __typename?: 'patient_VisitEventMsg';
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  eventOrigin?: Maybe<Patient_VisitEventOriginType>;
  id?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patient_VisitStatus>;
  userId?: Maybe<Scalars['String']>;
};

export enum Patient_VisitEventOriginType {
  VisitEventOriginTypeBillingCase = 'VISIT_EVENT_ORIGIN_TYPE_BILLING_CASE',
  VisitEventOriginTypeNone = 'VISIT_EVENT_ORIGIN_TYPE_NONE'
}

export type Patient_VisitFinishDateMsg = {
  __typename?: 'patient_VisitFinishDateMsg';
  finishDate?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_VisitForInvoiceInfoMsg = {
  __typename?: 'patient_VisitForInvoiceInfoMsg';
  allowedToBeLinked?: Maybe<Scalars['Boolean']>;
  visit?: Maybe<Patient_VisitMsg>;
};

export type Patient_VisitForInvoiceList = {
  __typename?: 'patient_VisitForInvoiceList';
  visitsForInvoice?: Maybe<Array<Maybe<Patient_VisitForInvoiceInfoMsg>>>;
};

export type Patient_VisitIdList = {
  __typename?: 'patient_VisitIdList';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_VisitIdToAdditionalServiceMap = {
  __typename?: 'patient_VisitIdToAdditionalServiceMap';
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Patient_VisitIdToPatientSexMap = {
  __typename?: 'patient_VisitIdToPatientSexMap';
  sex?: Maybe<Core_Sex>;
  visitId?: Maybe<Scalars['String']>;
};

/** TODO rename maybe */
export type Patient_VisitLinkedProcessReferenceMsg = {
  __typename?: 'patient_VisitLinkedProcessReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_VisitLinkedProcessType>;
};

export enum Patient_VisitLinkedProcessType {
  VisitLinkedProcessTypeAppointment = 'VISIT_LINKED_PROCESS_TYPE_APPOINTMENT',
  VisitLinkedProcessTypeClinicalRequest = 'VISIT_LINKED_PROCESS_TYPE_CLINICAL_REQUEST',
  VisitLinkedProcessTypeNone = 'VISIT_LINKED_PROCESS_TYPE_NONE',
  VisitLinkedProcessTypeSurgeryRequest = 'VISIT_LINKED_PROCESS_TYPE_SURGERY_REQUEST'
}

/** todo: create message ListVisitsResponse and put the visitIdToLastTreatmentDetails in it */
export type Patient_VisitList = {
  __typename?: 'patient_VisitList';
  visitIdToLastTreatmentDetails?: Maybe<Array<Maybe<Patient_VisitList_VisitIdToLastTreatmentDetailsEntry>>>;
  visits?: Maybe<Array<Maybe<Patient_VisitMsg>>>;
};

export type Patient_VisitList_VisitIdToLastTreatmentDetailsEntry = {
  __typename?: 'patient_VisitList_VisitIdToLastTreatmentDetailsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Treatment_TreatmentBasicInfoMsg>;
};

/** A visit is an event in which a patient comes to a clinic to receive a treatment */
export type Patient_VisitMsg = {
  __typename?: 'patient_VisitMsg';
  activityEvents?: Maybe<Array<Maybe<Patient_VisitActivityEventMsg>>>;
  activityStatus?: Maybe<Patient_VisitActivityStatus>;
  /** Additional information about the visit */
  additionalInformation?: Maybe<Scalars['String']>;
  /** it represents the current/latest additional services from the additional service assignment history, it's not saved */
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
  additionalServicesAssignments?: Maybe<Array<Maybe<Patient_Registry_AdditionalServicesAssignmentMsg>>>;
  /** Id of appointment (if exists) */
  appointmentId?: Maybe<Scalars['String']>;
  /** Users for whom the visit is relevant, can be used to track visits currently outside the user's ward */
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingCaseId?: Maybe<Scalars['String']>;
  creatorUserId?: Maybe<Scalars['String']>;
  /** The userId of the employee the client wants to see */
  currentDesiredUserId?: Maybe<Scalars['String']>;
  /** Number the patient is being called with */
  currentNumber?: Maybe<Scalars['Int']>;
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** Room the visitor is currently in */
  currentRoom?: Maybe<Patient_RoomMsg>;
  currentRoomId?: Maybe<Scalars['String']>;
  currentVisitType?: Maybe<Patient_VisitType>;
  dischargeEvents?: Maybe<Array<Maybe<Patient_VisitDischargeEventMsg>>>;
  dischargeStatus?: Maybe<Patient_VisitDischargeStatus>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalVisitIdMsg>>>;
  /** optional, only if billing case type is BG */
  germanBgDetails?: Maybe<Patient_GermanVisitBgDetailsMsg>;
  id?: Maybe<Scalars['String']>;
  /** TODO reason for admission -> can be a link to other objects I guess */
  infectionExists?: Maybe<Core_BoolUnknown>;
  infections?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  initialFinishDate?: Maybe<Timestamp>;
  isolationExists?: Maybe<Core_BoolUnknown>;
  isolations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  leadingUnitAssignments?: Maybe<Array<Maybe<Patient_LeadingUnitAssignmentMsg>>>;
  /** it represents the current/latest leading unit from the unit assignment history, it's not saved */
  leadingUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  level?: Maybe<Patient_TriageSystemLevelMsg>;
  /**
   * TODO BedType needs to be modeled
   *  TODO special requirements needs to be modeled
   */
  linkedProcesses?: Maybe<Array<Maybe<Patient_VisitLinkedProcessReferenceMsg>>>;
  /** Id of the office hour (if exists) */
  officeHourId?: Maybe<Scalars['String']>;
  organizationalUnitIdOnRegistration?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient_PatientMsg>;
  /**
   * IDs of documents with which the patient gets registered
   *  Note: Referral document IDs are saved in the respective ReferralMsg
   */
  patientDocumentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reasons for visit */
  reasonsForIntroduction?: Maybe<Array<Maybe<Scalars['String']>>>;
  referrals?: Maybe<Array<Maybe<Patient_ReferralMsg>>>;
  referred?: Maybe<Scalars['Boolean']>;
  registrationStatus?: Maybe<Billing_RegistrationStatus>;
  /** TODO: Streamline redundancy with targetTime */
  schedule?: Maybe<Patient_VisitScheduleMsg>;
  status?: Maybe<Patient_VisitStatus>;
  tags?: Maybe<Array<Maybe<Patient_VisitTag>>>;
  /** Appointment time entered by patient */
  targetTime?: Maybe<Timestamp>;
  timestamps?: Maybe<TimeMsg>;
  transfers?: Maybe<Array<Maybe<Patient_VisitTransferMsg>>>;
  visitEvents?: Maybe<Array<Maybe<Patient_VisitEventMsg>>>;
};

export type Patient_VisitResourceAllocationParametersMsg = {
  __typename?: 'patient_VisitResourceAllocationParametersMsg';
  blockEnd?: Maybe<Timestamp>;
  blockResource?: Maybe<Scalars['Boolean']>;
  /**
   * if true, a temporary resource will be created with the data in temporaryResourceDefinition,
   *  the resource in the assignment will be ignored
   */
  createTemporaryResource?: Maybe<Scalars['Boolean']>;
  /** this flag can be set to assign a resource forcibly for this visit (when resource is occupied) */
  forceAssignment?: Maybe<Scalars['Boolean']>;
  /** this flag can be set to unassign a resource forcibly for this visit without discharging the patient */
  forceResourceRemoval?: Maybe<Scalars['Boolean']>;
  /** if a new resource is expected to be allocated to the visit */
  newResourceId?: Maybe<Scalars['String']>;
  overrideConstraints?: Maybe<Scalars['Boolean']>;
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** if set to true, aborts contingent allocation */
  removeContingentAllocation?: Maybe<Scalars['Boolean']>;
  /**
   * if there is a resource assignment and we want to remove it, works for reserved beds all the time
   *  however a patient occupied bed can not be freed without discharging
   */
  removeResource?: Maybe<Scalars['Boolean']>;
  /**
   * if a contingent assignment was already reserved for a visit
   *  this id can be given to update that assignment
   */
  reservedContingentAssignmentId?: Maybe<Scalars['String']>;
  /**
   * if a static resource assignment was already reserved for a visit
   *  this id can be given to cancel that assignment
   */
  reservedStaticResourceAssignmentId?: Maybe<Scalars['String']>;
  /** If set, ignores all conditions and does not do any resource/contingent allocation; used e.g., if schedule draft is sent to scheduling staff */
  skipResourceAllocation?: Maybe<Scalars['Boolean']>;
  /**
   * if a resource is being allocated for a resource, this type can be set to choose
   *  type of the assignment (RESERVED or OCCUPIED)
   *  default is occupied
   */
  staticResourceAssignmentType?: Maybe<Resource_StaticResourceAssignmentType>;
  /**
   * if the new resource is full during reallocation,
   *  this flag can be set to swap the assignments in respective resources
   */
  swapIfFull?: Maybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: Maybe<Resource_TemporaryResourceDefinitionMsg>;
};

/** a message that holds all possible response fields due to resource allocation changes */
export type Patient_VisitResourceAllocationResponse = {
  __typename?: 'patient_VisitResourceAllocationResponse';
  /** when this allocation results in multiple assignments being modified */
  assignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
  /**
   * Redundant information - if there is no warning, the resource allocation was successful
   * @deprecated deprecated in proto
   */
  granted?: Maybe<Scalars['Boolean']>;
  warning?: Maybe<Resource_RequestStaticResourceWarning>;
};

export enum Patient_VisitResourceAllocationType {
  BookContingent = 'BookContingent',
  BookStaticResource = 'BookStaticResource',
  BookTemporaryStaticResource = 'BookTemporaryStaticResource',
  None = 'None',
  RemoveContingent = 'RemoveContingent'
}

/**
 * This represents a change of a visit schedule status to the VisitScheduleStatus in the field "type".
 *  Useful for tracking the duration of each step.
 */
export type Patient_VisitScheduleEventMsg = {
  __typename?: 'patient_VisitScheduleEventMsg';
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patient_VisitScheduleStatus>;
  userId?: Maybe<Scalars['String']>;
};

export type Patient_VisitScheduleInfoMsg = {
  __typename?: 'patient_VisitScheduleInfoMsg';
  finalAdmissionDate?: Maybe<Timestamp>;
  finalDischargeDate?: Maybe<Timestamp>;
  firstPlannedAdmissionDate?: Maybe<Timestamp>;
  firstStartDate?: Maybe<Timestamp>;
  lastPlannedAdmissionDate?: Maybe<Timestamp>;
  lastStartDate?: Maybe<Timestamp>;
  notYetDischarged?: Maybe<Scalars['Boolean']>;
  plannedDischargeDate?: Maybe<Timestamp>;
};

export type Patient_VisitScheduleMsg = {
  __typename?: 'patient_VisitScheduleMsg';
  absences?: Maybe<Array<Maybe<Patient_PatientAbsenceMsg>>>;
  admissionDate?: Maybe<Timestamp>;
  admissionTimeOfDay?: Maybe<TimeOfDayMsg>;
  /** use if the assignment sex differs from patient sex */
  assignmentSex?: Maybe<Resource_AssignmentSex>;
  comment?: Maybe<Scalars['String']>;
  contingentHolderId?: Maybe<Scalars['String']>;
  currentContingentAssignmentId?: Maybe<Scalars['String']>;
  /**
   * set if this visit currently has a bed assigned
   *  is set automatically by the backend, unmodifiable by frontend
   */
  currentStaticResourceAssignmentId?: Maybe<Scalars['String']>;
  dischargeDate?: Maybe<Timestamp>;
  /** Duration from admission to planned discharge date */
  durationAtPlannedDischargeInDays?: Maybe<Scalars['Int']>;
  /** Duration from admission to discharge date or now (if discharge is not set) */
  durationInDays?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<Maybe<Patient_VisitScheduleEventMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** relevant only in the case of visit transfers */
  oldContingentAssignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** relevant only in the case of visit transfers */
  oldStaticResourceAssignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** set by the backend if the allocated resource is on ward floor instead of room */
  onWardFloor?: Maybe<Scalars['Boolean']>;
  /** Can be in the future as well */
  plannedAdmissionDate?: Maybe<VeiosDateTimeMsg>;
  plannedAdmissionOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** Can be in the future as well */
  plannedDischargeDate?: Maybe<VeiosDateTimeMsg>;
  priority?: Maybe<Patient_VisitSchedulePriority>;
  reasonForAdmission?: Maybe<Scalars['String']>;
  /** Can be in the future as well */
  registrationDate?: Maybe<Timestamp>;
  requestedTimeFrameEnd?: Maybe<Timestamp>;
  requestedTimeFrameStart?: Maybe<Timestamp>;
  status?: Maybe<Patient_VisitScheduleStatus>;
};

export enum Patient_VisitSchedulePriority {
  VisitSchedulePriorityHigh = 'VISIT_SCHEDULE_PRIORITY_HIGH',
  VisitSchedulePriorityLow = 'VISIT_SCHEDULE_PRIORITY_LOW',
  VisitSchedulePriorityNone = 'VISIT_SCHEDULE_PRIORITY_NONE',
  VisitSchedulePriorityNormal = 'VISIT_SCHEDULE_PRIORITY_NORMAL'
}

export enum Patient_VisitScheduleStatus {
  VisitScheduleStatusNone = 'VISIT_SCHEDULE_STATUS_NONE',
  VisitScheduleStatusRequested = 'VISIT_SCHEDULE_STATUS_REQUESTED',
  VisitScheduleStatusScheduled = 'VISIT_SCHEDULE_STATUS_SCHEDULED',
  VisitScheduleStatusUnscheduled = 'VISIT_SCHEDULE_STATUS_UNSCHEDULED'
}

export type Patient_VisitSelectorMsg = {
  __typename?: 'patient_VisitSelectorMsg';
  includeLeadingUnitAssignments?: Maybe<Scalars['Boolean']>;
};

export type Patient_VisitStartDateMsg = {
  __typename?: 'patient_VisitStartDateMsg';
  startDate?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Patient_VisitStatus {
  /** Visit is ongoing in the hospital's care */
  VisitStatusActive = 'VISIT_STATUS_ACTIVE',
  /** In addition to all medical treatment and documentation, all administrative documentation is also completed */
  VisitStatusAdministrativelyCompleted = 'VISIT_STATUS_ADMINISTRATIVELY_COMPLETED',
  VisitStatusCancelled = 'VISIT_STATUS_CANCELLED',
  /** Visit creation is unfinished */
  VisitStatusDraft = 'VISIT_STATUS_DRAFT',
  /** All medical treatment and documentation is completed */
  VisitStatusMedicallyCompleted = 'VISIT_STATUS_MEDICALLY_COMPLETED',
  VisitStatusNone = 'VISIT_STATUS_NONE',
  /** Visit is planned for the future */
  VisitStatusPlanned = 'VISIT_STATUS_PLANNED'
}

export type Patient_VisitStatusInfoMsg = {
  __typename?: 'patient_VisitStatusInfoMsg';
  visitId?: Maybe<Scalars['String']>;
  visitStatus?: Maybe<Patient_VisitStatus>;
  visitType?: Maybe<Patient_VisitType>;
};

export enum Patient_VisitTag {
  VisitTagNone = 'VISIT_TAG_NONE',
  /** Visit must not be modified in our system. Happens e.g., when visits are imported from other system for overview/statistical purposes. */
  VisitTagReadOnly = 'VISIT_TAG_READ_ONLY'
}

export enum Patient_VisitTimeValidationError {
  VisitTimeValidationErrorAbsenceEndsAfterDischarge = 'VISIT_TIME_VALIDATION_ERROR_ABSENCE_ENDS_AFTER_DISCHARGE',
  VisitTimeValidationErrorAbsencePlannedTimeFromBeforeNow = 'VISIT_TIME_VALIDATION_ERROR_ABSENCE_PLANNED_TIME_FROM_BEFORE_NOW',
  VisitTimeValidationErrorAbsencePlannedTimeUntilBeforePlannedTimeFrom = 'VISIT_TIME_VALIDATION_ERROR_ABSENCE_PLANNED_TIME_UNTIL_BEFORE_PLANNED_TIME_FROM',
  VisitTimeValidationErrorAbsenceStartsBeforeAdmission = 'VISIT_TIME_VALIDATION_ERROR_ABSENCE_STARTS_BEFORE_ADMISSION',
  VisitTimeValidationErrorAdmissionInFuture = 'VISIT_TIME_VALIDATION_ERROR_ADMISSION_IN_FUTURE',
  VisitTimeValidationErrorAdmissionNotBeforeDischarge = 'VISIT_TIME_VALIDATION_ERROR_ADMISSION_NOT_BEFORE_DISCHARGE',
  VisitTimeValidationErrorDischargeInFuture = 'VISIT_TIME_VALIDATION_ERROR_DISCHARGE_IN_FUTURE',
  VisitTimeValidationErrorDischargeSetWithoutAdmission = 'VISIT_TIME_VALIDATION_ERROR_DISCHARGE_SET_WITHOUT_ADMISSION',
  VisitTimeValidationErrorNone = 'VISIT_TIME_VALIDATION_ERROR_NONE',
  VisitTimeValidationErrorOverlappingAbsences = 'VISIT_TIME_VALIDATION_ERROR_OVERLAPPING_ABSENCES',
  VisitTimeValidationErrorOverlappingAbsenceAndAdditionalServiceAssignment = 'VISIT_TIME_VALIDATION_ERROR_OVERLAPPING_ABSENCE_AND_ADDITIONAL_SERVICE_ASSIGNMENT',
  VisitTimeValidationErrorOverlappingAbsenceAndLeadingUnitAssignment = 'VISIT_TIME_VALIDATION_ERROR_OVERLAPPING_ABSENCE_AND_LEADING_UNIT_ASSIGNMENT',
  VisitTimeValidationErrorOverlappingAbsenceAndTransfer = 'VISIT_TIME_VALIDATION_ERROR_OVERLAPPING_ABSENCE_AND_TRANSFER',
  VisitTimeValidationErrorTransferAfterDischarge = 'VISIT_TIME_VALIDATION_ERROR_TRANSFER_AFTER_DISCHARGE',
  VisitTimeValidationErrorTransferBeforeAdmission = 'VISIT_TIME_VALIDATION_ERROR_TRANSFER_BEFORE_ADMISSION',
  VisitTimeValidationErrorTransferPlannedTimeBeforeNow = 'VISIT_TIME_VALIDATION_ERROR_TRANSFER_PLANNED_TIME_BEFORE_NOW'
}

export type Patient_VisitTransferEventMsg = {
  __typename?: 'patient_VisitTransferEventMsg';
  eventDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_VisitTransferStatus>;
  userId?: Maybe<Scalars['String']>;
};

export type Patient_VisitTransferMsg = {
  __typename?: 'patient_VisitTransferMsg';
  assignmentSex?: Maybe<Resource_AssignmentSex>;
  contingentAssignmentId?: Maybe<Scalars['String']>;
  desiredTransferTime?: Maybe<Timestamp>;
  desiredTransferTimeFrame?: Maybe<TimeFrameMsg>;
  events?: Maybe<Array<Maybe<Patient_VisitTransferEventMsg>>>;
  externalIds?: Maybe<Array<Maybe<Patient_ExternalVisitTransferIdMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** On transfer completion, will override its visit's contingentHolderId */
  newContingentHolderId?: Maybe<Scalars['String']>;
  /** Comment for occupancy management in case draft is sent to occupancy manager */
  occupancyManagementDetails?: Maybe<Scalars['String']>;
  originDepartmentId?: Maybe<Scalars['String']>;
  originOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** On transfer confirmation, will override its visit's schedule's plannedDischargeDate */
  plannedDischargeDate?: Maybe<VeiosDateTimeMsg>;
  /** Used by FE to find possible slots; no further use in BE, as BE uses plannedTransferTime, plannedDischargeDate */
  plannedRemainingDaysAfterTransfer?: Maybe<Scalars['Int']>;
  plannedTransferTime?: Maybe<Timestamp>;
  priority?: Maybe<Patient_VisitTransferPriority>;
  reasonForTransfer?: Maybe<Core_KnowledgeInputMsg>;
  /** set when transfer created within the history in the past */
  simpleTransfer?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Patient_VisitTransferStatus>;
  targetOrganizationalUnitId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  /** actual transfer time, set by backend when the transfer is completed */
  transferTime?: Maybe<Timestamp>;
};

export enum Patient_VisitTransferPriority {
  VisitTransferPriorityEmergency = 'VISIT_TRANSFER_PRIORITY_EMERGENCY',
  VisitTransferPriorityNone = 'VISIT_TRANSFER_PRIORITY_NONE',
  VisitTransferPriorityNormal = 'VISIT_TRANSFER_PRIORITY_NORMAL',
  VisitTransferPriorityUrgent = 'VISIT_TRANSFER_PRIORITY_URGENT'
}

export enum Patient_VisitTransferStatus {
  VisitTransferStatusCancelled = 'VISIT_TRANSFER_STATUS_CANCELLED',
  /** Patient arrived at target location */
  VisitTransferStatusCompleted = 'VISIT_TRANSFER_STATUS_COMPLETED',
  VisitTransferStatusDraft = 'VISIT_TRANSFER_STATUS_DRAFT',
  VisitTransferStatusNone = 'VISIT_TRANSFER_STATUS_NONE',
  VisitTransferStatusPlanned = 'VISIT_TRANSFER_STATUS_PLANNED',
  /** Draft submitted to occupancy management */
  VisitTransferStatusSubmittedDraft = 'VISIT_TRANSFER_STATUS_SUBMITTED_DRAFT'
}

export enum Patient_VisitType {
  VisitTypeInpatient = 'VISIT_TYPE_INPATIENT',
  VisitTypeNone = 'VISIT_TYPE_NONE',
  VisitTypeOutpatient = 'VISIT_TYPE_OUTPATIENT',
  VisitTypePostInpatient = 'VISIT_TYPE_POST_INPATIENT',
  VisitTypePreInpatient = 'VISIT_TYPE_PRE_INPATIENT',
  VisitTypeSemiInpatient = 'VISIT_TYPE_SEMI_INPATIENT',
  VisitTypeSurgery = 'VISIT_TYPE_SURGERY'
}

export type Patient_VisitUnitAssignmentMsg = {
  __typename?: 'patient_VisitUnitAssignmentMsg';
  /** end date can be empty */
  endDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Timestamp>;
};

export type Patient_Registry_AdditionalServiceMsg = {
  __typename?: 'patient_registry_AdditionalServiceMsg';
  /** Additional service can be assigned only to visits in these units */
  assignedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** External identifiers that are mapped */
  mappedExternalIds?: Maybe<Array<Maybe<Patient_Registry_ExternalAdditionalServiceIdMsg>>>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  possibleCaseTypes?: Maybe<Array<Maybe<Billing_BillingCaseType>>>;
  /** Additional service can be assigned only to visits of these types */
  possibleVisitTypes?: Maybe<Array<Maybe<Patient_VisitType>>>;
  referenceId?: Maybe<Scalars['String']>;
  status?: Maybe<Patient_Registry_AdditionalServiceStatus>;
  timestamps?: Maybe<TimeMsg>;
  /** Allows categorizing the service */
  types?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceType>>>;
};

export enum Patient_Registry_AdditionalServiceStatus {
  AdditionalServiceStatusActive = 'ADDITIONAL_SERVICE_STATUS_ACTIVE',
  AdditionalServiceStatusInactive = 'ADDITIONAL_SERVICE_STATUS_INACTIVE',
  AdditionalServiceStatusNone = 'ADDITIONAL_SERVICE_STATUS_NONE',
  AdditionalServiceStatusNotYetActive = 'ADDITIONAL_SERVICE_STATUS_NOT_YET_ACTIVE'
}

export enum Patient_Registry_AdditionalServiceType {
  AdditionalServiceTypeDoctor = 'ADDITIONAL_SERVICE_TYPE_DOCTOR',
  AdditionalServiceTypeNone = 'ADDITIONAL_SERVICE_TYPE_NONE',
  AdditionalServiceTypeRoom = 'ADDITIONAL_SERVICE_TYPE_ROOM'
}

export type Patient_Registry_AdditionalServicesAssignmentMsg = {
  __typename?: 'patient_registry_AdditionalServicesAssignmentMsg';
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** If set, marks connection to place where this assignment was created from */
  origin?: Maybe<Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg>;
  startTime?: Maybe<Timestamp>;
  status?: Maybe<Patient_Registry_AdditionalServicesAssignmentStatus>;
  /** If set, a change in the origin (e.g., change of time, cancellation) will also be reflected in this assignment */
  synchronizedToOrigin?: Maybe<Scalars['Boolean']>;
};

export type Patient_Registry_AdditionalServicesAssignmentOriginReferenceMsg = {
  __typename?: 'patient_registry_AdditionalServicesAssignmentOriginReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Patient_Registry_AdditionalServicesAssignmentOriginType>;
};

export enum Patient_Registry_AdditionalServicesAssignmentOriginType {
  AdditionalServicesAssignmentOriginTypeNone = 'ADDITIONAL_SERVICES_ASSIGNMENT_ORIGIN_TYPE_NONE',
  AdditionalServicesAssignmentOriginTypeVisitTransfer = 'ADDITIONAL_SERVICES_ASSIGNMENT_ORIGIN_TYPE_VISIT_TRANSFER'
}

export enum Patient_Registry_AdditionalServicesAssignmentStatus {
  AdditionalServicesAssignmentStatusConfirmed = 'ADDITIONAL_SERVICES_ASSIGNMENT_STATUS_CONFIRMED',
  AdditionalServicesAssignmentStatusDraft = 'ADDITIONAL_SERVICES_ASSIGNMENT_STATUS_DRAFT',
  AdditionalServicesAssignmentStatusNone = 'ADDITIONAL_SERVICES_ASSIGNMENT_STATUS_NONE',
  AdditionalServicesAssignmentStatusPlanned = 'ADDITIONAL_SERVICES_ASSIGNMENT_STATUS_PLANNED'
}

export type Patient_Registry_DeleteAdditionalServiceRequest = {
  __typename?: 'patient_registry_DeleteAdditionalServiceRequest';
  additionalServiceId?: Maybe<Scalars['String']>;
};

export type Patient_Registry_DeleteAdditionalServiceResponse = {
  __typename?: 'patient_registry_DeleteAdditionalServiceResponse';
  deletedAdditionalServiceId?: Maybe<Scalars['String']>;
};

export type Patient_Registry_ExternalAdditionalServiceIdMsg = {
  __typename?: 'patient_registry_ExternalAdditionalServiceIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Patient_Registry_FindAdditionalServiceRequest = {
  __typename?: 'patient_registry_FindAdditionalServiceRequest';
  referenceId?: Maybe<Scalars['String']>;
};

export type Patient_Registry_FindAdditionalServiceResponse = {
  __typename?: 'patient_registry_FindAdditionalServiceResponse';
  additionalService?: Maybe<Patient_Registry_AdditionalServiceMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Patient_Registry_GetAdditionalServicesRequest = {
  __typename?: 'patient_registry_GetAdditionalServicesRequest';
  additionalServiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patient_Registry_GetAdditionalServicesResponse = {
  __typename?: 'patient_registry_GetAdditionalServicesResponse';
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
};

export type Patient_Registry_ListAdditionalServicesRequest = {
  __typename?: 'patient_registry_ListAdditionalServicesRequest';
  caseType?: Maybe<Billing_BillingCaseType>;
  externalId?: Maybe<Scalars['String']>;
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Patient_Registry_ListAdditionalServicesResponse = {
  __typename?: 'patient_registry_ListAdditionalServicesResponse';
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
};

export type Patient_Registry_SearchAdditionalServicesRequest = {
  __typename?: 'patient_registry_SearchAdditionalServicesRequest';
  caseType?: Maybe<Billing_BillingCaseType>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  statuses?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceStatus>>>;
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Patient_Registry_SearchAdditionalServicesResponse = {
  __typename?: 'patient_registry_SearchAdditionalServicesResponse';
  additionalServices?: Maybe<Array<Maybe<Patient_Registry_AdditionalServiceMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Patient_Registry_UpdateAdditionalServiceRequest = {
  __typename?: 'patient_registry_UpdateAdditionalServiceRequest';
  additionalService?: Maybe<Patient_Registry_AdditionalServiceMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Patient_Registry_German_GermanPatientAbsenceDetailsMsg = {
  __typename?: 'patient_registry_german_GermanPatientAbsenceDetailsMsg';
  /**
   * If set on start of the absence:
   *  Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 31 (Beginn eines externen Aufenthalts (tagesstationäre Behandlung))
   *  Note: Property of the absence instead of the visit, as this can change daily
   */
  dayInpatientTreatment?: Maybe<Scalars['Boolean']>;
  endReason?: Maybe<Patient_Registry_German_GermanPatientAbsenceEndReason>;
  id?: Maybe<Scalars['String']>;
};

export enum Patient_Registry_German_GermanPatientAbsenceEndReason {
  /** Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 33 (Ungeplante Beendigung eines externen Aufenthalts bei tagesstationärerBehandlung - Notfall) */
  GermanPatientAbsenceEndReasonEmergency = 'GERMAN_PATIENT_ABSENCE_END_REASON_EMERGENCY',
  /** Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 34 (Ungeplante Beendigung eines externen Aufenthalts bei tagesstationärer Behandlung – medizinischer Behandlungsbedarf) */
  GermanPatientAbsenceEndReasonMedicalReason = 'GERMAN_PATIENT_ABSENCE_END_REASON_MEDICAL_REASON',
  GermanPatientAbsenceEndReasonNone = 'GERMAN_PATIENT_ABSENCE_END_REASON_NONE',
  /** Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 35 (Ungeplante Beendigung eines externen Aufenthalts bei tagesstationärer Behandlung – Wunsch des Patienten) */
  GermanPatientAbsenceEndReasonPatientWish = 'GERMAN_PATIENT_ABSENCE_END_REASON_PATIENT_WISH',
  /** Schlüsselverzeichnis nach 301, Schlüssel 5: Entlassungs-/Verlegungsgrund: 32 (Reguläre Beendigung eines externen Aufenthalts bei tagesstationärer Behandlung) */
  GermanPatientAbsenceEndReasonRegular = 'GERMAN_PATIENT_ABSENCE_END_REASON_REGULAR'
}

export type Patientportal_AcceptAppointmentProposalProxyRequest = {
  __typename?: 'patientportal_AcceptAppointmentProposalProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_AcceptAppointmentProposalRequest>;
};

export type Patientportal_AcceptLegalGuardianRequest = {
  __typename?: 'patientportal_AcceptLegalGuardianRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_AcceptProfessionalPortalUserInviteRequest = {
  __typename?: 'patientportal_AcceptProfessionalPortalUserInviteRequest';
  inviteIdentifier?: Maybe<Patientportal_ProfessionalPortalUserInviteIdentifier>;
};

export type Patientportal_AcceptWardRequest = {
  __typename?: 'patientportal_AcceptWardRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

/**
 * Used when confirming an action. The confirmableActionId is always required, all other parameters are optional.
 *  However, one of the following configurations of optional parameters is expected (with this order of priority):
 *  - [actionToken, confirmationProviderIndex, confirmationCode]:
 *      full confirmation using confirmation-code
 *  - [actionToken, confirmationProviderIndex, confirmationToken]:
 *      - CONFIRMATION_TOKEN_MODE_PARTIAL_CONFIRM:
 *          partial + full confirmation in single step using confirmation-token
 *      - CONFIRMATION_TOKEN_MODE_FULL_CONFIRM:
 *          full confirmation using confirmation-token
 *  - [confirmationProviderIndex, confirmationToken]:
 *      - CONFIRMATION_TOKEN_MODE_PARTIAL_CONFIRM:
 *          partial confirmation using confirmation-token
 *      - CONFIRMATION_TOKEN_MODE_FULL_CONFIRM:
 *          full confirmation using confirmation-token
 *  - [actionToken]:
 *      full confirmation of action already partially confirmed
 */
export type Patientportal_ActionConfirmationMsg = {
  __typename?: 'patientportal_ActionConfirmationMsg';
  actionToken?: Maybe<Scalars['String']>;
  confirmableActionId?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  confirmationProviderIndex?: Maybe<Scalars['Int']>;
  confirmationToken?: Maybe<Scalars['String']>;
};

export type Patientportal_AddLegalGuardianRequest = {
  __typename?: 'patientportal_AddLegalGuardianRequest';
  legalGuardianId?: Maybe<Scalars['String']>;
  type?: Maybe<Patientportal_PortalUserRelationshipType>;
};

export type Patientportal_AddLegalGuardianResponse = {
  __typename?: 'patientportal_AddLegalGuardianResponse';
  legalGuardian?: Maybe<Patientportal_PortalUserMsg>;
};

export type Patientportal_AdditionalServiceProxyList = {
  __typename?: 'patientportal_AdditionalServiceProxyList';
  proxyAdditionalServices?: Maybe<Array<Maybe<Patientportal_AdditionalServiceProxyMsg>>>;
};

export type Patientportal_AdditionalServiceProxyMsg = {
  __typename?: 'patientportal_AdditionalServiceProxyMsg';
  additionalService?: Maybe<Resource_AdditionalServiceMsg>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_AnswerFormQuestionProxyRequest = {
  __typename?: 'patientportal_AnswerFormQuestionProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_AnswerFormQuestionRequest>;
};

export type Patientportal_AnswerFormQuestionProxyResponse = {
  __typename?: 'patientportal_AnswerFormQuestionProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_AnswerFormQuestionResponse>;
};

export type Patientportal_AnswerFormSequenceQuestionProxyRequest = {
  __typename?: 'patientportal_AnswerFormSequenceQuestionProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_AnswerFormSequenceQuestionRequest>;
};

export type Patientportal_AnswerFormSequenceQuestionProxyResponse = {
  __typename?: 'patientportal_AnswerFormSequenceQuestionProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_AnswerFormSequenceQuestionResponse>;
};

export type Patientportal_AppointmentHandlerProxyList = {
  __typename?: 'patientportal_AppointmentHandlerProxyList';
  proxyAppointmentHandlers?: Maybe<Array<Maybe<Patientportal_AppointmentHandlerProxyMsg>>>;
};

export type Patientportal_AppointmentHandlerProxyMsg = {
  __typename?: 'patientportal_AppointmentHandlerProxyMsg';
  appointmentHandler?: Maybe<Resource_AppointmentHandlerMsg>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_AppointmentProxyList = {
  __typename?: 'patientportal_AppointmentProxyList';
  proxyAppointments?: Maybe<Array<Maybe<Patientportal_AppointmentProxyMsg>>>;
};

export type Patientportal_AppointmentProxyMsg = {
  __typename?: 'patientportal_AppointmentProxyMsg';
  appointment?: Maybe<Resource_AppointmentMsg>;
  clinicId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_OfficeHourPortalFacilityPathMsg>;
};

export type Patientportal_AppointmentRequestProxyList = {
  __typename?: 'patientportal_AppointmentRequestProxyList';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  proxyAppointmentRequests?: Maybe<Array<Maybe<Patientportal_AppointmentRequestProxyMsg>>>;
};

export type Patientportal_AppointmentRequestProxyMsg = {
  __typename?: 'patientportal_AppointmentRequestProxyMsg';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  clinicId?: Maybe<Scalars['String']>;
  portalFacilityPath?: Maybe<Patientportal_OfficeHourPortalFacilityPathMsg>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_AppointmentSeriesProxyMsg = {
  __typename?: 'patientportal_AppointmentSeriesProxyMsg';
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
  clinicId?: Maybe<Scalars['String']>;
  proxyAppointments?: Maybe<Array<Maybe<Patientportal_AppointmentProxyMsg>>>;
};

export type Patientportal_AppointmentTaskProxyMsg = {
  __typename?: 'patientportal_AppointmentTaskProxyMsg';
  appointmentTask?: Maybe<Resource_AppointmentTaskMsg>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_AppointmentTypeProxyList = {
  __typename?: 'patientportal_AppointmentTypeProxyList';
  proxyAppointmentTypes?: Maybe<Array<Maybe<Patientportal_AppointmentTypeProxyMsg>>>;
};

export type Patientportal_AppointmentTypeProxyMsg = {
  __typename?: 'patientportal_AppointmentTypeProxyMsg';
  appointmentType?: Maybe<Resource_AppointmentTypeMsg>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_BookReservedAppointmentOrSeriesProxyRequest = {
  __typename?: 'patientportal_BookReservedAppointmentOrSeriesProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_BookReservedAppointmentOrSeriesRequest>;
};

export type Patientportal_BookReservedAppointmentOrSeriesProxyResponse = {
  __typename?: 'patientportal_BookReservedAppointmentOrSeriesProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Resource_BookReservedAppointmentOrSeriesResponse>;
};

export type Patientportal_CancelAppointmentProxyRequest = {
  __typename?: 'patientportal_CancelAppointmentProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_CancelAppointmentOrSeriesRequest>;
};

export type Patientportal_CancelAppointmentRequestProxyRequest = {
  __typename?: 'patientportal_CancelAppointmentRequestProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_CancelAppointmentRequestRequest>;
};

export type Patientportal_CancelClinicalRequestProxyRequest = {
  __typename?: 'patientportal_CancelClinicalRequestProxyRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_CancelClinicalRequestProxyResponse = {
  __typename?: 'patientportal_CancelClinicalRequestProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_ClinicalRequestProxyMsg = {
  __typename?: 'patientportal_ClinicalRequestProxyMsg';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_ClinicalRequestTemplateProxyMsg = {
  __typename?: 'patientportal_ClinicalRequestTemplateProxyMsg';
  clinicalRequestTemplate?: Maybe<Clinicalrequest_ClinicalRequestTemplateMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

/**
 * A confirmable-action, is an action that has to be confirmed with a confirmation-provider.
 *  This message is always only sent to the initiator of an action.
 *  The initiator of an action owns a secret action-token.
 *  Each confirmation-provider owns at least one of two things (but can own both):
 *  - confirmation-code:
 *      This secret code is either sent to the confirmation-provider (e.g. via email) or can be computed by it (e.g. time-based OTP).
 *      The user can only confirm an action with it, if used together with the action-token of the initiator.
 *      As a result, this code has to either be manually entered on initiator device or a link/button containing the confirmation-code has to
 *      be activated on the device the action was initiated on, so that both pieces of information are present.
 *      Where we control the display of confirmation-codes to the user, the following guidelines should be used:
 *        - The confirmation-code text itself should be shown in a way that's easy to read and copy-and-paste compatible
 *        - If no confirmation-token is present for this provider, a link/button can be shown in addition to the confirmation-code text.
 *          When clicked, this link/button should auto-fill (and can auto-submit) the confirmation-code, but this can only be done on the
 *          same device the action was initiated, as explained above. This restriction should be hinted to the user
 *          in the UI. Implementing this link/button is especially important for long confirmation-codes that can occur in some situations.
 *  - confirmation-token:
 *      This secret token is only present for confirmation-providers it can be sent to (e.g email). The actual usage of this confirmation-token
 *      depends on the confirmation-token-mode of the confirmation-provider:
 *      - NO_CONFIRM:
 *          No confirmation-token is sent to any confirmation-provider.
 *      - PARTIAL_CONFIRM:
 *          In partial confirmation mode, the confirmation-token can be used to partially confirm the action without requiring any additional
 *          secrets. After being partially confirmed, an action still has to be fully confirmed. This is done using the action-token of the
 *          initiator, but this time also without requiring any additional secrets. This behavior is desirable for actions where the
 *          initiator is more or equally trustworthy in comparison to the confirmation-provider (e.g. 2FA sign-in).
 *          Note: The two steps described above can also be combined into one if both the confirmation-token and the action-token are present on
 *          the same device at the same time (e.g. when a confirmation-token link is clicked in the same browser).
 *      - FULL_CONFIRM:
 *          In full confirmation mode, the confirmation-token can be used to fully confirm the action without requiring any additional secrets.
 *          This behavior is desirable for actions where the initiator is less trustworthy than the confirmation-provider
 *          (e.g. password reset).
 *      For confirmation-tokens, we always display how they are displayed and these are the guidelines:
 *      - The confirmation-token should not be displayed as text
 *      - A link/button should be shown that automatically confirms the action fully or partially when activated.
 */
export type Patientportal_ConfirmableActionMsg = {
  __typename?: 'patientportal_ConfirmableActionMsg';
  /** secret token, owned by the initiator */
  actionToken?: Maybe<Scalars['String']>;
  /** all confirmation-providers that own a confirmationCode/confirmationToken for this action */
  confirmationProviders?: Maybe<Array<Maybe<Patientportal_ConfirmationProviderMsg>>>;
  /** until when this confirmable action is valid */
  expiresAt?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
};

export type Patientportal_ConfirmationCodeInfoMsg = {
  __typename?: 'patientportal_ConfirmationCodeInfoMsg';
  length?: Maybe<Scalars['Int']>;
  type?: Maybe<Patientportal_ConfirmationCodeType>;
};

export enum Patientportal_ConfirmationCodeType {
  /** numbers, uppercase letters and lowercase letters */
  ConfirmationCodeTypeAlphaNumeric = 'CONFIRMATION_CODE_TYPE_ALPHA_NUMERIC',
  /** numbers and uppercase letters */
  ConfirmationCodeTypeAlphaNumericUppercase = 'CONFIRMATION_CODE_TYPE_ALPHA_NUMERIC_UPPERCASE',
  ConfirmationCodeTypeNone = 'CONFIRMATION_CODE_TYPE_NONE',
  /** just numbers */
  ConfirmationCodeTypeNumeric = 'CONFIRMATION_CODE_TYPE_NUMERIC'
}

export type Patientportal_ConfirmationProviderEmailMsg = {
  __typename?: 'patientportal_ConfirmationProviderEmailMsg';
  /** if not set, only a confirmation-token was sent to this provider but no confirmation-code */
  confirmationCodeInfo?: Maybe<Patientportal_ConfirmationCodeInfoMsg>;
  /** how confirmation-tokens sent to this confirmation-provider can be used, NO_CONFIRM means no confirmation-token was sent */
  confirmationTokenMode?: Maybe<Patientportal_ConfirmationTokenMode>;
  emailAddress?: Maybe<Scalars['String']>;
};

/**
 * Information on a specific confirmation-provider.
 *  Has flexible design to allow for more technologies in the future.
 */
export type Patientportal_ConfirmationProviderMsg = {
  __typename?: 'patientportal_ConfirmationProviderMsg';
  email?: Maybe<Patientportal_ConfirmationProviderEmailMsg>;
  name?: Maybe<Scalars['String']>;
  /**
   * ActionConfirmationProviderTimeBasedOtpMsg timeBasedOtp = 6;
   *  ActionConfirmationProviderWebauthnMsg webauthn = 7;
   */
  sms?: Maybe<Patientportal_ConfirmationProviderSmsMsg>;
  type?: Maybe<Patientportal_ConfirmationProviderType>;
};

/** Information on a specific confirmation-provider that is sent to that provider itself. */
export type Patientportal_ConfirmationProviderSelfInfoMsg = {
  __typename?: 'patientportal_ConfirmationProviderSelfInfoMsg';
  confirmableActionId?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  confirmationProviderIndex?: Maybe<Scalars['Int']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmationTokenMode?: Maybe<Patientportal_ConfirmationTokenMode>;
};

export type Patientportal_ConfirmationProviderSmsMsg = {
  __typename?: 'patientportal_ConfirmationProviderSmsMsg';
  /** if not set, only a confirmation-token was sent to this provider but no confirmation-code */
  confirmationCodeInfo?: Maybe<Patientportal_ConfirmationCodeInfoMsg>;
  /** how confirmation-tokens sent to this confirmation-provider can be used, NO_CONFIRM means no confirmation-token was sent */
  confirmationTokenMode?: Maybe<Patientportal_ConfirmationTokenMode>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export enum Patientportal_ConfirmationProviderType {
  ConfirmationProviderProviderTypeEmail = 'CONFIRMATION_PROVIDER_PROVIDER_TYPE_EMAIL',
  ConfirmationProviderProviderTypeNone = 'CONFIRMATION_PROVIDER_PROVIDER_TYPE_NONE',
  /**
   * CONFIRMATION_PROVIDER_PROVIDER_TYPE_TIME_BASED_OTP = 3;
   *  CONFIRMATION_PROVIDER_PROVIDER_TYPE_WEBAUTHN = 4;
   */
  ConfirmationProviderProviderTypeSms = 'CONFIRMATION_PROVIDER_PROVIDER_TYPE_SMS'
}

export enum Patientportal_ConfirmationTokenMode {
  ConfirmationTokenModeFullConfirm = 'CONFIRMATION_TOKEN_MODE_FULL_CONFIRM',
  ConfirmationTokenModeNone = 'CONFIRMATION_TOKEN_MODE_NONE',
  ConfirmationTokenModeNoConfirm = 'CONFIRMATION_TOKEN_MODE_NO_CONFIRM',
  ConfirmationTokenModePartialConfirm = 'CONFIRMATION_TOKEN_MODE_PARTIAL_CONFIRM'
}

export type Patientportal_CreateAppointmentRequestProxyRequest = {
  __typename?: 'patientportal_CreateAppointmentRequestProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_CreateAppointmentRequestRequest>;
};

export type Patientportal_CreateClinicalRequestProxyRequest = {
  __typename?: 'patientportal_CreateClinicalRequestProxyRequest';
  clinicalRequestTemplateId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
  requesterUnitReference?: Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>;
};

export type Patientportal_CreateClinicalRequestProxyResponse = {
  __typename?: 'patientportal_CreateClinicalRequestProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateCommentProxyRequest = {
  __typename?: 'patientportal_CreateCommentProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Comment_CreateCommentRequest>;
};

export type Patientportal_CreateCommentProxyResponse = {
  __typename?: 'patientportal_CreateCommentProxyResponse';
  comment?: Maybe<Comment_CommentMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateExternalClinicRequest = {
  __typename?: 'patientportal_CreateExternalClinicRequest';
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<Patientportal_ExternalClinicBranchMsg>>>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateExternalDepartmentRequest = {
  __typename?: 'patientportal_CreateExternalDepartmentRequest';
  contact?: Maybe<Core_ContactMsg>;
  externalClinicId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateExternalOrganizationalUnitRequest = {
  __typename?: 'patientportal_CreateExternalOrganizationalUnitRequest';
  contact?: Maybe<Core_ContactMsg>;
  externalDepartmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateFormAnswerGroupProxyRequest = {
  __typename?: 'patientportal_CreateFormAnswerGroupProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_CreateFormAnswerGroupRequest>;
};

export type Patientportal_CreateFormAnswerGroupProxyResponse = {
  __typename?: 'patientportal_CreateFormAnswerGroupProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_CreateFormAnswerGroupResponse>;
};

export type Patientportal_CreateFormProxyRequest = {
  __typename?: 'patientportal_CreateFormProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_CreateFormRequest>;
};

export type Patientportal_CreateFormProxyResponse = {
  __typename?: 'patientportal_CreateFormProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_CreateFormResponse>;
};

export type Patientportal_CreateOrUpdatePortalClinicRequest = {
  __typename?: 'patientportal_CreateOrUpdatePortalClinicRequest';
  portalClinic?: Maybe<Patientportal_PortalClinicMsg>;
};

export type Patientportal_CreatePortalFacilityRequest = {
  __typename?: 'patientportal_CreatePortalFacilityRequest';
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_CreatePortalFacilityResponse = {
  __typename?: 'patientportal_CreatePortalFacilityResponse';
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
};

export type Patientportal_CreatePortalPatientDataSnapshotProxyRequest = {
  __typename?: 'patientportal_CreatePortalPatientDataSnapshotProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_CreatePortalPatientDataSnapshotRequest>;
};

export type Patientportal_CreatePortalUserRequest = {
  __typename?: 'patientportal_CreatePortalUserRequest';
  captchaSolution?: Maybe<Scalars['String']>;
  deviceSecretId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Patientportal_PortalDeviceType>;
  password?: Maybe<Scalars['String']>;
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
};

export type Patientportal_CreatePortalUserResponse = {
  __typename?: 'patientportal_CreatePortalUserResponse';
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  thirdPartyCommunicationVerificationConfirmableActions?: Maybe<Array<Maybe<Patientportal_ConfirmableActionMsg>>>;
  token?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateProfessionalPortalUserInviteRequest = {
  __typename?: 'patientportal_CreateProfessionalPortalUserInviteRequest';
  externalUnits?: Maybe<Array<Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  ownerPortalClinicId?: Maybe<Scalars['String']>;
  targetFacilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  validityTimeFrame?: Maybe<TimeFrameMsg>;
  whitelistedEmailDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  whitelistedEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_CreateProfessionalPortalUserRequest = {
  __typename?: 'patientportal_CreateProfessionalPortalUserRequest';
  captchaSolution?: Maybe<Scalars['String']>;
  /** only considered by backend if request comes from super user */
  enableTwoFactorAuthentication?: Maybe<Scalars['Boolean']>;
  inviteIdentifier?: Maybe<Patientportal_ProfessionalPortalUserInviteIdentifier>;
  password?: Maybe<Scalars['String']>;
  portalUser?: Maybe<Patientportal_ProfessionalPortalUserMsg>;
};

export type Patientportal_CreateProfessionalPortalUserResponse = {
  __typename?: 'patientportal_CreateProfessionalPortalUserResponse';
  portalUser?: Maybe<Patientportal_ProfessionalPortalUserMsg>;
  thirdPartyCommunicationVerificationConfirmableActions?: Maybe<Array<Maybe<Patientportal_ConfirmableActionMsg>>>;
  token?: Maybe<Scalars['String']>;
};

export type Patientportal_CreateReasonForRepresentationPortalProxyRequest = {
  __typename?: 'patientportal_CreateReasonForRepresentationPortalProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Treatment_ReasonForPresentationMsg>;
};

export type Patientportal_DeleteClinicalRequestProxyRequest = {
  __typename?: 'patientportal_DeleteClinicalRequestProxyRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteClinicalRequestProxyResponse = {
  __typename?: 'patientportal_DeleteClinicalRequestProxyResponse';
  deletedClinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteCommentProxyRequest = {
  __typename?: 'patientportal_DeleteCommentProxyRequest';
  commentId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteCommentProxyResponse = {
  __typename?: 'patientportal_DeleteCommentProxyResponse';
  deletedCommentId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteExternalClinicRequest = {
  __typename?: 'patientportal_DeleteExternalClinicRequest';
  externalClinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteExternalDepartmentRequest = {
  __typename?: 'patientportal_DeleteExternalDepartmentRequest';
  externalDepartmentId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteExternalOrganizationalUnitRequest = {
  __typename?: 'patientportal_DeleteExternalOrganizationalUnitRequest';
  externalOrganizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeleteFormAnswerGroupProxyRequest = {
  __typename?: 'patientportal_DeleteFormAnswerGroupProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_DeleteFormAnswerGroupRequest>;
};

export type Patientportal_DeleteFormAnswerGroupProxyResponse = {
  __typename?: 'patientportal_DeleteFormAnswerGroupProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_DeleteFormAnswerGroupResponse>;
};

export type Patientportal_DeletePortalFacilityRequest = {
  __typename?: 'patientportal_DeletePortalFacilityRequest';
  portalFacilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_DeletePortalFacilityResponse = {
  __typename?: 'patientportal_DeletePortalFacilityResponse';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_DeletePortalSnapshotsRequest = {
  __typename?: 'patientportal_DeletePortalSnapshotsRequest';
  /** All Ids of snapshots that should be deleted */
  snapshotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_DocumentMetadataProxyMsg = {
  __typename?: 'patientportal_DocumentMetadataProxyMsg';
  clinicId?: Maybe<Scalars['String']>;
  document?: Maybe<Document_Transfer_DocumentMetadataMsg>;
};

export type Patientportal_ExternalAdministrativeUnitReferenceList = {
  __typename?: 'patientportal_ExternalAdministrativeUnitReferenceList';
  externalAdministrativeUnitReferences?: Maybe<Array<Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
};

export type Patientportal_ExternalAdministrativeUnitReferenceMsg = {
  __typename?: 'patientportal_ExternalAdministrativeUnitReferenceMsg';
  type?: Maybe<Patientportal_ExternalAdministrativeUnitReferenceType>;
  unitId?: Maybe<Scalars['String']>;
};

export enum Patientportal_ExternalAdministrativeUnitReferenceType {
  ExternalAdministrativeUnitReferenceTypeClinic = 'EXTERNAL_ADMINISTRATIVE_UNIT_REFERENCE_TYPE_CLINIC',
  ExternalAdministrativeUnitReferenceTypeDepartment = 'EXTERNAL_ADMINISTRATIVE_UNIT_REFERENCE_TYPE_DEPARTMENT',
  ExternalAdministrativeUnitReferenceTypeNone = 'EXTERNAL_ADMINISTRATIVE_UNIT_REFERENCE_TYPE_NONE',
  ExternalAdministrativeUnitReferenceTypeOrganizationalUnit = 'EXTERNAL_ADMINISTRATIVE_UNIT_REFERENCE_TYPE_ORGANIZATIONAL_UNIT'
}

/** Additional information about locations of a clinic, not tied to organizational hierarchy */
export type Patientportal_ExternalClinicBranchMsg = {
  __typename?: 'patientportal_ExternalClinicBranchMsg';
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_ExternalClinicList = {
  __typename?: 'patientportal_ExternalClinicList';
  externalClinics?: Maybe<Array<Maybe<Patientportal_ExternalClinicMsg>>>;
};

export type Patientportal_ExternalClinicMsg = {
  __typename?: 'patientportal_ExternalClinicMsg';
  contact?: Maybe<Core_ContactMsg>;
  departments?: Maybe<Array<Maybe<Patientportal_ExternalDepartmentMsg>>>;
  id?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<Patientportal_ExternalClinicBranchMsg>>>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_ExternalDepartmentList = {
  __typename?: 'patientportal_ExternalDepartmentList';
  externalDepartments?: Maybe<Array<Maybe<Patientportal_ExternalDepartmentMsg>>>;
};

export type Patientportal_ExternalDepartmentMsg = {
  __typename?: 'patientportal_ExternalDepartmentMsg';
  clinicId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationalUnits?: Maybe<Array<Maybe<Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Patientportal_ExternalOrganizationalUnitList = {
  __typename?: 'patientportal_ExternalOrganizationalUnitList';
  externalOrganizationalUnits?: Maybe<Array<Maybe<Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Patientportal_ExternalOrganizationalUnitMsg = {
  __typename?: 'patientportal_ExternalOrganizationalUnitMsg';
  contact?: Maybe<Core_ContactMsg>;
  departmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** This type is linked to a professional portal user */
export type Patientportal_ExternalPractitionerMsg = {
  __typename?: 'patientportal_ExternalPractitionerMsg';
  id?: Maybe<Scalars['String']>;
  medicalFieldIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Patientportal_FindClinicUserPortalStaffRequest = {
  __typename?: 'patientportal_FindClinicUserPortalStaffRequest';
  clinicId?: Maybe<Scalars['String']>;
  clinicUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_FindClinicUserPortalStaffResponse = {
  __typename?: 'patientportal_FindClinicUserPortalStaffResponse';
  portalStaff?: Maybe<Patientportal_PortalStaffMsg>;
};

export type Patientportal_FindCurrentLegalGuardianRequest = {
  __typename?: 'patientportal_FindCurrentLegalGuardianRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_FindCurrentLegalGuardianResponse = {
  __typename?: 'patientportal_FindCurrentLegalGuardianResponse';
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  portalUserFound?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_FindCurrentPortalUserRequest = {
  __typename?: 'patientportal_FindCurrentPortalUserRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_FindCurrentPortalUserResponse = {
  __typename?: 'patientportal_FindCurrentPortalUserResponse';
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  portalUserFound?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_FindCurrentProfessionalPortalUserResponse = {
  __typename?: 'patientportal_FindCurrentProfessionalPortalUserResponse';
  professionalPortalUser?: Maybe<Patientportal_ProfessionalPortalUserMsg>;
  professionalPortalUserFound?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_FindFormSequenceAnswerProxyRequest = {
  __typename?: 'patientportal_FindFormSequenceAnswerProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_FindFormSequenceAnswerRequest>;
};

export type Patientportal_FindFormSequenceAnswerProxyResponse = {
  __typename?: 'patientportal_FindFormSequenceAnswerProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_FindFormSequenceAnswerResponse>;
};

export type Patientportal_FindPortalUserIdsByPatientIdsRequest = {
  __typename?: 'patientportal_FindPortalUserIdsByPatientIdsRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_FindPortalUserIdsByPatientIdsResponse = {
  __typename?: 'patientportal_FindPortalUserIdsByPatientIdsResponse';
  patientIdToPortalUserId?: Maybe<Array<Maybe<Patientportal_FindPortalUserIdsByPatientIdsResponse_PatientIdToPortalUserIdEntry>>>;
};

export type Patientportal_FindPortalUserIdsByPatientIdsResponse_PatientIdToPortalUserIdEntry = {
  __typename?: 'patientportal_FindPortalUserIdsByPatientIdsResponse_PatientIdToPortalUserIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Patientportal_FindPortalUserRequest = {
  __typename?: 'patientportal_FindPortalUserRequest';
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Core_PhoneNumberMsg>;
};

export type Patientportal_FindPortalUserResponse = {
  __typename?: 'patientportal_FindPortalUserResponse';
  portalUsers?: Maybe<Array<Maybe<Patientportal_SimplePortalUserMsg>>>;
};

export type Patientportal_FindSiblingFormSequenceAnswerProxyRequest = {
  __typename?: 'patientportal_FindSiblingFormSequenceAnswerProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_FindSiblingFormSequenceAnswerRequest>;
};

export type Patientportal_FindSiblingFormSequenceAnswerProxyResponse = {
  __typename?: 'patientportal_FindSiblingFormSequenceAnswerProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_FindSiblingFormSequenceAnswerResponse>;
};

export type Patientportal_GetAnamnesisCardReasonPortalProxyRequest = {
  __typename?: 'patientportal_GetAnamnesisCardReasonPortalProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Treatment_GetAnamnesisCardReasonRequest>;
};

export type Patientportal_GetAppointmentFormReferenceBlacklistProxyRequest = {
  __typename?: 'patientportal_GetAppointmentFormReferenceBlacklistProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetAppointmentFormReferenceBlacklistProxyResponse = {
  __typename?: 'patientportal_GetAppointmentFormReferenceBlacklistProxyResponse';
  formReferenceBlacklist?: Maybe<Scalars['String']>;
};

export type Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyRequest = {
  __typename?: 'patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyResponse = {
  __typename?: 'patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyResponse';
  formTemplateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetAppointmentHistoryProxyRequest = {
  __typename?: 'patientportal_GetAppointmentHistoryProxyRequest';
  appointmentId?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetAppointmentHistoryProxyResponse = {
  __typename?: 'patientportal_GetAppointmentHistoryProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Resource_GetAppointmentHistoryResponse>;
};

export type Patientportal_GetAppointmentProxyRequest = {
  __typename?: 'patientportal_GetAppointmentProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAppointmentRequest>;
};

export type Patientportal_GetAppointmentRequestProxyRequest = {
  __typename?: 'patientportal_GetAppointmentRequestProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAppointmentRequestRequest>;
};

export type Patientportal_GetAppointmentSeriesProxyRequest = {
  __typename?: 'patientportal_GetAppointmentSeriesProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAppointmentSeriesRequest>;
};

export type Patientportal_GetAppointmentTaskProxyRequest = {
  __typename?: 'patientportal_GetAppointmentTaskProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAppointmentTaskRequest>;
};

export type Patientportal_GetAppointmentTypeProxyRequest = {
  __typename?: 'patientportal_GetAppointmentTypeProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAppointmentTypeRequest>;
};

export type Patientportal_GetAvailableAppointmentSlotsProxyRequest = {
  __typename?: 'patientportal_GetAvailableAppointmentSlotsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_GetAvailableAppointmentTimesRequest>;
};

export type Patientportal_GetClinicPortalFacilitiesRequest = {
  __typename?: 'patientportal_GetClinicPortalFacilitiesRequest';
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetClinicPortalFacilitiesResponse = {
  __typename?: 'patientportal_GetClinicPortalFacilitiesResponse';
  paths?: Maybe<Array<Maybe<Patientportal_PortalFacilityHierarchyPathMsg>>>;
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_GetClinicalRequestLetterDocumentProxyRequest = {
  __typename?: 'patientportal_GetClinicalRequestLetterDocumentProxyRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetClinicalRequestLetterDocumentProxyResponse = {
  __typename?: 'patientportal_GetClinicalRequestLetterDocumentProxyResponse';
  document?: Maybe<Document_DocumentMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetClinicalRequestProxyRequest = {
  __typename?: 'patientportal_GetClinicalRequestProxyRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetClinicalRequestProxyResponse = {
  __typename?: 'patientportal_GetClinicalRequestProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetCommentHistoryProxyRequest = {
  __typename?: 'patientportal_GetCommentHistoryProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetCommentHistoryProxyResponse = {
  __typename?: 'patientportal_GetCommentHistoryProxyResponse';
  comments?: Maybe<Array<Maybe<Comment_CommentMsg>>>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetCurrentLegalGuardiansRequest = {
  __typename?: 'patientportal_GetCurrentLegalGuardiansRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_GetCurrentPortalUserClinicsResponse = {
  __typename?: 'patientportal_GetCurrentPortalUserClinicsResponse';
  clinics?: Maybe<Array<Maybe<Patientportal_PortalUserClinicMsg>>>;
};

export type Patientportal_GetCurrentWardsRequest = {
  __typename?: 'patientportal_GetCurrentWardsRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_GetDocumentPortalProxyRequest = {
  __typename?: 'patientportal_GetDocumentPortalProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  documentGroupId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  staticDocumentGroupId?: Maybe<Scalars['String']>;
  staticDocumentId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetDocumentPortalProxyResponse = {
  __typename?: 'patientportal_GetDocumentPortalProxyResponse';
  document?: Maybe<Patientportal_DocumentMetadataProxyMsg>;
};

export type Patientportal_GetExternalClinicRequest = {
  __typename?: 'patientportal_GetExternalClinicRequest';
  externalClinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetExternalClinicsRequest = {
  __typename?: 'patientportal_GetExternalClinicsRequest';
  externalClinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetExternalDepartmentRequest = {
  __typename?: 'patientportal_GetExternalDepartmentRequest';
  externalDepartmentId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetExternalDepartmentsRequest = {
  __typename?: 'patientportal_GetExternalDepartmentsRequest';
  externalDepartmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetExternalOrganizationalUnitRequest = {
  __typename?: 'patientportal_GetExternalOrganizationalUnitRequest';
  externalOrganizationalUnitId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetExternalOrganizationalUnitsRequest = {
  __typename?: 'patientportal_GetExternalOrganizationalUnitsRequest';
  externalOrganizationalUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetFormAnswerGroupHierarchyProxyRequest = {
  __typename?: 'patientportal_GetFormAnswerGroupHierarchyProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetFormAnswerGroupHierarchyRequest>;
};

export type Patientportal_GetFormAnswerGroupHierarchyProxyResponse = {
  __typename?: 'patientportal_GetFormAnswerGroupHierarchyProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetFormAnswerGroupHierarchyResponse>;
};

export type Patientportal_GetFormProxyRequest = {
  __typename?: 'patientportal_GetFormProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetFormRequest>;
};

export type Patientportal_GetFormProxyResponse = {
  __typename?: 'patientportal_GetFormProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetFormResponse>;
};

export type Patientportal_GetFormQuestionGroupHierarchyProxyRequest = {
  __typename?: 'patientportal_GetFormQuestionGroupHierarchyProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetFormQuestionGroupHierarchyRequest>;
};

export type Patientportal_GetFormQuestionGroupHierarchyProxyResponse = {
  __typename?: 'patientportal_GetFormQuestionGroupHierarchyProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetFormQuestionGroupHierarchyResponse>;
};

export type Patientportal_GetFormSequenceAnswerProxyRequest = {
  __typename?: 'patientportal_GetFormSequenceAnswerProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetFormSequenceAnswerRequest>;
};

export type Patientportal_GetFormSequenceAnswerProxyResponse = {
  __typename?: 'patientportal_GetFormSequenceAnswerProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetFormSequenceAnswerResponse>;
};

export type Patientportal_GetFormTemplateProxyRequest = {
  __typename?: 'patientportal_GetFormTemplateProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetFormTemplateRequest>;
};

export type Patientportal_GetFormTemplateProxyResponse = {
  __typename?: 'patientportal_GetFormTemplateProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetFormTemplateResponse>;
};

export type Patientportal_GetOfficeHourPortalFacilityPathRequest = {
  __typename?: 'patientportal_GetOfficeHourPortalFacilityPathRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetOfficeHourPortalFacilityPathResponse = {
  __typename?: 'patientportal_GetOfficeHourPortalFacilityPathResponse';
  path?: Maybe<Patientportal_OfficeHourPortalFacilityPathMsg>;
};

export type Patientportal_GetOfficeHoursPortalFacilityPathsRequest = {
  __typename?: 'patientportal_GetOfficeHoursPortalFacilityPathsRequest';
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetOfficeHoursPortalFacilityPathsResponse = {
  __typename?: 'patientportal_GetOfficeHoursPortalFacilityPathsResponse';
  paths?: Maybe<Array<Maybe<Patientportal_OfficeHourPortalFacilityPathMsg>>>;
};

export type Patientportal_GetPortalClinicRequest = {
  __typename?: 'patientportal_GetPortalClinicRequest';
  portalClinicId?: Maybe<Scalars['String']>;
  portalClinicName?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalFacilityHierarchyRequest = {
  __typename?: 'patientportal_GetPortalFacilityHierarchyRequest';
  clinicId?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Int']>;
  /** optional filter: if set, only facilities that have at least one of the capabilities are returned */
  requiredCapabilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityCapability>>>;
  rootPortalFacilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalFacilityHierarchyResponse = {
  __typename?: 'patientportal_GetPortalFacilityHierarchyResponse';
  parentId?: Maybe<Scalars['String']>;
  paths?: Maybe<Array<Maybe<Patientportal_PortalFacilityHierarchyPathMsg>>>;
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_GetPortalFacilityPathsRequest = {
  __typename?: 'patientportal_GetPortalFacilityPathsRequest';
  /** If set, only ids and names will be returned */
  onlyName?: Maybe<Scalars['Boolean']>;
  portalFacilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetPortalFacilityPathsResponse = {
  __typename?: 'patientportal_GetPortalFacilityPathsResponse';
  paths?: Maybe<Array<Maybe<Patientportal_PortalFacilityPathMsg>>>;
};

export type Patientportal_GetPortalSnapshotsRequest = {
  __typename?: 'patientportal_GetPortalSnapshotsRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalStaffRequest = {
  __typename?: 'patientportal_GetPortalStaffRequest';
  portalStaffId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalStaffResponse = {
  __typename?: 'patientportal_GetPortalStaffResponse';
  portalStaff?: Maybe<Patientportal_PortalStaffMsg>;
};

export type Patientportal_GetPortalUserAppointmentSeriesProxyRequest = {
  __typename?: 'patientportal_GetPortalUserAppointmentSeriesProxyRequest';
  /** Optional filter to limit the dates of appointment */
  filterEnd?: Maybe<Timestamp>;
  /** Optional filter to limit the dates of appointments */
  filterStart?: Maybe<Timestamp>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: Maybe<Array<Maybe<Resource_AppointmentSeriesStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: Maybe<Array<Maybe<Resource_AppointmentSeriesStatus>>>;
};

export type Patientportal_GetPortalUserAppointmentSeriesProxyResponse = {
  __typename?: 'patientportal_GetPortalUserAppointmentSeriesProxyResponse';
  proxyAppointmentSeries?: Maybe<Array<Maybe<Patientportal_AppointmentSeriesProxyMsg>>>;
};

export type Patientportal_GetPortalUserAppointmentsProxyRequest = {
  __typename?: 'patientportal_GetPortalUserAppointmentsProxyRequest';
  /** Optional filter to limit the dates of appointments */
  filterEnd?: Maybe<Timestamp>;
  /** Optional filter to limit the dates of appointments */
  filterStart?: Maybe<Timestamp>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: Maybe<Array<Maybe<Resource_AppointmentStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: Maybe<Array<Maybe<Resource_AppointmentStatus>>>;
};

export type Patientportal_GetPortalUserAppointmentsProxyResponse = {
  __typename?: 'patientportal_GetPortalUserAppointmentsProxyResponse';
  proxyAppointments?: Maybe<Array<Maybe<Patientportal_AppointmentProxyMsg>>>;
};

export type Patientportal_GetPortalUserDocumentsProxyRequest = {
  __typename?: 'patientportal_GetPortalUserDocumentsProxyRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalUserDocumentsProxyResponse = {
  __typename?: 'patientportal_GetPortalUserDocumentsProxyResponse';
  documents?: Maybe<Array<Maybe<Patientportal_DocumentMetadataProxyMsg>>>;
};

export type Patientportal_GetPortalUserPermissionsRequest = {
  __typename?: 'patientportal_GetPortalUserPermissionsRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalUserRequest = {
  __typename?: 'patientportal_GetPortalUserRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetPortalUsersRequest = {
  __typename?: 'patientportal_GetPortalUsersRequest';
  portalUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetProfessionalPortalUserRequest = {
  __typename?: 'patientportal_GetProfessionalPortalUserRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_GetProfessionalPortalUsersRequest = {
  __typename?: 'patientportal_GetProfessionalPortalUsersRequest';
  portalUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_GetSequentialFormSummaryProxyRequest = {
  __typename?: 'patientportal_GetSequentialFormSummaryProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_GetSequentialFormSummaryRequest>;
};

export type Patientportal_GetSequentialFormSummaryProxyResponse = {
  __typename?: 'patientportal_GetSequentialFormSummaryProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_GetSequentialFormSummaryResponse>;
};

export type Patientportal_GrantPortalUserPermissionsRequest = {
  __typename?: 'patientportal_GrantPortalUserPermissionsRequest';
  portalUserId?: Maybe<Scalars['String']>;
  portalUserPermissions?: Maybe<Array<Maybe<Patientportal_PortalUserPermissionMsg>>>;
};

export type Patientportal_ListAdditionalServicesProxyRequest = {
  __typename?: 'patientportal_ListAdditionalServicesProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ListAdditionalServicesRequest>;
};

export type Patientportal_ListAppointmentFormsProxyRequest = {
  __typename?: 'patientportal_ListAppointmentFormsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_ListAppointmentFormsRequest>;
};

export type Patientportal_ListAppointmentFormsProxyResponse = {
  __typename?: 'patientportal_ListAppointmentFormsProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_ListAppointmentFormsResponse>;
};

export type Patientportal_ListAppointmentHandlersProxyRequest = {
  __typename?: 'patientportal_ListAppointmentHandlersProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ListAppointmentHandlersRequest>;
};

export type Patientportal_ListAppointmentTasksProxyRequest = {
  __typename?: 'patientportal_ListAppointmentTasksProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ListAppointmentTasksRequest>;
};

export type Patientportal_ListAppointmentTasksProxyResponse = {
  __typename?: 'patientportal_ListAppointmentTasksProxyResponse';
  proxyAppointmentTasks?: Maybe<Array<Maybe<Patientportal_AppointmentTaskProxyMsg>>>;
};

export type Patientportal_ListAppointmentsProxyRequest = {
  __typename?: 'patientportal_ListAppointmentsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ListAppointmentsRequest>;
};

export type Patientportal_ListClinicalRequestPriorityLevelsProxyRequest = {
  __typename?: 'patientportal_ListClinicalRequestPriorityLevelsProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_ListClinicalRequestPriorityLevelsProxyResponse = {
  __typename?: 'patientportal_ListClinicalRequestPriorityLevelsProxyResponse';
  facilityId?: Maybe<Scalars['String']>;
  priorityLevels?: Maybe<Array<Maybe<Clinicalrequest_ClinicalRequestPriorityLevelMsg>>>;
};

export type Patientportal_ListClinicalRequestTemplatesProxyRequest = {
  __typename?: 'patientportal_ListClinicalRequestTemplatesProxyRequest';
  facilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Clinicalrequest_ListClinicalRequestTemplatesRequest>;
};

export type Patientportal_ListClinicalRequestTemplatesProxyResponse = {
  __typename?: 'patientportal_ListClinicalRequestTemplatesProxyResponse';
  proxyClinicalRequestTemplates?: Maybe<Array<Maybe<Patientportal_ClinicalRequestTemplateProxyMsg>>>;
};

export type Patientportal_ListCommentsProxyRequest = {
  __typename?: 'patientportal_ListCommentsProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Comment_ListCommentsRequest>;
};

export type Patientportal_ListCommentsProxyResponse = {
  __typename?: 'patientportal_ListCommentsProxyResponse';
  comments?: Maybe<Array<Maybe<Comment_CommentMsg>>>;
  contextFilters?: Maybe<Array<Maybe<Comment_ListCommentsRequestContextFilterMsg>>>;
  facilityId?: Maybe<Scalars['String']>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Patientportal_ListFormOptionsProxyRequest = {
  __typename?: 'patientportal_ListFormOptionsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_ListFormOptionsRequest>;
};

export type Patientportal_ListFormOptionsProxyResponse = {
  __typename?: 'patientportal_ListFormOptionsProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_ListFormOptionsResponse>;
};

export type Patientportal_ListPortalPatientDataSnapshotMetadataProxyRequest = {
  __typename?: 'patientportal_ListPortalPatientDataSnapshotMetadataProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Portaldata_ListPortalPatientDataSnapshotMetadataRequest>;
};

export type Patientportal_ListPortalPatientDataSnapshotMetadataProxyResponse = {
  __typename?: 'patientportal_ListPortalPatientDataSnapshotMetadataProxyResponse';
  response?: Maybe<Portaldata_ListPortalPatientDataSnapshotMetadataResponse>;
};

export type Patientportal_ListPortalUserAppointmentRequestsProxyRequest = {
  __typename?: 'patientportal_ListPortalUserAppointmentRequestsProxyRequest';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_ListPortalUserAppointmentTasksProxyResponse = {
  __typename?: 'patientportal_ListPortalUserAppointmentTasksProxyResponse';
  proxyAppointmentTasks?: Maybe<Array<Maybe<Patientportal_AppointmentTaskProxyMsg>>>;
};

export type Patientportal_ListPortalUserAppointmentTypesEntryProxyMsg = {
  __typename?: 'patientportal_ListPortalUserAppointmentTypesEntryProxyMsg';
  appointmentType?: Maybe<Resource_ListPortalUserAppointmentTypesEntryMsg>;
  clinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_ListPortalUserAppointmentTypesProxyRequest = {
  __typename?: 'patientportal_ListPortalUserAppointmentTypesProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ListPortalUserAppointmentTypesRequest>;
};

export type Patientportal_ListPortalUserAppointmentTypesProxyResponse = {
  __typename?: 'patientportal_ListPortalUserAppointmentTypesProxyResponse';
  proxyAppointmentTypes?: Maybe<Array<Maybe<Patientportal_ListPortalUserAppointmentTypesEntryProxyMsg>>>;
};

export type Patientportal_ListUnsubmittedClinicalRequestsProxyRequest = {
  __typename?: 'patientportal_ListUnsubmittedClinicalRequestsProxyRequest';
  facilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_ListUnsubmittedClinicalRequestsProxyResponse = {
  __typename?: 'patientportal_ListUnsubmittedClinicalRequestsProxyResponse';
  clinicalRequests?: Maybe<Array<Maybe<Patientportal_ClinicalRequestProxyMsg>>>;
};

export type Patientportal_MapPortalUserToInternalPatientRequest = {
  __typename?: 'patientportal_MapPortalUserToInternalPatientRequest';
  clinicId?: Maybe<Scalars['String']>;
  forceRelink?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_MapPortalUserToInternalPatientResponse = {
  __typename?: 'patientportal_MapPortalUserToInternalPatientResponse';
  patientId?: Maybe<Scalars['String']>;
};

export type Patientportal_MergePatientsPortalRequest = {
  __typename?: 'patientportal_MergePatientsPortalRequest';
  patientIdToBeMergedInto?: Maybe<Scalars['String']>;
  patientIdsToBeMerged?: Maybe<Array<Maybe<Scalars['String']>>>;
  portalClinicId?: Maybe<Scalars['String']>;
};

export type Patientportal_OfficeHourPortalFacilityPathMsg = {
  __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg';
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_PartiallyConfirmActionRequest = {
  __typename?: 'patientportal_PartiallyConfirmActionRequest';
  confirmableActionId?: Maybe<Scalars['String']>;
  confirmationProviderIndex?: Maybe<Scalars['Int']>;
  confirmationToken?: Maybe<Scalars['String']>;
};

/** Configurations for portal accounts */
export type Patientportal_PortalAccountSettingsMsg = {
  __typename?: 'patientportal_PortalAccountSettingsMsg';
  accessibilityModeActive?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_PortalClinicInformationMsg = {
  __typename?: 'patientportal_PortalClinicInformationMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_PortalClinicMsg = {
  __typename?: 'patientportal_PortalClinicMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serverNetworkConfiguration?: Maybe<Patientportal_ServerNetworkConfigurationMsg>;
};

export type Patientportal_PortalDataSnapshotList = {
  __typename?: 'patientportal_PortalDataSnapshotList';
  snapshots?: Maybe<Array<Maybe<Patientportal_PortalDataSnapshotMsg>>>;
};

/** Contains an encrypted snapshot of portal entity */
export type Patientportal_PortalDataSnapshotMsg = {
  __typename?: 'patientportal_PortalDataSnapshotMsg';
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  portalClinicInformation?: Maybe<Patientportal_PortalClinicInformationMsg>;
  portalUserId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Patientportal_PortalSnapshotType>;
};

export enum Patientportal_PortalDeviceType {
  PortalDeviceTypeAndroid = 'PORTAL_DEVICE_TYPE_ANDROID',
  PortalDeviceTypeBrowser = 'PORTAL_DEVICE_TYPE_BROWSER',
  PortalDeviceTypeIos = 'PORTAL_DEVICE_TYPE_IOS',
  PortalDeviceTypeNone = 'PORTAL_DEVICE_TYPE_NONE'
}

export type Patientportal_PortalFacilityAnswerMsg = {
  __typename?: 'patientportal_PortalFacilityAnswerMsg';
  answerText?: Maybe<Core_LocalizedStringMsg>;
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
};

export enum Patientportal_PortalFacilityCapability {
  PortalFacilityCapabilityAppointmentBooking = 'PORTAL_FACILITY_CAPABILITY_APPOINTMENT_BOOKING',
  PortalFacilityCapabilityClinicalRequest = 'PORTAL_FACILITY_CAPABILITY_CLINICAL_REQUEST',
  PortalFacilityCapabilityNone = 'PORTAL_FACILITY_CAPABILITY_NONE'
}

export type Patientportal_PortalFacilityFaqEntryMsg = {
  __typename?: 'patientportal_PortalFacilityFAQEntryMsg';
  answer?: Maybe<Patientportal_PortalFacilityAnswerMsg>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Patientportal_PortalFacilityQuestionMsg>;
};

export type Patientportal_PortalFacilityHierarchyPathMsg = {
  __typename?: 'patientportal_PortalFacilityHierarchyPathMsg';
  childIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_PortalFacilityList = {
  __typename?: 'patientportal_PortalFacilityList';
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_PortalFacilityMsg = {
  __typename?: 'patientportal_PortalFacilityMsg';
  administrativeUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  capabilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityCapability>>>;
  clinicId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  contactNote?: Maybe<Core_LocalizedStringMsg>;
  dataProtectionInformationUrl?: Maybe<Scalars['String']>;
  frequentlyAskedQuestions?: Maybe<Array<Maybe<Patientportal_PortalFacilityFaqEntryMsg>>>;
  headerImageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  logoImageId?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Core_LocalizedStringMsg>;
  name?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Maybe<Patientportal_WeeklyScheduleMsg>>>;
  openingHoursFreeText?: Maybe<Core_LocalizedStringMsg>;
  shortDescription?: Maybe<Core_LocalizedStringMsg>;
  showOpeningHours?: Maybe<Scalars['Boolean']>;
  showVisitingHours?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  visitingHours?: Maybe<Array<Maybe<Patientportal_WeeklyScheduleMsg>>>;
  visitingHoursFreeText?: Maybe<Core_LocalizedStringMsg>;
};

export type Patientportal_PortalFacilityPathMsg = {
  __typename?: 'patientportal_PortalFacilityPathMsg';
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_PortalFacilityQuestionMsg = {
  __typename?: 'patientportal_PortalFacilityQuestionMsg';
  id?: Maybe<Scalars['String']>;
  questionText?: Maybe<Core_LocalizedStringMsg>;
};

export enum Patientportal_PortalSnapshotType {
  PortalSnapshotTypeAllergies = 'PORTAL_SNAPSHOT_TYPE_ALLERGIES',
  PortalSnapshotTypeMedication = 'PORTAL_SNAPSHOT_TYPE_MEDICATION',
  PortalSnapshotTypeNone = 'PORTAL_SNAPSHOT_TYPE_NONE',
  PortalSnapshotTypeVitalData = 'PORTAL_SNAPSHOT_TYPE_VITAL_DATA'
}

export type Patientportal_PortalStaffMsg = {
  __typename?: 'patientportal_PortalStaffMsg';
  clinicId?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  matrixUsername?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Patientportal_PortalUserClinicMsg = {
  __typename?: 'patientportal_PortalUserClinicMsg';
  id?: Maybe<Scalars['String']>;
  isSyncEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type Patientportal_PortalUserList = {
  __typename?: 'patientportal_PortalUserList';
  portalUsers?: Maybe<Array<Maybe<Patientportal_PortalUserMsg>>>;
};

export type Patientportal_PortalUserMsg = {
  __typename?: 'patientportal_PortalUserMsg';
  accountVerificationRequiredForClinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  medicalDataSetupCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Core_HumanNameMsg>;
  phoneNumber?: Maybe<Scalars['Long']>;
  phoneNumberCountryCode?: Maybe<Scalars['Int']>;
  settings?: Maybe<Patientportal_PortalAccountSettingsMsg>;
  sex?: Maybe<Core_Sex>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_PortalUserPermissionList = {
  __typename?: 'patientportal_PortalUserPermissionList';
  portalUserPermissions?: Maybe<Array<Maybe<Patientportal_PortalUserPermissionMsg>>>;
};

export type Patientportal_PortalUserPermissionMsg = {
  __typename?: 'patientportal_PortalUserPermissionMsg';
  accessPermission?: Maybe<User_AccessPermission>;
  expirationDate?: Maybe<Timestamp>;
  permissionTarget?: Maybe<User_PermissionTarget>;
  targetPortalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_PortalUserRelationshipList = {
  __typename?: 'patientportal_PortalUserRelationshipList';
  relationships?: Maybe<Array<Maybe<Patientportal_PortalUserRelationshipMsg>>>;
};

export type Patientportal_PortalUserRelationshipMsg = {
  __typename?: 'patientportal_PortalUserRelationshipMsg';
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
  state?: Maybe<Patientportal_PortalUserRelationshipState>;
  type?: Maybe<Patientportal_PortalUserRelationshipType>;
};

export enum Patientportal_PortalUserRelationshipState {
  /** The guardianship is active. */
  PortalUserRelationshipStateActive = 'PORTAL_USER_RELATIONSHIP_STATE_ACTIVE',
  PortalUserRelationshipStateNone = 'PORTAL_USER_RELATIONSHIP_STATE_NONE',
  /** The guardianship is paused. */
  PortalUserRelationshipStatePaused = 'PORTAL_USER_RELATIONSHIP_STATE_PAUSED',
  /** A person has requested someone to be their legal guardian. */
  PortalUserRelationshipStatePendingLegalGuardianApproval = 'PORTAL_USER_RELATIONSHIP_STATE_PENDING_LEGAL_GUARDIAN_APPROVAL',
  /** A future legal guardian has requested someone to be their ward. */
  PortalUserRelationshipStatePendingWardApproval = 'PORTAL_USER_RELATIONSHIP_STATE_PENDING_WARD_APPROVAL'
}

export enum Patientportal_PortalUserRelationshipType {
  PortalUserRelationshipTypeChild = 'PORTAL_USER_RELATIONSHIP_TYPE_CHILD',
  PortalUserRelationshipTypeFriend = 'PORTAL_USER_RELATIONSHIP_TYPE_FRIEND',
  PortalUserRelationshipTypeNone = 'PORTAL_USER_RELATIONSHIP_TYPE_NONE',
  PortalUserRelationshipTypeOther = 'PORTAL_USER_RELATIONSHIP_TYPE_OTHER',
  PortalUserRelationshipTypeParent = 'PORTAL_USER_RELATIONSHIP_TYPE_PARENT',
  PortalUserRelationshipTypeSibling = 'PORTAL_USER_RELATIONSHIP_TYPE_SIBLING',
  PortalUserRelationshipTypeSpouse = 'PORTAL_USER_RELATIONSHIP_TYPE_SPOUSE'
}

export type Patientportal_PreparePasswordResetParamsMsg = {
  __typename?: 'patientportal_PreparePasswordResetParamsMsg';
  deviceSecretId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Patientportal_PreparePasswordResetRequest = {
  __typename?: 'patientportal_PreparePasswordResetRequest';
  actionConfirmation?: Maybe<Patientportal_ActionConfirmationMsg>;
  params?: Maybe<Patientportal_PreparePasswordResetParamsMsg>;
};

export type Patientportal_PreparePasswordResetResponse = {
  __typename?: 'patientportal_PreparePasswordResetResponse';
  confirmableAction?: Maybe<Patientportal_ConfirmableActionMsg>;
  success?: Maybe<Patientportal_PreparePasswordResetSuccessMsg>;
};

export type Patientportal_PreparePasswordResetSuccessMsg = {
  __typename?: 'patientportal_PreparePasswordResetSuccessMsg';
  passwordResetToken?: Maybe<Scalars['String']>;
};

export type Patientportal_ProfessionalPortalUserInviteIdentifier = {
  __typename?: 'patientportal_ProfessionalPortalUserInviteIdentifier';
  id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Patientportal_ProfessionalPortalUserInviteMsg = {
  __typename?: 'patientportal_ProfessionalPortalUserInviteMsg';
  externalUnits?: Maybe<Array<Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Patientportal_PortalClinicMsg>;
  targetFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
  timestamps?: Maybe<TimeMsg>;
  token?: Maybe<Scalars['String']>;
  validityTimeFrame?: Maybe<TimeFrameMsg>;
  whitelistedEmailDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  whitelistedEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Patientportal_ProfessionalPortalUserList = {
  __typename?: 'patientportal_ProfessionalPortalUserList';
  portalUsers?: Maybe<Array<Maybe<Patientportal_ProfessionalPortalUserMsg>>>;
};

export type Patientportal_ProfessionalPortalUserMsg = {
  __typename?: 'patientportal_ProfessionalPortalUserMsg';
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  email?: Maybe<Scalars['String']>;
  externalPractitioner?: Maybe<Patientportal_ExternalPractitionerMsg>;
  externalUnits?: Maybe<Array<Maybe<Patientportal_ExternalAdministrativeUnitReferenceMsg>>>;
  id?: Maybe<Scalars['String']>;
  isPasswordReset?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Core_HumanNameMsg>;
  permissions?: Maybe<Array<Maybe<Patientportal_PortalUserPermissionMsg>>>;
  phoneNumber?: Maybe<Scalars['Long']>;
  phoneNumberCountryCode?: Maybe<Scalars['Int']>;
  settings?: Maybe<Patientportal_PortalAccountSettingsMsg>;
  sex?: Maybe<Core_Sex>;
  simpleExternalUnits?: Maybe<Array<Patientportal_SimpleExternalAdministrativeUnitMsg>>;
  verified?: Maybe<Scalars['Boolean']>;
  whitelistedConsultRecipients?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_RejectAppointmentProposalsProxyRequest = {
  __typename?: 'patientportal_RejectAppointmentProposalsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_RejectAppointmentProposalsRequest>;
};

export type Patientportal_RejectLegalGuardianRequest = {
  __typename?: 'patientportal_RejectLegalGuardianRequest';
  portalUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type Patientportal_RejectWardRequest = {
  __typename?: 'patientportal_RejectWardRequest';
  portalUserId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type Patientportal_RemoveClinicalRequestAccessRequest = {
  __typename?: 'patientportal_RemoveClinicalRequestAccessRequest';
  facilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_RemoveClinicalRequestInputProxyRequest = {
  __typename?: 'patientportal_RemoveClinicalRequestInputProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Clinicalrequest_RemoveClinicalRequestInputRequest>;
};

export type Patientportal_RemoveClinicalRequestInputProxyResponse = {
  __typename?: 'patientportal_RemoveClinicalRequestInputProxyResponse';
  facilityId?: Maybe<Scalars['String']>;
  response?: Maybe<Clinicalrequest_RemoveClinicalRequestInputResponse>;
};

export type Patientportal_RemoveCustomClinicalRequestInputProxyRequest = {
  __typename?: 'patientportal_RemoveCustomClinicalRequestInputProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Clinicalrequest_RemoveCustomClinicalRequestInputRequest>;
};

export type Patientportal_RemoveCustomClinicalRequestInputProxyResponse = {
  __typename?: 'patientportal_RemoveCustomClinicalRequestInputProxyResponse';
  facilityId?: Maybe<Scalars['String']>;
  response?: Maybe<Clinicalrequest_RemoveCustomClinicalRequestInputResponse>;
};

export type Patientportal_RemoveLegalGuardianRequest = {
  __typename?: 'patientportal_RemoveLegalGuardianRequest';
  legalGuardianId?: Maybe<Scalars['String']>;
};

export type Patientportal_RemoveLegalGuardianResponse = {
  __typename?: 'patientportal_RemoveLegalGuardianResponse';
  legalGuardian?: Maybe<Patientportal_PortalUserMsg>;
};

export type Patientportal_RemoveScheduleAssignmentProxyRequest = {
  __typename?: 'patientportal_RemoveScheduleAssignmentProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_RemoveScheduleAssignmentRequest>;
};

export type Patientportal_RemoveScheduleExceptionProxyRequest = {
  __typename?: 'patientportal_RemoveScheduleExceptionProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_RemoveScheduleExceptionRequest>;
};

export type Patientportal_RenotifyConfirmationProviderRequest = {
  __typename?: 'patientportal_RenotifyConfirmationProviderRequest';
  actionToken?: Maybe<Scalars['String']>;
  confirmableActionId?: Maybe<Scalars['String']>;
  confirmationProviderIndex?: Maybe<Scalars['Int']>;
};

export type Patientportal_RenotifyConfirmationProviderResponse = {
  __typename?: 'patientportal_RenotifyConfirmationProviderResponse';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_RequestLegalGuardianRequest = {
  __typename?: 'patientportal_RequestLegalGuardianRequest';
  email?: Maybe<Scalars['String']>;
  type?: Maybe<Patientportal_PortalUserRelationshipType>;
};

export type Patientportal_RequestWardRequest = {
  __typename?: 'patientportal_RequestWardRequest';
  email?: Maybe<Scalars['String']>;
  type?: Maybe<Patientportal_PortalUserRelationshipType>;
};

export type Patientportal_ResetPasswordRequest = {
  __typename?: 'patientportal_ResetPasswordRequest';
  newPassword?: Maybe<Scalars['String']>;
  passwordResetToken?: Maybe<Scalars['String']>;
};

export type Patientportal_ResetPasswordResponse = {
  __typename?: 'patientportal_ResetPasswordResponse';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_RestartFormProxyRequest = {
  __typename?: 'patientportal_RestartFormProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_RestartFormRequest>;
};

export type Patientportal_RestartFormProxyResponse = {
  __typename?: 'patientportal_RestartFormProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_RestartFormResponse>;
};

export type Patientportal_RevokePortalUserPermissionsRequest = {
  __typename?: 'patientportal_RevokePortalUserPermissionsRequest';
  portalUserId?: Maybe<Scalars['String']>;
  portalUserPermissions?: Maybe<Array<Maybe<Patientportal_PortalUserPermissionMsg>>>;
};

export type Patientportal_ScheduleAssignmentProxyMsg = {
  __typename?: 'patientportal_ScheduleAssignmentProxyMsg';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ScheduleAssignmentMsg>;
};

export type Patientportal_ScheduleExceptionProxyMsg = {
  __typename?: 'patientportal_ScheduleExceptionProxyMsg';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_ScheduleExceptionMsg>;
};

export type Patientportal_SearchClinicalRequestsProxyRequest = {
  __typename?: 'patientportal_SearchClinicalRequestsProxyRequest';
  facilityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Clinicalrequest_SearchClinicalRequestsRequest>;
};

export type Patientportal_SearchClinicalRequestsProxyResponse = {
  __typename?: 'patientportal_SearchClinicalRequestsProxyResponse';
  clinicalRequests?: Maybe<Array<Maybe<Patientportal_ClinicalRequestProxyMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Patientportal_SearchExternalClinicsRequest = {
  __typename?: 'patientportal_SearchExternalClinicsRequest';
  text?: Maybe<Scalars['String']>;
};

export type Patientportal_SearchExternalDepartmentsRequest = {
  __typename?: 'patientportal_SearchExternalDepartmentsRequest';
  externalClinicId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Patientportal_SearchExternalDepartmentsResponse = {
  __typename?: 'patientportal_SearchExternalDepartmentsResponse';
  externalClinicId?: Maybe<Scalars['String']>;
  externalDepartments?: Maybe<Array<Maybe<Patientportal_ExternalDepartmentMsg>>>;
};

export type Patientportal_SearchExternalOrganizationalUnitsRequest = {
  __typename?: 'patientportal_SearchExternalOrganizationalUnitsRequest';
  externalDepartmentId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Patientportal_SearchExternalOrganizationalUnitsResponse = {
  __typename?: 'patientportal_SearchExternalOrganizationalUnitsResponse';
  externalDepartmentId?: Maybe<Scalars['String']>;
  externalOrganizationalUnits?: Maybe<Array<Maybe<Patientportal_ExternalOrganizationalUnitMsg>>>;
};

export type Patientportal_SearchFormOptionsProxyRequest = {
  __typename?: 'patientportal_SearchFormOptionsProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_SearchFormOptionsRequest>;
};

export type Patientportal_SearchFormOptionsProxyResponse = {
  __typename?: 'patientportal_SearchFormOptionsProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_SearchFormOptionsResponse>;
};

export type Patientportal_SearchPortalFacilitiesRequest = {
  __typename?: 'patientportal_SearchPortalFacilitiesRequest';
  /** Optional input used to sort results and filter */
  coordinates?: Maybe<Core_CoordinatesMsg>;
  /** Optional filter */
  languagesFilter?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** Must be provided in kilometers */
  maxDistanceFilter?: Maybe<Scalars['Float']>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
};

export type Patientportal_SearchPortalFacilitiesResponse = {
  __typename?: 'patientportal_SearchPortalFacilitiesResponse';
  hitCount?: Maybe<Scalars['Int']>;
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_ServerNetworkConfigurationMsg = {
  __typename?: 'patientportal_ServerNetworkConfigurationMsg';
  host?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
};

export type Patientportal_SetDeviceFirebaseTokenRequest = {
  __typename?: 'patientportal_SetDeviceFirebaseTokenRequest';
  deviceSecretId?: Maybe<Scalars['String']>;
  firebaseToken?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_SetDeviceFirebaseTokenResponse = {
  __typename?: 'patientportal_SetDeviceFirebaseTokenResponse';
  _?: Maybe<Scalars['String']>;
};

export type Patientportal_SignInPortalUserParamsMsg = {
  __typename?: 'patientportal_SignInPortalUserParamsMsg';
  deviceSecretId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Patientportal_PortalDeviceType>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  userType?: Maybe<Core_UserType>;
};

export type Patientportal_SignInPortalUserRequest = {
  __typename?: 'patientportal_SignInPortalUserRequest';
  actionConfirmation?: Maybe<Patientportal_ActionConfirmationMsg>;
  params?: Maybe<Patientportal_SignInPortalUserParamsMsg>;
};

export type Patientportal_SignInPortalUserResponse = {
  __typename?: 'patientportal_SignInPortalUserResponse';
  confirmableAction?: Maybe<Patientportal_ConfirmableActionMsg>;
  success?: Maybe<Patientportal_SignInPortalUserSuccessMsg>;
};

export type Patientportal_SignInPortalUserSuccessMsg = {
  __typename?: 'patientportal_SignInPortalUserSuccessMsg';
  encryptedMatrixRecoveryKey?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Patientportal_SimpleExternalAdministrativeUnitList = {
  __typename?: 'patientportal_SimpleExternalAdministrativeUnitList';
  externalAdministrativeUnits?: Maybe<Array<Maybe<Patientportal_SimpleExternalAdministrativeUnitMsg>>>;
};

export type Patientportal_SimpleExternalAdministrativeUnitMsg = {
  __typename?: 'patientportal_SimpleExternalAdministrativeUnitMsg';
  contact?: Maybe<Core_ContactMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Patientportal_SimpleExternalAdministrativeUnitMsg>;
  type?: Maybe<Patientportal_ExternalAdministrativeUnitReferenceType>;
};

export type Patientportal_SimplePortalUserMsg = {
  __typename?: 'patientportal_SimplePortalUserMsg';
  dateOfBirth?: Maybe<Timestamp>;
  name?: Maybe<Core_HumanNameMsg>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_SubmitAppointmentRequestProxyRequest = {
  __typename?: 'patientportal_SubmitAppointmentRequestProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_SubmitAppointmentRequestRequest>;
};

export type Patientportal_SubmitClinicalRequestProxyRequest = {
  __typename?: 'patientportal_SubmitClinicalRequestProxyRequest';
  clinicalRequestId?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_SubmitClinicalRequestProxyResponse = {
  __typename?: 'patientportal_SubmitClinicalRequestProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_SwitchPortalUserRequest = {
  __typename?: 'patientportal_SwitchPortalUserRequest';
  /** If left empty, switches to the legal guardian account if they are currently logged in as a ward */
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdateAnamnesisCardReasonPortalProxyRequest = {
  __typename?: 'patientportal_UpdateAnamnesisCardReasonPortalProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Treatment_UpdateAnamnesisCardReasonRequest>;
};

export type Patientportal_UpdateAppointmentRequestProxyRequest = {
  __typename?: 'patientportal_UpdateAppointmentRequestProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_UpdateAppointmentRequestRequest>;
};

export type Patientportal_UpdateAppointmentTaskResultProxyRequest = {
  __typename?: 'patientportal_UpdateAppointmentTaskResultProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_UpdateAppointmentTaskResultRequest>;
};

export type Patientportal_UpdateAppointmentTaskStatusProxyRequest = {
  __typename?: 'patientportal_UpdateAppointmentTaskStatusProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  request?: Maybe<Resource_UpdateAppointmentTaskStatusRequest>;
};

export type Patientportal_UpdateClinicalRequestProxyRequest = {
  __typename?: 'patientportal_UpdateClinicalRequestProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Clinicalrequest_UpdateClinicalRequestRequest>;
};

export type Patientportal_UpdateClinicalRequestProxyResponse = {
  __typename?: 'patientportal_UpdateClinicalRequestProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdateCommentProxyRequest = {
  __typename?: 'patientportal_UpdateCommentProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Comment_UpdateCommentRequest>;
};

export type Patientportal_UpdateCommentProxyResponse = {
  __typename?: 'patientportal_UpdateCommentProxyResponse';
  comment?: Maybe<Comment_CommentMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdateCustomClinicalRequestInputProxyRequest = {
  __typename?: 'patientportal_UpdateCustomClinicalRequestInputProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Clinicalrequest_UpdateCustomClinicalRequestInputRequest>;
};

export type Patientportal_UpdateCustomClinicalRequestInputProxyResponse = {
  __typename?: 'patientportal_UpdateCustomClinicalRequestInputProxyResponse';
  customClinicalRequestInput?: Maybe<Clinicalrequest_CustomClinicalRequestInputMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdateFormStatusProxyRequest = {
  __typename?: 'patientportal_UpdateFormStatusProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Form_UpdateFormStatusRequest>;
};

export type Patientportal_UpdateFormStatusProxyResponse = {
  __typename?: 'patientportal_UpdateFormStatusProxyResponse';
  clinicId?: Maybe<Scalars['String']>;
  response?: Maybe<Form_UpdateFormStatusResponse>;
};

export type Patientportal_UpdatePortalFacilityParentRequest = {
  __typename?: 'patientportal_UpdatePortalFacilityParentRequest';
  parentId?: Maybe<Scalars['String']>;
  portalFacilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdatePortalFacilityParentResponse = {
  __typename?: 'patientportal_UpdatePortalFacilityParentResponse';
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
};

export type Patientportal_UpdatePortalFacilityParentsRequest = {
  __typename?: 'patientportal_UpdatePortalFacilityParentsRequest';
  requests?: Maybe<Array<Maybe<Patientportal_UpdatePortalFacilityParentRequest>>>;
};

export type Patientportal_UpdatePortalFacilityParentsResponse = {
  __typename?: 'patientportal_UpdatePortalFacilityParentsResponse';
  portalFacilities?: Maybe<Array<Maybe<Patientportal_PortalFacilityMsg>>>;
};

export type Patientportal_UpdatePortalFacilityRequest = {
  __typename?: 'patientportal_UpdatePortalFacilityRequest';
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
};

export type Patientportal_UpdatePortalFacilityResponse = {
  __typename?: 'patientportal_UpdatePortalFacilityResponse';
  portalFacility?: Maybe<Patientportal_PortalFacilityMsg>;
};

export type Patientportal_UpdatePortalPatientAllergiesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientAllergiesProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientAllergiesRequest>;
};

export type Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientDataSnapshotStatusesProxyRequest';
  clinicId?: Maybe<Scalars['String']>;
  request?: Maybe<Portaldata_UpdatePortalPatientDataSnapshotStatusesRequest>;
};

export type Patientportal_UpdatePortalPatientDataSnapshotStatusesProxyResponse = {
  __typename?: 'patientportal_UpdatePortalPatientDataSnapshotStatusesProxyResponse';
  response?: Maybe<Portaldata_UpdatePortalPatientDataSnapshotStatusesResponse>;
};

export type Patientportal_UpdatePortalPatientDiagnosesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientDiagnosesProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientDiagnosesRequest>;
};

export type Patientportal_UpdatePortalPatientDiaryEntriesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientDiaryEntriesProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientDiaryEntriesRequest>;
};

export type Patientportal_UpdatePortalPatientMedicationsProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientMedicationsProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientMedicationsRequest>;
};

export type Patientportal_UpdatePortalPatientQuantityEntriesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientQuantityEntriesProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientQuantityEntriesRequest>;
};

export type Patientportal_UpdatePortalPatientSurgeriesProxyRequest = {
  __typename?: 'patientportal_UpdatePortalPatientSurgeriesProxyRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  request?: Maybe<Portaldata_UpdatePortalPatientSurgeriesRequest>;
};

export type Patientportal_UpdatePortalUserClinicRequest = {
  __typename?: 'patientportal_UpdatePortalUserClinicRequest';
  clinicId?: Maybe<Scalars['String']>;
  isSyncEnabled?: Maybe<Scalars['Boolean']>;
};

export type Patientportal_UpdatePortalUserClinicResponse = {
  __typename?: 'patientportal_UpdatePortalUserClinicResponse';
  clinic?: Maybe<Patientportal_PortalUserClinicMsg>;
};

export type Patientportal_UpdatePortalUserPasswordParamsMsg = {
  __typename?: 'patientportal_UpdatePortalUserPasswordParamsMsg';
  newPassword?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Patientportal_UpdatePortalUserPasswordRequest = {
  __typename?: 'patientportal_UpdatePortalUserPasswordRequest';
  actionConfirmation?: Maybe<Patientportal_ActionConfirmationMsg>;
  params?: Maybe<Patientportal_UpdatePortalUserPasswordParamsMsg>;
};

export type Patientportal_UpdatePortalUserPasswordResponse = {
  __typename?: 'patientportal_UpdatePortalUserPasswordResponse';
  confirmableAction?: Maybe<Patientportal_ConfirmableActionMsg>;
  success?: Maybe<Helper_Empty>;
};

export type Patientportal_UpdatePortalUserRequest = {
  __typename?: 'patientportal_UpdatePortalUserRequest';
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  /** True sets the corresponding field true, otherwise does not change it */
  medicalDataSetupCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Core_HumanNameMsg>;
  sex?: Maybe<Core_Sex>;
};

export type Patientportal_UpdatePortalUserResponse = {
  __typename?: 'patientportal_UpdatePortalUserResponse';
  portalUser?: Maybe<Patientportal_PortalUserMsg>;
};

export type Patientportal_UpdatePortalUserSettingsRequest = {
  __typename?: 'patientportal_UpdatePortalUserSettingsRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  settings?: Maybe<Patientportal_PortalAccountSettingsMsg>;
};

export type Patientportal_UpdateRelevantProblemsProxyRequest = {
  __typename?: 'patientportal_UpdateRelevantProblemsProxyRequest';
  facilityId?: Maybe<Scalars['String']>;
  request?: Maybe<Clinicalrequest_UpdateRelevantProblemsRequest>;
};

export type Patientportal_UpdateRelevantProblemsProxyResponse = {
  __typename?: 'patientportal_UpdateRelevantProblemsProxyResponse';
  clinicalRequest?: Maybe<Clinicalrequest_ClinicalRequestMsg>;
  facilityId?: Maybe<Scalars['String']>;
};

export type Patientportal_VerifyThirdPartyCommunicationParamsMsg = {
  __typename?: 'patientportal_VerifyThirdPartyCommunicationParamsMsg';
  email?: Maybe<Scalars['String']>;
  sms?: Maybe<Scalars['String']>;
};

export type Patientportal_VerifyThirdPartyCommunicationRequest = {
  __typename?: 'patientportal_VerifyThirdPartyCommunicationRequest';
  actionConfirmation?: Maybe<Patientportal_ActionConfirmationMsg>;
  params?: Maybe<Patientportal_VerifyThirdPartyCommunicationParamsMsg>;
};

export type Patientportal_VerifyThirdPartyCommunicationResponse = {
  __typename?: 'patientportal_VerifyThirdPartyCommunicationResponse';
  confirmableAction?: Maybe<Patientportal_ConfirmableActionMsg>;
  success?: Maybe<Patientportal_VerifyThirdPartyCommunicationSuccessMsg>;
};

export type Patientportal_VerifyThirdPartyCommunicationSuccessMsg = {
  __typename?: 'patientportal_VerifyThirdPartyCommunicationSuccessMsg';
  token?: Maybe<Scalars['String']>;
};

export type Patientportal_WeeklyScheduleMsg = {
  __typename?: 'patientportal_WeeklyScheduleMsg';
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  id?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<Core_TimeFrameOfDayMsg>;
};

export type Portaldata_CreatePortalPatientDataSnapshotRequest = {
  __typename?: 'portaldata_CreatePortalPatientDataSnapshotRequest';
  snapshot?: Maybe<Portaldata_PortalPatientDataSnapshotMsg>;
};

export type Portaldata_ExternalPortalActiveIngredientIdMsg = {
  __typename?: 'portaldata_ExternalPortalActiveIngredientIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalActiveIngredientIdType>;
};

export type Portaldata_ExternalPortalActiveIngredientUnitIdMsg = {
  __typename?: 'portaldata_ExternalPortalActiveIngredientUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalActiveIngredientUnitIdType>;
};

export type Portaldata_ExternalPortalDrugFormIdMsg = {
  __typename?: 'portaldata_ExternalPortalDrugFormIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalDrugFormIdType>;
};

export type Portaldata_ExternalPortalDrugIdMsg = {
  __typename?: 'portaldata_ExternalPortalDrugIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Drug_ExternalDrugIdType>;
};

export type Portaldata_ExternalPortalDrugPackageIdMsg = {
  __typename?: 'portaldata_ExternalPortalDrugPackageIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDrugPackageIdType>;
};

export type Portaldata_ExternalPortalMedicationDosageUnitIdMsg = {
  __typename?: 'portaldata_ExternalPortalMedicationDosageUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalMedicationDosageUnitIdType>;
};

export type Portaldata_ListPortalPatientDataSnapshotMetadataRequest = {
  __typename?: 'portaldata_ListPortalPatientDataSnapshotMetadataRequest';
  _?: Maybe<Scalars['String']>;
};

export type Portaldata_ListPortalPatientDataSnapshotMetadataResponse = {
  __typename?: 'portaldata_ListPortalPatientDataSnapshotMetadataResponse';
  patientDataSnapshotMetadata?: Maybe<Array<Maybe<Portaldata_PortalPatientDataSnapshotMetadataMsg>>>;
};

export type Portaldata_ListPortalPatientDataSnapshotsRequest = {
  __typename?: 'portaldata_ListPortalPatientDataSnapshotsRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Portaldata_ListPortalPatientDataSnapshotsResponse = {
  __typename?: 'portaldata_ListPortalPatientDataSnapshotsResponse';
  portalPatientDataSnapshots?: Maybe<Array<Maybe<Portaldata_PortalPatientDataSnapshotMsg>>>;
};

export type Portaldata_PortalActiveIngredientMsg = {
  __typename?: 'portaldata_PortalActiveIngredientMsg';
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalActiveIngredientIdMsg>>>;
  name?: Maybe<Scalars['String']>;
  strength?: Maybe<Portaldata_PortalActiveIngredientStrengthMsg>;
};

export type Portaldata_PortalActiveIngredientStrengthMsg = {
  __typename?: 'portaldata_PortalActiveIngredientStrengthMsg';
  lowerValue?: Maybe<Scalars['Float']>;
  unit?: Maybe<Portaldata_PortalActiveIngredientUnitMsg>;
  /** In some cases, the strength is provided as a range; in that case, this is required */
  upperValue?: Maybe<Scalars['Float']>;
};

export type Portaldata_PortalActiveIngredientUnitMsg = {
  __typename?: 'portaldata_PortalActiveIngredientUnitMsg';
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalActiveIngredientUnitIdMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalAllergyMsg = {
  __typename?: 'portaldata_PortalAllergyMsg';
  allergen?: Maybe<Core_KnowledgeInputMsg>;
  clientId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  reactionSeverity?: Maybe<Treatment_ReactionSeverity>;
  reactionType?: Maybe<Treatment_ReactionType>;
  symptoms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Portaldata_PortalDiagnosisCodingMsg = {
  __typename?: 'portaldata_PortalDiagnosisCodingMsg';
  codingId?: Maybe<Scalars['String']>;
  system?: Maybe<Treatment_DiagnosisCodingSystem>;
  systemVersion?: Maybe<Scalars['String']>;
  /** Relevant if the system uses multiple types of codes */
  type?: Maybe<Treatment_DiagnosisCodeType>;
};

export type Portaldata_PortalDiagnosisMsg = {
  __typename?: 'portaldata_PortalDiagnosisMsg';
  clientId?: Maybe<Scalars['String']>;
  codings?: Maybe<Array<Maybe<Portaldata_PortalDiagnosisCodingMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_DiagnosisDetailType>;
};

export type Portaldata_PortalDiaryEntryContentFeverMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentFeverMsg';
  temperatureC?: Maybe<Scalars['Float']>;
};

export type Portaldata_PortalDiaryEntryContentHealthStatusMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentHealthStatusMsg';
  healthStatus?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDiaryEntryContentMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentMsg';
  contentFever?: Maybe<Portaldata_PortalDiaryEntryContentFeverMsg>;
  contentHealthStatus?: Maybe<Portaldata_PortalDiaryEntryContentHealthStatusMsg>;
  contentNotes?: Maybe<Portaldata_PortalDiaryEntryContentNotesMsg>;
  contentPain?: Maybe<Portaldata_PortalDiaryEntryContentPainMsg>;
  contentSymptom?: Maybe<Portaldata_PortalDiaryEntryContentSymptomMsg>;
  contentType?: Maybe<Portaldata_PortalDiaryEntryContentType>;
  endTime?: Maybe<Core_LocalTimeMsg>;
  startTime?: Maybe<Core_LocalTimeMsg>;
};

export type Portaldata_PortalDiaryEntryContentNotesMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentNotesMsg';
  notes?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDiaryEntryContentPainMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentPainMsg';
  intensity?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDiaryEntryContentSymptomMsg = {
  __typename?: 'portaldata_PortalDiaryEntryContentSymptomMsg';
  intensity?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  symptom?: Maybe<Core_KnowledgeInputMsg>;
};

export enum Portaldata_PortalDiaryEntryContentType {
  PortalDiaryEntryContentTypeFever = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_FEVER',
  PortalDiaryEntryContentTypeHealthStatus = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_HEALTH_STATUS',
  PortalDiaryEntryContentTypeNone = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_NONE',
  PortalDiaryEntryContentTypeNotes = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_NOTES',
  PortalDiaryEntryContentTypePain = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_PAIN',
  PortalDiaryEntryContentTypeSymptom = 'PORTAL_DIARY_ENTRY_CONTENT_TYPE_SYMPTOM'
}

export type Portaldata_PortalDiaryEntryMsg = {
  __typename?: 'portaldata_PortalDiaryEntryMsg';
  clientId?: Maybe<Scalars['String']>;
  contents?: Maybe<Array<Maybe<Portaldata_PortalDiaryEntryContentMsg>>>;
  date?: Maybe<Core_LocalDateMsg>;
  id?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDrugFormMsg = {
  __typename?: 'portaldata_PortalDrugFormMsg';
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalDrugFormIdMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDrugMsg = {
  __typename?: 'portaldata_PortalDrugMsg';
  activeIngredients?: Maybe<Array<Maybe<Portaldata_PortalActiveIngredientMsg>>>;
  customText?: Maybe<Scalars['String']>;
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalDrugIdMsg>>>;
  form?: Maybe<Portaldata_PortalDrugFormMsg>;
  /**
   * If this is set, only the customText is relevant, not the other fields.
   *  Relevant e.g. in cases in which several active ingredients are mixed in custom ratio to create this drug.
   */
  isCustom?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalDrugPackageMsg = {
  __typename?: 'portaldata_PortalDrugPackageMsg';
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalDrugPackageIdMsg>>>;
  name?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalMedicationDosageUnitMsg = {
  __typename?: 'portaldata_PortalMedicationDosageUnitMsg';
  externalIds?: Maybe<Array<Maybe<Portaldata_ExternalPortalMedicationDosageUnitIdMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Portaldata_PortalMedicationMsg = {
  __typename?: 'portaldata_PortalMedicationMsg';
  clientId?: Maybe<Scalars['String']>;
  drug?: Maybe<Portaldata_PortalDrugMsg>;
  drugPackage?: Maybe<Portaldata_PortalDrugPackageMsg>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  schedule?: Maybe<Portaldata_PortalMedicationScheduleMsg>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  type?: Maybe<Portaldata_PortalMedicationType>;
};

export type Portaldata_PortalMedicationScheduleMsg = {
  __typename?: 'portaldata_PortalMedicationScheduleMsg';
  /** used with type WEEKLY */
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  dosageUnit?: Maybe<Portaldata_PortalMedicationDosageUnitMsg>;
  /** used with type DAILY/WEEKLY */
  eveningDosageValue?: Maybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  morningDosageValue?: Maybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  nightDosageValue?: Maybe<Scalars['Float']>;
  /** used with type DAILY/WEEKLY */
  noonDosageValue?: Maybe<Scalars['Float']>;
  /** used with type TEXT */
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Portaldata_PortalMedicationScheduleType>;
};

export enum Portaldata_PortalMedicationScheduleType {
  PortalMedicationScheduleTypeDaily = 'PORTAL_MEDICATION_SCHEDULE_TYPE_DAILY',
  PortalMedicationScheduleTypeNone = 'PORTAL_MEDICATION_SCHEDULE_TYPE_NONE',
  PortalMedicationScheduleTypeText = 'PORTAL_MEDICATION_SCHEDULE_TYPE_TEXT',
  PortalMedicationScheduleTypeWeekly = 'PORTAL_MEDICATION_SCHEDULE_TYPE_WEEKLY'
}

export enum Portaldata_PortalMedicationType {
  PortalMedicationTypeAcute = 'PORTAL_MEDICATION_TYPE_ACUTE',
  PortalMedicationTypeNone = 'PORTAL_MEDICATION_TYPE_NONE',
  PortalMedicationTypeOnDemand = 'PORTAL_MEDICATION_TYPE_ON_DEMAND',
  PortalMedicationTypePermanent = 'PORTAL_MEDICATION_TYPE_PERMANENT'
}

export type Portaldata_PortalPatientDataSnapshotMetadataMsg = {
  __typename?: 'portaldata_PortalPatientDataSnapshotMetadataMsg';
  patientDataSnapshotId?: Maybe<Scalars['String']>;
  status?: Maybe<Portaldata_PortalPatientDataSnapshotStatus>;
  timestamp?: Maybe<Timestamp>;
};

export type Portaldata_PortalPatientDataSnapshotMsg = {
  __typename?: 'portaldata_PortalPatientDataSnapshotMsg';
  allergies?: Maybe<Array<Maybe<Portaldata_PortalAllergyMsg>>>;
  diagnoses?: Maybe<Array<Maybe<Portaldata_PortalDiagnosisMsg>>>;
  diaryEntries?: Maybe<Array<Maybe<Portaldata_PortalDiaryEntryMsg>>>;
  hasAllergies?: Maybe<Scalars['Boolean']>;
  hasDiagnoses?: Maybe<Scalars['Boolean']>;
  hasMedications?: Maybe<Scalars['Boolean']>;
  hasSurgeries?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  medications?: Maybe<Array<Maybe<Portaldata_PortalMedicationMsg>>>;
  quantityEntries?: Maybe<Array<Maybe<Portaldata_PortalQuantityEntryMsg>>>;
  status?: Maybe<Portaldata_PortalPatientDataSnapshotStatus>;
  surgeries?: Maybe<Array<Maybe<Portaldata_PortalSurgeryMsg>>>;
  timestamp?: Maybe<Timestamp>;
};

export enum Portaldata_PortalPatientDataSnapshotStatus {
  PortalPatientDataSnapshotStatusHidden = 'PORTAL_PATIENT_DATA_SNAPSHOT_STATUS_HIDDEN',
  PortalPatientDataSnapshotStatusNone = 'PORTAL_PATIENT_DATA_SNAPSHOT_STATUS_NONE',
  PortalPatientDataSnapshotStatusVisible = 'PORTAL_PATIENT_DATA_SNAPSHOT_STATUS_VISIBLE'
}

export type Portaldata_PortalQuantityBloodPressureMsg = {
  __typename?: 'portaldata_PortalQuantityBloodPressureMsg';
  diastolicValueMmHg?: Maybe<Scalars['Int']>;
  systolicValueMmHg?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityBloodSugarMsg = {
  __typename?: 'portaldata_PortalQuantityBloodSugarMsg';
  valueMgDl?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityDistanceWalkingRunningMsg = {
  __typename?: 'portaldata_PortalQuantityDistanceWalkingRunningMsg';
  valueM?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityEntryMsg = {
  __typename?: 'portaldata_PortalQuantityEntryMsg';
  clientId?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Portaldata_PortalQuantityMsg>;
  startTimestamp?: Maybe<Timestamp>;
};

export type Portaldata_PortalQuantityFlightsClimbedMsg = {
  __typename?: 'portaldata_PortalQuantityFlightsClimbedMsg';
  value?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityHeightMsg = {
  __typename?: 'portaldata_PortalQuantityHeightMsg';
  valueCm?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityMsg = {
  __typename?: 'portaldata_PortalQuantityMsg';
  bloodPressure?: Maybe<Portaldata_PortalQuantityBloodPressureMsg>;
  bloodSugar?: Maybe<Portaldata_PortalQuantityBloodSugarMsg>;
  distanceWalkingRunning?: Maybe<Portaldata_PortalQuantityDistanceWalkingRunningMsg>;
  flightsClimbed?: Maybe<Portaldata_PortalQuantityFlightsClimbedMsg>;
  height?: Maybe<Portaldata_PortalQuantityHeightMsg>;
  oxygenSaturation?: Maybe<Portaldata_PortalQuantityOxygenSaturationMsg>;
  pulse?: Maybe<Portaldata_PortalQuantityPulseMsg>;
  respiratoryRate?: Maybe<Portaldata_PortalQuantityRespiratoryRateMsg>;
  stepCount?: Maybe<Portaldata_PortalQuantityStepCountMsg>;
  temperature?: Maybe<Portaldata_PortalQuantityTemperatureMsg>;
  type?: Maybe<Portaldata_PortalQuantityType>;
  weight?: Maybe<Portaldata_PortalQuantityWeightMsg>;
};

export type Portaldata_PortalQuantityOxygenSaturationMsg = {
  __typename?: 'portaldata_PortalQuantityOxygenSaturationMsg';
  valuePercent?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityPulseMsg = {
  __typename?: 'portaldata_PortalQuantityPulseMsg';
  valueBpm?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityRespiratoryRateMsg = {
  __typename?: 'portaldata_PortalQuantityRespiratoryRateMsg';
  valueBpm?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityStepCountMsg = {
  __typename?: 'portaldata_PortalQuantityStepCountMsg';
  value?: Maybe<Scalars['Int']>;
};

export type Portaldata_PortalQuantityTemperatureMsg = {
  __typename?: 'portaldata_PortalQuantityTemperatureMsg';
  valueC?: Maybe<Scalars['Float']>;
};

export enum Portaldata_PortalQuantityTimingType {
  PortalQuantityTimingTypeLocalDateTime = 'PORTAL_QUANTITY_TIMING_TYPE_LOCAL_DATE_TIME',
  PortalQuantityTimingTypeNone = 'PORTAL_QUANTITY_TIMING_TYPE_NONE',
  PortalQuantityTimingTypeTimestamp = 'PORTAL_QUANTITY_TIMING_TYPE_TIMESTAMP'
}

export enum Portaldata_PortalQuantityType {
  PortalQuantityTypeBloodPressure = 'PORTAL_QUANTITY_TYPE_BLOOD_PRESSURE',
  PortalQuantityTypeBloodSugar = 'PORTAL_QUANTITY_TYPE_BLOOD_SUGAR',
  PortalQuantityTypeDistanceWalkingRunning = 'PORTAL_QUANTITY_TYPE_DISTANCE_WALKING_RUNNING',
  PortalQuantityTypeFlightsClimbed = 'PORTAL_QUANTITY_TYPE_FLIGHTS_CLIMBED',
  PortalQuantityTypeHeight = 'PORTAL_QUANTITY_TYPE_HEIGHT',
  PortalQuantityTypeNone = 'PORTAL_QUANTITY_TYPE_NONE',
  PortalQuantityTypeOxygenSaturation = 'PORTAL_QUANTITY_TYPE_OXYGEN_SATURATION',
  PortalQuantityTypePulse = 'PORTAL_QUANTITY_TYPE_PULSE',
  PortalQuantityTypeRespiratoryRate = 'PORTAL_QUANTITY_TYPE_RESPIRATORY_RATE',
  PortalQuantityTypeStepCount = 'PORTAL_QUANTITY_TYPE_STEP_COUNT',
  PortalQuantityTypeTemperature = 'PORTAL_QUANTITY_TYPE_TEMPERATURE',
  PortalQuantityTypeWeight = 'PORTAL_QUANTITY_TYPE_WEIGHT'
}

export type Portaldata_PortalQuantityWeightMsg = {
  __typename?: 'portaldata_PortalQuantityWeightMsg';
  valueKg?: Maybe<Scalars['Float']>;
};

export type Portaldata_PortalSurgeryMsg = {
  __typename?: 'portaldata_PortalSurgeryMsg';
  clientId?: Maybe<Scalars['String']>;
  date?: Maybe<Core_LocalDateTimeMsg>;
  id?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  notes?: Maybe<Scalars['String']>;
  procedure?: Maybe<Core_KnowledgeInputMsg>;
  surgeon?: Maybe<Scalars['String']>;
};

export type Portaldata_UpdatePortalPatientAllergiesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientAllergiesRequest';
  createdOrUpdatedPortalAllergies?: Maybe<Array<Maybe<Portaldata_PortalAllergyMsg>>>;
  deletedPortalAllergyClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasAllergies?: Maybe<Scalars['Boolean']>;
};

export type Portaldata_UpdatePortalPatientDataSnapshotStatusesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientDataSnapshotStatusesRequest';
  elements?: Maybe<Array<Maybe<Portaldata_UpdatePortalPatientDataSnapshotStatusesRequestElementMsg>>>;
};

export type Portaldata_UpdatePortalPatientDataSnapshotStatusesRequestElementMsg = {
  __typename?: 'portaldata_UpdatePortalPatientDataSnapshotStatusesRequestElementMsg';
  patientDataSnapshotId?: Maybe<Scalars['String']>;
  status?: Maybe<Portaldata_PortalPatientDataSnapshotStatus>;
};

export type Portaldata_UpdatePortalPatientDataSnapshotStatusesResponse = {
  __typename?: 'portaldata_UpdatePortalPatientDataSnapshotStatusesResponse';
  changedPatientDataSnapshots?: Maybe<Array<Maybe<Portaldata_PortalPatientDataSnapshotMetadataMsg>>>;
};

export type Portaldata_UpdatePortalPatientDiagnosesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientDiagnosesRequest';
  createdOrUpdatedPortalDiagnoses?: Maybe<Array<Maybe<Portaldata_PortalDiagnosisMsg>>>;
  deletedPortalDiagnosisClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasDiagnoses?: Maybe<Scalars['Boolean']>;
};

export type Portaldata_UpdatePortalPatientDiaryEntriesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientDiaryEntriesRequest';
  createdOrUpdatedPortalDiaryEntries?: Maybe<Array<Maybe<Portaldata_PortalDiaryEntryMsg>>>;
  deletedPortalDiaryEntryClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Portaldata_UpdatePortalPatientMedicationsRequest = {
  __typename?: 'portaldata_UpdatePortalPatientMedicationsRequest';
  createdOrUpdatedPortalMedications?: Maybe<Array<Maybe<Portaldata_PortalMedicationMsg>>>;
  deletedPortalMedicationClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasMedications?: Maybe<Scalars['Boolean']>;
};

export type Portaldata_UpdatePortalPatientQuantityEntriesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientQuantityEntriesRequest';
  createdOrUpdatedPortalQuantityEntries?: Maybe<Array<Maybe<Portaldata_PortalQuantityEntryMsg>>>;
  deletedPortalQuantityEntryClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Portaldata_UpdatePortalPatientSurgeriesRequest = {
  __typename?: 'portaldata_UpdatePortalPatientSurgeriesRequest';
  createdOrUpdatedPortalSurgeries?: Maybe<Array<Maybe<Portaldata_PortalSurgeryMsg>>>;
  deletedPortalSurgeryClientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasSurgeries?: Maybe<Scalars['Boolean']>;
};

export type Reference_AgeMsg = {
  __typename?: 'reference_AgeMsg';
  age?: Maybe<Scalars['Int']>;
  resolution?: Maybe<TimePrecisionLevel>;
};

/** If the category of the result is part of the list in this reference, the result is inconspicuous */
export type Reference_CategoryReferenceMsg = {
  __typename?: 'reference_CategoryReferenceMsg';
  contain?: Maybe<Array<Maybe<Category_ResultCategoryMsg>>>;
};

export type Reference_DecimalReferenceMsg = {
  __typename?: 'reference_DecimalReferenceMsg';
  lower?: Maybe<DecimalMsg>;
  lowerInclusive?: Maybe<Scalars['Boolean']>;
  upper?: Maybe<DecimalMsg>;
  upperInclusive?: Maybe<Scalars['Boolean']>;
};

export type Reference_IntegerReferenceMsg = {
  __typename?: 'reference_IntegerReferenceMsg';
  lower?: Maybe<Scalars['Int']>;
  lowerInclusive?: Maybe<Scalars['Boolean']>;
  upper?: Maybe<Scalars['Int']>;
  upperInclusive?: Maybe<Scalars['Boolean']>;
};

/** A group of people identified by various criteria such as sex, age, or further medical characteristics */
export type Reference_PopulationMsg = {
  __typename?: 'reference_PopulationMsg';
  /** inclusive */
  ageLower?: Maybe<Reference_AgeMsg>;
  /** inclusive */
  ageUpper?: Maybe<Reference_AgeMsg>;
  /** Can be set if the reference applies to a specific subset, e.g., pregnant women */
  flags?: Maybe<Array<Maybe<Core_FlagMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sexes?: Maybe<Array<Maybe<Core_Sex>>>;
};

export type Reference_RatioReferenceMsg = {
  __typename?: 'reference_RatioReferenceMsg';
  lower?: Maybe<RatioMsg>;
  lowerInclusive?: Maybe<Scalars['Boolean']>;
  upper?: Maybe<RatioMsg>;
  upperInclusive?: Maybe<Scalars['Boolean']>;
};

export enum Reference_ReferenceRangeKind {
  ReferenceRangeKindDefaultChartRange = 'REFERENCE_RANGE_KIND_DEFAULT_CHART_RANGE',
  ReferenceRangeKindNone = 'REFERENCE_RANGE_KIND_NONE',
  ReferenceRangeKindReferenceRange = 'REFERENCE_RANGE_KIND_REFERENCE_RANGE',
  ReferenceRangeKindValidRange = 'REFERENCE_RANGE_KIND_VALID_RANGE'
}

export type Reference_ReferenceRangeMsg = {
  __typename?: 'reference_ReferenceRangeMsg';
  boolReference?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<Reference_CategoryReferenceMsg>;
  /**
   * Set true if the referenceRange is not defined for the TestAnalyte, but created ad-hoc;
   *  this is especially the case for external lab results.
   */
  customRange?: Maybe<Scalars['Boolean']>;
  /**
   * If the reference range should be displayed in a non-standardized way,
   *  e.g. using an overall description for a number of categories
   */
  customText?: Maybe<Scalars['String']>;
  decimalReference?: Maybe<Reference_DecimalReferenceMsg>;
  /** For double values, number of digits behind the decimal point */
  fractionDigits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  integerReference?: Maybe<Reference_IntegerReferenceMsg>;
  /** The scope this reference range is valid for, like a measurement parameter. */
  parentId?: Maybe<Scalars['String']>;
  /** For whom this reference range is applicable */
  population?: Maybe<Reference_PopulationMsg>;
  ratioReference?: Maybe<Reference_RatioReferenceMsg>;
  text?: Maybe<Reference_TextReferenceMsg>;
  type?: Maybe<Reference_ReferenceRangeTypeMsg>;
};

export enum Reference_ReferenceRangeSeverity {
  ReferenceRangeSeverityAbnormal = 'REFERENCE_RANGE_SEVERITY_ABNORMAL',
  ReferenceRangeSeverityCritical = 'REFERENCE_RANGE_SEVERITY_CRITICAL',
  ReferenceRangeSeverityCustom = 'REFERENCE_RANGE_SEVERITY_CUSTOM',
  ReferenceRangeSeverityInconspicuous = 'REFERENCE_RANGE_SEVERITY_INCONSPICUOUS',
  ReferenceRangeSeverityNone = 'REFERENCE_RANGE_SEVERITY_NONE'
}

export type Reference_ReferenceRangeSystemMsg = {
  __typename?: 'reference_ReferenceRangeSystemMsg';
  id?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  referenceRangeTypes?: Maybe<Array<Maybe<Reference_ReferenceRangeTypeMsg>>>;
};

export type Reference_ReferenceRangeTypeMsg = {
  __typename?: 'reference_ReferenceRangeTypeMsg';
  colorCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /**
   * if true, the respective reference range is the inconspicuous, i.e., default, one
   * @deprecated deprecated in proto
   */
  inconspicuousReference?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Reference_ReferenceRangeKind>;
  name?: Maybe<Scalars['String']>;
  severity?: Maybe<Reference_ReferenceRangeSeverity>;
};

export type Reference_TextReferenceMsg = {
  __typename?: 'reference_TextReferenceMsg';
  text?: Maybe<Scalars['String']>;
};

export type Resource_AcceptAppointmentProposalRequest = {
  __typename?: 'resource_AcceptAppointmentProposalRequest';
  /** The given proposed appointment will be booked and the others for the same request will be rejected */
  appointmentSlotProposalId?: Maybe<Scalars['String']>;
};

export type Resource_AddAppointmentSeriesAttendeesRequest = {
  __typename?: 'resource_AddAppointmentSeriesAttendeesRequest';
  appointmentSeriesId?: Maybe<Scalars['String']>;
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  status?: Maybe<Resource_AppointmentStatus>;
};

export type Resource_AddDepletableResourceChangeRequest = {
  __typename?: 'resource_AddDepletableResourceChangeRequest';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  change?: Maybe<Resource_DepletableResourceChangeMsg>;
};

export type Resource_AdditionalServiceList = {
  __typename?: 'resource_AdditionalServiceList';
  additionalServices?: Maybe<Array<Maybe<Resource_AdditionalServiceMsg>>>;
};

export type Resource_AdditionalServiceMsg = {
  __typename?: 'resource_AdditionalServiceMsg';
  /** We might need price unit in the future, for now it is in Euros */
  additionalPrice?: Maybe<Scalars['Float']>;
  description?: Maybe<Core_LocalizedStringMsg>;
  /** In minutes */
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_LocalizedStringMsg>;
  officeHourId?: Maybe<Scalars['String']>;
  status?: Maybe<Resource_AdditionalServiceStatus>;
};

export enum Resource_AdditionalServiceStatus {
  AdditionalServiceStatusActive = 'ADDITIONAL_SERVICE_STATUS_ACTIVE',
  AdditionalServiceStatusInactive = 'ADDITIONAL_SERVICE_STATUS_INACTIVE',
  AdditionalServiceStatusNone = 'ADDITIONAL_SERVICE_STATUS_NONE',
  AdditionalServiceStatusNotYetActive = 'ADDITIONAL_SERVICE_STATUS_NOT_YET_ACTIVE'
}

export type Resource_AppointmentAttendeeBasicInfoMsg = {
  __typename?: 'resource_AppointmentAttendeeBasicInfoMsg';
  dateOfBirth?: Maybe<Timestamp>;
  name?: Maybe<Core_HumanNameMsg>;
};

export enum Resource_AppointmentAttendeeIdentifierDisplayType {
  AppointmentAttendeeIdentifierDisplayTypeAttendeeInfo = 'APPOINTMENT_ATTENDEE_IDENTIFIER_DISPLAY_TYPE_ATTENDEE_INFO',
  AppointmentAttendeeIdentifierDisplayTypeNone = 'APPOINTMENT_ATTENDEE_IDENTIFIER_DISPLAY_TYPE_NONE',
  AppointmentAttendeeIdentifierDisplayTypePatient = 'APPOINTMENT_ATTENDEE_IDENTIFIER_DISPLAY_TYPE_PATIENT',
  AppointmentAttendeeIdentifierDisplayTypePortalUser = 'APPOINTMENT_ATTENDEE_IDENTIFIER_DISPLAY_TYPE_PORTAL_USER'
}

export type Resource_AppointmentAttendeeInfoMsg = {
  __typename?: 'resource_AppointmentAttendeeInfoMsg';
  contact?: Maybe<Core_ContactMsg>;
  dateOfBirth?: Maybe<Timestamp>;
  externalIds?: Maybe<Array<Maybe<Resource_ExternalAppointmentAttendeeIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_HumanNameMsg>;
  sex?: Maybe<Core_Sex>;
};

export type Resource_AppointmentAttendeeMsg = {
  __typename?: 'resource_AppointmentAttendeeMsg';
  /**
   * Used only when an appointment is created in the clinic side frontend for a patient (the actual human being)
   * that does not have a portal account or an internal patient (the backend entity)
   */
  attendeeInfo?: Maybe<Resource_AppointmentAttendeeInfoMsg>;
  attendeeStatus?: Maybe<Resource_AppointmentStatus>;
  displayType?: Maybe<Resource_AppointmentAttendeeIdentifierDisplayType>;
  id?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
};

export type Resource_AppointmentBasicInfoMsg = {
  __typename?: 'resource_AppointmentBasicInfoMsg';
  appointmentTypeName?: Maybe<Core_LocalizedStringMsg>;
  attendeeCount?: Maybe<Scalars['Int']>;
  attendeeInfos?: Maybe<Array<Maybe<Resource_AppointmentAttendeeBasicInfoMsg>>>;
  editingDisabled?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Timestamp>;
  external?: Maybe<Scalars['Boolean']>;
  groupAppointment?: Maybe<Scalars['Boolean']>;
  groupAppointmentQuota?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  imported?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Resource_AppointmentLocation>;
  officeHourId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Timestamp>;
  unverified?: Maybe<Scalars['Boolean']>;
};

export type Resource_AppointmentBlockList = {
  __typename?: 'resource_AppointmentBlockList';
  appointmentBlocks?: Maybe<Array<Maybe<Resource_AppointmentBlockMsg>>>;
};

export type Resource_AppointmentBlockMsg = {
  __typename?: 'resource_AppointmentBlockMsg';
  appointmentTypeId?: Maybe<Scalars['String']>;
  endTime?: Maybe<Timestamp>;
  handlers?: Maybe<Array<Maybe<Resource_AppointmentHandlerMsg>>>;
  officeHourId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Timestamp>;
};

export type Resource_AppointmentBookerReferenceMsg = {
  __typename?: 'resource_AppointmentBookerReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_AppointmentBookerReferenceType>;
};

export enum Resource_AppointmentBookerReferenceType {
  AppointmentBookerReferenceTypeInternalUser = 'APPOINTMENT_BOOKER_REFERENCE_TYPE_INTERNAL_USER',
  AppointmentBookerReferenceTypeNone = 'APPOINTMENT_BOOKER_REFERENCE_TYPE_NONE',
  AppointmentBookerReferenceTypePortalUser = 'APPOINTMENT_BOOKER_REFERENCE_TYPE_PORTAL_USER',
  AppointmentBookerReferenceTypeProfessionalPortalUser = 'APPOINTMENT_BOOKER_REFERENCE_TYPE_PROFESSIONAL_PORTAL_USER'
}

export type Resource_AppointmentConfigMsg = {
  __typename?: 'resource_AppointmentConfigMsg';
  /** Datetime appointment configuration starts being active */
  activeEnd?: Maybe<Timestamp>;
  /** Datetime appointment configuration starts being active */
  activeStart?: Maybe<Timestamp>;
  /** Whether portal users can see the available appointment slots or not */
  calendarVisible?: Maybe<Scalars['Boolean']>;
  coverageTypes?: Maybe<Array<Maybe<Billing_CoverageType>>>;
  filteringMode?: Maybe<Resource_AppointmentTypeFilteringMode>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to abort the booking process if one of the references of the last FormSequenceQuestion in a sequential Form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of this appointment config matches.
   */
  formReferenceBlacklist?: Maybe<Scalars['String']>;
  /** The id of the form template versioning group to be conducted when a portal user wants to book an appointment from the corresponding portal facility */
  formTemplateVersioningGroupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  planningHorizon?: Maybe<Resource_PlanningHorizon>;
  planningHorizonCustomQuarters?: Maybe<Array<Maybe<VeiosTimeFrameMsg>>>;
  /** Defines how much time before the appointment the reminders are sent and via which methods. */
  reminderTimes?: Maybe<Array<Maybe<Resource_AppointmentReminderTimeMsg>>>;
  useDefaultQuarters?: Maybe<Scalars['Boolean']>;
};

export type Resource_AppointmentEventMsg = {
  __typename?: 'resource_AppointmentEventMsg';
  appointmentEndTime?: Maybe<Timestamp>;
  appointmentHandler?: Maybe<Resource_AppointmentHandlerMsg>;
  appointmentStartTime?: Maybe<Timestamp>;
  appointmentStatus?: Maybe<Resource_AppointmentStatus>;
  appointmentType?: Maybe<Resource_AppointmentTypeMsg>;
  attendee?: Maybe<Resource_AppointmentAttendeeMsg>;
  happenedAt?: Maybe<Timestamp>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForForceScheduling?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForRebooking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  userReference?: Maybe<Resource_AppointmentBookerReferenceMsg>;
};

export enum Resource_AppointmentFlagActivationStatus {
  AppointmentFlagActivationStatusActive = 'APPOINTMENT_FLAG_ACTIVATION_STATUS_ACTIVE',
  /** treated as deleted */
  AppointmentFlagActivationStatusInactive = 'APPOINTMENT_FLAG_ACTIVATION_STATUS_INACTIVE',
  AppointmentFlagActivationStatusNone = 'APPOINTMENT_FLAG_ACTIVATION_STATUS_NONE',
  AppointmentFlagActivationStatusNotYetActive = 'APPOINTMENT_FLAG_ACTIVATION_STATUS_NOT_YET_ACTIVE'
}

export type Resource_AppointmentFlagMsg = {
  __typename?: 'resource_AppointmentFlagMsg';
  activationStatus?: Maybe<Resource_AppointmentFlagActivationStatus>;
  /** Hexadecimal RGB */
  colorCode?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  timestamps?: Maybe<TimeMsg>;
};

export type Resource_AppointmentHandlerList = {
  __typename?: 'resource_AppointmentHandlerList';
  appointmentHandlers?: Maybe<Array<Maybe<Resource_AppointmentHandlerMsg>>>;
};

export type Resource_AppointmentHandlerMsg = {
  __typename?: 'resource_AppointmentHandlerMsg';
  externalIds?: Maybe<Array<Maybe<Resource_ExternalAppointmentHandlerIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Resource_AppointmentHandlerStatus>;
  title?: Maybe<Scalars['String']>;
  unitReferences?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  userAssignments?: Maybe<Array<Maybe<Resource_AppointmentHandlerUserAssignmentMsg>>>;
};

export enum Resource_AppointmentHandlerStatus {
  AppointmentHandlerStatusActive = 'APPOINTMENT_HANDLER_STATUS_ACTIVE',
  AppointmentHandlerStatusInactive = 'APPOINTMENT_HANDLER_STATUS_INACTIVE',
  AppointmentHandlerStatusNone = 'APPOINTMENT_HANDLER_STATUS_NONE',
  AppointmentHandlerStatusNotYetActive = 'APPOINTMENT_HANDLER_STATUS_NOT_YET_ACTIVE'
}

export type Resource_AppointmentHandlerUserAssignmentMsg = {
  __typename?: 'resource_AppointmentHandlerUserAssignmentMsg';
  endTime?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

/** This object is not persisted. It is derived from the event history of the appointment and its connected requests. */
export type Resource_AppointmentHistoryEventMsg = {
  __typename?: 'resource_AppointmentHistoryEventMsg';
  actionType?: Maybe<Resource_AppointmentRequestActionType>;
  endTime?: Maybe<Timestamp>;
  /** Event type should be combined with action type */
  eventType?: Maybe<Resource_AppointmentHistoryEventType>;
  /** If the event type is "BOOKED" */
  startTime?: Maybe<Timestamp>;
  timestamp?: Maybe<Timestamp>;
  userReference?: Maybe<Resource_AppointmentBookerReferenceMsg>;
};

export enum Resource_AppointmentHistoryEventType {
  /** The appointment is booked or rebooked, depending on the action type. */
  AppointmentHistoryEventTypeBooked = 'APPOINTMENT_HISTORY_EVENT_TYPE_BOOKED',
  /** The appointment is cancelled. Can not be combined with action type. */
  AppointmentHistoryEventTypeCancelled = 'APPOINTMENT_HISTORY_EVENT_TYPE_CANCELLED',
  /** A counter request is submitted. */
  AppointmentHistoryEventTypeCounterRequestSubmitted = 'APPOINTMENT_HISTORY_EVENT_TYPE_COUNTER_REQUEST_SUBMITTED',
  /** The appointment has finished. Can not be combined with action type. */
  AppointmentHistoryEventTypeFinished = 'APPOINTMENT_HISTORY_EVENT_TYPE_FINISHED',
  /** The appointment is missed. Can not be combined with action type. */
  AppointmentHistoryEventTypeMissed = 'APPOINTMENT_HISTORY_EVENT_TYPE_MISSED',
  AppointmentHistoryEventTypeNone = 'APPOINTMENT_HISTORY_EVENT_TYPE_NONE',
  /** The appointment has started. Can not be combined with action type. */
  AppointmentHistoryEventTypeOngoing = 'APPOINTMENT_HISTORY_EVENT_TYPE_ONGOING',
  /**
   * All slot proposals are rejected.
   *  In this case, no appointment can be booked but if the request was a "rescheduling" request (action type "UPDATE"),
   *  this marks the time when the proposals for rescheduling are rejected.
   */
  AppointmentHistoryEventTypeProposalsRejected = 'APPOINTMENT_HISTORY_EVENT_TYPE_PROPOSALS_REJECTED',
  /** A slot proposal is accepted. */
  AppointmentHistoryEventTypeProposalAccepted = 'APPOINTMENT_HISTORY_EVENT_TYPE_PROPOSAL_ACCEPTED',
  /** Slot proposals are received for the appointment request. */
  AppointmentHistoryEventTypeProposalReceived = 'APPOINTMENT_HISTORY_EVENT_TYPE_PROPOSAL_RECEIVED',
  /** An appointment request is submitted. */
  AppointmentHistoryEventTypeRequested = 'APPOINTMENT_HISTORY_EVENT_TYPE_REQUESTED',
  /** The appointment request is approved. */
  AppointmentHistoryEventTypeRequestApproved = 'APPOINTMENT_HISTORY_EVENT_TYPE_REQUEST_APPROVED',
  /** The appointment request is rejected. */
  AppointmentHistoryEventTypeRequestRejected = 'APPOINTMENT_HISTORY_EVENT_TYPE_REQUEST_REJECTED',
  /** Appointment is reserved by the clinic for the patient. */
  AppointmentHistoryEventTypeReserved = 'APPOINTMENT_HISTORY_EVENT_TYPE_RESERVED'
}

/** Allows linking various procedures etc. to appointments to allow navigating between them */
export type Resource_AppointmentLinkMsg = {
  __typename?: 'resource_AppointmentLinkMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_AppointmentLinkType>;
};

export enum Resource_AppointmentLinkType {
  AppointmentLinkTypeNone = 'APPOINTMENT_LINK_TYPE_NONE',
  AppointmentLinkTypeSurgery = 'APPOINTMENT_LINK_TYPE_SURGERY'
}

export type Resource_AppointmentList = {
  __typename?: 'resource_AppointmentList';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
};

export enum Resource_AppointmentLocation {
  AppointmentLocationInPerson = 'APPOINTMENT_LOCATION_IN_PERSON',
  AppointmentLocationNone = 'APPOINTMENT_LOCATION_NONE',
  AppointmentLocationPhone = 'APPOINTMENT_LOCATION_PHONE',
  AppointmentLocationVideo = 'APPOINTMENT_LOCATION_VIDEO'
}

export type Resource_AppointmentMsg = {
  __typename?: 'resource_AppointmentMsg';
  /** Additional services can be selected from the list of additional services the appointment type offers. It is enough to set the ids. */
  additionalServices?: Maybe<Array<Maybe<Resource_AdditionalServiceMsg>>>;
  appointmentFlags?: Maybe<Array<Maybe<Resource_AppointmentFlagMsg>>>;
  /** Series won't have appointments to prevent an infinite loop */
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
  /** TODO remove */
  appointmentSeriesId?: Maybe<Scalars['String']>;
  /** For group appointments, status from attendee is the binding one for the attendee */
  appointmentStatus?: Maybe<Resource_AppointmentStatus>;
  appointmentType?: Maybe<Resource_AppointmentTypeMsg>;
  attendeeCount?: Maybe<Scalars['Int']>;
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  comment?: Maybe<Scalars['String']>;
  /** For some cases, editing of imported appointments in our system should be blocked */
  editingDisabled?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Timestamp>;
  /**
   * The event history is still relevant for group appointments' history.
   *  For the full history of the appointment for a specific attendee including the request history, use getAppointmentHistory call.
   */
  eventHistory?: Maybe<Array<Maybe<Resource_AppointmentEventMsg>>>;
  /** Booked or requested by a patient portal user */
  external?: Maybe<Scalars['Boolean']>;
  /** This external id and external flag above are not related */
  externalIds?: Maybe<Array<Maybe<Resource_ExternalAppointmentIdMsg>>>;
  forceScheduled?: Maybe<Scalars['Boolean']>;
  /** The two fields for group appointment are initially taken over from appointment type but can be updated by professionals */
  groupAppointment?: Maybe<Scalars['Boolean']>;
  groupAppointmentQuota?: Maybe<Scalars['Int']>;
  handler?: Maybe<Resource_AppointmentHandlerMsg>;
  id?: Maybe<Scalars['String']>;
  /** Marks whether appointment was created in an external system and only imported into our system */
  imported?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<Maybe<Resource_AppointmentLinkMsg>>>;
  location?: Maybe<Resource_AppointmentLocation>;
  officeHourId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Boolean']>;
  /** Not stored on the appointment; only added to this message when explicitly requested */
  requestBasicInfos?: Maybe<Array<Maybe<Resource_AppointmentRequestBasicInfoMsg>>>;
  requestContextReference?: Maybe<Resource_AppointmentRequestContextReferenceMsg>;
  startTime?: Maybe<Timestamp>;
  unverified?: Maybe<Scalars['Boolean']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Resource_AppointmentRegularScheduleDetailsList = {
  __typename?: 'resource_AppointmentRegularScheduleDetailsList';
  scheduleDetails?: Maybe<Array<Maybe<Resource_AppointmentRegularScheduleDetailsMsg>>>;
};

export type Resource_AppointmentRegularScheduleDetailsMsg = {
  __typename?: 'resource_AppointmentRegularScheduleDetailsMsg';
  appointmentConfigurationId?: Maybe<Scalars['String']>;
  appointmentTypes?: Maybe<Array<Maybe<Resource_AppointmentTypeMsg>>>;
  officeHourId?: Maybe<Scalars['String']>;
  planningHorizon?: Maybe<Resource_PlanningHorizon>;
  weekDaysConfigs?: Maybe<Array<Maybe<Resource_WeekDaysConfigMsg>>>;
};

export enum Resource_AppointmentReminderMode {
  AppointmentReminderModeAppNotification = 'APPOINTMENT_REMINDER_MODE_APP_NOTIFICATION',
  AppointmentReminderModeEmail = 'APPOINTMENT_REMINDER_MODE_EMAIL',
  AppointmentReminderModeNone = 'APPOINTMENT_REMINDER_MODE_NONE'
}

export type Resource_AppointmentReminderTimeMsg = {
  __typename?: 'resource_AppointmentReminderTimeMsg';
  mode?: Maybe<Resource_AppointmentReminderMode>;
  /** How much time, in the given units, before the appointment, the reminder should be sent. */
  timeInterval?: Maybe<Scalars['Long']>;
  /** Time unit */
  unit?: Maybe<TimePrecisionLevel>;
};

export enum Resource_AppointmentRequestActionType {
  /** Request type for first time booking */
  AppointmentRequestActionTypeBook = 'APPOINTMENT_REQUEST_ACTION_TYPE_BOOK',
  AppointmentRequestActionTypeNone = 'APPOINTMENT_REQUEST_ACTION_TYPE_NONE',
  /** Request type for updating a booked appointment */
  AppointmentRequestActionTypeUpdate = 'APPOINTMENT_REQUEST_ACTION_TYPE_UPDATE'
}

export type Resource_AppointmentRequestAgreementMsg = {
  __typename?: 'resource_AppointmentRequestAgreementMsg';
  accepted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  template?: Maybe<Resource_AppointmentRequestAgreementTemplateMsg>;
};

export type Resource_AppointmentRequestAgreementTemplateMsg = {
  __typename?: 'resource_AppointmentRequestAgreementTemplateMsg';
  description?: Maybe<Core_LocalizedStringMsg>;
  id?: Maybe<Scalars['String']>;
  mandatory?: Maybe<Scalars['Boolean']>;
};

/** Contains information from the request that may be needed in combination with an appointment */
export type Resource_AppointmentRequestBasicInfoMsg = {
  __typename?: 'resource_AppointmentRequestBasicInfoMsg';
  agreements?: Maybe<Array<Maybe<Resource_AppointmentRequestAgreementMsg>>>;
  comment?: Maybe<Scalars['String']>;
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  requestPreferencesFreeText?: Maybe<Scalars['String']>;
  submissionDate?: Maybe<Timestamp>;
};

export type Resource_AppointmentRequestConfigMsg = {
  __typename?: 'resource_AppointmentRequestConfigMsg';
  /** When turned on, patients can update a request and send it back, after the proposal step (converting it to an inbound request if it is already not) */
  allowCounterRequests?: Maybe<Scalars['Boolean']>;
  appointmentRequestSetting?: Maybe<Resource_AppointmentRequestSetting>;
  /** priority of waiting requests are, True: manually entered, False: automatically calculated */
  autoPrioritySetting?: Maybe<Scalars['Boolean']>;
  /**
   * Whether approval of the request is manual or automatic
   * It can be automatic only when the slot selection is also automatic.
   */
  autoRequestApproval?: Maybe<Scalars['Boolean']>;
  /** Whether selection of slots is manual or automatic */
  autoSlotSelection?: Maybe<Scalars['Boolean']>;
  /**
   * If turned on, the appointment requests made by the patients will block the time slot and the resources.
   * It requires having appointment request setting set to SLOT_REQUEST
   * For auto approval case, this becomes irrelevant as every request is either approved or rejected automatically as soon as they are submitted
   */
  blockingInboundRequests?: Maybe<Scalars['Boolean']>;
  /** If turned on, the appointment proposals made to the patients as well as the appointment requests made by the clinic will block the time slot and the resources. */
  blockingOutboundRequestsAndProposedSlots?: Maybe<Scalars['Boolean']>;
  /** How much time, in the given units, after the submission, the request must be expired. */
  deadlineInterval?: Maybe<Scalars['Int']>;
  /** Time unit */
  deadlineUnit?: Maybe<TimeUnit>;
  id?: Maybe<Scalars['String']>;
  /** Must be 1 if proposeSlots is false */
  numberOfAutoProposedSlots?: Maybe<Scalars['Int']>;
  /**
   * This field is a helper field. The actual information is stored in the other fields.
   *  When this is set, BE overrides the other fields to form the selected preset's config.
   */
  preset?: Maybe<Resource_AppointmentRequestConfigPreset>;
  /**
   * Whether the selected slots are proposed or the selected slot is directly booked
   * If set to false, only one slot must be selected in the slot selection step.
   */
  proposeSlots?: Maybe<Scalars['Boolean']>;
  timeoutForProposedSlots?: Maybe<Scalars['Int']>;
  timeoutPrecisionLevelForProposedSlots?: Maybe<TimePrecisionLevel>;
  waitingListEnabled?: Maybe<Scalars['Boolean']>;
};

export enum Resource_AppointmentRequestConfigPreset {
  AppointmentRequestConfigPresetDirectBooking = 'APPOINTMENT_REQUEST_CONFIG_PRESET_DIRECT_BOOKING',
  AppointmentRequestConfigPresetNone = 'APPOINTMENT_REQUEST_CONFIG_PRESET_NONE'
}

export type Resource_AppointmentRequestContextReferenceMsg = {
  __typename?: 'resource_AppointmentRequestContextReferenceMsg';
  /** Optional: reference id */
  referenceId?: Maybe<Scalars['String']>;
  requestContextType?: Maybe<Resource_AppointmentRequestContextType>;
};

export enum Resource_AppointmentRequestContextType {
  AppointmentRequestContextTypeClinicalRequest = 'APPOINTMENT_REQUEST_CONTEXT_TYPE_CLINICAL_REQUEST',
  AppointmentRequestContextTypeNone = 'APPOINTMENT_REQUEST_CONTEXT_TYPE_NONE',
  AppointmentRequestContextTypePatientPortal = 'APPOINTMENT_REQUEST_CONTEXT_TYPE_PATIENT_PORTAL'
}

export enum Resource_AppointmentRequestDirection {
  /** When the recipient of a request is the clinic. Creating this type requires "request" permissions. */
  AppointmentRequestDirectionInbound = 'APPOINTMENT_REQUEST_DIRECTION_INBOUND',
  AppointmentRequestDirectionNone = 'APPOINTMENT_REQUEST_DIRECTION_NONE',
  /** When the recipient of a request is a patient. Creating this type requires "write" permission. */
  AppointmentRequestDirectionOutbound = 'APPOINTMENT_REQUEST_DIRECTION_OUTBOUND'
}

export type Resource_AppointmentRequestEventMsg = {
  __typename?: 'resource_AppointmentRequestEventMsg';
  id?: Maybe<Scalars['String']>;
  requestActionType?: Maybe<Resource_AppointmentRequestActionType>;
  requestDirection?: Maybe<Resource_AppointmentRequestDirection>;
  requestPreferences?: Maybe<Resource_AppointmentRequestPreferencesMsg>;
  requestStatus?: Maybe<Resource_AppointmentRequestStatus>;
  requesterReference?: Maybe<Resource_AppointmentRequesterReferenceMsg>;
  slotProposals?: Maybe<Array<Maybe<Resource_AppointmentSlotProposalMsg>>>;
  timestamps?: Maybe<TimeMsg>;
};

export type Resource_AppointmentRequestList = {
  __typename?: 'resource_AppointmentRequestList';
  appointmentRequests?: Maybe<Array<Maybe<Resource_AppointmentRequestMsg>>>;
};

export type Resource_AppointmentRequestMsg = {
  __typename?: 'resource_AppointmentRequestMsg';
  actionType?: Maybe<Resource_AppointmentRequestActionType>;
  /** Additional services can be selected from the list of additional services the appointment type offers. It is enough to set the ids. */
  additionalServices?: Maybe<Array<Maybe<Resource_AdditionalServiceMsg>>>;
  agreements?: Maybe<Array<Maybe<Resource_AppointmentRequestAgreementMsg>>>;
  appointmentFlags?: Maybe<Array<Maybe<Resource_AppointmentFlagMsg>>>;
  appointmentSlotProposals?: Maybe<Array<Maybe<Resource_AppointmentSlotProposalMsg>>>;
  appointmentType?: Maybe<Resource_AppointmentTypeMsg>;
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
  comment?: Maybe<Scalars['String']>;
  createdInOrganizationalUnitId?: Maybe<Scalars['String']>;
  eventHistory?: Maybe<Array<Maybe<Resource_AppointmentRequestEventMsg>>>;
  /** TODO: workaround solution that should be replaced by appointment request tasks */
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Float']>;
  reasonForArchiving?: Maybe<Scalars['String']>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForRejection?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForRejectionExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForVisit?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  requestContextReference?: Maybe<Resource_AppointmentRequestContextReferenceMsg>;
  requestDirection?: Maybe<Resource_AppointmentRequestDirection>;
  requestPreferences?: Maybe<Resource_AppointmentRequestPreferencesMsg>;
  requester?: Maybe<Resource_AppointmentRequesterReferenceMsg>;
  status?: Maybe<Resource_AppointmentRequestStatus>;
  submissionDate?: Maybe<Timestamp>;
  unverified?: Maybe<Scalars['Boolean']>;
};

export type Resource_AppointmentRequestPreferencesMsg = {
  __typename?: 'resource_AppointmentRequestPreferencesMsg';
  /** Preferred handler, optional */
  appointmentHandler?: Maybe<Resource_AppointmentHandlerMsg>;
  exactTimeSlot?: Maybe<Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg>;
  /**
   * True means only the slots that patients can book
   * False means only the slots that patients can not book
   * Null means all slots
   * Patient portal requests must always set this to true, no restriction for clinic
   */
  freeText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  insideTimeFrame?: Maybe<Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg>;
  location?: Maybe<Resource_AppointmentLocation>;
  patientBookable?: Maybe<Scalars['Boolean']>;
};

export type Resource_AppointmentRequestPreferencesMsg_TimeSlotMsg = {
  __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg';
  end?: Maybe<Timestamp>;
  start?: Maybe<Timestamp>;
};

export enum Resource_AppointmentRequestSetting {
  AppointmentRequestSettingNone = 'APPOINTMENT_REQUEST_SETTING_NONE',
  /** The patient can request to book a specific slot. For direct booking, request setting must be set to slot request */
  AppointmentRequestSettingSlotRequest = 'APPOINTMENT_REQUEST_SETTING_SLOT_REQUEST',
  /** The patient can specify a time frame in which they request their appointment */
  AppointmentRequestSettingTimeframeRequest = 'APPOINTMENT_REQUEST_SETTING_TIMEFRAME_REQUEST',
  /** The patient can only request an appointment without any specific time frame */
  AppointmentRequestSettingUntimedRequest = 'APPOINTMENT_REQUEST_SETTING_UNTIMED_REQUEST'
}

export enum Resource_AppointmentRequestStatus {
  AppointmentRequestStatusApproved = 'APPOINTMENT_REQUEST_STATUS_APPROVED',
  AppointmentRequestStatusArchived = 'APPOINTMENT_REQUEST_STATUS_ARCHIVED',
  AppointmentRequestStatusCancelled = 'APPOINTMENT_REQUEST_STATUS_CANCELLED',
  AppointmentRequestStatusCreated = 'APPOINTMENT_REQUEST_STATUS_CREATED',
  AppointmentRequestStatusFulfilled = 'APPOINTMENT_REQUEST_STATUS_FULFILLED',
  AppointmentRequestStatusInProposal = 'APPOINTMENT_REQUEST_STATUS_IN_PROPOSAL',
  AppointmentRequestStatusInWaitingList = 'APPOINTMENT_REQUEST_STATUS_IN_WAITING_LIST',
  AppointmentRequestStatusNone = 'APPOINTMENT_REQUEST_STATUS_NONE',
  AppointmentRequestStatusProposalRejected = 'APPOINTMENT_REQUEST_STATUS_PROPOSAL_REJECTED',
  AppointmentRequestStatusRejected = 'APPOINTMENT_REQUEST_STATUS_REJECTED',
  AppointmentRequestStatusSubmitted = 'APPOINTMENT_REQUEST_STATUS_SUBMITTED'
}

export type Resource_AppointmentRequesterReferenceMsg = {
  __typename?: 'resource_AppointmentRequesterReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  requesterType?: Maybe<Resource_AppointmentRequesterType>;
};

export enum Resource_AppointmentRequesterType {
  AppointmentRequesterTypeInternalUser = 'APPOINTMENT_REQUESTER_TYPE_INTERNAL_USER',
  AppointmentRequesterTypeNone = 'APPOINTMENT_REQUESTER_TYPE_NONE',
  AppointmentRequesterTypePortalUser = 'APPOINTMENT_REQUESTER_TYPE_PORTAL_USER',
  AppointmentRequesterTypeProfessionalPortalUser = 'APPOINTMENT_REQUESTER_TYPE_PROFESSIONAL_PORTAL_USER'
}

export type Resource_AppointmentSeriesList = {
  __typename?: 'resource_AppointmentSeriesList';
  appointmentSeries?: Maybe<Array<Maybe<Resource_AppointmentSeriesMsg>>>;
};

export type Resource_AppointmentSeriesMsg = {
  __typename?: 'resource_AppointmentSeriesMsg';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Resource_AppointmentSeriesStatus>;
  title?: Maybe<Scalars['String']>;
  /**
   * If the appointments of the series is from various administrative units,
   * this should reference an administrative unit that contains the administrative units of the appointments
   * so that the permission check is easier and no permission denied issue is faced later when appointments are processed one by one
   */
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export enum Resource_AppointmentSeriesStatus {
  /** There is at least one booked appointment and no reserved appointment */
  AppointmentSeriesStatusBooked = 'APPOINTMENT_SERIES_STATUS_BOOKED',
  /** All appointments are cancelled */
  AppointmentSeriesStatusCancelled = 'APPOINTMENT_SERIES_STATUS_CANCELLED',
  /** The series is created but no appointment is linked */
  AppointmentSeriesStatusCreated = 'APPOINTMENT_SERIES_STATUS_CREATED',
  /** All appointments are finished */
  AppointmentSeriesStatusFinished = 'APPOINTMENT_SERIES_STATUS_FINISHED',
  AppointmentSeriesStatusNone = 'APPOINTMENT_SERIES_STATUS_NONE',
  /** There is at least one reserved appointment linked to the series */
  AppointmentSeriesStatusReserved = 'APPOINTMENT_SERIES_STATUS_RESERVED'
}

export type Resource_AppointmentSlotProposalMsg = {
  __typename?: 'resource_AppointmentSlotProposalMsg';
  endTime?: Maybe<Timestamp>;
  groupAppointment?: Maybe<Scalars['Boolean']>;
  handler?: Maybe<Resource_AppointmentHandlerMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Resource_AppointmentLocation>;
  /**
   * If exists, it (or the attendee if it is a group appointment) will have the status "PENDING", it will block the time slot and the resources.
   * Its existence depends on the appointment type.
   */
  proposedAppointment?: Maybe<Resource_AppointmentMsg>;
  startTime?: Maybe<Timestamp>;
  status?: Maybe<Resource_AppointmentSlotProposalStatus>;
};

export enum Resource_AppointmentSlotProposalStatus {
  AppointmentSlotProposalStatusAccepted = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_ACCEPTED',
  /** When the request is cancelled */
  AppointmentSlotProposalStatusCancelled = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_CANCELLED',
  AppointmentSlotProposalStatusNone = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_NONE',
  AppointmentSlotProposalStatusNotYetProposed = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_NOT_YET_PROPOSED',
  AppointmentSlotProposalStatusProposed = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_PROPOSED',
  AppointmentSlotProposalStatusRejected = 'APPOINTMENT_SLOT_PROPOSAL_STATUS_REJECTED'
}

export enum Resource_AppointmentStatus {
  /** Appointment is booked (confirmed) */
  AppointmentStatusBooked = 'APPOINTMENT_STATUS_BOOKED',
  AppointmentStatusCancelled = 'APPOINTMENT_STATUS_CANCELLED',
  /** The visit that is linked to the appointment is finished or the appointment is set to be finished manually */
  AppointmentStatusFinished = 'APPOINTMENT_STATUS_FINISHED',
  /** Patient did not show up for the appointment */
  AppointmentStatusMissed = 'APPOINTMENT_STATUS_MISSED',
  AppointmentStatusNone = 'APPOINTMENT_STATUS_NONE',
  /**
   * The appointment is created for an outbound appointment request created in the clinic with blocking slot proposals
   *  but not submitted yet, so the requester will not see the proposed appointment yet.
   */
  AppointmentStatusNotYetPending = 'APPOINTMENT_STATUS_NOT_YET_PENDING',
  /** The visit that is linked to the appointment is currently ongoing */
  AppointmentStatusOngoing = 'APPOINTMENT_STATUS_ONGOING',
  /**
   * The appointment is created for an outbound appointment request created and submitted in the clinic or a slot proposal
   *  made to an inbound request with blocking slot proposals. If the requester accepts the appointment, it will be BOOKED.
   */
  AppointmentStatusPending = 'APPOINTMENT_STATUS_PENDING',
  /**
   * The appointment is created for an inbound request with exact slot request and blocking requests configuration,
   *  in order to block the appointment slot that is requested by the requester. If the clinic approves the request and not propose slots, it will be BOOKED.
   */
  AppointmentStatusRequested = 'APPOINTMENT_STATUS_REQUESTED',
  /** Appointment is created in the clinic, not booked yet */
  AppointmentStatusReserved = 'APPOINTMENT_STATUS_RESERVED'
}

export type Resource_AppointmentTaskContentReferenceMsg = {
  __typename?: 'resource_AppointmentTaskContentReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_AppointmentTaskContentType>;
};

export type Resource_AppointmentTaskContentTemplateReferenceMsg = {
  __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_AppointmentTaskContentTemplateType>;
};

export enum Resource_AppointmentTaskContentTemplateType {
  AppointmentTaskContentTemplateTypeDocumentGroup = 'APPOINTMENT_TASK_CONTENT_TEMPLATE_TYPE_DOCUMENT_GROUP',
  AppointmentTaskContentTemplateTypeFormTemplateVersioningGroup = 'APPOINTMENT_TASK_CONTENT_TEMPLATE_TYPE_FORM_TEMPLATE_VERSIONING_GROUP',
  AppointmentTaskContentTemplateTypeNone = 'APPOINTMENT_TASK_CONTENT_TEMPLATE_TYPE_NONE',
  AppointmentTaskContentTemplateTypeStaticDocumentGroup = 'APPOINTMENT_TASK_CONTENT_TEMPLATE_TYPE_STATIC_DOCUMENT_GROUP'
}

export enum Resource_AppointmentTaskContentType {
  AppointmentTaskContentTypeDocumentGroup = 'APPOINTMENT_TASK_CONTENT_TYPE_DOCUMENT_GROUP',
  AppointmentTaskContentTypeFormTemplateVersioningGroup = 'APPOINTMENT_TASK_CONTENT_TYPE_FORM_TEMPLATE_VERSIONING_GROUP',
  AppointmentTaskContentTypeNone = 'APPOINTMENT_TASK_CONTENT_TYPE_NONE',
  AppointmentTaskContentTypeStaticDocumentGroup = 'APPOINTMENT_TASK_CONTENT_TYPE_STATIC_DOCUMENT_GROUP'
}

export enum Resource_AppointmentTaskDueStage {
  AppointmentTaskDueStageAfterAppointment = 'APPOINTMENT_TASK_DUE_STAGE_AFTER_APPOINTMENT',
  AppointmentTaskDueStageBeforeAppointment = 'APPOINTMENT_TASK_DUE_STAGE_BEFORE_APPOINTMENT',
  AppointmentTaskDueStageDuringAppointment = 'APPOINTMENT_TASK_DUE_STAGE_DURING_APPOINTMENT',
  AppointmentTaskDueStageNone = 'APPOINTMENT_TASK_DUE_STAGE_NONE'
}

export type Resource_AppointmentTaskList = {
  __typename?: 'resource_AppointmentTaskList';
  appointmentTasks?: Maybe<Array<Maybe<Resource_AppointmentTaskMsg>>>;
};

export type Resource_AppointmentTaskMsg = {
  __typename?: 'resource_AppointmentTaskMsg';
  appointmentId?: Maybe<Scalars['String']>;
  contentReferences?: Maybe<Array<Maybe<Resource_AppointmentTaskContentReferenceMsg>>>;
  dueStage?: Maybe<Resource_AppointmentTaskDueStage>;
  id?: Maybe<Scalars['String']>;
  information?: Maybe<Core_LocalizedStringMsg>;
  portalUserId?: Maybe<Scalars['String']>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  resultReferences?: Maybe<Array<Maybe<Resource_AppointmentTaskResultReferenceMsg>>>;
  status?: Maybe<Resource_AppointmentTaskStatus>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  taskTemplate?: Maybe<Resource_AppointmentTaskTemplateMsg>;
  title?: Maybe<Core_LocalizedStringMsg>;
  type?: Maybe<Resource_AppointmentTaskType>;
};

export type Resource_AppointmentTaskResultReferenceMsg = {
  __typename?: 'resource_AppointmentTaskResultReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_AppointmentTaskResultType>;
};

export enum Resource_AppointmentTaskResultType {
  AppointmentTaskResultTypeDocument = 'APPOINTMENT_TASK_RESULT_TYPE_DOCUMENT',
  AppointmentTaskResultTypeForm = 'APPOINTMENT_TASK_RESULT_TYPE_FORM',
  AppointmentTaskResultTypeNone = 'APPOINTMENT_TASK_RESULT_TYPE_NONE',
  AppointmentTaskResultTypeStaticDocument = 'APPOINTMENT_TASK_RESULT_TYPE_STATIC_DOCUMENT'
}

export enum Resource_AppointmentTaskStatus {
  AppointmentTaskStatusCanceled = 'APPOINTMENT_TASK_STATUS_CANCELED',
  AppointmentTaskStatusCreated = 'APPOINTMENT_TASK_STATUS_CREATED',
  AppointmentTaskStatusFinished = 'APPOINTMENT_TASK_STATUS_FINISHED',
  AppointmentTaskStatusNone = 'APPOINTMENT_TASK_STATUS_NONE',
  /** Tasks of this status can be updated freely by the clinic and will not be visible by the portal user */
  AppointmentTaskStatusNotYetCreated = 'APPOINTMENT_TASK_STATUS_NOT_YET_CREATED',
  AppointmentTaskStatusStarted = 'APPOINTMENT_TASK_STATUS_STARTED'
}

export type Resource_AppointmentTaskTemplateMsg = {
  __typename?: 'resource_AppointmentTaskTemplateMsg';
  contentTemplateReferences?: Maybe<Array<Maybe<Resource_AppointmentTaskContentTemplateReferenceMsg>>>;
  dueStage?: Maybe<Resource_AppointmentTaskDueStage>;
  id?: Maybe<Scalars['String']>;
  information?: Maybe<Core_LocalizedStringMsg>;
  officeHourId?: Maybe<Scalars['String']>;
  status?: Maybe<Resource_AppointmentTaskTemplateStatus>;
  subtitle?: Maybe<Core_LocalizedStringMsg>;
  taskType?: Maybe<Resource_AppointmentTaskType>;
  title?: Maybe<Core_LocalizedStringMsg>;
};

export enum Resource_AppointmentTaskTemplateStatus {
  AppointmentTaskTemplateStatusActive = 'APPOINTMENT_TASK_TEMPLATE_STATUS_ACTIVE',
  AppointmentTaskTemplateStatusInactive = 'APPOINTMENT_TASK_TEMPLATE_STATUS_INACTIVE',
  AppointmentTaskTemplateStatusNone = 'APPOINTMENT_TASK_TEMPLATE_STATUS_NONE',
  AppointmentTaskTemplateStatusNotYetActive = 'APPOINTMENT_TASK_TEMPLATE_STATUS_NOT_YET_ACTIVE'
}

export enum Resource_AppointmentTaskType {
  AppointmentTaskTypeDocumentDownload = 'APPOINTMENT_TASK_TYPE_DOCUMENT_DOWNLOAD',
  AppointmentTaskTypeDocumentUpload = 'APPOINTMENT_TASK_TYPE_DOCUMENT_UPLOAD',
  AppointmentTaskTypeForm = 'APPOINTMENT_TASK_TYPE_FORM',
  AppointmentTaskTypeInfo = 'APPOINTMENT_TASK_TYPE_INFO',
  AppointmentTaskTypeNone = 'APPOINTMENT_TASK_TYPE_NONE',
  AppointmentTaskTypeOfflineFormReasonForPresentation = 'APPOINTMENT_TASK_TYPE_OFFLINE_FORM_REASON_FOR_PRESENTATION',
  AppointmentTaskTypeShareMedicalData = 'APPOINTMENT_TASK_TYPE_SHARE_MEDICAL_DATA',
  AppointmentTaskTypeSign = 'APPOINTMENT_TASK_TYPE_SIGN'
}

export type Resource_AppointmentTimeFrameList = {
  __typename?: 'resource_AppointmentTimeFrameList';
  appointmentTimeFrames?: Maybe<Array<Maybe<Resource_AppointmentTimeFrameMsg>>>;
};

export type Resource_AppointmentTimeFrameMsg = {
  __typename?: 'resource_AppointmentTimeFrameMsg';
  appointmentTypeId?: Maybe<Scalars['String']>;
  endTime?: Maybe<Timestamp>;
  handler?: Maybe<Resource_AppointmentHandlerMsg>;
  officeHourId?: Maybe<Scalars['String']>;
  patientBookableAppointment?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Timestamp>;
};

export type Resource_AppointmentTypeAnswerMsg = {
  __typename?: 'resource_AppointmentTypeAnswerMsg';
  answerText?: Maybe<Core_LocalizedStringMsg>;
  fileIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
};

export type Resource_AppointmentTypeAppointmentLimitMsg = {
  __typename?: 'resource_AppointmentTypeAppointmentLimitMsg';
  activeEnd?: Maybe<Timestamp>;
  /** Time frame can be null, means it has no start or end */
  activeStart?: Maybe<Timestamp>;
  /** Limit has to be greater than or equal to 0 */
  appointmentLimit?: Maybe<Scalars['Int']>;
  /** Unit can be MONTH, WEEK, DAY */
  limitUnit?: Maybe<TimeUnit>;
};

export enum Resource_AppointmentTypeBookingState {
  AppointmentTypeBookingStateAvailable = 'APPOINTMENT_TYPE_BOOKING_STATE_AVAILABLE',
  AppointmentTypeBookingStateMultipleAllowed = 'APPOINTMENT_TYPE_BOOKING_STATE_MULTIPLE_ALLOWED',
  AppointmentTypeBookingStateMultipleNotAllowed = 'APPOINTMENT_TYPE_BOOKING_STATE_MULTIPLE_NOT_ALLOWED',
  AppointmentTypeBookingStateNone = 'APPOINTMENT_TYPE_BOOKING_STATE_NONE'
}

export type Resource_AppointmentTypeFaqEntryMsg = {
  __typename?: 'resource_AppointmentTypeFAQEntryMsg';
  answer?: Maybe<Resource_AppointmentTypeAnswerMsg>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Resource_AppointmentTypeQuestionMsg>;
};

export enum Resource_AppointmentTypeFilteringMode {
  /** Set the formReferenceBlacklist in AppointmentConfig to abort booking process based on form results */
  AppointmentTypeFilteringModeBlackList = 'APPOINTMENT_TYPE_FILTERING_MODE_BLACK_LIST',
  /** Can be NONE if and only if formTemplateVersioningGroupId of AppointmentConfig is null, otherwise a mode has to be selected */
  AppointmentTypeFilteringModeNone = 'APPOINTMENT_TYPE_FILTERING_MODE_NONE',
  /**
   * Set the formReferenceWhitelist in children AppointmentTypes to filter out
   *  appointment types which does not have the reference to the form result
   */
  AppointmentTypeFilteringModeWhiteList = 'APPOINTMENT_TYPE_FILTERING_MODE_WHITE_LIST'
}

export type Resource_AppointmentTypeList = {
  __typename?: 'resource_AppointmentTypeList';
  appointmentTypes?: Maybe<Array<Maybe<Resource_AppointmentTypeMsg>>>;
};

export type Resource_AppointmentTypeMsg = {
  __typename?: 'resource_AppointmentTypeMsg';
  additionalServices?: Maybe<Array<Maybe<Resource_AdditionalServiceMsg>>>;
  agreementTemplates?: Maybe<Array<Maybe<Resource_AppointmentRequestAgreementTemplateMsg>>>;
  allowPortalUserCancellation?: Maybe<Scalars['Boolean']>;
  allowPortalUserRescheduling?: Maybe<Scalars['Boolean']>;
  appointmentFlags?: Maybe<Array<Maybe<Resource_AppointmentFlagMsg>>>;
  appointmentLocations?: Maybe<Array<Maybe<Resource_AppointmentLocation>>>;
  /** For initial booking */
  appointmentRequestConfig?: Maybe<Resource_AppointmentRequestConfigMsg>;
  appointmentTaskTemplates?: Maybe<Array<Maybe<Resource_AppointmentTaskTemplateMsg>>>;
  /**
   * If true: users cannot book an appointment of this appointmentType if they have an ongoing appointment request
   * or if they have an already booked appointment
   *
   * Ongoing appointment request: An appointment request with status equal to one of the following: {submitted, approved, in_proposal, fulfilled}
   */
  blockMultipleBookings?: Maybe<Scalars['Boolean']>;
  /** RGB color code */
  colorCode?: Maybe<Scalars['String']>;
  description?: Maybe<Core_LocalizedStringMsg>;
  /** In minutes */
  duration?: Maybe<Scalars['Int']>;
  externalIds?: Maybe<Array<Maybe<Resource_ExternalAppointmentTypeIdMsg>>>;
  externalVideoAppointment?: Maybe<Scalars['Boolean']>;
  externalVideoAppointmentNote?: Maybe<Core_LocalizedStringMsg>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to abort the booking process if one of the references of the last FormSequenceQuestion in a sequential Form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of this appointment type matches.
   */
  formReferenceBlacklist?: Maybe<Scalars['String']>;
  /**
   * The id of the form template versioning group to be conducted when a portal user wants to book an appointment of this appointment type,
   *  to be filled directly after selecting this appointment type
   */
  formTemplateVersioningGroupId?: Maybe<Scalars['String']>;
  frequentlyAskedQuestions?: Maybe<Array<Maybe<Resource_AppointmentTypeFaqEntryMsg>>>;
  /** In minutes */
  granularity?: Maybe<Scalars['Int']>;
  groupAppointment?: Maybe<Scalars['Boolean']>;
  groupAppointmentQuota?: Maybe<Scalars['Int']>;
  handlerSelectable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  includedServices?: Maybe<Array<Maybe<Resource_IncludedServiceMsg>>>;
  /** Denotes that an appointment-booking portal-user has to provide their insurance type. Does not affect anything in the backend, currently. */
  insuranceTypeRequired?: Maybe<Scalars['Boolean']>;
  limits?: Maybe<Array<Maybe<Resource_AppointmentTypeAppointmentLimitMsg>>>;
  /** allows jumping into various cockpits from appointments */
  linkedCockpitTypes?: Maybe<Array<Maybe<Resource_CockpitType>>>;
  name?: Maybe<Core_LocalizedStringMsg>;
  officeHourId?: Maybe<Scalars['String']>;
  /**
   * The id of a FormTemplateReferenceItem which, if set,
   *  can be used to filter appointment-types by the references of the last FormSequenceQuestion in a sequential form which,
   *  is an instance of form template given by formTemplateVersioningGroupId of appointment config
   */
  parentConfigFormReferenceWhitelist?: Maybe<Scalars['String']>;
  phoneAppointmentNote?: Maybe<Core_LocalizedStringMsg>;
  portalDisplayName?: Maybe<Core_LocalizedStringMsg>;
  /**
   * How much time, in the given units, before the appointment, the appointment can be cancelled by the portal user,
   *  if enabled by allowPortalUserCancellation.
   */
  portalUserCancellationTimeInterval?: Maybe<Scalars['Int']>;
  portalUserCancellationTimeUnit?: Maybe<TimeUnit>;
  /** defines which procedures etc. can be linked to appointments of this type */
  possibleAppointmentLinks?: Maybe<Array<Maybe<Resource_AppointmentLinkType>>>;
  /**
   * The id of the form template versioning group to be conducted when a portal user wants to submit an appointment
   *  request from the corresponding portal facility. Form needs to be completed before request submission is possible.
   */
  preSubmissionFormTemplateVersioningGroupId?: Maybe<Scalars['String']>;
  /** used for deployment */
  referenceId?: Maybe<Scalars['String']>;
  /**
   * Overrides the same field from the office hour appointment config.
   * Defines how much time before the appointment the reminders are sent and via which methods.
   */
  reminderTimes?: Maybe<Array<Maybe<Resource_AppointmentReminderTimeMsg>>>;
  /**
   * If rescheduling config does not exist, appointmentRequestConfig will be used.
   *  Currently a completely independent rescheduling request config feature is not specified.
   *  For that reason, BE will sync data from appointmentRequestConfig to reschedulingRequestConfig.
   *  If directBooking preset is active, the fields regarding direct booking will be the exception to the sync.
   */
  reschedulingRequestConfig?: Maybe<Resource_AppointmentRequestConfigMsg>;
  status?: Maybe<Resource_AppointmentTypeStatus>;
  timestamps?: Maybe<TimeMsg>;
  /**
   * Can be used to turn off reminders for an appointment type whose office hour has reminders.
   *  If the appointment type has reminderConfigs, this field becomes obsolete, as the office hour reminders are overridden anyway.
   */
  turnOffOfficeHourReminderConfigs?: Maybe<Scalars['Boolean']>;
};

export type Resource_AppointmentTypeQuestionMsg = {
  __typename?: 'resource_AppointmentTypeQuestionMsg';
  id?: Maybe<Scalars['String']>;
  questionText?: Maybe<Core_LocalizedStringMsg>;
};

export enum Resource_AppointmentTypeStatus {
  AppointmentTypeStatusActive = 'APPOINTMENT_TYPE_STATUS_ACTIVE',
  AppointmentTypeStatusInactive = 'APPOINTMENT_TYPE_STATUS_INACTIVE',
  AppointmentTypeStatusNone = 'APPOINTMENT_TYPE_STATUS_NONE',
  AppointmentTypeStatusNotYetActive = 'APPOINTMENT_TYPE_STATUS_NOT_YET_ACTIVE'
}

export type Resource_ApproveAppointmentRequestRequest = {
  __typename?: 'resource_ApproveAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  /** if appointment request config states manual appointment approval and manual slot selection, slots must be provided */
  proposedSlots?: Maybe<Array<Maybe<Resource_AppointmentTimeFrameMsg>>>;
};

export type Resource_ApproveAppointmentRequestResponse = {
  __typename?: 'resource_ApproveAppointmentRequestResponse';
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  result?: Maybe<Resource_ApproveAppointmentRequestResponseMessageMsg>;
};

export type Resource_ApproveAppointmentRequestResponseMessageMsg = {
  __typename?: 'resource_ApproveAppointmentRequestResponseMessageMsg';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Resource_ApproveAppointmentRequestsRequest = {
  __typename?: 'resource_ApproveAppointmentRequestsRequest';
  requests?: Maybe<Array<Maybe<Resource_ApproveAppointmentRequestRequest>>>;
};

export type Resource_ApproveAppointmentRequestsResponse = {
  __typename?: 'resource_ApproveAppointmentRequestsResponse';
  responses?: Maybe<Array<Maybe<Resource_ApproveAppointmentRequestResponse>>>;
};

export type Resource_ArchiveAppointmentRequestRequest = {
  __typename?: 'resource_ArchiveAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  reasonForArchiving?: Maybe<Scalars['String']>;
};

export enum Resource_AssignmentSex {
  /** male */
  AssignmentSexM = 'ASSIGNMENT_SEX_M',
  AssignmentSexNeutral = 'ASSIGNMENT_SEX_NEUTRAL',
  AssignmentSexNone = 'ASSIGNMENT_SEX_NONE',
  /** female */
  AssignmentSexW = 'ASSIGNMENT_SEX_W'
}

export type Resource_AssignmentSexCountMapMsg = {
  __typename?: 'resource_AssignmentSexCountMapMsg';
  count?: Maybe<Scalars['Int']>;
  sex?: Maybe<Resource_AssignmentSex>;
};

export enum Resource_BedHandlingType {
  BedHandlingTypeElectric = 'BED_HANDLING_TYPE_ELECTRIC',
  BedHandlingTypeManual = 'BED_HANDLING_TYPE_MANUAL',
  BedHandlingTypeNone = 'BED_HANDLING_TYPE_NONE'
}

export type Resource_BedLocationBottleneckMsg = {
  __typename?: 'resource_BedLocationBottleneckMsg';
  overbookingCount?: Maybe<Scalars['Int']>;
  timeFrame?: Maybe<TimeFrameMsg>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_BedLocationResourceMsg = {
  __typename?: 'resource_BedLocationResourceMsg';
  outlets?: Maybe<Array<Maybe<Resource_OutletMsg>>>;
  roomId?: Maybe<Scalars['String']>;
};

export type Resource_BedLocationsOverviewEntryMsg = {
  __typename?: 'resource_BedLocationsOverviewEntryMsg';
  /** blocked by isolation, would otherwise be available */
  bedLocationsBlockedOnlyByIsolationCount?: Maybe<Scalars['Int']>;
  /** have a blocking assignment */
  blockedBedLocationsCount?: Maybe<Scalars['Int']>;
  /** not assigned, but have been booked via contingent, so they need a bed location */
  bookedContingentAssignmentCount?: Maybe<Scalars['Int']>;
  entries?: Maybe<Array<Maybe<Resource_FreeBedLocationsOverviewEntryMsg>>>;
  /** available for assignment */
  freeBedLocationsCount?: Maybe<Scalars['Int']>;
  occupiedBedLocationsCount?: Maybe<Scalars['Int']>;
  occupiedTemporaryBedLocationsCount?: Maybe<Scalars['Int']>;
  totalBedLocations?: Maybe<Scalars['Int']>;
  totalTemporaryBedLocations?: Maybe<Scalars['Int']>;
};

/** ------------- Model Types ------------- */
export type Resource_BedResourceMsg = {
  __typename?: 'resource_BedResourceMsg';
  bedLocationId?: Maybe<Scalars['String']>;
  bedType?: Maybe<Resource_BedTypeMsg>;
};

export type Resource_BedTypeMsg = {
  __typename?: 'resource_BedTypeMsg';
  bedHandling?: Maybe<Resource_BedHandlingType>;
  maxCapacityKilograms?: Maybe<Scalars['Float']>;
};

export type Resource_BookReservedAppointmentOrSeriesRequest = {
  __typename?: 'resource_BookReservedAppointmentOrSeriesRequest';
  appointmentId?: Maybe<Scalars['String']>;
  appointmentSeriesId?: Maybe<Scalars['String']>;
  /** If provided, the appointment will be booked for only these attendees, otherwise all */
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  /** Relevant only when the appointment is force scheduled */
  reasonsForForceScheduling?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForRebooking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_BookReservedAppointmentOrSeriesResponse = {
  __typename?: 'resource_BookReservedAppointmentOrSeriesResponse';
  appointment?: Maybe<Resource_AppointmentMsg>;
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
};

export type Resource_CancelAppointmentOrSeriesRequest = {
  __typename?: 'resource_CancelAppointmentOrSeriesRequest';
  appointmentId?: Maybe<Scalars['String']>;
  appointmentSeriesId?: Maybe<Scalars['String']>;
  /** If provided, appointment will be cancelled for only these attendees */
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  /** If set to true and the appointment is a part of series, cancel the later ones in the same series. */
  deleteLaterAppointments?: Maybe<Scalars['Boolean']>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_CancelAppointmentOrSeriesResponse = {
  __typename?: 'resource_CancelAppointmentOrSeriesResponse';
  appointment?: Maybe<Resource_AppointmentMsg>;
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
};

export type Resource_CancelAppointmentRequestRequest = {
  __typename?: 'resource_CancelAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_CancelExternalAppointmentsRequest = {
  __typename?: 'resource_CancelExternalAppointmentsRequest';
  externalIds?: Maybe<Array<Maybe<Resource_ExternalAppointmentIdMsg>>>;
};

export type Resource_CancelStaticResourceAssignmentRequest = {
  __typename?: 'resource_CancelStaticResourceAssignmentRequest';
  staticResourceAssignmentId?: Maybe<Scalars['String']>;
};

export type Resource_CancelStaticResourceAssignmentResponse = {
  __typename?: 'resource_CancelStaticResourceAssignmentResponse';
  staticResourceAssignmentId?: Maybe<Scalars['String']>;
};

export enum Resource_CockpitType {
  CockpitTypeInpatient = 'COCKPIT_TYPE_INPATIENT',
  CockpitTypeNone = 'COCKPIT_TYPE_NONE',
  CockpitTypeOutpatient = 'COCKPIT_TYPE_OUTPATIENT',
  CockpitTypeSurgery = 'COCKPIT_TYPE_SURGERY'
}

export type Resource_CreateAppointmentFlagRequest = {
  __typename?: 'resource_CreateAppointmentFlagRequest';
  colorCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  immediatelyActivate?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** mandatory */
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_CreateAppointmentFlagResponse = {
  __typename?: 'resource_CreateAppointmentFlagResponse';
  flag?: Maybe<Resource_AppointmentFlagMsg>;
};

export type Resource_CreateAppointmentRequest = {
  __typename?: 'resource_CreateAppointmentRequest';
  /** Optional: provide to include additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointment?: Maybe<Resource_AppointmentMsg>;
  forceCreation?: Maybe<Scalars['Boolean']>;
  /** considered only if forceCreation is true and the appointment status is BOOKED */
  reasonsForForceScheduling?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_CreateAppointmentRequestRequest = {
  __typename?: 'resource_CreateAppointmentRequestRequest';
  /** Optional: provide to include additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
};

export type Resource_CreateAppointmentSeriesAppointmentsRequest = {
  __typename?: 'resource_CreateAppointmentSeriesAppointmentsRequest';
  /** Optional: provide to include additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentSeriesId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['String']>;
  /**
   * Provide the ids of the existing appointment series attendees.
   *  If no attendees are provided, all attendees of the series will be used.
   */
  attendeeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional override for appointment type's default duration */
  duration?: Maybe<Scalars['Int']>;
  /** Date of first appointment */
  firstDate?: Maybe<Timestamp>;
  /** Optional filters for preferred handlers */
  handlerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The last date an appointment can take place */
  lastDate?: Maybe<Timestamp>;
  location?: Maybe<Resource_AppointmentLocation>;
  minusDays?: Maybe<Scalars['Int']>;
  /** The preferred number of appointments */
  numberOfAppointments?: Maybe<Scalars['Int']>;
  officeHourId?: Maybe<Scalars['String']>;
  /** mandatory information for defining recurrence of appointments */
  period?: Maybe<Scalars['Int']>;
  periodUnit?: Maybe<TimeUnit>;
  /**
   * Optional input fields to make the search flexible in case an appointment can not be found
   *  on the preferred dates
   */
  plusDays?: Maybe<Scalars['Int']>;
};

export type Resource_CreateAppointmentTaskRequest = {
  __typename?: 'resource_CreateAppointmentTaskRequest';
  appointmentId?: Maybe<Scalars['String']>;
  appointmentTask?: Maybe<Resource_AppointmentTaskMsg>;
  /** Optional list of portal user Ids */
  portalUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_CreateAppointmentTaskResponse = {
  __typename?: 'resource_CreateAppointmentTaskResponse';
  appointmentTasks?: Maybe<Array<Maybe<Resource_AppointmentTaskMsg>>>;
};

export type Resource_CreateDepletableResourceRequest = {
  __typename?: 'resource_CreateDepletableResourceRequest';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  resource?: Maybe<Resource_DepletableResourceMsg>;
};

export type Resource_CreateOrJoinAppointmentRequest = {
  __typename?: 'resource_CreateOrJoinAppointmentRequest';
  /** Optional: provide to include additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentId?: Maybe<Scalars['String']>;
  /** Can be used to connect appointments to appointments series */
  appointmentSeriesId?: Maybe<Scalars['String']>;
  /** If no attendees are provided, an empty attendee with status `RESERVED` will be automatically added */
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  forceCreation?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Resource_AppointmentLocation>;
  /** considered only if forceCreation is true and the appointment status is BOOKED */
  reasonsForForceScheduling?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  slot?: Maybe<Resource_AppointmentTimeFrameMsg>;
  /** For simplicity, all attendees has to have the same status. If left empty, the status will be reserved. */
  status?: Maybe<Resource_AppointmentStatus>;
};

/** Create */
export type Resource_CreateStaticResourceRequest = {
  __typename?: 'resource_CreateStaticResourceRequest';
  administrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  parentResourceId?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource_StaticResourceMsg>;
  updateParent?: Maybe<Scalars['Boolean']>;
};

export type Resource_CurrentAssignmentStatusesMsg = {
  __typename?: 'resource_CurrentAssignmentStatusesMsg';
  assignmentStatuses?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentType>>>;
};

export type Resource_DateList = {
  __typename?: 'resource_DateList';
  dates?: Maybe<Array<Maybe<Timestamp>>>;
};

export type Resource_DateToBedLocationsOverviewMapMsg = {
  __typename?: 'resource_DateToBedLocationsOverviewMapMsg';
  date?: Maybe<Timestamp>;
  entry?: Maybe<Resource_BedLocationsOverviewEntryMsg>;
};

export type Resource_DeleteAppointmentFlagRequest = {
  __typename?: 'resource_DeleteAppointmentFlagRequest';
  flagId?: Maybe<Scalars['String']>;
};

export type Resource_DeleteAppointmentFlagResponse = {
  __typename?: 'resource_DeleteAppointmentFlagResponse';
  deletedFlagId?: Maybe<Scalars['String']>;
};

export type Resource_DeleteAppointmentTaskRequest = {
  __typename?: 'resource_DeleteAppointmentTaskRequest';
  appointmentTaskId?: Maybe<Scalars['String']>;
};

export type Resource_DeleteAppointmentTaskTemplateRequest = {
  __typename?: 'resource_DeleteAppointmentTaskTemplateRequest';
  templateId?: Maybe<Scalars['String']>;
};

/** Delete */
export type Resource_DeleteDepletableResourceRequest = {
  __typename?: 'resource_DeleteDepletableResourceRequest';
  resourceId?: Maybe<Scalars['String']>;
};

export type Resource_DeleteStaticResourceCategoryRequest = {
  __typename?: 'resource_DeleteStaticResourceCategoryRequest';
  categoryId?: Maybe<Scalars['String']>;
};

export type Resource_DeleteStaticResourceRequest = {
  __typename?: 'resource_DeleteStaticResourceRequest';
  resourceId?: Maybe<Scalars['String']>;
};

export type Resource_DepletableResourceChangeMsg = {
  __typename?: 'resource_DepletableResourceChangeMsg';
  amountD?: Maybe<Scalars['Float']>;
  amountI?: Maybe<Scalars['Int']>;
  date?: Maybe<Timestamp>;
  externalId?: Maybe<Scalars['String']>;
  externalType?: Maybe<Resource_ExternalType>;
  id?: Maybe<Scalars['String']>;
  resource?: Maybe<Resource_DepletableResourceMsg>;
  resourceInformation?: Maybe<Resource_ResourceInformationMsg>;
};

export type Resource_DepletableResourceList = {
  __typename?: 'resource_DepletableResourceList';
  depletableResources?: Maybe<Array<Maybe<Resource_DepletableResourceMsg>>>;
};

/** ----- Depletable Resources ----- // */
export type Resource_DepletableResourceMsg = {
  __typename?: 'resource_DepletableResourceMsg';
  externalId?: Maybe<Scalars['String']>;
  externalType?: Maybe<Resource_ExternalType>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  precision?: Maybe<Scalars['Int']>;
  resourceInformation?: Maybe<Resource_ResourceInformationMsg>;
  unitType?: Maybe<Resource_UnitType>;
};

export enum Resource_DepletableResourceState {
  DepletableResourceStateFinished = 'DEPLETABLE_RESOURCE_STATE_FINISHED',
  DepletableResourceStateNone = 'DEPLETABLE_RESOURCE_STATE_NONE',
  DepletableResourceStateReserved = 'DEPLETABLE_RESOURCE_STATE_RESERVED'
}

export type Resource_ExternalAppointmentAttendeeIdMsg = {
  __typename?: 'resource_ExternalAppointmentAttendeeIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
};

export type Resource_ExternalAppointmentHandlerIdMsg = {
  __typename?: 'resource_ExternalAppointmentHandlerIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
};

export type Resource_ExternalAppointmentIdMsg = {
  __typename?: 'resource_ExternalAppointmentIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
};

export type Resource_ExternalAppointmentTypeIdMsg = {
  __typename?: 'resource_ExternalAppointmentTypeIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
};

export type Resource_ExternalResourceIdMsg = {
  __typename?: 'resource_ExternalResourceIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_ExternalResourceIdType>;
};

export enum Resource_ExternalResourceIdType {
  ExternalResourceIdTypeHis = 'EXTERNAL_RESOURCE_ID_TYPE_HIS',
  ExternalResourceIdTypeNone = 'EXTERNAL_RESOURCE_ID_TYPE_NONE'
}

export enum Resource_ExternalType {
  ExternalTypeNone = 'EXTERNAL_TYPE_NONE'
}

export type Resource_FindAppointmentAttendeeRequest = {
  __typename?: 'resource_FindAppointmentAttendeeRequest';
  externalAppointmentAttendeeId?: Maybe<Scalars['String']>;
};

export type Resource_FindAppointmentAttendeeResponse = {
  __typename?: 'resource_FindAppointmentAttendeeResponse';
  attendee?: Maybe<Resource_AppointmentAttendeeMsg>;
  found?: Maybe<Scalars['Boolean']>;
};

export type Resource_FindResourceTypeRequest = {
  __typename?: 'resource_FindResourceTypeRequest';
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_FindResourceTypeResponse = {
  __typename?: 'resource_FindResourceTypeResponse';
  found?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Resource_ResourceTypeMsg>;
};

export type Resource_FindStaticResourceNamesByIdsRequest = {
  __typename?: 'resource_FindStaticResourceNamesByIdsRequest';
  staticResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_FindStaticResourceNamesByIdsResponse = {
  __typename?: 'resource_FindStaticResourceNamesByIdsResponse';
  staticResourceNameById?: Maybe<Array<Maybe<Resource_FindStaticResourceNamesByIdsResponse_StaticResourceNameByIdEntry>>>;
};

export type Resource_FindStaticResourceNamesByIdsResponse_StaticResourceNameByIdEntry = {
  __typename?: 'resource_FindStaticResourceNamesByIdsResponse_StaticResourceNameByIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Resource_FindStaticResourceParametersMsg = {
  __typename?: 'resource_FindStaticResourceParametersMsg';
  externalId?: Maybe<Resource_ExternalResourceIdMsg>;
  name?: Maybe<Scalars['String']>;
  parentResourceId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_StaticResourceType>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_FindStaticResourceRequest = {
  __typename?: 'resource_FindStaticResourceRequest';
  parameters?: Maybe<Resource_FindStaticResourceParametersMsg>;
  referenceId?: Maybe<Scalars['String']>;
};

export type Resource_FindStaticResourceResponse = {
  __typename?: 'resource_FindStaticResourceResponse';
  found?: Maybe<Scalars['Boolean']>;
  staticResource?: Maybe<Resource_StaticResourceMsg>;
};

export type Resource_FlagsAdministrativeUnitContextMsg = {
  __typename?: 'resource_FlagsAdministrativeUnitContextMsg';
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: Maybe<Scalars['Boolean']>;
  ownerUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type Resource_FlagsOfficeHourContextMsg = {
  __typename?: 'resource_FlagsOfficeHourContextMsg';
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_FreeBedLocationsOverviewEntryMsg = {
  __typename?: 'resource_FreeBedLocationsOverviewEntryMsg';
  sexToCountMaps?: Maybe<Array<Maybe<Resource_AssignmentSexCountMapMsg>>>;
  /** Administrative unit is joined to the message */
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_GetAccountVerificationRequiredRequest = {
  __typename?: 'resource_GetAccountVerificationRequiredRequest';
  _?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentConfigRequest = {
  __typename?: 'resource_GetAppointmentConfigRequest';
  appointmentConfigId?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentFormReferenceBlacklistRequest = {
  __typename?: 'resource_GetAppointmentFormReferenceBlacklistRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentFormReferenceBlacklistResponse = {
  __typename?: 'resource_GetAppointmentFormReferenceBlacklistResponse';
  formReferenceBlacklist?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentFormTemplateVersioningGroupIdRequest = {
  __typename?: 'resource_GetAppointmentFormTemplateVersioningGroupIdRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentFormTemplateVersioningGroupIdResponse = {
  __typename?: 'resource_GetAppointmentFormTemplateVersioningGroupIdResponse';
  formTemplateVersioningGroupId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentHistoryRequest = {
  __typename?: 'resource_GetAppointmentHistoryRequest';
  /**
   * Optional field for portal user requests, the attendee will be deducted from the current portal user id.
   *  Mandatory for clinic user requests.
   */
  appointmentAttendeeId?: Maybe<Scalars['String']>;
  appointmentId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentHistoryResponse = {
  __typename?: 'resource_GetAppointmentHistoryResponse';
  events?: Maybe<Array<Maybe<Resource_AppointmentHistoryEventMsg>>>;
};

export type Resource_GetAppointmentRequest = {
  __typename?: 'resource_GetAppointmentRequest';
  appointmentId?: Maybe<Scalars['String']>;
  /** If set, includes request information in the response */
  getRequestInfo?: Maybe<Scalars['Boolean']>;
};

export type Resource_GetAppointmentRequestDocumentsRequest = {
  __typename?: 'resource_GetAppointmentRequestDocumentsRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentRequestDocumentsResponse = {
  __typename?: 'resource_GetAppointmentRequestDocumentsResponse';
  documents?: Maybe<Array<Maybe<Document_DocumentBasicInfoMsg>>>;
};

export type Resource_GetAppointmentRequestRequest = {
  __typename?: 'resource_GetAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentRequestsRequest = {
  __typename?: 'resource_GetAppointmentRequestsRequest';
  appointmentRequestIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_GetAppointmentSeriesRequest = {
  __typename?: 'resource_GetAppointmentSeriesRequest';
  appointmentSeriesId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentTaskRequest = {
  __typename?: 'resource_GetAppointmentTaskRequest';
  appointmentTaskId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentTypeRequest = {
  __typename?: 'resource_GetAppointmentTypeRequest';
  appointmentTypeId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentTypesRequest = {
  __typename?: 'resource_GetAppointmentTypesRequest';
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentTypeReferenceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_GetAppointmentWaitingListRequest = {
  __typename?: 'resource_GetAppointmentWaitingListRequest';
  appointmentTypeId?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_GetAppointmentsRequest = {
  __typename?: 'resource_GetAppointmentsRequest';
  appointmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_GetAppointmentsResponse = {
  __typename?: 'resource_GetAppointmentsResponse';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
};

export type Resource_GetAvailableAppointmentBlocksRequest = {
  __typename?: 'resource_GetAvailableAppointmentBlocksRequest';
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** End datetime of filter */
  end?: Maybe<Timestamp>;
  handlerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  inPersonAppointment?: Maybe<Scalars['Boolean']>;
  /** Merge overlapping blocks of different handlers with same appointment type */
  mergeBlocks?: Maybe<Scalars['Boolean']>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** True: patients can book, false: patients can not book, null: all */
  patientBookable?: Maybe<Scalars['Boolean']>;
  /** Start datetime of filter */
  start?: Maybe<Timestamp>;
};

export type Resource_GetAvailableAppointmentTimesRequest = {
  __typename?: 'resource_GetAvailableAppointmentTimesRequest';
  additionalServiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Id of the appointment that should not block the availability of the results */
  appointmentId?: Maybe<Scalars['String']>;
  /** Appointment type is necessary to determine the correct appointment config */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** The length of the appointment that is being looked for, only for clinic side */
  duration?: Maybe<Scalars['Int']>;
  /** End datetime of filter */
  end?: Maybe<Timestamp>;
  handlerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Maximum number of results that will be returned */
  maxNumberOfResults?: Maybe<Scalars['Int']>;
  officeHourId?: Maybe<Scalars['String']>;
  /**
   * True means only the slots that patients can book
   * False means only the slots that patients can not book
   * Null means all slots
   * Patient portal requests must always set this to true, no restriction for clinic
   */
  patientBookable?: Maybe<Scalars['Boolean']>;
  /** Start datetime of filter */
  start?: Maybe<Timestamp>;
  timeFrames?: Maybe<Array<Maybe<Core_TimeFrameOfDayMsg>>>;
};

export type Resource_GetBedLocationsBottlenecksRequest = {
  __typename?: 'resource_GetBedLocationsBottlenecksRequest';
  filterEnd?: Maybe<Timestamp>;
  filterStart?: Maybe<Timestamp>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_GetBedLocationsBottlenecksResponse = {
  __typename?: 'resource_GetBedLocationsBottlenecksResponse';
  /** List of dates where at least one overbooking was done */
  bottlenecks?: Maybe<Array<Maybe<Resource_BedLocationBottleneckMsg>>>;
};

export type Resource_GetBedLocationsOccupancyTrendRequest = {
  __typename?: 'resource_GetBedLocationsOccupancyTrendRequest';
  filterEnd?: Maybe<Timestamp>;
  filterStart?: Maybe<Timestamp>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_GetBedLocationsOccupancyTrendResponse = {
  __typename?: 'resource_GetBedLocationsOccupancyTrendResponse';
  /** Provide entries sorted by instant, ascending */
  entries?: Maybe<Array<Maybe<Resource_GetBedLocationsOccupancyTrendResponseEntry>>>;
};

export type Resource_GetBedLocationsOccupancyTrendResponseEntry = {
  __typename?: 'resource_GetBedLocationsOccupancyTrendResponseEntry';
  /** TODO granularity needs to be discussed */
  instant?: Maybe<Timestamp>;
  /** number of occupied bed locations / total bed locations at the instant given */
  occupancyRatio?: Maybe<Scalars['Float']>;
};

export type Resource_GetBedLocationsOverviewRequest = {
  __typename?: 'resource_GetBedLocationsOverviewRequest';
  filterEnd?: Maybe<Timestamp>;
  filterStart?: Maybe<Timestamp>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_GetBedLocationsOverviewResponse = {
  __typename?: 'resource_GetBedLocationsOverviewResponse';
  overviews?: Maybe<Array<Maybe<Resource_DateToBedLocationsOverviewMapMsg>>>;
};

export type Resource_GetPatientAppointmentsRequest = {
  __typename?: 'resource_GetPatientAppointmentsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Resource_GetPatientAppointmentsResponse = {
  __typename?: 'resource_GetPatientAppointmentsResponse';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Resource_GetResourceTypesRequest = {
  __typename?: 'resource_GetResourceTypesRequest';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_GetResourceTypesResponse = {
  __typename?: 'resource_GetResourceTypesResponse';
  types?: Maybe<Array<Maybe<Resource_ResourceTypeMsg>>>;
};

export type Resource_GetStaticResourceAssignmentRequest = {
  __typename?: 'resource_GetStaticResourceAssignmentRequest';
  id?: Maybe<Scalars['String']>;
};

export type Resource_GetStaticResourceAssignmentsRequest = {
  __typename?: 'resource_GetStaticResourceAssignmentsRequest';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_GetStaticResourceRequest = {
  __typename?: 'resource_GetStaticResourceRequest';
  id?: Maybe<Scalars['String']>;
};

export type Resource_GetStaticResourcesRequest = {
  __typename?: 'resource_GetStaticResourcesRequest';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_IncludedServiceMsg = {
  __typename?: 'resource_IncludedServiceMsg';
  description?: Maybe<Core_LocalizedStringMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Core_LocalizedStringMsg>;
};

export type Resource_LinkVisitToAppointmentRequest = {
  __typename?: 'resource_LinkVisitToAppointmentRequest';
  appointmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Resource_ListAdditionalServicesRequest = {
  __typename?: 'resource_ListAdditionalServicesRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_ListAppointmentFlagsRequest = {
  __typename?: 'resource_ListAppointmentFlagsRequest';
  administrativeUnit?: Maybe<Resource_FlagsAdministrativeUnitContextMsg>;
  officeHour?: Maybe<Resource_FlagsOfficeHourContextMsg>;
};

export type Resource_ListAppointmentFlagsResponse = {
  __typename?: 'resource_ListAppointmentFlagsResponse';
  flags?: Maybe<Array<Maybe<Resource_AppointmentFlagMsg>>>;
};

export type Resource_ListAppointmentHandlersRequest = {
  __typename?: 'resource_ListAppointmentHandlersRequest';
  administrativeUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  officeHourId?: Maybe<Scalars['String']>;
  /** Optional filter; if no statuses are provided, defaults to only returning active ones */
  statuses?: Maybe<Array<Maybe<Resource_AppointmentHandlerStatus>>>;
};

export type Resource_ListAppointmentRegularScheduleDetailsRequest = {
  __typename?: 'resource_ListAppointmentRegularScheduleDetailsRequest';
  officeHoursIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  planningHorizon?: Maybe<Resource_PlanningHorizon>;
};

export type Resource_ListAppointmentRequestsRequest = {
  __typename?: 'resource_ListAppointmentRequestsRequest';
  appointmentFlagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdInOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** Optional list of appointment locations */
  locations?: Maybe<Array<Maybe<Resource_AppointmentLocation>>>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional pagination */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Resource_AppointmentRequestStatus>>>;
  /** Optional order, default decreasing */
  submissionTimeSortOrder?: Maybe<Helper_SortOrder>;
};

export type Resource_ListAppointmentRequestsResponse = {
  __typename?: 'resource_ListAppointmentRequestsResponse';
  appointmentRequests?: Maybe<Array<Maybe<Resource_AppointmentRequestMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Resource_ListAppointmentSchedulesRequest = {
  __typename?: 'resource_ListAppointmentSchedulesRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_ListAppointmentSchedulesResponse = {
  __typename?: 'resource_ListAppointmentSchedulesResponse';
  appointmentConfigurationId?: Maybe<Scalars['String']>;
  appointmentTypes?: Maybe<Array<Maybe<Resource_AppointmentTypeMsg>>>;
  officeHourId?: Maybe<Scalars['String']>;
  scheduleAssignments?: Maybe<Array<Maybe<Resource_ScheduleAssignmentMsg>>>;
  scheduleExceptions?: Maybe<Array<Maybe<Resource_ScheduleExceptionMsg>>>;
};

export type Resource_ListAppointmentSeriesRequest = {
  __typename?: 'resource_ListAppointmentSeriesRequest';
  /** Optional */
  appointmentAttendeeInfoId?: Maybe<Scalars['String']>;
  /** End datetime of filter request */
  filterEnd?: Maybe<Timestamp>;
  /** Start datetime of filter request */
  filterStart?: Maybe<Timestamp>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  /** filter appointment series where status is in this list. if empty, it is ignored. */
  statusIn?: Maybe<Array<Maybe<Resource_AppointmentSeriesStatus>>>;
  /** filter appointment series where status is not in this list. if empty, it is ignored. */
  statusNotIn?: Maybe<Array<Maybe<Resource_AppointmentSeriesStatus>>>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_ListAppointmentTaskTemplatesRequest = {
  __typename?: 'resource_ListAppointmentTaskTemplatesRequest';
  officeHourId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Resource_AppointmentTaskTemplateStatus>>>;
};

export type Resource_ListAppointmentTaskTemplatesResponse = {
  __typename?: 'resource_ListAppointmentTaskTemplatesResponse';
  templates?: Maybe<Array<Maybe<Resource_AppointmentTaskTemplateMsg>>>;
};

export type Resource_ListAppointmentTasksRequest = {
  __typename?: 'resource_ListAppointmentTasksRequest';
  appointmentId?: Maybe<Scalars['String']>;
};

export type Resource_ListAppointmentTypesRequest = {
  __typename?: 'resource_ListAppointmentTypesRequest';
  /** Optional, the language the types should be listed in alphabetically */
  locale?: Maybe<Scalars['String']>;
  /** At least one is mandatory */
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional filter; if no statuses are provided, defaults to only returning active ones */
  statuses?: Maybe<Array<Maybe<Resource_AppointmentTypeStatus>>>;
};

export type Resource_ListAppointmentsRequest = {
  __typename?: 'resource_ListAppointmentsRequest';
  appointmentAttendeeInfoId?: Maybe<Scalars['String']>;
  appointmentFlagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional order, default decreasing */
  bookingTimeSortOrder?: Maybe<Helper_SortOrder>;
  clinicId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  /** True: booked or requested by portal user, False: Booked or requested by clinic user, Null: Both */
  external?: Maybe<Scalars['Boolean']>;
  /** End datetime of filter request */
  filterEnd?: Maybe<Timestamp>;
  /** Start datetime of filter request */
  filterStart?: Maybe<Timestamp>;
  handlerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * If set to true, only return appointments that have the imported flag set to true; if false, only those with false; if null, don't filter by this.
   *  This cannot be used in combination with the external flag; so if imported is not null, external is ignored
   */
  imported?: Maybe<Scalars['Boolean']>;
  /** Optional appointment locations */
  locations?: Maybe<Array<Maybe<Resource_AppointmentLocation>>>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** Optional pagination */
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  patientId?: Maybe<Scalars['String']>;
  portalUserId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Boolean']>;
  /** Optional order, default decreasing */
  startTimeSortOrder?: Maybe<Helper_SortOrder>;
  /** filter appointments where status is in this list. if empty, it is ignored. */
  statusIn?: Maybe<Array<Maybe<Resource_AppointmentStatus>>>;
  /** filter appointments where status is not in this list. if empty, it is ignored. */
  statusNotIn?: Maybe<Array<Maybe<Resource_AppointmentStatus>>>;
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_ListAppointmentsResponse = {
  __typename?: 'resource_ListAppointmentsResponse';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Resource_ListOperatingRoomComplexRoomIdsRequest = {
  __typename?: 'resource_ListOperatingRoomComplexRoomIdsRequest';
  operatingRoomComplexIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_ListOperatingRoomComplexRoomIdsResponse = {
  __typename?: 'resource_ListOperatingRoomComplexRoomIdsResponse';
  operatingRoomComplexIdToResourceIds?: Maybe<Array<Maybe<Resource_ListOperatingRoomComplexRoomIdsResponse_OperatingRoomComplexIdToResourceIdsEntry>>>;
};

export type Resource_ListOperatingRoomComplexRoomIdsResponse_OperatingRoomComplexIdToResourceIdsEntry = {
  __typename?: 'resource_ListOperatingRoomComplexRoomIdsResponse_OperatingRoomComplexIdToResourceIdsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Resource_StaticResourceIdList>;
};

export type Resource_ListPortalUserAppointmentTasksRequest = {
  __typename?: 'resource_ListPortalUserAppointmentTasksRequest';
  portalUserId?: Maybe<Scalars['String']>;
};

export type Resource_ListPortalUserAppointmentTypesEntryMsg = {
  __typename?: 'resource_ListPortalUserAppointmentTypesEntryMsg';
  appointmentType?: Maybe<Resource_AppointmentTypeMsg>;
  bookingState?: Maybe<Resource_AppointmentTypeBookingState>;
};

export type Resource_ListPortalUserAppointmentTypesRequest = {
  __typename?: 'resource_ListPortalUserAppointmentTypesRequest';
  /**
   * This list should be created from FormSequenceQuestionMsg->linkedReferences->id of the last FormSequenceQuestionMsg that
   *  is encountered.
   *  It's an optional filter, if no ids are provided, this filter is not applied.
   */
  formReferencesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional, the language the types should be listed in alphabetically */
  locale?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  /** Optional filter, if none is provided, all types are returned */
  statuses?: Maybe<Array<Maybe<Resource_AppointmentTypeStatus>>>;
};

export type Resource_ListPortalUserAppointmentTypesResponse = {
  __typename?: 'resource_ListPortalUserAppointmentTypesResponse';
  appointmentTypes?: Maybe<Array<Maybe<Resource_ListPortalUserAppointmentTypesEntryMsg>>>;
};

export type Resource_ListResourcesRequest = {
  __typename?: 'resource_ListResourcesRequest';
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used
   *  to check for any possible assignments these resources have.
   *  If these fields are set, only assignments in this timeframe will be considered, if not
   *  only currently active assignments will be considered.
   *  If only checkAssignmentsFrom is given, the checked timeframe will start and end at the moment of checkAssignmentsFrom.
   *  If only checkAssignmentsUntil is given, the checked timeframe will start from now until this stamp.
   */
  checkAssignmentsFrom?: Maybe<Timestamp>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used
   *  to check for any possible assignments these resources have.
   *  If these fields are set, only assignments in this timeframe will be considered, if not
   *  only currently active assignments will be considered.
   *  If only checkAssignmentsFrom is given, the checked timeframe will start and end at the moment of checkAssignmentsFrom.
   *  If only checkAssignmentsUntil is given, the checked timeframe will start from now until this stamp.
   */
  checkAssignmentsUntil?: Maybe<Timestamp>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used to filter
   *  resources that have no available child resources of the given type
   *  the type is required since many resources that are connected to a parent also have child resources
   */
  checkChildrenAvailability?: Maybe<Scalars['Boolean']>;
  /**
   * During the listing of resources of a ward or organizational unit, these fields can be used to filter
   *  resources that have no available child resources of the given type
   *  the type is required since many resources that are connected to a parent also have child resources
   */
  childrenType?: Maybe<Resource_StaticResourceType>;
  currentAssignmentStatuses?: Maybe<Resource_CurrentAssignmentStatusesMsg>;
  /** WARNING: this is not for regular usage, only set to true when explicitly required */
  includeTemporaryResources?: Maybe<Scalars['Boolean']>;
  /** Ignored if includeTemporaryResources is not true. If set, returns only those that have are explicitly marked as parent-less */
  onlyTemporaryWithoutParents?: Maybe<Scalars['Boolean']>;
  /** only works if type is set as operating room */
  operatingRoomComplexId?: Maybe<Scalars['String']>;
  parentResourceId?: Maybe<Scalars['String']>;
  removeAssigned?: Maybe<Scalars['Boolean']>;
  returnChildren?: Maybe<Scalars['Boolean']>;
  returnCurrentAssignments?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Resource_StaticResourceType>;
  units?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type Resource_ListStaticResourceAssignmentRequest = {
  __typename?: 'resource_ListStaticResourceAssignmentRequest';
  /** At least one of resourceId, visitId must be set */
  resourceId?: Maybe<Scalars['String']>;
  returnOldAssignments?: Maybe<Scalars['Boolean']>;
  /** At least one of resourceId, visitId must be set */
  visitId?: Maybe<Scalars['String']>;
};

export type Resource_ListStaticResourceAssignmentTimeFramesEntryMsg = {
  __typename?: 'resource_ListStaticResourceAssignmentTimeFramesEntryMsg';
  assignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  endTime?: Maybe<Timestamp>;
  /** Static resource assignment exception id, if the time frame is based on one */
  exceptionId?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Timestamp>;
};

export type Resource_ListStaticResourceAssignmentTimeFramesRequest = {
  __typename?: 'resource_ListStaticResourceAssignmentTimeFramesRequest';
  filterEnd?: Maybe<Timestamp>;
  filterStart?: Maybe<Timestamp>;
  /** Special case for operating rooms, gets time frames for all assignments of the operating rooms of the complex */
  operatingRoomComplexId?: Maybe<Scalars['String']>;
  /** Adds in session time frames too */
  sessionId?: Maybe<Scalars['String']>;
  /** Either set staticResourceAssignmentIds, staticResourceIds or operatingRoomComplexId */
  staticResourceAssignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  staticResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusIn?: Maybe<Array<Maybe<Resource_ResourceAssignmentStatus>>>;
  statusNotIn?: Maybe<Array<Maybe<Resource_ResourceAssignmentStatus>>>;
  typesIn?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentType>>>;
  typesNotIn?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentType>>>;
};

export type Resource_ListStaticResourceAssignmentTimeFramesResponse = {
  __typename?: 'resource_ListStaticResourceAssignmentTimeFramesResponse';
  entries?: Maybe<Array<Maybe<Resource_ListStaticResourceAssignmentTimeFramesEntryMsg>>>;
};

/** TODO: find fields to filter with */
export type Resource_ListStaticResourceCategoriesRequest = {
  __typename?: 'resource_ListStaticResourceCategoriesRequest';
  _?: Maybe<Scalars['String']>;
};

export type Resource_ListStaticResourcesResponse = {
  __typename?: 'resource_ListStaticResourcesResponse';
  assignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentsMapMsg>>>;
  staticResources?: Maybe<Array<Maybe<Resource_StaticResourceMsg>>>;
};

export type Resource_OperatingRoomMsg = {
  __typename?: 'resource_OperatingRoomMsg';
  /** TODO : fill it according to needs */
  operatingRoomComplexId?: Maybe<Scalars['String']>;
};

export type Resource_OutletMsg = {
  __typename?: 'resource_OutletMsg';
  bedLocationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  outletType?: Maybe<Resource_OutletType>;
  roomId?: Maybe<Scalars['String']>;
};

export enum Resource_OutletType {
  OutletTypeAnaestheticGasDischarge = 'OUTLET_TYPE_ANAESTHETIC_GAS_DISCHARGE',
  OutletTypeCallingSystem = 'OUTLET_TYPE_CALLING_SYSTEM',
  OutletTypeDataSupply = 'OUTLET_TYPE_DATA_SUPPLY',
  OutletTypeEmergencyPowerSupply = 'OUTLET_TYPE_EMERGENCY_POWER_SUPPLY',
  OutletTypeNone = 'OUTLET_TYPE_NONE',
  OutletTypeO2 = 'OUTLET_TYPE_O2',
  OutletTypePowerSupply = 'OUTLET_TYPE_POWER_SUPPLY',
  OutletTypePressure = 'OUTLET_TYPE_PRESSURE',
  OutletTypeSuction = 'OUTLET_TYPE_SUCTION',
  OutletTypeTelephone = 'OUTLET_TYPE_TELEPHONE',
  OutletTypeTv = 'OUTLET_TYPE_TV',
  OutletTypeVentilation = 'OUTLET_TYPE_VENTILATION'
}

export enum Resource_PlanningHorizon {
  PlanningHorizonMonth = 'PLANNING_HORIZON_MONTH',
  PlanningHorizonNone = 'PLANNING_HORIZON_NONE',
  PlanningHorizonQuarter = 'PLANNING_HORIZON_QUARTER',
  PlanningHorizonWeek = 'PLANNING_HORIZON_WEEK',
  PlanningHorizonYear = 'PLANNING_HORIZON_YEAR'
}

export type Resource_ReassignStaticResourceRequest = {
  __typename?: 'resource_ReassignStaticResourceRequest';
  /** if true, a temporary resource will be created with the data in temporaryResourceDefinition */
  createTemporaryResource?: Maybe<Scalars['Boolean']>;
  forceAssignment?: Maybe<Scalars['Boolean']>;
  isolation?: Maybe<Scalars['Boolean']>;
  newAssignmentSex?: Maybe<Resource_AssignmentSex>;
  newEndDate?: Maybe<Timestamp>;
  /** ignored if create temporary resource is set */
  newResourceId?: Maybe<Scalars['String']>;
  oldAssignmentId?: Maybe<Scalars['String']>;
  oldResourceAssignee?: Maybe<Resource_UnassignStaticResourceByAssigneeRequest>;
  removeEndDate?: Maybe<Scalars['Boolean']>;
  swapIfFull?: Maybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: Maybe<Resource_TemporaryResourceDefinitionMsg>;
};

export type Resource_ReassignStaticResourceResponse = {
  __typename?: 'resource_ReassignStaticResourceResponse';
  /** if there were conflicting assignments that could be swapped */
  assignmentsCreatedForOldResource?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
  /** if there were conflicting assignments that could be swapped */
  assignmentsRemovedFromNewResource?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
  /** assignment created as a result of reassigning action */
  newAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  /** assignment that ended as a result of reassigning action */
  oldAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  warning?: Maybe<Resource_RequestStaticResourceWarning>;
};

export type Resource_RefreshReservedAppointmentOrSeriesRequest = {
  __typename?: 'resource_RefreshReservedAppointmentOrSeriesRequest';
  appointmentId?: Maybe<Scalars['String']>;
  appointmentSeriesId?: Maybe<Scalars['String']>;
  /** If provided, the appointment will be refreshed for only these attendees, otherwise all */
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
};

export type Resource_RefreshReservedAppointmentOrSeriesResponse = {
  __typename?: 'resource_RefreshReservedAppointmentOrSeriesResponse';
  appointment?: Maybe<Resource_AppointmentMsg>;
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
};

export type Resource_RegularScheduleEntryMsg = {
  __typename?: 'resource_RegularScheduleEntryMsg';
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  handlers?: Maybe<Array<Maybe<Resource_AppointmentHandlerMsg>>>;
  timeFrame?: Maybe<Core_TimeFrameOfDayMsg>;
};

export type Resource_RejectAppointmentProposalsRequest = {
  __typename?: 'resource_RejectAppointmentProposalsRequest';
  /** Rejects all proposed appointments for this request */
  appointmentRequestId?: Maybe<Scalars['String']>;
};

export type Resource_RejectAppointmentRequestRequest = {
  __typename?: 'resource_RejectAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  reasonsForRejection?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForRejectionExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_RejectAppointmentRequestsRequest = {
  __typename?: 'resource_RejectAppointmentRequestsRequest';
  requests?: Maybe<Array<Maybe<Resource_RejectAppointmentRequestRequest>>>;
};

export type Resource_RemoveAdditionalServiceRequest = {
  __typename?: 'resource_RemoveAdditionalServiceRequest';
  additionalServiceId?: Maybe<Scalars['String']>;
};

export type Resource_RemoveAppointmentConfigRequest = {
  __typename?: 'resource_RemoveAppointmentConfigRequest';
  appointmentConfigId?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
};

export type Resource_RemoveAppointmentHandlerRequest = {
  __typename?: 'resource_RemoveAppointmentHandlerRequest';
  appointmentHandlerId?: Maybe<Scalars['String']>;
};

export type Resource_RemoveAppointmentTypeRequest = {
  __typename?: 'resource_RemoveAppointmentTypeRequest';
  appointmentTypeId?: Maybe<Scalars['String']>;
};

export type Resource_RemoveScheduleAssignmentRequest = {
  __typename?: 'resource_RemoveScheduleAssignmentRequest';
  scheduleAssignmentId?: Maybe<Scalars['String']>;
};

export type Resource_RemoveScheduleExceptionRequest = {
  __typename?: 'resource_RemoveScheduleExceptionRequest';
  scheduleExceptionId?: Maybe<Scalars['String']>;
};

export type Resource_RequestDepletableResourceRequest = {
  __typename?: 'resource_RequestDepletableResourceRequest';
  acquirerId?: Maybe<Scalars['String']>;
  acquirerType?: Maybe<Resource_ResourceAcquirerType>;
  amountD?: Maybe<Scalars['Float']>;
  amountI?: Maybe<Scalars['Int']>;
  date?: Maybe<Timestamp>;
  resourceId?: Maybe<Scalars['String']>;
};

export type Resource_RequestStaticResourceRequest = {
  __typename?: 'resource_RequestStaticResourceRequest';
  assignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  /** if true, a temporary resource will be created with the data in temporaryResourceDefinition, the resource in the assignment will be ignored */
  createTemporaryResource?: Maybe<Scalars['Boolean']>;
  forceAssignment?: Maybe<Scalars['Boolean']>;
  temporaryResourceDefinition?: Maybe<Resource_TemporaryResourceDefinitionMsg>;
};

export type Resource_RequestStaticResourceResponse = {
  __typename?: 'resource_RequestStaticResourceResponse';
  assignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  granted?: Maybe<Scalars['Boolean']>;
  warning?: Maybe<Resource_RequestStaticResourceWarning>;
};

export enum Resource_RequestStaticResourceWarning {
  /** Patient sex is not known and the user did not select a room sex for the patient */
  RequestStaticResourceWarningGenderUnknown = 'REQUEST_STATIC_RESOURCE_WARNING_GENDER_UNKNOWN',
  /** The patient needs to stay in a neutral room but the room is already occupied */
  RequestStaticResourceWarningNeutralRoomOccupied = 'REQUEST_STATIC_RESOURCE_WARNING_NEUTRAL_ROOM_OCCUPIED',
  RequestStaticResourceWarningNone = 'REQUEST_STATIC_RESOURCE_WARNING_NONE',
  /** The resource requested is occupied */
  RequestStaticResourceWarningResourceOccupied = 'REQUEST_STATIC_RESOURCE_WARNING_RESOURCE_OCCUPIED',
  /** Room designated for a specific gender which is different from the new patient gender */
  RequestStaticResourceWarningRoomGenderMismatch = 'REQUEST_STATIC_RESOURCE_WARNING_ROOM_GENDER_MISMATCH',
  /** Room is isolated and cannot accept new patients */
  RequestStaticResourceWarningRoomIsolated = 'REQUEST_STATIC_RESOURCE_WARNING_ROOM_ISOLATED',
  /** Isolated patient assigned to non-isolated room with patients stayed in it */
  RequestStaticResourceWarningRoomNotIsolatedPatientIsolated = 'REQUEST_STATIC_RESOURCE_WARNING_ROOM_NOT_ISOLATED_PATIENT_ISOLATED'
}

export type Resource_RequestStaticResourcesRequest = {
  __typename?: 'resource_RequestStaticResourcesRequest';
  assignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
};

export type Resource_RequestStaticResourcesResponse = {
  __typename?: 'resource_RequestStaticResourcesResponse';
  assignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
};

export type Resource_ReserveAssignedResourceRequest = {
  __typename?: 'resource_ReserveAssignedResourceRequest';
  assignmentId?: Maybe<Scalars['String']>;
  reserveUntil?: Maybe<Timestamp>;
};

export type Resource_ReserveAssignedResourceResponse = {
  __typename?: 'resource_ReserveAssignedResourceResponse';
  futureAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  oldAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  reserveAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
};

export type Resource_ResetAppointmentStatusRequest = {
  __typename?: 'resource_ResetAppointmentStatusRequest';
  appointmentId?: Maybe<Scalars['String']>;
};

export enum Resource_ResourceAcquirerType {
  ResourceAcquirerTypeNone = 'RESOURCE_ACQUIRER_TYPE_NONE',
  ResourceAcquirerTypePatient = 'RESOURCE_ACQUIRER_TYPE_PATIENT'
}

export type Resource_ResourceAssignmentCreatorMsg = {
  __typename?: 'resource_ResourceAssignmentCreatorMsg';
  creatorId?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_ResourceAssignmentCreatorType>;
};

export enum Resource_ResourceAssignmentCreatorType {
  ResourceAssignmentCreatorTypeNone = 'RESOURCE_ASSIGNMENT_CREATOR_TYPE_NONE',
  ResourceAssignmentCreatorTypePortalUser = 'RESOURCE_ASSIGNMENT_CREATOR_TYPE_PORTAL_USER',
  ResourceAssignmentCreatorTypeProfessionalPortalUser = 'RESOURCE_ASSIGNMENT_CREATOR_TYPE_PROFESSIONAL_PORTAL_USER',
  ResourceAssignmentCreatorTypeUser = 'RESOURCE_ASSIGNMENT_CREATOR_TYPE_USER'
}

export enum Resource_ResourceAssignmentStatus {
  ResourceAssignmentTypeCancelled = 'RESOURCE_ASSIGNMENT_TYPE_CANCELLED',
  ResourceAssignmentTypeConfirmed = 'RESOURCE_ASSIGNMENT_TYPE_CONFIRMED',
  ResourceAssignmentTypeNone = 'RESOURCE_ASSIGNMENT_TYPE_NONE',
  ResourceAssignmentTypeTentative = 'RESOURCE_ASSIGNMENT_TYPE_TENTATIVE'
}

export type Resource_ResourceIdList = {
  __typename?: 'resource_ResourceIdList';
  resourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_ResourceInformationMsg = {
  __typename?: 'resource_ResourceInformationMsg';
  expirationDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  manufactureDate?: Maybe<Timestamp>;
  partNumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type Resource_ResourceListResponse = {
  __typename?: 'resource_ResourceListResponse';
  _?: Maybe<Scalars['String']>;
};

export type Resource_ResourceManufacturerMsg = {
  __typename?: 'resource_ResourceManufacturerMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Resource_ResourceType {
  ResourceTypeDepletable = 'RESOURCE_TYPE_DEPLETABLE',
  ResourceTypeNone = 'RESOURCE_TYPE_NONE',
  ResourceTypeStatic = 'RESOURCE_TYPE_STATIC'
}

export type Resource_ResourceTypeMsg = {
  __typename?: 'resource_ResourceTypeMsg';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Resource_ResourceManufacturerMsg>;
  modelNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  staticResourceType?: Maybe<Resource_StaticResourceType>;
  timestamps?: Maybe<TimeMsg>;
};

/** Request */
export type Resource_ResourcesRequest = {
  __typename?: 'resource_ResourcesRequest';
  depletableRequests?: Maybe<Array<Maybe<Resource_RequestDepletableResourceRequest>>>;
  staticRequests?: Maybe<Array<Maybe<Resource_RequestStaticResourceRequest>>>;
};

export enum Resource_RestroomType {
  RestroomTypeDisabled = 'RESTROOM_TYPE_DISABLED',
  RestroomTypeNone = 'RESTROOM_TYPE_NONE',
  RestroomTypeStandard = 'RESTROOM_TYPE_STANDARD'
}

export type Resource_RoomResourceMsg = {
  __typename?: 'resource_RoomResourceMsg';
  bedLocations?: Maybe<Array<Maybe<Resource_BedLocationResourceMsg>>>;
  isolated?: Maybe<Scalars['Boolean']>;
  isolationTypeId?: Maybe<Scalars['String']>;
  outlets?: Maybe<Array<Maybe<Resource_OutletMsg>>>;
  restroomType?: Maybe<Resource_RestroomType>;
  /** Dynamically and automatically assigned to the room */
  sex?: Maybe<Resource_AssignmentSex>;
  /**
   * the latest time the sex assignment of the room is valid
   *  when a gendered assignment is set to a room, the expiration date is the end date of the assignment
   *  if there are multiple gendered assignments in the room, this date is the end date of the earliest ending assignment
   *  if this date is in the past, there are no guarantees that the sex of the room is correct,
   *  recalculateAssignmentSexes can be used to manually align room sexes
   */
  sexExpirationDate?: Maybe<Timestamp>;
  showerType?: Maybe<Resource_ShowerType>;
};

export type Resource_ScheduleAssignmentList = {
  __typename?: 'resource_ScheduleAssignmentList';
  scheduleAssignments?: Maybe<Array<Maybe<Resource_ScheduleAssignmentMsg>>>;
};

export type Resource_ScheduleAssignmentMsg = {
  __typename?: 'resource_ScheduleAssignmentMsg';
  /** Datetime schedule assigment stops being active */
  activeEnd?: Maybe<Timestamp>;
  /** Datetime schedule assigment starts being active */
  activeStart?: Maybe<Timestamp>;
  /**
   * If this is true, regardless of patientBookableTimeRange, the schedule is patient bookable.
   *  Otherwise the state of being patient bookable depends on patientBookableTimeRange.
   */
  alwaysPatientBookable?: Maybe<Scalars['Boolean']>;
  appointmentTypes?: Maybe<Array<Maybe<Resource_AppointmentTypeMsg>>>;
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  handlers?: Maybe<Array<Maybe<Resource_AppointmentHandlerMsg>>>;
  id?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  /**
   * Only appointments on a date between (current date + patientBookableLatestTimeRange) and (current date + patientBookableEarliestTimeRange)
   *  are bookable for patients. Example: Earliest 10 days, latest 2 days means one can book appointments between 2 days later and 10 days later.
   *  If earliest is null or smaller than latest, patients can never book an appointment.
   *  If latest is null, there is no limit on that end of the range.
   */
  patientBookableEarliestTimeRange?: Maybe<Scalars['Int']>;
  patientBookableLatestTimeRange?: Maybe<Scalars['Int']>;
  timeFrame?: Maybe<Core_TimeFrameOfDayMsg>;
};

export type Resource_ScheduleExceptionList = {
  __typename?: 'resource_ScheduleExceptionList';
  scheduleExceptions?: Maybe<Array<Maybe<Resource_ScheduleExceptionMsg>>>;
};

export type Resource_ScheduleExceptionMsg = {
  __typename?: 'resource_ScheduleExceptionMsg';
  appointmentTypes?: Maybe<Array<Maybe<Resource_AppointmentTypeMsg>>>;
  /** True: blocking an available time frame, False: adding a new available time frame */
  blocking?: Maybe<Scalars['Boolean']>;
  /** optional */
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Timestamp>;
  handlers?: Maybe<Array<Maybe<Resource_AppointmentHandlerMsg>>>;
  id?: Maybe<Scalars['String']>;
  officeHourId?: Maybe<Scalars['String']>;
  patientBookable?: Maybe<Scalars['Boolean']>;
  scheduleExceptionTag?: Maybe<Resource_ScheduleExceptionTag>;
  startTime?: Maybe<Timestamp>;
};

export enum Resource_ScheduleExceptionTag {
  ScheduleExceptionTagNone = 'SCHEDULE_EXCEPTION_TAG_NONE',
  ScheduleExceptionTagPublicHoliday = 'SCHEDULE_EXCEPTION_TAG_PUBLIC_HOLIDAY'
}

export type Resource_SearchAppointmentsSmartRequest = {
  __typename?: 'resource_SearchAppointmentsSmartRequest';
  filterEnd?: Maybe<Timestamp>;
  filterStart?: Maybe<Timestamp>;
  /** optional filter */
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  paginatedListRequest?: Maybe<Helper_PaginatedListRequest>;
  statusIn?: Maybe<Array<Maybe<Resource_AppointmentStatus>>>;
};

export type Resource_SearchAppointmentsSmartResponse = {
  __typename?: 'resource_SearchAppointmentsSmartResponse';
  appointments?: Maybe<Array<Maybe<Resource_AppointmentBasicInfoMsg>>>;
  hitCount?: Maybe<Scalars['Int']>;
};

export type Resource_SearchResourceTypesRequest = {
  __typename?: 'resource_SearchResourceTypesRequest';
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: Maybe<Scalars['Boolean']>;
  /** mandatory */
  ownerUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** optional */
  staticResourceType?: Maybe<Resource_StaticResourceType>;
  text?: Maybe<Scalars['String']>;
};

export type Resource_SearchResourceTypesResponse = {
  __typename?: 'resource_SearchResourceTypesResponse';
  types?: Maybe<Array<Maybe<Resource_ResourceTypeMsg>>>;
};

export type Resource_SearchStaticResourceCategoriesRequest = {
  __typename?: 'resource_SearchStaticResourceCategoriesRequest';
  text?: Maybe<Scalars['String']>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_SearchStaticResourceCategoriesResponse = {
  __typename?: 'resource_SearchStaticResourceCategoriesResponse';
  categories?: Maybe<Array<Maybe<Resource_StaticResourceCategoryMsg>>>;
};

export type Resource_SelectAppointmentSlotsRequest = {
  __typename?: 'resource_SelectAppointmentSlotsRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  proposedSlots?: Maybe<Array<Maybe<Resource_AppointmentMsg>>>;
};

export enum Resource_ShowerType {
  ShowerTypeBathtub = 'SHOWER_TYPE_BATHTUB',
  ShowerTypeNone = 'SHOWER_TYPE_NONE',
  ShowerTypeShower = 'SHOWER_TYPE_SHOWER'
}

export type Resource_StaticResourceAssignmentList = {
  __typename?: 'resource_StaticResourceAssignmentList';
  staticResourceAssignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
};

/** ----- Static Resource Assignment ----- // */
export type Resource_StaticResourceAssignmentMsg = {
  __typename?: 'resource_StaticResourceAssignmentMsg';
  assignedPatientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignedUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignmentSex?: Maybe<Resource_AssignmentSex>;
  /** required field if assignment type is STATIC_RESOURCE_ASSIGNMENT_TYPE_MAINTENANCE, ignored/not set otherwise */
  assignmentText?: Maybe<Scalars['String']>;
  connectedAppointment?: Maybe<Resource_AppointmentMsg>;
  creator?: Maybe<Resource_ResourceAssignmentCreatorMsg>;
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  endDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  /** isolation status of the assignment, relevant only for bed location assignments */
  isolated?: Maybe<Scalars['Boolean']>;
  /**
   * If this is true, the assignment can be postponed or moved earlier in case of a conflict when the user chooses to override the conflict.
   *  Currently only relevant for assignments that are part of a bundle, which is used by surgery.
   */
  movableOnConflict?: Maybe<Scalars['Boolean']>;
  /** For in session assignments, the id of the corresponding "non in session" assignment */
  originalAssignmentId?: Maybe<Scalars['String']>;
  /** the owner of the assignment, may not be set */
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** If type is "block" */
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** If recurring start date and end date are the active time frame of the rule */
  recurring?: Maybe<Scalars['Boolean']>;
  resource?: Maybe<Resource_StaticResourceMsg>;
  sessionId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Timestamp>;
  status?: Maybe<Resource_ResourceAssignmentStatus>;
  timeFrame?: Maybe<Core_TimeFrameOfDayMsg>;
  type?: Maybe<Resource_StaticResourceAssignmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Resource_StaticResourceAssignmentType {
  StaticResourceAssignmentTypeAvailable = 'STATIC_RESOURCE_ASSIGNMENT_TYPE_AVAILABLE',
  StaticResourceAssignmentTypeBlocked = 'STATIC_RESOURCE_ASSIGNMENT_TYPE_BLOCKED',
  StaticResourceAssignmentTypeNone = 'STATIC_RESOURCE_ASSIGNMENT_TYPE_NONE',
  StaticResourceAssignmentTypeOccupied = 'STATIC_RESOURCE_ASSIGNMENT_TYPE_OCCUPIED',
  StaticResourceAssignmentTypeReserved = 'STATIC_RESOURCE_ASSIGNMENT_TYPE_RESERVED'
}

export type Resource_StaticResourceAssignmentsMapMsg = {
  __typename?: 'resource_StaticResourceAssignmentsMapMsg';
  assignments?: Maybe<Array<Maybe<Resource_StaticResourceAssignmentMsg>>>;
  staticResourceId?: Maybe<Scalars['String']>;
};

export type Resource_StaticResourceCategoryList = {
  __typename?: 'resource_StaticResourceCategoryList';
  categories?: Maybe<Array<Maybe<Resource_StaticResourceCategoryMsg>>>;
};

/** ---- Static Resource Category / Specifier ---- // */
export type Resource_StaticResourceCategoryMsg = {
  __typename?: 'resource_StaticResourceCategoryMsg';
  categorySpecifiers?: Maybe<Array<Maybe<Resource_StaticResourceCategorySpecifierMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Resource_StaticResourceCategorySpecifierMsg = {
  __typename?: 'resource_StaticResourceCategorySpecifierMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  staticResources?: Maybe<Array<Maybe<Resource_StaticResourceMsg>>>;
};

export type Resource_StaticResourceIdList = {
  __typename?: 'resource_StaticResourceIdList';
  staticResourceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_StaticResourceList = {
  __typename?: 'resource_StaticResourceList';
  staticResources?: Maybe<Array<Maybe<Resource_StaticResourceMsg>>>;
};

/** ----- Static Resource ----- // */
export type Resource_StaticResourceMsg = {
  __typename?: 'resource_StaticResourceMsg';
  active?: Maybe<Scalars['Boolean']>;
  associatedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  bedLocation?: Maybe<Resource_BedLocationResourceMsg>;
  /**
   * todo: model this better after assignments
   *  repeated string accessibleOperationRoomIds = 15;
   */
  categorySpecifier?: Maybe<Resource_StaticResourceCategorySpecifierMsg>;
  containedStaticResources?: Maybe<Array<Maybe<Resource_StaticResourceMsg>>>;
  externalId?: Maybe<Resource_ExternalResourceIdMsg>;
  groupId?: Maybe<Scalars['String']>;
  /** if the resource supposed to have a parent but currently it does not exist and assumed to be to be a "temporary" parent */
  hasNoParent?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  information?: Maybe<Resource_ResourceInformationMsg>;
  instanceType?: Maybe<Resource_StaticResourceType>;
  name?: Maybe<Scalars['String']>;
  operatingRoom?: Maybe<Resource_OperatingRoomMsg>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  parentResourceInstanceType?: Maybe<Resource_StaticResourceType>;
  /** optional, will be set if parent resource exist */
  parentResourceName?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  room?: Maybe<Resource_RoomResourceMsg>;
  /** means this resource is going to be removed after releasing its assignment */
  temporary?: Maybe<Scalars['Boolean']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Resource_ResourceTypeMsg>;
};

export enum Resource_StaticResourceType {
  StaticResourceTypeBed = 'STATIC_RESOURCE_TYPE_BED',
  StaticResourceTypeBedLocation = 'STATIC_RESOURCE_TYPE_BED_LOCATION',
  StaticResourceTypeGeneric = 'STATIC_RESOURCE_TYPE_GENERIC',
  StaticResourceTypeNone = 'STATIC_RESOURCE_TYPE_NONE',
  StaticResourceTypeOperatingRoom = 'STATIC_RESOURCE_TYPE_OPERATING_ROOM',
  StaticResourceTypeRoom = 'STATIC_RESOURCE_TYPE_ROOM'
}

export type Resource_SubmitAppointmentRebookingRequestRequest = {
  __typename?: 'resource_SubmitAppointmentRebookingRequestRequest';
  /** Id of the appointment to be rescheduled, mandatory */
  appointmentId?: Maybe<Scalars['String']>;
  /** Can be optionally used to update the appointment type */
  appointmentTypeId?: Maybe<Scalars['String']>;
  /** Attendee must be set because, there is no other way of knowing which attendee will be rebooked */
  attendee?: Maybe<Resource_AppointmentAttendeeMsg>;
  /**
   * TODO : we might need to add or remove additional services here
   *  TODO related to a TODO in appointment request msg
   */
  formIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The preferences are mandatory */
  preferences?: Maybe<Resource_AppointmentRequestPreferencesMsg>;
  /** Must be set by clinic side requests, portal requests do not need it */
  requestDirection?: Maybe<Resource_AppointmentRequestDirection>;
};

export type Resource_SubmitAppointmentRequestRequest = {
  __typename?: 'resource_SubmitAppointmentRequestRequest';
  appointmentRequestId?: Maybe<Scalars['String']>;
  createAppointmentRequestRequest?: Maybe<Resource_CreateAppointmentRequestRequest>;
  /** In order to place the submission in the waiting list */
  inWaitingList?: Maybe<Scalars['Boolean']>;
  /** Can be used only for requesting to rebook a booked appointment */
  rebookingRequestSubmission?: Maybe<Resource_SubmitAppointmentRebookingRequestRequest>;
};

export type Resource_SubmitCounterAppointmentRequestRequest = {
  __typename?: 'resource_SubmitCounterAppointmentRequestRequest';
  /** Optional: provide to update the additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  /** In order to place the submission in the waiting list */
  inWaitingList?: Maybe<Scalars['Boolean']>;
};

export type Resource_TemporaryResourceDefinitionMsg = {
  __typename?: 'resource_TemporaryResourceDefinitionMsg';
  associatedUnits?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** if the resource supposed to have a parent but currently it does not exist and assumed to be to be a "temporary" parent */
  hasNoParent?: Maybe<Scalars['Boolean']>;
  instanceType?: Maybe<Resource_StaticResourceType>;
  name?: Maybe<Scalars['String']>;
  /** optional; if set, temporary resource gets assigned as child to this resource */
  parentResourceId?: Maybe<Scalars['String']>;
};

export type Resource_UnassignStaticResourceByAssigneeRequest = {
  __typename?: 'resource_UnassignStaticResourceByAssigneeRequest';
  patientId?: Maybe<Scalars['String']>;
  /** Static resource and one of the assignee ids are mandatory unless the static resource is temporarily */
  resourceId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Resource_UnassignStaticResourceRequest = {
  __typename?: 'resource_UnassignStaticResourceRequest';
  assignmentId?: Maybe<Scalars['String']>;
  blockEnd?: Maybe<Timestamp>;
  blockResource?: Maybe<Scalars['Boolean']>;
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  resourceAssignee?: Maybe<Resource_UnassignStaticResourceByAssigneeRequest>;
  sessionId?: Maybe<Scalars['String']>;
  /** if set, the unassigned assignment will end at this timestamp, cannot be in the future */
  unassignInstant?: Maybe<Timestamp>;
};

export type Resource_UnassignStaticResourceResponse = {
  __typename?: 'resource_UnassignStaticResourceResponse';
  createdBlockingAssignment?: Maybe<Resource_StaticResourceAssignmentMsg>;
  id?: Maybe<Scalars['String']>;
};

export type Resource_UnassignStaticResourcesRequest = {
  __typename?: 'resource_UnassignStaticResourcesRequest';
  assignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_UnassignStaticResourcesResponse = {
  __typename?: 'resource_UnassignStaticResourcesResponse';
  assignmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Resource_UnitMsg = {
  __typename?: 'resource_UnitMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Resource_UnitType>;
};

export enum Resource_UnitType {
  UnitTypeDouble = 'UNIT_TYPE_DOUBLE',
  UnitTypeInt = 'UNIT_TYPE_INT',
  UnitTypeNone = 'UNIT_TYPE_NONE'
}

export type Resource_UpdateAppointmentAttendeeRequest = {
  __typename?: 'resource_UpdateAppointmentAttendeeRequest';
  appointmentId?: Maybe<Scalars['String']>;
  appointmentSeriesId?: Maybe<Scalars['String']>;
  attendee?: Maybe<Resource_AppointmentAttendeeMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Resource_UpdateAppointmentAttendeeResponse = {
  __typename?: 'resource_UpdateAppointmentAttendeeResponse';
  appointment?: Maybe<Resource_AppointmentMsg>;
  appointmentSeries?: Maybe<Resource_AppointmentSeriesMsg>;
};

export type Resource_UpdateAppointmentFlagRequest = {
  __typename?: 'resource_UpdateAppointmentFlagRequest';
  flag?: Maybe<Resource_AppointmentFlagMsg>;
  immediatelyActivate?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Resource_UpdateAppointmentFlagResponse = {
  __typename?: 'resource_UpdateAppointmentFlagResponse';
  flag?: Maybe<Resource_AppointmentFlagMsg>;
};

export type Resource_UpdateAppointmentRequest = {
  __typename?: 'resource_UpdateAppointmentRequest';
  appointment?: Maybe<Resource_AppointmentMsg>;
  /** Mark changes as confirmed; used to push changes if push is activated */
  confirm?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Resource_UpdateAppointmentRequestFlagsRequest = {
  __typename?: 'resource_UpdateAppointmentRequestFlagsRequest';
  appointmentFlagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentRequestId?: Maybe<Scalars['String']>;
};

export type Resource_UpdateAppointmentRequestRequest = {
  __typename?: 'resource_UpdateAppointmentRequestRequest';
  /** Optional: provide to update the additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentRequest?: Maybe<Resource_AppointmentRequestMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Resource_UpdateAppointmentSlotRequest = {
  __typename?: 'resource_UpdateAppointmentSlotRequest';
  /** Optional: provide to include additional services */
  additionalServicesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  appointmentId?: Maybe<Scalars['String']>;
  /** If provided the slot will be updated only for these attendees, for others it will stay the same. Otherwise all */
  attendees?: Maybe<Array<Maybe<Resource_AppointmentAttendeeMsg>>>;
  forceUpdate?: Maybe<Scalars['Boolean']>;
  newSlot?: Maybe<Resource_AppointmentTimeFrameMsg>;
  /** considered only if forceUpdate is true and the status is BOOKED. DATASET_REASON_FOR_EXCEPTIONAL_SCHEDULING */
  reasonsForForceScheduling?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** considered only if the status is booked */
  reasonsForRebooking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** required: only reserved or booked are allowed */
  status?: Maybe<Resource_AppointmentStatus>;
};

export type Resource_UpdateAppointmentTaskRequest = {
  __typename?: 'resource_UpdateAppointmentTaskRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  task?: Maybe<Resource_AppointmentTaskMsg>;
};

export type Resource_UpdateAppointmentTaskResultRequest = {
  __typename?: 'resource_UpdateAppointmentTaskResultRequest';
  appointmentTaskId?: Maybe<Scalars['String']>;
  newResultReferences?: Maybe<Array<Maybe<Resource_AppointmentTaskResultReferenceMsg>>>;
};

export type Resource_UpdateAppointmentTaskStatusRequest = {
  __typename?: 'resource_UpdateAppointmentTaskStatusRequest';
  appointmentTaskId?: Maybe<Scalars['String']>;
  newStatus?: Maybe<Resource_AppointmentTaskStatus>;
  reasonsForCancellation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  reasonsForCancellationExternal?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Resource_UpdateAppointmentVisitInformationRequest = {
  __typename?: 'resource_UpdateAppointmentVisitInformationRequest';
  appointmentId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  /** For now, can be either ONGOING or FINISHED */
  status?: Maybe<Resource_AppointmentStatus>;
  visitId?: Maybe<Scalars['String']>;
};

/** Update */
export type Resource_UpdateDepletableResourceRequest = {
  __typename?: 'resource_UpdateDepletableResourceRequest';
  depletableResource?: Maybe<Resource_DepletableResourceMsg>;
};

export type Resource_UpdateResourceTypeRequest = {
  __typename?: 'resource_UpdateResourceTypeRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  type?: Maybe<Resource_ResourceTypeMsg>;
};

export type Resource_UpdateScheduleAssignmentsRequest = {
  __typename?: 'resource_UpdateScheduleAssignmentsRequest';
  officeHourId?: Maybe<Scalars['String']>;
  scheduleAssignmentList?: Maybe<Resource_ScheduleAssignmentList>;
};

export type Resource_UpdateScheduleExceptionsRequest = {
  __typename?: 'resource_UpdateScheduleExceptionsRequest';
  endTime?: Maybe<Timestamp>;
  officeHourId?: Maybe<Scalars['String']>;
  scheduleExceptionList?: Maybe<Resource_ScheduleExceptionList>;
  scheduleExceptionTag?: Maybe<Resource_ScheduleExceptionTag>;
  startTime?: Maybe<Timestamp>;
};

/** TODO: make this patch to update non-time related fields? */
export type Resource_UpdateStaticResourceAssignmentRequest = {
  __typename?: 'resource_UpdateStaticResourceAssignmentRequest';
  assignmentId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Timestamp>;
  /**
   * if this flag is set, the update will be performed even if there are other conflicting assignments
   *  the cancelled assignments will be returned
   */
  forceUpdate?: Maybe<Scalars['Boolean']>;
  isolation?: Maybe<Scalars['Boolean']>;
  moveableOnConflict?: Maybe<Scalars['Boolean']>;
  /**
   * If true, non of the fields that affect scheduling and status are changed.
   *  Such fields include reasonsForBlocking and moveableOnConflict.
   */
  noScheduleUpdate?: Maybe<Scalars['Boolean']>;
  /** Replaces existing reasonsForBlocking if replaceReasonsForBlocking is set */
  reasonsForBlocking?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  replaceReasonsForBlocking?: Maybe<Scalars['Boolean']>;
  /** If the assignment is an in session assignment, the session id must be provided */
  sessionId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Timestamp>;
  status?: Maybe<Resource_ResourceAssignmentStatus>;
  type?: Maybe<Resource_StaticResourceAssignmentType>;
};

export type Resource_UpdateStaticResourceCategoryRequest = {
  __typename?: 'resource_UpdateStaticResourceCategoryRequest';
  category?: Maybe<Resource_StaticResourceCategoryMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Resource_UpdateStaticResourceRequest = {
  __typename?: 'resource_UpdateStaticResourceRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  staticResource?: Maybe<Resource_StaticResourceMsg>;
};

export type Resource_VerifyAppointmentRequestsRequest = {
  __typename?: 'resource_VerifyAppointmentRequestsRequest';
  _?: Maybe<Scalars['String']>;
};

export type Resource_WeekDaysConfigMsg = {
  __typename?: 'resource_WeekDaysConfigMsg';
  regularScheduleEntries?: Maybe<Array<Maybe<Resource_RegularScheduleEntryMsg>>>;
  weekday?: Maybe<DayOfWeek>;
};

export type Signature_ElectronicSignatureDetailsMsg = {
  __typename?: 'signature_ElectronicSignatureDetailsMsg';
  encryptionAlgorithm?: Maybe<Signature_EncryptionAlgorithm>;
  lastValidated?: Maybe<Timestamp>;
  signatureScheme?: Maybe<Signature_SignatureScheme>;
  /** Hash for qualified electronic signature */
  signedHash?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Signature_ElectronicSignatureVerificationStatus>;
};

export enum Signature_ElectronicSignatureVerificationStatus {
  ElectronicSignatureVerificationStatusInconclusive = 'ELECTRONIC_SIGNATURE_VERIFICATION_STATUS_INCONCLUSIVE',
  ElectronicSignatureVerificationStatusInvalid = 'ELECTRONIC_SIGNATURE_VERIFICATION_STATUS_INVALID',
  ElectronicSignatureVerificationStatusNone = 'ELECTRONIC_SIGNATURE_VERIFICATION_STATUS_NONE',
  ElectronicSignatureVerificationStatusValid = 'ELECTRONIC_SIGNATURE_VERIFICATION_STATUS_VALID'
}

export enum Signature_EncryptionAlgorithm {
  EncryptionAlgorithmEcc = 'ENCRYPTION_ALGORITHM_ECC',
  EncryptionAlgorithmNone = 'ENCRYPTION_ALGORITHM_NONE',
  EncryptionAlgorithmRsa = 'ENCRYPTION_ALGORITHM_RSA'
}

export type Signature_SignatureActionDataMsg = {
  __typename?: 'signature_SignatureActionDataMsg';
  id?: Maybe<Scalars['String']>;
  /** When a user is added to / updated / removed from signature requests list */
  previousAssignee?: Maybe<Signature_SignatureAssigneeMsg>;
  /** Whether previous assignee was marked as optional */
  previousOptional?: Maybe<Scalars['Boolean']>;
  updatedAssignee?: Maybe<Signature_SignatureAssigneeMsg>;
  /** Whether updated assignee is marked as optional */
  updatedOptional?: Maybe<Scalars['Boolean']>;
};

export type Signature_SignatureAssigneeMsg = {
  __typename?: 'signature_SignatureAssigneeMsg';
  assignedRole?: Maybe<Core_ScopedRoleTypeMsg>;
  assignedUserId?: Maybe<Scalars['String']>;
};

export type Signature_SignatureMsg = {
  __typename?: 'signature_SignatureMsg';
  /** The assignee is either a user or a combination of scope and role */
  assignee?: Maybe<Signature_SignatureAssigneeMsg>;
  done?: Maybe<Scalars['Boolean']>;
  electronicSignatureDetails?: Maybe<Signature_ElectronicSignatureDetailsMsg>;
  /** Id of a user who signed the letter with another signature but indirectly fulfilled this signature */
  fulfillingUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  seen?: Maybe<Scalars['Boolean']>;
  signatureDate?: Maybe<Timestamp>;
  /** The id of the user who signed the letter directly with this signature */
  signingUserId?: Maybe<Scalars['String']>;
  /** Image of the signature; will be printed if set */
  staticImageId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Signature_SignatureType>;
};

export enum Signature_SignatureRequirementStatus {
  SignatureRequirementStatusComplete = 'SIGNATURE_REQUIREMENT_STATUS_COMPLETE',
  SignatureRequirementStatusIncomplete = 'SIGNATURE_REQUIREMENT_STATUS_INCOMPLETE',
  /** If the current user signs the letter, it will be complete */
  SignatureRequirementStatusLastSignature = 'SIGNATURE_REQUIREMENT_STATUS_LAST_SIGNATURE',
  SignatureRequirementStatusNone = 'SIGNATURE_REQUIREMENT_STATUS_NONE'
}

export type Signature_SignatureRequirementTemplateMsg = {
  __typename?: 'signature_SignatureRequirementTemplateMsg';
  assignedRole?: Maybe<Core_ScopedRoleTypeTemplateMsg>;
  id?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
};

export enum Signature_SignatureScheme {
  SignatureSchemeNone = 'SIGNATURE_SCHEME_NONE',
  /** RSASSA-PKCS1-v1_5 */
  SignatureSchemeRsassaPkcs_1V_1_5 = 'SIGNATURE_SCHEME_RSASSA_PKCS_1_V_1_5',
  /** RSASSA-PSS */
  SignatureSchemeRsassaPss = 'SIGNATURE_SCHEME_RSASSA_PSS'
}

export enum Signature_SignatureType {
  SignatureTypeNone = 'SIGNATURE_TYPE_NONE',
  SignatureTypeQualifiedElectronicSignature = 'SIGNATURE_TYPE_QUALIFIED_ELECTRONIC_SIGNATURE',
  SignatureTypeStandardElectronicSignature = 'SIGNATURE_TYPE_STANDARD_ELECTRONIC_SIGNATURE'
}

export enum Signature_SignatureUpdateType {
  SignatureUpdateTypeAddSignature = 'SIGNATURE_UPDATE_TYPE_ADD_SIGNATURE',
  SignatureUpdateTypeDeleteSignature = 'SIGNATURE_UPDATE_TYPE_DELETE_SIGNATURE',
  SignatureUpdateTypeNone = 'SIGNATURE_UPDATE_TYPE_NONE',
  SignatureUpdateTypeSign = 'SIGNATURE_UPDATE_TYPE_SIGN',
  SignatureUpdateTypeUnsign = 'SIGNATURE_UPDATE_TYPE_UNSIGN',
  SignatureUpdateTypeUpdateSignature = 'SIGNATURE_UPDATE_TYPE_UPDATE_SIGNATURE'
}

export type Surgery_LightSurgeryClassMsg = {
  __typename?: 'surgery_LightSurgeryClassMsg';
  /** Defines what consents are required for preanaesthetic assessment */
  anesthesiaConsentClassIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Use system icd-10 */
  icdCodes?: Maybe<Array<Maybe<Treatment_DiagnosisCodingMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  opsCodes?: Maybe<Array<Maybe<Core_ProcedureCodeMsg>>>;
  plannedCaseType?: Maybe<Surgery_PlannedCaseType>;
  /** Defines what consents are required for pre-operative assessment */
  preOperativeConsentClassIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  schedulingInfo?: Maybe<Surgery_SurgeryClassSchedulingInfoMsg>;
};

export enum Surgery_PlannedCaseType {
  PlannedCaseTypeInPatient = 'PLANNED_CASE_TYPE_IN_PATIENT',
  PlannedCaseTypeNone = 'PLANNED_CASE_TYPE_NONE',
  PlannedCaseTypeOutPatient = 'PLANNED_CASE_TYPE_OUT_PATIENT'
}

export enum Surgery_SurgeryAttendeeType {
  SurgeryAttendeeTypeAnesthesia = 'SURGERY_ATTENDEE_TYPE_ANESTHESIA',
  SurgeryAttendeeTypeNone = 'SURGERY_ATTENDEE_TYPE_NONE',
  SurgeryAttendeeTypeOther = 'SURGERY_ATTENDEE_TYPE_OTHER',
  SurgeryAttendeeTypeSurgical = 'SURGERY_ATTENDEE_TYPE_SURGICAL'
}

export type Surgery_SurgeryClassSchedulingInfoMsg = {
  __typename?: 'surgery_SurgeryClassSchedulingInfoMsg';
  anesthesiaFollowUpDurationInSeconds?: Maybe<Scalars['Int']>;
  anesthesiaPreparationDurationInSeconds?: Maybe<Scalars['Int']>;
  contingentHolderIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cutToCloseDurationInSeconds?: Maybe<Scalars['Int']>;
  deviceCategorySpecifierIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  followupStart?: Maybe<Surgery_SurgerySubPhaseType>;
  operatingTableCategorySpecifierId?: Maybe<Scalars['String']>;
  preparationStart?: Maybe<Surgery_SurgerySubPhaseType>;
  simultaneousFollowUpPhases?: Maybe<Scalars['Boolean']>;
  simultaneousPreparationPhases?: Maybe<Scalars['Boolean']>;
  surgeryStaffFollowUpDurationInSeconds?: Maybe<Scalars['Int']>;
  surgeryStaffPreparationDurationInSeconds?: Maybe<Scalars['Int']>;
  turnOverDurationInSeconds?: Maybe<Scalars['Int']>;
};

export enum Surgery_SurgeryLaterality {
  SurgerySideLocalizationBoth = 'SURGERY_SIDE_LOCALIZATION_BOTH',
  SurgerySideLocalizationLeft = 'SURGERY_SIDE_LOCALIZATION_LEFT',
  SurgerySideLocalizationNone = 'SURGERY_SIDE_LOCALIZATION_NONE',
  SurgerySideLocalizationRight = 'SURGERY_SIDE_LOCALIZATION_RIGHT'
}

export type Surgery_SurgeryRequirementLinkedRequestReferenceMsg = {
  __typename?: 'surgery_SurgeryRequirementLinkedRequestReferenceMsg';
  referenceId?: Maybe<Scalars['String']>;
  type?: Maybe<Surgery_SurgeryRequirementRequestType>;
};

export type Surgery_SurgeryRequirementMsg = {
  __typename?: 'surgery_SurgeryRequirementMsg';
  creatorUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkedRequests?: Maybe<Array<Maybe<Surgery_SurgeryRequirementLinkedRequestReferenceMsg>>>;
  modifierUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  timestamps?: Maybe<TimeMsg>;
};

export enum Surgery_SurgeryRequirementRequestType {
  SurgeryRequirementRequestTypeClinical = 'SURGERY_REQUIREMENT_REQUEST_TYPE_CLINICAL',
  SurgeryRequirementRequestTypeLab = 'SURGERY_REQUIREMENT_REQUEST_TYPE_LAB',
  SurgeryRequirementRequestTypeNone = 'SURGERY_REQUIREMENT_REQUEST_TYPE_NONE'
}

export type Surgery_SurgerySpecifierMsg = {
  __typename?: 'surgery_SurgerySpecifierMsg';
  /** Can be provided instead of surgery diagnosis for high priority emergency surgeries. TODO: Is this really everything we need in here as specifiers of a specific surgery? */
  emergencySurgeryDiagnoses?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  laterality?: Maybe<Surgery_SurgeryLaterality>;
  surgeryClass?: Maybe<Surgery_LightSurgeryClassMsg>;
  /**
   * TODO Specification Surgery Request 6.5.1.3 might need to update diagnosis too for the following feature
   * If the surgery diagnosis has not been documented beforehand the user has the option to select
   * a new ICD-10 diagnosis as it is done for all other clinical requests. When confirming the selection the user
   * needs to receive a warning note that the newly selected diagnosis is added to the patient’s treatment diagnoses.
   * By confirming the warning note the diagnosis is added to the patient’s diagnoses and is also selected in the
   * surgery diagnosis input field.
   */
  surgeryDiagnosesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Surgery_SurgerySubPhaseType {
  SurgerySubPhaseTypeAnesthesia = 'SURGERY_SUB_PHASE_TYPE_ANESTHESIA',
  SurgerySubPhaseTypeNone = 'SURGERY_SUB_PHASE_TYPE_NONE',
  SurgerySubPhaseTypeSurgeryStaff = 'SURGERY_SUB_PHASE_TYPE_SURGERY_STAFF'
}

export type Telematik_TelematikAuthorMsg = {
  __typename?: 'telematik_TelematikAuthorMsg';
  emailTelecommunications?: Maybe<Array<Maybe<Scalars['String']>>>;
  institutions?: Maybe<Array<Maybe<Telematik_TelematikOrganizationMsg>>>;
  person?: Maybe<Telematik_TelematikPersonMsg>;
  phoneTelecommunications?: Maybe<Array<Maybe<Telematik_TelematikPhoneTelecommunicationMsg>>>;
  roles?: Maybe<Array<Maybe<Telematik_TelematikCodeMsg>>>;
  specialities?: Maybe<Array<Maybe<Telematik_TelematikCodeMsg>>>;
};

export type Telematik_TelematikCodeMsg = {
  __typename?: 'telematik_TelematikCodeMsg';
  code?: Maybe<Scalars['String']>;
  codeSystemId?: Maybe<Scalars['String']>;
  codeSystemName?: Maybe<Scalars['String']>;
  description?: Maybe<Core_LocalizedStringMsg>;
  displayName?: Maybe<Scalars['String']>;
};

export type Telematik_TelematikDocumentMetadataMsg = {
  __typename?: 'telematik_TelematikDocumentMetadataMsg';
  authors?: Maybe<Array<Maybe<Telematik_TelematikAuthorMsg>>>;
  classCode?: Maybe<Telematik_TelematikCodeMsg>;
  comments?: Maybe<Core_LocalizedStringMsg>;
  confidentialityCodes?: Maybe<Array<Maybe<Telematik_TelematikCodeMsg>>>;
  creationTime?: Maybe<Timestamp>;
  eventCodeLists?: Maybe<Array<Maybe<Telematik_TelematikCodeMsg>>>;
  formatCode?: Maybe<Telematik_TelematikCodeMsg>;
  healthCareFacilityTypeCode?: Maybe<Telematik_TelematikCodeMsg>;
  languageCode?: Maybe<Scalars['String']>;
  legalAuthenticator?: Maybe<Telematik_TelematikPersonMsg>;
  mimeType?: Maybe<Scalars['String']>;
  practiceSettingCode?: Maybe<Telematik_TelematikCodeMsg>;
  referenceIds?: Maybe<Array<Maybe<Telematik_TelematikReferenceIdentifierMsg>>>;
  serviceStartTime?: Maybe<Timestamp>;
  serviceStopTime?: Maybe<Timestamp>;
  titles?: Maybe<Core_LocalizedStringMsg>;
  typeCode?: Maybe<Telematik_TelematikCodeMsg>;
  uri?: Maybe<Scalars['String']>;
};

export type Telematik_TelematikIntendedRecipientMsg = {
  __typename?: 'telematik_TelematikIntendedRecipientMsg';
  email?: Maybe<Scalars['String']>;
  organization?: Maybe<Telematik_TelematikOrganizationMsg>;
  person?: Maybe<Telematik_TelematikPersonMsg>;
  phone?: Maybe<Telematik_TelematikPhoneTelecommunicationMsg>;
};

/** id+assigningAuthority <=> Optional<telematikId> */
export type Telematik_TelematikOrganizationMsg = {
  __typename?: 'telematik_TelematikOrganizationMsg';
  assigningAuthority?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** id+assigningAuthority <=> Optional<Either<lanr, lifelongKvnr>> */
export type Telematik_TelematikPersonMsg = {
  __typename?: 'telematik_TelematikPersonMsg';
  assigningAuthority?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  prefix?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type Telematik_TelematikPhoneTelecommunicationMsg = {
  __typename?: 'telematik_TelematikPhoneTelecommunicationMsg';
  areaOrCityCode?: Maybe<Scalars['Long']>;
  countryCode?: Maybe<Scalars['Long']>;
  equipmentType?: Maybe<Scalars['String']>;
  localPhoneNumberExtension?: Maybe<Scalars['Long']>;
  phoneNumber?: Maybe<Scalars['Long']>;
  useCode?: Maybe<Scalars['String']>;
};

export type Telematik_TelematikReferenceIdentifierMsg = {
  __typename?: 'telematik_TelematikReferenceIdentifierMsg';
  assigningAuthority?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  type?: Maybe<Telematik_TelematikReferenceIdentifierType>;
};

export enum Telematik_TelematikReferenceIdentifierType {
  TiReferenceIdentifierTypeAccession = 'TI_REFERENCE_IDENTIFIER_TYPE_ACCESSION',
  TiReferenceIdentifierTypeEncounterId = 'TI_REFERENCE_IDENTIFIER_TYPE_ENCOUNTER_ID',
  TiReferenceIdentifierTypeNone = 'TI_REFERENCE_IDENTIFIER_TYPE_NONE',
  TiReferenceIdentifierTypeOrder = 'TI_REFERENCE_IDENTIFIER_TYPE_ORDER',
  TiReferenceIdentifierTypeReferral = 'TI_REFERENCE_IDENTIFIER_TYPE_REFERRAL',
  TiReferenceIdentifierTypeStudyInstanceUid = 'TI_REFERENCE_IDENTIFIER_TYPE_STUDY_INSTANCE_UID',
  TiReferenceIdentifierTypeUniqueId = 'TI_REFERENCE_IDENTIFIER_TYPE_UNIQUE_ID',
  TiReferenceIdentifierTypeWorkflowInstanceId = 'TI_REFERENCE_IDENTIFIER_TYPE_WORKFLOW_INSTANCE_ID'
}

export type Treatment_AbdomenLocationsBlock = {
  __typename?: 'treatment_AbdomenLocationsBlock';
  leftLowerQuadrant?: Maybe<Scalars['String']>;
  leftUpperQuadrant?: Maybe<Scalars['String']>;
  midAbdomen?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  rightLowerQuadrant?: Maybe<Scalars['String']>;
  rightUpperQuadrant?: Maybe<Scalars['String']>;
  wholeAbdomen?: Maybe<Scalars['String']>;
};

export type Treatment_AbdominalCirculationNoiseBlock = {
  __typename?: 'treatment_AbdominalCirculationNoiseBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_AbdominalInspectionGeneralBlock = {
  __typename?: 'treatment_AbdominalInspectionGeneralBlock';
  abdominalMovementsPresent?: Maybe<Scalars['Boolean']>;
  abdominalMovementsText?: Maybe<Scalars['String']>;
  abdominalShapeText?: Maybe<Scalars['String']>;
  abdominalShapes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  posture?: Maybe<Treatment_PostureType>;
  postureText?: Maybe<Scalars['String']>;
};

export type Treatment_AbdominalPainMsg = {
  __typename?: 'treatment_AbdominalPainMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Core_KnowledgeInputMsg>;
  quality?: Maybe<Core_KnowledgeInputMsg>;
  radiationDescription?: Maybe<Scalars['String']>;
  radiationPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_AbdominalPercussionBlock = {
  __typename?: 'treatment_AbdominalPercussionBlock';
  entireAbdomen?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  leftUpperQuadrant?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  lowerLeftQuadrant?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  lowerRightQuadrant?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  midAbdomen?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  percussionSounds?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  rightUpperQuadrant?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_AbdominalWallBlock = {
  __typename?: 'treatment_AbdominalWallBlock';
  abdominalWall?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_Abduction {
  Abduction_15To_20 = 'ABDUCTION_15_TO_20',
  AbductionLessThanOrEqual_10 = 'ABDUCTION_LESS_THAN_OR_EQUAL_10',
  AbductionMoreThanOrEqual_25 = 'ABDUCTION_MORE_THAN_OR_EQUAL_25',
  AbductionNone = 'ABDUCTION_NONE'
}

export enum Treatment_AbnormalitiesExaminationResult {
  AbnormalitiesExaminationConspicuous = 'ABNORMALITIES_EXAMINATION_CONSPICUOUS',
  AbnormalitiesExaminationInconspicuous = 'ABNORMALITIES_EXAMINATION_INCONSPICUOUS',
  AbnormalitiesExaminationResultNone = 'ABNORMALITIES_EXAMINATION_RESULT_NONE'
}

export type Treatment_AbnormalityAngleAndTextMsg = {
  __typename?: 'treatment_AbnormalityAngleAndTextMsg';
  angle1?: Maybe<Scalars['Int']>;
  angle2?: Maybe<Scalars['Int']>;
  angle3?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateDiagnosesInScopeRequest = {
  __typename?: 'treatment_ActivateDiagnosesInScopeRequest';
  scopeId?: Maybe<Scalars['String']>;
  scopeType?: Maybe<Treatment_DiagnosisScopeType>;
};

export type Treatment_ActivateDiagnosesInScopeResponse = {
  __typename?: 'treatment_ActivateDiagnosesInScopeResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateDiagnosesRequest = {
  __typename?: 'treatment_ActivateDiagnosesRequest';
  /**
   * optional: if set, will put the given categoryAssignment into all of the diagnoses in the context (including already active ones) if not yet there
   *  and no "stronger" assignment for the same scope exists.
   */
  categoryAssignment?: Maybe<Treatment_DiagnosisCategoryAssignmentMsg>;
  /**
   * optional: only relevant if categoryAssignment is set. If set, only sets the categoryAssignment for diagnoses that
   *  have any assignment matching any of the categoryAssignmentRequirementsAny. Required for surgery completion logic.
   */
  categoryAssignmentRequirementsAny?: Maybe<Array<Maybe<Treatment_DiagnosisCategoryAssignmentMsg>>>;
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateDiagnosesResponse = {
  __typename?: 'treatment_ActivateDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ActivateDiagnosisVersionRequest = {
  __typename?: 'treatment_ActivateDiagnosisVersionRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateDiagnosisVersionResponse = {
  __typename?: 'treatment_ActivateDiagnosisVersionResponse';
  /** the revision that was deactivated as a result if that exists */
  deactivatedDiagnosisRevision?: Maybe<Treatment_DiagnosisMsg>;
  /** the activated Diagnosis */
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_ActivateFluidFlowSystemVersionRequest = {
  __typename?: 'treatment_ActivateFluidFlowSystemVersionRequest';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateFluidFlowSystemVersionResponse = {
  __typename?: 'treatment_ActivateFluidFlowSystemVersionResponse';
  /** the revision that was deactivated as a result if that exists */
  deactivatedFluidFlowSystemRevision?: Maybe<Treatment_FluidFlowSystemMsg>;
  /** the activated FluidFlowSystem */
  fluidFlowSystem?: Maybe<Treatment_FluidFlowSystemMsg>;
};

export type Treatment_ActivateFluidFlowVersionRequest = {
  __typename?: 'treatment_ActivateFluidFlowVersionRequest';
  fluidFlowId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateFluidFlowVersionResponse = {
  __typename?: 'treatment_ActivateFluidFlowVersionResponse';
  /** the revision that was deactivated as a result if that exists */
  deactivatedFluidFlowRevision?: Maybe<Treatment_FluidFlowMsg>;
  /** the activated FluidFlow */
  fluidFlow?: Maybe<Treatment_FluidFlowMsg>;
};

export type Treatment_ActivateSymptomConfigurationVersionRequest = {
  __typename?: 'treatment_ActivateSymptomConfigurationVersionRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateSymptomConfigurationVersionResponse = {
  __typename?: 'treatment_ActivateSymptomConfigurationVersionResponse';
  /** the revision that was deactivated as a result if that exists */
  deactivatedSymptomConfigurationRevision?: Maybe<Treatment_SymptomConfigurationMsg>;
  /** the activated SymptomConfiguration */
  symptomConfiguration?: Maybe<Treatment_SymptomConfigurationMsg>;
};

export type Treatment_ActivateTherapyCardRevisionRequest = {
  __typename?: 'treatment_ActivateTherapyCardRevisionRequest';
  therapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateTherapyCardRevisionResponse = {
  __typename?: 'treatment_ActivateTherapyCardRevisionResponse';
  deactivatedTherapyCardRevision?: Maybe<Treatment_TherapyCardMsg>;
  therapyCard?: Maybe<Treatment_TherapyCardMsg>;
};

export type Treatment_ActivateWoundVersionRequest = {
  __typename?: 'treatment_ActivateWoundVersionRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_ActivateWoundVersionResponse = {
  __typename?: 'treatment_ActivateWoundVersionResponse';
  /** the revision that was deactivated as a result if that exists */
  deactivatedWoundRevision?: Maybe<Treatment_WoundMsg>;
  /** the activated Wound */
  wound?: Maybe<Treatment_WoundMsg>;
};

export enum Treatment_ActivityEnum {
  ActivityEnumFlexedArmsAndLegsThatResistExtension = 'ACTIVITY_ENUM_FLEXED_ARMS_AND_LEGS_THAT_RESIST_EXTENSION',
  ActivityEnumNone = 'ACTIVITY_ENUM_NONE',
  /** in specification:  DE: schlaff , EN: none */
  ActivityEnumNoActivity = 'ACTIVITY_ENUM_NO_ACTIVITY',
  ActivityEnumSomeFlexion = 'ACTIVITY_ENUM_SOME_FLEXION'
}

export type Treatment_ActivityEverydayLifeBlock = {
  __typename?: 'treatment_ActivityEverydayLifeBlock';
  jobActivityLevel?: Maybe<Treatment_JobActivityLevel>;
  physicalActivity?: Maybe<Treatment_PhysicalActivityType>;
  physicalActivityText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_ActivitySatisfactionWithCondition {
  ActivitySatisfactionWithConditionFullSatisfied = 'ACTIVITY_SATISFACTION_WITH_CONDITION_FULL_SATISFIED',
  /** limited condition, must be satisfied */
  ActivitySatisfactionWithConditionLimited = 'ACTIVITY_SATISFACTION_WITH_CONDITION_LIMITED',
  ActivitySatisfactionWithConditionNone = 'ACTIVITY_SATISFACTION_WITH_CONDITION_NONE',
  ActivitySatisfactionWithConditionSeverelyDisabled = 'ACTIVITY_SATISFACTION_WITH_CONDITION_SEVERELY_DISABLED'
}

export enum Treatment_AdditionalDiseases {
  AdditionalDiseasesArterialOcclusiveDisease = 'ADDITIONAL_DISEASES_ARTERIAL_OCCLUSIVE_DISEASE',
  AdditionalDiseasesDeficiencyFeverDiabetes = 'ADDITIONAL_DISEASES_DEFICIENCY_FEVER_DIABETES',
  AdditionalDiseasesMultipleSclerosisObesity = 'ADDITIONAL_DISEASES_MULTIPLE_SCLEROSIS_OBESITY',
  AdditionalDiseasesNone = 'ADDITIONAL_DISEASES_NONE',
  AdditionalDiseasesNotAtAll = 'ADDITIONAL_DISEASES_NOT_AT_ALL'
}

export enum Treatment_AdmissionStatus {
  /** medical (6) */
  AdmissionStatusMedical = 'ADMISSION_STATUS_MEDICAL',
  AdmissionStatusNone = 'ADMISSION_STATUS_NONE',
  /** not planned surgical (8) */
  AdmissionStatusNotPlannedSurgical = 'ADMISSION_STATUS_NOT_PLANNED_SURGICAL',
  /** planned surgical or after other procedure (0) */
  AdmissionStatusPlannedSurgicalOrOtherProcedure = 'ADMISSION_STATUS_PLANNED_SURGICAL_OR_OTHER_PROCEDURE'
}

export enum Treatment_Age {
  AgeLessThan_10 = 'AGE_LESS_THAN_10',
  AgeLessThan_30 = 'AGE_LESS_THAN_30',
  AgeLessThan_60 = 'AGE_LESS_THAN_60',
  AgeMoreThan_60 = 'AGE_MORE_THAN_60',
  AgeNone = 'AGE_NONE'
}

export enum Treatment_AlcoholAmountReference {
  AlcoholAmountReferenceBottle = 'ALCOHOL_AMOUNT_REFERENCE_BOTTLE',
  AlcoholAmountReferenceGlas = 'ALCOHOL_AMOUNT_REFERENCE_GLAS',
  AlcoholAmountReferenceMl = 'ALCOHOL_AMOUNT_REFERENCE_ML',
  AlcoholAmountReferenceNone = 'ALCOHOL_AMOUNT_REFERENCE_NONE'
}

export type Treatment_AlcoholBlock = {
  __typename?: 'treatment_AlcoholBlock';
  alcohols?: Maybe<Array<Maybe<Treatment_AlcoholMsg>>>;
  consumptionPresent?: Maybe<Scalars['Boolean']>;
  currentConsumption?: Maybe<Scalars['Boolean']>;
};

export type Treatment_AlcoholMsg = {
  __typename?: 'treatment_AlcoholMsg';
  amount?: Maybe<Scalars['Int']>;
  amountReference?: Maybe<Treatment_AlcoholAmountReference>;
  currentConsumption?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyReference?: Maybe<Treatment_ConsumptionFrequencyReference>;
  id?: Maybe<Scalars['String']>;
  substance?: Maybe<Treatment_AlcoholType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_AlcoholType {
  AlcoholTypeBeer = 'ALCOHOL_TYPE_BEER',
  AlcoholTypeLiquor = 'ALCOHOL_TYPE_LIQUOR',
  AlcoholTypeNone = 'ALCOHOL_TYPE_NONE',
  AlcoholTypeSparklingWine = 'ALCOHOL_TYPE_SPARKLING_WINE',
  AlcoholTypeSpirit = 'ALCOHOL_TYPE_SPIRIT',
  AlcoholTypeWine = 'ALCOHOL_TYPE_WINE'
}

export type Treatment_AllenTestBlock = {
  __typename?: 'treatment_AllenTestBlock';
  resultLeft?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  resultRight?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  textLeft?: Maybe<Scalars['String']>;
  textRight?: Maybe<Scalars['String']>;
};

export enum Treatment_AllergenCategory {
  AllergenCategoryBiological = 'ALLERGEN_CATEGORY_BIOLOGICAL',
  AllergenCategoryEnvironment = 'ALLERGEN_CATEGORY_ENVIRONMENT',
  AllergenCategoryFood = 'ALLERGEN_CATEGORY_FOOD',
  AllergenCategoryMedication = 'ALLERGEN_CATEGORY_MEDICATION',
  AllergenCategoryNone = 'ALLERGEN_CATEGORY_NONE'
}

export type Treatment_AllergenMsg = {
  __typename?: 'treatment_AllergenMsg';
  externalIds?: Maybe<Array<Maybe<Treatment_ExternalAllergenIdMsg>>>;
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Treatment_AllergiesAndIntolerancesBlock = {
  __typename?: 'treatment_AllergiesAndIntolerancesBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_AllergyActivation {
  /** Statuses below not in use yet */
  AllergyActivationActive = 'ALLERGY_ACTIVATION_ACTIVE',
  AllergyActivationNone = 'ALLERGY_ACTIVATION_NONE',
  /**
   * If a allergy has been created in a treatment that is still unfinished, this is set.
   *  In that case, it will not be shown outside the treatment
   *  Once that treatment is finished, the allergy will be set to ACTIVE.
   */
  AllergyActivationToBeActivated = 'ALLERGY_ACTIVATION_TO_BE_ACTIVATED'
}

export type Treatment_AllergyAndIntoleranceMsg = {
  __typename?: 'treatment_AllergyAndIntoleranceMsg';
  activationStatus?: Maybe<Treatment_AllergyActivation>;
  allergen?: Maybe<Treatment_AllergenMsg>;
  createdInTreatmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intakeRouteIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  lastAppearance?: Maybe<VeiosDateTimeMsg>;
  notes?: Maybe<Scalars['String']>;
  onset?: Maybe<VeiosTimeFrameMsg>;
  patientId?: Maybe<Scalars['String']>;
  reactionSeverity?: Maybe<Treatment_ReactionSeverity>;
  reactionStatus?: Maybe<Treatment_ReactionStatus>;
  /** TODO: Part of allergy dataset? */
  reactionType?: Maybe<Treatment_ReactionType>;
  recurrenceRisk?: Maybe<Treatment_RecurrenceRisk>;
  registeringUserId?: Maybe<Scalars['String']>;
  symptoms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  timestamps?: Maybe<TimeMsg>;
  verification?: Maybe<Treatment_AllergyVerification>;
};

export type Treatment_AllergyList = {
  __typename?: 'treatment_AllergyList';
  allergies?: Maybe<Array<Maybe<Treatment_AllergyAndIntoleranceMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export enum Treatment_AllergyVerification {
  AllergyVerificationConfirmed = 'ALLERGY_VERIFICATION_CONFIRMED',
  AllergyVerificationNone = 'ALLERGY_VERIFICATION_NONE',
  AllergyVerificationRefuted = 'ALLERGY_VERIFICATION_REFUTED',
  AllergyVerificationUnconfirmed = 'ALLERGY_VERIFICATION_UNCONFIRMED'
}

/** Amyotrophic Lateral Sclerosis Functional Rating Scale (ALSFRS-R-SE) */
export type Treatment_AlsfrsBlock = {
  __typename?: 'treatment_AlsfrsBlock';
  climbingStairs?: Maybe<Treatment_ClimbingStairs>;
  cuttingFood?: Maybe<Treatment_CuttingFood>;
  dressing?: Maybe<Treatment_Dressing>;
  handlingFeedingTube?: Maybe<Treatment_HandlingFeedingTube>;
  handwriting?: Maybe<Treatment_Handwriting>;
  mechanicalVentilation?: Maybe<Treatment_MechanicalVentilation>;
  respiratorySleepDisturbance?: Maybe<Treatment_RespiratorySleepDisturbance>;
  salivation?: Maybe<Treatment_Salivation>;
  score?: Maybe<Scalars['Int']>;
  shortnessOfBreath?: Maybe<Treatment_ShortnessOfBreath>;
  speech?: Maybe<Treatment_Speech>;
  swallowing?: Maybe<Treatment_Swallowing>;
  turningOverInBed?: Maybe<Treatment_TurningOverInBed>;
  walking?: Maybe<Treatment_Walking>;
};

export enum Treatment_Ambulation {
  AmbulationNone = 'AMBULATION_NONE',
  AmbulationWalkingNoWalking = 'AMBULATION_WALKING_NO_WALKING',
  AmbulationWalkingWithoutVertigo = 'AMBULATION_WALKING_WITHOUT_VERTIGO',
  AmbulationWalkingWithAssistance = 'AMBULATION_WALKING_WITH_ASSISTANCE'
}

export type Treatment_AnalRegionInspectionBlock = {
  __typename?: 'treatment_AnalRegionInspectionBlock';
  discoveredAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  hemorrhoidsDegree?: Maybe<Treatment_HemorrhoidsDegree>;
  hemorrhoidsPresent?: Maybe<Scalars['Boolean']>;
  inspection?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_AnamnesisBlockContentMsg = {
  __typename?: 'treatment_AnamnesisBlockContentMsg';
  activityEverydayLife?: Maybe<Treatment_ActivityEverydayLifeBlock>;
  alcohol?: Maybe<Treatment_AlcoholBlock>;
  allergiesAndIntolerances?: Maybe<Treatment_AllergiesAndIntolerancesBlock>;
  ankleBrachialIndex?: Maybe<Treatment_AnkleBrachialIndexBlock>;
  apfelRisk?: Maybe<Treatment_ApfelRiskBlock>;
  /** Pediatric scores */
  apgarScore?: Maybe<Treatment_ApgarScoreBlock>;
  ariscat?: Maybe<Treatment_AriscatBlock>;
  /** Anaesthesiology */
  asaClassification?: Maybe<Treatment_AsaClassificationBlock>;
  aspirationRisk?: Maybe<Treatment_AspirationRiskBlock>;
  /** Performance in activities of daily living */
  barthelIndex?: Maybe<Treatment_BarthelIndexBlock>;
  bdiIi?: Maybe<Treatment_BdiIiBlock>;
  biensteinBreathScale?: Maybe<Treatment_BiensteinBreathScaleBlock>;
  bloodPressureAndPulse?: Maybe<Treatment_BloodPressureAndPulseAnamnesticBlock>;
  /** Neurology */
  bodsScore?: Maybe<Treatment_BodsScoreBlock>;
  bodyMeasurements?: Maybe<Treatment_BodyMeasurementsBlock>;
  bradenQScale?: Maybe<Treatment_BradenQScaleBlock>;
  /** Wounds */
  bradenScale?: Maybe<Treatment_BradenScaleBlock>;
  bradenScaleBass?: Maybe<Treatment_BradenScaleBassBlock>;
  cam?: Maybe<Treatment_CamBlock>;
  camIcu?: Maybe<Treatment_CamIcuBlock>;
  cardiacArrhythmia?: Maybe<Treatment_CardiacArrhythmiaBlock>;
  cardiacInsufficiency?: Maybe<Treatment_CardiacInsufficiencyBlock>;
  /** Cardiology */
  cha2Ds2Vasc?: Maybe<Treatment_Cha2Ds2VascBlock>;
  /** Gastroenterology */
  childPugh?: Maybe<Treatment_ChildPughBlock>;
  /** Sugery */
  clavienDindo?: Maybe<Treatment_ClavienDindoBlock>;
  clockTest?: Maybe<Treatment_ClockTestBlock>;
  constantShoulder?: Maybe<Treatment_ConstantShoulderBlock>;
  contraceptives?: Maybe<Treatment_ContraceptivesBlock>;
  cough?: Maybe<Treatment_CoughBlock>;
  /** Pneumology scores */
  crb65Score?: Maybe<Treatment_Crb65ScoreBlock>;
  currentPregnancy?: Maybe<Treatment_CurrentPregnancyBlock>;
  cycle?: Maybe<Treatment_CycleBlock>;
  cycleDisorders?: Maybe<Treatment_CycleDisordersBlock>;
  deliriumDetection?: Maybe<Treatment_DeliriumDetectionBlock>;
  demTect?: Maybe<Treatment_DemTectBlock>;
  dermatologyLifeQualityIndex?: Maybe<Treatment_DermatologyLifeQualityIndexBlock>;
  dic?: Maybe<Treatment_DicBlock>;
  diseasesOfFamilyMembers?: Maybe<Treatment_DiseasesOfFamilyMembersBlock>;
  dos?: Maybe<Treatment_DosBlock>;
  dyspnea?: Maybe<Treatment_DyspneaAnamnesticBlock>;
  earlyRehabilitationBarthelIndex?: Maybe<Treatment_EarlyRehabilitationBarthelIndexBlock>;
  eclam?: Maybe<Treatment_EclamBlock>;
  /** Oncology */
  ecogStatus?: Maybe<Treatment_EcogStatusBlock>;
  edemata?: Maybe<Treatment_EdemataBlock>;
  educationalLevel?: Maybe<Treatment_EducationalLevelBlock>;
  /** Orthopedics */
  efas?: Maybe<Treatment_EfasBlock>;
  epworthSleepinessScale?: Maybe<Treatment_EpworthSleepinessScaleBlock>;
  erection?: Maybe<Treatment_ErectionBlock>;
  extendedBarthelIndex?: Maybe<Treatment_ExtendedBarthelIndexBlock>;
  familyStatus?: Maybe<Treatment_FamilyStatusBlock>;
  fatigueAssessmentScale?: Maybe<Treatment_FatigueAssessmentScaleBlock>;
  fever?: Maybe<Treatment_FeverBlock>;
  fim?: Maybe<Treatment_FimBlock>;
  friedrichWeickmannScale?: Maybe<Treatment_FriedrichWeickmannScaleBlock>;
  ftnd?: Maybe<Treatment_FtndBlock>;
  gastrointestinalDysfunction?: Maybe<Treatment_GastrointestinalDysfunctionBlock>;
  /** Geriatrics */
  geriatricDepressionScale?: Maybe<Treatment_GeriatricDepressionScaleBlock>;
  glasgowComaScale?: Maybe<Treatment_GlasgowComaScaleScoreBlock>;
  /** Psychiatrics */
  globalAssessmentOfFunctioning?: Maybe<Treatment_GlobalAssessmentOfFunctioningBlock>;
  goalAttainmentScaleBlock?: Maybe<Treatment_GoalAttainmentScaleBlock>;
  hasBled?: Maybe<Treatment_HasBledBlock>;
  hendrich?: Maybe<Treatment_HendrichBlock>;
  hendrichBass?: Maybe<Treatment_HendrichBassBlock>;
  hereditaryKidneyTumor?: Maybe<Treatment_HereditaryKidneyTumorBlock>;
  iadl?: Maybe<Treatment_IadlBlock>;
  icdsc?: Maybe<Treatment_IcdscBlock>;
  /** Urology */
  incontinence?: Maybe<Treatment_IncontinenceBlock>;
  ipss?: Maybe<Treatment_IpssBlock>;
  isarScreening?: Maybe<Treatment_IsarScreeningBlock>;
  itch?: Maybe<Treatment_ItchBlock>;
  karnofskyIndex?: Maybe<Treatment_KarnofskyIndexBlock>;
  kellgrenLawrence?: Maybe<Treatment_KellgrenLawrenceBlock>;
  lachsGeriatricScreening?: Maybe<Treatment_LachsGeriatricScreeningBlock>;
  lightSensitivity?: Maybe<Treatment_LightSensitivityBlock>;
  livingSituation?: Maybe<Treatment_LivingSituationBlock>;
  medication?: Maybe<Treatment_MedicationBlock>;
  meldAndMeldNa?: Maybe<Treatment_MeldAndMeldNaBlock>;
  menarcheMenopause?: Maybe<Treatment_MenarcheMenopauseBlock>;
  metabolicEquivalentOfTaskBlock?: Maybe<Treatment_MetabolicEquivalentOfTaskBlock>;
  micturitionDisorder?: Maybe<Treatment_MicturitionDisorderBlock>;
  miniMentalStateExamination?: Maybe<Treatment_MiniMentalStateExaminationBlock>;
  miniNutritionalAssessmentLongVersion?: Maybe<Treatment_MiniNutritionalAssessmentLongVersionBlock>;
  miniNutritionalAssessmentShortVersion?: Maybe<Treatment_MiniNutritionalAssessmentShortVersionBlock>;
  mocaTest?: Maybe<Treatment_MocaTestBlock>;
  modifiedKatzAdl?: Maybe<Treatment_ModifiedKatzAdlBlock>;
  modifiedNortonScale?: Maybe<Treatment_ModifiedNortonScaleBlock>;
  mrs?: Maybe<Treatment_MrsBlock>;
  nicotine?: Maybe<Treatment_NicotineBlock>;
  nightSweats?: Maybe<Treatment_NightSweatsBlock>;
  nikolausSocialQuestionnaire?: Maybe<Treatment_NikolausSocialQuestionnaireBlock>;
  nonInvasiveVentilation?: Maybe<Treatment_NonInvasiveVentilationBlock>;
  nuDesc?: Maybe<Treatment_NuDescBlock>;
  /** Symptoms */
  numericPainRatingScale?: Maybe<Treatment_NumericPainRatingScaleBlock>;
  nutritionalDisturbance?: Maybe<Treatment_NutritionalDisturbanceBlock>;
  nutritionalRiskScreening?: Maybe<Treatment_NutritionalRiskScreeningBlock>;
  nyha?: Maybe<Treatment_NyhaBlock>;
  occupation?: Maybe<Treatment_OccupationsBlock>;
  otherDrugsAndAddictiveSubstances?: Maybe<Treatment_OtherDrugsAndAddictiveSubstancesBlock>;
  otherRiskFactors?: Maybe<Treatment_OtherRiskFactorsBlock>;
  oxygenTherapy?: Maybe<Treatment_OxygenTherapyBlock>;
  /** Preanesthetic Assessment */
  pacemaker?: Maybe<Treatment_PacemakerBlock>;
  padss?: Maybe<Treatment_PadssBlock>;
  pain?: Maybe<Treatment_PainBlock>;
  /** Dermatology */
  pasi?: Maybe<Treatment_PasiBlock>;
  pastAirwayManagement?: Maybe<Treatment_PastAirwayManagementBlock>;
  patientHealthQuestionnaire?: Maybe<Treatment_PatientHealthQuestionnaireBlock>;
  pediatricGlasgowComaScale?: Maybe<Treatment_PediatricGlasgowComaScaleScoreBlock>;
  preExistingConditions?: Maybe<Treatment_PreExistingConditionsBlock>;
  previousPregnancies?: Maybe<Treatment_PreviousPregnanciesBlock>;
  previousSurgeries?: Maybe<Treatment_PreviousSurgeriesBlock>;
  qsofa?: Maybe<Treatment_QsofaBlock>;
  recentTravels?: Maybe<Treatment_RecentTravelsBlock>;
  revisedCardiacRiskIndex?: Maybe<Treatment_RevisedCardiacRiskIndexBlock>;
  /** Intensive Care Medicine */
  saps?: Maybe<Treatment_SapsBlock>;
  sexLife?: Maybe<Treatment_SexLifeBlock>;
  sigstad?: Maybe<Treatment_SigstadBlock>;
  skinChange?: Maybe<Treatment_SkinChangeBlock>;
  /** Rheumatology */
  sledai2K?: Maybe<Treatment_Sledai2KBlock>;
  sleepDisorder?: Maybe<Treatment_SleepDisorderBlock>;
  /** Emergency Medicine */
  sofa?: Maybe<Treatment_SofaBlock>;
  sport?: Maybe<Treatment_SportsBlock>;
  staffelsteinHip?: Maybe<Treatment_StaffelsteinHipBlock>;
  staffelsteinKnee?: Maybe<Treatment_StaffelsteinKneeBlock>;
  stdRisk?: Maybe<Treatment_StdRiskBlock>;
  stopBangRisk?: Maybe<Treatment_StopBangRiskBlock>;
  temperature?: Maybe<Treatment_TemperatureAnamnesticBlock>;
  timedUpAndGoTest?: Maybe<Treatment_TimedUpAndGoTestBlock>;
  tinettiMobilityTest?: Maybe<Treatment_TinettiMobilityTestBlock>;
  tiss?: Maybe<Treatment_TissBlock>;
  tissChildren?: Maybe<Treatment_TissChildrenBlock>;
  tracheostomy?: Maybe<Treatment_TracheostomyBlock>;
  updrs?: Maybe<Treatment_UpdrsBlock>;
  vaccinations?: Maybe<Treatment_VaccinationsBlock>;
  verbalRatingScale?: Maybe<Treatment_VerbalRatingScaleBlock>;
  vertigo?: Maybe<Treatment_VertigoBlock>;
  visualAnalogueScale?: Maybe<Treatment_VisualAnalogueScaleBlock>;
  wagnerArmstrongClassification?: Maybe<Treatment_WagnerArmstrongClassificationBlock>;
  warScore?: Maybe<Treatment_WarScoreBlock>;
  wellsI?: Maybe<Treatment_WellsIBlock>;
  wellsII?: Maybe<Treatment_WellsIiBlock>;
};

export type Treatment_AnamnesisBlockContentScoreMsg = {
  __typename?: 'treatment_AnamnesisBlockContentScoreMsg';
  blockMetadata?: Maybe<Treatment_AnamnesisBlockMetadataMsg>;
  scores?: Maybe<Array<Maybe<Treatment_ScoreBlockMsg>>>;
};

export enum Treatment_AnamnesisBlockLocation {
  AnamnesisBlockLocationNone = 'ANAMNESIS_BLOCK_LOCATION_NONE',
  AnamnesisBlockLocationPatientChart = 'ANAMNESIS_BLOCK_LOCATION_PATIENT_CHART',
  AnamnesisBlockLocationTreatment = 'ANAMNESIS_BLOCK_LOCATION_TREATMENT'
}

export type Treatment_AnamnesisBlockMetadataMsg = {
  __typename?: 'treatment_AnamnesisBlockMetadataMsg';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  problemSpecific?: Maybe<Scalars['Boolean']>;
  singleton?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMetadataTag>>>;
  type?: Maybe<Treatment_AnamnesisBlockType>;
};

export enum Treatment_AnamnesisBlockMetadataTag {
  AnamnesisBlockMetadataTagNone = 'ANAMNESIS_BLOCK_METADATA_TAG_NONE',
  AnamnesisBlockMetadataTagScore = 'ANAMNESIS_BLOCK_METADATA_TAG_SCORE'
}

export type Treatment_AnamnesisBlockMsg = {
  __typename?: 'treatment_AnamnesisBlockMsg';
  blockMetadata?: Maybe<Treatment_AnamnesisBlockMetadataMsg>;
  cardNumber?: Maybe<Scalars['Int']>;
  content?: Maybe<Treatment_AnamnesisBlockContentMsg>;
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_AnamnesisBlockLocation>;
  /** Origin of block */
  origin?: Maybe<Treatment_AnamnesisBlockOrigin>;
  /** Id of anamnesis that owns the block */
  owningAnamnesisId?: Maybe<Scalars['String']>;
  /** If Block is part of SpecialCard then owningCardId gives parent */
  owningCardId?: Maybe<Scalars['String']>;
  owningFormId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
  timestamps?: Maybe<TimeMsg>;
  /** Only relevant for static blocks. Shows that doctor has checked this block's content in the current treatment. */
  validation?: Maybe<Validation_ValidationMsg>;
};

export enum Treatment_AnamnesisBlockOrigin {
  /** Originates in a treatment anamensis */
  AnamnesisBlockOriginAnamnesis = 'ANAMNESIS_BLOCK_ORIGIN_ANAMNESIS',
  /** Originates in a patient survey (e.g. is non-verified patient information) */
  AnamnesisBlockOriginForm = 'ANAMNESIS_BLOCK_ORIGIN_FORM',
  AnamnesisBlockOriginNone = 'ANAMNESIS_BLOCK_ORIGIN_NONE'
}

export enum Treatment_AnamnesisBlockType {
  /** Not a real block; used to allow displaying data from outside the anamnesis (e.g., visit information) */
  AnamnesisBlockTypeDummy = 'ANAMNESIS_BLOCK_TYPE_DUMMY',
  /** Data is entered per treatment */
  AnamnesisBlockTypeDynamic = 'ANAMNESIS_BLOCK_TYPE_DYNAMIC',
  AnamnesisBlockTypeNone = 'ANAMNESIS_BLOCK_TYPE_NONE',
  /** Data is preserved over treatments */
  AnamnesisBlockTypeStatic = 'ANAMNESIS_BLOCK_TYPE_STATIC'
}

export enum Treatment_AnamnesisCardLayoutType {
  AnamnesisCardLayoutOneRow = 'ANAMNESIS_CARD_LAYOUT_ONE_ROW',
  AnamnesisCardLayoutTwoRow = 'ANAMNESIS_CARD_LAYOUT_TWO_ROW',
  AnamnesisCardLayoutUndefined = 'ANAMNESIS_CARD_LAYOUT_UNDEFINED'
}

export type Treatment_AnamnesisCardMetadataList = {
  __typename?: 'treatment_AnamnesisCardMetadataList';
  cardsMetadata?: Maybe<Array<Maybe<Treatment_AnamnesisCardMetadataMsg>>>;
};

export type Treatment_AnamnesisCardMetadataMsg = {
  __typename?: 'treatment_AnamnesisCardMetadataMsg';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  problemSpecificType?: Maybe<Treatment_ProblemSpecificAnamnesisType>;
  singleton?: Maybe<Scalars['Boolean']>;
};

export type Treatment_AnamnesisCardMsg = {
  __typename?: 'treatment_AnamnesisCardMsg';
  anamnesticProgress?: Maybe<Treatment_AnamnesticProgressMsg>;
  anesthesiaBackground?: Maybe<Treatment_AnesthesiaBackgroundMsg>;
  blocks?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Treatment_AnamnesisCardMetadataMsg>;
  owningAnamnesisId?: Maybe<Scalars['String']>;
  reasonForAdmission?: Maybe<Treatment_ReasonForAdmissionMsg>;
  reasonForCareAdmission?: Maybe<Treatment_ReasonForCareAdmissionMsg>;
  reasonForPresentation?: Maybe<Treatment_ReasonForPresentationMsg>;
  surgeryPreparation?: Maybe<Treatment_SurgeryPreparationMsg>;
  timestamps?: Maybe<TimeMsg>;
};

export type Treatment_AnamnesisList = {
  __typename?: 'treatment_AnamnesisList';
  anamnesisList?: Maybe<Array<Maybe<Treatment_AnamnesisMsg>>>;
};

export enum Treatment_AnamnesisLocation {
  AnamnesisLocationNone = 'ANAMNESIS_LOCATION_NONE',
  AnamnesisLocationPatientChart = 'ANAMNESIS_LOCATION_PATIENT_CHART',
  AnamnesisLocationTreatment = 'ANAMNESIS_LOCATION_TREATMENT'
}

export type Treatment_AnamnesisMsg = {
  __typename?: 'treatment_AnamnesisMsg';
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_AnamnesisLocation>;
  sections?: Maybe<Array<Maybe<Treatment_AnamnesisSectionMsg>>>;
  timestamps?: Maybe<TimeMsg>;
};

export type Treatment_AnamnesisSectionMsg = {
  __typename?: 'treatment_AnamnesisSectionMsg';
  cards?: Maybe<Array<Maybe<Treatment_AnamnesisCardMsg>>>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Treatment_SectionMetadataMsg>;
  owningAnamnesisId?: Maybe<Scalars['String']>;
  shortcuts?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
  timestamps?: Maybe<TimeMsg>;
};

export type Treatment_AnamnesisTemplateMsg = {
  __typename?: 'treatment_AnamnesisTemplateMsg';
  id?: Maybe<Scalars['String']>;
  ownerOrganizationalUnitId?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Treatment_SectionTemplateMsg>>>;
  shortcuts?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: Maybe<Treatment_TreatmentType>;
  version?: Maybe<Scalars['Int']>;
};

/** Inpatient equivalent to ReasonForPresentationMsg */
export type Treatment_AnamnesticProgressMsg = {
  __typename?: 'treatment_AnamnesticProgressMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** only used to document non-present symptoms */
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
};

export type Treatment_AnesthesiaBackgroundMsg = {
  __typename?: 'treatment_AnesthesiaBackgroundMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pastAnesthesiaComplications?: Maybe<Treatment_PastAnesthesiaComplicationsMsg>;
  previousHistoryHtml?: Maybe<Scalars['String']>;
  symptomOccurrences?: Maybe<Array<Maybe<Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
};

export type Treatment_AnesthesiologicalRiskFactorMsg = {
  __typename?: 'treatment_AnesthesiologicalRiskFactorMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  riskFactor?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_AnkleBrachialIndexBlock = {
  __typename?: 'treatment_AnkleBrachialIndexBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  /** unit: mmHg */
  systolicBloodPressureOfAnkle?: Maybe<Scalars['Int']>;
  /** unit: mmHg */
  systolicBloodPressureOfArm?: Maybe<Scalars['Int']>;
};

export type Treatment_ApfelRiskBlock = {
  __typename?: 'treatment_ApfelRiskBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  female?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  motionSicknessHistory?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  nonSmoker?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** <yes (1) / no (0)> */
  useOfPostoperativeOpioids?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ApgarScoreBlock = {
  __typename?: 'treatment_ApgarScoreBlock';
  activity?: Maybe<Treatment_ActivityEnum>;
  appearance?: Maybe<Treatment_AppearanceEnum>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  grimace?: Maybe<Treatment_GrimaceEnum>;
  pulse?: Maybe<Treatment_PulseEnum>;
  respiration?: Maybe<Treatment_RespirationEnum>;
  score?: Maybe<Scalars['Int']>;
};

export type Treatment_ApicalImpulseBlock = {
  __typename?: 'treatment_ApicalImpulseBlock';
  apicalImpulse?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_AppearanceBlock = {
  __typename?: 'treatment_AppearanceBlock';
  appearance?: Maybe<Treatment_AppearanceType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_AppearanceEnum {
  AppearanceEnumBlueAtExtremitiesBodyPink = 'APPEARANCE_ENUM_BLUE_AT_EXTREMITIES_BODY_PINK',
  AppearanceEnumBlueOrPaleAllOver = 'APPEARANCE_ENUM_BLUE_OR_PALE_ALL_OVER',
  AppearanceEnumNone = 'APPEARANCE_ENUM_NONE',
  AppearanceEnumNoCyanosisBodyAndExtremitiesPink = 'APPEARANCE_ENUM_NO_CYANOSIS_BODY_AND_EXTREMITIES_PINK'
}

export enum Treatment_AppearanceType {
  AppearanceNeglected = 'APPEARANCE_NEGLECTED',
  AppearanceNone = 'APPEARANCE_NONE',
  AppearanceReducedWellKept = 'APPEARANCE_REDUCED_WELL_KEPT',
  AppearanceWellKept = 'APPEARANCE_WELL_KEPT'
}

export type Treatment_AppendicitisSignsBlock = {
  __typename?: 'treatment_AppendicitisSignsBlock';
  blumbergSignPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  lanzSignPresent?: Maybe<Scalars['Boolean']>;
  mcBurneySignPresent?: Maybe<Scalars['Boolean']>;
  obturatorPainPresent?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  psoasPainPresent?: Maybe<Scalars['Boolean']>;
  rovsingSignPresent?: Maybe<Scalars['Boolean']>;
  sitkowskiSignPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ApplyHistoricAnamnesisBlockRequest = {
  __typename?: 'treatment_ApplyHistoricAnamnesisBlockRequest';
  currentAnamnesisBlockId?: Maybe<Scalars['String']>;
  historicAnamnesisBlockId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricAnamnesisBlockResponse = {
  __typename?: 'treatment_ApplyHistoricAnamnesisBlockResponse';
  anamnesisBlock?: Maybe<Treatment_AnamnesisBlockMsg>;
};

export type Treatment_ApplyHistoricAnamnesisRequest = {
  __typename?: 'treatment_ApplyHistoricAnamnesisRequest';
  currentAnamnesisId?: Maybe<Scalars['String']>;
  historicAnamnesisId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricAnamnesisResponse = {
  __typename?: 'treatment_ApplyHistoricAnamnesisResponse';
  anamnesis?: Maybe<Treatment_AnamnesisMsg>;
};

export type Treatment_ApplyHistoricPhysicalBlockRequest = {
  __typename?: 'treatment_ApplyHistoricPhysicalBlockRequest';
  currentPhysicalBlockId?: Maybe<Scalars['String']>;
  historicPhysicalBlockId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricPhysicalBlockResponse = {
  __typename?: 'treatment_ApplyHistoricPhysicalBlockResponse';
  physicalBlock?: Maybe<Treatment_PhysicalBlockMsg>;
};

export type Treatment_ApplyHistoricPhysicalExaminationRequest = {
  __typename?: 'treatment_ApplyHistoricPhysicalExaminationRequest';
  currentPhysicalExaminationId?: Maybe<Scalars['String']>;
  historicPhysicalExaminationId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricPhysicalExaminationResponse = {
  __typename?: 'treatment_ApplyHistoricPhysicalExaminationResponse';
  physicalExamination?: Maybe<Treatment_PhysicalExaminationMsg>;
};

export type Treatment_ApplyHistoricTherapyCardRequest = {
  __typename?: 'treatment_ApplyHistoricTherapyCardRequest';
  currentTherapyCardId?: Maybe<Scalars['String']>;
  historicTherapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricTherapyCardResponse = {
  __typename?: 'treatment_ApplyHistoricTherapyCardResponse';
  therapyCard?: Maybe<Treatment_TherapyCardMsg>;
};

export type Treatment_ApplyHistoricTherapyRequest = {
  __typename?: 'treatment_ApplyHistoricTherapyRequest';
  currentTherapyId?: Maybe<Scalars['String']>;
  historicTherapyId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyHistoricTherapyResponse = {
  __typename?: 'treatment_ApplyHistoricTherapyResponse';
  therapy?: Maybe<Treatment_TherapyMsg>;
};

export type Treatment_ApplyPhysicalPresetRequest = {
  __typename?: 'treatment_ApplyPhysicalPresetRequest';
  presetId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ApplyPhysicalPresetResponse = {
  __typename?: 'treatment_ApplyPhysicalPresetResponse';
  appliedBlocks?: Maybe<Array<Maybe<Treatment_PhysicalBlockMsg>>>;
};

export enum Treatment_AriscatAgeSelection {
  /** 51-80 (3) */
  AriscatAgeSelectionBetween_51And_80 = 'ARISCAT_AGE_SELECTION_BETWEEN_51_AND_80',
  /** >80 (16) */
  AriscatAgeSelectionGreaterThan_80 = 'ARISCAT_AGE_SELECTION_GREATER_THAN_80',
  /** ≤50 (0) */
  AriscatAgeSelectionLessThanOrEqual_50 = 'ARISCAT_AGE_SELECTION_LESS_THAN_OR_EQUAL_50',
  AriscatAgeSelectionNone = 'ARISCAT_AGE_SELECTION_NONE'
}

export type Treatment_AriscatBlock = {
  __typename?: 'treatment_AriscatBlock';
  ariscatAgeSelection?: Maybe<Treatment_AriscatAgeSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Emergency procedure: <yes (8) / no (0)> */
  emergencyProcedure?: Maybe<Scalars['Boolean']>;
  /** Preoperative SpO2 (%) */
  preoperartiveSpO2?: Maybe<Treatment_PreoperartiveSpO2>;
  /** Preoperative anemia (≤10 g/dl): <yes (11) / no (0)> */
  preoperativeAnemia?: Maybe<Scalars['Boolean']>;
  /** Respiratory Infections in the last month: <yes (16) / no (0)> */
  respiratoryInfections?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** Duration of surgery (hours) */
  surgeryDuration?: Maybe<Treatment_SurgeryDuration>;
  surgicalIncision?: Maybe<Treatment_SurgicalIncision>;
};

export enum Treatment_Arises {
  ArisesImpossibleWithoutHelp = 'ARISES_IMPOSSIBLE_WITHOUT_HELP',
  ArisesNone = 'ARISES_NONE',
  ArisesPossibleButNeedsArms = 'ARISES_POSSIBLE_BUT_NEEDS_ARMS',
  ArisesPossibleWithoutUsingArms = 'ARISES_POSSIBLE_WITHOUT_USING_ARMS'
}

export enum Treatment_ArrythmiaOnsetType {
  ArrythmiaOnsetTypeNone = 'ARRYTHMIA_ONSET_TYPE_NONE',
  ArrythmiaOnsetTypeSuccessive = 'ARRYTHMIA_ONSET_TYPE_SUCCESSIVE',
  ArrythmiaOnsetTypeSudden = 'ARRYTHMIA_ONSET_TYPE_SUDDEN'
}

export type Treatment_ArteriaMsg = {
  __typename?: 'treatment_ArteriaMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_AsaClassificationBlock = {
  __typename?: 'treatment_AsaClassificationBlock';
  asaClassificationSelection?: Maybe<Treatment_AsaClassificationSelection>;
  completed?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_AsaClassificationSelection {
  AsaClassificationSelectionFive = 'ASA_CLASSIFICATION_SELECTION_FIVE',
  AsaClassificationSelectionFour = 'ASA_CLASSIFICATION_SELECTION_FOUR',
  AsaClassificationSelectionNone = 'ASA_CLASSIFICATION_SELECTION_NONE',
  AsaClassificationSelectionOne = 'ASA_CLASSIFICATION_SELECTION_ONE',
  AsaClassificationSelectionSix = 'ASA_CLASSIFICATION_SELECTION_SIX',
  AsaClassificationSelectionThree = 'ASA_CLASSIFICATION_SELECTION_THREE',
  AsaClassificationSelectionTwo = 'ASA_CLASSIFICATION_SELECTION_TWO'
}

export type Treatment_AscitesBlock = {
  __typename?: 'treatment_AscitesBlock';
  ascitesPresent?: Maybe<Scalars['Boolean']>;
  fluidWavePresent?: Maybe<Scalars['Boolean']>;
  shiftingDullnessPresent?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_AscitesCheck {
  /** absent (1) */
  AscitesCheckAbsent = 'ASCITES_CHECK_ABSENT',
  /** moderate (3) */
  AscitesCheckModerate = 'ASCITES_CHECK_MODERATE',
  AscitesCheckNone = 'ASCITES_CHECK_NONE',
  /** slight (2) */
  AscitesCheckSlight = 'ASCITES_CHECK_SLIGHT'
}

export type Treatment_AspirationRiskBlock = {
  __typename?: 'treatment_AspirationRiskBlock';
  aspirationRiskPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_AssessmentMsg = {
  __typename?: 'treatment_AssessmentMsg';
  /** automatic addition of points based on previous entries */
  assessmentScore?: Maybe<Scalars['Float']>;
  calfCircumference?: Maybe<Treatment_CalfCircumference>;
  /** How much does the patient drink per day?: */
  dailyFluidIntake?: Maybe<Treatment_DailyFluidIntake>;
  /** Eating with or without help: */
  eatingAssistance?: Maybe<Treatment_EatingAssistance>;
  /** Compared with persons of the same age, the patient estimates his health status as follows: */
  estimateHealthStatus?: Maybe<Treatment_EstimateHealthStatus>;
  /** Does the patient eat fruits or vegetables at least twice a day? */
  fruitsOrVegetablesIntake?: Maybe<Scalars['Boolean']>;
  /** Does the patient have pressure ulcers or skin ulcers: < yes (0) / no (1)> */
  hasPressureOrSkinUlcers?: Maybe<Scalars['Boolean']>;
  /** Does the patient live independently at home?: < yes (0) / no (1)> */
  livingIndependentlyAtHome?: Maybe<Scalars['Boolean']>;
  /** How many main meals does the patient eat per day?: */
  mealsPerDay?: Maybe<Treatment_MealsPerDay>;
  /** Protein intake: Does the patient eat: */
  proteinIntakeList?: Maybe<Array<Maybe<Treatment_ProteinIntake>>>;
  /** How does the patient rate his or her nutritional status */
  rateNutritionalStatus?: Maybe<Treatment_RateNutritionalStatus>;
  /** Does the patient take more than 3 prescription medications per day?: < yes (0) / no (1)> */
  takingMoreThanThreeMedicationsPerDay?: Maybe<Scalars['Boolean']>;
  upperArmCircumference?: Maybe<Treatment_UpperArmCircumference>;
};

export enum Treatment_AttemptToRise {
  AttemptToRiseImpossibleWithoutHelp = 'ATTEMPT_TO_RISE_IMPOSSIBLE_WITHOUT_HELP',
  AttemptToRiseNone = 'ATTEMPT_TO_RISE_NONE',
  AttemptToRisePossibleButNeedsMoreThanOneAttempt = 'ATTEMPT_TO_RISE_POSSIBLE_BUT_NEEDS_MORE_THAN_ONE_ATTEMPT',
  AttemptToRisePossibleInOneAttempt = 'ATTEMPT_TO_RISE_POSSIBLE_IN_ONE_ATTEMPT'
}

export enum Treatment_AttentionAndCalculationAbility {
  /** 65 or S (1) */
  AttentionAndCalculationAbility_65OrS = 'ATTENTION_AND_CALCULATION_ABILITY_65_OR_S',
  /** 72 or T (1) */
  AttentionAndCalculationAbility_72OrT = 'ATTENTION_AND_CALCULATION_ABILITY_72_OR_T',
  /** 79 or U (1) */
  AttentionAndCalculationAbility_79OrU = 'ATTENTION_AND_CALCULATION_ABILITY_79_OR_U',
  /** 86 or H (1) */
  AttentionAndCalculationAbility_86OrH = 'ATTENTION_AND_CALCULATION_ABILITY_86_OR_H',
  /** 93 or L (1) */
  AttentionAndCalculationAbility_93OrL = 'ATTENTION_AND_CALCULATION_ABILITY_93_OR_L',
  AttentionAndCalculationAbilityNone = 'ATTENTION_AND_CALCULATION_ABILITY_NONE'
}

export type Treatment_AttentionBlock = {
  __typename?: 'treatment_AttentionBlock';
  abstraction?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  abstractionText?: Maybe<Scalars['String']>;
  attention?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  concentration?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  concentrationText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  neglect?: Maybe<Scalars['Boolean']>;
  neglectDescriptions?: Maybe<Array<Maybe<Treatment_NeglectDescriptionMsg>>>;
  perception?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  perceptionText?: Maybe<Scalars['String']>;
};

export type Treatment_AutoUpdatedAnamnesisBlockInfo = {
  __typename?: 'treatment_AutoUpdatedAnamnesisBlockInfo';
  blockId?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_AutoUpdatedProblemSpecificAnamnesisCardReasonInfo = {
  __typename?: 'treatment_AutoUpdatedProblemSpecificAnamnesisCardReasonInfo';
  reasonInfo?: Maybe<Scalars['String']>;
};

export type Treatment_AxillaryLymphNodesBlock = {
  __typename?: 'treatment_AxillaryLymphNodesBlock';
  abnormalitiesPresent?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: Maybe<Array<Maybe<Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export enum Treatment_Bmi {
  /** 19 to < 21 (1). [19:21) */
  BmiBetween_19InclusiveAnd_21Exclusive = 'BMI_BETWEEN_19_INCLUSIVE_AND_21_EXCLUSIVE',
  /** 21 to < 23 (2). [21:23) */
  BmiBetween_21InclusiveAnd_23Exclusive = 'BMI_BETWEEN_21_INCLUSIVE_AND_23_EXCLUSIVE',
  /** ≥ 23 (3) */
  BmiGreaterThanOrEqual_23 = 'BMI_GREATER_THAN_OR_EQUAL_23',
  /** <19 (0) */
  BmiLessThan_19 = 'BMI_LESS_THAN_19',
  BmiNone = 'BMI_NONE'
}

export type Treatment_BalanceTestMsg = {
  __typename?: 'treatment_BalanceTestMsg';
  arises?: Maybe<Treatment_Arises>;
  attemptToRise?: Maybe<Treatment_AttemptToRise>;
  balanceWithEyesAndFeetClosed?: Maybe<Treatment_BalanceWithEyesAndFeetClosed>;
  immediateStandingBalance?: Maybe<Treatment_ImmediateStandingBalance>;
  nudged?: Maybe<Treatment_Nudged>;
  seatingBalance?: Maybe<Treatment_SeatingBalance>;
  sittingDown?: Maybe<Treatment_SittingDown>;
  standingBalance?: Maybe<Treatment_StandingBalance>;
  turning360Degrees?: Maybe<Treatment_Turning360Degrees>;
};

export enum Treatment_BalanceWithEyesAndFeetClosed {
  BalanceWithEyesAndFeetClosedNone = 'BALANCE_WITH_EYES_AND_FEET_CLOSED_NONE',
  BalanceWithEyesAndFeetClosedSteady = 'BALANCE_WITH_EYES_AND_FEET_CLOSED_STEADY',
  BalanceWithEyesAndFeetClosedUnsteady = 'BALANCE_WITH_EYES_AND_FEET_CLOSED_UNSTEADY'
}

export type Treatment_BarthelIndexBlock = {
  __typename?: 'treatment_BarthelIndexBlock';
  barthelIndexFields?: Maybe<Treatment_BarthelIndexFieldsMsg>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_BarthelIndexDressing {
  BarthelIndexDressingIndependent = 'BARTHEL_INDEX_DRESSING_INDEPENDENT',
  BarthelIndexDressingNeedsHelp = 'BARTHEL_INDEX_DRESSING_NEEDS_HELP',
  BarthelIndexDressingNone = 'BARTHEL_INDEX_DRESSING_NONE',
  BarthelIndexDressingUnable = 'BARTHEL_INDEX_DRESSING_UNABLE'
}

export type Treatment_BarthelIndexFieldsMsg = {
  __typename?: 'treatment_BarthelIndexFieldsMsg';
  barthelIndexDressing?: Maybe<Treatment_BarthelIndexDressing>;
  bathing?: Maybe<Treatment_Bathing>;
  bladderControl?: Maybe<Treatment_BladderControl>;
  bowelControl?: Maybe<Treatment_BowelControl>;
  feeding?: Maybe<Treatment_Feeding>;
  grooming?: Maybe<Treatment_Grooming>;
  mobilityOnLevelsSurface?: Maybe<Treatment_MobilityOnLevelsSurface>;
  score?: Maybe<Scalars['Int']>;
  stairs?: Maybe<Treatment_Stairs>;
  toiletUse?: Maybe<Treatment_ToiletUse>;
  transfers?: Maybe<Treatment_Transfers>;
};

export enum Treatment_Bathing {
  BathingIndependent = 'BATHING_INDEPENDENT',
  BathingNone = 'BATHING_NONE',
  BathingUnable = 'BATHING_UNABLE'
}

export enum Treatment_Bathroom {
  BathroomInsideApartmentWheelchairAccessible = 'BATHROOM_INSIDE_APARTMENT_WHEELCHAIR_ACCESSIBLE',
  BathroomNone = 'BATHROOM_NONE',
  BathroomSmallNotWheelchairAccessible = 'BATHROOM_SMALL_NOT_WHEELCHAIR_ACCESSIBLE'
}

export enum Treatment_BbsPain {
  BbsPainMild = 'BBS_PAIN_MILD',
  BbsPainModerateBreathInfluencingPain = 'BBS_PAIN_MODERATE_BREATH_INFLUENCING_PAIN',
  BbsPainNone = 'BBS_PAIN_NONE',
  BbsPainNotAtAll = 'BBS_PAIN_NOT_AT_ALL',
  BbsPainSevereBreathInfluencingPain = 'BBS_PAIN_SEVERE_BREATH_INFLUENCING_PAIN'
}

export enum Treatment_BbsWillingnessToCooperate {
  BbsWillingnessToCooperateContinuousCooperation = 'BBS_WILLINGNESS_TO_COOPERATE_CONTINUOUS_COOPERATION',
  BbsWillingnessToCooperateCooperationAfterRequest = 'BBS_WILLINGNESS_TO_COOPERATE_COOPERATION_AFTER_REQUEST',
  BbsWillingnessToCooperateNone = 'BBS_WILLINGNESS_TO_COOPERATE_NONE',
  BbsWillingnessToCooperateNoCooperation = 'BBS_WILLINGNESS_TO_COOPERATE_NO_COOPERATION',
  BbsWillingnessToCooperateOnlyAfterRequest = 'BBS_WILLINGNESS_TO_COOPERATE_ONLY_AFTER_REQUEST'
}

export type Treatment_BdiIiBlock = {
  __typename?: 'treatment_BdiIiBlock';
  /** <My appetite has not changed (0) / My appetite is a little worse than usual (1) /My appetite is a little bigger than usual (1) /My appetite is much worse than usual (2) /My appetite is much bigger than usual (2) / I have no appetite at all (3) /I have cravings all the time (3)> */
  changesInAppetite?: Maybe<Treatment_ChangesInAppetite>;
  /** <My sleep habits have not changed (0) /I sleep a little more than usual (1) /I sleep a little less than usual (1) /I sleep a lot more than usual (2) /I sleep a lot less than usual (2) /I sleep most of the day (3) /I wake up 1-2 hours earlier than usual and can't get back to sleep (3)> */
  changesInSleepHabits?: Maybe<Treatment_ChangesInSleepHabits>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** <I don't cry more often than I used to (0) /I cry more now than I used to (1) /I cry at the slightest occasion (2) /I would like to cry, but I can't (3)> */
  crying?: Maybe<Treatment_Crying>;
  /** <I can concentrate as well as ever (0) /I can't concentrate as well as usual (1) /I find it difficult to concentrate on anything for any length of time (2) /I can't concentrate at all (3)> */
  difficultyConcentrating?: Maybe<Treatment_DifficultyConcentrating>;
  /** <I don't feel like a failure (0) /I have feelings of failure more often (1) /When I look back, I see a lot of failures (2) /I feel like I am a complete failure as a person (3)> */
  feelingsOfFailure?: Maybe<Treatment_FeelingsOfFailure>;
  /** <I don't feel like I'm being punished for anything (0) /I feel like I might be punished (1) /I expect to be punished (2) /I feel like I'm being punished (3)> */
  feelingsOfPunishment?: Maybe<Treatment_FeelingsOfPunishment>;
  /** <I don't have any particular guilt feelings (0) /I often have guilt feelings about things I have done or should have done (1) /I have guilt feelings most of the time (2) /I have guilt feelings all the time (3)> */
  guiltFeelings?: Maybe<Treatment_GuiltFeelings>;
  /** <I am as decisive as ever (0) /I find it harder than usual to make decisions (1) /I find it much harder than usual to make decisions (2) /I have trouble making decisions at all (3)> */
  inabilityToMakeDecisions?: Maybe<Treatment_InabilityToMakeDecisions>;
  /** <I am not more irritable than usual (0) /I am more irritable than usual (1) I am much more irritable than usual (2) /I feel irritable all the time (3)> */
  irritability?: Maybe<Treatment_Irritability>;
  /** <I have as much energy as ever (0) /I have less energy than usual (1) /I have so little energy that I can hardly manage anything (2) /I have no energy left to do anything at all (3)> */
  lossOfEnergy?: Maybe<Treatment_LossOfEnergy>;
  /** <I can enjoy things as much as I used to (0) /I can't enjoy things as much as I used to (1) /Things that only used to give me pleasure I can hardly enjoy anymore (2) /Things that used to give me pleasure I can't enjoy at all (3)> */
  lossOfEnjoyment?: Maybe<Treatment_LossOfEnjoyment>;
  /** <I have not lost interest in other people or in activities (0) /I have less interest in other people or in things than usual (1) /I have lost interest in other people or things for the most part (2) /I have a hard time being interested in anything at all (3)> */
  lossOfInterest?: Maybe<Treatment_LossOfInterest>;
  /** <My interest in sexuality has not changed lately (0) / I am less interested in sexuality than I used to be (1) /I am much less interested in sexuality now (2) /I have completely lost interest in sexuality (3)> */
  lossOfSexualInterest?: Maybe<Treatment_LossOfSexualInterest>;
  /** <I am not despondent about the future (0) / I am more despondent about the future than usual (1) /I am despondent and do not expect my situation to get better (2) /I think my future is hopeless and will only get worse (3)> */
  pessimism?: Maybe<Treatment_Pessimism>;
  /** <I am no more restless than usual (0) /I am more restless than usual (1) /I am so restless that it is difficult for me to sit still (2) /I am such a restless person that I am constantly moving or doing something (3)> */
  restlessness?: Maybe<Treatment_Restlessness>;
  /** <I am not sad (0) / I am often sad (1) / I am sad all the time (2) / I am so sad or unhappy that I can't stand it (3)> */
  sadness?: Maybe<Treatment_Sadness>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** <I think as highly of myself as ever (0) /I have lost confidence in myself (1) /I am disappointed in myself (2) /I completely reject myself (3)> */
  selfRejection?: Maybe<Treatment_SelfRejection>;
  /** <I do not criticize or blame myself more than usual (0) /I am more critical of myself than usual (1) /I criticize myself for all my shortcomings (2) /I blame myself for everything bad that happens (3)> */
  selfReproach?: Maybe<Treatment_SelfReproach>;
  /** <I don't think about harming myself (0) / I sometimes think about suicide, but I wouldn't do it (1) /I would like to kill myself most (2) /I would kill myself if I had the chance (3)> */
  suicidalThoughts?: Maybe<Treatment_SuicidalThoughts>;
  /** <I don't feel more tired or exhausted than usual (0) /I get tired or exhausted more quickly than usual (1) /I am too tired or exhausted to do many things I usually do (2) /I am so tired or exhausted that I can do almost nothing (3)> */
  tirednessOrExhaustion?: Maybe<Treatment_TirednessOrExhaustion>;
  /** <I don't feel worthless (0) /I consider myself less valuable and useful than usual (1) Compared to other people, I feel much less valuable (2) /I feel completely worthless (3)> */
  worthlessness?: Maybe<Treatment_Worthlessness>;
};

export type Treatment_BiensteinBreathScaleBlock = {
  __typename?: 'treatment_BiensteinBreathScaleBlock';
  bbsPain?: Maybe<Treatment_BbsPain>;
  bbsWillingnessToCooperate?: Maybe<Treatment_BbsWillingnessToCooperate>;
  breathingEffort?: Maybe<Treatment_BreathingEffort>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  dysphagia?: Maybe<Treatment_Dysphagia>;
  immunodeficiency?: Maybe<Treatment_Immunodeficiency>;
  intubationAnesthesiaVentilation?: Maybe<Treatment_IntubationAnesthesiaVentilation>;
  levelOfConsciousness?: Maybe<Treatment_LevelOfConsciousness>;
  manipulativeOrotrachealMeasures?: Maybe<Treatment_ManipulativeOrotrachealMeasures>;
  mobilityLimitations?: Maybe<Treatment_MobilityLimitations>;
  occupation?: Maybe<Treatment_Occupation>;
  presentAcuteRespiratoryDisease?: Maybe<Treatment_PresentAcuteRespiratoryDisease>;
  previousLungDisease?: Maybe<Treatment_PreviousLungDisease>;
  respiratoryDepressantMedications?: Maybe<Treatment_RespiratoryDepressantMedications>;
  respiratoryRate?: Maybe<Treatment_RespiratoryRate>;
  score?: Maybe<Scalars['Int']>;
  smoker?: Maybe<Treatment_Smoker>;
};

export enum Treatment_BingeEatingIntensity {
  BingeEatingIntensityConsistent = 'BINGE_EATING_INTENSITY_CONSISTENT',
  BingeEatingIntensityDecreasing = 'BINGE_EATING_INTENSITY_DECREASING',
  BingeEatingIntensityIncreasing = 'BINGE_EATING_INTENSITY_INCREASING',
  BingeEatingIntensityNone = 'BINGE_EATING_INTENSITY_NONE'
}

export type Treatment_BingeEatingMsg = {
  __typename?: 'treatment_BingeEatingMsg';
  accompanyingFeelings?: Maybe<Scalars['String']>;
  duration?: Maybe<VeiosTimeSpanMsg>;
  endingReasons?: Maybe<Scalars['String']>;
  foodAndQuantity?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_BingeEatingResolution>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intensity?: Maybe<Treatment_BingeEatingIntensity>;
  trigger?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_BingeEatingResolution {
  BingeEatingResolutionDay = 'BINGE_EATING_RESOLUTION_DAY',
  BingeEatingResolutionMonth = 'BINGE_EATING_RESOLUTION_MONTH',
  BingeEatingResolutionNone = 'BINGE_EATING_RESOLUTION_NONE',
  BingeEatingResolutionWeek = 'BINGE_EATING_RESOLUTION_WEEK',
  BingeEatingResolutionYear = 'BINGE_EATING_RESOLUTION_YEAR'
}

export enum Treatment_BladderControl {
  BladderControlContinent = 'BLADDER_CONTROL_CONTINENT',
  BladderControlIncontinent = 'BLADDER_CONTROL_INCONTINENT',
  BladderControlNone = 'BLADDER_CONTROL_NONE',
  BladderControlOccasionalAccident = 'BLADDER_CONTROL_OCCASIONAL_ACCIDENT'
}

export enum Treatment_Bleeding {
  BleedingMinor = 'BLEEDING_MINOR',
  BleedingModerate = 'BLEEDING_MODERATE',
  BleedingNone = 'BLEEDING_NONE',
  BleedingSevere = 'BLEEDING_SEVERE'
}

export enum Treatment_BleedingIntensity {
  BleedingIntensityHeavy = 'BLEEDING_INTENSITY_HEAVY',
  BleedingIntensityMedium = 'BLEEDING_INTENSITY_MEDIUM',
  BleedingIntensityNone = 'BLEEDING_INTENSITY_NONE',
  BleedingIntensityWeak = 'BLEEDING_INTENSITY_WEAK'
}

export type Treatment_BloodPressureAndPulseAnamnesticBlock = {
  __typename?: 'treatment_BloodPressureAndPulseAnamnesticBlock';
  measurements?: Maybe<Array<Maybe<Treatment_BloodPressureAndPulseAnamnesticMsg>>>;
};

export type Treatment_BloodPressureAndPulseAnamnesticMsg = {
  __typename?: 'treatment_BloodPressureAndPulseAnamnesticMsg';
  diastolicValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  numberOfBPM?: Maybe<Scalars['Int']>;
  systolicValue?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  timeOfMeasurement?: Maybe<VeiosDateTimeMsg>;
};

export type Treatment_BloodPressureAndPulseBlock = {
  __typename?: 'treatment_BloodPressureAndPulseBlock';
  measurements?: Maybe<Array<Maybe<Treatment_BloodPressureAndPulseMsg>>>;
};

export type Treatment_BloodPressureAndPulseMsg = {
  __typename?: 'treatment_BloodPressureAndPulseMsg';
  diastolicValue?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  numberOfBPM?: Maybe<Scalars['Int']>;
  pulseQuality?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  pulseRhythmType?: Maybe<Treatment_PulseRhythmType>;
  systolicValue?: Maybe<Scalars['Int']>;
  timeOfMeasurement?: Maybe<VeiosDateTimeMsg>;
};

export type Treatment_BodsScoreBlock = {
  __typename?: 'treatment_BodsScoreBlock';
  bodsScoreOneValueSelection?: Maybe<Treatment_BodsScoreOneValueSelection>;
  bodsScoreTwoValueSelection?: Maybe<Treatment_BodsScoreTwoValueSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_BodsScoreOneValueSelection {
  /** No tracheal cannula, efficient saliva swallowing (1) */
  BodsScoreOneValueSelectionEfficientSalivaSwallowing = 'BODS_SCORE_ONE_VALUE_SELECTION_EFFICIENT_SALIVA_SWALLOWING',
  /** No tracheostomy tube, inefficient saliva swallowing, frequent gurgling vocal sound (3) */
  BodsScoreOneValueSelectionFrequentGurglingVocalSound = 'BODS_SCORE_ONE_VALUE_SELECTION_FREQUENT_GURGLING_VOCAL_SOUND',
  /** Inadequate protective mechanisms and occasional need for suction or tracheal cannula permanently unblocked or speaking cannula (4) */
  BodsScoreOneValueSelectionInadequateProtectiveMechanisms = 'BODS_SCORE_ONE_VALUE_SELECTION_INADEQUATE_PROTECTIVE_MECHANISMS',
  BodsScoreOneValueSelectionNone = 'BODS_SCORE_ONE_VALUE_SELECTION_NONE',
  /** No tracheostomy tube, inefficient saliva swallowing, occasional gurgling vocal sound (2) */
  BodsScoreOneValueSelectionOccasionalGurglingVocalSound = 'BODS_SCORE_ONE_VALUE_SELECTION_OCCASIONAL_GURGLING_VOCAL_SOUND',
  /** Tracheal cannula always blocked (8) */
  BodsScoreOneValueSelectionTrachealCannulaAlwaysBlocked = 'BODS_SCORE_ONE_VALUE_SELECTION_TRACHEAL_CANNULA_ALWAYS_BLOCKED',
  /** Tracheal cannula unblocked long time (>1-12 h) (6) */
  BodsScoreOneValueSelectionTrachealCannulaUnblockedLongTime = 'BODS_SCORE_ONE_VALUE_SELECTION_TRACHEAL_CANNULA_UNBLOCKED_LONG_TIME',
  /** Tracheal cannula unblocked short time (<1 h) (7) */
  BodsScoreOneValueSelectionTrachealCannulaUnblockedShortTime = 'BODS_SCORE_ONE_VALUE_SELECTION_TRACHEAL_CANNULA_UNBLOCKED_SHORT_TIME'
}

export enum Treatment_BodsScoreTwoValueSelection {
  /** Completely oral with minor restrictions (2) */
  BodsScoreTwoValueSelectionCompletelyOralWithMinorRestrictions = 'BODS_SCORE_TWO_VALUE_SELECTION_COMPLETELY_ORAL_WITH_MINOR_RESTRICTIONS',
  /** Completely oral with moderate restrictions (3) */
  BodsScoreTwoValueSelectionCompletelyOralWithModerateRestrictions = 'BODS_SCORE_TWO_VALUE_SELECTION_COMPLETELY_ORAL_WITH_MODERATE_RESTRICTIONS',
  /** Completely oral with severe restrictions (4) */
  BodsScoreTwoValueSelectionCompletelyOralWithSevereRestrictions = 'BODS_SCORE_TWO_VALUE_SELECTION_COMPLETELY_ORAL_WITH_SEVERE_RESTRICTIONS',
  /** Exclusively tube/parenteral (8) */
  BodsScoreTwoValueSelectionExclusivelyTube = 'BODS_SCORE_TWO_VALUE_SELECTION_EXCLUSIVELY_TUBE',
  /** Full oral without restriction (1) */
  BodsScoreTwoValueSelectionFullOralWithoutRestriction = 'BODS_SCORE_TWO_VALUE_SELECTION_FULL_ORAL_WITHOUT_RESTRICTION',
  BodsScoreTwoValueSelectionNone = 'BODS_SCORE_TWO_VALUE_SELECTION_NONE',
  /** Partially oral (6) */
  BodsScoreTwoValueSelectionPartiallyOral = 'BODS_SCORE_TWO_VALUE_SELECTION_PARTIALLY_ORAL',
  /** predominantly oral (5) */
  BodsScoreTwoValueSelectionPredominantlyOral = 'BODS_SCORE_TWO_VALUE_SELECTION_PREDOMINANTLY_ORAL',
  /** Slightly oral (7) */
  BodsScoreTwoValueSelectionSlightlyOral = 'BODS_SCORE_TWO_VALUE_SELECTION_SLIGHTLY_ORAL'
}

export type Treatment_BodyMeasurementsBlock = {
  __typename?: 'treatment_BodyMeasurementsBlock';
  abdominalGirth?: Maybe<Scalars['Float']>;
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Treatment_BodyMisconceptionMsg = {
  __typename?: 'treatment_BodyMisconceptionMsg';
  avoidanceOfExposingActivities?: Maybe<Scalars['Boolean']>;
  dissatisfactionDescription?: Maybe<Scalars['String']>;
  dissatisfactionWithAreas?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  perceptionMismatch?: Maybe<Scalars['Boolean']>;
  perceptionMismatchDescription?: Maybe<Scalars['String']>;
};

export enum Treatment_BodyRegionPercentage {
  /** 9% (1) */
  BodyRegionPercentage_9Percent = 'BODY_REGION_PERCENTAGE_9_PERCENT',
  /** absent symptoms (0) */
  BodyRegionPercentageAbsentSymptoms = 'BODY_REGION_PERCENTAGE_ABSENT_SYMPTOMS',
  /** 10-29% (2) */
  BodyRegionPercentageBetween_10And_29Percent = 'BODY_REGION_PERCENTAGE_BETWEEN_10_AND_29_PERCENT',
  /** 30-49% (3) */
  BodyRegionPercentageBetween_30And_49Percent = 'BODY_REGION_PERCENTAGE_BETWEEN_30_AND_49_PERCENT',
  /** 50-69% (4) */
  BodyRegionPercentageBetween_50And_69Percent = 'BODY_REGION_PERCENTAGE_BETWEEN_50_AND_69_PERCENT',
  /** 70-89% (5) */
  BodyRegionPercentageBetween_70And_89Percent = 'BODY_REGION_PERCENTAGE_BETWEEN_70_AND_89_PERCENT',
  /** 90-100% (6) */
  BodyRegionPercentageBetween_90And_100Percent = 'BODY_REGION_PERCENTAGE_BETWEEN_90_AND_100_PERCENT',
  BodyRegionPercentageNone = 'BODY_REGION_PERCENTAGE_NONE'
}

export enum Treatment_BowelControl {
  BowelControlContinent = 'BOWEL_CONTROL_CONTINENT',
  BowelControlIncontinent = 'BOWEL_CONTROL_INCONTINENT',
  BowelControlNone = 'BOWEL_CONTROL_NONE',
  BowelControlOccasionalAccident = 'BOWEL_CONTROL_OCCASIONAL_ACCIDENT'
}

export type Treatment_BowelSoundsBlock = {
  __typename?: 'treatment_BowelSoundsBlock';
  bowelSound?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  entireAbdomenText?: Maybe<Scalars['String']>;
  leftUpperQuadrantText?: Maybe<Scalars['String']>;
  lowerLeftQuadrantText?: Maybe<Scalars['String']>;
  lowerRightQuadrantText?: Maybe<Scalars['String']>;
  midAbdomenText?: Maybe<Scalars['String']>;
  rightUpperQuadrantText?: Maybe<Scalars['String']>;
};

export type Treatment_BradenQScaleBlock = {
  __typename?: 'treatment_BradenQScaleBlock';
  bradenScaleActivity?: Maybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: Maybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  frictionAndShear?: Maybe<Treatment_FrictionAndShear>;
  moisture?: Maybe<Treatment_Moisture>;
  nutrition?: Maybe<Treatment_Nutrition>;
  score?: Maybe<Scalars['Int']>;
  sensorySensitivity?: Maybe<Treatment_SensorySensitivity>;
  tissuePerfusionAndOxygenation?: Maybe<Treatment_TissuePerfusionAndOxygenation>;
};

export enum Treatment_BradenScaleActivity {
  BradenScaleActivityBedfast = 'BRADEN_SCALE_ACTIVITY_BEDFAST',
  BradenScaleActivityChairfast = 'BRADEN_SCALE_ACTIVITY_CHAIRFAST',
  BradenScaleActivityNone = 'BRADEN_SCALE_ACTIVITY_NONE',
  BradenScaleActivityWalksFrequently = 'BRADEN_SCALE_ACTIVITY_WALKS_FREQUENTLY',
  BradenScaleActivityWalksOccasionally = 'BRADEN_SCALE_ACTIVITY_WALKS_OCCASIONALLY'
}

/** BradenScaleBlock for BAss */
export type Treatment_BradenScaleBassBlock = {
  __typename?: 'treatment_BradenScaleBassBlock';
  bradenScaleActivity?: Maybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: Maybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  frictionAndShear?: Maybe<Treatment_FrictionAndShear>;
  moisture?: Maybe<Treatment_Moisture>;
  nutrition?: Maybe<Treatment_Nutrition>;
  other?: Maybe<Treatment_OtherSignificantRiskFactors>;
  score?: Maybe<Scalars['Int']>;
  sensorySensitivity?: Maybe<Treatment_SensorySensitivity>;
};

export type Treatment_BradenScaleBlock = {
  __typename?: 'treatment_BradenScaleBlock';
  bradenScaleActivity?: Maybe<Treatment_BradenScaleActivity>;
  bradenScaleMobility?: Maybe<Treatment_BradenScaleMobility>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  frictionAndShear?: Maybe<Treatment_FrictionAndShear>;
  moisture?: Maybe<Treatment_Moisture>;
  nutrition?: Maybe<Treatment_Nutrition>;
  score?: Maybe<Scalars['Int']>;
  sensorySensitivity?: Maybe<Treatment_SensorySensitivity>;
};

export enum Treatment_BradenScaleMobility {
  BradenScaleMobilityCompletelyLimited = 'BRADEN_SCALE_MOBILITY_COMPLETELY_LIMITED',
  BradenScaleMobilityNone = 'BRADEN_SCALE_MOBILITY_NONE',
  BradenScaleMobilityNotLimited = 'BRADEN_SCALE_MOBILITY_NOT_LIMITED',
  BradenScaleMobilitySlightlyLimited = 'BRADEN_SCALE_MOBILITY_SLIGHTLY_LIMITED',
  BradenScaleMobilityVeryLimited = 'BRADEN_SCALE_MOBILITY_VERY_LIMITED'
}

export enum Treatment_BreathingEffort {
  BreathingEffortBreathingWithAssistance = 'BREATHING_EFFORT_BREATHING_WITH_ASSISTANCE',
  BreathingEffortNone = 'BREATHING_EFFORT_NONE',
  BreathingEffortNoBreathing = 'BREATHING_EFFORT_NO_BREATHING',
  BreathingEffortWithoutEffort = 'BREATHING_EFFORT_WITHOUT_EFFORT',
  BreathingEffortWithEffort = 'BREATHING_EFFORT_WITH_EFFORT'
}

export type Treatment_BreathingMovabilityBlock = {
  __typename?: 'treatment_BreathingMovabilityBlock';
  breathingMovabilities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  breathingMovabilityResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_BreathingMovementBlock = {
  __typename?: 'treatment_BreathingMovementBlock';
  breathingMovement?: Maybe<Treatment_BreathingMovementType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_BreathingMovementType {
  BreathingMovementAsymmetric = 'BREATHING_MOVEMENT_ASYMMETRIC',
  BreathingMovementNone = 'BREATHING_MOVEMENT_NONE',
  BreathingMovementSymmetric = 'BREATHING_MOVEMENT_SYMMETRIC'
}

export type Treatment_BronchophonyBlock = {
  __typename?: 'treatment_BronchophonyBlock';
  bronchophony?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  bronchophonyAbnormalitiesPresent?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export enum Treatment_CalfCircumference {
  /** >= 31cm  TODO the score was not mentioned in the specification */
  CalfCircumferenceGreaterThanOrEqual_31 = 'CALF_CIRCUMFERENCE_GREATER_THAN_OR_EQUAL_31',
  /** <31 (0) */
  CalfCircumferenceLessThan_31 = 'CALF_CIRCUMFERENCE_LESS_THAN_31',
  CalfCircumferenceNone = 'CALF_CIRCUMFERENCE_NONE'
}

/** for reference: https://www.criticalcarepractitioner.co.uk/wp-content/uploads/2017/07/CONFUSION-ASSESSMENT-METHOD-CAM-.png */
export type Treatment_CamBlock = {
  __typename?: 'treatment_CamBlock';
  /** A: Acute onset or fluctuating course: <yes/ no> */
  acuteOnsetOrFluctuatingCourse?: Maybe<Scalars['Boolean']>;
  /** D: Altered level of consciousness: <yes/no> */
  alteredLevelOfConsciousness?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Result of the assessment */
  delirium?: Maybe<Scalars['Boolean']>;
  /** C: Disorganized Thinking: <yes/no> */
  disorganizedThinking?: Maybe<Scalars['Boolean']>;
  /** B: Inattention: <yes/no> */
  inattention?: Maybe<Scalars['Boolean']>;
};

/** for reference: https://www.researchgate.net/figure/Confusion-assessment-method-for-the-ICU-CAM-ICU-Flow-sheet_fig1_303790119 */
export type Treatment_CamIcuBlock = {
  __typename?: 'treatment_CamIcuBlock';
  /** A: Acute onset or fluctuating course: <yes/ no> */
  acuteOnsetOrFluctuatingCourse?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Result of the assessment */
  delirium?: Maybe<Scalars['Boolean']>;
  /** D: Disorganized thinking – combined number of errors to questions and commands >1: <yes / no> */
  disorganizedThinking?: Maybe<Scalars['Boolean']>;
  /** B: Letter attention test with >2 errors: < yes/ no> */
  letterAttentionTest?: Maybe<Scalars['Boolean']>;
  /** C: RASS = 0: < yes/ no> */
  rass?: Maybe<Scalars['Boolean']>;
};

export type Treatment_CancelDiagnosisVersionRequest = {
  __typename?: 'treatment_CancelDiagnosisVersionRequest';
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelDiagnosisVersionResponse = {
  __typename?: 'treatment_CancelDiagnosisVersionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CancelFluidFlowSystemVersionRequest = {
  __typename?: 'treatment_CancelFluidFlowSystemVersionRequest';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelFluidFlowSystemVersionResponse = {
  __typename?: 'treatment_CancelFluidFlowSystemVersionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CancelFluidFlowVersionRequest = {
  __typename?: 'treatment_CancelFluidFlowVersionRequest';
  fluidFlowId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelFluidFlowVersionResponse = {
  __typename?: 'treatment_CancelFluidFlowVersionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CancelSymptomConfigurationVersionRequest = {
  __typename?: 'treatment_CancelSymptomConfigurationVersionRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelSymptomConfigurationVersionResponse = {
  __typename?: 'treatment_CancelSymptomConfigurationVersionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CancelTherapyCardRevisionRequest = {
  __typename?: 'treatment_CancelTherapyCardRevisionRequest';
  revisionGroupId?: Maybe<Scalars['String']>;
  revisionId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelTherapyCardRevisionResponse = {
  __typename?: 'treatment_CancelTherapyCardRevisionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CancelWoundVersionRequest = {
  __typename?: 'treatment_CancelWoundVersionRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_CancelWoundVersionResponse = {
  __typename?: 'treatment_CancelWoundVersionResponse';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_CardMetadataMsg = {
  __typename?: 'treatment_CardMetadataMsg';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  singleton?: Maybe<Scalars['Boolean']>;
};

export type Treatment_CardTemplateMsg = {
  __typename?: 'treatment_CardTemplateMsg';
  blocks?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Whether the card should already be created when the skeleton is constructed */
  create?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['Int']>;
  /**
   * Used in problem-specific cards:
   *  determines which diagnoses are displayed in selectable list of "non-existing complications"
   */
  relevantAnesthesiaComplications?: Maybe<Array<Maybe<Treatment_RelevantAnesthesiaComplicationInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which diagnoses are displayed in selectable list of "non-existent diagnoses"
   */
  relevantDiagnoses?: Maybe<Array<Maybe<Treatment_RelevantDiagnosisInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which reasons are displayed in selectable list of "reasons for presentation"
   */
  relevantReasons?: Maybe<Array<Maybe<Treatment_RelevantReasonForPresentationInfoMsg>>>;
  /**
   * Used in problem-specific cards:
   *  determines which symptoms are displayed in selectable list of "non-existent symptoms"
   */
  relevantSymptoms?: Maybe<Array<Maybe<Treatment_RelevantSymptomInfoMsg>>>;
};

export type Treatment_CardiacArrhythmiaBlock = {
  __typename?: 'treatment_CardiacArrhythmiaBlock';
  arrhythmia?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  chestPain?: Maybe<Core_KnowledgeInputMsg>;
  chestPainPresent?: Maybe<Scalars['Boolean']>;
  chestTightnessDescription?: Maybe<Scalars['String']>;
  chestTightnessPresent?: Maybe<Scalars['Boolean']>;
  estimatedBeatsPerMinute?: Maybe<Scalars['Int']>;
  furtherDetails?: Maybe<Scalars['String']>;
  occurrence?: Maybe<Treatment_SymptomOnsetType>;
  paroxysmalArrhythmia?: Maybe<Treatment_ParoxysmalCardiacArrhythmiaMsg>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  unconsciousnessDescription?: Maybe<Scalars['String']>;
  unconsciousnessPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_CardiacInsufficiencyBlock = {
  __typename?: 'treatment_CardiacInsufficiencyBlock';
  furtherClassification?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  furtherInformation?: Maybe<Treatment_CardiacInsufficiencyDetailsMsg>;
  nyhaClassification?: Maybe<Treatment_NyhaClassification>;
  occurrence?: Maybe<Treatment_CardiacInsufficiencyOccurrence>;
  occurrenceText?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  reducedPerformance?: Maybe<Scalars['Boolean']>;
  sweats?: Maybe<Scalars['Boolean']>;
  tachycardia?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export type Treatment_CardiacInsufficiencyDetailsMsg = {
  __typename?: 'treatment_CardiacInsufficiencyDetailsMsg';
  chestPain?: Maybe<Scalars['Boolean']>;
  coldAndBlueLipsOrFingers?: Maybe<Scalars['Boolean']>;
  coughingOrFoaming?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  lossOfConsciousness?: Maybe<Scalars['Boolean']>;
  nightlyUrinationFrequency?: Maybe<Scalars['Int']>;
  nocturnalUrinationUrge?: Maybe<Scalars['Boolean']>;
  skinPaleness?: Maybe<Scalars['Boolean']>;
  stomachPainAndNausea?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_CardiacInsufficiencyOccurrence {
  CardiacInsufficiencyOccurrenceGreaterEffort = 'CARDIAC_INSUFFICIENCY_OCCURRENCE_GREATER_EFFORT',
  CardiacInsufficiencyOccurrenceNone = 'CARDIAC_INSUFFICIENCY_OCCURRENCE_NONE',
  CardiacInsufficiencyOccurrenceOneFlightOfStairs = 'CARDIAC_INSUFFICIENCY_OCCURRENCE_ONE_FLIGHT_OF_STAIRS',
  CardiacInsufficiencyOccurrenceRest = 'CARDIAC_INSUFFICIENCY_OCCURRENCE_REST',
  CardiacInsufficiencyOccurrenceTwoFlightsOfStairs = 'CARDIAC_INSUFFICIENCY_OCCURRENCE_TWO_FLIGHTS_OF_STAIRS'
}

export enum Treatment_Caregivers {
  CaregiversNone = 'CAREGIVERS_NONE',
  CaregiversNotPresent = 'CAREGIVERS_NOT_PRESENT',
  CaregiversPresent = 'CAREGIVERS_PRESENT'
}

export type Treatment_CervicalSpineJointsMsg = {
  __typename?: 'treatment_CervicalSpineJointsMsg';
  /** c3/4 */
  c3C4?: Maybe<Laterality_Laterality>;
  /** c4/5 */
  c4C5?: Maybe<Laterality_Laterality>;
  /** c5/6 */
  c5C6?: Maybe<Laterality_Laterality>;
  /** c6/7 */
  c6C7?: Maybe<Laterality_Laterality>;
  /** c7/8 */
  c7C8?: Maybe<Laterality_Laterality>;
  /** c8/Th1 */
  c8Th1?: Maybe<Laterality_Laterality>;
};

export type Treatment_CervicalSpineMsg = {
  __typename?: 'treatment_CervicalSpineMsg';
  c4?: Maybe<Laterality_Laterality>;
  c5?: Maybe<Laterality_Laterality>;
  c6?: Maybe<Laterality_Laterality>;
  c7?: Maybe<Laterality_Laterality>;
  c8?: Maybe<Laterality_Laterality>;
};

export enum Treatment_Cha2Ds2VascAge {
  /** 65-74 years-old (1) */
  Cha2Ds2VascAgeBetween_65And_74 = 'CHA2DS2VASC_AGE_BETWEEN_65_AND_74',
  /** ≥75 years-old (2) */
  Cha2Ds2VascAgeGreaterThanOrEqual_75 = 'CHA2DS2VASC_AGE_GREATER_THAN_OR_EQUAL_75',
  /** <65 years-old (0) */
  Cha2Ds2VascAgeLessThan_65 = 'CHA2DS2VASC_AGE_LESS_THAN_65',
  Cha2Ds2VascAgeNone = 'CHA2DS2VASC_AGE_NONE'
}

export type Treatment_Cha2Ds2VascBlock = {
  __typename?: 'treatment_Cha2Ds2VascBlock';
  /** ≥75 years-old (2) / 65-74 years-old (1) / <65 years-old (0) */
  age?: Maybe<Treatment_Cha2Ds2VascAge>;
  /** yes (1) / no (0) */
  chronicalHeartFailure?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  diabetes?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  female?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  hypertension?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** yes (1) / no (0) */
  strokeTiaThromboembolismHistory?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  vascularDiseaseHistory?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_Change {
  ChangeImprovement = 'CHANGE_IMPROVEMENT',
  ChangeNeutral = 'CHANGE_NEUTRAL',
  ChangeNone = 'CHANGE_NONE',
  ChangeWorsening = 'CHANGE_WORSENING'
}

export type Treatment_ChangeDiagnosisCreationVisitRequest = {
  __typename?: 'treatment_ChangeDiagnosisCreationVisitRequest';
  newVisitId?: Maybe<Scalars['String']>;
  oldVisitId?: Maybe<Scalars['String']>;
  /** currently, only supported for surgery diagnoses, might be extended in future */
  surgeryId?: Maybe<Scalars['String']>;
};

export enum Treatment_ChangesInAppetite {
  ChangesInAppetiteCravingAllTheTime = 'CHANGES_IN_APPETITE_CRAVING_ALL_THE_TIME',
  ChangesInAppetiteLittleBigger = 'CHANGES_IN_APPETITE_LITTLE_BIGGER',
  ChangesInAppetiteLittleWorth = 'CHANGES_IN_APPETITE_LITTLE_WORTH',
  ChangesInAppetiteMuchBigger = 'CHANGES_IN_APPETITE_MUCH_BIGGER',
  ChangesInAppetiteMuchWorth = 'CHANGES_IN_APPETITE_MUCH_WORTH',
  ChangesInAppetiteNone = 'CHANGES_IN_APPETITE_NONE',
  ChangesInAppetiteNoAppetiteAtAll = 'CHANGES_IN_APPETITE_NO_APPETITE_AT_ALL',
  ChangesInAppetiteNoChange = 'CHANGES_IN_APPETITE_NO_CHANGE'
}

export enum Treatment_ChangesInSleepHabits {
  ChangesInSleepHabitsNone = 'CHANGES_IN_SLEEP_HABITS_NONE',
  ChangesInSleepHabitsNoChange = 'CHANGES_IN_SLEEP_HABITS_NO_CHANGE',
  ChangesInSleepHabitsSleepALittleLess = 'CHANGES_IN_SLEEP_HABITS_SLEEP_A_LITTLE_LESS',
  ChangesInSleepHabitsSleepALittleMore = 'CHANGES_IN_SLEEP_HABITS_SLEEP_A_LITTLE_MORE',
  ChangesInSleepHabitsSleepALotLess = 'CHANGES_IN_SLEEP_HABITS_SLEEP_A_LOT_LESS',
  ChangesInSleepHabitsSleepALotMore = 'CHANGES_IN_SLEEP_HABITS_SLEEP_A_LOT_MORE',
  ChangesInSleepHabitsSleepMostOfTheDay = 'CHANGES_IN_SLEEP_HABITS_SLEEP_MOST_OF_THE_DAY',
  ChangesInSleepHabitsWakeUpTwoHoursEarly = 'CHANGES_IN_SLEEP_HABITS_WAKE_UP_TWO_HOURS_EARLY'
}

export type Treatment_ChecklistElementActionMsg = {
  __typename?: 'treatment_ChecklistElementActionMsg';
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_ChecklistElementStatus>;
  timestamps?: Maybe<TimeMsg>;
  userId?: Maybe<Scalars['String']>;
};

export type Treatment_ChecklistElementMsg = {
  __typename?: 'treatment_ChecklistElementMsg';
  actions?: Maybe<Array<Maybe<Treatment_ChecklistElementActionMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  item?: Maybe<Treatment_ChecklistItemMsg>;
  status?: Maybe<Treatment_ChecklistElementStatus>;
};

export enum Treatment_ChecklistElementStatus {
  ChecklistElementStatusNo = 'CHECKLIST_ELEMENT_STATUS_NO',
  ChecklistElementStatusNone = 'CHECKLIST_ELEMENT_STATUS_NONE',
  ChecklistElementStatusNotApplicable = 'CHECKLIST_ELEMENT_STATUS_NOT_APPLICABLE',
  ChecklistElementStatusYes = 'CHECKLIST_ELEMENT_STATUS_YES'
}

export type Treatment_ChecklistItemMsg = {
  __typename?: 'treatment_ChecklistItemMsg';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Treatment_ChecklistMsg = {
  __typename?: 'treatment_ChecklistMsg';
  elements?: Maybe<Array<Maybe<Treatment_ChecklistElementMsg>>>;
  id?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_ChecklistType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ChecklistTemplateMsg = {
  __typename?: 'treatment_ChecklistTemplateMsg';
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<Treatment_ChecklistItemMsg>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Treatment_ChecklistType>;
};

export enum Treatment_ChecklistType {
  ChecklistTypeCareAdmission = 'CHECKLIST_TYPE_CARE_ADMISSION',
  ChecklistTypeNone = 'CHECKLIST_TYPE_NONE'
}

export type Treatment_ChewingMusclesAndFacialMotorSkillsBlock = {
  __typename?: 'treatment_ChewingMusclesAndFacialMotorSkillsBlock';
  examinationOfEyelidClosing?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfEyelidClosingText?: Maybe<Scalars['String']>;
  examinationOfMasticatoryMuscles?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfMasticatoryMusclesText?: Maybe<Scalars['String']>;
  examinationOfTheMimicMuscles?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  examinationOfTheMimicMusclesText?: Maybe<Scalars['String']>;
  facialMotorSkills?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: Maybe<Scalars['String']>;
};

export type Treatment_ChildPughBlock = {
  __typename?: 'treatment_ChildPughBlock';
  /** Ascites (sonographic): absent (1) / slight (2) / moderate (3) */
  ascites?: Maybe<Treatment_AscitesCheck>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** no Encephalopathy (1) / Grade I-II (2) / >Grade II (3) */
  hepatischeEnzephalopathie?: Maybe<Treatment_HepatischeEnzephalopathie>;
  /** % : >70 (1) / 40-70 (2) / <40 (3) */
  quickValue?: Maybe<Treatment_QuickValue>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** g/dl: < >3.5 (1) / 2,8-3,5 (2) / <2,8 (3) */
  serumAlbumin?: Maybe<Treatment_SerumAlbumin>;
  /** mg/dl: <2,0 (1) / 2.0-3,0 (2) / >3.0 (3) */
  serumBilirubin?: Maybe<Treatment_SerumBilirubin>;
};

export type Treatment_ClavienDindoBlock = {
  __typename?: 'treatment_ClavienDindoBlock';
  clavienDindoSelection?: Maybe<Treatment_ClavienDindoSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_ClavienDindoSelection {
  CalvienDindoSelectionGrade_1 = 'CALVIEN_DINDO_SELECTION_GRADE_1',
  CalvienDindoSelectionGrade_2 = 'CALVIEN_DINDO_SELECTION_GRADE_2',
  CalvienDindoSelectionGrade_3A = 'CALVIEN_DINDO_SELECTION_GRADE_3A',
  CalvienDindoSelectionGrade_3B = 'CALVIEN_DINDO_SELECTION_GRADE_3B',
  CalvienDindoSelectionGrade_4A = 'CALVIEN_DINDO_SELECTION_GRADE_4A',
  CalvienDindoSelectionGrade_4B = 'CALVIEN_DINDO_SELECTION_GRADE_4B',
  CalvienDindoSelectionGrade_5 = 'CALVIEN_DINDO_SELECTION_GRADE_5',
  CalvienDindoSelectionNone = 'CALVIEN_DINDO_SELECTION_NONE'
}

export enum Treatment_ClimbingStairs {
  ClimbingStairsAssistanceRequired = 'CLIMBING_STAIRS_ASSISTANCE_REQUIRED',
  ClimbingStairsNone = 'CLIMBING_STAIRS_NONE',
  ClimbingStairsNotPossible = 'CLIMBING_STAIRS_NOT_POSSIBLE',
  ClimbingStairsSlightUnsteadinessOrFatigue = 'CLIMBING_STAIRS_SLIGHT_UNSTEADINESS_OR_FATIGUE',
  ClimbingStairsSlow = 'CLIMBING_STAIRS_SLOW',
  ClimbingStairsUndisturbed = 'CLIMBING_STAIRS_UNDISTURBED'
}

export type Treatment_ClinicalRecommendationMsg = {
  __typename?: 'treatment_ClinicalRecommendationMsg';
  compliance?: Maybe<Treatment_RecommendationCompliance>;
  complianceDetails?: Maybe<Scalars['String']>;
  connectedDiagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  /** Text of the recommendation in html format */
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Treatment_ClinicalRecommendationOrigin>;
};

export enum Treatment_ClinicalRecommendationOrigin {
  ClinicalRecommendationOriginDischarge = 'CLINICAL_RECOMMENDATION_ORIGIN_DISCHARGE',
  ClinicalRecommendationOriginNone = 'CLINICAL_RECOMMENDATION_ORIGIN_NONE',
  ClinicalRecommendationOriginTreatment = 'CLINICAL_RECOMMENDATION_ORIGIN_TREATMENT'
}

export type Treatment_ClinicalRecommendationsList = {
  __typename?: 'treatment_ClinicalRecommendationsList';
  /** If we want the list for a given diagnosis, this is set */
  diagnosisId?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<Maybe<Treatment_ClinicalRecommendationMsg>>>;
  /** If we want the list for a given treatment, this is set */
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ClinicalStagingCodingMsg = {
  __typename?: 'treatment_ClinicalStagingCodingMsg';
  /** Fixed UUID of coding system */
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Version of coding system (often year) */
  version?: Maybe<Scalars['String']>;
};

/** Used to define the extent of a disease */
export type Treatment_ClinicalStagingInputMsg = {
  __typename?: 'treatment_ClinicalStagingInputMsg';
  code?: Maybe<Treatment_ClinicalStagingCodingMsg>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tumorInformation?: Maybe<Treatment_TumorInformationMsg>;
};

export enum Treatment_ClockScaleSelection {
  ClockScaleSelectionEight = 'CLOCK_SCALE_SELECTION_EIGHT',
  ClockScaleSelectionFive = 'CLOCK_SCALE_SELECTION_FIVE',
  ClockScaleSelectionFour = 'CLOCK_SCALE_SELECTION_FOUR',
  ClockScaleSelectionNine = 'CLOCK_SCALE_SELECTION_NINE',
  ClockScaleSelectionNone = 'CLOCK_SCALE_SELECTION_NONE',
  ClockScaleSelectionOne = 'CLOCK_SCALE_SELECTION_ONE',
  ClockScaleSelectionSeven = 'CLOCK_SCALE_SELECTION_SEVEN',
  ClockScaleSelectionSix = 'CLOCK_SCALE_SELECTION_SIX',
  ClockScaleSelectionTen = 'CLOCK_SCALE_SELECTION_TEN',
  ClockScaleSelectionThree = 'CLOCK_SCALE_SELECTION_THREE',
  ClockScaleSelectionTwo = 'CLOCK_SCALE_SELECTION_TWO'
}

export type Treatment_ClockTestBlock = {
  __typename?: 'treatment_ClockTestBlock';
  completed?: Maybe<Scalars['Boolean']>;
  shulmanScale?: Maybe<Treatment_ClockScaleSelection>;
  sunderlandScale?: Maybe<Treatment_ClockScaleSelection>;
  watsonScale?: Maybe<Treatment_ClockScaleSelection>;
};

export enum Treatment_Comfort {
  /** Cramped conditions, door thresholds, many carpets */
  ComfortCrampedConditionsDoorThresholdsManyCarpets = 'COMFORT_CRAMPED_CONDITIONS_DOOR_THRESHOLDS_MANY_CARPETS',
  ComfortNone = 'COMFORT_NONE',
  /** Apartment on one floor, spacious and wheelchair accessible */
  ComfortOneFloorSpaciousWheelchair = 'COMFORT_ONE_FLOOR_SPACIOUS_WHEELCHAIR',
  /** Several living levels, not wheelchair accessible */
  ComfortSeveralLivingLevelsNotWheelchairAccessible = 'COMFORT_SEVERAL_LIVING_LEVELS_NOT_WHEELCHAIR_ACCESSIBLE'
}

export type Treatment_CompositeChecklistIdMsg = {
  __typename?: 'treatment_CompositeChecklistIdMsg';
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_ChecklistType>;
};

export enum Treatment_Comprehension {
  ComprehensionNone = 'COMPREHENSION_NONE',
  ComprehensionUnderstandingNotPossible = 'COMPREHENSION_UNDERSTANDING_NOT_POSSIBLE',
  ComprehensionUnderstandsComplexIssues = 'COMPREHENSION_UNDERSTANDS_COMPLEX_ISSUES',
  ComprehensionUnderstandsSimpleRequests = 'COMPREHENSION_UNDERSTANDS_SIMPLE_REQUESTS',
  ComprehensionUnhindered = 'COMPREHENSION_UNHINDERED'
}

export type Treatment_CompressionStabilityBlock = {
  __typename?: 'treatment_CompressionStabilityBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_ConditionDevelopment {
  ConditionBetter = 'CONDITION_BETTER',
  ConditionMuchBetter = 'CONDITION_MUCH_BETTER',
  ConditionMuchWorse = 'CONDITION_MUCH_WORSE',
  ConditionNone = 'CONDITION_NONE',
  ConditionNoLongerPresent = 'CONDITION_NO_LONGER_PRESENT',
  ConditionUnchanged = 'CONDITION_UNCHANGED',
  ConditionWorse = 'CONDITION_WORSE'
}

export enum Treatment_ConnectionOfLettersAndNumbers {
  ConnectionOfLettersAndNumbersNone = 'CONNECTION_OF_LETTERS_AND_NUMBERS_NONE',
  ConnectionOfLettersAndNumbersSuccessful = 'CONNECTION_OF_LETTERS_AND_NUMBERS_SUCCESSFUL',
  ConnectionOfLettersAndNumbersUnsuccessful = 'CONNECTION_OF_LETTERS_AND_NUMBERS_UNSUCCESSFUL'
}

export type Treatment_ConstantShoulderBlock = {
  __typename?: 'treatment_ConstantShoulderBlock';
  /** 0°-30° (0) / 31°-60° (2) / 61°-90° (4) / 91°-120° (6) / 121°-150° (8) / 151°-180° (10) */
  abduction?: Maybe<Treatment_DegreeSelect>;
  /** Ability to work: 0-4 */
  abilityToWork?: Maybe<Treatment_ConstantShoulderSliderToFour>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /**
   * hand on top of head, elbow forward (2)
   * /hand on top of head, elbow to side (2)
   * /hand on back of head, elbow forward (2)
   * /hand on back of head, elbow to side (2)
   * /unrestricted overhead mobility (2)
   */
  externalRotationList?: Maybe<Array<Maybe<Treatment_ExternalRotation>>>;
  /** 0°-30° (0) / 31°-60° (2) / 61°-90° (4) / 91°-120° (6) / 121°-150° (8) / 151°-180° (10) */
  flexion?: Maybe<Treatment_DegreeSelect>;
  /**
   * Force (90° abduction in scapular plane, hand pronated):
   * <numeric input>
   * (non-negative integers; two decimals; interval: 0,45; range: 0,45 to 11,25 >
   */
  force?: Maybe<Scalars['Float']>;
  /** girth (2) / xiphoid (4) /neck (6) / vertex (8) / beyond head (10) */
  handReach?: Maybe<Treatment_HandReach>;
  /**
   * back of hand on outer thigh (0)
   * /back of hand on buttock (2)
   * /back of hand on lumbosacral junction (4)
   * /back of hand on girdle line (3rd LWK) (6)
   * /back of hand on 12th dorsal vertebra (8)
   * /back of hand between shoulder blades (10)
   */
  internalRotation?: Maybe<Treatment_InternalRotation>;
  /** Pain: 0-15 */
  pain?: Maybe<Treatment_ConstantShoulderSliderToFifteen>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** Sleep ability: 0-2 */
  sleepAbility?: Maybe<Treatment_ConstantShoulderSliderToTwo>;
  /** Recreational/sports ability: 0-15 */
  sportsAbility?: Maybe<Treatment_ConstantShoulderSliderToFifteen>;
};

export enum Treatment_ConstantShoulderSliderToFifteen {
  ConstantShoulderSlider_15Eight = 'CONSTANT_SHOULDER_SLIDER_15_EIGHT',
  ConstantShoulderSlider_15Eleven = 'CONSTANT_SHOULDER_SLIDER_15_ELEVEN',
  ConstantShoulderSlider_15Fifteen = 'CONSTANT_SHOULDER_SLIDER_15_FIFTEEN',
  ConstantShoulderSlider_15Five = 'CONSTANT_SHOULDER_SLIDER_15_FIVE',
  ConstantShoulderSlider_15Four = 'CONSTANT_SHOULDER_SLIDER_15_FOUR',
  ConstantShoulderSlider_15Fourteen = 'CONSTANT_SHOULDER_SLIDER_15_FOURTEEN',
  ConstantShoulderSlider_15Nine = 'CONSTANT_SHOULDER_SLIDER_15_NINE',
  ConstantShoulderSlider_15None = 'CONSTANT_SHOULDER_SLIDER_15_NONE',
  ConstantShoulderSlider_15One = 'CONSTANT_SHOULDER_SLIDER_15_ONE',
  ConstantShoulderSlider_15Seven = 'CONSTANT_SHOULDER_SLIDER_15_SEVEN',
  ConstantShoulderSlider_15Six = 'CONSTANT_SHOULDER_SLIDER_15_SIX',
  ConstantShoulderSlider_15Ten = 'CONSTANT_SHOULDER_SLIDER_15_TEN',
  ConstantShoulderSlider_15Thirteen = 'CONSTANT_SHOULDER_SLIDER_15_THIRTEEN',
  ConstantShoulderSlider_15Three = 'CONSTANT_SHOULDER_SLIDER_15_THREE',
  ConstantShoulderSlider_15Twelve = 'CONSTANT_SHOULDER_SLIDER_15_TWELVE',
  ConstantShoulderSlider_15Two = 'CONSTANT_SHOULDER_SLIDER_15_TWO',
  ConstantShoulderSlider_15Zero = 'CONSTANT_SHOULDER_SLIDER_15_ZERO'
}

export enum Treatment_ConstantShoulderSliderToFour {
  ConstantShoulderSlider_4Four = 'CONSTANT_SHOULDER_SLIDER_4_FOUR',
  ConstantShoulderSlider_4None = 'CONSTANT_SHOULDER_SLIDER_4_NONE',
  ConstantShoulderSlider_4One = 'CONSTANT_SHOULDER_SLIDER_4_ONE',
  ConstantShoulderSlider_4Three = 'CONSTANT_SHOULDER_SLIDER_4_THREE',
  ConstantShoulderSlider_4Two = 'CONSTANT_SHOULDER_SLIDER_4_TWO',
  ConstantShoulderSlider_4Zero = 'CONSTANT_SHOULDER_SLIDER_4_ZERO'
}

export enum Treatment_ConstantShoulderSliderToTwo {
  ConstantShoulderSlider_2None = 'CONSTANT_SHOULDER_SLIDER_2_NONE',
  ConstantShoulderSlider_2One = 'CONSTANT_SHOULDER_SLIDER_2_ONE',
  ConstantShoulderSlider_2Two = 'CONSTANT_SHOULDER_SLIDER_2_TWO',
  ConstantShoulderSlider_2Zero = 'CONSTANT_SHOULDER_SLIDER_2_ZERO'
}

export enum Treatment_ConsumptionDurationReference {
  ConsumptionDurationReferenceMonth = 'CONSUMPTION_DURATION_REFERENCE_MONTH',
  ConsumptionDurationReferenceNone = 'CONSUMPTION_DURATION_REFERENCE_NONE',
  ConsumptionDurationReferenceYear = 'CONSUMPTION_DURATION_REFERENCE_YEAR'
}

export enum Treatment_ConsumptionFrequencyReference {
  ConsumptionFrequencyReferenceDay = 'CONSUMPTION_FREQUENCY_REFERENCE_DAY',
  ConsumptionFrequencyReferenceMonth = 'CONSUMPTION_FREQUENCY_REFERENCE_MONTH',
  ConsumptionFrequencyReferenceNone = 'CONSUMPTION_FREQUENCY_REFERENCE_NONE',
  ConsumptionFrequencyReferenceWeek = 'CONSUMPTION_FREQUENCY_REFERENCE_WEEK',
  ConsumptionFrequencyReferenceYear = 'CONSUMPTION_FREQUENCY_REFERENCE_YEAR'
}

export enum Treatment_ContactSatisfactionWithCondition {
  ContactSatisfactionWithConditionFeelsLonely = 'CONTACT_SATISFACTION_WITH_CONDITION_FEELS_LONELY',
  ContactSatisfactionWithConditionFeelsWellTakenCare = 'CONTACT_SATISFACTION_WITH_CONDITION_FEELS_WELL_TAKEN_CARE',
  ContactSatisfactionWithConditionMediumSatisfaction = 'CONTACT_SATISFACTION_WITH_CONDITION_MEDIUM_SATISFACTION',
  ContactSatisfactionWithConditionNone = 'CONTACT_SATISFACTION_WITH_CONDITION_NONE'
}

export enum Treatment_ContactWithCaregiver {
  ContactWithCaregiverFrequentlyPerDay = 'CONTACT_WITH_CAREGIVER_FREQUENTLY_PER_DAY',
  ContactWithCaregiverNever = 'CONTACT_WITH_CAREGIVER_NEVER',
  ContactWithCaregiverNone = 'CONTACT_WITH_CAREGIVER_NONE',
  ContactWithCaregiverOnceAWeek = 'CONTACT_WITH_CAREGIVER_ONCE_A_WEEK',
  ContactWithCaregiverRarely = 'CONTACT_WITH_CAREGIVER_RARELY'
}

export type Treatment_ContraceptivesBlock = {
  __typename?: 'treatment_ContraceptivesBlock';
  contraceptiveIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ContusionHematomaBlock = {
  __typename?: 'treatment_ContusionHematomaBlock';
  contusionMarks?: Maybe<Array<Maybe<Treatment_ContusionMarkMsg>>>;
  contusionMarksPresent?: Maybe<Scalars['Boolean']>;
  contusionMarksText?: Maybe<Scalars['String']>;
  hematomas?: Maybe<Array<Maybe<Treatment_HematomaMsg>>>;
  hematomasPresent?: Maybe<Scalars['Boolean']>;
  hematomasText?: Maybe<Scalars['String']>;
};

export type Treatment_ContusionMarkMsg = {
  __typename?: 'treatment_ContusionMarkMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_CoordinationAbnormalitiesSingleTestMsg = {
  __typename?: 'treatment_CoordinationAbnormalitiesSingleTestMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_CoordinationAbnormalitiesTestMsg = {
  __typename?: 'treatment_CoordinationAbnormalitiesTestMsg';
  id?: Maybe<Scalars['String']>;
  leftTest?: Maybe<Treatment_CoordinationAbnormalitiesSingleTestMsg>;
  rightTest?: Maybe<Treatment_CoordinationAbnormalitiesSingleTestMsg>;
};

export type Treatment_CoordinationBlock = {
  __typename?: 'treatment_CoordinationBlock';
  baranyTest?: Maybe<Treatment_CoordinationTestMsg>;
  coordination?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  diadochokinesis?: Maybe<Treatment_CoordinationAbnormalitiesTestMsg>;
  fingerNoseTest?: Maybe<Treatment_CoordinationAbnormalitiesTestMsg>;
  fingerToFingerTest?: Maybe<Treatment_CoordinationAbnormalitiesTestMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  heelKneeTest?: Maybe<Treatment_CoordinationAbnormalitiesTestMsg>;
};

export type Treatment_CoordinationSingleTestMsg = {
  __typename?: 'treatment_CoordinationSingleTestMsg';
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_CoordinationTestMsg = {
  __typename?: 'treatment_CoordinationTestMsg';
  id?: Maybe<Scalars['String']>;
  leftTest?: Maybe<Treatment_CoordinationSingleTestMsg>;
  rightTest?: Maybe<Treatment_CoordinationSingleTestMsg>;
};

export enum Treatment_CopyingThreeDimensionalCube {
  CopyingThreeDimensionalCubeNone = 'COPYING_THREE_DIMENSIONAL_CUBE_NONE',
  CopyingThreeDimensionalCubeSuccessful = 'COPYING_THREE_DIMENSIONAL_CUBE_SUCCESSFUL',
  CopyingThreeDimensionalCubeUnsuccessful = 'COPYING_THREE_DIMENSIONAL_CUBE_UNSUCCESSFUL'
}

export enum Treatment_CormackLehaneClassification {
  CormackLehaneClassification_1 = 'CORMACK_LEHANE_CLASSIFICATION_1',
  CormackLehaneClassification_2 = 'CORMACK_LEHANE_CLASSIFICATION_2',
  CormackLehaneClassification_2A = 'CORMACK_LEHANE_CLASSIFICATION_2A',
  CormackLehaneClassification_2B = 'CORMACK_LEHANE_CLASSIFICATION_2B',
  CormackLehaneClassification_3 = 'CORMACK_LEHANE_CLASSIFICATION_3',
  CormackLehaneClassification_4 = 'CORMACK_LEHANE_CLASSIFICATION_4',
  CormackLehaneClassificationNone = 'CORMACK_LEHANE_CLASSIFICATION_NONE'
}

export type Treatment_CortisoneMsg = {
  __typename?: 'treatment_CortisoneMsg';
  cortisoneDrugLink?: Maybe<Drug_DrugLinkMsg>;
  /** non-negative; unit: ml */
  cortisoneVolume?: Maybe<Scalars['Float']>;
};

export type Treatment_CoughBlock = {
  __typename?: 'treatment_CoughBlock';
  furtherClassification?: Maybe<Treatment_CoughDetailsMsg>;
  furtherClassificationPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  symptomAppearance?: Maybe<Treatment_SymptomAppearance>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export type Treatment_CoughDetailsMsg = {
  __typename?: 'treatment_CoughDetailsMsg';
  coughQualities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  coughSounds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  coughTriggerPresent?: Maybe<Scalars['Boolean']>;
  coughTriggers?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  painDescription?: Maybe<Core_KnowledgeInputMsg>;
  painPresent?: Maybe<Scalars['Boolean']>;
  sputumAmountDescription?: Maybe<Scalars['String']>;
  sputumDaytimeDependencePresent?: Maybe<Scalars['Boolean']>;
  sputumDaytimeDependences?: Maybe<Array<Maybe<Treatment_DaytimeDependence>>>;
  sputumDescription?: Maybe<Scalars['String']>;
  sputumIncreasedAfterEating?: Maybe<Scalars['Boolean']>;
  sputumPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_Crb65ScoreBlock = {
  __typename?: 'treatment_Crb65ScoreBlock';
  /** < yes (1) / no (0) > */
  ageGreaterOrEqual65?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** <present (1) / not present (0) > */
  confusionPresent?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0) > */
  diastolicBloodPressureLessOrEqual60OrSystolicBloodPressureLessThan90?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0) > */
  respiratoryRateGreaterOrEqualThan30?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
};

export type Treatment_CreateAllergyRequest = {
  __typename?: 'treatment_CreateAllergyRequest';
  patientId?: Maybe<Scalars['String']>;
  /** Optional: if within a treatment, this has to be set */
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateAnamnesisBlockRequest = {
  __typename?: 'treatment_CreateAnamnesisBlockRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_AnamnesisBlockLocation>;
  pathKey?: Maybe<Treatment_PathKeyMsg>;
  patientId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateAnamnesisBlockResponse = {
  __typename?: 'treatment_CreateAnamnesisBlockResponse';
  anamnesisBlock?: Maybe<Treatment_AnamnesisBlockMsg>;
};

export type Treatment_CreateAnamnesisCardRequest = {
  __typename?: 'treatment_CreateAnamnesisCardRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_CreateAnamnesisRequest = {
  __typename?: 'treatment_CreateAnamnesisRequest';
  location?: Maybe<Treatment_AnamnesisLocation>;
  patientId?: Maybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateAnamnesisResponse = {
  __typename?: 'treatment_CreateAnamnesisResponse';
  anamnesis?: Maybe<Treatment_AnamnesisMsg>;
};

export type Treatment_CreateChecklistTemplateRequest = {
  __typename?: 'treatment_CreateChecklistTemplateRequest';
  items?: Maybe<Array<Maybe<Treatment_ChecklistItemMsg>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  type?: Maybe<Treatment_ChecklistType>;
};

export type Treatment_CreateClinicalRecommendationRequest = {
  __typename?: 'treatment_CreateClinicalRecommendationRequest';
  dischargeId?: Maybe<Scalars['String']>;
  origin?: Maybe<Treatment_ClinicalRecommendationOrigin>;
  patientId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateClinicalRecommendationResponse = {
  __typename?: 'treatment_CreateClinicalRecommendationResponse';
  clinicalRecommendationId?: Maybe<Scalars['String']>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  recommendation?: Maybe<Treatment_ClinicalRecommendationMsg>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_CreateDiagnosisCodingRequest = {
  __typename?: 'treatment_CreateDiagnosisCodingRequest';
  /**
   * By default, an icd coding change will clear any alpha/orphaIds.
   *  For synchronization with external systems, it may be convenient to set those first and then create the ICD code -
   *  in that case, this is set.
   */
  avoidClearingCodings?: Maybe<Scalars['Boolean']>;
  /** If set to true, any existing icd codes will be cleared from the diagnosis */
  clearIcdCodings?: Maybe<Scalars['Boolean']>;
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisCoding?: Maybe<Treatment_DiagnosisCodingMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateDiagnosisCodingResponse = {
  __typename?: 'treatment_CreateDiagnosisCodingResponse';
  diagnosisCoding?: Maybe<Treatment_DiagnosisCodingMsg>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: Maybe<Scalars['String']>;
  updatedDiagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_CreateDiagnosisRequest = {
  __typename?: 'treatment_CreateDiagnosisRequest';
  categoryAssignment?: Maybe<Treatment_DiagnosisCategoryAssignmentMsg>;
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  /** always needs to be set */
  patientId?: Maybe<Scalars['String']>;
  /** If the diagnosis is not determined through treatment, but just an entry of old data */
  previousDiagnosis?: Maybe<Scalars['Boolean']>;
  /** if the diagnosis is created in a preanesthetic assessment for the recommendation */
  recommended?: Maybe<Scalars['Boolean']>;
  /** optional */
  tagAssignments?: Maybe<Array<Maybe<Treatment_DiagnosisTagAssignmentMsg>>>;
};

export type Treatment_CreateDiagnosisResponse = {
  __typename?: 'treatment_CreateDiagnosisResponse';
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_CreateFluidFlowRequest = {
  __typename?: 'treatment_CreateFluidFlowRequest';
  fluidFlow?: Maybe<Treatment_FluidFlowMsg>;
  /**
   * when creating a fluid flow, its version source is assumed to be new
   *  due to them being only revisioned
   * @deprecated deprecated in proto
   */
  versionSource?: Maybe<Versioning_VersionSourceMsg>;
};

export type Treatment_CreateFluidFlowSystemRequest = {
  __typename?: 'treatment_CreateFluidFlowSystemRequest';
  detailsNumber?: Maybe<Scalars['Int']>;
  fluidFlowSystem?: Maybe<Treatment_FluidFlowSystemMsg>;
  /** only relevant for NamedFluidFlowSystemMsg */
  name?: Maybe<Scalars['String']>;
  /**
   * when creating a fluid flow system, its version source is assumed to be new
   *  due to them being only revisioned
   * @deprecated deprecated in proto
   */
  versionSource?: Maybe<Versioning_VersionSourceMsg>;
};

export type Treatment_CreateImmunityTestRequest = {
  __typename?: 'treatment_CreateImmunityTestRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_CreatePhysicalBlockRequest = {
  __typename?: 'treatment_CreatePhysicalBlockRequest';
  location?: Maybe<Treatment_PhysicalBlockLocation>;
  pathKey?: Maybe<Treatment_PathKeyMsg>;
  patientId?: Maybe<Scalars['String']>;
  physicalExaminationId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreatePhysicalBlockResponse = {
  __typename?: 'treatment_CreatePhysicalBlockResponse';
  physicalBlock?: Maybe<Treatment_PhysicalBlockMsg>;
};

export type Treatment_CreatePhysicalExaminationRequest = {
  __typename?: 'treatment_CreatePhysicalExaminationRequest';
  location?: Maybe<Treatment_PhysicalExaminationLocation>;
  patientId?: Maybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreatePhysicalExaminationResponse = {
  __typename?: 'treatment_CreatePhysicalExaminationResponse';
  physicalExamination?: Maybe<Treatment_PhysicalExaminationMsg>;
};

export type Treatment_CreatePhysicalPresetRequest = {
  __typename?: 'treatment_CreatePhysicalPresetRequest';
  overrideDefault?: Maybe<Scalars['Boolean']>;
  preset?: Maybe<Treatment_PhysicalPresetMsg>;
};

export type Treatment_CreateSymptomConfigurationRequest = {
  __typename?: 'treatment_CreateSymptomConfigurationRequest';
  parameters?: Maybe<Versioning_VersionedEntityCreationParametersMsg>;
  symptomConfiguration?: Maybe<Treatment_SymptomConfigurationMsg>;
  versionSource?: Maybe<Versioning_VersionSourceMsg>;
};

export type Treatment_CreateTherapyCardRequest = {
  __typename?: 'treatment_CreateTherapyCardRequest';
  cardNumber?: Maybe<Scalars['Int']>;
  location?: Maybe<Treatment_TherapyCardLocation>;
  /** only relevant for NamedProcedureMsg */
  name?: Maybe<Scalars['String']>;
  participatingUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
  revisionSource?: Maybe<Versioning_RevisionSourceMsg>;
  surgeryId?: Maybe<Scalars['String']>;
  therapyId?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameMsg>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateTherapyRequest = {
  __typename?: 'treatment_CreateTherapyRequest';
  location?: Maybe<Treatment_TherapyLocation>;
  patientId?: Maybe<Scalars['String']>;
  /** currently unused */
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateTherapyResponse = {
  __typename?: 'treatment_CreateTherapyResponse';
  therapy?: Maybe<Treatment_TherapyMsg>;
};

export type Treatment_CreateTreatmentRequest = {
  __typename?: 'treatment_CreateTreatmentRequest';
  /** To create a treatment without visitId, this flag must be explicitly set */
  allowMissingVisitId?: Maybe<Scalars['Boolean']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateTreatmentResponse = {
  __typename?: 'treatment_CreateTreatmentResponse';
  /** set if denied due to existing open treatment in some other unit */
  blockingOpenTreatment?: Maybe<Treatment_OpenTreatmentInfoMsg>;
  /** set if there is an open treatment the user can continue with in the same unit */
  oldTreatmentInUnit?: Maybe<Treatment_OpenTreatmentInfoMsg>;
  /** set if successful */
  treatment?: Maybe<Treatment_TreatmentMsg>;
};

export type Treatment_CreateVaccinationCertificateRequest = {
  __typename?: 'treatment_CreateVaccinationCertificateRequest';
  fileId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateVaccinationDiseaseRequest = {
  __typename?: 'treatment_CreateVaccinationDiseaseRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateVaccinationRequest = {
  __typename?: 'treatment_CreateVaccinationRequest';
  patientId?: Maybe<Scalars['String']>;
  /** optional: set only if vaccination is part of the treatment */
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_CreateWoundRequest = {
  __typename?: 'treatment_CreateWoundRequest';
  /** mandatory */
  context?: Maybe<Treatment_WoundContextReferenceMsg>;
  documentationDate?: Maybe<Timestamp>;
  parameters?: Maybe<Versioning_VersionedEntityCreationParametersMsg>;
  versionSource?: Maybe<Versioning_VersionSourceMsg>;
};

export type Treatment_CrepitationMsg = {
  __typename?: 'treatment_CrepitationMsg';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationInput?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_CrepitationsBlock = {
  __typename?: 'treatment_CrepitationsBlock';
  crepitations?: Maybe<Array<Maybe<Treatment_CrepitationMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_CruciateLigamentsExaminationBlock = {
  __typename?: 'treatment_CruciateLigamentsExaminationBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_CruciateLigamentsExaminationMsg>;
  right?: Maybe<Treatment_CruciateLigamentsExaminationMsg>;
};

export type Treatment_CruciateLigamentsExaminationMsg = {
  __typename?: 'treatment_CruciateLigamentsExaminationMsg';
  activeQuadricepsTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  activeQuadricepsTestText?: Maybe<Scalars['String']>;
  anteriorDrawerTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorDrawerTestText?: Maybe<Scalars['String']>;
  gravitySignTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  gravitySignTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lachmansTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lachmansTestText?: Maybe<Scalars['String']>;
  pivotShiftTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pivotShiftTestText?: Maybe<Scalars['String']>;
  posteriorDrawerTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  posteriorDrawerTestText?: Maybe<Scalars['String']>;
  reversedLachmansTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  reversedLachmansTestText?: Maybe<Scalars['String']>;
  tibiaStepOffSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaStepOffSignText?: Maybe<Scalars['String']>;
};

export enum Treatment_Crying {
  CryingAtTheSlightestOccasion = 'CRYING_AT_THE_SLIGHTEST_OCCASION',
  CryingMoreCrying = 'CRYING_MORE_CRYING',
  CryingNone = 'CRYING_NONE',
  CryingNoCrying = 'CRYING_NO_CRYING',
  CryingWantToCryWithoutCrying = 'CRYING_WANT_TO_CRY_WITHOUT_CRYING'
}

export type Treatment_CryotherapyMsg = {
  __typename?: 'treatment_CryotherapyMsg';
  connectedDiagnosisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cycles?: Maybe<Scalars['Int']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  notes?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  timePerCycle?: Maybe<Scalars['Int']>;
};

export type Treatment_CurrentPregnancyBlock = {
  __typename?: 'treatment_CurrentPregnancyBlock';
  calculatedGestationalAge?: Maybe<Scalars['Int']>;
  currentPregnancyPresent?: Maybe<Core_BoolUnknown>;
  currentPregnancyText?: Maybe<Scalars['String']>;
  lastMenstruation?: Maybe<VeiosDateTimeMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_CustomFunctionTestMsg = {
  __typename?: 'treatment_CustomFunctionTestMsg';
  customFunctionTestName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  leftText?: Maybe<Scalars['String']>;
  right?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  rightText?: Maybe<Scalars['String']>;
};

export enum Treatment_CuttingFood {
  /** Food needs to be handed */
  CuttingFoodNeedsFoodHanded = 'CUTTING_FOOD_NEEDS_FOOD_HANDED',
  /** Food needs to be cut, can eat slowly on own */
  CuttingFoodNeedsFoodToBeCut = 'CUTTING_FOOD_NEEDS_FOOD_TO_BE_CUT',
  CuttingFoodNone = 'CUTTING_FOOD_NONE',
  /** Somewhat slow and awkward, but no help needed */
  CuttingFoodSlowAndAwkward = 'CUTTING_FOOD_SLOW_AND_AWKWARD',
  /** Can cut most food, but slow and awkward, needs partial help */
  CuttingFoodSomeHelpNeeded = 'CUTTING_FOOD_SOME_HELP_NEEDED',
  CuttingFoodUndisturbed = 'CUTTING_FOOD_UNDISTURBED'
}

export type Treatment_CvcMsg = {
  __typename?: 'treatment_CvcMsg';
  insertion?: Maybe<Core_KnowledgeInputMsg>;
  numberOfLumen?: Maybe<Scalars['Int']>;
  skinLevel?: Maybe<Scalars['Float']>;
};

export type Treatment_CycleBlock = {
  __typename?: 'treatment_CycleBlock';
  averageBleedingDuration?: Maybe<Scalars['Int']>;
  averageBleedingIntensity?: Maybe<Treatment_BleedingIntensity>;
  averageCycleDurationDays?: Maybe<Scalars['Int']>;
  averageCycleDurationText?: Maybe<Scalars['String']>;
  bleedingPresent?: Maybe<Scalars['Boolean']>;
  maximumCycleDuration?: Maybe<VeiosTimeSpanMsg>;
  maximumCycleDurationText?: Maybe<Scalars['String']>;
  minimumCycleDuration?: Maybe<VeiosTimeSpanMsg>;
  minimumCycleDurationText?: Maybe<Scalars['String']>;
  periodRhythmRegular?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_CycleDisordersBlock = {
  __typename?: 'treatment_CycleDisordersBlock';
  cycleDisorders?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** In days */
  cycleDuration?: Maybe<Scalars['Int']>;
  furtherDetails?: Maybe<Scalars['String']>;
  /** In ml */
  mensesAmount?: Maybe<Scalars['Int']>;
  /** In days */
  mensesDuration?: Maybe<Scalars['Int']>;
  menstruationCycle?: Maybe<Treatment_MenstruationCycle>;
  menstruationCycleText?: Maybe<Scalars['String']>;
  menstruationPresent?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_DailyFluidIntake {
  /** 3 to 5 glasses or cups (0.5) */
  DailyFluidIntakeBetween_3And_5Cups = 'DAILY_FLUID_INTAKE_BETWEEN_3_AND_5_CUPS',
  /** less than 3 glasses or cups (0) */
  DailyFluidIntakeLessThan_3Cups = 'DAILY_FLUID_INTAKE_LESS_THAN_3_CUPS',
  /** more than 5 glasses or cups (1) */
  DailyFluidIntakeMoreThan_5Cups = 'DAILY_FLUID_INTAKE_MORE_THAN_5_CUPS',
  DailyFluidIntakeNone = 'DAILY_FLUID_INTAKE_NONE'
}

export enum Treatment_DaytimeDependence {
  DaytimeDependenceDay = 'DAYTIME_DEPENDENCE_DAY',
  DaytimeDependenceNight = 'DAYTIME_DEPENDENCE_NIGHT',
  DaytimeDependenceNone = 'DAYTIME_DEPENDENCE_NONE'
}

/** todo: maybe merge patient and default configurations? */
export type Treatment_DefaultFluidBalanceConfigurationMsg = {
  __typename?: 'treatment_DefaultFluidBalanceConfigurationMsg';
  active?: Maybe<Scalars['Boolean']>;
  configuration?: Maybe<Treatment_FluidBalanceConfigurationMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** TODO: probably only one default configuration per scope */
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export enum Treatment_DefecationResolution {
  DefecationResolutionDay = 'DEFECATION_RESOLUTION_DAY',
  DefecationResolutionNone = 'DEFECATION_RESOLUTION_NONE',
  DefecationResolutionWeek = 'DEFECATION_RESOLUTION_WEEK'
}

export type Treatment_DeformitiesMalpositionsLowerLimbBlock = {
  __typename?: 'treatment_DeformitiesMalpositionsLowerLimbBlock';
  deformitiesAndMalpositions?: Maybe<Array<Maybe<Treatment_DeformitiesMalpositionsMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_DeformitiesMalpositionsMsg = {
  __typename?: 'treatment_DeformitiesMalpositionsMsg';
  deformitiesAndMalpositions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_DeformitiesMalpositionsSpineBlock = {
  __typename?: 'treatment_DeformitiesMalpositionsSpineBlock';
  deformitiesAndMalpositions?: Maybe<Array<Maybe<Treatment_DeformitiesMalpositionsMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_DeformitiesMalpositionsUpperLimbBlock = {
  __typename?: 'treatment_DeformitiesMalpositionsUpperLimbBlock';
  deformitiesAndMalpositions?: Maybe<Array<Maybe<Treatment_DeformitiesMalpositionsMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_DegreeSelect {
  Degree_0To_30 = 'DEGREE_0_TO_30',
  Degree_31To_60 = 'DEGREE_31_TO_60',
  Degree_61To_90 = 'DEGREE_61_TO_90',
  Degree_91To_120 = 'DEGREE_91_TO_120',
  Degree_121To_150 = 'DEGREE_121_TO_150',
  Degree_151To_180 = 'DEGREE_151_TO_180',
  DegreeNone = 'DEGREE_NONE'
}

export type Treatment_DeleteAllergyRequest = {
  __typename?: 'treatment_DeleteAllergyRequest';
  allergyId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteAllergyResponse = {
  __typename?: 'treatment_DeleteAllergyResponse';
  /** ID of deleted allergy */
  deletedAllergyId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteAnamnesisCardRequest = {
  __typename?: 'treatment_DeleteAnamnesisCardRequest';
  cardId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteClinicalRecommendationRequest = {
  __typename?: 'treatment_DeleteClinicalRecommendationRequest';
  clinicalRecommendationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteClinicalRecommendationResponse = {
  __typename?: 'treatment_DeleteClinicalRecommendationResponse';
  deletedClinicalRecommendationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDefaultFluidBalanceConfigurationRequest = {
  __typename?: 'treatment_DeleteDefaultFluidBalanceConfigurationRequest';
  defaultConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDefaultFluidBalanceConfigurationResponse = {
  __typename?: 'treatment_DeleteDefaultFluidBalanceConfigurationResponse';
  defaultConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDiagnosisCodingRequest = {
  __typename?: 'treatment_DeleteDiagnosisCodingRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisCodingGroupId?: Maybe<Scalars['String']>;
  diagnosisCodingId?: Maybe<Scalars['String']>;
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDiagnosisCodingResponse = {
  __typename?: 'treatment_DeleteDiagnosisCodingResponse';
  deletedDiagnosisCodingId?: Maybe<Scalars['String']>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: Maybe<Scalars['String']>;
  updatedDiagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_DeleteDiagnosisCodingsRequest = {
  __typename?: 'treatment_DeleteDiagnosisCodingsRequest';
  contexts?: Maybe<Array<Maybe<Treatment_DiagnosisAccessContextMsg>>>;
  /** deletes all codings of the given diagnoses */
  diagnosisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDiagnosisCodingsResponse = {
  __typename?: 'treatment_DeleteDiagnosisCodingsResponse';
  deletedDiagnosisCodingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_DeleteDiagnosisVersionRequest = {
  __typename?: 'treatment_DeleteDiagnosisVersionRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteDiagnosisVersionResponse = {
  __typename?: 'treatment_DeleteDiagnosisVersionResponse';
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedDiagnosisRevision?: Maybe<Treatment_DiagnosisMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedDiagnosisRevision?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_DeleteFluidFlowSystemVersionRequest = {
  __typename?: 'treatment_DeleteFluidFlowSystemVersionRequest';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteFluidFlowSystemVersionResponse = {
  __typename?: 'treatment_DeleteFluidFlowSystemVersionResponse';
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedFluidFlowSystemRevision?: Maybe<Treatment_FluidFlowSystemMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedFluidFlowSystemRevision?: Maybe<Treatment_FluidFlowSystemMsg>;
};

export type Treatment_DeleteFluidFlowVersionRequest = {
  __typename?: 'treatment_DeleteFluidFlowVersionRequest';
  fluidFlowId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteFluidFlowVersionResponse = {
  __typename?: 'treatment_DeleteFluidFlowVersionResponse';
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedFluidFlowRevision?: Maybe<Treatment_FluidFlowMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedFluidFlowRevision?: Maybe<Treatment_FluidFlowMsg>;
};

export type Treatment_DeletePatientFluidBalanceConfigurationRequest = {
  __typename?: 'treatment_DeletePatientFluidBalanceConfigurationRequest';
  patientConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeletePatientFluidBalanceConfigurationResponse = {
  __typename?: 'treatment_DeletePatientFluidBalanceConfigurationResponse';
  patientConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeletePhysicalBlocksRequest = {
  __typename?: 'treatment_DeletePhysicalBlocksRequest';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  /** Value doesn't matter, field just has to be set if scope should be physicalExamination */
  physicalExamination?: Maybe<Scalars['Boolean']>;
  physicalId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_DeletePhysicalBlocksResponse = {
  __typename?: 'treatment_DeletePhysicalBlocksResponse';
  deletedBlockInfos?: Maybe<Array<Maybe<Treatment_DeletedPhysicalBlockInfoMsg>>>;
};

export type Treatment_DeleteSymptomConfigurationVersionRequest = {
  __typename?: 'treatment_DeleteSymptomConfigurationVersionRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteSymptomConfigurationVersionResponse = {
  __typename?: 'treatment_DeleteSymptomConfigurationVersionResponse';
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedSymptomConfigurationRevision?: Maybe<Treatment_SymptomConfigurationMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedSymptomConfigurationRevision?: Maybe<Treatment_SymptomConfigurationMsg>;
};

export type Treatment_DeleteTherapyCardRequest = {
  __typename?: 'treatment_DeleteTherapyCardRequest';
  cardId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteTherapyCardResponse = {
  __typename?: 'treatment_DeleteTherapyCardResponse';
  deleted?: Maybe<Scalars['Boolean']>;
  deletedCardId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteVaccinationRequest = {
  __typename?: 'treatment_DeleteVaccinationRequest';
  vaccinationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteVaccinationResponse = {
  __typename?: 'treatment_DeleteVaccinationResponse';
  deletedVaccinationId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteWoundRequest = {
  __typename?: 'treatment_DeleteWoundRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteWoundResponse = {
  __typename?: 'treatment_DeleteWoundResponse';
  /** ID of deleted wound */
  deletedWoundId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteWoundVersionRequest = {
  __typename?: 'treatment_DeleteWoundVersionRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_DeleteWoundVersionResponse = {
  __typename?: 'treatment_DeleteWoundVersionResponse';
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and is returned here
   */
  activatedWoundRevision?: Maybe<Treatment_WoundMsg>;
  /**
   * when the target was a version that was already ACTIVE, then a new revision that is marked as deleted can be created
   *  and a previous one is deactivated, which is returned here
   */
  deactivatedWoundRevision?: Maybe<Treatment_WoundMsg>;
};

export type Treatment_DeletedPhysicalBlockInfoMsg = {
  __typename?: 'treatment_DeletedPhysicalBlockInfoMsg';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  deletedBlockId?: Maybe<Scalars['String']>;
};

export enum Treatment_DeliriumDetectionAgitation {
  /** moderate agitation (4) */
  DeliriumDetectionAgitationModerateAgitation = 'DELIRIUM_DETECTION_AGITATION_MODERATE_AGITATION',
  DeliriumDetectionAgitationNone = 'DELIRIUM_DETECTION_AGITATION_NONE',
  /** none (normal activity) (0) */
  DeliriumDetectionAgitationNormalActivity = 'DELIRIUM_DETECTION_AGITATION_NORMAL_ACTIVITY',
  /** severe agitation (7) */
  DeliriumDetectionAgitationSevereAgitation = 'DELIRIUM_DETECTION_AGITATION_SEVERE_AGITATION',
  /** slightly increased (1) */
  DeliriumDetectionAgitationSlightlyIncreased = 'DELIRIUM_DETECTION_AGITATION_SLIGHTLY_INCREASED'
}

export enum Treatment_DeliriumDetectionAnxiety {
  /** none (at rest) (0) */
  DeliriumDetectionAnxietyAtRest = 'DELIRIUM_DETECTION_ANXIETY_AT_REST',
  /** minor (1) */
  DeliriumDetectionAnxietyMinor = 'DELIRIUM_DETECTION_ANXIETY_MINOR',
  /** (intermittent) moderate (4) */
  DeliriumDetectionAnxietyModerate = 'DELIRIUM_DETECTION_ANXIETY_MODERATE',
  DeliriumDetectionAnxietyNone = 'DELIRIUM_DETECTION_ANXIETY_NONE',
  /** panic attack (7) */
  DeliriumDetectionAnxietyPanicAttack = 'DELIRIUM_DETECTION_ANXIETY_PANIC_ATTACK'
}

export type Treatment_DeliriumDetectionBlock = {
  __typename?: 'treatment_DeliriumDetectionBlock';
  agitation?: Maybe<Treatment_DeliriumDetectionAgitation>;
  anxiety?: Maybe<Treatment_DeliriumDetectionAnxiety>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  hallucination?: Maybe<Treatment_DeliriumDetectionHallucination>;
  myocloniasEpilepticSeizuresSelection?: Maybe<Treatment_MyocloniasEpilepticSeizuresSelection>;
  orientation?: Maybe<Treatment_DeliriumDetectionOrientation>;
  paroxysmalSweating?: Maybe<Treatment_DeliriumDetectionParoxysmalSweating>;
  score?: Maybe<Scalars['Int']>;
  sleepWakeRhythm?: Maybe<Treatment_SleepWakeRhythm>;
  tremor?: Maybe<Treatment_DeliriumDetectionTremor>;
};

export enum Treatment_DeliriumDetectionHallucination {
  DeliriumDetectionHallucinationNone = 'DELIRIUM_DETECTION_HALLUCINATION_NONE',
  /** none(0) */
  DeliriumDetectionHallucinationNotAtAll = 'DELIRIUM_DETECTION_HALLUCINATION_NOT_AT_ALL',
  /** occasional (mild) (1) */
  DeliriumDetectionHallucinationOccasionalMild = 'DELIRIUM_DETECTION_HALLUCINATION_OCCASIONAL_MILD',
  /** permanent (mild) (4) */
  DeliriumDetectionHallucinationPermanentMild = 'DELIRIUM_DETECTION_HALLUCINATION_PERMANENT_MILD',
  /** permanent (severe) (7) */
  DeliriumDetectionHallucinationPermanentSevere = 'DELIRIUM_DETECTION_HALLUCINATION_PERMANENT_SEVERE'
}

export enum Treatment_DeliriumDetectionOrientation {
  /** Oriented to time, place and person, ability to concentrate maintained (0) */
  DeliriumDetectionOrientationAbilityToConcentrateMaintained = 'DELIRIUM_DETECTION_ORIENTATION_ABILITY_TO_CONCENTRATE_MAINTAINED',
  /** Uncertain about orientation to place and/or time, inability to concentrate (1) */
  DeliriumDetectionOrientationInabilityToConcentrateMaintained = 'DELIRIUM_DETECTION_ORIENTATION_INABILITY_TO_CONCENTRATE_MAINTAINED',
  /** Lack of orientation to place and/or time (4) */
  DeliriumDetectionOrientationLackOfOrientationToPlaceOrTime = 'DELIRIUM_DETECTION_ORIENTATION_LACK_OF_ORIENTATION_TO_PLACE_OR_TIME',
  /** lack of orientation to time, place and person (7) */
  DeliriumDetectionOrientationLackOfOrientationToPlaceTimePerson = 'DELIRIUM_DETECTION_ORIENTATION_LACK_OF_ORIENTATION_TO_PLACE_TIME_PERSON',
  DeliriumDetectionOrientationNone = 'DELIRIUM_DETECTION_ORIENTATION_NONE'
}

export enum Treatment_DeliriumDetectionParoxysmalSweating {
  /** hardly any (usually confined to palm) (1) */
  DeliriumDetectionParoxysmalSweatingHardlyAnyConfinedToPalm = 'DELIRIUM_DETECTION_PAROXYSMAL_SWEATING_HARDLY_ANY_CONFINED_TO_PALM',
  DeliriumDetectionParoxysmalSweatingNone = 'DELIRIUM_DETECTION_PAROXYSMAL_SWEATING_NONE',
  /** none (0) */
  DeliriumDetectionParoxysmalSweatingNotAtAll = 'DELIRIUM_DETECTION_PAROXYSMAL_SWEATING_NOT_AT_ALL',
  /** severe hyperhidrosis (patient wet) (7) */
  DeliriumDetectionParoxysmalSweatingSevereHyperhidrosis = 'DELIRIUM_DETECTION_PAROXYSMAL_SWEATING_SEVERE_HYPERHIDROSIS',
  /** visible on forehead (4) */
  DeliriumDetectionParoxysmalSweatingVisibleOnForehead = 'DELIRIUM_DETECTION_PAROXYSMAL_SWEATING_VISIBLE_ON_FOREHEAD'
}

export enum Treatment_DeliriumDetectionTremor {
  /** moderate (outstretched arms) (4) */
  DeliriumDetectionTremorModerate = 'DELIRIUM_DETECTION_TREMOR_MODERATE',
  DeliriumDetectionTremorNone = 'DELIRIUM_DETECTION_TREMOR_NONE',
  /** none (0) */
  DeliriumDetectionTremorNotAtAll = 'DELIRIUM_DETECTION_TREMOR_NOT_AT_ALL',
  /** only noticeable (fingertips) (1) */
  DeliriumDetectionTremorOnlyNoticeable = 'DELIRIUM_DETECTION_TREMOR_ONLY_NOTICEABLE',
  /** severe (even not outstretched arms) (7) */
  DeliriumDetectionTremorSevere = 'DELIRIUM_DETECTION_TREMOR_SEVERE'
}

export type Treatment_DemTectBlock = {
  __typename?: 'treatment_DemTectBlock';
  /** Age <60 years: <yes/no> (singleselect) */
  ageLessThan60?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /**
   * Task 2: Convert numbers and number words (max. 4 points): <numeric input> (non-negative integers from 0-4)
   * if age < 60 years :
   * Evaluation Task 2: <0 points (0) / 1-2 points (1) / 3 points (2) / 4 points (3)> (singleselect)
   * else :
   * Evaluation Task 2: <0 points (0) / 1-2 points (1) / 3 points (2) / 4 points (3)> (singleselect)
   */
  convertNumbersAndNumberWords?: Maybe<Scalars['Int']>;
  /**
   * Task 4: Repeat number sequence backwards (max 6 points): <numeric input> (non-negative integers from 0-6)
   * if age < 60 years :
   * Evaluation Task 4: <0 points (0) / 2-3points (1) / 4 points (2) / 5-6 points (3)> (singleselect)
   * else :
   * Evaluation Task 4: <0 points (0) / 2 points (1) / 3 points (2) / 4-6 points (3)> (singleselect)
   */
  repeatNumberSequenceBackwards?: Maybe<Scalars['Int']>;
  /**
   * Task 1: Repeat word list (max. 20 points): <numeric input> (non-negative integers from 0-20)
   * if age < 60 years :
   * Evaluation Task 1: <0-7 points (0) / 8-10 points (1) / 11-12 points (2) / 13-20 points (3)>
   * else :
   * Evaluation Task 1: <0-6 points (0) / 7-8 points (1) / 9-10 points (2) / 11-20 points (3)>
   */
  repeatWordList?: Maybe<Scalars['Int']>;
  /**
   * Task 5: repeat word list from task 1 (max. 10 points): <numeric input> (non-negative integers from 0-10)
   * if age < 60 years :
   * Evaluation Task 5: <0 points (0) / 1-3 points (1) / 4-5 points (2) / 6-10 points (5)> (singleselect)
   * else :
   * Evaluation Task 5: <0 points (0) / 1-2 points (1) / 3-4 points (2) / 5-10 points (5)> (singleselect)
   */
  repeatWordListAgain?: Maybe<Scalars['Int']>;
  /** Automatic addition of points based on points from Evaluation of tasks */
  score?: Maybe<Scalars['Int']>;
  /**
   * Task 3: Supermarket task (max. 30 points): <numeric input> (non-negative integers from 0-30)
   * if age < 60 years :
   * Evaluation Task 3: <0-12 points (0) / 13-15 points (1) / 16-19 points (2) / 20-30 points (4)> (singleselect)
   * else :
   * Evaluation Task 3: <0-5 points (0) / 6-9 points (1) / 10-15 points (2) / 16-30 points (4)> (singleselect)
   */
  supermarketTask?: Maybe<Scalars['Int']>;
};

export type Treatment_DentureMsg = {
  __typename?: 'treatment_DentureMsg';
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Core_KnowledgeInputMsg>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_DenturesBlock = {
  __typename?: 'treatment_DenturesBlock';
  dentures?: Maybe<Array<Maybe<Treatment_DentureMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_DermatologyLifeQualityIndexBlock = {
  __typename?: 'treatment_DermatologyLifeQualityIndexBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** 1: Over the last week, how itchy, sore, painful or stinging has your skin been? */
  painfulSkinStatus?: Maybe<Treatment_DlqiSelection>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** 9: Over the last week, how much has your skin caused any sexual difficulties? */
  skinConditionCausesSexualDifficulties?: Maybe<Treatment_DlqiSelection>;
  /** 7b: f "No", over the last week how much has your skin been a problem at work or studying?: */
  skinConditionImpactAtWork?: Maybe<Treatment_DlqiSelection>;
  /** 3: Over the last week, how much has your skin interfered with you going shopping or looking after your home or garden? */
  skinConditionImpactOnDailyActivities?: Maybe<Treatment_DlqiSelection>;
  /** 5: Over the last week, how much has your skin affected any social or leisure activities? */
  skinConditionImpactOnSocialActivities?: Maybe<Treatment_DlqiSelection>;
  /** 8: Over the last week, how much has your skin created problems with your partner or any of your close friends or relatives? */
  skinConditionImpactSocialRelationship?: Maybe<Treatment_DlqiSelection>;
  /** 4: Over the last week, how much has your skin influenced the clothes you wear? */
  skinConditionInfluencedByClothes?: Maybe<Treatment_DlqiSelection>;
  /** 6: Over the last week, how much has your skin made it difficult for you to do any sport? */
  skinDifficultyToDoSport?: Maybe<Treatment_DlqiSelection>;
  /** 2: Over the last week, how embarrassed self-conscious have you been because of your skin? */
  skinEmbarrassment?: Maybe<Treatment_DlqiSelection>;
  /** 7a: Over the last week, has your skin prevented you from working or studying? */
  skinPreventionFromWorking?: Maybe<Treatment_DlqiSelection>;
  /** 10: Over the last week, how much of a problem has the treatment for your skin been, for example by making your home messy, or by taking up time? */
  skinTreatmentDisruptionLevel?: Maybe<Treatment_DlqiSelection>;
};

export enum Treatment_Dermatome {
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  C6 = 'C6',
  C7 = 'C7',
  C8 = 'C8',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L4 = 'L4',
  L5 = 'L5',
  None = 'NONE',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
  S5 = 'S5',
  Th1 = 'Th1',
  Th2 = 'Th2',
  Th3 = 'Th3',
  Th4 = 'Th4',
  Th5 = 'Th5',
  Th6 = 'Th6',
  Th7 = 'Th7',
  Th8 = 'Th8',
  Th9 = 'Th9',
  Th10 = 'Th10',
  Th11 = 'Th11',
  Th12 = 'Th12'
}

export enum Treatment_DevelopmentOfContacts {
  DevelopmentOfContactsGainedNewAcquaintances = 'DEVELOPMENT_OF_CONTACTS_GAINED_NEW_ACQUAINTANCES',
  DevelopmentOfContactsGiveUpSomeContacts = 'DEVELOPMENT_OF_CONTACTS_GIVE_UP_SOME_CONTACTS',
  DevelopmentOfContactsLostAlmostAllContacts = 'DEVELOPMENT_OF_CONTACTS_LOST_ALMOST_ALL_CONTACTS',
  DevelopmentOfContactsNone = 'DEVELOPMENT_OF_CONTACTS_NONE',
  DevelopmentOfContactsNoChange = 'DEVELOPMENT_OF_CONTACTS_NO_CHANGE'
}

export type Treatment_DiagnosesDevelopmentMsg = {
  __typename?: 'treatment_DiagnosesDevelopmentMsg';
  conditionDevelopment?: Maybe<Treatment_ConditionDevelopment>;
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_DiagnosisAccessContextMsg = {
  __typename?: 'treatment_DiagnosisAccessContextMsg';
  /** the most specific context */
  specificContext?: Maybe<Treatment_DiagnosisContextReferenceMsg>;
  /** optional additional information */
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_DiagnosisCategory {
  DiagnosisCategoryNone = 'DIAGNOSIS_CATEGORY_NONE',
  DiagnosisCategoryPrimaryTreatment = 'DIAGNOSIS_CATEGORY_PRIMARY_TREATMENT',
  DiagnosisCategorySecondaryTreatment = 'DIAGNOSIS_CATEGORY_SECONDARY_TREATMENT'
}

export type Treatment_DiagnosisCategoryAssignmentMsg = {
  __typename?: 'treatment_DiagnosisCategoryAssignmentMsg';
  category?: Maybe<Treatment_DiagnosisCategory>;
  scopeId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_DiagnosisScopeType>;
};

export enum Treatment_DiagnosisCodeType {
  /** ICD-10 GM "Ausrufezeichenkode" */
  DiagnosisCodeTypeAdditional = 'DIAGNOSIS_CODE_TYPE_ADDITIONAL',
  /** ICD-10 GM "Sternkode" */
  DiagnosisCodeTypeAsterisk = 'DIAGNOSIS_CODE_TYPE_ASTERISK',
  /** ICD-10 GM "Kreuz-Schlüsselnummer" */
  DiagnosisCodeTypeCross = 'DIAGNOSIS_CODE_TYPE_CROSS',
  DiagnosisCodeTypeNone = 'DIAGNOSIS_CODE_TYPE_NONE',
  /** ICD-10 GM "Primärkode" (that is not "Kreuz-Schlüsselnummer) */
  DiagnosisCodeTypePrimary = 'DIAGNOSIS_CODE_TYPE_PRIMARY'
}

export type Treatment_DiagnosisCodingActivityInfoMsg = {
  __typename?: 'treatment_DiagnosisCodingActivityInfoMsg';
  latest?: Maybe<Scalars['Boolean']>;
  latestDiagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_DiagnosisCodingList = {
  __typename?: 'treatment_DiagnosisCodingList';
  diagnosisCodings?: Maybe<Array<Maybe<Treatment_DiagnosisCodingMsg>>>;
};

/** Standardized medical code for a diagnosis */
export type Treatment_DiagnosisCodingMsg = {
  __typename?: 'treatment_DiagnosisCodingMsg';
  codingId?: Maybe<Scalars['String']>;
  germanCodingDetails?: Maybe<Treatment_Diagnosis_German_GermanDiagnosisCodingDetailsMsg>;
  /** Allows grouping the same coding of different revisions of the same diagnosis together */
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** The name of the code */
  name?: Maybe<Scalars['String']>;
  /** id of person who inserted the data */
  recorderId?: Maybe<Core_PersonReferenceMsg>;
  system?: Maybe<Treatment_DiagnosisCodingSystem>;
  systemVersion?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  /** Relevant if the system uses multiple types of codes */
  type?: Maybe<Treatment_DiagnosisCodeType>;
  units?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
  /** id of person who last updated the data */
  updaterId?: Maybe<Core_PersonReferenceMsg>;
};

export enum Treatment_DiagnosisCodingSystem {
  DiagnosisCodingSystemAlphaId = 'DIAGNOSIS_CODING_SYSTEM_ALPHA_ID',
  DiagnosisCodingSystemIcd_10Gm = 'DIAGNOSIS_CODING_SYSTEM_ICD_10_GM',
  DiagnosisCodingSystemNone = 'DIAGNOSIS_CODING_SYSTEM_NONE',
  DiagnosisCodingSystemOrphaId = 'DIAGNOSIS_CODING_SYSTEM_ORPHA_ID'
}

/** contextId refers to billing case id when type is set to DIAGNOSIS_CONTEXT_TYPE_CODING */
export type Treatment_DiagnosisContextReferenceMsg = {
  __typename?: 'treatment_DiagnosisContextReferenceMsg';
  contextId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_DiagnosisContextType>;
};

export enum Treatment_DiagnosisContextType {
  /** billing context, e.g., in grouping view */
  DiagnosisContextTypeBillingCase = 'DIAGNOSIS_CONTEXT_TYPE_BILLING_CASE',
  DiagnosisContextTypeNone = 'DIAGNOSIS_CONTEXT_TYPE_NONE',
  /** patient outside a visit or more specific context */
  DiagnosisContextTypePatient = 'DIAGNOSIS_CONTEXT_TYPE_PATIENT',
  DiagnosisContextTypeSurgery = 'DIAGNOSIS_CONTEXT_TYPE_SURGERY',
  DiagnosisContextTypeTreatment = 'DIAGNOSIS_CONTEXT_TYPE_TREATMENT',
  /** visit outside a more specific procedure (e.g., treatment, surgery) */
  DiagnosisContextTypeVisit = 'DIAGNOSIS_CONTEXT_TYPE_VISIT'
}

export type Treatment_DiagnosisDetailMsg = {
  __typename?: 'treatment_DiagnosisDetailMsg';
  codes?: Maybe<Array<Maybe<Treatment_DiagnosisCodingMsg>>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  laterality?: Maybe<Laterality_Laterality>;
  status?: Maybe<Treatment_DiagnosisStatus>;
  type?: Maybe<Treatment_DiagnosisDetailType>;
};

export enum Treatment_DiagnosisDetailType {
  DiagnosisDetailTypeExclusion = 'DIAGNOSIS_DETAIL_TYPE_EXCLUSION',
  DiagnosisDetailTypeNone = 'DIAGNOSIS_DETAIL_TYPE_NONE',
  DiagnosisDetailTypeReliable = 'DIAGNOSIS_DETAIL_TYPE_RELIABLE',
  DiagnosisDetailTypeSuspected = 'DIAGNOSIS_DETAIL_TYPE_SUSPECTED',
  DiagnosisDetailTypeSymptomFreeAfterIllness = 'DIAGNOSIS_DETAIL_TYPE_SYMPTOM_FREE_AFTER_ILLNESS'
}

export type Treatment_DiagnosisDevelopmentMsg = {
  __typename?: 'treatment_DiagnosisDevelopmentMsg';
  conditionDevelopment?: Maybe<Treatment_ConditionDevelopment>;
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_DiagnosisList = {
  __typename?: 'treatment_DiagnosisList';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  treatmentId?: Maybe<Scalars['String']>;
};

export enum Treatment_DiagnosisLocalization {
  DiagnosisLocalizationBoth = 'DIAGNOSIS_LOCALIZATION_BOTH',
  DiagnosisLocalizationLeft = 'DIAGNOSIS_LOCALIZATION_LEFT',
  DiagnosisLocalizationNone = 'DIAGNOSIS_LOCALIZATION_NONE',
  DiagnosisLocalizationRight = 'DIAGNOSIS_LOCALIZATION_RIGHT'
}

export type Treatment_DiagnosisMsg = {
  __typename?: 'treatment_DiagnosisMsg';
  /** Period of time in which the diagnosed illness eased up */
  abatement?: Maybe<VeiosTimeFrameMsg>;
  /** id of person who gave the diagnosis */
  asserterId?: Maybe<Core_PersonReferenceMsg>;
  categoryAssignments?: Maybe<Array<Maybe<Treatment_DiagnosisCategoryAssignmentMsg>>>;
  causedByDiagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  clinicalStagings?: Maybe<Array<Maybe<Treatment_ClinicalStagingInputMsg>>>;
  /** only set if created in coding context for the given billing case */
  createdInBillingCaseId?: Maybe<Scalars['String']>;
  createdInClinicalRequestExecutionId?: Maybe<Scalars['String']>;
  /** only set if created within a surgery */
  createdInSurgeryId?: Maybe<Scalars['String']>;
  /** id of treatment diagnosis was created in */
  createdInTreatmentId?: Maybe<Scalars['String']>;
  /** only used for versioning purposes; will not be set if created in a more specific context (e.g., treatment) */
  createdInVisitId?: Maybe<Scalars['String']>;
  /** In combination with the createdIn... ids, defines where this version of the diagnosis was created */
  creationContextType?: Maybe<Treatment_DiagnosisContextType>;
  creationOrganizationalUnitId?: Maybe<Scalars['String']>;
  /**
   * obsolete, but has to be kept for documentation of old data
   * @deprecated deprecated in proto
   */
  dateOfFinalDiagnosis?: Maybe<Timestamp>;
  /** is set by backend, should not be edited by FE */
  deleted?: Maybe<Scalars['Boolean']>;
  diagnosisDetail?: Maybe<Treatment_DiagnosisDetailMsg>;
  differentialDiagnosesDetail?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  /**
   * Whether the diagnosis was not determined through treatment, but just an entry of old information
   * @deprecated deprecated in proto
   */
  external?: Maybe<Scalars['Boolean']>;
  /** If false, this diagnosis is newly created and was not initialized by editing/importing an existing diagnosis */
  hasPredecessor?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  /** While the version info is newly created for each version, the initial context tells where the diagnosis versioning group was originally created */
  initialCreationContext?: Maybe<Treatment_DiagnosisContextReferenceMsg>;
  /**
   * When this diagnosis was initially made.
   *  Can be before the date of entry if e.g., a different hospital or doctor's office made the diagnosis.
   *  When an updated diagnosis is entered, the initialDiagnosisDate of the previous version is transferred.
   */
  initialDiagnosisDate?: Maybe<VeiosDateTimeMsg>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** Period of time in which the diagnosed illness first appeared */
  onset?: Maybe<VeiosTimeFrameMsg>;
  patientId?: Maybe<Scalars['String']>;
  recommended?: Maybe<Scalars['Boolean']>;
  /** id of person who inserted the data */
  recorderId?: Maybe<Core_PersonReferenceMsg>;
  severity?: Maybe<Treatment_DiagnosisSeverity>;
  tagAssignments?: Maybe<Array<Maybe<Treatment_DiagnosisTagAssignmentMsg>>>;
  /** @deprecated deprecated in proto */
  text?: Maybe<Scalars['String']>;
  textHtml?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_DiagnosisType>;
  validated?: Maybe<Scalars['Boolean']>;
  versionInfo?: Maybe<Versioning_VersionInfoMsg>;
};

export type Treatment_DiagnosisPresenceMsg = {
  __typename?: 'treatment_DiagnosisPresenceMsg';
  codes?: Maybe<Array<Maybe<Treatment_DiagnosisCodingMsg>>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_DiagnosisScopeType {
  /** Used in clinical requests */
  DiagnosisScopeTypeClinicalRequest = 'DIAGNOSIS_SCOPE_TYPE_CLINICAL_REQUEST',
  DiagnosisScopeTypeNone = 'DIAGNOSIS_SCOPE_TYPE_NONE',
  DiagnosisScopeTypeSurgery = 'DIAGNOSIS_SCOPE_TYPE_SURGERY',
  /** Used for treatment diagnoses, i.e., not those documented as previous diagnoses, but in the diagnosis step */
  DiagnosisScopeTypeTreatment = 'DIAGNOSIS_SCOPE_TYPE_TREATMENT',
  /** Used in medical admission */
  DiagnosisScopeTypeVisit = 'DIAGNOSIS_SCOPE_TYPE_VISIT'
}

export enum Treatment_DiagnosisSeverity {
  DiagnosisSeverityMild = 'DIAGNOSIS_SEVERITY_MILD',
  DiagnosisSeverityModerate = 'DIAGNOSIS_SEVERITY_MODERATE',
  DiagnosisSeverityNone = 'DIAGNOSIS_SEVERITY_NONE',
  DiagnosisSeveritySevere = 'DIAGNOSIS_SEVERITY_SEVERE'
}

export enum Treatment_DiagnosisStatus {
  DiagnosisStatusActive = 'DIAGNOSIS_STATUS_ACTIVE',
  DiagnosisStatusActiveRecurrence = 'DIAGNOSIS_STATUS_ACTIVE_RECURRENCE',
  DiagnosisStatusActiveRelapse = 'DIAGNOSIS_STATUS_ACTIVE_RELAPSE',
  DiagnosisStatusInactive = 'DIAGNOSIS_STATUS_INACTIVE',
  DiagnosisStatusInactiveRemission = 'DIAGNOSIS_STATUS_INACTIVE_REMISSION',
  DiagnosisStatusInactiveResolved = 'DIAGNOSIS_STATUS_INACTIVE_RESOLVED',
  DiagnosisStatusNone = 'DIAGNOSIS_STATUS_NONE'
}

export enum Treatment_DiagnosisTag {
  DiagnosisTagAdmission = 'DIAGNOSIS_TAG_ADMISSION',
  DiagnosisTagNone = 'DIAGNOSIS_TAG_NONE',
  DiagnosisTagReferral = 'DIAGNOSIS_TAG_REFERRAL'
}

export type Treatment_DiagnosisTagAssignmentMsg = {
  __typename?: 'treatment_DiagnosisTagAssignmentMsg';
  tag?: Maybe<Treatment_DiagnosisTag>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_DiagnosisType {
  DiagnosisTypeAcute = 'DIAGNOSIS_TYPE_ACUTE',
  DiagnosisTypeAnamnestic = 'DIAGNOSIS_TYPE_ANAMNESTIC',
  DiagnosisTypeNone = 'DIAGNOSIS_TYPE_NONE',
  DiagnosisTypePermanent = 'DIAGNOSIS_TYPE_PERMANENT'
}

export type Treatment_DialysisCatheterMsg = {
  __typename?: 'treatment_DialysisCatheterMsg';
  insertion?: Maybe<Core_KnowledgeInputMsg>;
  numberOfLumen?: Maybe<Scalars['Int']>;
  skinLevel?: Maybe<Scalars['Float']>;
};

export type Treatment_DicBlock = {
  __typename?: 'treatment_DicBlock';
  completed?: Maybe<Scalars['Boolean']>;
  fibrinFormationMarker?: Maybe<Treatment_DicFibrinFormationMarker>;
  fibrinogen?: Maybe<Treatment_DicFibrinogen>;
  platelets?: Maybe<Treatment_DicPlatelets>;
  prothrombinTimeProlongation?: Maybe<Treatment_DicProthrombinTimeProlongation>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_DicFibrinFormationMarker {
  DicFibrinFormationMarkerHighlyElevated = 'DIC_FIBRIN_FORMATION_MARKER_HIGHLY_ELEVATED',
  DicFibrinFormationMarkerModeratelyElevated = 'DIC_FIBRIN_FORMATION_MARKER_MODERATELY_ELEVATED',
  DicFibrinFormationMarkerNone = 'DIC_FIBRIN_FORMATION_MARKER_NONE',
  DicFibrinFormationMarkerNotElevated = 'DIC_FIBRIN_FORMATION_MARKER_NOT_ELEVATED'
}

export enum Treatment_DicFibrinogen {
  DicFibrinogenGreaterThan_1 = 'DIC_FIBRINOGEN_GREATER_THAN_1',
  DicFibrinogenLessThan_1 = 'DIC_FIBRINOGEN_LESS_THAN_1',
  DicFibrinogenNone = 'DIC_FIBRINOGEN_NONE'
}

export enum Treatment_DicPlatelets {
  DicPlateletsBetween_100000And_50000 = 'DIC_PLATELETS_BETWEEN_100000_AND_50000',
  DicPlateletsGreaterThan_100000 = 'DIC_PLATELETS_GREATER_THAN_100000',
  DicPlateletsLessThan_50000 = 'DIC_PLATELETS_LESS_THAN_50000',
  DicPlateletsNone = 'DIC_PLATELETS_NONE'
}

export enum Treatment_DicProthrombinTimeProlongation {
  DicProthrombinTimeProlongationBetween_3And_6 = 'DIC_PROTHROMBIN_TIME_PROLONGATION_BETWEEN_3_AND_6',
  DicProthrombinTimeProlongationGreaterThan_6 = 'DIC_PROTHROMBIN_TIME_PROLONGATION_GREATER_THAN_6',
  DicProthrombinTimeProlongationLessThan_3 = 'DIC_PROTHROMBIN_TIME_PROLONGATION_LESS_THAN_3',
  DicProthrombinTimeProlongationNone = 'DIC_PROTHROMBIN_TIME_PROLONGATION_NONE'
}

export enum Treatment_DietaryBehavior {
  DietaryBehaviorBalanced = 'DIETARY_BEHAVIOR_BALANCED',
  DietaryBehaviorNone = 'DIETARY_BEHAVIOR_NONE',
  DietaryBehaviorUnbalanced = 'DIETARY_BEHAVIOR_UNBALANCED'
}

export enum Treatment_DifficultyConcentrating {
  DifficultyConcentratingCannotConcentrate = 'DIFFICULTY_CONCENTRATING_CANNOT_CONCENTRATE',
  DifficultyConcentratingCannotConcentrateAtAll = 'DIFFICULTY_CONCENTRATING_CANNOT_CONCENTRATE_AT_ALL',
  DifficultyConcentratingCanConcentrate = 'DIFFICULTY_CONCENTRATING_CAN_CONCENTRATE',
  DifficultyConcentratingDifficultToConcentrateForLengthOfTime = 'DIFFICULTY_CONCENTRATING_DIFFICULT_TO_CONCENTRATE_FOR_LENGTH_OF_TIME',
  DifficultyConcentratingNone = 'DIFFICULTY_CONCENTRATING_NONE'
}

export enum Treatment_DifficultySelect {
  /** with great difficulty or not possible (0) */
  DifficultySelectGreat = 'DIFFICULTY_SELECT_GREAT',
  DifficultySelectNone = 'DIFFICULTY_SELECT_NONE',
  /** without difficulty (5) */
  DifficultySelectNoDifficulty = 'DIFFICULTY_SELECT_NO_DIFFICULTY',
  /** with difficulty and use of handrail (3) */
  DifficultySelectSome = 'DIFFICULTY_SELECT_SOME'
}

export type Treatment_DigitalRectalExamBlock = {
  __typename?: 'treatment_DigitalRectalExamBlock';
  analReflexPresent?: Maybe<Scalars['Boolean']>;
  bloodOnGlovePresent?: Maybe<Scalars['Boolean']>;
  faecesOnGlovePresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  mucousMembraneText?: Maybe<Scalars['String']>;
  mucousMembranes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  pressurePainPresent?: Maybe<Scalars['Boolean']>;
  resistances?: Maybe<Array<Maybe<Treatment_DigitalRectalResistanceMsg>>>;
  resistancesPresent?: Maybe<Scalars['Boolean']>;
  sphincterTonus?: Maybe<Treatment_SphincterTonusType>;
};

export type Treatment_DigitalRectalResistanceMsg = {
  __typename?: 'treatment_DigitalRectalResistanceMsg';
  id?: Maybe<Scalars['String']>;
  /** Clock-like system from 1 to 12 */
  localizations?: Maybe<Array<Maybe<Treatment_ResistanceLocation>>>;
  text?: Maybe<Scalars['String']>;
};

/**
 * A collection of all vaccination-relevant information for one patient, specified by the patientId.
 *  Aimed at containing all information required by the German "Digitaler Impfpass".
 */
export type Treatment_DigitalVaccinationCertificateMsg = {
  __typename?: 'treatment_DigitalVaccinationCertificateMsg';
  /** Id of the photo/scan of the paper vaccination certificate */
  fileId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  immunityTests?: Maybe<Array<Maybe<Treatment_ImmunityTestMsg>>>;
  patientId?: Maybe<Scalars['String']>;
  relevantDiseases?: Maybe<Array<Maybe<Treatment_VaccinationRelevantDiseaseMsg>>>;
  vaccinations?: Maybe<Array<Maybe<Treatment_VaccinationMsg>>>;
};

export type Treatment_DiseasesOfFamilyMemberMsg = {
  __typename?: 'treatment_DiseasesOfFamilyMemberMsg';
  dateOfDeath?: Maybe<VeiosDateTimeMsg>;
  degreeOfRelationship?: Maybe<Core_KnowledgeInputMsg>;
  diagnosisDetails?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  id?: Maybe<Scalars['String']>;
  passedAway?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_DiseasesOfFamilyMembersBlock = {
  __typename?: 'treatment_DiseasesOfFamilyMembersBlock';
  familyMembersDiseases?: Maybe<Array<Maybe<Treatment_DiseasesOfFamilyMemberMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_DlqiSelection {
  /** a little (1) */
  DlqiSelectionALittle = 'DLQI_SELECTION_A_LITTLE',
  /** a lot (2) */
  DlqiSelectionALot = 'DLQI_SELECTION_A_LOT',
  DlqiSelectionNone = 'DLQI_SELECTION_NONE',
  /** not at all (0) */
  DlqiSelectionNotAtAll = 'DLQI_SELECTION_NOT_AT_ALL',
  /** not relevant (0) */
  DlqiSelectionNotRelevant = 'DLQI_SELECTION_NOT_RELEVANT',
  /** very much (3) */
  DlqiSelectionVeryMuch = 'DLQI_SELECTION_VERY_MUCH'
}

export type Treatment_DosBlock = {
  __typename?: 'treatment_DosBlock';
  /** Gives answers that do not fit the question */
  answersDoesNotFitTheQuestion?: Maybe<Treatment_DosSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Knows which part of the day it is */
  dayPartAwareness?: Maybe<Treatment_DosSelectionNegation>;
  /** Does not finish question or answer */
  doesNotFinishQuestionOrAnswer?: Maybe<Treatment_DosSelection>;
  /** Dozes during conversation or activities */
  dozesDuringActivities?: Maybe<Treatment_DosSelection>;
  /** Is easily distracted by stimuli from the environment */
  easilyDistracted?: Maybe<Treatment_DosSelection>;
  /** Is easily or suddenly emotional */
  easilyEmotional?: Maybe<Treatment_DosSelection>;
  /** Sees / hears things which are not there */
  imaginarySensation?: Maybe<Treatment_DosSelection>;
  /** Is picking, disorderly, restless */
  isPickingDisorderlyRestless?: Maybe<Treatment_DosSelection>;
  /** Maintains attention to conversation or action */
  maintainAttentionToAction?: Maybe<Treatment_DosSelectionNegation>;
  /** Pulls IV tubes, feeding tubes, catheters */
  pullsIvTubesFeedingTubes?: Maybe<Treatment_DosSelection>;
  /** Reacts slowly to instructions */
  reactsSlowlyToInstructions?: Maybe<Treatment_DosSelection>;
  /** Remembers recent event */
  rememberRecentEvent?: Maybe<Treatment_DosSelectionNegation>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** Thinks to be somewhere else */
  thinksToBeSomewhereElse?: Maybe<Treatment_DosSelection>;
};

export enum Treatment_DosSelection {
  /** never (0) */
  DosSelectionNever = 'DOS_SELECTION_NEVER',
  DosSelectionNone = 'DOS_SELECTION_NONE',
  /** sometimes – always (1) */
  DosSelectionSometimesAlways = 'DOS_SELECTION_SOMETIMES_ALWAYS',
  DosSelectionSometimesUnknown = 'DOS_SELECTION_SOMETIMES_UNKNOWN'
}

export enum Treatment_DosSelectionNegation {
  /** never (1) */
  DosSelectionNegationNever = 'DOS_SELECTION_NEGATION_NEVER',
  DosSelectionNegationNone = 'DOS_SELECTION_NEGATION_NONE',
  /** sometimes – always (0) */
  DosSelectionNegationSometimesAlways = 'DOS_SELECTION_NEGATION_SOMETIMES_ALWAYS',
  DosSelectionNegationSometimesUnknown = 'DOS_SELECTION_NEGATION_SOMETIMES_UNKNOWN'
}

export enum Treatment_Dressing {
  /** Assistance from other person required */
  DressingAssistanceRequired = 'DRESSING_ASSISTANCE_REQUIRED',
  /** Intermittent HIlp or assistive procedures are required */
  DressingAssistiveProceduresRequired = 'DRESSING_ASSISTIVE_PROCEDURES_REQUIRED',
  DressingCompleteDependence = 'DRESSING_COMPLETE_DEPENDENCE',
  DressingNone = 'DRESSING_NONE',
  /** No assistance required, but requires effort */
  DressingRequiresEffort = 'DRESSING_REQUIRES_EFFORT',
  DressingUndisturbed = 'DRESSING_UNDISTURBED'
}

export type Treatment_DrugAndAddictiveSubstanceMsg = {
  __typename?: 'treatment_DrugAndAddictiveSubstanceMsg';
  currentConsumption?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyReference?: Maybe<Treatment_ConsumptionFrequencyReference>;
  id?: Maybe<Scalars['String']>;
  substance?: Maybe<Core_KnowledgeInputMsg>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_DysarthriaTestResult {
  DysarthriaTestComa = 'DYSARTHRIA_TEST_COMA',
  DysarthriaTestIntubation = 'DYSARTHRIA_TEST_INTUBATION',
  DysarthriaTestMildToModerate = 'DYSARTHRIA_TEST_MILD_TO_MODERATE',
  DysarthriaTestNone = 'DYSARTHRIA_TEST_NONE',
  DysarthriaTestNothing = 'DYSARTHRIA_TEST_NOTHING',
  DysarthriaTestSevere = 'DYSARTHRIA_TEST_SEVERE'
}

export enum Treatment_Dysphagia {
  DysphagiaComplete = 'DYSPHAGIA_COMPLETE',
  DysphagiaNone = 'DYSPHAGIA_NONE',
  DysphagiaNotAtAll = 'DYSPHAGIA_NOT_AT_ALL',
  DysphagiaWithLiquidFood = 'DYSPHAGIA_WITH_LIQUID_FOOD',
  DysphagiaWithMushyFood = 'DYSPHAGIA_WITH_MUSHY_FOOD'
}

export enum Treatment_DyspneaAtsGrade {
  DyspneaAtsGrade_0 = 'DYSPNEA_ATS_GRADE_0',
  DyspneaAtsGrade_1 = 'DYSPNEA_ATS_GRADE_1',
  DyspneaAtsGrade_2 = 'DYSPNEA_ATS_GRADE_2',
  DyspneaAtsGrade_3 = 'DYSPNEA_ATS_GRADE_3',
  DyspneaAtsGrade_4 = 'DYSPNEA_ATS_GRADE_4',
  DyspneaAtsGradeNone = 'DYSPNEA_ATS_GRADE_NONE'
}

export type Treatment_DyspneaAnamnesticBlock = {
  __typename?: 'treatment_DyspneaAnamnesticBlock';
  atsGrade?: Maybe<Treatment_DyspneaAtsGrade>;
  atsGradeText?: Maybe<Scalars['String']>;
  auxiliaryRespiratoryMuscleUse?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  muscleUseDescription?: Maybe<Scalars['String']>;
  occurrence?: Maybe<Treatment_SymptomOnsetType>;
  occurrenceSituation?: Maybe<Treatment_DyspneaSituation>;
  occurrenceSituationDescription?: Maybe<Scalars['String']>;
  paroxysmalDyspnea?: Maybe<Treatment_ParoxysmalDyspneaMsg>;
  persistentDyspnea?: Maybe<Treatment_PersistentDyspneaMsg>;
  positionDependence?: Maybe<Scalars['Boolean']>;
  positionDependenceDescription?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  qualities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_DyspneaCourse {
  DyspneaCourseNone = 'DYSPNEA_COURSE_NONE',
  DyspneaCourseProgressive = 'DYSPNEA_COURSE_PROGRESSIVE',
  DyspneaCourseSymptomFreeIntervals = 'DYSPNEA_COURSE_SYMPTOM_FREE_INTERVALS'
}

export enum Treatment_DyspneaResolution {
  DyspneaResolutionDay = 'DYSPNEA_RESOLUTION_DAY',
  DyspneaResolutionMonth = 'DYSPNEA_RESOLUTION_MONTH',
  DyspneaResolutionNone = 'DYSPNEA_RESOLUTION_NONE',
  DyspneaResolutionWeek = 'DYSPNEA_RESOLUTION_WEEK'
}

export enum Treatment_DyspneaSituation {
  DyspneaSituationExertion = 'DYSPNEA_SITUATION_EXERTION',
  DyspneaSituationNone = 'DYSPNEA_SITUATION_NONE',
  DyspneaSituationRest = 'DYSPNEA_SITUATION_REST'
}

export type Treatment_EarPartInspectionAbnormalityMsg = {
  __typename?: 'treatment_EarPartInspectionAbnormalityMsg';
  combined?: Maybe<Treatment_EarPartSideInspectionMsg>;
  documentationMode?: Maybe<Treatment_LateralityDocumentationMode>;
  id?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_EarPartSideInspectionMsg>;
  right?: Maybe<Treatment_EarPartSideInspectionMsg>;
};

export type Treatment_EarPartInspectionMsg = {
  __typename?: 'treatment_EarPartInspectionMsg';
  abnormalities?: Maybe<Array<Maybe<Treatment_EarPartInspectionAbnormalityMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_EarPartSideInspectionMsg = {
  __typename?: 'treatment_EarPartSideInspectionMsg';
  abnormality?: Maybe<Treatment_PhysicalAbnormalityMsg>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_EarlyRehabilitationBarthelIndexBlock = {
  __typename?: 'treatment_EarlyRehabilitationBarthelIndexBlock';
  barthelIndexFields?: Maybe<Treatment_BarthelIndexFieldsMsg>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  frIndex?: Maybe<Treatment_FrIndexMsg>;
  score?: Maybe<Scalars['Int']>;
};

export type Treatment_EarsInspectionBlock = {
  __typename?: 'treatment_EarsInspectionBlock';
  earCanals?: Maybe<Treatment_EarPartInspectionMsg>;
  externalEars?: Maybe<Treatment_EarPartInspectionMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  mastoid?: Maybe<Treatment_MastoidInspectionMsg>;
  tympanicMembranes?: Maybe<Treatment_EarPartInspectionMsg>;
};

export enum Treatment_EatingAssistance {
  /** needs help eating (0) */
  EatingAssistanceNeedsHelp = 'EATING_ASSISTANCE_NEEDS_HELP',
  EatingAssistanceNone = 'EATING_ASSISTANCE_NONE',
  /** eats without help, no difficulty (2) */
  EatingAssistanceWithoutHelpWithoutDifficulty = 'EATING_ASSISTANCE_WITHOUT_HELP_WITHOUT_DIFFICULTY',
  /** eats without help but with difficulty (1) */
  EatingAssistanceWithoutHelpWithDifficulty = 'EATING_ASSISTANCE_WITHOUT_HELP_WITH_DIFFICULTY'
}

export enum Treatment_EatingHabit {
  EatingHabitNone = 'EATING_HABIT_NONE',
  /** no decrease in food intake (2) */
  EatingHabitNoDecreaseInFoodIntake = 'EATING_HABIT_NO_DECREASE_IN_FOOD_INTAKE',
  /** severe decrease in food intake (0) */
  EatingHabitSevereDecreaseInFoodIntake = 'EATING_HABIT_SEVERE_DECREASE_IN_FOOD_INTAKE',
  /** slight decrease in food intake (1) */
  EatingHabitSlightDecreaseInFoodIntake = 'EATING_HABIT_SLIGHT_DECREASE_IN_FOOD_INTAKE'
}

export type Treatment_EchocardiographyMsg = {
  __typename?: 'treatment_EchocardiographyMsg';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_EclamBlock = {
  __typename?: 'treatment_EclamBlock';
  /** Joint complaints */
  arthritis?: Maybe<Scalars['Boolean']>;
  /** Skin mucosal involvement */
  butterflyErythema?: Maybe<Scalars['Boolean']>;
  /** Complement depletion */
  c3?: Maybe<Scalars['Boolean']>;
  c50?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  discoidErythema?: Maybe<Scalars['Boolean']>;
  /** ESR (Elevation) */
  esrElevation?: Maybe<Scalars['Boolean']>;
  fatigue?: Maybe<Scalars['Boolean']>;
  /** General symptoms */
  fever?: Maybe<Scalars['Boolean']>;
  functionalImpairment?: Maybe<Scalars['Boolean']>;
  generalizedErythema?: Maybe<Scalars['Boolean']>;
  /** Cns involvement */
  headacheOrMigraine?: Maybe<Scalars['Boolean']>;
  hematuria?: Maybe<Scalars['Boolean']>;
  hemolyticAnemia?: Maybe<Scalars['Boolean']>;
  increasingDyspnea?: Maybe<Scalars['Boolean']>;
  leukopeniaOrLymphopenia?: Maybe<Scalars['Boolean']>;
  /** Myositis */
  myositis?: Maybe<Scalars['Boolean']>;
  newAthralgias?: Maybe<Scalars['Boolean']>;
  /** Hematologic involvement */
  nonHemolyticAnemia?: Maybe<Scalars['Boolean']>;
  oralUlcers?: Maybe<Scalars['Boolean']>;
  organicBrainPsychosyndrome?: Maybe<Scalars['Boolean']>;
  pathologicSediment?: Maybe<Scalars['Boolean']>;
  /** Pericarditis */
  pericarditis?: Maybe<Scalars['Boolean']>;
  /** Pulmonary involvement */
  pleuritis?: Maybe<Scalars['Boolean']>;
  pneumonitis?: Maybe<Scalars['Boolean']>;
  /** Renal involvement */
  proteinuria?: Maybe<Scalars['Boolean']>;
  psychosis?: Maybe<Scalars['Boolean']>;
  renalManifestationNewOrWorsened?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  seizures?: Maybe<Scalars['Boolean']>;
  skinMucosalManifestationNewOrWorsening?: Maybe<Scalars['Boolean']>;
  sterilePeritonitis?: Maybe<Scalars['Boolean']>;
  stroke?: Maybe<Scalars['Boolean']>;
  thrombocytopenia?: Maybe<Scalars['Boolean']>;
  /** Intestinal involvement */
  vasculitis?: Maybe<Scalars['Boolean']>;
  vasculitisOfTheSkin?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_EcogGrade {
  /** 4 - completely disabled, cannot carry on any self-care, totally confined to bed or chair */
  EcogGradeCompletelyDisabled = 'ECOG_GRADE_COMPLETELY_DISABLED',
  /** 5 - dead */
  EcogGradeDead = 'ECOG_GRADE_DEAD',
  /** 0 - Fully active */
  EcogGradeFullyActive = 'ECOG_GRADE_FULLY_ACTIVE',
  /** 3 - capable of only limited self-care, confined to bed or chair more than 50% of waking hours */
  EcogGradeLimitedSelfCare = 'ECOG_GRADE_LIMITED_SELF_CARE',
  /** 1- restricted in physically strenuous activity but ambulatory and able to carry out work of a light or sedentary nature */
  EcogGradeModerateActive = 'ECOG_GRADE_MODERATE_ACTIVE',
  /** 2 - ambulatory and capable of all self-care but unable to carry out any work activities, up and about more than 50% of waking hours */
  EcogGradeMostlySelfCare = 'ECOG_GRADE_MOSTLY_SELF_CARE',
  EcogGradeNone = 'ECOG_GRADE_NONE'
}

export type Treatment_EcogStatusBlock = {
  __typename?: 'treatment_EcogStatusBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  ecogGrade?: Maybe<Treatment_EcogGrade>;
};

export type Treatment_EconomicCircumstancesMsg = {
  __typename?: 'treatment_EconomicCircumstancesMsg';
  economicCircumstancesScore?: Maybe<Scalars['Int']>;
  financialDisposalLimitPerMonth?: Maybe<Scalars['Int']>;
  moneySufficient?: Maybe<Scalars['Boolean']>;
  savingsAssetsAvailable?: Maybe<Scalars['Boolean']>;
  selfManaged?: Maybe<Scalars['Boolean']>;
};

export type Treatment_EdemaMsg = {
  __typename?: 'treatment_EdemaMsg';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_EdemasBlock = {
  __typename?: 'treatment_EdemasBlock';
  edemaPresent?: Maybe<Scalars['Boolean']>;
  edemas?: Maybe<Array<Maybe<Treatment_EdemaMsg>>>;
};

export type Treatment_EdemataBlock = {
  __typename?: 'treatment_EdemataBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  improvedAfterRest?: Maybe<Scalars['Boolean']>;
  improvedAfterRestDescription?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  occurrenceTimes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  onsetType?: Maybe<Treatment_SymptomAppearance>;
  painTriggers?: Maybe<Array<Maybe<Treatment_EdemataPainTrigger>>>;
  painfulSwelling?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  temperatureSensation?: Maybe<Treatment_EdemataTemperatureSensation>;
};

export enum Treatment_EdemataPainTrigger {
  EdemataPainTriggerMuscularStrain = 'EDEMATA_PAIN_TRIGGER_MUSCULAR_STRAIN',
  EdemataPainTriggerNone = 'EDEMATA_PAIN_TRIGGER_NONE',
  EdemataPainTriggerPermanent = 'EDEMATA_PAIN_TRIGGER_PERMANENT',
  EdemataPainTriggerPressure = 'EDEMATA_PAIN_TRIGGER_PRESSURE'
}

export enum Treatment_EdemataTemperatureSensation {
  EdemataTemperatureSensationCold = 'EDEMATA_TEMPERATURE_SENSATION_COLD',
  EdemataTemperatureSensationInconspicuous = 'EDEMATA_TEMPERATURE_SENSATION_INCONSPICUOUS',
  EdemataTemperatureSensationNone = 'EDEMATA_TEMPERATURE_SENSATION_NONE',
  EdemataTemperatureSensationOverheated = 'EDEMATA_TEMPERATURE_SENSATION_OVERHEATED'
}

export type Treatment_EducationalLevelBlock = {
  __typename?: 'treatment_EducationalLevelBlock';
  highestEducationalLevel?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_EfasBlock = {
  __typename?: 'treatment_EfasBlock';
  /**
   * Can you jog? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  canJog?: Maybe<Treatment_EfasSlider>;
  /**
   * Can you run? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  canRun?: Maybe<Treatment_EfasSlider>;
  /**
   * 3: How much has your gait (i.e., the way you walk) changed because of your foot and or ankle problem? <0-4> (slider)
   *  show as a note: 0=Extreme gait change, 4=No
   */
  changeInGait?: Maybe<Treatment_EfasSlider>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /**
   * 1: Do you have pain in your foot and or ankle when you are at rest? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  footOrAnklePainAtRest?: Maybe<Treatment_EfasSlider>;
  /**
   * 5: Do you have pain in your foot and or ankle when you are walking? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  footOrAnklePainInWalking?: Maybe<Treatment_EfasSlider>;
  /**
   * Do you have problems landing after jumping? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  landingProblemsAfterJumping?: Maybe<Treatment_EfasSlider>;
  /**
   * 6: How often do you have pain in your foot and/or ankle during physical activity? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  painDuringPhysicalActivity?: Maybe<Treatment_EfasSlider>;
  /**
   * Are you able to perform your sports with your usual technique? <0-4> (slider)
   *  show as a note: 0=Impossible, 4=No limitation
   */
  performSportsWithUsualTechnique?: Maybe<Treatment_EfasSlider>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /**
   * 2: How far can you walk before you get pain in your foot and/or ankle<0-4> (slider)
   *  show as a note: /0=Impossible, 4=No limitation
   */
  walkedBeforePain?: Maybe<Treatment_EfasSlider>;
  /**
   * 4: Do you have difficulty walking on uneven surfaces? <0-4> (slider)
   *  show as a note: 0=Always, 4=Never
   */
  walkingDifficultyOnEvenSurfaces?: Maybe<Treatment_EfasSlider>;
};

export enum Treatment_EfasSlider {
  EfasSliderFour = 'EFAS_SLIDER_FOUR',
  EfasSliderNone = 'EFAS_SLIDER_NONE',
  EfasSliderOne = 'EFAS_SLIDER_ONE',
  EfasSliderThree = 'EFAS_SLIDER_THREE',
  EfasSliderTwo = 'EFAS_SLIDER_TWO',
  EfasSliderZero = 'EFAS_SLIDER_ZERO'
}

export type Treatment_ElbowJointMsg = {
  __typename?: 'treatment_ElbowJointMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  flexionInPronation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  flexionInSupination?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_EpsSelection {
  /** high chance of dosing (3) */
  EpsSelectionHighDosingChance = 'EPS_SELECTION_HIGH_DOSING_CHANCE',
  /** moderate chance of dosing (2) */
  EpsSelectionModerateDosingChance = 'EPS_SELECTION_MODERATE_DOSING_CHANCE',
  EpsSelectionNone = 'EPS_SELECTION_NONE',
  /** no change of dosing (0) */
  EpsSelectionNoDosingChange = 'EPS_SELECTION_NO_DOSING_CHANGE',
  /** slight chance of dosing (1) */
  EpsSelectionSlightDosingChance = 'EPS_SELECTION_SLIGHT_DOSING_CHANCE'
}

export type Treatment_EpworthSleepinessScaleBlock = {
  __typename?: 'treatment_EpworthSleepinessScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  lyingDownInTheAfternoon?: Maybe<Treatment_EpsSelection>;
  oneHourRidingWithNoBreak?: Maybe<Treatment_EpsSelection>;
  score?: Maybe<Scalars['Int']>;
  sittingAndReading?: Maybe<Treatment_EpsSelection>;
  sittingAndTalking?: Maybe<Treatment_EpsSelection>;
  sittingInAPublicInactivePlace?: Maybe<Treatment_EpsSelection>;
  sittingQuietlyAfterLunch?: Maybe<Treatment_EpsSelection>;
  stoppedInTraffic?: Maybe<Treatment_EpsSelection>;
  watchingTelevision?: Maybe<Treatment_EpsSelection>;
};

export type Treatment_ErectionBlock = {
  __typename?: 'treatment_ErectionBlock';
  completed?: Maybe<Scalars['Boolean']>;
  confidence?: Maybe<Treatment_ErectionConfidence>;
  difficulty?: Maybe<Treatment_ErectionDifficulty>;
  maintenance?: Maybe<Treatment_ErectionMaintenance>;
  satisfaction?: Maybe<Treatment_ErectionSatisfaction>;
  score?: Maybe<Scalars['Int']>;
  sufficiency?: Maybe<Treatment_ErectionSufficiency>;
};

export enum Treatment_ErectionConfidence {
  ErectionConfidenceHigh = 'ERECTION_CONFIDENCE_HIGH',
  ErectionConfidenceLow = 'ERECTION_CONFIDENCE_LOW',
  ErectionConfidenceModerate = 'ERECTION_CONFIDENCE_MODERATE',
  ErectionConfidenceNone = 'ERECTION_CONFIDENCE_NONE',
  ErectionConfidenceVeryHigh = 'ERECTION_CONFIDENCE_VERY_HIGH',
  ErectionConfidenceVeryLow = 'ERECTION_CONFIDENCE_VERY_LOW'
}

export enum Treatment_ErectionDifficulty {
  ErectionDifficultyALittleDifficult = 'ERECTION_DIFFICULTY_A_LITTLE_DIFFICULT',
  ErectionDifficultyDifficult = 'ERECTION_DIFFICULTY_DIFFICULT',
  ErectionDifficultyExtremelyDifficult = 'ERECTION_DIFFICULTY_EXTREMELY_DIFFICULT',
  ErectionDifficultyNone = 'ERECTION_DIFFICULTY_NONE',
  ErectionDifficultyNotAttempted = 'ERECTION_DIFFICULTY_NOT_ATTEMPTED',
  ErectionDifficultyNotDifficult = 'ERECTION_DIFFICULTY_NOT_DIFFICULT',
  ErectionDifficultyVeryDifficult = 'ERECTION_DIFFICULTY_VERY_DIFFICULT'
}

export enum Treatment_ErectionMaintenance {
  ErectionMaintenanceAlmostAlwaysOrAlways = 'ERECTION_MAINTENANCE_ALMOST_ALWAYS_OR_ALWAYS',
  ErectionMaintenanceAlmostNeverOrNever = 'ERECTION_MAINTENANCE_ALMOST_NEVER_OR_NEVER',
  ErectionMaintenanceMostly = 'ERECTION_MAINTENANCE_MOSTLY',
  ErectionMaintenanceNone = 'ERECTION_MAINTENANCE_NONE',
  ErectionMaintenanceNotAttempted = 'ERECTION_MAINTENANCE_NOT_ATTEMPTED',
  ErectionMaintenanceSeldom = 'ERECTION_MAINTENANCE_SELDOM',
  ErectionMaintenanceSometimes = 'ERECTION_MAINTENANCE_SOMETIMES'
}

export enum Treatment_ErectionSatisfaction {
  ErectionSatisfactionAlmostAlwaysOrAlways = 'ERECTION_SATISFACTION_ALMOST_ALWAYS_OR_ALWAYS',
  ErectionSatisfactionAlmostNeverOrNever = 'ERECTION_SATISFACTION_ALMOST_NEVER_OR_NEVER',
  ErectionSatisfactionMostly = 'ERECTION_SATISFACTION_MOSTLY',
  ErectionSatisfactionNone = 'ERECTION_SATISFACTION_NONE',
  ErectionSatisfactionNotAttempted = 'ERECTION_SATISFACTION_NOT_ATTEMPTED',
  ErectionSatisfactionSeldom = 'ERECTION_SATISFACTION_SELDOM',
  ErectionSatisfactionSometimes = 'ERECTION_SATISFACTION_SOMETIMES'
}

export enum Treatment_ErectionSufficiency {
  ErectionSufficiencyAlmostAlwaysOrAlways = 'ERECTION_SUFFICIENCY_ALMOST_ALWAYS_OR_ALWAYS',
  ErectionSufficiencyAlmostNeverOrNever = 'ERECTION_SUFFICIENCY_ALMOST_NEVER_OR_NEVER',
  ErectionSufficiencyMostly = 'ERECTION_SUFFICIENCY_MOSTLY',
  ErectionSufficiencyNone = 'ERECTION_SUFFICIENCY_NONE',
  ErectionSufficiencyNoSexualStimulation = 'ERECTION_SUFFICIENCY_NO_SEXUAL_STIMULATION',
  ErectionSufficiencyRarely = 'ERECTION_SUFFICIENCY_RARELY',
  ErectionSufficiencySometimes = 'ERECTION_SUFFICIENCY_SOMETIMES'
}

export enum Treatment_EstimateHealthStatus {
  /** better (2) */
  EstimateHealthStatusBetter = 'ESTIMATE_HEALTH_STATUS_BETTER',
  /** equally good (1) */
  EstimateHealthStatusEquallyGood = 'ESTIMATE_HEALTH_STATUS_EQUALLY_GOOD',
  EstimateHealthStatusNone = 'ESTIMATE_HEALTH_STATUS_NONE',
  /** does not know (0.5) */
  EstimateHealthStatusUnknown = 'ESTIMATE_HEALTH_STATUS_UNKNOWN',
  /** worse (0) */
  EstimateHealthStatusWorse = 'ESTIMATE_HEALTH_STATUS_WORSE'
}

export type Treatment_ExcretoryGlandsMsg = {
  __typename?: 'treatment_ExcretoryGlandsMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_ExecutiveFunctionsBlock = {
  __typename?: 'treatment_ExecutiveFunctionsBlock';
  descriptions?: Maybe<Array<Maybe<Treatment_ExecutiveFunctionsDescriptionMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  luriaSequence?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  luriaSequenceText?: Maybe<Scalars['String']>;
  planningAndExecutionOfActivities?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_ExecutiveFunctionsDescriptionMsg = {
  __typename?: 'treatment_ExecutiveFunctionsDescriptionMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_ExtendedBarthelIndexBlock = {
  __typename?: 'treatment_ExtendedBarthelIndexBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  comprehension?: Maybe<Treatment_Comprehension>;
  extendedBarthelIndexMemory?: Maybe<Treatment_ExtendedBarthelIndexMemory>;
  makingOneselfUnderstood?: Maybe<Treatment_MakingOneselfUnderstood>;
  problemSolving?: Maybe<Treatment_ProblemSolving>;
  score?: Maybe<Scalars['Int']>;
  socialInteraction?: Maybe<Treatment_SocialInteraction>;
  visionAndNeglect?: Maybe<Treatment_VisionAndNeglect>;
};

export enum Treatment_ExtendedBarthelIndexMemory {
  ExtendedBarthelIndexMemoryDisoriented = 'EXTENDED_BARTHEL_INDEX_MEMORY_DISORIENTED',
  ExtendedBarthelIndexMemoryEssentiallyUndisturbed = 'EXTENDED_BARTHEL_INDEX_MEMORY_ESSENTIALLY_UNDISTURBED',
  ExtendedBarthelIndexMemoryNone = 'EXTENDED_BARTHEL_INDEX_MEMORY_NONE',
  ExtendedBarthelIndexMemoryRemindedFrequently = 'EXTENDED_BARTHEL_INDEX_MEMORY_REMINDED_FREQUENTLY',
  ExtendedBarthelIndexMemoryRemindedOrUseMedicalAids = 'EXTENDED_BARTHEL_INDEX_MEMORY_REMINDED_OR_USE_MEDICAL_AIDS'
}

export type Treatment_ExternalAllergenIdMsg = {
  __typename?: 'treatment_ExternalAllergenIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalAllergenIdType>;
};

export type Treatment_ExternalMaterialBlock = {
  __typename?: 'treatment_ExternalMaterialBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_ExternalRotation {
  ExternalRotationHandOnBackOfHeadElbowForward = 'EXTERNAL_ROTATION_HAND_ON_BACK_OF_HEAD_ELBOW_FORWARD',
  ExternalRotationHandOnBackOfHeadElbowToSide = 'EXTERNAL_ROTATION_HAND_ON_BACK_OF_HEAD_ELBOW_TO_SIDE',
  ExternalRotationHandOnTopOfHeadElbowForward = 'EXTERNAL_ROTATION_HAND_ON_TOP_OF_HEAD_ELBOW_FORWARD',
  ExternalRotationHandOnTopOfHeadElbowToSide = 'EXTERNAL_ROTATION_HAND_ON_TOP_OF_HEAD_ELBOW_TO_SIDE',
  ExternalRotationNone = 'EXTERNAL_ROTATION_NONE',
  ExternalRotationUnrestrictedOverheadMobility = 'EXTERNAL_ROTATION_UNRESTRICTED_OVERHEAD_MOBILITY'
}

export type Treatment_ExternalSourceMsg = {
  __typename?: 'treatment_ExternalSourceMsg';
  id?: Maybe<Scalars['String']>;
  /** can be patient id, contact id, external contact (e.g., clinic/practitioner) id */
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Treatment_ExternalSourceType>;
  validated?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_ExternalSourceType {
  /** medical provider */
  ExternalSourceTypeMedical = 'EXTERNAL_SOURCE_TYPE_MEDICAL',
  ExternalSourceTypeNone = 'EXTERNAL_SOURCE_TYPE_NONE',
  /** personal recollection */
  ExternalSourceTypePersonal = 'EXTERNAL_SOURCE_TYPE_PERSONAL',
  /** written record */
  ExternalSourceTypeRecord = 'EXTERNAL_SOURCE_TYPE_RECORD'
}

export type Treatment_ExternalVaccinationIdMsg = {
  __typename?: 'treatment_ExternalVaccinationIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Knowledge_ExternalDrugPackageIdType>;
};

export type Treatment_ExtrapyramidalMovementDisordersBlock = {
  __typename?: 'treatment_ExtrapyramidalMovementDisordersBlock';
  extrapyramidalMovementDisorders?: Maybe<Scalars['Boolean']>;
  extrapyramidalMovementDisordersDescriptions?: Maybe<Array<Maybe<Treatment_ExtrapyramidalMovementDisordersMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
};

export type Treatment_ExtrapyramidalMovementDisordersMsg = {
  __typename?: 'treatment_ExtrapyramidalMovementDisordersMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_ExtremitiesAtaxiaTestResult {
  ExtremitiesAtaxiaTestComa = 'EXTREMITIES_ATAXIA_TEST_COMA',
  ExtremitiesAtaxiaTestNone = 'EXTREMITIES_ATAXIA_TEST_NONE',
  ExtremitiesAtaxiaTestNothing = 'EXTREMITIES_ATAXIA_TEST_NOTHING',
  ExtremitiesAtaxiaTestOne = 'EXTREMITIES_ATAXIA_TEST_ONE',
  ExtremitiesAtaxiaTestTwo = 'EXTREMITIES_ATAXIA_TEST_TWO'
}

export type Treatment_ExtremitiesTemperatureBlock = {
  __typename?: 'treatment_ExtremitiesTemperatureBlock';
  abnormalitiesExaminationResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_ExudateQuantity {
  ExudateQuantityLittle = 'EXUDATE_QUANTITY_LITTLE',
  ExudateQuantityMedium = 'EXUDATE_QUANTITY_MEDIUM',
  ExudateQuantityMuch = 'EXUDATE_QUANTITY_MUCH',
  ExudateQuantityNone = 'EXUDATE_QUANTITY_NONE'
}

export enum Treatment_EyeResponseType {
  EyeResponseDoesNotOpen = 'EYE_RESPONSE_DOES_NOT_OPEN',
  EyeResponseNone = 'EYE_RESPONSE_NONE',
  EyeResponseOpensInResponseToPain = 'EYE_RESPONSE_OPENS_IN_RESPONSE_TO_PAIN',
  EyeResponseOpensInResponseToVoice = 'EYE_RESPONSE_OPENS_IN_RESPONSE_TO_VOICE',
  EyeResponseOpensSpontaneously = 'EYE_RESPONSE_OPENS_SPONTANEOUSLY'
}

export type Treatment_FacetInfiltrationMsg = {
  __typename?: 'treatment_FacetInfiltrationMsg';
  cervicalSpineJoints?: Maybe<Treatment_CervicalSpineJointsMsg>;
  cervicalSpineJointsPresent?: Maybe<Scalars['Boolean']>;
  headJoints?: Maybe<Treatment_HeadJointsMsg>;
  headJointsPresent?: Maybe<Scalars['Boolean']>;
  imaging?: Maybe<Scalars['Boolean']>;
  lumbarSpineJoints?: Maybe<Treatment_LumbarSpineJointsMsg>;
  lumbarSpineJointsPresent?: Maybe<Scalars['Boolean']>;
  others?: Maybe<Scalars['String']>;
  othersPresent?: Maybe<Scalars['Boolean']>;
  thoracicSpineJoints?: Maybe<Treatment_ThoracicSpineJointsMsg>;
  thoracicSpineJointsPresent?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_FacialNerveParesisTestResult {
  FacialNerveParesisTestComa = 'FACIAL_NERVE_PARESIS_TEST_COMA',
  FacialNerveParesisTestComplete = 'FACIAL_NERVE_PARESIS_TEST_COMPLETE',
  FacialNerveParesisTestMinor = 'FACIAL_NERVE_PARESIS_TEST_MINOR',
  FacialNerveParesisTestNone = 'FACIAL_NERVE_PARESIS_TEST_NONE',
  FacialNerveParesisTestNothing = 'FACIAL_NERVE_PARESIS_TEST_NOTHING',
  FacialNerveParesisTestPartial = 'FACIAL_NERVE_PARESIS_TEST_PARTIAL'
}

export type Treatment_FacialSensitivityAndTrigeminalReflexesBlock = {
  __typename?: 'treatment_FacialSensitivityAndTrigeminalReflexesBlock';
  aesthesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  aesthesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  aesthesiaAbnormalitiesText?: Maybe<Scalars['String']>;
  algesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  algesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  algesiaAbnormalitiesText?: Maybe<Scalars['String']>;
  facialSensitivity?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: Maybe<Scalars['String']>;
  kornealReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  kornealReflexText?: Maybe<Scalars['String']>;
  masseterReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  masseterReflexText?: Maybe<Scalars['String']>;
  palpationOfNerveExitPoints?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  palpationOfNerveExitPointsText?: Maybe<Scalars['String']>;
};

export enum Treatment_FamilyStatus {
  FamilyStatusDivorced = 'FAMILY_STATUS_DIVORCED',
  FamilyStatusMarried = 'FAMILY_STATUS_MARRIED',
  FamilyStatusNone = 'FAMILY_STATUS_NONE',
  FamilyStatusSingle = 'FAMILY_STATUS_SINGLE',
  FamilyStatusWidow = 'FAMILY_STATUS_WIDOW'
}

export type Treatment_FamilyStatusBlock = {
  __typename?: 'treatment_FamilyStatusBlock';
  familyStatus?: Maybe<Treatment_FamilyStatus>;
  numberBoys?: Maybe<Scalars['Int']>;
  numberGirls?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_FasSelection {
  /** always (5) */
  FasSelectionAlways = 'FAS_SELECTION_ALWAYS',
  /** never (1) */
  FasSelectionNever = 'FAS_SELECTION_NEVER',
  FasSelectionNone = 'FAS_SELECTION_NONE',
  /** often (4) */
  FasSelectionOften = 'FAS_SELECTION_OFTEN',
  /** regularly (3) */
  FasSelectionRegularly = 'FAS_SELECTION_REGULARLY',
  /** sometimes (2) */
  FasSelectionSometimes = 'FAS_SELECTION_SOMETIMES'
}

export enum Treatment_FastingPeriodResolution {
  FastingPeriodTimeMonth = 'FASTING_PERIOD_TIME_MONTH',
  FastingPeriodTimeNone = 'FASTING_PERIOD_TIME_NONE',
  FastingPeriodTimeYear = 'FASTING_PERIOD_TIME_YEAR'
}

export type Treatment_FastingPeriodsMsg = {
  __typename?: 'treatment_FastingPeriodsMsg';
  duration?: Maybe<VeiosTimeSpanMsg>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_FastingPeriodResolution>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_FatigueAssessmentScaleBlock = {
  __typename?: 'treatment_FatigueAssessmentScaleBlock';
  botheredByFatigue?: Maybe<Treatment_FasSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  energeticEveryday?: Maybe<Treatment_FasSelection>;
  lazyDuringDay?: Maybe<Treatment_FasSelection>;
  mentallyExhausted?: Maybe<Treatment_FasSelection>;
  noDesireToDoAnything?: Maybe<Treatment_FasSelection>;
  physicallyExhausted?: Maybe<Treatment_FasSelection>;
  problemsToThinkClearly?: Maybe<Treatment_FasSelection>;
  procrastination?: Maybe<Treatment_FasSelection>;
  quiteConcentration?: Maybe<Treatment_FasSelection>;
  score?: Maybe<Scalars['Int']>;
  tiredVeryQuickly?: Maybe<Treatment_FasSelection>;
};

export type Treatment_FecalCollectorMsg = {
  __typename?: 'treatment_FecalCollectorMsg';
  _?: Maybe<Scalars['String']>;
};

export enum Treatment_Feeding {
  FeedingIndependent = 'FEEDING_INDEPENDENT',
  FeedingNeedsHelp = 'FEEDING_NEEDS_HELP',
  FeedingNone = 'FEEDING_NONE',
  FeedingUnable = 'FEEDING_UNABLE'
}

export enum Treatment_FeelingsOfFailure {
  FeelingsOfFailureCompleteFailure = 'FEELINGS_OF_FAILURE_COMPLETE_FAILURE',
  FeelingsOfFailureHaveFeelingOfFailure = 'FEELINGS_OF_FAILURE_HAVE_FEELING_OF_FAILURE',
  FeelingsOfFailureMoreFailureFromThePast = 'FEELINGS_OF_FAILURE_MORE_FAILURE_FROM_THE_PAST',
  FeelingsOfFailureNone = 'FEELINGS_OF_FAILURE_NONE',
  FeelingsOfFailureNoFeelingOfFailure = 'FEELINGS_OF_FAILURE_NO_FEELING_OF_FAILURE'
}

export enum Treatment_FeelingsOfPunishment {
  FeelingsOfPunishmentFeelsExpectedToBePunished = 'FEELINGS_OF_PUNISHMENT_FEELS_EXPECTED_TO_BE_PUNISHED',
  FeelingsOfPunishmentFeelsMightBePunished = 'FEELINGS_OF_PUNISHMENT_FEELS_MIGHT_BE_PUNISHED',
  FeelingsOfPunishmentFeelsToBePunished = 'FEELINGS_OF_PUNISHMENT_FEELS_TO_BE_PUNISHED',
  FeelingsOfPunishmentNone = 'FEELINGS_OF_PUNISHMENT_NONE',
  FeelingsOfPunishmentNoPunishmentFeelings = 'FEELINGS_OF_PUNISHMENT_NO_PUNISHMENT_FEELINGS'
}

export type Treatment_FeverBlock = {
  __typename?: 'treatment_FeverBlock';
  chillsPresent?: Maybe<Scalars['Boolean']>;
  chillsText?: Maybe<Scalars['String']>;
  daytimeDependencePresent?: Maybe<Scalars['Boolean']>;
  daytimeDependences?: Maybe<Array<Maybe<Treatment_DaytimeDependence>>>;
  feverCourseText?: Maybe<Scalars['String']>;
  feverCourses?: Maybe<Array<Maybe<Treatment_FeverCourse>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  sweatingPresent?: Maybe<Scalars['Boolean']>;
  sweatingText?: Maybe<Scalars['String']>;
  /** Temperature in celsius */
  temperature?: Maybe<Scalars['Float']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_FeverCourse {
  FeverCourseContinuous = 'FEVER_COURSE_CONTINUOUS',
  FeverCourseIntermittent = 'FEVER_COURSE_INTERMITTENT',
  FeverCourseNone = 'FEVER_COURSE_NONE',
  FeverCourseRecurring = 'FEVER_COURSE_RECURRING',
  FeverCourseRemittent = 'FEVER_COURSE_REMITTENT',
  FeverCourseUndulating = 'FEVER_COURSE_UNDULATING'
}

/** Functional Independence Measure (FIM) */
export type Treatment_FimBlock = {
  __typename?: 'treatment_FimBlock';
  bathingShoweringWashing?: Maybe<Treatment_FimSelection>;
  bladderControl?: Maybe<Treatment_FimSelection>;
  bowelControl?: Maybe<Treatment_FimSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  dressingDownstairs?: Maybe<Treatment_FimSelection>;
  dressingUpstairs?: Maybe<Treatment_FimSelection>;
  eatingAndDrinking?: Maybe<Treatment_FimSelection>;
  /** Expression (making oneself understood) */
  expression?: Maybe<Treatment_FimSelection>;
  intimateHygiene?: Maybe<Treatment_FimSelection>;
  movementClimbingStairs?: Maybe<Treatment_FimSelection>;
  movementWalkingWheelchair?: Maybe<Treatment_FimSelection>;
  personalHygiene?: Maybe<Treatment_FimSelection>;
  problemSolvingSkills?: Maybe<Treatment_FimSelection>;
  score?: Maybe<Scalars['Int']>;
  /** Social Behavior */
  socialBehavior?: Maybe<Treatment_FimSelection>;
  transferBedChairWheelChair?: Maybe<Treatment_FimSelection>;
  transferShowerBath?: Maybe<Treatment_FimSelection>;
  transferToiletSeat?: Maybe<Treatment_FimSelection>;
  understanding?: Maybe<Treatment_FimSelection>;
};

export enum Treatment_FimSelection {
  /** contact assistance (4) */
  FimSelectionContactAssistance = 'FIM_SELECTION_CONTACT_ASSISTANCE',
  /** limited independence (6) */
  FimSelectionLimitedIndependence = 'FIM_SELECTION_LIMITED_INDEPENDENCE',
  /** marked assistance (2) */
  FimSelectionMarkedAssistance = 'FIM_SELECTION_MARKED_ASSISTANCE',
  /** moderate assistance (3) */
  FimSelectionModerateAssistance = 'FIM_SELECTION_MODERATE_ASSISTANCE',
  FimSelectionNone = 'FIM_SELECTION_NONE',
  /** supervision or preparation (5) */
  FimSelectionSupervisionOrPreparation = 'FIM_SELECTION_SUPERVISION_OR_PREPARATION',
  /** total assistance (1) */
  FimSelectionTotalAssistance = 'FIM_SELECTION_TOTAL_ASSISTANCE',
  /** total independence (7) */
  FimSelectionTotalIndependence = 'FIM_SELECTION_TOTAL_INDEPENDENCE'
}

export type Treatment_FindDiagnosisActiveVersionRevisionsRequest = {
  __typename?: 'treatment_FindDiagnosisActiveVersionRevisionsRequest';
  diagnosisCodingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_FindDiagnosisActiveVersionRevisionsResponse = {
  __typename?: 'treatment_FindDiagnosisActiveVersionRevisionsResponse';
  diagnosisCodingIdToLatestInfo?: Maybe<Array<Maybe<Treatment_FindDiagnosisActiveVersionRevisionsResponse_DiagnosisCodingIdToLatestInfoEntry>>>;
};

export type Treatment_FindDiagnosisActiveVersionRevisionsResponse_DiagnosisCodingIdToLatestInfoEntry = {
  __typename?: 'treatment_FindDiagnosisActiveVersionRevisionsResponse_DiagnosisCodingIdToLatestInfoEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Treatment_DiagnosisCodingActivityInfoMsg>;
};

export type Treatment_FindLatestAnamnesisBlockRequest = {
  __typename?: 'treatment_FindLatestAnamnesisBlockRequest';
  pathKeys?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_FindLatestAnamnesisBlockResponse = {
  __typename?: 'treatment_FindLatestAnamnesisBlockResponse';
  anamnesisBlock?: Maybe<Treatment_AnamnesisBlockMsg>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type Treatment_FindLatestPhysicalBlockRequest = {
  __typename?: 'treatment_FindLatestPhysicalBlockRequest';
  pathKeys?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_FindLatestPhysicalBlockResponse = {
  __typename?: 'treatment_FindLatestPhysicalBlockResponse';
  exists?: Maybe<Scalars['Boolean']>;
  physicalBlock?: Maybe<Treatment_PhysicalBlockMsg>;
};

export type Treatment_FindLatestTreatmentsDetailsRequest = {
  __typename?: 'treatment_FindLatestTreatmentsDetailsRequest';
  /** optional filter */
  treatmentType?: Maybe<Treatment_TreatmentType>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_FindLatestTreatmentsDetailsResponse = {
  __typename?: 'treatment_FindLatestTreatmentsDetailsResponse';
  visitIdToLastTreatmentDetails?: Maybe<Array<Maybe<Treatment_FindLatestTreatmentsDetailsResponse_VisitIdToLastTreatmentDetailsEntry>>>;
};

export type Treatment_FindLatestTreatmentsDetailsResponse_VisitIdToLastTreatmentDetailsEntry = {
  __typename?: 'treatment_FindLatestTreatmentsDetailsResponse_VisitIdToLastTreatmentDetailsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Treatment_TreatmentBasicInfoMsg>;
};

export type Treatment_FingerJointsMsg = {
  __typename?: 'treatment_FingerJointsMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fingerAbduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  fingerAdduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  fingerExtension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  fingerFlexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
  littleFingerAbduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  thumbAbduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  thumbAdduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  thumbExtension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  thumbFlexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  thumbOpposition?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
};

export enum Treatment_Flexion {
  Flexion_75To_95 = 'FLEXION_75_TO_95',
  FlexionGreaterThanEqual_100 = 'FLEXION_GREATER_THAN_EQUAL_100',
  FlexionLessThanEqual_70 = 'FLEXION_LESS_THAN_EQUAL_70',
  FlexionNone = 'FLEXION_NONE'
}

export type Treatment_FlowNoiseLowerExtremityBlock = {
  __typename?: 'treatment_FlowNoiseLowerExtremityBlock';
  left?: Maybe<Treatment_FlowNoiseLowerExtremityMsg>;
  right?: Maybe<Treatment_FlowNoiseLowerExtremityMsg>;
};

export type Treatment_FlowNoiseLowerExtremityMsg = {
  __typename?: 'treatment_FlowNoiseLowerExtremityMsg';
  arteriaDorsalisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaDorsalisText?: Maybe<Scalars['String']>;
  arteriaFemoralisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaFemoralisText?: Maybe<Scalars['String']>;
  arteriaPopliteaFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaPopliteaText?: Maybe<Scalars['String']>;
  arteriaTibialisPosteriorFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaTibialisText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_FlowNoiseUpperExtremityMsg = {
  __typename?: 'treatment_FlowNoiseUpperExtremityMsg';
  arteriaBrachialisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaBrachialisText?: Maybe<Scalars['String']>;
  arteriaCarotisCommunisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaCarotisCommunisText?: Maybe<Scalars['String']>;
  arteriaRadialisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaRadialisText?: Maybe<Scalars['String']>;
  arteriaSubclaviaFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaSubclaviaText?: Maybe<Scalars['String']>;
  arteriaUlnarisFlowNoisePresent?: Maybe<Scalars['Boolean']>;
  arteriaUlnarisText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_FlowNoisesUpperExtremityBlock = {
  __typename?: 'treatment_FlowNoisesUpperExtremityBlock';
  left?: Maybe<Treatment_FlowNoiseUpperExtremityMsg>;
  right?: Maybe<Treatment_FlowNoiseUpperExtremityMsg>;
};

export enum Treatment_FlowSystemLengthUnit {
  FlowSystemLengthUnitCm = 'FLOW_SYSTEM_LENGTH_UNIT_CM',
  FlowSystemLengthUnitNone = 'FLOW_SYSTEM_LENGTH_UNIT_NONE'
}

export enum Treatment_FlowSystemSizeUnit {
  FlowSystemSizeUnitCharr = 'FLOW_SYSTEM_SIZE_UNIT_CHARR',
  FlowSystemSizeUnitGauge = 'FLOW_SYSTEM_SIZE_UNIT_GAUGE',
  FlowSystemSizeUnitMm = 'FLOW_SYSTEM_SIZE_UNIT_MM',
  FlowSystemSizeUnitNone = 'FLOW_SYSTEM_SIZE_UNIT_NONE'
}

export type Treatment_FluidBalanceConfigurationMsg = {
  __typename?: 'treatment_FluidBalanceConfigurationMsg';
  /** The time of day for the start time of the first entry */
  offsetTimeOfDay?: Maybe<TimeOfDayMsg>;
  /** Allows defining the period of every fluid balance entry, e.g. 8 HOURS */
  period?: Maybe<Scalars['Int']>;
  /** Only "HOURS" and "DAYS" are valid. TODO: For the demo "DAYS" with period > 1 are also not valid. */
  periodUnit?: Maybe<TimeUnit>;
};

export type Treatment_FluidFlowBalanceMsg = {
  __typename?: 'treatment_FluidFlowBalanceMsg';
  endTime?: Maybe<Timestamp>;
  overall?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Timestamp>;
  totalIn?: Maybe<Scalars['Int']>;
  totalOut?: Maybe<Scalars['Int']>;
};

export type Treatment_FluidFlowMsg = {
  __typename?: 'treatment_FluidFlowMsg';
  flowDate?: Maybe<Timestamp>;
  fluidFlowSystem?: Maybe<Treatment_FluidFlowSystemBasicInfoMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inflowForms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  outflowForms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  /** Quantity in milliliters */
  quantity?: Maybe<Scalars['Int']>;
  stationaryVisitId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_FluidFlowType>;
  versionInfo?: Maybe<Versioning_VersionInfoMsg>;
};

export type Treatment_FluidFlowResultMsg = {
  __typename?: 'treatment_FluidFlowResultMsg';
  /** The configuration on which the result is based */
  configuration?: Maybe<Treatment_FluidBalanceConfigurationMsg>;
  configurationId?: Maybe<Scalars['String']>;
  configurationName?: Maybe<Scalars['String']>;
  defaultConfiguration?: Maybe<Scalars['Boolean']>;
  fluidFlowBalances?: Maybe<Array<Maybe<Treatment_FluidFlowBalanceMsg>>>;
};

export type Treatment_FluidFlowSystemBasicInfoMsg = {
  __typename?: 'treatment_FluidFlowSystemBasicInfoMsg';
  endDate?: Maybe<Timestamp>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Treatment_FluidFlowSystemMetadataMsg>;
  startDate?: Maybe<Timestamp>;
};

export type Treatment_FluidFlowSystemDetailsMsg = {
  __typename?: 'treatment_FluidFlowSystemDetailsMsg';
  arteria?: Maybe<Treatment_ArteriaMsg>;
  cvc?: Maybe<Treatment_CvcMsg>;
  dialysisCatheter?: Maybe<Treatment_DialysisCatheterMsg>;
  fecalCollector?: Maybe<Treatment_FecalCollectorMsg>;
  gastricTube?: Maybe<Treatment_GastricTubeMsg>;
  intraosseousAccess?: Maybe<Treatment_IntraosseousAccessMsg>;
  mediastinalDrainage?: Maybe<Treatment_MediastinalDrainageMsg>;
  namedFluidFlowSystem?: Maybe<Treatment_NamedFluidFlowSystemMsg>;
  painCatheter?: Maybe<Treatment_PainCatheterMsg>;
  peg?: Maybe<Treatment_PegMsg>;
  pericardialDrainage?: Maybe<Treatment_PericardialDrainageMsg>;
  peritonealCatheter?: Maybe<Treatment_PeritonealCatheterMsg>;
  picc?: Maybe<Treatment_PiCcMsg>;
  piv?: Maybe<Treatment_PivMsg>;
  portCatheter?: Maybe<Treatment_PortCatheterMsg>;
  renalFistulaCatheter?: Maybe<Treatment_RenalFistulaCatheterMsg>;
  shunt?: Maybe<Treatment_ShuntMsg>;
  thoraxDrainage?: Maybe<Treatment_ThoraxDrainageMsg>;
  urinaryCatheter?: Maybe<Treatment_UrinaryCatheterMsg>;
  vacuumTherapySystem?: Maybe<Treatment_VacuumTherapySystemMsg>;
  ventricularDrainage?: Maybe<Treatment_VentricularDrainageMsg>;
  woundDrainage?: Maybe<Treatment_WoundDrainageMsg>;
};

export type Treatment_FluidFlowSystemList = {
  __typename?: 'treatment_FluidFlowSystemList';
  fluidFlowSystems?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMsg>>>;
};

export type Treatment_FluidFlowSystemMetadataMsg = {
  __typename?: 'treatment_FluidFlowSystemMetadataMsg';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type Treatment_FluidFlowSystemMsg = {
  __typename?: 'treatment_FluidFlowSystemMsg';
  details?: Maybe<Treatment_FluidFlowSystemDetailsMsg>;
  endDate?: Maybe<Timestamp>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Treatment_FluidFlowSystemMetadataMsg>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Timestamp>;
  timestamps?: Maybe<TimeMsg>;
  versionInfo?: Maybe<Versioning_VersionInfoMsg>;
  visitId?: Maybe<Scalars['String']>;
};

/** repetition cycle */
export type Treatment_FluidFlowSystemTimePeriodMsg = {
  __typename?: 'treatment_FluidFlowSystemTimePeriodMsg';
  duration?: Maybe<Scalars['Float']>;
  durationTimeUnit?: Maybe<TimeUnit>;
  offset?: Maybe<Scalars['Float']>;
  offsetTimeUnit?: Maybe<TimeUnit>;
};

export enum Treatment_FluidFlowType {
  FluidFlowTypeInflow = 'FLUID_FLOW_TYPE_INFLOW',
  FluidFlowTypeNone = 'FLUID_FLOW_TYPE_NONE',
  FluidFlowTypeOutflow = 'FLUID_FLOW_TYPE_OUTFLOW'
}

export enum Treatment_FollowCommand {
  /** please close your eyes (1) */
  FollowCommandCloseYourEyes = 'FOLLOW_COMMAND_CLOSE_YOUR_EYES',
  /** drop it on the floor (1) */
  FollowCommandDropPaperOnTheFloor = 'FOLLOW_COMMAND_DROP_PAPER_ON_THE_FLOOR',
  /** fold it in half (1) */
  FollowCommandFoldPaperInHalf = 'FOLLOW_COMMAND_FOLD_PAPER_IN_HALF',
  FollowCommandNone = 'FOLLOW_COMMAND_NONE',
  /** please take the paper in your hand (1) */
  FollowCommandTakePaperInYourHand = 'FOLLOW_COMMAND_TAKE_PAPER_IN_YOUR_HAND',
  /** trace pentagons (1) */
  FollowCommandTracePentagons = 'FOLLOW_COMMAND_TRACE_PENTAGONS',
  /** write a complete sentence (1) */
  FollowCommandWriteCompleteSentence = 'FOLLOW_COMMAND_WRITE_COMPLETE_SENTENCE'
}

export enum Treatment_FollowingInstructionsTestResult {
  FollowingInstructionsTestAllCorrectlyPerformed = 'FOLLOWING_INSTRUCTIONS_TEST_ALL_CORRECTLY_PERFORMED',
  FollowingInstructionsTestComa = 'FOLLOWING_INSTRUCTIONS_TEST_COMA',
  FollowingInstructionsTestNone = 'FOLLOWING_INSTRUCTIONS_TEST_NONE',
  FollowingInstructionsTestNoCorrectlyPerformed = 'FOLLOWING_INSTRUCTIONS_TEST_NO_CORRECTLY_PERFORMED',
  FollowingInstructionsTestOneCorrectlyPerformed = 'FOLLOWING_INSTRUCTIONS_TEST_ONE_CORRECTLY_PERFORMED'
}

export enum Treatment_ForceAsymmetry {
  ForceAsymmetryEquallyStrong = 'FORCE_ASYMMETRY_EQUALLY_STRONG',
  ForceAsymmetryLeftStronger = 'FORCE_ASYMMETRY_LEFT_STRONGER',
  ForceAsymmetryNone = 'FORCE_ASYMMETRY_NONE',
  ForceAsymmetryRightStronger = 'FORCE_ASYMMETRY_RIGHT_STRONGER'
}

export type Treatment_ForceLevelsAndDetailsMsg = {
  __typename?: 'treatment_ForceLevelsAndDetailsMsg';
  forceAsymmetry?: Maybe<Treatment_ForceAsymmetry>;
  forceLeft?: Maybe<Scalars['Int']>;
  forceRight?: Maybe<Scalars['Int']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_FrIndexMsg = {
  __typename?: 'treatment_FrIndexMsg';
  /** Behavioral disorder requiring supervision: <yes (-50) / no (0)> */
  behavioralDisorderRequiringSupervision?: Maybe<Scalars['Boolean']>;
  frIndexScore?: Maybe<Scalars['Int']>;
  /** Intensive care monitoring obligation: <yes (-50) / no (0)> */
  intensiveCareMonitoringObligation?: Maybe<Scalars['Boolean']>;
  /** Intermittent Ventilation: <yes (-50) / no (0)> */
  intermittentVentilation?: Maybe<Scalars['Boolean']>;
  /** Orientation disorder requiring supervision: <yes (-50) / no (0)> */
  orientationDisorderRequiringSupervision?: Maybe<Scalars['Boolean']>;
  /** Severe communication disorder: <yes (-50) / no (0)> */
  severeCommunicationDisorder?: Maybe<Scalars['Boolean']>;
  /** Swallowing disorder requiring supervision: <yes (-50) / no (0)> */
  swallowingDisorderRequiringSupervision?: Maybe<Scalars['Boolean']>;
  /** Tracheostoma requiring suction: <yes (-50) / no (0)> */
  tracheostomaRequiringSuction?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_FrictionAndShear {
  FrictionAndShearNone = 'FRICTION_AND_SHEAR_NONE',
  FrictionAndShearNoApparentProblem = 'FRICTION_AND_SHEAR_NO_APPARENT_PROBLEM',
  FrictionAndShearPotentialProblem = 'FRICTION_AND_SHEAR_POTENTIAL_PROBLEM',
  FrictionAndShearProblem = 'FRICTION_AND_SHEAR_PROBLEM'
}

export type Treatment_FriedrichWeickmannScaleBlock = {
  __typename?: 'treatment_FriedrichWeickmannScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  details?: Maybe<Scalars['String']>;
  scale?: Maybe<Treatment_FriedrichWeickmannScaleSelection>;
};

export enum Treatment_FriedrichWeickmannScaleSelection {
  /** C: coma, areflexia */
  FriedrichWeickmannScaleSelectionComa = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_COMA',
  /** A0: inconspicuous */
  FriedrichWeickmannScaleSelectionInconspicuous = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_INCONSPICUOUS',
  /** B2: midbrain syndrome, startle synergisms to external stimuli */
  FriedrichWeickmannScaleSelectionMidbrainSyndrome = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_MIDBRAIN_SYNDROME',
  FriedrichWeickmannScaleSelectionNone = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_NONE',
  /** A2: callable, follows simple requests, no adequate response, incontinent */
  FriedrichWeickmannScaleSelectionNoAdequateResponse = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_NO_ADEQUATE_RESPONSE',
  /** B1: no verbal utterances, purposeful defensive movements */
  FriedrichWeickmannScaleSelectionNoVerbalUtterances = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_NO_VERBAL_UTTERANCES',
  /** A3: still callable, falls back asleep quickly, significantly delayed in responding */
  FriedrichWeickmannScaleSelectionResponseSignificantlyDelayed = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_RESPONSE_SIGNIFICANTLY_DELAYED',
  /** A1: responsive, slowed, agitated, behavior not appropriate to situation */
  FriedrichWeickmannScaleSelectionResponsiveSlowed = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_RESPONSIVE_SLOWED',
  /** AD: transitory syndrome, fully responsive, inadequate responses, somewhat confused */
  FriedrichWeickmannScaleSelectionSomewhatConfused = 'FRIEDRICH_WEICKMANN_SCALE_SELECTION_SOMEWHAT_CONFUSED'
}

export type Treatment_FtndBlock = {
  __typename?: 'treatment_FtndBlock';
  /** Which cigarette would you not want to do without: <the first one after waking up (1)/another one (0)> (singleselect) */
  cigaretteToDoWithout?: Maybe<Treatment_FtndCigaretteToDoWithout>;
  /** How many cigarettes do you smoke per day: <More than 30 (3) /21-30 (2) /11-20 (1) /10 or less (0)> (singleselect) */
  cigarettesPerDay?: Maybe<Treatment_FtndCigarettesPerDay>;
  completed?: Maybe<Scalars['Boolean']>;
  /** When do you smoke your first cigarette after waking up: <within 5 minutes (3)/within 6 to 30 minutes (2)/within 31 to 60 minutes (1)/it takes longer than 60 minutes (0)> (singleselect) */
  firstCigaretteTime?: Maybe<Treatment_FtndFirstCigaretteTime>;
  score?: Maybe<Scalars['Int']>;
  /** Do you find it difficult to refrain from smoking in places where smoking is prohibited (e.g. church, library, cinema, etc.): <yes (1) /no (0)> (singleselect) */
  smokeInProhibitedPlacesDifficulty?: Maybe<Scalars['Boolean']>;
  /** Do you generally smoke more in the first few hours after waking up than during the rest of the day: <yes (1) / no (0)> (singleselect) */
  smokeMoreInFirstHours?: Maybe<Scalars['Boolean']>;
  /** Do you smoke when you are ill and have to stay in bed during the day?: <yes (1) / no (0)> (singleselect) */
  smokeWhenIll?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_FtndCigaretteToDoWithout {
  FtndCigaretteToDoWithoutAnotherOne = 'FTND_CIGARETTE_TO_DO_WITHOUT_ANOTHER_ONE',
  FtndCigaretteToDoWithoutFirstOne = 'FTND_CIGARETTE_TO_DO_WITHOUT_FIRST_ONE',
  FtndCigaretteToDoWithoutNone = 'FTND_CIGARETTE_TO_DO_WITHOUT_NONE'
}

export enum Treatment_FtndCigarettesPerDay {
  FtndCigarettesPerDayElevenToTwenty = 'FTND_CIGARETTES_PER_DAY_ELEVEN_TO_TWENTY',
  FtndCigarettesPerDayMoreThanThirty = 'FTND_CIGARETTES_PER_DAY_MORE_THAN_THIRTY',
  FtndCigarettesPerDayNone = 'FTND_CIGARETTES_PER_DAY_NONE',
  FtndCigarettesPerDayTenOrLess = 'FTND_CIGARETTES_PER_DAY_TEN_OR_LESS',
  FtndCigarettesPerDayTwentyOneToThirty = 'FTND_CIGARETTES_PER_DAY_TWENTY_ONE_TO_THIRTY'
}

export enum Treatment_FtndFirstCigaretteTime {
  FtndFirstCigaretteTimeLongerThanSixtyMins = 'FTND_FIRST_CIGARETTE_TIME_LONGER_THAN_SIXTY_MINS',
  FtndFirstCigaretteTimeNone = 'FTND_FIRST_CIGARETTE_TIME_NONE',
  FtndFirstCigaretteTimeSixToThirtyMins = 'FTND_FIRST_CIGARETTE_TIME_SIX_TO_THIRTY_MINS',
  FtndFirstCigaretteTimeThirtyOneToSixtyMins = 'FTND_FIRST_CIGARETTE_TIME_THIRTY_ONE_TO_SIXTY_MINS',
  FtndFirstCigaretteTimeWithinFiveMins = 'FTND_FIRST_CIGARETTE_TIME_WITHIN_FIVE_MINS'
}

export type Treatment_FunctionTestsHandMsg = {
  __typename?: 'treatment_FunctionTestsHandMsg';
  allenTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  allenTestText?: Maybe<Scalars['String']>;
  bottleSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  bottleSignText?: Maybe<Scalars['String']>;
  carpalCompressionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  carpalCompressionTestText?: Maybe<Scalars['String']>;
  finkelsteinSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  finkelsteinSignText?: Maybe<Scalars['String']>;
  fistClosure?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fistClosureText?: Maybe<Scalars['String']>;
  hoffmannTinelSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  hoffmannTinelSignText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phalenSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  phalenSignText?: Maybe<Scalars['String']>;
  triggerFinger?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  triggerFingerText?: Maybe<Scalars['String']>;
};

export type Treatment_FunctionTestsHipAndPelvicMsg = {
  __typename?: 'treatment_FunctionTestsHipAndPelvicMsg';
  drehmannsSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  drehmannsSignText?: Maybe<Scalars['String']>;
  faberTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  faberTestText?: Maybe<Scalars['String']>;
  faddirTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  faddirTestText?: Maybe<Scalars['String']>;
  hipImpingementTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  hipImpingementTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mennellsSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  mennellsSignText?: Maybe<Scalars['String']>;
  patricksTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  patricksTestText?: Maybe<Scalars['String']>;
  psoasSnappingTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  psoasSnappingTestText?: Maybe<Scalars['String']>;
  spineTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  spineTestText?: Maybe<Scalars['String']>;
  standingFlexionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  standingFlexionTestText?: Maybe<Scalars['String']>;
  thomasTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thomasTestText?: Maybe<Scalars['String']>;
  threeStageHyperextensionsTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  threeStageHyperextensionsTestText?: Maybe<Scalars['String']>;
  tractSnappingTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tractSnappingTestText?: Maybe<Scalars['String']>;
  trendelenburgsSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  trendelenburgsSignText?: Maybe<Scalars['String']>;
};

export type Treatment_FunctionalExaminationOfVestibularNerveBlock = {
  __typename?: 'treatment_FunctionalExaminationOfVestibularNerveBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  nystagmusAssessments?: Maybe<Array<Maybe<Treatment_NystagmusAssessmentMsg>>>;
  vestibuloOcularReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: Maybe<Scalars['String']>;
};

export type Treatment_FurtherFunctionalTestsSpineBlock = {
  __typename?: 'treatment_FurtherFunctionalTestsSpineBlock';
  behindTheHeadWallDistance?: Maybe<Scalars['Float']>;
  behindTheHeadWallDistanceTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  chinSternumDistanceInclination?: Maybe<Scalars['Float']>;
  chinSternumDistanceReclination?: Maybe<Scalars['Float']>;
  chinSternumDistanceTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: Maybe<Scalars['String']>;
  thoracicCircumferenceDifference?: Maybe<Scalars['Float']>;
  thoracicCircumferenceDifferenceTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thoracicCircumferenceExpiration?: Maybe<Scalars['Float']>;
  thoracicCircumferenceInspiration?: Maybe<Scalars['Float']>;
};

export type Treatment_FurtherProceduresMsg = {
  __typename?: 'treatment_FurtherProceduresMsg';
  id?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<Maybe<Treatment_ClinicalRecommendationMsg>>>;
};

export type Treatment_FurtherShoulderFunctionTestsBlock = {
  __typename?: 'treatment_FurtherShoulderFunctionTestsBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_FurtherShoulderFunctionTestsMsg>;
  right?: Maybe<Treatment_FurtherShoulderFunctionTestsMsg>;
};

export type Treatment_FurtherShoulderFunctionTestsMsg = {
  __typename?: 'treatment_FurtherShoulderFunctionTestsMsg';
  anteriorApprehensionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorApprehensionTestText?: Maybe<Scalars['String']>;
  crossBodyTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  crossBodyTestText?: Maybe<Scalars['String']>;
  frontDrawer?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  frontDrawerText?: Maybe<Scalars['String']>;
  hawkinsKennedyTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  hawkinsKennedyTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  infraspinatusTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  infraspinatusTestText?: Maybe<Scalars['String']>;
  neerTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  neerTestText?: Maybe<Scalars['String']>;
  oBrienTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  oBrienTestText?: Maybe<Scalars['String']>;
  palmUpTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  palmUpTestText?: Maybe<Scalars['String']>;
  posteriorApprehensionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  posteriorApprehensionTestText?: Maybe<Scalars['String']>;
  rearDrawer?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  rearDrawerText?: Maybe<Scalars['String']>;
  speedTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  speedTestText?: Maybe<Scalars['String']>;
};

export type Treatment_GaitBlock = {
  __typename?: 'treatment_GaitBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  gait?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  heelWalking?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  heelWalkingText?: Maybe<Scalars['String']>;
  normalWalkingAndTurning?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  normalWalkingAndTurningDescriptions?: Maybe<Array<Maybe<Treatment_GaitDescriptionMsg>>>;
  tightropeWalking?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tightropeWalkingText?: Maybe<Scalars['String']>;
  toeWalking?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  toeWalkingText?: Maybe<Scalars['String']>;
  /** The unity of the walking distance is the meter (m). */
  walkingDistance?: Maybe<Scalars['Int']>;
  walkingDistanceText?: Maybe<Scalars['String']>;
};

export type Treatment_GaitDescriptionMsg = {
  __typename?: 'treatment_GaitDescriptionMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_GaitTestMsg = {
  __typename?: 'treatment_GaitTestMsg';
  initiationOfGait?: Maybe<Treatment_InitiationOfGait>;
  /** <yes (1) / no (0)> */
  leftFootCompletelyLeavesTheGroundWhileWalking?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  leftFootPassesRightStanceFoot?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Treatment_Path>;
  /** <yes (1) / no (0)> */
  rightAndLeftStepsAppearToBeOfEqualLength?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  rightFootCompletelyLeavesTheGroundWhileWalking?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  rightFootPassesLeftStanceFoot?: Maybe<Scalars['Boolean']>;
  stepContinually?: Maybe<Treatment_StepContinually>;
  trunk?: Maybe<Treatment_Trunk>;
  walkingStance?: Maybe<Treatment_WalkingStance>;
};

export type Treatment_GallBladderSignsBlock = {
  __typename?: 'treatment_GallBladderSignsBlock';
  courvoisiersSignPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  murphysSignPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_GastricTubeMsg = {
  __typename?: 'treatment_GastricTubeMsg';
  length?: Maybe<Scalars['Float']>;
  lengthUnit?: Maybe<Treatment_FlowSystemLengthUnit>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  materials?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  numberOfLumen?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_GastrointestinalDysfunctionBlock = {
  __typename?: 'treatment_GastrointestinalDysfunctionBlock';
  abdominalCramps?: Maybe<Scalars['Boolean']>;
  abdominalGirthIncrease?: Maybe<Scalars['Boolean']>;
  abdominalPain?: Maybe<Treatment_AbdominalPainMsg>;
  abdominalPainPresent?: Maybe<Scalars['Boolean']>;
  digestiveComplaints?: Maybe<Scalars['Boolean']>;
  flatulence?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  heartburnPresent?: Maybe<Scalars['Boolean']>;
  heartburnText?: Maybe<Scalars['String']>;
  ingestionAspirationPresent?: Maybe<Scalars['Boolean']>;
  nauseaPresent?: Maybe<Scalars['Boolean']>;
  nauseaText?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  regurgitationOnset?: Maybe<Treatment_RegurgitationOnset>;
  regurgitationPresent?: Maybe<Scalars['Boolean']>;
  stoolDescription?: Maybe<Treatment_StoolDescriptionMsg>;
  stoolDescriptionPresent?: Maybe<Scalars['Boolean']>;
  swallowingDifficultyPresent?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  vomitingPresent?: Maybe<Scalars['Boolean']>;
  vomitingText?: Maybe<Scalars['String']>;
  /** in kg */
  weightGain?: Maybe<Scalars['Float']>;
  weightIncrease?: Maybe<Scalars['Boolean']>;
};

export type Treatment_GeneralAnesthesiaMsg = {
  __typename?: 'treatment_GeneralAnesthesiaMsg';
  airwayAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  airwayManagements?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  anesthesiaSystems?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  blockage?: Maybe<Scalars['Boolean']>;
  /** unit: cmH2O */
  bronchialCuffPressure?: Maybe<Scalars['Int']>;
  canPerformWithoutAnesthesia?: Maybe<Scalars['Boolean']>;
  cormackLehaneClassification?: Maybe<Treatment_CormackLehaneClassification>;
  /** one decimal; unit: cm */
  depth?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intubationAccess?: Maybe<Treatment_IntubationAccess>;
  intubationText?: Maybe<Scalars['String']>;
  maskVentilations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  narcoticApplication?: Maybe<Treatment_NarcoticApplication>;
  patientIntubated?: Maybe<Scalars['Boolean']>;
  preoxygenation?: Maybe<Core_KnowledgeInputMsg>;
  rapidSequenceInduction?: Maybe<Scalars['Boolean']>;
  /** one-decimal; unit: <mm / Charr> */
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_GeneralAnesthesiaSizeUnit>;
  /** unit: cmH2O */
  trachealCuffPressure?: Maybe<Scalars['Int']>;
  tubeTypes?: Maybe<Array<Maybe<Treatment_GeneralAnesthesiaTubeTypeMsg>>>;
  types?: Maybe<Array<Maybe<Treatment_GeneralAnesthesiaType>>>;
  ventilationTypes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_GeneralAnesthesiaSizeUnit {
  GeneralAnesthesiaSizeUnitCharr = 'GENERAL_ANESTHESIA_SIZE_UNIT_CHARR',
  GeneralAnesthesiaSizeUnitMm = 'GENERAL_ANESTHESIA_SIZE_UNIT_MM',
  GeneralAnesthesiaSizeUnitNone = 'GENERAL_ANESTHESIA_SIZE_UNIT_NONE'
}

export type Treatment_GeneralAnesthesiaTubeTypeMsg = {
  __typename?: 'treatment_GeneralAnesthesiaTubeTypeMsg';
  generalId?: Maybe<Scalars['String']>;
  hasBronchialCuffPressure?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_GeneralAnesthesiaType {
  GeneralAnesthesiaTypeBalanced = 'GENERAL_ANESTHESIA_TYPE_BALANCED',
  GeneralAnesthesiaTypeInhalative = 'GENERAL_ANESTHESIA_TYPE_INHALATIVE',
  GeneralAnesthesiaTypeNone = 'GENERAL_ANESTHESIA_TYPE_NONE',
  GeneralAnesthesiaTypeTiva = 'GENERAL_ANESTHESIA_TYPE_TIVA'
}

export type Treatment_GeneralConditionBlock = {
  __typename?: 'treatment_GeneralConditionBlock';
  generalCondition?: Maybe<Treatment_GeneralConditionType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_GeneralConditionType {
  GeneralConditionGood = 'GENERAL_CONDITION_GOOD',
  GeneralConditionNone = 'GENERAL_CONDITION_NONE',
  GeneralConditionReduced = 'GENERAL_CONDITION_REDUCED',
  GeneralConditionSignificantlyReduced = 'GENERAL_CONDITION_SIGNIFICANTLY_REDUCED',
  GeneralConditionSlightlyReduced = 'GENERAL_CONDITION_SLIGHTLY_REDUCED'
}

export type Treatment_GeneralFindingsBlock = {
  __typename?: 'treatment_GeneralFindingsBlock';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_GeriatricDepressionScaleBlock = {
  __typename?: 'treatment_GeriatricDepressionScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Do you think you have more difficulty with memory than other people?: < yes (1) / no (0)> */
  difficultyWithMemory?: Maybe<Scalars['Boolean']>;
  /** Are you afraid that something bad will happen to you?: < yes (1) / no (0)> */
  fearFromFuture?: Maybe<Scalars['Boolean']>;
  /** Do you often feel bored?: < yes (1) / no (0)> */
  feelsBored?: Maybe<Scalars['Boolean']>;
  /** Do you feel full of energy?: < yes (0) / no (1)> */
  feelsFullOfEnergy?: Maybe<Scalars['Boolean']>;
  /** Do you feel happy most of the time?: < yes (0) / no (1)> */
  feelsHappy?: Maybe<Scalars['Boolean']>;
  /** Do you often feel helpless?: < yes (1) / no (0)> */
  feelsHelpless?: Maybe<Scalars['Boolean']>;
  /** Do you think most other people have it better than you?: < yes (1) / no (0)> */
  feelsOtherPeopleAreBetter?: Maybe<Scalars['Boolean']>;
  /** Do you feel that your situation is hopeless?: < yes (1) / no (0)> */
  feelsSituationIsHopeless?: Maybe<Scalars['Boolean']>;
  /** Do you feel pretty worthless in your current state?: < yes (1) / no (0)> */
  feelsWorthless?: Maybe<Scalars['Boolean']>;
  /** Have you given up many of your activities and interests?: < yes (1) / no (0)> */
  giveUpInterests?: Maybe<Scalars['Boolean']>;
  /** Are you in a good mood most of the time?: < yes (0) / no (1)> */
  inGoodMood?: Maybe<Scalars['Boolean']>;
  /** Do you feel like your life is empty?: < yes (1) / no (0)> */
  lifeEmpty?: Maybe<Scalars['Boolean']>;
  /** Are you basically satisfied with your life?: < yes (0) / no (1)> */
  lifeSatisfaction?: Maybe<Scalars['Boolean']>;
  /** Do you prefer to be at home instead of going out and doing something?: < yes (1) / no (0)> */
  preferIndoorsActivities?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** Do you think it is nice to be alive now?: < yes (0) / no (1)> */
  wantsToBeAlive?: Maybe<Scalars['Boolean']>;
};

export type Treatment_GetAnamnesisBlockRequest = {
  __typename?: 'treatment_GetAnamnesisBlockRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  blockId?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  fieldMask?: Maybe<FieldMask>;
  owningCardId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_GetAnamnesisCardAnamnesticProgressRequest = {
  __typename?: 'treatment_GetAnamnesisCardAnamnesticProgressRequest';
  anamnesticProgressId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardAnesthesiaBackgroundRequest = {
  __typename?: 'treatment_GetAnamnesisCardAnesthesiaBackgroundRequest';
  anesthesiaBackgroundId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardReasonForAdmissionRequest = {
  __typename?: 'treatment_GetAnamnesisCardReasonForAdmissionRequest';
  reasonForAdmissionId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardReasonForCareAdmissionRequest = {
  __typename?: 'treatment_GetAnamnesisCardReasonForCareAdmissionRequest';
  reasonForCareAdmissionId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardReasonRequest = {
  __typename?: 'treatment_GetAnamnesisCardReasonRequest';
  appointmentId?: Maybe<Scalars['String']>;
  reasonId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardSurgeryPreparationRequest = {
  __typename?: 'treatment_GetAnamnesisCardSurgeryPreparationRequest';
  surgeryPreparationId?: Maybe<Scalars['String']>;
};

export type Treatment_GetAnamnesisCardTemplateRequest = {
  __typename?: 'treatment_GetAnamnesisCardTemplateRequest';
  cardNumber?: Maybe<Scalars['Int']>;
  /** For the latest card template of the organizational unit */
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** For the card template of a specific treatment */
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
};

export type Treatment_GetAnamnesisRequest = {
  __typename?: 'treatment_GetAnamnesisRequest';
  anamnesisId?: Maybe<Scalars['String']>;
};

export type Treatment_GetChecklistRequest = {
  __typename?: 'treatment_GetChecklistRequest';
  checklistId?: Maybe<Scalars['String']>;
  compositeId?: Maybe<Treatment_CompositeChecklistIdMsg>;
};

export type Treatment_GetCommitRequest = {
  __typename?: 'treatment_GetCommitRequest';
  commitId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_GetDefaultFluidBalanceConfigurationRequest = {
  __typename?: 'treatment_GetDefaultFluidBalanceConfigurationRequest';
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type Treatment_GetDiagnosesRequest = {
  __typename?: 'treatment_GetDiagnosesRequest';
  diagnosisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetDiagnosesResponse = {
  __typename?: 'treatment_GetDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_GetDiagnosisCodingsRequest = {
  __typename?: 'treatment_GetDiagnosisCodingsRequest';
  diagnosisCodingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetDiagnosisLatestRevisionsRequest = {
  __typename?: 'treatment_GetDiagnosisLatestRevisionsRequest';
  revisionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetDiagnosisLatestRevisionsResponse = {
  __typename?: 'treatment_GetDiagnosisLatestRevisionsResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_GetFluidFlowSystemMetadataRequest = {
  __typename?: 'treatment_GetFluidFlowSystemMetadataRequest';
  detailsNumbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** optional for setting the description as a name with a specific language */
  language?: Maybe<Core_Language>;
};

export type Treatment_GetFluidFlowSystemMetadataResponse = {
  __typename?: 'treatment_GetFluidFlowSystemMetadataResponse';
  metadataList?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMetadataMsg>>>;
};

export type Treatment_GetFluidFlowSystemsRequest = {
  __typename?: 'treatment_GetFluidFlowSystemsRequest';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetFurtherProceduresRequest = {
  __typename?: 'treatment_GetFurtherProceduresRequest';
  procedureId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_GetLatestPractitionerRequest = {
  __typename?: 'treatment_GetLatestPractitionerRequest';
  administrativeUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** Finds the latest before this timestamp */
  latestTime?: Maybe<Timestamp>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_GetLatestPractitionerResponse = {
  __typename?: 'treatment_GetLatestPractitionerResponse';
  userId?: Maybe<Scalars['String']>;
};

export type Treatment_GetLatestTreatmentStatusInfoRequest = {
  __typename?: 'treatment_GetLatestTreatmentStatusInfoRequest';
  treatmentType?: Maybe<Treatment_TreatmentType>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetLatestTreatmentStatusInfoResponse = {
  __typename?: 'treatment_GetLatestTreatmentStatusInfoResponse';
  statusInfo?: Maybe<Array<Maybe<Treatment_TreatmentStatusInfoMsg>>>;
};

export type Treatment_GetLatestWoundVersionRequest = {
  __typename?: 'treatment_GetLatestWoundVersionRequest';
  woundVersionGroupId?: Maybe<Scalars['String']>;
};

export type Treatment_GetLatestWoundVersionsRequest = {
  __typename?: 'treatment_GetLatestWoundVersionsRequest';
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetPhysicalBlockRequest = {
  __typename?: 'treatment_GetPhysicalBlockRequest';
  blockId?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  fieldMask?: Maybe<FieldMask>;
  physicalId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_GetPhysicalDefaultPathRequest = {
  __typename?: 'treatment_GetPhysicalDefaultPathRequest';
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_GetPhysicalExaminationRequest = {
  __typename?: 'treatment_GetPhysicalExaminationRequest';
  fieldMask?: Maybe<FieldMask>;
  physicalExaminationId?: Maybe<Scalars['String']>;
};

export type Treatment_GetProblemSpecificAnamnesisCardRequest = {
  __typename?: 'treatment_GetProblemSpecificAnamnesisCardRequest';
  cardId?: Maybe<Scalars['String']>;
};

export type Treatment_GetProblemSpecificCardsMetadataRequest = {
  __typename?: 'treatment_GetProblemSpecificCardsMetadataRequest';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_GetSymptomConfigurationRequest = {
  __typename?: 'treatment_GetSymptomConfigurationRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_GetTherapyCardMetadataListRequest = {
  __typename?: 'treatment_GetTherapyCardMetadataListRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['Boolean']>;
  /**
   * if empty, don't filter by tag
   *  if card metadata has one of these filters we have it in the response.
   */
  tags?: Maybe<Array<Maybe<Treatment_TherapyCardMetadataTag>>>;
  therapyId?: Maybe<Scalars['String']>;
  therapyTemplateId?: Maybe<Scalars['String']>;
  /** should be set if organizationalUnitId is set. */
  treatmentType?: Maybe<Treatment_TreatmentType>;
};

export type Treatment_GetTherapyCardMetadataListResponse = {
  __typename?: 'treatment_GetTherapyCardMetadataListResponse';
  elements?: Maybe<Array<Maybe<Treatment_TherapyCardMetadataListElementMsg>>>;
};

export type Treatment_GetTherapyCardRequest = {
  __typename?: 'treatment_GetTherapyCardRequest';
  therapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_GetTherapyRequest = {
  __typename?: 'treatment_GetTherapyRequest';
  therapyId?: Maybe<Scalars['String']>;
};

export type Treatment_GetTreatmentDetailsRequest = {
  __typename?: 'treatment_GetTreatmentDetailsRequest';
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_GetTreatmentRequest = {
  __typename?: 'treatment_GetTreatmentRequest';
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_GetTreatmentTypesRequest = {
  __typename?: 'treatment_GetTreatmentTypesRequest';
  physicalExaminationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_GetTreatmentTypesResponse = {
  __typename?: 'treatment_GetTreatmentTypesResponse';
  treatmentTypes?: Maybe<Array<Maybe<Treatment_GetTreatmentTypesResponseEntry>>>;
};

export type Treatment_GetTreatmentTypesResponseEntry = {
  __typename?: 'treatment_GetTreatmentTypesResponseEntry';
  physicalExaminationId?: Maybe<Scalars['String']>;
  treatmentTypeMsg?: Maybe<Treatment_TreatmentTypeMsg>;
};

export type Treatment_GetWoundHistoryRequest = {
  __typename?: 'treatment_GetWoundHistoryRequest';
  versionGroupId?: Maybe<Scalars['String']>;
};

export enum Treatment_GettingUp {
  GettingUpDependent = 'GETTING_UP_DEPENDENT',
  GettingUpNone = 'GETTING_UP_NONE',
  GettingUpWithoutDifficulty = 'GETTING_UP_WITHOUT_DIFFICULTY',
  GettingUpWithAssistance = 'GETTING_UP_WITH_ASSISTANCE'
}

export enum Treatment_GlasgowComaScale {
  /** ≥4 to <8 (6) */
  GlasgowComaScaleBetween_4InclusiveAnd_8Exclusive = 'GLASGOW_COMA_SCALE_BETWEEN_4_INCLUSIVE_AND_8_EXCLUSIVE',
  /** ≥8 (0) */
  GlasgowComaScaleGreaterThanOrEqual_8 = 'GLASGOW_COMA_SCALE_GREATER_THAN_OR_EQUAL_8',
  /** <4 (13) */
  GlasgowComaScaleLessThan_4 = 'GLASGOW_COMA_SCALE_LESS_THAN_4',
  GlasgowComaScaleNone = 'GLASGOW_COMA_SCALE_NONE'
}

export type Treatment_GlasgowComaScaleBlock = {
  __typename?: 'treatment_GlasgowComaScaleBlock';
  eyeResponse?: Maybe<Treatment_EyeResponseType>;
  gcsScore?: Maybe<Scalars['Int']>;
  motorResponse?: Maybe<Treatment_MotorResponseType>;
  verbalResponse?: Maybe<Treatment_VerbalResponseType>;
};

export type Treatment_GlasgowComaScaleScoreBlock = {
  __typename?: 'treatment_GlasgowComaScaleScoreBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  eyeResponse?: Maybe<Treatment_EyeResponseType>;
  motorResponse?: Maybe<Treatment_MotorResponseType>;
  score?: Maybe<Scalars['Int']>;
  verbalResponse?: Maybe<Treatment_VerbalResponseType>;
};

export type Treatment_GlobalAssessmentOfFunctioningBlock = {
  __typename?: 'treatment_GlobalAssessmentOfFunctioningBlock';
  completed?: Maybe<Scalars['Boolean']>;
  /** non-negative integers from 1-100; unit: % */
  globalAssessmentOfFunctioning?: Maybe<Scalars['Int']>;
};

export enum Treatment_GlutealMuscleStrength {
  /** 1/5 - 2/5 */
  GlutealMuscleStrength_1_5To_2_5 = 'GLUTEAL_MUSCLE_STRENGTH_1_5_TO_2_5',
  /** 3/5 */
  GlutealMuscleStrength_3_5 = 'GLUTEAL_MUSCLE_STRENGTH_3_5',
  /** 4/5 to 5/5 */
  GlutealMuscleStrength_4_5To_5_5 = 'GLUTEAL_MUSCLE_STRENGTH_4_5_TO_5_5',
  GlutealMuscleStrengthNone = 'GLUTEAL_MUSCLE_STRENGTH_NONE'
}

export type Treatment_GoalAttainmentScaleBlock = {
  __typename?: 'treatment_GoalAttainmentScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  goalA?: Maybe<Scalars['String']>;
  goalB?: Maybe<Scalars['String']>;
  goalC?: Maybe<Scalars['String']>;
  goalD?: Maybe<Scalars['String']>;
  goalDegreeOfAchievementA?: Maybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementB?: Maybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementC?: Maybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementD?: Maybe<Treatment_GoalDegreeOfAchievement>;
  goalDegreeOfAchievementE?: Maybe<Treatment_GoalDegreeOfAchievement>;
  goalE?: Maybe<Scalars['String']>;
};

export enum Treatment_GoalDegreeOfAchievement {
  GoalDegreeOfAchievement_10Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_10_PERCENT',
  GoalDegreeOfAchievement_20Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_20_PERCENT',
  GoalDegreeOfAchievement_30Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_30_PERCENT',
  GoalDegreeOfAchievement_40Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_40_PERCENT',
  GoalDegreeOfAchievement_50Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_50_PERCENT',
  GoalDegreeOfAchievement_60Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_60_PERCENT',
  GoalDegreeOfAchievement_70Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_70_PERCENT',
  GoalDegreeOfAchievement_80Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_80_PERCENT',
  GoalDegreeOfAchievement_90Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_90_PERCENT',
  GoalDegreeOfAchievement_100Percent = 'GOAL_DEGREE_OF_ACHIEVEMENT_100_PERCENT',
  GoalDegreeOfAchievementNone = 'GOAL_DEGREE_OF_ACHIEVEMENT_NONE'
}

export enum Treatment_Got {
  /** ≥1000 (4) */
  GotGreaterThanOrEqual_1000 = 'GOT_GREATER_THAN_OR_EQUAL_1000',
  /** <1000 (0) */
  GotLessThan_1000 = 'GOT_LESS_THAN_1000',
  GotNone = 'GOT_NONE'
}

export enum Treatment_GrimaceEnum {
  GrimaceEnumCry = 'GRIMACE_ENUM_CRY',
  GrimaceEnumGrimace = 'GRIMACE_ENUM_GRIMACE',
  GrimaceEnumNone = 'GRIMACE_ENUM_NONE',
  GrimaceEnumNoResponse = 'GRIMACE_ENUM_NO_RESPONSE'
}

export enum Treatment_Grooming {
  GroomingIndependent = 'GROOMING_INDEPENDENT',
  GroomingNone = 'GROOMING_NONE',
  GroomingUnable = 'GROOMING_UNABLE'
}

export enum Treatment_GuiltFeelings {
  GuiltFeelingsAlwaysHaveGuiltFeelings = 'GUILT_FEELINGS_ALWAYS_HAVE_GUILT_FEELINGS',
  GuiltFeelingsNone = 'GUILT_FEELINGS_NONE',
  GuiltFeelingsNoGuiltFeelings = 'GUILT_FEELINGS_NO_GUILT_FEELINGS',
  GuiltFeelingsOftenHaveGuiltFeelings = 'GUILT_FEELINGS_OFTEN_HAVE_GUILT_FEELINGS',
  GuiltFeelingsUsuallyHaveGuiltFeelings = 'GUILT_FEELINGS_USUALLY_HAVE_GUILT_FEELINGS'
}

export type Treatment_HairScalpInspectionBlock = {
  __typename?: 'treatment_HairScalpInspectionBlock';
  erythema?: Maybe<Scalars['Boolean']>;
  erythemaText?: Maybe<Scalars['String']>;
  hairDensityReduction?: Maybe<Scalars['Boolean']>;
  hairDensityReductionText?: Maybe<Scalars['String']>;
  partingHairBorderLeft?: Maybe<Scalars['Float']>;
  partingHairBorderMiddle?: Maybe<Scalars['Float']>;
  partingHairBorderRight?: Maybe<Scalars['Float']>;
  pustules?: Maybe<Scalars['Boolean']>;
  pustulesText?: Maybe<Scalars['String']>;
  scaling?: Maybe<Scalars['Boolean']>;
  scalingText?: Maybe<Scalars['String']>;
};

export type Treatment_HairScalpPalpationBlock = {
  __typename?: 'treatment_HairScalpPalpationBlock';
  epilationBorderArea?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  epilationBorderAreaText?: Maybe<Scalars['String']>;
  epilationDiffuseScalp?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  epilationDiffuseScalpText?: Maybe<Scalars['String']>;
};

export type Treatment_HandFunctionTestsBlock = {
  __typename?: 'treatment_HandFunctionTestsBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_FunctionTestsHandMsg>;
  right?: Maybe<Treatment_FunctionTestsHandMsg>;
};

export enum Treatment_HandReach {
  HandReachBeyondHead = 'HAND_REACH_BEYOND_HEAD',
  HandReachGirth = 'HAND_REACH_GIRTH',
  HandReachNeck = 'HAND_REACH_NECK',
  HandReachNone = 'HAND_REACH_NONE',
  HandReachVertex = 'HAND_REACH_VERTEX',
  HandReachXiphoid = 'HAND_REACH_XIPHOID'
}

export enum Treatment_HandlingFeedingTube {
  /** Cannot assist with feeding tube at any point */
  HandlingFeedingTubeCannotAssist = 'HANDLING_FEEDING_TUBE_CANNOT_ASSIST',
  /** Minimal assistance can be given with feeding tube */
  HandlingFeedingTubeMinAssistanceNeeded = 'HANDLING_FEEDING_TUBE_MIN_ASSISTANCE_NEEDED',
  HandlingFeedingTubeNone = 'HANDLING_FEEDING_TUBE_NONE',
  /** Somewhat slow and awkward, but all actions can be performed independently */
  HandlingFeedingTubeSlowAndAwkward = 'HANDLING_FEEDING_TUBE_SLOW_AND_AWKWARD',
  /** Some assistance needed when handling caps and lids */
  HandlingFeedingTubeSomeAssistanceNeeded = 'HANDLING_FEEDING_TUBE_SOME_ASSISTANCE_NEEDED',
  HandlingFeedingTubeUndisturbed = 'HANDLING_FEEDING_TUBE_UNDISTURBED'
}

export enum Treatment_Handwriting {
  HandwritingCannotHoldPen = 'HANDWRITING_CANNOT_HOLD_PEN',
  /** Holding pen is possible, but not legible writing */
  HandwritingHoldingPen = 'HANDWRITING_HOLDING_PEN',
  HandwritingNone = 'HANDWRITING_NONE',
  /** Not all words are legible */
  HandwritingNotAllWordsLegible = 'HANDWRITING_NOT_ALL_WORDS_LEGIBLE',
  /** Slower or unclean, all words are legible */
  HandwritingSlowerOrUnclean = 'HANDWRITING_SLOWER_OR_UNCLEAN',
  HandwritingUndisturbed = 'HANDWRITING_UNDISTURBED'
}

export type Treatment_HasBledBlock = {
  __typename?: 'treatment_HasBledBlock';
  /** yes (1) / no (0) */
  abnormalLiverFunction?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  abnormalRenalFunction?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  ageGreaterThan65?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  alcoholAbuse?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  bleedingTendency?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  concomitantAntiplateletAgents?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  hypertension?: Maybe<Scalars['Boolean']>;
  /** yes (1) / no (0) */
  labileINsInPatientTakingWarfarin?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** yes (1) / no (0) */
  stroke?: Maybe<Scalars['Boolean']>;
};

export type Treatment_HeadAndNeckLymphNodesBlock = {
  __typename?: 'treatment_HeadAndNeckLymphNodesBlock';
  abnormalitiesPresent?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: Maybe<Array<Maybe<Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export type Treatment_HeadAndNeckMsg = {
  __typename?: 'treatment_HeadAndNeckMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  id?: Maybe<Scalars['String']>;
  inclination?: Maybe<Treatment_SingleForceLevelAndDetailsMsg>;
  reclination?: Maybe<Treatment_SingleForceLevelAndDetailsMsg>;
  rotation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
};

export type Treatment_HeadAndNeckPasiMsg = {
  __typename?: 'treatment_HeadAndNeckPasiMsg';
  headAndNeckBodyRegionPercentage?: Maybe<Treatment_BodyRegionPercentage>;
  headAndNeckDiscoloration?: Maybe<Treatment_PasiSelection>;
  headAndNeckScaling?: Maybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.1> */
  headAndNeckScore?: Maybe<Scalars['Float']>;
  headAndNeckThickness?: Maybe<Treatment_PasiSelection>;
};

export type Treatment_HeadJointsMsg = {
  __typename?: 'treatment_HeadJointsMsg';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_HeadSalivaryGlandsBlock = {
  __typename?: 'treatment_HeadSalivaryGlandsBlock';
  abnormalitiesResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  abnormalitiesResultText?: Maybe<Scalars['String']>;
  excretoryGlands?: Maybe<Array<Maybe<Treatment_ExcretoryGlandsMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
};

export type Treatment_HearingBlock = {
  __typename?: 'treatment_HearingBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  gelleTestLeft?: Maybe<Scalars['Boolean']>;
  gelleTestLeftText?: Maybe<Scalars['String']>;
  gelleTestRight?: Maybe<Scalars['Boolean']>;
  gelleTestRightText?: Maybe<Scalars['String']>;
  leftAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  leftAbnormalitiesText?: Maybe<Scalars['String']>;
  rightAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  rightAbnormalitiesText?: Maybe<Scalars['String']>;
  rinneTestLeft?: Maybe<Scalars['Boolean']>;
  rinneTestLeftText?: Maybe<Scalars['String']>;
  rinneTestRight?: Maybe<Scalars['Boolean']>;
  rinneTestRightText?: Maybe<Scalars['String']>;
  simpleHearingTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  weberTest?: Maybe<Treatment_WeberTestResultType>;
  weberTestText?: Maybe<Scalars['String']>;
  whisperedSpeechTestLeft?: Maybe<Core_KnowledgeInputMsg>;
  whisperedSpeechTestLeftText?: Maybe<Scalars['String']>;
  whisperedSpeechTestRight?: Maybe<Core_KnowledgeInputMsg>;
  whisperedSpeechTestRightText?: Maybe<Scalars['String']>;
};

export type Treatment_HeartMurmursBlock = {
  __typename?: 'treatment_HeartMurmursBlock';
  heartMurmurs?: Maybe<Array<Maybe<Treatment_HeartMurmursMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_HeartMurmursConduction {
  HeartMurmursConductionAxilla = 'HEART_MURMURS_CONDUCTION_AXILLA',
  HeartMurmursConductionCarotids = 'HEART_MURMURS_CONDUCTION_CAROTIDS',
  HeartMurmursConductionNone = 'HEART_MURMURS_CONDUCTION_NONE',
  HeartMurmursNoConduction = 'HEART_MURMURS_NO_CONDUCTION'
}

export type Treatment_HeartMurmursMsg = {
  __typename?: 'treatment_HeartMurmursMsg';
  conductionPresent?: Maybe<Scalars['Boolean']>;
  conductions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  punctumMaximum?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  timeCourses?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** Sound volume in volume/6 (1/6 ... 6/6) without unit */
  timePoints?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  tonalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  volume?: Maybe<Scalars['Int']>;
};

export enum Treatment_HeartMurmursTimeCourse {
  HeartMurmursTimeCourseBandShaped = 'HEART_MURMURS_TIME_COURSE_BAND_SHAPED',
  HeartMurmursTimeCourseCrescendo = 'HEART_MURMURS_TIME_COURSE_CRESCENDO',
  HeartMurmursTimeCourseCrescendoDecrescendo = 'HEART_MURMURS_TIME_COURSE_CRESCENDO_DECRESCENDO',
  HeartMurmursTimeCourseDecrescendo = 'HEART_MURMURS_TIME_COURSE_DECRESCENDO',
  HeartMurmursTimeCourseHolosystolic = 'HEART_MURMURS_TIME_COURSE_HOLOSYSTOLIC',
  HeartMurmursTimeCourseNone = 'HEART_MURMURS_TIME_COURSE_NONE',
  HeartMurmursTimeCourseSpindleShaped = 'HEART_MURMURS_TIME_COURSE_SPINDLE_SHAPED'
}

export enum Treatment_HeartMurmursTimePoint {
  HeartMurmursTimePointDiastolic = 'HEART_MURMURS_TIME_POINT_DIASTOLIC',
  HeartMurmursTimePointEarlyDiastolic = 'HEART_MURMURS_TIME_POINT_EARLY_DIASTOLIC',
  HeartMurmursTimePointEarlySystolic = 'HEART_MURMURS_TIME_POINT_EARLY_SYSTOLIC',
  HeartMurmursTimePointHolosystolic = 'HEART_MURMURS_TIME_POINT_HOLOSYSTOLIC',
  HeartMurmursTimePointLateDiastolic = 'HEART_MURMURS_TIME_POINT_LATE_DIASTOLIC',
  HeartMurmursTimePointLateSystolic = 'HEART_MURMURS_TIME_POINT_LATE_SYSTOLIC',
  HeartMurmursTimePointMesosystolic = 'HEART_MURMURS_TIME_POINT_MESOSYSTOLIC',
  HeartMurmursTimePointMiddleDiastolic = 'HEART_MURMURS_TIME_POINT_MIDDLE_DIASTOLIC',
  HeartMurmursTimePointMiddleSystolic = 'HEART_MURMURS_TIME_POINT_MIDDLE_SYSTOLIC',
  HeartMurmursTimePointNone = 'HEART_MURMURS_TIME_POINT_NONE',
  HeartMurmursTimePointSystolic = 'HEART_MURMURS_TIME_POINT_SYSTOLIC'
}

export enum Treatment_HeartMurmursTonality {
  HeartMurmursTonalityBlowing = 'HEART_MURMURS_TONALITY_BLOWING',
  HeartMurmursTonalityDecongestant = 'HEART_MURMURS_TONALITY_DECONGESTANT',
  HeartMurmursTonalityHarsh = 'HEART_MURMURS_TONALITY_HARSH',
  HeartMurmursTonalityHighFrequency = 'HEART_MURMURS_TONALITY_HIGH_FREQUENCY',
  HeartMurmursTonalityLowFrequency = 'HEART_MURMURS_TONALITY_LOW_FREQUENCY',
  HeartMurmursTonalityMusical = 'HEART_MURMURS_TONALITY_MUSICAL',
  HeartMurmursTonalityNone = 'HEART_MURMURS_TONALITY_NONE',
  HeartMurmursTonalityPouring = 'HEART_MURMURS_TONALITY_POURING',
  HeartMurmursTonalityRumbling = 'HEART_MURMURS_TONALITY_RUMBLING',
  HeartMurmursTonalityShabby = 'HEART_MURMURS_TONALITY_SHABBY',
  HeartMurmursTonalitySoft = 'HEART_MURMURS_TONALITY_SOFT',
  HeartMurmursTonalitySwelling = 'HEART_MURMURS_TONALITY_SWELLING',
  HeartMurmursTonalityWhistling = 'HEART_MURMURS_TONALITY_WHISTLING'
}

export type Treatment_HeartRateBlock = {
  __typename?: 'treatment_HeartRateBlock';
  heartFrequency?: Maybe<Scalars['Int']>;
  heartRate?: Maybe<Treatment_HeartRateType>;
};

export enum Treatment_HeartRateType {
  HeartRateBradycardia = 'HEART_RATE_BRADYCARDIA',
  HeartRateNone = 'HEART_RATE_NONE',
  HeartRateNormofrequent = 'HEART_RATE_NORMOFREQUENT',
  HeartRateTachycardia = 'HEART_RATE_TACHYCARDIA'
}

export enum Treatment_HeartRhythmType {
  HeartRhythmArrhythmic = 'HEART_RHYTHM_ARRHYTHMIC',
  HeartRhythmNone = 'HEART_RHYTHM_NONE',
  HeartRhythmRhythmic = 'HEART_RHYTHM_RHYTHMIC'
}

export type Treatment_HeartSoundBlock = {
  __typename?: 'treatment_HeartSoundBlock';
  heartRhythm?: Maybe<Treatment_HeartRhythmType>;
  heartSound?: Maybe<Treatment_HeartSoundType>;
  heartSoundFeatures?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  specialTones?: Maybe<Scalars['String']>;
};

export enum Treatment_HeartSoundType {
  HeartSoundsImpure = 'HEART_SOUNDS_IMPURE',
  HeartSoundsNone = 'HEART_SOUNDS_NONE',
  HeartSoundsPure = 'HEART_SOUNDS_PURE'
}

export enum Treatment_Heating {
  HeatingGoodAndComfort = 'HEATING_GOOD_AND_COMFORT',
  HeatingNone = 'HEATING_NONE',
  HeatingPoorTroublesomeToHeat = 'HEATING_POOR_TROUBLESOME_TO_HEAT'
}

export type Treatment_HematomaMsg = {
  __typename?: 'treatment_HematomaMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_HemorrhoidsDegree {
  HemorrhoidsDegreeTypeFour = 'HEMORRHOIDS_DEGREE_TYPE_FOUR',
  HemorrhoidsDegreeTypeNone = 'HEMORRHOIDS_DEGREE_TYPE_NONE',
  HemorrhoidsDegreeTypeThree = 'HEMORRHOIDS_DEGREE_TYPE_THREE',
  HemorrhoidsDegreeTypeTwo = 'HEMORRHOIDS_DEGREE_TYPE_TWO'
}

/** Hendrich Fall Risk for BAss */
export type Treatment_HendrichBassBlock = {
  __typename?: 'treatment_HendrichBassBlock';
  alteredElimination?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  confusionOrDisorientation?: Maybe<Scalars['Boolean']>;
  depression?: Maybe<Scalars['Boolean']>;
  dizzinessOrVertigo?: Maybe<Scalars['Boolean']>;
  nonAdaptiveMobilityOrGeneralizedWeakness?: Maybe<Scalars['Boolean']>;
  recentHistoryOfFalls?: Maybe<Scalars['Boolean']>;
  /** automatic computation of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
};

/** Hendrich Fall Risk */
export type Treatment_HendrichBlock = {
  __typename?: 'treatment_HendrichBlock';
  alteredElimination?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  confusionOrDisorientation?: Maybe<Scalars['Boolean']>;
  depression?: Maybe<Scalars['Boolean']>;
  dizzinessOrVertigo?: Maybe<Scalars['Boolean']>;
  nonAdaptiveMobilityOrGeneralizedWeakness?: Maybe<Scalars['Boolean']>;
  primaryCancerDiagnosis?: Maybe<Scalars['Boolean']>;
  recentHistoryOfFalls?: Maybe<Scalars['Boolean']>;
  /** automatic computation of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_HepatischeEnzephalopathie {
  /** Grade I-II (2) */
  HepatischeEnzephalopathieGradeIIi = 'HEPATISCHE_ENZEPHALOPATHIE_GRADE_I_II',
  /** >Grade II (3) */
  HepatischeEnzephalopathieMoreThanGradeIi = 'HEPATISCHE_ENZEPHALOPATHIE_MORE_THAN_GRADE_II',
  HepatischeEnzephalopathieNone = 'HEPATISCHE_ENZEPHALOPATHIE_NONE',
  /** no Encephalopathy (1) */
  HepatischeEnzephalopathieNoEncephalopathy = 'HEPATISCHE_ENZEPHALOPATHIE_NO_ENCEPHALOPATHY'
}

export type Treatment_HereditaryKidneyTumorBlock = {
  __typename?: 'treatment_HereditaryKidneyTumorBlock';
  /** Bilateral tumor: <yes (0.5) / no (0)> (singleselect) */
  bilateralTumor?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  /** Dermatology Leiomyoma or fibrofollicucoma/enoral fibroma/nail fold fibroma/angiofibroma: <yes (1) / no (0)> (singleselect) */
  dermatologyLeiomyoma?: Maybe<Scalars['Boolean']>;
  /** Age at initial diagnosis < 45 years: <yes (1.5) / no (0)> (singleselect) */
  diagnosisBeforeFortyFive?: Maybe<Scalars['Boolean']>;
  /** GIST: <yes (1) / no (0)> (singleselect) */
  gist?: Maybe<Scalars['Boolean']>;
  /** Hemangioblastoma retina/CNS, childhood seizures: <yes (1) / no (0)> (singleselect) */
  hemangioblastoma?: Maybe<Scalars['Boolean']>;
  /** Multifocal tumor (non-papillary in terminal NI): <yes (1) / no (0)> (singleselect) */
  multifocalTumor?: Maybe<Scalars['Boolean']>;
  /** Non-clear cell RCC: <yes (1) / no (0)> (singleselect) */
  nonclearCellRcc?: Maybe<Scalars['Boolean']>;
  /** Phaeochromocytoma/paraganglion: <yes (1) / no (0)> (singleselect) */
  phaeochromocytoma?: Maybe<Scalars['Boolean']>;
  /** Pulmonary cysts, recurrent pneumathoraces, lympangioleiomyomatosis: <yes (1) / no (0)> (singleselect) */
  pulmonaryCysts?: Maybe<Scalars['Boolean']>;
  /** Positive family history for RCC-associated tumor syndromes?: <yes (1.5) / no (0)> (singleselect) */
  rccSyndromesInFamily?: Maybe<Scalars['Boolean']>;
  /** Renal tumor in the family 1st/2nd degree of kinship: <yes (1.5) / no (0)> (singleselect) */
  renalTumorInFamily?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  /** Uterus with multiple leiomyomas or fibroid tumors (aged <30 years): <yes (1.5) / no (0)> (singleselect) */
  uterusLeiomyomas?: Maybe<Scalars['Boolean']>;
};

export type Treatment_HerniaBlock = {
  __typename?: 'treatment_HerniaBlock';
  hernias?: Maybe<Array<Maybe<Treatment_HerniaMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_HerniaMsg = {
  __typename?: 'treatment_HerniaMsg';
  bowelSoundsPresent?: Maybe<Scalars['Boolean']>;
  herniaType?: Maybe<Core_KnowledgeInputMsg>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  palpable?: Maybe<Scalars['Boolean']>;
  reponible?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type Treatment_HipAndPelvicFunctionTestsBlock = {
  __typename?: 'treatment_HipAndPelvicFunctionTestsBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_FunctionTestsHipAndPelvicMsg>;
  right?: Maybe<Treatment_FunctionTestsHipAndPelvicMsg>;
};

export enum Treatment_HipExtensionDeficit {
  HipExtensionDeficit_10To_25 = 'HIP_EXTENSION_DEFICIT_10_TO_25',
  HipExtensionDeficitGreaterThanEqual_30 = 'HIP_EXTENSION_DEFICIT_GREATER_THAN_EQUAL_30',
  HipExtensionDeficitLessThanEqual_5 = 'HIP_EXTENSION_DEFICIT_LESS_THAN_EQUAL_5',
  HipExtensionDeficitNone = 'HIP_EXTENSION_DEFICIT_NONE'
}

export type Treatment_HipJointMsg = {
  __typename?: 'treatment_HipJointMsg';
  abduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  adduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_HipWalkingDistance {
  /** walking at a stretch up to 500m possible */
  HipWalkingDistance_500m = 'HIP_WALKING_DISTANCE_500m',
  HipWalkingDistanceImmobile = 'HIP_WALKING_DISTANCE_IMMOBILE',
  /** mobile in room */
  HipWalkingDistanceInRoom = 'HIP_WALKING_DISTANCE_IN_ROOM',
  HipWalkingDistanceNone = 'HIP_WALKING_DISTANCE_NONE',
  HipWalkingDistanceUnlimited = 'HIP_WALKING_DISTANCE_UNLIMITED'
}

export enum Treatment_HobbiesStatus {
  HobbiesStatusNone = 'HOBBIES_STATUS_NONE',
  HobbiesStatusNonPresent = 'HOBBIES_STATUS_NON_PRESENT',
  HobbiesStatusPresent = 'HOBBIES_STATUS_PRESENT'
}

export enum Treatment_HoehnAndYahrStage {
  HoehnAndYahrStageAsymptomatic = 'HOEHN_AND_YAHR_STAGE_ASYMPTOMATIC',
  HoehnAndYahrStageBedriddenUnlessAided = 'HOEHN_AND_YAHR_STAGE_BEDRIDDEN_UNLESS_AIDED',
  HoehnAndYahrStageBilateralInvolvementWithoutImpairmentBalance = 'HOEHN_AND_YAHR_STAGE_BILATERAL_INVOLVEMENT_WITHOUT_IMPAIRMENT_BALANCE',
  HoehnAndYahrStageMildToModerateInvolvement = 'HOEHN_AND_YAHR_STAGE_MILD_TO_MODERATE_INVOLVEMENT',
  HoehnAndYahrStageNone = 'HOEHN_AND_YAHR_STAGE_NONE',
  HoehnAndYahrStageSevereDisability = 'HOEHN_AND_YAHR_STAGE_SEVERE_DISABILITY',
  HoehnAndYahrStageUnilateralInvolvementOnly = 'HOEHN_AND_YAHR_STAGE_UNILATERAL_INVOLVEMENT_ONLY'
}

export type Treatment_HousingSituationMsg = {
  __typename?: 'treatment_HousingSituationMsg';
  bathroom?: Maybe<Treatment_Bathroom>;
  comfort?: Maybe<Treatment_Comfort>;
  heating?: Maybe<Treatment_Heating>;
  housingSituationScore?: Maybe<Scalars['Int']>;
  housingSituationStairs?: Maybe<Treatment_HousingSituationStairs>;
  lengthOfResidence?: Maybe<Treatment_LengthOfResidence>;
  lighting?: Maybe<Treatment_Lighting>;
  localTransport?: Maybe<Treatment_LocalTransport>;
  satisfactionWithHousingCondition?: Maybe<Treatment_SatisfactionWithHousingSituation>;
  shopping?: Maybe<Treatment_Shopping>;
  telephone?: Maybe<Treatment_Telephone>;
  water?: Maybe<Treatment_Water>;
};

export enum Treatment_HousingSituationStairs {
  HousingSituationStairsGroundFloor = 'HOUSING_SITUATION_STAIRS_GROUND_FLOOR',
  HousingSituationStairsNone = 'HOUSING_SITUATION_STAIRS_NONE',
  HousingSituationStairsSecondFloorOrHigher = 'HOUSING_SITUATION_STAIRS_SECOND_FLOOR_OR_HIGHER'
}

export enum Treatment_Hunger {
  HungerIncreased = 'HUNGER_INCREASED',
  HungerNone = 'HUNGER_NONE',
  HungerNormal = 'HUNGER_NORMAL',
  HungerReduced = 'HUNGER_REDUCED'
}

export enum Treatment_Hygiene {
  HygieneDependent = 'HYGIENE_DEPENDENT',
  HygieneNone = 'HYGIENE_NONE',
  HygieneWithoutDifficulty = 'HYGIENE_WITHOUT_DIFFICULTY',
  HygieneWithAssistance = 'HYGIENE_WITH_ASSISTANCE'
}

export type Treatment_HypopharynxMsg = {
  __typename?: 'treatment_HypopharynxMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

/** Instrumental activities of daily living (IADL) */
export type Treatment_IadlBlock = {
  __typename?: 'treatment_IadlBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  iadlCooking?: Maybe<Treatment_IadlCooking>;
  iadlFunction?: Maybe<Treatment_IadlFunction>;
  iadlHousehold?: Maybe<Treatment_IadlHousehold>;
  iadlLaundry?: Maybe<Treatment_IadlLaundry>;
  iadlMedication?: Maybe<Treatment_IadlMedication>;
  iadlMoneyTransactions?: Maybe<Treatment_IadlMoneyTransactions>;
  iadlShopping?: Maybe<Treatment_IadlShopping>;
  iadlTransportation?: Maybe<Treatment_IadlTransportation>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_IadlCooking {
  /** Needs meals prepared and served (0) */
  IadlCookingNeedsMealsPreparedAndServed = 'IADL_COOKING_NEEDS_MEALS_PREPARED_AND_SERVED',
  IadlCookingNone = 'IADL_COOKING_NONE',
  /** Cooks needed meals only after preparation by others (0) */
  IadlCookingOnlyCooksNeededMeals = 'IADL_COOKING_ONLY_COOKS_NEEDED_MEALS',
  /** Cooks independently, but does not follow needed diet (0) */
  IadlCookingOnlyCooksWithoutDiet = 'IADL_COOKING_ONLY_COOKS_WITHOUT_DIET',
  /** Plans and cooks needed meals independently (1) */
  IadlCookingPlansAndCooksNeededMeals = 'IADL_COOKING_PLANS_AND_COOKS_NEEDED_MEALS'
}

export enum Treatment_IadlFunction {
  /** Answers but does not dial independently (1) */
  IadlFunctionAnswersButDoesNotDial = 'IADL_FUNCTION_ANSWERS_BUT_DOES_NOT_DIAL',
  /** Dials some known numbers (1) */
  IadlFunctionDialsKnownNumbers = 'IADL_FUNCTION_DIALS_KNOWN_NUMBERS',
  /** Does not use phone at all (0) */
  IadlFunctionDoesNotUsePhoneAtAll = 'IADL_FUNCTION_DOES_NOT_USE_PHONE_AT_ALL',
  IadlFunctionNone = 'IADL_FUNCTION_NONE',
  /** Uses phone on own initiative (1) */
  IadlFunctionUsesPhoneOnOwnInitiative = 'IADL_FUNCTION_USES_PHONE_ON_OWN_INITIATIVE'
}

export enum Treatment_IadlHousehold {
  /** Can perform small household chores but cannot keep home clean (1) */
  IadlHouseholdCannotKeepHomeClean = 'IADL_HOUSEHOLD_CANNOT_KEEP_HOME_CLEAN',
  /** Keeps household in order or requires assistance with heavy chores (1) */
  IadlHouseholdKeepsHouseholdInorder = 'IADL_HOUSEHOLD_KEEPS_HOUSEHOLD_INORDER',
  /** Needs assistance in all household tasks (1) */
  IadlHouseholdNeedsAssistanceInAllTasks = 'IADL_HOUSEHOLD_NEEDS_ASSISTANCE_IN_ALL_TASKS',
  IadlHouseholdNone = 'IADL_HOUSEHOLD_NONE',
  /** Can no longer perform daily household chores (0) */
  IadlHouseholdNoLongerPerformDailyChores = 'IADL_HOUSEHOLD_NO_LONGER_PERFORM_DAILY_CHORES',
  /** Independently performs small household chores (1) */
  IadlHouseholdPerformsSmallHouseholdChores = 'IADL_HOUSEHOLD_PERFORMS_SMALL_HOUSEHOLD_CHORES'
}

export enum Treatment_IadlLaundry {
  /** All laundry must be organized by others (0) */
  IadlLaundryMustBeOrganizedByOthers = 'IADL_LAUNDRY_MUST_BE_ORGANIZED_BY_OTHERS',
  IadlLaundryNone = 'IADL_LAUNDRY_NONE',
  /** Washes all own laundry (1) */
  IadlLaundryWashesAllOwnLaundry = 'IADL_LAUNDRY_WASHES_ALL_OWN_LAUNDRY',
  /** Washes small items (1) */
  IadlLaundryWashesSmallItems = 'IADL_LAUNDRY_WASHES_SMALL_ITEMS'
}

export enum Treatment_IadlMedication {
  IadlMedicationNone = 'IADL_MEDICATION_NONE',
  /** Can no longer take medication correctly (0) */
  IadlMedicationNoLongerTakeMedication = 'IADL_MEDICATION_NO_LONGER_TAKE_MEDICATION',
  /** Takes medication independently at correct time in correct dosage (1) */
  IadlMedicationTakenAtCorrectTimeInCorrectDosage = 'IADL_MEDICATION_TAKEN_AT_CORRECT_TIME_IN_CORRECT_DOSAGE',
  /** Takes prepared medication correctly (0) */
  IadlMedicationTakesPreparedMedicationCorrectly = 'IADL_MEDICATION_TAKES_PREPARED_MEDICATION_CORRECTLY'
}

export enum Treatment_IadlMoneyTransactions {
  /** Carries out small daily expenses, needs help with banking transactions (1) */
  IadlMoneyTransactionsCarriesOutSmallDailyExpenses = 'IADL_MONEY_TRANSACTIONS_CARRIES_OUT_SMALL_DAILY_EXPENSES',
  IadlMoneyTransactionsNone = 'IADL_MONEY_TRANSACTIONS_NONE',
  /** Can no longer handle money (0) */
  IadlMoneyTransactionsNoLongerHandleMoney = 'IADL_MONEY_TRANSACTIONS_NO_LONGER_HANDLE_MONEY',
  /** Regulates money transactions independently (budget/transfers/going to the bank) (1) */
  IadlMoneyTransactionsRegulateTransactionsIndependently = 'IADL_MONEY_TRANSACTIONS_REGULATE_TRANSACTIONS_INDEPENDENTLY'
}

export enum Treatment_IadlShopping {
  /** Buys most things independently (1) */
  IadlShoppingBuysMostThingsIndependently = 'IADL_SHOPPING_BUYS_MOST_THINGS_INDEPENDENTLY',
  /** Makes few purchases (0) */
  IadlShoppingMakesFewPurchases = 'IADL_SHOPPING_MAKES_FEW_PURCHASES',
  /** Needs company when shopping (0) */
  IadlShoppingNeedsCompanyWhenShopping = 'IADL_SHOPPING_NEEDS_COMPANY_WHEN_SHOPPING',
  IadlShoppingNone = 'IADL_SHOPPING_NONE',
  /** unable to shop (0) */
  IadlShoppingUnableToShop = 'IADL_SHOPPING_UNABLE_TO_SHOP'
}

export enum Treatment_IadlTransportation {
  /** Limited trips in cab or car accompanied (0) */
  IadlTransportationLimitedTripsInCapOrCar = 'IADL_TRANSPORTATION_LIMITED_TRIPS_IN_CAP_OR_CAR',
  IadlTransportationNone = 'IADL_TRANSPORTATION_NONE',
  /** No longer uses transportation at all (0) */
  IadlTransportationNoLongerUseTransportation = 'IADL_TRANSPORTATION_NO_LONGER_USE_TRANSPORTATION',
  /** Orders and uses cab, but no public transportation (1) */
  IadlTransportationOrdersAndUsesCab = 'IADL_TRANSPORTATION_ORDERS_AND_USES_CAB',
  /** Uses public transportation accompanied (1) */
  IadlTransportationPublicTransportationAccompanied = 'IADL_TRANSPORTATION_PUBLIC_TRANSPORTATION_ACCOMPANIED',
  /** Uses public transportation independently, own car (1) */
  IadlTransportationPublicTransportationOrCar = 'IADL_TRANSPORTATION_PUBLIC_TRANSPORTATION_OR_CAR'
}

export type Treatment_IcdscBlock = {
  __typename?: 'treatment_IcdscBlock';
  /** < yes (1) / no (0)> */
  agitationOrSlowness?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  changedConsciousness?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  disorientation?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  fluctuatingSymptoms?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  hallucination?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  inadequateSpeechOrDisposition?: Maybe<Scalars['Boolean']>;
  /** < yes (1) / no (0)> */
  inattention?: Maybe<Scalars['Boolean']>;
  /** Automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** < yes (1) / no (0)> */
  sleepDisturbance?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_IdentifyObject {
  IdentifyObjectNone = 'IDENTIFY_OBJECT_NONE',
  /** object 1 */
  IdentifyObjectObject_1 = 'IDENTIFY_OBJECT_OBJECT_1',
  /** object 2 */
  IdentifyObjectObject_2 = 'IDENTIFY_OBJECT_OBJECT_2'
}

export type Treatment_IllusionsBlock = {
  __typename?: 'treatment_IllusionsBlock';
  auditoryHallucinations?: Maybe<Scalars['Boolean']>;
  auditoryHallucinationsDescriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  auditoryHallucinationsText?: Maybe<Scalars['String']>;
  bodyHallucinations?: Maybe<Scalars['Boolean']>;
  bodyHallucinationsText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  hallucinations?: Maybe<Scalars['Boolean']>;
  hypnagogicHallucinations?: Maybe<Scalars['Boolean']>;
  hypnagogicHallucinationsText?: Maybe<Scalars['String']>;
  illusions?: Maybe<Scalars['Boolean']>;
  illusoryMisperceptions?: Maybe<Scalars['Boolean']>;
  illusoryMisperceptionsText?: Maybe<Scalars['String']>;
  metamorphosia?: Maybe<Scalars['Boolean']>;
  metamorphosiaText?: Maybe<Scalars['String']>;
  olfactoryAndGustatoryHallucinations?: Maybe<Scalars['Boolean']>;
  olfactoryAndGustatoryHallucinationsText?: Maybe<Scalars['String']>;
  pseudoHallucinations?: Maybe<Scalars['Boolean']>;
  pseudoHallucinationsText?: Maybe<Scalars['String']>;
  visualHallucinations?: Maybe<Scalars['Boolean']>;
  visualHallucinationsText?: Maybe<Scalars['String']>;
};

export enum Treatment_ImmediateStandingBalance {
  ImmediateStandingBalanceNone = 'IMMEDIATE_STANDING_BALANCE_NONE',
  ImmediateStandingBalanceSafeWithoutAssistance = 'IMMEDIATE_STANDING_BALANCE_SAFE_WITHOUT_ASSISTANCE',
  ImmediateStandingBalanceSafeWithAssistance = 'IMMEDIATE_STANDING_BALANCE_SAFE_WITH_ASSISTANCE',
  ImmediateStandingBalanceUnsafe = 'IMMEDIATE_STANDING_BALANCE_UNSAFE'
}

export type Treatment_ImmunityTestList = {
  __typename?: 'treatment_ImmunityTestList';
  immunityTests?: Maybe<Array<Maybe<Treatment_ImmunityTestMsg>>>;
};

/** A test administered to determine whether an immunity against a given disease already exists. */
export type Treatment_ImmunityTestMsg = {
  __typename?: 'treatment_ImmunityTestMsg';
  examinationDate?: Maybe<Timestamp>;
  externalInformationDetails?: Maybe<Treatment_ExternalSourceMsg>;
  id?: Maybe<Scalars['String']>;
  immune?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  /** False if test was administered externally */
  primarySource?: Maybe<Scalars['Boolean']>;
  registeringUserId?: Maybe<Scalars['String']>;
  /** Disease at which the test is aimed */
  testTypeId?: Maybe<Core_KnowledgeInputMsg>;
};

export enum Treatment_Immunodeficiency {
  ImmunodeficiencyIncreased = 'IMMUNODEFICIENCY_INCREASED',
  ImmunodeficiencyMild = 'IMMUNODEFICIENCY_MILD',
  ImmunodeficiencyNone = 'IMMUNODEFICIENCY_NONE',
  ImmunodeficiencyNotAtAll = 'IMMUNODEFICIENCY_NOT_AT_ALL',
  ImmunodeficiencyTotal = 'IMMUNODEFICIENCY_TOTAL'
}

export type Treatment_ImportDiagnosisRequest = {
  __typename?: 'treatment_ImportDiagnosisRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
  /** True if import as primary diagnosis, false if import as secondary diagnosis */
  primaryDiagnosis?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ImportDiagnosisResponse = {
  __typename?: 'treatment_ImportDiagnosisResponse';
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_ImportSymptomConfigurationRequest = {
  __typename?: 'treatment_ImportSymptomConfigurationRequest';
  /** The following three fields are optional, if they don't exist, they will be taken from symptom configuration */
  patientId?: Maybe<Scalars['String']>;
  symptomConfigurationId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ImportSymptomConfigurationsRequest = {
  __typename?: 'treatment_ImportSymptomConfigurationsRequest';
  /** must match the patientId of the provided symptomOccurrences */
  patientId?: Maybe<Scalars['String']>;
  symptomOccurrenceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ImportSymptomConfigurationsResponse = {
  __typename?: 'treatment_ImportSymptomConfigurationsResponse';
  configurations?: Maybe<Array<Maybe<Treatment_SymptomConfigurationMsg>>>;
};

export enum Treatment_InabilityToMakeDecisions {
  InabilityToMakeDecisionsDecisive = 'INABILITY_TO_MAKE_DECISIONS_DECISIVE',
  InabilityToMakeDecisionsHardToMakeDecisions = 'INABILITY_TO_MAKE_DECISIONS_HARD_TO_MAKE_DECISIONS',
  InabilityToMakeDecisionsMuchHarderToMakeDecisions = 'INABILITY_TO_MAKE_DECISIONS_MUCH_HARDER_TO_MAKE_DECISIONS',
  InabilityToMakeDecisionsNone = 'INABILITY_TO_MAKE_DECISIONS_NONE',
  InabilityToMakeDecisionsTroubleMakingDecisions = 'INABILITY_TO_MAKE_DECISIONS_TROUBLE_MAKING_DECISIONS'
}

export enum Treatment_Incontinence {
  IncontinenceMostlyUrine = 'INCONTINENCE_MOSTLY_URINE',
  IncontinenceNone = 'INCONTINENCE_NONE',
  IncontinenceNotAtAll = 'INCONTINENCE_NOT_AT_ALL',
  IncontinenceSometimes = 'INCONTINENCE_SOMETIMES',
  IncontinenceUrineAndStool = 'INCONTINENCE_URINE_AND_STOOL'
}

export enum Treatment_IncontinenceAmount {
  IncontinenceAmountLarge = 'INCONTINENCE_AMOUNT_LARGE',
  IncontinenceAmountMedium = 'INCONTINENCE_AMOUNT_MEDIUM',
  IncontinenceAmountNone = 'INCONTINENCE_AMOUNT_NONE',
  IncontinenceAmountNoLeakage = 'INCONTINENCE_AMOUNT_NO_LEAKAGE',
  IncontinenceAmountSmall = 'INCONTINENCE_AMOUNT_SMALL'
}

export type Treatment_IncontinenceBlock = {
  __typename?: 'treatment_IncontinenceBlock';
  amount?: Maybe<Treatment_IncontinenceAmount>;
  completed?: Maybe<Scalars['Boolean']>;
  /** if “Incontinence pads” is selected: */
  dayIncontinencePadCount?: Maybe<Scalars['Int']>;
  frequency?: Maybe<Treatment_IncontinenceFrequency>;
  incontinenceOccasions?: Maybe<Array<Maybe<Treatment_IncontinenceOccasion>>>;
  /** if “Incontinence pads” is selected: */
  nightIncontinencePadCount?: Maybe<Scalars['Int']>;
  padStatus?: Maybe<Treatment_IncontinencePadStatus>;
  score?: Maybe<Scalars['Int']>;
  severity?: Maybe<Treatment_IncontinenceSeverity>;
};

export enum Treatment_IncontinenceFrequency {
  IncontinenceFrequencyConstantly = 'INCONTINENCE_FREQUENCY_CONSTANTLY',
  IncontinenceFrequencyMultipleTimesADay = 'INCONTINENCE_FREQUENCY_MULTIPLE_TIMES_A_DAY',
  IncontinenceFrequencyNever = 'INCONTINENCE_FREQUENCY_NEVER',
  IncontinenceFrequencyNone = 'INCONTINENCE_FREQUENCY_NONE',
  IncontinenceFrequencyOnceADay = 'INCONTINENCE_FREQUENCY_ONCE_A_DAY',
  IncontinenceFrequencyOnceAWeekOrLess = 'INCONTINENCE_FREQUENCY_ONCE_A_WEEK_OR_LESS',
  IncontinenceFrequencyTwoToThreeTimesAWeek = 'INCONTINENCE_FREQUENCY_TWO_TO_THREE_TIMES_A_WEEK'
}

export enum Treatment_IncontinenceOccasion {
  IncontinenceOccasionAfterUrinating = 'INCONTINENCE_OCCASION_AFTER_URINATING',
  IncontinenceOccasionAtNoTime = 'INCONTINENCE_OCCASION_AT_NO_TIME',
  IncontinenceOccasionBeforeReachingToilet = 'INCONTINENCE_OCCASION_BEFORE_REACHING_TOILET',
  IncontinenceOccasionConstantly = 'INCONTINENCE_OCCASION_CONSTANTLY',
  IncontinenceOccasionCoughSneezeRunEtc = 'INCONTINENCE_OCCASION_COUGH_SNEEZE_RUN_ETC',
  IncontinenceOccasionNone = 'INCONTINENCE_OCCASION_NONE',
  IncontinenceOccasionPhysicalExertionSport = 'INCONTINENCE_OCCASION_PHYSICAL_EXERTION_SPORT',
  IncontinenceOccasionSleep = 'INCONTINENCE_OCCASION_SLEEP',
  IncontinenceOccasionWithoutReason = 'INCONTINENCE_OCCASION_WITHOUT_REASON'
}

export enum Treatment_IncontinencePadStatus {
  IncontinencePadStatusIncontinencePads = 'INCONTINENCE_PAD_STATUS_INCONTINENCE_PADS',
  IncontinencePadStatusNone = 'INCONTINENCE_PAD_STATUS_NONE',
  IncontinencePadStatusNoPads = 'INCONTINENCE_PAD_STATUS_NO_PADS',
  IncontinencePadStatusSingleSafetyPad = 'INCONTINENCE_PAD_STATUS_SINGLE_SAFETY_PAD'
}

export enum Treatment_IncontinenceSeverity {
  IncontinenceSeverityEight = 'INCONTINENCE_SEVERITY_EIGHT',
  IncontinenceSeverityFive = 'INCONTINENCE_SEVERITY_FIVE',
  IncontinenceSeverityFour = 'INCONTINENCE_SEVERITY_FOUR',
  IncontinenceSeverityNine = 'INCONTINENCE_SEVERITY_NINE',
  IncontinenceSeverityNone = 'INCONTINENCE_SEVERITY_NONE',
  IncontinenceSeverityOne = 'INCONTINENCE_SEVERITY_ONE',
  IncontinenceSeveritySeven = 'INCONTINENCE_SEVERITY_SEVEN',
  IncontinenceSeveritySix = 'INCONTINENCE_SEVERITY_SIX',
  IncontinenceSeverityTen = 'INCONTINENCE_SEVERITY_TEN',
  IncontinenceSeverityThree = 'INCONTINENCE_SEVERITY_THREE',
  IncontinenceSeverityTwo = 'INCONTINENCE_SEVERITY_TWO',
  IncontinenceSeverityZero = 'INCONTINENCE_SEVERITY_ZERO'
}

export enum Treatment_IncreasedVertigoTime {
  IncreasedVertigoTimeNone = 'INCREASED_VERTIGO_TIME_NONE',
  IncreasedVertigoTimeWeekdays = 'INCREASED_VERTIGO_TIME_WEEKDAYS',
  IncreasedVertigoTimeWeekends = 'INCREASED_VERTIGO_TIME_WEEKENDS'
}

export enum Treatment_IndexSelection {
  IndexSelection_0Percent = 'INDEX_SELECTION_0_PERCENT',
  IndexSelection_10Percent = 'INDEX_SELECTION_10_PERCENT',
  IndexSelection_20Percent = 'INDEX_SELECTION_20_PERCENT',
  IndexSelection_30Percent = 'INDEX_SELECTION_30_PERCENT',
  IndexSelection_40Percent = 'INDEX_SELECTION_40_PERCENT',
  IndexSelection_50Percent = 'INDEX_SELECTION_50_PERCENT',
  IndexSelection_60Percent = 'INDEX_SELECTION_60_PERCENT',
  IndexSelection_70Percent = 'INDEX_SELECTION_70_PERCENT',
  IndexSelection_80Percent = 'INDEX_SELECTION_80_PERCENT',
  IndexSelection_90Percent = 'INDEX_SELECTION_90_PERCENT',
  IndexSelection_100Percent = 'INDEX_SELECTION_100_PERCENT',
  IndexSelectionNone = 'INDEX_SELECTION_NONE'
}

export type Treatment_InguinalLymphNodesBlock = {
  __typename?: 'treatment_InguinalLymphNodesBlock';
  abnormalitiesPresent?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lymphNodeAbnormalities?: Maybe<Array<Maybe<Treatment_LymphNodesAbnormalitiesMsg>>>;
};

export enum Treatment_InitiationOfGait {
  InitiationOfGaitAnyHesitancyOrMultipleAttemptsToStart = 'INITIATION_OF_GAIT_ANY_HESITANCY_OR_MULTIPLE_ATTEMPTS_TO_START',
  InitiationOfGaitNone = 'INITIATION_OF_GAIT_NONE',
  InitiationOfGaitNoHesitancy = 'INITIATION_OF_GAIT_NO_HESITANCY'
}

export type Treatment_InnerNoseMsg = {
  __typename?: 'treatment_InnerNoseMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nasalCavity?: Maybe<Treatment_NasalCavityMsg>;
  nasalVestibule?: Maybe<Treatment_NasalVestibuleMsg>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_InspectionOfTheMusculatureAndMuscleTrophicsBlock = {
  __typename?: 'treatment_InspectionOfTheMusculatureAndMuscleTrophicsBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  inspectionOfTheMusculatureAndMuscleTrophics?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export enum Treatment_InspiratoryExpiratoryRatio {
  InspiratoryExpiratoryRatioNone = 'INSPIRATORY_EXPIRATORY_RATIO_NONE',
  InspiratoryExpiratoryRatioNormal = 'INSPIRATORY_EXPIRATORY_RATIO_NORMAL',
  InspiratoryExpiratoryRatioProlongedExpiration = 'INSPIRATORY_EXPIRATORY_RATIO_PROLONGED_EXPIRATION',
  InspiratoryExpiratoryRatioProlongedInspiration = 'INSPIRATORY_EXPIRATORY_RATIO_PROLONGED_INSPIRATION',
  InspiratoryExpiratoryRatioShortenedExpiration = 'INSPIRATORY_EXPIRATORY_RATIO_SHORTENED_EXPIRATION',
  InspiratoryExpiratoryRatioShortenedInspiration = 'INSPIRATORY_EXPIRATORY_RATIO_SHORTENED_INSPIRATION'
}

export enum Treatment_IntactExaminationResult {
  IntactExaminationResultIntact = 'INTACT_EXAMINATION_RESULT_INTACT',
  IntactExaminationResultNone = 'INTACT_EXAMINATION_RESULT_NONE',
  IntactExaminationResultNotIntact = 'INTACT_EXAMINATION_RESULT_NOT_INTACT'
}

export enum Treatment_InterestsDevelopment {
  InterestsDevelopmentGiveUpSomeInterests = 'INTERESTS_DEVELOPMENT_GIVE_UP_SOME_INTERESTS',
  InterestsDevelopmentLostAllInterests = 'INTERESTS_DEVELOPMENT_LOST_ALL_INTERESTS',
  InterestsDevelopmentNewPlansInterests = 'INTERESTS_DEVELOPMENT_NEW_PLANS_INTERESTS',
  InterestsDevelopmentNone = 'INTERESTS_DEVELOPMENT_NONE',
  InterestsDevelopmentUnchanged = 'INTERESTS_DEVELOPMENT_UNCHANGED'
}

export enum Treatment_InternalRotation {
  InternalRotationBackOfHandBetweenShoulderBlades = 'INTERNAL_ROTATION_BACK_OF_HAND_BETWEEN_SHOULDER_BLADES',
  InternalRotationBackOfHandOn_12ThDorsalVertebra = 'INTERNAL_ROTATION_BACK_OF_HAND_ON_12TH_DORSAL_VERTEBRA',
  InternalRotationBackOfHandOnButtock = 'INTERNAL_ROTATION_BACK_OF_HAND_ON_BUTTOCK',
  InternalRotationBackOfHandOnGirdleLine = 'INTERNAL_ROTATION_BACK_OF_HAND_ON_GIRDLE_LINE',
  InternalRotationBackOfHandOnLumbosacralJunction = 'INTERNAL_ROTATION_BACK_OF_HAND_ON_LUMBOSACRAL_JUNCTION',
  InternalRotationBackOfHandOnOuterThigh = 'INTERNAL_ROTATION_BACK_OF_HAND_ON_OUTER_THIGH',
  InternalRotationNone = 'INTERNAL_ROTATION_NONE'
}

export type Treatment_IntraosseousAccessMsg = {
  __typename?: 'treatment_IntraosseousAccessMsg';
  _?: Maybe<Scalars['String']>;
};

export enum Treatment_IntubationAccess {
  IntubationAccessNasal = 'INTUBATION_ACCESS_NASAL',
  IntubationAccessNone = 'INTUBATION_ACCESS_NONE',
  IntubationAccessOral = 'INTUBATION_ACCESS_ORAL',
  IntubationAccessTracheostomy = 'INTUBATION_ACCESS_TRACHEOSTOMY'
}

export enum Treatment_IntubationAnesthesiaVentilation {
  IntubationAnesthesiaVentilationMultipleAnesthesiaOrMoreThan_12HrsVentilation = 'INTUBATION_ANESTHESIA_VENTILATION_MULTIPLE_ANESTHESIA_OR_MORE_THAN_12_HRS_VENTILATION',
  IntubationAnesthesiaVentilationNone = 'INTUBATION_ANESTHESIA_VENTILATION_NONE',
  IntubationAnesthesiaVentilationNoneInLast_3Weeks = 'INTUBATION_ANESTHESIA_VENTILATION_NONE_IN_LAST_3_WEEKS',
  IntubationAnesthesiaVentilationProlongedIntubation = 'INTUBATION_ANESTHESIA_VENTILATION_PROLONGED_INTUBATION',
  IntubationAnesthesiaVentilationShortIntubation = 'INTUBATION_ANESTHESIA_VENTILATION_SHORT_INTUBATION'
}

export type Treatment_IpssBlock = {
  __typename?: 'treatment_IpssBlock';
  completed?: Maybe<Scalars['Boolean']>;
  delayUrinationDifficulty?: Maybe<Treatment_IpssDelayUrinationDifficulty>;
  incompleteEmptying?: Maybe<Treatment_IpssIncompleteEmptying>;
  nightUrination?: Maybe<Treatment_IpssNightUrination>;
  repeatUrination?: Maybe<Treatment_IpssRepeatUrination>;
  restartUrination?: Maybe<Treatment_IpssRestartUrination>;
  score?: Maybe<Scalars['Int']>;
  strain?: Maybe<Treatment_IpssStrain>;
  weakStream?: Maybe<Treatment_IpssWeakStream>;
};

export enum Treatment_IpssDelayUrinationDifficulty {
  IpssDelayUrinationDifficultyAboutHalfOfTime = 'IPSS_DELAY_URINATION_DIFFICULTY_ABOUT_HALF_OF_TIME',
  IpssDelayUrinationDifficultyAlmostAlways = 'IPSS_DELAY_URINATION_DIFFICULTY_ALMOST_ALWAYS',
  IpssDelayUrinationDifficultyLessThanHalfOfTime = 'IPSS_DELAY_URINATION_DIFFICULTY_LESS_THAN_HALF_OF_TIME',
  IpssDelayUrinationDifficultyLessThanOneInFive = 'IPSS_DELAY_URINATION_DIFFICULTY_LESS_THAN_ONE_IN_FIVE',
  IpssDelayUrinationDifficultyMoreThanHalfOfTime = 'IPSS_DELAY_URINATION_DIFFICULTY_MORE_THAN_HALF_OF_TIME',
  IpssDelayUrinationDifficultyNever = 'IPSS_DELAY_URINATION_DIFFICULTY_NEVER',
  IpssDelayUrinationDifficultyNone = 'IPSS_DELAY_URINATION_DIFFICULTY_NONE'
}

export enum Treatment_IpssIncompleteEmptying {
  IpssIncompleteEmptyingAboutHalfOfTime = 'IPSS_INCOMPLETE_EMPTYING_ABOUT_HALF_OF_TIME',
  IpssIncompleteEmptyingAlmostAlways = 'IPSS_INCOMPLETE_EMPTYING_ALMOST_ALWAYS',
  IpssIncompleteEmptyingLessThanHalfOfTime = 'IPSS_INCOMPLETE_EMPTYING_LESS_THAN_HALF_OF_TIME',
  IpssIncompleteEmptyingLessThanOneInFive = 'IPSS_INCOMPLETE_EMPTYING_LESS_THAN_ONE_IN_FIVE',
  IpssIncompleteEmptyingMoreThanHalfOfTime = 'IPSS_INCOMPLETE_EMPTYING_MORE_THAN_HALF_OF_TIME',
  IpssIncompleteEmptyingNever = 'IPSS_INCOMPLETE_EMPTYING_NEVER',
  IpssIncompleteEmptyingNone = 'IPSS_INCOMPLETE_EMPTYING_NONE'
}

export enum Treatment_IpssNightUrination {
  IpssNightUrinationFiveOrMoreTimes = 'IPSS_NIGHT_URINATION_FIVE_OR_MORE_TIMES',
  IpssNightUrinationFourTimes = 'IPSS_NIGHT_URINATION_FOUR_TIMES',
  IpssNightUrinationNever = 'IPSS_NIGHT_URINATION_NEVER',
  IpssNightUrinationNone = 'IPSS_NIGHT_URINATION_NONE',
  IpssNightUrinationOnce = 'IPSS_NIGHT_URINATION_ONCE',
  IpssNightUrinationThreeTimes = 'IPSS_NIGHT_URINATION_THREE_TIMES',
  IpssNightUrinationTwice = 'IPSS_NIGHT_URINATION_TWICE'
}

export enum Treatment_IpssRepeatUrination {
  IpssRepeatUrinationAboutHalfOfTime = 'IPSS_REPEAT_URINATION_ABOUT_HALF_OF_TIME',
  IpssRepeatUrinationAlmostAlways = 'IPSS_REPEAT_URINATION_ALMOST_ALWAYS',
  IpssRepeatUrinationLessThanHalfOfTime = 'IPSS_REPEAT_URINATION_LESS_THAN_HALF_OF_TIME',
  IpssRepeatUrinationLessThanOneInFive = 'IPSS_REPEAT_URINATION_LESS_THAN_ONE_IN_FIVE',
  IpssRepeatUrinationMoreThanHalfOfTime = 'IPSS_REPEAT_URINATION_MORE_THAN_HALF_OF_TIME',
  IpssRepeatUrinationNever = 'IPSS_REPEAT_URINATION_NEVER',
  IpssRepeatUrinationNone = 'IPSS_REPEAT_URINATION_NONE'
}

export enum Treatment_IpssRestartUrination {
  IpssRestartUrinationAboutHalfOfTime = 'IPSS_RESTART_URINATION_ABOUT_HALF_OF_TIME',
  IpssRestartUrinationAlmostAlways = 'IPSS_RESTART_URINATION_ALMOST_ALWAYS',
  IpssRestartUrinationLessThanHalfOfTime = 'IPSS_RESTART_URINATION_LESS_THAN_HALF_OF_TIME',
  IpssRestartUrinationLessThanOneInFive = 'IPSS_RESTART_URINATION_LESS_THAN_ONE_IN_FIVE',
  IpssRestartUrinationMoreThanHalfOfTime = 'IPSS_RESTART_URINATION_MORE_THAN_HALF_OF_TIME',
  IpssRestartUrinationNever = 'IPSS_RESTART_URINATION_NEVER',
  IpssRestartUrinationNone = 'IPSS_RESTART_URINATION_NONE'
}

export enum Treatment_IpssStrain {
  IpssStrainAboutHalfOfTime = 'IPSS_STRAIN_ABOUT_HALF_OF_TIME',
  IpssStrainAlmostAlways = 'IPSS_STRAIN_ALMOST_ALWAYS',
  IpssStrainLessThanHalfOfTime = 'IPSS_STRAIN_LESS_THAN_HALF_OF_TIME',
  IpssStrainLessThanOneInFive = 'IPSS_STRAIN_LESS_THAN_ONE_IN_FIVE',
  IpssStrainMoreThanHalfOfTime = 'IPSS_STRAIN_MORE_THAN_HALF_OF_TIME',
  IpssStrainNever = 'IPSS_STRAIN_NEVER',
  IpssStrainNone = 'IPSS_STRAIN_NONE'
}

export enum Treatment_IpssWeakStream {
  IpssWeakStreamAboutHalfOfTime = 'IPSS_WEAK_STREAM_ABOUT_HALF_OF_TIME',
  IpssWeakStreamAlmostAlways = 'IPSS_WEAK_STREAM_ALMOST_ALWAYS',
  IpssWeakStreamLessThanHalfOfTime = 'IPSS_WEAK_STREAM_LESS_THAN_HALF_OF_TIME',
  IpssWeakStreamLessThanOneInFive = 'IPSS_WEAK_STREAM_LESS_THAN_ONE_IN_FIVE',
  IpssWeakStreamMoreThanHalfOfTime = 'IPSS_WEAK_STREAM_MORE_THAN_HALF_OF_TIME',
  IpssWeakStreamNever = 'IPSS_WEAK_STREAM_NEVER',
  IpssWeakStreamNone = 'IPSS_WEAK_STREAM_NONE'
}

export enum Treatment_Irritability {
  IrritabilityIrritableAllTheTime = 'IRRITABILITY_IRRITABLE_ALL_THE_TIME',
  IrritabilityMoreIrritableThanUsual = 'IRRITABILITY_MORE_IRRITABLE_THAN_USUAL',
  IrritabilityMuchMoreIrritableThanUsual = 'IRRITABILITY_MUCH_MORE_IRRITABLE_THAN_USUAL',
  IrritabilityNone = 'IRRITABILITY_NONE',
  IrritabilityNoIrritableThanUsual = 'IRRITABILITY_NO_IRRITABLE_THAN_USUAL'
}

export type Treatment_IsarScreeningBlock = {
  __typename?: 'treatment_IsarScreeningBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  hospitalizedInPastSixMonths?: Maybe<Scalars['Boolean']>;
  memoryProblems?: Maybe<Scalars['Boolean']>;
  needHelpAfterIllness?: Maybe<Scalars['Boolean']>;
  needHelpBeforeIllness?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  sightProblems?: Maybe<Scalars['Boolean']>;
  takeMoreMedicationsDaily?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ItchBlock = {
  __typename?: 'treatment_ItchBlock';
  daytimeDependence?: Maybe<Treatment_DaytimeDependence>;
  daytimeDependencePresent?: Maybe<Scalars['Boolean']>;
  itchClassification?: Maybe<Treatment_ItchClassification>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_ItchClassification {
  ItchGeneralized = 'ITCH_GENERALIZED',
  ItchLocalized = 'ITCH_LOCALIZED',
  ItchNone = 'ITCH_NONE'
}

export enum Treatment_JobActivityLevel {
  JobActivityMoving = 'JOB_ACTIVITY_MOVING',
  JobActivityNone = 'JOB_ACTIVITY_NONE',
  JobActivitySeated = 'JOB_ACTIVITY_SEATED',
  JobActivityStanding = 'JOB_ACTIVITY_STANDING'
}

export type Treatment_JugularVeinsInspectionBlock = {
  __typename?: 'treatment_JugularVeinsInspectionBlock';
  jugularVeinPressure?: Maybe<Scalars['Float']>;
  jugularVeinPressureText?: Maybe<Scalars['String']>;
  jugularVeinsType?: Maybe<Treatment_JugularVeinsType>;
  jugularVeinsTypeText?: Maybe<Scalars['String']>;
  pulseWavesType?: Maybe<Treatment_PathologicalExaminationResult>;
  pulseWavesTypeText?: Maybe<Scalars['String']>;
};

export enum Treatment_JugularVeinsType {
  JugularVeinsJammed = 'JUGULAR_VEINS_JAMMED',
  JugularVeinsNone = 'JUGULAR_VEINS_NONE',
  JugularVeinsNotJammed = 'JUGULAR_VEINS_NOT_JAMMED'
}

export type Treatment_KarnofskyIndexBlock = {
  __typename?: 'treatment_KarnofskyIndexBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  indexSelection?: Maybe<Treatment_IndexSelection>;
};

export type Treatment_KellgrenLawrenceBlock = {
  __typename?: 'treatment_KellgrenLawrenceBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  grade?: Maybe<Treatment_KellgrenLawrenceGrade>;
};

export enum Treatment_KellgrenLawrenceGrade {
  KellgrenLawrenceMild = 'KELLGREN_LAWRENCE_MILD',
  KellgrenLawrenceModerate = 'KELLGREN_LAWRENCE_MODERATE',
  KellgrenLawrenceNone = 'KELLGREN_LAWRENCE_NONE',
  KellgrenLawrenceNormal = 'KELLGREN_LAWRENCE_NORMAL',
  KellgrenLawrenceQuestionable = 'KELLGREN_LAWRENCE_QUESTIONABLE',
  KellgrenLawrenceSevere = 'KELLGREN_LAWRENCE_SEVERE'
}

export type Treatment_KidneyPainOnPercussionBlock = {
  __typename?: 'treatment_KidneyPainOnPercussionBlock';
  painOnPercussionPresent?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_KneeExtensionDeficit {
  KneeExtensionDeficit_0 = 'KNEE_EXTENSION_DEFICIT_0',
  KneeExtensionDeficit_5To_15 = 'KNEE_EXTENSION_DEFICIT_5_TO_15',
  KneeExtensionDeficitGreaterThanEqual_20 = 'KNEE_EXTENSION_DEFICIT_GREATER_THAN_EQUAL_20',
  KneeExtensionDeficitNone = 'KNEE_EXTENSION_DEFICIT_NONE'
}

export type Treatment_KneeJointMsg = {
  __typename?: 'treatment_KneeJointMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_KneeWalkingDistance {
  /** walking at a stretch from 50m to 500m possible (4) */
  KneeWalkingDistance_50To_500 = 'KNEE_WALKING_DISTANCE_50_TO_500',
  KneeWalkingDistanceImmobile = 'KNEE_WALKING_DISTANCE_IMMOBILE',
  KneeWalkingDistanceInRoom = 'KNEE_WALKING_DISTANCE_IN_ROOM',
  KneeWalkingDistanceNone = 'KNEE_WALKING_DISTANCE_NONE',
  /** unlimited (5) */
  KneeWalkingDistanceUnlimited = 'KNEE_WALKING_DISTANCE_UNLIMITED',
  /** walking at a stretch to 50m possible (4) */
  KneeWalkingDistanceUpTo_50 = 'KNEE_WALKING_DISTANCE_UP_TO_50'
}

export type Treatment_LachsGeriatricScreeningBlock = {
  __typename?: 'treatment_LachsGeriatricScreeningBlock';
  /** true -> conspicuous , false -> inconspicuous */
  activity?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  arms?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  bladderContinence?: Maybe<Scalars['Boolean']>;
  /** 8a: Cognitive status. true -> conspicuous , false -> inconspicuous */
  cognitiveStatusFirstScreening?: Maybe<Scalars['Boolean']>;
  /** 8b: Cognitive status. // true -> conspicuous , false -> inconspicuous */
  cognitiveStatusSecondScreening?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  depression?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  fallInLastMonth?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  fecalContinence?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  generalRisk?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  hearing?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  legs?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  nutrition?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** true -> conspicuous , false -> inconspicuous */
  seeing?: Maybe<Scalars['Boolean']>;
  /** true -> conspicuous , false -> inconspicuous */
  socialSupport?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  sufferingFromFrequentPain?: Maybe<Scalars['Boolean']>;
  /** <yes (1) / no (0)> */
  takingMoreThanFiveMedications?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_LanguageTestResult {
  LanguageTestComa = 'LANGUAGE_TEST_COMA',
  LanguageTestGlobalAphasiaOrMute = 'LANGUAGE_TEST_GLOBAL_APHASIA_OR_MUTE',
  LanguageTestMildToModerateAphasia = 'LANGUAGE_TEST_MILD_TO_MODERATE_APHASIA',
  LanguageTestNone = 'LANGUAGE_TEST_NONE',
  LanguageTestNoAphasia = 'LANGUAGE_TEST_NO_APHASIA',
  LanguageTestSevereAphasia = 'LANGUAGE_TEST_SEVERE_APHASIA'
}

export type Treatment_LaryngoscopyIndicationMsg = {
  __typename?: 'treatment_LaryngoscopyIndicationMsg';
  text?: Maybe<Scalars['String']>;
  timing?: Maybe<Treatment_LaryngoscopyIndicationTiming>;
};

export enum Treatment_LaryngoscopyIndicationTiming {
  LaryngoscopyIndicationTimingNone = 'LARYNGOSCOPY_INDICATION_TIMING_NONE',
  LaryngoscopyIndicationTimingPostoperative = 'LARYNGOSCOPY_INDICATION_TIMING_POSTOPERATIVE',
  LaryngoscopyIndicationTimingPreoperative = 'LARYNGOSCOPY_INDICATION_TIMING_PREOPERATIVE'
}

export type Treatment_LaryngoscopyMsg = {
  __typename?: 'treatment_LaryngoscopyMsg';
  assessment?: Maybe<Scalars['String']>;
  evaluationOfSwallowing?: Maybe<Scalars['String']>;
  evaluationOfSwallowingPresent?: Maybe<Scalars['Boolean']>;
  floatingOrSupportedLaryngoscopy?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageSeriesId?: Maybe<Scalars['String']>;
  indication?: Maybe<Treatment_LaryngoscopyIndicationMsg>;
  /** TODO add billing */
  localizedDiagnosisDetails?: Maybe<Array<Maybe<Treatment_LocalizedDiagnosisDetailMsg>>>;
  microlaryngoscopy?: Maybe<Scalars['Boolean']>;
  technique?: Maybe<Treatment_LaryngoscopyTechnique>;
  vocalCordCompletelyMobile?: Maybe<Scalars['Boolean']>;
  vocalCordImmobilityDetails?: Maybe<Treatment_VocalCordImmobilityDetailsMsg>;
};

export enum Treatment_LaryngoscopyTechnique {
  LaryngoscopyTechniqueDirect = 'LARYNGOSCOPY_TECHNIQUE_DIRECT',
  LaryngoscopyTechniqueIndirect = 'LARYNGOSCOPY_TECHNIQUE_INDIRECT',
  LaryngoscopyTechniqueNone = 'LARYNGOSCOPY_TECHNIQUE_NONE',
  LaryngoscopyTechniqueOther = 'LARYNGOSCOPY_TECHNIQUE_OTHER'
}

export type Treatment_LarynxHypopharynxInspectionBlock = {
  __typename?: 'treatment_LarynxHypopharynxInspectionBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  hypopharynx?: Maybe<Array<Maybe<Treatment_HypopharynxMsg>>>;
  hypopharynxResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  hypopharynxResultText?: Maybe<Scalars['String']>;
  larynx?: Maybe<Array<Maybe<Treatment_LarynxMsg>>>;
  larynxResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  larynxResultText?: Maybe<Scalars['String']>;
};

export type Treatment_LarynxMsg = {
  __typename?: 'treatment_LarynxMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_LateralityDocumentationMode {
  LateralityDocumentationModeCombined = 'LATERALITY_DOCUMENTATION_MODE_COMBINED',
  LateralityDocumentationModeIndividual = 'LATERALITY_DOCUMENTATION_MODE_INDIVIDUAL',
  LateralityDocumentationModeNone = 'LATERALITY_DOCUMENTATION_MODE_NONE'
}

export enum Treatment_LeavingHome {
  LeavingHomeDaily = 'LEAVING_HOME_DAILY',
  LeavingHomeLessThanOnceAWeek = 'LEAVING_HOME_LESS_THAN_ONCE_A_WEEK',
  LeavingHomeNever = 'LEAVING_HOME_NEVER',
  LeavingHomeNone = 'LEAVING_HOME_NONE',
  LeavingHomeOnceOrTwiceAWeek = 'LEAVING_HOME_ONCE_OR_TWICE_A_WEEK'
}

export enum Treatment_LengthOfResidence {
  /** has lived in the apartment for a long time (>5 years) */
  LengthOfResidenceLongTime = 'LENGTH_OF_RESIDENCE_LONG_TIME',
  LengthOfResidenceNone = 'LENGTH_OF_RESIDENCE_NONE',
  /** has moved into the apartment within the last 5 years */
  LengthOfResidenceWithinLast_5Years = 'LENGTH_OF_RESIDENCE_WITHIN_LAST_5_YEARS'
}

export enum Treatment_LevelOfConsciousness {
  LevelOfConsciousnessDoesNotRespondToResponse = 'LEVEL_OF_CONSCIOUSNESS_DOES_NOT_RESPOND_TO_RESPONSE',
  LevelOfConsciousnessMildRestraints = 'LEVEL_OF_CONSCIOUSNESS_MILD_RESTRAINTS',
  LevelOfConsciousnessNone = 'LEVEL_OF_CONSCIOUSNESS_NONE',
  LevelOfConsciousnessNoResponse = 'LEVEL_OF_CONSCIOUSNESS_NO_RESPONSE',
  LevelOfConsciousnessNoRestraints = 'LEVEL_OF_CONSCIOUSNESS_NO_RESTRAINTS'
}

export enum Treatment_LightReaction {
  LightReactionDelayed = 'LIGHT_REACTION_DELAYED',
  LightReactionNone = 'LIGHT_REACTION_NONE',
  LightReactionPrompt = 'LIGHT_REACTION_PROMPT'
}

export type Treatment_LightSensitivityBlock = {
  __typename?: 'treatment_LightSensitivityBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_Lighting {
  LightingFewLightSwitches = 'LIGHTING_FEW_LIGHT_SWITCHES',
  LightingNone = 'LIGHTING_NONE',
  LightingStairwellAndHallwaysBright = 'LIGHTING_STAIRWELL_AND_HALLWAYS_BRIGHT',
  LightingStairwellAndHallwaysDimlyLit = 'LIGHTING_STAIRWELL_AND_HALLWAYS_DIMLY_LIT'
}

export type Treatment_LimbCircumferenceDifferenceBlock = {
  __typename?: 'treatment_LimbCircumferenceDifferenceBlock';
  armCircumferenceDifferencePresent?: Maybe<Scalars['Boolean']>;
  armCircumferenceDifferenceText?: Maybe<Scalars['String']>;
  legCircumferenceDifferencePresent?: Maybe<Scalars['Boolean']>;
  legCircumferenceDifferenceText?: Maybe<Scalars['String']>;
};

export enum Treatment_Limp {
  /** fluent gait (5) */
  LimpFluentGait = 'LIMP_FLUENT_GAIT',
  /** mild to moderate (3) */
  LimpMildToModerate = 'LIMP_MILD_TO_MODERATE',
  LimpNone = 'LIMP_NONE',
  /** severe (0) */
  LimpSevere = 'LIMP_SEVERE'
}

export type Treatment_ListActivePatientsDiagnosesRequest = {
  __typename?: 'treatment_ListActivePatientsDiagnosesRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  whitelistedIcd10Prefixes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListAllergiesRequest = {
  __typename?: 'treatment_ListAllergiesRequest';
  includeNotYetActive?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListAnamensisBlockMetadataResponse = {
  __typename?: 'treatment_ListAnamensisBlockMetadataResponse';
  anamnesisBlockMetadataList?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMetadataMsg>>>;
};

export type Treatment_ListAnamnesesRequest = {
  __typename?: 'treatment_ListAnamnesesRequest';
  anamnesisIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
  /** TODO why treatment id? */
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ListAnamnesisBlockHistoryRequest = {
  __typename?: 'treatment_ListAnamnesisBlockHistoryRequest';
  pathKey?: Maybe<Treatment_PathKeyMsg>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListAnamnesisBlockHistoryResponse = {
  __typename?: 'treatment_ListAnamnesisBlockHistoryResponse';
  anamnesisBlocks?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
};

export type Treatment_ListAnamnesisBlockMetadataRequest = {
  __typename?: 'treatment_ListAnamnesisBlockMetadataRequest';
  /** optional for setting the description as a name with a specific language */
  language?: Maybe<Core_Language>;
  tag?: Maybe<Treatment_AnamnesisBlockMetadataTag>;
};

export type Treatment_ListAnamnesisBlocksResponse = {
  __typename?: 'treatment_ListAnamnesisBlocksResponse';
  blocks?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
};

export type Treatment_ListAnamnesisHistoryRequest = {
  __typename?: 'treatment_ListAnamnesisHistoryRequest';
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListAnamnesisHistoryResponse = {
  __typename?: 'treatment_ListAnamnesisHistoryResponse';
  anamneses?: Maybe<Array<Maybe<Treatment_AnamnesisMsg>>>;
};

export type Treatment_ListAnamnesisScoresRequest = {
  __typename?: 'treatment_ListAnamnesisScoresRequest';
  /** If set to true, blockNumbers will be ignored and all score blocks will be returned */
  allScores?: Maybe<Scalars['Boolean']>;
  blockNumbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Optional, used for alphabetical ordering (default is German) */
  locale?: Maybe<Core_Language>;
  /** Optional filter */
  medicalItemStatuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  surgeryId?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameMsg>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListAnamnesisScoresResponse = {
  __typename?: 'treatment_ListAnamnesisScoresResponse';
  blockContentScores?: Maybe<Array<Maybe<Treatment_AnamnesisBlockContentScoreMsg>>>;
};

export type Treatment_ListClinicalRecommendationsRequest = {
  __typename?: 'treatment_ListClinicalRecommendationsRequest';
  dischargeId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ListCurrentSymptomConfigurationsRequest = {
  __typename?: 'treatment_ListCurrentSymptomConfigurationsRequest';
  /** mandatory, required for versioning */
  patientId?: Maybe<Scalars['String']>;
  /** Mandatory */
  treatmentId?: Maybe<Scalars['String']>;
  /** Mandatory */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListCurrentSymptomConfigurationsResponse = {
  __typename?: 'treatment_ListCurrentSymptomConfigurationsResponse';
  symptomConfigurations?: Maybe<Array<Maybe<Treatment_SymptomConfigurationMsg>>>;
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDefaultPhysicalPresetsRequest = {
  __typename?: 'treatment_ListDefaultPhysicalPresetsRequest';
  /** optional: If this is set, return only the preset parts that are relevant to that physical examination's template */
  physicalExaminationId?: Maybe<Scalars['String']>;
  /** optional */
  scope?: Maybe<Treatment_PhysicalPresetScopeMsg>;
};

export type Treatment_ListDeletedDiagnosesRequest = {
  __typename?: 'treatment_ListDeletedDiagnosesRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  /** required */
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDeletedDiagnosesResponse = {
  __typename?: 'treatment_ListDeletedDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ListDiagnosesByVisitIdsRequest = {
  __typename?: 'treatment_ListDiagnosesByVisitIdsRequest';
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListDiagnosesByVisitIdsResponse = {
  __typename?: 'treatment_ListDiagnosesByVisitIdsResponse';
  diagnosesByVisitIds?: Maybe<Array<Maybe<Treatment_ListDiagnosesByVisitIdsResponse_DiagnosesByVisitIdsEntry>>>;
};

export type Treatment_ListDiagnosesByVisitIdsResponse_DiagnosesByVisitIdsEntry = {
  __typename?: 'treatment_ListDiagnosesByVisitIdsResponse_DiagnosesByVisitIdsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Treatment_DiagnosisList>;
};

export type Treatment_ListDiagnosesRequest = {
  __typename?: 'treatment_ListDiagnosesRequest';
  categoryAssignments?: Maybe<Array<Maybe<Treatment_DiagnosisCategoryAssignmentMsg>>>;
  createdInTreatmentId?: Maybe<Scalars['String']>;
  /** optional filters */
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDiagnosesResponse = {
  __typename?: 'treatment_ListDiagnosesResponse';
  diagnosis?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ListDiagnosisRecommendationsRequest = {
  __typename?: 'treatment_ListDiagnosisRecommendationsRequest';
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDiagnosisRevisionsRequest = {
  __typename?: 'treatment_ListDiagnosisRevisionsRequest';
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDiagnosisRevisionsResponse = {
  __typename?: 'treatment_ListDiagnosisRevisionsResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ListDiagnosisVersionsRequest = {
  __typename?: 'treatment_ListDiagnosisVersionsRequest';
  diagnosisId?: Maybe<Scalars['String']>;
};

export type Treatment_ListDiagnosisVersionsResponse = {
  __typename?: 'treatment_ListDiagnosisVersionsResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ListFilledAnamnesisBlocksRequest = {
  __typename?: 'treatment_ListFilledAnamnesisBlocksRequest';
  anamnesisId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFilledPhysicalBlocksRequest = {
  __typename?: 'treatment_ListFilledPhysicalBlocksRequest';
  examinationId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowRevisionsRequest = {
  __typename?: 'treatment_ListFluidFlowRevisionsRequest';
  fluidFlowId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowRevisionsResponse = {
  __typename?: 'treatment_ListFluidFlowRevisionsResponse';
  fluidFlows?: Maybe<Array<Maybe<Treatment_FluidFlowMsg>>>;
};

export type Treatment_ListFluidFlowSystemMetadataRequest = {
  __typename?: 'treatment_ListFluidFlowSystemMetadataRequest';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowSystemMetadataResponse = {
  __typename?: 'treatment_ListFluidFlowSystemMetadataResponse';
  metadataList?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMetadataMsg>>>;
};

export type Treatment_ListFluidFlowSystemRevisionsRequest = {
  __typename?: 'treatment_ListFluidFlowSystemRevisionsRequest';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowSystemRevisionsResponse = {
  __typename?: 'treatment_ListFluidFlowSystemRevisionsResponse';
  fluidFlowSystems?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMsg>>>;
};

export type Treatment_ListFluidFlowSystemVersionsRequest = {
  __typename?: 'treatment_ListFluidFlowSystemVersionsRequest';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowSystemVersionsResponse = {
  __typename?: 'treatment_ListFluidFlowSystemVersionsResponse';
  fluidFlowSystems?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMsg>>>;
};

export type Treatment_ListFluidFlowSystemsRequest = {
  __typename?: 'treatment_ListFluidFlowSystemsRequest';
  endDate?: Maybe<Timestamp>;
  numbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  patientId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowSystemsResponse = {
  __typename?: 'treatment_ListFluidFlowSystemsResponse';
  fluidFlowSystems?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMsg>>>;
};

export type Treatment_ListFluidFlowVersionsRequest = {
  __typename?: 'treatment_ListFluidFlowVersionsRequest';
  fluidFlowId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowVersionsResponse = {
  __typename?: 'treatment_ListFluidFlowVersionsResponse';
  fluidFlows?: Maybe<Array<Maybe<Treatment_FluidFlowMsg>>>;
};

export type Treatment_ListFluidFlowsRequest = {
  __typename?: 'treatment_ListFluidFlowsRequest';
  /** The last entry ends before or at the offset time of the end date */
  endDate?: Maybe<Timestamp>;
  /** Optional filter to filter by fluid flow system */
  fluidFlowSystemId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  returnDeleted?: Maybe<Scalars['Boolean']>;
  /** The first entry starts at the offset time of the start date */
  startDate?: Maybe<Timestamp>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListFluidFlowsResponse = {
  __typename?: 'treatment_ListFluidFlowsResponse';
  fluidFlowSystemId?: Maybe<Scalars['String']>;
  inFlows?: Maybe<Array<Maybe<Treatment_FluidFlowMsg>>>;
  outFlows?: Maybe<Array<Maybe<Treatment_FluidFlowMsg>>>;
  patientId?: Maybe<Scalars['String']>;
  /** Every result is for a different configuration */
  results?: Maybe<Array<Maybe<Treatment_FluidFlowResultMsg>>>;
};

export type Treatment_ListImmunityTestsRequest = {
  __typename?: 'treatment_ListImmunityTestsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPatientDiagnosesRequest = {
  __typename?: 'treatment_ListPatientDiagnosesRequest';
  /** if set, visitId is ignored and returns diagnoses with overrides from this context */
  billingCaseId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
  /**
   * optional. if set, filter the diagnoses by checking for the existence of an external id of type ICD10
   *  that starts with any of the given prefixes
   */
  whitelistedIcd10Prefixes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListPatientFluidBalanceConfigurationsRequest = {
  __typename?: 'treatment_ListPatientFluidBalanceConfigurationsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPatientFluidBalanceConfigurationsResponse = {
  __typename?: 'treatment_ListPatientFluidBalanceConfigurationsResponse';
  patientConfigurations?: Maybe<Array<Maybe<Treatment_PatientFluidBalanceConfigurationMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPatientsAllergiesRequest = {
  __typename?: 'treatment_ListPatientsAllergiesRequest';
  patientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListPatientsAllergiesResponse = {
  __typename?: 'treatment_ListPatientsAllergiesResponse';
  allergyLists?: Maybe<Array<Maybe<Treatment_AllergyList>>>;
};

export type Treatment_ListPhysicalBlockHistoryRequest = {
  __typename?: 'treatment_ListPhysicalBlockHistoryRequest';
  pathKey?: Maybe<Treatment_PathKeyMsg>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPhysicalBlockHistoryResponse = {
  __typename?: 'treatment_ListPhysicalBlockHistoryResponse';
  physicalBlocks?: Maybe<Array<Maybe<Treatment_PhysicalBlockMsg>>>;
};

export type Treatment_ListPhysicalBlockMetadataRequest = {
  __typename?: 'treatment_ListPhysicalBlockMetadataRequest';
  /** optional for setting the description as a name with a specific language */
  language?: Maybe<Core_Language>;
};

export type Treatment_ListPhysicalBlockMetadataResponse = {
  __typename?: 'treatment_ListPhysicalBlockMetadataResponse';
  physicalBlockMetadataList?: Maybe<Array<Maybe<Treatment_PhysicalBlockMetadataMsg>>>;
};

export type Treatment_ListPhysicalBlocksResponse = {
  __typename?: 'treatment_ListPhysicalBlocksResponse';
  blocks?: Maybe<Array<Maybe<Treatment_PhysicalBlockMsg>>>;
};

export type Treatment_ListPhysicalExaminationHistoryRequest = {
  __typename?: 'treatment_ListPhysicalExaminationHistoryRequest';
  /** Set to show empty physical examinations. By default they are filtered out. */
  displayEmpty?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPhysicalExaminationHistoryResponse = {
  __typename?: 'treatment_ListPhysicalExaminationHistoryResponse';
  physicalExaminations?: Maybe<Array<Maybe<Treatment_PhysicalExaminationMsg>>>;
};

export type Treatment_ListPhysicalExaminationsRequest = {
  __typename?: 'treatment_ListPhysicalExaminationsRequest';
  patientId?: Maybe<Scalars['String']>;
  physicalExaminationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPhysicalPresetsRequest = {
  __typename?: 'treatment_ListPhysicalPresetsRequest';
  /** If set, only the provided owners will be considered; else the owners' parents as well */
  exactOwnerMatch?: Maybe<Scalars['Boolean']>;
  /** Set to true if presets marked as "defaultPreset" should also be returned */
  includeDefaultPresets?: Maybe<Scalars['Boolean']>;
  owners?: Maybe<Array<Maybe<Treatment_PhysicalPresetOwnerReferenceMsg>>>;
  /** Optional: scope filter */
  scope?: Maybe<Treatment_PhysicalPresetScopeMsg>;
};

export type Treatment_ListPreviousDiagnosesRequest = {
  __typename?: 'treatment_ListPreviousDiagnosesRequest';
  /** We have to exclude primary and secondary diagnoses of the current treatment */
  currentTreatmentId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPreviousTreatmentInfoRequest = {
  __typename?: 'treatment_ListPreviousTreatmentInfoRequest';
  patientId?: Maybe<Scalars['String']>;
  /** optional filter */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPreviousVaccinationsRequest = {
  __typename?: 'treatment_ListPreviousVaccinationsRequest';
  /** We have to exclude vaccinations that were made in the current treatment */
  currentTreatmentId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListPrimaryVisitDiagnosesRequest = {
  __typename?: 'treatment_ListPrimaryVisitDiagnosesRequest';
  visitPatientIdPairs?: Maybe<Array<Maybe<Treatment_VisitPatientIdPairMsg>>>;
};

export type Treatment_ListPrimaryVisitDiagnosesResponse = {
  __typename?: 'treatment_ListPrimaryVisitDiagnosesResponse';
  primaryVisitDiagnoses?: Maybe<Array<Maybe<Treatment_VisitDiagnosesList>>>;
};

export type Treatment_ListSurgeryDiagnosesRequest = {
  __typename?: 'treatment_ListSurgeryDiagnosesRequest';
  /** mandatory */
  patientId?: Maybe<Scalars['String']>;
  /** mandatory */
  surgeryId?: Maybe<Scalars['String']>;
};

export type Treatment_ListSurgeryDiagnosesResponse = {
  __typename?: 'treatment_ListSurgeryDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  surgeryId?: Maybe<Scalars['String']>;
};

export type Treatment_ListSurgeryDiagnosisVersioningGroupIdsRequest = {
  __typename?: 'treatment_ListSurgeryDiagnosisVersioningGroupIdsRequest';
  billingCaseId?: Maybe<Scalars['String']>;
  surgeryIds?: Maybe<Helper_IdList>;
};

export type Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse = {
  __typename?: 'treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse';
  diagnosisVersioningGroupIdToSurgeryIds?: Maybe<Array<Maybe<Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse_DiagnosisVersioningGroupIdToSurgeryIdsEntry>>>;
};

export type Treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse_DiagnosisVersioningGroupIdToSurgeryIdsEntry = {
  __typename?: 'treatment_ListSurgeryDiagnosisVersioningGroupIdsResponse_DiagnosisVersioningGroupIdToSurgeryIdsEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Helper_IdList>;
};

export type Treatment_ListSymptomConfigurationRevisionsRequest = {
  __typename?: 'treatment_ListSymptomConfigurationRevisionsRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_ListSymptomConfigurationRevisionsResponse = {
  __typename?: 'treatment_ListSymptomConfigurationRevisionsResponse';
  symptomConfigurations?: Maybe<Array<Maybe<Treatment_SymptomConfigurationMsg>>>;
};

export type Treatment_ListSymptomConfigurationVersionsRequest = {
  __typename?: 'treatment_ListSymptomConfigurationVersionsRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_ListSymptomConfigurationVersionsResponse = {
  __typename?: 'treatment_ListSymptomConfigurationVersionsResponse';
  symptomConfigurations?: Maybe<Array<Maybe<Treatment_SymptomConfigurationMsg>>>;
};

export type Treatment_ListSymptomConfigurationsRequest = {
  __typename?: 'treatment_ListSymptomConfigurationsRequest';
  endCutoff?: Maybe<Timestamp>;
  /** mandatory, required for versioning */
  patientId?: Maybe<Scalars['String']>;
  returnDeleted?: Maybe<Scalars['Boolean']>;
  startCutoff?: Maybe<Timestamp>;
  /** if set, not yet active configurations created in this treatment are displayed as well */
  treatmentId?: Maybe<Scalars['String']>;
  /** Provide at least one of visit id or treatment id */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListSymptomConfigurationsResponse = {
  __typename?: 'treatment_ListSymptomConfigurationsResponse';
  versionGroups?: Maybe<Array<Maybe<Treatment_SymptomConfigurationVersionGroupMsg>>>;
};

export type Treatment_ListTherapyCardHistoryRequest = {
  __typename?: 'treatment_ListTherapyCardHistoryRequest';
  /** if filtering by timeframe, this flag decides whether TherapyCards which don't have a timeframe specified will be returned */
  includeUnspecifiedTimeFrames?: Maybe<Scalars['Boolean']>;
  /** if empty, don't filter by tag */
  metadataTags?: Maybe<Array<Maybe<Treatment_TherapyCardMetadataTag>>>;
  numbers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  surgeryId?: Maybe<Scalars['String']>;
  /** if not set, don't filter by timeframe */
  timeFrame?: Maybe<TimeFrameMsg>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTherapyCardHistoryResponse = {
  __typename?: 'treatment_ListTherapyCardHistoryResponse';
  therapyCards?: Maybe<Array<Maybe<Treatment_TherapyCardMsg>>>;
};

export type Treatment_ListTherapyCardRevisionsRequest = {
  __typename?: 'treatment_ListTherapyCardRevisionsRequest';
  therapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTherapyCardRevisionsResponse = {
  __typename?: 'treatment_ListTherapyCardRevisionsResponse';
  therapyCards?: Maybe<Array<Maybe<Treatment_TherapyCardMsg>>>;
};

export type Treatment_ListTherapyHistoryRequest = {
  __typename?: 'treatment_ListTherapyHistoryRequest';
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTherapyHistoryResponse = {
  __typename?: 'treatment_ListTherapyHistoryResponse';
  therapies?: Maybe<Array<Maybe<Treatment_TherapyMsg>>>;
};

export type Treatment_ListTreatmentAnamnesisBlocksRequest = {
  __typename?: 'treatment_ListTreatmentAnamnesisBlocksRequest';
  blockNumber?: Maybe<Scalars['Int']>;
  treatmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListTreatmentAnamnesisBlocksResponse = {
  __typename?: 'treatment_ListTreatmentAnamnesisBlocksResponse';
  entries?: Maybe<Array<Maybe<Treatment_ListTreatmentAnamnesisBlocksResponseEntryMsg>>>;
};

export type Treatment_ListTreatmentAnamnesisBlocksResponseEntryMsg = {
  __typename?: 'treatment_ListTreatmentAnamnesisBlocksResponseEntryMsg';
  /** Set if the treatment had a block of the given number; not set if not. */
  anamnesisBlock?: Maybe<Treatment_AnamnesisBlockMsg>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTreatmentDiagnosesRequest = {
  __typename?: 'treatment_ListTreatmentDiagnosesRequest';
  treatmentId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTreatmentsRequest = {
  __typename?: 'treatment_ListTreatmentsRequest';
  /** optional sortOrder, default DESC */
  createdAtSortOrder?: Maybe<Helper_SortOrder>;
  patientId?: Maybe<Scalars['String']>;
  /** if empty, don't filter by status */
  statuses?: Maybe<Array<Maybe<Treatment_TreatmentStatus>>>;
  /** optional filter */
  surgeryId?: Maybe<Scalars['String']>;
  /** if empty, don't filter by type */
  types?: Maybe<Array<Maybe<Treatment_TreatmentType>>>;
  /** optional filter */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListTreatmentsResponse = {
  __typename?: 'treatment_ListTreatmentsResponse';
  patientId?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<Maybe<Treatment_TreatmentMsg>>>;
  /** it's set if `visitId` is set in the `ListTreatmentsRequest` */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_ListVaccinationDiseasesRequest = {
  __typename?: 'treatment_ListVaccinationDiseasesRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListVaccinationsRequest = {
  __typename?: 'treatment_ListVaccinationsRequest';
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_ListWoundProcedureHistoryRequest = {
  __typename?: 'treatment_ListWoundProcedureHistoryRequest';
  patientId?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<Treatment_MedicalItemStatus>>>;
  /** if not set, don't filter by timeframe */
  timeFrame?: Maybe<TimeFrameMsg>;
  timeFrameTimeFromSort?: Maybe<Helper_SortOrder>;
  visitId?: Maybe<Scalars['String']>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListWoundProcedureHistoryResponse = {
  __typename?: 'treatment_ListWoundProcedureHistoryResponse';
  woundProcedureGroups?: Maybe<Array<Maybe<Treatment_WoundProcedureGroupMsg>>>;
};

export type Treatment_ListWoundRevisionsRequest = {
  __typename?: 'treatment_ListWoundRevisionsRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_ListWoundRevisionsResponse = {
  __typename?: 'treatment_ListWoundRevisionsResponse';
  wounds?: Maybe<Array<Maybe<Treatment_WoundMsg>>>;
};

export type Treatment_ListWoundVersionsRequest = {
  __typename?: 'treatment_ListWoundVersionsRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_ListWoundVersionsResponse = {
  __typename?: 'treatment_ListWoundVersionsResponse';
  wounds?: Maybe<Array<Maybe<Treatment_WoundMsg>>>;
};

export type Treatment_ListWoundsRequest = {
  __typename?: 'treatment_ListWoundsRequest';
  /** mandatory */
  context?: Maybe<Treatment_WoundContextReferenceMsg>;
  /** optional filter */
  healingProgresses?: Maybe<Array<Maybe<Treatment_WoundHealingProgress>>>;
  /** optional filter */
  onlyHealed?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  onlyLatestVersion?: Maybe<Scalars['Boolean']>;
  /** optional filter */
  timeFrame?: Maybe<TimeFrameMsg>;
  /** optional sort */
  woundDateSort?: Maybe<Helper_SortOrder>;
  /** optional filter */
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_ListWoundsResponse = {
  __typename?: 'treatment_ListWoundsResponse';
  patientId?: Maybe<Scalars['String']>;
  woundVersionGroups?: Maybe<Array<Maybe<Treatment_WoundVersionGroupMsg>>>;
};

export enum Treatment_ListingWords {
  ListingWordsLargerThanOrEqual_11 = 'LISTING_WORDS_LARGER_THAN_OR_EQUAL_11',
  ListingWordsLessThan_11 = 'LISTING_WORDS_LESS_THAN_11',
  ListingWordsNone = 'LISTING_WORDS_NONE'
}

export type Treatment_LiverPalpationBlock = {
  __typename?: 'treatment_LiverPalpationBlock';
  hepatojugularRefluxPresent?: Maybe<Scalars['Boolean']>;
  isLiverPalpable?: Maybe<Scalars['Boolean']>;
  liverRim?: Maybe<Scalars['Int']>;
  liverSurface?: Maybe<Treatment_LiverSurface>;
  liverTexture?: Maybe<Treatment_LiverTexture>;
  pulsationsPresent?: Maybe<Scalars['Boolean']>;
  tendernessPresent?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_LiverSizeBlock = {
  __typename?: 'treatment_LiverSizeBlock';
  liverSize?: Maybe<Scalars['Float']>;
  measurement?: Maybe<Array<Maybe<Treatment_LiverSizeMeasurement>>>;
};

export enum Treatment_LiverSizeMeasurement {
  LiverSizeMeasurementAuscultation = 'LIVER_SIZE_MEASUREMENT_AUSCULTATION',
  LiverSizeMeasurementNone = 'LIVER_SIZE_MEASUREMENT_NONE',
  LiverSizeMeasurementPercussion = 'LIVER_SIZE_MEASUREMENT_PERCUSSION'
}

export type Treatment_LiverSkinSignExaminationBlock = {
  __typename?: 'treatment_LiverSkinSignExaminationBlock';
  liverSkinSigns?: Maybe<Array<Maybe<Treatment_LiverSkinSignMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_LiverSkinSignMsg = {
  __typename?: 'treatment_LiverSkinSignMsg';
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  imageSeriesId?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_LiverSurface {
  LiverSurfaceKnotty = 'LIVER_SURFACE_KNOTTY',
  LiverSurfaceNone = 'LIVER_SURFACE_NONE',
  LiverSurfaceSmooth = 'LIVER_SURFACE_SMOOTH'
}

export enum Treatment_LiverTexture {
  LiverTextureNone = 'LIVER_TEXTURE_NONE',
  LiverTextureSoft = 'LIVER_TEXTURE_SOFT',
  LiverTextureTender = 'LIVER_TEXTURE_TENDER'
}

export enum Treatment_LivingCircumstances {
  LivingCircumstancesAloneLongTime = 'LIVING_CIRCUMSTANCES_ALONE_LONG_TIME',
  LivingCircumstancesAloneRecently = 'LIVING_CIRCUMSTANCES_ALONE_RECENTLY',
  LivingCircumstancesNone = 'LIVING_CIRCUMSTANCES_NONE',
  LivingCircumstancesWithFamilyPartner = 'LIVING_CIRCUMSTANCES_WITH_FAMILY_PARTNER',
  LivingCircumstancesWithPartnerNeedsHelp = 'LIVING_CIRCUMSTANCES_WITH_PARTNER_NEEDS_HELP'
}

export type Treatment_LivingSituationBlock = {
  __typename?: 'treatment_LivingSituationBlock';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_LocalAnaesthesiaMsg = {
  __typename?: 'treatment_LocalAnaesthesiaMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Core_KnowledgeInputMsg>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_LocalAnestheticMsg = {
  __typename?: 'treatment_LocalAnestheticMsg';
  /** non-negative; unit: ml */
  localAnaesthesiaVolume?: Maybe<Scalars['Float']>;
  localAnesthesticDrugLink?: Maybe<Drug_DrugLinkMsg>;
};

export enum Treatment_LocalTransport {
  /** next stop further away */
  LocalTransportNextStopFurtherAway = 'LOCAL_TRANSPORT_NEXT_STOP_FURTHER_AWAY',
  LocalTransportNone = 'LOCAL_TRANSPORT_NONE',
  /** stop nearby (<1 km) */
  LocalTransportStopNearby = 'LOCAL_TRANSPORT_STOP_NEARBY'
}

export type Treatment_LocalizedDiagnosisDetailMsg = {
  __typename?: 'treatment_LocalizedDiagnosisDetailMsg';
  diagnosisDetail?: Maybe<Treatment_DiagnosisDetailMsg>;
  diagnosisLocalization?: Maybe<Treatment_DiagnosisLocalization>;
};

export enum Treatment_LossOfEnergy {
  LossOfEnergyHaveLessEnergy = 'LOSS_OF_ENERGY_HAVE_LESS_ENERGY',
  LossOfEnergyHaveLittleEnergy = 'LOSS_OF_ENERGY_HAVE_LITTLE_ENERGY',
  LossOfEnergyHaveMoreEnergy = 'LOSS_OF_ENERGY_HAVE_MORE_ENERGY',
  LossOfEnergyHaveNoEnergy = 'LOSS_OF_ENERGY_HAVE_NO_ENERGY',
  LossOfEnergyNone = 'LOSS_OF_ENERGY_NONE'
}

export enum Treatment_LossOfEnjoyment {
  LossOfEnjoymentCannotEnjoy = 'LOSS_OF_ENJOYMENT_CANNOT_ENJOY',
  LossOfEnjoymentCanEnjoy = 'LOSS_OF_ENJOYMENT_CAN_ENJOY',
  LossOfEnjoymentLessPastEnjoymentExperience = 'LOSS_OF_ENJOYMENT_LESS_PAST_ENJOYMENT_EXPERIENCE',
  LossOfEnjoymentNone = 'LOSS_OF_ENJOYMENT_NONE',
  LossOfEnjoymentNoPastEnjoymentExperience = 'LOSS_OF_ENJOYMENT_NO_PAST_ENJOYMENT_EXPERIENCE'
}

export enum Treatment_LossOfInterest {
  LossOfInterestLessInterest = 'LOSS_OF_INTEREST_LESS_INTEREST',
  LossOfInterestMostlyHaveLossOfInterest = 'LOSS_OF_INTEREST_MOSTLY_HAVE_LOSS_OF_INTEREST',
  LossOfInterestNone = 'LOSS_OF_INTEREST_NONE',
  LossOfInterestNotInterestedAtAll = 'LOSS_OF_INTEREST_NOT_INTERESTED_AT_ALL',
  LossOfInterestNoLossOfInterest = 'LOSS_OF_INTEREST_NO_LOSS_OF_INTEREST'
}

export enum Treatment_LossOfSexualInterest {
  LossOfSexualInterestCompletelyLossOfInterest = 'LOSS_OF_SEXUAL_INTEREST_COMPLETELY_LOSS_OF_INTEREST',
  LossOfSexualInterestLessInterested = 'LOSS_OF_SEXUAL_INTEREST_LESS_INTERESTED',
  LossOfSexualInterestMuchLessInterested = 'LOSS_OF_SEXUAL_INTEREST_MUCH_LESS_INTERESTED',
  LossOfSexualInterestNone = 'LOSS_OF_SEXUAL_INTEREST_NONE',
  LossOfSexualInterestNoChange = 'LOSS_OF_SEXUAL_INTEREST_NO_CHANGE'
}

export type Treatment_LowerAnkleJointMsg = {
  __typename?: 'treatment_LowerAnkleJointMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  id?: Maybe<Scalars['String']>;
  pronation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  supination?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
};

export type Treatment_LowerLegAndAnkleFunctionTestMsg = {
  __typename?: 'treatment_LowerLegAndAnkleFunctionTestMsg';
  anteriorDrawerTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  anteriorDrawerTestText?: Maybe<Scalars['String']>;
  crossedLegTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  crossedLegTestText?: Maybe<Scalars['String']>;
  frickTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  frickTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lateralGapping?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lateralGappingText?: Maybe<Scalars['String']>;
  silfverskjoeldTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  silfverskjoeldTestText?: Maybe<Scalars['String']>;
  squeezeTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  squeezeTestText?: Maybe<Scalars['String']>;
};

export type Treatment_LowerLegAndAnkleFunctionTestsBlock = {
  __typename?: 'treatment_LowerLegAndAnkleFunctionTestsBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_LowerLegAndAnkleFunctionTestMsg>;
  right?: Maybe<Treatment_LowerLegAndAnkleFunctionTestMsg>;
};

export type Treatment_LowerLimbsPasiMsg = {
  __typename?: 'treatment_LowerLimbsPasiMsg';
  lowerLimbsBodyRegionPercentage?: Maybe<Treatment_BodyRegionPercentage>;
  lowerLimbsDiscoloration?: Maybe<Treatment_PasiSelection>;
  lowerLimbsScaling?: Maybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.4> */
  lowerLimbsScore?: Maybe<Scalars['Float']>;
  lowerLimbsThickness?: Maybe<Treatment_PasiSelection>;
};

export type Treatment_LumbarSpineJointsMsg = {
  __typename?: 'treatment_LumbarSpineJointsMsg';
  /** L1/L2 */
  l1L2?: Maybe<Laterality_Laterality>;
  /** L2/L3 */
  l2L3?: Maybe<Laterality_Laterality>;
  /** L3/L4 */
  l3L4?: Maybe<Laterality_Laterality>;
  /** L4/L5 */
  l4L5?: Maybe<Laterality_Laterality>;
  /** L5/S1 */
  l5S1?: Maybe<Laterality_Laterality>;
};

export type Treatment_LumbarSpineMsg = {
  __typename?: 'treatment_LumbarSpineMsg';
  l1?: Maybe<Laterality_Laterality>;
  l2?: Maybe<Laterality_Laterality>;
  l3?: Maybe<Laterality_Laterality>;
  l4?: Maybe<Laterality_Laterality>;
  l5?: Maybe<Laterality_Laterality>;
  s1?: Maybe<Laterality_Laterality>;
};

export type Treatment_LungAusculatationsBlock = {
  __typename?: 'treatment_LungAusculatationsBlock';
  auscultations?: Maybe<Array<Maybe<Treatment_LungAuscultationDescriptionMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  nonExistentRales?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_LungAuscultationDescriptionMsg = {
  __typename?: 'treatment_LungAuscultationDescriptionMsg';
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_LungBorderBlock = {
  __typename?: 'treatment_LungBorderBlock';
  lungBorder?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_LungsThoraxPressurePainBlock = {
  __typename?: 'treatment_LungsThoraxPressurePainBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_LymphNodesAbnormalitiesMsg = {
  __typename?: 'treatment_LymphNodesAbnormalitiesMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_MakingOneselfUnderstood {
  MakingOneselfUnderstoodAlmostEverything = 'MAKING_ONESELF_UNDERSTOOD_ALMOST_EVERYTHING',
  MakingOneselfUnderstoodCannotBeUnderstandable = 'MAKING_ONESELF_UNDERSTOOD_CANNOT_BE_UNDERSTANDABLE',
  MakingOneselfUnderstoodExpressSimpleFacts = 'MAKING_ONESELF_UNDERSTOOD_EXPRESS_SIMPLE_FACTS',
  MakingOneselfUnderstoodNone = 'MAKING_ONESELF_UNDERSTOOD_NONE'
}

export type Treatment_MallampatiClassificationBlock = {
  __typename?: 'treatment_MallampatiClassificationBlock';
  mallampatiClassificationSelection?: Maybe<Treatment_MallampatiClassificationSelection>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_MallampatiClassificationSelection {
  MallampatiClassificationSelectionNone = 'MALLAMPATI_CLASSIFICATION_SELECTION_NONE',
  MallampatiClassificationSelectionOnlyHardPalateVisible = 'MALLAMPATI_CLASSIFICATION_SELECTION_ONLY_HARD_PALATE_VISIBLE',
  MallampatiClassificationSelectionSoftPalateAndBaseOfUvulaVisible = 'MALLAMPATI_CLASSIFICATION_SELECTION_SOFT_PALATE_AND_BASE_OF_UVULA_VISIBLE',
  MallampatiClassificationSelectionSoftPalateAndUvulaVisible = 'MALLAMPATI_CLASSIFICATION_SELECTION_SOFT_PALATE_AND_UVULA_VISIBLE',
  MallampatiClassificationSelectionSoftPalateUvulaAndPillarsVisible = 'MALLAMPATI_CLASSIFICATION_SELECTION_SOFT_PALATE_UVULA_AND_PILLARS_VISIBLE'
}

export enum Treatment_ManipulativeOrotrachealMeasures {
  ManipulativeOrotrachealMeasuresNone = 'MANIPULATIVE_OROTRACHEAL_MEASURES_NONE',
  ManipulativeOrotrachealMeasuresNotAtAll = 'MANIPULATIVE_OROTRACHEAL_MEASURES_NOT_AT_ALL',
  ManipulativeOrotrachealMeasuresNursingMeasures = 'MANIPULATIVE_OROTRACHEAL_MEASURES_NURSING_MEASURES',
  ManipulativeOrotrachealMeasuresOralNasalEndotrachealSuctioningWithOrWithoutLyingTube = 'MANIPULATIVE_OROTRACHEAL_MEASURES_ORAL_NASAL_ENDOTRACHEAL_SUCTIONING_WITH_OR_WITHOUT_LYING_TUBE',
  ManipulativeOrotrachealMeasuresOralNasalSuctioning = 'MANIPULATIVE_OROTRACHEAL_MEASURES_ORAL_NASAL_SUCTIONING'
}

export type Treatment_MastoidAbnormalityMsg = {
  __typename?: 'treatment_MastoidAbnormalityMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_MastoidInspectionAbnormalityMsg = {
  __typename?: 'treatment_MastoidInspectionAbnormalityMsg';
  combined?: Maybe<Treatment_MastoidSideInspectionMsg>;
  documentationMode?: Maybe<Treatment_LateralityDocumentationMode>;
  id?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_MastoidSideInspectionMsg>;
  right?: Maybe<Treatment_MastoidSideInspectionMsg>;
};

export type Treatment_MastoidInspectionMsg = {
  __typename?: 'treatment_MastoidInspectionMsg';
  abnormalities?: Maybe<Array<Maybe<Treatment_MastoidInspectionAbnormalityMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_MastoidSideInspectionMsg = {
  __typename?: 'treatment_MastoidSideInspectionMsg';
  abnormality?: Maybe<Treatment_MastoidAbnormalityMsg>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_MealsPerDay {
  MealsPerDayNone = 'MEALS_PER_DAY_NONE',
  /** 1 meal (0) */
  MealsPerDayOne = 'MEALS_PER_DAY_ONE',
  /** 3 meals (2) */
  MealsPerDayThree = 'MEALS_PER_DAY_THREE',
  /** 2 meals (1) */
  MealsPerDayTwo = 'MEALS_PER_DAY_TWO'
}

export enum Treatment_MechanicalVentilation {
  /** Intermittent use of noninvasive ventilation */
  MechanicalVentilationIntermittentUse = 'MECHANICAL_VENTILATION_INTERMITTENT_USE',
  /** Mechanical ventilation via intubation or tracheostoma */
  MechanicalVentilationIntubationOrTracheostoma = 'MECHANICAL_VENTILATION_INTUBATION_OR_TRACHEOSTOMA',
  MechanicalVentilationNone = 'MECHANICAL_VENTILATION_NONE',
  MechanicalVentilationNotRequired = 'MECHANICAL_VENTILATION_NOT_REQUIRED',
  /** Continuous use of noninvasive ventilation (day and night) */
  MechanicalVentilationVentilationAtDayAndNight = 'MECHANICAL_VENTILATION_VENTILATION_AT_DAY_AND_NIGHT',
  /** Continuous use of noninvasive ventilation at night or additionally by the hour during the day */
  MechanicalVentilationVentilationAtNight = 'MECHANICAL_VENTILATION_VENTILATION_AT_NIGHT'
}

export type Treatment_MediastinalDrainageMsg = {
  __typename?: 'treatment_MediastinalDrainageMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  suction?: Maybe<Scalars['Float']>;
  suctionUnit?: Maybe<Treatment_SuctionUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_MedicalItemContextMsg = {
  __typename?: 'treatment_MedicalItemContextMsg';
  currentStatusEntry?: Maybe<Treatment_MedicalItemStatusEntryMsg>;
  dischargeId?: Maybe<Scalars['String']>;
  historicStatusEntries?: Maybe<Array<Maybe<Treatment_MedicalItemStatusEntryMsg>>>;
  owningAdministrativeUnit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  surgeryId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_MedicalItemStatus {
  MedicalItemStatusAccepted = 'MEDICAL_ITEM_STATUS_ACCEPTED',
  MedicalItemStatusCancelled = 'MEDICAL_ITEM_STATUS_CANCELLED',
  MedicalItemStatusDenied = 'MEDICAL_ITEM_STATUS_DENIED',
  MedicalItemStatusNone = 'MEDICAL_ITEM_STATUS_NONE',
  MedicalItemStatusNotYetAccepted = 'MEDICAL_ITEM_STATUS_NOT_YET_ACCEPTED',
  MedicalItemStatusNotYetActive = 'MEDICAL_ITEM_STATUS_NOT_YET_ACTIVE'
}

export type Treatment_MedicalItemStatusEntryMsg = {
  __typename?: 'treatment_MedicalItemStatusEntryMsg';
  setAt?: Maybe<Timestamp>;
  setBy?: Maybe<Core_PersonReferenceMsg>;
  status?: Maybe<Treatment_MedicalItemStatus>;
};

export type Treatment_MedicationBlock = {
  __typename?: 'treatment_MedicationBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_MeldAndMeldNaBlock = {
  __typename?: 'treatment_MeldAndMeldNaBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** unit: mg/dl */
  creatinine?: Maybe<Scalars['Float']>;
  inr?: Maybe<Scalars['Float']>;
  /** MELD-Score – Serum sodium - (0.025 * MELD-Score * (140 – Serum sodium)) + 140 */
  meldNaScore?: Maybe<Scalars['Int']>;
  /** 10 * ((0.957 * ln(Creatinine)) + (0.378 * ln(Total Bilirubin)) + (1.12 * ln(INR))) + 6.43 */
  meldScore?: Maybe<Scalars['Int']>;
  /** unit: mmol/l */
  serumSodium?: Maybe<Scalars['Float']>;
  /** unit: mg/dl */
  totalBilirubin?: Maybe<Scalars['Float']>;
  twoFoldHemodialysis?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_Memory {
  /** apple (1) */
  MemoryApple = 'MEMORY_APPLE',
  MemoryNone = 'MEMORY_NONE',
  /** penny (1) */
  MemoryPenny = 'MEMORY_PENNY',
  /** table (1) */
  MemoryTable = 'MEMORY_TABLE'
}

export enum Treatment_MemoryAbility {
  /** apple (1) */
  MemoryAbilityApple = 'MEMORY_ABILITY_APPLE',
  MemoryAbilityNone = 'MEMORY_ABILITY_NONE',
  /** penny (1) */
  MemoryAbilityPenny = 'MEMORY_ABILITY_PENNY',
  /** table (1) */
  MemoryAbilityTable = 'MEMORY_ABILITY_TABLE'
}

export type Treatment_MemoryBlock = {
  __typename?: 'treatment_MemoryBlock';
  amnesia?: Maybe<Scalars['Boolean']>;
  amnesiaDescriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  amnesiaText?: Maybe<Scalars['String']>;
  autobiographicalMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  autobiographicalMemoryText?: Maybe<Scalars['String']>;
  confabulations?: Maybe<Scalars['Boolean']>;
  confabulationsText?: Maybe<Scalars['String']>;
  episodicMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  episodicMemoryText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  longTermMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  longTermMemoryText?: Maybe<Scalars['String']>;
  memory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  paramnesia?: Maybe<Scalars['Boolean']>;
  paramnesiaText?: Maybe<Scalars['String']>;
  retention?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  retentionText?: Maybe<Scalars['String']>;
  semanticMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  semanticMemoryText?: Maybe<Scalars['String']>;
  shortTermMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  shortTermMemoryText?: Maybe<Scalars['String']>;
  timeGridDisturbances?: Maybe<Scalars['Boolean']>;
  timeGridDisturbancesText?: Maybe<Scalars['String']>;
  workingMemory?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  workingMemoryText?: Maybe<Scalars['String']>;
};

export type Treatment_MenarcheMenopauseBlock = {
  __typename?: 'treatment_MenarcheMenopauseBlock';
  /** The time of the menarche; typically just entered as year or month and year */
  menarche?: Maybe<VeiosDateTimeMsg>;
  /** The time of the menopause; typically just entered as year or month and year */
  menopause?: Maybe<VeiosDateTimeMsg>;
};

export type Treatment_MenisciExaminationBlock = {
  __typename?: 'treatment_MenisciExaminationBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_MenisciExaminationMsg>;
  right?: Maybe<Treatment_MenisciExaminationMsg>;
};

export type Treatment_MenisciExaminationMsg = {
  __typename?: 'treatment_MenisciExaminationMsg';
  apleyGrindingSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  apleyGrindingSignText?: Maybe<Scalars['String']>;
  boehlersSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  boehlersSignText?: Maybe<Scalars['String']>;
  bragardTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  bragardTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mcMurrayTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  mcMurrayTestText?: Maybe<Scalars['String']>;
  payrsSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  payrsSignText?: Maybe<Scalars['String']>;
  steinmannIISign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  steinmannIISignText?: Maybe<Scalars['String']>;
  steinmannISign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  steinmannISignText?: Maybe<Scalars['String']>;
};

export enum Treatment_MenstruationCycle {
  MenstruationCycleIrregular = 'MENSTRUATION_CYCLE_IRREGULAR',
  MenstruationCycleNone = 'MENSTRUATION_CYCLE_NONE',
  MenstruationCycleRegular = 'MENSTRUATION_CYCLE_REGULAR'
}

export type Treatment_MentalEatingDisorderMsg = {
  __typename?: 'treatment_MentalEatingDisorderMsg';
  bingeEating?: Maybe<Treatment_BingeEatingMsg>;
  bingeEatingPresent?: Maybe<Scalars['Boolean']>;
  bodyMisconception?: Maybe<Treatment_BodyMisconceptionMsg>;
  bodyMisconceptionPresent?: Maybe<Scalars['Boolean']>;
  dietaryBehavior?: Maybe<Treatment_DietaryBehavior>;
  dietaryBehaviorDescription?: Maybe<Scalars['String']>;
  fastingPeriods?: Maybe<Treatment_FastingPeriodsMsg>;
  fastingPeriodsPresent?: Maybe<Scalars['Boolean']>;
  feelingOfHunger?: Maybe<Scalars['Boolean']>;
  feelingOfSatiety?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  /** in kg */
  maximumWeight?: Maybe<Scalars['Float']>;
  /** in kg */
  minimumWeight?: Maybe<Scalars['Float']>;
  purging?: Maybe<Treatment_PurgingMsg>;
  purgingPresent?: Maybe<Scalars['Boolean']>;
  regularMainMeals?: Maybe<Scalars['Boolean']>;
  regularMainMealsDescription?: Maybe<Scalars['String']>;
  satisfiedWithCurrentWeight?: Maybe<Scalars['Boolean']>;
  snacks?: Maybe<Scalars['Boolean']>;
  snacksDescription?: Maybe<Scalars['String']>;
  timeOfFeelingOfHunger?: Maybe<Scalars['String']>;
  weightDissatisfactionReasons?: Maybe<Scalars['String']>;
  weightVariability?: Maybe<Treatment_WeightVariability>;
};

export enum Treatment_MentalState {
  MentalStateApatheticListless = 'MENTAL_STATE_APATHETIC_LISTLESS',
  MentalStateConfused = 'MENTAL_STATE_CONFUSED',
  MentalStateDull = 'MENTAL_STATE_DULL',
  MentalStateLucid = 'MENTAL_STATE_LUCID',
  MentalStateNone = 'MENTAL_STATE_NONE'
}

export type Treatment_MetabolicEquivalentOfTaskBlock = {
  __typename?: 'treatment_MetabolicEquivalentOfTaskBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  metabolicEquivalentOfTaskSelection?: Maybe<Treatment_MetabolicEquivalentOfTaskSelection>;
  score?: Maybe<Scalars['String']>;
};

export enum Treatment_MetabolicEquivalentOfTaskSelection {
  MetabolicEquivalentOfTaskSelectionFour = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_FOUR',
  MetabolicEquivalentOfTaskSelectionGreaterOrEqualThanFour = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_GREATER_OR_EQUAL_THAN_FOUR',
  MetabolicEquivalentOfTaskSelectionGreaterOrEqualThanTen = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_GREATER_OR_EQUAL_THAN_TEN',
  MetabolicEquivalentOfTaskSelectionGreaterThanSix = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_GREATER_THAN_SIX',
  MetabolicEquivalentOfTaskSelectionNone = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_NONE',
  MetabolicEquivalentOfTaskSelectionSix = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_SIX',
  MetabolicEquivalentOfTaskSelectionSmallerThanFour = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_SMALLER_THAN_FOUR',
  MetabolicEquivalentOfTaskSelectionSmallerThanOne = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_SMALLER_THAN_ONE',
  MetabolicEquivalentOfTaskSelectionSmallerThanThree = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_SMALLER_THAN_THREE',
  MetabolicEquivalentOfTaskSelectionThree = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_THREE',
  MetabolicEquivalentOfTaskSelectionTwo = 'METABOLIC_EQUIVALENT_OF_TASK_SELECTION_TWO'
}

export type Treatment_MicturitionDisorderBlock = {
  __typename?: 'treatment_MicturitionDisorderBlock';
  dailyNocturiaFrequency?: Maybe<Scalars['Int']>;
  flow?: Maybe<Treatment_MicturitionFlowType>;
  furtherComplaints?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherComplaintsText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  nocturiaPresent?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  totalVolume?: Maybe<Treatment_MicuritionVolume>;
  urinaryContinencePresent?: Maybe<Scalars['Boolean']>;
  urinaryContinenceText?: Maybe<Scalars['String']>;
  urinaryIncontinenceType?: Maybe<Core_KnowledgeInputMsg>;
  urineColors?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  urineTextures?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_MicturitionFlowType {
  MicturitionFlowContinuous = 'MICTURITION_FLOW_CONTINUOUS',
  MicturitionFlowInterrupted = 'MICTURITION_FLOW_INTERRUPTED',
  MicturitionFlowNone = 'MICTURITION_FLOW_NONE'
}

export enum Treatment_MicuritionVolume {
  MicuritionVolumeDecreased = 'MICURITION_VOLUME_DECREASED',
  MicuritionVolumeIncreased = 'MICURITION_VOLUME_INCREASED',
  MicuritionVolumeNone = 'MICURITION_VOLUME_NONE',
  MicuritionVolumeNormal = 'MICURITION_VOLUME_NORMAL'
}

export type Treatment_MiniMentalStateExaminationBlock = {
  __typename?: 'treatment_MiniMentalStateExaminationBlock';
  attentionAndCalculationAbilityList?: Maybe<Array<Maybe<Treatment_AttentionAndCalculationAbility>>>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  followCommandList?: Maybe<Array<Maybe<Treatment_FollowCommand>>>;
  identifyObjectList?: Maybe<Array<Maybe<Treatment_IdentifyObject>>>;
  memoryAbilityList?: Maybe<Array<Maybe<Treatment_MemoryAbility>>>;
  memoryList?: Maybe<Array<Maybe<Treatment_Memory>>>;
  orientationLocalisationList?: Maybe<Array<Maybe<Treatment_OrientationLocalisation>>>;
  orientationTimeList?: Maybe<Array<Maybe<Treatment_OrientationTime>>>;
  repeatSentenceList?: Maybe<Array<Maybe<Treatment_RepeatSentence>>>;
  score?: Maybe<Scalars['Int']>;
};

export type Treatment_MiniNutritionalAssessmentLongVersionBlock = {
  __typename?: 'treatment_MiniNutritionalAssessmentLongVersionBlock';
  assessment?: Maybe<Treatment_AssessmentMsg>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Score Screening + Score Assessment */
  score?: Maybe<Scalars['Float']>;
  screening?: Maybe<Treatment_ScreeningMsg>;
};

export type Treatment_MiniNutritionalAssessmentShortVersionBlock = {
  __typename?: 'treatment_MiniNutritionalAssessmentShortVersionBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  screening?: Maybe<Treatment_ScreeningMsg>;
};

/** Arbitrary text in which examinations can be specified */
export type Treatment_MiscellaneousExaminationMsg = {
  __typename?: 'treatment_MiscellaneousExaminationMsg';
  text?: Maybe<Scalars['String']>;
};

/** Arbitrary text in which therapies can be specified */
export type Treatment_MiscellaneousTherapyMsg = {
  __typename?: 'treatment_MiscellaneousTherapyMsg';
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_MnsWillingnessToCooperate {
  MnsWillingnessToCooperateFull = 'MNS_WILLINGNESS_TO_COOPERATE_FULL',
  MnsWillingnessToCooperateLittle = 'MNS_WILLINGNESS_TO_COOPERATE_LITTLE',
  MnsWillingnessToCooperateNone = 'MNS_WILLINGNESS_TO_COOPERATE_NONE',
  MnsWillingnessToCooperateNotAtAll = 'MNS_WILLINGNESS_TO_COOPERATE_NOT_AT_ALL',
  MnsWillingnessToCooperatePartially = 'MNS_WILLINGNESS_TO_COOPERATE_PARTIALLY'
}

export enum Treatment_Mobility {
  /** bedridden or mobilized in a chair (0) */
  MobilityInAChair = 'MOBILITY_IN_A_CHAIR',
  /** leaves the home (2) */
  MobilityLeavesTheHome = 'MOBILITY_LEAVES_THE_HOME',
  /** able to move around the home (1) */
  MobilityMoveAroundTheHome = 'MOBILITY_MOVE_AROUND_THE_HOME',
  MobilityNone = 'MOBILITY_NONE'
}

export enum Treatment_MobilityLimitations {
  MobilityLimitationsLimitedMobilityCompensatedByWalkingAids = 'MOBILITY_LIMITATIONS_LIMITED_MOBILITY_COMPENSATED_BY_WALKING_AIDS',
  MobilityLimitationsMainOccupations = 'MOBILITY_LIMITATIONS_MAIN_OCCUPATIONS',
  MobilityLimitationsNone = 'MOBILITY_LIMITATIONS_NONE',
  MobilityLimitationsNotAtAll = 'MOBILITY_LIMITATIONS_NOT_AT_ALL',
  MobilityLimitationsTotal = 'MOBILITY_LIMITATIONS_TOTAL'
}

export enum Treatment_MobilityOnLevelsSurface {
  MobilityOnLevelsSurfaceImmobile = 'MOBILITY_ON_LEVELS_SURFACE_IMMOBILE',
  MobilityOnLevelsSurfaceIndependent = 'MOBILITY_ON_LEVELS_SURFACE_INDEPENDENT',
  MobilityOnLevelsSurfaceNone = 'MOBILITY_ON_LEVELS_SURFACE_NONE',
  MobilityOnLevelsSurfaceWalksWithHelp = 'MOBILITY_ON_LEVELS_SURFACE_WALKS_WITH_HELP',
  MobilityOnLevelsSurfaceWheelchairIndependent = 'MOBILITY_ON_LEVELS_SURFACE_WHEELCHAIR_INDEPENDENT'
}

export type Treatment_MobilitySpineBlock = {
  __typename?: 'treatment_MobilitySpineBlock';
  movementPain?: Maybe<Scalars['Boolean']>;
  movementPainText?: Maybe<Scalars['String']>;
  restrictionOfMovement?: Maybe<Scalars['Boolean']>;
  restrictionOfMovementText?: Maybe<Scalars['String']>;
};

export type Treatment_MobilityTestAnkleBlock = {
  __typename?: 'treatment_MobilityTestAnkleBlock';
  left?: Maybe<Treatment_MobilityTestAnkleMsg>;
  right?: Maybe<Treatment_MobilityTestAnkleMsg>;
};

export type Treatment_MobilityTestAnkleMeasurementMsg = {
  __typename?: 'treatment_MobilityTestAnkleMeasurementMsg';
  id?: Maybe<Scalars['String']>;
  lowerAnklePronationSupination?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  upperAnklePlantarFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestAnkleMsg = {
  __typename?: 'treatment_MobilityTestAnkleMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestAnkleMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestAnkleMeasurementMsg>;
};

export type Treatment_MobilityTestCervicalSpineBlock = {
  __typename?: 'treatment_MobilityTestCervicalSpineBlock';
  mobilityTestSpine?: Maybe<Treatment_MobilityTestSpineMsg>;
};

export type Treatment_MobilityTestElbowJointBlock = {
  __typename?: 'treatment_MobilityTestElbowJointBlock';
  left?: Maybe<Treatment_MobilityTestElbowJointMsg>;
  right?: Maybe<Treatment_MobilityTestElbowJointMsg>;
};

export type Treatment_MobilityTestElbowJointMeasurementMsg = {
  __typename?: 'treatment_MobilityTestElbowJointMeasurementMsg';
  flexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  pronationSupinationForearm?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestElbowJointMsg = {
  __typename?: 'treatment_MobilityTestElbowJointMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestElbowJointMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestElbowJointMeasurementMsg>;
};

export type Treatment_MobilityTestFingerJointsBlock = {
  __typename?: 'treatment_MobilityTestFingerJointsBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_MobilityTestFingerJointsMsg>;
  right?: Maybe<Treatment_MobilityTestFingerJointsMsg>;
};

export type Treatment_MobilityTestFingerJointsMeasurementMsg = {
  __typename?: 'treatment_MobilityTestFingerJointsMeasurementMsg';
  fingerBasicJointsAdductionAbduction?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  fingerBasicJointsFlexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  fingerEndJointsFlexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  fingerMiddleJointsFlexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  thumbBasicJointFlexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointAdductionAbduction?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointFlexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  thumbSaddleJointInternalExternalRotation?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestFingerJointsMsg = {
  __typename?: 'treatment_MobilityTestFingerJointsMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestFingerJointsMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestFingerJointsMeasurementMsg>;
};

export type Treatment_MobilityTestHipJointBlock = {
  __typename?: 'treatment_MobilityTestHipJointBlock';
  left?: Maybe<Treatment_MobilityTestHipJointMsg>;
  right?: Maybe<Treatment_MobilityTestHipJointMsg>;
};

export type Treatment_MobilityTestHipJointMeasurementMsg = {
  __typename?: 'treatment_MobilityTestHipJointMeasurementMsg';
  adAbduction?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  flexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  internalExternalRotation?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestHipJointMsg = {
  __typename?: 'treatment_MobilityTestHipJointMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestHipJointMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestHipJointMeasurementMsg>;
};

export type Treatment_MobilityTestKneeBlock = {
  __typename?: 'treatment_MobilityTestKneeBlock';
  left?: Maybe<Treatment_MobilityTestKneeMsg>;
  right?: Maybe<Treatment_MobilityTestKneeMsg>;
};

export type Treatment_MobilityTestKneeMeasurementMsg = {
  __typename?: 'treatment_MobilityTestKneeMeasurementMsg';
  adAbductionKneeFlexed?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  adAbductionKneeStraight?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  flexionExtension?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  internalExternalRotationKneeFlexed?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  internalExternalRotationKneeStraight?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestKneeMsg = {
  __typename?: 'treatment_MobilityTestKneeMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestKneeMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestKneeMeasurementMsg>;
};

export type Treatment_MobilityTestLumbarSpineBlock = {
  __typename?: 'treatment_MobilityTestLumbarSpineBlock';
  mobilityTestSpine?: Maybe<Treatment_MobilityTestSpineMsg>;
};

export type Treatment_MobilityTestShoulderBlock = {
  __typename?: 'treatment_MobilityTestShoulderBlock';
  left?: Maybe<Treatment_MobilityTestShoulderMsg>;
  right?: Maybe<Treatment_MobilityTestShoulderMsg>;
};

export type Treatment_MobilityTestShoulderJointIsolatedBlock = {
  __typename?: 'treatment_MobilityTestShoulderJointIsolatedBlock';
  left?: Maybe<Treatment_MobilityTestShoulderJointIsolatedMsg>;
  right?: Maybe<Treatment_MobilityTestShoulderJointIsolatedMsg>;
};

export type Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg = {
  __typename?: 'treatment_MobilityTestShoulderJointIsolatedMeasurementMsg';
  adAbduction?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  anteRetroversion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  innerOuterRotation90Abducted?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  internalExternalRotationNeutralPosition?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestShoulderJointIsolatedMsg = {
  __typename?: 'treatment_MobilityTestShoulderJointIsolatedMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestShoulderJointIsolatedMeasurementMsg>;
};

export type Treatment_MobilityTestShoulderMeasurementMsg = {
  __typename?: 'treatment_MobilityTestShoulderMeasurementMsg';
  adAbduction?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  anteRetroversion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  internalExternalRotation?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestShoulderMsg = {
  __typename?: 'treatment_MobilityTestShoulderMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestShoulderMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestShoulderMeasurementMsg>;
};

export type Treatment_MobilityTestSpineMeasurementMsg = {
  __typename?: 'treatment_MobilityTestSpineMeasurementMsg';
  id?: Maybe<Scalars['String']>;
  inclinationReclination?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  lateralFlexionLeftRight?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  rotationLeftRight?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestSpineMsg = {
  __typename?: 'treatment_MobilityTestSpineMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestSpineMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestSpineMeasurementMsg>;
};

export type Treatment_MobilityTestThoracicSpineBlock = {
  __typename?: 'treatment_MobilityTestThoracicSpineBlock';
  mobilityTestSpine?: Maybe<Treatment_MobilityTestSpineMsg>;
};

export type Treatment_MobilityTestToeJointsBlock = {
  __typename?: 'treatment_MobilityTestToeJointsBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_MobilityTestToeJointsMsg>;
  right?: Maybe<Treatment_MobilityTestToeJointsMsg>;
};

export type Treatment_MobilityTestToeJointsMeasurementMsg = {
  __typename?: 'treatment_MobilityTestToeJointsMeasurementMsg';
  basicToeJointsFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  endToeJointsPlantarFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  id?: Maybe<Scalars['String']>;
  middleToeJointsPlantarFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

export type Treatment_MobilityTestToeJointsMsg = {
  __typename?: 'treatment_MobilityTestToeJointsMsg';
  activeMeasurement?: Maybe<Treatment_MobilityTestToeJointsMeasurementMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passiveMeasurement?: Maybe<Treatment_MobilityTestToeJointsMeasurementMsg>;
};

export type Treatment_MobilityTestWristBlock = {
  __typename?: 'treatment_MobilityTestWristBlock';
  left?: Maybe<Treatment_MobilityTestWristMsg>;
  right?: Maybe<Treatment_MobilityTestWristMsg>;
};

export type Treatment_MobilityTestWristMsg = {
  __typename?: 'treatment_MobilityTestWristMsg';
  activePalmarFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
  enterPassiveMeasurements?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  passivePalmarFlexionDorsiflexion?: Maybe<Treatment_AbnormalityAngleAndTextMsg>;
};

/** Montreal Coginitive Assessment */
export type Treatment_MocaTestBlock = {
  __typename?: 'treatment_MocaTestBlock';
  completed?: Maybe<Scalars['Boolean']>;
  connectionOfLettersAndNumbers?: Maybe<Treatment_ConnectionOfLettersAndNumbers>;
  copyingThreeDimensionalCube?: Maybe<Treatment_CopyingThreeDimensionalCube>;
  listingWords?: Maybe<Treatment_ListingWords>;
  namingAnimalList?: Maybe<Array<Maybe<Treatment_NamingAnimal>>>;
  orientationList?: Maybe<Array<Maybe<Treatment_Orientation>>>;
  recallingWordList?: Maybe<Array<Maybe<Treatment_RecallingWord>>>;
  recognizingFeatures?: Maybe<Treatment_RecognizingFeatures>;
  repetitionOfNumbersInDictatedOrder?: Maybe<Treatment_RepetitionOfNumbersInDictatedOrder>;
  repetitionOfNumbersInReversedOrder?: Maybe<Treatment_RepetitionOfNumbersInReversedOrder>;
  repetitionOfSentences?: Maybe<Treatment_RepetitionOfSentences>;
  /** automatic computation of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  seriesOfLetters?: Maybe<Treatment_SeriesOfLetters>;
  subtraction?: Maybe<Treatment_Subtraction>;
};

/** Modified Katz Activities of Daily Living (ADL) Scale */
export type Treatment_ModifiedKatzAdlBlock = {
  __typename?: 'treatment_ModifiedKatzAdlBlock';
  bathing?: Maybe<Treatment_ModifiedKatzAdlSelection>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  continence?: Maybe<Treatment_ModifiedKatzAdlSelection>;
  dressing?: Maybe<Treatment_ModifiedKatzAdlSelection>;
  eating?: Maybe<Treatment_ModifiedKatzAdlSelection>;
  score?: Maybe<Scalars['Int']>;
  toileting?: Maybe<Treatment_ModifiedKatzAdlSelection>;
  transferring?: Maybe<Treatment_ModifiedKatzAdlSelection>;
};

export enum Treatment_ModifiedKatzAdlSelection {
  /** dependent (0) */
  ModifiedKatzAdlSelectionDependent = 'MODIFIED_KATZ_ADL_SELECTION_DEPENDENT',
  /** independent (1) */
  ModifiedKatzAdlSelectionIndependent = 'MODIFIED_KATZ_ADL_SELECTION_INDEPENDENT',
  ModifiedKatzAdlSelectionNone = 'MODIFIED_KATZ_ADL_SELECTION_NONE'
}

export enum Treatment_ModifiedNortonActivity {
  ModifiedNortonActivityNeedsBedridden = 'MODIFIED_NORTON_ACTIVITY_NEEDS_BEDRIDDEN',
  ModifiedNortonActivityNeedsWheelchair = 'MODIFIED_NORTON_ACTIVITY_NEEDS_WHEELCHAIR',
  ModifiedNortonActivityNone = 'MODIFIED_NORTON_ACTIVITY_NONE',
  ModifiedNortonActivityWalksUnassisted = 'MODIFIED_NORTON_ACTIVITY_WALKS_UNASSISTED',
  ModifiedNortonActivityWalksWithAssistance = 'MODIFIED_NORTON_ACTIVITY_WALKS_WITH_ASSISTANCE'
}

export enum Treatment_ModifiedNortonMobility {
  ModifiedNortonMobilityCompletelyLimited = 'MODIFIED_NORTON_MOBILITY_COMPLETELY_LIMITED',
  ModifiedNortonMobilityFullMobility = 'MODIFIED_NORTON_MOBILITY_FULL_MOBILITY',
  ModifiedNortonMobilityNone = 'MODIFIED_NORTON_MOBILITY_NONE',
  ModifiedNortonMobilitySlightlyLimited = 'MODIFIED_NORTON_MOBILITY_SLIGHTLY_LIMITED',
  ModifiedNortonMobilityVeryLimited = 'MODIFIED_NORTON_MOBILITY_VERY_LIMITED'
}

export type Treatment_ModifiedNortonScaleBlock = {
  __typename?: 'treatment_ModifiedNortonScaleBlock';
  additionalDiseases?: Maybe<Treatment_AdditionalDiseases>;
  age?: Maybe<Treatment_Age>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  incontinence?: Maybe<Treatment_Incontinence>;
  mentalState?: Maybe<Treatment_MentalState>;
  modifiedNortonActivity?: Maybe<Treatment_ModifiedNortonActivity>;
  modifiedNortonMobility?: Maybe<Treatment_ModifiedNortonMobility>;
  physicalCondition?: Maybe<Treatment_PhysicalCondition>;
  score?: Maybe<Scalars['Int']>;
  skinCondition?: Maybe<Treatment_SkinCondition>;
  willingnessToCooperate?: Maybe<Treatment_MnsWillingnessToCooperate>;
};

export enum Treatment_Moisture {
  MoistureConstantly = 'MOISTURE_CONSTANTLY',
  MoistureNone = 'MOISTURE_NONE',
  MoistureOccasionally = 'MOISTURE_OCCASIONALLY',
  MoistureOften = 'MOISTURE_OFTEN',
  MoistureRarely = 'MOISTURE_RARELY'
}

export type Treatment_MonosynapticReflexMsg = {
  __typename?: 'treatment_MonosynapticReflexMsg';
  forceAsymmetry?: Maybe<Treatment_ForceAsymmetry>;
  id?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_ReflexStatus>;
  right?: Maybe<Treatment_ReflexStatus>;
};

export type Treatment_MonosynapticReflexesBlock = {
  __typename?: 'treatment_MonosynapticReflexesBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  reflexes?: Maybe<Treatment_MonosynapticReflexesGroupMsg>;
};

export type Treatment_MonosynapticReflexesGroupMsg = {
  __typename?: 'treatment_MonosynapticReflexesGroupMsg';
  achillesTendonReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  adductorReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  bicepsTendonReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  brachioradialisReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  id?: Maybe<Scalars['String']>;
  masseterReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  patellarTendonReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  pronatorReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  tibialisPosteriorReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  tricepsTendonReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
  troemnerReflex?: Maybe<Treatment_MonosynapticReflexMsg>;
};

export type Treatment_MoodAndPsycheBlock = {
  __typename?: 'treatment_MoodAndPsycheBlock';
  moodAndPsyche?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_MotorAspectsOfDailyLivingMsg = {
  __typename?: 'treatment_MotorAspectsOfDailyLivingMsg';
  chewingAndSwallowing?: Maybe<Treatment_UpdrsSelection>;
  dressing?: Maybe<Treatment_UpdrsSelection>;
  eatingTasks?: Maybe<Treatment_UpdrsSelection>;
  freezing?: Maybe<Treatment_UpdrsSelection>;
  gettingOutOfBed?: Maybe<Treatment_UpdrsSelection>;
  handwriting?: Maybe<Treatment_UpdrsSelection>;
  hobbiesAndActivities?: Maybe<Treatment_UpdrsSelection>;
  hygiene?: Maybe<Treatment_UpdrsSelection>;
  salivaAndDrooling?: Maybe<Treatment_UpdrsSelection>;
  speech?: Maybe<Treatment_UpdrsSelection>;
  tremor?: Maybe<Treatment_UpdrsSelection>;
  turningInBed?: Maybe<Treatment_UpdrsSelection>;
  walkingAndBalance?: Maybe<Treatment_UpdrsSelection>;
};

export type Treatment_MotorComplicationsMsg = {
  __typename?: 'treatment_MotorComplicationsMsg';
  complexityOfMotorFluctuation?: Maybe<Treatment_UpdrsSelection>;
  functionalImpactOfDyskinesias?: Maybe<Treatment_UpdrsSelection>;
  functionalImpactOfFluctuations?: Maybe<Treatment_UpdrsSelection>;
  painfulOffStateDystonia?: Maybe<Treatment_UpdrsSelection>;
  timeSpentInTheOffState?: Maybe<Treatment_UpdrsSelection>;
  timeSpentWithDyskinesias?: Maybe<Treatment_UpdrsSelection>;
};

export type Treatment_MotorExaminationMsg = {
  __typename?: 'treatment_MotorExaminationMsg';
  arisingFromChair?: Maybe<Treatment_UpdrsSelection>;
  constancyOfRestTremor?: Maybe<Treatment_UpdrsSelection>;
  facialExpression?: Maybe<Treatment_UpdrsSelection>;
  fingerTappingLeftHand?: Maybe<Treatment_UpdrsSelection>;
  fingerTappingRightHand?: Maybe<Treatment_UpdrsSelection>;
  freezingOfGait?: Maybe<Treatment_UpdrsSelection>;
  gait?: Maybe<Treatment_UpdrsSelection>;
  globalSpontaneityOfMovement?: Maybe<Treatment_UpdrsSelection>;
  handMovementsLeftHand?: Maybe<Treatment_UpdrsSelection>;
  handMovementsRightHand?: Maybe<Treatment_UpdrsSelection>;
  /** <Asymptomatic (0) / Unilateral involvement only (1) /Bilateral involvement without impairment of balance (2) / Mild to moderate involvement (3) /Severe disability; still able to walk or stand unassisted (4) /Wheelchair bound or bedridden unless aided (5)> */
  hoehnAndYahrStage?: Maybe<Treatment_HoehnAndYahrStage>;
  /** Is the patient on levodopa?: <yes/no> */
  isPatientOnLevodopa?: Maybe<Scalars['Boolean']>;
  /** Is the patient on medication?: <yes/no> */
  isPatientOnMedication?: Maybe<Scalars['Boolean']>;
  kineticTremorLeftHand?: Maybe<Treatment_UpdrsSelection>;
  kineticTremorRightHand?: Maybe<Treatment_UpdrsSelection>;
  legAbilityLeftLeg?: Maybe<Treatment_UpdrsSelection>;
  legAbilityRightLeg?: Maybe<Treatment_UpdrsSelection>;
  /** minutes since last dose: <numeric input> (non-negative integers, no decimals, unit: minutes) */
  minutesSinceLastDose?: Maybe<Scalars['Int']>;
  /** Did these movements interfere with ratings?: <yes/no> */
  movementsInterfereWithRatings?: Maybe<Scalars['Boolean']>;
  /** Patient's clinical state: <on/off> */
  patientClinicalState?: Maybe<Treatment_PatientClinicalState>;
  posturalStability?: Maybe<Treatment_UpdrsSelection>;
  posturalTremorLeftHand?: Maybe<Treatment_UpdrsSelection>;
  posturalTremorRightHand?: Maybe<Treatment_UpdrsSelection>;
  postureCheck?: Maybe<Treatment_UpdrsSelection>;
  pronationSupinationMovementsLeftHand?: Maybe<Treatment_UpdrsSelection>;
  pronationSupinationMovementsRightHand?: Maybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLipJaw?: Maybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLle?: Maybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeLue?: Maybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeRle?: Maybe<Treatment_UpdrsSelection>;
  restTremorAmplitudeRue?: Maybe<Treatment_UpdrsSelection>;
  rigidityLle?: Maybe<Treatment_UpdrsSelection>;
  rigidityLue?: Maybe<Treatment_UpdrsSelection>;
  rigidityNeck?: Maybe<Treatment_UpdrsSelection>;
  rigidityRle?: Maybe<Treatment_UpdrsSelection>;
  rigidityRue?: Maybe<Treatment_UpdrsSelection>;
  speech?: Maybe<Treatment_UpdrsSelection>;
  toeTappingLeftFoot?: Maybe<Treatment_UpdrsSelection>;
  toeTappingRightFoot?: Maybe<Treatment_UpdrsSelection>;
  /** Were dyskinesias present?: <yes/no> */
  wereDyskinesiasPreset?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_MotorFunctionArmTestResult {
  MotorFunctionArmTestActiveLifting = 'MOTOR_FUNCTION_ARM_TEST_ACTIVE_LIFTING',
  MotorFunctionArmTestAmputation = 'MOTOR_FUNCTION_ARM_TEST_AMPUTATION',
  MotorFunctionArmTestComa = 'MOTOR_FUNCTION_ARM_TEST_COMA',
  MotorFunctionArmTestDescent_10Seconds = 'MOTOR_FUNCTION_ARM_TEST_DESCENT_10_SECONDS',
  MotorFunctionArmTestNone = 'MOTOR_FUNCTION_ARM_TEST_NONE',
  MotorFunctionArmTestNoActiveLifting = 'MOTOR_FUNCTION_ARM_TEST_NO_ACTIVE_LIFTING',
  MotorFunctionArmTestNoDescent = 'MOTOR_FUNCTION_ARM_TEST_NO_DESCENT',
  MotorFunctionArmTestNoMovement = 'MOTOR_FUNCTION_ARM_TEST_NO_MOVEMENT'
}

export enum Treatment_MotorFunctionLegTestResult {
  MotorFunctionLegTestActiveLifting = 'MOTOR_FUNCTION_LEG_TEST_ACTIVE_LIFTING',
  MotorFunctionLegTestAmputation = 'MOTOR_FUNCTION_LEG_TEST_AMPUTATION',
  MotorFunctionLegTestComa = 'MOTOR_FUNCTION_LEG_TEST_COMA',
  MotorFunctionLegTestDescent_5Seconds = 'MOTOR_FUNCTION_LEG_TEST_DESCENT_5_SECONDS',
  MotorFunctionLegTestNone = 'MOTOR_FUNCTION_LEG_TEST_NONE',
  MotorFunctionLegTestNoActiveLifting = 'MOTOR_FUNCTION_LEG_TEST_NO_ACTIVE_LIFTING',
  MotorFunctionLegTestNoDescent = 'MOTOR_FUNCTION_LEG_TEST_NO_DESCENT',
  MotorFunctionLegTestNoMovement = 'MOTOR_FUNCTION_LEG_TEST_NO_MOVEMENT'
}

export enum Treatment_MotorResponseType {
  MotorResponseAbnormalFlexionPainfulStimuli = 'MOTOR_RESPONSE_ABNORMAL_FLEXION_PAINFUL_STIMULI',
  MotorResponseExtensionPainfulStimuli = 'MOTOR_RESPONSE_EXTENSION_PAINFUL_STIMULI',
  MotorResponseFlexionPainfulStimuli = 'MOTOR_RESPONSE_FLEXION_PAINFUL_STIMULI',
  MotorResponseLocalizesPainfulStimuli = 'MOTOR_RESPONSE_LOCALIZES_PAINFUL_STIMULI',
  MotorResponseNone = 'MOTOR_RESPONSE_NONE',
  MotorResponseNoMovement = 'MOTOR_RESPONSE_NO_MOVEMENT',
  MotorResponseObeysCommands = 'MOTOR_RESPONSE_OBEYS_COMMANDS'
}

export type Treatment_MouthAndThroatAndLarynxInspectionBlock = {
  __typename?: 'treatment_MouthAndThroatAndLarynxInspectionBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  mouthOpening?: Maybe<Treatment_MouthOpeningMsg>;
  oralMucosa?: Maybe<Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  oropharynx?: Maybe<Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  ostiaOfTheExcretoryDuctsOfSalivaryGlands?: Maybe<Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  thyreomentalDistance?: Maybe<Treatment_ThyreomentalDistanceMsg>;
  tonsillaePalatinae?: Maybe<Treatment_MouthAndThroatAndLarynxPartExaminationMsg>;
  toothStatus?: Maybe<Treatment_ToothStatusMsg>;
};

export type Treatment_MouthAndThroatAndLarynxPartExaminationMsg = {
  __typename?: 'treatment_MouthAndThroatAndLarynxPartExaminationMsg';
  abnormalities?: Maybe<Array<Maybe<Treatment_PhysicalAbnormalityMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export enum Treatment_MouthOpeningAbnormality {
  MouthOpeningAbnormalityImpossible = 'MOUTH_OPENING_ABNORMALITY_IMPOSSIBLE',
  MouthOpeningAbnormalityLimited = 'MOUTH_OPENING_ABNORMALITY_LIMITED',
  MouthOpeningAbnormalityNone = 'MOUTH_OPENING_ABNORMALITY_NONE'
}

export type Treatment_MouthOpeningMsg = {
  __typename?: 'treatment_MouthOpeningMsg';
  abnormality?: Maybe<Treatment_MouthOpeningAbnormality>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mouthOpeningExaminationResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_MrsBlock = {
  __typename?: 'treatment_MrsBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  scale?: Maybe<Treatment_MrsScaleSelection>;
};

export enum Treatment_MrsScaleSelection {
  /** 6-Death following a stroke */
  MrsScaleSelectionDeathFollowingAStroke = 'MRS_SCALE_SELECTION_DEATH_FOLLOWING_A_STROKE',
  /** 4-Moderately severe disability */
  MrsScaleSelectionModeratelySevereDisability = 'MRS_SCALE_SELECTION_MODERATELY_SEVERE_DISABILITY',
  /** 3-Moderate disability */
  MrsScaleSelectionModerateDisability = 'MRS_SCALE_SELECTION_MODERATE_DISABILITY',
  MrsScaleSelectionNone = 'MRS_SCALE_SELECTION_NONE',
  /** 1-No significant disability */
  MrsScaleSelectionNoSignificantDisability = 'MRS_SCALE_SELECTION_NO_SIGNIFICANT_DISABILITY',
  /** 0-No symptoms */
  MrsScaleSelectionNoSymptoms = 'MRS_SCALE_SELECTION_NO_SYMPTOMS',
  /** 5-Severe disability */
  MrsScaleSelectionSevereDisability = 'MRS_SCALE_SELECTION_SEVERE_DISABILITY',
  /** 2-Slight disability */
  MrsScaleSelectionSlightlyDisability = 'MRS_SCALE_SELECTION_SLIGHTLY_DISABILITY'
}

export type Treatment_MuscleToneBlock = {
  __typename?: 'treatment_MuscleToneBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  muscleTone?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export enum Treatment_MyocloniasEpilepticSeizuresSelection {
  /** epileptic seizure (7) */
  MyocloniasEpilepticSeizuresSelectionEpilepticSeizures = 'MYOCLONIAS_EPILEPTIC_SEIZURES_SELECTION_EPILEPTIC_SEIZURES',
  /** myoclonias (1) */
  MyocloniasEpilepticSeizuresSelectionMyoclonias = 'MYOCLONIAS_EPILEPTIC_SEIZURES_SELECTION_MYOCLONIAS',
  MyocloniasEpilepticSeizuresSelectionNone = 'MYOCLONIAS_EPILEPTIC_SEIZURES_SELECTION_NONE',
  /** none (0) */
  MyocloniasEpilepticSeizuresSelectionNotAtAll = 'MYOCLONIAS_EPILEPTIC_SEIZURES_SELECTION_NOT_AT_ALL'
}

export enum Treatment_NyhaClassification {
  NyhaNone = 'NYHA_NONE',
  NyhaStadium_1 = 'NYHA_STADIUM_1',
  NyhaStadium_2 = 'NYHA_STADIUM_2',
  NyhaStadium_3 = 'NYHA_STADIUM_3',
  NyhaStadium_4 = 'NYHA_STADIUM_4'
}

export type Treatment_NailChangeExaminationBlock = {
  __typename?: 'treatment_NailChangeExaminationBlock';
  nailChanges?: Maybe<Array<Maybe<Treatment_NailChangeMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_NailChangeMsg = {
  __typename?: 'treatment_NailChangeMsg';
  dermatoscopicDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageSeriesId?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  macroscopicDescription?: Maybe<Scalars['String']>;
};

export type Treatment_NamedFluidFlowSystemMsg = {
  __typename?: 'treatment_NamedFluidFlowSystemMsg';
  name?: Maybe<Scalars['String']>;
};

export type Treatment_NamedProcedureMsg = {
  __typename?: 'treatment_NamedProcedureMsg';
  content?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Treatment_NamingAnimal {
  NamingAnimalsBear = 'NAMING_ANIMALS_BEAR',
  NamingAnimalsGiraffe = 'NAMING_ANIMALS_GIRAFFE',
  NamingAnimalsHippo = 'NAMING_ANIMALS_HIPPO',
  NamingAnimalsNone = 'NAMING_ANIMALS_NONE'
}

export enum Treatment_NarcoticApplication {
  NarcoticApplicationMultipleTimes = 'NARCOTIC_APPLICATION_MULTIPLE_TIMES',
  NarcoticApplicationNone = 'NARCOTIC_APPLICATION_NONE',
  NarcoticApplicationOneTime = 'NARCOTIC_APPLICATION_ONE_TIME'
}

export type Treatment_NasalCavityConspicuousnessEntryMsg = {
  __typename?: 'treatment_NasalCavityConspicuousnessEntryMsg';
  combined?: Maybe<Treatment_NasalCavityConspicuousnessMsg>;
  documentationMode?: Maybe<Treatment_LateralityDocumentationMode>;
  id?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_NasalCavityConspicuousnessMsg>;
  right?: Maybe<Treatment_NasalCavityConspicuousnessMsg>;
};

export type Treatment_NasalCavityConspicuousnessMsg = {
  __typename?: 'treatment_NasalCavityConspicuousnessMsg';
  conspicuousness?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_NasalCavityMsg = {
  __typename?: 'treatment_NasalCavityMsg';
  conspicuousnesses?: Maybe<Array<Maybe<Treatment_NasalCavityConspicuousnessEntryMsg>>>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_NasalVestibuleMsg = {
  __typename?: 'treatment_NasalVestibuleMsg';
  furtherDetailsCombined?: Maybe<Scalars['String']>;
  furtherDetailsLeft?: Maybe<Scalars['String']>;
  furtherDetailsRight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export enum Treatment_Nausea {
  NauseaMinor = 'NAUSEA_MINOR',
  NauseaModerate = 'NAUSEA_MODERATE',
  NauseaNone = 'NAUSEA_NONE',
  NauseaSevere = 'NAUSEA_SEVERE'
}

export type Treatment_NeckAndShoulderMotorSkillsBlock = {
  __typename?: 'treatment_NeckAndShoulderMotorSkillsBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  headRotation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  headRotationText?: Maybe<Scalars['String']>;
  neckAndShoulderMotorSkills?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  shoulderRotation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  shoulderRotationText?: Maybe<Scalars['String']>;
};

export type Treatment_NeglectDescriptionMsg = {
  __typename?: 'treatment_NeglectDescriptionMsg';
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_NeglectTestResult {
  NeglectTestComa = 'NEGLECT_TEST_COMA',
  NeglectTestMultipleModalities = 'NEGLECT_TEST_MULTIPLE_MODALITIES',
  NeglectTestNone = 'NEGLECT_TEST_NONE',
  NeglectTestNothing = 'NEGLECT_TEST_NOTHING',
  NeglectTestNotAssessable = 'NEGLECT_TEST_NOT_ASSESSABLE',
  NeglectTestOneModality = 'NEGLECT_TEST_ONE_MODALITY'
}

export type Treatment_NerveRootBlockMsg = {
  __typename?: 'treatment_NerveRootBlockMsg';
  cervicalSpine?: Maybe<Treatment_CervicalSpineMsg>;
  cervicalSpinePresent?: Maybe<Scalars['Boolean']>;
  imaging?: Maybe<Scalars['Boolean']>;
  lumbarSpine?: Maybe<Treatment_LumbarSpineMsg>;
  lumbarSpinePresent?: Maybe<Scalars['Boolean']>;
  others?: Maybe<Scalars['String']>;
  othersPresent?: Maybe<Scalars['Boolean']>;
  thoracicSpine?: Maybe<Treatment_ThoracicSpineMsg>;
  thoracicSpinePresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_NerveStretchSignsBlock = {
  __typename?: 'treatment_NerveStretchSignsBlock';
  brudzinskiSign?: Maybe<Scalars['Boolean']>;
  brudzinskiSignText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_NerveStretchSignsMsg>;
  lhermittSign?: Maybe<Scalars['Boolean']>;
  lhermittSignText?: Maybe<Scalars['String']>;
  meningismusSign?: Maybe<Scalars['Boolean']>;
  meningismusSignText?: Maybe<Scalars['String']>;
  right?: Maybe<Treatment_NerveStretchSignsMsg>;
};

export type Treatment_NerveStretchSignsMsg = {
  __typename?: 'treatment_NerveStretchSignsMsg';
  bragardSign?: Maybe<Scalars['Boolean']>;
  bragardSignText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kernigSign?: Maybe<Scalars['Boolean']>;
  kernigSignText?: Maybe<Scalars['String']>;
  lasegueSign?: Maybe<Scalars['Boolean']>;
  lasegueSignText?: Maybe<Scalars['String']>;
  pseudolasequeSign?: Maybe<Scalars['Boolean']>;
  pseudolasequeSignText?: Maybe<Scalars['String']>;
  reversedLasequeSign?: Maybe<Scalars['Boolean']>;
  reversedLasequeSignText?: Maybe<Scalars['String']>;
};

export type Treatment_NeuraxialAnesthesiaMsg = {
  __typename?: 'treatment_NeuraxialAnesthesiaMsg';
  /** one decimal; unit: cm */
  catheterInEpiduralSpace?: Maybe<Scalars['Float']>;
  cerebrospinalFluid?: Maybe<Core_KnowledgeInputMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** one decimal; unit: cm */
  lossOfResistance?: Maybe<Scalars['Float']>;
  punctureLocation?: Maybe<Core_KnowledgeInputMsg>;
  punctures?: Maybe<Scalars['Int']>;
  /** one decimal; unit: cm */
  skinLevel?: Maybe<Scalars['Float']>;
  /** one decimal; unit: cm */
  tunnel?: Maybe<Scalars['Float']>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_NeurologicalExaminationMsg = {
  __typename?: 'treatment_NeurologicalExaminationMsg';
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_NeuropsychologicalProblems {
  /** mild dementia (1) */
  NeuropsychologicalProblemsMildDementia = 'NEUROPSYCHOLOGICAL_PROBLEMS_MILD_DEMENTIA',
  NeuropsychologicalProblemsNone = 'NEUROPSYCHOLOGICAL_PROBLEMS_NONE',
  /** no psychological problems (2) */
  NeuropsychologicalProblemsNoProblems = 'NEUROPSYCHOLOGICAL_PROBLEMS_NO_PROBLEMS',
  /** severe dementia or depression (0) */
  NeuropsychologicalProblemsSevereDementiaOrDepression = 'NEUROPSYCHOLOGICAL_PROBLEMS_SEVERE_DEMENTIA_OR_DEPRESSION'
}

export type Treatment_NicotineBlock = {
  __typename?: 'treatment_NicotineBlock';
  calculatedPackYears?: Maybe<Scalars['Int']>;
  consumptionPresent?: Maybe<Scalars['Boolean']>;
  currentConsumption?: Maybe<Scalars['Boolean']>;
  nicotineConsumptions?: Maybe<Array<Maybe<Treatment_NicotineMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_NicotineMsg = {
  __typename?: 'treatment_NicotineMsg';
  consumptionDuration?: Maybe<Scalars['Int']>;
  consumptionDurationReference?: Maybe<Treatment_ConsumptionDurationReference>;
  currentConsumption?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyReference?: Maybe<Treatment_ConsumptionFrequencyReference>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tobaccoUse?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_NightSweatsBlock = {
  __typename?: 'treatment_NightSweatsBlock';
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_NightSweatsResolution>;
  furtherDetails?: Maybe<Scalars['String']>;
  nightlyPajamaChanges?: Maybe<Scalars['Int']>;
  pajamaChangePresent?: Maybe<Scalars['Boolean']>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_NightSweatsResolution {
  NightSweatsResolutionMonth = 'NIGHT_SWEATS_RESOLUTION_MONTH',
  NightSweatsResolutionNone = 'NIGHT_SWEATS_RESOLUTION_NONE',
  NightSweatsResolutionWeek = 'NIGHT_SWEATS_RESOLUTION_WEEK',
  NightSweatsResolutionYear = 'NIGHT_SWEATS_RESOLUTION_YEAR'
}

export type Treatment_NihssBlock = {
  __typename?: 'treatment_NihssBlock';
  dysarthria?: Maybe<Treatment_DysarthriaTestResult>;
  dysarthriaText?: Maybe<Scalars['String']>;
  extremitiesAtaxia?: Maybe<Treatment_ExtremitiesAtaxiaTestResult>;
  extremitiesAtaxiaText?: Maybe<Scalars['String']>;
  facialNerveParesis?: Maybe<Treatment_FacialNerveParesisTestResult>;
  facialNerveParesisText?: Maybe<Scalars['String']>;
  followingInstructions?: Maybe<Treatment_FollowingInstructionsTestResult>;
  followingInstructionsText?: Maybe<Scalars['String']>;
  language?: Maybe<Treatment_LanguageTestResult>;
  languageText?: Maybe<Scalars['String']>;
  motorFunctionLeftArm?: Maybe<Treatment_MotorFunctionArmTestResult>;
  motorFunctionLeftArmText?: Maybe<Scalars['String']>;
  motorFunctionLeftLeg?: Maybe<Treatment_MotorFunctionLegTestResult>;
  motorFunctionLeftLegText?: Maybe<Scalars['String']>;
  motorFunctionRightArm?: Maybe<Treatment_MotorFunctionArmTestResult>;
  motorFunctionRightArmText?: Maybe<Scalars['String']>;
  motorFunctionRightLeg?: Maybe<Treatment_MotorFunctionLegTestResult>;
  motorFunctionRightLegText?: Maybe<Scalars['String']>;
  neglect?: Maybe<Treatment_NeglectTestResult>;
  neglectText?: Maybe<Scalars['String']>;
  oculomotorFunction?: Maybe<Treatment_OculomotorFunctionTestResult>;
  oculomotorFunctionText?: Maybe<Scalars['String']>;
  orientation?: Maybe<Treatment_OrientationTestResult>;
  orientationText?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  sensitivity?: Maybe<Treatment_SensitivityTestResult>;
  sensitivityText?: Maybe<Scalars['String']>;
  vigilance?: Maybe<Treatment_NihssVigilanceType>;
  vigilanceText?: Maybe<Scalars['String']>;
  visualField?: Maybe<Treatment_VisualFieldTestResult>;
  visualFieldText?: Maybe<Scalars['String']>;
};

export enum Treatment_NihssVigilanceType {
  NihssVigilanceTypeAwake = 'NIHSS_VIGILANCE_TYPE_AWAKE',
  NihssVigilanceTypeComatose = 'NIHSS_VIGILANCE_TYPE_COMATOSE',
  NihssVigilanceTypeLightHeaded = 'NIHSS_VIGILANCE_TYPE_LIGHT_HEADED',
  NihssVigilanceTypeNone = 'NIHSS_VIGILANCE_TYPE_NONE',
  NihssVigilanceTypeSomnolent = 'NIHSS_VIGILANCE_TYPE_SOMNOLENT'
}

export type Treatment_NikolausSocialQuestionnaireBlock = {
  __typename?: 'treatment_NikolausSocialQuestionnaireBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  economicCircumstances?: Maybe<Treatment_EconomicCircumstancesMsg>;
  housingSituation?: Maybe<Treatment_HousingSituationMsg>;
  score?: Maybe<Scalars['Int']>;
  socialActivities?: Maybe<Treatment_SocialActivitiesMsg>;
  socialContactsAndSupport?: Maybe<Treatment_SocialContactsAndSupportMsg>;
};

export type Treatment_NonInvasiveVentilationBlock = {
  __typename?: 'treatment_NonInvasiveVentilationBlock';
  causes?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  durationOfTherapyPerDay?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  oxygenFlowRate?: Maybe<Scalars['Int']>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_NonMotorAspectsOfDailyLivingMsg = {
  __typename?: 'treatment_NonMotorAspectsOfDailyLivingMsg';
  anxiousMood?: Maybe<Treatment_UpdrsSelection>;
  apathy?: Maybe<Treatment_UpdrsSelection>;
  cognitiveImpairment?: Maybe<Treatment_UpdrsSelection>;
  constipationProblems?: Maybe<Treatment_UpdrsSelection>;
  daytimeSleepiness?: Maybe<Treatment_UpdrsSelection>;
  depressedMood?: Maybe<Treatment_UpdrsSelection>;
  fatigue?: Maybe<Treatment_UpdrsSelection>;
  featuresOfDss?: Maybe<Treatment_UpdrsSelection>;
  hallucinationsAndPsychosis?: Maybe<Treatment_UpdrsSelection>;
  lightHeadednessOnStanding?: Maybe<Treatment_UpdrsSelection>;
  painAndOtherSensations?: Maybe<Treatment_UpdrsSelection>;
  sleepProblems?: Maybe<Treatment_UpdrsSelection>;
  /** <patient / caregiver / both> */
  sourceOfInformation?: Maybe<Treatment_SourceOfInformation>;
  urinaryProblems?: Maybe<Treatment_UpdrsSelection>;
  /** <patient / caregiver / both> */
  whoIsFillingOutQuestionnaire?: Maybe<Treatment_SourceOfInformation>;
};

export type Treatment_NoseExaminationMsg = {
  __typename?: 'treatment_NoseExaminationMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_NoseInspectionBlock = {
  __typename?: 'treatment_NoseInspectionBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  innerNose?: Maybe<Treatment_InnerNoseMsg>;
  midFace?: Maybe<Treatment_NoseExaminationMsg>;
  nasopharynx?: Maybe<Treatment_NoseExaminationMsg>;
  outerNose?: Maybe<Treatment_NoseExaminationMsg>;
};

export type Treatment_NosePalpationBlock = {
  __typename?: 'treatment_NosePalpationBlock';
  frontalSinus?: Maybe<Treatment_SinusPalpationMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  maxillarySinus?: Maybe<Treatment_SinusPalpationMsg>;
};

export enum Treatment_NrsSelection {
  /** Mild (1) */
  NrsSelectionMild = 'NRS_SELECTION_MILD',
  /** Moderate (2) */
  NrsSelectionModerate = 'NRS_SELECTION_MODERATE',
  NrsSelectionNone = 'NRS_SELECTION_NONE',
  /** None (0) */
  NrsSelectionNotAtAll = 'NRS_SELECTION_NOT_AT_ALL',
  /** Severe (3) */
  NrsSelectionSevere = 'NRS_SELECTION_SEVERE'
}

export type Treatment_NuDescBlock = {
  __typename?: 'treatment_NuDescBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  disorientation?: Maybe<Treatment_NuDescSelection>;
  illusions?: Maybe<Treatment_NuDescSelection>;
  inappropriateBehavior?: Maybe<Treatment_NuDescSelection>;
  inappropriateCommunication?: Maybe<Treatment_NuDescSelection>;
  psychomotoricRetardation?: Maybe<Treatment_NuDescSelection>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_NuDescSelection {
  /** absent (0) */
  NuDescSelectionAbsent = 'NU_DESC_SELECTION_ABSENT',
  NuDescSelectionNone = 'NU_DESC_SELECTION_NONE',
  /** present (1) */
  NuDescSelectionPresent = 'NU_DESC_SELECTION_PRESENT',
  /** present to a great extent (2) */
  NuDescSelectionPresentToGreatExtent = 'NU_DESC_SELECTION_PRESENT_TO_GREAT_EXTENT'
}

export enum Treatment_Nudged {
  NudgedDoesNotFallOver = 'NUDGED_DOES_NOT_FALL_OVER',
  NudgedNone = 'NUDGED_NONE',
  NudgedSafe = 'NUDGED_SAFE',
  NudgedWouldFallOverWithoutHelp = 'NUDGED_WOULD_FALL_OVER_WITHOUT_HELP'
}

export type Treatment_NumericPainRatingScaleBlock = {
  __typename?: 'treatment_NumericPainRatingScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  severitySlider?: Maybe<Treatment_SeveritySlider>;
};

export enum Treatment_Nutrition {
  NutritionAdequate = 'NUTRITION_ADEQUATE',
  NutritionExcellent = 'NUTRITION_EXCELLENT',
  NutritionNone = 'NUTRITION_NONE',
  NutritionProbablyInadequate = 'NUTRITION_PROBABLY_INADEQUATE',
  NutritionVeryPoor = 'NUTRITION_VERY_POOR'
}

export type Treatment_NutritionStatusBlock = {
  __typename?: 'treatment_NutritionStatusBlock';
  nutritionStatus?: Maybe<Treatment_NutritionStatusType>;
};

export enum Treatment_NutritionStatusType {
  NutritionStatusAdipositas = 'NUTRITION_STATUS_ADIPOSITAS',
  NutritionStatusCachexia = 'NUTRITION_STATUS_CACHEXIA',
  NutritionStatusNone = 'NUTRITION_STATUS_NONE',
  NutritionStatusNormal = 'NUTRITION_STATUS_NORMAL',
  NutritionStatusObesity = 'NUTRITION_STATUS_OBESITY',
  NutritionStatusReduced = 'NUTRITION_STATUS_REDUCED'
}

export type Treatment_NutritionalDisturbanceBlock = {
  __typename?: 'treatment_NutritionalDisturbanceBlock';
  bmi?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  hungerDescription?: Maybe<Scalars['String']>;
  hungerLevel?: Maybe<Treatment_Hunger>;
  mentalEatingDisorder?: Maybe<Treatment_MentalEatingDisorderMsg>;
  mentalEatingDisorderSuspected?: Maybe<Scalars['Boolean']>;
  nutritionForms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
  thirstDescription?: Maybe<Scalars['String']>;
  thirstLevel?: Maybe<Treatment_Thirst>;
};

export type Treatment_NutritionalRiskScreeningBlock = {
  __typename?: 'treatment_NutritionalRiskScreeningBlock';
  /** Age ≥ 70: */
  ageGreaterThan70?: Maybe<Scalars['Boolean']>;
  /** <20.5 kg/m2?: <yes/no> */
  bodyMassIndexBelow20Point5?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Has food intake been decreased in the past week?: <yes/no> */
  decreaseFoodIntakeInPastWeek?: Maybe<Scalars['Boolean']>;
  diseaseSeverity?: Maybe<Treatment_NrsSelection>;
  /**
   * if yes to any of the questions, then
   * 1) Nutritional status disorder: < None (0) / Mild (1) / Moderate (2) / Severe (3)> (singleselect)
   * 2) Disease severity: < None (0) / Mild (1) / Moderate (2) / Severe (3)> (singleselect)
   * 3) Age ≥ 70: <yes (1) /no (0)> (singleselect)
   */
  nutritionalStatusDisorder?: Maybe<Treatment_NrsSelection>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** Is the patient seriously ill? (e.g. intensive care): <yes/no> */
  seriouslyIll?: Maybe<Scalars['Boolean']>;
  /** Has the patient lost weight in the past 3 months?: <yes/no> */
  weightLossInPastThreeMonths?: Maybe<Scalars['Boolean']>;
};

export type Treatment_NyhaBlock = {
  __typename?: 'treatment_NyhaBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  nyhaStage?: Maybe<Treatment_NyhaStage>;
  score?: Maybe<Scalars['String']>;
};

export enum Treatment_NyhaStage {
  NyhaStageI = 'NYHA_STAGE_I',
  NyhaStageIi = 'NYHA_STAGE_II',
  NyhaStageIii = 'NYHA_STAGE_III',
  NyhaStageIv = 'NYHA_STAGE_IV',
  NyhaStageNone = 'NYHA_STAGE_NONE'
}

export type Treatment_NystagmusAssessmentMsg = {
  __typename?: 'treatment_NystagmusAssessmentMsg';
  assessmentText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_OpsInformationMsg = {
  __typename?: 'treatment_OPSInformationMsg';
  id?: Maybe<Scalars['String']>;
  opsCode?: Maybe<Scalars['String']>;
  opsVersion?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_Occupation {
  OccupationHazardousOccupationFop_1To_2Years = 'OCCUPATION_HAZARDOUS_OCCUPATION_FOP_1_TO_2_YEARS',
  OccupationHazardousOccupationFor_2To_10Years = 'OCCUPATION_HAZARDOUS_OCCUPATION_FOR_2_TO_10_YEARS',
  OccupationHazardousOccupationForMoreThan_10Years = 'OCCUPATION_HAZARDOUS_OCCUPATION_FOR_MORE_THAN_10_YEARS',
  OccupationNone = 'OCCUPATION_NONE',
  OccupationNoOccupationHazardousToLungs = 'OCCUPATION_NO_OCCUPATION_HAZARDOUS_TO_LUNGS'
}

export type Treatment_OccupationMsg = {
  __typename?: 'treatment_OccupationMsg';
  employmentTime?: Maybe<VeiosTimeFrameMsg>;
  id?: Maybe<Scalars['String']>;
  occupation?: Maybe<Core_KnowledgeInputMsg>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_OccupationSatisfactionType {
  OccupationSatisfactionHigh = 'OCCUPATION_SATISFACTION_HIGH',
  OccupationSatisfactionIntermediate = 'OCCUPATION_SATISFACTION_INTERMEDIATE',
  OccupationSatisfactionLow = 'OCCUPATION_SATISFACTION_LOW',
  OccupationSatisfactionNone = 'OCCUPATION_SATISFACTION_NONE',
  OccupationSatisfactionVeryHigh = 'OCCUPATION_SATISFACTION_VERY_HIGH',
  OccupationSatisfactionVeryLow = 'OCCUPATION_SATISFACTION_VERY_LOW'
}

export type Treatment_OccupationsBlock = {
  __typename?: 'treatment_OccupationsBlock';
  isCurrentlyEmployed?: Maybe<Scalars['Boolean']>;
  occupationSatisfaction?: Maybe<Treatment_OccupationSatisfactionType>;
  occupations?: Maybe<Array<Maybe<Treatment_OccupationMsg>>>;
  satisfactionText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  unemploymentText?: Maybe<Scalars['String']>;
  wasUnemployedBefore?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_OculomotorFunctionTestResult {
  OculomotorFunctionTestComa = 'OCULOMOTOR_FUNCTION_TEST_COMA',
  OculomotorFunctionTestCompleteGazeParesis = 'OCULOMOTOR_FUNCTION_TEST_COMPLETE_GAZE_PARESIS',
  OculomotorFunctionTestInsufficientCooperation = 'OCULOMOTOR_FUNCTION_TEST_INSUFFICIENT_COOPERATION',
  OculomotorFunctionTestNone = 'OCULOMOTOR_FUNCTION_TEST_NONE',
  OculomotorFunctionTestNormalFindings = 'OCULOMOTOR_FUNCTION_TEST_NORMAL_FINDINGS',
  OculomotorFunctionTestPartialGazeParesis = 'OCULOMOTOR_FUNCTION_TEST_PARTIAL_GAZE_PARESIS'
}

export type Treatment_OculomotorSkillsBlock = {
  __typename?: 'treatment_OculomotorSkillsBlock';
  convergenceReaction?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  convergenceReactionText?: Maybe<Scalars['String']>;
  eyeMovement?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  eyeMovementText?: Maybe<Scalars['String']>;
  fixationSuppressionOfTheVestibuloOcularReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fixationSuppressionOfTheVestibuloOcularReflexText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  inspectionBulbPosition?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  inspectionBulbPositionText?: Maybe<Scalars['String']>;
  lidElevation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lidElevationText?: Maybe<Scalars['String']>;
  oculomotorSkills?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pursuitTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pursuitTestText?: Maybe<Scalars['String']>;
  vestibuloOcularReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: Maybe<Scalars['String']>;
  voluntarySaccades?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  voluntarySaccadesText?: Maybe<Scalars['String']>;
};

export type Treatment_OlfactorySenseBlock = {
  __typename?: 'treatment_OlfactorySenseBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  olfactorySense?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_OpenTreatmentInfoMsg = {
  __typename?: 'treatment_OpenTreatmentInfoMsg';
  organizationalUnitId?: Maybe<Scalars['String']>;
  timestamps?: Maybe<TimeMsg>;
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_TreatmentType>;
  userId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_Orientation {
  OrientationCity = 'ORIENTATION_CITY',
  OrientationCurrentPlace = 'ORIENTATION_CURRENT_PLACE',
  OrientationDate = 'ORIENTATION_DATE',
  OrientationDay = 'ORIENTATION_DAY',
  OrientationMonth = 'ORIENTATION_MONTH',
  OrientationNone = 'ORIENTATION_NONE',
  OrientationYear = 'ORIENTATION_YEAR'
}

export type Treatment_OrientationBlock = {
  __typename?: 'treatment_OrientationBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['Boolean']>;
  personText?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['Boolean']>;
  placeText?: Maybe<Scalars['String']>;
  situation?: Maybe<Scalars['Boolean']>;
  situationText?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Boolean']>;
  timeText?: Maybe<Scalars['String']>;
};

export enum Treatment_OrientationLocalisation {
  /** clinic, practice, nursing home (1) */
  OrientationLocalisationClinicPracticeNursing = 'ORIENTATION_LOCALISATION_CLINIC_PRACTICE_NURSING',
  /** country, city (1) */
  OrientationLocalisationCountryCity = 'ORIENTATION_LOCALISATION_COUNTRY_CITY',
  OrientationLocalisationNone = 'ORIENTATION_LOCALISATION_NONE',
  /** state (1) */
  OrientationLocalisationState = 'ORIENTATION_LOCALISATION_STATE',
  /** station, floor (1) */
  OrientationLocalisationStationFloor = 'ORIENTATION_LOCALISATION_STATION_FLOOR',
  /** town, district (1) */
  OrientationLocalisationTownDistrict = 'ORIENTATION_LOCALISATION_TOWN_DISTRICT'
}

export enum Treatment_OrientationTestResult {
  OrientationTestBothAnswersCorrect = 'ORIENTATION_TEST_BOTH_ANSWERS_CORRECT',
  OrientationTestNone = 'ORIENTATION_TEST_NONE',
  OrientationTestNoAnswerCorrect = 'ORIENTATION_TEST_NO_ANSWER_CORRECT',
  OrientationTestOneAnswerCorrect = 'ORIENTATION_TEST_ONE_ANSWER_CORRECT',
  OrientationTestSevereAphasiaOrComa = 'ORIENTATION_TEST_SEVERE_APHASIA_OR_COMA',
  OrientationTestSevereDysarthriaOrIntubated = 'ORIENTATION_TEST_SEVERE_DYSARTHRIA_OR_INTUBATED'
}

export enum Treatment_OrientationTime {
  /** date (1) */
  OrientationTimeDate = 'ORIENTATION_TIME_DATE',
  /** day of the week (1) */
  OrientationTimeDayOfTheWeek = 'ORIENTATION_TIME_DAY_OF_THE_WEEK',
  /** month (1) */
  OrientationTimeMonth = 'ORIENTATION_TIME_MONTH',
  OrientationTimeNone = 'ORIENTATION_TIME_NONE',
  /** season (1) */
  OrientationTimeSeason = 'ORIENTATION_TIME_SEASON',
  /** year (1) */
  OrientationTimeYear = 'ORIENTATION_TIME_YEAR'
}

export type Treatment_OrientativeFunctionalTestsSpineBlock = {
  __typename?: 'treatment_OrientativeFunctionalTestsSpineBlock';
  adamsForwardBentTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  adamsForwardBentTestText?: Maybe<Scalars['String']>;
  distanceDorsiflexionOtt?: Maybe<Scalars['Float']>;
  distanceDorsiflexionSchober?: Maybe<Scalars['Float']>;
  distanceVentralFlexionOtt?: Maybe<Scalars['Float']>;
  distanceVentralFlexionSchober?: Maybe<Scalars['Float']>;
  fingerTipsToFloorDistance?: Maybe<Scalars['Float']>;
  fingertipsToFloorDistanceTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: Maybe<Scalars['String']>;
  ottsSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  schobersTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_OrientativeShoulderFunctionTestsBlock = {
  __typename?: 'treatment_OrientativeShoulderFunctionTestsBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_OrientativeShoulderFunctionTestsMsg>;
  right?: Maybe<Treatment_OrientativeShoulderFunctionTestsMsg>;
};

export type Treatment_OrientativeShoulderFunctionTestsMsg = {
  __typename?: 'treatment_OrientativeShoulderFunctionTestsMsg';
  apronHandle?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  apronHandleText?: Maybe<Scalars['String']>;
  bellyPressTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  bellyPressTestText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  jobeTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  jobeTestText?: Maybe<Scalars['String']>;
  liftOffTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  liftOffTestText?: Maybe<Scalars['String']>;
  neckGrip?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  neckGripText?: Maybe<Scalars['String']>;
  painfulArcTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  painfulArcTestText?: Maybe<Scalars['String']>;
};

export type Treatment_OrientingEyeExaminationBlock = {
  __typename?: 'treatment_OrientingEyeExaminationBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_OrientingForceSingleTestMsg = {
  __typename?: 'treatment_OrientingForceSingleTestMsg';
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_OrientingForceTestBlock = {
  __typename?: 'treatment_OrientingForceTestBlock';
  armExtensionTest?: Maybe<Treatment_OrientingForceSingleTestMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  legExtensionTest?: Maybe<Treatment_OrientingForceSingleTestMsg>;
  orientingForceTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_OrientingNeurologicalExaminationBlock = {
  __typename?: 'treatment_OrientingNeurologicalExaminationBlock';
  orientingNeurologicalExamination?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  orientingNeurologicalExaminationText?: Maybe<Scalars['String']>;
};

export type Treatment_OtherDrugsAndAddictiveSubstancesBlock = {
  __typename?: 'treatment_OtherDrugsAndAddictiveSubstancesBlock';
  consumptionPresent?: Maybe<Scalars['Boolean']>;
  currentConsumption?: Maybe<Scalars['Boolean']>;
  substances?: Maybe<Array<Maybe<Treatment_DrugAndAddictiveSubstanceMsg>>>;
};

export type Treatment_OtherPhysicalBlock = {
  __typename?: 'treatment_OtherPhysicalBlock';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_OtherRiskFactorsBlock = {
  __typename?: 'treatment_OtherRiskFactorsBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  riskFactors?: Maybe<Array<Maybe<Treatment_AnesthesiologicalRiskFactorMsg>>>;
};

export enum Treatment_OtherSignificantRiskFactors {
  OtherSignificantRiskFactorsAdvancedAge = 'OTHER_SIGNIFICANT_RISK_FACTORS_ADVANCED_AGE',
  OtherSignificantRiskFactorsFever = 'OTHER_SIGNIFICANT_RISK_FACTORS_FEVER',
  OtherSignificantRiskFactorsInadequateProteinIntake = 'OTHER_SIGNIFICANT_RISK_FACTORS_INADEQUATE_PROTEIN_INTAKE',
  /** <60 mmHg diastolisch */
  OtherSignificantRiskFactorsLowBloodPressure = 'OTHER_SIGNIFICANT_RISK_FACTORS_LOW_BLOOD_PRESSURE',
  OtherSignificantRiskFactorsNone = 'OTHER_SIGNIFICANT_RISK_FACTORS_NONE',
  OtherSignificantRiskFactorsNoRiskFactor = 'OTHER_SIGNIFICANT_RISK_FACTORS_NO_RISK_FACTOR',
  OtherSignificantRiskFactorsUnstableCirculation = 'OTHER_SIGNIFICANT_RISK_FACTORS_UNSTABLE_CIRCULATION'
}

export type Treatment_OxygenTherapyBlock = {
  __typename?: 'treatment_OxygenTherapyBlock';
  durationOfTherapyPerDay?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  oxygenFlowRate?: Maybe<Scalars['Int']>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_PDmsLowerExtremitiesBlock = {
  __typename?: 'treatment_PDmsLowerExtremitiesBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_PDmsLowerExtremityMsg>;
  right?: Maybe<Treatment_PDmsLowerExtremityMsg>;
};

export type Treatment_PDmsLowerExtremityMsg = {
  __typename?: 'treatment_PDmsLowerExtremityMsg';
  id?: Maybe<Scalars['String']>;
  pDmsIntact?: Maybe<Treatment_IntactExaminationResult>;
  peripheralProperties?: Maybe<Treatment_PeripheralPropertiesMsg>;
};

export type Treatment_PDmsUpperExtremitiesBlock = {
  __typename?: 'treatment_PDmsUpperExtremitiesBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_PDmsUpperExtremityMsg>;
  right?: Maybe<Treatment_PDmsUpperExtremityMsg>;
};

export type Treatment_PDmsUpperExtremityMsg = {
  __typename?: 'treatment_PDmsUpperExtremityMsg';
  id?: Maybe<Scalars['String']>;
  pDmsIntact?: Maybe<Treatment_IntactExaminationResult>;
  peripheralProperties?: Maybe<Treatment_PeripheralPropertiesMsg>;
};

export type Treatment_PacemakerBlock = {
  __typename?: 'treatment_PacemakerBlock';
  currentPacemakerMode?: Maybe<Core_KnowledgeInputMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  indicationsForImplantation?: Maybe<Array<Maybe<Treatment_DiagnosisDetailMsg>>>;
  intrinsicRhythmPresent?: Maybe<Scalars['Boolean']>;
  lastCheckUpAppointment?: Maybe<Timestamp>;
  lastCheckUpAppointmentId?: Maybe<Scalars['String']>;
  /** add knowledge dataset */
  pacemakerType?: Maybe<Core_KnowledgeInputMsg>;
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_PadssBlock = {
  __typename?: 'treatment_PadssBlock';
  /** < walking without vertigo possible (2) / walking with assistance possible (1) / no walking possible, vertigo (0)> */
  ambulation?: Maybe<Treatment_Ambulation>;
  /** < minor (2) / moderate (1) / severe (0)> */
  bleeding?: Maybe<Treatment_Bleeding>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** < minor (2) / moderate (1) / severe (0)> */
  nausea?: Maybe<Treatment_Nausea>;
  /** < minor (VAS 1-2) (2) / moderate (VAS 3-4) (1) / severe (VAS >4) (0)> */
  pain?: Maybe<Treatment_Pain>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** < <20% of preoperative value (2) / 20-40% of preoperative value (1) / >40% of preoperative value (0)> */
  systolicBloodPressure?: Maybe<Treatment_SystolicBloodPressure>;
};

export enum Treatment_Pain {
  PainMinor = 'PAIN_MINOR',
  PainModerate = 'PAIN_MODERATE',
  PainNone = 'PAIN_NONE',
  PainSevere = 'PAIN_SEVERE'
}

export type Treatment_PainBlock = {
  __typename?: 'treatment_PainBlock';
  aggravatingFactors?: Maybe<Scalars['Boolean']>;
  aggravatingFactorsText?: Maybe<Scalars['String']>;
  onset?: Maybe<Core_KnowledgeInputMsg>;
  /** natural number without 0 */
  period?: Maybe<Scalars['Int']>;
  periodUnit?: Maybe<TimeUnit>;
  quality?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  radiation?: Maybe<Scalars['Boolean']>;
  radiationLocalizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  relievingFactors?: Maybe<Scalars['Boolean']>;
  relievingFactorsText?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  temporalCourse?: Maybe<Treatment_TemporalCourse>;
};

export type Treatment_PainCatheterMsg = {
  __typename?: 'treatment_PainCatheterMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_PainQuestionnaireMsg = {
  __typename?: 'treatment_PainQuestionnaireMsg';
  fiveMinutes?: Maybe<Scalars['Int']>;
  oneHour?: Maybe<Scalars['Int']>;
  oneMinute?: Maybe<Scalars['Int']>;
  sixHours?: Maybe<Scalars['Int']>;
  tenMinutes?: Maybe<Scalars['Int']>;
  thirtyMinutes?: Maybe<Scalars['Int']>;
  twentyFourHours?: Maybe<Scalars['Int']>;
  twentyMinutes?: Maybe<Scalars['Int']>;
  twoHours?: Maybe<Scalars['Int']>;
};

export type Treatment_PalpationAnkleJointBlock = {
  __typename?: 'treatment_PalpationAnkleJointBlock';
  left?: Maybe<Treatment_PalpationAnkleJointMsg>;
  right?: Maybe<Treatment_PalpationAnkleJointMsg>;
};

export type Treatment_PalpationAnkleJointMsg = {
  __typename?: 'treatment_PalpationAnkleJointMsg';
  ankleJoint?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  ankleJointText?: Maybe<Scalars['String']>;
  calcaneus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  calcaneusText?: Maybe<Scalars['String']>;
  fibula?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fibulaText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  talus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  talusText?: Maybe<Scalars['String']>;
  tibia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationElbowJointBlock = {
  __typename?: 'treatment_PalpationElbowJointBlock';
  left?: Maybe<Treatment_PalpationElbowJointMsg>;
  right?: Maybe<Treatment_PalpationElbowJointMsg>;
};

export type Treatment_PalpationElbowJointMsg = {
  __typename?: 'treatment_PalpationElbowJointMsg';
  elbowJoint?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  elbowJointText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lateralEpicondyle?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lateralEpicondyleText?: Maybe<Scalars['String']>;
  medialEpicondyle?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  medialEpicondyleText?: Maybe<Scalars['String']>;
  olecranon?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  olecranonText?: Maybe<Scalars['String']>;
  radialHead?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  radialHeadText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationFootBlock = {
  __typename?: 'treatment_PalpationFootBlock';
  left?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  leftText?: Maybe<Scalars['String']>;
  right?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  rightText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationForearmBlock = {
  __typename?: 'treatment_PalpationForearmBlock';
  left?: Maybe<Treatment_PalpationForearmMsg>;
  right?: Maybe<Treatment_PalpationForearmMsg>;
};

export type Treatment_PalpationForearmMsg = {
  __typename?: 'treatment_PalpationForearmMsg';
  id?: Maybe<Scalars['String']>;
  radius?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  radiusText?: Maybe<Scalars['String']>;
  ulna?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  ulnaText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationHandsBlock = {
  __typename?: 'treatment_PalpationHandsBlock';
  left?: Maybe<Treatment_PalpationHandsMsg>;
  right?: Maybe<Treatment_PalpationHandsMsg>;
};

export type Treatment_PalpationHandsMsg = {
  __typename?: 'treatment_PalpationHandsMsg';
  fingerJoints?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fingerJointsText?: Maybe<Scalars['String']>;
  handAndHandJoints?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  handAndHandJointsText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationHipAndPelvicBlock = {
  __typename?: 'treatment_PalpationHipAndPelvicBlock';
  left?: Maybe<Treatment_PalpationHipAndPelvicMsg>;
  right?: Maybe<Treatment_PalpationHipAndPelvicMsg>;
};

export type Treatment_PalpationHipAndPelvicMsg = {
  __typename?: 'treatment_PalpationHipAndPelvicMsg';
  groinPressure?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  groinPressureText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pelvicCompression?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pelvicCompressionText?: Maybe<Scalars['String']>;
  pelvicStability?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pelvicStabilityText?: Maybe<Scalars['String']>;
  thigh?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thighText?: Maybe<Scalars['String']>;
  trochanterMajor?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  trochanterMajorText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationKneeBlock = {
  __typename?: 'treatment_PalpationKneeBlock';
  left?: Maybe<Treatment_PalpationKneeMsg>;
  right?: Maybe<Treatment_PalpationKneeMsg>;
};

export type Treatment_PalpationKneeMsg = {
  __typename?: 'treatment_PalpationKneeMsg';
  aboveAndBelowPatella?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  aboveBelowPatellaText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  knee?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  kneeJointGap?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  kneeJointGapText?: Maybe<Scalars['String']>;
  kneeText?: Maybe<Scalars['String']>;
  patella?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  patellaText?: Maybe<Scalars['String']>;
  surroundingSoftTissue?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  surroundingSoftTissueText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationLowerLegBlock = {
  __typename?: 'treatment_PalpationLowerLegBlock';
  left?: Maybe<Treatment_PalpationLowerLegMsg>;
  right?: Maybe<Treatment_PalpationLowerLegMsg>;
};

export type Treatment_PalpationLowerLegMsg = {
  __typename?: 'treatment_PalpationLowerLegMsg';
  fibula?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  fibulaText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tibia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tibiaText?: Maybe<Scalars['String']>;
};

export type Treatment_PalpationShoulderUpperArmBlock = {
  __typename?: 'treatment_PalpationShoulderUpperArmBlock';
  left?: Maybe<Treatment_PalpationShoulderUpperArmMsg>;
  right?: Maybe<Treatment_PalpationShoulderUpperArmMsg>;
};

export type Treatment_PalpationShoulderUpperArmMsg = {
  __typename?: 'treatment_PalpationShoulderUpperArmMsg';
  acromioclavicularJoint?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  acromioclavicularJointText?: Maybe<Scalars['String']>;
  acromion?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  acromionText?: Maybe<Scalars['String']>;
  clavicle?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  clavicleText?: Maybe<Scalars['String']>;
  coracoidProcess?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  coracoidProcessText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  intertubercularSulcus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  intertubercularSulcusText?: Maybe<Scalars['String']>;
  majorTubercle?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  majorTubercleText?: Maybe<Scalars['String']>;
  scapula?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  scapulaText?: Maybe<Scalars['String']>;
  sternoclavicularJoint?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  sternoclavicularJointText?: Maybe<Scalars['String']>;
  tubercleMinus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tubercleMinusText?: Maybe<Scalars['String']>;
  upperArm?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  upperArmText?: Maybe<Scalars['String']>;
};

export type Treatment_PancreatitisSkinSignsBlock = {
  __typename?: 'treatment_PancreatitisSkinSignsBlock';
  pancreatitisSkinSigns?: Maybe<Array<Maybe<Treatment_PancreatitisSkinSignsType>>>;
  present?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_PancreatitisSkinSignsType {
  PancreatitisSkinSignCullen = 'PANCREATITIS_SKIN_SIGN_CULLEN',
  PancreatitisSkinSignFox = 'PANCREATITIS_SKIN_SIGN_FOX',
  PancreatitisSkinSignGreyTurner = 'PANCREATITIS_SKIN_SIGN_GREY_TURNER',
  PancreatitisSkinSignNone = 'PANCREATITIS_SKIN_SIGN_NONE'
}

export type Treatment_ParoxysmalCardiacArrhythmiaMsg = {
  __typename?: 'treatment_ParoxysmalCardiacArrhythmiaMsg';
  averageDuration?: Maybe<VeiosTimeSpanMsg>;
  cessationMechanismsDescription?: Maybe<Scalars['String']>;
  cessationMechanismsPresent?: Maybe<Scalars['Boolean']>;
  endType?: Maybe<Treatment_ArrythmiaOnsetType>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_SymptomFrequency>;
  id?: Maybe<Scalars['String']>;
  lastOccurrence?: Maybe<VeiosDateTimeMsg>;
  onsetType?: Maybe<Treatment_ArrythmiaOnsetType>;
  situationalOnsetPresent?: Maybe<Scalars['Boolean']>;
  situationalOnsets?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_ParoxysmalDyspneaMsg = {
  __typename?: 'treatment_ParoxysmalDyspneaMsg';
  averageDuration?: Maybe<VeiosTimeSpanMsg>;
  endType?: Maybe<Treatment_SymptomAppearance>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_DyspneaResolution>;
  id?: Maybe<Scalars['String']>;
  lastOccurrence?: Maybe<VeiosDateTimeMsg>;
  onsetType?: Maybe<Treatment_SymptomAppearance>;
  situationDependenceDescription?: Maybe<Scalars['String']>;
  situationDependencePresent?: Maybe<Scalars['Boolean']>;
  terminationMechanismsDescription?: Maybe<Scalars['String']>;
  terminationMechanismsPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ParoxysmalVertigoMsg = {
  __typename?: 'treatment_ParoxysmalVertigoMsg';
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_SymptomFrequency>;
  id?: Maybe<Scalars['String']>;
  lastSeizureDate?: Maybe<VeiosDateTimeMsg>;
  seizureDuration?: Maybe<VeiosTimeSpanMsg>;
  symptomsBetweenSeizures?: Maybe<Scalars['Boolean']>;
  symptomsBetweenSeizuresText?: Maybe<Scalars['String']>;
};

export enum Treatment_PartnerDisturbed {
  PartnerDisturbedNo = 'PARTNER_DISTURBED_NO',
  PartnerDisturbedNone = 'PARTNER_DISTURBED_NONE',
  PartnerDisturbedNoPartner = 'PARTNER_DISTURBED_NO_PARTNER',
  PartnerDisturbedSeparateBedroom = 'PARTNER_DISTURBED_SEPARATE_BEDROOM',
  PartnerDisturbedYes = 'PARTNER_DISTURBED_YES'
}

export enum Treatment_Partners {
  PartnersFemale = 'PARTNERS_FEMALE',
  PartnersMale = 'PARTNERS_MALE',
  PartnersNone = 'PARTNERS_NONE',
  PartnersOther = 'PARTNERS_OTHER'
}

export type Treatment_PasiBlock = {
  __typename?: 'treatment_PasiBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  headAndNeckPasi?: Maybe<Treatment_HeadAndNeckPasiMsg>;
  lowerLimbsPasi?: Maybe<Treatment_LowerLimbsPasiMsg>;
  /** <Sum of all Subscores> */
  score?: Maybe<Scalars['Float']>;
  trunkPasi?: Maybe<Treatment_TrunkPasiMsg>;
  upperLimbsPasi?: Maybe<Treatment_UpperLimbsPasiMsg>;
};

export enum Treatment_PasiSelection {
  /** absent symptoms (0) */
  PasiSelectionAbsentSymptoms = 'PASI_SELECTION_ABSENT_SYMPTOMS',
  /** mild symptoms (1) */
  PasiSelectionMildSymptoms = 'PASI_SELECTION_MILD_SYMPTOMS',
  /** moderate symptoms (2) */
  PasiSelectionModerateSymptoms = 'PASI_SELECTION_MODERATE_SYMPTOMS',
  PasiSelectionNone = 'PASI_SELECTION_NONE',
  /** severe symptoms (3) */
  PasiSelectionSevereSymptoms = 'PASI_SELECTION_SEVERE_SYMPTOMS',
  /** very severe symptoms (4) */
  PasiSelectionVerySevereSymptoms = 'PASI_SELECTION_VERY_SEVERE_SYMPTOMS'
}

export type Treatment_PastAirwayManagementBlock = {
  __typename?: 'treatment_PastAirwayManagementBlock';
  airwayAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  cormackLehaneClassification?: Maybe<Treatment_CormackLehaneClassification>;
  furtherDetails?: Maybe<Scalars['String']>;
  maskVentilations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_PastAnaesthesiaComplicationOccurrenceMsg = {
  __typename?: 'treatment_PastAnaesthesiaComplicationOccurrenceMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pastComplication?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_PastAnesthesiaComplicationsMsg = {
  __typename?: 'treatment_PastAnesthesiaComplicationsMsg';
  complications?: Maybe<Array<Maybe<Treatment_PastAnaesthesiaComplicationOccurrenceMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nonExistingComplications?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_PastTracheostomyDetailsMsg = {
  __typename?: 'treatment_PastTracheostomyDetailsMsg';
  date?: Maybe<Timestamp>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_PatellaExaminationBlock = {
  __typename?: 'treatment_PatellaExaminationBlock';
  customFunctionTests?: Maybe<Array<Maybe<Treatment_CustomFunctionTestMsg>>>;
  left?: Maybe<Treatment_PatellaExaminationMsg>;
  right?: Maybe<Treatment_PatellaExaminationMsg>;
};

export type Treatment_PatellaExaminationMsg = {
  __typename?: 'treatment_PatellaExaminationMsg';
  apprehensionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  apprehensionTestText?: Maybe<Scalars['String']>;
  facetPressurePain?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  facetPressurePainText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  patellaMobility?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  patellaMobilityText?: Maybe<Scalars['String']>;
  patellaTap?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  patellaTapText?: Maybe<Scalars['String']>;
  zohlensSign?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  zohlensSignText?: Maybe<Scalars['String']>;
};

export enum Treatment_Path {
  PathModerateDeviationOrUsesAids = 'PATH_MODERATE_DEVIATION_OR_USES_AIDS',
  /** <straight without aids (2) / moderate deviation or uses aids (1) / significant deviation (0)> */
  PathNone = 'PATH_NONE',
  PathSignificantDeviation = 'PATH_SIGNIFICANT_DEVIATION',
  PathStraightWithoutAids = 'PATH_STRAIGHT_WITHOUT_AIDS'
}

export type Treatment_PathKeyMsg = {
  __typename?: 'treatment_PathKeyMsg';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_PathologicReflexesBlock = {
  __typename?: 'treatment_PathologicReflexesBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  glabellarReflex?: Maybe<Scalars['Boolean']>;
  glabellarReflexText?: Maybe<Scalars['String']>;
  left?: Maybe<Treatment_PathologicReflexesMsg>;
  right?: Maybe<Treatment_PathologicReflexesMsg>;
  snoutReflex?: Maybe<Scalars['Boolean']>;
  snoutReflexText?: Maybe<Scalars['String']>;
  suckingReflex?: Maybe<Scalars['Boolean']>;
  suckingReflexText?: Maybe<Scalars['String']>;
};

export type Treatment_PathologicReflexesMsg = {
  __typename?: 'treatment_PathologicReflexesMsg';
  babinskiReflex?: Maybe<Scalars['Boolean']>;
  babinskiReflexText?: Maybe<Scalars['String']>;
  gordonSign?: Maybe<Scalars['Boolean']>;
  gordonSignText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  oppenheimSign?: Maybe<Scalars['Boolean']>;
  oppenheimSignText?: Maybe<Scalars['String']>;
  palmarGraspSign?: Maybe<Scalars['Boolean']>;
  palmarGraspSignText?: Maybe<Scalars['String']>;
  palmomentalReflex?: Maybe<Scalars['Boolean']>;
  palmomentalReflexText?: Maybe<Scalars['String']>;
  struempellSign?: Maybe<Scalars['Boolean']>;
  struempellSignText?: Maybe<Scalars['String']>;
};

export enum Treatment_PathologicalExaminationResult {
  PathologicalExaminationResultNone = 'PATHOLOGICAL_EXAMINATION_RESULT_NONE',
  PathologicalExaminationResultNormal = 'PATHOLOGICAL_EXAMINATION_RESULT_NORMAL',
  PathologicalExaminationResultPathological = 'PATHOLOGICAL_EXAMINATION_RESULT_PATHOLOGICAL'
}

export enum Treatment_PatientClinicalState {
  PatientClinicalStateNone = 'PATIENT_CLINICAL_STATE_NONE',
  PatientClinicalStateOff = 'PATIENT_CLINICAL_STATE_OFF',
  PatientClinicalStateOn = 'PATIENT_CLINICAL_STATE_ON'
}

export type Treatment_PatientDiagnosisList = {
  __typename?: 'treatment_PatientDiagnosisList';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  patientId?: Maybe<Scalars['String']>;
};

/**
 * TODO: is it possible to look at fluid balances of a patient from previous visits?
 * If it is possible, we would probably want different configurations based on visits instead of patient as the configuration might differ.
 * Otherwise, we should probably come up with a way to clean up configurations for patients whose stationary visit ended unless there is a reason to keep them for future
 */
export type Treatment_PatientFluidBalanceConfigurationMsg = {
  __typename?: 'treatment_PatientFluidBalanceConfigurationMsg';
  active?: Maybe<Scalars['Boolean']>;
  configuration?: Maybe<Treatment_FluidBalanceConfigurationMsg>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
};

export type Treatment_PatientHealthQuestionnaireBlock = {
  __typename?: 'treatment_PatientHealthQuestionnaireBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  feelingBadAboutYourself?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  feelingHopeless?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  feelingTired?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  littleInterest?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  movingOrSpeakingSlowly?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  poorAppetite?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  score?: Maybe<Scalars['Int']>;
  thoughtsAboutHurtingYourself?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  troubleConcentration?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
  troubleFalling?: Maybe<Treatment_PatientHealthQuestionnaireSelection>;
};

export enum Treatment_PatientHealthQuestionnaireSelection {
  /** more than half the days (2) */
  PatientHealthQuestionnaireSelectionMoreThanHalfDays = 'PATIENT_HEALTH_QUESTIONNAIRE_SELECTION_MORE_THAN_HALF_DAYS',
  /** nearly every day (3) */
  PatientHealthQuestionnaireSelectionNearlyEveryDay = 'PATIENT_HEALTH_QUESTIONNAIRE_SELECTION_NEARLY_EVERY_DAY',
  PatientHealthQuestionnaireSelectionNone = 'PATIENT_HEALTH_QUESTIONNAIRE_SELECTION_NONE',
  /** not at all (0) */
  PatientHealthQuestionnaireSelectionNotAtAll = 'PATIENT_HEALTH_QUESTIONNAIRE_SELECTION_NOT_AT_ALL',
  /** several days (1) */
  PatientHealthQuestionnaireSelectionSeveralDays = 'PATIENT_HEALTH_QUESTIONNAIRE_SELECTION_SEVERAL_DAYS'
}

export type Treatment_PatientsDiagnosisList = {
  __typename?: 'treatment_PatientsDiagnosisList';
  patientsDiagnosis?: Maybe<Array<Maybe<Treatment_PatientDiagnosisList>>>;
};

export type Treatment_PediatricGlasgowComaScaleScoreBlock = {
  __typename?: 'treatment_PediatricGlasgowComaScaleScoreBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  eyeResponse?: Maybe<Treatment_EyeResponseType>;
  motorResponse?: Maybe<Treatment_PediatricMotorResponseType>;
  score?: Maybe<Scalars['Int']>;
  verbalResponse?: Maybe<Treatment_PediatricVerbalResponseType>;
};

export enum Treatment_PediatricMotorResponseType {
  PediatricMotorResponseAbnormalExtension = 'PEDIATRIC_MOTOR_RESPONSE_ABNORMAL_EXTENSION',
  PediatricMotorResponseAbnormalFlexion = 'PEDIATRIC_MOTOR_RESPONSE_ABNORMAL_FLEXION',
  PediatricMotorResponseLocalizingPain = 'PEDIATRIC_MOTOR_RESPONSE_LOCALIZING_PAIN',
  PediatricMotorResponseNone = 'PEDIATRIC_MOTOR_RESPONSE_NONE',
  PediatricMotorResponseNoMovement = 'PEDIATRIC_MOTOR_RESPONSE_NO_MOVEMENT',
  PediatricMotorResponseSpontaneousMovements = 'PEDIATRIC_MOTOR_RESPONSE_SPONTANEOUS_MOVEMENTS',
  PediatricMotorResponseWithdrawalFromPain = 'PEDIATRIC_MOTOR_RESPONSE_WITHDRAWAL_FROM_PAIN'
}

export enum Treatment_PediatricVerbalResponseType {
  PediatricVerbalResponseBabblingChattering = 'PEDIATRIC_VERBAL_RESPONSE_BABBLING_CHATTERING',
  PediatricVerbalResponseConversesNormally = 'PEDIATRIC_VERBAL_RESPONSE_CONVERSES_NORMALLY',
  PediatricVerbalResponseCryingAndInconsolable = 'PEDIATRIC_VERBAL_RESPONSE_CRYING_AND_INCONSOLABLE',
  PediatricVerbalResponseCryingButConsolable = 'PEDIATRIC_VERBAL_RESPONSE_CRYING_BUT_CONSOLABLE',
  PediatricVerbalResponseMakesNoSounds = 'PEDIATRIC_VERBAL_RESPONSE_MAKES_NO_SOUNDS',
  PediatricVerbalResponseNone = 'PEDIATRIC_VERBAL_RESPONSE_NONE'
}

export type Treatment_PegMsg = {
  __typename?: 'treatment_PegMsg';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_PercussionSoundDescriptionMsg = {
  __typename?: 'treatment_PercussionSoundDescriptionMsg';
  id?: Maybe<Scalars['String']>;
  lungLocalizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  percussionSoundDescriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_PercussionSoundLungBlock = {
  __typename?: 'treatment_PercussionSoundLungBlock';
  percussionSound?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  percussionSoundDescriptions?: Maybe<Array<Maybe<Treatment_PercussionSoundDescriptionMsg>>>;
};

export type Treatment_PericardialDrainageMsg = {
  __typename?: 'treatment_PericardialDrainageMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  suction?: Maybe<Scalars['Float']>;
  suctionUnit?: Maybe<Treatment_SuctionUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_PeriduralInjectionsMsg = {
  __typename?: 'treatment_PeriduralInjectionsMsg';
  singleShotPeriduralAnaesthesia?: Maybe<Scalars['Boolean']>;
  spineLevels?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_PeripheralAnesthesiaMsg = {
  __typename?: 'treatment_PeripheralAnesthesiaMsg';
  /** one decimal; unit: cm */
  depth?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  punctureLocation?: Maybe<Core_KnowledgeInputMsg>;
  /** one decimal; unit: cm */
  skinLevel?: Maybe<Scalars['Float']>;
  technique?: Maybe<Core_KnowledgeInputMsg>;
  /** one decimal; unit: cm */
  tunnel?: Maybe<Scalars['Float']>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_PeripheralPropertiesMsg = {
  __typename?: 'treatment_PeripheralPropertiesMsg';
  id?: Maybe<Scalars['String']>;
  peripheralBloodFlowState?: Maybe<Treatment_IntactExaminationResult>;
  peripheralBloodFlowText?: Maybe<Scalars['String']>;
  peripheralMotorFunctionState?: Maybe<Treatment_IntactExaminationResult>;
  peripheralMotorFunctionText?: Maybe<Scalars['String']>;
  peripheralSensibilityState?: Maybe<Treatment_IntactExaminationResult>;
  peripheralSensibilityText?: Maybe<Scalars['String']>;
};

export type Treatment_PeripheralPulseDeficitBlock = {
  __typename?: 'treatment_PeripheralPulseDeficitBlock';
  peripheralPulseDeficit?: Maybe<Scalars['Boolean']>;
  peripheralPulseDeficitText?: Maybe<Scalars['String']>;
};

export type Treatment_PeritonealCatheterMsg = {
  __typename?: 'treatment_PeritonealCatheterMsg';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_PeritonealPunctureMsg = {
  __typename?: 'treatment_PeritonealPunctureMsg';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_PeritonitisSignsBlock = {
  __typename?: 'treatment_PeritonitisSignsBlock';
  contralateralReboundTendernessPresent?: Maybe<Scalars['Boolean']>;
  contralateralReboundTendernessText?: Maybe<Scalars['String']>;
  cutaneousHyperesthesiaPresent?: Maybe<Scalars['Boolean']>;
  cutaneousHyperesthesiaText?: Maybe<Scalars['String']>;
  muscularDefensePresent?: Maybe<Scalars['Boolean']>;
  muscularDefenseText?: Maybe<Scalars['String']>;
  painIncreasedByCoughingPresent?: Maybe<Scalars['Boolean']>;
  painIncreasedByCoughingText?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  reboundTendernessPresent?: Maybe<Scalars['Boolean']>;
  reboundTendernessText?: Maybe<Scalars['String']>;
  shakingPainPresent?: Maybe<Scalars['Boolean']>;
  shakingPainText?: Maybe<Scalars['String']>;
};

export type Treatment_PersistentDyspneaMsg = {
  __typename?: 'treatment_PersistentDyspneaMsg';
  course?: Maybe<Treatment_DyspneaCourse>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_Pessimism {
  PessimismDespondentHopelessFutureAndWillGetWorse = 'PESSIMISM_DESPONDENT_HOPELESS_FUTURE_AND_WILL_GET_WORSE',
  PessimismDespondentWithNoBetterSituation = 'PESSIMISM_DESPONDENT_WITH_NO_BETTER_SITUATION',
  PessimismMoreDespondentAboutFuture = 'PESSIMISM_MORE_DESPONDENT_ABOUT_FUTURE',
  PessimismNone = 'PESSIMISM_NONE',
  PessimismNotDespondentAboutFuture = 'PESSIMISM_NOT_DESPONDENT_ABOUT_FUTURE'
}

export enum Treatment_PetsStatus {
  PetsStatusNone = 'PETS_STATUS_NONE',
  PetsStatusNonPresent = 'PETS_STATUS_NON_PRESENT',
  PetsStatusPresent = 'PETS_STATUS_PRESENT'
}

export type Treatment_PharyngealMotorSkillsAndSensitivityBlock = {
  __typename?: 'treatment_PharyngealMotorSkillsAndSensitivityBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  gagReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  gagReflexText?: Maybe<Scalars['String']>;
  pharyngealMotorSkillsAndSensitivity?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  softPalate?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  softPalateText?: Maybe<Scalars['String']>;
  swallowingAct?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  swallowingActText?: Maybe<Scalars['String']>;
  uvula?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  uvulaText?: Maybe<Scalars['String']>;
  voiceCheck?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  voiceCheckText?: Maybe<Scalars['String']>;
};

export type Treatment_PhysicalAbnormalityMsg = {
  __typename?: 'treatment_PhysicalAbnormalityMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_PhysicalActivityType {
  PhysicalActivityAverage = 'PHYSICAL_ACTIVITY_AVERAGE',
  PhysicalActivityHigh = 'PHYSICAL_ACTIVITY_HIGH',
  PhysicalActivityInactive = 'PHYSICAL_ACTIVITY_INACTIVE',
  PhysicalActivityLow = 'PHYSICAL_ACTIVITY_LOW',
  PhysicalActivityNone = 'PHYSICAL_ACTIVITY_NONE',
  PhysicalActivityVeryHigh = 'PHYSICAL_ACTIVITY_VERY_HIGH'
}

export type Treatment_PhysicalBlockContentMsg = {
  __typename?: 'treatment_PhysicalBlockContentMsg';
  abdominalCirculationNoise?: Maybe<Treatment_AbdominalCirculationNoiseBlock>;
  abdominalInspectionGeneral?: Maybe<Treatment_AbdominalInspectionGeneralBlock>;
  abdominalPercussion?: Maybe<Treatment_AbdominalPercussionBlock>;
  abdominalWall?: Maybe<Treatment_AbdominalWallBlock>;
  /** should be directly before ExtremitiesTemperatureBlock extremitiesTemperature = 20151; */
  allenTest?: Maybe<Treatment_AllenTestBlock>;
  alsfrs?: Maybe<Treatment_AlsfrsBlock>;
  analRegionInspection?: Maybe<Treatment_AnalRegionInspectionBlock>;
  apicalImpulse?: Maybe<Treatment_ApicalImpulseBlock>;
  appearance?: Maybe<Treatment_AppearanceBlock>;
  appendicitisSigns?: Maybe<Treatment_AppendicitisSignsBlock>;
  ascites?: Maybe<Treatment_AscitesBlock>;
  attention?: Maybe<Treatment_AttentionBlock>;
  axillaryLymphNodes?: Maybe<Treatment_AxillaryLymphNodesBlock>;
  bloodPressureAndPulse?: Maybe<Treatment_BloodPressureAndPulseBlock>;
  bodyMeasurements?: Maybe<Treatment_BodyMeasurementsBlock>;
  bowelSounds?: Maybe<Treatment_BowelSoundsBlock>;
  breathingMovability?: Maybe<Treatment_BreathingMovabilityBlock>;
  breathingMovement?: Maybe<Treatment_BreathingMovementBlock>;
  bronchophony?: Maybe<Treatment_BronchophonyBlock>;
  chewingMusclesAndFacialMotorSkills?: Maybe<Treatment_ChewingMusclesAndFacialMotorSkillsBlock>;
  compressionStability?: Maybe<Treatment_CompressionStabilityBlock>;
  contusionHematoma?: Maybe<Treatment_ContusionHematomaBlock>;
  coordination?: Maybe<Treatment_CoordinationBlock>;
  crepitations?: Maybe<Treatment_CrepitationsBlock>;
  cruciateLigamentsExamination?: Maybe<Treatment_CruciateLigamentsExaminationBlock>;
  deformitiesMalpositionsLowerLimbs?: Maybe<Treatment_DeformitiesMalpositionsLowerLimbBlock>;
  deformitiesMalpositionsSpine?: Maybe<Treatment_DeformitiesMalpositionsSpineBlock>;
  deformitiesMalpositionsUpperLimb?: Maybe<Treatment_DeformitiesMalpositionsUpperLimbBlock>;
  /** Preanesthetic Assessment */
  dentures?: Maybe<Treatment_DenturesBlock>;
  digitalRectalExamination?: Maybe<Treatment_DigitalRectalExamBlock>;
  earsInspection?: Maybe<Treatment_EarsInspectionBlock>;
  edemas?: Maybe<Treatment_EdemasBlock>;
  executiveFunctions?: Maybe<Treatment_ExecutiveFunctionsBlock>;
  externalMaterial?: Maybe<Treatment_ExternalMaterialBlock>;
  extrapyramidalMovementDisorders?: Maybe<Treatment_ExtrapyramidalMovementDisordersBlock>;
  extremitiesTemperature?: Maybe<Treatment_ExtremitiesTemperatureBlock>;
  facialSensitivityAndTrigeminalReflexes?: Maybe<Treatment_FacialSensitivityAndTrigeminalReflexesBlock>;
  flowNoiseLowerExtremity?: Maybe<Treatment_FlowNoiseLowerExtremityBlock>;
  flowNoiseUpperExtremity?: Maybe<Treatment_FlowNoisesUpperExtremityBlock>;
  functionTestsHipAndPelvic?: Maybe<Treatment_HipAndPelvicFunctionTestsBlock>;
  /** should be directly after NeckAndShoulderMotorSkillsBlock neckAndShoulderMotorSkills = 20180; */
  functionalExaminationOfVestibularNerve?: Maybe<Treatment_FunctionalExaminationOfVestibularNerveBlock>;
  furtherFunctionalTestsSpine?: Maybe<Treatment_FurtherFunctionalTestsSpineBlock>;
  furtherShoulderFunctionTests?: Maybe<Treatment_FurtherShoulderFunctionTestsBlock>;
  gait?: Maybe<Treatment_GaitBlock>;
  gallBladderSigns?: Maybe<Treatment_GallBladderSignsBlock>;
  generalCondition?: Maybe<Treatment_GeneralConditionBlock>;
  generalFindings?: Maybe<Treatment_GeneralFindingsBlock>;
  glasgowComaScale?: Maybe<Treatment_GlasgowComaScaleBlock>;
  hairScalpInspection?: Maybe<Treatment_HairScalpInspectionBlock>;
  hairScalpPalpation?: Maybe<Treatment_HairScalpPalpationBlock>;
  handFunctionTests?: Maybe<Treatment_HandFunctionTestsBlock>;
  headAndNeckLymphNode?: Maybe<Treatment_HeadAndNeckLymphNodesBlock>;
  headSalivaryGlands?: Maybe<Treatment_HeadSalivaryGlandsBlock>;
  hearing?: Maybe<Treatment_HearingBlock>;
  heartMurmurs?: Maybe<Treatment_HeartMurmursBlock>;
  heartRate?: Maybe<Treatment_HeartRateBlock>;
  heartSound?: Maybe<Treatment_HeartSoundBlock>;
  hernia?: Maybe<Treatment_HerniaBlock>;
  illusions?: Maybe<Treatment_IllusionsBlock>;
  inguinalLymphNodes?: Maybe<Treatment_InguinalLymphNodesBlock>;
  inspectionOfTheMusculatureAndMuscleTrophics?: Maybe<Treatment_InspectionOfTheMusculatureAndMuscleTrophicsBlock>;
  jugularVeinsInspection?: Maybe<Treatment_JugularVeinsInspectionBlock>;
  kidneyPainOnPercussion?: Maybe<Treatment_KidneyPainOnPercussionBlock>;
  larynxHypopharynxInspection?: Maybe<Treatment_LarynxHypopharynxInspectionBlock>;
  limbCircumferenceDifference?: Maybe<Treatment_LimbCircumferenceDifferenceBlock>;
  liverPalpation?: Maybe<Treatment_LiverPalpationBlock>;
  liverSize?: Maybe<Treatment_LiverSizeBlock>;
  liverSkinSigns?: Maybe<Treatment_LiverSkinSignExaminationBlock>;
  lowerLegAndAnkleFunctionTests?: Maybe<Treatment_LowerLegAndAnkleFunctionTestsBlock>;
  lungAusculatations?: Maybe<Treatment_LungAusculatationsBlock>;
  lungBorder?: Maybe<Treatment_LungBorderBlock>;
  lungsThoraxPressurePain?: Maybe<Treatment_LungsThoraxPressurePainBlock>;
  mallampatiClassification?: Maybe<Treatment_MallampatiClassificationBlock>;
  memory?: Maybe<Treatment_MemoryBlock>;
  menisciExamination?: Maybe<Treatment_MenisciExaminationBlock>;
  mobilitySpine?: Maybe<Treatment_MobilitySpineBlock>;
  mobilityTestAnkle?: Maybe<Treatment_MobilityTestAnkleBlock>;
  mobilityTestCervicalSpine?: Maybe<Treatment_MobilityTestCervicalSpineBlock>;
  mobilityTestElbowJoint?: Maybe<Treatment_MobilityTestElbowJointBlock>;
  mobilityTestFingerJoint?: Maybe<Treatment_MobilityTestFingerJointsBlock>;
  mobilityTestHipJoint?: Maybe<Treatment_MobilityTestHipJointBlock>;
  mobilityTestKnee?: Maybe<Treatment_MobilityTestKneeBlock>;
  mobilityTestLumbarSpine?: Maybe<Treatment_MobilityTestLumbarSpineBlock>;
  mobilityTestShoulder?: Maybe<Treatment_MobilityTestShoulderBlock>;
  mobilityTestShoulderJointIsolated?: Maybe<Treatment_MobilityTestShoulderJointIsolatedBlock>;
  mobilityTestThoracicSpine?: Maybe<Treatment_MobilityTestThoracicSpineBlock>;
  mobilityTestToeJoints?: Maybe<Treatment_MobilityTestToeJointsBlock>;
  mobilityTestWrist?: Maybe<Treatment_MobilityTestWristBlock>;
  monosynapticReflexes?: Maybe<Treatment_MonosynapticReflexesBlock>;
  moodAndPsyche?: Maybe<Treatment_MoodAndPsycheBlock>;
  mouthAndThroatAndLarynxInspection?: Maybe<Treatment_MouthAndThroatAndLarynxInspectionBlock>;
  muscleTone?: Maybe<Treatment_MuscleToneBlock>;
  nailChange?: Maybe<Treatment_NailChangeExaminationBlock>;
  neckAndShoulderMotorSkills?: Maybe<Treatment_NeckAndShoulderMotorSkillsBlock>;
  nerveStretchSigns?: Maybe<Treatment_NerveStretchSignsBlock>;
  nihss?: Maybe<Treatment_NihssBlock>;
  noseInspection?: Maybe<Treatment_NoseInspectionBlock>;
  /** should be directly after NoseInspectionBlock noseInspection = 20029; */
  nosePalpation?: Maybe<Treatment_NosePalpationBlock>;
  nutritionStatus?: Maybe<Treatment_NutritionStatusBlock>;
  oculomotorSkills?: Maybe<Treatment_OculomotorSkillsBlock>;
  olfactorySense?: Maybe<Treatment_OlfactorySenseBlock>;
  orientation?: Maybe<Treatment_OrientationBlock>;
  orientativeFunctionalTestsSpine?: Maybe<Treatment_OrientativeFunctionalTestsSpineBlock>;
  orientativeShoulderFunctionTests?: Maybe<Treatment_OrientativeShoulderFunctionTestsBlock>;
  orientingEyeExamination?: Maybe<Treatment_OrientingEyeExaminationBlock>;
  orientingForceTest?: Maybe<Treatment_OrientingForceTestBlock>;
  orientingNeurologicalExamination?: Maybe<Treatment_OrientingNeurologicalExaminationBlock>;
  otherPhysical?: Maybe<Treatment_OtherPhysicalBlock>;
  pDmsLowerExtremities?: Maybe<Treatment_PDmsLowerExtremitiesBlock>;
  pDmsUpperExtremities?: Maybe<Treatment_PDmsUpperExtremitiesBlock>;
  palpationAnkleJoint?: Maybe<Treatment_PalpationAnkleJointBlock>;
  palpationElbowJoint?: Maybe<Treatment_PalpationElbowJointBlock>;
  palpationFoot?: Maybe<Treatment_PalpationFootBlock>;
  palpationForearm?: Maybe<Treatment_PalpationForearmBlock>;
  palpationHands?: Maybe<Treatment_PalpationHandsBlock>;
  palpationHipAndPelvic?: Maybe<Treatment_PalpationHipAndPelvicBlock>;
  palpationKnee?: Maybe<Treatment_PalpationKneeBlock>;
  palpationLowerLeg?: Maybe<Treatment_PalpationLowerLegBlock>;
  palpationShoulderUpperArm?: Maybe<Treatment_PalpationShoulderUpperArmBlock>;
  pancreatitisSkinSigns?: Maybe<Treatment_PancreatitisSkinSignsBlock>;
  patellaExamination?: Maybe<Treatment_PatellaExaminationBlock>;
  pathologicReflexes?: Maybe<Treatment_PathologicReflexesBlock>;
  percussionSoundLung?: Maybe<Treatment_PercussionSoundLungBlock>;
  peripheralPulseDeficit?: Maybe<Treatment_PeripheralPulseDeficitBlock>;
  peritonitisSigns?: Maybe<Treatment_PeritonitisSignsBlock>;
  pharyngealMotorSkillsAndSensitivity?: Maybe<Treatment_PharyngealMotorSkillsAndSensitivityBlock>;
  polysynapticReflexes?: Maybe<Treatment_PolysynapticReflexesBlock>;
  postureAndStand?: Maybe<Treatment_PostureAndStandBlock>;
  precordialBruit?: Maybe<Treatment_PrecordialBruitBlock>;
  pressurePainAbdomen?: Maybe<Treatment_AbdomenLocationsBlock>;
  prostateExamination?: Maybe<Treatment_ProstateExaminationBlock>;
  psychopathologicalFindings?: Maybe<Treatment_PsychopathologicalFindingsBlock>;
  pulsePalpationAbdomen?: Maybe<Treatment_PulsePalpationAbdomenBlock>;
  pulsePalpationLowerExtremity?: Maybe<Treatment_PulsePalpationLowerExtremityBlock>;
  pulsePalpationUpperExtremity?: Maybe<Treatment_PulsePalpationUpperExtremityBlock>;
  pupilsAndLightReaction?: Maybe<Treatment_PupilsAndLightReactionBlock>;
  qualitativeConsciousness?: Maybe<Treatment_QualitativeConsciousnessBlock>;
  resistancesAbdomen?: Maybe<Treatment_AbdomenLocationsBlock>;
  respiration?: Maybe<Treatment_RespirationBlock>;
  senseOfTaste?: Maybe<Treatment_SenseOfTasteBlock>;
  sensitivity?: Maybe<Treatment_SensitivityBlock>;
  singleForceTest?: Maybe<Treatment_SingleForceTestBlock>;
  skinChangeExaminations?: Maybe<Treatment_SkinChangeExaminationsBlock>;
  skinColor?: Maybe<Treatment_SkinColorBlock>;
  skinThickness?: Maybe<Treatment_SkinThicknessBlock>;
  skinTurgor?: Maybe<Treatment_SkinTurgorBlock>;
  skullPalpation?: Maybe<Treatment_SkullPalpationBlock>;
  softTissueEmphysema?: Maybe<Treatment_SoftTissueEmphysemaBlock>;
  speaking?: Maybe<Treatment_SpeakingBlock>;
  specialRespiratoryFeatures?: Maybe<Treatment_SpecialRespiratoryFeaturesBlock>;
  specificEars?: Maybe<Treatment_SpecificEarsBlock>;
  specificEyes?: Maybe<Treatment_SpecificEyesBlock>;
  specificNoseAndSinus?: Maybe<Treatment_SpecificNoseAndSinusBlock>;
  speech?: Maybe<Treatment_SpeechBlock>;
  spineAgility?: Maybe<Treatment_SpineAgilityBlock>;
  spinePalpation?: Maybe<Treatment_SpinePalpationBlock>;
  spinePercussion?: Maybe<Treatment_SpinePercussionBlock>;
  spleenPalpation?: Maybe<Treatment_SpleenPalpationBlock>;
  stopBangRisk?: Maybe<Treatment_StopBangRiskBlock>;
  surgicalScars?: Maybe<Treatment_SurgicalScarsBlock>;
  swellingLimbs?: Maybe<Treatment_SwellingLimbsBlock>;
  temperature?: Maybe<Treatment_TemperatureBlock>;
  thoraxForm?: Maybe<Treatment_ThoraxFormBlock>;
  thyroidInspectionAndPalpationAndAuscultation?: Maybe<Treatment_ThyroidInspectionAndPalpationAndAuscultationBlock>;
  tongueMotorSkills?: Maybe<Treatment_TongueMotorSkillsBlock>;
  tracheaPosition?: Maybe<Treatment_TracheaPositionBlock>;
  trichoscopy?: Maybe<Treatment_TrichoscopyBlock>;
  upperLipBiteTest?: Maybe<Treatment_UpperLipBiteTestBlock>;
  urinaryBladder?: Maybe<Treatment_UrinaryBladderBlock>;
  varicosis?: Maybe<Treatment_VaricosisBlock>;
  vigilance?: Maybe<Treatment_VigilanceBlock>;
  visualAcuity?: Maybe<Treatment_VisualAcuityBlock>;
  visualFieldAndVisualAttention?: Maybe<Treatment_VisualFieldAndVisualAttentionBlock>;
  vocalFremitus?: Maybe<Treatment_VocalFremitusBlock>;
  wounds?: Maybe<Treatment_WoundExaminationBlock>;
};

export enum Treatment_PhysicalBlockLocation {
  PhysicalBlockLocationNone = 'PHYSICAL_BLOCK_LOCATION_NONE',
  PhysicalBlockLocationPatientChart = 'PHYSICAL_BLOCK_LOCATION_PATIENT_CHART',
  PhysicalBlockLocationTreatment = 'PHYSICAL_BLOCK_LOCATION_TREATMENT'
}

export type Treatment_PhysicalBlockMetadataMsg = {
  __typename?: 'treatment_PhysicalBlockMetadataMsg';
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  singleton?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Treatment_PhysicalBlockType>;
};

export type Treatment_PhysicalBlockMsg = {
  __typename?: 'treatment_PhysicalBlockMsg';
  blockMetadata?: Maybe<Treatment_PhysicalBlockMetadataMsg>;
  cardNumber?: Maybe<Scalars['Int']>;
  content?: Maybe<Treatment_PhysicalBlockContentMsg>;
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_PhysicalBlockLocation>;
  /** Id of physical examination that owns the block */
  owningPhysicalId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
  timestamps?: Maybe<TimeMsg>;
};

export type Treatment_PhysicalBlockPresetMsg = {
  __typename?: 'treatment_PhysicalBlockPresetMsg';
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  content?: Maybe<Treatment_PhysicalBlockContentMsg>;
  id?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export enum Treatment_PhysicalBlockType {
  /** Not a real block; used to allow displaying data from outside the examination (e.g., images) */
  PhysicalBlockTypeDummy = 'PHYSICAL_BLOCK_TYPE_DUMMY',
  /** Data is entered per treatment */
  PhysicalBlockTypeDynamic = 'PHYSICAL_BLOCK_TYPE_DYNAMIC',
  PhysicalBlockTypeNone = 'PHYSICAL_BLOCK_TYPE_NONE'
}

export type Treatment_PhysicalCardMsg = {
  __typename?: 'treatment_PhysicalCardMsg';
  blocks?: Maybe<Array<Maybe<Treatment_PhysicalBlockMsg>>>;
  metadata?: Maybe<Treatment_CardMetadataMsg>;
  owningPhysicalId?: Maybe<Scalars['String']>;
};

export enum Treatment_PhysicalCondition {
  PhysicalConditionBad = 'PHYSICAL_CONDITION_BAD',
  PhysicalConditionGood = 'PHYSICAL_CONDITION_GOOD',
  PhysicalConditionNone = 'PHYSICAL_CONDITION_NONE',
  PhysicalConditionPoor = 'PHYSICAL_CONDITION_POOR',
  PhysicalConditionVeryBad = 'PHYSICAL_CONDITION_VERY_BAD'
}

export type Treatment_PhysicalExaminationList = {
  __typename?: 'treatment_PhysicalExaminationList';
  physicalExaminationList?: Maybe<Array<Maybe<Treatment_PhysicalExaminationMsg>>>;
};

export enum Treatment_PhysicalExaminationLocation {
  PhysicalExaminationLocationNone = 'PHYSICAL_EXAMINATION_LOCATION_NONE',
  PhysicalExaminationLocationPatientChart = 'PHYSICAL_EXAMINATION_LOCATION_PATIENT_CHART',
  PhysicalExaminationLocationTreatment = 'PHYSICAL_EXAMINATION_LOCATION_TREATMENT'
}

export type Treatment_PhysicalExaminationMsg = {
  __typename?: 'treatment_PhysicalExaminationMsg';
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_PhysicalExaminationLocation>;
  sections?: Maybe<Array<Maybe<Treatment_PhysicalSectionMsg>>>;
  timestamps?: Maybe<TimeMsg>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_PhysicalPresetList = {
  __typename?: 'treatment_PhysicalPresetList';
  presets?: Maybe<Array<Maybe<Treatment_PhysicalPresetMsg>>>;
};

export type Treatment_PhysicalPresetMsg = {
  __typename?: 'treatment_PhysicalPresetMsg';
  blockPresets?: Maybe<Array<Maybe<Treatment_PhysicalBlockPresetMsg>>>;
  creatorUserId?: Maybe<Scalars['String']>;
  /** Only one default preset is allowed per owner (i.e., combination of ownerType and ownerId), this is checked in the backend. */
  defaultPreset?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Treatment_PhysicalPresetOwnerReferenceMsg>;
  scope?: Maybe<Treatment_PhysicalPresetScopeMsg>;
};

export type Treatment_PhysicalPresetOwnerReferenceMsg = {
  __typename?: 'treatment_PhysicalPresetOwnerReferenceMsg';
  ownerId?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Treatment_PhysicalPresetOwnerType>;
};

export enum Treatment_PhysicalPresetOwnerType {
  PhysicalPresetOwnerAvelios = 'PHYSICAL_PRESET_OWNER_AVELIOS',
  PhysicalPresetOwnerClinic = 'PHYSICAL_PRESET_OWNER_CLINIC',
  PhysicalPresetOwnerDepartment = 'PHYSICAL_PRESET_OWNER_DEPARTMENT',
  PhysicalPresetOwnerDivision = 'PHYSICAL_PRESET_OWNER_DIVISION',
  PhysicalPresetOwnerNone = 'PHYSICAL_PRESET_OWNER_NONE',
  PhysicalPresetOwnerOrganizationalUnit = 'PHYSICAL_PRESET_OWNER_ORGANIZATIONAL_UNIT',
  PhysicalPresetOwnerUser = 'PHYSICAL_PRESET_OWNER_USER'
}

export type Treatment_PhysicalPresetScopeMsg = {
  __typename?: 'treatment_PhysicalPresetScopeMsg';
  number?: Maybe<Scalars['Int']>;
  /** Relevant only for PHYSICAL_PRESET_SCOPE_BLOCK */
  parentNumber?: Maybe<Scalars['Int']>;
  scopeType?: Maybe<Treatment_PhysicalPresetScopeType>;
};

export enum Treatment_PhysicalPresetScopeType {
  PhysicalPresetScopeBlock = 'PHYSICAL_PRESET_SCOPE_BLOCK',
  PhysicalPresetScopeCard = 'PHYSICAL_PRESET_SCOPE_CARD',
  PhysicalPresetScopeNone = 'PHYSICAL_PRESET_SCOPE_NONE',
  PhysicalPresetScopePhysicalExamination = 'PHYSICAL_PRESET_SCOPE_PHYSICAL_EXAMINATION',
  PhysicalPresetScopeSection = 'PHYSICAL_PRESET_SCOPE_SECTION'
}

export type Treatment_PhysicalSectionMsg = {
  __typename?: 'treatment_PhysicalSectionMsg';
  cards?: Maybe<Array<Maybe<Treatment_PhysicalCardMsg>>>;
  metadata?: Maybe<Treatment_SectionMetadataMsg>;
  owningPhysicalId?: Maybe<Scalars['String']>;
};

export type Treatment_PhysicalTemplateMsg = {
  __typename?: 'treatment_PhysicalTemplateMsg';
  /** The section/card/block that is displayed by default when opening the physical examination */
  defaultPath?: Maybe<Treatment_PathKeyMsg>;
  id?: Maybe<Scalars['String']>;
  ownerOrganizationalUnitId?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Treatment_SectionTemplateMsg>>>;
  shortcuts?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: Maybe<Treatment_TreatmentType>;
  version?: Maybe<Scalars['Int']>;
};

export type Treatment_PiCcMsg = {
  __typename?: 'treatment_PiCCMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  numberOfLumen?: Maybe<Scalars['Int']>;
};

export type Treatment_PivMsg = {
  __typename?: 'treatment_PivMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Core_KnowledgeInputMsg>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
};

export type Treatment_PleuralPunctureMsg = {
  __typename?: 'treatment_PleuralPunctureMsg';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_PolysynapticReflexesBlock = {
  __typename?: 'treatment_PolysynapticReflexesBlock';
  abdomialSkinReflex?: Maybe<Scalars['Boolean']>;
  abdomialSkinReflexText?: Maybe<Scalars['String']>;
  analReflex?: Maybe<Scalars['Boolean']>;
  analReflexText?: Maybe<Scalars['String']>;
  babinskiReflexLeft?: Maybe<Scalars['Boolean']>;
  babinskiReflexLeftText?: Maybe<Scalars['String']>;
  babinskiReflexRight?: Maybe<Scalars['Boolean']>;
  babinskiReflexRightText?: Maybe<Scalars['String']>;
  bulbocavernosusReflex?: Maybe<Scalars['Boolean']>;
  bulbocavernosusReflexText?: Maybe<Scalars['String']>;
  cornealReflexLeft?: Maybe<Scalars['Boolean']>;
  cornealReflexLeftText?: Maybe<Scalars['String']>;
  cornealReflexRight?: Maybe<Scalars['Boolean']>;
  cornealReflexRightText?: Maybe<Scalars['String']>;
  coughReflex?: Maybe<Scalars['Boolean']>;
  coughReflexText?: Maybe<Scalars['String']>;
  cremastericReflexLeft?: Maybe<Scalars['Boolean']>;
  cremastericReflexLeftText?: Maybe<Scalars['String']>;
  cremastericReflexRight?: Maybe<Scalars['Boolean']>;
  cremastericReflexRightText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  gagReflex?: Maybe<Scalars['Boolean']>;
  gagReflexText?: Maybe<Scalars['String']>;
  lightReactionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  lightReactionTestText?: Maybe<Scalars['String']>;
  vestibuloOcularReflex?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  vestibuloOcularReflexText?: Maybe<Scalars['String']>;
};

export type Treatment_PortCatheterMsg = {
  __typename?: 'treatment_PortCatheterMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  /** unit: mm (Millimeters) */
  needleLength?: Maybe<Scalars['Int']>;
};

export type Treatment_PostureAndStandBlock = {
  __typename?: 'treatment_PostureAndStandBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  jumping?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  jumpingText?: Maybe<Scalars['String']>;
  posture?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  postureAndStand?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  postureText?: Maybe<Scalars['String']>;
  retropulsionTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  retropulsionTestText?: Maybe<Scalars['String']>;
  rombergsTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  rombergsTestText?: Maybe<Scalars['String']>;
  singleLegStand?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  singleLegStandText?: Maybe<Scalars['String']>;
  twoLeggedStand?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  twoLeggedStandText?: Maybe<Scalars['String']>;
  unterbergersTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  unterbergersTestText?: Maybe<Scalars['String']>;
};

export enum Treatment_PostureType {
  PostureCalm = 'POSTURE_CALM',
  PostureNone = 'POSTURE_NONE',
  PostureRestless = 'POSTURE_RESTLESS'
}

export enum Treatment_PreExistingConditions {
  /** high-risk diagnosis (17) */
  PreExistingConditionsHighRiskDiagnosis = 'PRE_EXISTING_CONDITIONS_HIGH_RISK_DIAGNOSIS',
  /** low-risk diagnosis (10) */
  PreExistingConditionsLowRiskDiagnosis = 'PRE_EXISTING_CONDITIONS_LOW_RISK_DIAGNOSIS',
  PreExistingConditionsNone = 'PRE_EXISTING_CONDITIONS_NONE'
}

export type Treatment_PreExistingConditionsBlock = {
  __typename?: 'treatment_PreExistingConditionsBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_PrecordialBruitBlock = {
  __typename?: 'treatment_PrecordialBruitBlock';
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_PreoperartiveSpO2 {
  /** 91-95 (8) */
  PreoperativeSpo2Between_91And_95 = 'PREOPERATIVE_SPO2_BETWEEN_91_AND_95',
  /** ≥96 (0) */
  PreoperativeSpo2GreaterThanOrEqual_96 = 'PREOPERATIVE_SPO2_GREATER_THAN_OR_EQUAL_96',
  /** ≤90 (24) */
  PreoperativeSpo2LessThanOrEqual_90 = 'PREOPERATIVE_SPO2_LESS_THAN_OR_EQUAL_90',
  PreoperativeSpo2None = 'PREOPERATIVE_SPO2_NONE'
}

export enum Treatment_PresentAcuteRespiratoryDisease {
  PresentAcuteRespiratoryDiseaseBronchialInfection = 'PRESENT_ACUTE_RESPIRATORY_DISEASE_BRONCHIAL_INFECTION',
  PresentAcuteRespiratoryDiseaseLungDisease = 'PRESENT_ACUTE_RESPIRATORY_DISEASE_LUNG_DISEASE',
  PresentAcuteRespiratoryDiseaseMildInfection = 'PRESENT_ACUTE_RESPIRATORY_DISEASE_MILD_INFECTION',
  PresentAcuteRespiratoryDiseaseNone = 'PRESENT_ACUTE_RESPIRATORY_DISEASE_NONE',
  PresentAcuteRespiratoryDiseaseNotAtAll = 'PRESENT_ACUTE_RESPIRATORY_DISEASE_NOT_AT_ALL'
}

export type Treatment_PreviousExaminationMsg = {
  __typename?: 'treatment_PreviousExaminationMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  opsId?: Maybe<Treatment_OpsInformationMsg>;
  therapist?: Maybe<Treatment_TherapistMsg>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_PreviousLungDisease {
  PreviousLungDiseaseMildInfections = 'PREVIOUS_LUNG_DISEASE_MILD_INFECTIONS',
  PreviousLungDiseaseNone = 'PREVIOUS_LUNG_DISEASE_NONE',
  PreviousLungDiseaseNotAtAll = 'PREVIOUS_LUNG_DISEASE_NOT_AT_ALL',
  PreviousLungDiseaseSevereCourses = 'PREVIOUS_LUNG_DISEASE_SEVERE_COURSES',
  PreviousLungDiseaseWithPermanentRespiratoryLimitation = 'PREVIOUS_LUNG_DISEASE_WITH_PERMANENT_RESPIRATORY_LIMITATION'
}

export type Treatment_PreviousPregnanciesBlock = {
  __typename?: 'treatment_PreviousPregnanciesBlock';
  gravida?: Maybe<Scalars['Int']>;
  numberCaesareanSections?: Maybe<Scalars['Int']>;
  para?: Maybe<Scalars['Int']>;
  pastCaesareanSection?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_PreviousSurgeriesBlock = {
  __typename?: 'treatment_PreviousSurgeriesBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_PreviousTherapyMsg = {
  __typename?: 'treatment_PreviousTherapyMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  medicationId?: Maybe<Core_KnowledgeInputMsg>;
  opsId?: Maybe<Treatment_OpsInformationMsg>;
  therapist?: Maybe<Treatment_TherapistMsg>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export type Treatment_PreviousTreatmentInfo = {
  __typename?: 'treatment_PreviousTreatmentInfo';
  primaryDiagnosisDescriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentDetails?: Maybe<Treatment_TreatmentDetailsMsg>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_PreviousTreatmentInfoList = {
  __typename?: 'treatment_PreviousTreatmentInfoList';
  treatments?: Maybe<Array<Maybe<Treatment_PreviousTreatmentInfo>>>;
};

export enum Treatment_ProblemSolving {
  ProblemSolvingEssentiallyUndisturbed = 'PROBLEM_SOLVING_ESSENTIALLY_UNDISTURBED',
  ProblemSolvingNone = 'PROBLEM_SOLVING_NONE',
  ProblemSolvingRequiresLittleAssistance = 'PROBLEM_SOLVING_REQUIRES_LITTLE_ASSISTANCE',
  ProblemSolvingRequiresMajorAssistance = 'PROBLEM_SOLVING_REQUIRES_MAJOR_ASSISTANCE'
}

export enum Treatment_ProblemSpecificAnamnesisType {
  ProblemSpecificAnamnesisTypeAnamnesticProgress = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_ANAMNESTIC_PROGRESS',
  ProblemSpecificAnamnesisTypeAnesthesiaBackground = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_ANESTHESIA_BACKGROUND',
  ProblemSpecificAnamnesisTypeNone = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_NONE',
  ProblemSpecificAnamnesisTypeReasonForAdmission = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_REASON_FOR_ADMISSION',
  ProblemSpecificAnamnesisTypeReasonForCareAdmission = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_REASON_FOR_CARE_ADMISSION',
  ProblemSpecificAnamnesisTypeReasonForPresentation = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_REASON_FOR_PRESENTATION',
  ProblemSpecificAnamnesisTypeSurgeryPreparation = 'PROBLEM_SPECIFIC_ANAMNESIS_TYPE_SURGERY_PREPARATION'
}

export type Treatment_ProstateExaminationBlock = {
  __typename?: 'treatment_ProstateExaminationBlock';
  mucousMembraneMovable?: Maybe<Scalars['Boolean']>;
  pressurePainPresent?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Core_KnowledgeInputMsg>;
  text?: Maybe<Scalars['String']>;
  textures?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_ProteinIntake {
  /** at least once a day dairy products (0.5) */
  ProteinIntakeAtLeastOnceADayDairyProducts = 'PROTEIN_INTAKE_AT_LEAST_ONCE_A_DAY_DAIRY_PRODUCTS',
  /** at least twice a week legumes or eggs (0.5) */
  ProteinIntakeAtLeastTwiceAWeekLegumesOrEggs = 'PROTEIN_INTAKE_AT_LEAST_TWICE_A_WEEK_LEGUMES_OR_EGGS',
  /** daily meat, fish, or poultry (0.5) */
  ProteinIntakeDailyMeatFishOrPoultry = 'PROTEIN_INTAKE_DAILY_MEAT_FISH_OR_POULTRY',
  ProteinIntakeNone = 'PROTEIN_INTAKE_NONE'
}

export enum Treatment_ProthrombinTimeByQuick {
  /** ≥40 to <60 (2) */
  ProthrombinTimeByQuickBetween_40InclusiveAnd_60Exclusive = 'PROTHROMBIN_TIME_BY_QUICK_BETWEEN_40_INCLUSIVE_AND_60_EXCLUSIVE',
  /** ≥60 (0) */
  ProthrombinTimeByQuickGreaterThanOrEqual_60 = 'PROTHROMBIN_TIME_BY_QUICK_GREATER_THAN_OR_EQUAL_60',
  /** <40 (6) */
  ProthrombinTimeByQuickLessThan_40 = 'PROTHROMBIN_TIME_BY_QUICK_LESS_THAN_40',
  ProthrombinTimeByQuickNone = 'PROTHROMBIN_TIME_BY_QUICK_NONE'
}

export type Treatment_PsychopathologicalFindingsBlock = {
  __typename?: 'treatment_PsychopathologicalFindingsBlock';
  htmlText?: Maybe<Scalars['String']>;
};

export enum Treatment_PublicTransportation {
  PublicTransportationCannotUse = 'PUBLIC_TRANSPORTATION_CANNOT_USE',
  PublicTransportationCanUse = 'PUBLIC_TRANSPORTATION_CAN_USE',
  PublicTransportationNone = 'PUBLIC_TRANSPORTATION_NONE'
}

export enum Treatment_PulseEnum {
  PulseEnumGreaterThan_100 = 'PULSE_ENUM_GREATER_THAN_100',
  PulseEnumLessThan_100 = 'PULSE_ENUM_LESS_THAN_100',
  PulseEnumNone = 'PULSE_ENUM_NONE',
  PulseEnumNoPulse = 'PULSE_ENUM_NO_PULSE'
}

export type Treatment_PulsePalpationAbdomenBlock = {
  __typename?: 'treatment_PulsePalpationAbdomenBlock';
  pulsePalpation?: Maybe<Treatment_PulsePalpationAbdomenType>;
  pulsePalpationText?: Maybe<Scalars['String']>;
};

export enum Treatment_PulsePalpationAbdomenType {
  PulsePalpationAbdomenNone = 'PULSE_PALPATION_ABDOMEN_NONE',
  PulsePalpationAbdomenNotPalpable = 'PULSE_PALPATION_ABDOMEN_NOT_PALPABLE',
  PulsePalpationAbdomenPalpable = 'PULSE_PALPATION_ABDOMEN_PALPABLE',
  PulsePalpationAbdomenWeaklyPalpable = 'PULSE_PALPATION_ABDOMEN_WEAKLY_PALPABLE'
}

export type Treatment_PulsePalpationLowerExtremityBlock = {
  __typename?: 'treatment_PulsePalpationLowerExtremityBlock';
  left?: Maybe<Treatment_PulsePalpationLowerExtremityMsg>;
  right?: Maybe<Treatment_PulsePalpationLowerExtremityMsg>;
};

export type Treatment_PulsePalpationLowerExtremityMsg = {
  __typename?: 'treatment_PulsePalpationLowerExtremityMsg';
  dorsalisPedisArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  dorsalisPedisArteryText?: Maybe<Scalars['String']>;
  femoralArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  femoralArteryText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  poplitealArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  poplitealArteryText?: Maybe<Scalars['String']>;
  posteriorTibialArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  posteriorTibialArteryText?: Maybe<Scalars['String']>;
};

export type Treatment_PulsePalpationUpperExtremityBlock = {
  __typename?: 'treatment_PulsePalpationUpperExtremityBlock';
  left?: Maybe<Treatment_PulsePalpationUpperExtremityMsg>;
  right?: Maybe<Treatment_PulsePalpationUpperExtremityMsg>;
};

export type Treatment_PulsePalpationUpperExtremityMsg = {
  __typename?: 'treatment_PulsePalpationUpperExtremityMsg';
  brachialArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  brachialArteryText?: Maybe<Scalars['String']>;
  carotidArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  carotidArteryText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  radialArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  radialArteryText?: Maybe<Scalars['String']>;
  subclavianArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  subclavianArteryText?: Maybe<Scalars['String']>;
  ulnarArtery?: Maybe<Treatment_VascularSystemPalpationResult>;
  ulnarArteryText?: Maybe<Scalars['String']>;
};

export enum Treatment_PulseRhythmType {
  PulseRhythmArrhythmic = 'PULSE_RHYTHM_ARRHYTHMIC',
  PulseRhythmNone = 'PULSE_RHYTHM_NONE',
  PulseRhythmRhythmic = 'PULSE_RHYTHM_RHYTHMIC'
}

export enum Treatment_PupilForm {
  PupilFormNone = 'PUPIL_FORM_NONE',
  PupilFormNotRound = 'PUPIL_FORM_NOT_ROUND',
  PupilFormRound = 'PUPIL_FORM_ROUND'
}

export enum Treatment_PupilSize {
  PupilSizeEnlarged = 'PUPIL_SIZE_ENLARGED',
  PupilSizeNone = 'PUPIL_SIZE_NONE',
  PupilSizeNormal = 'PUPIL_SIZE_NORMAL',
  PupilSizeReduced = 'PUPIL_SIZE_REDUCED'
}

export enum Treatment_PupilSizeRelationship {
  PupilSizeRelationAnisocore = 'PUPIL_SIZE_RELATION_ANISOCORE',
  PupilSizeRelationIsocore = 'PUPIL_SIZE_RELATION_ISOCORE',
  PupilSizeRelationNone = 'PUPIL_SIZE_RELATION_NONE'
}

export enum Treatment_PupillaryResponse {
  /** both sides reactive or size <3 mm diameter (0) */
  PupillaryResponseBothSidesReactiveOrLessThan_3Mm = 'PUPILLARY_RESPONSE_BOTH_SIDES_REACTIVE_OR_LESS_THAN_3_MM',
  PupillaryResponseNone = 'PUPILLARY_RESPONSE_NONE',
  /** both sides light-rigid and size ≥3 mm diameter (8) */
  PupillaryResponseOneSideLightRigidAndGreaterThanOrEqual_3Mm = 'PUPILLARY_RESPONSE_ONE_SIDE_LIGHT_RIGID_AND_GREATER_THAN_OR_EQUAL_3_MM',
  /** only one side reactive and size ≥3 mm diameter (3) */
  PupillaryResponseOneSideReactiveAndGreaterThanOrEqual_3Mm = 'PUPILLARY_RESPONSE_ONE_SIDE_REACTIVE_AND_GREATER_THAN_OR_EQUAL_3_MM'
}

export type Treatment_PupilsAndLightReactionBlock = {
  __typename?: 'treatment_PupilsAndLightReactionBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  pupilLeft?: Maybe<Treatment_PupilsMsg>;
  pupilRight?: Maybe<Treatment_PupilsMsg>;
  pupilSizeRelationship?: Maybe<Treatment_PupilSizeRelationship>;
  pupilSizeRelationshipText?: Maybe<Scalars['String']>;
  pupilsAndLightReaction?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_PupilsMsg = {
  __typename?: 'treatment_PupilsMsg';
  directLightReaction?: Maybe<Treatment_LightReaction>;
  directLightReactionText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  indirectLightReaction?: Maybe<Treatment_LightReaction>;
  indirectLightReactionText?: Maybe<Scalars['String']>;
  pupilForm?: Maybe<Treatment_PupilForm>;
  pupilFormText?: Maybe<Scalars['String']>;
  pupilSize?: Maybe<Treatment_PupilSize>;
  pupilSizeText?: Maybe<Scalars['String']>;
};

export enum Treatment_PurgingMethod {
  PurgingMethodMedication = 'PURGING_METHOD_MEDICATION',
  PurgingMethodNone = 'PURGING_METHOD_NONE',
  PurgingMethodOther = 'PURGING_METHOD_OTHER',
  PurgingMethodVomiting = 'PURGING_METHOD_VOMITING'
}

export type Treatment_PurgingMsg = {
  __typename?: 'treatment_PurgingMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  medications?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  methods?: Maybe<Array<Maybe<Treatment_PurgingMethod>>>;
  otherMethodDescription?: Maybe<Scalars['String']>;
  vomitingType?: Maybe<Treatment_PurgingVomiting>;
};

export enum Treatment_PurgingVomiting {
  PurgingVomitingInduced = 'PURGING_VOMITING_INDUCED',
  PurgingVomitingNone = 'PURGING_VOMITING_NONE',
  PurgingVomitingSpontaneous = 'PURGING_VOMITING_SPONTANEOUS'
}

export type Treatment_PushTreatmentDiagnosesRequest = {
  __typename?: 'treatment_PushTreatmentDiagnosesRequest';
  treatmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_PushTreatmentDiagnosesResponse = {
  __typename?: 'treatment_PushTreatmentDiagnosesResponse';
  failedTreatmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  successfulTreatmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_QsofaBlock = {
  __typename?: 'treatment_QsofaBlock';
  /** altered mentation or GCS less than 15: <yes (1) / no (0)> */
  alteredMentation?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** respiratory rate greater or equal than 22 per minute: <yes (1) / no (0)> */
  respiratoryRate?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** systolic blood pressure less than or equal 100 mmHg: <yes (1) / no (0)> */
  systolicBloodPressure?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_QuadricepsMuscleStrength {
  QuadricepsMuscleStrength_1To_2 = 'QUADRICEPS_MUSCLE_STRENGTH_1_TO_2',
  QuadricepsMuscleStrength_3 = 'QUADRICEPS_MUSCLE_STRENGTH_3',
  QuadricepsMuscleStrength_4To_5 = 'QUADRICEPS_MUSCLE_STRENGTH_4_TO_5',
  QuadricepsMuscleStrengthNone = 'QUADRICEPS_MUSCLE_STRENGTH_NONE'
}

export type Treatment_QualitativeConsciousnessBlock = {
  __typename?: 'treatment_QualitativeConsciousnessBlock';
  cloudingOfConsciousness?: Maybe<Scalars['Boolean']>;
  cloudingOfConsciousnessText?: Maybe<Scalars['String']>;
  consciousnessConstriction?: Maybe<Scalars['Boolean']>;
  consciousnessConstrictionText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  shiftInConsciousness?: Maybe<Scalars['Boolean']>;
  shiftInConsciousnessText?: Maybe<Scalars['String']>;
};

export enum Treatment_QuickValue {
  /** % : 40-70 (2) */
  QuickValueBetween_40And_70 = 'QUICK_VALUE_BETWEEN_40_AND_70',
  /** % : < >70 (1) */
  QuickValueGreaterThan_70 = 'QUICK_VALUE_GREATER_THAN_70',
  /** % : <40 (3) */
  QuickValueLessThan_40 = 'QUICK_VALUE_LESS_THAN_40',
  QuickValueNone = 'QUICK_VALUE_NONE'
}

export enum Treatment_RateNutritionalStatus {
  /** lacks nutrition (0) */
  RateNutritionalStatusLacksNutrition = 'RATE_NUTRITIONAL_STATUS_LACKS_NUTRITION',
  RateNutritionalStatusNone = 'RATE_NUTRITIONAL_STATUS_NONE',
  /** is unsure (1) */
  RateNutritionalStatusUnsure = 'RATE_NUTRITIONAL_STATUS_UNSURE',
  /** well nourished (2) */
  RateNutritionalStatusWellNourished = 'RATE_NUTRITIONAL_STATUS_WELL_NOURISHED'
}

export enum Treatment_ReactionSeverity {
  ReactionSeverityMild = 'REACTION_SEVERITY_MILD',
  ReactionSeverityModerate = 'REACTION_SEVERITY_MODERATE',
  ReactionSeverityNone = 'REACTION_SEVERITY_NONE',
  ReactionSeveritySevere = 'REACTION_SEVERITY_SEVERE'
}

export enum Treatment_ReactionStatus {
  ReactionStatusActive = 'REACTION_STATUS_ACTIVE',
  ReactionStatusInactive = 'REACTION_STATUS_INACTIVE',
  ReactionStatusNone = 'REACTION_STATUS_NONE',
  ReactionStatusResolved = 'REACTION_STATUS_RESOLVED'
}

export enum Treatment_ReactionType {
  ReactionTypeAllergy = 'REACTION_TYPE_ALLERGY',
  ReactionTypeIntolerance = 'REACTION_TYPE_INTOLERANCE',
  ReactionTypeNone = 'REACTION_TYPE_NONE'
}

export type Treatment_ReactivateWoundRequest = {
  __typename?: 'treatment_ReactivateWoundRequest';
  woundId?: Maybe<Scalars['String']>;
};

export type Treatment_ReactivateWoundResponse = {
  __typename?: 'treatment_ReactivateWoundResponse';
  reactivatedWoundId?: Maybe<Scalars['String']>;
};

export type Treatment_ReasonForAdmissionMsg = {
  __typename?: 'treatment_ReasonForAdmissionMsg';
  /** If linked to an appointment otherwise empty */
  appointmentId?: Maybe<Scalars['String']>;
  diagnosisPresences?: Maybe<Array<Maybe<Treatment_DiagnosisPresenceMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  previousExaminations?: Maybe<Array<Maybe<Treatment_PreviousExaminationMsg>>>;
  previousExaminationsPresent?: Maybe<Scalars['Boolean']>;
  previousHistoryHtml?: Maybe<Scalars['String']>;
  previousTherapies?: Maybe<Array<Maybe<Treatment_PreviousTherapyMsg>>>;
  previousTherapiesPresent?: Maybe<Scalars['Boolean']>;
  reasonsForAdmission?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  recorderType?: Maybe<Core_RecorderType>;
  symptomChangePresent?: Maybe<Scalars['Boolean']>;
  symptomChangeText?: Maybe<Scalars['String']>;
  symptomOccurrences?: Maybe<Array<Maybe<Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
};

export type Treatment_ReasonForCareAdmissionMsg = {
  __typename?: 'treatment_ReasonForCareAdmissionMsg';
  id?: Maybe<Scalars['String']>;
  reasonForCareAdmission?: Maybe<Scalars['String']>;
};

export type Treatment_ReasonForPresentationMsg = {
  __typename?: 'treatment_ReasonForPresentationMsg';
  /** If linked to an appointment otherwise empty */
  appointmentId?: Maybe<Scalars['String']>;
  diagnosisDevelopments?: Maybe<Array<Maybe<Treatment_DiagnosisDevelopmentMsg>>>;
  diagnosisPresences?: Maybe<Array<Maybe<Treatment_DiagnosisPresenceMsg>>>;
  /** false if follow-up */
  firstExamination?: Maybe<Scalars['Boolean']>;
  followUpExaminationText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  previousExaminations?: Maybe<Array<Maybe<Treatment_PreviousExaminationMsg>>>;
  previousExaminationsPresent?: Maybe<Scalars['Boolean']>;
  /** @deprecated deprecated in proto */
  previousHistory?: Maybe<Scalars['String']>;
  previousHistoryHtml?: Maybe<Scalars['String']>;
  previousTherapies?: Maybe<Array<Maybe<Treatment_PreviousTherapyMsg>>>;
  previousTherapiesPresent?: Maybe<Scalars['Boolean']>;
  reasonsForPresentation?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  recorderType?: Maybe<Core_RecorderType>;
  symptomChangePresent?: Maybe<Scalars['Boolean']>;
  symptomChangeText?: Maybe<Scalars['String']>;
  symptomOccurrences?: Maybe<Array<Maybe<Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
};

export type Treatment_ReassignDiagnosesRequest = {
  __typename?: 'treatment_ReassignDiagnosesRequest';
  alsoReassignEditable?: Maybe<Scalars['Boolean']>;
  sourceAssignments?: Maybe<Array<Maybe<Treatment_DiagnosisCategoryAssignmentMsg>>>;
  targets?: Maybe<Array<Maybe<Treatment_ReassignDiagnosesTargetMsg>>>;
};

export type Treatment_ReassignDiagnosesResponse = {
  __typename?: 'treatment_ReassignDiagnosesResponse';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
};

export type Treatment_ReassignDiagnosesTargetMsg = {
  __typename?: 'treatment_ReassignDiagnosesTargetMsg';
  scopeId?: Maybe<Scalars['String']>;
  scopeType?: Maybe<Treatment_DiagnosisScopeType>;
};

export enum Treatment_RecallingWord {
  RecallingWordsBanana = 'RECALLING_WORDS_BANANA',
  RecallingWordsGreen = 'RECALLING_WORDS_GREEN',
  RecallingWordsNone = 'RECALLING_WORDS_NONE',
  RecallingWordsTable = 'RECALLING_WORDS_TABLE',
  RecallingWordsTruck = 'RECALLING_WORDS_TRUCK',
  RecallingWordsViolin = 'RECALLING_WORDS_VIOLIN'
}

export type Treatment_RecentTravelsBlock = {
  __typename?: 'treatment_RecentTravelsBlock';
  present?: Maybe<Scalars['Boolean']>;
  recentDestinations?: Maybe<Array<Maybe<Treatment_TravelDestinationMsg>>>;
};

export enum Treatment_RecognizingFeatures {
  RecognizingFeaturesNone = 'RECOGNIZING_FEATURES_NONE',
  /** recognized one common feature */
  RecognizingFeaturesOne = 'RECOGNIZING_FEATURES_ONE',
  /** recognized both common feature */
  RecognizingFeaturesTwo = 'RECOGNIZING_FEATURES_TWO',
  /** recognized no common feature */
  RecognizingFeaturesZero = 'RECOGNIZING_FEATURES_ZERO'
}

export enum Treatment_RecommendationCompliance {
  RecommendationComplianceNone = 'RECOMMENDATION_COMPLIANCE_NONE',
  RecommendationComplianceNotPerformed = 'RECOMMENDATION_COMPLIANCE_NOT_PERFORMED',
  RecommendationComplianceNotYetPerformed = 'RECOMMENDATION_COMPLIANCE_NOT_YET_PERFORMED',
  RecommendationComplianceNoInformation = 'RECOMMENDATION_COMPLIANCE_NO_INFORMATION',
  RecommendationCompliancePartiallyPerformed = 'RECOMMENDATION_COMPLIANCE_PARTIALLY_PERFORMED',
  RecommendationCompliancePerformed = 'RECOMMENDATION_COMPLIANCE_PERFORMED'
}

export enum Treatment_RecurrenceRisk {
  RecurrenceRiskHigh = 'RECURRENCE_RISK_HIGH',
  RecurrenceRiskLow = 'RECURRENCE_RISK_LOW',
  RecurrenceRiskNone = 'RECURRENCE_RISK_NONE',
  RecurrenceRiskUnableToAssess = 'RECURRENCE_RISK_UNABLE_TO_ASSESS'
}

export enum Treatment_ReflexStatus {
  ReflexStatusCannotTrigger = 'REFLEX_STATUS_CANNOT_TRIGGER',
  ReflexStatusCloniform = 'REFLEX_STATUS_CLONIFORM',
  ReflexStatusIncreased = 'REFLEX_STATUS_INCREASED',
  ReflexStatusLively = 'REFLEX_STATUS_LIVELY',
  ReflexStatusMediumLively = 'REFLEX_STATUS_MEDIUM_LIVELY',
  ReflexStatusNone = 'REFLEX_STATUS_NONE',
  ReflexStatusWeak = 'REFLEX_STATUS_WEAK'
}

export enum Treatment_RegurgitationOnset {
  RegurgitationOnsetImmediate = 'REGURGITATION_ONSET_IMMEDIATE',
  RegurgitationOnsetInProgress = 'REGURGITATION_ONSET_IN_PROGRESS',
  RegurgitationOnsetNone = 'REGURGITATION_ONSET_NONE'
}

export enum Treatment_RelationshipWithCaregiver {
  RelationshipWithCaregiverConflictualAndTense = 'RELATIONSHIP_WITH_CAREGIVER_CONFLICTUAL_AND_TENSE',
  RelationshipWithCaregiverHarmoniousTrusting = 'RELATIONSHIP_WITH_CAREGIVER_HARMONIOUS_TRUSTING',
  RelationshipWithCaregiverNone = 'RELATIONSHIP_WITH_CAREGIVER_NONE'
}

export type Treatment_RelevantAnesthesiaComplicationInfoMsg = {
  __typename?: 'treatment_RelevantAnesthesiaComplicationInfoMsg';
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_RelevantDiagnosisInfoMsg = {
  __typename?: 'treatment_RelevantDiagnosisInfoMsg';
  codes?: Maybe<Array<Maybe<Treatment_DiagnosisCodingMsg>>>;
  description?: Maybe<Scalars['String']>;
};

export type Treatment_RelevantReasonForPresentationInfoMsg = {
  __typename?: 'treatment_RelevantReasonForPresentationInfoMsg';
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_RelevantSymptomInfoMsg = {
  __typename?: 'treatment_RelevantSymptomInfoMsg';
  generalId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_RemoveSymptomConfigurationRequest = {
  __typename?: 'treatment_RemoveSymptomConfigurationRequest';
  symptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_RemoveSymptomConfigurationResponse = {
  __typename?: 'treatment_RemoveSymptomConfigurationResponse';
  removedSymptomConfigurationId?: Maybe<Scalars['String']>;
};

export type Treatment_RenalFistulaCatheterMsg = {
  __typename?: 'treatment_RenalFistulaCatheterMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  /** unit: Charr */
  size?: Maybe<Scalars['Float']>;
};

export enum Treatment_RepeatSentence {
  RepeatSentenceNone = 'REPEAT_SENTENCE_NONE',
  /** successful (1) */
  RepeatSentenceSuccessful = 'REPEAT_SENTENCE_SUCCESSFUL',
  /** unsuccessful (1) */
  RepeatSentenceUnsuccessful = 'REPEAT_SENTENCE_UNSUCCESSFUL'
}

export enum Treatment_RepetitionOfNumbersInDictatedOrder {
  RepetitionOfNumbersInDictatedOrderNone = 'REPETITION_OF_NUMBERS_IN_DICTATED_ORDER_NONE',
  RepetitionOfNumbersInDictatedOrderSuccessful = 'REPETITION_OF_NUMBERS_IN_DICTATED_ORDER_SUCCESSFUL',
  RepetitionOfNumbersInDictatedOrderUnsuccessful = 'REPETITION_OF_NUMBERS_IN_DICTATED_ORDER_UNSUCCESSFUL'
}

export enum Treatment_RepetitionOfNumbersInReversedOrder {
  RepetitionOfNumbersInReversedOrderNone = 'REPETITION_OF_NUMBERS_IN_REVERSED_ORDER_NONE',
  RepetitionOfNumbersInReversedOrderSuccessful = 'REPETITION_OF_NUMBERS_IN_REVERSED_ORDER_SUCCESSFUL',
  RepetitionOfNumbersInReversedOrderUnsuccessful = 'REPETITION_OF_NUMBERS_IN_REVERSED_ORDER_UNSUCCESSFUL'
}

export enum Treatment_RepetitionOfSentences {
  RepetitionOfSentencesNone = 'REPETITION_OF_SENTENCES_NONE',
  /** one sentence repeated correctly */
  RepetitionOfSentencesOne = 'REPETITION_OF_SENTENCES_ONE',
  /** both sentences repeated correctly */
  RepetitionOfSentencesTwo = 'REPETITION_OF_SENTENCES_TWO',
  /** no sentence repeated correctly */
  RepetitionOfSentencesZero = 'REPETITION_OF_SENTENCES_ZERO'
}

export type Treatment_ResetAnamnesisBlockValidationRequest = {
  __typename?: 'treatment_ResetAnamnesisBlockValidationRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  blockId?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export enum Treatment_ResistanceLocation {
  OclockEight = 'OCLOCK_EIGHT',
  OclockEleven = 'OCLOCK_ELEVEN',
  OclockFive = 'OCLOCK_FIVE',
  OclockFour = 'OCLOCK_FOUR',
  OclockNine = 'OCLOCK_NINE',
  OclockNone = 'OCLOCK_NONE',
  OclockOne = 'OCLOCK_ONE',
  OclockSeven = 'OCLOCK_SEVEN',
  OclockSix = 'OCLOCK_SIX',
  OclockTen = 'OCLOCK_TEN',
  OclockThree = 'OCLOCK_THREE',
  OclockTwelve = 'OCLOCK_TWELVE',
  OclockTwo = 'OCLOCK_TWO'
}

export type Treatment_RespirationBlock = {
  __typename?: 'treatment_RespirationBlock';
  respirationMeasurements?: Maybe<Array<Maybe<Treatment_RespirationMsg>>>;
};

export enum Treatment_RespirationEnum {
  RespirationEnumAbsent = 'RESPIRATION_ENUM_ABSENT',
  RespirationEnumNone = 'RESPIRATION_ENUM_NONE',
  RespirationEnumStrongRobustCry = 'RESPIRATION_ENUM_STRONG_ROBUST_CRY',
  RespirationEnumWeakIrregularGasping = 'RESPIRATION_ENUM_WEAK_IRREGULAR_GASPING'
}

export enum Treatment_RespirationFrequencyType {
  RespirationFrequencyBradypnea = 'RESPIRATION_FREQUENCY_BRADYPNEA',
  RespirationFrequencyNone = 'RESPIRATION_FREQUENCY_NONE',
  RespirationFrequencyNormopnea = 'RESPIRATION_FREQUENCY_NORMOPNEA',
  RespirationFrequencyTachypnea = 'RESPIRATION_FREQUENCY_TACHYPNEA'
}

export type Treatment_RespirationMsg = {
  __typename?: 'treatment_RespirationMsg';
  depth?: Maybe<Treatment_RespiratoryDepthType>;
  id?: Maybe<Scalars['String']>;
  inspiratoryExpiratoryRatios?: Maybe<Array<Maybe<Treatment_InspiratoryExpiratoryRatio>>>;
  pulseOximetry?: Maybe<Scalars['Float']>;
  respirationFrequency?: Maybe<Scalars['Int']>;
  respirationFrequencyType?: Maybe<Treatment_RespirationFrequencyType>;
  rhythm?: Maybe<Treatment_RespiratoryRhythmType>;
  timeOfMeasurement?: Maybe<VeiosDateTimeMsg>;
};

export enum Treatment_RespiratoryDepressantMedications {
  RespiratoryDepressantMedicationsIrregularUse = 'RESPIRATORY_DEPRESSANT_MEDICATIONS_IRREGULAR_USE',
  RespiratoryDepressantMedicationsNone = 'RESPIRATORY_DEPRESSANT_MEDICATIONS_NONE',
  RespiratoryDepressantMedicationsNotAtAll = 'RESPIRATORY_DEPRESSANT_MEDICATIONS_NOT_AT_ALL',
  RespiratoryDepressantMedicationsRegularMeds = 'RESPIRATORY_DEPRESSANT_MEDICATIONS_REGULAR_MEDS',
  RespiratoryDepressantMedicationsRegularUse = 'RESPIRATORY_DEPRESSANT_MEDICATIONS_REGULAR_USE'
}

export enum Treatment_RespiratoryDepthType {
  RespiratoryDepthDeepened = 'RESPIRATORY_DEPTH_DEEPENED',
  RespiratoryDepthNone = 'RESPIRATORY_DEPTH_NONE',
  RespiratoryDepthNormal = 'RESPIRATORY_DEPTH_NORMAL',
  RespiratoryDepthReduced = 'RESPIRATORY_DEPTH_REDUCED'
}

export enum Treatment_RespiratoryRate {
  RespiratoryRateBetween_14And_20 = 'RESPIRATORY_RATE_BETWEEN_14_AND_20',
  RespiratoryRateIrregularBreathing = 'RESPIRATORY_RATE_IRREGULAR_BREATHING',
  RespiratoryRateNone = 'RESPIRATORY_RATE_NONE',
  RespiratoryRateRegularButBradypneaOrTachypnea = 'RESPIRATORY_RATE_REGULAR_BUT_BRADYPNEA_OR_TACHYPNEA',
  RespiratoryRateVeryIrregularBreathing = 'RESPIRATORY_RATE_VERY_IRREGULAR_BREATHING'
}

export enum Treatment_RespiratoryRhythmType {
  RespiratoryRhythmIrregular = 'RESPIRATORY_RHYTHM_IRREGULAR',
  RespiratoryRhythmNone = 'RESPIRATORY_RHYTHM_NONE',
  RespiratoryRhythmRegular = 'RESPIRATORY_RHYTHM_REGULAR'
}

export enum Treatment_RespiratorySleepDisturbance {
  /** Highly disturbed sleep due to shortness of breath or shortness of breath */
  RespiratorySleepDisturbanceHighlyDisturbedSleep = 'RESPIRATORY_SLEEP_DISTURBANCE_HIGHLY_DISTURBED_SLEEP',
  RespiratorySleepDisturbanceNone = 'RESPIRATORY_SLEEP_DISTURBANCE_NONE',
  /** Repeated sleep disturbance due to shortness of breath or shortness of breath, no use of more than 2 pillows */
  RespiratorySleepDisturbanceRepeatedDisturbance = 'RESPIRATORY_SLEEP_DISTURBANCE_REPEATED_DISTURBANCE',
  /** Sleeping only possible in sitting position */
  RespiratorySleepDisturbanceSittingPosition = 'RESPIRATORY_SLEEP_DISTURBANCE_SITTING_POSITION',
  RespiratorySleepDisturbanceUndisturbed = 'RESPIRATORY_SLEEP_DISTURBANCE_UNDISTURBED',
  /** Regular use of more than 2 pillows required for sleep */
  RespiratorySleepDisturbanceUseMoreThan_2Pillows = 'RESPIRATORY_SLEEP_DISTURBANCE_USE_MORE_THAN_2_PILLOWS'
}

export type Treatment_RestingElectrocardiographyMsg = {
  __typename?: 'treatment_RestingElectrocardiographyMsg';
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_Restlessness {
  RestlessnessConstantlyMovingOrDoingSomething = 'RESTLESSNESS_CONSTANTLY_MOVING_OR_DOING_SOMETHING',
  RestlessnessDifficultToSitStill = 'RESTLESSNESS_DIFFICULT_TO_SIT_STILL',
  RestlessnessMoreRestlessness = 'RESTLESSNESS_MORE_RESTLESSNESS',
  RestlessnessNone = 'RESTLESSNESS_NONE',
  RestlessnessNoRestlessness = 'RESTLESSNESS_NO_RESTLESSNESS'
}

export type Treatment_RevisedCardiacRiskIndexBlock = {
  __typename?: 'treatment_RevisedCardiacRiskIndexBlock';
  /** Cerebrovascular Disease: <yes (1) / no (0)> */
  cerebrovascularDisease?: Maybe<Scalars['Boolean']>;
  /** Serum Creatinine >2 mg/dl or compensated renal insufficiency: <yes (1) / no (0)> */
  compensatedRenalInsufficiency?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Congestive Heart Failure: <yes (1) / no (0)> */
  congestiveHeartFailure?: Maybe<Scalars['Boolean']>;
  /** Coronary Artery Disease: <yes (1) / no (0)> */
  coronaryArteryDisease?: Maybe<Scalars['Boolean']>;
  /** Diabetes Mellitus on Insulin: <yes (1) / no (0)> */
  diabetesMellitusOnInsulin?: Maybe<Scalars['Boolean']>;
  /** High Risk Surgery: <yes (1) / no (0)> */
  highRiskSurgery?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
};

export type Treatment_RiskFactorsMsg = {
  __typename?: 'treatment_RiskFactorsMsg';
  animalExposurePresent?: Maybe<Scalars['Boolean']>;
  animalExposureText?: Maybe<Scalars['String']>;
  consumedRawMilkProductsPresent?: Maybe<Scalars['Boolean']>;
  consumedRawMilkProductsText?: Maybe<Scalars['String']>;
  contactSickPresent?: Maybe<Scalars['Boolean']>;
  contactSickText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  malariaProphylaxisPresent?: Maybe<Scalars['Boolean']>;
  malariaProphylaxisText?: Maybe<Scalars['String']>;
  receivedBloodTransfusionPresent?: Maybe<Scalars['Boolean']>;
  receivedBloodTransfusions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  receivedBloodTransfusionsText?: Maybe<Scalars['String']>;
  sexualRiskContactsPresent?: Maybe<Scalars['Boolean']>;
  sexualRiskContactsText?: Maybe<Scalars['String']>;
  specialActivitiesPresent?: Maybe<Scalars['Boolean']>;
  specialActivitiesText?: Maybe<Scalars['String']>;
  visitsCavesPresent?: Maybe<Scalars['Boolean']>;
  visitsCavesText?: Maybe<Scalars['String']>;
};

export enum Treatment_Sadness {
  SadnessAllTheTime = 'SADNESS_ALL_THE_TIME',
  SadnessNone = 'SADNESS_NONE',
  SadnessNotSad = 'SADNESS_NOT_SAD',
  SadnessOftenSad = 'SADNESS_OFTEN_SAD',
  SadnessSoSadAndUnhappy = 'SADNESS_SO_SAD_AND_UNHAPPY'
}

export enum Treatment_Salivation {
  /** Markedly increased salivation with some loss of saliva */
  SalivationMarkedlyIncreasedWithSomeLoss = 'SALIVATION_MARKEDLY_INCREASED_WITH_SOME_LOSS',
  /** Marked loss of saliva from mouth */
  SalivationMarkedLossFromMouth = 'SALIVATION_MARKED_LOSS_FROM_MOUTH',
  /** Moderately increased salivation; little loss of saliva possible */
  SalivationModeratelyIncreasedOrLittleLoss = 'SALIVATION_MODERATELY_INCREASED_OR_LITTLE_LOSS',
  SalivationNone = 'SALIVATION_NONE',
  /** Slight but definite excess of saliva in mouth; loss of saliva possible at night */
  SalivationSlightExcess = 'SALIVATION_SLIGHT_EXCESS',
  SalivationUndisturbed = 'SALIVATION_UNDISTURBED'
}

export enum Treatment_SapsAdmissionType {
  /** medical (6) */
  SapsAdmissionTypeMedical = 'SAPS_ADMISSION_TYPE_MEDICAL',
  SapsAdmissionTypeNone = 'SAPS_ADMISSION_TYPE_NONE',
  /** not planned surgical (8) */
  SapsAdmissionTypeNotPlannedSurgical = 'SAPS_ADMISSION_TYPE_NOT_PLANNED_SURGICAL',
  /** planned surgical (0) */
  SapsAdmissionTypePlannedSurgical = 'SAPS_ADMISSION_TYPE_PLANNED_SURGICAL'
}

export enum Treatment_SapsAge {
  /** 40-59 (7) */
  SapsAgeBetween_40And_59 = 'SAPS_AGE_BETWEEN_40_AND_59',
  /** 60-69 (12) */
  SapsAgeBetween_60And_69 = 'SAPS_AGE_BETWEEN_60_AND_69',
  /** 70-74 (15) */
  SapsAgeBetween_70And_74 = 'SAPS_AGE_BETWEEN_70_AND_74',
  /** 75-79 (16) */
  SapsAgeBetween_75And_79 = 'SAPS_AGE_BETWEEN_75_AND_79',
  /** ≥80 (18) */
  SapsAgeGreaterThanOrEqual_80 = 'SAPS_AGE_GREATER_THAN_OR_EQUAL_80',
  /** <40 (0) */
  SapsAgeLessThan_40 = 'SAPS_AGE_LESS_THAN_40',
  SapsAgeNone = 'SAPS_AGE_NONE'
}

/** Simplified Acute Physiology Score (SAPS) */
export type Treatment_SapsBlock = {
  __typename?: 'treatment_SapsBlock';
  admissionType?: Maybe<Treatment_SapsAdmissionType>;
  age?: Maybe<Treatment_SapsAge>;
  chronicDisease?: Maybe<Treatment_SapsChronicDisease>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  heartRate?: Maybe<Treatment_SapsHeartRate>;
  pa02FiO2?: Maybe<Treatment_SapsPa02FiO2>;
  score?: Maybe<Scalars['Int']>;
  serumBicarbonate?: Maybe<Treatment_SapsSerumBicarbonate>;
  serumBilirubin?: Maybe<Treatment_SapsSerumBilirubin>;
  serumPotassium?: Maybe<Treatment_SapsSerumPotassium>;
  serumSodium?: Maybe<Treatment_SapsSerumSodium>;
  serumUrea?: Maybe<Treatment_SapsSerumUrea>;
  systolicBloodPressure?: Maybe<Treatment_SapsSystolicBloodPressure>;
  temperature?: Maybe<Treatment_SapsTemperature>;
  urineOutput?: Maybe<Treatment_SapsUrineOutput>;
  whiteBloodCellCount?: Maybe<Treatment_SapsWhiteBloodCellCount>;
};

export enum Treatment_SapsChronicDisease {
  /** AIDS (17) */
  SapsChronicDiseaseAids = 'SAPS_CHRONIC_DISEASE_AIDS',
  /** Hämatologische Neoplasie (10) */
  SapsChronicDiseaseHematologicalNeoplasia = 'SAPS_CHRONIC_DISEASE_HEMATOLOGICAL_NEOPLASIA',
  /** Neoplasie mit Metastasen (9) */
  SapsChronicDiseaseNeoplasiaWithMetastases = 'SAPS_CHRONIC_DISEASE_NEOPLASIA_WITH_METASTASES',
  SapsChronicDiseaseNone = 'SAPS_CHRONIC_DISEASE_NONE'
}

export enum Treatment_SapsHeartRate {
  /** 40-69 (2) */
  SapsHeartRateBetween_40And_69 = 'SAPS_HEART_RATE_BETWEEN_40_AND_69',
  /** 70-119 (0) */
  SapsHeartRateBetween_70And_119 = 'SAPS_HEART_RATE_BETWEEN_70_AND_119',
  /** 120-159 (4) */
  SapsHeartRateBetween_120And_159 = 'SAPS_HEART_RATE_BETWEEN_120_AND_159',
  /** ≥160 (7) */
  SapsHeartRateBetweenGreaterThanOrEqual_160 = 'SAPS_HEART_RATE_BETWEEN_GREATER_THAN_OR_EQUAL_160',
  /** <40 (11) */
  SapsHeartRateBetweenLessThan_40 = 'SAPS_HEART_RATE_BETWEEN_LESS_THAN_40',
  SapsHeartRateNone = 'SAPS_HEART_RATE_NONE'
}

export enum Treatment_SapsPa02FiO2 {
  /** 100-<200 (9) */
  SapsPa02Fio2Between_100InclusiveAnd_200Exclusive = 'SAPS_PA02_FIO2_BETWEEN_100_INCLUSIVE_AND_200_EXCLUSIVE',
  /** ≥200 (6) */
  SapsPa02Fio2GreaterThanOrEqual_200 = 'SAPS_PA02_FIO2_GREATER_THAN_OR_EQUAL_200',
  /** <100 (11) */
  SapsPa02Fio2LessThan_100 = 'SAPS_PA02_FIO2_LESS_THAN_100',
  SapsPa02Fio2None = 'SAPS_PA02_FIO2_NONE',
  SapsPa02Fio2NoMechanicalVentilation = 'SAPS_PA02_FIO2_NO_MECHANICAL_VENTILATION'
}

export enum Treatment_SapsSerumBicarbonate {
  /** 15-<20 (3) */
  SapsSerumBicarbonateBetween_15InclusiveAnd_20Exclusive = 'SAPS_SERUM_BICARBONATE_BETWEEN_15_INCLUSIVE_AND_20_EXCLUSIVE',
  /** ≥20 (0) */
  SapsSerumBicarbonateGreaterThanOrEqual_20 = 'SAPS_SERUM_BICARBONATE_GREATER_THAN_OR_EQUAL_20',
  /** <15 (6) */
  SapsSerumBicarbonateLessThan_15 = 'SAPS_SERUM_BICARBONATE_LESS_THAN_15',
  SapsSerumBicarbonateNone = 'SAPS_SERUM_BICARBONATE_NONE'
}

export enum Treatment_SapsSerumBilirubin {
  /** 68,4-<102,6 (4) */
  SapsSerumBilirubinBetween_68_4InclusiveAnd_102_6Exclusive = 'SAPS_SERUM_BILIRUBIN_BETWEEN_68_4_INCLUSIVE_AND_102_6_EXCLUSIVE',
  /** ≥102,6 (9) */
  SapsSerumBilirubinGreaterThanOrEqual_102_6 = 'SAPS_SERUM_BILIRUBIN_GREATER_THAN_OR_EQUAL_102_6',
  /** <68,4 (0) */
  SapsSerumBilirubinLessThan_68_4 = 'SAPS_SERUM_BILIRUBIN_LESS_THAN_68_4',
  SapsSerumBilirubinNone = 'SAPS_SERUM_BILIRUBIN_NONE'
}

export enum Treatment_SapsSerumPotassium {
  /** [3,0-5,0) (0) */
  SapsSerumPotassiumBetween_3InclusiveAnd_5Exclusive = 'SAPS_SERUM_POTASSIUM_BETWEEN_3_INCLUSIVE_AND_5_EXCLUSIVE',
  /** (-inf, 3) U [5, +inf) (3) */
  SapsSerumPotassiumLessThan_3AndGreaterThanOrEqual_5 = 'SAPS_SERUM_POTASSIUM_LESS_THAN_3_AND_GREATER_THAN_OR_EQUAL_5',
  SapsSerumPotassiumNone = 'SAPS_SERUM_POTASSIUM_NONE'
}

export enum Treatment_SapsSerumSodium {
  /** 125-<145 (0) */
  SapsSerumSodiumBetween_125InclusiveAnd_145Exclusive = 'SAPS_SERUM_SODIUM_BETWEEN_125_INCLUSIVE_AND_145_EXCLUSIVE',
  /** ≥145 (1) */
  SapsSerumSodiumGreaterThanOrEqual_145 = 'SAPS_SERUM_SODIUM_GREATER_THAN_OR_EQUAL_145',
  /** <125 (5) */
  SapsSerumSodiumLessThan_125 = 'SAPS_SERUM_SODIUM_LESS_THAN_125',
  SapsSerumSodiumNone = 'SAPS_SERUM_SODIUM_NONE'
}

export enum Treatment_SapsSerumUrea {
  /** 0,6.-<1,8 (6) */
  SapsSerumUreaBetween_0_6InclusiveAnd_1_8Exclusive = 'SAPS_SERUM_UREA_BETWEEN_0_6_INCLUSIVE_AND_1_8_EXCLUSIVE',
  /** ≥1,8 (10) */
  SapsSerumUreaGreaterThanOrEqual_1_8 = 'SAPS_SERUM_UREA_GREATER_THAN_OR_EQUAL_1_8',
  /** <0,6 (0) */
  SapsSerumUreaLessThan_0_6 = 'SAPS_SERUM_UREA_LESS_THAN_0_6',
  SapsSerumUreaNone = 'SAPS_SERUM_UREA_NONE'
}

export enum Treatment_SapsSystolicBloodPressure {
  /** 70-99 (5) */
  SapsSystolicBloodPressureBetween_70And_99 = 'SAPS_SYSTOLIC_BLOOD_PRESSURE_BETWEEN_70_AND_99',
  /** 100-199 (0) */
  SapsSystolicBloodPressureBetween_100And_199 = 'SAPS_SYSTOLIC_BLOOD_PRESSURE_BETWEEN_100_AND_199',
  /** ≥200 (2) */
  SapsSystolicBloodPressureGreaterThanOrEqual_200 = 'SAPS_SYSTOLIC_BLOOD_PRESSURE_GREATER_THAN_OR_EQUAL_200',
  /** <70 (13) */
  SapsSystolicBloodPressureLessThan_70 = 'SAPS_SYSTOLIC_BLOOD_PRESSURE_LESS_THAN_70',
  SapsSystolicBloodPressureNone = 'SAPS_SYSTOLIC_BLOOD_PRESSURE_NONE'
}

export enum Treatment_SapsTemperature {
  /** ≥39 (3) */
  SapsTemperatureGreaterThanOrEqual_39 = 'SAPS_TEMPERATURE_GREATER_THAN_OR_EQUAL_39',
  /** <39 (0) */
  SapsTemperatureLessThan_39 = 'SAPS_TEMPERATURE_LESS_THAN_39',
  SapsTemperatureNone = 'SAPS_TEMPERATURE_NONE'
}

export enum Treatment_SapsUrineOutput {
  /** 0,5-<1,0 (4) */
  SapsUrineOutputBetween_0_5InclusiveAnd_1Exclusive = 'SAPS_URINE_OUTPUT_BETWEEN_0_5_INCLUSIVE_AND_1_EXCLUSIVE',
  /** ≥1,0 (0) */
  SapsUrineOutputGreaterThanOrEqual_1 = 'SAPS_URINE_OUTPUT_GREATER_THAN_OR_EQUAL_1',
  /** <0,5 (11) */
  SapsUrineOutputLessThanO_5 = 'SAPS_URINE_OUTPUT_LESS_THAN_O_5',
  SapsUrineOutputNone = 'SAPS_URINE_OUTPUT_NONE'
}

export enum Treatment_SapsWhiteBloodCellCount {
  /** 1,0-<20 (0) */
  SapsWhiteBloodCellCountBetween_1InclusiveAnd_20Exclusive = 'SAPS_WHITE_BLOOD_CELL_COUNT_BETWEEN_1_INCLUSIVE_AND_20_EXCLUSIVE',
  /** ≥20 (3) */
  SapsWhiteBloodCellCountGreaterThanOrEqual_20 = 'SAPS_WHITE_BLOOD_CELL_COUNT_GREATER_THAN_OR_EQUAL_20',
  /** <1,0 (12) */
  SapsWhiteBloodCellCountLessThan_1 = 'SAPS_WHITE_BLOOD_CELL_COUNT_LESS_THAN_1',
  SapsWhiteBloodCellCountNone = 'SAPS_WHITE_BLOOD_CELL_COUNT_NONE'
}

export enum Treatment_SatisfactionWithHousingSituation {
  SatisfactionWithHousingSituationDissatisfied = 'SATISFACTION_WITH_HOUSING_SITUATION_DISSATISFIED',
  SatisfactionWithHousingSituationMustBeSatisfied = 'SATISFACTION_WITH_HOUSING_SITUATION_MUST_BE_SATISFIED',
  SatisfactionWithHousingSituationNone = 'SATISFACTION_WITH_HOUSING_SITUATION_NONE',
  SatisfactionWithHousingSituationVerySatisfied = 'SATISFACTION_WITH_HOUSING_SITUATION_VERY_SATISFIED'
}

export type Treatment_ScoreBlockMsg = {
  __typename?: 'treatment_ScoreBlockMsg';
  blockId?: Maybe<Scalars['String']>;
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  scoreValues?: Maybe<Array<Maybe<Treatment_ScoreValueMsg>>>;
  timestamps?: Maybe<TimeMsg>;
};

export enum Treatment_ScoreDataType {
  ScoreDataTypeFloat = 'SCORE_DATA_TYPE_FLOAT',
  ScoreDataTypeInteger = 'SCORE_DATA_TYPE_INTEGER',
  ScoreDataTypeNone = 'SCORE_DATA_TYPE_NONE',
  ScoreDataTypeString = 'SCORE_DATA_TYPE_STRING',
  ScoreDataTypeVoid = 'SCORE_DATA_TYPE_VOID'
}

export type Treatment_ScoreValueMsg = {
  __typename?: 'treatment_ScoreValueMsg';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** fieldName = "score" by default for non-void types. */
  fieldName?: Maybe<Scalars['String']>;
  /** if type = VOID then you should ignore the other fields. */
  scoreDataType?: Maybe<Treatment_ScoreDataType>;
  scoreFloat?: Maybe<Scalars['Float']>;
  scoreInt?: Maybe<Scalars['Int']>;
  scoreString?: Maybe<Scalars['String']>;
};

export type Treatment_ScreeningMsg = {
  __typename?: 'treatment_ScreeningMsg';
  bmi?: Maybe<Treatment_Bmi>;
  /** Has the patient eaten less during the last 3 months because of loss of appetite, digestive problems, difficulty chewing or swallowing? */
  eatingHabitLastThreeMonths?: Maybe<Treatment_EatingHabit>;
  /** Acute illness or psychological stress during the last 3 months?: < yes (0) / no (1)> */
  illnessOrStressLastThreeMonths?: Maybe<Scalars['Boolean']>;
  mobility?: Maybe<Treatment_Mobility>;
  neuropsychologicalProblems?: Maybe<Treatment_NeuropsychologicalProblems>;
  /** automatic addition of points based on entries above */
  screeningScore?: Maybe<Scalars['Int']>;
  /** weight loss in the last 3 months */
  weightLossLastThreeMonths?: Maybe<Treatment_WeightLoss>;
};

export type Treatment_SearchPatientDiagnosesRequest = {
  __typename?: 'treatment_SearchPatientDiagnosesRequest';
  patientId?: Maybe<Scalars['String']>;
  searchContext?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  searchTerm?: Maybe<Scalars['String']>;
};

export enum Treatment_SeatingBalance {
  SeatingBalanceLeansToTheSideOrSlidesInTheChair = 'SEATING_BALANCE_LEANS_TO_THE_SIDE_OR_SLIDES_IN_THE_CHAIR',
  SeatingBalanceNone = 'SEATING_BALANCE_NONE',
  SeatingBalanceSteadySafe = 'SEATING_BALANCE_STEADY_SAFE'
}

export type Treatment_SectionMetadataMsg = {
  __typename?: 'treatment_SectionMetadataMsg';
  /** True if the cards that appear in the section are not fixed */
  dynamic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type Treatment_SectionTemplateMsg = {
  __typename?: 'treatment_SectionTemplateMsg';
  cards?: Maybe<Array<Maybe<Treatment_CardTemplateMsg>>>;
  number?: Maybe<Scalars['Int']>;
  shortcuts?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
};

export type Treatment_SedationMsg = {
  __typename?: 'treatment_SedationMsg';
  airwayAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  airwayManagements?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  canPerformWithoutSedation?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ventilationTypes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_SelfRejection {
  SelfRejectionCompletelySelfRejection = 'SELF_REJECTION_COMPLETELY_SELF_REJECTION',
  SelfRejectionLoseSelfConfidence = 'SELF_REJECTION_LOSE_SELF_CONFIDENCE',
  SelfRejectionNone = 'SELF_REJECTION_NONE',
  SelfRejectionNoSelfRejection = 'SELF_REJECTION_NO_SELF_REJECTION',
  SelfRejectionSelfDisappointment = 'SELF_REJECTION_SELF_DISAPPOINTMENT'
}

export enum Treatment_SelfReproach {
  SelfReproachBlameForAllBadThingsHappened = 'SELF_REPROACH_BLAME_FOR_ALL_BAD_THINGS_HAPPENED',
  SelfReproachCriticizeForAllShortcomings = 'SELF_REPROACH_CRITICIZE_FOR_ALL_SHORTCOMINGS',
  SelfReproachMoreSelfReproach = 'SELF_REPROACH_MORE_SELF_REPROACH',
  SelfReproachNone = 'SELF_REPROACH_NONE',
  SelfReproachNoSelfReproach = 'SELF_REPROACH_NO_SELF_REPROACH'
}

export type Treatment_SenseOfTasteBlock = {
  __typename?: 'treatment_SenseOfTasteBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  bitter?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  bitterText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  salty?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  saltyText?: Maybe<Scalars['String']>;
  senseOfTaste?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  sour?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  sourText?: Maybe<Scalars['String']>;
  sweet?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  sweetText?: Maybe<Scalars['String']>;
  tastePerception?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  tasteQualities?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_SensitivityBlock = {
  __typename?: 'treatment_SensitivityBlock';
  aesthesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  aesthesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  aesthesiaAbnormalitiesText?: Maybe<Scalars['String']>;
  algesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  algesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  algesiaAbnormalitiesText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  pallaesthesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  pallaesthesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  pallaesthesiaAbnormalitiesText?: Maybe<Scalars['String']>;
  proprioception?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  proprioceptionText?: Maybe<Scalars['String']>;
  sensitivity?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thermaesthesia?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thermaesthesiaAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  thermaesthesiaAbnormalitiesText?: Maybe<Scalars['String']>;
};

export enum Treatment_SensitivityTestResult {
  SensitivityTestComa = 'SENSITIVITY_TEST_COMA',
  SensitivityTestMildToModerateLoss = 'SENSITIVITY_TEST_MILD_TO_MODERATE_LOSS',
  SensitivityTestNone = 'SENSITIVITY_TEST_NONE',
  SensitivityTestNormal = 'SENSITIVITY_TEST_NORMAL',
  SensitivityTestSevereToCompleteLoss = 'SENSITIVITY_TEST_SEVERE_TO_COMPLETE_LOSS',
  SensitivityTestUnderstandingDifficulties = 'SENSITIVITY_TEST_UNDERSTANDING_DIFFICULTIES'
}

export enum Treatment_SensorySensitivity {
  SensorySensitivityCompletelyLimited = 'SENSORY_SENSITIVITY_COMPLETELY_LIMITED',
  SensorySensitivityNone = 'SENSORY_SENSITIVITY_NONE',
  SensorySensitivityNoImpairment = 'SENSORY_SENSITIVITY_NO_IMPAIRMENT',
  SensorySensitivitySeverelyLimited = 'SENSORY_SENSITIVITY_SEVERELY_LIMITED',
  SensorySensitivitySlightlyLimited = 'SENSORY_SENSITIVITY_SLIGHTLY_LIMITED'
}

export enum Treatment_SeriesOfLetters {
  SeriesOfLettersLargerThanOrEqual_2Mistakes = 'SERIES_OF_LETTERS_LARGER_THAN_OR_EQUAL_2_MISTAKES',
  SeriesOfLettersLessThan_2Mistakes = 'SERIES_OF_LETTERS_LESS_THAN_2_MISTAKES',
  SeriesOfLettersNone = 'SERIES_OF_LETTERS_NONE'
}

export enum Treatment_SerumAlbumin {
  /** 2,8-3,5 (2) */
  SerumAlbuminBetween_2_8And_3_5 = 'SERUM_ALBUMIN_BETWEEN_2_8_AND_3_5',
  /** >3.5 (1) */
  SerumAlbuminGreaterThan_3_5 = 'SERUM_ALBUMIN_GREATER_THAN_3_5',
  /** <2,8 (3) */
  SerumAlbuminLessThan_2_8 = 'SERUM_ALBUMIN_LESS_THAN_2_8',
  SerumAlbuminNone = 'SERUM_ALBUMIN_NONE'
}

export enum Treatment_SerumBilirubin {
  /** mg/dl: 2.0-3,0 (2) */
  SerumBilirubinBetween_2And_3 = 'SERUM_BILIRUBIN_BETWEEN_2_AND_3',
  /** mg/dl: >3.0 (3) */
  SerumBilirubinGreaterThan_3 = 'SERUM_BILIRUBIN_GREATER_THAN_3',
  /** mg/dl: <2,0 (1) */
  SerumBilirubinLessThan_2 = 'SERUM_BILIRUBIN_LESS_THAN_2',
  SerumBilirubinNone = 'SERUM_BILIRUBIN_NONE'
}

export enum Treatment_SeveritySelection {
  SeveritySelectionModeratePain = 'SEVERITY_SELECTION_MODERATE_PAIN',
  SeveritySelectionNone = 'SEVERITY_SELECTION_NONE',
  SeveritySelectionNoPain = 'SEVERITY_SELECTION_NO_PAIN',
  SeveritySelectionSeverePain = 'SEVERITY_SELECTION_SEVERE_PAIN',
  SeveritySelectionSlightPain = 'SEVERITY_SELECTION_SLIGHT_PAIN',
  SeveritySelectionUnbearable = 'SEVERITY_SELECTION_UNBEARABLE'
}

export enum Treatment_SeveritySlider {
  SeveritySliderEight = 'SEVERITY_SLIDER_EIGHT',
  SeveritySliderFive = 'SEVERITY_SLIDER_FIVE',
  SeveritySliderFour = 'SEVERITY_SLIDER_FOUR',
  SeveritySliderNine = 'SEVERITY_SLIDER_NINE',
  SeveritySliderNone = 'SEVERITY_SLIDER_NONE',
  SeveritySliderOne = 'SEVERITY_SLIDER_ONE',
  SeveritySliderSeven = 'SEVERITY_SLIDER_SEVEN',
  SeveritySliderSix = 'SEVERITY_SLIDER_SIX',
  SeveritySliderTen = 'SEVERITY_SLIDER_TEN',
  SeveritySliderThree = 'SEVERITY_SLIDER_THREE',
  SeveritySliderTwo = 'SEVERITY_SLIDER_TWO',
  SeveritySliderZero = 'SEVERITY_SLIDER_ZERO'
}

export type Treatment_SexLifeBlock = {
  __typename?: 'treatment_SexLifeBlock';
  erectileDysfunctionPresent?: Maybe<Scalars['Boolean']>;
  erectileDysfunctionText?: Maybe<Scalars['String']>;
  happySexLifePresent?: Maybe<Scalars['Boolean']>;
  happySexLifeText?: Maybe<Scalars['String']>;
  potencyEnhancingDrugsPresent?: Maybe<Scalars['Boolean']>;
  potencyEnhancingDrugsText?: Maybe<Scalars['String']>;
  problemsSexPresent?: Maybe<Scalars['Boolean']>;
  problemsSexText?: Maybe<Scalars['String']>;
  sexPartners?: Maybe<Array<Maybe<Treatment_Partners>>>;
  sexPartnersText?: Maybe<Scalars['String']>;
  sexualPractices?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_ShoesOrSocks {
  ShoesOrSocksNone = 'SHOES_OR_SOCKS_NONE',
  ShoesOrSocksWithoutDifficulty = 'SHOES_OR_SOCKS_WITHOUT_DIFFICULTY',
  ShoesOrSocksWithDifficulty = 'SHOES_OR_SOCKS_WITH_DIFFICULTY',
  ShoesOrSocksWithGreatDifficultyOrImpossible = 'SHOES_OR_SOCKS_WITH_GREAT_DIFFICULTY_OR_IMPOSSIBLE'
}

export enum Treatment_Shopping {
  ShoppingAllFurtherAway = 'SHOPPING_ALL_FURTHER_AWAY',
  ShoppingEasilyAccessible = 'SHOPPING_EASILY_ACCESSIBLE',
  ShoppingNone = 'SHOPPING_NONE',
  ShoppingOnlyBackerButcherNearby = 'SHOPPING_ONLY_BACKER_BUTCHER_NEARBY'
}

export enum Treatment_ShortnessOfBreath {
  /** Significant shortness of breath or shortness of breath at rest. Mechanical ventilation is used or recommended */
  ShortnessOfBreathAtRestMechanicalVentilation = 'SHORTNESS_OF_BREATH_AT_REST_MECHANICAL_VENTILATION',
  /** Occurred during activities of daily living including eating, bathing, dressing */
  ShortnessOfBreathDuringActivities = 'SHORTNESS_OF_BREATH_DURING_ACTIVITIES',
  ShortnessOfBreathNone = 'SHORTNESS_OF_BREATH_NONE',
  ShortnessOfBreathUndisturbed = 'SHORTNESS_OF_BREATH_UNDISTURBED',
  /** Occurred while at rest, sitting, or lying down */
  ShortnessOfBreathWhileAtRest = 'SHORTNESS_OF_BREATH_WHILE_AT_REST',
  ShortnessOfBreathWhileWalking = 'SHORTNESS_OF_BREATH_WHILE_WALKING'
}

export type Treatment_ShoulderJointMsg = {
  __typename?: 'treatment_ShoulderJointMsg';
  abduction?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  elevation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  externalRotation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
  internalRotation?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
};

export type Treatment_ShuntMsg = {
  __typename?: 'treatment_ShuntMsg';
  type?: Maybe<Core_KnowledgeInputMsg>;
  vessels?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_SignVaccinationRequest = {
  __typename?: 'treatment_SignVaccinationRequest';
  vaccinationId?: Maybe<Scalars['String']>;
};

export type Treatment_SigstadBlock = {
  __typename?: 'treatment_SigstadBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
  /** multiselect */
  symptomList?: Maybe<Array<Maybe<Treatment_Symptom>>>;
};

export type Treatment_SingleForceLevelAndDetailsMsg = {
  __typename?: 'treatment_SingleForceLevelAndDetailsMsg';
  force?: Maybe<Scalars['Int']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_SingleForceTestBlock = {
  __typename?: 'treatment_SingleForceTestBlock';
  elbowJoint?: Maybe<Treatment_ElbowJointMsg>;
  fingerJoints?: Maybe<Treatment_FingerJointsMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  headAndNeck?: Maybe<Treatment_HeadAndNeckMsg>;
  hipJoints?: Maybe<Treatment_HipJointMsg>;
  kneeJoint?: Maybe<Treatment_KneeJointMsg>;
  lowerAnkleJoint?: Maybe<Treatment_LowerAnkleJointMsg>;
  shoulderJoint?: Maybe<Treatment_ShoulderJointMsg>;
  toeJoints?: Maybe<Treatment_ToeJointsMsg>;
  upperAnkleJoint?: Maybe<Treatment_UpperAnkleJointMsg>;
  wrist?: Maybe<Treatment_WristMsg>;
};

export type Treatment_SinusPalpationMsg = {
  __typename?: 'treatment_SinusPalpationMsg';
  id?: Maybe<Scalars['String']>;
  localization?: Maybe<Treatment_SinusPercussionLocalization>;
  localizationText?: Maybe<Scalars['String']>;
  percussionType?: Maybe<Treatment_SinusPercussionType>;
};

export enum Treatment_SinusPercussionLocalization {
  SinusPercussionLocalizationBothSides = 'SINUS_PERCUSSION_LOCALIZATION_BOTH_SIDES',
  SinusPercussionLocalizationLeft = 'SINUS_PERCUSSION_LOCALIZATION_LEFT',
  SinusPercussionLocalizationNone = 'SINUS_PERCUSSION_LOCALIZATION_NONE',
  SinusPercussionLocalizationRight = 'SINUS_PERCUSSION_LOCALIZATION_RIGHT'
}

export enum Treatment_SinusPercussionType {
  SinusPercussionNone = 'SINUS_PERCUSSION_NONE',
  SinusPercussionNotPainfulKnocking = 'SINUS_PERCUSSION_NOT_PAINFUL_KNOCKING',
  SinusPercussionPainfulKnocking = 'SINUS_PERCUSSION_PAINFUL_KNOCKING'
}

export enum Treatment_SittingDown {
  SittingDownNone = 'SITTING_DOWN_NONE',
  SittingDownSureWithFineMovement = 'SITTING_DOWN_SURE_WITH_FINE_MOVEMENT',
  SittingDownUnsure = 'SITTING_DOWN_UNSURE',
  SittingDownUseOfArmsOrRoughMovements = 'SITTING_DOWN_USE_OF_ARMS_OR_ROUGH_MOVEMENTS'
}

export type Treatment_SkinChangeBlock = {
  __typename?: 'treatment_SkinChangeBlock';
  changeOverTime?: Maybe<Scalars['Boolean']>;
  changeOverTimeDescription?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  numberOfEpisodes?: Maybe<Scalars['Int']>;
  numberOfEpisodesResolution?: Maybe<Treatment_SkinChangeTime>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  timeOccurrence?: Maybe<Treatment_TimeOccurrence>;
  types?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_SkinChangeExaminationsBlock = {
  __typename?: 'treatment_SkinChangeExaminationsBlock';
  abnormalitiesPresent?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  skinChanges?: Maybe<Array<Maybe<Treatment_SkinChangeMsg>>>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SkinChangeMsg = {
  __typename?: 'treatment_SkinChangeMsg';
  dermatoscopicDescription?: Maybe<Scalars['String']>;
  descriptionDataset?: Maybe<Core_KnowledgeInputMsg>;
  id?: Maybe<Scalars['String']>;
  imageSeriesId?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  macroscopicDescription?: Maybe<Scalars['String']>;
};

export enum Treatment_SkinChangeTime {
  SkinChangeTimeMonth = 'SKIN_CHANGE_TIME_MONTH',
  SkinChangeTimeNone = 'SKIN_CHANGE_TIME_NONE',
  SkinChangeTimeYear = 'SKIN_CHANGE_TIME_YEAR'
}

export type Treatment_SkinColorBlock = {
  __typename?: 'treatment_SkinColorBlock';
  skinColors?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_SkinCondition {
  SkinConditionAllRight = 'SKIN_CONDITION_ALL_RIGHT',
  SkinConditionMoist = 'SKIN_CONDITION_MOIST',
  SkinConditionNone = 'SKIN_CONDITION_NONE',
  SkinConditionScalyDry = 'SKIN_CONDITION_SCALY_DRY',
  SkinConditionSoresAllergyCrack = 'SKIN_CONDITION_SORES_ALLERGY_CRACK'
}

export type Treatment_SkinStaplingClipMsg = {
  __typename?: 'treatment_SkinStaplingClipMsg';
  clips?: Maybe<Scalars['Int']>;
  recommendedRemovalDuration?: Maybe<Scalars['Int']>;
  recommendedRemovalDurationUnit?: Maybe<TimeUnit>;
};

export type Treatment_SkinThicknessBlock = {
  __typename?: 'treatment_SkinThicknessBlock';
  skinThickness?: Maybe<Treatment_SkinThicknessType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_SkinThicknessType {
  SkinThicknessIncreased = 'SKIN_THICKNESS_INCREASED',
  SkinThicknessNone = 'SKIN_THICKNESS_NONE',
  SkinThicknessNormal = 'SKIN_THICKNESS_NORMAL',
  SkinThicknessReduced = 'SKIN_THICKNESS_REDUCED'
}

export type Treatment_SkinTurgorBlock = {
  __typename?: 'treatment_SkinTurgorBlock';
  skinTurgor?: Maybe<Treatment_SkinTurgorType>;
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_SkinTurgorType {
  SkinTurgorIncreased = 'SKIN_TURGOR_INCREASED',
  SkinTurgorNone = 'SKIN_TURGOR_NONE',
  SkinTurgorNormal = 'SKIN_TURGOR_NORMAL',
  SkinTurgorReduced = 'SKIN_TURGOR_REDUCED'
}

export type Treatment_SkullPalpationBlock = {
  __typename?: 'treatment_SkullPalpationBlock';
  examinationResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  examinationResultText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  orbitalRimStepFormationPresent?: Maybe<Scalars['Boolean']>;
  orbitalRimStepFormationText?: Maybe<Scalars['String']>;
  palpableBonyStepsPresent?: Maybe<Scalars['Boolean']>;
  palpableBonyStepsText?: Maybe<Scalars['String']>;
};

export enum Treatment_Sledai2KAlopecia {
  Sledai_2KAlopeciaNo = 'SLEDAI_2K_ALOPECIA_NO',
  Sledai_2KAlopeciaNone = 'SLEDAI_2K_ALOPECIA_NONE',
  Sledai_2KAlopeciaYes = 'SLEDAI_2K_ALOPECIA_YES'
}

export enum Treatment_Sledai2KArthritis {
  Sledai_2KArthritisNo = 'SLEDAI_2K_ARTHRITIS_NO',
  Sledai_2KArthritisNone = 'SLEDAI_2K_ARTHRITIS_NONE',
  Sledai_2KArthritisYes = 'SLEDAI_2K_ARTHRITIS_YES'
}

export type Treatment_Sledai2KBlock = {
  __typename?: 'treatment_Sledai2KBlock';
  alopecia?: Maybe<Treatment_Sledai2KAlopecia>;
  arthritis?: Maybe<Treatment_Sledai2KArthritis>;
  completed?: Maybe<Scalars['Boolean']>;
  cranialNerveDisorder?: Maybe<Treatment_Sledai2KCranialNerveDisorder>;
  cva?: Maybe<Treatment_Sledai2KCva>;
  fever?: Maybe<Treatment_Sledai2KFever>;
  hematuria?: Maybe<Treatment_Sledai2KHematuria>;
  increasedDnaBinding?: Maybe<Treatment_Sledai2KIncreasedDnaBinding>;
  leukopenia?: Maybe<Treatment_Sledai2KLeukopenia>;
  lowComplement?: Maybe<Treatment_Sledai2KLowComplement>;
  lupusHeadache?: Maybe<Treatment_Sledai2KLupusHeadache>;
  mucosalUlcers?: Maybe<Treatment_Sledai2KMucosalUlcers>;
  myositis?: Maybe<Treatment_Sledai2KMyositis>;
  organicBrainSyndrome?: Maybe<Treatment_Sledai2KOrganicBrainSyndrome>;
  pericarditis?: Maybe<Treatment_Sledai2KPericarditis>;
  pleurisy?: Maybe<Treatment_Sledai2KPleurisy>;
  proteinuria?: Maybe<Treatment_Sledai2KProteinuria>;
  psychosis?: Maybe<Treatment_Sledai2KPsychosis>;
  pyuria?: Maybe<Treatment_Sledai2KPyuria>;
  rash?: Maybe<Treatment_Sledai2KRash>;
  score?: Maybe<Scalars['Int']>;
  seizure?: Maybe<Treatment_Sledai2KSeizure>;
  thrombocytopenia?: Maybe<Treatment_Sledai2KThrombocytopenia>;
  urinaryCasts?: Maybe<Treatment_Sledai2KUrinaryCasts>;
  vasculitis?: Maybe<Treatment_Sledai2KVasculitis>;
  visualDisturbance?: Maybe<Treatment_Sledai2KVisualDisturbance>;
};

export enum Treatment_Sledai2KCranialNerveDisorder {
  Sledai_2KCranialNerveDisorderNo = 'SLEDAI_2K_CRANIAL_NERVE_DISORDER_NO',
  Sledai_2KCranialNerveDisorderNone = 'SLEDAI_2K_CRANIAL_NERVE_DISORDER_NONE',
  Sledai_2KCranialNerveDisorderYes = 'SLEDAI_2K_CRANIAL_NERVE_DISORDER_YES'
}

export enum Treatment_Sledai2KCva {
  Sledai_2KCvaNo = 'SLEDAI_2K_CVA_NO',
  Sledai_2KCvaNone = 'SLEDAI_2K_CVA_NONE',
  Sledai_2KCvaYes = 'SLEDAI_2K_CVA_YES'
}

export enum Treatment_Sledai2KFever {
  Sledai_2KFeverNo = 'SLEDAI_2K_FEVER_NO',
  Sledai_2KFeverNone = 'SLEDAI_2K_FEVER_NONE',
  Sledai_2KFeverYes = 'SLEDAI_2K_FEVER_YES'
}

export enum Treatment_Sledai2KHematuria {
  Sledai_2KHematuriaNo = 'SLEDAI_2K_HEMATURIA_NO',
  Sledai_2KHematuriaNone = 'SLEDAI_2K_HEMATURIA_NONE',
  Sledai_2KHematuriaYes = 'SLEDAI_2K_HEMATURIA_YES'
}

export enum Treatment_Sledai2KIncreasedDnaBinding {
  Sledai_2KIncreasedDnaBindingNo = 'SLEDAI_2K_INCREASED_DNA_BINDING_NO',
  Sledai_2KIncreasedDnaBindingNone = 'SLEDAI_2K_INCREASED_DNA_BINDING_NONE',
  Sledai_2KIncreasedDnaBindingYes = 'SLEDAI_2K_INCREASED_DNA_BINDING_YES'
}

export enum Treatment_Sledai2KLeukopenia {
  Sledai_2KLeukopeniaNo = 'SLEDAI_2K_LEUKOPENIA_NO',
  Sledai_2KLeukopeniaNone = 'SLEDAI_2K_LEUKOPENIA_NONE',
  Sledai_2KLeukopeniaYes = 'SLEDAI_2K_LEUKOPENIA_YES'
}

export enum Treatment_Sledai2KLowComplement {
  Sledai_2KLowComplementNo = 'SLEDAI_2K_LOW_COMPLEMENT_NO',
  Sledai_2KLowComplementNone = 'SLEDAI_2K_LOW_COMPLEMENT_NONE',
  Sledai_2KLowComplementYes = 'SLEDAI_2K_LOW_COMPLEMENT_YES'
}

export enum Treatment_Sledai2KLupusHeadache {
  Sledai_2KLupusHeadacheNo = 'SLEDAI_2K_LUPUS_HEADACHE_NO',
  Sledai_2KLupusHeadacheNone = 'SLEDAI_2K_LUPUS_HEADACHE_NONE',
  Sledai_2KLupusHeadacheYes = 'SLEDAI_2K_LUPUS_HEADACHE_YES'
}

export enum Treatment_Sledai2KMucosalUlcers {
  Sledai_2KMucosalUlcersNo = 'SLEDAI_2K_MUCOSAL_ULCERS_NO',
  Sledai_2KMucosalUlcersNone = 'SLEDAI_2K_MUCOSAL_ULCERS_NONE',
  Sledai_2KMucosalUlcersYes = 'SLEDAI_2K_MUCOSAL_ULCERS_YES'
}

export enum Treatment_Sledai2KMyositis {
  Sledai_2KMyositisN0 = 'SLEDAI_2K_MYOSITIS_N0',
  Sledai_2KMyositisNone = 'SLEDAI_2K_MYOSITIS_NONE',
  Sledai_2KMyositisYes = 'SLEDAI_2K_MYOSITIS_YES'
}

export enum Treatment_Sledai2KOrganicBrainSyndrome {
  Sledai_2KOrganicBrainSyndromeNo = 'SLEDAI_2K_ORGANIC_BRAIN_SYNDROME_NO',
  Sledai_2KOrganicBrainSyndromeNone = 'SLEDAI_2K_ORGANIC_BRAIN_SYNDROME_NONE',
  Sledai_2KOrganicBrainSyndromeYes = 'SLEDAI_2K_ORGANIC_BRAIN_SYNDROME_YES'
}

export enum Treatment_Sledai2KPericarditis {
  Sledai_2KPericarditisNo = 'SLEDAI_2K_PERICARDITIS_NO',
  Sledai_2KPericarditisNone = 'SLEDAI_2K_PERICARDITIS_NONE',
  Sledai_2KPericarditisYes = 'SLEDAI_2K_PERICARDITIS_YES'
}

export enum Treatment_Sledai2KPleurisy {
  Sledai_2KPleurisyNo = 'SLEDAI_2K_PLEURISY_NO',
  Sledai_2KPleurisyNone = 'SLEDAI_2K_PLEURISY_NONE',
  Sledai_2KPleurisyYes = 'SLEDAI_2K_PLEURISY_YES'
}

export enum Treatment_Sledai2KProteinuria {
  Sledai_2KProteinuriaNo = 'SLEDAI_2K_PROTEINURIA_NO',
  Sledai_2KProteinuriaNone = 'SLEDAI_2K_PROTEINURIA_NONE',
  Sledai_2KProteinuriaYes = 'SLEDAI_2K_PROTEINURIA_YES'
}

export enum Treatment_Sledai2KPsychosis {
  Sledai_2KPsychosisNo = 'SLEDAI_2K_PSYCHOSIS_NO',
  Sledai_2KPsychosisNone = 'SLEDAI_2K_PSYCHOSIS_NONE',
  Sledai_2KPsychosisYes = 'SLEDAI_2K_PSYCHOSIS_YES'
}

export enum Treatment_Sledai2KPyuria {
  Sledai_2KPyuriaNo = 'SLEDAI_2K_PYURIA_NO',
  Sledai_2KPyuriaNone = 'SLEDAI_2K_PYURIA_NONE',
  Sledai_2KPyuriaYes = 'SLEDAI_2K_PYURIA_YES'
}

export enum Treatment_Sledai2KRash {
  Sledai_2KRashNo = 'SLEDAI_2K_RASH_NO',
  Sledai_2KRashNone = 'SLEDAI_2K_RASH_NONE',
  Sledai_2KRashYes = 'SLEDAI_2K_RASH_YES'
}

export enum Treatment_Sledai2KSeizure {
  Sledai_2KSeizureNo = 'SLEDAI_2K_SEIZURE_NO',
  Sledai_2KSeizureNone = 'SLEDAI_2K_SEIZURE_NONE',
  Sledai_2KSeizureYes = 'SLEDAI_2K_SEIZURE_YES'
}

export enum Treatment_Sledai2KThrombocytopenia {
  Sledai_2KThrombocytopeniaNo = 'SLEDAI_2K_THROMBOCYTOPENIA_NO',
  Sledai_2KThrombocytopeniaNone = 'SLEDAI_2K_THROMBOCYTOPENIA_NONE',
  Sledai_2KThrombocytopeniaYes = 'SLEDAI_2K_THROMBOCYTOPENIA_YES'
}

export enum Treatment_Sledai2KUrinaryCasts {
  Sledai_2KUrinaryCastsNo = 'SLEDAI_2K_URINARY_CASTS_NO',
  Sledai_2KUrinaryCastsNone = 'SLEDAI_2K_URINARY_CASTS_NONE',
  Sledai_2KUrinaryCastsYes = 'SLEDAI_2K_URINARY_CASTS_YES'
}

export enum Treatment_Sledai2KVasculitis {
  Sledai_2KVasculitisNo = 'SLEDAI_2K_VASCULITIS_NO',
  Sledai_2KVasculitisNone = 'SLEDAI_2K_VASCULITIS_NONE',
  Sledai_2KVasculitisYes = 'SLEDAI_2K_VASCULITIS_YES'
}

export enum Treatment_Sledai2KVisualDisturbance {
  Sledai_2KVisualDisturbanceNo = 'SLEDAI_2K_VISUAL_DISTURBANCE_NO',
  Sledai_2KVisualDisturbanceNone = 'SLEDAI_2K_VISUAL_DISTURBANCE_NONE',
  Sledai_2KVisualDisturbanceYes = 'SLEDAI_2K_VISUAL_DISTURBANCE_YES'
}

export type Treatment_SleepApneaMsg = {
  __typename?: 'treatment_SleepApneaMsg';
  feelingOfSuffocation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  observedRespiratoryCessation?: Maybe<Scalars['Boolean']>;
  startling?: Maybe<Scalars['Boolean']>;
  sufficientAirThroughNose?: Maybe<Scalars['Boolean']>;
};

export type Treatment_SleepDisorderBlock = {
  __typename?: 'treatment_SleepDisorderBlock';
  details?: Maybe<Treatment_SleepDisorderDetailsMsg>;
  furtherClassification?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  sleepApnea?: Maybe<Treatment_SleepApneaMsg>;
  sleepApneaPresent?: Maybe<Scalars['Boolean']>;
  sleepDisturbancePresent?: Maybe<Scalars['Boolean']>;
  sleepDisturbances?: Maybe<Array<Maybe<Treatment_SleepDisturbance>>>;
  sleepMovement?: Maybe<Treatment_SleepMovementMsg>;
  sleepMovementPresent?: Maybe<Scalars['Boolean']>;
  /** From 1 (bad) to 10 (good) */
  sleepQuality?: Maybe<Scalars['Int']>;
  snoring?: Maybe<Treatment_SnoringMsg>;
  snoringPresent?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export type Treatment_SleepDisorderDetailsMsg = {
  __typename?: 'treatment_SleepDisorderDetailsMsg';
  awakeAtNightDuration?: Maybe<VeiosTimeSpanMsg>;
  awakingTime?: Maybe<TimeOfDayMsg>;
  bedTime?: Maybe<TimeOfDayMsg>;
  decreasedPerformance?: Maybe<Scalars['Boolean']>;
  decreasedSexualDesire?: Maybe<Scalars['Boolean']>;
  erectileDysfunction?: Maybe<Scalars['Boolean']>;
  exhaustionDespiteSleep?: Maybe<Scalars['Boolean']>;
  fallAsleepDuringDay?: Maybe<Scalars['Boolean']>;
  fallingAsleepDuration?: Maybe<VeiosTimeSpanMsg>;
  id?: Maybe<Scalars['String']>;
  impairedConcentrationOrMemory?: Maybe<Scalars['Boolean']>;
  microsleepWhileDriving?: Maybe<Scalars['Boolean']>;
  morningHeadache?: Maybe<Scalars['Boolean']>;
  nightlyUrinationFrequency?: Maybe<Scalars['Int']>;
  nocturnalUrinationUrge?: Maybe<Scalars['Boolean']>;
  recentWeightLoss?: Maybe<Scalars['Boolean']>;
  talkingInSleep?: Maybe<Scalars['Boolean']>;
  talkingInSleepDescription?: Maybe<Scalars['String']>;
  /** in kg */
  weightLoss?: Maybe<Scalars['Float']>;
  weightLossTimeFrame?: Maybe<VeiosTimeFrameMsg>;
  workInShifts?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_SleepDisturbance {
  SleepDisturbanceFallingAsleep = 'SLEEP_DISTURBANCE_FALLING_ASLEEP',
  SleepDisturbanceNone = 'SLEEP_DISTURBANCE_NONE',
  SleepDisturbanceStayingAsleep = 'SLEEP_DISTURBANCE_STAYING_ASLEEP'
}

export type Treatment_SleepMovementMsg = {
  __typename?: 'treatment_SleepMovementMsg';
  flappingMovement?: Maybe<Scalars['Boolean']>;
  flappingMovementDescription?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legMovement?: Maybe<Scalars['Boolean']>;
  legMovementDescription?: Maybe<Scalars['String']>;
  legTinglingOrPain?: Maybe<Scalars['Boolean']>;
  legTinglingOrPainDescription?: Maybe<Scalars['String']>;
  tossingAndTurning?: Maybe<Scalars['Boolean']>;
  tossingAndTurningDescription?: Maybe<Scalars['String']>;
};

export enum Treatment_SleepWakeRhythm {
  /** mild alteration (sleep disturbance) (1) */
  SleepWakeRhythmMildAlteration = 'SLEEP_WAKE_RHYTHM_MILD_ALTERATION',
  SleepWakeRhythmNone = 'SLEEP_WAKE_RHYTHM_NONE',
  /** none (0) */
  SleepWakeRhythmNotAtAll = 'SLEEP_WAKE_RHYTHM_NOT_AT_ALL',
  /** Insomnia at night despite strong pharmacotherapy, daytime sleepiness (7) */
  SleepWakeRhythmSleepInsomniaAtNight = 'SLEEP_WAKE_RHYTHM_SLEEP_INSOMNIA_AT_NIGHT',
  /** sleep only with strong pharmacotherapy (4) */
  SleepWakeRhythmSleepOnlyWithStrongPharmacotherapy = 'SLEEP_WAKE_RHYTHM_SLEEP_ONLY_WITH_STRONG_PHARMACOTHERAPY'
}

export enum Treatment_Smoker {
  SmokerLessThan_6LightCigarettesPerDay = 'SMOKER_LESS_THAN_6_LIGHT_CIGARETTES_PER_DAY',
  SmokerLessThan_6StrongCigarettesPerDay = 'SMOKER_LESS_THAN_6_STRONG_CIGARETTES_PER_DAY',
  SmokerMoreThan_6StrongCigarettesPerDay = 'SMOKER_MORE_THAN_6_STRONG_CIGARETTES_PER_DAY',
  SmokerNone = 'SMOKER_NONE',
  SmokerNonSmoker = 'SMOKER_NON_SMOKER'
}

export type Treatment_SnoringMsg = {
  __typename?: 'treatment_SnoringMsg';
  id?: Maybe<Scalars['String']>;
  partnerDisturbed?: Maybe<Array<Maybe<Treatment_PartnerDisturbed>>>;
  partnerDisturbedDescription?: Maybe<Scalars['String']>;
  snoringRhythm?: Maybe<Treatment_SnoringRhythm>;
  /** From 1 (silent) to 10 (loud) */
  snoringVolume?: Maybe<Scalars['Int']>;
};

export enum Treatment_SnoringRhythm {
  SnoringRhythmIrregular = 'SNORING_RHYTHM_IRREGULAR',
  SnoringRhythmNone = 'SNORING_RHYTHM_NONE',
  SnoringRhythmRegular = 'SNORING_RHYTHM_REGULAR'
}

export type Treatment_SocialActivitiesMsg = {
  __typename?: 'treatment_SocialActivitiesMsg';
  activitySatisfactionWithCondition?: Maybe<Treatment_ActivitySatisfactionWithCondition>;
  hobbiesStatus?: Maybe<Treatment_HobbiesStatus>;
  interestsDevelopment?: Maybe<Treatment_InterestsDevelopment>;
  leavingHome?: Maybe<Treatment_LeavingHome>;
  occupation?: Maybe<Scalars['String']>;
  petsStatus?: Maybe<Treatment_PetsStatus>;
  socialActivitiesScore?: Maybe<Scalars['Int']>;
};

export type Treatment_SocialContactsAndSupportMsg = {
  __typename?: 'treatment_SocialContactsAndSupportMsg';
  caregivers?: Maybe<Treatment_Caregivers>;
  contactSatisfactionWithCondition?: Maybe<Treatment_ContactSatisfactionWithCondition>;
  contactWithCaregiver?: Maybe<Treatment_ContactWithCaregiver>;
  developmentOfContacts?: Maybe<Treatment_DevelopmentOfContacts>;
  livingCircumstances?: Maybe<Treatment_LivingCircumstances>;
  relationshipWithCaregiver?: Maybe<Treatment_RelationshipWithCaregiver>;
  socialContactsAndSupportScore?: Maybe<Scalars['Int']>;
};

export enum Treatment_SocialInteraction {
  SocialInteractionAlwaysUncooperative = 'SOCIAL_INTERACTION_ALWAYS_UNCOOPERATIVE',
  SocialInteractionNone = 'SOCIAL_INTERACTION_NONE',
  SocialInteractionOccasionallyUncooperative = 'SOCIAL_INTERACTION_OCCASIONALLY_UNCOOPERATIVE',
  SocialInteractionUndisturbed = 'SOCIAL_INTERACTION_UNDISTURBED'
}

export enum Treatment_SofaBilirubin {
  SofaBilirubinBetween_1_2And_1_9 = 'SOFA_BILIRUBIN_BETWEEN_1_2_AND_1_9',
  SofaBilirubinBetween_2_0And_5_9 = 'SOFA_BILIRUBIN_BETWEEN_2_0_AND_5_9',
  SofaBilirubinBetween_6_0And_11_9 = 'SOFA_BILIRUBIN_BETWEEN_6_0_AND_11_9',
  SofaBilirubinGreaterThan_12 = 'SOFA_BILIRUBIN_GREATER_THAN_12',
  SofaBilirubinLessThan_1_2 = 'SOFA_BILIRUBIN_LESS_THAN_1_2',
  SofaBilirubinNone = 'SOFA_BILIRUBIN_NONE'
}

export type Treatment_SofaBlock = {
  __typename?: 'treatment_SofaBlock';
  bilirubin?: Maybe<Treatment_SofaBilirubin>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  creatinine?: Maybe<Treatment_SofaCreatinine>;
  glasgowComaScale?: Maybe<Treatment_SofaGlasgowComaScale>;
  meanArterialPressure?: Maybe<Treatment_SofaMeanArterialPressure>;
  oxygenationIndex?: Maybe<Treatment_SofaOxygenationIndex>;
  platelets?: Maybe<Treatment_SofaPlatelets>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_SofaCreatinine {
  SofaCreatinineBetween_1_2And_1_9 = 'SOFA_CREATININE_BETWEEN_1_2_AND_1_9',
  SofaCreatinineBetween_2_0And_3_4 = 'SOFA_CREATININE_BETWEEN_2_0_AND_3_4',
  SofaCreatinineBetween_3_5And_4_9 = 'SOFA_CREATININE_BETWEEN_3_5_AND_4_9',
  SofaCreatinineGreaterThan_5 = 'SOFA_CREATININE_GREATER_THAN_5',
  SofaCreatinineLessThan_1_2 = 'SOFA_CREATININE_LESS_THAN_1_2',
  SofaCreatinineNone = 'SOFA_CREATININE_NONE'
}

export enum Treatment_SofaGlasgowComaScale {
  SofaGlasgowComaScale_15 = 'SOFA_GLASGOW_COMA_SCALE_15',
  SofaGlasgowComaScaleBetween_6And_9 = 'SOFA_GLASGOW_COMA_SCALE_BETWEEN_6_AND_9',
  SofaGlasgowComaScaleBetween_10And_12 = 'SOFA_GLASGOW_COMA_SCALE_BETWEEN_10_AND_12',
  SofaGlasgowComaScaleBetween_13And_14 = 'SOFA_GLASGOW_COMA_SCALE_BETWEEN_13_AND_14',
  SofaGlasgowComaScaleLessThan_6 = 'SOFA_GLASGOW_COMA_SCALE_LESS_THAN_6',
  SofaGlasgowComaScaleNone = 'SOFA_GLASGOW_COMA_SCALE_NONE'
}

export enum Treatment_SofaMeanArterialPressure {
  SofaMeanArterialPressureCatecholaminesDosageHigh = 'SOFA_MEAN_ARTERIAL_PRESSURE_CATECHOLAMINES_DOSAGE_HIGH',
  SofaMeanArterialPressureCatecholaminesDosageLow = 'SOFA_MEAN_ARTERIAL_PRESSURE_CATECHOLAMINES_DOSAGE_LOW',
  SofaMeanArterialPressureCatecholaminesDosageMedium = 'SOFA_MEAN_ARTERIAL_PRESSURE_CATECHOLAMINES_DOSAGE_MEDIUM',
  SofaMeanArterialPressureGreaterThanOrEqualTo_70 = 'SOFA_MEAN_ARTERIAL_PRESSURE_GREATER_THAN_OR_EQUAL_TO_70',
  SofaMeanArterialPressureLessThan_70 = 'SOFA_MEAN_ARTERIAL_PRESSURE_LESS_THAN_70',
  SofaMeanArterialPressureNone = 'SOFA_MEAN_ARTERIAL_PRESSURE_NONE'
}

export enum Treatment_SofaOxygenationIndex {
  /** [100:200) (3) */
  SofaOxygenationIndexBetween_100InclusiveAnd_200ExclusiveAndVentilation = 'SOFA_OXYGENATION_INDEX_BETWEEN_100_INCLUSIVE_AND_200_EXCLUSIVE_AND_VENTILATION',
  /** [200:300) (2) */
  SofaOxygenationIndexBetween_200InclusiveAnd_300Exclusive = 'SOFA_OXYGENATION_INDEX_BETWEEN_200_INCLUSIVE_AND_300_EXCLUSIVE',
  /** [300:400) (1) */
  SofaOxygenationIndexBetween_300InclusiveAnd_400Exclusive = 'SOFA_OXYGENATION_INDEX_BETWEEN_300_INCLUSIVE_AND_400_EXCLUSIVE',
  /** >=400 (0) */
  SofaOxygenationIndexGreaterThanOrEqualTo_400 = 'SOFA_OXYGENATION_INDEX_GREATER_THAN_OR_EQUAL_TO_400',
  /** <100 (4) */
  SofaOxygenationIndexLessThan_100AndVentilation = 'SOFA_OXYGENATION_INDEX_LESS_THAN_100_AND_VENTILATION',
  SofaOxygenationIndexNone = 'SOFA_OXYGENATION_INDEX_NONE'
}

export enum Treatment_SofaPlatelets {
  /** [20:50) */
  SofaPlateletsBetween_20InclusiveAnd_50Exclusive = 'SOFA_PLATELETS_BETWEEN_20_INCLUSIVE_AND_50_EXCLUSIVE',
  /** [50:100) */
  SofaPlateletsBetween_50InclusiveAnd_100Exclusive = 'SOFA_PLATELETS_BETWEEN_50_INCLUSIVE_AND_100_EXCLUSIVE',
  /** [100:150) */
  SofaPlateletsBetween_100InclusiveAnd_150Exclusive = 'SOFA_PLATELETS_BETWEEN_100_INCLUSIVE_AND_150_EXCLUSIVE',
  SofaPlateletsBetweenLessThan_20 = 'SOFA_PLATELETS_BETWEEN_LESS_THAN_20',
  SofaPlateletsGreaterThanOrEqualTo_150 = 'SOFA_PLATELETS_GREATER_THAN_OR_EQUAL_TO_150',
  SofaPlateletsNone = 'SOFA_PLATELETS_NONE'
}

export type Treatment_SoftTissueEmphysemMsg = {
  __typename?: 'treatment_SoftTissueEmphysemMsg';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locationInput?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_SoftTissueEmphysemaBlock = {
  __typename?: 'treatment_SoftTissueEmphysemaBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  softTissueEmphysema?: Maybe<Array<Maybe<Treatment_SoftTissueEmphysemMsg>>>;
};

export enum Treatment_SoftTissueFindings {
  SoftTissueFindingsNone = 'SOFT_TISSUE_FINDINGS_NONE',
  SoftTissueFindingsPeriarticularSwelling = 'SOFT_TISSUE_FINDINGS_PERIARTICULAR_SWELLING',
  SoftTissueFindingsSignificantIntraarticularEffusion = 'SOFT_TISSUE_FINDINGS_SIGNIFICANT_INTRAARTICULAR_EFFUSION',
  SoftTissueFindingsUnremarkable = 'SOFT_TISSUE_FINDINGS_UNREMARKABLE'
}

export enum Treatment_SourceOfInformation {
  SourceOfInformationBoth = 'SOURCE_OF_INFORMATION_BOTH',
  SourceOfInformationCaregiver = 'SOURCE_OF_INFORMATION_CAREGIVER',
  SourceOfInformationNone = 'SOURCE_OF_INFORMATION_NONE',
  SourceOfInformationPatient = 'SOURCE_OF_INFORMATION_PATIENT'
}

export type Treatment_SpeakingBlock = {
  __typename?: 'treatment_SpeakingBlock';
  descriptions?: Maybe<Array<Maybe<Treatment_SpeakingDescriptionMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  speaking?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_SpeakingDescriptionMsg = {
  __typename?: 'treatment_SpeakingDescriptionMsg';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SpecialRespiratoryFeaturesBlock = {
  __typename?: 'treatment_SpecialRespiratoryFeaturesBlock';
  breathingSounds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  breathingSoundsPresent?: Maybe<Scalars['Boolean']>;
  cyanosis?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  cyanosisPresent?: Maybe<Scalars['Boolean']>;
  dyspnea?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  dyspneaPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  specialBreathingPatterns?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  specialBreathingPatternsPresent?: Maybe<Scalars['Boolean']>;
  tidalAirSmells?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  tidalAirSmellsResult?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_SpecificEarsBlock = {
  __typename?: 'treatment_SpecificEarsBlock';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SpecificEyesBlock = {
  __typename?: 'treatment_SpecificEyesBlock';
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SpecificNoseAndSinusBlock = {
  __typename?: 'treatment_SpecificNoseAndSinusBlock';
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_Speech {
  /** Speech is combined with nonverbal communication */
  SpeechCombinedWithNonverbal = 'SPEECH_COMBINED_WITH_NONVERBAL',
  /** Loss of intelligible speech */
  SpeechLossOfIntelligible = 'SPEECH_LOSS_OF_INTELLIGIBLE',
  SpeechNone = 'SPEECH_NONE',
  /** Perceptible speech disturbances */
  SpeechPerceptibleSpeechDisturbances = 'SPEECH_PERCEPTIBLE_SPEECH_DISTURBANCES',
  /** Repetition necessary for communication */
  SpeechRepetition = 'SPEECH_REPETITION',
  SpeechUndisturbed = 'SPEECH_UNDISTURBED'
}

export type Treatment_SpeechBlock = {
  __typename?: 'treatment_SpeechBlock';
  aphasia?: Maybe<Scalars['Boolean']>;
  aphasiaDescriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  aphasiaText?: Maybe<Scalars['String']>;
  flowOfSpeech?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  flowOfSpeechAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  flowOfSpeechText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  naming?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  namingText?: Maybe<Scalars['String']>;
  repeating?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  repeatingText?: Maybe<Scalars['String']>;
  speech?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  speechComprehension?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  speechComprehensionText?: Maybe<Scalars['String']>;
};

export enum Treatment_SphincterTonusType {
  SphincterTonusDecreased = 'SPHINCTER_TONUS_DECREASED',
  SphincterTonusIncreased = 'SPHINCTER_TONUS_INCREASED',
  SphincterTonusNone = 'SPHINCTER_TONUS_NONE',
  SphincterTonusNormal = 'SPHINCTER_TONUS_NORMAL'
}

export type Treatment_SpineAgilityBlock = {
  __typename?: 'treatment_SpineAgilityBlock';
  movementPainPresent?: Maybe<Scalars['Boolean']>;
  movementPainText?: Maybe<Scalars['String']>;
  restrictionOfMovementPresent?: Maybe<Scalars['Boolean']>;
  restrictionOfMovementText?: Maybe<Scalars['String']>;
};

export type Treatment_SpineInfiltrationIndicationMsg = {
  __typename?: 'treatment_SpineInfiltrationIndicationMsg';
  painBeforeInjection?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SpineInfiltrationMsg = {
  __typename?: 'treatment_SpineInfiltrationMsg';
  cortisone?: Maybe<Treatment_CortisoneMsg>;
  cortisonePresent?: Maybe<Scalars['Boolean']>;
  facetInfiltration?: Maybe<Treatment_FacetInfiltrationMsg>;
  facetInfiltrationPresent?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  indication?: Maybe<Treatment_SpineInfiltrationIndicationMsg>;
  localAnesthetic?: Maybe<Treatment_LocalAnestheticMsg>;
  nerveRootBlock?: Maybe<Treatment_NerveRootBlockMsg>;
  nerveRootBlockPresent?: Maybe<Scalars['Boolean']>;
  neurologicalExaminationAfterInfiltration?: Maybe<Treatment_NeurologicalExaminationMsg>;
  neurologicalExaminationBeforeInfiltration?: Maybe<Treatment_NeurologicalExaminationMsg>;
  /** most likely will be replaced by formId in the future */
  painQuestionnaireAfterInjection?: Maybe<Treatment_PainQuestionnaireMsg>;
  periduralInjections?: Maybe<Treatment_PeriduralInjectionsMsg>;
};

export type Treatment_SpinePalpationBlock = {
  __typename?: 'treatment_SpinePalpationBlock';
  abnormalitiesPresent?: Maybe<Scalars['Boolean']>;
  abnormalitiesText?: Maybe<Scalars['String']>;
};

export type Treatment_SpinePercussionBlock = {
  __typename?: 'treatment_SpinePercussionBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_SpleenPalpationBlock = {
  __typename?: 'treatment_SpleenPalpationBlock';
  furtherDetails?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  spleenPalpable?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_SportFrequencyReference {
  SportFrequencyMonth = 'SPORT_FREQUENCY_MONTH',
  SportFrequencyNone = 'SPORT_FREQUENCY_NONE',
  SportFrequencyWeek = 'SPORT_FREQUENCY_WEEK'
}

export type Treatment_SportMsg = {
  __typename?: 'treatment_SportMsg';
  frequency?: Maybe<Scalars['Int']>;
  frequencyReference?: Maybe<Treatment_SportFrequencyReference>;
  id?: Maybe<Scalars['String']>;
  occurringProblems?: Maybe<Scalars['String']>;
  sport?: Maybe<Core_KnowledgeInputMsg>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SportsBlock = {
  __typename?: 'treatment_SportsBlock';
  present?: Maybe<Scalars['Boolean']>;
  sports?: Maybe<Array<Maybe<Treatment_SportMsg>>>;
};

export type Treatment_StaffelsteinHipBlock = {
  __typename?: 'treatment_StaffelsteinHipBlock';
  abduction?: Maybe<Treatment_Abduction>;
  completed?: Maybe<Scalars['Boolean']>;
  extensionDeficit?: Maybe<Treatment_HipExtensionDeficit>;
  flexion?: Maybe<Treatment_Flexion>;
  gettingUp?: Maybe<Treatment_GettingUp>;
  glutealMuscleStrength?: Maybe<Treatment_GlutealMuscleStrength>;
  hygiene?: Maybe<Treatment_Hygiene>;
  limp?: Maybe<Treatment_Limp>;
  pain?: Maybe<Treatment_StaffelsteinPain>;
  publicTransportation?: Maybe<Treatment_PublicTransportation>;
  score?: Maybe<Scalars['Int']>;
  shoesOrSocks?: Maybe<Treatment_ShoesOrSocks>;
  stairsDifficulty?: Maybe<Treatment_StairsDifficulty>;
  walkingAids?: Maybe<Treatment_WalkingAids>;
  walkingDistance?: Maybe<Treatment_HipWalkingDistance>;
};

export type Treatment_StaffelsteinKneeBlock = {
  __typename?: 'treatment_StaffelsteinKneeBlock';
  /** without difficulty (5) /with difficulty and use of handrail (3) /with great difficulty or not possible (0) */
  climbingStairs?: Maybe<Treatment_DifficultySelect>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** 0° (10) / 5°-15° (5) / ≥20° (0) */
  extensionDeficit?: Maybe<Treatment_KneeExtensionDeficit>;
  /** ≥100° (10) / 75°-95° (5) / ≤70° (0) */
  flexion?: Maybe<Treatment_Flexion>;
  /** without difficulty (5) /with little assistance (3) /dependent (great difficulty) */
  gettingUpFromBedAndChair?: Maybe<Treatment_DifficultySelect>;
  /** fluent gait (5) /mild to moderate (3) /severe (0) */
  limp?: Maybe<Treatment_Limp>;
  /**
   * no pain during activities of daily living (40)
   * /mild, occasional or subthreshold pain that does not affect activities of daily living (30)
   * /moderate pain, possibly with analgesic use (20)
   * /pain significantly interferes with work and activities of daily living, constant need for analgesics (10)
   * /severe pain, patient severely restricted or immobile (0)
   */
  pain?: Maybe<Treatment_StaffelsteinPain>;
  /** without difficulty (5) /with little assistance (3) /dependent (0) (with great difficulty / not possible) */
  personalAndToiletHygiene?: Maybe<Treatment_DifficultySelect>;
  publicTransportation?: Maybe<Treatment_PublicTransportation>;
  /** without difficulty (5) /with difficulty (3) /not possible (0) */
  puttingOnSocksOrShoes?: Maybe<Treatment_DifficultySelect>;
  /** 4/5 - 5/5 (10) / 3/5 (5) / 1/5 - 2/5 (0) */
  quadricepsMuscleStrength?: Maybe<Treatment_QuadricepsMuscleStrength>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** unremarkable (10) / periarticular swelling (5) / significant intraarticular effusion (0) */
  softTissueFindings?: Maybe<Treatment_SoftTissueFindings>;
  /** none (5) /forearm crutches, walking stick (4) /rollator, walking frame (3) / wheelchair (2) / bedridden (0) */
  walkingAids?: Maybe<Treatment_WalkingAids>;
  /** unlimited (5) /walking at a stretch from 50m to 500m possible (4) /walking at a stretch to 50m possible (4) /mobile in room (2) /immobile (5) */
  walkingDistance?: Maybe<Treatment_KneeWalkingDistance>;
};

export enum Treatment_StaffelsteinPain {
  /** mild, occasional or subthreshold pain that does not affect activities of daily living (30) */
  StaffelsteinPainMild = 'STAFFELSTEIN_PAIN_MILD',
  /** moderate pain, possibly with analgesic use (20) */
  StaffelsteinPainModerate = 'STAFFELSTEIN_PAIN_MODERATE',
  StaffelsteinPainNone = 'STAFFELSTEIN_PAIN_NONE',
  /** no pain during activities of daily living (40) */
  StaffelsteinPainNoPain = 'STAFFELSTEIN_PAIN_NO_PAIN',
  /** severe pain, patient severely restricted or immobile (0) */
  StaffelsteinPainSevere = 'STAFFELSTEIN_PAIN_SEVERE',
  /** pain significantly interferes with work and activities of daily living, constant need for analgesics (10) */
  StaffelsteinPainSignificant = 'STAFFELSTEIN_PAIN_SIGNIFICANT'
}

export enum Treatment_Stairs {
  StairsIndependent = 'STAIRS_INDEPENDENT',
  StairsNeedsHelp = 'STAIRS_NEEDS_HELP',
  StairsNone = 'STAIRS_NONE',
  StairsUnable = 'STAIRS_UNABLE'
}

export enum Treatment_StairsDifficulty {
  StairsDifficultyNone = 'STAIRS_DIFFICULTY_NONE',
  StairsDifficultyWithoutDifficulty = 'STAIRS_DIFFICULTY_WITHOUT_DIFFICULTY',
  StairsDifficultyWithDifficultyAndHandrail = 'STAIRS_DIFFICULTY_WITH_DIFFICULTY_AND_HANDRAIL',
  StairsDifficultyWithGreatDifficultyOrImpossible = 'STAIRS_DIFFICULTY_WITH_GREAT_DIFFICULTY_OR_IMPOSSIBLE'
}

export type Treatment_StandbyMsg = {
  __typename?: 'treatment_StandbyMsg';
  airwayAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  airwayManagements?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ventilationTypes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_StandingBalance {
  StandingBalanceNone = 'STANDING_BALANCE_NONE',
  /** feet far apart (>10cm) */
  StandingBalanceSafeButFeetFarApartOrAid = 'STANDING_BALANCE_SAFE_BUT_FEET_FAR_APART_OR_AID',
  StandingBalanceSteadyWithoutAid = 'STANDING_BALANCE_STEADY_WITHOUT_AID',
  StandingBalanceUnsteady = 'STANDING_BALANCE_UNSTEADY'
}

export type Treatment_StdRiskBlock = {
  __typename?: 'treatment_StdRiskBlock';
  numberPartnersLastMonth?: Maybe<Scalars['Int']>;
  numberPartnersLastSixMonth?: Maybe<Scalars['Int']>;
  numberPartnersLifetime?: Maybe<Scalars['Int']>;
  stdProtections?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  stdRiskFactorsPresent?: Maybe<Scalars['Boolean']>;
  stdRiskFactorsText?: Maybe<Scalars['String']>;
  stdTestsPresent?: Maybe<Scalars['Boolean']>;
  stdTestsText?: Maybe<Scalars['String']>;
};

export enum Treatment_StepContinually {
  StepContinuallyContinuousSteps = 'STEP_CONTINUALLY_CONTINUOUS_STEPS',
  StepContinuallyDiscontinuityBetweenSteps = 'STEP_CONTINUALLY_DISCONTINUITY_BETWEEN_STEPS',
  /** <continuous steps (1) / discontinuity between steps (0)> */
  StepContinuallyNone = 'STEP_CONTINUALLY_NONE'
}

export enum Treatment_StomachacheLocalization {
  StomachacheLocalizationEntireAbdomen = 'STOMACHACHE_LOCALIZATION_ENTIRE_ABDOMEN',
  StomachacheLocalizationLeftUpperQuadrant = 'STOMACHACHE_LOCALIZATION_LEFT_UPPER_QUADRANT',
  StomachacheLocalizationLowerLeftQuadrant = 'STOMACHACHE_LOCALIZATION_LOWER_LEFT_QUADRANT',
  StomachacheLocalizationLowerRightQuadrant = 'STOMACHACHE_LOCALIZATION_LOWER_RIGHT_QUADRANT',
  StomachacheLocalizationMidAbdomen = 'STOMACHACHE_LOCALIZATION_MID_ABDOMEN',
  StomachacheLocalizationNone = 'STOMACHACHE_LOCALIZATION_NONE',
  StomachacheLocalizationRightUpperQuadrant = 'STOMACHACHE_LOCALIZATION_RIGHT_UPPER_QUADRANT'
}

export type Treatment_StoolDescriptionMsg = {
  __typename?: 'treatment_StoolDescriptionMsg';
  defecationPain?: Maybe<Core_KnowledgeInputMsg>;
  defecationPainPresent?: Maybe<Scalars['Boolean']>;
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  evaluationText?: Maybe<Scalars['String']>;
  fecalContinenceDescription?: Maybe<Scalars['String']>;
  fecalContinencePresent?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<Scalars['Int']>;
  frequencyResolution?: Maybe<Treatment_DefecationResolution>;
  id?: Maybe<Scalars['String']>;
  lastDefecation?: Maybe<VeiosDateTimeMsg>;
  qualities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_StopBangRiskBlock = {
  __typename?: 'treatment_StopBangRiskBlock';
  /** Age >50 years: <yes (1) / no (0)> */
  ageGreaterThan50?: Maybe<Scalars['Boolean']>;
  /** BMI >35 kg/m2: <yes (1) / no (0)> */
  bmiGreaterThan35?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** High blood pressure or current treatment for hypertension: <yes (1) / no (0)> */
  highBloodPressure?: Maybe<Scalars['Boolean']>;
  /** Loud snoring: <yes (1) / no (0)> */
  loudSnoring?: Maybe<Scalars['Boolean']>;
  /** Male: <yes (1) / no (0)> */
  male?: Maybe<Scalars['Boolean']>;
  /** Neck circumference >40 cm: <yes (1) / no (0)> */
  neckCircumferenceGreaterThan40?: Maybe<Scalars['Boolean']>;
  /** Often fatigue or sleepiness during the daytime: <yes (1) / no (0)> */
  oftenFatigue?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** Observed to stop breathing during sleep: <yes (1) / no (0)> */
  stopBreathingDuringSleep?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_Subtraction {
  Subtraction_0CorrectResult = 'SUBTRACTION_0_CORRECT_RESULT',
  Subtraction_1CorrectResult = 'SUBTRACTION_1_CORRECT_RESULT',
  Subtraction_2To_3CorrectResult = 'SUBTRACTION_2_TO_3_CORRECT_RESULT',
  SubtractionNone = 'SUBTRACTION_NONE',
  SubtractionOver_3CorrectResult = 'SUBTRACTION_OVER_3_CORRECT_RESULT'
}

export type Treatment_SuctionTimeIntervalMsg = {
  __typename?: 'treatment_SuctionTimeIntervalMsg';
  duration?: Maybe<Scalars['Int']>;
  durationTimeUnit?: Maybe<TimeUnit>;
  repetitionCycle?: Maybe<Scalars['Int']>;
  repetitionCycleTimeUnit?: Maybe<TimeUnit>;
};

export enum Treatment_SuctionTimeIntervalType {
  SuctionTimeIntervalTypeContinually = 'SUCTION_TIME_INTERVAL_TYPE_CONTINUALLY',
  SuctionTimeIntervalTypeIntermitted = 'SUCTION_TIME_INTERVAL_TYPE_INTERMITTED',
  SuctionTimeIntervalTypeNone = 'SUCTION_TIME_INTERVAL_TYPE_NONE'
}

export enum Treatment_SuctionUnit {
  SuctionUnitCmH2O = 'SUCTION_UNIT_CM_H2O',
  SuctionUnitMmHg = 'SUCTION_UNIT_MM_HG',
  SuctionUnitNone = 'SUCTION_UNIT_NONE'
}

export enum Treatment_SuicidalThoughts {
  SuicidalThoughtsAlwaysHaveSuicidalThoughts = 'SUICIDAL_THOUGHTS_ALWAYS_HAVE_SUICIDAL_THOUGHTS',
  SuicidalThoughtsNone = 'SUICIDAL_THOUGHTS_NONE',
  SuicidalThoughtsNoSuicidalThoughts = 'SUICIDAL_THOUGHTS_NO_SUICIDAL_THOUGHTS',
  SuicidalThoughtsOftenHaveSuicidalThoughtsWithNoAction = 'SUICIDAL_THOUGHTS_OFTEN_HAVE_SUICIDAL_THOUGHTS_WITH_NO_ACTION',
  SuicidalThoughtsUsuallyHaveSuicidalThoughts = 'SUICIDAL_THOUGHTS_USUALLY_HAVE_SUICIDAL_THOUGHTS'
}

export enum Treatment_SurgeryDuration {
  /** (2-3] (16) */
  SurgeryDurationBetween_2And_3 = 'SURGERY_DURATION_BETWEEN_2_AND_3',
  /** >3 (23) */
  SurgeryDurationGreaterThan_3 = 'SURGERY_DURATION_GREATER_THAN_3',
  /** ≤2 (0) */
  SurgeryDurationLessThanOrEqual_2 = 'SURGERY_DURATION_LESS_THAN_OR_EQUAL_2',
  SurgeryDurationNone = 'SURGERY_DURATION_NONE'
}

export type Treatment_SurgeryPreparationMsg = {
  __typename?: 'treatment_SurgeryPreparationMsg';
  diagnosesDevelopments?: Maybe<Array<Maybe<Treatment_DiagnosesDevelopmentMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  previousHistoryHtml?: Maybe<Scalars['String']>;
  symptomOccurrences?: Maybe<Array<Maybe<Treatment_SymptomOccurrenceMsg>>>;
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
};

export enum Treatment_SurgicalIncision {
  /** Intra-thoracic (24) */
  SurgicalIncisionIntraThoracic = 'SURGICAL_INCISION_INTRA_THORACIC',
  SurgicalIncisionNone = 'SURGICAL_INCISION_NONE',
  /** Peripheral (0) */
  SurgicalIncisionPeripheral = 'SURGICAL_INCISION_PERIPHERAL',
  /** Upper abdominal (15) */
  SurgicalIncisionUpperAbdominal = 'SURGICAL_INCISION_UPPER_ABDOMINAL'
}

export type Treatment_SurgicalScarMsg = {
  __typename?: 'treatment_SurgicalScarMsg';
  dateOfOperation?: Maybe<VeiosDateTimeMsg>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
  localizationsInput?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  nameOfOperation?: Maybe<Scalars['String']>;
};

export type Treatment_SurgicalScarsBlock = {
  __typename?: 'treatment_SurgicalScarsBlock';
  present?: Maybe<Scalars['Boolean']>;
  surgicalScars?: Maybe<Array<Maybe<Treatment_SurgicalScarMsg>>>;
};

export type Treatment_SutureRemovalMsg = {
  __typename?: 'treatment_SutureRemovalMsg';
  recommendedRemovalDuration?: Maybe<Scalars['Int']>;
  recommendedRemovalDurationUnit?: Maybe<TimeUnit>;
};

export type Treatment_SutureThreadMsg = {
  __typename?: 'treatment_SutureThreadMsg';
  resobabilityType?: Maybe<Treatment_SutureThreadResobabilityType>;
  /** unit:USP */
  sutureThreadSize?: Maybe<Core_KnowledgeInputMsg>;
  sutureThreads?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_SutureThreadResobabilityType {
  SutureThreadResobabilityTypeLongTermResobable = 'SUTURE_THREAD_RESOBABILITY_TYPE_LONG_TERM_RESOBABLE',
  SutureThreadResobabilityTypeMediumTermResobable = 'SUTURE_THREAD_RESOBABILITY_TYPE_MEDIUM_TERM_RESOBABLE',
  SutureThreadResobabilityTypeNone = 'SUTURE_THREAD_RESOBABILITY_TYPE_NONE',
  SutureThreadResobabilityTypeNonResobable = 'SUTURE_THREAD_RESOBABILITY_TYPE_NON_RESOBABLE',
  SutureThreadResobabilityTypeResobable = 'SUTURE_THREAD_RESOBABILITY_TYPE_RESOBABLE',
  SutureThreadResobabilityTypeShortTermResobable = 'SUTURE_THREAD_RESOBABILITY_TYPE_SHORT_TERM_RESOBABLE'
}

export enum Treatment_Swallowing {
  /** Change in food consistency required */
  SwallowingChangeInFoodConsistency = 'SWALLOWING_CHANGE_IN_FOOD_CONSISTENCY',
  /** Incipient eating problems with occasional swallowing */
  SwallowingEatingProblems = 'SWALLOWING_EATING_PROBLEMS',
  /** Feeding exclusively via feeding tube */
  SwallowingFeedingExclusivelyViaTube = 'SWALLOWING_FEEDING_EXCLUSIVELY_VIA_TUBE',
  SwallowingNone = 'SWALLOWING_NONE',
  /** Supplemental tube feeding required */
  SwallowingSupplementalTubeFeeding = 'SWALLOWING_SUPPLEMENTAL_TUBE_FEEDING',
  SwallowingUndisturbed = 'SWALLOWING_UNDISTURBED'
}

export type Treatment_SwellingLimbsBlock = {
  __typename?: 'treatment_SwellingLimbsBlock';
  present?: Maybe<Scalars['Boolean']>;
  swellings?: Maybe<Array<Maybe<Treatment_SwellingLimbsMsg>>>;
};

export type Treatment_SwellingLimbsMsg = {
  __typename?: 'treatment_SwellingLimbsMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_Symptom {
  /** drowsiness, apathy (3) */
  SymptomApathy = 'SYMPTOM_APATHY',
  /** borborygmus (1) */
  SymptomBorborygmus = 'SYMPTOM_BORBORYGMUS',
  /** burping (-1) */
  SymptomBurping = 'SYMPTOM_BURPING',
  /** dizziness (2) */
  SymptomDizziness = 'SYMPTOM_DIZZINESS',
  /** dyspnea (3) */
  SymptomDyspnea = 'SYMPTOM_DYSPNEA',
  /** weakness, fatigue (3) */
  SymptomFatigue = 'SYMPTOM_FATIGUE',
  /** flush, Sweating, pallor, cold sweats (1) */
  SymptomFlushSweatingPallor = 'SYMPTOM_FLUSH_SWEATING_PALLOR',
  /** Fullness, meteorism (1) */
  SymptomFullnessMeteorism = 'SYMPTOM_FULLNESS_METEORISM',
  /** headache (1) */
  SymptomHeadache = 'SYMPTOM_HEADACHE',
  /** needs to sit or lie down (4) */
  SymptomLieDown = 'SYMPTOM_LIE_DOWN',
  /** Nausea (1) */
  SymptomNausea = 'SYMPTOM_NAUSEA',
  SymptomNone = 'SYMPTOM_NONE',
  /** palpitation(3) */
  SymptomPalpitation = 'SYMPTOM_PALPITATION',
  /** restlessness (2) */
  SymptomRestlessness = 'SYMPTOM_RESTLESSNESS',
  /** shock (5) */
  SymptomShock = 'SYMPTOM_SHOCK',
  /** syncope, loss of consciousness (4) */
  SymptomSyncope = 'SYMPTOM_SYNCOPE',
  /** vomiting (-4) */
  SymptomVomiting = 'SYMPTOM_VOMITING'
}

export enum Treatment_SymptomAppearance {
  SymptomAppearanceNone = 'SYMPTOM_APPEARANCE_NONE',
  SymptomAppearanceSuccessive = 'SYMPTOM_APPEARANCE_SUCCESSIVE',
  SymptomAppearanceSudden = 'SYMPTOM_APPEARANCE_SUDDEN'
}

export enum Treatment_SymptomConfigurationActivationStatus {
  /** Confirmed, cannot be deleted anymore */
  SymptomConfigurationActivationStatusActive = 'SYMPTOM_CONFIGURATION_ACTIVATION_STATUS_ACTIVE',
  SymptomConfigurationActivationStatusInactive = 'SYMPTOM_CONFIGURATION_ACTIVATION_STATUS_INACTIVE',
  SymptomConfigurationActivationStatusNone = 'SYMPTOM_CONFIGURATION_ACTIVATION_STATUS_NONE',
  /** Entered, but not confirmed yet, i.e., not visible outside its creation scope */
  SymptomConfigurationActivationStatusNotYetActivated = 'SYMPTOM_CONFIGURATION_ACTIVATION_STATUS_NOT_YET_ACTIVATED'
}

export type Treatment_SymptomConfigurationMsg = {
  __typename?: 'treatment_SymptomConfigurationMsg';
  /** Blocks that are related to this SymptomConfiguration */
  blocks?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
  conditionDevelopment?: Maybe<Treatment_ConditionDevelopment>;
  /** For when this entry applies */
  date?: Maybe<Timestamp>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  owner?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  patientId?: Maybe<Scalars['String']>;
  symptom?: Maybe<Treatment_SymptomMsg>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  treatmentId?: Maybe<Scalars['String']>;
  versionInfo?: Maybe<Versioning_VersionInfoMsg>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_SymptomConfigurationVersionGroupMsg = {
  __typename?: 'treatment_SymptomConfigurationVersionGroupMsg';
  symptomConfigurations?: Maybe<Array<Maybe<Treatment_SymptomConfigurationMsg>>>;
  versioningGroupId?: Maybe<Scalars['String']>;
};

export enum Treatment_SymptomFrequency {
  SymptomFrequencyDay = 'SYMPTOM_FREQUENCY_DAY',
  SymptomFrequencyMonth = 'SYMPTOM_FREQUENCY_MONTH',
  SymptomFrequencyNone = 'SYMPTOM_FREQUENCY_NONE',
  SymptomFrequencyWeek = 'SYMPTOM_FREQUENCY_WEEK'
}

export type Treatment_SymptomMsg = {
  __typename?: 'treatment_SymptomMsg';
  generalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  present?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_SymptomOccurrenceMsg = {
  __typename?: 'treatment_SymptomOccurrenceMsg';
  blocks?: Maybe<Array<Maybe<Treatment_AnamnesisBlockMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  symptoms?: Maybe<Array<Maybe<Treatment_SymptomMsg>>>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_SymptomOnsetType {
  SymptomOnsetTypeNone = 'SYMPTOM_ONSET_TYPE_NONE',
  SymptomOnsetTypeParoxysmal = 'SYMPTOM_ONSET_TYPE_PAROXYSMAL',
  SymptomOnsetTypePersistent = 'SYMPTOM_ONSET_TYPE_PERSISTENT'
}

export enum Treatment_SystolicBloodPressure {
  SystolicBloodPressureBetween_20And_40Percent = 'SYSTOLIC_BLOOD_PRESSURE_BETWEEN_20_AND_40_PERCENT',
  SystolicBloodPressureGreaterThan_40Percent = 'SYSTOLIC_BLOOD_PRESSURE_GREATER_THAN_40_PERCENT',
  SystolicBloodPressureLessThan_20Percent = 'SYSTOLIC_BLOOD_PRESSURE_LESS_THAN_20_PERCENT',
  SystolicBloodPressureNone = 'SYSTOLIC_BLOOD_PRESSURE_NONE'
}

export type Treatment_TakeOverTherapyCardEditableRevisionRequest = {
  __typename?: 'treatment_TakeOverTherapyCardEditableRevisionRequest';
  revisionGroupId?: Maybe<Scalars['String']>;
  therapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_TakeOverTherapyCardEditableRevisionResponse = {
  __typename?: 'treatment_TakeOverTherapyCardEditableRevisionResponse';
  card?: Maybe<Treatment_TherapyCardMsg>;
};

export enum Treatment_Telephone {
  TelephoneNone = 'TELEPHONE_NONE',
  TelephoneNotPresent = 'TELEPHONE_NOT_PRESENT',
  TelephonePresent = 'TELEPHONE_PRESENT'
}

export type Treatment_TemperatureAnamnesticBlock = {
  __typename?: 'treatment_TemperatureAnamnesticBlock';
  temperatureMeasurements?: Maybe<Array<Maybe<Treatment_TemperatureAnamnesticMsg>>>;
};

export type Treatment_TemperatureAnamnesticMsg = {
  __typename?: 'treatment_TemperatureAnamnesticMsg';
  id?: Maybe<Scalars['String']>;
  locationOfMeasurement?: Maybe<Core_KnowledgeInputMsg>;
  temperature?: Maybe<Scalars['Float']>;
  timeOfMeasurement?: Maybe<VeiosDateTimeMsg>;
};

export type Treatment_TemperatureBlock = {
  __typename?: 'treatment_TemperatureBlock';
  temperaturMeasurements?: Maybe<Array<Maybe<Treatment_TemperatureMsg>>>;
};

export type Treatment_TemperatureMsg = {
  __typename?: 'treatment_TemperatureMsg';
  id?: Maybe<Scalars['String']>;
  locationOfMeasurement?: Maybe<Core_KnowledgeInputMsg>;
  temperature?: Maybe<Scalars['Float']>;
  timeOfMeasurement?: Maybe<VeiosDateTimeMsg>;
};

export enum Treatment_TemporalCourse {
  TemporalCourseContinuous = 'TEMPORAL_COURSE_CONTINUOUS',
  TemporalCourseIncreasing = 'TEMPORAL_COURSE_INCREASING',
  TemporalCourseIntermitent = 'TEMPORAL_COURSE_INTERMITENT',
  TemporalCourseNone = 'TEMPORAL_COURSE_NONE',
  TemporalCourseWaveLike = 'TEMPORAL_COURSE_WAVE_LIKE'
}

export enum Treatment_TestTimeSelection {
  TestTimeSelectionBetween_10And_20Seconds = 'TEST_TIME_SELECTION_BETWEEN_10_AND_20_SECONDS',
  TestTimeSelectionBetween_20And_30Seconds = 'TEST_TIME_SELECTION_BETWEEN_20_AND_30_SECONDS',
  TestTimeSelectionGreaterThan_30Seconds = 'TEST_TIME_SELECTION_GREATER_THAN_30_SECONDS',
  TestTimeSelectionLessThan_10Seconds = 'TEST_TIME_SELECTION_LESS_THAN_10_SECONDS',
  TestTimeSelectionNone = 'TEST_TIME_SELECTION_NONE'
}

export type Treatment_TherapistMsg = {
  __typename?: 'treatment_TherapistMsg';
  id?: Maybe<Scalars['String']>;
  medicalSpecialtyIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  /** Allows to gender: "Facharzt/Fachärztin für ..." */
  sex?: Maybe<Core_Sex>;
  /**
   * can be name etc.
   *  TODO: more structure needed?
   */
  text?: Maybe<Scalars['String']>;
  /** If the therapist has already been entered as practitioner in the system, this id can be used to retrieve the information */
  therapistId?: Maybe<Core_PersonReferenceMsg>;
};

export type Treatment_TherapyCardContentMsg = {
  __typename?: 'treatment_TherapyCardContentMsg';
  cryotherapy?: Maybe<Treatment_CryotherapyMsg>;
  echocardiography?: Maybe<Treatment_EchocardiographyMsg>;
  /** anesthetic procedures */
  generalAnesthesia?: Maybe<Treatment_GeneralAnesthesiaMsg>;
  laryngoscopy?: Maybe<Treatment_LaryngoscopyMsg>;
  localAnaesthesia?: Maybe<Treatment_LocalAnaesthesiaMsg>;
  miscExamination?: Maybe<Treatment_MiscellaneousExaminationMsg>;
  miscTherapy?: Maybe<Treatment_MiscellaneousTherapyMsg>;
  namedProcedure?: Maybe<Treatment_NamedProcedureMsg>;
  neuraxialAnesthesia?: Maybe<Treatment_NeuraxialAnesthesiaMsg>;
  peripheralAnesthesia?: Maybe<Treatment_PeripheralAnesthesiaMsg>;
  peritonealPuncture?: Maybe<Treatment_PeritonealPunctureMsg>;
  pleuralPuncture?: Maybe<Treatment_PleuralPunctureMsg>;
  restingElectrocardiography?: Maybe<Treatment_RestingElectrocardiographyMsg>;
  sedation?: Maybe<Treatment_SedationMsg>;
  spineInfiltration?: Maybe<Treatment_SpineInfiltrationMsg>;
  standby?: Maybe<Treatment_StandbyMsg>;
  ultrasound?: Maybe<Treatment_UltrasoundMsg>;
  woundDebridement?: Maybe<Treatment_WoundDebridementMsg>;
  woundSkinStapling?: Maybe<Treatment_WoundSkinStaplingMsg>;
  woundSuture?: Maybe<Treatment_WoundSutureMsg>;
  woundTreatment?: Maybe<Treatment_WoundTreatmentMsg>;
  woundVacuumTherapy?: Maybe<Treatment_WoundVacuumTherapyMsg>;
};

export enum Treatment_TherapyCardLocation {
  TherapyCardLocationNone = 'THERAPY_CARD_LOCATION_NONE',
  TherapyCardLocationPatientChart = 'THERAPY_CARD_LOCATION_PATIENT_CHART',
  TherapyCardLocationSurgeryDocumentation = 'THERAPY_CARD_LOCATION_SURGERY_DOCUMENTATION',
  TherapyCardLocationSurgeryPatientChart = 'THERAPY_CARD_LOCATION_SURGERY_PATIENT_CHART',
  TherapyCardLocationTreatment = 'THERAPY_CARD_LOCATION_TREATMENT'
}

export type Treatment_TherapyCardMetadataListElementMsg = {
  __typename?: 'treatment_TherapyCardMetadataListElementMsg';
  cardMetadata?: Maybe<Treatment_TherapyCardMetadataMsg>;
  /** The name of the named procedure if this element corresponds to a NamedProcedure */
  name?: Maybe<Scalars['String']>;
};

export type Treatment_TherapyCardMetadataMsg = {
  __typename?: 'treatment_TherapyCardMetadataMsg';
  forms?: Maybe<Array<Maybe<Treatment_TherapyFormMsg>>>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  /** tells us if there are multiple therapies in one card */
  singleton?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Treatment_TherapyCardMetadataTag>>>;
};

export enum Treatment_TherapyCardMetadataTag {
  TherapyCardMetadataTagAnesthesiologicalDocumentation = 'THERAPY_CARD_METADATA_TAG_ANESTHESIOLOGICAL_DOCUMENTATION',
  TherapyCardMetadataTagNone = 'THERAPY_CARD_METADATA_TAG_NONE',
  TherapyCardMetadataTagSurgeryPatientChart = 'THERAPY_CARD_METADATA_TAG_SURGERY_PATIENT_CHART',
  TherapyCardMetadataTagWound = 'THERAPY_CARD_METADATA_TAG_WOUND'
}

export type Treatment_TherapyCardMsg = {
  __typename?: 'treatment_TherapyCardMsg';
  content?: Maybe<Treatment_TherapyCardContentMsg>;
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_TherapyCardLocation>;
  metadata?: Maybe<Treatment_TherapyCardMetadataMsg>;
  participatingUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  /** can be null/empty */
  therapyId?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<TimeFrameMsg>;
};

export type Treatment_TherapyCardTemplateMsg = {
  __typename?: 'treatment_TherapyCardTemplateMsg';
  /** Only relevant for NamedProcedureMsg: Content of the NamedProcedureMsg gets auto-filled with this when this template is selected. */
  content?: Maybe<Scalars['String']>;
  create?: Maybe<Scalars['Boolean']>;
  /** only relevant for NamedProcedureMsg */
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type Treatment_TherapyFormMsg = {
  __typename?: 'treatment_TherapyFormMsg';
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum Treatment_TherapyLocation {
  TherapyLocationNone = 'THERAPY_LOCATION_NONE',
  TherapyLocationPatientChart = 'THERAPY_LOCATION_PATIENT_CHART',
  TherapyLocationTreatment = 'THERAPY_LOCATION_TREATMENT'
}

export type Treatment_TherapyMsg = {
  __typename?: 'treatment_TherapyMsg';
  context?: Maybe<Treatment_MedicalItemContextMsg>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Treatment_TherapyLocation>;
  therapies?: Maybe<Array<Maybe<Treatment_TherapyCardMsg>>>;
  therapyTemplate?: Maybe<Treatment_TherapyTemplateMsg>;
  treatmentEvaluationText?: Maybe<Scalars['String']>;
  /** can be empty/null */
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_TherapyTemplateMsg = {
  __typename?: 'treatment_TherapyTemplateMsg';
  cards?: Maybe<Array<Maybe<Treatment_TherapyCardTemplateMsg>>>;
  id?: Maybe<Scalars['String']>;
  ownerOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** The type of treatment that this template is used for */
  type?: Maybe<Treatment_TreatmentType>;
  version?: Maybe<Scalars['Int']>;
};

export enum Treatment_Thirst {
  ThirstIncreased = 'THIRST_INCREASED',
  ThirstNone = 'THIRST_NONE',
  ThirstNormal = 'THIRST_NORMAL',
  ThirstReduced = 'THIRST_REDUCED'
}

export type Treatment_ThoracicSpineJointsMsg = {
  __typename?: 'treatment_ThoracicSpineJointsMsg';
  /** Th1/Th2 */
  th1Th2?: Maybe<Laterality_Laterality>;
  /** Th2/Th3 */
  th2Th3?: Maybe<Laterality_Laterality>;
  /** Th3/Th4 */
  th3Th4?: Maybe<Laterality_Laterality>;
  /** Th4/Th5 */
  th4Th5?: Maybe<Laterality_Laterality>;
  /** Th5/Th6 */
  th5Th6?: Maybe<Laterality_Laterality>;
  /** Th6/Th7 */
  th6Th7?: Maybe<Laterality_Laterality>;
  /** Th7/Th8 */
  th7Th8?: Maybe<Laterality_Laterality>;
  /** Th8/Th9 */
  th8Th9?: Maybe<Laterality_Laterality>;
  /** Th9/Th10 */
  th9Th10?: Maybe<Laterality_Laterality>;
  /** Th10/Th11 */
  th10Th11?: Maybe<Laterality_Laterality>;
  /** Th11/Th12 */
  th11Th12?: Maybe<Laterality_Laterality>;
  /** Th12/L1 */
  th12L1?: Maybe<Laterality_Laterality>;
};

export type Treatment_ThoracicSpineMsg = {
  __typename?: 'treatment_ThoracicSpineMsg';
  th1?: Maybe<Laterality_Laterality>;
  th2?: Maybe<Laterality_Laterality>;
  th3?: Maybe<Laterality_Laterality>;
  th4?: Maybe<Laterality_Laterality>;
  th5?: Maybe<Laterality_Laterality>;
  th6?: Maybe<Laterality_Laterality>;
  th7?: Maybe<Laterality_Laterality>;
  th8?: Maybe<Laterality_Laterality>;
  th9?: Maybe<Laterality_Laterality>;
  th10?: Maybe<Laterality_Laterality>;
  th11?: Maybe<Laterality_Laterality>;
  th12?: Maybe<Laterality_Laterality>;
};

export type Treatment_ThoraxDrainageMsg = {
  __typename?: 'treatment_ThoraxDrainageMsg';
  localization?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  suction?: Maybe<Scalars['Float']>;
  suctionUnit?: Maybe<Treatment_SuctionUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_ThoraxFormBlock = {
  __typename?: 'treatment_ThoraxFormBlock';
  text?: Maybe<Scalars['String']>;
  thoraxForm?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  thoraxForms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_ThoraxFormType {
  ThoraxFormBarrelChest = 'THORAX_FORM_BARREL_CHEST',
  ThoraxFormCardiacHump = 'THORAX_FORM_CARDIAC_HUMP',
  ThoraxFormChickenBreast = 'THORAX_FORM_CHICKEN_BREAST',
  ThoraxFormKyphoscoliosis = 'THORAX_FORM_KYPHOSCOLIOSIS',
  ThoraxFormNone = 'THORAX_FORM_NONE',
  ThoraxFormSunkenChest = 'THORAX_FORM_SUNKEN_CHEST'
}

export type Treatment_ThoraxSkinChangeBlock = {
  __typename?: 'treatment_ThoraxSkinChangeBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_ThyreomentalDistanceMsg = {
  __typename?: 'treatment_ThyreomentalDistanceMsg';
  /** one decimal, unit: cm */
  distance?: Maybe<Scalars['Float']>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_ThyroidExaminationDetailMsg = {
  __typename?: 'treatment_ThyroidExaminationDetailMsg';
  descriptionText?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_ThyroidExaminationMsg = {
  __typename?: 'treatment_ThyroidExaminationMsg';
  details?: Maybe<Array<Maybe<Treatment_ThyroidExaminationDetailMsg>>>;
  id?: Maybe<Scalars['String']>;
  result?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  textIfInconspicuous?: Maybe<Scalars['String']>;
};

export type Treatment_ThyroidInspectionAndPalpationAndAuscultationBlock = {
  __typename?: 'treatment_ThyroidInspectionAndPalpationAndAuscultationBlock';
  auscultation?: Maybe<Treatment_ThyroidExaminationMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  inspection?: Maybe<Treatment_ThyroidExaminationMsg>;
  palpation?: Maybe<Treatment_ThyroidExaminationMsg>;
  strumaGrading?: Maybe<Core_KnowledgeInputMsg>;
};

export enum Treatment_TimeOccurrence {
  TimeOccurrenceContinuous = 'TIME_OCCURRENCE_CONTINUOUS',
  TimeOccurrenceInEpisodes = 'TIME_OCCURRENCE_IN_EPISODES',
  TimeOccurrenceNone = 'TIME_OCCURRENCE_NONE',
  TimeOccurrenceOnce = 'TIME_OCCURRENCE_ONCE'
}

export type Treatment_TimedUpAndGoTestBlock = {
  __typename?: 'treatment_TimedUpAndGoTestBlock';
  completed?: Maybe<Scalars['Boolean']>;
  testTimeSelection?: Maybe<Treatment_TestTimeSelection>;
};

export type Treatment_TinettiMobilityTestBlock = {
  __typename?: 'treatment_TinettiMobilityTestBlock';
  balanceTest?: Maybe<Treatment_BalanceTestMsg>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  gaitTest?: Maybe<Treatment_GaitTestMsg>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_TirednessOrExhaustion {
  TirednessOrExhaustionMoreFromDoingNothing = 'TIREDNESS_OR_EXHAUSTION_MORE_FROM_DOING_NOTHING',
  TirednessOrExhaustionMoreFromRoutineThings = 'TIREDNESS_OR_EXHAUSTION_MORE_FROM_ROUTINE_THINGS',
  TirednessOrExhaustionMoreQuicklyThanUsual = 'TIREDNESS_OR_EXHAUSTION_MORE_QUICKLY_THAN_USUAL',
  TirednessOrExhaustionNone = 'TIREDNESS_OR_EXHAUSTION_NONE',
  TirednessOrExhaustionNoFeeling = 'TIREDNESS_OR_EXHAUSTION_NO_FEELING'
}

/** Therapeutic Intervention Scoring System (TISS) */
export type Treatment_TissBlock = {
  __typename?: 'treatment_TissBlock';
  /** Actions outside the ward (diagnostics / surgery): <yes (5) / no (0)> */
  actionsOutsideTheWard?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** controlled ventilation: <yes (5) / no (0)> */
  controlledVentilation?: Maybe<Scalars['Boolean']>;
  /** Fluid replacement in high volumes (>5 l/24 hr): <yes (4) / no (0)> */
  fluidReplacementInHighVolumes?: Maybe<Scalars['Boolean']>;
  /** Hemofiltration / dialysis: <yes (3) / no (0)> */
  hemofilterationDialysis?: Maybe<Scalars['Boolean']>;
  /** Infusion of multiple catecholamines (>1): <yes (4) / no (0)> */
  infusionOfMultipleCatecholamines?: Maybe<Scalars['Boolean']>;
  /** Intracranial pressure measurement: <yes (4) / no (0)> */
  intracranialPressureMeasurement?: Maybe<Scalars['Boolean']>;
  /** Left atrial catheter / pulmonary catheter: <yes (8) / no (0)> */
  leftAtrialPulmonaryCatheter?: Maybe<Scalars['Boolean']>;
  /** Peripheral arterial catheter: <yes (5) / no (0)> */
  peripheralArterialCatheter?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** Special interventions in the ITS (e.g., tracheostomy, cardioversion): <yes (5) / no (0)> */
  specialInterventionsInTheITS?: Maybe<Scalars['Boolean']>;
  /** Treatment of metabolic acidosis/alkalosis: <yes (4) / no (0)> */
  treatmentOfMetabolicAcidosisAlkalosis?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_TissChildrenAge {
  /** Child [1 YEAR : 8 YEARS) (7) */
  TissChildrenAgeBetween_1YearInclusiveAnd_8YearsExclusive = 'TISS_CHILDREN_AGE_BETWEEN_1_YEAR_INCLUSIVE_AND_8_YEARS_EXCLUSIVE',
  /** Adolescent [8 YEARS : 18 YEARS) (0) */
  TissChildrenAgeBetween_8YearsInclusiveAnd_18YearsExclusive = 'TISS_CHILDREN_AGE_BETWEEN_8_YEARS_INCLUSIVE_AND_18_YEARS_EXCLUSIVE',
  /** Infant (27 DAYS : 1 YEAR) (15) */
  TissChildrenAgeBetween_27DaysAnd_1Year = 'TISS_CHILDREN_AGE_BETWEEN_27_DAYS_AND_1_YEAR',
  TissChildrenAgeNone = 'TISS_CHILDREN_AGE_NONE'
}

/** Therapeutic Intervention Scoring System (TISS) Children */
export type Treatment_TissChildrenBlock = {
  __typename?: 'treatment_TissChildrenBlock';
  /** Actions outside the ICU requiring transport: <yes (5) / no (0)> */
  actionsOutsideIcu?: Maybe<Scalars['Boolean']>;
  admissionStatus?: Maybe<Treatment_AdmissionStatus>;
  age?: Maybe<Treatment_TissChildrenAge>;
  /** Apparative ventilation including any form of CPAP: <yes (5) / no (0)> */
  apparativeVentilation?: Maybe<Scalars['Boolean']>;
  /** Catheters (non-transurethral or suprapubic bladder catheter): <yes (4) / no (0)> */
  catheters?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  creatinine?: Maybe<Treatment_TissChildrenCreatinine>;
  /** Dialysis: <yes (6) / no (0)> */
  dialysis?: Maybe<Scalars['Boolean']>;
  /** Fluid replacement > 3,000 ml/m2KOF /24h: <yes (4) / no (0)> */
  fluidReplacementGreaterThan3K?: Maybe<Scalars['Boolean']>;
  glasgowComaScale?: Maybe<Treatment_GlasgowComaScale>;
  got?: Maybe<Treatment_Got>;
  heartRate?: Maybe<Treatment_TissChildrenHeartRate>;
  /** Infusion of >1 catecholamine or PDE III inhibitor or vasopressor: <yes (4) / no (0)> */
  infusionOfGreaterThanOneCatecholamine?: Maybe<Scalars['Boolean']>;
  /** Intracranial pressure measurement (invasive procedure): <yes (4) / no (0)> */
  intracranialPressureMeasurement?: Maybe<Scalars['Boolean']>;
  /** Invasive circulatory monitoring: <yes (5) / no (0)> */
  invasiveCirculatoryMonitoring?: Maybe<Scalars['Boolean']>;
  leukocytes?: Maybe<Treatment_TissChildrenLeukocytes>;
  pa02FiO2?: Maybe<Treatment_TissChildrenPa02FiO2>;
  paCo2?: Maybe<Treatment_TissChildrenPaCo2>;
  platelets?: Maybe<Treatment_TissChildrenPlatelets>;
  preExistingConditions?: Maybe<Treatment_PreExistingConditions>;
  prothrombinTimeByQuick?: Maybe<Treatment_ProthrombinTimeByQuick>;
  pupillaryResponse?: Maybe<Treatment_PupillaryResponse>;
  score?: Maybe<Scalars['Int']>;
  /** Special interventions in the intensive care unit: <yes (8) / no (0)> */
  specialInterventionsInIntensiveCare?: Maybe<Scalars['Boolean']>;
  standardBaseExcess?: Maybe<Treatment_TissChildrenStandardBaseExcess>;
  systolicBloodPressure?: Maybe<Treatment_TissChildrenSystolicBloodPressure>;
  /** Therapy of alkalosis or acidosis: <yes (4) / no (0)> */
  therapyOfAlkalosisOrAcidosis?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_TissChildrenCreatinine {
  /** ≥53 to <159 (age ≥ 1 year) (4) */
  TissChildrenCreatinineChildAdolescentBetween_53InclusiveAnd_159Exclusive = 'TISS_CHILDREN_CREATININE_CHILD_ADOLESCENT_BETWEEN_53_INCLUSIVE_AND_159_EXCLUSIVE',
  /** ≥159 (10) */
  TissChildrenCreatinineGreaterThanOrEqual_159 = 'TISS_CHILDREN_CREATININE_GREATER_THAN_OR_EQUAL_159',
  /** ≥53 to <159 (age < 1 year) (6) */
  TissChildrenCreatinineInfantBetween_53InclusiveAnd_159Exclusive = 'TISS_CHILDREN_CREATININE_INFANT_BETWEEN_53_INCLUSIVE_AND_159_EXCLUSIVE',
  /** <53 (0) */
  TissChildrenCreatinineLessThan_53 = 'TISS_CHILDREN_CREATININE_LESS_THAN_53',
  TissChildrenCreatinineNone = 'TISS_CHILDREN_CREATININE_NONE'
}

export enum Treatment_TissChildrenHeartRate {
  /**
   * Adolescent
   *  ≥55 to <140 (0)
   */
  TissChildrenHeartRateAdolescentBetween_55InclusiveAnd_140Exclusive = 'TISS_CHILDREN_HEART_RATE_ADOLESCENT_BETWEEN_55_INCLUSIVE_AND_140_EXCLUSIVE',
  /** ≥140 (4) */
  TissChildrenHeartRateAdolescentGreaterThanOrEqual_140 = 'TISS_CHILDREN_HEART_RATE_ADOLESCENT_GREATER_THAN_OR_EQUAL_140',
  /** <55 (6) */
  TissChildrenHeartRateAdolescentLessThan_55 = 'TISS_CHILDREN_HEART_RATE_ADOLESCENT_LESS_THAN_55',
  /**
   * Child
   *  ≥70 to <150 (0)
   */
  TissChildrenHeartRateChildBetween_70InclusiveAnd_150Exclusive = 'TISS_CHILDREN_HEART_RATE_CHILD_BETWEEN_70_INCLUSIVE_AND_150_EXCLUSIVE',
  /** ≥150 (4) */
  TissChildrenHeartRateChildGreaterThanOrEqual_150 = 'TISS_CHILDREN_HEART_RATE_CHILD_GREATER_THAN_OR_EQUAL_150',
  /** <70 (6) */
  TissChildrenHeartRateChildLessThan_70 = 'TISS_CHILDREN_HEART_RATE_CHILD_LESS_THAN_70',
  /**
   * Infant
   *  ≥90 to <160 (0)
   */
  TissChildrenHeartRateInfantBetween_90InclusiveAnd_160Exclusive = 'TISS_CHILDREN_HEART_RATE_INFANT_BETWEEN_90_INCLUSIVE_AND_160_EXCLUSIVE',
  /** ≥160 (4) */
  TissChildrenHeartRateInfantGreaterThanOrEqual_160 = 'TISS_CHILDREN_HEART_RATE_INFANT_GREATER_THAN_OR_EQUAL_160',
  /** <90 (6) */
  TissChildrenHeartRateInfantLessThan_90 = 'TISS_CHILDREN_HEART_RATE_INFANT_LESS_THAN_90',
  TissChildrenHeartRateNone = 'TISS_CHILDREN_HEART_RATE_NONE'
}

export enum Treatment_TissChildrenLeukocytes {
  /** [1;4) (3) */
  TissChildrenLeukocytesBetween_1InclusiveAnd_4Exclusive = 'TISS_CHILDREN_LEUKOCYTES_BETWEEN_1_INCLUSIVE_AND_4_EXCLUSIVE',
  /** [4;20) (3) */
  TissChildrenLeukocytesBetween_4InclusiveAnd_20Exclusive = 'TISS_CHILDREN_LEUKOCYTES_BETWEEN_4_INCLUSIVE_AND_20_EXCLUSIVE',
  /** [20;inf) (3) */
  TissChildrenLeukocytesGreaterThanOrEqual_20 = 'TISS_CHILDREN_LEUKOCYTES_GREATER_THAN_OR_EQUAL_20',
  /** (-inf;1) (12) */
  TissChildrenLeukocytesLessThan_1 = 'TISS_CHILDREN_LEUKOCYTES_LESS_THAN_1',
  TissChildrenLeukocytesNone = 'TISS_CHILDREN_LEUKOCYTES_NONE'
}

export enum Treatment_TissChildrenPa02FiO2 {
  /** ≥100 to <200 (8) */
  TissChildrenPa02Fio2Between_100InclusiveAnd_2OoExclusive = 'TISS_CHILDREN_PA02_FIO2_BETWEEN_100_INCLUSIVE_AND_2OO_EXCLUSIVE',
  /** ≥200 to <300 (2) */
  TissChildrenPa02Fio2Between_200InclusiveAnd_3OoExclusive = 'TISS_CHILDREN_PA02_FIO2_BETWEEN_200_INCLUSIVE_AND_3OO_EXCLUSIVE',
  /** ≥300 (0) */
  TissChildrenPa02Fio2GreaterThanOrEqual_300 = 'TISS_CHILDREN_PA02_FIO2_GREATER_THAN_OR_EQUAL_300',
  /** <100 (13) */
  TissChildrenPa02Fio2LessThan_100 = 'TISS_CHILDREN_PA02_FIO2_LESS_THAN_100',
  TissChildrenPa02Fio2None = 'TISS_CHILDREN_PA02_FIO2_NONE',
  TissChildrenPa02Fio2NoMechanicalVentilation = 'TISS_CHILDREN_PA02_FIO2_NO_MECHANICAL_VENTILATION'
}

export enum Treatment_TissChildrenPaCo2 {
  /** ≥80 (6) */
  TissChildrenPaCo2GreaterThanOrEqual_80 = 'TISS_CHILDREN_PA_CO2_GREATER_THAN_OR_EQUAL_80',
  /** <80 (0) */
  TissChildrenPaCo2LessThan_80 = 'TISS_CHILDREN_PA_CO2_LESS_THAN_80',
  TissChildrenPaCo2None = 'TISS_CHILDREN_PA_CO2_NONE'
}

export enum Treatment_TissChildrenPlatelets {
  /** ≥50 to 100 (2) */
  TissChildrenPlateletsBetween_50And_100 = 'TISS_CHILDREN_PLATELETS_BETWEEN_50_AND_100',
  /** ≥100 (0) */
  TissChildrenPlateletsGreaterThan_100 = 'TISS_CHILDREN_PLATELETS_GREATER_THAN_100',
  /** <50 (6) */
  TissChildrenPlateletsLessThan_50 = 'TISS_CHILDREN_PLATELETS_LESS_THAN_50',
  TissChildrenPlateletsNone = 'TISS_CHILDREN_PLATELETS_NONE'
}

export enum Treatment_TissChildrenStandardBaseExcess {
  /** ≥-3.0 to ≤+3.0 (0) */
  TissChildrenStandardBaseExcessBetweenNeg_3AndPos_3 = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_BETWEEN_NEG_3_AND_POS_3',
  /** ≥-8.0 to <- 3.0 (2) */
  TissChildrenStandardBaseExcessBetweenNeg_8AndNeg_3 = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_BETWEEN_NEG_8_AND_NEG_3',
  /** ≥-13.0 to < 8.0 (6) */
  TissChildrenStandardBaseExcessBetweenNeg_13InclusiveAndPos_8Exclusive = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_BETWEEN_NEG_13_INCLUSIVE_AND_POS_8_EXCLUSIVE',
  /** >+3.0 to ≤+8.0 (2) */
  TissChildrenStandardBaseExcessBetweenPos_3AndPos_8 = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_BETWEEN_POS_3_AND_POS_8',
  /** >+8.0 (6) */
  TissChildrenStandardBaseExcessGreaterThanPos_8 = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_GREATER_THAN_POS_8',
  /** <-13.0 (10) */
  TissChildrenStandardBaseExcessLessThanNeg_13 = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_LESS_THAN_NEG_13',
  TissChildrenStandardBaseExcessNone = 'TISS_CHILDREN_STANDARD_BASE_EXCESS_NONE'
}

export enum Treatment_TissChildrenSystolicBloodPressure {
  /** ≥50 to <65 (6) */
  TissChildrenSystolicBloodPressureAdolescentBetween_50InclusiveAnd_65Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_BETWEEN_50_INCLUSIVE_AND_65_EXCLUSIVE',
  /** ≥65 to <90 (2) */
  TissChildrenSystolicBloodPressureAdolescentBetween_65InclusiveAnd_90Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_BETWEEN_65_INCLUSIVE_AND_90_EXCLUSIVE',
  /**
   * Adolescent
   *   ≥90 to <150 (0)
   */
  TissChildrenSystolicBloodPressureAdolescentBetween_90InclusiveAnd_150Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_BETWEEN_90_INCLUSIVE_AND_150_EXCLUSIVE',
  /** ≥150 to <200 (2) */
  TissChildrenSystolicBloodPressureAdolescentBetween_150InclusiveAnd_200Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_BETWEEN_150_INCLUSIVE_AND_200_EXCLUSIVE',
  /** ≥200 (6) */
  TissChildrenSystolicBloodPressureAdolescentGreaterThanOrEqual_200 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_GREATER_THAN_OR_EQUAL_200',
  /** 0 to <50 (13)> */
  TissChildrenSystolicBloodPressureAdolescentLessThan_50 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_ADOLESCENT_LESS_THAN_50',
  /** ≥50 to <65 (6) */
  TissChildrenSystolicBloodPressureChildBetween_50InclusiveAnd_65Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_BETWEEN_50_INCLUSIVE_AND_65_EXCLUSIVE',
  /** ≥65 to <75 (2) */
  TissChildrenSystolicBloodPressureChildBetween_65InclusiveAnd_75Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_BETWEEN_65_INCLUSIVE_AND_75_EXCLUSIVE',
  /**
   * Child
   *   ≥75 to <140 (0)
   */
  TissChildrenSystolicBloodPressureChildBetween_75InclusiveAnd_140Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_BETWEEN_75_INCLUSIVE_AND_140_EXCLUSIVE',
  /** ≥140 to <180 (2) */
  TissChildrenSystolicBloodPressureChildBetween_140InclusiveAnd_180Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_BETWEEN_140_INCLUSIVE_AND_180_EXCLUSIVE',
  /** ≥180 (6) */
  TissChildrenSystolicBloodPressureChildGreaterThanOrEqual_180 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_GREATER_THAN_OR_EQUAL_180',
  /** 0 to <50 (13) */
  TissChildrenSystolicBloodPressureChildLessThan_50 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_CHILD_LESS_THAN_50',
  /** ≥40 to <55 (6) */
  TissChildrenSystolicBloodPressureInfantBetween_40InclusiveAnd_55Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_BETWEEN_40_INCLUSIVE_AND_55_EXCLUSIVE',
  /** ≥55 to <65 (2) */
  TissChildrenSystolicBloodPressureInfantBetween_55InclusiveAnd_65Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_BETWEEN_55_INCLUSIVE_AND_65_EXCLUSIVE',
  /**
   * Infant
   *  ≥65 to <130 (0)
   */
  TissChildrenSystolicBloodPressureInfantBetween_65InclusiveAnd_130Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_BETWEEN_65_INCLUSIVE_AND_130_EXCLUSIVE',
  /** ≥130 to <160 (2) */
  TissChildrenSystolicBloodPressureInfantBetween_130InclusiveAnd_160Exclusive = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_BETWEEN_130_INCLUSIVE_AND_160_EXCLUSIVE',
  /** ≥160 (6) */
  TissChildrenSystolicBloodPressureInfantGreaterThanOrEqual_160 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_GREATER_THAN_OR_EQUAL_160',
  /** 0 to <40 (13) */
  TissChildrenSystolicBloodPressureInfantLessThan_40 = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_INFANT_LESS_THAN_40',
  TissChildrenSystolicBloodPressureNone = 'TISS_CHILDREN_SYSTOLIC_BLOOD_PRESSURE_NONE'
}

export enum Treatment_TissuePerfusionAndOxygenation {
  TissuePerfusionAndOxygenationAdequate = 'TISSUE_PERFUSION_AND_OXYGENATION_ADEQUATE',
  TissuePerfusionAndOxygenationCompromised = 'TISSUE_PERFUSION_AND_OXYGENATION_COMPROMISED',
  TissuePerfusionAndOxygenationExcellent = 'TISSUE_PERFUSION_AND_OXYGENATION_EXCELLENT',
  TissuePerfusionAndOxygenationExtremelyCompromised = 'TISSUE_PERFUSION_AND_OXYGENATION_EXTREMELY_COMPROMISED',
  TissuePerfusionAndOxygenationNone = 'TISSUE_PERFUSION_AND_OXYGENATION_NONE'
}

export type Treatment_ToeJointsMsg = {
  __typename?: 'treatment_ToeJointsMsg';
  bigToeExtension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  id?: Maybe<Scalars['String']>;
};

export enum Treatment_ToiletUse {
  ToiletUseIndependent = 'TOILET_USE_INDEPENDENT',
  ToiletUseNeedsHelp = 'TOILET_USE_NEEDS_HELP',
  ToiletUseNone = 'TOILET_USE_NONE',
  ToiletUseUnable = 'TOILET_USE_UNABLE'
}

export type Treatment_TongueMotorSkillsBlock = {
  __typename?: 'treatment_TongueMotorSkillsBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  abnormalitiesText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  tongueMotorSkills?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_ToothStatusDescriptionMsg = {
  __typename?: 'treatment_ToothStatusDescriptionMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  statuses?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_ToothStatusMsg = {
  __typename?: 'treatment_ToothStatusMsg';
  descriptions?: Maybe<Array<Maybe<Treatment_ToothStatusDescriptionMsg>>>;
  furtherDetails?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  toothStatus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_TracheaPositionBlock = {
  __typename?: 'treatment_TracheaPositionBlock';
  tracheaPosition?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_TracheostomyBlock = {
  __typename?: 'treatment_TracheostomyBlock';
  afterTracheostomy?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  method?: Maybe<Core_KnowledgeInputMsg>;
  pastTracheostomies?: Maybe<Array<Maybe<Treatment_PastTracheostomyDetailsMsg>>>;
  present?: Maybe<Scalars['Boolean']>;
  tracheostomyTubeSizes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  tracheostomyTubeTypes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_Transfers {
  TransfersIndependent = 'TRANSFERS_INDEPENDENT',
  TransfersNeedsMajorHelp = 'TRANSFERS_NEEDS_MAJOR_HELP',
  TransfersNeedsMinorHelp = 'TRANSFERS_NEEDS_MINOR_HELP',
  TransfersNone = 'TRANSFERS_NONE',
  TransfersUnable = 'TRANSFERS_UNABLE'
}

export type Treatment_TravelDestinationMsg = {
  __typename?: 'treatment_TravelDestinationMsg';
  destinationIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  id?: Maybe<Scalars['String']>;
  mainPreTravelInformationSource?: Maybe<Core_KnowledgeInputMsg>;
  receivedPreTravelInformationPresent?: Maybe<Scalars['Boolean']>;
  riskFactorsQuestionnaire?: Maybe<Treatment_RiskFactorsMsg>;
  text?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
  transportMeans?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  travelReason?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_TreatmentBasicInfoMsg = {
  __typename?: 'treatment_TreatmentBasicInfoMsg';
  id?: Maybe<Scalars['String']>;
  treatmentDetails?: Maybe<Treatment_TreatmentDetailsMsg>;
};

export type Treatment_TreatmentComponentDescriptionMsg = {
  __typename?: 'treatment_TreatmentComponentDescriptionMsg';
  description?: Maybe<Scalars['String']>;
  language?: Maybe<Core_Language>;
};

/** Defines the default structure of a treatment in the given administrative unit */
export type Treatment_TreatmentConfigurationMsg = {
  __typename?: 'treatment_TreatmentConfigurationMsg';
  activeSteps?: Maybe<Array<Maybe<Treatment_TreatmentStep>>>;
  id?: Maybe<Scalars['String']>;
  ownerOrganizationalUnitId?: Maybe<Scalars['String']>;
  /** The type of treatment that this configuration is used for */
  type?: Maybe<Treatment_TreatmentType>;
  version?: Maybe<Scalars['Int']>;
};

export type Treatment_TreatmentDetailsMsg = {
  __typename?: 'treatment_TreatmentDetailsMsg';
  /** When the treatment was aborted, empty if not aborted */
  abortedAt?: Maybe<Timestamp>;
  /** User who aborted the treatment, empty if not aborted or auto-aborted */
  abortingUserId?: Maybe<Scalars['String']>;
  clinicalRequestExecutionId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  duration?: Maybe<Treatment_TreatmentDurationMsg>;
  /** Whether the treatment was aborted by force, usually by someone outside of the treatment's organizational unit */
  forcedAbortion?: Maybe<Scalars['Boolean']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** Users participating in the treatment */
  participatingUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
  /** Specifies the reason in case the treatment was aborted */
  reasonForAbortion?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_TreatmentStatus>;
  surgeryId?: Maybe<Scalars['String']>;
  /** Start and end of the treatment, manually documented */
  timeFrame?: Maybe<TimeFrameMsg>;
  timestamps?: Maybe<TimeMsg>;
  type?: Maybe<Treatment_TreatmentType>;
  /** Reference to the user who conducts the treatment, typically a doctor */
  userId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_TreatmentDetailsUpdateRequest = {
  __typename?: 'treatment_TreatmentDetailsUpdateRequest';
  /** Set this when "re-finishing" an already finished treatment to allow for activation of modified activated information */
  confirmFinish?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Treatment_TreatmentDurationMsg>;
  /** should be set to true to force treatment abortion */
  forceAbortion?: Maybe<Scalars['Boolean']>;
  /** Users participating in the treatment */
  participatingUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Relevant only if the status is set to aborted */
  reasonForAbortion?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_TreatmentStatus>;
  /** Start and end of the treatment, manually documented */
  timeFrame?: Maybe<TimeFrameMsg>;
  treatmentId?: Maybe<Scalars['String']>;
};

export type Treatment_TreatmentDurationMsg = {
  __typename?: 'treatment_TreatmentDurationMsg';
  duration?: Maybe<Scalars['Int']>;
  durationUnit?: Maybe<TimeUnit>;
};

export type Treatment_TreatmentMsg = {
  __typename?: 'treatment_TreatmentMsg';
  anamnesis?: Maybe<Treatment_AnamnesisMsg>;
  configuration?: Maybe<Treatment_TreatmentConfigurationMsg>;
  fieldMask?: Maybe<FieldMask>;
  furtherProcedures?: Maybe<Treatment_FurtherProceduresMsg>;
  id?: Maybe<Scalars['String']>;
  physicalExamination?: Maybe<Treatment_PhysicalExaminationMsg>;
  therapy?: Maybe<Treatment_TherapyMsg>;
  treatmentDetails?: Maybe<Treatment_TreatmentDetailsMsg>;
  vaccinations?: Maybe<Array<Maybe<Treatment_VaccinationMsg>>>;
};

export enum Treatment_TreatmentStatus {
  TreatmentStatusAborted = 'TREATMENT_STATUS_ABORTED',
  TreatmentStatusFinished = 'TREATMENT_STATUS_FINISHED',
  TreatmentStatusNone = 'TREATMENT_STATUS_NONE',
  TreatmentStatusUnfinished = 'TREATMENT_STATUS_UNFINISHED'
}

export type Treatment_TreatmentStatusInfoMsg = {
  __typename?: 'treatment_TreatmentStatusInfoMsg';
  status?: Maybe<Treatment_TreatmentStatus>;
  timestamps?: Maybe<TimeMsg>;
  treatmentId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_TreatmentStep {
  TreatmentStepAnamnesis = 'TREATMENT_STEP_ANAMNESIS',
  TreatmentStepAnesthesiaPlan = 'TREATMENT_STEP_ANESTHESIA_PLAN',
  TreatmentStepCareAdmissionRequests = 'TREATMENT_STEP_CARE_ADMISSION_REQUESTS',
  TreatmentStepCareAssessment = 'TREATMENT_STEP_CARE_ASSESSMENT',
  TreatmentStepCareDiagnosis = 'TREATMENT_STEP_CARE_DIAGNOSIS',
  TreatmentStepCarePlan = 'TREATMENT_STEP_CARE_PLAN',
  TreatmentStepCareRoundProgress = 'TREATMENT_STEP_CARE_ROUND_PROGRESS',
  TreatmentStepConsent = 'TREATMENT_STEP_CONSENT',
  TreatmentStepDiagnosis = 'TREATMENT_STEP_DIAGNOSIS',
  TreatmentStepExamination = 'TREATMENT_STEP_EXAMINATION',
  TreatmentStepFurtherProcedures = 'TREATMENT_STEP_FURTHER_PROCEDURES',
  TreatmentStepLetter = 'TREATMENT_STEP_LETTER',
  TreatmentStepMeasurements = 'TREATMENT_STEP_MEASUREMENTS',
  TreatmentStepMedicalRoundProgress = 'TREATMENT_STEP_MEDICAL_ROUND_PROGRESS',
  TreatmentStepNoStep = 'TREATMENT_STEP_NO_STEP',
  TreatmentStepRequests = 'TREATMENT_STEP_REQUESTS',
  TreatmentStepTherapy = 'TREATMENT_STEP_THERAPY',
  TreatmentStepWardMedication = 'TREATMENT_STEP_WARD_MEDICATION',
  TreatmentStepWounds = 'TREATMENT_STEP_WOUNDS'
}

export type Treatment_TreatmentTemplateMsg = {
  __typename?: 'treatment_TreatmentTemplateMsg';
  id?: Maybe<Scalars['String']>;
  ownerOrganizationalUnitId?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<Treatment_SectionTemplateMsg>>>;
  shortcuts?: Maybe<Array<Maybe<Treatment_PathKeyMsg>>>;
  /** The type of treatment that this template is used for */
  type?: Maybe<Treatment_TreatmentType>;
  version?: Maybe<Scalars['Int']>;
};

export enum Treatment_TreatmentType {
  TreatmentTypeCareAdmission = 'TREATMENT_TYPE_CARE_ADMISSION',
  TreatmentTypeCareRound = 'TREATMENT_TYPE_CARE_ROUND',
  TreatmentTypeMedicalAdmission = 'TREATMENT_TYPE_MEDICAL_ADMISSION',
  TreatmentTypeMedicalRound = 'TREATMENT_TYPE_MEDICAL_ROUND',
  TreatmentTypeNone = 'TREATMENT_TYPE_NONE',
  TreatmentTypeOutpatient = 'TREATMENT_TYPE_OUTPATIENT',
  TreatmentTypePreanestheticAssessment = 'TREATMENT_TYPE_PREANESTHETIC_ASSESSMENT',
  TreatmentTypePreoperativeAssessment = 'TREATMENT_TYPE_PREOPERATIVE_ASSESSMENT'
}

/** Direct use of enum in SchemaModification causes error */
export type Treatment_TreatmentTypeMsg = {
  __typename?: 'treatment_TreatmentTypeMsg';
  treatmentType?: Maybe<Treatment_TreatmentType>;
};

export type Treatment_TrichoscopyBlock = {
  __typename?: 'treatment_TrichoscopyBlock';
  caliberJumps?: Maybe<Scalars['Boolean']>;
  caliberJumpsText?: Maybe<Scalars['String']>;
  miniaturizedHair?: Maybe<Scalars['Boolean']>;
  miniaturizedHairText?: Maybe<Scalars['String']>;
  peladHair?: Maybe<Scalars['Boolean']>;
  peladHairText?: Maybe<Scalars['String']>;
  perifollicularScaling?: Maybe<Scalars['Boolean']>;
  perifollicularScalingText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tuftHair?: Maybe<Scalars['Boolean']>;
  tuftHairText?: Maybe<Scalars['String']>;
  yellowDots?: Maybe<Scalars['Boolean']>;
  yellowDotsText?: Maybe<Scalars['String']>;
};

export enum Treatment_Trunk {
  /** < No sway without assistive device (2) / No sway but compensation with knees and arms necessary (1) / Significant sway or uses assistive device (0)> */
  TrunkNone = 'TRUNK_NONE',
  TrunkNoSwayButCompensationWithKneesAndArmsNecessary = 'TRUNK_NO_SWAY_BUT_COMPENSATION_WITH_KNEES_AND_ARMS_NECESSARY',
  TrunkNoSwayWithoutAssistiveDevice = 'TRUNK_NO_SWAY_WITHOUT_ASSISTIVE_DEVICE',
  TrunkSignificantSignificantSwayOrUsesAssistiveDevice = 'TRUNK_SIGNIFICANT_SIGNIFICANT_SWAY_OR_USES_ASSISTIVE_DEVICE'
}

export type Treatment_TrunkPasiMsg = {
  __typename?: 'treatment_TrunkPasiMsg';
  trunkBodyRegionPercentage?: Maybe<Treatment_BodyRegionPercentage>;
  trunkDiscoloration?: Maybe<Treatment_PasiSelection>;
  trunkScaling?: Maybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.3> */
  trunkScore?: Maybe<Scalars['Float']>;
  trunkThickness?: Maybe<Treatment_PasiSelection>;
};

export type Treatment_TumorInformationMsg = {
  __typename?: 'treatment_TumorInformationMsg';
  /** G */
  grading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** N */
  lymphNode?: Maybe<Scalars['String']>;
  lymphNodeSuffix1?: Maybe<Scalars['Int']>;
  lymphNodeSuffix2?: Maybe<Scalars['Int']>;
  lymphNodeSuffixSentinel?: Maybe<Scalars['String']>;
  /** L */
  lymphaticVesselInvasion?: Maybe<Scalars['String']>;
  /** M */
  metastases?: Maybe<Scalars['String']>;
  metastasesPrefix?: Maybe<Scalars['String']>;
  metastasesSuffix?: Maybe<Scalars['String']>;
  /** Pn */
  perineuralInvasion?: Maybe<Scalars['String']>;
  /** prefix */
  prefix?: Maybe<Scalars['String']>;
  prefixLymphNode?: Maybe<Scalars['String']>;
  prefixTumorSize?: Maybe<Scalars['String']>;
  /** R */
  residualStatus?: Maybe<Scalars['String']>;
  /** S */
  serumTumorMarkers?: Maybe<Scalars['String']>;
  /** T */
  tumorSize?: Maybe<Scalars['String']>;
  /** V */
  veinInvasion?: Maybe<Scalars['String']>;
};

export enum Treatment_Turning360Degrees {
  Turning_360DegreesContinuousStepsIfNecessaryWithAid = 'TURNING_360_DEGREES_CONTINUOUS_STEPS_IF_NECESSARY_WITH_AID',
  Turning_360DegreesDiscontinuousStepsNeedsAid = 'TURNING_360_DEGREES_DISCONTINUOUS_STEPS_NEEDS_AID',
  Turning_360DegreesNone = 'TURNING_360_DEGREES_NONE',
  Turning_360DegreesSafeContinuousSteps = 'TURNING_360_DEGREES_SAFE_CONTINUOUS_STEPS'
}

export enum Treatment_TurningOverInBed {
  /** Able to turn over or straighten bedspread, but cannot complete movement independently */
  TurningOverInBedCannotCompleteIndependently = 'TURNING_OVER_IN_BED_CANNOT_COMPLETE_INDEPENDENTLY',
  TurningOverInBedCompleteDependence = 'TURNING_OVER_IN_BED_COMPLETE_DEPENDENCE',
  TurningOverInBedNone = 'TURNING_OVER_IN_BED_NONE',
  /** Able to turn over or straighten bedspread independently, but requires great effort */
  TurningOverInBedRequiresEffort = 'TURNING_OVER_IN_BED_REQUIRES_EFFORT',
  /** Somewhat slow and awkward, but no help required */
  TurningOverInBedSlowAndAwkward = 'TURNING_OVER_IN_BED_SLOW_AND_AWKWARD',
  TurningOverInBedUndisturbed = 'TURNING_OVER_IN_BED_UNDISTURBED'
}

export type Treatment_UltrasoundMsg = {
  __typename?: 'treatment_UltrasoundMsg';
  text?: Maybe<Scalars['String']>;
};

export enum Treatment_UnderminingLocale {
  UnderminingLocaleEight = 'UNDERMINING_LOCALE_EIGHT',
  UnderminingLocaleEleven = 'UNDERMINING_LOCALE_ELEVEN',
  UnderminingLocaleFive = 'UNDERMINING_LOCALE_FIVE',
  UnderminingLocaleFour = 'UNDERMINING_LOCALE_FOUR',
  UnderminingLocaleNine = 'UNDERMINING_LOCALE_NINE',
  UnderminingLocaleNone = 'UNDERMINING_LOCALE_NONE',
  UnderminingLocaleOne = 'UNDERMINING_LOCALE_ONE',
  UnderminingLocaleSeven = 'UNDERMINING_LOCALE_SEVEN',
  UnderminingLocaleSix = 'UNDERMINING_LOCALE_SIX',
  UnderminingLocaleTen = 'UNDERMINING_LOCALE_TEN',
  UnderminingLocaleThree = 'UNDERMINING_LOCALE_THREE',
  UnderminingLocaleTwelve = 'UNDERMINING_LOCALE_TWELVE',
  UnderminingLocaleTwo = 'UNDERMINING_LOCALE_TWO'
}

export type Treatment_UpdateAllergyRequest = {
  __typename?: 'treatment_UpdateAllergyRequest';
  allergy?: Maybe<Treatment_AllergyAndIntoleranceMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateAnamnesisBlockRequest = {
  __typename?: 'treatment_UpdateAnamnesisBlockRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  block?: Maybe<Treatment_AnamnesisBlockMsg>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  commitId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  disableBlockAutoValidation?: Maybe<Scalars['Boolean']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchUpdateTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_UpdateAnamnesisBlockResponse = {
  __typename?: 'treatment_UpdateAnamnesisBlockResponse';
  /**
   * If we added/removed symptoms in a reason for presentation block,
   *  that may have caused other blocks to be updated accordingly
   */
  autoUpdatedCards?: Maybe<Array<Maybe<Treatment_AutoUpdatedProblemSpecificAnamnesisCardReasonInfo>>>;
  block?: Maybe<Treatment_AnamnesisBlockMsg>;
  id?: Maybe<Scalars['String']>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_UpdateAnamnesisBlockStatusRequest = {
  __typename?: 'treatment_UpdateAnamnesisBlockStatusRequest';
  anamnesisBlockId?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_MedicalItemStatus>;
};

export type Treatment_UpdateAnamnesisBlockStatusResponse = {
  __typename?: 'treatment_UpdateAnamnesisBlockStatusResponse';
  anamnesisBlock?: Maybe<Treatment_AnamnesisBlockMsg>;
};

export type Treatment_UpdateAnamnesisCardAnamnesticProgressRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardAnamnesticProgressRequest';
  anamnesticProgress?: Maybe<Treatment_AnamnesticProgressMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateAnamnesisCardAnamnesticProgressResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardAnamnesticProgressResponse';
  anamnesticProgress?: Maybe<Treatment_AnamnesticProgressMsg>;
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
};

export type Treatment_UpdateAnamnesisCardAnesthesiaBackgroundRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardAnesthesiaBackgroundRequest';
  anesthesiaBackground?: Maybe<Treatment_AnesthesiaBackgroundMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateAnamnesisCardAnesthesiaBackgroundResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardAnesthesiaBackgroundResponse';
  anesthesiaBackground?: Maybe<Treatment_AnesthesiaBackgroundMsg>;
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
};

export type Treatment_UpdateAnamnesisCardReasonForAdmissionRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonForAdmissionRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  reasonForAdmission?: Maybe<Treatment_ReasonForAdmissionMsg>;
  /** default false; setting this to true triggers a subscription publish updating the frontend in realtime */
  systemUpdate?: Maybe<Scalars['Boolean']>;
};

export type Treatment_UpdateAnamnesisCardReasonForAdmissionResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonForAdmissionResponse';
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
  reasonForAdmission?: Maybe<Treatment_ReasonForAdmissionMsg>;
};

export type Treatment_UpdateAnamnesisCardReasonForCareAdmissionRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonForCareAdmissionRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  reasonForCareAdmission?: Maybe<Treatment_ReasonForCareAdmissionMsg>;
};

export type Treatment_UpdateAnamnesisCardReasonForCareAdmissionResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonForCareAdmissionResponse';
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
  reasonForCareAdmission?: Maybe<Treatment_ReasonForCareAdmissionMsg>;
};

export type Treatment_UpdateAnamnesisCardReasonRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  reason?: Maybe<Treatment_ReasonForPresentationMsg>;
  /** default false; setting this to true triggers a subscription publish updating the frontend in realtime */
  systemUpdate?: Maybe<Scalars['Boolean']>;
};

export type Treatment_UpdateAnamnesisCardReasonResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardReasonResponse';
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
  reasonForPresentation?: Maybe<Treatment_ReasonForPresentationMsg>;
};

export type Treatment_UpdateAnamnesisCardSurgeryPreparationRequest = {
  __typename?: 'treatment_UpdateAnamnesisCardSurgeryPreparationRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  surgeryPreparation?: Maybe<Treatment_SurgeryPreparationMsg>;
};

export type Treatment_UpdateAnamnesisCardSurgeryPreparationResponse = {
  __typename?: 'treatment_UpdateAnamnesisCardSurgeryPreparationResponse';
  autoUpdatedBlocks?: Maybe<Array<Maybe<Treatment_AutoUpdatedAnamnesisBlockInfo>>>;
  /** card can contain new blocks */
  card?: Maybe<Treatment_AnamnesisCardMsg>;
  surgeryPreparation?: Maybe<Treatment_SurgeryPreparationMsg>;
};

export type Treatment_UpdateAnamnesisStatusRequest = {
  __typename?: 'treatment_UpdateAnamnesisStatusRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_MedicalItemStatus>;
};

export type Treatment_UpdateAnamnesisStatusResponse = {
  __typename?: 'treatment_UpdateAnamnesisStatusResponse';
  anamnesis?: Maybe<Treatment_AnamnesisMsg>;
};

export type Treatment_UpdateChecklistElementRequest = {
  __typename?: 'treatment_UpdateChecklistElementRequest';
  checklistElement?: Maybe<Treatment_ChecklistElementMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateChecklistElementStatusesRequest = {
  __typename?: 'treatment_UpdateChecklistElementStatusesRequest';
  checklistId?: Maybe<Scalars['String']>;
  targetStatus?: Maybe<Treatment_ChecklistElementStatus>;
};

export type Treatment_UpdateChecklistElementStatusesResponse = {
  __typename?: 'treatment_UpdateChecklistElementStatusesResponse';
  checklistElements?: Maybe<Array<Maybe<Treatment_ChecklistElementMsg>>>;
};

export type Treatment_UpdateClinicalRecommendationRequest = {
  __typename?: 'treatment_UpdateClinicalRecommendationRequest';
  clinicalRecommendation?: Maybe<Treatment_ClinicalRecommendationMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateClinicalRecommendationResponse = {
  __typename?: 'treatment_UpdateClinicalRecommendationResponse';
  clinicalRecommendationId?: Maybe<Scalars['String']>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  recommendation?: Maybe<Treatment_ClinicalRecommendationMsg>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_UpdateDefaultFluidBalanceConfigurationRequest = {
  __typename?: 'treatment_UpdateDefaultFluidBalanceConfigurationRequest';
  defaultConfiguration?: Maybe<Treatment_DefaultFluidBalanceConfigurationMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateDiagnosesAssignmentsRequest = {
  __typename?: 'treatment_UpdateDiagnosesAssignmentsRequest';
  requests?: Maybe<Array<Maybe<Treatment_UpdateDiagnosisAssignmentRequest>>>;
};

export type Treatment_UpdateDiagnosesAssignmentsResponse = {
  __typename?: 'treatment_UpdateDiagnosesAssignmentsResponse';
  responses?: Maybe<Array<Maybe<Treatment_UpdateDiagnosisAssignmentResponse>>>;
};

export type Treatment_UpdateDiagnosisAssignmentRequest = {
  __typename?: 'treatment_UpdateDiagnosisAssignmentRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
  /** To un-assign, set the category to NONE */
  targetCategoryAssignment?: Maybe<Treatment_DiagnosisCategoryAssignmentMsg>;
};

export type Treatment_UpdateDiagnosisAssignmentResponse = {
  __typename?: 'treatment_UpdateDiagnosisAssignmentResponse';
  deletedDiagnosisId?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_UpdateDiagnosisCodingRequest = {
  __typename?: 'treatment_UpdateDiagnosisCodingRequest';
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosisCoding?: Maybe<Treatment_DiagnosisCodingMsg>;
  diagnosisId?: Maybe<Scalars['String']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateDiagnosisCodingResponse = {
  __typename?: 'treatment_UpdateDiagnosisCodingResponse';
  diagnosisCoding?: Maybe<Treatment_DiagnosisCodingMsg>;
  /** As this can change via this call, return so that caller can handle the possibly updated id */
  diagnosisRevisionGroupId?: Maybe<Scalars['String']>;
  updatedDiagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_UpdateDiagnosisRequest = {
  __typename?: 'treatment_UpdateDiagnosisRequest';
  /**
   * If true, ensures none of the diagnosis' existing codes are kept; they are all replaced by the ones from the update.
   *  Needed because patch update does not support deletion and creation in the same update
   */
  clearExistingCodes?: Maybe<Scalars['Boolean']>;
  context?: Maybe<Treatment_DiagnosisAccessContextMsg>;
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateDiagnosisResponse = {
  __typename?: 'treatment_UpdateDiagnosisResponse';
  diagnosis?: Maybe<Treatment_DiagnosisMsg>;
  /** Set if the update triggered creation of a new version */
  replacedDiagnosis?: Maybe<Treatment_DiagnosisMsg>;
};

export type Treatment_UpdateFluidFlowRequest = {
  __typename?: 'treatment_UpdateFluidFlowRequest';
  /**
   * If there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: Maybe<Scalars['Boolean']>;
  fluidFlow?: Maybe<Treatment_FluidFlowMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  /**
   * If there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: Maybe<Scalars['Boolean']>;
  /**
   * when updating a fluid flow system, its version direction is assumed to be revision
   *  due to them being only revisioned
   * @deprecated deprecated in proto
   */
  versioningDirection?: Maybe<Versioning_VersioningDirection>;
};

export type Treatment_UpdateFluidFlowSystemRequest = {
  __typename?: 'treatment_UpdateFluidFlowSystemRequest';
  /**
   * if there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: Maybe<Scalars['Boolean']>;
  fluidFlowSystem?: Maybe<Treatment_FluidFlowSystemMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: Maybe<Scalars['Boolean']>;
  /**
   * when updating a fluid flow system, its version direction is assumed to be revision
   *  due to them being only revisioned
   * @deprecated deprecated in proto
   */
  versioningDirection?: Maybe<Versioning_VersioningDirection>;
};

export type Treatment_UpdateFurtherProceduresResponse = {
  __typename?: 'treatment_UpdateFurtherProceduresResponse';
  furtherProcedures?: Maybe<Treatment_FurtherProceduresMsg>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  procedureId?: Maybe<Scalars['String']>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_UpdateImmunityTestRequest = {
  __typename?: 'treatment_UpdateImmunityTestRequest';
  immunityTest?: Maybe<Treatment_ImmunityTestMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdatePatientFluidBalanceConfigurationRequest = {
  __typename?: 'treatment_UpdatePatientFluidBalanceConfigurationRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  patientConfiguration?: Maybe<Treatment_PatientFluidBalanceConfigurationMsg>;
};

export type Treatment_UpdatePhysicalBlockRequest = {
  __typename?: 'treatment_UpdatePhysicalBlockRequest';
  block?: Maybe<Treatment_PhysicalBlockMsg>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  commitId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  patch?: Maybe<Scalars['Boolean']>;
  patchUpdateTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  physicalId?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_UpdatePhysicalBlockResponse = {
  __typename?: 'treatment_UpdatePhysicalBlockResponse';
  block?: Maybe<Treatment_PhysicalBlockMsg>;
  id?: Maybe<Scalars['String']>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_UpdatePhysicalBlockStatusRequest = {
  __typename?: 'treatment_UpdatePhysicalBlockStatusRequest';
  physicalBlockId?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_MedicalItemStatus>;
};

export type Treatment_UpdatePhysicalBlockStatusResponse = {
  __typename?: 'treatment_UpdatePhysicalBlockStatusResponse';
  physicalBlock?: Maybe<Treatment_PhysicalBlockMsg>;
};

export type Treatment_UpdatePhysicalExaminationStatusRequest = {
  __typename?: 'treatment_UpdatePhysicalExaminationStatusRequest';
  physicalExaminationId?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_MedicalItemStatus>;
};

export type Treatment_UpdatePhysicalExaminationStatusResponse = {
  __typename?: 'treatment_UpdatePhysicalExaminationStatusResponse';
  physicalExamination?: Maybe<Treatment_PhysicalExaminationMsg>;
};

export type Treatment_UpdatePhysicalPresetRequest = {
  __typename?: 'treatment_UpdatePhysicalPresetRequest';
  overrideDefault?: Maybe<Scalars['Boolean']>;
  preset?: Maybe<Treatment_PhysicalPresetMsg>;
};

export type Treatment_UpdateSymptomConfigurationRequest = {
  __typename?: 'treatment_UpdateSymptomConfigurationRequest';
  parameters?: Maybe<Versioning_VersionedEntityCreationParametersMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  symptomConfiguration?: Maybe<Treatment_SymptomConfigurationMsg>;
  versioningDirection?: Maybe<Versioning_VersioningDirection>;
};

export type Treatment_UpdateSymptomConfigurationResponse = {
  __typename?: 'treatment_UpdateSymptomConfigurationResponse';
  /** Set if the update triggered creation of a new version, this is the old version that shouldn't be displayed in that treatment anymore */
  replacedSymptomConfiguration?: Maybe<Treatment_SymptomConfigurationMsg>;
  symptomConfiguration?: Maybe<Treatment_SymptomConfigurationMsg>;
};

export type Treatment_UpdateTherapyCardRequest = {
  __typename?: 'treatment_UpdateTherapyCardRequest';
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: Maybe<Scalars['Boolean']>;
  card?: Maybe<Treatment_TherapyCardMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  /**
   * if there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: Maybe<Scalars['Boolean']>;
};

export type Treatment_UpdateTherapyCardResponse = {
  __typename?: 'treatment_UpdateTherapyCardResponse';
  id?: Maybe<Scalars['String']>;
  inMemory?: Maybe<Scalars['Boolean']>;
  persisted?: Maybe<Scalars['Boolean']>;
  therapyCard?: Maybe<Treatment_TherapyCardMsg>;
  /** result of BlockUpdate validation */
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type Treatment_UpdateTherapyCardStatusRequest = {
  __typename?: 'treatment_UpdateTherapyCardStatusRequest';
  immediatelyActivate?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Treatment_MedicalItemStatus>;
  therapyCardId?: Maybe<Scalars['String']>;
};

export type Treatment_UpdateTherapyCardStatusResponse = {
  __typename?: 'treatment_UpdateTherapyCardStatusResponse';
  therapyCard?: Maybe<Treatment_TherapyCardMsg>;
};

export type Treatment_UpdateTherapyStatusRequest = {
  __typename?: 'treatment_UpdateTherapyStatusRequest';
  status?: Maybe<Treatment_MedicalItemStatus>;
  therapyId?: Maybe<Scalars['String']>;
};

export type Treatment_UpdateTherapyStatusResponse = {
  __typename?: 'treatment_UpdateTherapyStatusResponse';
  therapy?: Maybe<Treatment_TherapyMsg>;
};

export type Treatment_UpdateTreatmentEvaluationRequest = {
  __typename?: 'treatment_UpdateTreatmentEvaluationRequest';
  therapyId?: Maybe<Scalars['String']>;
  treatmentEvaluationText?: Maybe<Scalars['String']>;
};

export type Treatment_UpdateTreatmentEvaluationResponse = {
  __typename?: 'treatment_UpdateTreatmentEvaluationResponse';
  treatmentEvaluationText?: Maybe<Scalars['String']>;
};

export type Treatment_UpdateVaccinationDiseaseRequest = {
  __typename?: 'treatment_UpdateVaccinationDiseaseRequest';
  disease?: Maybe<Treatment_VaccinationRelevantDiseaseMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
};

export type Treatment_UpdateVaccinationRequest = {
  __typename?: 'treatment_UpdateVaccinationRequest';
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  vaccination?: Maybe<Treatment_VaccinationMsg>;
};

export type Treatment_UpdateWoundRequest = {
  __typename?: 'treatment_UpdateWoundRequest';
  parameters?: Maybe<Versioning_VersionedEntityCreationParametersMsg>;
  patch?: Maybe<Scalars['Boolean']>;
  patchTree?: Maybe<Core_PatchUpdateTreeRootMsg>;
  versioningDirection?: Maybe<Versioning_VersioningDirection>;
  wound?: Maybe<Treatment_WoundMsg>;
};

export type Treatment_UpdrsBlock = {
  __typename?: 'treatment_UpdrsBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  motorAspectsOfDailyLiving?: Maybe<Treatment_MotorAspectsOfDailyLivingMsg>;
  motorComplications?: Maybe<Treatment_MotorComplicationsMsg>;
  motorExamination?: Maybe<Treatment_MotorExaminationMsg>;
  nonMotorAspectsOfDailyLiving?: Maybe<Treatment_NonMotorAspectsOfDailyLivingMsg>;
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_UpdrsSelection {
  /** mild (2) */
  UpdrsSelectionMild = 'UPDRS_SELECTION_MILD',
  /** moderate (3) */
  UpdrsSelectionModerate = 'UPDRS_SELECTION_MODERATE',
  UpdrsSelectionNone = 'UPDRS_SELECTION_NONE',
  /** normal (0) */
  UpdrsSelectionNormal = 'UPDRS_SELECTION_NORMAL',
  /** severe (4) */
  UpdrsSelectionSevere = 'UPDRS_SELECTION_SEVERE',
  /** slight (1) */
  UpdrsSelectionSlight = 'UPDRS_SELECTION_SLIGHT'
}

export type Treatment_UpperAnkleJointMsg = {
  __typename?: 'treatment_UpperAnkleJointMsg';
  dorsalExtension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  id?: Maybe<Scalars['String']>;
  plantarFlexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
};

export enum Treatment_UpperArmCircumference {
  /** 21 to ≤22cm (0.5). [21:22] */
  UpperArmCircumferenceBetween_21And_22Cm = 'UPPER_ARM_CIRCUMFERENCE_BETWEEN_21_AND_22_CM',
  /** >22cm (1) */
  UpperArmCircumferenceGreaterThan_22Cm = 'UPPER_ARM_CIRCUMFERENCE_GREATER_THAN_22_CM',
  /** <21cm (0) */
  UpperArmCircumferenceLessThan_21Cm = 'UPPER_ARM_CIRCUMFERENCE_LESS_THAN_21_CM',
  UpperArmCircumferenceNone = 'UPPER_ARM_CIRCUMFERENCE_NONE'
}

export type Treatment_UpperLimbsPasiMsg = {
  __typename?: 'treatment_UpperLimbsPasiMsg';
  upperLimbsBodyRegionPercentage?: Maybe<Treatment_BodyRegionPercentage>;
  upperLimbsDiscoloration?: Maybe<Treatment_PasiSelection>;
  upperLimbsScaling?: Maybe<Treatment_PasiSelection>;
  /** <(Value(Discoloration) + Value(Thickness) + Value(Scaling)) * Value(Percentage) * 0.2> */
  upperLimbsScore?: Maybe<Scalars['Float']>;
  upperLimbsThickness?: Maybe<Treatment_PasiSelection>;
};

export type Treatment_UpperLipBiteTestBlock = {
  __typename?: 'treatment_UpperLipBiteTestBlock';
  score?: Maybe<Scalars['Int']>;
  upperLipBiteTestSelection?: Maybe<Treatment_UpperLipBiteTestSelection>;
};

export enum Treatment_UpperLipBiteTestSelection {
  UpperLipBiteTestSelectionAbleToBiteUpperLipBelowVermilionLine = 'UPPER_LIP_BITE_TEST_SELECTION_ABLE_TO_BITE_UPPER_LIP_BELOW_VERMILION_LINE',
  UpperLipBiteTestSelectionAbleToRaiseLowerIncisorsAboveVermilionLine = 'UPPER_LIP_BITE_TEST_SELECTION_ABLE_TO_RAISE_LOWER_INCISORS_ABOVE_VERMILION_LINE',
  UpperLipBiteTestSelectionNone = 'UPPER_LIP_BITE_TEST_SELECTION_NONE',
  UpperLipBiteTestSelectionUnableToBiteUpperLip = 'UPPER_LIP_BITE_TEST_SELECTION_UNABLE_TO_BITE_UPPER_LIP'
}

export type Treatment_UrinaryBladderBlock = {
  __typename?: 'treatment_UrinaryBladderBlock';
  palpationUrinaryBladder?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  text?: Maybe<Scalars['String']>;
};

export type Treatment_UrinaryCatheterMsg = {
  __typename?: 'treatment_UrinaryCatheterMsg';
  materials?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_VaccinationDiseaseList = {
  __typename?: 'treatment_VaccinationDiseaseList';
  diseases?: Maybe<Array<Maybe<Treatment_VaccinationRelevantDiseaseMsg>>>;
};

export enum Treatment_VaccinationEntryType {
  VaccinationEntryTypeDigital = 'VACCINATION_ENTRY_TYPE_DIGITAL',
  VaccinationEntryTypeDigitalAndCertificate = 'VACCINATION_ENTRY_TYPE_DIGITAL_AND_CERTIFICATE',
  VaccinationEntryTypeDigitalAndVaccinationCard = 'VACCINATION_ENTRY_TYPE_DIGITAL_AND_VACCINATION_CARD',
  VaccinationEntryTypeNone = 'VACCINATION_ENTRY_TYPE_NONE'
}

export type Treatment_VaccinationList = {
  __typename?: 'treatment_VaccinationList';
  patientId?: Maybe<Scalars['String']>;
  vaccinations?: Maybe<Array<Maybe<Treatment_VaccinationMsg>>>;
};

export type Treatment_VaccinationMsg = {
  __typename?: 'treatment_VaccinationMsg';
  /** Alternative to entering all data from previous vaccinations: just set this */
  basicImmunizationCompleted?: Maybe<Scalars['Boolean']>;
  bodyPartId?: Maybe<Core_KnowledgeInputMsg>;
  /** Fixed legal disclaimer */
  disclaimer?: Maybe<Scalars['String']>;
  entryType?: Maybe<Treatment_VaccinationEntryType>;
  externalIds?: Maybe<Array<Maybe<Treatment_ExternalVaccinationIdMsg>>>;
  externalVaccinationDetails?: Maybe<Treatment_ExternalSourceMsg>;
  /** Dates at which a follow-up vaccination is required */
  followUpDates?: Maybe<Array<Maybe<VeiosDateTimeMsg>>>;
  id?: Maybe<Scalars['String']>;
  /** Path by which the vaccine is taken into the body */
  intakeRouteId?: Maybe<Core_KnowledgeInputMsg>;
  notes?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  packageSize?: Maybe<Scalars['String']>;
  /** True if vaccination was administered as part of the treatment */
  primarySource?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Treatment_VaccinationQuantityMsg>;
  /** When the vaccination was recorded in this system */
  recordDate?: Maybe<Timestamp>;
  registeringUserId?: Maybe<Scalars['String']>;
  responsibleUserId?: Maybe<Scalars['String']>;
  status?: Maybe<Treatment_VaccinationStatus>;
  vaccinationDate?: Maybe<VeiosDateTimeMsg>;
  /** Diseases which the vaccination is aimed at */
  vaccinationTargetIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  vaccine?: Maybe<Treatment_VaccineMsg>;
};

/** TODO: Rather use standardized QuantityMsg? */
export type Treatment_VaccinationQuantityMsg = {
  __typename?: 'treatment_VaccinationQuantityMsg';
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Core_Unit>;
};

/**
 * A disease that a patient had against which vaccinations are administered.
 *  Can influence when/whether a vaccination is required, depending on the immunity level reached by having the disease.
 */
export type Treatment_VaccinationRelevantDiseaseMsg = {
  __typename?: 'treatment_VaccinationRelevantDiseaseMsg';
  diseaseId?: Maybe<Core_KnowledgeInputMsg>;
  externalInformationDetails?: Maybe<Treatment_ExternalSourceMsg>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** False if information was provided from an external source */
  primarySource?: Maybe<Scalars['Boolean']>;
  recordDate?: Maybe<Timestamp>;
  registeringUserId?: Maybe<Scalars['String']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export enum Treatment_VaccinationStatus {
  VaccinationStatusCompleted = 'VACCINATION_STATUS_COMPLETED',
  VaccinationStatusNone = 'VACCINATION_STATUS_NONE',
  /** This status is set if e.g. the first of multiple vaccinations has been administered. */
  VaccinationStatusNotDone = 'VACCINATION_STATUS_NOT_DONE'
}

export type Treatment_VaccinationsBlock = {
  __typename?: 'treatment_VaccinationsBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_VaccineMsg = {
  __typename?: 'treatment_VaccineMsg';
  batch?: Maybe<Scalars['String']>;
  drugLink?: Maybe<Drug_DrugLinkMsg>;
  expirationDate?: Maybe<VeiosDateTimeMsg>;
  id?: Maybe<Scalars['String']>;
};

export type Treatment_VacuumTherapySystemMsg = {
  __typename?: 'treatment_VacuumTherapySystemMsg';
  connectedWoundVersionGroupId?: Maybe<Scalars['String']>;
  localization?: Maybe<Core_KnowledgeInputMsg>;
  suctionRate?: Maybe<Scalars['Int']>;
  /** TODO we need to check for the correctness of the data type */
  suctionTimeInterval?: Maybe<Treatment_FluidFlowSystemTimePeriodMsg>;
  /** if type = continually then suctionTimeInterval.offset should be equal to null */
  suctionTimeIntervalType?: Maybe<Treatment_SuctionTimeIntervalType>;
  suctionUnit?: Maybe<Treatment_SuctionUnit>;
};

export type Treatment_ValidateAnamnesisBlockRequest = {
  __typename?: 'treatment_ValidateAnamnesisBlockRequest';
  anamnesisId?: Maybe<Scalars['String']>;
  blockId?: Maybe<Scalars['String']>;
  blockNumber?: Maybe<Scalars['Int']>;
  cardNumber?: Maybe<Scalars['Int']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Treatment_ValidateImmunityTestRequest = {
  __typename?: 'treatment_ValidateImmunityTestRequest';
  immunityTestId?: Maybe<Scalars['String']>;
};

export type Treatment_ValidateVaccinationDiseaseRequest = {
  __typename?: 'treatment_ValidateVaccinationDiseaseRequest';
  diseaseId?: Maybe<Scalars['String']>;
};

export type Treatment_ValidateVaccinationRequest = {
  __typename?: 'treatment_ValidateVaccinationRequest';
  vaccinationId?: Maybe<Scalars['String']>;
};

export type Treatment_ValidationRequestMsg = {
  __typename?: 'treatment_ValidationRequestMsg';
  validateAllSubLevels?: Maybe<Scalars['Boolean']>;
  validateThisLevel?: Maybe<Scalars['Boolean']>;
};

export type Treatment_VaricosisBlock = {
  __typename?: 'treatment_VaricosisBlock';
  text?: Maybe<Scalars['String']>;
  varicosisPresent?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_VascularSystemPalpationResult {
  VascularSystemPalpationNone = 'VASCULAR_SYSTEM_PALPATION_NONE',
  VascularSystemPalpationNotPalpable = 'VASCULAR_SYSTEM_PALPATION_NOT_PALPABLE',
  VascularSystemPalpationPoorlyPalpable = 'VASCULAR_SYSTEM_PALPATION_POORLY_PALPABLE',
  VascularSystemPalpationWellPalpable = 'VASCULAR_SYSTEM_PALPATION_WELL_PALPABLE'
}

export type Treatment_VentricularDrainageMsg = {
  __typename?: 'treatment_VentricularDrainageMsg';
  _?: Maybe<Scalars['String']>;
};

export type Treatment_VerbalRatingScaleBlock = {
  __typename?: 'treatment_VerbalRatingScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  severitySelection?: Maybe<Treatment_SeveritySelection>;
};

export enum Treatment_VerbalResponseType {
  VerbalResponseDisoriented = 'VERBAL_RESPONSE_DISORIENTED',
  VerbalResponseMakesNoSounds = 'VERBAL_RESPONSE_MAKES_NO_SOUNDS',
  VerbalResponseMakesSounds = 'VERBAL_RESPONSE_MAKES_SOUNDS',
  VerbalResponseNone = 'VERBAL_RESPONSE_NONE',
  VerbalResponseOriented = 'VERBAL_RESPONSE_ORIENTED',
  VerbalResponseWords = 'VERBAL_RESPONSE_WORDS'
}

export type Treatment_VertigoBlock = {
  __typename?: 'treatment_VertigoBlock';
  directions?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  furtherClassification?: Maybe<Treatment_VertigoDetailsMsg>;
  furtherClassificationPresent?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  onsetType?: Maybe<Treatment_SymptomOnsetType>;
  paroxysmalVertigo?: Maybe<Treatment_ParoxysmalVertigoMsg>;
  present?: Maybe<Scalars['Boolean']>;
  timeFrame?: Maybe<VeiosTimeFrameMsg>;
};

export type Treatment_VertigoDetailsMsg = {
  __typename?: 'treatment_VertigoDetailsMsg';
  description?: Maybe<Scalars['String']>;
  dizzyInMorningAfterGettingUp?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  increasedVertigoTime?: Maybe<Treatment_IncreasedVertigoTime>;
  positionalDependences?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  seeingStartsWhenGettingUp?: Maybe<Scalars['Boolean']>;
  triggers?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  unsteadyGait?: Maybe<Scalars['Boolean']>;
};

export type Treatment_VigilanceBlock = {
  __typename?: 'treatment_VigilanceBlock';
  text?: Maybe<Scalars['String']>;
  vigilance?: Maybe<Treatment_VigilanceType>;
};

export enum Treatment_VigilanceType {
  VigilanceAwake = 'VIGILANCE_AWAKE',
  VigilanceComatose = 'VIGILANCE_COMATOSE',
  VigilanceLightHeaded = 'VIGILANCE_LIGHT_HEADED',
  VigilanceNone = 'VIGILANCE_NONE',
  VigilanceSomnolent = 'VIGILANCE_SOMNOLENT',
  VigilanceSoporous = 'VIGILANCE_SOPOROUS'
}

export enum Treatment_VisionAndNeglect {
  VisionAndNeglectEssentiallyUndisturbed = 'VISION_AND_NEGLECT_ESSENTIALLY_UNDISTURBED',
  VisionAndNeglectNone = 'VISION_AND_NEGLECT_NONE',
  /** cannot find his way around sufficiently even in familiar surroundings */
  VisionAndNeglectSevere = 'VISION_AND_NEGLECT_SEVERE',
  /** finds his way around in familiar but not unfamiliar surroundings */
  VisionAndNeglectSevereFamiliar = 'VISION_AND_NEGLECT_SEVERE_FAMILIAR',
  /** severe reading disorder, but is able to find his way around in familiar and unfamiliar surrounding */
  VisionAndNeglectSevereFamiliarUnfamiliar = 'VISION_AND_NEGLECT_SEVERE_FAMILIAR_UNFAMILIAR'
}

export type Treatment_VisitDiagnosesList = {
  __typename?: 'treatment_VisitDiagnosesList';
  diagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  idPair?: Maybe<Treatment_VisitPatientIdPairMsg>;
  /** kept separately for FE backwards compatibility */
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_VisitPatientIdPairMsg = {
  __typename?: 'treatment_VisitPatientIdPairMsg';
  patientId?: Maybe<Scalars['String']>;
  visitId?: Maybe<Scalars['String']>;
};

export type Treatment_VisualAcuityBlock = {
  __typename?: 'treatment_VisualAcuityBlock';
  abnormalityLeftText?: Maybe<Scalars['String']>;
  abnormalityRightText?: Maybe<Scalars['String']>;
  furtherDetails?: Maybe<Scalars['String']>;
  simpleVisualAcuityTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

export type Treatment_VisualAnalogueScaleBlock = {
  __typename?: 'treatment_VisualAnalogueScaleBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  severitySlider?: Maybe<Treatment_SeveritySlider>;
};

export type Treatment_VisualFieldAndVisualAttentionBlock = {
  __typename?: 'treatment_VisualFieldAndVisualAttentionBlock';
  fingerPerimetricVisualFieldTest?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  furtherDetails?: Maybe<Scalars['String']>;
  leftAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  leftAbnormalitiesText?: Maybe<Scalars['String']>;
  overallAssessment?: Maybe<Core_KnowledgeInputMsg>;
  overallAssessmentText?: Maybe<Scalars['String']>;
  rightAbnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  rightAbnormalitiesText?: Maybe<Scalars['String']>;
  testForVisualExtinction?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  testForVisualExtinctionText?: Maybe<Scalars['String']>;
};

export enum Treatment_VisualFieldTestResult {
  VisualFieldTestBilateralHemianopsia = 'VISUAL_FIELD_TEST_BILATERAL_HEMIANOPSIA',
  VisualFieldTestComa = 'VISUAL_FIELD_TEST_COMA',
  VisualFieldTestCompleteHemianopsia = 'VISUAL_FIELD_TEST_COMPLETE_HEMIANOPSIA',
  VisualFieldTestExtinctionHemianopsia = 'VISUAL_FIELD_TEST_EXTINCTION_HEMIANOPSIA',
  VisualFieldTestNone = 'VISUAL_FIELD_TEST_NONE',
  VisualFieldTestNotAssessable = 'VISUAL_FIELD_TEST_NOT_ASSESSABLE',
  VisualFieldTestNoRestriction = 'VISUAL_FIELD_TEST_NO_RESTRICTION',
  VisualFieldTestPartialHemianopsia = 'VISUAL_FIELD_TEST_PARTIAL_HEMIANOPSIA'
}

export enum Treatment_VocalCordImmobility {
  VocalCordImmobilityBoth = 'VOCAL_CORD_IMMOBILITY_BOTH',
  VocalCordImmobilityLeft = 'VOCAL_CORD_IMMOBILITY_LEFT',
  VocalCordImmobilityNone = 'VOCAL_CORD_IMMOBILITY_NONE',
  VocalCordImmobilityRight = 'VOCAL_CORD_IMMOBILITY_RIGHT'
}

export type Treatment_VocalCordImmobilityDetailsMsg = {
  __typename?: 'treatment_VocalCordImmobilityDetailsMsg';
  immobility?: Maybe<Treatment_VocalCordImmobility>;
  paresis?: Maybe<Treatment_VocalCordParesis>;
};

export enum Treatment_VocalCordParesis {
  VocalCordParesisBoth = 'VOCAL_CORD_PARESIS_BOTH',
  VocalCordParesisLeft = 'VOCAL_CORD_PARESIS_LEFT',
  VocalCordParesisNone = 'VOCAL_CORD_PARESIS_NONE',
  VocalCordParesisRight = 'VOCAL_CORD_PARESIS_RIGHT'
}

export type Treatment_VocalFremitusBlock = {
  __typename?: 'treatment_VocalFremitusBlock';
  abnormalities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  vocalFremitus?: Maybe<Treatment_AbnormalitiesExaminationResult>;
};

/** https://veioscom.sharepoint.com/:x:/r/sites/product/_layouts/15/Doc.aspx?sourcedoc=%7B9D898CC3-81F6-4EB1-8F8D-6AA67CBC8E69%7D&file=20230415_DataSet_Wagner-Armstrong_diab.%20foot.xlsx&action=default&mobileredirect=true */
export type Treatment_WagnerArmstrongClassificationBlock = {
  __typename?: 'treatment_WagnerArmstrongClassificationBlock';
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  wagnerArmstrongInput?: Maybe<Treatment_WagnerArmstrongInput>;
};

export enum Treatment_WagnerArmstrongInput {
  WagnerArmstrongInputGrad_0A = 'WAGNER_ARMSTRONG_INPUT_GRAD_0_A',
  WagnerArmstrongInputGrad_0B = 'WAGNER_ARMSTRONG_INPUT_GRAD_0_B',
  WagnerArmstrongInputGrad_0C = 'WAGNER_ARMSTRONG_INPUT_GRAD_0_C',
  WagnerArmstrongInputGrad_0D = 'WAGNER_ARMSTRONG_INPUT_GRAD_0_D',
  WagnerArmstrongInputGrad_1A = 'WAGNER_ARMSTRONG_INPUT_GRAD_1_A',
  WagnerArmstrongInputGrad_1B = 'WAGNER_ARMSTRONG_INPUT_GRAD_1_B',
  WagnerArmstrongInputGrad_1C = 'WAGNER_ARMSTRONG_INPUT_GRAD_1_C',
  WagnerArmstrongInputGrad_1D = 'WAGNER_ARMSTRONG_INPUT_GRAD_1_D',
  WagnerArmstrongInputGrad_2A = 'WAGNER_ARMSTRONG_INPUT_GRAD_2_A',
  WagnerArmstrongInputGrad_2B = 'WAGNER_ARMSTRONG_INPUT_GRAD_2_B',
  WagnerArmstrongInputGrad_2C = 'WAGNER_ARMSTRONG_INPUT_GRAD_2_C',
  WagnerArmstrongInputGrad_2D = 'WAGNER_ARMSTRONG_INPUT_GRAD_2_D',
  WagnerArmstrongInputGrad_3A = 'WAGNER_ARMSTRONG_INPUT_GRAD_3_A',
  WagnerArmstrongInputGrad_3B = 'WAGNER_ARMSTRONG_INPUT_GRAD_3_B',
  WagnerArmstrongInputGrad_3C = 'WAGNER_ARMSTRONG_INPUT_GRAD_3_C',
  WagnerArmstrongInputGrad_3D = 'WAGNER_ARMSTRONG_INPUT_GRAD_3_D',
  WagnerArmstrongInputGrad_4A = 'WAGNER_ARMSTRONG_INPUT_GRAD_4_A',
  WagnerArmstrongInputGrad_4B = 'WAGNER_ARMSTRONG_INPUT_GRAD_4_B',
  WagnerArmstrongInputGrad_4C = 'WAGNER_ARMSTRONG_INPUT_GRAD_4_C',
  WagnerArmstrongInputGrad_4D = 'WAGNER_ARMSTRONG_INPUT_GRAD_4_D',
  WagnerArmstrongInputGrad_5A = 'WAGNER_ARMSTRONG_INPUT_GRAD_5_A',
  WagnerArmstrongInputGrad_5B = 'WAGNER_ARMSTRONG_INPUT_GRAD_5_B',
  WagnerArmstrongInputGrad_5C = 'WAGNER_ARMSTRONG_INPUT_GRAD_5_C',
  WagnerArmstrongInputGrad_5D = 'WAGNER_ARMSTRONG_INPUT_GRAD_5_D',
  WagnerArmstrongInputGradNone = 'WAGNER_ARMSTRONG_INPUT_GRAD_NONE'
}

export enum Treatment_Walking {
  /** Beginning to have difficulty walking */
  WalkingBeginningDifficulty = 'WALKING_BEGINNING_DIFFICULTY',
  WalkingNone = 'WALKING_NONE',
  /** No purposeful leg movement possible */
  WalkingNoPurposefulLegMovement = 'WALKING_NO_PURPOSEFUL_LEG_MOVEMENT',
  /** Unable to walk, but purposeful leg movement possible */
  WalkingPurposefulLegMovementPossible = 'WALKING_PURPOSEFUL_LEG_MOVEMENT_POSSIBLE',
  WalkingUndisturbed = 'WALKING_UNDISTURBED',
  /** Can walk only with assistance */
  WalkingWithAssistance = 'WALKING_WITH_ASSISTANCE'
}

export enum Treatment_WalkingAids {
  WalkingAidsBedridden = 'WALKING_AIDS_BEDRIDDEN',
  WalkingAidsForearmCruchesOrWalkingStick = 'WALKING_AIDS_FOREARM_CRUCHES_OR_WALKING_STICK',
  WalkingAidsNone = 'WALKING_AIDS_NONE',
  WalkingAidsNoWalkingAids = 'WALKING_AIDS_NO_WALKING_AIDS',
  WalkingAidsRollatorOrWalkingFrame = 'WALKING_AIDS_ROLLATOR_OR_WALKING_FRAME',
  WalkingAidsWheelchair = 'WALKING_AIDS_WHEELCHAIR'
}

export enum Treatment_WalkingStance {
  WalkingStanceHeelsAlmostTouching = 'WALKING_STANCE_HEELS_ALMOST_TOUCHING',
  WalkingStanceHeelsFarApart = 'WALKING_STANCE_HEELS_FAR_APART',
  /** <heels almost touching (1) / heels far apart (0)> */
  WalkingStanceNone = 'WALKING_STANCE_NONE'
}

export type Treatment_WarScoreBlock = {
  __typename?: 'treatment_WarScoreBlock';
  /** Acquired immunodeficiency due to pharmacotherapy such as ciclosporin, methotrexate, glucocorticoids, antibodies: <yes (1) / no (0)> */
  acquiredImmunodeficiencyDueToPharmacotherapy?: Maybe<Scalars['Boolean']>;
  /** Acquired immunosuppressive disease (e.g., diabetes mellitus): <yes (1) / no (0)> */
  acquiredImmunosuppressiveDisease?: Maybe<Scalars['Boolean']>;
  /** Patient age >80 years : <yes (1) / no (0)> */
  ageGreaterThan80?: Maybe<Scalars['Boolean']>;
  /** Burn wounds with involvement of >15% body surface area (BSA): <yes (3) / no (0)> */
  burnWoundsWithInvolvement15PercentOfBsa?: Maybe<Scalars['Boolean']>;
  /** Chronic wounds of any aetiology with a depth >1,5 cm: <yes (1) / no (0)> */
  chronicWoundsDepthGreaterThan1Point5Cm?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Difficult hygienic conditions due to social or professional environment (e.g., farmer, truck driver): <yes (1) / no (0)> */
  difficultHygienicConditions?: Maybe<Scalars['Boolean']>;
  /** Extended inpatient status >3 weeks: <yes (1) / no (0)> */
  extendedInpatientStatusMoreThan3Weeks?: Maybe<Scalars['Boolean']>;
  /** Heavily contaminated acute wounds: <yes (2) / no (0)> */
  heavilyContaminatedAcuteWounds?: Maybe<Scalars['Boolean']>;
  /** Postsurgical wound healing disorder which results in (unplanned) healing by secondary intention: <yes (1) / no (0)> */
  postsurgicalWoundHealingDisorder?: Maybe<Scalars['Boolean']>;
  /** <automatic addition of points based on previous entries> */
  score?: Maybe<Scalars['Int']>;
  /** Severe acquired immunodeficiency (e.g., HIV infection): <yes (2) / no (0)> */
  severeAcquiredImmunodeficiency?: Maybe<Scalars['Boolean']>;
  /** Severe congenital immunodeficiency such as agammaglobulinaemia, severe combined immunodeficiency (SCID): <yes (3) / no (0)> */
  severeCongenitalImmunodeficiency?: Maybe<Scalars['Boolean']>;
  /** Solid tumour disease: <yes (1) / no (0)> */
  solidTumorDisease?: Maybe<Scalars['Boolean']>;
  /** Systemic haematological disease: <yes (1) / no (0)> */
  systemicHaematologicalDisease?: Maybe<Scalars['Boolean']>;
  /** Wound dimensions >10 cm2: <yes (1) / no (0)> */
  woundDimensionsGreaterThan10?: Maybe<Scalars['Boolean']>;
  /** Wound persisting for >1 year: <yes (1) / no (0)> */
  woundPersistingForGreaterThanOneYear?: Maybe<Scalars['Boolean']>;
  /** Wounds exposed to high bacterial loads due to localization (e.g., perineum, genitals): <yes (1) / no (0)> */
  woundsExposedToHighBacterialLoads?: Maybe<Scalars['Boolean']>;
  /** Bite, stab or gunshot wounds penetrating 1,5-3,5 cm: <yes (2) / no (0)> */
  woundsPenetratingBetween1Point5And3Point5Cm?: Maybe<Scalars['Boolean']>;
  /** Bite, stab or gunshot wounds penetrating >3,5 cm: <yes (3) / no (0)> */
  woundsPenetratingMoreThan3Point5Cm?: Maybe<Scalars['Boolean']>;
  /** Wounds that have a direct connection to organs or functional structures (e.g. including joints) or which contain foreign material: <yes (3) / no (0)> */
  woundsWithDirectConnectionToOrgans?: Maybe<Scalars['Boolean']>;
  /** Young age of patient (premature infants, babies, young children): <yes (1) / no (0)> */
  youngAgeOfPatient?: Maybe<Scalars['Boolean']>;
};

export enum Treatment_Water {
  WaterHotWater = 'WATER_HOT_WATER',
  WaterNone = 'WATER_NONE',
  WaterNoHotWater = 'WATER_NO_HOT_WATER'
}

export enum Treatment_WeberTestResultType {
  WeberTestResultLaterizationLeft = 'WEBER_TEST_RESULT_LATERIZATION_LEFT',
  WeberTestResultLaterizationRight = 'WEBER_TEST_RESULT_LATERIZATION_RIGHT',
  WeberTestResultNone = 'WEBER_TEST_RESULT_NONE',
  WeberTestResultNoLaterization = 'WEBER_TEST_RESULT_NO_LATERIZATION'
}

export enum Treatment_WeightLoss {
  /** weight loss between 1 and 3 kg (2) */
  WeightLossBetween_1And_3 = 'WEIGHT_LOSS_BETWEEN_1_AND_3',
  /** weight loss > 3 kg (0) */
  WeightLossGreaterThan_3 = 'WEIGHT_LOSS_GREATER_THAN_3',
  WeightLossNone = 'WEIGHT_LOSS_NONE',
  /** no weight loss (3) */
  WeightLossNoWeightLoss = 'WEIGHT_LOSS_NO_WEIGHT_LOSS',
  /** not known (1) */
  WeightLossUnknown = 'WEIGHT_LOSS_UNKNOWN'
}

export enum Treatment_WeightVariability {
  WeightVariabilityFluctuating = 'WEIGHT_VARIABILITY_FLUCTUATING',
  WeightVariabilityNone = 'WEIGHT_VARIABILITY_NONE',
  WeightVariabilityStable = 'WEIGHT_VARIABILITY_STABLE'
}

export type Treatment_WellsIBlock = {
  __typename?: 'treatment_WellsIBlock';
  /** Clinical signs of deep vein thrombosis:  yes (3) / no (0) */
  clinicalSignsOfDeepVeinThrombosis?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Heart rate >100/min: yes (1.5) / no (0) */
  exceedHeartRate?: Maybe<Scalars['Boolean']>;
  /** Hemoptysis: yes (1) / no (0) */
  hemoptysis?: Maybe<Scalars['Boolean']>;
  /** Pulmonary embolism more likely than alternative diagnosis: yes (3) / no (0) */
  likelyPulmonaryEmbolism?: Maybe<Scalars['Boolean']>;
  /** Malignancy: yes (1) / no (0) */
  malignancy?: Maybe<Scalars['Boolean']>;
  /** Previous pulmonary embolism or deep vein thrombosis: yes (1.5) / no (0) */
  previousPulmonaryEmbolism?: Maybe<Scalars['Boolean']>;
  /** Recent surgery or immobilization: yes (1.5) / no (0) */
  recentSurgery?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Float']>;
};

export type Treatment_WellsIiBlock = {
  __typename?: 'treatment_WellsIIBlock';
  /** Clinical signs of deep vein thrombosis: yes (1) / no (0) */
  clinicalSignsOfDeepVeinThrombosis?: Maybe<Scalars['Boolean']>;
  /** true if all fields are set for score calculation */
  completed?: Maybe<Scalars['Boolean']>;
  /** Heart rate >100/min: yes (1) / no (0) */
  exceedHeartRate?: Maybe<Scalars['Boolean']>;
  /** Hemoptysis: yes (1) / no (0) */
  hemoptysis?: Maybe<Scalars['Boolean']>;
  /** Pulmonary embolism more likely than alternative diagnosis: yes (1) / no (0) */
  likelyPulmonaryEmbolism?: Maybe<Scalars['Boolean']>;
  /** Malignancy: yes (1) / no (0) */
  malignancy?: Maybe<Scalars['Boolean']>;
  /** Previous pulmonary embolism or deep vein thrombosis: yes (1) / no (0) */
  previousPulmonaryEmbolism?: Maybe<Scalars['Boolean']>;
  /** Recent surgery or immobilization: yes (1) / no (0) */
  recentSurgery?: Maybe<Scalars['Boolean']>;
  /** automatic addition of points based on previous entries */
  score?: Maybe<Scalars['Int']>;
};

export enum Treatment_Worthlessness {
  WorthlessnessCompletelyWorthless = 'WORTHLESSNESS_COMPLETELY_WORTHLESS',
  WorthlessnessLessValuableAndUseful = 'WORTHLESSNESS_LESS_VALUABLE_AND_USEFUL',
  WorthlessnessLessValuableComparedToOthers = 'WORTHLESSNESS_LESS_VALUABLE_COMPARED_TO_OTHERS',
  WorthlessnessNone = 'WORTHLESSNESS_NONE',
  WorthlessnessNoWorthlessFeelings = 'WORTHLESSNESS_NO_WORTHLESS_FEELINGS'
}

export type Treatment_WoundAnamnesisMsg = {
  __typename?: 'treatment_WoundAnamnesisMsg';
  connectedDiagnoses?: Maybe<Array<Maybe<Treatment_DiagnosisMsg>>>;
  placesOfOrigin?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  recurrenceAmount?: Maybe<Scalars['Int']>;
  /** recurrence */
  recurrencePresent?: Maybe<Scalars['Boolean']>;
  woundAids?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundDate?: Maybe<Timestamp>;
  woundDiagnostics?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundTherapies?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_WoundContextReferenceMsg = {
  __typename?: 'treatment_WoundContextReferenceMsg';
  patientId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
  type?: Maybe<Treatment_WoundContextType>;
  visitId?: Maybe<Scalars['String']>;
};

export enum Treatment_WoundContextType {
  WoundContextNone = 'WOUND_CONTEXT_NONE',
  WoundContextPatientChart = 'WOUND_CONTEXT_PATIENT_CHART',
  WoundContextTreatment = 'WOUND_CONTEXT_TREATMENT'
}

export type Treatment_WoundDebridementMsg = {
  __typename?: 'treatment_WoundDebridementMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  localAnesthesia?: Maybe<Treatment_WoundLocalAnesthesiaMsg>;
  woundCleanings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundCompression?: Maybe<Core_KnowledgeInputMsg>;
  woundCoverings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundPads?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundRinsings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundTamponades?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_WoundDrainageMsg = {
  __typename?: 'treatment_WoundDrainageMsg';
  connectedWoundVersionGroupId?: Maybe<Scalars['String']>;
  localization?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Scalars['Float']>;
  sizeUnit?: Maybe<Treatment_FlowSystemSizeUnit>;
  type?: Maybe<Core_KnowledgeInputMsg>;
};

export type Treatment_WoundExaminationBlock = {
  __typename?: 'treatment_WoundExaminationBlock';
  present?: Maybe<Scalars['Boolean']>;
};

export type Treatment_WoundExudateMsg = {
  __typename?: 'treatment_WoundExudateMsg';
  exudatePresent?: Maybe<Scalars['Boolean']>;
  exudateQualities?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  exudateQuantity?: Maybe<Treatment_ExudateQuantity>;
};

export type Treatment_WoundGroundMsg = {
  __typename?: 'treatment_WoundGroundMsg';
  groundConspicuous?: Maybe<Scalars['Boolean']>;
  groundText?: Maybe<Scalars['String']>;
  grounds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export enum Treatment_WoundHealingProgress {
  WoundHealingProgressImproved = 'WOUND_HEALING_PROGRESS_IMPROVED',
  WoundHealingProgressNone = 'WOUND_HEALING_PROGRESS_NONE',
  WoundHealingProgressUnchanged = 'WOUND_HEALING_PROGRESS_UNCHANGED',
  WoundHealingProgressWorse = 'WOUND_HEALING_PROGRESS_WORSE'
}

export type Treatment_WoundInfectionSignsMsg = {
  __typename?: 'treatment_WoundInfectionSignsMsg';
  infectionSigns?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  infectionSignsPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_WoundList = {
  __typename?: 'treatment_WoundList';
  wounds?: Maybe<Array<Maybe<Treatment_WoundMsg>>>;
};

export type Treatment_WoundLocalAnesthesiaMsg = {
  __typename?: 'treatment_WoundLocalAnesthesiaMsg';
  drugLink?: Maybe<Drug_DrugLinkMsg>;
  /** non-negative; unit: ml */
  localAnaesthesiaVolume?: Maybe<Scalars['Float']>;
};

export type Treatment_WoundMarginExcisionMsg = {
  __typename?: 'treatment_WoundMarginExcisionMsg';
  excisionPresent?: Maybe<Scalars['Boolean']>;
  excisionText?: Maybe<Scalars['String']>;
};

export type Treatment_WoundMarginMsg = {
  __typename?: 'treatment_WoundMarginMsg';
  marginText?: Maybe<Scalars['String']>;
  margins?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  marginsConspicuous?: Maybe<Scalars['Boolean']>;
};

export type Treatment_WoundMsg = {
  __typename?: 'treatment_WoundMsg';
  advancedWoundTherapies?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  anamnesis?: Maybe<Treatment_WoundAnamnesisMsg>;
  ceapClassification?: Maybe<Core_KnowledgeInputMsg>;
  chronicWound?: Maybe<Scalars['Boolean']>;
  connectedFlowSystems?: Maybe<Array<Maybe<Treatment_FluidFlowSystemMsg>>>;
  decubitusClassification?: Maybe<Core_KnowledgeInputMsg>;
  description?: Maybe<Scalars['String']>;
  /** use it for first documentation date */
  documentationDate?: Maybe<Timestamp>;
  exudate?: Maybe<Treatment_WoundExudateMsg>;
  fontaineClassification?: Maybe<Core_KnowledgeInputMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  ground?: Maybe<Treatment_WoundGroundMsg>;
  healed?: Maybe<Scalars['Boolean']>;
  /** use it for first documentation date */
  healingDate?: Maybe<Timestamp>;
  healingProgress?: Maybe<Treatment_WoundHealingProgress>;
  id?: Maybe<Scalars['String']>;
  imageSeriesId?: Maybe<Scalars['String']>;
  infectionSigns?: Maybe<Treatment_WoundInfectionSignsMsg>;
  localizations?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  margin?: Maybe<Treatment_WoundMarginMsg>;
  odor?: Maybe<Treatment_WoundOdorMsg>;
  pain?: Maybe<Treatment_WoundPainMsg>;
  patientId?: Maybe<Scalars['String']>;
  rutherfordClassification?: Maybe<Core_KnowledgeInputMsg>;
  size?: Maybe<Treatment_WoundSizeMsg>;
  surroundings?: Maybe<Treatment_WoundSurroundingsMsg>;
  tascClassification?: Maybe<Core_KnowledgeInputMsg>;
  treatmentId?: Maybe<Scalars['String']>;
  undermining?: Maybe<Treatment_WoundUnderminingMsg>;
  versionInfo?: Maybe<Versioning_VersionInfoMsg>;
  visitId?: Maybe<Scalars['String']>;
  wagnerDiabeticFootUlcerClassification?: Maybe<Core_KnowledgeInputMsg>;
  widmerClassification?: Maybe<Core_KnowledgeInputMsg>;
  woundHealingFactors?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundStage?: Maybe<Core_KnowledgeInputMsg>;
  woundSymptoms?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundTypes?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

export type Treatment_WoundOdorMsg = {
  __typename?: 'treatment_WoundOdorMsg';
  odorPresent?: Maybe<Scalars['Boolean']>;
  odorText?: Maybe<Scalars['String']>;
};

export type Treatment_WoundPainMsg = {
  __typename?: 'treatment_WoundPainMsg';
  /** range: 1-10; unit: NRS */
  painLevel?: Maybe<Scalars['Int']>;
  painPresent?: Maybe<Scalars['Boolean']>;
};

export type Treatment_WoundProcedureGroupMsg = {
  __typename?: 'treatment_WoundProcedureGroupMsg';
  therapyCards?: Maybe<Array<Maybe<Treatment_TherapyCardMsg>>>;
  woundVersionGroupId?: Maybe<Scalars['String']>;
};

export type Treatment_WoundSizeMsg = {
  __typename?: 'treatment_WoundSizeMsg';
  /** Calculated area in cm² */
  area?: Maybe<Scalars['Float']>;
  /** in cm */
  depth?: Maybe<Scalars['Float']>;
  /** in cm */
  diameter?: Maybe<Scalars['Float']>;
  /** in cm */
  length?: Maybe<Scalars['Float']>;
  /** in cm */
  width?: Maybe<Scalars['Float']>;
};

export type Treatment_WoundSkinGlueMsg = {
  __typename?: 'treatment_WoundSkinGlueMsg';
  skinGlue?: Maybe<Scalars['Boolean']>;
  skinGlueText?: Maybe<Scalars['String']>;
};

export type Treatment_WoundSkinStaplingMsg = {
  __typename?: 'treatment_WoundSkinStaplingMsg';
  clip?: Maybe<Treatment_SkinStaplingClipMsg>;
  furtherDetails?: Maybe<Scalars['String']>;
  localAnesthesia?: Maybe<Treatment_WoundLocalAnesthesiaMsg>;
  skinGlue?: Maybe<Treatment_WoundSkinGlueMsg>;
  woundCleanings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundMarginExcision?: Maybe<Treatment_WoundMarginExcisionMsg>;
  woundRinsings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_WoundSurroundingsMsg = {
  __typename?: 'treatment_WoundSurroundingsMsg';
  surroundings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  surroundingsConspicuous?: Maybe<Scalars['Boolean']>;
  surroundingsText?: Maybe<Scalars['String']>;
};

export enum Treatment_WoundSutureMethodType {
  SutureProcedureMethodTypeNone = 'SUTURE_PROCEDURE_METHOD_TYPE_NONE',
  SutureProcedureMethodTypePrimary = 'SUTURE_PROCEDURE_METHOD_TYPE_PRIMARY',
  SutureProcedureMethodTypeSecondary = 'SUTURE_PROCEDURE_METHOD_TYPE_SECONDARY'
}

export type Treatment_WoundSutureMsg = {
  __typename?: 'treatment_WoundSutureMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  localAnesthesia?: Maybe<Treatment_WoundLocalAnesthesiaMsg>;
  methodType?: Maybe<Treatment_WoundSutureMethodType>;
  skinGlue?: Maybe<Treatment_WoundSkinGlueMsg>;
  /** non-negative integers */
  stitches?: Maybe<Scalars['Int']>;
  sutureRemoval?: Maybe<Treatment_SutureRemovalMsg>;
  sutureTechniques?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  sutureThread?: Maybe<Treatment_SutureThreadMsg>;
  woundCleanings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundMarginExcision?: Maybe<Treatment_WoundMarginExcisionMsg>;
  woundRinsings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_WoundTreatmentMsg = {
  __typename?: 'treatment_WoundTreatmentMsg';
  furtherDetails?: Maybe<Scalars['String']>;
  woundCleanings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundCompression?: Maybe<Core_KnowledgeInputMsg>;
  woundCoverings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundRinsings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundTamponades?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_WoundUnderminingMsg = {
  __typename?: 'treatment_WoundUnderminingMsg';
  /** TODO: Data type? */
  underminingLocales?: Maybe<Array<Maybe<Treatment_UnderminingLocale>>>;
  underminingPresent?: Maybe<Scalars['Boolean']>;
  underminingText?: Maybe<Scalars['String']>;
};

export enum Treatment_WoundVacuumTherapyActionType {
  WoundVacuumTherapyActionTypeApply = 'WOUND_VACUUM_THERAPY_ACTION_TYPE_APPLY',
  WoundVacuumTherapyActionTypeChange = 'WOUND_VACUUM_THERAPY_ACTION_TYPE_CHANGE',
  WoundVacuumTherapyActionTypeNone = 'WOUND_VACUUM_THERAPY_ACTION_TYPE_NONE',
  WoundVacuumTherapyActionTypeRemove = 'WOUND_VACUUM_THERAPY_ACTION_TYPE_REMOVE'
}

export type Treatment_WoundVacuumTherapyMsg = {
  __typename?: 'treatment_WoundVacuumTherapyMsg';
  actionType?: Maybe<Treatment_WoundVacuumTherapyActionType>;
  connectedFlowSystem?: Maybe<Treatment_FluidFlowSystemMsg>;
  debridement?: Maybe<Scalars['Boolean']>;
  furtherDetails?: Maybe<Scalars['String']>;
  localAnesthesia?: Maybe<Treatment_WoundLocalAnesthesiaMsg>;
  suctionRate?: Maybe<Scalars['Int']>;
  suctionTimeInterval?: Maybe<Treatment_SuctionTimeIntervalMsg>;
  suctionTimeIntervalType?: Maybe<Treatment_SuctionTimeIntervalType>;
  woundCleanings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundEdgeProtections?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundRinsings?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  woundVersionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Treatment_WoundVersionGroupMsg = {
  __typename?: 'treatment_WoundVersionGroupMsg';
  latestWoundId?: Maybe<Scalars['String']>;
  versionGroupId?: Maybe<Scalars['String']>;
  wounds?: Maybe<Array<Maybe<Treatment_WoundMsg>>>;
};

export type Treatment_WristMsg = {
  __typename?: 'treatment_WristMsg';
  evaluation?: Maybe<Treatment_AbnormalitiesExaminationResult>;
  extension?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  flexion?: Maybe<Treatment_ForceLevelsAndDetailsMsg>;
  id?: Maybe<Scalars['String']>;
};

/** Allows overriding Diagnosis' properties for specific coding */
export type Treatment_Diagnosis_German_GermanDiagnosisCodingDetailsMsg = {
  __typename?: 'treatment_diagnosis_german_GermanDiagnosisCodingDetailsMsg';
  /** German "Kommentar" */
  comment?: Maybe<Scalars['String']>;
  diagnosisDetailType?: Maybe<Treatment_DiagnosisDetailType>;
  diagnosisType?: Maybe<Treatment_DiagnosisType>;
  /** German "Ausnahmetatbestand" */
  exceptionalCircumstance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** German "Erläuterung" */
  justification?: Maybe<Scalars['String']>;
  laterality?: Maybe<Laterality_Laterality>;
  persistentCode?: Maybe<Scalars['Boolean']>;
};

export enum User_AccessPermission {
  /** Permission allows administrative access */
  AccessPermissionAdministrate = 'ACCESS_PERMISSION_ADMINISTRATE',
  AccessPermissionNone = 'ACCESS_PERMISSION_NONE',
  AccessPermissionRead = 'ACCESS_PERMISSION_READ',
  AccessPermissionRequest = 'ACCESS_PERMISSION_REQUEST',
  AccessPermissionSign = 'ACCESS_PERMISSION_SIGN',
  /** Permission allows temporary deletion within 15 minutes */
  AccessPermissionTemporaryDelete = 'ACCESS_PERMISSION_TEMPORARY_DELETE',
  AccessPermissionValidate = 'ACCESS_PERMISSION_VALIDATE',
  AccessPermissionWrite = 'ACCESS_PERMISSION_WRITE'
}

export type User_AdministrativeUnitList = {
  __typename?: 'user_AdministrativeUnitList';
  administrativeUnits?: Maybe<Array<Maybe<User_AdministrativeUnitMsg>>>;
};

export type User_AdministrativeUnitMsg = {
  __typename?: 'user_AdministrativeUnitMsg';
  children?: Maybe<Array<Maybe<User_AdministrativeUnitMsg>>>;
  contact?: Maybe<Core_ContactMsg>;
  defaultParentId?: Maybe<Scalars['String']>;
  externalCategories?: Maybe<Array<Maybe<User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  /** Administrative Unit Tree */
  id?: Maybe<Scalars['String']>;
  /** Administrative Unit Details */
  name?: Maybe<Scalars['String']>;
  organizationalUnitType?: Maybe<User_OrganizationalUnitType>;
  parents?: Maybe<Array<Maybe<User_AdministrativeUnitMsg>>>;
  specializationIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
  type?: Maybe<Core_AdministrativeUnitType>;
};

export type User_AdministrativeUnitNameMappingMsg = {
  __typename?: 'user_AdministrativeUnitNameMappingMsg';
  clinic?: Maybe<User_SimpleAdministrativeUnitMsg>;
  department?: Maybe<User_SimpleAdministrativeUnitMsg>;
  division?: Maybe<User_SimpleAdministrativeUnitMsg>;
  organizationalUnit?: Maybe<User_SimpleAdministrativeUnitMsg>;
};

export type User_AdministrativeUnitProxyMappingList = {
  __typename?: 'user_AdministrativeUnitProxyMappingList';
  mappings?: Maybe<Array<Maybe<User_AdministrativeUnitProxyMappingMsg>>>;
};

/** AdministrativeUnitMapping extended by external ids */
export type User_AdministrativeUnitProxyMappingMsg = {
  __typename?: 'user_AdministrativeUnitProxyMappingMsg';
  /** Only id and external ids and external categories are set */
  clinic?: Maybe<User_ClinicMsg>;
  clinicId?: Maybe<Scalars['String']>;
  /** Only id and external ids and external categories are set */
  department?: Maybe<User_DepartmentMsg>;
  /** Only id and external ids and external categories are set */
  division?: Maybe<User_DivisionMsg>;
  /** Only id and external ids and external categories are set */
  organizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
};

/** Light-weight representation of a unit hierarchy */
export type User_AdministrativeUnitTreeMsg = {
  __typename?: 'user_AdministrativeUnitTreeMsg';
  children?: Maybe<Array<Maybe<User_AdministrativeUnitTreeMsg>>>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

/** Used only for broadcasting division/department updates via kafka */
export type User_AdministrativeUnitUpdateMsg = {
  __typename?: 'user_AdministrativeUnitUpdateMsg';
  externalCategories?: Maybe<Array<Maybe<User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  /** Used to communicate the updates of division and departments */
  unitMapping?: Maybe<Core_AdministrativeUnitMappingMsg>;
  /** false for first time creations, true for updates */
  updateChildren?: Maybe<Scalars['Boolean']>;
};

export type User_ClinicList = {
  __typename?: 'user_ClinicList';
  clinics?: Maybe<Array<Maybe<User_ClinicMsg>>>;
};

export type User_ClinicMsg = {
  __typename?: 'user_ClinicMsg';
  contact?: Maybe<Core_ContactMsg>;
  divisions?: Maybe<Array<Maybe<User_DivisionMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  specializationIds?: Maybe<Array<Maybe<Core_KnowledgeInputMsg>>>;
};

/** associated units should be given in parentIds and childrenIds */
export type User_CreateAdministrativeUnitRequest = {
  __typename?: 'user_CreateAdministrativeUnitRequest';
  administrativeUnit?: Maybe<User_AdministrativeUnitMsg>;
  childrenIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When returning the created unit */
  includeHierarchy?: Maybe<Scalars['Boolean']>;
  parentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_CreateDepartmentRequest = {
  __typename?: 'user_CreateDepartmentRequest';
  department?: Maybe<User_DepartmentMsg>;
  divisionId?: Maybe<Scalars['String']>;
};

export type User_CreateDivisionRequest = {
  __typename?: 'user_CreateDivisionRequest';
  clinicId?: Maybe<Scalars['String']>;
  division?: Maybe<User_DivisionMsg>;
};

export type User_CreateOrganizationalUnitRequest = {
  __typename?: 'user_CreateOrganizationalUnitRequest';
  /** Mandatory, must be one of the department ids as well */
  defaultDepartmentId?: Maybe<Scalars['String']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
};

export type User_CreateRoleRequest = {
  __typename?: 'user_CreateRoleRequest';
  externalNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_CreateUserRequest = {
  __typename?: 'user_CreateUserRequest';
  password?: Maybe<Scalars['String']>;
  user?: Maybe<User_UserMsg>;
};

export type User_CreateUserResponse = {
  __typename?: 'user_CreateUserResponse';
  user?: Maybe<User_UserMsg>;
  validationResult?: Maybe<Validation_ValidationResultMsg>;
};

export type User_DeleteOfficeHourRequest = {
  __typename?: 'user_DeleteOfficeHourRequest';
  officeHourId?: Maybe<Scalars['String']>;
};

export type User_DeleteOfficeHourResponse = {
  __typename?: 'user_DeleteOfficeHourResponse';
  deletedOfficeHourId?: Maybe<Scalars['String']>;
};

export type User_DeleteRoleRequest = {
  __typename?: 'user_DeleteRoleRequest';
  roleId?: Maybe<Scalars['String']>;
};

export type User_DeleteRoleResponse = {
  __typename?: 'user_DeleteRoleResponse';
  deletedRoleId?: Maybe<Scalars['String']>;
};

export type User_DepartmentList = {
  __typename?: 'user_DepartmentList';
  departments?: Maybe<Array<Maybe<User_DepartmentMsg>>>;
};

export type User_DepartmentMsg = {
  __typename?: 'user_DepartmentMsg';
  clinicId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  divisionId?: Maybe<Scalars['String']>;
  externalCategories?: Maybe<Array<Maybe<User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationalUnits?: Maybe<Array<Maybe<User_OrganizationalUnitMsg>>>;
};

export type User_DepartmentSearchResultMsg = {
  __typename?: 'user_DepartmentSearchResultMsg';
  department?: Maybe<User_DepartmentMsg>;
  parentDivision?: Maybe<User_DivisionMsg>;
};

export type User_DivisionList = {
  __typename?: 'user_DivisionList';
  divisions?: Maybe<Array<Maybe<User_DivisionMsg>>>;
};

export type User_DivisionMsg = {
  __typename?: 'user_DivisionMsg';
  clinicId?: Maybe<Scalars['String']>;
  contact?: Maybe<Core_ContactMsg>;
  departments?: Maybe<Array<Maybe<User_DepartmentMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** fow now it's only added to department but will be added to other administrative unit types in the future */
export type User_ExternalAdministrativeUnitCategoryMsg = {
  __typename?: 'user_ExternalAdministrativeUnitCategoryMsg';
  category?: Maybe<Scalars['String']>;
  type?: Maybe<User_ExternalAdministrativeUnitCategoryType>;
};

export enum User_ExternalAdministrativeUnitCategoryType {
  ExternalAdministrativeUnitCategoryTypeGermanDepartmentKey = 'EXTERNAL_ADMINISTRATIVE_UNIT_CATEGORY_TYPE_GERMAN_DEPARTMENT_KEY',
  ExternalAdministrativeUnitCategoryTypeNone = 'EXTERNAL_ADMINISTRATIVE_UNIT_CATEGORY_TYPE_NONE'
}

export type User_ExternalUnitIdMsg = {
  __typename?: 'user_ExternalUnitIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<User_ExternalUnitIdType>;
};

export enum User_ExternalUnitIdType {
  /** German “Betriebsstättennummer” */
  ExternalUnitIdTypeBsnr = 'EXTERNAL_UNIT_ID_TYPE_BSNR',
  ExternalUnitIdTypeDrg = 'EXTERNAL_UNIT_ID_TYPE_DRG',
  /** German “Institutionskennzeichen” */
  ExternalUnitIdTypeIk = 'EXTERNAL_UNIT_ID_TYPE_IK',
  ExternalUnitIdTypeKey = 'EXTERNAL_UNIT_ID_TYPE_KEY',
  /** German "Standortnummer" */
  ExternalUnitIdTypeLocnr = 'EXTERNAL_UNIT_ID_TYPE_LOCNR',
  ExternalUnitIdTypeName = 'EXTERNAL_UNIT_ID_TYPE_NAME',
  ExternalUnitIdTypeNone = 'EXTERNAL_UNIT_ID_TYPE_NONE',
  ExternalUnitIdTypeQsmed = 'EXTERNAL_UNIT_ID_TYPE_QSMED',
  ExternalUnitIdTypeShortKey = 'EXTERNAL_UNIT_ID_TYPE_SHORT_KEY'
}

export type User_ExternalUserIdMsg = {
  __typename?: 'user_ExternalUserIdMsg';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemId?: Maybe<Scalars['String']>;
  type?: Maybe<User_ExternalUserIdType>;
};

export enum User_ExternalUserIdType {
  ExternalUserIdTypeActiveDirectory = 'EXTERNAL_USER_ID_TYPE_ACTIVE_DIRECTORY',
  ExternalUserIdTypeHis = 'EXTERNAL_USER_ID_TYPE_HIS',
  ExternalUserIdTypeIk = 'EXTERNAL_USER_ID_TYPE_IK',
  ExternalUserIdTypeKodip = 'EXTERNAL_USER_ID_TYPE_KODIP',
  /** German “Lebenslange Arztnummer” */
  ExternalUserIdTypeLanr = 'EXTERNAL_USER_ID_TYPE_LANR',
  ExternalUserIdTypeNone = 'EXTERNAL_USER_ID_TYPE_NONE',
  ExternalUserIdTypePseudoLanr = 'EXTERNAL_USER_ID_TYPE_PSEUDO_LANR',
  ExternalUserIdTypeQsmed = 'EXTERNAL_USER_ID_TYPE_QSMED'
}

export type User_FindAdministrativeUnitRequest = {
  __typename?: 'user_FindAdministrativeUnitRequest';
  baseUnitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  /** optional: if the unit is an organizationalUnit and only one of its parents should be searched, this should be set */
  parentDepartmentId?: Maybe<Scalars['String']>;
  /** Unit must have primary address */
  requirePrimaryAddress?: Maybe<Scalars['Boolean']>;
  /** Optional: if set, only returns unit if it has an external id with any of these types */
  requiredExternalIdTypesAny?: Maybe<Array<Maybe<User_ExternalUnitIdType>>>;
};

export type User_FindAdministrativeUnitResponse = {
  __typename?: 'user_FindAdministrativeUnitResponse';
  clinic?: Maybe<User_ClinicMsg>;
  department?: Maybe<User_DepartmentMsg>;
  division?: Maybe<User_DivisionMsg>;
  found?: Maybe<Scalars['Boolean']>;
  organizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
};

export type User_FindExternalUnitIdsRequest = {
  __typename?: 'user_FindExternalUnitIdsRequest';
  /** optional: if the unit is an organizationalUnit and only one of its parents should be searched, this should be set */
  parentDepartmentId?: Maybe<Scalars['String']>;
  /** If true, the external id is searched in the unit's parents if the unit itself does not contain an external id of the given type */
  searchParents?: Maybe<Scalars['Boolean']>;
  type?: Maybe<User_ExternalUnitIdType>;
  unit?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type User_FindExternalUnitIdsResponse = {
  __typename?: 'user_FindExternalUnitIdsResponse';
  externalUnitIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
};

export type User_FindHumanNamesByUserIdsRequest = {
  __typename?: 'user_FindHumanNamesByUserIdsRequest';
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_FindHumanNamesByUserIdsResponse = {
  __typename?: 'user_FindHumanNamesByUserIdsResponse';
  userIdToHumanName?: Maybe<Array<Maybe<User_FindHumanNamesByUserIdsResponse_UserIdToHumanNameEntry>>>;
};

export type User_FindHumanNamesByUserIdsResponse_UserIdToHumanNameEntry = {
  __typename?: 'user_FindHumanNamesByUserIdsResponse_UserIdToHumanNameEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Core_HumanNameMsg>;
};

export type User_FindUserIdsByUserNamesRequest = {
  __typename?: 'user_FindUserIdsByUserNamesRequest';
  userNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_FindUserIdsByUserNamesResponse = {
  __typename?: 'user_FindUserIdsByUserNamesResponse';
  userNameToUserId?: Maybe<Array<Maybe<User_FindUserIdsByUserNamesResponse_UserNameToUserIdEntry>>>;
};

export type User_FindUserIdsByUserNamesResponse_UserNameToUserIdEntry = {
  __typename?: 'user_FindUserIdsByUserNamesResponse_UserNameToUserIdEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/**
 * Only used to provide frontend with an easy way of checking authorization of a user,
 *  gets converted by backend when sending info about current user
 */
export type User_FlatPermissionMsg = {
  __typename?: 'user_FlatPermissionMsg';
  accessPermission?: Maybe<User_AccessPermission>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  target?: Maybe<User_PermissionTarget>;
};

export type User_GetAdministrativeUnitIds = {
  __typename?: 'user_GetAdministrativeUnitIds';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_GetAdministrativeUnitNameMappingRequest = {
  __typename?: 'user_GetAdministrativeUnitNameMappingRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_GetAdministrativeUnitRequest = {
  __typename?: 'user_GetAdministrativeUnitRequest';
  administrativeUnitId?: Maybe<Scalars['String']>;
  includeDetails?: Maybe<Scalars['Boolean']>;
  includeHierarchy?: Maybe<Scalars['Boolean']>;
};

export type User_GetClinicRequest = {
  __typename?: 'user_GetClinicRequest';
  clinicId?: Maybe<Scalars['String']>;
  /** Whether clinic details such as address should be included in the return message */
  includeDetails?: Maybe<Scalars['Boolean']>;
  /** Whether the child divisions, departments, organizational units should be included in the return message */
  includeHierarchy?: Maybe<Scalars['Boolean']>;
};

export type User_GetClinicsRequest = {
  __typename?: 'user_GetClinicsRequest';
  clinicIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_GetDepartmentRequest = {
  __typename?: 'user_GetDepartmentRequest';
  departmentId?: Maybe<Scalars['String']>;
  /** Whether the child organizational units should be included in the return message */
  includeHierarchy?: Maybe<Scalars['Boolean']>;
};

export type User_GetDepartmentsRequest = {
  __typename?: 'user_GetDepartmentsRequest';
  departmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_GetDivisionRequest = {
  __typename?: 'user_GetDivisionRequest';
  divisionId?: Maybe<Scalars['String']>;
  /** Whether the child departments, organizational units should be included in the return message */
  includeHierarchy?: Maybe<Scalars['Boolean']>;
};

export type User_GetDivisionsRequest = {
  __typename?: 'user_GetDivisionsRequest';
  divisionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_GetOfficeHourIdsFromNameAndUnitIdRequest = {
  __typename?: 'user_GetOfficeHourIdsFromNameAndUnitIdRequest';
  name?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
};

export type User_GetOfficeHourIdsFromNameAndUnitIdResponse = {
  __typename?: 'user_GetOfficeHourIdsFromNameAndUnitIdResponse';
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_GetOfficeHourRequest = {
  __typename?: 'user_GetOfficeHourRequest';
  id?: Maybe<Scalars['String']>;
};

export type User_GetOfficeHourResponse = {
  __typename?: 'user_GetOfficeHourResponse';
  clinicId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  officeHour?: Maybe<User_OfficeHourMsg>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_GetOfficeHoursRequest = {
  __typename?: 'user_GetOfficeHoursRequest';
  divisionId?: Maybe<Scalars['String']>;
  officeHourIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_GetOrganizationalUnitRequest = {
  __typename?: 'user_GetOrganizationalUnitRequest';
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_GetOrganizationalUnitsRequest = {
  __typename?: 'user_GetOrganizationalUnitsRequest';
  organizationalUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_GetRoleRequest = {
  __typename?: 'user_GetRoleRequest';
  externalName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
};

export type User_GetUnitsFromExternalIdsRequest = {
  __typename?: 'user_GetUnitsFromExternalIdsRequest';
  externalIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  systemId?: Maybe<Scalars['String']>;
};

export type User_GetUnitsFromExternalIdsResponse = {
  __typename?: 'user_GetUnitsFromExternalIdsResponse';
  administrativeUnitIds?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type User_GetUserRequest = {
  __typename?: 'user_GetUserRequest';
  userId?: Maybe<Scalars['String']>;
};

export type User_GetUsersRequest = {
  __typename?: 'user_GetUsersRequest';
  includePermissions?: Maybe<Scalars['Boolean']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_JwtAppTokenRequest = {
  __typename?: 'user_JwtAppTokenRequest';
  appId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<User_SpecialPermissionMsg>>>;
};

export type User_JwtTokenMsg = {
  __typename?: 'user_JwtTokenMsg';
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type User_JwtTokenRefreshRequest = {
  __typename?: 'user_JwtTokenRefreshRequest';
  refreshToken?: Maybe<Scalars['String']>;
};

export type User_ListAdministrativeUnitMappingsRequest = {
  __typename?: 'user_ListAdministrativeUnitMappingsRequest';
  _?: Maybe<Scalars['String']>;
};

export type User_ListAdministrativeUnitMappingsResponse = {
  __typename?: 'user_ListAdministrativeUnitMappingsResponse';
  /** mappings where the organizational unit is the lowest level and the department is the unit's default department */
  defaultUnitMappings?: Maybe<Array<Maybe<Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the department is the lowest level */
  departmentMappings?: Maybe<Array<Maybe<Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the division is the lowest level */
  divisionMappings?: Maybe<Array<Maybe<Core_AdministrativeUnitMappingMsg>>>;
  /** mappings where the organizational unit is the lowest level, multiple parents per organizational unit possible */
  unitMappings?: Maybe<Array<Maybe<Core_FlexibleAdministrativeUnitMappingMsg>>>;
};

export type User_ListAdministrativeUnitProxyMappingsRequest = {
  __typename?: 'user_ListAdministrativeUnitProxyMappingsRequest';
  _?: Maybe<Scalars['String']>;
};

export type User_ListAdministrativeUnitsRequest = {
  __typename?: 'user_ListAdministrativeUnitsRequest';
  administrativeUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  includeDetails?: Maybe<Scalars['Boolean']>;
  includeHierarchy?: Maybe<Scalars['Boolean']>;
};

export type User_ListExternalUserIdsRequest = {
  __typename?: 'user_ListExternalUserIdsRequest';
  externalIdTypes?: Maybe<Array<Maybe<User_ExternalUserIdType>>>;
  unitReference?: Maybe<Core_AdministrativeUnitReferenceMsg>;
};

export type User_ListExternalUserIdsResponseElementMsg = {
  __typename?: 'user_ListExternalUserIdsResponseElementMsg';
  externalUserIds?: Maybe<Array<Maybe<User_ExternalUserIdMsg>>>;
  humanName?: Maybe<Core_HumanNameMsg>;
  userId?: Maybe<Scalars['String']>;
};

export type User_ListExternalUserIdsResponseElementResponse = {
  __typename?: 'user_ListExternalUserIdsResponseElementResponse';
  externalUserIds?: Maybe<Array<Maybe<User_ListExternalUserIdsResponseElementMsg>>>;
};

export type User_ListLoginTargetModulesResponse = {
  __typename?: 'user_ListLoginTargetModulesResponse';
  possibleTargetModules?: Maybe<Array<Maybe<User_LoginTargetModule>>>;
};

export type User_ListLoginTargetUnitsRequest = {
  __typename?: 'user_ListLoginTargetUnitsRequest';
  targetModule?: Maybe<User_LoginTargetModule>;
};

export type User_ListLoginTargetUnitsResponse = {
  __typename?: 'user_ListLoginTargetUnitsResponse';
  clinicTrees?: Maybe<Array<Maybe<User_AdministrativeUnitTreeMsg>>>;
};

export type User_ListOrganizationalUnitIdsRequest = {
  __typename?: 'user_ListOrganizationalUnitIdsRequest';
  administrativeUnitIds?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type User_ListOrganizationalUnitIdsResponse = {
  __typename?: 'user_ListOrganizationalUnitIdsResponse';
  organizationalUnitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type User_LogOutRequest = {
  __typename?: 'user_LogOutRequest';
  /** dummy as Empty is not accepted as input */
  logOut?: Maybe<Scalars['Boolean']>;
};

export enum User_LoginTargetModule {
  LoginTargetModuleInpatient = 'LOGIN_TARGET_MODULE_INPATIENT',
  LoginTargetModuleLab = 'LOGIN_TARGET_MODULE_LAB',
  LoginTargetModuleNone = 'LOGIN_TARGET_MODULE_NONE',
  LoginTargetModuleOutpatient = 'LOGIN_TARGET_MODULE_OUTPATIENT',
  LoginTargetModuleSurgery = 'LOGIN_TARGET_MODULE_SURGERY'
}

export enum User_OfficeHourActivationStatus {
  OfficeHourActivationStatusActive = 'OFFICE_HOUR_ACTIVATION_STATUS_ACTIVE',
  OfficeHourActivationStatusInactive = 'OFFICE_HOUR_ACTIVATION_STATUS_INACTIVE',
  OfficeHourActivationStatusNone = 'OFFICE_HOUR_ACTIVATION_STATUS_NONE',
  OfficeHourActivationStatusNotYetActive = 'OFFICE_HOUR_ACTIVATION_STATUS_NOT_YET_ACTIVE'
}

export type User_OfficeHourList = {
  __typename?: 'user_OfficeHourList';
  divisionId?: Maybe<Scalars['String']>;
  officeHours?: Maybe<Array<Maybe<User_OfficeHourMsg>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_OfficeHourMsg = {
  __typename?: 'user_OfficeHourMsg';
  activationStatus?: Maybe<User_OfficeHourActivationStatus>;
  /** True if the Patient needs an appointment to attend the OfficeHour */
  hasAppointments?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  regularSchedule?: Maybe<Array<Maybe<Core_DayOfWeekScheduleMsg>>>;
  specialSchedule?: Maybe<Array<Maybe<Core_DateScheduleMsg>>>;
};

export type User_OfficeHourToAdministrativeUnitMappingList = {
  __typename?: 'user_OfficeHourToAdministrativeUnitMappingList';
  officeHoursToAdministrativeUnitMappings?: Maybe<Array<Maybe<User_OfficeHourToAdministrativeUnitMappingMsg>>>;
};

export type User_OfficeHourToAdministrativeUnitMappingMsg = {
  __typename?: 'user_OfficeHourToAdministrativeUnitMappingMsg';
  officeHourId?: Maybe<Scalars['String']>;
  unitMapping?: Maybe<Core_FlexibleAdministrativeUnitMappingMsg>;
};

export type User_OrganizationalUnitList = {
  __typename?: 'user_OrganizationalUnitList';
  organizationalUnits?: Maybe<Array<Maybe<User_OrganizationalUnitMsg>>>;
};

export type User_OrganizationalUnitMsg = {
  __typename?: 'user_OrganizationalUnitMsg';
  contact?: Maybe<Core_ContactMsg>;
  defaultClinicId?: Maybe<Scalars['String']>;
  defaultDepartmentId?: Maybe<Scalars['String']>;
  defaultDivisionId?: Maybe<Scalars['String']>;
  externalCategories?: Maybe<Array<Maybe<User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<User_OrganizationalUnitType>;
};

export type User_OrganizationalUnitResultList = {
  __typename?: 'user_OrganizationalUnitResultList';
  organizationalUnits?: Maybe<Array<Maybe<User_OrganizationalUnitMsg>>>;
};

export type User_OrganizationalUnitSearchResultMsg = {
  __typename?: 'user_OrganizationalUnitSearchResultMsg';
  organizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
  parentDepartment?: Maybe<User_DepartmentMsg>;
  parentDivision?: Maybe<User_DivisionMsg>;
};

export enum User_OrganizationalUnitType {
  OrganizationalUnitTypeLab = 'ORGANIZATIONAL_UNIT_TYPE_LAB',
  OrganizationalUnitTypeNone = 'ORGANIZATIONAL_UNIT_TYPE_NONE',
  OrganizationalUnitTypeOther = 'ORGANIZATIONAL_UNIT_TYPE_OTHER',
  OrganizationalUnitTypeOutpatient = 'ORGANIZATIONAL_UNIT_TYPE_OUTPATIENT',
  OrganizationalUnitTypeSurgery = 'ORGANIZATIONAL_UNIT_TYPE_SURGERY',
  OrganizationalUnitTypeWard = 'ORGANIZATIONAL_UNIT_TYPE_WARD'
}

/** Used only for broadcasting organizational unit updates via kafka */
export type User_OrganizationalUnitUpdateMsg = {
  __typename?: 'user_OrganizationalUnitUpdateMsg';
  defaultUnitMapping?: Maybe<Core_AdministrativeUnitMappingMsg>;
  externalCategories?: Maybe<Array<Maybe<User_ExternalAdministrativeUnitCategoryMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  unitMappings?: Maybe<Core_FlexibleAdministrativeUnitMappingMsg>;
  updateChildren?: Maybe<Scalars['Boolean']>;
};

export enum User_PermissionTarget {
  PermissionTargetAppointment = 'PERMISSION_TARGET_APPOINTMENT',
  PermissionTargetBilling = 'PERMISSION_TARGET_BILLING',
  PermissionTargetCare = 'PERMISSION_TARGET_CARE',
  PermissionTargetClinic = 'PERMISSION_TARGET_CLINIC',
  PermissionTargetClinicalRequest = 'PERMISSION_TARGET_CLINICAL_REQUEST',
  PermissionTargetDevice = 'PERMISSION_TARGET_DEVICE',
  PermissionTargetDocument = 'PERMISSION_TARGET_DOCUMENT',
  PermissionTargetFindingMessage = 'PERMISSION_TARGET_FINDING_MESSAGE',
  PermissionTargetForm = 'PERMISSION_TARGET_FORM',
  PermissionTargetImage = 'PERMISSION_TARGET_IMAGE',
  PermissionTargetLab = 'PERMISSION_TARGET_LAB',
  PermissionTargetLetter = 'PERMISSION_TARGET_LETTER',
  PermissionTargetMedication = 'PERMISSION_TARGET_MEDICATION',
  PermissionTargetNone = 'PERMISSION_TARGET_NONE',
  PermissionTargetPatient = 'PERMISSION_TARGET_PATIENT',
  /** TODO how to model planning and coordination rights? new AccessPermission values? */
  PermissionTargetSurgery = 'PERMISSION_TARGET_SURGERY',
  PermissionTargetTreatment = 'PERMISSION_TARGET_TREATMENT',
  PermissionTargetUser = 'PERMISSION_TARGET_USER',
  PermissionTargetVisit = 'PERMISSION_TARGET_VISIT'
}

/**
 * Consists of a target area (e.g., Treatment, Patient Letter) and a list of access permissions (e.g., Read, Write).
 *  The unit type determines on which scale this permission is granted.
 */
export type User_PermissionTokenMsg = {
  __typename?: 'user_PermissionTokenMsg';
  accessPermission?: Maybe<User_AccessPermission>;
  administrativeUnitType?: Maybe<Core_AdministrativeUnitType>;
  id?: Maybe<Scalars['String']>;
  target?: Maybe<User_PermissionTarget>;
};

export type User_RequestSpecialAccessRequest = {
  __typename?: 'user_RequestSpecialAccessRequest';
  resourceId?: Maybe<Scalars['String']>;
  type?: Maybe<User_SpecialAccessTargetType>;
};

/** A collection of actions that a user with this role is allowed to perform */
export type User_RoleMsg = {
  __typename?: 'user_RoleMsg';
  /** Names by which the role is defined in the clinic's other systems */
  externalNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pathKeyConstraints?: Maybe<Array<Maybe<Common_Access_PathKeyAccessConstraintMsg>>>;
  permissionTokens?: Maybe<Array<Maybe<User_PermissionTokenMsg>>>;
  scopedConstraints?: Maybe<Array<Maybe<Common_Access_ScopedAccessConstraintMsg>>>;
  targetConstraints?: Maybe<Array<Maybe<Common_Access_TargetConstraint>>>;
  targetedRouteConstraints?: Maybe<Array<Maybe<Common_Access_TargetedRouteConstraintMsg>>>;
  types?: Maybe<Array<Maybe<Core_RoleType>>>;
};

/**
 * Maps a role, which specifies the actions that can be performed, to a scope, which specifies where these
 *  actions can be performed
 */
export type User_RoleScopeMappingMsg = {
  __typename?: 'user_RoleScopeMappingMsg';
  id?: Maybe<Scalars['String']>;
  /** role with predefined permissions */
  role?: Maybe<User_RoleMsg>;
  /** the administrative units in which the user has that role */
  scope?: Maybe<Array<Maybe<Core_AdministrativeUnitReferenceMsg>>>;
};

export type User_SearchDepartmentsRequest = {
  __typename?: 'user_SearchDepartmentsRequest';
  clinicId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  /** if this is set to true, the parent division of each department will be included in the response */
  includeParentDivision?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type User_SearchDepartmentsResponse = {
  __typename?: 'user_SearchDepartmentsResponse';
  results?: Maybe<Array<Maybe<User_DepartmentSearchResultMsg>>>;
};

export type User_SearchDivisionsRequest = {
  __typename?: 'user_SearchDivisionsRequest';
  /** mandatory filter */
  clinicId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type User_SearchOfficeHoursRequest = {
  __typename?: 'user_SearchOfficeHoursRequest';
  clinicId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  includeParents?: Maybe<Scalars['Boolean']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type User_SearchOfficeHoursResultList = {
  __typename?: 'user_SearchOfficeHoursResultList';
  officeHoursSearchResults?: Maybe<Array<Maybe<User_SearchOfficeHoursResultMsg>>>;
};

export type User_SearchOfficeHoursResultMsg = {
  __typename?: 'user_SearchOfficeHoursResultMsg';
  officeHour?: Maybe<User_OfficeHourMsg>;
  parentClinic?: Maybe<User_ClinicMsg>;
  parentDepartment?: Maybe<User_DepartmentMsg>;
  parentDivision?: Maybe<User_DivisionMsg>;
  parentOrganizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
};

export type User_SearchOrganizationalUnitsRequest = {
  __typename?: 'user_SearchOrganizationalUnitsRequest';
  clinicId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  /**
   * If this is set to true, the parent department of each unit will be included in the response.
   *  If the departmentId parent_filter is set, that department will be returned, else the default parent.
   */
  includeParentDepartment?: Maybe<Scalars['Boolean']>;
  /**
   * If this is set to true, the parent division of each unit will be included in the response.
   *  If the departmentId parent_filter is set, the parent of that department will be returned,
   *  else the division of the default parent.
   */
  includeParentDivision?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  /** optional filter */
  type?: Maybe<User_OrganizationalUnitType>;
};

export type User_SearchOrganizationalUnitsResponse = {
  __typename?: 'user_SearchOrganizationalUnitsResponse';
  results?: Maybe<Array<Maybe<User_OrganizationalUnitSearchResultMsg>>>;
};

export type User_SearchRolesRequest = {
  __typename?: 'user_SearchRolesRequest';
  searchText?: Maybe<Scalars['String']>;
};

export type User_SearchRolesResponse = {
  __typename?: 'user_SearchRolesResponse';
  roles?: Maybe<Array<Maybe<User_RoleMsg>>>;
};

export type User_SearchUsersRequest = {
  __typename?: 'user_SearchUsersRequest';
  clinicId?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['String']>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  /** Only relevant if administrative unit filter set; if true, rank by unit instead of filtering */
  rankByUnit?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  /** D-Arzt filter */
  userShouldHaveIk?: Maybe<Scalars['Boolean']>;
};

export type User_SignInRequest = {
  __typename?: 'user_SignInRequest';
  password?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type User_SimpleAdministrativeUnitList = {
  __typename?: 'user_SimpleAdministrativeUnitList';
  administrativeUnits?: Maybe<Array<Maybe<User_SimpleAdministrativeUnitMsg>>>;
};

/**
 * This message is designed to use in data loaders.
 * It's used to load necessary fields of administrative units
 */
export type User_SimpleAdministrativeUnitMsg = {
  __typename?: 'user_SimpleAdministrativeUnitMsg';
  externalIds?: Maybe<Array<Maybe<User_ExternalUnitIdMsg>>>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Core_AdministrativeUnitType>;
  unitId?: Maybe<Scalars['String']>;
};

export enum User_SpecialAccessTargetType {
  SpecialAccessTargetTypeNone = 'SPECIAL_ACCESS_TARGET_TYPE_NONE',
  SpecialAccessTargetTypePatient = 'SPECIAL_ACCESS_TARGET_TYPE_PATIENT'
}

/** Allows fine-grained customization of a user's permissions beyond the role */
export type User_SpecialPermissionMsg = {
  __typename?: 'user_SpecialPermissionMsg';
  accessPermission?: Maybe<User_AccessPermission>;
  id?: Maybe<Scalars['String']>;
  /**
   * true  = permission is added
   *  false = permission is denied even if it would be granted by the user's role
   */
  positive?: Maybe<Scalars['Boolean']>;
  scope?: Maybe<Core_AdministrativeUnitReferenceMsg>;
  target?: Maybe<User_PermissionTarget>;
};

export type User_TokenMsg = {
  __typename?: 'user_TokenMsg';
  token?: Maybe<Scalars['String']>;
};

/**
 * new associated units, must be given in parentIds or childrenIds
 *  along with relevant flags being set to true: updateParents, updateChildren, updateDefaultParent
 *  Previous children and parents will be cleaned. Should they be kept, they must also be given in the list of parentIds or childrenIds
 *  new default parent id should be given inside administrative unit if updateDefaultParent flag is set to true
 */
export type User_UpdateAdministrativeUnitRequest = {
  __typename?: 'user_UpdateAdministrativeUnitRequest';
  administrativeUnit?: Maybe<User_AdministrativeUnitMsg>;
  childrenIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** When returning the updated unit */
  includeHierarchy?: Maybe<Scalars['Boolean']>;
  parentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updateChildren?: Maybe<Scalars['Boolean']>;
  updateDefaultParent?: Maybe<Scalars['Boolean']>;
  updateParents?: Maybe<Scalars['Boolean']>;
};

export type User_UpdateCurrentOrganizationalUnitRequest = {
  __typename?: 'user_UpdateCurrentOrganizationalUnitRequest';
  /**
   * if not set, the default department of the provided organizationalUnit is set if the user is assigned to it;
   *  else any department the user is assigned to that is a parent of the provided organizational unit is set.
   */
  departmentId?: Maybe<Scalars['String']>;
  /** mandatory */
  organizationalUnitId?: Maybe<Scalars['String']>;
};

export type User_UpdateCurrentOrganizationalUnitResponse = {
  __typename?: 'user_UpdateCurrentOrganizationalUnitResponse';
  token?: Maybe<User_TokenMsg>;
  user?: Maybe<User_UserMsg>;
};

export type User_UpdateDepartmentRequest = {
  __typename?: 'user_UpdateDepartmentRequest';
  department?: Maybe<User_DepartmentMsg>;
  divisionId?: Maybe<Scalars['String']>;
  updateParent?: Maybe<Scalars['Boolean']>;
};

export type User_UpdateDivisionRequest = {
  __typename?: 'user_UpdateDivisionRequest';
  clinicId?: Maybe<Scalars['String']>;
  division?: Maybe<User_DivisionMsg>;
  updateParent?: Maybe<Scalars['Boolean']>;
};

export type User_UpdateExternalUserIdRequest = {
  __typename?: 'user_UpdateExternalUserIdRequest';
  /** Currently, only allowed type is LANR */
  externalId?: Maybe<User_ExternalUserIdMsg>;
  /** If set to true, any external ids in the given user of externalId.type will be removed */
  remove?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type User_UpdateOfficeHourRequest = {
  __typename?: 'user_UpdateOfficeHourRequest';
  officeHour?: Maybe<User_OfficeHourMsg>;
  organizationalUnitId?: Maybe<Scalars['String']>;
  updateOrganizationalUnit?: Maybe<Scalars['Boolean']>;
};

export type User_UpdateOrganizationalUnitRequest = {
  __typename?: 'user_UpdateOrganizationalUnitRequest';
  defaultDepartmentId?: Maybe<Scalars['String']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalUnit?: Maybe<User_OrganizationalUnitMsg>;
  updateDefaultParent?: Maybe<Scalars['Boolean']>;
  updateParents?: Maybe<Scalars['Boolean']>;
};

export type User_UpdateRoleRequest = {
  __typename?: 'user_UpdateRoleRequest';
  role?: Maybe<User_RoleMsg>;
};

export type User_UpdateUserPasswordRequest = {
  __typename?: 'user_UpdateUserPasswordRequest';
  newPassword?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type User_UpdateUserPermissionsRequest = {
  __typename?: 'user_UpdateUserPermissionsRequest';
  permissions?: Maybe<Array<Maybe<User_RoleScopeMappingMsg>>>;
  /**
   * If set to true, the role scope mappings are persisted as provided in this request. By default, the roles are scoped
   *  to all scopes where the respective user has any roles.
   */
  useProvidedRoleScopes?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type User_UpdateUserPermissionsResponse = {
  __typename?: 'user_UpdateUserPermissionsResponse';
  token?: Maybe<User_TokenMsg>;
  user?: Maybe<User_UserMsg>;
};

export type User_UserMsg = {
  __typename?: 'user_UserMsg';
  clinics?: Maybe<Array<Maybe<User_ClinicMsg>>>;
  contact?: Maybe<Core_ContactMsg>;
  /**
   * The administrative units connected to the organizational unit for which the user is currently signed in;
   *  required for authorization
   */
  currentAdministrativeUnitIds?: Maybe<Core_AdministrativeUnitMappingMsg>;
  /** The department for which the user is currently signed in */
  currentDepartmentId?: Maybe<Scalars['String']>;
  /** The organizational unit for which the user is currently signed in */
  currentOrganizationalUnitId?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Timestamp>;
  departments?: Maybe<Array<Maybe<User_DepartmentMsg>>>;
  divisions?: Maybe<Array<Maybe<User_DivisionMsg>>>;
  externalIds?: Maybe<Array<Maybe<User_ExternalUserIdMsg>>>;
  /** Used to provide frontend with an easy way of checking authorization of a user */
  flatPermissions?: Maybe<Array<Maybe<User_FlatPermissionMsg>>>;
  id?: Maybe<Scalars['String']>;
  medicalPosition?: Maybe<Scalars['String']>;
  name?: Maybe<Core_HumanNameMsg>;
  organizationalPosition?: Maybe<Scalars['String']>;
  organizationalUnits?: Maybe<Array<Maybe<User_OrganizationalUnitMsg>>>;
  permissions?: Maybe<Array<Maybe<User_RoleScopeMappingMsg>>>;
  qualifications?: Maybe<Array<Maybe<Patient_MedicalQualificationMsg>>>;
  sex?: Maybe<Core_Sex>;
  specialPermissions?: Maybe<Array<Maybe<User_SpecialPermissionMsg>>>;
  systemUser?: Maybe<Scalars['Boolean']>;
  useExternalAuthentication?: Maybe<Scalars['Boolean']>;
  userName?: Maybe<Scalars['String']>;
};

export type User_UserResultList = {
  __typename?: 'user_UserResultList';
  users?: Maybe<Array<Maybe<User_UserMsg>>>;
};

/** Represents an inconsistent state */
export type Validation_ConsistencyIssueMsg = {
  __typename?: 'validation_ConsistencyIssueMsg';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Validation_ConsistencyStatus>;
};

export enum Validation_ConsistencyStatus {
  ConsistencyError = 'CONSISTENCY_ERROR',
  ConsistencyOk = 'CONSISTENCY_OK',
  ConsistencyWarning = 'CONSISTENCY_WARNING'
}

export enum Validation_ExternalValidator {
  ExternalValidatorNone = 'EXTERNAL_VALIDATOR_NONE',
  /** GKV */
  ExternalValidatorStatutoryHealthInsurance = 'EXTERNAL_VALIDATOR_STATUTORY_HEALTH_INSURANCE'
}

export type Validation_ValidationIssueMsg = {
  __typename?: 'validation_ValidationIssueMsg';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Validation_ValidationStatus>;
};

/** This message is used as part of other messages to contain information about validation by a user */
export type Validation_ValidationMsg = {
  __typename?: 'validation_ValidationMsg';
  externalValidator?: Maybe<Validation_ExternalValidator>;
  id?: Maybe<Scalars['String']>;
  /** The action type which made the validation end up in the current state */
  reset?: Maybe<Scalars['Boolean']>;
  validatedAt?: Maybe<Timestamp>;
  /** ID of the treatment in which the block was last validated */
  validatedInTreatmentId?: Maybe<Scalars['String']>;
  /** ID of the visit in which the block was last validated */
  validatedInVisitId?: Maybe<Scalars['String']>;
  /** ID of the user who made the validation */
  validatorId?: Maybe<Scalars['String']>;
  /** Organizational unit the user is in at the moment of validation */
  validatorOrganizationalUnitId?: Maybe<Scalars['String']>;
};

export type Validation_ValidationResultMsg = {
  __typename?: 'validation_ValidationResultMsg';
  consistencyIssues?: Maybe<Array<Maybe<Validation_ConsistencyIssueMsg>>>;
  validationIssues?: Maybe<Array<Maybe<Validation_ValidationIssueMsg>>>;
};

export enum Validation_ValidationStatus {
  ValidationError = 'VALIDATION_ERROR',
  ValidationNone = 'VALIDATION_NONE',
  ValidationOk = 'VALIDATION_OK',
  ValidationWarning = 'VALIDATION_WARNING'
}

export type Versioning_RevisionInfoMsg = {
  __typename?: 'versioning_RevisionInfoMsg';
  currentStatusEntry?: Maybe<Versioning_RevisionStatusEntryMsg>;
  /**
   * if this revision group already has a revision that is being edited and that revision is not this one,
   *  then this field is set and represents the currentStatusEntry of that exclusive editable revision.
   *  => if this field is set, create calls with this revisionGroupId as a source will fail = this revisionGroup is locked
   */
  exclusivelyEditableRevision?: Maybe<Versioning_RevisionInfoMsg>;
  groupCreatorId?: Maybe<Scalars['String']>;
  historicStatusEntries?: Maybe<Array<Maybe<Versioning_RevisionStatusEntryMsg>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  revisionCreationTimestamp?: Maybe<Timestamp>;
  revisionGroupCreationTimestamp?: Maybe<Timestamp>;
  revisionGroupId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Timestamp>;
};

export type Versioning_RevisionSourceMsg = {
  __typename?: 'versioning_RevisionSourceMsg';
  new?: Maybe<Scalars['Boolean']>;
  revisionGroupId?: Maybe<Scalars['String']>;
};

export enum Versioning_RevisionStatus {
  RevisionStatusActive = 'REVISION_STATUS_ACTIVE',
  RevisionStatusDisabled = 'REVISION_STATUS_DISABLED',
  RevisionStatusEditable = 'REVISION_STATUS_EDITABLE',
  RevisionStatusNone = 'REVISION_STATUS_NONE'
}

export type Versioning_RevisionStatusEntryMsg = {
  __typename?: 'versioning_RevisionStatusEntryMsg';
  organizationalUnitId?: Maybe<Scalars['String']>;
  status?: Maybe<Versioning_RevisionStatus>;
  timestamp?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export type Versioning_VersionInfoMsg = {
  __typename?: 'versioning_VersionInfoMsg';
  currentStatusEntry?: Maybe<Versioning_VersionStatusEntryMsg>;
  /**
   * if this version group can only have one editable version at a time,
   *  and such a version exists but is not this one,
   *  then this field is set and represents the currentStatusEntry of that exclusive editable version.
   *  => if this field is set, update calls or create calls with this versionGroupId as a source will fail = this versionGroup is locked
   */
  exclusivelyEditableVersion?: Maybe<Versioning_VersionInfoMsg>;
  historicStatusEntries?: Maybe<Array<Maybe<Versioning_VersionStatusEntryMsg>>>;
  revisionInfo?: Maybe<Versioning_RevisionInfoMsg>;
  versionCreationTimestamp?: Maybe<Timestamp>;
  versionGroupId?: Maybe<Scalars['String']>;
};

export type Versioning_VersionSourceMsg = {
  __typename?: 'versioning_VersionSourceMsg';
  new?: Maybe<Scalars['Boolean']>;
  revisionGroupId?: Maybe<Scalars['String']>;
  versionGroup?: Maybe<Versioning_VersionSourceVersionGroupMsg>;
};

export type Versioning_VersionSourceVersionGroupMsg = {
  __typename?: 'versioning_VersionSourceVersionGroupMsg';
  /**
   * optional, if specified the new group version is created based
   *  on this instance version
   */
  revisionGroupId?: Maybe<Scalars['String']>;
  versionGroupId?: Maybe<Scalars['String']>;
};

export enum Versioning_VersionStatus {
  VersionStatusActive = 'VERSION_STATUS_ACTIVE',
  VersionStatusCancelled = 'VERSION_STATUS_CANCELLED',
  VersionStatusEditable = 'VERSION_STATUS_EDITABLE',
  VersionStatusNone = 'VERSION_STATUS_NONE'
}

export type Versioning_VersionStatusEntryMsg = {
  __typename?: 'versioning_VersionStatusEntryMsg';
  organizationalUnitId?: Maybe<Scalars['String']>;
  status?: Maybe<Versioning_VersionStatus>;
  timestamp?: Maybe<Timestamp>;
  userId?: Maybe<Scalars['String']>;
};

export type Versioning_VersionedEntityCreationParametersMsg = {
  __typename?: 'versioning_VersionedEntityCreationParametersMsg';
  /**
   * If there are editable revisions by other users for the revision groupId,
   * cancel the revision, losing the information not yet saved in that revision
   * this flag must not be set together with takeOverEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  cancelEditable?: Maybe<Scalars['Boolean']>;
  /**
   * If there are editable revisions by other users for the revision groupId,
   * take over the revision, keeping the information not yet saved in that revision
   * this flag must not be set together with cancelEditable
   * these flags should also not be set if this call did not give out an EXISTING_REVISION error beforehand
   */
  takeOverEditable?: Maybe<Scalars['Boolean']>;
  /**
   * When creating a new editable revision for a version and
   * the creator of the version is not this user, then the version must be taken over.
   * This action would push a new status entry to the VersionedEntity, changing the user to the current one.
   * This is a prerequisite if the current user wants to edit this version.(Wound Control in this context)
   * Only relevant if version source is revisionGroupId.
   */
  takeOverVersion?: Maybe<Scalars['Boolean']>;
};

export enum Versioning_VersioningDirection {
  VersioningDirectionNone = 'VERSIONING_DIRECTION_NONE',
  VersioningDirectionRevision = 'VERSIONING_DIRECTION_REVISION',
  VersioningDirectionVersion = 'VERSIONING_DIRECTION_VERSION'
}

export type AppointmentHistoryEventFragment = { __typename?: 'resource_AppointmentHistoryEventMsg', eventType?: Resource_AppointmentHistoryEventType | null, actionType?: Resource_AppointmentRequestActionType | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, timestamp?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null } | null };

export type GetAppointmentHistoryQueryVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetAppointmentHistoryQuery = { __typename?: 'QueryType', getAppointmentHistory?: { __typename?: 'patientportal_GetAppointmentHistoryProxyResponse', clinicId?: string | null, response?: { __typename?: 'resource_GetAppointmentHistoryResponse', events?: Array<{ __typename?: 'resource_AppointmentHistoryEventMsg', eventType?: Resource_AppointmentHistoryEventType | null, actionType?: Resource_AppointmentRequestActionType | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, timestamp?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null } | null } | null> | null } | null } | null };

export type AppointmentRequesterReferenceFragment = { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null };

export type AppointmentRequestEventHistoryFragment = { __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null };

export type AppointmentSlotProposalFragment = { __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null };

export type AppointmentRequestPreferenceTimeFrameFragment = { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type AppointmentRequestPreferencesFragment = { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null };

export type AppointmentRequestAgreementFragment = { __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null };

export type AppointmentRequestFragment = { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null };

export type GetAppointmentRequestQueryVariables = Exact<{
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentRequestQuery = { __typename?: 'QueryType', getAppointmentRequest?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type ProxyAppointmentRequestFragment = { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null };

export type ListPortalUserAppointmentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPortalUserAppointmentRequestsQuery = { __typename?: 'QueryType', listPortalUserAppointmentRequests?: { __typename?: 'patientportal_AppointmentRequestProxyList', proxyAppointmentRequests?: Array<{ __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type SubmitAppointmentRequestMutationVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentRequest?: InputMaybe<Input_Resource_CreateAppointmentRequestRequest>;
  appointmentRequestId?: InputMaybe<Scalars['String']>;
}>;


export type SubmitAppointmentRequestMutation = { __typename?: 'MutationType', submitAppointmentRequest?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type CreateAppointmentRequestMutationVariables = Exact<{
  clinicId: Scalars['String'];
  portalUserId: Scalars['String'];
  appointmentRequest?: InputMaybe<Input_Resource_AppointmentRequestMsg>;
}>;


export type CreateAppointmentRequestMutation = { __typename?: 'MutationType', createAppointmentRequest?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, portalUserId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type CancelAppointmentRequestMutationVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentRequestId: Scalars['String'];
  reasonsForCancellation?: InputMaybe<Array<InputMaybe<Input_Core_KnowledgeInputMsg>> | InputMaybe<Input_Core_KnowledgeInputMsg>>;
}>;


export type CancelAppointmentRequestMutation = { __typename?: 'MutationType', cancelAppointmentRequest?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type AcceptAppointmentProposalMutationVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentSlotProposalId: Scalars['String'];
  portalUserId: Scalars['String'];
}>;


export type AcceptAppointmentProposalMutation = { __typename?: 'MutationType', acceptAppointmentProposal?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type RejectAppointmentProposalsMutationVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentRequestId: Scalars['String'];
}>;


export type RejectAppointmentProposalsMutation = { __typename?: 'MutationType', rejectAppointmentProposals?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type UpdateAppointmentRequestMutationVariables = Exact<{
  clinicId: Scalars['String'];
  portalUserId: Scalars['String'];
  appointmentRequest: Input_Resource_AppointmentRequestMsg;
}>;


export type UpdateAppointmentRequestMutation = { __typename?: 'MutationType', updateAppointmentRequest?: { __typename?: 'patientportal_AppointmentRequestProxyMsg', clinicId?: string | null, appointmentRequest?: { __typename?: 'resource_AppointmentRequestMsg', id?: string | null, unverified?: boolean | null, officeHourId?: string | null, portalUserId?: string | null, patientId?: string | null, actionType?: Resource_AppointmentRequestActionType | null, formIds?: Array<string | null> | null, comment?: string | null, status?: Resource_AppointmentRequestStatus | null, priority?: number | null, reasonForArchiving?: string | null, appointmentSlotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, requester?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, requestPreferences?: { __typename?: 'resource_AppointmentRequestPreferencesMsg', id?: string | null, freeText?: string | null, location?: Resource_AppointmentLocation | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, exactTimeSlot?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, insideTimeFrame?: { __typename?: 'resource_AppointmentRequestPreferencesMsg_TimeSlotMsg', end?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, start?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentRequestEventMsg', id?: string | null, requestActionType?: Resource_AppointmentRequestActionType | null, requestStatus?: Resource_AppointmentRequestStatus | null, requesterReference?: { __typename?: 'resource_AppointmentRequesterReferenceMsg', referenceId?: string | null, requesterType?: Resource_AppointmentRequesterType | null } | null, slotProposals?: Array<{ __typename?: 'resource_AppointmentSlotProposalMsg', id?: string | null, status?: Resource_AppointmentSlotProposalStatus | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, proposedAppointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null } | null } | null> | null, timestamps?: { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null> | null, reasonsForRejection?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForRejectionExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, agreements?: Array<{ __typename?: 'resource_AppointmentRequestAgreementMsg', id?: string | null, accepted?: boolean | null, template?: { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type GetAvailableAppointmentSlotsQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request: Input_Resource_GetAvailableAppointmentTimesRequest;
}>;


export type GetAvailableAppointmentSlotsQuery = { __typename?: 'QueryType', getAvailableAppointmentSlots?: { __typename?: 'resource_AppointmentTimeFrameList', appointmentTimeFrames?: Array<{ __typename?: 'resource_AppointmentTimeFrameMsg', officeHourId?: string | null, appointmentTypeId?: string | null, patientBookableAppointment?: boolean | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null };

export type GetAppointmentFormReferenceBlacklistQueryVariables = Exact<{
  clinicId: Scalars['String'];
  officeHourId: Scalars['String'];
}>;


export type GetAppointmentFormReferenceBlacklistQuery = { __typename?: 'QueryType', getAppointmentFormReferenceBlacklist?: { __typename?: 'patientportal_GetAppointmentFormReferenceBlacklistProxyResponse', formReferenceBlacklist?: string | null } | null };

export type GetAvailableAppointmentDatesQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request: Input_Resource_GetAvailableAppointmentTimesRequest;
}>;


export type GetAvailableAppointmentDatesQuery = { __typename?: 'QueryType', getAvailableAppointmentDates?: { __typename?: 'resource_DateList', dates?: Array<{ __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null> | null } | null };

export type GetAppointmentQueryVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetAppointmentQuery = { __typename?: 'QueryType', getAppointment?: { __typename?: 'patientportal_AppointmentProxyMsg', clinicId?: string | null, appointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type CancelAppointmentMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request: Input_Resource_CancelAppointmentOrSeriesRequest;
  portalUserId: Scalars['String'];
}>;


export type CancelAppointmentMutation = { __typename?: 'MutationType', cancelAppointment?: { __typename?: 'patientportal_AppointmentProxyMsg', clinicId?: string | null, appointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null };

export type GetAppointmentTaskQueryVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentTaskId: Scalars['String'];
}>;


export type GetAppointmentTaskQuery = { __typename?: 'QueryType', getAppointmentTask?: { __typename?: 'patientportal_AppointmentTaskProxyMsg', clinicId?: string | null, appointmentTask?: { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null } | null };

export type ListAppointmentTasksQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request: Input_Resource_ListAppointmentTasksRequest;
}>;


export type ListAppointmentTasksQuery = { __typename?: 'QueryType', listAppointmentTasks?: { __typename?: 'patientportal_ListAppointmentTasksProxyResponse', proxyAppointmentTasks?: Array<{ __typename?: 'patientportal_AppointmentTaskProxyMsg', clinicId?: string | null, appointmentTask?: { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null };

export type UpdateAppointmentTaskStatusMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request: Input_Resource_UpdateAppointmentTaskStatusRequest;
}>;


export type UpdateAppointmentTaskStatusMutation = { __typename?: 'MutationType', updateAppointmentTaskStatus?: { __typename?: 'patientportal_AppointmentTaskProxyMsg', clinicId?: string | null, appointmentTask?: { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null } | null };

export type UpdateAppointmentTaskResultMutationVariables = Exact<{
  clinicId: Scalars['String'];
  portalUserId: Scalars['String'];
  appointmentTaskId: Scalars['String'];
  newResultReferences: Array<Input_Resource_AppointmentTaskResultReferenceMsg> | Input_Resource_AppointmentTaskResultReferenceMsg;
}>;


export type UpdateAppointmentTaskResultMutation = { __typename?: 'MutationType', updateAppointmentTaskResult?: { __typename?: 'patientportal_AppointmentTaskProxyMsg', clinicId?: string | null, appointmentTask?: { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null } | null };

export type GetAppointmentFormTemplateIdQueryVariables = Exact<{
  clinicId: Scalars['String'];
  officeHourId: Scalars['String'];
}>;


export type GetAppointmentFormTemplateIdQuery = { __typename?: 'QueryType', getAppointmentFormTemplateVersioningGroupId?: { __typename?: 'patientportal_GetAppointmentFormTemplateVersioningGroupIdProxyResponse', formTemplateVersioningGroupId?: string | null } | null };

export type AppointmentTaskProxyFragment = { __typename?: 'patientportal_AppointmentTaskProxyMsg', clinicId?: string | null, appointmentTask?: { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null };

export type AppointmentTaskFragment = { __typename?: 'resource_AppointmentTaskMsg', id?: string | null, dueStage?: Resource_AppointmentTaskDueStage | null, appointmentId?: string | null, type?: Resource_AppointmentTaskType | null, status?: Resource_AppointmentTaskStatus | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, information?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, taskTemplate?: { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null, contentReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null } | null> | null, resultReferences?: Array<{ __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null };

export type AppointmentTaskContentReferenceFragment = { __typename?: 'resource_AppointmentTaskContentReferenceMsg', type?: Resource_AppointmentTaskContentType | null, referenceId?: string | null };

export type AppointmentTaskResultReferenceFragment = { __typename?: 'resource_AppointmentTaskResultReferenceMsg', referenceId?: string | null, type?: Resource_AppointmentTaskResultType | null };

export type UserAssignmentFragment = { __typename?: 'resource_AppointmentHandlerUserAssignmentMsg', visible?: boolean | null, userId?: string | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type AppointmentHandlerFragment = { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null };

export type AppointmentTimeFrameFragment = { __typename?: 'resource_AppointmentTimeFrameMsg', officeHourId?: string | null, appointmentTypeId?: string | null, patientBookableAppointment?: boolean | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type AppointmentProxyFragment = { __typename?: 'patientportal_AppointmentProxyMsg', clinicId?: string | null, appointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null };

export type AppointmentTaskContentTemplateReferenceFragment = { __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null };

export type AppointmentTaskTemplateFragment = { __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null };

export type AppointmentRequestConfigFragment = { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null };

export type AppointmentRequestAgreementTemplateFragment = { __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type AppointmentTypeFragment = { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null };

export type PortalUserAppointmentTypeFragment = { __typename?: 'resource_ListPortalUserAppointmentTypesEntryMsg', bookingState?: Resource_AppointmentTypeBookingState | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, preSubmissionFormTemplateVersioningGroupId?: string | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null };

export type AppointmentBookerReferenceFragment = { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null };

export type AppointmentEventHistoryFragment = { __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null };

export type AppointmentFragment = { __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null };

export type AppointmentSeriesFragment = { __typename?: 'resource_AppointmentSeriesMsg', id?: string | null, title?: string | null, appointments?: Array<{ __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null> | null };

export type GetPortalUserAppointmentsQueryVariables = Exact<{
  statusIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>> | InputMaybe<Resource_AppointmentStatus>>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Resource_AppointmentStatus>> | InputMaybe<Resource_AppointmentStatus>>;
}>;


export type GetPortalUserAppointmentsQuery = { __typename?: 'QueryType', getPortalUserAppointments?: { __typename?: 'patientportal_GetPortalUserAppointmentsProxyResponse', proxyAppointments?: Array<{ __typename?: 'patientportal_AppointmentProxyMsg', clinicId?: string | null, appointment?: { __typename?: 'resource_AppointmentMsg', id?: string | null, unverified?: boolean | null, appointmentSeriesId?: string | null, appointmentStatus?: Resource_AppointmentStatus | null, comment?: string | null, officeHourId?: string | null, visitId?: string | null, editingDisabled?: boolean | null, location?: Resource_AppointmentLocation | null, attendeeCount?: number | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, endTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, handler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, startTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, eventHistory?: Array<{ __typename?: 'resource_AppointmentEventMsg', appointmentStatus?: Resource_AppointmentStatus | null, userReference?: { __typename?: 'resource_AppointmentBookerReferenceMsg', type?: Resource_AppointmentBookerReferenceType | null, referenceId?: string | null } | null, happenedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentStartTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentEndTime?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, reasonsForRebooking?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForForceScheduling?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellation?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null, reasonsForCancellationExternal?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null> | null, requestBasicInfos?: Array<{ __typename?: 'resource_AppointmentRequestBasicInfoMsg', comment?: string | null, id?: string | null, submissionDate?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null> | null } | null, portalFacilityPath?: { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type ProxyAppointmentTypeFragment = { __typename?: 'patientportal_AppointmentTypeProxyMsg', clinicId?: string | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null };

export type PortalUserProxyAppointmentTypeFragment = { __typename?: 'patientportal_ListPortalUserAppointmentTypesEntryProxyMsg', clinicId?: string | null, appointmentType?: { __typename?: 'resource_ListPortalUserAppointmentTypesEntryMsg', bookingState?: Resource_AppointmentTypeBookingState | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, preSubmissionFormTemplateVersioningGroupId?: string | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type ListAppointmentTypesQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Resource_ListPortalUserAppointmentTypesRequest>;
}>;


export type ListAppointmentTypesQuery = { __typename?: 'QueryType', listPortalUserAppointmentTypes?: { __typename?: 'patientportal_ListPortalUserAppointmentTypesProxyResponse', proxyAppointmentTypes?: Array<{ __typename?: 'patientportal_ListPortalUserAppointmentTypesEntryProxyMsg', clinicId?: string | null, appointmentType?: { __typename?: 'resource_ListPortalUserAppointmentTypesEntryMsg', bookingState?: Resource_AppointmentTypeBookingState | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, preSubmissionFormTemplateVersioningGroupId?: string | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type ListPortalUserAppointmentTypesQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Resource_ListPortalUserAppointmentTypesRequest>;
}>;


export type ListPortalUserAppointmentTypesQuery = { __typename?: 'QueryType', listPortalUserAppointmentTypes?: { __typename?: 'patientportal_ListPortalUserAppointmentTypesProxyResponse', proxyAppointmentTypes?: Array<{ __typename?: 'patientportal_ListPortalUserAppointmentTypesEntryProxyMsg', clinicId?: string | null, appointmentType?: { __typename?: 'resource_ListPortalUserAppointmentTypesEntryMsg', bookingState?: Resource_AppointmentTypeBookingState | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, preSubmissionFormTemplateVersioningGroupId?: string | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type ProxyAppointmentHandlerFragment = { __typename?: 'patientportal_AppointmentHandlerProxyMsg', clinicId?: string | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null };

export type ListAppointmentHandlersQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Resource_ListAppointmentHandlersRequest>;
}>;


export type ListAppointmentHandlersQuery = { __typename?: 'QueryType', listAppointmentHandlers?: { __typename?: 'patientportal_AppointmentHandlerProxyList', proxyAppointmentHandlers?: Array<{ __typename?: 'patientportal_AppointmentHandlerProxyMsg', clinicId?: string | null, appointmentHandler?: { __typename?: 'resource_AppointmentHandlerMsg', id?: string | null, title?: string | null } | null } | null> | null } | null };

export type GetAppointmentTypeQueryVariables = Exact<{
  clinicId: Scalars['String'];
  appointmentTypeId: Scalars['String'];
}>;


export type GetAppointmentTypeQuery = { __typename?: 'QueryType', getAppointmentType?: { __typename?: 'patientportal_AppointmentTypeProxyMsg', clinicId?: string | null, appointmentType?: { __typename?: 'resource_AppointmentTypeMsg', id?: string | null, duration?: number | null, granularity?: number | null, handlerSelectable?: boolean | null, officeHourId?: string | null, appointmentLocations?: Array<Resource_AppointmentLocation | null> | null, formTemplateVersioningGroupId?: string | null, preSubmissionFormTemplateVersioningGroupId?: string | null, groupAppointment?: boolean | null, groupAppointmentQuota?: number | null, allowPortalUserCancellation?: boolean | null, allowPortalUserRescheduling?: boolean | null, portalUserCancellationTimeUnit?: TimeUnit | null, portalUserCancellationTimeInterval?: number | null, externalVideoAppointment?: boolean | null, appointmentRequestConfig?: { __typename?: 'resource_AppointmentRequestConfigMsg', appointmentRequestSetting?: Resource_AppointmentRequestSetting | null, autoPrioritySetting?: boolean | null, autoRequestApproval?: boolean | null, autoSlotSelection?: boolean | null, numberOfAutoProposedSlots?: number | null, proposeSlots?: boolean | null, timeoutForProposedSlots?: number | null } | null, appointmentTaskTemplates?: Array<{ __typename?: 'resource_AppointmentTaskTemplateMsg', id?: string | null, officeHourId?: string | null, taskType?: Resource_AppointmentTaskType | null, dueStage?: Resource_AppointmentTaskDueStage | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contentTemplateReferences?: Array<{ __typename?: 'resource_AppointmentTaskContentTemplateReferenceMsg', type?: Resource_AppointmentTaskContentTemplateType | null, referenceId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, name?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, portalDisplayName?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, phoneAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, externalVideoAppointmentNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, agreementTemplates?: Array<{ __typename?: 'resource_AppointmentRequestAgreementTemplateMsg', id?: string | null, mandatory?: boolean | null, description?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type TimestampFragment = { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null };

export type TimestampsFragment = { __typename?: 'TimeMsg', createdAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type TimeOfDayFragment = { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null };

export type TimeFrameFragment = { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null };

export type AddressFragment = { __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null };

export type PhoneNumberFragment = { __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null };

export type EmailFragment = { __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null };

export type ContactFragment = { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null };

export type HumanNameFragment = { __typename?: 'core_HumanNameMsg', id?: string | null, affix?: string | null, firstName?: string | null, lastName?: string | null, maidenName?: string | null, middleNames?: Array<string | null> | null, prefix?: string | null, title?: string | null };

export type LocalizedStringFragment = { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null };

export type KnowledgeInputFragment = { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null };

export type KnowledgeBaseQueryVariables = Exact<{
  request?: InputMaybe<Input_Knowledge_KnowledgeSearchRequest>;
}>;


export type KnowledgeBaseQuery = { __typename?: 'QueryType', searchStandardizedData?: { __typename?: 'knowledge_SearchResultList', results?: Array<{ __typename?: 'knowledge_SearchResult', generalId?: string | null, text?: string | null, configurations?: Array<string | null> | null } | null> | null } | null };

export type AdministrativeUnitReferenceFragment = { __typename?: 'core_AdministrativeUnitReferenceMsg', type?: Core_AdministrativeUnitType | null, unitId?: string | null };

export type LocalDateFragment = { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null };

export type LocalTimeFragment = { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null };

export type LocalDateTimeFragment = { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null };

export type ClinicalRequestIdentifierFragment = { __typename?: 'document_transfer_ClinicalRequestIdentifier', clinicalRequestId?: string | null, clinicalRequestInputTemplateId?: string | null };

export type DocumentTypeExternalIdFragment = { __typename?: 'document_DocumentTypeExternalIdMsg', id?: string | null, type?: Document_DocumentTypeExternalIdType | null, externalId?: string | null };

export type DocumentTypeFragment = { __typename?: 'document_DocumentTypeMsg', id?: string | null, description?: string | null, displayName?: string | null, externalIds?: Array<{ __typename?: 'document_DocumentTypeExternalIdMsg', id?: string | null, type?: Document_DocumentTypeExternalIdType | null, externalId?: string | null } | null> | null };

export type DocumentMetadataFragment = { __typename?: 'document_transfer_DocumentMetadataMsg', formId?: string | null, appointmentTaskId?: string | null, resourceId?: string | null, fileName?: string | null, documentId?: string | null, originalFileName?: string | null, mimeType?: string | null, releasedToPortal?: boolean | null, clinicalRequestIdentifier?: { __typename?: 'document_transfer_ClinicalRequestIdentifier', clinicalRequestId?: string | null, clinicalRequestInputTemplateId?: string | null } | null, timestamp?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, documentClass?: { __typename?: 'document_DocumentTypeMsg', id?: string | null, description?: string | null, displayName?: string | null, externalIds?: Array<{ __typename?: 'document_DocumentTypeExternalIdMsg', id?: string | null, type?: Document_DocumentTypeExternalIdType | null, externalId?: string | null } | null> | null } | null };

export type DocumentMetadataProxyFragment = { __typename?: 'patientportal_DocumentMetadataProxyMsg', clinicId?: string | null, document?: { __typename?: 'document_transfer_DocumentMetadataMsg', formId?: string | null, appointmentTaskId?: string | null, resourceId?: string | null, fileName?: string | null, documentId?: string | null, originalFileName?: string | null, mimeType?: string | null, releasedToPortal?: boolean | null, clinicalRequestIdentifier?: { __typename?: 'document_transfer_ClinicalRequestIdentifier', clinicalRequestId?: string | null, clinicalRequestInputTemplateId?: string | null } | null, timestamp?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, documentClass?: { __typename?: 'document_DocumentTypeMsg', id?: string | null, description?: string | null, displayName?: string | null, externalIds?: Array<{ __typename?: 'document_DocumentTypeExternalIdMsg', id?: string | null, type?: Document_DocumentTypeExternalIdType | null, externalId?: string | null } | null> | null } | null } | null };

export type GetDocumentQueryVariables = Exact<{
  input?: InputMaybe<Input_Patientportal_GetDocumentPortalProxyRequest>;
}>;


export type GetDocumentQuery = { __typename?: 'QueryType', getDocument?: { __typename?: 'patientportal_GetDocumentPortalProxyResponse', document?: { __typename?: 'patientportal_DocumentMetadataProxyMsg', clinicId?: string | null, document?: { __typename?: 'document_transfer_DocumentMetadataMsg', formId?: string | null, appointmentTaskId?: string | null, resourceId?: string | null, fileName?: string | null, documentId?: string | null, originalFileName?: string | null, mimeType?: string | null, releasedToPortal?: boolean | null, clinicalRequestIdentifier?: { __typename?: 'document_transfer_ClinicalRequestIdentifier', clinicalRequestId?: string | null, clinicalRequestInputTemplateId?: string | null } | null, timestamp?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, documentClass?: { __typename?: 'document_DocumentTypeMsg', id?: string | null, description?: string | null, displayName?: string | null, externalIds?: Array<{ __typename?: 'document_DocumentTypeExternalIdMsg', id?: string | null, type?: Document_DocumentTypeExternalIdType | null, externalId?: string | null } | null> | null } | null } | null } | null } | null };

export type GetPortalFacilityPathsQueryVariables = Exact<{
  portalFacilityIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPortalFacilityPathsQuery = { __typename?: 'QueryType', getPortalFacilityPaths?: { __typename?: 'patientportal_GetPortalFacilityPathsResponse', paths?: Array<{ __typename?: 'patientportal_PortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type GetPortalFacilityHierarchyQueryVariables = Exact<{
  rootPortalFacilityId?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
  depth: Scalars['Int'];
}>;


export type GetPortalFacilityHierarchyQuery = { __typename?: 'QueryType', getPortalFacilityHierarchy?: { __typename?: 'patientportal_GetPortalFacilityHierarchyResponse', parentId?: string | null, paths?: Array<{ __typename?: 'patientportal_PortalFacilityHierarchyPathMsg', childIds?: Array<string | null> | null } | null> | null, portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null } | null };

export type OfficeHourPortalFacilityPathFragment = { __typename?: 'patientportal_OfficeHourPortalFacilityPathMsg', portalFacilities?: Array<{ __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null } | null> | null };

export type PortalFacilityQuestionFragment = { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type PortalFacilityAnswerFragment = { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type PortalFacilityFaqEntryFragment = { __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null };

export type PortalFacilityFragment = { __typename?: 'patientportal_PortalFacilityMsg', id?: string | null, clinicId?: string | null, name?: string | null, logoImageId?: string | null, headerImageIds?: Array<string | null> | null, officeHourId?: string | null, showOpeningHours?: boolean | null, showVisitingHours?: boolean | null, dataProtectionInformationUrl?: string | null, shortDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longDescription?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, contactNote?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, openingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHours?: Array<{ __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null } | null> | null, visitingHoursFreeText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, frequentlyAskedQuestions?: Array<{ __typename?: 'patientportal_PortalFacilityFAQEntryMsg', id?: string | null, question?: { __typename?: 'patientportal_PortalFacilityQuestionMsg', id?: string | null, questionText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, answer?: { __typename?: 'patientportal_PortalFacilityAnswerMsg', id?: string | null, fileIds?: Array<string | null> | null, answerText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null> | null };

export type OptionFragment = { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type OptionGroupFragment = { __typename?: 'form_FormOptionGroupMsg', id?: string | null, options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type SearchFormOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
  formDatasetId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type SearchFormOptionsQuery = { __typename?: 'QueryType', searchFormOptions?: { __typename?: 'patientportal_SearchFormOptionsProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_SearchFormOptionsResponse', optionGroups?: Array<{ __typename?: 'form_FormOptionGroupMsg', title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null> | null } | null } | null };

export type ListFormOptionsQueryVariables = Exact<{
  clinicId: Scalars['String'];
  datasetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ListFormOptionsQuery = { __typename?: 'QueryType', listFormOptions?: { __typename?: 'patientportal_ListFormOptionsProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_ListFormOptionsResponse', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type FormQuestionFragment = { __typename?: 'form_FormQuestionMsg', id?: string | null, isDisplayAsRequired?: boolean | null, questionGroupId?: string | null, type?: Form_FormValueType | null, boolean?: { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null } | null, defaultValue?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null, double?: { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null } | null, externalIds?: Array<{ __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null } | null> | null, infoText?: { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null } | null, integer?: { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null } | null, localDate?: { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null } | null, localTime?: { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null } | null, select?: { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null } | null, string?: { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, document?: { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null } | null };

export type FormStringQuestionFragment = { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type FormSelectQuestionFragment = { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null };

export type FormMultiSelectQuestionFragment = { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null };

export type FormMultiKnowledgeQuestionFragment = { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null };

export type FormLocalTimeQuestionFragment = { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null };

export type FormLocalDateTimeQuestionFragment = { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null };

export type FormLocalDateQuestionFragment = { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null };

export type FormKnowledgeQuestionFragment = { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null };

export type DocumentQuestionFragment = { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null };

export type FormIntegerQuestionFragment = { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null };

export type InfoTextFormQuestionFragment = { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null };

export type FormExternalIdFragment = { __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null };

export type FormDoubleQuestionFragment = { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null };

export type ChildAnswerGroupSelectQuestionFragment = { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null };

export type FormBooleanQuestionFragment = { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null };

export type FormSequenceQuestionFragment = { __typename?: 'form_FormSequenceQuestionMsg', id?: string | null, questionId?: string | null, linkedReferences?: Array<{ __typename?: 'form_FormTemplateItemReferenceMsg', id?: string | null } | null> | null };

export type FormValueFragment = { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null };

export type FormBooleanValueFragment = { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null };

export type ChildAnswerGroupSelectFragment = { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null };

export type FormDoubleValueFragment = { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null };

export type FormIntegerValueFragment = { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null };

export type FormKnowledgeValueFragment = { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null };

export type FormLocalDateValueFragment = { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null };

export type FormLocalDateTimeValueFragment = { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null };

export type FormLocalTimeValueFragment = { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null };

export type FormMultiKnowledgeValueFragment = { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null };

export type FormMultiSelectValueFragment = { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null };

export type FormSelectValueFragment = { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null };

export type FormStringValueFragment = { __typename?: 'form_StringFormValueMsg', value?: string | null };

export type FormTimestampValueFragment = { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type FormFragment = { __typename?: 'form_FormMsg', id?: string | null, owningOrganizationalUnitId?: string | null, status?: Form_FormStatus | null, templateId?: string | null, answerGroups?: Array<{ __typename?: 'form_FormAnswerGroupMsg', id?: string | null, parentAnswerGroupId?: string | null, questionGroupId?: string | null, directParentFormId?: string | null, answers?: Array<{ __typename?: 'form_FormAnswerMsg', id?: string | null, answerGroupId?: string | null, isEnabled?: boolean | null, isValid?: boolean | null, questionGroupId?: string | null, questionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, childAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null } | null> | null, context?: { __typename?: 'form_FormContextMsg', identifiers?: Array<{ __typename?: 'form_FormContextIdentifierMsg', contextId?: string | null, type?: Form_FormContextType | null } | null> | null } | null, directChildAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null, sequenceAnswers?: Array<{ __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type FormSequenceAnswerFragment = { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null };

export type FormChildAnswerGroupInfoFragment = { __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null };

export type AnswerGroupFragment = { __typename?: 'form_FormAnswerGroupMsg', id?: string | null, parentAnswerGroupId?: string | null, questionGroupId?: string | null, directParentFormId?: string | null, answers?: Array<{ __typename?: 'form_FormAnswerMsg', id?: string | null, answerGroupId?: string | null, isEnabled?: boolean | null, isValid?: boolean | null, questionGroupId?: string | null, questionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, childAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null };

export type FormAnswerFragment = { __typename?: 'form_FormAnswerMsg', id?: string | null, answerGroupId?: string | null, isEnabled?: boolean | null, isValid?: boolean | null, questionGroupId?: string | null, questionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null };

export type FormContextFragment = { __typename?: 'form_FormContextMsg', identifiers?: Array<{ __typename?: 'form_FormContextIdentifierMsg', contextId?: string | null, type?: Form_FormContextType | null } | null> | null };

export type GetFormSequenceAnswerQueryVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Form_GetFormSequenceAnswerRequest>;
}>;


export type GetFormSequenceAnswerQuery = { __typename?: 'QueryType', getFormSequenceAnswer?: { __typename?: 'patientportal_GetFormSequenceAnswerProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_GetFormSequenceAnswerResponse', question?: { __typename?: 'form_FormQuestionMsg', id?: string | null, isDisplayAsRequired?: boolean | null, questionGroupId?: string | null, type?: Form_FormValueType | null, boolean?: { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null } | null, defaultValue?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null, double?: { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null } | null, externalIds?: Array<{ __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null } | null> | null, infoText?: { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null } | null, integer?: { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null } | null, localDate?: { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null } | null, localTime?: { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null } | null, select?: { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null } | null, string?: { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, document?: { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null } | null } | null, sequenceQuestion?: { __typename?: 'form_FormSequenceQuestionMsg', id?: string | null, questionId?: string | null, linkedReferences?: Array<{ __typename?: 'form_FormTemplateItemReferenceMsg', id?: string | null } | null> | null } | null, sequenceAnswer?: { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null } | null } | null };

export type FindFormSequenceAnswerMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Form_FindFormSequenceAnswerRequest>;
}>;


export type FindFormSequenceAnswerMutation = { __typename?: 'MutationType', findFormSequenceAnswer?: { __typename?: 'patientportal_FindFormSequenceAnswerProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_FindFormSequenceAnswerResponse', sequenceQuestion?: { __typename?: 'form_FormSequenceQuestionMsg', id?: string | null, linkedReferences?: Array<{ __typename?: 'form_FormTemplateItemReferenceMsg', id?: string | null } | null> | null } | null, sequenceAnswer?: { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null, question?: { __typename?: 'form_FormQuestionMsg', id?: string | null, isDisplayAsRequired?: boolean | null, questionGroupId?: string | null, type?: Form_FormValueType | null, boolean?: { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null } | null, defaultValue?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null, double?: { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null } | null, externalIds?: Array<{ __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null } | null> | null, infoText?: { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null } | null, integer?: { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null } | null, localDate?: { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null } | null, localTime?: { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null } | null, select?: { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null } | null, string?: { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, document?: { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null } | null } | null } | null } | null };

export type FindSiblingFormSequenceAnswerMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Form_FindSiblingFormSequenceAnswerRequest>;
}>;


export type FindSiblingFormSequenceAnswerMutation = { __typename?: 'MutationType', findSiblingFormSequenceAnswer?: { __typename?: 'patientportal_FindSiblingFormSequenceAnswerProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_FindSiblingFormSequenceAnswerResponse', siblingQuestion?: { __typename?: 'form_FormQuestionMsg', id?: string | null, isDisplayAsRequired?: boolean | null, questionGroupId?: string | null, type?: Form_FormValueType | null, boolean?: { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null } | null, defaultValue?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null, double?: { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null } | null, externalIds?: Array<{ __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null } | null> | null, infoText?: { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null } | null, integer?: { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null } | null, localDate?: { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null } | null, localTime?: { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null } | null, select?: { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null } | null, string?: { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, document?: { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null } | null } | null, siblingSequenceQuestion?: { __typename?: 'form_FormSequenceQuestionMsg', id?: string | null, questionId?: string | null, linkedReferences?: Array<{ __typename?: 'form_FormTemplateItemReferenceMsg', id?: string | null } | null> | null } | null, siblingSequenceAnswer?: { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null } | null } | null };

export type AnswerFormSequenceQuestionMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Form_AnswerFormSequenceQuestionRequest>;
}>;


export type AnswerFormSequenceQuestionMutation = { __typename?: 'MutationType', answerFormSequenceQuestion?: { __typename?: 'patientportal_AnswerFormSequenceQuestionProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_AnswerFormSequenceQuestionResponse', sequenceAnswer?: { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null, nextSequenceAnswer?: { __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null, nextSequenceQuestion?: { __typename?: 'form_FormSequenceQuestionMsg', id?: string | null, questionId?: string | null, linkedReferences?: Array<{ __typename?: 'form_FormTemplateItemReferenceMsg', id?: string | null } | null> | null } | null, nextQuestion?: { __typename?: 'form_FormQuestionMsg', id?: string | null, isDisplayAsRequired?: boolean | null, questionGroupId?: string | null, type?: Form_FormValueType | null, boolean?: { __typename?: 'form_BooleanFormQuestionMsg', nullable?: boolean | null, longNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, longYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortNoText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, shortYesText?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormQuestionMsg', childQuestionGroupTargetId?: string | null } | null, defaultValue?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null, double?: { __typename?: 'form_DoubleFormQuestionMsg', showSlider?: boolean | null, valueMax?: number | null, valueMin?: number | null, stepSize?: number | null, unitDatasetId?: string | null } | null, externalIds?: Array<{ __typename?: 'form_FormExternalIdMsg', externalId?: string | null, externalIdType?: string | null } | null> | null, infoText?: { __typename?: 'form_InfoTextFormQuestionMsg', _?: string | null } | null, integer?: { __typename?: 'form_IntegerFormQuestionMsg', showSlider?: boolean | null, valueMin?: number | null, valueMax?: number | null, specialMode?: Form_IntegerFormQuestionSpecialMode | null, stepSize?: number | null, unitDatasetId?: string | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormQuestionMsg', knowledgeDataset?: Knowledge_KnowledgeDataset | null, searchable?: boolean | null } | null, localDate?: { __typename?: 'form_LocalDateFormQuestionMsg', _?: string | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormQuestionMsg', _?: string | null } | null, localTime?: { __typename?: 'form_LocalTimeFormQuestionMsg', _?: string | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormQuestionMsg', searchable?: boolean | null, knowledgeDataset?: Knowledge_KnowledgeDataset | null, maxAnswers?: number | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormQuestionMsg', maxAnswers?: number | null, searchable?: boolean | null, datasetId?: string | null } | null, select?: { __typename?: 'form_SelectFormQuestionMsg', datasetId?: string | null, searchable?: boolean | null } | null, string?: { __typename?: 'form_StringFormQuestionMsg', maxCharacters?: number | null, placeholder?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, document?: { __typename?: 'form_DocumentFormQuestionMsg', staticDocumentGroupId?: string | null, maxFileSize?: any | null } | null } | null } | null } | null };

export type CreateFormMutationVariables = Exact<{
  clinicId: Scalars['String'];
  request?: InputMaybe<Input_Form_CreateFormRequest>;
}>;


export type CreateFormMutation = { __typename?: 'MutationType', createForm?: { __typename?: 'patientportal_CreateFormProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_CreateFormResponse', form?: { __typename?: 'form_FormMsg', id?: string | null, owningOrganizationalUnitId?: string | null, status?: Form_FormStatus | null, templateId?: string | null, answerGroups?: Array<{ __typename?: 'form_FormAnswerGroupMsg', id?: string | null, parentAnswerGroupId?: string | null, questionGroupId?: string | null, directParentFormId?: string | null, answers?: Array<{ __typename?: 'form_FormAnswerMsg', id?: string | null, answerGroupId?: string | null, isEnabled?: boolean | null, isValid?: boolean | null, questionGroupId?: string | null, questionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, childAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null } | null> | null, context?: { __typename?: 'form_FormContextMsg', identifiers?: Array<{ __typename?: 'form_FormContextIdentifierMsg', contextId?: string | null, type?: Form_FormContextType | null } | null> | null } | null, directChildAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null, sequenceAnswers?: Array<{ __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null } | null };

export type UpdateFormStatusMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['String']>;
  formId: Scalars['String'];
  status?: InputMaybe<Form_FormStatus>;
}>;


export type UpdateFormStatusMutation = { __typename?: 'MutationType', updateFormStatus?: { __typename?: 'patientportal_UpdateFormStatusProxyResponse', clinicId?: string | null, response?: { __typename?: 'form_UpdateFormStatusResponse', form?: { __typename?: 'form_FormMsg', id?: string | null, owningOrganizationalUnitId?: string | null, status?: Form_FormStatus | null, templateId?: string | null, answerGroups?: Array<{ __typename?: 'form_FormAnswerGroupMsg', id?: string | null, parentAnswerGroupId?: string | null, questionGroupId?: string | null, directParentFormId?: string | null, answers?: Array<{ __typename?: 'form_FormAnswerMsg', id?: string | null, answerGroupId?: string | null, isEnabled?: boolean | null, isValid?: boolean | null, questionGroupId?: string | null, questionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, childAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null } | null> | null, context?: { __typename?: 'form_FormContextMsg', identifiers?: Array<{ __typename?: 'form_FormContextIdentifierMsg', contextId?: string | null, type?: Form_FormContextType | null } | null> | null } | null, directChildAnswerGroupInfo?: Array<{ __typename?: 'form_FormChildAnswerGroupInfoMsg', id?: string | null, answerGroupIds?: Array<string | null> | null, questionGroupId?: string | null, isEnabled?: boolean | null } | null> | null, sequenceAnswers?: Array<{ __typename?: 'form_FormSequenceAnswerMsg', id?: string | null, forwardsState?: Form_FormSequenceAnswerForwardsState | null, hasBackwardsSibling?: boolean | null, sequenceQuestionId?: string | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, value?: { __typename?: 'form_FormValueMsg', boolean?: { __typename?: 'form_BooleanFormValueMsg', value?: boolean | null } | null, childAnswerGroupSelect?: { __typename?: 'form_ChildAnswerGroupSelectFormValueMsg', childAnswerGroupId?: string | null } | null, double?: { __typename?: 'form_DoubleFormValueMsg', value?: number | null, unitOptionId?: string | null } | null, integer?: { __typename?: 'form_IntegerFormValueMsg', unitOptionId?: string | null, value?: number | null } | null, knowledge?: { __typename?: 'form_KnowledgeFormValueMsg', value?: { __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null } | null, localDate?: { __typename?: 'form_LocalDateFormValueMsg', value?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null } | null, localDateTime?: { __typename?: 'form_LocalDateTimeFormValueMsg', value?: { __typename?: 'core_LocalDateTimeMsg', date?: { __typename?: 'core_LocalDateMsg', year?: number | null, day?: number | null, month?: number | null } | null, time?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null } | null, localTime?: { __typename?: 'form_LocalTimeFormValueMsg', value?: { __typename?: 'core_LocalTimeMsg', hour?: number | null, minute?: number | null, nano?: number | null, second?: number | null } | null } | null, multiKnowledge?: { __typename?: 'form_MultiKnowledgeFormValueMsg', values?: Array<{ __typename?: 'core_KnowledgeInputMsg', id?: string | null, generalId?: string | null, text?: string | null } | null> | null } | null, multiSelect?: { __typename?: 'form_MultiSelectFormValueMsg', options?: Array<{ __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null> | null } | null, select?: { __typename?: 'form_SelectFormValueMsg', option?: { __typename?: 'form_FormOptionMsg', id?: string | null, title?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null, subtitle?: { __typename?: 'core_LocalizedStringMsg', id?: string | null, translations?: Array<{ __typename?: 'core_TranslationMsg', locale?: string | null, text?: string | null } | null> | null } | null } | null } | null, string?: { __typename?: 'form_StringFormValueMsg', value?: string | null } | null, timestamp?: { __typename?: 'form_TimestampFormValueMsg', value?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null, document?: { __typename?: 'form_DocumentFormValueMsg', documentId?: string | null } | null } | null } | null> | null, updatedAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null } | null } | null } | null };

export type OpeningHoursFragment = { __typename?: 'patientportal_WeeklyScheduleMsg', id?: string | null, daysOfWeek?: Array<DayOfWeek | null> | null, timeFrame?: { __typename?: 'core_TimeFrameOfDayMsg', end?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null, start?: { __typename?: 'TimeOfDayMsg', hours?: number | null, minutes?: number | null } | null } | null };

export type LegalGuardianFragment = { __typename?: 'patientportal_PortalUserMsg', accountVerificationRequiredForClinicIds?: Array<string | null> | null, id?: string | null, sex?: Core_Sex | null, email?: string | null, name?: { __typename?: 'core_HumanNameMsg', id?: string | null, affix?: string | null, firstName?: string | null, lastName?: string | null, maidenName?: string | null, middleNames?: Array<string | null> | null, prefix?: string | null, title?: string | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, dateOfBirth?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null };

export type PortalUserFragment = { __typename?: 'patientportal_PortalUserMsg', id?: string | null, accountVerificationRequiredForClinicIds?: Array<string | null> | null, verified?: boolean | null, email?: string | null, sex?: Core_Sex | null, dateOfBirth?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, name?: { __typename?: 'core_HumanNameMsg', id?: string | null, affix?: string | null, firstName?: string | null, lastName?: string | null, maidenName?: string | null, middleNames?: Array<string | null> | null, prefix?: string | null, title?: string | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, settings?: { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null } | null };

export type ConfirmableActionFragment = { __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null };

export type LoginMutationVariables = Exact<{
  params?: InputMaybe<Input_Patientportal_SignInPortalUserParamsMsg>;
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
}>;


export type LoginMutation = { __typename?: 'MutationType', signInPortalUser?: { __typename?: 'patientportal_SignInPortalUserResponse', success?: { __typename?: 'patientportal_SignInPortalUserSuccessMsg', token?: string | null, portalUserId?: string | null, encryptedMatrixRecoveryKey?: string | null } | null, confirmableAction?: { __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null } | null } | null };

export type PartiallyConfirmActionMutationVariables = Exact<{
  confirmableActionId: Scalars['String'];
  confirmationProviderIndex: Scalars['Int'];
  confirmationToken: Scalars['String'];
}>;


export type PartiallyConfirmActionMutation = { __typename?: 'MutationType', partiallyConfirmAction?: { __typename?: 'helper_Empty', _?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'MutationType', logOut?: { __typename?: 'helper_Empty', _?: string | null } | null };

export type FindCurrentPortalUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCurrentPortalUserQuery = { __typename?: 'QueryType', findCurrentPortalUser?: { __typename?: 'patientportal_FindCurrentPortalUserResponse', portalUser?: { __typename?: 'patientportal_PortalUserMsg', id?: string | null, accountVerificationRequiredForClinicIds?: Array<string | null> | null, verified?: boolean | null, email?: string | null, sex?: Core_Sex | null, dateOfBirth?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, name?: { __typename?: 'core_HumanNameMsg', id?: string | null, affix?: string | null, firstName?: string | null, lastName?: string | null, maidenName?: string | null, middleNames?: Array<string | null> | null, prefix?: string | null, title?: string | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, settings?: { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null } | null } | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  params?: InputMaybe<Input_Patientportal_UpdatePortalUserPasswordParamsMsg>;
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
}>;


export type UpdatePasswordMutation = { __typename?: 'MutationType', updatePortalUserPassword?: { __typename?: 'patientportal_UpdatePortalUserPasswordResponse', success?: { __typename?: 'helper_Empty', _?: string | null } | null, confirmableAction?: { __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null } | null } | null };

export type CreatePortalUserMutationVariables = Exact<{
  portalUser?: InputMaybe<Input_Patientportal_PortalUserMsg>;
  password: Scalars['String'];
  captchaSolution: Scalars['String'];
  deviceSecretId: Scalars['String'];
  deviceType?: InputMaybe<Patientportal_PortalDeviceType>;
}>;


export type CreatePortalUserMutation = { __typename?: 'MutationType', createPortalUser?: { __typename?: 'patientportal_CreatePortalUserResponse', token?: string | null, thirdPartyCommunicationVerificationConfirmableActions?: Array<{ __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null } | null> | null, portalUser?: { __typename?: 'patientportal_PortalUserMsg', id?: string | null, accountVerificationRequiredForClinicIds?: Array<string | null> | null, verified?: boolean | null, email?: string | null, sex?: Core_Sex | null, dateOfBirth?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, name?: { __typename?: 'core_HumanNameMsg', id?: string | null, affix?: string | null, firstName?: string | null, lastName?: string | null, maidenName?: string | null, middleNames?: Array<string | null> | null, prefix?: string | null, title?: string | null } | null, contact?: { __typename?: 'core_ContactMsg', id?: string | null, addresses?: Array<{ __typename?: 'core_AddressMsg', id?: string | null, primary?: boolean | null, city?: string | null, countryCode?: string | null, houseNumber?: string | null, street?: string | null, zipCode?: string | null, co?: string | null, precinct?: string | null, additional?: string | null, municipalKey?: string | null } | null> | null, landlineNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, faxNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, mobileNumbers?: Array<{ __typename?: 'core_PhoneNumberMsg', id?: string | null, countryCode?: number | null, number?: any | null, type?: Core_PhoneNumberType | null } | null> | null, emails?: Array<{ __typename?: 'core_EmailMsg', id?: string | null, email?: string | null, primary?: boolean | null } | null> | null } | null, settings?: { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null } | null } | null } | null };

export type VerifyThirdPartyCommunicationMutationVariables = Exact<{
  params?: InputMaybe<Input_Patientportal_VerifyThirdPartyCommunicationParamsMsg>;
  actionConfirmation?: InputMaybe<Input_Patientportal_ActionConfirmationMsg>;
}>;


export type VerifyThirdPartyCommunicationMutation = { __typename?: 'MutationType', verifyThirdPartyCommunication?: { __typename?: 'patientportal_VerifyThirdPartyCommunicationResponse', confirmableAction?: { __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null } | null, success?: { __typename?: 'patientportal_VerifyThirdPartyCommunicationSuccessMsg', token?: string | null } | null } | null };

export type RenotifyConfirmationProviderMutationVariables = Exact<{
  confirmableActionId: Scalars['String'];
  actionToken: Scalars['String'];
  confirmationProviderIndex: Scalars['Int'];
}>;


export type RenotifyConfirmationProviderMutation = { __typename?: 'MutationType', renotifyConfirmationProvider?: { __typename?: 'patientportal_RenotifyConfirmationProviderResponse', _?: string | null } | null };

export type PreparePasswordResetMutationVariables = Exact<{
  input?: InputMaybe<Input_Patientportal_PreparePasswordResetRequest>;
}>;


export type PreparePasswordResetMutation = { __typename?: 'MutationType', preparePasswordReset?: { __typename?: 'patientportal_PreparePasswordResetResponse', success?: { __typename?: 'patientportal_PreparePasswordResetSuccessMsg', passwordResetToken?: string | null } | null, confirmableAction?: { __typename?: 'patientportal_ConfirmableActionMsg', id?: string | null, actionToken?: string | null, expiresAt?: { __typename?: 'Timestamp', seconds?: any | null, nanos?: number | null } | null, confirmationProviders?: Array<{ __typename?: 'patientportal_ConfirmationProviderMsg', name?: string | null, type?: Patientportal_ConfirmationProviderType | null, email?: { __typename?: 'patientportal_ConfirmationProviderEmailMsg', emailAddress?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null, sms?: { __typename?: 'patientportal_ConfirmationProviderSmsMsg', phoneNumber?: string | null, confirmationTokenMode?: Patientportal_ConfirmationTokenMode | null, confirmationCodeInfo?: { __typename?: 'patientportal_ConfirmationCodeInfoMsg', type?: Patientportal_ConfirmationCodeType | null, length?: number | null } | null } | null } | null> | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  passwordResetToken: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'MutationType', resetPassword?: { __typename?: 'patientportal_ResetPasswordResponse', _?: string | null } | null };

export type PortalAccountSettingsFragment = { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null };

export type UpdatePortalUserSettingsMutationVariables = Exact<{
  input?: InputMaybe<Input_Patientportal_UpdatePortalUserSettingsRequest>;
}>;


export type UpdatePortalUserSettingsMutation = { __typename?: 'MutationType', updatePortalUserSettings?: { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null } | null };

export type GetPortalUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortalUserSettingsQuery = { __typename?: 'QueryType', findCurrentPortalUser?: { __typename?: 'patientportal_FindCurrentPortalUserResponse', portalUser?: { __typename?: 'patientportal_PortalUserMsg', id?: string | null, settings?: { __typename?: 'patientportal_PortalAccountSettingsMsg', accessibilityModeActive?: boolean | null } | null } | null } | null };

export const TimestampFragmentDoc = gql`
    fragment Timestamp on Timestamp {
  seconds
  nanos
}
    `;
export const AppointmentHistoryEventFragmentDoc = gql`
    fragment AppointmentHistoryEvent on resource_AppointmentHistoryEventMsg {
  eventType
  actionType
  startTime {
    ...Timestamp
  }
  endTime {
    ...Timestamp
  }
  timestamp {
    ...Timestamp
  }
  userReference {
    type
  }
}
    ${TimestampFragmentDoc}`;
export const AppointmentHandlerFragmentDoc = gql`
    fragment AppointmentHandler on resource_AppointmentHandlerMsg {
  id
  title
}
    `;
export const AppointmentSlotProposalFragmentDoc = gql`
    fragment AppointmentSlotProposal on resource_AppointmentSlotProposalMsg {
  id
  startTime {
    ...Timestamp
  }
  endTime {
    ...Timestamp
  }
  handler {
    ...AppointmentHandler
  }
  proposedAppointment {
    id
  }
  status
}
    ${TimestampFragmentDoc}
${AppointmentHandlerFragmentDoc}`;
export const AppointmentRequestConfigFragmentDoc = gql`
    fragment AppointmentRequestConfig on resource_AppointmentRequestConfigMsg {
  appointmentRequestSetting
  autoPrioritySetting
  autoRequestApproval
  autoSlotSelection
  numberOfAutoProposedSlots
  proposeSlots
  timeoutForProposedSlots
}
    `;
export const LocalizedStringFragmentDoc = gql`
    fragment LocalizedString on core_LocalizedStringMsg {
  id
  translations {
    locale
    text
  }
}
    `;
export const AppointmentTaskContentTemplateReferenceFragmentDoc = gql`
    fragment AppointmentTaskContentTemplateReference on resource_AppointmentTaskContentTemplateReferenceMsg {
  type
  referenceId
}
    `;
export const AppointmentTaskTemplateFragmentDoc = gql`
    fragment AppointmentTaskTemplate on resource_AppointmentTaskTemplateMsg {
  id
  officeHourId
  title {
    ...LocalizedString
  }
  subtitle {
    ...LocalizedString
  }
  taskType
  contentTemplateReferences {
    ...AppointmentTaskContentTemplateReference
  }
  dueStage
}
    ${LocalizedStringFragmentDoc}
${AppointmentTaskContentTemplateReferenceFragmentDoc}`;
export const AppointmentRequestAgreementTemplateFragmentDoc = gql`
    fragment AppointmentRequestAgreementTemplate on resource_AppointmentRequestAgreementTemplateMsg {
  id
  mandatory
  description {
    ...LocalizedString
  }
}
    ${LocalizedStringFragmentDoc}`;
export const AppointmentTypeFragmentDoc = gql`
    fragment AppointmentType on resource_AppointmentTypeMsg {
  id
  appointmentRequestConfig {
    ...AppointmentRequestConfig
  }
  appointmentTaskTemplates {
    ...AppointmentTaskTemplate
  }
  description {
    ...LocalizedString
  }
  duration
  granularity
  handlerSelectable
  name {
    ...LocalizedString
  }
  portalDisplayName {
    ...LocalizedString
  }
  officeHourId
  appointmentLocations
  formTemplateVersioningGroupId
  preSubmissionFormTemplateVersioningGroupId
  groupAppointment
  groupAppointmentQuota
  allowPortalUserCancellation
  allowPortalUserRescheduling
  portalUserCancellationTimeUnit
  portalUserCancellationTimeInterval
  phoneAppointmentNote {
    ...LocalizedString
  }
  externalVideoAppointment
  externalVideoAppointmentNote {
    ...LocalizedString
  }
  agreementTemplates {
    ...AppointmentRequestAgreementTemplate
  }
}
    ${AppointmentRequestConfigFragmentDoc}
${AppointmentTaskTemplateFragmentDoc}
${LocalizedStringFragmentDoc}
${AppointmentRequestAgreementTemplateFragmentDoc}`;
export const AppointmentBookerReferenceFragmentDoc = gql`
    fragment AppointmentBookerReference on resource_AppointmentBookerReferenceMsg {
  type
  referenceId
}
    `;
export const KnowledgeInputFragmentDoc = gql`
    fragment KnowledgeInput on core_KnowledgeInputMsg {
  id
  generalId
  text
}
    `;
export const AppointmentEventHistoryFragmentDoc = gql`
    fragment AppointmentEventHistory on resource_AppointmentEventMsg {
  userReference {
    ...AppointmentBookerReference
  }
  happenedAt {
    ...Timestamp
  }
  appointmentStartTime {
    ...Timestamp
  }
  appointmentEndTime {
    ...Timestamp
  }
  appointmentHandler {
    ...AppointmentHandler
  }
  appointmentType {
    ...AppointmentType
  }
  appointmentStatus
  reasonsForRebooking {
    ...KnowledgeInput
  }
  reasonsForForceScheduling {
    ...KnowledgeInput
  }
  reasonsForCancellation {
    ...KnowledgeInput
  }
  reasonsForCancellationExternal {
    ...KnowledgeInput
  }
}
    ${AppointmentBookerReferenceFragmentDoc}
${TimestampFragmentDoc}
${AppointmentHandlerFragmentDoc}
${AppointmentTypeFragmentDoc}
${KnowledgeInputFragmentDoc}`;
export const AppointmentFragmentDoc = gql`
    fragment Appointment on resource_AppointmentMsg {
  id
  unverified
  appointmentSeriesId
  appointmentStatus
  appointmentType {
    ...AppointmentType
  }
  comment
  endTime {
    ...Timestamp
  }
  handler {
    ...AppointmentHandler
  }
  officeHourId
  startTime {
    ...Timestamp
  }
  eventHistory {
    ...AppointmentEventHistory
  }
  visitId
  editingDisabled
  location
  attendeeCount
  groupAppointment
  groupAppointmentQuota
  requestBasicInfos {
    comment
    submissionDate {
      ...Timestamp
    }
    id
  }
}
    ${AppointmentTypeFragmentDoc}
${TimestampFragmentDoc}
${AppointmentHandlerFragmentDoc}
${AppointmentEventHistoryFragmentDoc}`;
export const AppointmentRequesterReferenceFragmentDoc = gql`
    fragment AppointmentRequesterReference on resource_AppointmentRequesterReferenceMsg {
  referenceId
  requesterType
}
    `;
export const AppointmentRequestPreferenceTimeFrameFragmentDoc = gql`
    fragment AppointmentRequestPreferenceTimeFrame on resource_AppointmentRequestPreferencesMsg_TimeSlotMsg {
  end {
    ...Timestamp
  }
  start {
    ...Timestamp
  }
}
    ${TimestampFragmentDoc}`;
export const AppointmentRequestPreferencesFragmentDoc = gql`
    fragment AppointmentRequestPreferences on resource_AppointmentRequestPreferencesMsg {
  id
  appointmentHandler {
    ...AppointmentHandler
  }
  freeText
  exactTimeSlot {
    ...AppointmentRequestPreferenceTimeFrame
  }
  insideTimeFrame {
    ...AppointmentRequestPreferenceTimeFrame
  }
  location
}
    ${AppointmentHandlerFragmentDoc}
${AppointmentRequestPreferenceTimeFrameFragmentDoc}`;
export const TimestampsFragmentDoc = gql`
    fragment Timestamps on TimeMsg {
  createdAt {
    ...Timestamp
  }
  updatedAt {
    ...Timestamp
  }
}
    ${TimestampFragmentDoc}`;
export const AppointmentRequestEventHistoryFragmentDoc = gql`
    fragment AppointmentRequestEventHistory on resource_AppointmentRequestEventMsg {
  id
  requestActionType
  requesterReference {
    ...AppointmentRequesterReference
  }
  slotProposals {
    ...AppointmentSlotProposal
  }
  timestamps {
    ...Timestamps
  }
  requestStatus
  timestamps {
    ...Timestamps
  }
}
    ${AppointmentRequesterReferenceFragmentDoc}
${AppointmentSlotProposalFragmentDoc}
${TimestampsFragmentDoc}`;
export const AppointmentRequestAgreementFragmentDoc = gql`
    fragment AppointmentRequestAgreement on resource_AppointmentRequestAgreementMsg {
  id
  accepted
  template {
    ...AppointmentRequestAgreementTemplate
  }
}
    ${AppointmentRequestAgreementTemplateFragmentDoc}`;
export const AppointmentRequestFragmentDoc = gql`
    fragment AppointmentRequest on resource_AppointmentRequestMsg {
  id
  unverified
  officeHourId
  portalUserId
  patientId
  actionType
  formIds
  appointmentSlotProposals {
    ...AppointmentSlotProposal
  }
  appointments {
    ...Appointment
  }
  appointmentType {
    ...AppointmentType
  }
  comment
  requester {
    ...AppointmentRequesterReference
  }
  status
  submissionDate {
    ...Timestamp
  }
  priority
  requestPreferences {
    ...AppointmentRequestPreferences
  }
  eventHistory {
    ...AppointmentRequestEventHistory
  }
  reasonsForRejection {
    ...KnowledgeInput
  }
  reasonsForRejectionExternal {
    ...KnowledgeInput
  }
  reasonsForCancellation {
    ...KnowledgeInput
  }
  submissionDate {
    ...Timestamp
  }
  agreements {
    ...AppointmentRequestAgreement
  }
  reasonForArchiving
}
    ${AppointmentSlotProposalFragmentDoc}
${AppointmentFragmentDoc}
${AppointmentTypeFragmentDoc}
${AppointmentRequesterReferenceFragmentDoc}
${TimestampFragmentDoc}
${AppointmentRequestPreferencesFragmentDoc}
${AppointmentRequestEventHistoryFragmentDoc}
${KnowledgeInputFragmentDoc}
${AppointmentRequestAgreementFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on core_AddressMsg {
  id
  primary
  city
  countryCode
  houseNumber
  street
  zipCode
  co
  precinct
  additional
  municipalKey
}
    `;
export const PhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on core_PhoneNumberMsg {
  id
  countryCode
  number
  type
}
    `;
export const EmailFragmentDoc = gql`
    fragment Email on core_EmailMsg {
  id
  email
  primary
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on core_ContactMsg {
  id
  addresses {
    ...Address
  }
  landlineNumbers {
    ...PhoneNumber
  }
  faxNumbers {
    ...PhoneNumber
  }
  mobileNumbers {
    ...PhoneNumber
  }
  emails {
    ...Email
  }
}
    ${AddressFragmentDoc}
${PhoneNumberFragmentDoc}
${EmailFragmentDoc}`;
export const TimeOfDayFragmentDoc = gql`
    fragment TimeOfDay on TimeOfDayMsg {
  hours
  minutes
}
    `;
export const TimeFrameFragmentDoc = gql`
    fragment TimeFrame on core_TimeFrameOfDayMsg {
  end {
    ...TimeOfDay
  }
  start {
    ...TimeOfDay
  }
}
    ${TimeOfDayFragmentDoc}`;
export const OpeningHoursFragmentDoc = gql`
    fragment OpeningHours on patientportal_WeeklyScheduleMsg {
  id
  daysOfWeek
  timeFrame {
    ...TimeFrame
  }
}
    ${TimeFrameFragmentDoc}`;
export const PortalFacilityQuestionFragmentDoc = gql`
    fragment PortalFacilityQuestion on patientportal_PortalFacilityQuestionMsg {
  id
  questionText {
    ...LocalizedString
  }
}
    ${LocalizedStringFragmentDoc}`;
export const PortalFacilityAnswerFragmentDoc = gql`
    fragment PortalFacilityAnswer on patientportal_PortalFacilityAnswerMsg {
  id
  answerText {
    ...LocalizedString
  }
  fileIds
}
    ${LocalizedStringFragmentDoc}`;
export const PortalFacilityFaqEntryFragmentDoc = gql`
    fragment PortalFacilityFAQEntry on patientportal_PortalFacilityFAQEntryMsg {
  id
  question {
    ...PortalFacilityQuestion
  }
  answer {
    ...PortalFacilityAnswer
  }
}
    ${PortalFacilityQuestionFragmentDoc}
${PortalFacilityAnswerFragmentDoc}`;
export const PortalFacilityFragmentDoc = gql`
    fragment PortalFacility on patientportal_PortalFacilityMsg {
  id
  clinicId
  name
  logoImageId
  shortDescription {
    ...LocalizedString
  }
  longDescription {
    ...LocalizedString
  }
  headerImageIds
  contact {
    ...Contact
  }
  contactNote {
    ...LocalizedString
  }
  officeHourId
  openingHoursFreeText {
    ...LocalizedString
  }
  openingHours {
    ...OpeningHours
  }
  showOpeningHours
  visitingHours {
    ...OpeningHours
  }
  visitingHoursFreeText {
    ...LocalizedString
  }
  showVisitingHours
  dataProtectionInformationUrl
  frequentlyAskedQuestions {
    ...PortalFacilityFAQEntry
  }
}
    ${LocalizedStringFragmentDoc}
${ContactFragmentDoc}
${OpeningHoursFragmentDoc}
${PortalFacilityFaqEntryFragmentDoc}`;
export const OfficeHourPortalFacilityPathFragmentDoc = gql`
    fragment OfficeHourPortalFacilityPath on patientportal_OfficeHourPortalFacilityPathMsg {
  portalFacilities {
    ...PortalFacility
  }
}
    ${PortalFacilityFragmentDoc}`;
export const ProxyAppointmentRequestFragmentDoc = gql`
    fragment ProxyAppointmentRequest on patientportal_AppointmentRequestProxyMsg {
  clinicId
  appointmentRequest {
    ...AppointmentRequest
  }
  portalFacilityPath {
    ...OfficeHourPortalFacilityPath
  }
}
    ${AppointmentRequestFragmentDoc}
${OfficeHourPortalFacilityPathFragmentDoc}`;
export const AppointmentTaskContentReferenceFragmentDoc = gql`
    fragment AppointmentTaskContentReference on resource_AppointmentTaskContentReferenceMsg {
  type
  referenceId
}
    `;
export const AppointmentTaskResultReferenceFragmentDoc = gql`
    fragment AppointmentTaskResultReference on resource_AppointmentTaskResultReferenceMsg {
  referenceId
  type
}
    `;
export const AppointmentTaskFragmentDoc = gql`
    fragment AppointmentTask on resource_AppointmentTaskMsg {
  id
  title {
    ...LocalizedString
  }
  subtitle {
    ...LocalizedString
  }
  information {
    ...LocalizedString
  }
  taskTemplate {
    ...AppointmentTaskTemplate
  }
  dueStage
  appointmentId
  contentReferences {
    ...AppointmentTaskContentReference
  }
  resultReferences {
    ...AppointmentTaskResultReference
  }
  type
  status
  reasonsForCancellationExternal {
    ...KnowledgeInput
  }
}
    ${LocalizedStringFragmentDoc}
${AppointmentTaskTemplateFragmentDoc}
${AppointmentTaskContentReferenceFragmentDoc}
${AppointmentTaskResultReferenceFragmentDoc}
${KnowledgeInputFragmentDoc}`;
export const AppointmentTaskProxyFragmentDoc = gql`
    fragment AppointmentTaskProxy on patientportal_AppointmentTaskProxyMsg {
  clinicId
  appointmentTask {
    ...AppointmentTask
  }
}
    ${AppointmentTaskFragmentDoc}`;
export const UserAssignmentFragmentDoc = gql`
    fragment UserAssignment on resource_AppointmentHandlerUserAssignmentMsg {
  visible
  userId
  startTime {
    ...Timestamp
  }
  endTime {
    ...Timestamp
  }
}
    ${TimestampFragmentDoc}`;
export const AppointmentTimeFrameFragmentDoc = gql`
    fragment AppointmentTimeFrame on resource_AppointmentTimeFrameMsg {
  officeHourId
  appointmentTypeId
  patientBookableAppointment
  handler {
    ...AppointmentHandler
  }
  startTime {
    ...Timestamp
  }
  endTime {
    ...Timestamp
  }
}
    ${AppointmentHandlerFragmentDoc}
${TimestampFragmentDoc}`;
export const AppointmentProxyFragmentDoc = gql`
    fragment AppointmentProxy on patientportal_AppointmentProxyMsg {
  clinicId
  appointment {
    ...Appointment
  }
  portalFacilityPath {
    ...OfficeHourPortalFacilityPath
  }
}
    ${AppointmentFragmentDoc}
${OfficeHourPortalFacilityPathFragmentDoc}`;
export const AppointmentSeriesFragmentDoc = gql`
    fragment AppointmentSeries on resource_AppointmentSeriesMsg {
  id
  title
  appointments {
    ...Appointment
  }
}
    ${AppointmentFragmentDoc}`;
export const ProxyAppointmentTypeFragmentDoc = gql`
    fragment ProxyAppointmentType on patientportal_AppointmentTypeProxyMsg {
  clinicId
  appointmentType {
    ...AppointmentType
  }
}
    ${AppointmentTypeFragmentDoc}`;
export const PortalUserAppointmentTypeFragmentDoc = gql`
    fragment PortalUserAppointmentType on resource_ListPortalUserAppointmentTypesEntryMsg {
  appointmentType {
    id
    appointmentRequestConfig {
      ...AppointmentRequestConfig
    }
    appointmentTaskTemplates {
      ...AppointmentTaskTemplate
    }
    description {
      ...LocalizedString
    }
    duration
    granularity
    handlerSelectable
    name {
      ...LocalizedString
    }
    officeHourId
    appointmentLocations
    formTemplateVersioningGroupId
    groupAppointment
    groupAppointmentQuota
    preSubmissionFormTemplateVersioningGroupId
    agreementTemplates {
      ...AppointmentRequestAgreementTemplate
    }
  }
  bookingState
}
    ${AppointmentRequestConfigFragmentDoc}
${AppointmentTaskTemplateFragmentDoc}
${LocalizedStringFragmentDoc}
${AppointmentRequestAgreementTemplateFragmentDoc}`;
export const PortalUserProxyAppointmentTypeFragmentDoc = gql`
    fragment PortalUserProxyAppointmentType on patientportal_ListPortalUserAppointmentTypesEntryProxyMsg {
  clinicId
  appointmentType {
    ...PortalUserAppointmentType
  }
}
    ${PortalUserAppointmentTypeFragmentDoc}`;
export const ProxyAppointmentHandlerFragmentDoc = gql`
    fragment ProxyAppointmentHandler on patientportal_AppointmentHandlerProxyMsg {
  clinicId
  appointmentHandler {
    ...AppointmentHandler
  }
}
    ${AppointmentHandlerFragmentDoc}`;
export const AdministrativeUnitReferenceFragmentDoc = gql`
    fragment AdministrativeUnitReference on core_AdministrativeUnitReferenceMsg {
  type
  unitId
}
    `;
export const ClinicalRequestIdentifierFragmentDoc = gql`
    fragment ClinicalRequestIdentifier on document_transfer_ClinicalRequestIdentifier {
  clinicalRequestId
  clinicalRequestInputTemplateId
}
    `;
export const DocumentTypeExternalIdFragmentDoc = gql`
    fragment DocumentTypeExternalId on document_DocumentTypeExternalIdMsg {
  id
  type
  externalId
}
    `;
export const DocumentTypeFragmentDoc = gql`
    fragment DocumentType on document_DocumentTypeMsg {
  id
  externalIds {
    ...DocumentTypeExternalId
  }
  description
  displayName
}
    ${DocumentTypeExternalIdFragmentDoc}`;
export const DocumentMetadataFragmentDoc = gql`
    fragment DocumentMetadata on document_transfer_DocumentMetadataMsg {
  clinicalRequestIdentifier {
    ...ClinicalRequestIdentifier
  }
  formId
  appointmentTaskId
  resourceId
  fileName
  timestamp {
    ...Timestamp
  }
  documentId
  originalFileName
  documentClass {
    ...DocumentType
  }
  mimeType
  releasedToPortal
}
    ${ClinicalRequestIdentifierFragmentDoc}
${TimestampFragmentDoc}
${DocumentTypeFragmentDoc}`;
export const DocumentMetadataProxyFragmentDoc = gql`
    fragment DocumentMetadataProxy on patientportal_DocumentMetadataProxyMsg {
  clinicId
  document {
    ...DocumentMetadata
  }
}
    ${DocumentMetadataFragmentDoc}`;
export const OptionFragmentDoc = gql`
    fragment Option on form_FormOptionMsg {
  id
  title {
    ...LocalizedString
  }
  subtitle {
    ...LocalizedString
  }
}
    ${LocalizedStringFragmentDoc}`;
export const OptionGroupFragmentDoc = gql`
    fragment OptionGroup on form_FormOptionGroupMsg {
  id
  options {
    ...Option
  }
  title {
    ...LocalizedString
  }
  subtitle {
    ...LocalizedString
  }
}
    ${OptionFragmentDoc}
${LocalizedStringFragmentDoc}`;
export const FormBooleanQuestionFragmentDoc = gql`
    fragment FormBooleanQuestion on form_BooleanFormQuestionMsg {
  longNoText {
    ...LocalizedString
  }
  longYesText {
    ...LocalizedString
  }
  nullable
  shortNoText {
    ...LocalizedString
  }
  shortYesText {
    ...LocalizedString
  }
}
    ${LocalizedStringFragmentDoc}`;
export const ChildAnswerGroupSelectQuestionFragmentDoc = gql`
    fragment ChildAnswerGroupSelectQuestion on form_ChildAnswerGroupSelectFormQuestionMsg {
  childQuestionGroupTargetId
}
    `;
export const FormBooleanValueFragmentDoc = gql`
    fragment FormBooleanValue on form_BooleanFormValueMsg {
  value
}
    `;
export const ChildAnswerGroupSelectFragmentDoc = gql`
    fragment ChildAnswerGroupSelect on form_ChildAnswerGroupSelectFormValueMsg {
  childAnswerGroupId
}
    `;
export const FormDoubleValueFragmentDoc = gql`
    fragment FormDoubleValue on form_DoubleFormValueMsg {
  value
  unitOptionId
}
    `;
export const FormIntegerValueFragmentDoc = gql`
    fragment FormIntegerValue on form_IntegerFormValueMsg {
  unitOptionId
  value
}
    `;
export const FormKnowledgeValueFragmentDoc = gql`
    fragment FormKnowledgeValue on form_KnowledgeFormValueMsg {
  value {
    ...KnowledgeInput
  }
}
    ${KnowledgeInputFragmentDoc}`;
export const LocalDateFragmentDoc = gql`
    fragment LocalDate on core_LocalDateMsg {
  year
  day
  month
}
    `;
export const FormLocalDateValueFragmentDoc = gql`
    fragment FormLocalDateValue on form_LocalDateFormValueMsg {
  value {
    ...LocalDate
  }
}
    ${LocalDateFragmentDoc}`;
export const LocalTimeFragmentDoc = gql`
    fragment LocalTime on core_LocalTimeMsg {
  hour
  minute
  nano
  second
}
    `;
export const LocalDateTimeFragmentDoc = gql`
    fragment LocalDateTime on core_LocalDateTimeMsg {
  date {
    ...LocalDate
  }
  time {
    ...LocalTime
  }
}
    ${LocalDateFragmentDoc}
${LocalTimeFragmentDoc}`;
export const FormLocalDateTimeValueFragmentDoc = gql`
    fragment FormLocalDateTimeValue on form_LocalDateTimeFormValueMsg {
  value {
    ...LocalDateTime
  }
}
    ${LocalDateTimeFragmentDoc}`;
export const FormLocalTimeValueFragmentDoc = gql`
    fragment FormLocalTimeValue on form_LocalTimeFormValueMsg {
  value {
    ...LocalTime
  }
}
    ${LocalTimeFragmentDoc}`;
export const FormMultiKnowledgeValueFragmentDoc = gql`
    fragment FormMultiKnowledgeValue on form_MultiKnowledgeFormValueMsg {
  values {
    ...KnowledgeInput
  }
}
    ${KnowledgeInputFragmentDoc}`;
export const FormMultiSelectValueFragmentDoc = gql`
    fragment FormMultiSelectValue on form_MultiSelectFormValueMsg {
  options {
    ...Option
  }
}
    ${OptionFragmentDoc}`;
export const FormSelectValueFragmentDoc = gql`
    fragment FormSelectValue on form_SelectFormValueMsg {
  option {
    ...Option
  }
}
    ${OptionFragmentDoc}`;
export const FormStringValueFragmentDoc = gql`
    fragment FormStringValue on form_StringFormValueMsg {
  value
}
    `;
export const FormTimestampValueFragmentDoc = gql`
    fragment FormTimestampValue on form_TimestampFormValueMsg {
  value {
    ...Timestamp
  }
}
    ${TimestampFragmentDoc}`;
export const FormValueFragmentDoc = gql`
    fragment FormValue on form_FormValueMsg {
  boolean {
    ...FormBooleanValue
  }
  childAnswerGroupSelect {
    ...ChildAnswerGroupSelect
  }
  double {
    ...FormDoubleValue
  }
  integer {
    ...FormIntegerValue
  }
  knowledge {
    ...FormKnowledgeValue
  }
  localDate {
    ...FormLocalDateValue
  }
  localDateTime {
    ...FormLocalDateTimeValue
  }
  localTime {
    ...FormLocalTimeValue
  }
  multiKnowledge {
    ...FormMultiKnowledgeValue
  }
  multiSelect {
    ...FormMultiSelectValue
  }
  select {
    ...FormSelectValue
  }
  string {
    ...FormStringValue
  }
  timestamp {
    ...FormTimestampValue
  }
  document {
    documentId
  }
}
    ${FormBooleanValueFragmentDoc}
${ChildAnswerGroupSelectFragmentDoc}
${FormDoubleValueFragmentDoc}
${FormIntegerValueFragmentDoc}
${FormKnowledgeValueFragmentDoc}
${FormLocalDateValueFragmentDoc}
${FormLocalDateTimeValueFragmentDoc}
${FormLocalTimeValueFragmentDoc}
${FormMultiKnowledgeValueFragmentDoc}
${FormMultiSelectValueFragmentDoc}
${FormSelectValueFragmentDoc}
${FormStringValueFragmentDoc}
${FormTimestampValueFragmentDoc}`;
export const FormDoubleQuestionFragmentDoc = gql`
    fragment FormDoubleQuestion on form_DoubleFormQuestionMsg {
  showSlider
  valueMax
  valueMin
  stepSize
  unitDatasetId
}
    `;
export const FormExternalIdFragmentDoc = gql`
    fragment FormExternalId on form_FormExternalIdMsg {
  externalId
  externalIdType
}
    `;
export const InfoTextFormQuestionFragmentDoc = gql`
    fragment InfoTextFormQuestion on form_InfoTextFormQuestionMsg {
  _
}
    `;
export const FormIntegerQuestionFragmentDoc = gql`
    fragment FormIntegerQuestion on form_IntegerFormQuestionMsg {
  showSlider
  valueMin
  valueMax
  specialMode
  stepSize
  unitDatasetId
}
    `;
export const FormKnowledgeQuestionFragmentDoc = gql`
    fragment FormKnowledgeQuestion on form_KnowledgeFormQuestionMsg {
  knowledgeDataset
  searchable
}
    `;
export const FormLocalDateQuestionFragmentDoc = gql`
    fragment FormLocalDateQuestion on form_LocalDateFormQuestionMsg {
  _
}
    `;
export const FormLocalDateTimeQuestionFragmentDoc = gql`
    fragment FormLocalDateTimeQuestion on form_LocalDateTimeFormQuestionMsg {
  _
}
    `;
export const FormLocalTimeQuestionFragmentDoc = gql`
    fragment FormLocalTimeQuestion on form_LocalTimeFormQuestionMsg {
  _
}
    `;
export const FormMultiKnowledgeQuestionFragmentDoc = gql`
    fragment FormMultiKnowledgeQuestion on form_MultiKnowledgeFormQuestionMsg {
  searchable
  knowledgeDataset
  maxAnswers
}
    `;
export const FormMultiSelectQuestionFragmentDoc = gql`
    fragment FormMultiSelectQuestion on form_MultiSelectFormQuestionMsg {
  maxAnswers
  searchable
  datasetId
}
    `;
export const FormSelectQuestionFragmentDoc = gql`
    fragment FormSelectQuestion on form_SelectFormQuestionMsg {
  datasetId
  searchable
}
    `;
export const FormStringQuestionFragmentDoc = gql`
    fragment FormStringQuestion on form_StringFormQuestionMsg {
  maxCharacters
  placeholder {
    ...LocalizedString
  }
}
    ${LocalizedStringFragmentDoc}`;
export const DocumentQuestionFragmentDoc = gql`
    fragment DocumentQuestion on form_DocumentFormQuestionMsg {
  staticDocumentGroupId
  maxFileSize
}
    `;
export const FormQuestionFragmentDoc = gql`
    fragment FormQuestion on form_FormQuestionMsg {
  id
  boolean {
    ...FormBooleanQuestion
  }
  childAnswerGroupSelect {
    ...ChildAnswerGroupSelectQuestion
  }
  defaultValue {
    ...FormValue
  }
  double {
    ...FormDoubleQuestion
  }
  externalIds {
    ...FormExternalId
  }
  infoText {
    ...InfoTextFormQuestion
  }
  integer {
    ...FormIntegerQuestion
  }
  isDisplayAsRequired
  knowledge {
    ...FormKnowledgeQuestion
  }
  localDate {
    ...FormLocalDateQuestion
  }
  localDateTime {
    ...FormLocalDateTimeQuestion
  }
  localTime {
    ...FormLocalTimeQuestion
  }
  multiKnowledge {
    ...FormMultiKnowledgeQuestion
  }
  multiSelect {
    ...FormMultiSelectQuestion
  }
  questionGroupId
  select {
    ...FormSelectQuestion
  }
  string {
    ...FormStringQuestion
  }
  subtitle {
    ...LocalizedString
  }
  title {
    ...LocalizedString
  }
  document {
    ...DocumentQuestion
  }
  type
}
    ${FormBooleanQuestionFragmentDoc}
${ChildAnswerGroupSelectQuestionFragmentDoc}
${FormValueFragmentDoc}
${FormDoubleQuestionFragmentDoc}
${FormExternalIdFragmentDoc}
${InfoTextFormQuestionFragmentDoc}
${FormIntegerQuestionFragmentDoc}
${FormKnowledgeQuestionFragmentDoc}
${FormLocalDateQuestionFragmentDoc}
${FormLocalDateTimeQuestionFragmentDoc}
${FormLocalTimeQuestionFragmentDoc}
${FormMultiKnowledgeQuestionFragmentDoc}
${FormMultiSelectQuestionFragmentDoc}
${FormSelectQuestionFragmentDoc}
${FormStringQuestionFragmentDoc}
${LocalizedStringFragmentDoc}
${DocumentQuestionFragmentDoc}`;
export const FormSequenceQuestionFragmentDoc = gql`
    fragment FormSequenceQuestion on form_FormSequenceQuestionMsg {
  id
  linkedReferences {
    id
  }
  questionId
}
    `;
export const FormAnswerFragmentDoc = gql`
    fragment FormAnswer on form_FormAnswerMsg {
  id
  answerGroupId
  isEnabled
  isValid
  questionGroupId
  questionId
  updatedAt {
    ...Timestamp
  }
  value {
    ...FormValue
  }
}
    ${TimestampFragmentDoc}
${FormValueFragmentDoc}`;
export const FormChildAnswerGroupInfoFragmentDoc = gql`
    fragment FormChildAnswerGroupInfo on form_FormChildAnswerGroupInfoMsg {
  id
  answerGroupIds
  questionGroupId
  isEnabled
}
    `;
export const AnswerGroupFragmentDoc = gql`
    fragment AnswerGroup on form_FormAnswerGroupMsg {
  id
  answers {
    ...FormAnswer
  }
  childAnswerGroupInfo {
    ...FormChildAnswerGroupInfo
  }
  parentAnswerGroupId
  questionGroupId
  directParentFormId
}
    ${FormAnswerFragmentDoc}
${FormChildAnswerGroupInfoFragmentDoc}`;
export const FormContextFragmentDoc = gql`
    fragment FormContext on form_FormContextMsg {
  identifiers {
    contextId
    type
  }
}
    `;
export const FormSequenceAnswerFragmentDoc = gql`
    fragment FormSequenceAnswer on form_FormSequenceAnswerMsg {
  id
  forwardsState
  hasBackwardsSibling
  sequenceQuestionId
  updatedAt {
    ...Timestamp
  }
  value {
    ...FormValue
  }
}
    ${TimestampFragmentDoc}
${FormValueFragmentDoc}`;
export const FormFragmentDoc = gql`
    fragment Form on form_FormMsg {
  id
  answerGroups {
    ...AnswerGroup
  }
  context {
    ...FormContext
  }
  directChildAnswerGroupInfo {
    ...FormChildAnswerGroupInfo
  }
  owningOrganizationalUnitId
  sequenceAnswers {
    ...FormSequenceAnswer
  }
  status
  templateId
  updatedAt {
    ...Timestamp
  }
}
    ${AnswerGroupFragmentDoc}
${FormContextFragmentDoc}
${FormChildAnswerGroupInfoFragmentDoc}
${FormSequenceAnswerFragmentDoc}
${TimestampFragmentDoc}`;
export const HumanNameFragmentDoc = gql`
    fragment HumanName on core_HumanNameMsg {
  id
  affix
  firstName
  lastName
  maidenName
  middleNames
  prefix
  title
}
    `;
export const LegalGuardianFragmentDoc = gql`
    fragment LegalGuardian on patientportal_PortalUserMsg {
  accountVerificationRequiredForClinicIds
  id
  name {
    ...HumanName
  }
  contact {
    ...Contact
  }
  sex
  dateOfBirth {
    ...Timestamp
  }
  email
}
    ${HumanNameFragmentDoc}
${ContactFragmentDoc}
${TimestampFragmentDoc}`;
export const PortalAccountSettingsFragmentDoc = gql`
    fragment PortalAccountSettings on patientportal_PortalAccountSettingsMsg {
  accessibilityModeActive
}
    `;
export const PortalUserFragmentDoc = gql`
    fragment PortalUser on patientportal_PortalUserMsg {
  id
  accountVerificationRequiredForClinicIds
  verified
  dateOfBirth {
    ...Timestamp
  }
  name {
    ...HumanName
  }
  contact {
    ...Contact
  }
  email
  sex
  settings {
    ...PortalAccountSettings
  }
}
    ${TimestampFragmentDoc}
${HumanNameFragmentDoc}
${ContactFragmentDoc}
${PortalAccountSettingsFragmentDoc}`;
export const ConfirmableActionFragmentDoc = gql`
    fragment ConfirmableAction on patientportal_ConfirmableActionMsg {
  id
  actionToken
  expiresAt {
    ...Timestamp
  }
  confirmationProviders {
    name
    type
    email {
      emailAddress
      confirmationCodeInfo {
        type
        length
      }
      confirmationTokenMode
    }
    sms {
      phoneNumber
      confirmationCodeInfo {
        type
        length
      }
      confirmationTokenMode
    }
  }
}
    ${TimestampFragmentDoc}`;
export const GetAppointmentHistoryDocument = gql`
    query GetAppointmentHistory($clinicId: String!, $appointmentId: String!) {
  getAppointmentHistory(
    input: {clinicId: $clinicId, appointmentId: $appointmentId}
  ) {
    clinicId
    response {
      events {
        ...AppointmentHistoryEvent
      }
    }
  }
}
    ${AppointmentHistoryEventFragmentDoc}`;

/**
 * __useGetAppointmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetAppointmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentHistoryQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentHistoryQuery, GetAppointmentHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentHistoryQuery, GetAppointmentHistoryQueryVariables>(GetAppointmentHistoryDocument, options);
      }
export function useGetAppointmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentHistoryQuery, GetAppointmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentHistoryQuery, GetAppointmentHistoryQueryVariables>(GetAppointmentHistoryDocument, options);
        }
export type GetAppointmentHistoryQueryHookResult = ReturnType<typeof useGetAppointmentHistoryQuery>;
export type GetAppointmentHistoryLazyQueryHookResult = ReturnType<typeof useGetAppointmentHistoryLazyQuery>;
export type GetAppointmentHistoryQueryResult = Apollo.QueryResult<GetAppointmentHistoryQuery, GetAppointmentHistoryQueryVariables>;
export const GetAppointmentRequestDocument = gql`
    query GetAppointmentRequest($appointmentRequestId: String, $clinicId: String) {
  getAppointmentRequest(
    input: {clinicId: $clinicId, request: {appointmentRequestId: $appointmentRequestId}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;

/**
 * __useGetAppointmentRequestQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRequestQuery({
 *   variables: {
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAppointmentRequestQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentRequestQuery, GetAppointmentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRequestQuery, GetAppointmentRequestQueryVariables>(GetAppointmentRequestDocument, options);
      }
export function useGetAppointmentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRequestQuery, GetAppointmentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRequestQuery, GetAppointmentRequestQueryVariables>(GetAppointmentRequestDocument, options);
        }
export type GetAppointmentRequestQueryHookResult = ReturnType<typeof useGetAppointmentRequestQuery>;
export type GetAppointmentRequestLazyQueryHookResult = ReturnType<typeof useGetAppointmentRequestLazyQuery>;
export type GetAppointmentRequestQueryResult = Apollo.QueryResult<GetAppointmentRequestQuery, GetAppointmentRequestQueryVariables>;
export const ListPortalUserAppointmentRequestsDocument = gql`
    query ListPortalUserAppointmentRequests {
  listPortalUserAppointmentRequests {
    proxyAppointmentRequests {
      ...ProxyAppointmentRequest
    }
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;

/**
 * __useListPortalUserAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useListPortalUserAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortalUserAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPortalUserAppointmentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPortalUserAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<ListPortalUserAppointmentRequestsQuery, ListPortalUserAppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPortalUserAppointmentRequestsQuery, ListPortalUserAppointmentRequestsQueryVariables>(ListPortalUserAppointmentRequestsDocument, options);
      }
export function useListPortalUserAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPortalUserAppointmentRequestsQuery, ListPortalUserAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPortalUserAppointmentRequestsQuery, ListPortalUserAppointmentRequestsQueryVariables>(ListPortalUserAppointmentRequestsDocument, options);
        }
export type ListPortalUserAppointmentRequestsQueryHookResult = ReturnType<typeof useListPortalUserAppointmentRequestsQuery>;
export type ListPortalUserAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useListPortalUserAppointmentRequestsLazyQuery>;
export type ListPortalUserAppointmentRequestsQueryResult = Apollo.QueryResult<ListPortalUserAppointmentRequestsQuery, ListPortalUserAppointmentRequestsQueryVariables>;
export const SubmitAppointmentRequestDocument = gql`
    mutation SubmitAppointmentRequest($clinicId: String!, $appointmentRequest: Input_resource_CreateAppointmentRequestRequest, $appointmentRequestId: String) {
  submitAppointmentRequest(
    input: {clinicId: $clinicId, request: {appointmentRequestId: $appointmentRequestId, createAppointmentRequestRequest: $appointmentRequest}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;
export type SubmitAppointmentRequestMutationFn = Apollo.MutationFunction<SubmitAppointmentRequestMutation, SubmitAppointmentRequestMutationVariables>;

/**
 * __useSubmitAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useSubmitAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAppointmentRequestMutation, { data, loading, error }] = useSubmitAppointmentRequestMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentRequest: // value for 'appointmentRequest'
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *   },
 * });
 */
export function useSubmitAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAppointmentRequestMutation, SubmitAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAppointmentRequestMutation, SubmitAppointmentRequestMutationVariables>(SubmitAppointmentRequestDocument, options);
      }
export type SubmitAppointmentRequestMutationHookResult = ReturnType<typeof useSubmitAppointmentRequestMutation>;
export type SubmitAppointmentRequestMutationResult = Apollo.MutationResult<SubmitAppointmentRequestMutation>;
export type SubmitAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<SubmitAppointmentRequestMutation, SubmitAppointmentRequestMutationVariables>;
export const CreateAppointmentRequestDocument = gql`
    mutation CreateAppointmentRequest($clinicId: String!, $portalUserId: String!, $appointmentRequest: Input_resource_AppointmentRequestMsg) {
  createAppointmentRequest(
    input: {clinicId: $clinicId, portalUserId: $portalUserId, request: {appointmentRequest: $appointmentRequest}}
  ) {
    clinicId
    portalUserId
    appointmentRequest {
      ...AppointmentRequest
    }
  }
}
    ${AppointmentRequestFragmentDoc}`;
export type CreateAppointmentRequestMutationFn = Apollo.MutationFunction<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;

/**
 * __useCreateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentRequestMutation, { data, loading, error }] = useCreateAppointmentRequestMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      portalUserId: // value for 'portalUserId'
 *      appointmentRequest: // value for 'appointmentRequest'
 *   },
 * });
 */
export function useCreateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>(CreateAppointmentRequestDocument, options);
      }
export type CreateAppointmentRequestMutationHookResult = ReturnType<typeof useCreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationResult = Apollo.MutationResult<CreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;
export const CancelAppointmentRequestDocument = gql`
    mutation CancelAppointmentRequest($clinicId: String!, $appointmentRequestId: String!, $reasonsForCancellation: [Input_core_KnowledgeInputMsg]) {
  cancelAppointmentRequest(
    input: {clinicId: $clinicId, request: {appointmentRequestId: $appointmentRequestId, reasonsForCancellation: $reasonsForCancellation}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;
export type CancelAppointmentRequestMutationFn = Apollo.MutationFunction<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;

/**
 * __useCancelAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentRequestMutation, { data, loading, error }] = useCancelAppointmentRequestMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *      reasonsForCancellation: // value for 'reasonsForCancellation'
 *   },
 * });
 */
export function useCancelAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>(CancelAppointmentRequestDocument, options);
      }
export type CancelAppointmentRequestMutationHookResult = ReturnType<typeof useCancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationResult = Apollo.MutationResult<CancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;
export const AcceptAppointmentProposalDocument = gql`
    mutation AcceptAppointmentProposal($clinicId: String!, $appointmentSlotProposalId: String!, $portalUserId: String!) {
  acceptAppointmentProposal(
    input: {clinicId: $clinicId, portalUserId: $portalUserId, request: {appointmentSlotProposalId: $appointmentSlotProposalId}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;
export type AcceptAppointmentProposalMutationFn = Apollo.MutationFunction<AcceptAppointmentProposalMutation, AcceptAppointmentProposalMutationVariables>;

/**
 * __useAcceptAppointmentProposalMutation__
 *
 * To run a mutation, you first call `useAcceptAppointmentProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAppointmentProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAppointmentProposalMutation, { data, loading, error }] = useAcceptAppointmentProposalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentSlotProposalId: // value for 'appointmentSlotProposalId'
 *      portalUserId: // value for 'portalUserId'
 *   },
 * });
 */
export function useAcceptAppointmentProposalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAppointmentProposalMutation, AcceptAppointmentProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAppointmentProposalMutation, AcceptAppointmentProposalMutationVariables>(AcceptAppointmentProposalDocument, options);
      }
export type AcceptAppointmentProposalMutationHookResult = ReturnType<typeof useAcceptAppointmentProposalMutation>;
export type AcceptAppointmentProposalMutationResult = Apollo.MutationResult<AcceptAppointmentProposalMutation>;
export type AcceptAppointmentProposalMutationOptions = Apollo.BaseMutationOptions<AcceptAppointmentProposalMutation, AcceptAppointmentProposalMutationVariables>;
export const RejectAppointmentProposalsDocument = gql`
    mutation RejectAppointmentProposals($clinicId: String!, $appointmentRequestId: String!) {
  rejectAppointmentProposals(
    input: {clinicId: $clinicId, request: {appointmentRequestId: $appointmentRequestId}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;
export type RejectAppointmentProposalsMutationFn = Apollo.MutationFunction<RejectAppointmentProposalsMutation, RejectAppointmentProposalsMutationVariables>;

/**
 * __useRejectAppointmentProposalsMutation__
 *
 * To run a mutation, you first call `useRejectAppointmentProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAppointmentProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAppointmentProposalsMutation, { data, loading, error }] = useRejectAppointmentProposalsMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *   },
 * });
 */
export function useRejectAppointmentProposalsMutation(baseOptions?: Apollo.MutationHookOptions<RejectAppointmentProposalsMutation, RejectAppointmentProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAppointmentProposalsMutation, RejectAppointmentProposalsMutationVariables>(RejectAppointmentProposalsDocument, options);
      }
export type RejectAppointmentProposalsMutationHookResult = ReturnType<typeof useRejectAppointmentProposalsMutation>;
export type RejectAppointmentProposalsMutationResult = Apollo.MutationResult<RejectAppointmentProposalsMutation>;
export type RejectAppointmentProposalsMutationOptions = Apollo.BaseMutationOptions<RejectAppointmentProposalsMutation, RejectAppointmentProposalsMutationVariables>;
export const UpdateAppointmentRequestDocument = gql`
    mutation UpdateAppointmentRequest($clinicId: String!, $portalUserId: String!, $appointmentRequest: Input_resource_AppointmentRequestMsg!) {
  updateAppointmentRequest(
    input: {clinicId: $clinicId, portalUserId: $portalUserId, request: {patch: true, appointmentRequest: $appointmentRequest}}
  ) {
    ...ProxyAppointmentRequest
  }
}
    ${ProxyAppointmentRequestFragmentDoc}`;
export type UpdateAppointmentRequestMutationFn = Apollo.MutationFunction<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>;

/**
 * __useUpdateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentRequestMutation, { data, loading, error }] = useUpdateAppointmentRequestMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      portalUserId: // value for 'portalUserId'
 *      appointmentRequest: // value for 'appointmentRequest'
 *   },
 * });
 */
export function useUpdateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>(UpdateAppointmentRequestDocument, options);
      }
export type UpdateAppointmentRequestMutationHookResult = ReturnType<typeof useUpdateAppointmentRequestMutation>;
export type UpdateAppointmentRequestMutationResult = Apollo.MutationResult<UpdateAppointmentRequestMutation>;
export type UpdateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>;
export const GetAvailableAppointmentSlotsDocument = gql`
    query GetAvailableAppointmentSlots($clinicId: String!, $request: Input_resource_GetAvailableAppointmentTimesRequest!) {
  getAvailableAppointmentSlots(input: {clinicId: $clinicId, request: $request}) {
    appointmentTimeFrames {
      ...AppointmentTimeFrame
    }
  }
}
    ${AppointmentTimeFrameFragmentDoc}`;

/**
 * __useGetAvailableAppointmentSlotsQuery__
 *
 * To run a query within a React component, call `useGetAvailableAppointmentSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAppointmentSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAppointmentSlotsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetAvailableAppointmentSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableAppointmentSlotsQuery, GetAvailableAppointmentSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAppointmentSlotsQuery, GetAvailableAppointmentSlotsQueryVariables>(GetAvailableAppointmentSlotsDocument, options);
      }
export function useGetAvailableAppointmentSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAppointmentSlotsQuery, GetAvailableAppointmentSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAppointmentSlotsQuery, GetAvailableAppointmentSlotsQueryVariables>(GetAvailableAppointmentSlotsDocument, options);
        }
export type GetAvailableAppointmentSlotsQueryHookResult = ReturnType<typeof useGetAvailableAppointmentSlotsQuery>;
export type GetAvailableAppointmentSlotsLazyQueryHookResult = ReturnType<typeof useGetAvailableAppointmentSlotsLazyQuery>;
export type GetAvailableAppointmentSlotsQueryResult = Apollo.QueryResult<GetAvailableAppointmentSlotsQuery, GetAvailableAppointmentSlotsQueryVariables>;
export const GetAppointmentFormReferenceBlacklistDocument = gql`
    query GetAppointmentFormReferenceBlacklist($clinicId: String!, $officeHourId: String!) {
  getAppointmentFormReferenceBlacklist(
    input: {clinicId: $clinicId, officeHourId: $officeHourId}
  ) {
    formReferenceBlacklist
  }
}
    `;

/**
 * __useGetAppointmentFormReferenceBlacklistQuery__
 *
 * To run a query within a React component, call `useGetAppointmentFormReferenceBlacklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentFormReferenceBlacklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentFormReferenceBlacklistQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      officeHourId: // value for 'officeHourId'
 *   },
 * });
 */
export function useGetAppointmentFormReferenceBlacklistQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentFormReferenceBlacklistQuery, GetAppointmentFormReferenceBlacklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentFormReferenceBlacklistQuery, GetAppointmentFormReferenceBlacklistQueryVariables>(GetAppointmentFormReferenceBlacklistDocument, options);
      }
export function useGetAppointmentFormReferenceBlacklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentFormReferenceBlacklistQuery, GetAppointmentFormReferenceBlacklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentFormReferenceBlacklistQuery, GetAppointmentFormReferenceBlacklistQueryVariables>(GetAppointmentFormReferenceBlacklistDocument, options);
        }
export type GetAppointmentFormReferenceBlacklistQueryHookResult = ReturnType<typeof useGetAppointmentFormReferenceBlacklistQuery>;
export type GetAppointmentFormReferenceBlacklistLazyQueryHookResult = ReturnType<typeof useGetAppointmentFormReferenceBlacklistLazyQuery>;
export type GetAppointmentFormReferenceBlacklistQueryResult = Apollo.QueryResult<GetAppointmentFormReferenceBlacklistQuery, GetAppointmentFormReferenceBlacklistQueryVariables>;
export const GetAvailableAppointmentDatesDocument = gql`
    query GetAvailableAppointmentDates($clinicId: String!, $request: Input_resource_GetAvailableAppointmentTimesRequest!) {
  getAvailableAppointmentDates(input: {clinicId: $clinicId, request: $request}) {
    dates {
      ...Timestamp
    }
  }
}
    ${TimestampFragmentDoc}`;

/**
 * __useGetAvailableAppointmentDatesQuery__
 *
 * To run a query within a React component, call `useGetAvailableAppointmentDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAppointmentDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAppointmentDatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetAvailableAppointmentDatesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableAppointmentDatesQuery, GetAvailableAppointmentDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAppointmentDatesQuery, GetAvailableAppointmentDatesQueryVariables>(GetAvailableAppointmentDatesDocument, options);
      }
export function useGetAvailableAppointmentDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAppointmentDatesQuery, GetAvailableAppointmentDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAppointmentDatesQuery, GetAvailableAppointmentDatesQueryVariables>(GetAvailableAppointmentDatesDocument, options);
        }
export type GetAvailableAppointmentDatesQueryHookResult = ReturnType<typeof useGetAvailableAppointmentDatesQuery>;
export type GetAvailableAppointmentDatesLazyQueryHookResult = ReturnType<typeof useGetAvailableAppointmentDatesLazyQuery>;
export type GetAvailableAppointmentDatesQueryResult = Apollo.QueryResult<GetAvailableAppointmentDatesQuery, GetAvailableAppointmentDatesQueryVariables>;
export const GetAppointmentDocument = gql`
    query GetAppointment($clinicId: String!, $appointmentId: String!) {
  getAppointment(
    input: {clinicId: $clinicId, request: {appointmentId: $appointmentId}}
  ) {
    ...AppointmentProxy
  }
}
    ${AppointmentProxyFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($clinicId: String!, $request: Input_resource_CancelAppointmentOrSeriesRequest!, $portalUserId: String!) {
  cancelAppointment(
    input: {clinicId: $clinicId, request: $request, portalUserId: $portalUserId}
  ) {
    ...AppointmentProxy
  }
}
    ${AppointmentProxyFragmentDoc}`;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *      portalUserId: // value for 'portalUserId'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const GetAppointmentTaskDocument = gql`
    query GetAppointmentTask($clinicId: String!, $appointmentTaskId: String!) {
  getAppointmentTask(
    input: {clinicId: $clinicId, request: {appointmentTaskId: $appointmentTaskId}}
  ) {
    ...AppointmentTaskProxy
  }
}
    ${AppointmentTaskProxyFragmentDoc}`;

/**
 * __useGetAppointmentTaskQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTaskQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentTaskId: // value for 'appointmentTaskId'
 *   },
 * });
 */
export function useGetAppointmentTaskQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentTaskQuery, GetAppointmentTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentTaskQuery, GetAppointmentTaskQueryVariables>(GetAppointmentTaskDocument, options);
      }
export function useGetAppointmentTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentTaskQuery, GetAppointmentTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentTaskQuery, GetAppointmentTaskQueryVariables>(GetAppointmentTaskDocument, options);
        }
export type GetAppointmentTaskQueryHookResult = ReturnType<typeof useGetAppointmentTaskQuery>;
export type GetAppointmentTaskLazyQueryHookResult = ReturnType<typeof useGetAppointmentTaskLazyQuery>;
export type GetAppointmentTaskQueryResult = Apollo.QueryResult<GetAppointmentTaskQuery, GetAppointmentTaskQueryVariables>;
export const ListAppointmentTasksDocument = gql`
    query ListAppointmentTasks($clinicId: String!, $request: Input_resource_ListAppointmentTasksRequest!) {
  listAppointmentTasks(input: {clinicId: $clinicId, request: $request}) {
    proxyAppointmentTasks {
      ...AppointmentTaskProxy
    }
  }
}
    ${AppointmentTaskProxyFragmentDoc}`;

/**
 * __useListAppointmentTasksQuery__
 *
 * To run a query within a React component, call `useListAppointmentTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppointmentTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppointmentTasksQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListAppointmentTasksQuery(baseOptions: Apollo.QueryHookOptions<ListAppointmentTasksQuery, ListAppointmentTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppointmentTasksQuery, ListAppointmentTasksQueryVariables>(ListAppointmentTasksDocument, options);
      }
export function useListAppointmentTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppointmentTasksQuery, ListAppointmentTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppointmentTasksQuery, ListAppointmentTasksQueryVariables>(ListAppointmentTasksDocument, options);
        }
export type ListAppointmentTasksQueryHookResult = ReturnType<typeof useListAppointmentTasksQuery>;
export type ListAppointmentTasksLazyQueryHookResult = ReturnType<typeof useListAppointmentTasksLazyQuery>;
export type ListAppointmentTasksQueryResult = Apollo.QueryResult<ListAppointmentTasksQuery, ListAppointmentTasksQueryVariables>;
export const UpdateAppointmentTaskStatusDocument = gql`
    mutation UpdateAppointmentTaskStatus($clinicId: String!, $request: Input_resource_UpdateAppointmentTaskStatusRequest!) {
  updateAppointmentTaskStatus(input: {clinicId: $clinicId, request: $request}) {
    ...AppointmentTaskProxy
  }
}
    ${AppointmentTaskProxyFragmentDoc}`;
export type UpdateAppointmentTaskStatusMutationFn = Apollo.MutationFunction<UpdateAppointmentTaskStatusMutation, UpdateAppointmentTaskStatusMutationVariables>;

/**
 * __useUpdateAppointmentTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentTaskStatusMutation, { data, loading, error }] = useUpdateAppointmentTaskStatusMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateAppointmentTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentTaskStatusMutation, UpdateAppointmentTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentTaskStatusMutation, UpdateAppointmentTaskStatusMutationVariables>(UpdateAppointmentTaskStatusDocument, options);
      }
export type UpdateAppointmentTaskStatusMutationHookResult = ReturnType<typeof useUpdateAppointmentTaskStatusMutation>;
export type UpdateAppointmentTaskStatusMutationResult = Apollo.MutationResult<UpdateAppointmentTaskStatusMutation>;
export type UpdateAppointmentTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentTaskStatusMutation, UpdateAppointmentTaskStatusMutationVariables>;
export const UpdateAppointmentTaskResultDocument = gql`
    mutation UpdateAppointmentTaskResult($clinicId: String!, $portalUserId: String!, $appointmentTaskId: String!, $newResultReferences: [Input_resource_AppointmentTaskResultReferenceMsg!]!) {
  updateAppointmentTaskResult(
    input: {clinicId: $clinicId, portalUserId: $portalUserId, request: {appointmentTaskId: $appointmentTaskId, newResultReferences: $newResultReferences}}
  ) {
    clinicId
    appointmentTask {
      ...AppointmentTask
    }
  }
}
    ${AppointmentTaskFragmentDoc}`;
export type UpdateAppointmentTaskResultMutationFn = Apollo.MutationFunction<UpdateAppointmentTaskResultMutation, UpdateAppointmentTaskResultMutationVariables>;

/**
 * __useUpdateAppointmentTaskResultMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentTaskResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentTaskResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentTaskResultMutation, { data, loading, error }] = useUpdateAppointmentTaskResultMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      portalUserId: // value for 'portalUserId'
 *      appointmentTaskId: // value for 'appointmentTaskId'
 *      newResultReferences: // value for 'newResultReferences'
 *   },
 * });
 */
export function useUpdateAppointmentTaskResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentTaskResultMutation, UpdateAppointmentTaskResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentTaskResultMutation, UpdateAppointmentTaskResultMutationVariables>(UpdateAppointmentTaskResultDocument, options);
      }
export type UpdateAppointmentTaskResultMutationHookResult = ReturnType<typeof useUpdateAppointmentTaskResultMutation>;
export type UpdateAppointmentTaskResultMutationResult = Apollo.MutationResult<UpdateAppointmentTaskResultMutation>;
export type UpdateAppointmentTaskResultMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentTaskResultMutation, UpdateAppointmentTaskResultMutationVariables>;
export const GetAppointmentFormTemplateIdDocument = gql`
    query GetAppointmentFormTemplateId($clinicId: String!, $officeHourId: String!) {
  getAppointmentFormTemplateVersioningGroupId(
    input: {clinicId: $clinicId, officeHourId: $officeHourId}
  ) {
    formTemplateVersioningGroupId
  }
}
    `;

/**
 * __useGetAppointmentFormTemplateIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentFormTemplateIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentFormTemplateIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentFormTemplateIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      officeHourId: // value for 'officeHourId'
 *   },
 * });
 */
export function useGetAppointmentFormTemplateIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentFormTemplateIdQuery, GetAppointmentFormTemplateIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentFormTemplateIdQuery, GetAppointmentFormTemplateIdQueryVariables>(GetAppointmentFormTemplateIdDocument, options);
      }
export function useGetAppointmentFormTemplateIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentFormTemplateIdQuery, GetAppointmentFormTemplateIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentFormTemplateIdQuery, GetAppointmentFormTemplateIdQueryVariables>(GetAppointmentFormTemplateIdDocument, options);
        }
export type GetAppointmentFormTemplateIdQueryHookResult = ReturnType<typeof useGetAppointmentFormTemplateIdQuery>;
export type GetAppointmentFormTemplateIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentFormTemplateIdLazyQuery>;
export type GetAppointmentFormTemplateIdQueryResult = Apollo.QueryResult<GetAppointmentFormTemplateIdQuery, GetAppointmentFormTemplateIdQueryVariables>;
export const GetPortalUserAppointmentsDocument = gql`
    query GetPortalUserAppointments($statusIn: [resource_AppointmentStatus], $statusNotIn: [resource_AppointmentStatus]) {
  getPortalUserAppointments(
    input: {statusIn: $statusIn, statusNotIn: $statusNotIn}
  ) {
    proxyAppointments {
      ...AppointmentProxy
    }
  }
}
    ${AppointmentProxyFragmentDoc}`;

/**
 * __useGetPortalUserAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetPortalUserAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalUserAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalUserAppointmentsQuery({
 *   variables: {
 *      statusIn: // value for 'statusIn'
 *      statusNotIn: // value for 'statusNotIn'
 *   },
 * });
 */
export function useGetPortalUserAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPortalUserAppointmentsQuery, GetPortalUserAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalUserAppointmentsQuery, GetPortalUserAppointmentsQueryVariables>(GetPortalUserAppointmentsDocument, options);
      }
export function useGetPortalUserAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalUserAppointmentsQuery, GetPortalUserAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalUserAppointmentsQuery, GetPortalUserAppointmentsQueryVariables>(GetPortalUserAppointmentsDocument, options);
        }
export type GetPortalUserAppointmentsQueryHookResult = ReturnType<typeof useGetPortalUserAppointmentsQuery>;
export type GetPortalUserAppointmentsLazyQueryHookResult = ReturnType<typeof useGetPortalUserAppointmentsLazyQuery>;
export type GetPortalUserAppointmentsQueryResult = Apollo.QueryResult<GetPortalUserAppointmentsQuery, GetPortalUserAppointmentsQueryVariables>;
export const ListAppointmentTypesDocument = gql`
    query ListAppointmentTypes($clinicId: String!, $request: Input_resource_ListPortalUserAppointmentTypesRequest) {
  listPortalUserAppointmentTypes(input: {clinicId: $clinicId, request: $request}) {
    proxyAppointmentTypes {
      appointmentType {
        ...PortalUserAppointmentType
      }
      clinicId
    }
  }
}
    ${PortalUserAppointmentTypeFragmentDoc}`;

/**
 * __useListAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useListAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppointmentTypesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListAppointmentTypesQuery(baseOptions: Apollo.QueryHookOptions<ListAppointmentTypesQuery, ListAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppointmentTypesQuery, ListAppointmentTypesQueryVariables>(ListAppointmentTypesDocument, options);
      }
export function useListAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppointmentTypesQuery, ListAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppointmentTypesQuery, ListAppointmentTypesQueryVariables>(ListAppointmentTypesDocument, options);
        }
export type ListAppointmentTypesQueryHookResult = ReturnType<typeof useListAppointmentTypesQuery>;
export type ListAppointmentTypesLazyQueryHookResult = ReturnType<typeof useListAppointmentTypesLazyQuery>;
export type ListAppointmentTypesQueryResult = Apollo.QueryResult<ListAppointmentTypesQuery, ListAppointmentTypesQueryVariables>;
export const ListPortalUserAppointmentTypesDocument = gql`
    query ListPortalUserAppointmentTypes($clinicId: String!, $request: Input_resource_ListPortalUserAppointmentTypesRequest) {
  listPortalUserAppointmentTypes(input: {clinicId: $clinicId, request: $request}) {
    proxyAppointmentTypes {
      ...PortalUserProxyAppointmentType
    }
  }
}
    ${PortalUserProxyAppointmentTypeFragmentDoc}`;

/**
 * __useListPortalUserAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useListPortalUserAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortalUserAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPortalUserAppointmentTypesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListPortalUserAppointmentTypesQuery(baseOptions: Apollo.QueryHookOptions<ListPortalUserAppointmentTypesQuery, ListPortalUserAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPortalUserAppointmentTypesQuery, ListPortalUserAppointmentTypesQueryVariables>(ListPortalUserAppointmentTypesDocument, options);
      }
export function useListPortalUserAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPortalUserAppointmentTypesQuery, ListPortalUserAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPortalUserAppointmentTypesQuery, ListPortalUserAppointmentTypesQueryVariables>(ListPortalUserAppointmentTypesDocument, options);
        }
export type ListPortalUserAppointmentTypesQueryHookResult = ReturnType<typeof useListPortalUserAppointmentTypesQuery>;
export type ListPortalUserAppointmentTypesLazyQueryHookResult = ReturnType<typeof useListPortalUserAppointmentTypesLazyQuery>;
export type ListPortalUserAppointmentTypesQueryResult = Apollo.QueryResult<ListPortalUserAppointmentTypesQuery, ListPortalUserAppointmentTypesQueryVariables>;
export const ListAppointmentHandlersDocument = gql`
    query ListAppointmentHandlers($clinicId: String!, $request: Input_resource_ListAppointmentHandlersRequest) {
  listAppointmentHandlers(input: {clinicId: $clinicId, request: $request}) {
    proxyAppointmentHandlers {
      ...ProxyAppointmentHandler
    }
  }
}
    ${ProxyAppointmentHandlerFragmentDoc}`;

/**
 * __useListAppointmentHandlersQuery__
 *
 * To run a query within a React component, call `useListAppointmentHandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppointmentHandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppointmentHandlersQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListAppointmentHandlersQuery(baseOptions: Apollo.QueryHookOptions<ListAppointmentHandlersQuery, ListAppointmentHandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppointmentHandlersQuery, ListAppointmentHandlersQueryVariables>(ListAppointmentHandlersDocument, options);
      }
export function useListAppointmentHandlersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppointmentHandlersQuery, ListAppointmentHandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppointmentHandlersQuery, ListAppointmentHandlersQueryVariables>(ListAppointmentHandlersDocument, options);
        }
export type ListAppointmentHandlersQueryHookResult = ReturnType<typeof useListAppointmentHandlersQuery>;
export type ListAppointmentHandlersLazyQueryHookResult = ReturnType<typeof useListAppointmentHandlersLazyQuery>;
export type ListAppointmentHandlersQueryResult = Apollo.QueryResult<ListAppointmentHandlersQuery, ListAppointmentHandlersQueryVariables>;
export const GetAppointmentTypeDocument = gql`
    query GetAppointmentType($clinicId: String!, $appointmentTypeId: String!) {
  getAppointmentType(
    input: {clinicId: $clinicId, request: {appointmentTypeId: $appointmentTypeId}}
  ) {
    clinicId
    appointmentType {
      ...AppointmentType
    }
  }
}
    ${AppointmentTypeFragmentDoc}`;

/**
 * __useGetAppointmentTypeQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *   },
 * });
 */
export function useGetAppointmentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentTypeQuery, GetAppointmentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentTypeQuery, GetAppointmentTypeQueryVariables>(GetAppointmentTypeDocument, options);
      }
export function useGetAppointmentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentTypeQuery, GetAppointmentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentTypeQuery, GetAppointmentTypeQueryVariables>(GetAppointmentTypeDocument, options);
        }
export type GetAppointmentTypeQueryHookResult = ReturnType<typeof useGetAppointmentTypeQuery>;
export type GetAppointmentTypeLazyQueryHookResult = ReturnType<typeof useGetAppointmentTypeLazyQuery>;
export type GetAppointmentTypeQueryResult = Apollo.QueryResult<GetAppointmentTypeQuery, GetAppointmentTypeQueryVariables>;
export const KnowledgeBaseDocument = gql`
    query KnowledgeBase($request: Input_knowledge_KnowledgeSearchRequest) {
  searchStandardizedData(input: $request) {
    results {
      generalId
      text
      configurations
    }
  }
}
    `;

/**
 * __useKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useKnowledgeBaseQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
      }
export function useKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
        }
export type KnowledgeBaseQueryHookResult = ReturnType<typeof useKnowledgeBaseQuery>;
export type KnowledgeBaseLazyQueryHookResult = ReturnType<typeof useKnowledgeBaseLazyQuery>;
export type KnowledgeBaseQueryResult = Apollo.QueryResult<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($input: Input_patientportal_GetDocumentPortalProxyRequest) {
  getDocument(input: $input) {
    document {
      ...DocumentMetadataProxy
    }
  }
}
    ${DocumentMetadataProxyFragmentDoc}`;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export const GetPortalFacilityPathsDocument = gql`
    query GetPortalFacilityPaths($portalFacilityIds: [String!]!) {
  getPortalFacilityPaths(
    input: {portalFacilityIds: $portalFacilityIds, onlyName: true}
  ) {
    paths {
      portalFacilities {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPortalFacilityPathsQuery__
 *
 * To run a query within a React component, call `useGetPortalFacilityPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalFacilityPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalFacilityPathsQuery({
 *   variables: {
 *      portalFacilityIds: // value for 'portalFacilityIds'
 *   },
 * });
 */
export function useGetPortalFacilityPathsQuery(baseOptions: Apollo.QueryHookOptions<GetPortalFacilityPathsQuery, GetPortalFacilityPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalFacilityPathsQuery, GetPortalFacilityPathsQueryVariables>(GetPortalFacilityPathsDocument, options);
      }
export function useGetPortalFacilityPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalFacilityPathsQuery, GetPortalFacilityPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalFacilityPathsQuery, GetPortalFacilityPathsQueryVariables>(GetPortalFacilityPathsDocument, options);
        }
export type GetPortalFacilityPathsQueryHookResult = ReturnType<typeof useGetPortalFacilityPathsQuery>;
export type GetPortalFacilityPathsLazyQueryHookResult = ReturnType<typeof useGetPortalFacilityPathsLazyQuery>;
export type GetPortalFacilityPathsQueryResult = Apollo.QueryResult<GetPortalFacilityPathsQuery, GetPortalFacilityPathsQueryVariables>;
export const GetPortalFacilityHierarchyDocument = gql`
    query GetPortalFacilityHierarchy($rootPortalFacilityId: String, $clinicId: String, $depth: Int!) {
  getPortalFacilityHierarchy(
    input: {rootPortalFacilityId: $rootPortalFacilityId, depth: $depth, clinicId: $clinicId, requiredCapabilities: [PORTAL_FACILITY_CAPABILITY_APPOINTMENT_BOOKING]}
  ) {
    paths {
      childIds
    }
    portalFacilities {
      ...PortalFacility
    }
    parentId
  }
}
    ${PortalFacilityFragmentDoc}`;

/**
 * __useGetPortalFacilityHierarchyQuery__
 *
 * To run a query within a React component, call `useGetPortalFacilityHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalFacilityHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalFacilityHierarchyQuery({
 *   variables: {
 *      rootPortalFacilityId: // value for 'rootPortalFacilityId'
 *      clinicId: // value for 'clinicId'
 *      depth: // value for 'depth'
 *   },
 * });
 */
export function useGetPortalFacilityHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetPortalFacilityHierarchyQuery, GetPortalFacilityHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalFacilityHierarchyQuery, GetPortalFacilityHierarchyQueryVariables>(GetPortalFacilityHierarchyDocument, options);
      }
export function useGetPortalFacilityHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalFacilityHierarchyQuery, GetPortalFacilityHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalFacilityHierarchyQuery, GetPortalFacilityHierarchyQueryVariables>(GetPortalFacilityHierarchyDocument, options);
        }
export type GetPortalFacilityHierarchyQueryHookResult = ReturnType<typeof useGetPortalFacilityHierarchyQuery>;
export type GetPortalFacilityHierarchyLazyQueryHookResult = ReturnType<typeof useGetPortalFacilityHierarchyLazyQuery>;
export type GetPortalFacilityHierarchyQueryResult = Apollo.QueryResult<GetPortalFacilityHierarchyQuery, GetPortalFacilityHierarchyQueryVariables>;
export const SearchFormOptionsDocument = gql`
    query SearchFormOptions($clinicId: String!, $formDatasetId: String!, $query: String) {
  searchFormOptions(
    input: {clinicId: $clinicId, request: {formDatasetId: $formDatasetId, query: $query}}
  ) {
    clinicId
    response {
      optionGroups {
        title {
          ...LocalizedString
        }
        subtitle {
          ...LocalizedString
        }
        options {
          ...Option
        }
      }
    }
  }
}
    ${LocalizedStringFragmentDoc}
${OptionFragmentDoc}`;

/**
 * __useSearchFormOptionsQuery__
 *
 * To run a query within a React component, call `useSearchFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFormOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      formDatasetId: // value for 'formDatasetId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchFormOptionsQuery(baseOptions: Apollo.QueryHookOptions<SearchFormOptionsQuery, SearchFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFormOptionsQuery, SearchFormOptionsQueryVariables>(SearchFormOptionsDocument, options);
      }
export function useSearchFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFormOptionsQuery, SearchFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFormOptionsQuery, SearchFormOptionsQueryVariables>(SearchFormOptionsDocument, options);
        }
export type SearchFormOptionsQueryHookResult = ReturnType<typeof useSearchFormOptionsQuery>;
export type SearchFormOptionsLazyQueryHookResult = ReturnType<typeof useSearchFormOptionsLazyQuery>;
export type SearchFormOptionsQueryResult = Apollo.QueryResult<SearchFormOptionsQuery, SearchFormOptionsQueryVariables>;
export const ListFormOptionsDocument = gql`
    query ListFormOptions($clinicId: String!, $datasetIds: [String]) {
  listFormOptions(
    input: {clinicId: $clinicId, request: {datasetIds: $datasetIds}}
  ) {
    clinicId
    response {
      options {
        ...Option
      }
    }
  }
}
    ${OptionFragmentDoc}`;

/**
 * __useListFormOptionsQuery__
 *
 * To run a query within a React component, call `useListFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      datasetIds: // value for 'datasetIds'
 *   },
 * });
 */
export function useListFormOptionsQuery(baseOptions: Apollo.QueryHookOptions<ListFormOptionsQuery, ListFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormOptionsQuery, ListFormOptionsQueryVariables>(ListFormOptionsDocument, options);
      }
export function useListFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormOptionsQuery, ListFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormOptionsQuery, ListFormOptionsQueryVariables>(ListFormOptionsDocument, options);
        }
export type ListFormOptionsQueryHookResult = ReturnType<typeof useListFormOptionsQuery>;
export type ListFormOptionsLazyQueryHookResult = ReturnType<typeof useListFormOptionsLazyQuery>;
export type ListFormOptionsQueryResult = Apollo.QueryResult<ListFormOptionsQuery, ListFormOptionsQueryVariables>;
export const GetFormSequenceAnswerDocument = gql`
    query GetFormSequenceAnswer($clinicId: String!, $request: Input_form_GetFormSequenceAnswerRequest) {
  getFormSequenceAnswer(input: {clinicId: $clinicId, request: $request}) {
    clinicId
    response {
      question {
        ...FormQuestion
      }
      sequenceQuestion {
        ...FormSequenceQuestion
      }
      sequenceAnswer {
        ...FormSequenceAnswer
      }
    }
  }
}
    ${FormQuestionFragmentDoc}
${FormSequenceQuestionFragmentDoc}
${FormSequenceAnswerFragmentDoc}`;

/**
 * __useGetFormSequenceAnswerQuery__
 *
 * To run a query within a React component, call `useGetFormSequenceAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSequenceAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSequenceAnswerQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetFormSequenceAnswerQuery(baseOptions: Apollo.QueryHookOptions<GetFormSequenceAnswerQuery, GetFormSequenceAnswerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormSequenceAnswerQuery, GetFormSequenceAnswerQueryVariables>(GetFormSequenceAnswerDocument, options);
      }
export function useGetFormSequenceAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormSequenceAnswerQuery, GetFormSequenceAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormSequenceAnswerQuery, GetFormSequenceAnswerQueryVariables>(GetFormSequenceAnswerDocument, options);
        }
export type GetFormSequenceAnswerQueryHookResult = ReturnType<typeof useGetFormSequenceAnswerQuery>;
export type GetFormSequenceAnswerLazyQueryHookResult = ReturnType<typeof useGetFormSequenceAnswerLazyQuery>;
export type GetFormSequenceAnswerQueryResult = Apollo.QueryResult<GetFormSequenceAnswerQuery, GetFormSequenceAnswerQueryVariables>;
export const FindFormSequenceAnswerDocument = gql`
    mutation FindFormSequenceAnswer($clinicId: String!, $request: Input_form_FindFormSequenceAnswerRequest) {
  findFormSequenceAnswer(input: {clinicId: $clinicId, request: $request}) {
    clinicId
    response {
      sequenceQuestion {
        id
        linkedReferences {
          id
        }
      }
      sequenceAnswer {
        ...FormSequenceAnswer
      }
      question {
        ...FormQuestion
      }
    }
  }
}
    ${FormSequenceAnswerFragmentDoc}
${FormQuestionFragmentDoc}`;
export type FindFormSequenceAnswerMutationFn = Apollo.MutationFunction<FindFormSequenceAnswerMutation, FindFormSequenceAnswerMutationVariables>;

/**
 * __useFindFormSequenceAnswerMutation__
 *
 * To run a mutation, you first call `useFindFormSequenceAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindFormSequenceAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findFormSequenceAnswerMutation, { data, loading, error }] = useFindFormSequenceAnswerMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useFindFormSequenceAnswerMutation(baseOptions?: Apollo.MutationHookOptions<FindFormSequenceAnswerMutation, FindFormSequenceAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindFormSequenceAnswerMutation, FindFormSequenceAnswerMutationVariables>(FindFormSequenceAnswerDocument, options);
      }
export type FindFormSequenceAnswerMutationHookResult = ReturnType<typeof useFindFormSequenceAnswerMutation>;
export type FindFormSequenceAnswerMutationResult = Apollo.MutationResult<FindFormSequenceAnswerMutation>;
export type FindFormSequenceAnswerMutationOptions = Apollo.BaseMutationOptions<FindFormSequenceAnswerMutation, FindFormSequenceAnswerMutationVariables>;
export const FindSiblingFormSequenceAnswerDocument = gql`
    mutation FindSiblingFormSequenceAnswer($clinicId: String!, $request: Input_form_FindSiblingFormSequenceAnswerRequest) {
  findSiblingFormSequenceAnswer(input: {clinicId: $clinicId, request: $request}) {
    clinicId
    response {
      siblingQuestion {
        ...FormQuestion
      }
      siblingSequenceQuestion {
        ...FormSequenceQuestion
      }
      siblingSequenceAnswer {
        ...FormSequenceAnswer
      }
    }
  }
}
    ${FormQuestionFragmentDoc}
${FormSequenceQuestionFragmentDoc}
${FormSequenceAnswerFragmentDoc}`;
export type FindSiblingFormSequenceAnswerMutationFn = Apollo.MutationFunction<FindSiblingFormSequenceAnswerMutation, FindSiblingFormSequenceAnswerMutationVariables>;

/**
 * __useFindSiblingFormSequenceAnswerMutation__
 *
 * To run a mutation, you first call `useFindSiblingFormSequenceAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindSiblingFormSequenceAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findSiblingFormSequenceAnswerMutation, { data, loading, error }] = useFindSiblingFormSequenceAnswerMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useFindSiblingFormSequenceAnswerMutation(baseOptions?: Apollo.MutationHookOptions<FindSiblingFormSequenceAnswerMutation, FindSiblingFormSequenceAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindSiblingFormSequenceAnswerMutation, FindSiblingFormSequenceAnswerMutationVariables>(FindSiblingFormSequenceAnswerDocument, options);
      }
export type FindSiblingFormSequenceAnswerMutationHookResult = ReturnType<typeof useFindSiblingFormSequenceAnswerMutation>;
export type FindSiblingFormSequenceAnswerMutationResult = Apollo.MutationResult<FindSiblingFormSequenceAnswerMutation>;
export type FindSiblingFormSequenceAnswerMutationOptions = Apollo.BaseMutationOptions<FindSiblingFormSequenceAnswerMutation, FindSiblingFormSequenceAnswerMutationVariables>;
export const AnswerFormSequenceQuestionDocument = gql`
    mutation AnswerFormSequenceQuestion($clinicId: String!, $request: Input_form_AnswerFormSequenceQuestionRequest) {
  answerFormSequenceQuestion(input: {clinicId: $clinicId, request: $request}) {
    clinicId
    response {
      sequenceAnswer {
        ...FormSequenceAnswer
      }
      nextSequenceAnswer {
        ...FormSequenceAnswer
      }
      nextSequenceQuestion {
        ...FormSequenceQuestion
      }
      nextQuestion {
        ...FormQuestion
      }
    }
  }
}
    ${FormSequenceAnswerFragmentDoc}
${FormSequenceQuestionFragmentDoc}
${FormQuestionFragmentDoc}`;
export type AnswerFormSequenceQuestionMutationFn = Apollo.MutationFunction<AnswerFormSequenceQuestionMutation, AnswerFormSequenceQuestionMutationVariables>;

/**
 * __useAnswerFormSequenceQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerFormSequenceQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerFormSequenceQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerFormSequenceQuestionMutation, { data, loading, error }] = useAnswerFormSequenceQuestionMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAnswerFormSequenceQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerFormSequenceQuestionMutation, AnswerFormSequenceQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerFormSequenceQuestionMutation, AnswerFormSequenceQuestionMutationVariables>(AnswerFormSequenceQuestionDocument, options);
      }
export type AnswerFormSequenceQuestionMutationHookResult = ReturnType<typeof useAnswerFormSequenceQuestionMutation>;
export type AnswerFormSequenceQuestionMutationResult = Apollo.MutationResult<AnswerFormSequenceQuestionMutation>;
export type AnswerFormSequenceQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerFormSequenceQuestionMutation, AnswerFormSequenceQuestionMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($clinicId: String!, $request: Input_form_CreateFormRequest) {
  createForm(input: {clinicId: $clinicId, request: $request}) {
    clinicId
    response {
      form {
        ...Form
      }
    }
  }
}
    ${FormFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormStatusDocument = gql`
    mutation UpdateFormStatus($clinicId: String, $formId: String!, $status: form_FormStatus) {
  updateFormStatus(
    input: {clinicId: $clinicId, request: {formId: $formId, status: $status}}
  ) {
    clinicId
    response {
      form {
        ...Form
      }
    }
  }
}
    ${FormFragmentDoc}`;
export type UpdateFormStatusMutationFn = Apollo.MutationFunction<UpdateFormStatusMutation, UpdateFormStatusMutationVariables>;

/**
 * __useUpdateFormStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFormStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormStatusMutation, { data, loading, error }] = useUpdateFormStatusMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      formId: // value for 'formId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateFormStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormStatusMutation, UpdateFormStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormStatusMutation, UpdateFormStatusMutationVariables>(UpdateFormStatusDocument, options);
      }
export type UpdateFormStatusMutationHookResult = ReturnType<typeof useUpdateFormStatusMutation>;
export type UpdateFormStatusMutationResult = Apollo.MutationResult<UpdateFormStatusMutation>;
export type UpdateFormStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFormStatusMutation, UpdateFormStatusMutationVariables>;
export const LoginDocument = gql`
    mutation Login($params: Input_patientportal_SignInPortalUserParamsMsg, $actionConfirmation: Input_patientportal_ActionConfirmationMsg) {
  signInPortalUser(
    input: {params: $params, actionConfirmation: $actionConfirmation}
  ) {
    success {
      token
      portalUserId
      encryptedMatrixRecoveryKey
    }
    confirmableAction {
      ...ConfirmableAction
    }
  }
}
    ${ConfirmableActionFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      params: // value for 'params'
 *      actionConfirmation: // value for 'actionConfirmation'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const PartiallyConfirmActionDocument = gql`
    mutation PartiallyConfirmAction($confirmableActionId: String!, $confirmationProviderIndex: Int!, $confirmationToken: String!) {
  partiallyConfirmAction(
    input: {confirmableActionId: $confirmableActionId, confirmationProviderIndex: $confirmationProviderIndex, confirmationToken: $confirmationToken}
  ) {
    _
  }
}
    `;
export type PartiallyConfirmActionMutationFn = Apollo.MutationFunction<PartiallyConfirmActionMutation, PartiallyConfirmActionMutationVariables>;

/**
 * __usePartiallyConfirmActionMutation__
 *
 * To run a mutation, you first call `usePartiallyConfirmActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartiallyConfirmActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partiallyConfirmActionMutation, { data, loading, error }] = usePartiallyConfirmActionMutation({
 *   variables: {
 *      confirmableActionId: // value for 'confirmableActionId'
 *      confirmationProviderIndex: // value for 'confirmationProviderIndex'
 *      confirmationToken: // value for 'confirmationToken'
 *   },
 * });
 */
export function usePartiallyConfirmActionMutation(baseOptions?: Apollo.MutationHookOptions<PartiallyConfirmActionMutation, PartiallyConfirmActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartiallyConfirmActionMutation, PartiallyConfirmActionMutationVariables>(PartiallyConfirmActionDocument, options);
      }
export type PartiallyConfirmActionMutationHookResult = ReturnType<typeof usePartiallyConfirmActionMutation>;
export type PartiallyConfirmActionMutationResult = Apollo.MutationResult<PartiallyConfirmActionMutation>;
export type PartiallyConfirmActionMutationOptions = Apollo.BaseMutationOptions<PartiallyConfirmActionMutation, PartiallyConfirmActionMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logOut {
    _
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const FindCurrentPortalUserDocument = gql`
    query FindCurrentPortalUser {
  findCurrentPortalUser {
    portalUser {
      ...PortalUser
    }
  }
}
    ${PortalUserFragmentDoc}`;

/**
 * __useFindCurrentPortalUserQuery__
 *
 * To run a query within a React component, call `useFindCurrentPortalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCurrentPortalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCurrentPortalUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindCurrentPortalUserQuery(baseOptions?: Apollo.QueryHookOptions<FindCurrentPortalUserQuery, FindCurrentPortalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCurrentPortalUserQuery, FindCurrentPortalUserQueryVariables>(FindCurrentPortalUserDocument, options);
      }
export function useFindCurrentPortalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCurrentPortalUserQuery, FindCurrentPortalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCurrentPortalUserQuery, FindCurrentPortalUserQueryVariables>(FindCurrentPortalUserDocument, options);
        }
export type FindCurrentPortalUserQueryHookResult = ReturnType<typeof useFindCurrentPortalUserQuery>;
export type FindCurrentPortalUserLazyQueryHookResult = ReturnType<typeof useFindCurrentPortalUserLazyQuery>;
export type FindCurrentPortalUserQueryResult = Apollo.QueryResult<FindCurrentPortalUserQuery, FindCurrentPortalUserQueryVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($params: Input_patientportal_UpdatePortalUserPasswordParamsMsg, $actionConfirmation: Input_patientportal_ActionConfirmationMsg) {
  updatePortalUserPassword(
    input: {params: $params, actionConfirmation: $actionConfirmation}
  ) {
    success {
      _
    }
    confirmableAction {
      ...ConfirmableAction
    }
  }
}
    ${ConfirmableActionFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      params: // value for 'params'
 *      actionConfirmation: // value for 'actionConfirmation'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const CreatePortalUserDocument = gql`
    mutation CreatePortalUser($portalUser: Input_patientportal_PortalUserMsg, $password: String!, $captchaSolution: String!, $deviceSecretId: String!, $deviceType: patientportal_PortalDeviceType) {
  createPortalUser(
    input: {portalUser: $portalUser, password: $password, captchaSolution: $captchaSolution, deviceSecretId: $deviceSecretId, deviceType: $deviceType}
  ) {
    token
    thirdPartyCommunicationVerificationConfirmableActions {
      ...ConfirmableAction
    }
    portalUser {
      ...PortalUser
    }
  }
}
    ${ConfirmableActionFragmentDoc}
${PortalUserFragmentDoc}`;
export type CreatePortalUserMutationFn = Apollo.MutationFunction<CreatePortalUserMutation, CreatePortalUserMutationVariables>;

/**
 * __useCreatePortalUserMutation__
 *
 * To run a mutation, you first call `useCreatePortalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortalUserMutation, { data, loading, error }] = useCreatePortalUserMutation({
 *   variables: {
 *      portalUser: // value for 'portalUser'
 *      password: // value for 'password'
 *      captchaSolution: // value for 'captchaSolution'
 *      deviceSecretId: // value for 'deviceSecretId'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useCreatePortalUserMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortalUserMutation, CreatePortalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortalUserMutation, CreatePortalUserMutationVariables>(CreatePortalUserDocument, options);
      }
export type CreatePortalUserMutationHookResult = ReturnType<typeof useCreatePortalUserMutation>;
export type CreatePortalUserMutationResult = Apollo.MutationResult<CreatePortalUserMutation>;
export type CreatePortalUserMutationOptions = Apollo.BaseMutationOptions<CreatePortalUserMutation, CreatePortalUserMutationVariables>;
export const VerifyThirdPartyCommunicationDocument = gql`
    mutation VerifyThirdPartyCommunication($params: Input_patientportal_VerifyThirdPartyCommunicationParamsMsg, $actionConfirmation: Input_patientportal_ActionConfirmationMsg) {
  verifyThirdPartyCommunication(
    input: {params: $params, actionConfirmation: $actionConfirmation}
  ) {
    confirmableAction {
      ...ConfirmableAction
    }
    success {
      token
    }
  }
}
    ${ConfirmableActionFragmentDoc}`;
export type VerifyThirdPartyCommunicationMutationFn = Apollo.MutationFunction<VerifyThirdPartyCommunicationMutation, VerifyThirdPartyCommunicationMutationVariables>;

/**
 * __useVerifyThirdPartyCommunicationMutation__
 *
 * To run a mutation, you first call `useVerifyThirdPartyCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyThirdPartyCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyThirdPartyCommunicationMutation, { data, loading, error }] = useVerifyThirdPartyCommunicationMutation({
 *   variables: {
 *      params: // value for 'params'
 *      actionConfirmation: // value for 'actionConfirmation'
 *   },
 * });
 */
export function useVerifyThirdPartyCommunicationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyThirdPartyCommunicationMutation, VerifyThirdPartyCommunicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyThirdPartyCommunicationMutation, VerifyThirdPartyCommunicationMutationVariables>(VerifyThirdPartyCommunicationDocument, options);
      }
export type VerifyThirdPartyCommunicationMutationHookResult = ReturnType<typeof useVerifyThirdPartyCommunicationMutation>;
export type VerifyThirdPartyCommunicationMutationResult = Apollo.MutationResult<VerifyThirdPartyCommunicationMutation>;
export type VerifyThirdPartyCommunicationMutationOptions = Apollo.BaseMutationOptions<VerifyThirdPartyCommunicationMutation, VerifyThirdPartyCommunicationMutationVariables>;
export const RenotifyConfirmationProviderDocument = gql`
    mutation RenotifyConfirmationProvider($confirmableActionId: String!, $actionToken: String!, $confirmationProviderIndex: Int!) {
  renotifyConfirmationProvider(
    input: {confirmableActionId: $confirmableActionId, actionToken: $actionToken, confirmationProviderIndex: $confirmationProviderIndex}
  ) {
    _
  }
}
    `;
export type RenotifyConfirmationProviderMutationFn = Apollo.MutationFunction<RenotifyConfirmationProviderMutation, RenotifyConfirmationProviderMutationVariables>;

/**
 * __useRenotifyConfirmationProviderMutation__
 *
 * To run a mutation, you first call `useRenotifyConfirmationProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenotifyConfirmationProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renotifyConfirmationProviderMutation, { data, loading, error }] = useRenotifyConfirmationProviderMutation({
 *   variables: {
 *      confirmableActionId: // value for 'confirmableActionId'
 *      actionToken: // value for 'actionToken'
 *      confirmationProviderIndex: // value for 'confirmationProviderIndex'
 *   },
 * });
 */
export function useRenotifyConfirmationProviderMutation(baseOptions?: Apollo.MutationHookOptions<RenotifyConfirmationProviderMutation, RenotifyConfirmationProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenotifyConfirmationProviderMutation, RenotifyConfirmationProviderMutationVariables>(RenotifyConfirmationProviderDocument, options);
      }
export type RenotifyConfirmationProviderMutationHookResult = ReturnType<typeof useRenotifyConfirmationProviderMutation>;
export type RenotifyConfirmationProviderMutationResult = Apollo.MutationResult<RenotifyConfirmationProviderMutation>;
export type RenotifyConfirmationProviderMutationOptions = Apollo.BaseMutationOptions<RenotifyConfirmationProviderMutation, RenotifyConfirmationProviderMutationVariables>;
export const PreparePasswordResetDocument = gql`
    mutation PreparePasswordReset($input: Input_patientportal_PreparePasswordResetRequest) {
  preparePasswordReset(input: $input) {
    success {
      passwordResetToken
    }
    confirmableAction {
      ...ConfirmableAction
    }
  }
}
    ${ConfirmableActionFragmentDoc}`;
export type PreparePasswordResetMutationFn = Apollo.MutationFunction<PreparePasswordResetMutation, PreparePasswordResetMutationVariables>;

/**
 * __usePreparePasswordResetMutation__
 *
 * To run a mutation, you first call `usePreparePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreparePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preparePasswordResetMutation, { data, loading, error }] = usePreparePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreparePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PreparePasswordResetMutation, PreparePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreparePasswordResetMutation, PreparePasswordResetMutationVariables>(PreparePasswordResetDocument, options);
      }
export type PreparePasswordResetMutationHookResult = ReturnType<typeof usePreparePasswordResetMutation>;
export type PreparePasswordResetMutationResult = Apollo.MutationResult<PreparePasswordResetMutation>;
export type PreparePasswordResetMutationOptions = Apollo.BaseMutationOptions<PreparePasswordResetMutation, PreparePasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($passwordResetToken: String!, $newPassword: String!) {
  resetPassword(
    input: {passwordResetToken: $passwordResetToken, newPassword: $newPassword}
  ) {
    _
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      passwordResetToken: // value for 'passwordResetToken'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePortalUserSettingsDocument = gql`
    mutation UpdatePortalUserSettings($input: Input_patientportal_UpdatePortalUserSettingsRequest) {
  updatePortalUserSettings(input: $input) {
    ...PortalAccountSettings
  }
}
    ${PortalAccountSettingsFragmentDoc}`;
export type UpdatePortalUserSettingsMutationFn = Apollo.MutationFunction<UpdatePortalUserSettingsMutation, UpdatePortalUserSettingsMutationVariables>;

/**
 * __useUpdatePortalUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePortalUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortalUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortalUserSettingsMutation, { data, loading, error }] = useUpdatePortalUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortalUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortalUserSettingsMutation, UpdatePortalUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortalUserSettingsMutation, UpdatePortalUserSettingsMutationVariables>(UpdatePortalUserSettingsDocument, options);
      }
export type UpdatePortalUserSettingsMutationHookResult = ReturnType<typeof useUpdatePortalUserSettingsMutation>;
export type UpdatePortalUserSettingsMutationResult = Apollo.MutationResult<UpdatePortalUserSettingsMutation>;
export type UpdatePortalUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePortalUserSettingsMutation, UpdatePortalUserSettingsMutationVariables>;
export const GetPortalUserSettingsDocument = gql`
    query GetPortalUserSettings {
  findCurrentPortalUser {
    portalUser {
      id
      settings {
        ...PortalAccountSettings
      }
    }
  }
}
    ${PortalAccountSettingsFragmentDoc}`;

/**
 * __useGetPortalUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetPortalUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetPortalUserSettingsQuery, GetPortalUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalUserSettingsQuery, GetPortalUserSettingsQueryVariables>(GetPortalUserSettingsDocument, options);
      }
export function useGetPortalUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalUserSettingsQuery, GetPortalUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalUserSettingsQuery, GetPortalUserSettingsQueryVariables>(GetPortalUserSettingsDocument, options);
        }
export type GetPortalUserSettingsQueryHookResult = ReturnType<typeof useGetPortalUserSettingsQuery>;
export type GetPortalUserSettingsLazyQueryHookResult = ReturnType<typeof useGetPortalUserSettingsLazyQuery>;
export type GetPortalUserSettingsQueryResult = Apollo.QueryResult<GetPortalUserSettingsQuery, GetPortalUserSettingsQueryVariables>;